// 基础数据
const AEObasicData = {
    // 成交方式
    CUSTransac: [
        {
            codeName: "CIF",
            codeValue: "1"
        }, {
            codeName: "C&F",
            codeValue: "2"
        }, {
            codeName: "FOB",
            codeValue: "3"
        }, {
            codeName: "C&I",
            codeValue: "4"
        },
        //  {
        //     codeName: "市场价",
        //     codeValue: "5"
        // }, {
        //     codeName: "垫仓",
        //     codeValue: "6"
        // }, 
        {
            codeName: "EXW",
            codeValue: "7"
        }
    ],
    // 随附单证代码
    CUS_LICENSEDOCU: [
        {
            codeName: "零关税申请单",
            codeValue: "#"
        },
        {
            codeName: "反制措施排除代码",
            codeValue: "0"
        },
        {
            codeName: "进口许可证",
            codeValue: "1"
        },
        {
            codeName: "两用物项和技术进口许可证",
            codeValue: "2"
        },
        {
            codeName: "两用物项和技术出口许可证",
            codeValue: "3"
        },
        {
            codeName: "出口许可证",
            codeValue: "4"
        },
        {
            codeName: "纺织品临时出口许可证",
            codeValue: "5"
        },
        {
            codeName: "旧机电产品禁止进口",
            codeValue: "6"
        },
        {
            codeName: "自动进口许可证",
            codeValue: "7"
        },
        {
            codeName: "禁止出口商品",
            codeValue: "8"
        },
        {
            codeName: "禁止进口商品",
            codeValue: "9"
        },
        {
            codeName: "准予担保通知书",
            codeValue: "@"
        },
        {
            codeName: "检验检疫",
            codeValue: "A"
        },
        {
            codeName: "电子底账",
            codeValue: "B"
        },
        {
            codeName: "毛坯钻石进出境检验",
            codeValue: "D"
        },
        {
            codeName: "濒危物种允许出口证明书",
            codeValue: "E"
        },
        {
            codeName: "濒危物种允许进口证明书",
            codeValue: "F"
        },
        {
            codeName: "两用物项和技术出口许可证(定向)",
            codeValue: "G"
        },
        {
            codeName: "港澳OPA纺织品证明",
            codeValue: "H"
        },
        {
            codeName: "麻醉药品精神药物进出口准许证",
            codeValue: "I"
        },
        {
            codeName: "黄金及黄金制品进出口准许证",
            codeValue: "J"
        },
        {
            codeName: "深加工结转申请表",
            codeValue: "K"
        },
        {
            codeName: "药品进出口准许证",
            codeValue: "L"
        },
        {
            codeName: "密码产品和设备进口许可证",
            codeValue: "M"
        },
        {
            codeName: "军品出口许可证",
            codeValue: "N"
        },
        {
            codeName: "自动进口许可证(新旧机电产品)",
            codeValue: "O"
        },
        {
            codeName: "固体废物进口许可证",
            codeValue: "P"
        },
        {
            codeName: "进口药品通关单",
            codeValue: "Q"
        },
        {
            codeName: "进口兽药通关单",
            codeValue: "R"
        },
        {
            codeName: "农药进出口登记管理放行通知单",
            codeValue: "S"
        },
        {
            codeName: "提发货凭证",
            codeValue: "T"
        },
        {
            codeName: "合法捕捞产品通关证明",
            codeValue: "U"
        },
        {
            codeName: "人类遗传资源材料出口、出境证明",
            codeValue: "V"
        },
        {
            codeName: "有毒化学品环境管理放行通知单",
            codeValue: "X"
        },
        {
            codeName: "原产地证明",
            codeValue: "Y"
        },
        {
            codeName: "赴境外加工光盘进口备案证明",
            codeValue: "Z"
        },
        {
            codeName: "保税核注清单",
            codeValue: "a"
        },
        {
            codeName: "进口广播电影电视节目带(片)提取单",
            codeValue: "b"
        },
        {
            codeName: "内销征税联系单",
            codeValue: "c"
        },
        {
            codeName: "援外项目任务通知函",
            codeValue: "d"
        },
        {
            codeName: "关税配额外优惠税率进口棉花配额证",
            codeValue: "e"
        },
        {
            codeName: "音像制品（成品）进口批准单",
            codeValue: "f"
        },
        {
            codeName: "技术出口合同登记证",
            codeValue: "g"
        },
        {
            codeName: "核增核扣表",
            codeValue: "h"
        },
        {
            codeName: "技术出口许可证",
            codeValue: "i"
        },
        {
            codeName: "民用爆炸物品进出口审批单",
            codeValue: "k"
        },
        {
            codeName: "银行调运人民币现钞进出境证明",
            codeValue: "m"
        },
        {
            codeName: "音像制品（版权引进）批准单",
            codeValue: "n"
        },
        {
            codeName: "国别关税配额证明",
            codeValue: "q"
        },
        {
            codeName: "预归类标志",
            codeValue: "r"
        },
        {
            codeName: "适用ITA税率的商品用途认定证明",
            codeValue: "s"
        },
        {
            codeName: "关税配额证明",
            codeValue: "t"
        },
        {
            codeName: "自动进口许可证(加工贸易)",
            codeValue: "v"
        },
        {
            codeName: "再生原料装运前检验证书",
            codeValue: "w"
        },
        {
            codeName: "出口许可证(加工贸易)",
            codeValue: "x"
        },
        {
            codeName: "出口许可证(边境小额贸易)",
            codeValue: "y"
        },
        {
            codeName: "古生物化石出境批件",
            codeValue: "z"
        }
    ],
    // 
    DecAttTypeCode_V: [
        {
            codeName: "发票",
            codeValue: "00000001"
        },
        {
            codeName: "装箱单",
            codeValue: "00000002"
        },
        {
            codeName: "提/运单",
            codeValue: "00000003"
        },
        {
            codeName: "合同",
            codeValue: "00000004"
        },
        {
            codeName: "代理报关委托协议（纸质）",
            codeValue: "00000008"
        },
        {
            codeName: "原产地证据文件",
            codeValue: "00000009"
        },
        {
            codeName: "载货清单（舱单）",
            codeValue: "00000010"
        },
        {
            codeName: "特许权使用费涉及的原进口货物报关单海关编号",
            codeValue: "00000011"
        },
        {
            codeName: "特许权使用费合同/协议",
            codeValue: "00000012"
        },
        {
            codeName: "特许权使用费发票",
            codeValue: "00000013"
        },
        {
            codeName: "特许权使用费支付凭证",
            codeValue: "00000014"
        },
        {
            codeName: "代扣代缴税款纳税凭证",
            codeValue: "00000015"
        },
        {
            codeName: "特许权使用费其他材料",
            codeValue: "00000016"
        },
        {
            codeName: "出口证明信",
            codeValue: "00000017"
        },
        {
            codeName: "代理报关委托协议（电子）",
            codeValue: "10000001"
        },
        {
            codeName: "减免税货物税款担保证明",
            codeValue: "10000002"
        },
        {
            codeName: "减免税货物税款担保延期证明",
            codeValue: "10000003"
        },
        {
            codeName: "跨境B2B出口单证",
            codeValue: "10000004"
        },
        {
            codeName: "兽医(卫生)证书",
            codeValue: "20000011"
        },
        {
            codeName: "动物检疫证书",
            codeValue: "20000012"
        },
        {
            codeName: "植物检疫证书",
            codeValue: "20000013"
        },
        {
            codeName: "装运前检验证书",
            codeValue: "20000014"
        },
        {
            codeName: "重量证书",
            codeValue: "20000015"
        },
        {
            codeName: "TCK检验证书（美国小麦）",
            codeValue: "20000016"
        },
        {
            codeName: "熏蒸证书",
            codeValue: "20000017"
        },
        {
            codeName: "放射性物质检测合格证明",
            codeValue: "20000018"
        },
        {
            codeName: "木材发货检验码单",
            codeValue: "20000019"
        },
        {
            codeName: "水果预检验证书",
            codeValue: "20000020"
        },
        {
            codeName: "中转进境确认证明文件（经港澳地区中转入境水果）",
            codeValue: "20000021"
        },
        {
            codeName: "检测报告",
            codeValue: "20000022"
        },
        {
            codeName: "危险特性分类鉴别报告",
            codeValue: "20000023"
        },
        {
            codeName: "型式试验报告",
            codeValue: "20000024"
        },
        {
            codeName: "动物检疫合格证明（国产原料）；进境货物检疫证明、原产国检验证书（进口原料）",
            codeValue: "20000025"
        },
        {
            codeName: "微生物检测报告（沙门氏菌、产志贺毒素大肠杆菌、金黄色葡萄球菌、单增李斯特菌）",
            codeValue: "20000026"
        },
        {
            codeName: "出口水产品成品检验报告",
            codeValue: "20000027"
        },
        {
            codeName: "检疫处理结果报告单",
            codeValue: "20000028"
        },
        {
            codeName: "检验报告",
            codeValue: "20000029"
        },
        {
            codeName: "质量安全符合性声明",
            codeValue: "20000030"
        },
        {
            codeName: "企业提供的证明材料",
            codeValue: "50000001"
        },
        {
            codeName: "企业提供的声明",
            codeValue: "50000002"
        },
        {
            codeName: "企业提供的标签标识",
            codeValue: "50000003"
        },
        {
            codeName: "企业提供的其他",
            codeValue: "50000004"
        },
        {
            codeName: "农业转基因生物安全证书",
            codeValue: "50000005"
        },
        {
            codeName: "引进种子、苗木检疫审批单",
            codeValue: "50000006"
        },
        {
            codeName: "远洋自捕水产品的确认通知（文件）和远洋渔业项目确认表、农业部远洋渔业企业资格证书",
            codeValue: "50000007"
        },
        {
            codeName: "特种设备制造许可证",
            codeValue: "50000008"
        },
        {
            codeName: "进口化妆品卫生许可批件",
            codeValue: "50000009"
        },
        {
            codeName: "特殊医学用途配方食品注册证书",
            codeValue: "50000010"
        },
        {
            codeName: "保健食品注册证书/备案凭证",
            codeValue: "50000011"
        },
        {
            codeName: "捕捞船舶登记证和捕捞许可证（野生捕捞水生动物）",
            codeValue: "50000012"
        },
        {
            codeName: "化妆品生产许可证(仅限首次出口时提供)",
            codeValue: "50000013"
        },
        {
            codeName: "特殊用途销售包装化妆品成品应当提供相应的卫生许可批件或者具有相关资质的机构出具的是否存在安全性风险物质的有关安全性评估资料(仅限首次出口时提供)",
            codeValue: "50000014"
        },
        {
            codeName: "民用爆炸品进口审批单",
            codeValue: "60000001"
        },
        {
            codeName: "民用爆炸品出口审批单",
            codeValue: "60000002"
        },
        {
            codeName: "军品出口许可证",
            codeValue: "60000003"
        },
        {
            codeName: "人类遗传资源材料出口、出境证明",
            codeValue: "60000004"
        },
        {
            codeName: "古生物化石出口、出境批件",
            codeValue: "60000005"
        },
        {
            codeName: "密码出口许可证",
            codeValue: "60000006"
        },
        {
            codeName: "援外项目任务通知单",
            codeValue: "60000007"
        },
        {
            codeName: "医疗用毒性药品进出口批件",
            codeValue: "60000008"
        },
        {
            codeName: "放射性药品进出口批件",
            codeValue: "60000009"
        },
        {
            codeName: "血液出口批件",
            codeValue: "60000010"
        },
        {
            codeName: "化学品进出口环境管理登记证明",
            codeValue: "60000011"
        }
    ],
    // 报关单类型
    DEC_ENTRY_TYPE: [
        {
            codeName: "有纸报关",
            codeValue: "0"
        },
        {
            codeName: "无纸带清单报关",
            codeValue: "D"
        },
        {
            codeName: "有纸带清单报关",
            codeValue: "L"
        },
        {
            codeName: "通关无纸化",
            codeValue: "M"
        },
        {
            codeName: "无纸报关",
            codeValue: "W"
        }
    ],
    // 清单类型
    DEC_BILL_TYPE: [
        {
            codeName: "一般备案清单",
            codeValue: "1"
        }, {
            codeName: "先进区、后报关",
            codeValue: "2"
        }, {
            codeName: "集报备案清单",
            codeValue: "3"
        }, {
            codeName: "两单一审备案清单",
            codeValue: "4"
        }
    ],
    // 是/否
    trueORfalse: [
        {
            codeName: "是",
            codeValue: "1"
        }, {
            codeName: "否",
            codeValue: "0"
        }
    ],
    // 征免方式 征减免税
    CUS_LEVYMODE: [
        {
            codeName: "照章征税",
            codeValue: "1"
        },
        {
            codeName: "折半征税",
            codeValue: "2"
        },
        {
            codeName: "全免",
            codeValue: "3"
        },
        {
            codeName: "特案",
            codeValue: "4"
        },
        {
            codeName: "随征免性质",
            codeValue: "5"
        },
        {
            codeName: "保证金",
            codeValue: "6"
        },
        {
            codeName: "保函",
            codeValue: "7"
        },
        {
            codeName: "折半补税",
            codeValue: "8"
        },
        {
            codeName: "全额退税",
            codeValue: "9"
        },
        {
            codeName: "不计征关税、增值税和消费税",
            codeValue: "A"
        },
        {
            codeName: "不计征关税",
            codeValue: "B"
        },
        {
            codeName: "不计征关税、增值税",
            codeValue: "C"
        },
        {
            codeName: "不计征增值税和消费税",
            codeValue: "D"
        },
        {
            codeName: "不计征增值税",
            codeValue: "E"
        }
    ],
    // 用途列表
    CIQ_USE: [
        {
            codeName: "种用或繁殖",
            codeValue: "11"
        },
        {
            codeName: "食用",
            codeValue: "12"
        },
        {
            codeName: "奶用",
            codeValue: "13"
        },
        {
            codeName: "观赏或演艺",
            codeValue: "14"
        },
        {
            codeName: "伴侣",
            codeValue: "15"
        },
        {
            codeName: "实验",
            codeValue: "16"
        },
        {
            codeName: "药用",
            codeValue: "17"
        },
        {
            codeName: "饲用",
            codeValue: "18"
        },
        {
            codeName: "食品包装材料",
            codeValue: "19"
        },
        {
            codeName: "食品加工设备",
            codeValue: "20"
        },
        {
            codeName: "食品添加剂",
            codeValue: "21"
        },
        {
            codeName: "介质土",
            codeValue: "22"
        },
        {
            codeName: "食品容器",
            codeValue: "23"
        },
        {
            codeName: "食品洗涤剂",
            codeValue: "24"
        },
        {
            codeName: "食品消毒剂",
            codeValue: "25"
        },
        {
            codeName: "仅工业用途",
            codeValue: "26"
        },
        {
            codeName: "化妆品",
            codeValue: "27"
        },
        {
            codeName: "化妆品原料",
            codeValue: "28"
        },
        {
            codeName: "肥料",
            codeValue: "29"
        },
        {
            codeName: "保健品",
            codeValue: "30"
        },
        {
            codeName: "治疗、预防、诊断",
            codeValue: "31"
        },
        {
            codeName: "科研",
            codeValue: "32"
        },
        {
            codeName: "展览展示",
            codeValue: "33"
        },
        {
            codeName: "现货交易和期货实物交割",
            codeValue: "34"
        },
        {
            codeName: "其他",
            codeValue: "99"
        }
    ],
    // 运输方式
    CUS_MAPPING_TRANSPORT_CODE_V: [
        {
            codeName: "保税仓库",
            cusCode: "8",
            codeValue: "8",
            gbName: "保税仓库",
            gbCode: "8",
            ciqCode: "9"
        },
        {
            codeName: "保税区  ",
            cusCode: "7",
            codeValue: "7",
            gbName: "保税区  ",
            gbCode: "7",
            ciqCode: "9"
        },
        {
            codeName: "保税港区",
            cusCode: "Y",
            codeValue: "Y",
            gbName: "保税港区",
            gbCode: "Y",
            ciqCode: "9"
        },
        {
            codeName: "公路运输",
            cusCode: "4",
            codeValue: "4",
            gbName: "公路运输",
            gbCode: "4",
            ciqCode: "3"
        },
        {
            codeName: "其他方式运输",
            cusCode: "9",
            codeValue: "9",
            gbName: "其他方式运输",
            gbCode: "9",
            ciqCode: "9"
        },
        {
            codeName: "出口加工区",
            cusCode: "Z",
            codeValue: "Z",
            gbName: "出口加工区",
            gbCode: "Z",
            ciqCode: "9"
        },
        {
            codeName: "固定设施运输",
            cusCode: "9",
            codeValue: "G",
            gbName: "固定设施运输",
            gbCode: "G",
            ciqCode: "6"
        },
        {
            codeName: "旅客携带",
            cusCode: "9",
            codeValue: "L",
            gbName: "旅客携带",
            gbCode: "L",
            ciqCode: "5"
        },
        {
            codeName: "水路运输",
            cusCode: "2",
            codeValue: "2",
            gbName: "水路运输",
            gbCode: "2",
            ciqCode: "1"
        },
        {
            codeName: "洋浦保税港区",
            cusCode: "P",
            codeValue: "P",
            gbName: "洋浦保税港区",
            gbCode: "P",
            ciqCode: "P"
        },
        {
            codeName: "物流中心",
            cusCode: "W",
            codeValue: "W",
            gbName: "物流中心",
            gbCode: "W",
            ciqCode: "9"
        },
        {
            codeName: "物流园区",
            cusCode: "X",
            codeValue: "X",
            gbName: "物流园区",
            gbCode: "X",
            ciqCode: "9"
        },
        {
            codeName: "特殊综合保税区",
            cusCode: "S",
            codeValue: "S",
            gbName: "特殊综合保税区",
            gbCode: "S",
            ciqCode: "S"
        },
        {
            codeName: "监管仓库",
            cusCode: "1",
            codeValue: "1",
            gbName: "监管仓库",
            gbCode: "1",
            ciqCode: "9"
        },
        {
            codeName: "综合实验区",
            cusCode: "T",
            codeValue: "T",
            gbName: "综合实验区",
            gbCode: "T",
            ciqCode: "9"
        },
        {
            codeName: "航空运输",
            cusCode: "5",
            codeValue: "5",
            gbName: "航空运输",
            gbCode: "5",
            ciqCode: "4"
        },
        {
            codeName: "边境特殊海关作业区",
            cusCode: "H",
            codeValue: "H",
            gbName: "边境特殊海关作业区",
            gbCode: "H",
            ciqCode: "9"
        },
        {
            codeName: "邮件运输",
            cusCode: "6",
            codeValue: "6",
            gbName: "邮件运输",
            gbCode: "6",
            ciqCode: "9"
        },
        {
            codeName: "铁路运输",
            cusCode: "3",
            codeValue: "3",
            gbName: "铁路运输",
            gbCode: "3",
            ciqCode: "2"
        },
        {
            codeName: "非保税区",
            cusCode: "0",
            codeValue: "0",
            gbName: "非保税区",
            gbCode: "0",
            ciqCode: "9"
        }
    ],
    // 包装方式
    CUS_MAPPING_PACKAGEKIND_CODE_V: [
        {
            packSeqNo: "1",
            packQty: "0",
            packType: "00",
            packTypeName: "散装",
            state: null
        },
        {
            packSeqNo: "2",
            packQty: "0",
            packType: "01",
            packTypeName: "裸装",
            state: null
        },
        {
            packSeqNo: "3",
            packQty: "0",
            packType: "04",
            packTypeName: "球状罐类",
            state: null
        },
        {
            packSeqNo: "4",
            packQty: "0",
            packType: "06",
            packTypeName: "包/袋",
            state: null
        },
        {
            packSeqNo: "5",
            packQty: "0",
            packType: "22",
            packTypeName: "纸制或纤维板制盒/箱",
            state: null
        },
        {
            packSeqNo: "6",
            packQty: "0",
            packType: "23",
            packTypeName: "木制或竹藤等植物性材料制盒/箱",
            state: null
        },
        {
            packSeqNo: "7",
            packQty: "0",
            packType: "29",
            packTypeName: "其他材料制盒/箱",
            state: null
        },
        {
            packSeqNo: "8",
            packQty: "0",
            packType: "32",
            packTypeName: "纸制或纤维板制桶",
            state: null
        },
        {
            packSeqNo: "9",
            packQty: "0",
            packType: "33",
            packTypeName: "木制或竹藤等植物性材料制桶",
            state: null
        },
        {
            packSeqNo: "10",
            packQty: "0",
            packType: "39",
            packTypeName: "其他材料制桶",
            state: null
        },
        {
            packSeqNo: "11",
            packQty: "0",
            packType: "41",
            packTypeName: "中型散装容器",
            state: null
        },
        {
            packSeqNo: "12",
            packQty: "0",
            packType: "42",
            packTypeName: "便携式罐体",
            state: null
        },
        {
            packSeqNo: "13",
            packQty: "0",
            packType: "43",
            packTypeName: "可移动罐柜",
            state: null
        },
        {
            packSeqNo: "14",
            packQty: "0",
            packType: "92",
            packTypeName: "再生木托",
            state: null
        },
        {
            packSeqNo: "15",
            packQty: "0",
            packType: "93",
            packTypeName: "天然木托",
            state: null
        },
        {
            packSeqNo: "16",
            packQty: "0",
            packType: "98",
            packTypeName: "植物性铺垫材料",
            state: null
        },
        {
            packSeqNo: "17",
            packQty: "0",
            packType: "99",
            packTypeName: "其他包装",
            state: null
        }
    ],
    // 币制
    CUS_MAPPING_CURRENCY_CODE_V: [
        {
            codeName: "阿联酋迪拉姆",
            cusCode: "138",
            codeValue: "AED",
            gbName: "阿联酋迪拉姆",
            gbCode: "AED",
            ciqCode: null
        },
        {
            codeName: "澳大利亚元",
            cusCode: "601",
            codeValue: "AUD",
            gbName: "澳大利亚元",
            gbCode: "AUD",
            ciqCode: "036"
        },
        {
            codeName: "加拿大元",
            cusCode: "501",
            codeValue: "CAD",
            gbName: "加拿大元",
            gbCode: "CAD",
            ciqCode: "124"
        },
        {
            codeName: "瑞士法郎",
            cusCode: "331",
            codeValue: "CHF",
            gbName: "瑞士法郎",
            gbCode: "CHF",
            ciqCode: "756"
        },
        {
            codeName: "人民币",
            cusCode: "142",
            codeValue: "CNY",
            gbName: "人民币",
            gbCode: "CNY",
            ciqCode: "156"
        },
        {
            codeName: "丹麦克朗",
            cusCode: "302",
            codeValue: "DKK",
            gbName: "丹麦克朗",
            gbCode: "DKK",
            ciqCode: "208"
        },
        {
            codeName: "欧元",
            cusCode: "300",
            codeValue: "EUR",
            gbName: "欧元",
            gbCode: "EUR",
            ciqCode: "910"
        },
        {
            codeName: "英镑",
            cusCode: "303",
            codeValue: "GBP",
            gbName: "英镑",
            gbCode: "GBP",
            ciqCode: "826"
        },
        {
            codeName: "港币",
            cusCode: "110",
            codeValue: "HKD",
            gbName: "港币",
            gbCode: "HKD",
            ciqCode: "344"
        },
        {
            codeName: "匈牙利福林",
            cusCode: "321",
            codeValue: "HUF",
            gbName: "匈牙利福林",
            gbCode: "HUF",
            ciqCode: null
        },
        {
            codeName: "印度尼西亚卢比",
            cusCode: "112",
            codeValue: "IDR",
            gbName: "印度尼西亚卢比",
            gbCode: "IDR",
            ciqCode: null
        },
        {
            codeName: "日本元",
            cusCode: "116",
            codeValue: "JPY",
            gbName: "日本元",
            gbCode: "JPY",
            ciqCode: "392"
        },
        {
            codeName: "柬埔寨瑞尔",
            cusCode: "107",
            codeValue: "KHR",
            gbName: "柬埔寨瑞尔",
            gbCode: "KHR",
            ciqCode: null
        },
        {
            codeName: "韩国圆",
            cusCode: "133",
            codeValue: "KRW",
            gbName: "韩国圆",
            gbCode: "KRW",
            ciqCode: "410"
        },
        {
            codeName: "哈萨克斯坦坚戈",
            cusCode: "145",
            codeValue: "KZT",
            gbName: "哈萨克斯坦坚戈",
            gbCode: "KZT",
            ciqCode: null
        },
        {
            codeName: "蒙古图格里克",
            cusCode: "124",
            codeValue: "MNT",
            gbName: "蒙古图格里克",
            gbCode: "MNT",
            ciqCode: null
        },
        {
            codeName: "澳门元",
            cusCode: "121",
            codeValue: "MOP",
            gbName: "澳门元",
            gbCode: "MOP",
            ciqCode: "446"
        },
        {
            codeName: "墨西哥比索",
            cusCode: "429",
            codeValue: "MXN",
            gbName: "墨西哥比索",
            gbCode: "MXN",
            ciqCode: null
        },
        {
            codeName: "马来西亚林吉特",
            cusCode: "122",
            codeValue: "MYR",
            gbName: "马来西亚林吉特",
            gbCode: "MYR",
            ciqCode: "458"
        },
        {
            codeName: "挪威克朗",
            cusCode: "326",
            codeValue: "NOK",
            gbName: "挪威克朗",
            gbCode: "NOK",
            ciqCode: "578"
        },
        {
            codeName: "新西兰元",
            cusCode: "609",
            codeValue: "NZD",
            gbName: "新西兰元",
            gbCode: "NZD",
            ciqCode: "554"
        },
        {
            codeName: "波兰兹罗提",
            cusCode: "327",
            codeValue: "PLN",
            gbName: "波兰兹罗提",
            gbCode: "PLN",
            ciqCode: null
        },
        {
            codeName: "俄罗斯卢布",
            cusCode: "344",
            codeValue: "RUB",
            gbName: "俄罗斯卢布",
            gbCode: "RUB",
            ciqCode: "643"
        },
        {
            codeName: "沙特里亚尔",
            cusCode: "131",
            codeValue: "SAR",
            gbName: "沙特里亚尔",
            gbCode: "SAR",
            ciqCode: null
        },
        {
            codeName: "瑞典克朗",
            cusCode: "330",
            codeValue: "SEK",
            gbName: "瑞典克朗",
            gbCode: "SEK",
            ciqCode: "752"
        },
        {
            codeName: "新加坡元",
            cusCode: "132",
            codeValue: "SGD",
            gbName: "新加坡元",
            gbCode: "SGD",
            ciqCode: "702"
        },
        {
            codeName: "泰国铢",
            cusCode: "136",
            codeValue: "THB",
            gbName: "泰国铢",
            gbCode: "THB",
            ciqCode: "764"
        },
        {
            codeName: "土耳其里拉",
            cusCode: "137",
            codeValue: "TRY",
            gbName: "土耳其里拉",
            gbCode: "TRY",
            ciqCode: null
        },
        {
            codeName: "美元",
            cusCode: "502",
            codeValue: "USD",
            gbName: "美元",
            gbCode: "USD",
            ciqCode: "840"
        },
        {
            codeName: "南非兰特",
            cusCode: "244",
            codeValue: "ZAR",
            gbName: "南非兰特",
            gbCode: "ZAR",
            ciqCode: null
        }
    ],
    // 监管证件代码表

    // 进口-入境口岸
    CIQ_PORT_CN: [
        {
            codeName: "北京",
            codeValue: "110001"
        },
        {
            codeName: "北京平谷国际陆港",
            codeValue: "110002"
        },
        {
            codeName: "北京天竺综合保税区",
            codeValue: "110003"
        },
        {
            codeName: "首都国际机场",
            codeValue: "110101"
        },
        {
            codeName: "北京丰台货运",
            codeValue: "110201"
        },
        {
            codeName: "北京朝阳口岸",
            codeValue: "110301"
        },
        {
            codeName: "北京西站",
            codeValue: "110801"
        },
        {
            codeName: "北京大兴国际机场",
            codeValue: "115301"
        },
        {
            codeName: "天津",
            codeValue: "120001"
        },
        {
            codeName: "北疆港区",
            codeValue: "120002"
        },
        {
            codeName: "天津保税物流园区",
            codeValue: "120003"
        },
        {
            codeName: "天津港保税区",
            codeValue: "120004"
        },
        {
            codeName: "中国（天津）自由贸易试验区",
            codeValue: "120011"
        },
        {
            codeName: "天津出口加工区",
            codeValue: "120201"
        },
        {
            codeName: "天津滨海新区综合保税区",
            codeValue: "120601"
        },
        {
            codeName: "大沽口港区",
            codeValue: "120801"
        },
        {
            codeName: "南疆港区",
            codeValue: "121001"
        },
        {
            codeName: "渤中",
            codeValue: "121002"
        },
        {
            codeName: "东疆港区",
            codeValue: "121501"
        },
        {
            codeName: "天津邮轮母港",
            codeValue: "121502"
        },
        {
            codeName: "天津新港客运码头",
            codeValue: "121503"
        },
        {
            codeName: "天津东疆保税港区",
            codeValue: "121504"
        },
        {
            codeName: "天津滨海国际机场货邮",
            codeValue: "121701"
        },
        {
            codeName: "天津滨海国际机场T1通道",
            codeValue: "121702"
        },
        {
            codeName: "天津滨海国际机场T2通道",
            codeValue: "121703"
        },
        {
            codeName: "石家庄",
            codeValue: "130001"
        },
        {
            codeName: "石家庄正定机场",
            codeValue: "130002"
        },
        {
            codeName: "秦皇岛",
            codeValue: "130101"
        },
        {
            codeName: "秦皇岛出口加工区",
            codeValue: "130102"
        },
        {
            codeName: "河北省唐山市",
            codeValue: "130200"
        },
        {
            codeName: "京唐港",
            codeValue: "130201"
        },
        {
            codeName: "唐山",
            codeValue: "130202"
        },
        {
            codeName: "曹妃甸港",
            codeValue: "130203"
        },
        {
            codeName: "曹妃甸综合保税区",
            codeValue: "130204"
        },
        {
            codeName: "河北省秦皇岛市",
            codeValue: "130300"
        },
        {
            codeName: "河北省邯郸市",
            codeValue: "130400"
        },
        {
            codeName: "河北省邢台市",
            codeValue: "130500"
        },
        {
            codeName: "河北省保定市",
            codeValue: "130600"
        },
        {
            codeName: "河北省张家口市",
            codeValue: "130700"
        },
        {
            codeName: "河北省承德市",
            codeValue: "130800"
        },
        {
            codeName: "河北省沧州市",
            codeValue: "130900"
        },
        {
            codeName: "河北省廊坊市",
            codeValue: "131000"
        },
        {
            codeName: "河北省衡水市",
            codeValue: "131100"
        },
        {
            codeName: "黄骅",
            codeValue: "131101"
        },
        {
            codeName: "石家庄综合保税区",
            codeValue: "131201"
        },
        {
            codeName: "雄安综保区",
            codeValue: "131300"
        },
        {
            codeName: "廊坊综合保税区",
            codeValue: "135701"
        },
        {
            codeName: "太原",
            codeValue: "140001"
        },
        {
            codeName: "太原武宿机场",
            codeValue: "140002"
        },
        {
            codeName: "太原武宿综合保税区",
            codeValue: "140003"
        },
        {
            codeName: "山西省大同市",
            codeValue: "140200"
        },
        {
            codeName: "山西省阳泉市",
            codeValue: "140300"
        },
        {
            codeName: "山西省长治市",
            codeValue: "140400"
        },
        {
            codeName: "山西省晋城市",
            codeValue: "140500"
        },
        {
            codeName: "山西省朔州市",
            codeValue: "140600"
        },
        {
            codeName: "山西省晋中市",
            codeValue: "140700"
        },
        {
            codeName: "山西省运城市",
            codeValue: "140800"
        },
        {
            codeName: "运城盐湖国际机场",
            codeValue: "140801"
        },
        {
            codeName: "山西省忻州市",
            codeValue: "140900"
        },
        {
            codeName: "山西省临汾市",
            codeValue: "141000"
        },
        {
            codeName: "山西省吕梁市",
            codeValue: "141100"
        },
        {
            codeName: "呼和浩特",
            codeValue: "150001"
        },
        {
            codeName: "呼和浩特白塔机场",
            codeValue: "150002"
        },
        {
            codeName: "鄂尔多斯伊金霍洛机场",
            codeValue: "150004"
        },
        {
            codeName: "满洲里西郊机场",
            codeValue: "150101"
        },
        {
            codeName: "满洲里铁路",
            codeValue: "150102"
        },
        {
            codeName: "二卡",
            codeValue: "150103"
        },
        {
            codeName: "满洲里十八里",
            codeValue: "150104"
        },
        {
            codeName: "阿日哈沙特",
            codeValue: "150105"
        },
        {
            codeName: "满洲里综合保税区",
            codeValue: "150106"
        },
        {
            codeName: "内蒙古自治区包头市",
            codeValue: "150200"
        },
        {
            codeName: "二连浩特铁路",
            codeValue: "150201"
        },
        {
            codeName: "二连浩特公路",
            codeValue: "150202"
        },
        {
            codeName: "内蒙古自治区乌海市",
            codeValue: "150300"
        },
        {
            codeName: "海拉尔东山机场",
            codeValue: "150301"
        },
        {
            codeName: "额布都格",
            codeValue: "150302"
        },
        {
            codeName: "胡列也吐",
            codeValue: "150303"
        },
        {
            codeName: "内蒙古自治区赤峰市",
            codeValue: "150400"
        },
        {
            codeName: "满都拉",
            codeValue: "150401"
        },
        {
            codeName: "内蒙古自治区通辽市",
            codeValue: "150500"
        },
        {
            codeName: "内蒙古自治区鄂尔多斯市",
            codeValue: "150600"
        },
        {
            codeName: "内蒙古自治区呼伦贝尔市",
            codeValue: "150700"
        },
        {
            codeName: "内蒙古自治区巴彦淖尔市",
            codeValue: "150800"
        },
        {
            codeName: "黑山头",
            codeValue: "150801"
        },
        {
            codeName: "室韦",
            codeValue: "150802"
        },
        {
            codeName: "内蒙古自治区乌兰察布市",
            codeValue: "150900"
        },
        {
            codeName: "策克",
            codeValue: "150901"
        },
        {
            codeName: "珠恩嘎达布其",
            codeValue: "151001"
        },
        {
            codeName: "甘其毛都",
            codeValue: "151101"
        },
        {
            codeName: "巴格毛都",
            codeValue: "151102"
        },
        {
            codeName: "阿尔山",
            codeValue: "151201"
        },
        {
            codeName: "内蒙古自治区兴安盟",
            codeValue: "152200"
        },
        {
            codeName: "内蒙古自治区锡林郭勒盟",
            codeValue: "152500"
        },
        {
            codeName: "内蒙古自治区阿拉善盟",
            codeValue: "152900"
        },
        {
            codeName: "包头保税物流中心（B型）",
            codeValue: "155401"
        },
        {
            codeName: "巴彦淖尔市保税物流中心（B型）",
            codeValue: "156101"
        },
        {
            codeName: "七苏木保税物流中心（B型）",
            codeValue: "156301"
        },
        {
            codeName: "乌力吉口岸",
            codeValue: "156501"
        },
        {
            codeName: "呼和浩特综合保税区",
            codeValue: "156601"
        },
        {
            codeName: "鄂尔多斯综合保税区",
            codeValue: "156800"
        },
        {
            codeName: "沈阳",
            codeValue: "210001"
        },
        {
            codeName: "大连港大窑湾港区",
            codeValue: "210101"
        },
        {
            codeName: "大连北良港区",
            codeValue: "210102"
        },
        {
            codeName: "大连港油品码头港区",
            codeValue: "210103"
        },
        {
            codeName: "大连大窑湾保税港区",
            codeValue: "210104"
        },
        {
            codeName: "辽宁省大连市",
            codeValue: "210200"
        },
        {
            codeName: "辽宁省鞍山市",
            codeValue: "210300"
        },
        {
            codeName: "沈阳桃仙国际机场",
            codeValue: "210301"
        },
        {
            codeName: "辽宁省抚顺市",
            codeValue: "210400"
        },
        {
            codeName: "锦州",
            codeValue: "210401"
        },
        {
            codeName: "辽宁省本溪市",
            codeValue: "210500"
        },
        {
            codeName: "辽宁省丹东市",
            codeValue: "210600"
        },
        {
            codeName: "辽宁省锦州市",
            codeValue: "210700"
        },
        {
            codeName: "丹东港浪头港区",
            codeValue: "210701"
        },
        {
            codeName: "丹东铁路",
            codeValue: "210702"
        },
        {
            codeName: "丹东公路",
            codeValue: "210703"
        },
        {
            codeName: "丹东输油管道",
            codeValue: "210704"
        },
        {
            codeName: "丹东太平湾",
            codeValue: "210705"
        },
        {
            codeName: "丹东长甸河口",
            codeValue: "210706"
        },
        {
            codeName: "丹东哑巴沟",
            codeValue: "210707"
        },
        {
            codeName: "丹东马市过货点",
            codeValue: "210708"
        },
        {
            codeName: "丹东安民",
            codeValue: "210709"
        },
        {
            codeName: "辽宁省营口市",
            codeValue: "210800"
        },
        {
            codeName: "丹东港大东港区",
            codeValue: "210801"
        },
        {
            codeName: "丹东大鹿岛",
            codeValue: "210802"
        },
        {
            codeName: "丹东大台子",
            codeValue: "210803"
        },
        {
            codeName: "丹东一撮毛过货点",
            codeValue: "210804"
        },
        {
            codeName: "丹东丹纸码头",
            codeValue: "210805"
        },
        {
            codeName: "辽宁省阜新市",
            codeValue: "210900"
        },
        {
            codeName: "营口港老港区",
            codeValue: "210901"
        },
        {
            codeName: "辽宁省辽阳市",
            codeValue: "211000"
        },
        {
            codeName: "营口港鲅鱼圈港区",
            codeValue: "211001"
        },
        {
            codeName: "营口港仙人岛港区",
            codeValue: "211002"
        },
        {
            codeName: "营口港保税物流园区",
            codeValue: "211003"
        },
        {
            codeName: "辽宁省盘锦市",
            codeValue: "211100"
        },
        {
            codeName: "辽宁省铁岭市",
            codeValue: "211200"
        },
        {
            codeName: "辽宁省朝阳市",
            codeValue: "211300"
        },
        {
            codeName: "辽宁省葫芦岛市",
            codeValue: "211400"
        },
        {
            codeName: "盘锦港",
            codeValue: "211401"
        },
        {
            codeName: "葫芦岛港",
            codeValue: "211501"
        },
        {
            codeName: "大连周水子国际机场",
            codeValue: "211801"
        },
        {
            codeName: "大连港香炉礁港区",
            codeValue: "211901"
        },
        {
            codeName: "大连港老港区",
            codeValue: "211902"
        },
        {
            codeName: "大连港大连湾港区",
            codeValue: "211903"
        },
        {
            codeName: "大连港汽车码头港区",
            codeValue: "211904"
        },
        {
            codeName: "大连港矿石码头港区",
            codeValue: "211905"
        },
        {
            codeName: "旅顺新港",
            codeValue: "211906"
        },
        {
            codeName: "庄河港",
            codeValue: "211907"
        },
        {
            codeName: "大连长海四块石码头",
            codeValue: "211908"
        },
        {
            codeName: "大连出口加工区",
            codeValue: "211909"
        },
        {
            codeName: "大连保税区",
            codeValue: "211910"
        },
        {
            codeName: "长兴岛港",
            codeValue: "212001"
        },
        {
            codeName: "沈阳综合保税区",
            codeValue: "212101"
        },
        {
            codeName: "长春",
            codeValue: "220001"
        },
        {
            codeName: "长春龙嘉国际机场",
            codeValue: "220002"
        },
        {
            codeName: "长春铁路",
            codeValue: "220003"
        },
        {
            codeName: "临江",
            codeValue: "220004"
        },
        {
            codeName: "大安",
            codeValue: "220005"
        },
        {
            codeName: "图们公路",
            codeValue: "220006"
        },
        {
            codeName: "图们铁路",
            codeValue: "220007"
        },
        {
            codeName: "船营",
            codeValue: "220008"
        },
        {
            codeName: "档石",
            codeValue: "220009"
        },
        {
            codeName: "下三道沟",
            codeValue: "220010"
        },
        {
            codeName: "长春兴隆综合保税区",
            codeValue: "220011"
        },
        {
            codeName: "双目峰公务通道",
            codeValue: "220101"
        },
        {
            codeName: "延吉朝阳川机场",
            codeValue: "220102"
        },
        {
            codeName: "三合",
            codeValue: "220103"
        },
        {
            codeName: "开山屯",
            codeValue: "220104"
        },
        {
            codeName: "南坪",
            codeValue: "220105"
        },
        {
            codeName: "古城里",
            codeValue: "220106"
        },
        {
            codeName: "吉林省吉林市",
            codeValue: "220200"
        },
        {
            codeName: "珲春公路",
            codeValue: "220201"
        },
        {
            codeName: "珲春铁路",
            codeValue: "220202"
        },
        {
            codeName: "沙坨子",
            codeValue: "220203"
        },
        {
            codeName: "圈河",
            codeValue: "220204"
        },
        {
            codeName: "珲春出口加工区",
            codeValue: "220205"
        },
        {
            codeName: "吉林省四平市",
            codeValue: "220300"
        },
        {
            codeName: "吉林省辽源市",
            codeValue: "220400"
        },
        {
            codeName: "吉林省通化市",
            codeValue: "220500"
        },
        {
            codeName: "集安铁路",
            codeValue: "220501"
        },
        {
            codeName: "老虎哨",
            codeValue: "220502"
        },
        {
            codeName: "青石",
            codeValue: "220503"
        },
        {
            codeName: "秋皮村",
            codeValue: "220504"
        },
        {
            codeName: "集安过货通道",
            codeValue: "220505"
        },
        {
            codeName: "吉林省白山市",
            codeValue: "220600"
        },
        {
            codeName: "长白",
            codeValue: "220601"
        },
        {
            codeName: "十三道沟",
            codeValue: "220602"
        },
        {
            codeName: "八道沟",
            codeValue: "220603"
        },
        {
            codeName: "南尖头",
            codeValue: "220604"
        },
        {
            codeName: "吉林省松原市",
            codeValue: "220700"
        },
        {
            codeName: "吉林铁路",
            codeValue: "220701"
        },
        {
            codeName: "吉林省白城市",
            codeValue: "220800"
        },
        {
            codeName: "吉林省延边朝鲜族自治州",
            codeValue: "222400"
        },
        {
            codeName: "哈尔滨",
            codeValue: "230001"
        },
        {
            codeName: "哈尔滨太平国际机场",
            codeValue: "230002"
        },
        {
            codeName: "嘉荫",
            codeValue: "230003"
        },
        {
            codeName: "漠河",
            codeValue: "230004"
        },
        {
            codeName: "绥芬河综合保税区",
            codeValue: "230005"
        },
        {
            codeName: "齐齐哈尔三家子机场",
            codeValue: "230101"
        },
        {
            codeName: "黑龙江省齐齐哈尔市",
            codeValue: "230200"
        },
        {
            codeName: "大庆",
            codeValue: "230201"
        },
        {
            codeName: "黑龙江省鸡西市",
            codeValue: "230300"
        },
        {
            codeName: "牡丹江海浪机场",
            codeValue: "230301"
        },
        {
            codeName: "黑龙江省鹤岗市",
            codeValue: "230400"
        },
        {
            codeName: "绥芬河铁路",
            codeValue: "230401"
        },
        {
            codeName: "绥芬河公路",
            codeValue: "230402"
        },
        {
            codeName: "黑龙江省双鸭山市",
            codeValue: "230500"
        },
        {
            codeName: "虎林",
            codeValue: "230501"
        },
        {
            codeName: "黑龙江省大庆市",
            codeValue: "230600"
        },
        {
            codeName: "密山",
            codeValue: "230601"
        },
        {
            codeName: "黑龙江省伊春市",
            codeValue: "230700"
        },
        {
            codeName: "佳木斯港",
            codeValue: "230701"
        },
        {
            codeName: "佳木斯东郊机场",
            codeValue: "230702"
        },
        {
            codeName: "桦川",
            codeValue: "230703"
        },
        {
            codeName: "黑龙江省佳木斯市",
            codeValue: "230800"
        },
        {
            codeName: "饶河",
            codeValue: "230801"
        },
        {
            codeName: "黑龙江省七台河市",
            codeValue: "230900"
        },
        {
            codeName: "同江",
            codeValue: "230901"
        },
        {
            codeName: "黑龙江省牡丹江市",
            codeValue: "231000"
        },
        {
            codeName: "抚远",
            codeValue: "231001"
        },
        {
            codeName: "黑龙江省黑河市",
            codeValue: "231100"
        },
        {
            codeName: "黑河",
            codeValue: "231101"
        },
        {
            codeName: "孙吴港",
            codeValue: "231102"
        },
        {
            codeName: "孙吴边境通道",
            codeValue: "231103"
        },
        {
            codeName: "呼玛",
            codeValue: "231104"
        },
        {
            codeName: "黑龙江省绥化市",
            codeValue: "231200"
        },
        {
            codeName: "逊克",
            codeValue: "231201"
        },
        {
            codeName: "萝北",
            codeValue: "231401"
        },
        {
            codeName: "东宁",
            codeValue: "231501"
        },
        {
            codeName: "绥滨",
            codeValue: "231601"
        },
        {
            codeName: "富锦",
            codeValue: "231602"
        },
        {
            codeName: "哈尔滨港",
            codeValue: "231701"
        },
        {
            codeName: "哈尔滨站",
            codeValue: "231702"
        },
        {
            codeName: "黑龙江省大兴安岭地区",
            codeValue: "232700"
        },
        {
            codeName: "上海",
            codeValue: "310001"
        },
        {
            codeName: "龙吴",
            codeValue: "310002"
        },
        {
            codeName: "中国（上海）自由贸易试验区",
            codeValue: "310011"
        },
        {
            codeName: "上海嘉定出口加工区",
            codeValue: "310101"
        },
        {
            codeName: "上海青浦出口加工区",
            codeValue: "310102"
        },
        {
            codeName: "上海金桥出口加工区",
            codeValue: "310201"
        },
        {
            codeName: "上海虹桥国际机场",
            codeValue: "310301"
        },
        {
            codeName: "上海浦东国际机场",
            codeValue: "310302"
        },
        {
            codeName: "上海浦东机场综合保税区",
            codeValue: "310303"
        },
        {
            codeName: "罗泾",
            codeValue: "310401"
        },
        {
            codeName: "吴淞",
            codeValue: "310402"
        },
        {
            codeName: "崇明",
            codeValue: "310501"
        },
        {
            codeName: "外高桥",
            codeValue: "310701"
        },
        {
            codeName: "上海外高桥保税物流园区",
            codeValue: "310702"
        },
        {
            codeName: "上海外高桥保税区",
            codeValue: "310703"
        },
        {
            codeName: "上海漕河泾出口加工区",
            codeValue: "310901"
        },
        {
            codeName: "浦东临港产业作业区",
            codeValue: "311001"
        },
        {
            codeName: "洋山港",
            codeValue: "311002"
        },
        {
            codeName: "洋山保税港区",
            codeValue: "311003"
        },
        {
            codeName: "上海站",
            codeValue: "311201"
        },
        {
            codeName: "上海松江出口加工区A区",
            codeValue: "311301"
        },
        {
            codeName: "上海松江出口加工区B区",
            codeValue: "311302"
        },
        {
            codeName: "上海奉贤综合保税区",
            codeValue: "317001"
        },
        {
            codeName: "南京",
            codeValue: "320001"
        },
        {
            codeName: "南京禄口国际机场",
            codeValue: "320101"
        },
        {
            codeName: "南京港",
            codeValue: "320102"
        },
        {
            codeName: "南京出口加工区",
            codeValue: "320103"
        },
        {
            codeName: "南京综合保税区",
            codeValue: "320104"
        },
        {
            codeName: "江苏省无锡市",
            codeValue: "320200"
        },
        {
            codeName: "苏州",
            codeValue: "320201"
        },
        {
            codeName: "苏州工业园综合保税区",
            codeValue: "320202"
        },
        {
            codeName: "苏州高新技术产业开发区综合保税区",
            codeValue: "320203"
        },
        {
            codeName: "吴中出口加工区",
            codeValue: "320204"
        },
        {
            codeName: "江苏省徐州市",
            codeValue: "320300"
        },
        {
            codeName: "吴江出口加工区",
            codeValue: "320301"
        },
        {
            codeName: "江苏省常州市",
            codeValue: "320400"
        },
        {
            codeName: "昆山综合保税区",
            codeValue: "320401"
        },
        {
            codeName: "江苏省苏州市",
            codeValue: "320500"
        },
        {
            codeName: "张家港",
            codeValue: "320501"
        },
        {
            codeName: "张家港保税港区",
            codeValue: "320502"
        },
        {
            codeName: "江苏省南通市",
            codeValue: "320600"
        },
        {
            codeName: "常熟",
            codeValue: "320601"
        },
        {
            codeName: "常熟出口加工区",
            codeValue: "320602"
        },
        {
            codeName: "江苏省连云港市",
            codeValue: "320700"
        },
        {
            codeName: "太仓",
            codeValue: "320701"
        },
        {
            codeName: "太仓港综合保税区",
            codeValue: "320702"
        },
        {
            codeName: "江苏省淮安市",
            codeValue: "320800"
        },
        {
            codeName: "无锡",
            codeValue: "320801"
        },
        {
            codeName: "苏南硕放国际机场",
            codeValue: "320802"
        },
        {
            codeName: "无锡高新区综合保税区",
            codeValue: "320803"
        },
        {
            codeName: "无锡出口加工区",
            codeValue: "320804"
        },
        {
            codeName: "江苏省盐城市",
            codeValue: "320900"
        },
        {
            codeName: "江阴",
            codeValue: "320901"
        },
        {
            codeName: "江苏省扬州市",
            codeValue: "321000"
        },
        {
            codeName: "江苏省镇江市",
            codeValue: "321100"
        },
        {
            codeName: "南通",
            codeValue: "321101"
        },
        {
            codeName: "如皋",
            codeValue: "321103"
        },
        {
            codeName: "南通综合保税区",
            codeValue: "321104"
        },
        {
            codeName: "南通机场",
            codeValue: "321106"
        },
        {
            codeName: "江苏省泰州市",
            codeValue: "321200"
        },
        {
            codeName: "连云港",
            codeValue: "321201"
        },
        {
            codeName: "连云港出口加工区",
            codeValue: "321202"
        },
        {
            codeName: "江苏省宿迁市",
            codeValue: "321300"
        },
        {
            codeName: "镇江",
            codeValue: "321301"
        },
        {
            codeName: "镇江出口加工区",
            codeValue: "321302"
        },
        {
            codeName: "徐州机场",
            codeValue: "321401"
        },
        {
            codeName: "淮安综合保税区",
            codeValue: "321501"
        },
        {
            codeName: "淮安出口加工区",
            codeValue: "321502"
        },
        {
            codeName: "常州",
            codeValue: "321601"
        },
        {
            codeName: "常州出口加工区",
            codeValue: "321602"
        },
        {
            codeName: "武进出口加工区",
            codeValue: "321603"
        },
        {
            codeName: "常州奔牛机场",
            codeValue: "321604"
        },
        {
            codeName: "盐城机场",
            codeValue: "321701"
        },
        {
            codeName: "射阳",
            codeValue: "321702"
        },
        {
            codeName: "盐城综合保税区",
            codeValue: "321703"
        },
        {
            codeName: "大丰",
            codeValue: "321704"
        },
        {
            codeName: "扬州",
            codeValue: "321801"
        },
        {
            codeName: "扬州出口加工区",
            codeValue: "321802"
        },
        {
            codeName: "高港",
            codeValue: "321901"
        },
        {
            codeName: "泰州",
            codeValue: "321902"
        },
        {
            codeName: "靖江",
            codeValue: "322201"
        },
        {
            codeName: "泰州出口加工区",
            codeValue: "322202"
        },
        {
            codeName: "启东",
            codeValue: "322401"
        },
        {
            codeName: "如东洋口",
            codeValue: "322501"
        },
        {
            codeName: "杭州",
            codeValue: "330001"
        },
        {
            codeName: "杭州萧山国际机场",
            codeValue: "330002"
        },
        {
            codeName: "温州龙湾国际机场",
            codeValue: "330101"
        },
        {
            codeName: "温州港瓯江港区七里作业区",
            codeValue: "330102"
        },
        {
            codeName: "温州港平阳港区",
            codeValue: "330103"
        },
        {
            codeName: "温州港状元岙港区",
            codeValue: "330104"
        },
        {
            codeName: "温州港乐清湾港区",
            codeValue: "330105"
        },
        {
            codeName: "温州港大小门岛港区",
            codeValue: "330106"
        },
        {
            codeName: "浙江省宁波市",
            codeValue: "330200"
        },
        {
            codeName: "金义综合保税区",
            codeValue: "330201"
        },
        {
            codeName: "浙江省温州市",
            codeValue: "330300"
        },
        {
            codeName: "舟山",
            codeValue: "330301"
        },
        {
            codeName: "舟山定海港区",
            codeValue: "330302"
        },
        {
            codeName: "舟山定海岙山油库",
            codeValue: "330303"
        },
        {
            codeName: "舟山定海万向油库",
            codeValue: "330304"
        },
        {
            codeName: "舟山老塘山港区",
            codeValue: "330305"
        },
        {
            codeName: "舟山老塘山三期码头",
            codeValue: "330306"
        },
        {
            codeName: "舟山老塘山五期码头",
            codeValue: "330307"
        },
        {
            codeName: "舟山老塘山册子油库",
            codeValue: "330308"
        },
        {
            codeName: "舟山金塘港区",
            codeValue: "330309"
        },
        {
            codeName: "舟山金塘集装箱码头",
            codeValue: "330310"
        },
        {
            codeName: "舟山沈家门港区",
            codeValue: "330311"
        },
        {
            codeName: "舟山沈家门半升洞油库",
            codeValue: "330312"
        },
        {
            codeName: "舟山六横港区",
            codeValue: "330313"
        },
        {
            codeName: "舟山六横煤电码头",
            codeValue: "330314"
        },
        {
            codeName: "舟山六横武港码头",
            codeValue: "330315"
        },
        {
            codeName: "舟山六横金润石油",
            codeValue: "330316"
        },
        {
            codeName: "舟山衢山港区",
            codeValue: "330317"
        },
        {
            codeName: "舟山马岙港区",
            codeValue: "330318"
        },
        {
            codeName: "舟山马岙太平洋化工",
            codeValue: "330319"
        },
        {
            codeName: "舟山马岙纳海油污",
            codeValue: "330320"
        },
        {
            codeName: "舟山马岙天禄能源",
            codeValue: "330321"
        },
        {
            codeName: "岱山高亭",
            codeValue: "330322"
        },
        {
            codeName: "舟山港综合保税区",
            codeValue: "330323"
        },
        {
            codeName: "浙江省嘉兴市",
            codeValue: "330400"
        },
        {
            codeName: "泗礁",
            codeValue: "330401"
        },
        {
            codeName: "浙江省湖州市",
            codeValue: "330500"
        },
        {
            codeName: "海门",
            codeValue: "330501"
        },
        {
            codeName: "台州",
            codeValue: "330502"
        },
        {
            codeName: "大麦屿",
            codeValue: "330503"
        },
        {
            codeName: "浙江省绍兴市",
            codeValue: "330600"
        },
        {
            codeName: "浙江省金华市",
            codeValue: "330700"
        },
        {
            codeName: "嘉兴",
            codeValue: "330701"
        },
        {
            codeName: "嘉兴港",
            codeValue: "330702"
        },
        {
            codeName: "嘉兴出口加工区A区",
            codeValue: "330703"
        },
        {
            codeName: "嘉兴出口加工区B区",
            codeValue: "330704"
        },
        {
            codeName: "浙江省衢州市",
            codeValue: "330800"
        },
        {
            codeName: "湖州",
            codeValue: "330801"
        },
        {
            codeName: "湖州南浔",
            codeValue: "330802"
        },
        {
            codeName: "湖州安吉川达",
            codeValue: "330803"
        },
        {
            codeName: "浙江省舟山市",
            codeValue: "330900"
        },
        {
            codeName: "浙江省台州市",
            codeValue: "331000"
        },
        {
            codeName: "浙江省丽水市",
            codeValue: "331100"
        },
        {
            codeName: "杭州保税物流园区（B型）",
            codeValue: "331101"
        },
        {
            codeName: "义乌",
            codeValue: "331201"
        },
        {
            codeName: "杭州出口加工区",
            codeValue: "333301"
        },
        {
            codeName: "杭州中和保税区",
            codeValue: "333302"
        },
        {
            codeName: "合肥",
            codeValue: "340001"
        },
        {
            codeName: "合肥新桥国际机场",
            codeValue: "340002"
        },
        {
            codeName: "合肥新站",
            codeValue: "340003"
        },
        {
            codeName: "六安",
            codeValue: "340004"
        },
        {
            codeName: "芜湖出口加工区",
            codeValue: "340005"
        },
        {
            codeName: "合肥出口加工区",
            codeValue: "340006"
        },
        {
            codeName: "合肥综合保税区",
            codeValue: "340007"
        },
        {
            codeName: "芜湖",
            codeValue: "340101"
        },
        {
            codeName: "安徽省芜湖市",
            codeValue: "340200"
        },
        {
            codeName: "安庆",
            codeValue: "340201"
        },
        {
            codeName: "安徽省蚌埠市",
            codeValue: "340300"
        },
        {
            codeName: "铜陵",
            codeValue: "340301"
        },
        {
            codeName: "安徽省淮南市",
            codeValue: "340400"
        },
        {
            codeName: "马鞍山",
            codeValue: "340401"
        },
        {
            codeName: "安徽省马鞍山市",
            codeValue: "340500"
        },
        {
            codeName: "蚌埠",
            codeValue: "340501"
        },
        {
            codeName: "淮南",
            codeValue: "340502"
        },
        {
            codeName: "安徽省淮北市",
            codeValue: "340600"
        },
        {
            codeName: "阜阳",
            codeValue: "340601"
        },
        {
            codeName: "亳州",
            codeValue: "340602"
        },
        {
            codeName: "安徽省铜陵市",
            codeValue: "340700"
        },
        {
            codeName: "黄山屯溪机场",
            codeValue: "340701"
        },
        {
            codeName: "安徽省安庆市",
            codeValue: "340800"
        },
        {
            codeName: "池州",
            codeValue: "340801"
        },
        {
            codeName: "滁州",
            codeValue: "340901"
        },
        {
            codeName: "安徽省黄山市",
            codeValue: "341000"
        },
        {
            codeName: "宣城",
            codeValue: "341001"
        },
        {
            codeName: "安徽省滁州市",
            codeValue: "341100"
        },
        {
            codeName: "安徽省阜阳市",
            codeValue: "341200"
        },
        {
            codeName: "淮北",
            codeValue: "341201"
        },
        {
            codeName: "宿州",
            codeValue: "341202"
        },
        {
            codeName: "安徽省宿州市",
            codeValue: "341300"
        },
        {
            codeName: "安徽省六安市",
            codeValue: "341500"
        },
        {
            codeName: "安徽省亳州市",
            codeValue: "341600"
        },
        {
            codeName: "安徽省池州市",
            codeValue: "341700"
        },
        {
            codeName: "安徽省宣城市",
            codeValue: "341800"
        },
        {
            codeName: "福州",
            codeValue: "350001"
        },
        {
            codeName: "福州港江阴港区非保税码头",
            codeValue: "350002"
        },
        {
            codeName: "福州港平潭金井码头",
            codeValue: "350003"
        },
        {
            codeName: "平潭港口岸澳前港区",
            codeValue: "350004"
        },
        {
            codeName: "福州港平潭澳前客滚码头",
            codeValue: "350005"
        },
        {
            codeName: "武夷山机场",
            codeValue: "350006"
        },
        {
            codeName: "武夷山陆地港",
            codeValue: "350007"
        },
        {
            codeName: "福州保税港区",
            codeValue: "350008"
        },
        {
            codeName: "中国（福建）自由贸易试验区",
            codeValue: "350011"
        },
        {
            codeName: "泉州港肖厝港区",
            codeValue: "350101"
        },
        {
            codeName: "泉州港泉州湾港区",
            codeValue: "350102"
        },
        {
            codeName: "泉州港围头湾港区",
            codeValue: "350103"
        },
        {
            codeName: "泉州港深沪湾港区",
            codeValue: "350104"
        },
        {
            codeName: "泉州港斗尾港区",
            codeValue: "350105"
        },
        {
            codeName: "泉州港石井客运码头",
            codeValue: "350106"
        },
        {
            codeName: "泉州港肖厝小额贸易点",
            codeValue: "350107"
        },
        {
            codeName: "泉州惠安崇武小额贸易点",
            codeValue: "350108"
        },
        {
            codeName: "泉州后渚小额贸易点",
            codeValue: "350109"
        },
        {
            codeName: "泉州石狮石湖小额贸易点",
            codeValue: "350110"
        },
        {
            codeName: "泉州晋江围头小额贸易点",
            codeValue: "350111"
        },
        {
            codeName: "泉州晋江深沪小额贸易点",
            codeValue: "350112"
        },
        {
            codeName: "泉州南安石井小额贸易点",
            codeValue: "350113"
        },
        {
            codeName: "泉州晋江陆地港",
            codeValue: "350114"
        },
        {
            codeName: "泉州晋江机场",
            codeValue: "350115"
        },
        {
            codeName: "泉州出口加工区",
            codeValue: "350116"
        },
        {
            codeName: "福建省厦门市",
            codeValue: "350200"
        },
        {
            codeName: "莆田湄洲岛小额贸易点",
            codeValue: "350201"
        },
        {
            codeName: "莆田港秀屿港区",
            codeValue: "350202"
        },
        {
            codeName: "莆田港湄洲岛客运码头",
            codeValue: "350203"
        },
        {
            codeName: "莆田港东吴港区",
            codeValue: "350204"
        },
        {
            codeName: "福建省莆田市",
            codeValue: "350300"
        },
        {
            codeName: "三明陆地港",
            codeValue: "350301"
        },
        {
            codeName: "福建省三明市",
            codeValue: "350400"
        },
        {
            codeName: "福州港马尾客运码头",
            codeValue: "350401"
        },
        {
            codeName: "福州港闽江口内港区",
            codeValue: "350402"
        },
        {
            codeName: "福州港马尾小额贸易点",
            codeValue: "350403"
        },
        {
            codeName: "福州港连江琯头小额贸易点",
            codeValue: "350404"
        },
        {
            codeName: "福州港罗源迹头小额贸易点",
            codeValue: "350405"
        },
        {
            codeName: "福州港罗源湾港区",
            codeValue: "350406"
        },
        {
            codeName: "福州港黄岐港区",
            codeValue: "350407"
        },
        {
            codeName: "福州港松下港区牛头湾作业区",
            codeValue: "350408"
        },
        {
            codeName: "福州港松下港区长乐松下小额贸易点",
            codeValue: "350409"
        },
        {
            codeName: "福州保税区",
            codeValue: "350410"
        },
        {
            codeName: "福州出口加工区",
            codeValue: "350411"
        },
        {
            codeName: "福建省泉州市",
            codeValue: "350500"
        },
        {
            codeName: "宁德港三都澳港区",
            codeValue: "350501"
        },
        {
            codeName: "宁德港三沙港区",
            codeValue: "350502"
        },
        {
            codeName: "宁德港沙埕港区",
            codeValue: "350503"
        },
        {
            codeName: "宁德港赛江港区",
            codeValue: "350504"
        },
        {
            codeName: "霞浦三沙小额贸易点",
            codeValue: "350505"
        },
        {
            codeName: "福建省漳州市",
            codeValue: "350600"
        },
        {
            codeName: "福州港松下港区元洪作业区",
            codeValue: "350601"
        },
        {
            codeName: "福州港松下港区南青屿小额贸易点",
            codeValue: "350602"
        },
        {
            codeName: "福建省南平市",
            codeValue: "350700"
        },
        {
            codeName: "福建省龙岩市",
            codeValue: "350800"
        },
        {
            codeName: "福建省宁德市",
            codeValue: "350900"
        },
        {
            codeName: "龙岩陆地港",
            codeValue: "350901"
        },
        {
            codeName: "东山湾东山港区",
            codeValue: "351101"
        },
        {
            codeName: "东山湾诏安港区",
            codeValue: "351102"
        },
        {
            codeName: "漳州东山铜陵小额贸易点",
            codeValue: "351103"
        },
        {
            codeName: "漳州云霄礁美小额贸易点",
            codeValue: "351104"
        },
        {
            codeName: "漳州诏安田厝小额贸易点",
            codeValue: "351105"
        },
        {
            codeName: "福州长乐国际机场",
            codeValue: "351201"
        },
        {
            codeName: "平潭综合实验区",
            codeValue: "355800"
        },
        {
            codeName: "南昌",
            codeValue: "360001"
        },
        {
            codeName: "南昌昌北机场",
            codeValue: "360002"
        },
        {
            codeName: "南昌出口加工区",
            codeValue: "360003"
        },
        {
            codeName: "九江",
            codeValue: "360101"
        },
        {
            codeName: "江西省景德镇市",
            codeValue: "360200"
        },
        {
            codeName: "江西省萍乡市",
            codeValue: "360300"
        },
        {
            codeName: "赣州出口加工区",
            codeValue: "360301"
        },
        {
            codeName: "赣州综合保税区",
            codeValue: "360302"
        },
        {
            codeName: "江西省九江市",
            codeValue: "360400"
        },
        {
            codeName: "江西省新余市",
            codeValue: "360500"
        },
        {
            codeName: "江西省鹰潭市",
            codeValue: "360600"
        },
        {
            codeName: "井冈山出口加工区",
            codeValue: "360601"
        },
        {
            codeName: "江西省赣州市",
            codeValue: "360700"
        },
        {
            codeName: "江西省吉安市",
            codeValue: "360800"
        },
        {
            codeName: "江西省宜春市",
            codeValue: "360900"
        },
        {
            codeName: "江西省抚州市",
            codeValue: "361000"
        },
        {
            codeName: "江西省上饶市",
            codeValue: "361100"
        },
        {
            codeName: "九江综合保税区",
            codeValue: "365102"
        },
        {
            codeName: "济南",
            codeValue: "370001"
        },
        {
            codeName: "日照",
            codeValue: "370002"
        },
        {
            codeName: "岚山",
            codeValue: "370003"
        },
        {
            codeName: "青岛港",
            codeValue: "370101"
        },
        {
            codeName: "山东省青岛市",
            codeValue: "370200"
        },
        {
            codeName: "黄岛",
            codeValue: "370201"
        },
        {
            codeName: "青岛前湾保税港区",
            codeValue: "370202"
        },
        {
            codeName: "青岛西海岸出口加工区",
            codeValue: "370203"
        },
        {
            codeName: "山东省淄博市",
            codeValue: "370300"
        },
        {
            codeName: "烟台莱山机场",
            codeValue: "370301"
        },
        {
            codeName: "烟台港",
            codeValue: "370302"
        },
        {
            codeName: "烟台保税港区A区",
            codeValue: "370303"
        },
        {
            codeName: "烟台保税港区B区",
            codeValue: "370304"
        },
        {
            codeName: "山东省枣庄市",
            codeValue: "370400"
        },
        {
            codeName: "石岛",
            codeValue: "370401"
        },
        {
            codeName: "龙眼",
            codeValue: "370402"
        },
        {
            codeName: "山东省东营市",
            codeValue: "370500"
        },
        {
            codeName: "龙口",
            codeValue: "370501"
        },
        {
            codeName: "山东省烟台市",
            codeValue: "370600"
        },
        {
            codeName: "莱州",
            codeValue: "370601"
        },
        {
            codeName: "山东省潍坊市",
            codeValue: "370700"
        },
        {
            codeName: "济南遥墙机场",
            codeValue: "370701"
        },
        {
            codeName: "济南综合保税区",
            codeValue: "370702"
        },
        {
            codeName: "济南出口加工区",
            codeValue: "370703"
        },
        {
            codeName: "山东省济宁市",
            codeValue: "370800"
        },
        {
            codeName: "济宁站",
            codeValue: "370801"
        },
        {
            codeName: "山东省泰安市",
            codeValue: "370900"
        },
        {
            codeName: "潍坊",
            codeValue: "370901"
        },
        {
            codeName: "潍坊综合保税区",
            codeValue: "370902"
        },
        {
            codeName: "山东省威海市",
            codeValue: "371000"
        },
        {
            codeName: "山东省日照市",
            codeValue: "371100"
        },
        {
            codeName: "山东省莱芜市",
            codeValue: "371200"
        },
        {
            codeName: "威海机场",
            codeValue: "371201"
        },
        {
            codeName: "威海港",
            codeValue: "371202"
        },
        {
            codeName: "威海出口加工区",
            codeValue: "371203"
        },
        {
            codeName: "山东省临沂市",
            codeValue: "371300"
        },
        {
            codeName: "山东省德州市",
            codeValue: "371400"
        },
        {
            codeName: "山东省聊城市",
            codeValue: "371500"
        },
        {
            codeName: "山东省滨州市",
            codeValue: "371600"
        },
        {
            codeName: "山东省菏泽市",
            codeValue: "371700"
        },
        {
            codeName: "临沂站",
            codeValue: "371801"
        },
        {
            codeName: "临沂综合保税区",
            codeValue: "371802"
        },
        {
            codeName: "东营",
            codeValue: "371901"
        },
        {
            codeName: "东营综合保税区",
            codeValue: "371902"
        },
        {
            codeName: "青岛胶东国际机场",
            codeValue: "372301"
        },
        {
            codeName: "蓬莱",
            codeValue: "372401"
        },
        {
            codeName: "青岛胶州湾综合保税区",
            codeValue: "375101"
        },
        {
            codeName: "烟台福山回里保税物流中心（B型）",
            codeValue: "375301"
        },
        {
            codeName: "宁波",
            codeValue: "380001"
        },
        {
            codeName: "宁波栎社机场",
            codeValue: "380002"
        },
        {
            codeName: "宁波甬江港区",
            codeValue: "380003"
        },
        {
            codeName: "宁波出口加工区",
            codeValue: "380004"
        },
        {
            codeName: "宁波保税区",
            codeValue: "380005"
        },
        {
            codeName: "宁波北仑港港区",
            codeValue: "380101"
        },
        {
            codeName: "宁波穿山港区",
            codeValue: "380102"
        },
        {
            codeName: "慈溪出口加工区",
            codeValue: "380201"
        },
        {
            codeName: "宁波象山石浦港区",
            codeValue: "380701"
        },
        {
            codeName: "宁波象山港区",
            codeValue: "380702"
        },
        {
            codeName: "宁波大榭港区",
            codeValue: "380801"
        },
        {
            codeName: "宁波梅山保税港区",
            codeValue: "380901"
        },
        {
            codeName: "宁波镇海港区",
            codeValue: "381001"
        },
        {
            codeName: "厦门",
            codeValue: "390001"
        },
        {
            codeName: "厦门邮轮中心",
            codeValue: "390002"
        },
        {
            codeName: "刘五店",
            codeValue: "390003"
        },
        {
            codeName: "大磴岛",
            codeValue: "390004"
        },
        {
            codeName: "厦门象屿保税物流园区",
            codeValue: "390005"
        },
        {
            codeName: "厦门翔安火炬保税物流园区",
            codeValue: "390007"
        },
        {
            codeName: "厦门保税区",
            codeValue: "390008"
        },
        {
            codeName: "厦门海沧港区",
            codeValue: "390101"
        },
        {
            codeName: "厦门海沧保税港区",
            codeValue: "390102"
        },
        {
            codeName: "漳州招银港区",
            codeValue: "390301"
        },
        {
            codeName: "漳州后石港区",
            codeValue: "390302"
        },
        {
            codeName: "漳州古雷港区",
            codeValue: "390303"
        },
        {
            codeName: "漳州旧镇港区",
            codeValue: "390304"
        },
        {
            codeName: "漳州石码港区",
            codeValue: "390305"
        },
        {
            codeName: "厦门高崎国际机场",
            codeValue: "399101"
        },
        {
            codeName: "厦门五通码头",
            codeValue: "399102"
        },
        {
            codeName: "厦门五缘湾码头",
            codeValue: "399103"
        },
        {
            codeName: "厦门东渡港区",
            codeValue: "399501"
        },
        {
            codeName: "济南章锦综合保税区",
            codeValue: "405301"
        },
        {
            codeName: "淄博综合保税区",
            codeValue: "405401"
        },
        {
            codeName: "郑州",
            codeValue: "410001"
        },
        {
            codeName: "郑州查验场",
            codeValue: "410002"
        },
        {
            codeName: "郑州新郑国际机场",
            codeValue: "410003"
        },
        {
            codeName: "郑州站",
            codeValue: "410004"
        },
        {
            codeName: "郑州出口加工区",
            codeValue: "410005"
        },
        {
            codeName: "洛阳北郊机场",
            codeValue: "410101"
        },
        {
            codeName: "河南省开封市",
            codeValue: "410200"
        },
        {
            codeName: "河南省洛阳市",
            codeValue: "410300"
        },
        {
            codeName: "河南省平顶山市",
            codeValue: "410400"
        },
        {
            codeName: "河南省安阳市",
            codeValue: "410500"
        },
        {
            codeName: "漯河查验场",
            codeValue: "410501"
        },
        {
            codeName: "河南省鹤壁市",
            codeValue: "410600"
        },
        {
            codeName: "南阳卧龙综合保税区",
            codeValue: "410601"
        },
        {
            codeName: "河南省新乡市",
            codeValue: "410700"
        },
        {
            codeName: "河南省焦作市",
            codeValue: "410800"
        },
        {
            codeName: "河南省濮阳市",
            codeValue: "410900"
        },
        {
            codeName: "郑州新郑综合保税区",
            codeValue: "410901"
        },
        {
            codeName: "河南省许昌市",
            codeValue: "411000"
        },
        {
            codeName: "河南省漯河市",
            codeValue: "411100"
        },
        {
            codeName: "河南省三门峡市",
            codeValue: "411200"
        },
        {
            codeName: "河南省南阳市",
            codeValue: "411300"
        },
        {
            codeName: "河南省商丘市",
            codeValue: "411400"
        },
        {
            codeName: "河南省信阳市",
            codeValue: "411500"
        },
        {
            codeName: "河南省周口市",
            codeValue: "411600"
        },
        {
            codeName: "河南省驻马店市",
            codeValue: "411700"
        },
        {
            codeName: "河南省省直辖县级行政区划",
            codeValue: "419000"
        },
        {
            codeName: "武汉",
            codeValue: "420001"
        },
        {
            codeName: "武汉天河机场",
            codeValue: "420002"
        },
        {
            codeName: "武汉阳逻水运港",
            codeValue: "420003"
        },
        {
            codeName: "武汉经开综合保税区",
            codeValue: "420004"
        },
        {
            codeName: "武汉东西湖保税物流园区",
            codeValue: "420005"
        },
        {
            codeName: "武汉东湖综合保税区",
            codeValue: "420006"
        },
        {
            codeName: "武汉新港空港综合保税区",
            codeValue: "420007"
        },
        {
            codeName: "荆州盐卡",
            codeValue: "420101"
        },
        {
            codeName: "湖北省黄石市",
            codeValue: "420200"
        },
        {
            codeName: "襄阳铁路",
            codeValue: "420201"
        },
        {
            codeName: "襄阳公路",
            codeValue: "420202"
        },
        {
            codeName: "十堰公路",
            codeValue: "420203"
        },
        {
            codeName: "湖北省十堰市",
            codeValue: "420300"
        },
        {
            codeName: "宜昌三峡机场",
            codeValue: "420301"
        },
        {
            codeName: "宜昌水运港",
            codeValue: "420302"
        },
        {
            codeName: "黄石水运港",
            codeValue: "420401"
        },
        {
            codeName: "湖北省宜昌市",
            codeValue: "420500"
        },
        {
            codeName: "湖北省襄阳市",
            codeValue: "420600"
        },
        {
            codeName: "湖北省鄂州市",
            codeValue: "420700"
        },
        {
            codeName: "湖北省荆门市",
            codeValue: "420800"
        },
        {
            codeName: "湖北省孝感市",
            codeValue: "420900"
        },
        {
            codeName: "湖北省荆州市",
            codeValue: "421000"
        },
        {
            codeName: "湖北省黄冈市",
            codeValue: "421100"
        },
        {
            codeName: "湖北省咸宁市",
            codeValue: "421200"
        },
        {
            codeName: "湖北省随州市",
            codeValue: "421300"
        },
        {
            codeName: "湖北省恩施土家族苗族自治州",
            codeValue: "422800"
        },
        {
            codeName: "湖北省省直辖县级行政区划",
            codeValue: "429000"
        },
        {
            codeName: "长沙",
            codeValue: "430001"
        },
        {
            codeName: "长沙黄花国际机场旅检通道",
            codeValue: "430002"
        },
        {
            codeName: "长沙黄花国际机场货场",
            codeValue: "430003"
        },
        {
            codeName: "张家界荷花国际机场",
            codeValue: "430004"
        },
        {
            codeName: "长沙霞凝港",
            codeValue: "430005"
        },
        {
            codeName: "长沙霞凝铁路",
            codeValue: "430006"
        },
        {
            codeName: "长沙金霞保税物流园区",
            codeValue: "430007"
        },
        {
            codeName: "湘潭综合保税区",
            codeValue: "430008"
        },
        {
            codeName: "长沙黄花国际机场国际快件监控中心",
            codeValue: "430009"
        },
        {
            codeName: "岳阳城陵矶水运",
            codeValue: "430101"
        },
        {
            codeName: "岳阳城陵矶综合保税区",
            codeValue: "430103"
        },
        {
            codeName: "湖南省株洲市",
            codeValue: "430200"
        },
        {
            codeName: "常德盐关水运",
            codeValue: "430201"
        },
        {
            codeName: "湖南省湘潭市",
            codeValue: "430300"
        },
        {
            codeName: "湖南省衡阳市",
            codeValue: "430400"
        },
        {
            codeName: "衡阳公路",
            codeValue: "430401"
        },
        {
            codeName: "衡阳综合保税区",
            codeValue: "430402"
        },
        {
            codeName: "湖南省邵阳市",
            codeValue: "430500"
        },
        {
            codeName: "郴州公路",
            codeValue: "430501"
        },
        {
            codeName: "郴州铁路",
            codeValue: "430502"
        },
        {
            codeName: "郴州出口加工区",
            codeValue: "430503"
        },
        {
            codeName: "湖南省岳阳市",
            codeValue: "430600"
        },
        {
            codeName: "湖南省常德市",
            codeValue: "430700"
        },
        {
            codeName: "湘潭公路",
            codeValue: "430701"
        },
        {
            codeName: "长沙黄花综合保税区",
            codeValue: "430702"
        },
        {
            codeName: "湖南省张家界市",
            codeValue: "430800"
        },
        {
            codeName: "湖南省益阳市",
            codeValue: "430900"
        },
        {
            codeName: "湖南省郴州市",
            codeValue: "431000"
        },
        {
            codeName: "湖南省永州市",
            codeValue: "431100"
        },
        {
            codeName: "湖南省怀化市",
            codeValue: "431200"
        },
        {
            codeName: "湖南省娄底市",
            codeValue: "431300"
        },
        {
            codeName: "湖南省湘西土家族苗族自治州",
            codeValue: "433100"
        },
        {
            codeName: "广州",
            codeValue: "440001"
        },
        {
            codeName: "黄埔港务码头",
            codeValue: "440002"
        },
        {
            codeName: "南沙粮食及通用码头",
            codeValue: "440003"
        },
        {
            codeName: "黄埔嘉利仓码头",
            codeValue: "440004"
        },
        {
            codeName: "佛山三水西南码头",
            codeValue: "440005"
        },
        {
            codeName: "佛山三水港码头",
            codeValue: "440006"
        },
        {
            codeName: "佛山三水车检场",
            codeValue: "440007"
        },
        {
            codeName: "东莞凤岗车检场",
            codeValue: "440008"
        },
        {
            codeName: "东莞长安车检场",
            codeValue: "440009"
        },
        {
            codeName: "广州香港马会马匹查验场",
            codeValue: "440010"
        },
        {
            codeName: "中国（广东）自由贸易试验区",
            codeValue: "440011"
        },
        {
            codeName: "广州新沙码头",
            codeValue: "440101"
        },
        {
            codeName: "广州新风码头",
            codeValue: "440102"
        },
        {
            codeName: "广州河南码头",
            codeValue: "440103"
        },
        {
            codeName: "广州石榴岗码头",
            codeValue: "440104"
        },
        {
            codeName: "广州造纸厂码头",
            codeValue: "440105"
        },
        {
            codeName: "广州石井滘心港码头",
            codeValue: "440106"
        },
        {
            codeName: "广州东朗码头",
            codeValue: "440107"
        },
        {
            codeName: "广州萝岗车检场",
            codeValue: "440108"
        },
        {
            codeName: "广东省韶关市",
            codeValue: "440200"
        },
        {
            codeName: "韶关新港码头",
            codeValue: "440201"
        },
        {
            codeName: "韶关铁路装卸点",
            codeValue: "440202"
        },
        {
            codeName: "乐昌铁路装卸点",
            codeValue: "440203"
        },
        {
            codeName: "韶关车检场",
            codeValue: "440204"
        },
        {
            codeName: "广东省深圳市",
            codeValue: "440300"
        },
        {
            codeName: "南海港客运码头",
            codeValue: "440301"
        },
        {
            codeName: "南海三山港",
            codeValue: "440302"
        },
        {
            codeName: "南海九江码头",
            codeValue: "440303"
        },
        {
            codeName: "南海北村码头",
            codeValue: "440304"
        },
        {
            codeName: "南海平洲南港码头",
            codeValue: "440305"
        },
        {
            codeName: "南海官窑车检场",
            codeValue: "440306"
        },
        {
            codeName: "南海桂江车检场",
            codeValue: "440307"
        },
        {
            codeName: "广东省珠海市",
            codeValue: "440400"
        },
        {
            codeName: "顺德港客运码头",
            codeValue: "440401"
        },
        {
            codeName: "顺德容奇货运码头",
            codeValue: "440402"
        },
        {
            codeName: "顺德食出码头",
            codeValue: "440403"
        },
        {
            codeName: "顺德北滘港货运码头",
            codeValue: "440404"
        },
        {
            codeName: "顺德勒流港货运码头",
            codeValue: "440405"
        },
        {
            codeName: "顺德陈村车检场",
            codeValue: "440406"
        },
        {
            codeName: "顺德勒流车检场",
            codeValue: "440407"
        },
        {
            codeName: "顺德容奇车检场",
            codeValue: "440408"
        },
        {
            codeName: "顺德乐从车检场",
            codeValue: "440409"
        },
        {
            codeName: "顺德北窖车检场",
            codeValue: "440410"
        },
        {
            codeName: "广东省汕头市",
            codeValue: "440500"
        },
        {
            codeName: "汕头广澳港港务公司码头",
            codeValue: "440501"
        },
        {
            codeName: "汕头暹罗石油气码头",
            codeValue: "440502"
        },
        {
            codeName: "汕头海门电厂码头",
            codeValue: "440503"
        },
        {
            codeName: "汕头西堤码头",
            codeValue: "440504"
        },
        {
            codeName: "汕头永泰码头",
            codeValue: "440505"
        },
        {
            codeName: "汕头大明石油气码头",
            codeValue: "440506"
        },
        {
            codeName: "汕头华润水泥码头",
            codeValue: "440507"
        },
        {
            codeName: "汕头港务四公司煤码头",
            codeValue: "440508"
        },
        {
            codeName: "汕头港务三公司煤码头",
            codeValue: "440509"
        },
        {
            codeName: "汕头国集码头",
            codeValue: "440510"
        },
        {
            codeName: "汕头海通码头",
            codeValue: "440511"
        },
        {
            codeName: "汕头莱芜码头",
            codeValue: "440512"
        },
        {
            codeName: "汕头前江码头",
            codeValue: "440513"
        },
        {
            codeName: "汕头铁路装卸点",
            codeValue: "440514"
        },
        {
            codeName: "汕头联成车检场",
            codeValue: "440515"
        },
        {
            codeName: "汕头濠江车检场",
            codeValue: "440516"
        },
        {
            codeName: "汕头澄海车检场",
            codeValue: "440517"
        },
        {
            codeName: "汕头潮阳车检场",
            codeValue: "440518"
        },
        {
            codeName: "揭阳潮汕机场",
            codeValue: "440519"
        },
        {
            codeName: "汕头保税区",
            codeValue: "440520"
        },
        {
            codeName: "汕头海门中转基地码头",
            codeValue: "440521"
        },
        {
            codeName: "广东省佛山市",
            codeValue: "440600"
        },
        {
            codeName: "佛山铁路客运站",
            codeValue: "440601"
        },
        {
            codeName: "佛山澜石码头",
            codeValue: "440602"
        },
        {
            codeName: "佛山滘口码头",
            codeValue: "440603"
        },
        {
            codeName: "佛山新港码头",
            codeValue: "440604"
        },
        {
            codeName: "佛山车检场",
            codeValue: "440605"
        },
        {
            codeName: "广东省江门市",
            codeValue: "440700"
        },
        {
            codeName: "江门港客运码头",
            codeValue: "440701"
        },
        {
            codeName: "江门鹤山港客运码头",
            codeValue: "440702"
        },
        {
            codeName: "江门台山核电重件码头",
            codeValue: "440703"
        },
        {
            codeName: "江门台山国华粤电煤码头",
            codeValue: "440704"
        },
        {
            codeName: "江门台山公益港客运码头",
            codeValue: "440705"
        },
        {
            codeName: "江门中外运外海货柜码头",
            codeValue: "440706"
        },
        {
            codeName: "江门国际货柜码头",
            codeValue: "440707"
        },
        {
            codeName: "江门荷塘码头",
            codeValue: "440708"
        },
        {
            codeName: "江门台山公益码头",
            codeValue: "440709"
        },
        {
            codeName: "江门恩平横板码头",
            codeValue: "440710"
        },
        {
            codeName: "江门鹤山港货运码头",
            codeValue: "440711"
        },
        {
            codeName: "江门车检场",
            codeValue: "440712"
        },
        {
            codeName: "江门台山车检场",
            codeValue: "440713"
        },
        {
            codeName: "江门鹤山车检场",
            codeValue: "440714"
        },
        {
            codeName: "江门恩平车检场",
            codeValue: "440715"
        },
        {
            codeName: "广东省湛江市",
            codeValue: "440800"
        },
        {
            codeName: "湛江机场",
            codeValue: "440801"
        },
        {
            codeName: "湛江港集团公司霞山港区码头",
            codeValue: "440802"
        },
        {
            codeName: "湛江南油码头",
            codeValue: "440803"
        },
        {
            codeName: "湛江港集团公司调顺港区码头",
            codeValue: "440804"
        },
        {
            codeName: "湛江调顺岛电力公司码头",
            codeValue: "440805"
        },
        {
            codeName: "湛江霞海港码头",
            codeValue: "440806"
        },
        {
            codeName: "湛江霞海中外运码头",
            codeValue: "440807"
        },
        {
            codeName: "湛江霞山长桥码头",
            codeValue: "440808"
        },
        {
            codeName: "湛江徐闻海安港码头",
            codeValue: "440809"
        },
        {
            codeName: "湛江廉江营仔港码头",
            codeValue: "440810"
        },
        {
            codeName: "湛江遂溪北潭港码头",
            codeValue: "440811"
        },
        {
            codeName: "湛江雷州流沙港码头",
            codeValue: "440812"
        },
        {
            codeName: "湛江霞海港车检场",
            codeValue: "440813"
        },
        {
            codeName: "湛江宝满港集装箱码头",
            codeValue: "440814"
        },
        {
            codeName: "湛江霞山散货码头",
            codeValue: "440815"
        },
        {
            codeName: "湛江东海岛宝钢基地码头",
            codeValue: "440816"
        },
        {
            codeName: "湛江东海岛宝钢成品码头",
            codeValue: "440817"
        },
        {
            codeName: "湛江吴川车检场",
            codeValue: "440818"
        },
        {
            codeName: "湛江龙腾码头",
            codeValue: "440819"
        },
        {
            codeName: "湛江遂溪车检场",
            codeValue: "440820"
        },
        {
            codeName: "广东省茂名市",
            codeValue: "440900"
        },
        {
            codeName: "茂名水东港港口公司双泊位码头",
            codeValue: "440901"
        },
        {
            codeName: "茂名水东港石化公司码头",
            codeValue: "440902"
        },
        {
            codeName: "茂名水东港30万吨级单点",
            codeValue: "440903"
        },
        {
            codeName: "茂名水东港天源化工码头",
            codeValue: "440904"
        },
        {
            codeName: "茂名水东港港口公司公用码头",
            codeValue: "440905"
        },
        {
            codeName: "茂名水东港隆港石油码头",
            codeValue: "440906"
        },
        {
            codeName: "茂名水东港长晟综合码头",
            codeValue: "440907"
        },
        {
            codeName: "茂名水东港天源煤炭码头",
            codeValue: "440908"
        },
        {
            codeName: "茂名博贺港码头",
            codeValue: "440909"
        },
        {
            codeName: "潮州车检场",
            codeValue: "441001"
        },
        {
            codeName: "潮州三百门港务码头",
            codeValue: "441101"
        },
        {
            codeName: "潮州三百门华丰油气码头",
            codeValue: "441102"
        },
        {
            codeName: "潮州三百门恒业码头",
            codeValue: "441103"
        },
        {
            codeName: "潮州金狮湾华丰油气码头",
            codeValue: "441104"
        },
        {
            codeName: "潮州金狮湾大唐电厂煤码头",
            codeValue: "441105"
        },
        {
            codeName: "潮州金狮湾亚太一期码头",
            codeValue: "441106"
        },
        {
            codeName: "饶平车检场",
            codeValue: "441107"
        },
        {
            codeName: "广东省肇庆市",
            codeValue: "441200"
        },
        {
            codeName: "肇庆铁路客运站",
            codeValue: "441201"
        },
        {
            codeName: "肇庆港客运码头",
            codeValue: "441202"
        },
        {
            codeName: "肇庆三榕港码头",
            codeValue: "441203"
        },
        {
            codeName: "肇庆新港码头",
            codeValue: "441204"
        },
        {
            codeName: "肇庆高要港码头",
            codeValue: "441205"
        },
        {
            codeName: "肇庆德庆康州码头",
            codeValue: "441206"
        },
        {
            codeName: "肇庆四会港码头",
            codeValue: "441207"
        },
        {
            codeName: "肇庆大旺车检场",
            codeValue: "441208"
        },
        {
            codeName: "广东省惠州市",
            codeValue: "441300"
        },
        {
            codeName: "惠州大澳塘码头",
            codeValue: "441301"
        },
        {
            codeName: "惠州平海电厂煤码头",
            codeValue: "441302"
        },
        {
            codeName: "惠州碧甲码头",
            codeValue: "441303"
        },
        {
            codeName: "惠州博罗宏兴码头",
            codeValue: "441304"
        },
        {
            codeName: "惠州石湾集装箱码头",
            codeValue: "441305"
        },
        {
            codeName: "惠州车检场",
            codeValue: "441306"
        },
        {
            codeName: "惠州淡水车检场",
            codeValue: "441307"
        },
        {
            codeName: "惠州惠东车检场",
            codeValue: "441308"
        },
        {
            codeName: "惠州红海车检场",
            codeValue: "441309"
        },
        {
            codeName: "惠州园洲车检场",
            codeValue: "441310"
        },
        {
            codeName: "惠州中海油基地码头",
            codeValue: "441311"
        },
        {
            codeName: "广东省梅州市",
            codeValue: "441400"
        },
        {
            codeName: "梅州机场",
            codeValue: "441401"
        },
        {
            codeName: "梅州车检场",
            codeValue: "441402"
        },
        {
            codeName: "广东省汕尾市",
            codeValue: "441500"
        },
        {
            codeName: "汕尾港务码头",
            codeValue: "441501"
        },
        {
            codeName: "汕尾电厂码头",
            codeValue: "441502"
        },
        {
            codeName: "汕尾万聪码头",
            codeValue: "441503"
        },
        {
            codeName: "汕尾乌坎码头",
            codeValue: "441504"
        },
        {
            codeName: "汕尾海丰车检场",
            codeValue: "441505"
        },
        {
            codeName: "汕尾陆丰车检场",
            codeValue: "441506"
        },
        {
            codeName: "汕尾车检场",
            codeValue: "441507"
        },
        {
            codeName: "汕尾华润海丰电厂码头",
            codeValue: "441508"
        },
        {
            codeName: "广东省河源市",
            codeValue: "441600"
        },
        {
            codeName: "河源车检场",
            codeValue: "441601"
        },
        {
            codeName: "广东省阳江市",
            codeValue: "441700"
        },
        {
            codeName: "阳江港务公司码头",
            codeValue: "441701"
        },
        {
            codeName: "阳江良港码头",
            codeValue: "441702"
        },
        {
            codeName: "阳江保丰码头",
            codeValue: "441703"
        },
        {
            codeName: "阳江闸坡码头",
            codeValue: "441704"
        },
        {
            codeName: "阳江东平码头",
            codeValue: "441705"
        },
        {
            codeName: "阳江溪头港码头",
            codeValue: "441706"
        },
        {
            codeName: "阳江车检场",
            codeValue: "441707"
        },
        {
            codeName: "华夏阳西电厂码头",
            codeValue: "441708"
        },
        {
            codeName: "广东省清远市",
            codeValue: "441800"
        },
        {
            codeName: "清远新港码头",
            codeValue: "441801"
        },
        {
            codeName: "清远英德码头",
            codeValue: "441802"
        },
        {
            codeName: "清远铁路装卸点",
            codeValue: "441803"
        },
        {
            codeName: "清远车检场",
            codeValue: "441804"
        },
        {
            codeName: "广东省东莞市",
            codeValue: "441900"
        },
        {
            codeName: "东莞铁路客运站",
            codeValue: "441901"
        },
        {
            codeName: "东莞虎门港客运码头",
            codeValue: "441902"
        },
        {
            codeName: "东莞海腾码头",
            codeValue: "441903"
        },
        {
            codeName: "东莞华润水泥码头",
            codeValue: "441904"
        },
        {
            codeName: "东莞金明石化码头",
            codeValue: "441905"
        },
        {
            codeName: "东莞国际货柜码头",
            codeValue: "441906"
        },
        {
            codeName: "东莞飞虎石化码头",
            codeValue: "441907"
        },
        {
            codeName: "东莞荣轩货柜码头",
            codeValue: "441908"
        },
        {
            codeName: "东莞同舟石化码头",
            codeValue: "441909"
        },
        {
            codeName: "东莞三江石化码头",
            codeValue: "441910"
        },
        {
            codeName: "东莞虎门港5、6号泊位",
            codeValue: "441911"
        },
        {
            codeName: "东莞九丰石化码头",
            codeValue: "441912"
        },
        {
            codeName: "东莞东洲油气化工码头",
            codeValue: "441913"
        },
        {
            codeName: "东莞虎门港7、8号泊位",
            codeValue: "441914"
        },
        {
            codeName: "东莞中海油立沙码头",
            codeValue: "441915"
        },
        {
            codeName: "东莞南粤码头",
            codeValue: "441916"
        },
        {
            codeName: "东莞东江口码头",
            codeValue: "441917"
        },
        {
            codeName: "东莞海昌煤码头",
            codeValue: "441918"
        },
        {
            codeName: "东莞深赤湾散杂货码头",
            codeValue: "441919"
        },
        {
            codeName: "东莞宏业货柜码头",
            codeValue: "441920"
        },
        {
            codeName: "东莞沙角A电厂煤码头",
            codeValue: "441921"
        },
        {
            codeName: "东莞沙角B电厂煤码头",
            codeValue: "441922"
        },
        {
            codeName: "东莞沙角C电厂煤码头",
            codeValue: "441923"
        },
        {
            codeName: "东莞龙通码头",
            codeValue: "441924"
        },
        {
            codeName: "东莞基业码头",
            codeValue: "441925"
        },
        {
            codeName: "东莞中外运石龙码头",
            codeValue: "441926"
        },
        {
            codeName: "东莞马士基码头",
            codeValue: "441927"
        },
        {
            codeName: "东莞永安码头",
            codeValue: "441928"
        },
        {
            codeName: "东莞联通码头",
            codeValue: "441929"
        },
        {
            codeName: "常平铁路装卸点",
            codeValue: "441930"
        },
        {
            codeName: "东莞虎门车检场",
            codeValue: "441931"
        },
        {
            codeName: "东莞寮步车检场",
            codeValue: "441932"
        },
        {
            codeName: "东莞立沙岛阳鸿石化码头",
            codeValue: "441933"
        },
        {
            codeName: "东莞立沙岛鸿源油品码头",
            codeValue: "441934"
        },
        {
            codeName: "东莞石龙铁路物流中心",
            codeValue: "441935"
        },
        {
            codeName: "东莞联兴化工码头",
            codeValue: "441936"
        },
        {
            codeName: "广东省中山市",
            codeValue: "442000"
        },
        {
            codeName: "中山港货运码头",
            codeValue: "442001"
        },
        {
            codeName: "中山港客运码头",
            codeValue: "442002"
        },
        {
            codeName: "中山港外贸码头",
            codeValue: "442003"
        },
        {
            codeName: "中山石岐纸厂码头",
            codeValue: "442004"
        },
        {
            codeName: "中山水出码头",
            codeValue: "442005"
        },
        {
            codeName: "中山小榄码头",
            codeValue: "442006"
        },
        {
            codeName: "中山神湾码头",
            codeValue: "442007"
        },
        {
            codeName: "中山小榄车检场",
            codeValue: "442008"
        },
        {
            codeName: "中山保税物流中心车检场",
            codeValue: "442009"
        },
        {
            codeName: "中山神湾游艇码头",
            codeValue: "442010"
        },
        {
            codeName: "中山黄圃多用途码头",
            codeValue: "442011"
        },
        {
            codeName: "黄埔石化码头",
            codeValue: "442101"
        },
        {
            codeName: "黄埔新港码头",
            codeValue: "442102"
        },
        {
            codeName: "黄埔集装箱码头",
            codeValue: "442103"
        },
        {
            codeName: "黄埔墩头西基码头",
            codeValue: "442104"
        },
        {
            codeName: "黄埔东江口码头",
            codeValue: "442105"
        },
        {
            codeName: "黄埔省物资码头",
            codeValue: "442106"
        },
        {
            codeName: "黄埔广保通码头",
            codeValue: "442107"
        },
        {
            codeName: "广州开发区东江仓码头",
            codeValue: "442108"
        },
        {
            codeName: "黄埔中外运东江仓码头",
            codeValue: "442109"
        },
        {
            codeName: "中外运黄埔仓码头",
            codeValue: "442110"
        },
        {
            codeName: "黄埔庙沙围码头",
            codeValue: "442111"
        },
        {
            codeName: "黄埔庙头建翔码头",
            codeValue: "442112"
        },
        {
            codeName: "黄埔集通码头",
            codeValue: "442113"
        },
        {
            codeName: "广州开发区车检场",
            codeValue: "442114"
        },
        {
            codeName: "广州保税物流园区",
            codeValue: "442115"
        },
        {
            codeName: "广州保税区",
            codeValue: "442116"
        },
        {
            codeName: "广州出口加工区",
            codeValue: "442117"
        },
        {
            codeName: "广州铁路客运站",
            codeValue: "442201"
        },
        {
            codeName: "广州东圃永业码头",
            codeValue: "442202"
        },
        {
            codeName: "广州白云国际机场",
            codeValue: "442301"
        },
        {
            codeName: "广州白云机场综合保税区",
            codeValue: "442302"
        },
        {
            codeName: "番禺莲花山客运港",
            codeValue: "442401"
        },
        {
            codeName: "番禺莲花山货运港",
            codeValue: "442402"
        },
        {
            codeName: "番禺沙湾车检场",
            codeValue: "442403"
        },
        {
            codeName: "花都港码头",
            codeValue: "442501"
        },
        {
            codeName: "花都车检场",
            codeValue: "442502"
        },
        {
            codeName: "增城新塘港客运码头",
            codeValue: "442601"
        },
        {
            codeName: "增城新塘东洲湾码头",
            codeValue: "442602"
        },
        {
            codeName: "增城新塘口岸码头",
            codeValue: "442603"
        },
        {
            codeName: "增城新塘食出码头",
            codeValue: "442604"
        },
        {
            codeName: "增城新塘车检场",
            codeValue: "442605"
        },
        {
            codeName: "从化车检场",
            codeValue: "442701"
        },
        {
            codeName: "江门天马码头",
            codeValue: "442801"
        },
        {
            codeName: "江门新会电厂码头",
            codeValue: "442802"
        },
        {
            codeName: "江门银湖修船码头",
            codeValue: "442803"
        },
        {
            codeName: "江门宜大化工码头",
            codeValue: "442804"
        },
        {
            codeName: "新会港客运码头",
            codeValue: "442805"
        },
        {
            codeName: "新会西河口码头",
            codeValue: "442806"
        },
        {
            codeName: "新会今古洲码头",
            codeValue: "442807"
        },
        {
            codeName: "新会睦洲糖纸厂码头",
            codeValue: "442808"
        },
        {
            codeName: "新会大敖集装箱厂码头",
            codeValue: "442809"
        },
        {
            codeName: "新会崖门沙石泥码头",
            codeValue: "442810"
        },
        {
            codeName: "新会崖西沙石泥码头",
            codeValue: "442811"
        },
        {
            codeName: "新会牛牯岭易燃品码头",
            codeValue: "442812"
        },
        {
            codeName: "新会车检场",
            codeValue: "442813"
        },
        {
            codeName: "新会航建码头",
            codeValue: "442814"
        },
        {
            codeName: "江门三埠港客运码头",
            codeValue: "442901"
        },
        {
            codeName: "江门三埠港货运码头",
            codeValue: "442902"
        },
        {
            codeName: "江门水口码头",
            codeValue: "442903"
        },
        {
            codeName: "开平车检场",
            codeValue: "442904"
        },
        {
            codeName: "高明港客运码头",
            codeValue: "443001"
        },
        {
            codeName: "高明食出码头",
            codeValue: "443002"
        },
        {
            codeName: "高明珠江码头",
            codeValue: "443003"
        },
        {
            codeName: "高明车检场",
            codeValue: "443004"
        },
        {
            codeName: "惠州港通用码头",
            codeValue: "443101"
        },
        {
            codeName: "惠州港油气码头",
            codeValue: "443102"
        },
        {
            codeName: "惠州大港石化码头",
            codeValue: "443103"
        },
        {
            codeName: "惠州泽华石化码头",
            codeValue: "443104"
        },
        {
            codeName: "惠州国际集装箱码头",
            codeValue: "443105"
        },
        {
            codeName: "惠州马鞭洲石化码头",
            codeValue: "443106"
        },
        {
            codeName: "惠州中海壳牌马鞭洲码头",
            codeValue: "443107"
        },
        {
            codeName: "惠州中海壳牌东联码头",
            codeValue: "443108"
        },
        {
            codeName: "惠州中海炼油马鞭洲码头",
            codeValue: "443109"
        },
        {
            codeName: "惠州中海炼油东联码头",
            codeValue: "443110"
        },
        {
            codeName: "大亚湾石化区公用石化码头",
            codeValue: "443111"
        },
        {
            codeName: "揭阳榕江泰丰码头",
            codeValue: "443201"
        },
        {
            codeName: "揭阳靖海惠来电厂码头",
            codeValue: "443202"
        },
        {
            codeName: "揭阳曲溪码头",
            codeValue: "443203"
        },
        {
            codeName: "揭阳车检场",
            codeValue: "443204"
        },
        {
            codeName: "揭阳惠来车检场",
            codeValue: "443205"
        },
        {
            codeName: "揭阳普宁车检场",
            codeValue: "443206"
        },
        {
            codeName: "揭阳神泉中海油码头",
            codeValue: "443207"
        },
        {
            codeName: "云浮新港",
            codeValue: "443301"
        },
        {
            codeName: "云浮罗定车检场",
            codeValue: "443302"
        },
        {
            codeName: "云浮车检场",
            codeValue: "443303"
        },
        {
            codeName: "南沙港客运码头",
            codeValue: "443401"
        },
        {
            codeName: "南沙南伟码头",
            codeValue: "443402"
        },
        {
            codeName: "南沙东发码头",
            codeValue: "443403"
        },
        {
            codeName: "南沙港一期码头",
            codeValue: "443404"
        },
        {
            codeName: "南沙港二期码头",
            codeValue: "443405"
        },
        {
            codeName: "南沙汽车码头",
            codeValue: "443406"
        },
        {
            codeName: "南沙港发石化码头",
            codeValue: "443407"
        },
        {
            codeName: "南沙小虎石化码头",
            codeValue: "443408"
        },
        {
            codeName: "南沙华润热电煤码头",
            codeValue: "443409"
        },
        {
            codeName: "南沙粤海石化码头",
            codeValue: "443410"
        },
        {
            codeName: "南沙珠江电厂码头",
            codeValue: "443411"
        },
        {
            codeName: "南沙中石油码头",
            codeValue: "443412"
        },
        {
            codeName: "南沙中船龙穴船舶维修码头",
            codeValue: "443413"
        },
        {
            codeName: "南沙港建液化气码头",
            codeValue: "443414"
        },
        {
            codeName: "南沙车检场",
            codeValue: "443415"
        },
        {
            codeName: "广州南沙保税港区",
            codeValue: "443416"
        },
        {
            codeName: "南沙港三期码头",
            codeValue: "443417"
        },
        {
            codeName: "广东南沙港口岸南沙国际邮轮母港码头",
            codeValue: "443418"
        },
        {
            codeName: "广东省潮州市",
            codeValue: "445100"
        },
        {
            codeName: "广东省揭阳市",
            codeValue: "445200"
        },
        {
            codeName: "广东省云浮市",
            codeValue: "445300"
        },
        {
            codeName: "南宁",
            codeValue: "450001"
        },
        {
            codeName: "南宁吴圩机场",
            codeValue: "450002"
        },
        {
            codeName: "梧州",
            codeValue: "450101"
        },
        {
            codeName: "广西壮族自治区柳州市",
            codeValue: "450200"
        },
        {
            codeName: "北海福成机场",
            codeValue: "450201"
        },
        {
            codeName: "北海",
            codeValue: "450202"
        },
        {
            codeName: "石头埠",
            codeValue: "450203"
        },
        {
            codeName: "北海出口加工区",
            codeValue: "450204"
        },
        {
            codeName: "广西壮族自治区桂林市",
            codeValue: "450300"
        },
        {
            codeName: "防城",
            codeValue: "450301"
        },
        {
            codeName: "茅岭",
            codeValue: "450302"
        },
        {
            codeName: "企沙",
            codeValue: "450303"
        },
        {
            codeName: "广西壮族自治区梧州市",
            codeValue: "450400"
        },
        {
            codeName: "凭祥友谊关公路",
            codeValue: "450401"
        },
        {
            codeName: "凭祥友谊关通道",
            codeValue: "450402"
        },
        {
            codeName: "凭祥浦寨通道",
            codeValue: "450403"
        },
        {
            codeName: "凭祥弄尧通道",
            codeValue: "450404"
        },
        {
            codeName: "凭祥站",
            codeValue: "450405"
        },
        {
            codeName: "爱店",
            codeValue: "450406"
        },
        {
            codeName: "凭祥综合保税区",
            codeValue: "450407"
        },
        {
            codeName: "广西壮族自治区北海市",
            codeValue: "450500"
        },
        {
            codeName: "水口",
            codeValue: "450501"
        },
        {
            codeName: "硕龙",
            codeValue: "450502"
        },
        {
            codeName: "广西壮族自治区防城港市",
            codeValue: "450600"
        },
        {
            codeName: "东兴",
            codeValue: "450601"
        },
        {
            codeName: "江平",
            codeValue: "450602"
        },
        {
            codeName: "江山",
            codeValue: "450603"
        },
        {
            codeName: "峒中",
            codeValue: "450604"
        },
        {
            codeName: "广西壮族自治区钦州市",
            codeValue: "450700"
        },
        {
            codeName: "果子山",
            codeValue: "450701"
        },
        {
            codeName: "钦州",
            codeValue: "450702"
        },
        {
            codeName: "广西壮族自治区贵港市",
            codeValue: "450800"
        },
        {
            codeName: "桂林两江国际机场",
            codeValue: "450801"
        },
        {
            codeName: "广西壮族自治区玉林市",
            codeValue: "450900"
        },
        {
            codeName: "柳州",
            codeValue: "450901"
        },
        {
            codeName: "广西壮族自治区百色市",
            codeValue: "451000"
        },
        {
            codeName: "广西壮族自治区贺州市",
            codeValue: "451100"
        },
        {
            codeName: "贵港",
            codeValue: "451101"
        },
        {
            codeName: "广西壮族自治区河池市",
            codeValue: "451200"
        },
        {
            codeName: "岳圩",
            codeValue: "451201"
        },
        {
            codeName: "龙邦",
            codeValue: "451202"
        },
        {
            codeName: "平孟",
            codeValue: "451203"
        },
        {
            codeName: "广西壮族自治区来宾市",
            codeValue: "451300"
        },
        {
            codeName: "钦州保税港区",
            codeValue: "451301"
        },
        {
            codeName: "广西壮族自治区崇左市",
            codeValue: "451400"
        },
        {
            codeName: "南宁港",
            codeValue: "451501"
        },
        {
            codeName: "海口",
            codeValue: "460001"
        },
        {
            codeName: "海口港",
            codeValue: "460002"
        },
        {
            codeName: "马村港",
            codeValue: "460003"
        },
        {
            codeName: "海口综合保税区",
            codeValue: "460004"
        },
        {
            codeName: "洋浦保税港区",
            codeValue: "460005"
        },
        {
            codeName: "海口新海港",
            codeValue: "460006"
        },
        {
            codeName: "海口南港",
            codeValue: "460007"
        },
        {
            codeName: "三亚凤凰国际机场",
            codeValue: "460101"
        },
        {
            codeName: "三亚港",
            codeValue: "460102"
        },
        {
            codeName: "海南省三亚市",
            codeValue: "460200"
        },
        {
            codeName: "八所港",
            codeValue: "460201"
        },
        {
            codeName: "海南省三沙市",
            codeValue: "460300"
        },
        {
            codeName: "洋浦港",
            codeValue: "460301"
        },
        {
            codeName: "洋浦神头港",
            codeValue: "460302"
        },
        {
            codeName: "海南省儋州市",
            codeValue: "460400"
        },
        {
            codeName: "清澜港",
            codeValue: "460401"
        },
        {
            codeName: "铺前",
            codeValue: "460402"
        },
        {
            codeName: "琼海潭门",
            codeValue: "460403"
        },
        {
            codeName: "博鳌机场",
            codeValue: "460404"
        },
        {
            codeName: "海口美兰机场",
            codeValue: "460501"
        },
        {
            codeName: "海口空港综合保税区",
            codeValue: "465501"
        },
        {
            codeName: "海南省省直辖县级行政区划",
            codeValue: "469000"
        },
        {
            codeName: "海南自贸港内",
            codeValue: "469999"
        },
        {
            codeName: "深圳",
            codeValue: "470001"
        },
        {
            codeName: "蛇口",
            codeValue: "470101"
        },
        {
            codeName: "赤湾",
            codeValue: "470102"
        },
        {
            codeName: "东角头",
            codeValue: "470103"
        },
        {
            codeName: "妈湾1号泊位",
            codeValue: "470104"
        },
        {
            codeName: "妈湾2号泊位",
            codeValue: "470105"
        },
        {
            codeName: "妈湾3号泊位",
            codeValue: "470106"
        },
        {
            codeName: "妈湾4号泊位",
            codeValue: "470107"
        },
        {
            codeName: "皇岗",
            codeValue: "470201"
        },
        {
            codeName: "福田",
            codeValue: "470202"
        },
        {
            codeName: "罗湖",
            codeValue: "470301"
        },
        {
            codeName: "文锦渡",
            codeValue: "470401"
        },
        {
            codeName: "沙头角",
            codeValue: "470501"
        },
        {
            codeName: "中英街桥头",
            codeValue: "470502"
        },
        {
            codeName: "盐田",
            codeValue: "470601"
        },
        {
            codeName: "下洞码头",
            codeValue: "470602"
        },
        {
            codeName: "LNG码头",
            codeValue: "470603"
        },
        {
            codeName: "沙鱼冲",
            codeValue: "470604"
        },
        {
            codeName: "深圳盐田综合保税区",
            codeValue: "470606"
        },
        {
            codeName: "大亚湾",
            codeValue: "470701"
        },
        {
            codeName: "深圳宝安国际机场",
            codeValue: "471001"
        },
        {
            codeName: "福永码头",
            codeValue: "471002"
        },
        {
            codeName: "机场油轮码头",
            codeValue: "471003"
        },
        {
            codeName: "深圳福田保税区",
            codeValue: "471101"
        },
        {
            codeName: "深圳坪山综合保税区",
            codeValue: "471301"
        },
        {
            codeName: "深圳湾",
            codeValue: "471401"
        },
        {
            codeName: "大铲湾",
            codeValue: "471601"
        },
        {
            codeName: "妈湾5号泊位",
            codeValue: "471801"
        },
        {
            codeName: "妈湾6号泊位",
            codeValue: "471802"
        },
        {
            codeName: "妈湾7号泊位",
            codeValue: "471803"
        },
        {
            codeName: "深圳前海综合保税区",
            codeValue: "471804"
        },
        {
            codeName: "莲塘",
            codeValue: "477101"
        },
        {
            codeName: "珠海",
            codeValue: "480001"
        },
        {
            codeName: "拱北货场",
            codeValue: "480002"
        },
        {
            codeName: "拱北旅检通道",
            codeValue: "480003"
        },
        {
            codeName: "香洲",
            codeValue: "480004"
        },
        {
            codeName: "九洲货运码头",
            codeValue: "480005"
        },
        {
            codeName: "九洲客运码头",
            codeValue: "480006"
        },
        {
            codeName: "九洲白石货场",
            codeValue: "480007"
        },
        {
            codeName: "湾仔豪通码头",
            codeValue: "480008"
        },
        {
            codeName: "湾仔客运码头",
            codeValue: "480009"
        },
        {
            codeName: "湾仔西域码头",
            codeValue: "480010"
        },
        {
            codeName: "珠海保税区加华码头",
            codeValue: "480011"
        },
        {
            codeName: "珠海保税区货场",
            codeValue: "480012"
        },
        {
            codeName: "珠澳跨境工业区（珠海园区）货场",
            codeValue: "480013"
        },
        {
            codeName: "珠澳跨境工业区（珠海园区）旅检通道",
            codeValue: "480014"
        },
        {
            codeName: "湾仔洪湾码头",
            codeValue: "480015"
        },
        {
            codeName: "港珠澳大桥货车查验场",
            codeValue: "480016"
        },
        {
            codeName: "港珠澳大桥客车查验场",
            codeValue: "480017"
        },
        {
            codeName: "港珠澳大桥随车验放厅",
            codeValue: "480018"
        },
        {
            codeName: "港珠澳大桥珠澳旅检",
            codeValue: "480019"
        },
        {
            codeName: "港珠澳大桥珠港旅检",
            codeValue: "480020"
        },
        {
            codeName: "斗门客运码头",
            codeValue: "480101"
        },
        {
            codeName: "斗门新环码头",
            codeValue: "480102"
        },
        {
            codeName: "高栏",
            codeValue: "480201"
        },
        {
            codeName: "平沙新码头",
            codeValue: "480202"
        },
        {
            codeName: "万山",
            codeValue: "480301"
        },
        {
            codeName: "横琴",
            codeValue: "480401"
        },
        {
            codeName: "重庆",
            codeValue: "500001"
        },
        {
            codeName: "重庆港",
            codeValue: "500002"
        },
        {
            codeName: "万州",
            codeValue: "500101"
        },
        {
            codeName: "九龙坡港",
            codeValue: "500201"
        },
        {
            codeName: "重庆两路寸滩保税港区水港",
            codeValue: "500401"
        },
        {
            codeName: "重庆两路寸滩保税港区空港",
            codeValue: "500402"
        },
        {
            codeName: "重庆西永综合保税区",
            codeValue: "500501"
        },
        {
            codeName: "重庆江北国际机场",
            codeValue: "500601"
        },
        {
            codeName: "成都",
            codeValue: "510001"
        },
        {
            codeName: "成都国际邮件互换局",
            codeValue: "510002"
        },
        {
            codeName: "成都双流国际机场T1航站楼",
            codeValue: "510003"
        },
        {
            codeName: "成都双流国际机场货场",
            codeValue: "510004"
        },
        {
            codeName: "成都双流国际机场国际快件",
            codeValue: "510005"
        },
        {
            codeName: "宜宾港",
            codeValue: "510006"
        },
        {
            codeName: "成都龙泉驿",
            codeValue: "510007"
        },
        {
            codeName: "成都青白江",
            codeValue: "510008"
        },
        {
            codeName: "攀枝花",
            codeValue: "510101"
        },
        {
            codeName: "四川省自贡市",
            codeValue: "510300"
        },
        {
            codeName: "四川省攀枝花市",
            codeValue: "510400"
        },
        {
            codeName: "乐山",
            codeValue: "510401"
        },
        {
            codeName: "四川省泸州市",
            codeValue: "510500"
        },
        {
            codeName: "四川省德阳市",
            codeValue: "510600"
        },
        {
            codeName: "绵阳",
            codeValue: "510601"
        },
        {
            codeName: "绵阳出口加工区",
            codeValue: "510602"
        },
        {
            codeName: "四川省绵阳市",
            codeValue: "510700"
        },
        {
            codeName: "泸州港",
            codeValue: "510701"
        },
        {
            codeName: "四川省广元市",
            codeValue: "510800"
        },
        {
            codeName: "四川省遂宁市",
            codeValue: "510900"
        },
        {
            codeName: "四川省内江市",
            codeValue: "511000"
        },
        {
            codeName: "成都高新综合保税区双流园区",
            codeValue: "511001"
        },
        {
            codeName: "成都高新综合保税区A区",
            codeValue: "511002"
        },
        {
            codeName: "成都高新综合保税区B区",
            codeValue: "511003"
        },
        {
            codeName: "成都高新综合保税区C区",
            codeValue: "511004"
        },
        {
            codeName: "四川省乐山市",
            codeValue: "511100"
        },
        {
            codeName: "四川省南充市",
            codeValue: "511300"
        },
        {
            codeName: "四川省眉山市",
            codeValue: "511400"
        },
        {
            codeName: "四川省宜宾市",
            codeValue: "511500"
        },
        {
            codeName: "四川省广安市",
            codeValue: "511600"
        },
        {
            codeName: "四川省达州市",
            codeValue: "511700"
        },
        {
            codeName: "四川省雅安市",
            codeValue: "511800"
        },
        {
            codeName: "四川省巴中市",
            codeValue: "511900"
        },
        {
            codeName: "四川省资阳市",
            codeValue: "512000"
        },
        {
            codeName: "四川省阿坝藏族羌族自治州",
            codeValue: "513200"
        },
        {
            codeName: "四川省甘孜藏族自治州",
            codeValue: "513300"
        },
        {
            codeName: "四川省凉山彝族自治州",
            codeValue: "513400"
        },
        {
            codeName: "成都天府国际机场",
            codeValue: "515101"
        },
        {
            codeName: "贵阳",
            codeValue: "520001"
        },
        {
            codeName: "贵阳龙洞堡机场",
            codeValue: "520002"
        },
        {
            codeName: "贵阳综合保税区",
            codeValue: "520003"
        },
        {
            codeName: "北贵安综合保税区",
            codeValue: "520004"
        },
        {
            codeName: "贵州省六盘水市",
            codeValue: "520200"
        },
        {
            codeName: "贵州省遵义市",
            codeValue: "520300"
        },
        {
            codeName: "贵州省安顺市",
            codeValue: "520400"
        },
        {
            codeName: "贵州省毕节市",
            codeValue: "520500"
        },
        {
            codeName: "贵州省铜仁市",
            codeValue: "520600"
        },
        {
            codeName: "贵州省黔西南布依族苗族自治州",
            codeValue: "522300"
        },
        {
            codeName: "贵州省黔东南苗族侗族自治州",
            codeValue: "522600"
        },
        {
            codeName: "贵州省黔南布依族苗族自治州",
            codeValue: "522700"
        },
        {
            codeName: "昆明",
            codeValue: "530001"
        },
        {
            codeName: "昆明出口加工区",
            codeValue: "530002"
        },
        {
            codeName: "昆明综合保税区",
            codeValue: "530003"
        },
        {
            codeName: "瑞丽",
            codeValue: "530101"
        },
        {
            codeName: "姐告",
            codeValue: "530102"
        },
        {
            codeName: "弄岛",
            codeValue: "530103"
        },
        {
            codeName: "畹町",
            codeValue: "530104"
        },
        {
            codeName: "芒市",
            codeValue: "530201"
        },
        {
            codeName: "盈江",
            codeValue: "530202"
        },
        {
            codeName: "章凤",
            codeValue: "530203"
        },
        {
            codeName: "云南省曲靖市",
            codeValue: "530300"
        },
        {
            codeName: "腾冲",
            codeValue: "530301"
        },
        {
            codeName: "猴桥",
            codeValue: "530302"
        },
        {
            codeName: "滇滩",
            codeValue: "530303"
        },
        {
            codeName: "云南省玉溪市",
            codeValue: "530400"
        },
        {
            codeName: "耿马",
            codeValue: "530401"
        },
        {
            codeName: "孟定清水河",
            codeValue: "530402"
        },
        {
            codeName: "沧源",
            codeValue: "530403"
        },
        {
            codeName: "南伞",
            codeValue: "530404"
        },
        {
            codeName: "云南省保山市",
            codeValue: "530500"
        },
        {
            codeName: "河口站",
            codeValue: "530501"
        },
        {
            codeName: "河口",
            codeValue: "530502"
        },
        {
            codeName: "云南省昭通市",
            codeValue: "530600"
        },
        {
            codeName: "西双版纳",
            codeValue: "530601"
        },
        {
            codeName: "西双版纳国际机场",
            codeValue: "530602"
        },
        {
            codeName: "景洪港",
            codeValue: "530603"
        },
        {
            codeName: "打洛",
            codeValue: "530604"
        },
        {
            codeName: "大勐龙",
            codeValue: "530605"
        },
        {
            codeName: "云南省丽江市　　　　　　　",
            codeValue: "530700"
        },
        {
            codeName: "普洱",
            codeValue: "530701"
        },
        {
            codeName: "孟连",
            codeValue: "530702"
        },
        {
            codeName: "思茅港",
            codeValue: "530703"
        },
        {
            codeName: "云南省普洱市",
            codeValue: "530800"
        },
        {
            codeName: "勐腊",
            codeValue: "530801"
        },
        {
            codeName: "磨憨",
            codeValue: "530802"
        },
        {
            codeName: "关累港",
            codeValue: "530803"
        },
        {
            codeName: "云南省临沧市",
            codeValue: "530900"
        },
        {
            codeName: "金平",
            codeValue: "530901"
        },
        {
            codeName: "金水河",
            codeValue: "530902"
        },
        {
            codeName: "红河综合保税区",
            codeValue: "530903"
        },
        {
            codeName: "麻栗坡",
            codeValue: "531001"
        },
        {
            codeName: "天保",
            codeValue: "531002"
        },
        {
            codeName: "田蓬",
            codeValue: "531003"
        },
        {
            codeName: "大理",
            codeValue: "531101"
        },
        {
            codeName: "昆明长水国际机场",
            codeValue: "531201"
        },
        {
            codeName: "丽江三义机场",
            codeValue: "531301"
        },
        {
            codeName: "勐康",
            codeValue: "531401"
        },
        {
            codeName: "龙富",
            codeValue: "531402"
        },
        {
            codeName: "怒江",
            codeValue: "531501"
        },
        {
            codeName: "片马",
            codeValue: "531502"
        },
        {
            codeName: "云南省楚雄彝族自治州",
            codeValue: "532300"
        },
        {
            codeName: "云南省红河哈尼族彝族自治州",
            codeValue: "532500"
        },
        {
            codeName: "云南省文山壮族苗族自治州",
            codeValue: "532600"
        },
        {
            codeName: "云南省西双版纳傣族自治州",
            codeValue: "532800"
        },
        {
            codeName: "云南省大理白族自治州",
            codeValue: "532900"
        },
        {
            codeName: "云南省德宏傣族景颇族自治州",
            codeValue: "533100"
        },
        {
            codeName: "云南省怒江傈僳族自治州",
            codeValue: "533300"
        },
        {
            codeName: "云南省迪庆藏族自治州",
            codeValue: "533400"
        },
        {
            codeName: "都龙",
            codeValue: "537701"
        },
        {
            codeName: "拉萨",
            codeValue: "540001"
        },
        {
            codeName: "拉萨贡嘎机场",
            codeValue: "540002"
        },
        {
            codeName: "吉隆",
            codeValue: "540101"
        },
        {
            codeName: "樟木",
            codeValue: "540102"
        },
        {
            codeName: "日屋",
            codeValue: "540103"
        },
        {
            codeName: "西藏自治区日喀则市",
            codeValue: "540200"
        },
        {
            codeName: "普兰",
            codeValue: "540201"
        },
        {
            codeName: "西藏自治区昌都市",
            codeValue: "540300"
        },
        {
            codeName: "西藏自治区林芝市",
            codeValue: "540400"
        },
        {
            codeName: "西藏自治区山南市",
            codeValue: "540500"
        },
        {
            codeName: "西藏自治区那曲市",
            codeValue: "540600"
        },
        {
            codeName: "西藏自治区阿里地区",
            codeValue: "542500"
        },
        {
            codeName: "揭阳惠来原油码头",
            codeValue: "575301"
        },
        {
            codeName: "广东华电丰盛汕头电厂码头",
            codeValue: "575702"
        },
        {
            codeName: "汕尾陆丰宝丽华电厂码头",
            codeValue: "575901"
        },
        {
            codeName: "汕尾小漠国际物流港码头",
            codeValue: "575902"
        },
        {
            codeName: "揭阳港神泉港区",
            codeValue: "576101"
        },
        {
            codeName: "潮州港扩建货运码头",
            codeValue: "576201"
        },
        {
            codeName: "潮州港华瀛天然气码头",
            codeValue: "576202"
        },
        {
            codeName: "湛江东海岛中科炼化码头",
            codeValue: "585301"
        },
        {
            codeName: "湛江港大唐雷州电厂码头",
            codeValue: "585501"
        },
        {
            codeName: "茂名港吉达港区东华能源码头",
            codeValue: "585801"
        },
        {
            codeName: "江门高新港码头",
            codeValue: "595101"
        },
        {
            codeName: "江门大广海湾保税物流中心（B型）",
            codeValue: "595301"
        },
        {
            codeName: "西安",
            codeValue: "610001"
        },
        {
            codeName: "西安咸阳国际机场",
            codeValue: "610002"
        },
        {
            codeName: "宝鸡",
            codeValue: "610003"
        },
        {
            codeName: "汉中",
            codeValue: "610004"
        },
        {
            codeName: "榆林",
            codeValue: "610005"
        },
        {
            codeName: "延安",
            codeValue: "610006"
        },
        {
            codeName: "渭南",
            codeValue: "610007"
        },
        {
            codeName: "西安综合保税区",
            codeValue: "610008"
        },
        {
            codeName: "西安关中综合保税区",
            codeValue: "610009"
        },
        {
            codeName: "西安高新综合保税区",
            codeValue: "610010"
        },
        {
            codeName: "陕西西咸空港综合保税区",
            codeValue: "610011"
        },
        {
            codeName: "西安航空基地综合保税区",
            codeValue: "610012"
        },
        {
            codeName: "宝鸡综合保税区",
            codeValue: "610013"
        },
        {
            codeName: "陕西杨凌综合保税区",
            codeValue: "610014"
        },
        {
            codeName: "陕西省铜川市",
            codeValue: "610200"
        },
        {
            codeName: "陕西省宝鸡市",
            codeValue: "610300"
        },
        {
            codeName: "陕西省咸阳市",
            codeValue: "610400"
        },
        {
            codeName: "陕西省渭南市",
            codeValue: "610500"
        },
        {
            codeName: "陕西省延安市",
            codeValue: "610600"
        },
        {
            codeName: "陕西省汉中市",
            codeValue: "610700"
        },
        {
            codeName: "陕西省榆林市",
            codeValue: "610800"
        },
        {
            codeName: "陕西省安康市",
            codeValue: "610900"
        },
        {
            codeName: "陕西省商洛市",
            codeValue: "611000"
        },
        {
            codeName: "兰州",
            codeValue: "620001"
        },
        {
            codeName: "兰州中川机场",
            codeValue: "620002"
        },
        {
            codeName: "兰州新区综合保税区",
            codeValue: "620003"
        },
        {
            codeName: "酒泉",
            codeValue: "620101"
        },
        {
            codeName: "马鬃山",
            codeValue: "620102"
        },
        {
            codeName: "甘肃省嘉峪关市",
            codeValue: "620200"
        },
        {
            codeName: "甘肃省金昌市",
            codeValue: "620300"
        },
        {
            codeName: "甘肃省白银市",
            codeValue: "620400"
        },
        {
            codeName: "甘肃省天水市",
            codeValue: "620500"
        },
        {
            codeName: "甘肃省武威市",
            codeValue: "620600"
        },
        {
            codeName: "甘肃省张掖市",
            codeValue: "620700"
        },
        {
            codeName: "甘肃省平凉市",
            codeValue: "620800"
        },
        {
            codeName: "甘肃省酒泉市",
            codeValue: "620900"
        },
        {
            codeName: "甘肃省庆阳市",
            codeValue: "621000"
        },
        {
            codeName: "甘肃省定西市",
            codeValue: "621100"
        },
        {
            codeName: "甘肃省陇南市",
            codeValue: "621200"
        },
        {
            codeName: "甘肃省临夏回族自治州",
            codeValue: "622900"
        },
        {
            codeName: "甘肃省甘南藏族自治州",
            codeValue: "623000"
        },
        {
            codeName: "西宁",
            codeValue: "630001"
        },
        {
            codeName: "西宁曹家堡机场",
            codeValue: "630002"
        },
        {
            codeName: "青海省海东市",
            codeValue: "630200"
        },
        {
            codeName: "青海省海北藏族自治州",
            codeValue: "632200"
        },
        {
            codeName: "青海省黄南藏族自治州",
            codeValue: "632300"
        },
        {
            codeName: "青海省海南藏族自治州",
            codeValue: "632500"
        },
        {
            codeName: "青海省果洛藏族自治州",
            codeValue: "632600"
        },
        {
            codeName: "青海省玉树藏族自治州",
            codeValue: "632700"
        },
        {
            codeName: "青海省海西蒙古族藏族自治州",
            codeValue: "632800"
        },
        {
            codeName: "银川",
            codeValue: "640001"
        },
        {
            codeName: "银川河东机场",
            codeValue: "640101"
        },
        {
            codeName: "宁夏回族自治区石嘴山市",
            codeValue: "640200"
        },
        {
            codeName: "宁夏回族自治区吴忠市",
            codeValue: "640300"
        },
        {
            codeName: "宁夏回族自治区固原市",
            codeValue: "640400"
        },
        {
            codeName: "宁夏回族自治区中卫市",
            codeValue: "640500"
        },
        {
            codeName: "乌鲁木齐",
            codeValue: "650001"
        },
        {
            codeName: "乌鲁木齐地窝堡国际机场",
            codeValue: "650002"
        },
        {
            codeName: "阿勒泰",
            codeValue: "650101"
        },
        {
            codeName: "红山嘴",
            codeValue: "650102"
        },
        {
            codeName: "阿黑土别克",
            codeValue: "650103"
        },
        {
            codeName: "塔克什肯",
            codeValue: "650104"
        },
        {
            codeName: "新疆维吾尔自治区克拉玛依市",
            codeValue: "650200"
        },
        {
            codeName: "巴克图",
            codeValue: "650201"
        },
        {
            codeName: "巴克图国际汽车货运",
            codeValue: "650202"
        },
        {
            codeName: "阿拉山口公路",
            codeValue: "650301"
        },
        {
            codeName: "阿拉山口铁路",
            codeValue: "650302"
        },
        {
            codeName: "阿拉山口综合保税区",
            codeValue: "650303"
        },
        {
            codeName: "新疆维吾尔自治区吐鲁番市",
            codeValue: "650400"
        },
        {
            codeName: "伊犁",
            codeValue: "650401"
        },
        {
            codeName: "伊犁州国际汽车",
            codeValue: "650402"
        },
        {
            codeName: "木扎尔特",
            codeValue: "650403"
        },
        {
            codeName: "都拉塔",
            codeValue: "650404"
        },
        {
            codeName: "新疆维吾尔自治区哈密市",
            codeValue: "650500"
        },
        {
            codeName: "霍尔果斯",
            codeValue: "650501"
        },
        {
            codeName: "巴州",
            codeValue: "650701"
        },
        {
            codeName: "喀什",
            codeValue: "650801"
        },
        {
            codeName: "其尼瓦格国际汽车",
            codeValue: "650802"
        },
        {
            codeName: "喀什机场",
            codeValue: "650803"
        },
        {
            codeName: "红其拉甫",
            codeValue: "650804"
        },
        {
            codeName: "喀什综合保税区",
            codeValue: "650805"
        },
        {
            codeName: "伊尔克什坦",
            codeValue: "650901"
        },
        {
            codeName: "吐尔尕特",
            codeValue: "650902"
        },
        {
            codeName: "阿图什国际汽车",
            codeValue: "650903"
        },
        {
            codeName: "吉木乃",
            codeValue: "651001"
        },
        {
            codeName: "卡拉苏",
            codeValue: "651101"
        },
        {
            codeName: "奎屯",
            codeValue: "651201"
        },
        {
            codeName: "霍尔果斯国际边境合作中心(中方配套区)",
            codeValue: "651301"
        },
        {
            codeName: "老爷庙",
            codeValue: "651401"
        },
        {
            codeName: "乌拉斯台",
            codeValue: "651501"
        },
        {
            codeName: "乌鲁木齐铁路",
            codeValue: "651502"
        },
        {
            codeName: "乌鲁木齐碾子沟客运站",
            codeValue: "651503"
        },
        {
            codeName: "边疆宾馆国际汽车货运",
            codeValue: "651504"
        },
        {
            codeName: "乌鲁木齐出口加工区",
            codeValue: "651505"
        },
        {
            codeName: "新疆维吾尔自治区昌吉回族自治州",
            codeValue: "652300"
        },
        {
            codeName: "新疆维吾尔自治区博尔塔拉蒙古自治州",
            codeValue: "652700"
        },
        {
            codeName: "新疆维吾尔自治区巴音郭楞蒙古自治州",
            codeValue: "652800"
        },
        {
            codeName: "新疆维吾尔自治区阿克苏地区",
            codeValue: "652900"
        },
        {
            codeName: "新疆维吾尔自治区克孜勒苏柯尔克孜自治州",
            codeValue: "653000"
        },
        {
            codeName: "新疆维吾尔自治区喀什地区",
            codeValue: "653100"
        },
        {
            codeName: "新疆维吾尔自治区和田地区",
            codeValue: "653200"
        },
        {
            codeName: "新疆维吾尔自治区伊犁哈萨克自治州",
            codeValue: "654000"
        },
        {
            codeName: "新疆维吾尔自治区塔城地区",
            codeValue: "654200"
        },
        {
            codeName: "新疆维吾尔自治区阿勒泰地区",
            codeValue: "654300"
        },
        {
            codeName: "新疆维吾尔自治区自治区直辖县级行政单位",
            codeValue: "659000"
        },
        {
            codeName: "未列出的特殊监管区",
            codeValue: "999999"
        }
    ],
    // 海关信息
    CUS_CUSTOMS: [
        {
            codeName: "海关总署",
            codeValue: "0000"
        },
        {
            codeName: "北京关区",
            codeValue: "0100"
        },
        {
            codeName: "京机场关",
            codeValue: "0101"
        },
        {
            codeName: "京监管处",
            codeValue: "0102"
        },
        {
            codeName: "京关展览",
            codeValue: "0103"
        },
        {
            codeName: "京西城关",
            codeValue: "0104"
        },
        {
            codeName: "京会展关",
            codeValue: "0105"
        },
        {
            codeName: "大兴机场",
            codeValue: "0106"
        },
        {
            codeName: "机场库区",
            codeValue: "0107"
        },
        {
            codeName: "京综合处",
            codeValue: "0108"
        },
        {
            codeName: "机场旅检",
            codeValue: "0109"
        },
        {
            codeName: "平谷海关",
            codeValue: "0110"
        },
        {
            codeName: "京车站关",
            codeValue: "0111"
        },
        {
            codeName: "京邮局关",
            codeValue: "0112"
        },
        {
            codeName: "京中关村",
            codeValue: "0113"
        },
        {
            codeName: "海淀海关",
            codeValue: "0114"
        },
        {
            codeName: "京东城关",
            codeValue: "0115"
        },
        {
            codeName: "大兴旅检",
            codeValue: "0116"
        },
        {
            codeName: "亦庄海关",
            codeValue: "0117"
        },
        {
            codeName: "京朝阳关",
            codeValue: "0118"
        },
        {
            codeName: "通州海关",
            codeValue: "0119"
        },
        {
            codeName: "京稽查处",
            codeValue: "0121"
        },
        {
            codeName: "机场调技",
            codeValue: "0123"
        },
        {
            codeName: "北京站",
            codeValue: "0124"
        },
        {
            codeName: "西客站",
            codeValue: "0125"
        },
        {
            codeName: "丰台海关",
            codeValue: "0126"
        },
        {
            codeName: "京快件",
            codeValue: "0127"
        },
        {
            codeName: "顺义海关",
            codeValue: "0128"
        },
        {
            codeName: "天竺海关",
            codeValue: "0129"
        },
        {
            codeName: "亦庄物流",
            codeValue: "0130"
        },
        {
            codeName: "大兴综保",
            codeValue: "0131"
        },
        {
            codeName: "中关村综保",
            codeValue: "0132"
        },
        {
            codeName: "天津海关",
            codeValue: "0200"
        },
        {
            codeName: "津南开关",
            codeValue: "0201"
        },
        {
            codeName: "新港海关",
            codeValue: "0202"
        },
        {
            codeName: "塘沽海关",
            codeValue: "0203"
        },
        {
            codeName: "东港海关",
            codeValue: "0204"
        },
        {
            codeName: "津塘沽办",
            codeValue: "0205"
        },
        {
            codeName: "津邮局关",
            codeValue: "0206"
        },
        {
            codeName: "津机场办",
            codeValue: "0207"
        },
        {
            codeName: "津保空港",
            codeValue: "0208"
        },
        {
            codeName: "津蓟州关",
            codeValue: "0209"
        },
        {
            codeName: "武清海关",
            codeValue: "0210"
        },
        {
            codeName: "泰达综保",
            codeValue: "0211"
        },
        {
            codeName: "津保海港",
            codeValue: "0212"
        },
        {
            codeName: "东疆综保",
            codeValue: "0213"
        },
        {
            codeName: "津滨综保",
            codeValue: "0214"
        },
        {
            codeName: "津机快件",
            codeValue: "0215"
        },
        {
            codeName: "津开物流",
            codeValue: "0216"
        },
        {
            codeName: "津东疆关",
            codeValue: "0217"
        },
        {
            codeName: "静海海关",
            codeValue: "0218"
        },
        {
            codeName: "津北辰关",
            codeValue: "0219"
        },
        {
            codeName: "津关税处",
            codeValue: "0220"
        },
        {
            codeName: "津宁河关",
            codeValue: "0221"
        },
        {
            codeName: "津大港关",
            codeValue: "0222"
        },
        {
            codeName: "津临港关",
            codeValue: "0223"
        },
        {
            codeName: "津南疆关",
            codeValue: "0224"
        },
        {
            codeName: "津西青关",
            codeValue: "0225"
        },
        {
            codeName: "津北塘关",
            codeValue: "0226"
        },
        {
            codeName: "津河西关",
            codeValue: "0227"
        },
        {
            codeName: "津东丽关",
            codeValue: "0228"
        },
        {
            codeName: "津蓟物流",
            codeValue: "0229"
        },
        {
            codeName: "津保税关",
            codeValue: "0230"
        },
        {
            codeName: "石家庄区",
            codeValue: "0400"
        },
        {
            codeName: "鹿泉海关",
            codeValue: "0401"
        },
        {
            codeName: "秦皇岛关",
            codeValue: "0402"
        },
        {
            codeName: "唐山海关",
            codeValue: "0403"
        },
        {
            codeName: "廊坊海关",
            codeValue: "0404"
        },
        {
            codeName: "保定海关",
            codeValue: "0405"
        },
        {
            codeName: "邯郸海关",
            codeValue: "0406"
        },
        {
            codeName: "秦综保区",
            codeValue: "0407"
        },
        {
            codeName: "沧州海关",
            codeValue: "0408"
        },
        {
            codeName: "廊坊综保",
            codeValue: "0409"
        },
        {
            codeName: "石机场关",
            codeValue: "0410"
        },
        {
            codeName: "张家口关",
            codeValue: "0411"
        },
        {
            codeName: "曹妃甸关",
            codeValue: "0412"
        },
        {
            codeName: "邢台海关",
            codeValue: "0413"
        },
        {
            codeName: "曹综保区",
            codeValue: "0414"
        },
        {
            codeName: "衡水海关",
            codeValue: "0415"
        },
        {
            codeName: "石关快件",
            codeValue: "0416"
        },
        {
            codeName: "承德海关",
            codeValue: "0417"
        },
        {
            codeName: "石综保区",
            codeValue: "0418"
        },
        {
            codeName: "武安物流",
            codeValue: "0419"
        },
        {
            codeName: "京唐物流",
            codeValue: "0420"
        },
        {
            codeName: "正定海关",
            codeValue: "0421"
        },
        {
            codeName: "京唐港关",
            codeValue: "0422"
        },
        {
            codeName: "雄安海关",
            codeValue: "0423"
        },
        {
            codeName: "黄骅港关",
            codeValue: "0424"
        },
        {
            codeName: "辛集物流",
            codeValue: "0425"
        },
        {
            codeName: "北戴河关",
            codeValue: "0426"
        },
        {
            codeName: "石关邮件",
            codeValue: "0427"
        },
        {
            codeName: "雄安综保",
            codeValue: "0428"
        },
        {
            codeName: "高邑B保",
            codeValue: "0429"
        },
        {
            codeName: "太原关区",
            codeValue: "0500"
        },
        {
            codeName: "晋阳海关",
            codeValue: "0501"
        },
        {
            codeName: "并机场关",
            codeValue: "0502"
        },
        {
            codeName: "大同海关",
            codeValue: "0503"
        },
        {
            codeName: "临汾海关",
            codeValue: "0504"
        },
        {
            codeName: "方略物流",
            codeValue: "0505"
        },
        {
            codeName: "太原综保",
            codeValue: "0506"
        },
        {
            codeName: "运城海关",
            codeValue: "0507"
        },
        {
            codeName: "晋城海关",
            codeValue: "0508"
        },
        {
            codeName: "兰花物流",
            codeValue: "0509"
        },
        {
            codeName: "太原邮件",
            codeValue: "0510"
        },
        {
            codeName: "武宿海关",
            codeValue: "0511"
        },
        {
            codeName: "长治海关",
            codeValue: "0512"
        },
        {
            codeName: "阳泉海关",
            codeValue: "0513"
        },
        {
            codeName: "朔州海关",
            codeValue: "0514"
        },
        {
            codeName: "忻州海关",
            codeValue: "0515"
        },
        {
            codeName: "大同保B",
            codeValue: "0516"
        },
        {
            codeName: "满洲里关",
            codeValue: "0600"
        },
        {
            codeName: "海拉尔关",
            codeValue: "0601"
        },
        {
            codeName: "额尔古纳",
            codeValue: "0602"
        },
        {
            codeName: "满十八里",
            codeValue: "0603"
        },
        {
            codeName: "赤峰海关",
            codeValue: "0604"
        },
        {
            codeName: "通辽海关",
            codeValue: "0605"
        },
        {
            codeName: "满哈沙特",
            codeValue: "0606"
        },
        {
            codeName: "满室韦",
            codeValue: "0607"
        },
        {
            codeName: "满互贸区",
            codeValue: "0608"
        },
        {
            codeName: "满铁路",
            codeValue: "0609"
        },
        {
            codeName: "满市区",
            codeValue: "0610"
        },
        {
            codeName: "满机场",
            codeValue: "0611"
        },
        {
            codeName: "阿尔山关",
            codeValue: "0612"
        },
        {
            codeName: "赤峰物流",
            codeValue: "0613"
        },
        {
            codeName: "额布都格",
            codeValue: "0614"
        },
        {
            codeName: "满综保区",
            codeValue: "0615"
        },
        {
            codeName: "满关邮办",
            codeValue: "0616"
        },
        {
            codeName: "满综口岸",
            codeValue: "0617"
        },
        {
            codeName: "通辽 B 保",
            codeValue: "0618"
        },
        {
            codeName: "呼特关区",
            codeValue: "0700"
        },
        {
            codeName: "赛罕海关",
            codeValue: "0701"
        },
        {
            codeName: "二关铁路",
            codeValue: "0702"
        },
        {
            codeName: "包头海关",
            codeValue: "0703"
        },
        {
            codeName: "呼关邮办",
            codeValue: "0704"
        },
        {
            codeName: "二关公路",
            codeValue: "0705"
        },
        {
            codeName: "包头箱站",
            codeValue: "0706"
        },
        {
            codeName: "额济纳关",
            codeValue: "0707"
        },
        {
            codeName: "乌拉特关",
            codeValue: "0708"
        },
        {
            codeName: "满达口岸",
            codeValue: "0709"
        },
        {
            codeName: "东乌海关",
            codeValue: "0710"
        },
        {
            codeName: "机场海关",
            codeValue: "0711"
        },
        {
            codeName: "呼综保区",
            codeValue: "0712"
        },
        {
            codeName: "鄂尔多斯",
            codeValue: "0713"
        },
        {
            codeName: "集宁海关",
            codeValue: "0714"
        },
        {
            codeName: "乌海海关",
            codeValue: "0715"
        },
        {
            codeName: "鄂综保区",
            codeValue: "0716"
        },
        {
            codeName: "包头保B",
            codeValue: "0717"
        },
        {
            codeName: "巴市保B",
            codeValue: "0718"
        },
        {
            codeName: "二关公直",
            codeValue: "0719"
        },
        {
            codeName: "七苏保B",
            codeValue: "0720"
        },
        {
            codeName: "阿拉善关",
            codeValue: "0721"
        },
        {
            codeName: "赛乌素机场",
            codeValue: "0722"
        },
        {
            codeName: "沈阳关区",
            codeValue: "0800"
        },
        {
            codeName: "浑南海关",
            codeValue: "0801"
        },
        {
            codeName: "锦州海关",
            codeValue: "0802"
        },
        {
            codeName: "沈邮局关",
            codeValue: "0803"
        },
        {
            codeName: "抚顺海关",
            codeValue: "0804"
        },
        {
            codeName: "铁西海关",
            codeValue: "0805"
        },
        {
            codeName: "辽阳海关",
            codeValue: "0806"
        },
        {
            codeName: "沈机场关",
            codeValue: "0807"
        },
        {
            codeName: "辽中海关",
            codeValue: "0808"
        },
        {
            codeName: "沈快件",
            codeValue: "0809"
        },
        {
            codeName: "葫芦岛关",
            codeValue: "0810"
        },
        {
            codeName: "辽宁朝阳",
            codeValue: "0811"
        },
        {
            codeName: "沈抚新区",
            codeValue: "0812"
        },
        {
            codeName: "铁岭海关",
            codeValue: "0813"
        },
        {
            codeName: "铁保（B型）",
            codeValue: "0814"
        },
        {
            codeName: "阜新海关",
            codeValue: "0815"
        },
        {
            codeName: "锦港保B",
            codeValue: "0816"
        },
        {
            codeName: "班列沈集",
            codeValue: "0817"
        },
        {
            codeName: "大连海关",
            codeValue: "0900"
        },
        {
            codeName: "大连港湾",
            codeValue: "0901"
        },
        {
            codeName: "大连机场",
            codeValue: "0902"
        },
        {
            codeName: "连开发区",
            codeValue: "0903"
        },
        {
            codeName: "湾里综保",
            codeValue: "0904"
        },
        {
            codeName: "北良港关",
            codeValue: "0905"
        },
        {
            codeName: "连保税区",
            codeValue: "0906"
        },
        {
            codeName: "连物流园",
            codeValue: "0907"
        },
        {
            codeName: "连大窑湾",
            codeValue: "0908"
        },
        {
            codeName: "连邮局关",
            codeValue: "0909"
        },
        {
            codeName: "连窑综保",
            codeValue: "0910"
        },
        {
            codeName: "长兴岛关",
            codeValue: "0911"
        },
        {
            codeName: "大连快件",
            codeValue: "0912"
        },
        {
            codeName: "庄河海关",
            codeValue: "0915"
        },
        {
            codeName: "七贤岭关",
            codeValue: "0916"
        },
        {
            codeName: "旅顺海关",
            codeValue: "0917"
        },
        {
            codeName: "连窑物流",
            codeValue: "0918"
        },
        {
            codeName: "金石滩关",
            codeValue: "0919"
        },
        {
            codeName: "丹东海关",
            codeValue: "0930"
        },
        {
            codeName: "本溪海关",
            codeValue: "0931"
        },
        {
            codeName: "丹太平湾",
            codeValue: "0932"
        },
        {
            codeName: "营口海关",
            codeValue: "0940"
        },
        {
            codeName: "盘锦海关",
            codeValue: "0941"
        },
        {
            codeName: "盘港物流",
            codeValue: "0942"
        },
        {
            codeName: "营口综保",
            codeValue: "0943"
        },
        {
            codeName: "鲅鱼圈关",
            codeValue: "0950"
        },
        {
            codeName: "营港物流",
            codeValue: "0951"
        },
        {
            codeName: "仙人岛办",
            codeValue: "0953"
        },
        {
            codeName: "大东港关",
            codeValue: "0960"
        },
        {
            codeName: "鞍山海关",
            codeValue: "0980"
        },
        {
            codeName: "长春关区",
            codeValue: "1500"
        },
        {
            codeName: "绿园海关",
            codeValue: "1501"
        },
        {
            codeName: "兴隆海关",
            codeValue: "1502"
        },
        {
            codeName: "长白海关",
            codeValue: "1503"
        },
        {
            codeName: "临江口岸",
            codeValue: "1504"
        },
        {
            codeName: "图们海关",
            codeValue: "1505"
        },
        {
            codeName: "通化海关",
            codeValue: "1506"
        },
        {
            codeName: "珲春海关",
            codeValue: "1507"
        },
        {
            codeName: "吉林海关",
            codeValue: "1508"
        },
        {
            codeName: "延吉海关",
            codeValue: "1509"
        },
        {
            codeName: "长春综保",
            codeValue: "1510"
        },
        {
            codeName: "龙嘉机场",
            codeValue: "1511"
        },
        {
            codeName: "松原海关",
            codeValue: "1512"
        },
        {
            codeName: "白城海关",
            codeValue: "1513"
        },
        {
            codeName: "白山海关",
            codeValue: "1514"
        },
        {
            codeName: "图们车办",
            codeValue: "1515"
        },
        {
            codeName: "通海关村",
            codeValue: "1516"
        },
        {
            codeName: "珲长岭子",
            codeValue: "1517"
        },
        {
            codeName: "吉关车办",
            codeValue: "1518"
        },
        {
            codeName: "图们三合",
            codeValue: "1519"
        },
        {
            codeName: "一汽场站",
            codeValue: "1521"
        },
        {
            codeName: "长白山海关",
            codeValue: "1522"
        },
        {
            codeName: "四平海关",
            codeValue: "1523"
        },
        {
            codeName: "辽源海关",
            codeValue: "1524"
        },
        {
            codeName: "图们桥办",
            codeValue: "1525"
        },
        {
            codeName: "通集青石",
            codeValue: "1526"
        },
        {
            codeName: "珲春圈河",
            codeValue: "1527"
        },
        {
            codeName: "吉林物流",
            codeValue: "1528"
        },
        {
            codeName: "延吉南坪",
            codeValue: "1529"
        },
        {
            codeName: "兴隆铁路",
            codeValue: "1531"
        },
        {
            codeName: "通集铁路",
            codeValue: "1536"
        },
        {
            codeName: "珲沙坨子",
            codeValue: "1537"
        },
        {
            codeName: "图开山屯",
            codeValue: "1539"
        },
        {
            codeName: "通集公路",
            codeValue: "1546"
        },
        {
            codeName: "珲综保区",
            codeValue: "1547"
        },
        {
            codeName: "延古城里",
            codeValue: "1549"
        },
        {
            codeName: "珲春车办",
            codeValue: "1557"
        },
        {
            codeName: "延吉邮办",
            codeValue: "1559"
        },
        {
            codeName: "珲综口岸",
            codeValue: "1567"
        },
        {
            codeName: "延吉机办",
            codeValue: "1569"
        },
        {
            codeName: "延关快件",
            codeValue: "1579"
        },
        {
            codeName: "延吉保B",
            codeValue: "1589"
        },
        {
            codeName: "长邮海关",
            codeValue: "1591"
        },
        {
            codeName: "长白邮办",
            codeValue: "1593"
        },
        {
            codeName: "图们邮办",
            codeValue: "1595"
        },
        {
            codeName: "通集邮办",
            codeValue: "1596"
        },
        {
            codeName: "哈尔滨区",
            codeValue: "1900"
        },
        {
            codeName: "哈尔滨关",
            codeValue: "1901"
        },
        {
            codeName: "绥关铁路",
            codeValue: "1902"
        },
        {
            codeName: "黑河海关",
            codeValue: "1903"
        },
        {
            codeName: "同江海关",
            codeValue: "1904"
        },
        {
            codeName: "佳木斯海关",
            codeValue: "1905"
        },
        {
            codeName: "牡丹江关",
            codeValue: "1906"
        },
        {
            codeName: "东宁海关",
            codeValue: "1907"
        },
        {
            codeName: "逊克海关",
            codeValue: "1908"
        },
        {
            codeName: "齐齐哈尔",
            codeValue: "1909"
        },
        {
            codeName: "大庆海关",
            codeValue: "1910"
        },
        {
            codeName: "密山海关",
            codeValue: "1911"
        },
        {
            codeName: "虎林海关",
            codeValue: "1912"
        },
        {
            codeName: "同江富锦",
            codeValue: "1913"
        },
        {
            codeName: "抚远海关",
            codeValue: "1914"
        },
        {
            codeName: "漠河海关",
            codeValue: "1915"
        },
        {
            codeName: "萝北海关",
            codeValue: "1916"
        },
        {
            codeName: "嘉荫海关",
            codeValue: "1917"
        },
        {
            codeName: "饶河海关",
            codeValue: "1918"
        },
        {
            codeName: "冰城香办",
            codeValue: "1919"
        },
        {
            codeName: "哈开发区",
            codeValue: "1920"
        },
        {
            codeName: "绥综保区",
            codeValue: "1921"
        },
        {
            codeName: "冰城邮办",
            codeValue: "1922"
        },
        {
            codeName: "哈关车办",
            codeValue: "1923"
        },
        {
            codeName: "哈机场关",
            codeValue: "1924"
        },
        {
            codeName: "绥关公路",
            codeValue: "1925"
        },
        {
            codeName: "哈综保区",
            codeValue: "1926"
        },
        {
            codeName: "哈综口岸",
            codeValue: "1927"
        },
        {
            codeName: "绥综口岸",
            codeValue: "1928"
        },
        {
            codeName: "牡保B型",
            codeValue: "1929"
        },
        {
            codeName: "冰城海关",
            codeValue: "1930"
        },
        {
            codeName: "鹤岗海关",
            codeValue: "1931"
        },
        {
            codeName: "黑河保B",
            codeValue: "1932"
        },
        {
            codeName: "绥化海关",
            codeValue: "1933"
        },
        {
            codeName: "黑关公路",
            codeValue: "1934"
        },
        {
            codeName: "同关铁路",
            codeValue: "1935"
        },
        {
            codeName: "上海海关",
            codeValue: "2200"
        },
        {
            codeName: "浦江海关",
            codeValue: "2201"
        },
        {
            codeName: "吴淞海关",
            codeValue: "2202"
        },
        {
            codeName: "虹桥机场",
            codeValue: "2203"
        },
        {
            codeName: "闵开发区",
            codeValue: "2204"
        },
        {
            codeName: "车站海关",
            codeValue: "2205"
        },
        {
            codeName: "邮局海关",
            codeValue: "2206"
        },
        {
            codeName: "洋山海关",
            codeValue: "2207"
        },
        {
            codeName: "宝山海关",
            codeValue: "2208"
        },
        {
            codeName: "龙吴海关",
            codeValue: "2209"
        },
        {
            codeName: "浦东海关",
            codeValue: "2210"
        },
        {
            codeName: "卢湾监管",
            codeValue: "2211"
        },
        {
            codeName: "奉贤海关",
            codeValue: "2212"
        },
        {
            codeName: "莘庄海关",
            codeValue: "2213"
        },
        {
            codeName: "漕河泾发",
            codeValue: "2214"
        },
        {
            codeName: "西北物流",
            codeValue: "2215"
        },
        {
            codeName: "浦机综保",
            codeValue: "2216"
        },
        {
            codeName: "嘉定海关",
            codeValue: "2217"
        },
        {
            codeName: "外高桥关",
            codeValue: "2218"
        },
        {
            codeName: "沪杨浦关",
            codeValue: "2219"
        },
        {
            codeName: "金山海关",
            codeValue: "2220"
        },
        {
            codeName: "松江海关",
            codeValue: "2221"
        },
        {
            codeName: "青浦海关",
            codeValue: "2222"
        },
        {
            codeName: "沪科创关",
            codeValue: "2223"
        },
        {
            codeName: "崇明海关",
            codeValue: "2224"
        },
        {
            codeName: "外港海关",
            codeValue: "2225"
        },
        {
            codeName: "贸易网点",
            codeValue: "2226"
        },
        {
            codeName: "普陀区站",
            codeValue: "2227"
        },
        {
            codeName: "沪会展关",
            codeValue: "2228"
        },
        {
            codeName: "航交办",
            codeValue: "2229"
        },
        {
            codeName: "沪徐汇关",
            codeValue: "2230"
        },
        {
            codeName: "洋山市内",
            codeValue: "2231"
        },
        {
            codeName: "嘉定综保",
            codeValue: "2232"
        },
        {
            codeName: "浦东机场",
            codeValue: "2233"
        },
        {
            codeName: "沪钻交所",
            codeValue: "2234"
        },
        {
            codeName: "松江综A",
            codeValue: "2235"
        },
        {
            codeName: "洋山芦潮",
            codeValue: "2236"
        },
        {
            codeName: "松江综B",
            codeValue: "2237"
        },
        {
            codeName: "青浦综保",
            codeValue: "2238"
        },
        {
            codeName: "奉贤综保",
            codeValue: "2239"
        },
        {
            codeName: "漕河泾综",
            codeValue: "2240"
        },
        {
            codeName: "沪黄浦关",
            codeValue: "2241"
        },
        {
            codeName: "沪业二处",
            codeValue: "2242"
        },
        {
            codeName: "沪虹口关",
            codeValue: "2243"
        },
        {
            codeName: "上海快件",
            codeValue: "2244"
        },
        {
            codeName: "金桥综保",
            codeValue: "2245"
        },
        {
            codeName: "外高桥综",
            codeValue: "2246"
        },
        {
            codeName: "沪化工区",
            codeValue: "2247"
        },
        {
            codeName: "洋山港区",
            codeValue: "2248"
        },
        {
            codeName: "洋山特综",
            codeValue: "2249"
        },
        {
            codeName: "沪空港办",
            codeValue: "2250"
        },
        {
            codeName: "沪金桥办",
            codeValue: "2251"
        },
        {
            codeName: "虹桥B保",
            codeValue: "2252"
        },
        {
            codeName: "南京海关",
            codeValue: "2300"
        },
        {
            codeName: "连云港关",
            codeValue: "2301"
        },
        {
            codeName: "南通海关",
            codeValue: "2302"
        },
        {
            codeName: "苏州海关",
            codeValue: "2303"
        },
        {
            codeName: "无锡海关",
            codeValue: "2304"
        },
        {
            codeName: "张家港关",
            codeValue: "2305"
        },
        {
            codeName: "常州海关",
            codeValue: "2306"
        },
        {
            codeName: "镇江海关",
            codeValue: "2307"
        },
        {
            codeName: "新生圩关",
            codeValue: "2308"
        },
        {
            codeName: "盐城海关",
            codeValue: "2309"
        },
        {
            codeName: "扬州海关",
            codeValue: "2310"
        },
        {
            codeName: "徐州海关",
            codeValue: "2311"
        },
        {
            codeName: "江阴海关",
            codeValue: "2312"
        },
        {
            codeName: "张保税区",
            codeValue: "2313"
        },
        {
            codeName: "苏工业区",
            codeValue: "2314"
        },
        {
            codeName: "淮安海关",
            codeValue: "2315"
        },
        {
            codeName: "泰州海关",
            codeValue: "2316"
        },
        {
            codeName: "禄口机场",
            codeValue: "2317"
        },
        {
            codeName: "金陵江北",
            codeValue: "2318"
        },
        {
            codeName: "如皋海关",
            codeValue: "2319"
        },
        {
            codeName: "锡关机办",
            codeValue: "2320"
        },
        {
            codeName: "常溧阳办",
            codeValue: "2321"
        },
        {
            codeName: "镇丹阳办",
            codeValue: "2322"
        },
        {
            codeName: "金陵海关",
            codeValue: "2323"
        },
        {
            codeName: "常熟海关",
            codeValue: "2324"
        },
        {
            codeName: "昆山海关",
            codeValue: "2325"
        },
        {
            codeName: "吴江海关",
            codeValue: "2326"
        },
        {
            codeName: "太仓海关",
            codeValue: "2327"
        },
        {
            codeName: "苏吴中办",
            codeValue: "2328"
        },
        {
            codeName: "启东海关",
            codeValue: "2329"
        },
        {
            codeName: "泰泰兴办",
            codeValue: "2330"
        },
        {
            codeName: "宜兴海关",
            codeValue: "2331"
        },
        {
            codeName: "锡锡山办",
            codeValue: "2332"
        },
        {
            codeName: "南通关办",
            codeValue: "2333"
        },
        {
            codeName: "新沂保B",
            codeValue: "2334"
        },
        {
            codeName: "昆山加工",
            codeValue: "2335"
        },
        {
            codeName: "苏园加工",
            codeValue: "2336"
        },
        {
            codeName: "徐州综保",
            codeValue: "2337"
        },
        {
            codeName: "苏关邮办",
            codeValue: "2338"
        },
        {
            codeName: "南通加工",
            codeValue: "2339"
        },
        {
            codeName: "无锡加工",
            codeValue: "2340"
        },
        {
            codeName: "连关加工",
            codeValue: "2341"
        },
        {
            codeName: "连赣榆办",
            codeValue: "2342"
        },
        {
            codeName: "宁南加工",
            codeValue: "2343"
        },
        {
            codeName: "苏高加工",
            codeValue: "2344"
        },
        {
            codeName: "镇江加工",
            codeValue: "2345"
        },
        {
            codeName: "连关综保",
            codeValue: "2346"
        },
        {
            codeName: "苏园B区",
            codeValue: "2347"
        },
        {
            codeName: "金港海关",
            codeValue: "2348"
        },
        {
            codeName: "金陵邮办",
            codeValue: "2349"
        },
        {
            codeName: "苏高物流",
            codeValue: "2350"
        },
        {
            codeName: "金陵江宁",
            codeValue: "2351"
        },
        {
            codeName: "宁空保B",
            codeValue: "2352"
        },
        {
            codeName: "常关出加",
            codeValue: "2353"
        },
        {
            codeName: "扬关出加",
            codeValue: "2354"
        },
        {
            codeName: "常熟出加",
            codeValue: "2355"
        },
        {
            codeName: "宿迁保B",
            codeValue: "2356"
        },
        {
            codeName: "常关武办",
            codeValue: "2357"
        },
        {
            codeName: "苏园保税",
            codeValue: "2358"
        },
        {
            codeName: "吴中出加",
            codeValue: "2359"
        },
        {
            codeName: "盐关港办",
            codeValue: "2360"
        },
        {
            codeName: "淮关出加",
            codeValue: "2361"
        },
        {
            codeName: "澄关物流",
            codeValue: "2362"
        },
        {
            codeName: "靖江物流",
            codeValue: "2363"
        },
        {
            codeName: "武进出加",
            codeValue: "2364"
        },
        {
            codeName: "张保税港",
            codeValue: "2365"
        },
        {
            codeName: "宿迁海关",
            codeValue: "2366"
        },
        {
            codeName: "泰出加区",
            codeValue: "2367"
        },
        {
            codeName: "苏高综保",
            codeValue: "2368"
        },
        {
            codeName: "昆山综保",
            codeValue: "2369"
        },
        {
            codeName: "连关物流",
            codeValue: "2370"
        },
        {
            codeName: "盐机场办",
            codeValue: "2371"
        },
        {
            codeName: "盐城综保",
            codeValue: "2372"
        },
        {
            codeName: "淮安综保",
            codeValue: "2373"
        },
        {
            codeName: "锡高综保",
            codeValue: "2374"
        },
        {
            codeName: "靖江海关",
            codeValue: "2375"
        },
        {
            codeName: "南通综保",
            codeValue: "2376"
        },
        {
            codeName: "龙潭综保",
            codeValue: "2377"
        },
        {
            codeName: "江宁综保",
            codeValue: "2378"
        },
        {
            codeName: "苏相城办",
            codeValue: "2379"
        },
        {
            codeName: "太仓综保",
            codeValue: "2380"
        },
        {
            codeName: "苏园贸易",
            codeValue: "2381"
        },
        {
            codeName: "苏虎丘办",
            codeValue: "2382"
        },
        {
            codeName: "如东海关",
            codeValue: "2383"
        },
        {
            codeName: "如皋物流",
            codeValue: "2384"
        },
        {
            codeName: "泰州综保",
            codeValue: "2385"
        },
        {
            codeName: "镇江综保",
            codeValue: "2386"
        },
        {
            codeName: "常州综保",
            codeValue: "2387"
        },
        {
            codeName: "武进综保",
            codeValue: "2388"
        },
        {
            codeName: "常熟综保",
            codeValue: "2389"
        },
        {
            codeName: "吴江综保",
            codeValue: "2390"
        },
        {
            codeName: "徐州物流",
            codeValue: "2391"
        },
        {
            codeName: "通海门办",
            codeValue: "2392"
        },
        {
            codeName: "通海安办",
            codeValue: "2393"
        },
        {
            codeName: "吴中综保",
            codeValue: "2394"
        },
        {
            codeName: "大丰物流",
            codeValue: "2395"
        },
        {
            codeName: "海安物流",
            codeValue: "2396"
        },
        {
            codeName: "江阴综保",
            codeValue: "2397"
        },
        {
            codeName: "扬州综保",
            codeValue: "2398"
        },
        {
            codeName: "杭州关区",
            codeValue: "2900"
        },
        {
            codeName: "钱综三处",
            codeValue: "2901"
        },
        {
            codeName: "钱江海关",
            codeValue: "2902"
        },
        {
            codeName: "温州海关",
            codeValue: "2903"
        },
        {
            codeName: "舟山海关",
            codeValue: "2904"
        },
        {
            codeName: "台州海关",
            codeValue: "2905"
        },
        {
            codeName: "绍兴海关",
            codeValue: "2906"
        },
        {
            codeName: "湖州海关",
            codeValue: "2907"
        },
        {
            codeName: "嘉兴海关",
            codeValue: "2908"
        },
        {
            codeName: "钱关下沙",
            codeValue: "2909"
        },
        {
            codeName: "杭州机场",
            codeValue: "2910"
        },
        {
            codeName: "钱关邮办",
            codeValue: "2911"
        },
        {
            codeName: "钱关萧办",
            codeValue: "2912"
        },
        {
            codeName: "丽水海关",
            codeValue: "2915"
        },
        {
            codeName: "杭州快件",
            codeValue: "2916"
        },
        {
            codeName: "衢州海关",
            codeValue: "2917"
        },
        {
            codeName: "钱关余办",
            codeValue: "2918"
        },
        {
            codeName: "钱关富办",
            codeValue: "2919"
        },
        {
            codeName: "金华海关",
            codeValue: "2920"
        },
        {
            codeName: "义乌海关",
            codeValue: "2921"
        },
        {
            codeName: "金关永办",
            codeValue: "2922"
        },
        {
            codeName: "义乌物流",
            codeValue: "2923"
        },
        {
            codeName: "金义综保",
            codeValue: "2924"
        },
        {
            codeName: "义乌综保",
            codeValue: "2925"
        },
        {
            codeName: "义关机办",
            codeValue: "2927"
        },
        {
            codeName: "杭关电商",
            codeValue: "2928"
        },
        {
            codeName: "钱关建办",
            codeValue: "2929"
        },
        {
            codeName: "温关邮办",
            codeValue: "2931"
        },
        {
            codeName: "温经开关",
            codeValue: "2932"
        },
        {
            codeName: "温关机办",
            codeValue: "2933"
        },
        {
            codeName: "温关鳌办",
            codeValue: "2934"
        },
        {
            codeName: "温关瑞办",
            codeValue: "2935"
        },
        {
            codeName: "温关乐办",
            codeValue: "2936"
        },
        {
            codeName: "温州物流",
            codeValue: "2937"
        },
        {
            codeName: "温州综保",
            codeValue: "2938"
        },
        {
            codeName: "嵊泗海关",
            codeValue: "2941"
        },
        {
            codeName: "舟关金塘",
            codeValue: "2942"
        },
        {
            codeName: "舟关综保",
            codeValue: "2943"
        },
        {
            codeName: "台关临办",
            codeValue: "2951"
        },
        {
            codeName: "台关温办",
            codeValue: "2952"
        },
        {
            codeName: "台关玉办",
            codeValue: "2953"
        },
        {
            codeName: "台州综保",
            codeValue: "2954"
        },
        {
            codeName: "绍关虞办",
            codeValue: "2961"
        },
        {
            codeName: "绍关诸办",
            codeValue: "2962"
        },
        {
            codeName: "绍关新办",
            codeValue: "2963"
        },
        {
            codeName: "绍兴综保",
            codeValue: "2964"
        },
        {
            codeName: "湖关安办",
            codeValue: "2971"
        },
        {
            codeName: "湖关德办",
            codeValue: "2972"
        },
        {
            codeName: "德清保B",
            codeValue: "2973"
        },
        {
            codeName: "衢州综保",
            codeValue: "2977"
        },
        {
            codeName: "湖州保B",
            codeValue: "2979"
        },
        {
            codeName: "嘉关乍办",
            codeValue: "2981"
        },
        {
            codeName: "嘉关善办",
            codeValue: "2982"
        },
        {
            codeName: "嘉兴综保",
            codeValue: "2983"
        },
        {
            codeName: "嘉关宁办",
            codeValue: "2984"
        },
        {
            codeName: "嘉兴桐办",
            codeValue: "2985"
        },
        {
            codeName: "嘉综B区",
            codeValue: "2986"
        },
        {
            codeName: "杭州综保",
            codeValue: "2991"
        },
        {
            codeName: "杭州物流",
            codeValue: "2992"
        },
        {
            codeName: "宁波关区",
            codeValue: "3100"
        },
        {
            codeName: "海曙海关",
            codeValue: "3101"
        },
        {
            codeName: "镇海海关",
            codeValue: "3102"
        },
        {
            codeName: "甬北城办",
            codeValue: "3103"
        },
        {
            codeName: "北仑海关",
            codeValue: "3104"
        },
        {
            codeName: "甬保税区",
            codeValue: "3105"
        },
        {
            codeName: "大榭海关",
            codeValue: "3106"
        },
        {
            codeName: "余姚海关",
            codeValue: "3107"
        },
        {
            codeName: "慈溪海关",
            codeValue: "3108"
        },
        {
            codeName: "甬机场关",
            codeValue: "3109"
        },
        {
            codeName: "象山海关",
            codeValue: "3110"
        },
        {
            codeName: "甬加工区",
            codeValue: "3111"
        },
        {
            codeName: "甬物流区",
            codeValue: "3112"
        },
        {
            codeName: "慈加工区",
            codeValue: "3113"
        },
        {
            codeName: "鄞州海关",
            codeValue: "3114"
        },
        {
            codeName: "栎社海关",
            codeValue: "3115"
        },
        {
            codeName: "梅山港区",
            codeValue: "3116"
        },
        {
            codeName: "梅山保税",
            codeValue: "3117"
        },
        {
            codeName: "宁波快件",
            codeValue: "3118"
        },
        {
            codeName: "甬邮局关",
            codeValue: "3119"
        },
        {
            codeName: "镇海物流",
            codeValue: "3120"
        },
        {
            codeName: "甬北港办",
            codeValue: "3121"
        },
        {
            codeName: "甬北穿办",
            codeValue: "3122"
        },
        {
            codeName: "甬江海关",
            codeValue: "3123"
        },
        {
            codeName: "奉化海关",
            codeValue: "3124"
        },
        {
            codeName: "宁海海关",
            codeValue: "3125"
        },
        {
            codeName: "甬新区关",
            codeValue: "3126"
        },
        {
            codeName: "合肥海关",
            codeValue: "3300"
        },
        {
            codeName: "芜湖海关",
            codeValue: "3301"
        },
        {
            codeName: "安庆海关",
            codeValue: "3302"
        },
        {
            codeName: "马鞍山关",
            codeValue: "3303"
        },
        {
            codeName: "黄山海关",
            codeValue: "3304"
        },
        {
            codeName: "蚌埠海关",
            codeValue: "3305"
        },
        {
            codeName: "铜陵海关",
            codeValue: "3306"
        },
        {
            codeName: "阜阳海关",
            codeValue: "3307"
        },
        {
            codeName: "池州海关",
            codeValue: "3308"
        },
        {
            codeName: "滁州海关",
            codeValue: "3309"
        },
        {
            codeName: "庐州海关",
            codeValue: "3310"
        },
        {
            codeName: "新桥机场",
            codeValue: "3311"
        },
        {
            codeName: "芜湖综保",
            codeValue: "3312"
        },
        {
            codeName: "经开综保",
            codeValue: "3313"
        },
        {
            codeName: "宣城海关",
            codeValue: "3315"
        },
        {
            codeName: "蚌埠物流",
            codeValue: "3316"
        },
        {
            codeName: "合肥综保",
            codeValue: "3317"
        },
        {
            codeName: "淮南海关",
            codeValue: "3318"
        },
        {
            codeName: "宿州海关",
            codeValue: "3319"
        },
        {
            codeName: "合关快件",
            codeValue: "3320"
        },
        {
            codeName: "安庆物流",
            codeValue: "3321"
        },
        {
            codeName: "宣城物流",
            codeValue: "3322"
        },
        {
            codeName: "空港物流",
            codeValue: "3323"
        },
        {
            codeName: "马综保区",
            codeValue: "3324"
        },
        {
            codeName: "六安海关",
            codeValue: "3325"
        },
        {
            codeName: "淮北海关",
            codeValue: "3326"
        },
        {
            codeName: "亳州海关",
            codeValue: "3327"
        },
        {
            codeName: "铜陵物流",
            codeValue: "3328"
        },
        {
            codeName: "安庆综保",
            codeValue: "3329"
        },
        {
            codeName: "池州物流",
            codeValue: "3330"
        },
        {
            codeName: "福州关区",
            codeValue: "3500"
        },
        {
            codeName: "马尾海关",
            codeValue: "3501"
        },
        {
            codeName: "榕福清办",
            codeValue: "3502"
        },
        {
            codeName: "宁德海关",
            codeValue: "3503"
        },
        {
            codeName: "三明海关",
            codeValue: "3504"
        },
        {
            codeName: "榕罗源办",
            codeValue: "3505"
        },
        {
            codeName: "莆田海关",
            codeValue: "3506"
        },
        {
            codeName: "长乐机场",
            codeValue: "3507"
        },
        {
            codeName: "榕江阴港",
            codeValue: "3508"
        },
        {
            codeName: "榕邮局办",
            codeValue: "3509"
        },
        {
            codeName: "南平海关",
            codeValue: "3510"
        },
        {
            codeName: "武夷山关",
            codeValue: "3511"
        },
        {
            codeName: "黄岐监管",
            codeValue: "3512"
        },
        {
            codeName: "榕快安办",
            codeValue: "3513"
        },
        {
            codeName: "平潭港区",
            codeValue: "3515"
        },
        {
            codeName: "平潭海关",
            codeValue: "3516"
        },
        {
            codeName: "榕城海关",
            codeValue: "3518"
        },
        {
            codeName: "宁德保B",
            codeValue: "3519"
        },
        {
            codeName: "福州综保",
            codeValue: "3520"
        },
        {
            codeName: "榕翔保B",
            codeValue: "3521"
        },
        {
            codeName: "福机场综",
            codeValue: "3522"
        },
        {
            codeName: "榕江阴综",
            codeValue: "3523"
        },
        {
            codeName: "厦门关区",
            codeValue: "3700"
        },
        {
            codeName: "厦门海关",
            codeValue: "3701"
        },
        {
            codeName: "泉刺桐办",
            codeValue: "3702"
        },
        {
            codeName: "漳州海关",
            codeValue: "3703"
        },
        {
            codeName: "东山海关",
            codeValue: "3704"
        },
        {
            codeName: "泉石狮办",
            codeValue: "3705"
        },
        {
            codeName: "龙岩海关",
            codeValue: "3706"
        },
        {
            codeName: "泉泉港办",
            codeValue: "3707"
        },
        {
            codeName: "海沧港区",
            codeValue: "3708"
        },
        {
            codeName: "海沧保税",
            codeValue: "3709"
        },
        {
            codeName: "高崎海关",
            codeValue: "3710"
        },
        {
            codeName: "东渡海关",
            codeValue: "3711"
        },
        {
            codeName: "海沧海关",
            codeValue: "3712"
        },
        {
            codeName: "邮局海关",
            codeValue: "3713"
        },
        {
            codeName: "象屿保税",
            codeValue: "3714"
        },
        {
            codeName: "机场海关",
            codeValue: "3715"
        },
        {
            codeName: "集同海关",
            codeValue: "3716"
        },
        {
            codeName: "象屿综保",
            codeValue: "3717"
        },
        {
            codeName: "泉综保区",
            codeValue: "3718"
        },
        {
            codeName: "厦门加工",
            codeValue: "3719"
        },
        {
            codeName: "厦门物流",
            codeValue: "3720"
        },
        {
            codeName: "大嶝监管",
            codeValue: "3722"
        },
        {
            codeName: "泉晋江办",
            codeValue: "3723"
        },
        {
            codeName: "邮轮海关",
            codeValue: "3724"
        },
        {
            codeName: "翔安海关",
            codeValue: "3725"
        },
        {
            codeName: "泉陆地港",
            codeValue: "3726"
        },
        {
            codeName: "古雷海关",
            codeValue: "3727"
        },
        {
            codeName: "泉安溪办",
            codeValue: "3728"
        },
        {
            codeName: "泉南安办",
            codeValue: "3729"
        },
        {
            codeName: "厦五通办",
            codeValue: "3730"
        },
        {
            codeName: "漳招银办",
            codeValue: "3731"
        },
        {
            codeName: "泉州海关",
            codeValue: "3732"
        },
        {
            codeName: "漳州保B",
            codeValue: "3733"
        },
        {
            codeName: "泉州保B",
            codeValue: "3735"
        },
        {
            codeName: "厦稽查处",
            codeValue: "3777"
        },
        {
            codeName: "厦侦查局",
            codeValue: "3788"
        },
        {
            codeName: "南昌关区",
            codeValue: "4000"
        },
        {
            codeName: "赣江海关",
            codeValue: "4001"
        },
        {
            codeName: "九江海关",
            codeValue: "4002"
        },
        {
            codeName: "赣州海关",
            codeValue: "4003"
        },
        {
            codeName: "景德镇关",
            codeValue: "4004"
        },
        {
            codeName: "吉安海关",
            codeValue: "4005"
        },
        {
            codeName: "昌北机场",
            codeValue: "4006"
        },
        {
            codeName: "青山湖关",
            codeValue: "4007"
        },
        {
            codeName: "龙南海关",
            codeValue: "4008"
        },
        {
            codeName: "新余海关",
            codeValue: "4009"
        },
        {
            codeName: "浔关区办",
            codeValue: "4010"
        },
        {
            codeName: "洪关区办",
            codeValue: "4011"
        },
        {
            codeName: "虔关区办",
            codeValue: "4012"
        },
        {
            codeName: "上饶海关",
            codeValue: "4013"
        },
        {
            codeName: "南昌物流",
            codeValue: "4014"
        },
        {
            codeName: "吉井加工",
            codeValue: "4015"
        },
        {
            codeName: "鹰潭海关",
            codeValue: "4016"
        },
        {
            codeName: "赣州综保",
            codeValue: "4017"
        },
        {
            codeName: "宜春海关",
            codeValue: "4018"
        },
        {
            codeName: "南昌综保",
            codeValue: "4019"
        },
        {
            codeName: "龙南物流",
            codeValue: "4020"
        },
        {
            codeName: "萍乡海关",
            codeValue: "4021"
        },
        {
            codeName: "抚州海关",
            codeValue: "4022"
        },
        {
            codeName: "九江综保",
            codeValue: "4023"
        },
        {
            codeName: "南昌快件",
            codeValue: "4024"
        },
        {
            codeName: "南昌邮件",
            codeValue: "4025"
        },
        {
            codeName: "吉井综保",
            codeValue: "4026"
        },
        {
            codeName: "上饶综保",
            codeValue: "4027"
        },
        {
            codeName: "青岛海关",
            codeValue: "4200"
        },
        {
            codeName: "烟台海关",
            codeValue: "4201"
        },
        {
            codeName: "日照海关",
            codeValue: "4202"
        },
        {
            codeName: "龙口海关",
            codeValue: "4203"
        },
        {
            codeName: "威海海关",
            codeValue: "4204"
        },
        {
            codeName: "烟综保西",
            codeValue: "4208"
        },
        {
            codeName: "荣成海关",
            codeValue: "4209"
        },
        {
            codeName: "青保税区",
            codeValue: "4210"
        },
        {
            codeName: "济宁海关",
            codeValue: "4211"
        },
        {
            codeName: "临沂海关",
            codeValue: "4213"
        },
        {
            codeName: "青前湾港",
            codeValue: "4214"
        },
        {
            codeName: "菏泽海关",
            codeValue: "4215"
        },
        {
            codeName: "枣庄海关",
            codeValue: "4217"
        },
        {
            codeName: "青开发区",
            codeValue: "4218"
        },
        {
            codeName: "蓬莱海关",
            codeValue: "4219"
        },
        {
            codeName: "青机场关",
            codeValue: "4220"
        },
        {
            codeName: "烟机场办",
            codeValue: "4221"
        },
        {
            codeName: "莱州海关",
            codeValue: "4222"
        },
        {
            codeName: "青岛邮关",
            codeValue: "4223"
        },
        {
            codeName: "烟关长办",
            codeValue: "4224"
        },
        {
            codeName: "威海港办",
            codeValue: "4225"
        },
        {
            codeName: "青岛大港",
            codeValue: "4227"
        },
        {
            codeName: "烟关快件",
            codeValue: "4228"
        },
        {
            codeName: "前湾保税",
            codeValue: "4230"
        },
        {
            codeName: "烟开发区",
            codeValue: "4231"
        },
        {
            codeName: "日岚山办",
            codeValue: "4232"
        },
        {
            codeName: "荣龙眼办",
            codeValue: "4236"
        },
        {
            codeName: "威邮局办",
            codeValue: "4238"
        },
        {
            codeName: "青关快件",
            codeValue: "4240"
        },
        {
            codeName: "烟综保东",
            codeValue: "4241"
        },
        {
            codeName: "威综保北",
            codeValue: "4242"
        },
        {
            codeName: "济曲阜办",
            codeValue: "4243"
        },
        {
            codeName: "烟台邮办",
            codeValue: "4245"
        },
        {
            codeName: "青胶综保",
            codeValue: "4246"
        },
        {
            codeName: "威机场办",
            codeValue: "4247"
        },
        {
            codeName: "青西综区",
            codeValue: "4250"
        },
        {
            codeName: "日照物流",
            codeValue: "4253"
        },
        {
            codeName: "青岛物流",
            codeValue: "4254"
        },
        {
            codeName: "威港快件",
            codeValue: "4256"
        },
        {
            codeName: "临综保区",
            codeValue: "4257"
        },
        {
            codeName: "前湾口岸",
            codeValue: "4258"
        },
        {
            codeName: "黄关快件",
            codeValue: "4259"
        },
        {
            codeName: "青港快件",
            codeValue: "4260"
        },
        {
            codeName: "烟港快件",
            codeValue: "4261"
        },
        {
            codeName: "威综保南",
            codeValue: "4262"
        },
        {
            codeName: "海阳海关",
            codeValue: "4263"
        },
        {
            codeName: "烟莱阳办",
            codeValue: "4264"
        },
        {
            codeName: "胶州海关",
            codeValue: "4265"
        },
        {
            codeName: "即墨海关",
            codeValue: "4266"
        },
        {
            codeName: "烟招远办",
            codeValue: "4267"
        },
        {
            codeName: "青董港关",
            codeValue: "4268"
        },
        {
            codeName: "石港快件",
            codeValue: "4269"
        },
        {
            codeName: "威文登办",
            codeValue: "4270"
        },
        {
            codeName: "日照综保",
            codeValue: "4271"
        },
        {
            codeName: "大港快件",
            codeValue: "4272"
        },
        {
            codeName: "即墨综保",
            codeValue: "4273"
        },
        {
            codeName: "烟福保B",
            codeValue: "4274"
        },
        {
            codeName: "烟芝罘办",
            codeValue: "4275"
        },
        {
            codeName: "菏港保税",
            codeValue: "4276"
        },
        {
            codeName: "青西保B",
            codeValue: "4277"
        },
        {
            codeName: "威高快件",
            codeValue: "4278"
        },
        {
            codeName: "临沂机场",
            codeValue: "4279"
        },
        {
            codeName: "青空综保",
            codeValue: "4280"
        },
        {
            codeName: "济宁保B",
            codeValue: "4281"
        },
        {
            codeName: "烟八角办",
            codeValue: "4288"
        },
        {
            codeName: "济南海关",
            codeValue: "4300"
        },
        {
            codeName: "泉城海关",
            codeValue: "4301"
        },
        {
            codeName: "济机场关",
            codeValue: "4302"
        },
        {
            codeName: "济综保区",
            codeValue: "4303"
        },
        {
            codeName: "济邮局关",
            codeValue: "4305"
        },
        {
            codeName: "章锦综保",
            codeValue: "4306"
        },
        {
            codeName: "潍坊海关",
            codeValue: "4310"
        },
        {
            codeName: "潍诸城办",
            codeValue: "4311"
        },
        {
            codeName: "潍综保区",
            codeValue: "4312"
        },
        {
            codeName: "潍寿光办",
            codeValue: "4313"
        },
        {
            codeName: "诸城物流",
            codeValue: "4315"
        },
        {
            codeName: "潍综电商",
            codeValue: "4316"
        },
        {
            codeName: "淄博海关",
            codeValue: "4320"
        },
        {
            codeName: "淄博物流",
            codeValue: "4321"
        },
        {
            codeName: "淄博综保",
            codeValue: "4322"
        },
        {
            codeName: "泰安海关",
            codeValue: "4330"
        },
        {
            codeName: "济机快件",
            codeValue: "4341"
        },
        {
            codeName: "济邮快件",
            codeValue: "4342"
        },
        {
            codeName: "东营海关",
            codeValue: "4350"
        },
        {
            codeName: "东营综保",
            codeValue: "4351"
        },
        {
            codeName: "聊城海关",
            codeValue: "4360"
        },
        {
            codeName: "德州海关",
            codeValue: "4370"
        },
        {
            codeName: "滨州海关",
            codeValue: "4380"
        },
        {
            codeName: "滨州物流",
            codeValue: "4381"
        },
        {
            codeName: "莱芜海关",
            codeValue: "4390"
        },
        {
            codeName: "郑州关区",
            codeValue: "4600"
        },
        {
            codeName: "金水海关",
            codeValue: "4601"
        },
        {
            codeName: "洛阳海关",
            codeValue: "4602"
        },
        {
            codeName: "南阳海关",
            codeValue: "4603"
        },
        {
            codeName: "郑机场关",
            codeValue: "4604"
        },
        {
            codeName: "郑邮局关",
            codeValue: "4605"
        },
        {
            codeName: "郑车站关",
            codeValue: "4606"
        },
        {
            codeName: "安阳海关",
            codeValue: "4607"
        },
        {
            codeName: "新区海关",
            codeValue: "4608"
        },
        {
            codeName: "商丘海关",
            codeValue: "4609"
        },
        {
            codeName: "周口海关",
            codeValue: "4610"
        },
        {
            codeName: "经开综保",
            codeValue: "4611"
        },
        {
            codeName: "新郑海关",
            codeValue: "4612"
        },
        {
            codeName: "郑州空港",
            codeValue: "4613"
        },
        {
            codeName: "焦作海关",
            codeValue: "4614"
        },
        {
            codeName: "三门峡关",
            codeValue: "4615"
        },
        {
            codeName: "新乡海关",
            codeValue: "4616"
        },
        {
            codeName: "信阳海关",
            codeValue: "4617"
        },
        {
            codeName: "鹤壁海关",
            codeValue: "4618"
        },
        {
            codeName: "德众物流",
            codeValue: "4619"
        },
        {
            codeName: "郑航空港",
            codeValue: "4620"
        },
        {
            codeName: "许昌海关",
            codeValue: "4621"
        },
        {
            codeName: "南阳综保",
            codeValue: "4622"
        },
        {
            codeName: "商丘物流",
            codeValue: "4623"
        },
        {
            codeName: "漯河海关",
            codeValue: "4624"
        },
        {
            codeName: "濮阳海关",
            codeValue: "4625"
        },
        {
            codeName: "民权办",
            codeValue: "4626"
        },
        {
            codeName: "民权保B",
            codeValue: "4627"
        },
        {
            codeName: "济源海关",
            codeValue: "4628"
        },
        {
            codeName: "驻马店海关",
            codeValue: "4629"
        },
        {
            codeName: "平顶山海关",
            codeValue: "4630"
        },
        {
            codeName: "开封海关",
            codeValue: "4631"
        },
        {
            codeName: "许昌保B",
            codeValue: "4632"
        },
        {
            codeName: "洛阳综保",
            codeValue: "4633"
        },
        {
            codeName: "开封综合",
            codeValue: "4634"
        },
        {
            codeName: "武汉海关",
            codeValue: "4700"
        },
        {
            codeName: "宜昌海关",
            codeValue: "4701"
        },
        {
            codeName: "荆州海关",
            codeValue: "4702"
        },
        {
            codeName: "襄阳海关",
            codeValue: "4703"
        },
        {
            codeName: "黄石海关",
            codeValue: "4704"
        },
        {
            codeName: "汉阳海关",
            codeValue: "4705"
        },
        {
            codeName: "宜三峡办",
            codeValue: "4706"
        },
        {
            codeName: "鄂加工区",
            codeValue: "4707"
        },
        {
            codeName: "现场一处",
            codeValue: "4708"
        },
        {
            codeName: "武江物流",
            codeValue: "4709"
        },
        {
            codeName: "武关货管",
            codeValue: "4710"
        },
        {
            codeName: "武关快件",
            codeValue: "4711"
        },
        {
            codeName: "武关机场",
            codeValue: "4712"
        },
        {
            codeName: "邮局海关",
            codeValue: "4713"
        },
        {
            codeName: "新港海关",
            codeValue: "4714"
        },
        {
            codeName: "汉口海关",
            codeValue: "4715"
        },
        {
            codeName: "十堰海关",
            codeValue: "4716"
        },
        {
            codeName: "武昌海关",
            codeValue: "4718"
        },
        {
            codeName: "东湖综保",
            codeValue: "4719"
        },
        {
            codeName: "黄石物流",
            codeValue: "4720"
        },
        {
            codeName: "仙桃海关",
            codeValue: "4721"
        },
        {
            codeName: "东湖陆港",
            codeValue: "4722"
        },
        {
            codeName: "宜昌物流",
            codeValue: "4723"
        },
        {
            codeName: "襄阳物流",
            codeValue: "4724"
        },
        {
            codeName: "空港综保",
            codeValue: "4725"
        },
        {
            codeName: "新港综保",
            codeValue: "4726"
        },
        {
            codeName: "荆门海关",
            codeValue: "4727"
        },
        {
            codeName: "鄂州海关",
            codeValue: "4728"
        },
        {
            codeName: "随州海关",
            codeValue: "4729"
        },
        {
            codeName: "恩施海关",
            codeValue: "4730"
        },
        {
            codeName: "经开综保",
            codeValue: "4731"
        },
        {
            codeName: "仙桃物流",
            codeValue: "4732"
        },
        {
            codeName: "荆门保B",
            codeValue: "4733"
        },
        {
            codeName: "宜昌综保",
            codeValue: "4734"
        },
        {
            codeName: "襄阳综保",
            codeValue: "4735"
        },
        {
            codeName: "黄石综保",
            codeValue: "4736"
        },
        {
            codeName: "鄂州保B",
            codeValue: "4738"
        },
        {
            codeName: "长沙关区",
            codeValue: "4900"
        },
        {
            codeName: "衡阳海关",
            codeValue: "4901"
        },
        {
            codeName: "岳阳海关",
            codeValue: "4902"
        },
        {
            codeName: "郴州海关",
            codeValue: "4903"
        },
        {
            codeName: "常德海关",
            codeValue: "4904"
        },
        {
            codeName: "星关霞办",
            codeValue: "4905"
        },
        {
            codeName: "株洲海关",
            codeValue: "4906"
        },
        {
            codeName: "韶山海关",
            codeValue: "4907"
        },
        {
            codeName: "湘机场关",
            codeValue: "4908"
        },
        {
            codeName: "株关醴办",
            codeValue: "4909"
        },
        {
            codeName: "郴州综保",
            codeValue: "4910"
        },
        {
            codeName: "永州海关",
            codeValue: "4911"
        },
        {
            codeName: "金霞物流",
            codeValue: "4913"
        },
        {
            codeName: "张家界关",
            codeValue: "4914"
        },
        {
            codeName: "衡阳综保",
            codeValue: "4915"
        },
        {
            codeName: "星沙海关",
            codeValue: "4916"
        },
        {
            codeName: "湘潭综保",
            codeValue: "4917"
        },
        {
            codeName: "星关浏办",
            codeValue: "4918"
        },
        {
            codeName: "岳阳综保",
            codeValue: "4919"
        },
        {
            codeName: "湘邮海关",
            codeValue: "4920"
        },
        {
            codeName: "黄花综保",
            codeValue: "4921"
        },
        {
            codeName: "株洲物流",
            codeValue: "4922"
        },
        {
            codeName: "邵阳海关",
            codeValue: "4923"
        },
        {
            codeName: "益阳海关",
            codeValue: "4924"
        },
        {
            codeName: "怀化海关",
            codeValue: "4925"
        },
        {
            codeName: "湘西海关",
            codeValue: "4926"
        },
        {
            codeName: "星关铁运",
            codeValue: "4927"
        },
        {
            codeName: "娄底海关",
            codeValue: "4928"
        },
        {
            codeName: "广东分署",
            codeValue: "5000"
        },
        {
            codeName: "广州海关",
            codeValue: "5100"
        },
        {
            codeName: "内港新风",
            codeValue: "5101"
        },
        {
            codeName: "越秀海关",
            codeValue: "5102"
        },
        {
            codeName: "清远海关",
            codeValue: "5103"
        },
        {
            codeName: "清远英德",
            codeValue: "5104"
        },
        {
            codeName: "白云保税",
            codeValue: "5105"
        },
        {
            codeName: "南沙散货",
            codeValue: "5106"
        },
        {
            codeName: "肇庆大旺",
            codeValue: "5107"
        },
        {
            codeName: "肇庆德庆",
            codeValue: "5108"
        },
        {
            codeName: "海珠滘心",
            codeValue: "5109"
        },
        {
            codeName: "南海海关",
            codeValue: "5110"
        },
        {
            codeName: "南海陆港",
            codeValue: "5111"
        },
        {
            codeName: "南海九江",
            codeValue: "5112"
        },
        {
            codeName: "南海北村",
            codeValue: "5113"
        },
        {
            codeName: "南海平洲",
            codeValue: "5114"
        },
        {
            codeName: "荔湾海关",
            codeValue: "5115"
        },
        {
            codeName: "南海业务",
            codeValue: "5116"
        },
        {
            codeName: "桂江车场",
            codeValue: "5117"
        },
        {
            codeName: "平洲旅检",
            codeValue: "5118"
        },
        {
            codeName: "南海三山",
            codeValue: "5119"
        },
        {
            codeName: "海珠海关",
            codeValue: "5120"
        },
        {
            codeName: "内港芳村",
            codeValue: "5121"
        },
        {
            codeName: "内港洲嘴",
            codeValue: "5122"
        },
        {
            codeName: "内港四仓",
            codeValue: "5123"
        },
        {
            codeName: "双东车场",
            codeValue: "5124"
        },
        {
            codeName: "从化海关",
            codeValue: "5125"
        },
        {
            codeName: "内港赤航",
            codeValue: "5126"
        },
        {
            codeName: "广州萝岗",
            codeValue: "5130"
        },
        {
            codeName: "花都海关",
            codeValue: "5131"
        },
        {
            codeName: "花都码头",
            codeValue: "5132"
        },
        {
            codeName: "穗知识城",
            codeValue: "5133"
        },
        {
            codeName: "穗保税处",
            codeValue: "5134"
        },
        {
            codeName: "天河海关",
            codeValue: "5135"
        },
        {
            codeName: "穗统计处",
            codeValue: "5136"
        },
        {
            codeName: "穗价格处",
            codeValue: "5137"
        },
        {
            codeName: "高明食出",
            codeValue: "5138"
        },
        {
            codeName: "穗监管处",
            codeValue: "5139"
        },
        {
            codeName: "穗关税处",
            codeValue: "5140"
        },
        {
            codeName: "广州机场",
            codeValue: "5141"
        },
        {
            codeName: "民航快件",
            codeValue: "5142"
        },
        {
            codeName: "广州车站",
            codeValue: "5143"
        },
        {
            codeName: "穗机综保",
            codeValue: "5144"
        },
        {
            codeName: "广州邮办",
            codeValue: "5145"
        },
        {
            codeName: "穗关会展",
            codeValue: "5146"
        },
        {
            codeName: "穗邮办监",
            codeValue: "5147"
        },
        {
            codeName: "穗大郎站",
            codeValue: "5148"
        },
        {
            codeName: "大铲海关",
            codeValue: "5149"
        },
        {
            codeName: "顺德海关",
            codeValue: "5150"
        },
        {
            codeName: "顺德保税",
            codeValue: "5151"
        },
        {
            codeName: "佛山综合保税区",
            codeValue: "5152"
        },
        {
            codeName: "顺德车场",
            codeValue: "5153"
        },
        {
            codeName: "北窖车场",
            codeValue: "5154"
        },
        {
            codeName: "顺德旅检",
            codeValue: "5155"
        },
        {
            codeName: "陈村车场",
            codeValue: "5157"
        },
        {
            codeName: "顺德勒流",
            codeValue: "5158"
        },
        {
            codeName: "番禺海关",
            codeValue: "5160"
        },
        {
            codeName: "沙湾车场",
            codeValue: "5161"
        },
        {
            codeName: "番禺旅检",
            codeValue: "5162"
        },
        {
            codeName: "番禺货柜",
            codeValue: "5163"
        },
        {
            codeName: "番禺船舶",
            codeValue: "5164"
        },
        {
            codeName: "南沙保税",
            codeValue: "5165"
        },
        {
            codeName: "南沙新港",
            codeValue: "5166"
        },
        {
            codeName: "南沙货港",
            codeValue: "5167"
        },
        {
            codeName: "南沙汽车",
            codeValue: "5168"
        },
        {
            codeName: "南沙海关",
            codeValue: "5169"
        },
        {
            codeName: "肇庆海关",
            codeValue: "5170"
        },
        {
            codeName: "肇庆高要",
            codeValue: "5171"
        },
        {
            codeName: "肇庆车场",
            codeValue: "5172"
        },
        {
            codeName: "肇庆新港",
            codeValue: "5173"
        },
        {
            codeName: "肇庆旅检",
            codeValue: "5174"
        },
        {
            codeName: "肇庆码头",
            codeValue: "5175"
        },
        {
            codeName: "肇庆四会",
            codeValue: "5176"
        },
        {
            codeName: "肇庆三榕",
            codeValue: "5177"
        },
        {
            codeName: "云浮海关",
            codeValue: "5178"
        },
        {
            codeName: "罗定海关",
            codeValue: "5179"
        },
        {
            codeName: "佛关禅办",
            codeValue: "5180"
        },
        {
            codeName: "高明海关",
            codeValue: "5181"
        },
        {
            codeName: "佛山澜石",
            codeValue: "5182"
        },
        {
            codeName: "三水码头",
            codeValue: "5183"
        },
        {
            codeName: "佛山窖口",
            codeValue: "5184"
        },
        {
            codeName: "佛山快件",
            codeValue: "5185"
        },
        {
            codeName: "佛山保税",
            codeValue: "5186"
        },
        {
            codeName: "佛山车场",
            codeValue: "5187"
        },
        {
            codeName: "佛山海关",
            codeValue: "5188"
        },
        {
            codeName: "佛山新港",
            codeValue: "5189"
        },
        {
            codeName: "韶关海关",
            codeValue: "5190"
        },
        {
            codeName: "韶关乐昌",
            codeValue: "5191"
        },
        {
            codeName: "三水海关",
            codeValue: "5192"
        },
        {
            codeName: "三水车场",
            codeValue: "5193"
        },
        {
            codeName: "三水港",
            codeValue: "5194"
        },
        {
            codeName: "审单中心",
            codeValue: "5195"
        },
        {
            codeName: "云浮新港",
            codeValue: "5196"
        },
        {
            codeName: "白云电商",
            codeValue: "5197"
        },
        {
            codeName: "穗河源关",
            codeValue: "5198"
        },
        {
            codeName: "穗技术处",
            codeValue: "5199"
        },
        {
            codeName: "黄埔关区",
            codeValue: "5200"
        },
        {
            codeName: "埔老港关",
            codeValue: "5201"
        },
        {
            codeName: "埔新港关",
            codeValue: "5202"
        },
        {
            codeName: "增城海关",
            codeValue: "5203"
        },
        {
            codeName: "东莞海关",
            codeValue: "5204"
        },
        {
            codeName: "太平海关",
            codeValue: "5205"
        },
        {
            codeName: "惠州海关（作废）",
            codeValue: "5206"
        },
        {
            codeName: "凤岗海关",
            codeValue: "5207"
        },
        {
            codeName: "穗东海关",
            codeValue: "5208"
        },
        {
            codeName: "埔东海关",
            codeValue: "5209"
        },
        {
            codeName: "埔红海办",
            codeValue: "5210"
        },
        {
            codeName: "河源海关",
            codeValue: "5211"
        },
        {
            codeName: "新沙海关",
            codeValue: "5212"
        },
        {
            codeName: "埔长安关",
            codeValue: "5213"
        },
        {
            codeName: "常平海关",
            codeValue: "5214"
        },
        {
            codeName: "沙田海关",
            codeValue: "5216"
        },
        {
            codeName: "寮步车场",
            codeValue: "5217"
        },
        {
            codeName: "江龙车场",
            codeValue: "5218"
        },
        {
            codeName: "黄埔综保",
            codeValue: "5219"
        },
        {
            codeName: "东莞物流",
            codeValue: "5220"
        },
        {
            codeName: "埔荔城办",
            codeValue: "5221"
        },
        {
            codeName: "清溪物流",
            codeValue: "5222"
        },
        {
            codeName: "东莞邮办",
            codeValue: "5223"
        },
        {
            codeName: "萝岗海关",
            codeValue: "5224"
        },
        {
            codeName: "虎门综保",
            codeValue: "5225"
        },
        {
            codeName: "深圳海关",
            codeValue: "5300"
        },
        {
            codeName: "皇岗海关",
            codeValue: "5301"
        },
        {
            codeName: "罗湖海关",
            codeValue: "5302"
        },
        {
            codeName: "沙头角关",
            codeValue: "5303"
        },
        {
            codeName: "蛇口海关",
            codeValue: "5304"
        },
        {
            codeName: "福强海关",
            codeValue: "5305"
        },
        {
            codeName: "笋岗海关",
            codeValue: "5306"
        },
        {
            codeName: "南头海关",
            codeValue: "5307"
        },
        {
            codeName: "龙岗海关",
            codeValue: "5308"
        },
        {
            codeName: "布吉海关",
            codeValue: "5309"
        },
        {
            codeName: "淡水办",
            codeValue: "5310"
        },
        {
            codeName: "深关车站",
            codeValue: "5311"
        },
        {
            codeName: "深监管处",
            codeValue: "5312"
        },
        {
            codeName: "深调查局",
            codeValue: "5313"
        },
        {
            codeName: "深关邮局",
            codeValue: "5314"
        },
        {
            codeName: "惠东海关",
            codeValue: "5315"
        },
        {
            codeName: "大鹏海关",
            codeValue: "5316"
        },
        {
            codeName: "深机场关",
            codeValue: "5317"
        },
        {
            codeName: "梅林海关",
            codeValue: "5318"
        },
        {
            codeName: "同乐海关",
            codeValue: "5319"
        },
        {
            codeName: "文锦渡关",
            codeValue: "5320"
        },
        {
            codeName: "福田海关",
            codeValue: "5321"
        },
        {
            codeName: "沙保税关",
            codeValue: "5322"
        },
        {
            codeName: "深审单处",
            codeValue: "5323"
        },
        {
            codeName: "深审价办",
            codeValue: "5324"
        },
        {
            codeName: "深关税处",
            codeValue: "5325"
        },
        {
            codeName: "深数统处",
            codeValue: "5326"
        },
        {
            codeName: "深法规处",
            codeValue: "5327"
        },
        {
            codeName: "深规范处",
            codeValue: "5328"
        },
        {
            codeName: "深保税处",
            codeValue: "5329"
        },
        {
            codeName: "盐保税关",
            codeValue: "5330"
        },
        {
            codeName: "三门岛办",
            codeValue: "5331"
        },
        {
            codeName: "深财务处",
            codeValue: "5332"
        },
        {
            codeName: "深侦查局",
            codeValue: "5333"
        },
        {
            codeName: "深稽查处",
            codeValue: "5334"
        },
        {
            codeName: "深技术处",
            codeValue: "5335"
        },
        {
            codeName: "深办公室",
            codeValue: "5336"
        },
        {
            codeName: "大亚湾核",
            codeValue: "5337"
        },
        {
            codeName: "惠州港关",
            codeValue: "5338"
        },
        {
            codeName: "坪山海关",
            codeValue: "5339"
        },
        {
            codeName: "沙湾海关",
            codeValue: "5340"
        },
        {
            codeName: "深惠州关",
            codeValue: "5341"
        },
        {
            codeName: "深红海办",
            codeValue: "5342"
        },
        {
            codeName: "深盐物流",
            codeValue: "5343"
        },
        {
            codeName: "惠石化办",
            codeValue: "5344"
        },
        {
            codeName: "深圳湾关",
            codeValue: "5345"
        },
        {
            codeName: "深机快件",
            codeValue: "5346"
        },
        {
            codeName: "深关大铲",
            codeValue: "5348"
        },
        {
            codeName: "前海综保",
            codeValue: "5349"
        },
        {
            codeName: "大运通关",
            codeValue: "5350"
        },
        {
            codeName: "前海保税",
            codeValue: "5351"
        },
        {
            codeName: "梅沙海关",
            codeValue: "5352"
        },
        {
            codeName: "西九龙关",
            codeValue: "5353"
        },
        {
            codeName: "莲塘海关",
            codeValue: "5354"
        },
        {
            codeName: "福中海关",
            codeValue: "5355"
        },
        {
            codeName: "前海海关",
            codeValue: "5356"
        },
        {
            codeName: "观澜海关",
            codeValue: "5357"
        },
        {
            codeName: "西沥海关",
            codeValue: "5358"
        },
        {
            codeName: "拱北关区",
            codeValue: "5700"
        },
        {
            codeName: "拱稽查处",
            codeValue: "5701"
        },
        {
            codeName: "闸口海关",
            codeValue: "5710"
        },
        {
            codeName: "中山海关",
            codeValue: "5720"
        },
        {
            codeName: "中山港",
            codeValue: "5721"
        },
        {
            codeName: "中石岐办",
            codeValue: "5724"
        },
        {
            codeName: "坦洲货场",
            codeValue: "5725"
        },
        {
            codeName: "中山物流",
            codeValue: "5726"
        },
        {
            codeName: "小榄港",
            codeValue: "5727"
        },
        {
            codeName: "神湾港",
            codeValue: "5728"
        },
        {
            codeName: "中山快件",
            codeValue: "5729"
        },
        {
            codeName: "香洲海关",
            codeValue: "5730"
        },
        {
            codeName: "湾仔海关",
            codeValue: "5740"
        },
        {
            codeName: "湾仔船舶",
            codeValue: "5741"
        },
        {
            codeName: "九洲海关",
            codeValue: "5750"
        },
        {
            codeName: "拱白石办",
            codeValue: "5760"
        },
        {
            codeName: "斗门海关",
            codeValue: "5770"
        },
        {
            codeName: "斗井岸办",
            codeValue: "5771"
        },
        {
            codeName: "斗平沙办",
            codeValue: "5772"
        },
        {
            codeName: "高栏海关",
            codeValue: "5780"
        },
        {
            codeName: "高综保区",
            codeValue: "5781"
        },
        {
            codeName: "宏达码头",
            codeValue: "5782"
        },
        {
            codeName: "大桥海关",
            codeValue: "5788"
        },
        {
            codeName: "青茂海关",
            codeValue: "5790"
        },
        {
            codeName: "拱跨工区",
            codeValue: "5791"
        },
        {
            codeName: "拱保税区",
            codeValue: "5792"
        },
        {
            codeName: "万山海关",
            codeValue: "5793"
        },
        {
            codeName: "桂山中途",
            codeValue: "5794"
        },
        {
            codeName: "横琴海关",
            codeValue: "5795"
        },
        {
            codeName: "澳大校区",
            codeValue: "5796"
        },
        {
            codeName: "拱关邮检",
            codeValue: "5798"
        },
        {
            codeName: "珠海快件",
            codeValue: "5799"
        },
        {
            codeName: "汕头海关",
            codeValue: "6000"
        },
        {
            codeName: "汕关货一",
            codeValue: "6001"
        },
        {
            codeName: "汕关货二",
            codeValue: "6002"
        },
        {
            codeName: "汕关行邮",
            codeValue: "6003"
        },
        {
            codeName: "潮汕机场",
            codeValue: "6004"
        },
        {
            codeName: "汕关保税",
            codeValue: "6006"
        },
        {
            codeName: "汕关业务",
            codeValue: "6007"
        },
        {
            codeName: "濠江海关",
            codeValue: "6008"
        },
        {
            codeName: "汕关邮包",
            codeValue: "6009"
        },
        {
            codeName: "汕保物流",
            codeValue: "6010"
        },
        {
            codeName: "揭阳海关",
            codeValue: "6011"
        },
        {
            codeName: "普宁海关",
            codeValue: "6012"
        },
        {
            codeName: "澄海海关",
            codeValue: "6013"
        },
        {
            codeName: "广澳海关",
            codeValue: "6014"
        },
        {
            codeName: "南澳海关",
            codeValue: "6015"
        },
        {
            codeName: "濠江现场",
            codeValue: "6016"
        },
        {
            codeName: "揭关惠来",
            codeValue: "6018"
        },
        {
            codeName: "龙湖海关",
            codeValue: "6019"
        },
        {
            codeName: "汕港海关",
            codeValue: "6020"
        },
        {
            codeName: "潮州海关",
            codeValue: "6021"
        },
        {
            codeName: "饶平海关",
            codeValue: "6022"
        },
        {
            codeName: "饶平快件",
            codeValue: "6023"
        },
        {
            codeName: "汕头综保",
            codeValue: "6026"
        },
        {
            codeName: "潮阳海关",
            codeValue: "6028"
        },
        {
            codeName: "汕尾海关",
            codeValue: "6031"
        },
        {
            codeName: "海城海关",
            codeValue: "6032"
        },
        {
            codeName: "尾关陆丰",
            codeValue: "6033"
        },
        {
            codeName: "汕关快件",
            codeValue: "6038"
        },
        {
            codeName: "梅州海关",
            codeValue: "6041"
        },
        {
            codeName: "梅州兴宁",
            codeValue: "6042"
        },
        {
            codeName: "梅州综保",
            codeValue: "6046"
        },
        {
            codeName: "海口关区",
            codeValue: "6400"
        },
        {
            codeName: "海口港",
            codeValue: "6401"
        },
        {
            codeName: "三亚海关",
            codeValue: "6402"
        },
        {
            codeName: "八所海关",
            codeValue: "6403"
        },
        {
            codeName: "洋浦海关",
            codeValue: "6404"
        },
        {
            codeName: "海保税区",
            codeValue: "6405"
        },
        {
            codeName: "文昌海关",
            codeValue: "6406"
        },
        {
            codeName: "美兰机场",
            codeValue: "6407"
        },
        {
            codeName: "洋浦保税",
            codeValue: "6408"
        },
        {
            codeName: "海口综保",
            codeValue: "6409"
        },
        {
            codeName: "马村港",
            codeValue: "6410"
        },
        {
            codeName: "椰城海关",
            codeValue: "6411"
        },
        {
            codeName: "三沙海关",
            codeValue: "6412"
        },
        {
            codeName: "博鳌机场",
            codeValue: "6413"
        },
        {
            codeName: "海空综保",
            codeValue: "6414"
        },
        {
            codeName: "三亚B保",
            codeValue: "6415"
        },
        {
            codeName: "三亚机场",
            codeValue: "6416"
        },
        {
            codeName: "湛江关区",
            codeValue: "6700"
        },
        {
            codeName: "湛江海关",
            codeValue: "6701"
        },
        {
            codeName: "茂名海关",
            codeValue: "6702"
        },
        {
            codeName: "徐闻海关",
            codeValue: "6703"
        },
        {
            codeName: "海东海关",
            codeValue: "6704"
        },
        {
            codeName: "茂名水东",
            codeValue: "6705"
        },
        {
            codeName: "湛江吴川",
            codeValue: "6706"
        },
        {
            codeName: "廉江海关",
            codeValue: "6707"
        },
        {
            codeName: "茂名高州",
            codeValue: "6708"
        },
        {
            codeName: "茂名信宜",
            codeValue: "6709"
        },
        {
            codeName: "东海岛关",
            codeValue: "6710"
        },
        {
            codeName: "霞山海关",
            codeValue: "6711"
        },
        {
            codeName: "霞海海关",
            codeValue: "6712"
        },
        {
            codeName: "湛江机场",
            codeValue: "6713"
        },
        {
            codeName: "湛江博贺",
            codeValue: "6714"
        },
        {
            codeName: "湛江快件",
            codeValue: "6715"
        },
        {
            codeName: "湛江物流",
            codeValue: "6716"
        },
        {
            codeName: "湛江调顺",
            codeValue: "6717"
        },
        {
            codeName: "湛江遂溪",
            codeValue: "6718"
        },
        {
            codeName: "湛江综保",
            codeValue: "6719"
        },
        {
            codeName: "江门关区",
            codeValue: "6800"
        },
        {
            codeName: "江门海关",
            codeValue: "6810"
        },
        {
            codeName: "高沙海关",
            codeValue: "6811"
        },
        {
            codeName: "外海海关",
            codeValue: "6812"
        },
        {
            codeName: "江门旅检",
            codeValue: "6813"
        },
        {
            codeName: "外海电商",
            codeValue: "6815"
        },
        {
            codeName: "江门车场",
            codeValue: "6816"
        },
        {
            codeName: "江门保税",
            codeValue: "6817"
        },
        {
            codeName: "新会海关",
            codeValue: "6820"
        },
        {
            codeName: "新会港",
            codeValue: "6821"
        },
        {
            codeName: "新会稽查",
            codeValue: "6827"
        },
        {
            codeName: "台山海关",
            codeValue: "6830"
        },
        {
            codeName: "台公益港",
            codeValue: "6831"
        },
        {
            codeName: "台山稽查",
            codeValue: "6837"
        },
        {
            codeName: "开平海关",
            codeValue: "6840"
        },
        {
            codeName: "开平码头",
            codeValue: "6841"
        },
        {
            codeName: "开平电商",
            codeValue: "6847"
        },
        {
            codeName: "恩平海关",
            codeValue: "6850"
        },
        {
            codeName: "恩平港",
            codeValue: "6851"
        },
        {
            codeName: "恩平稽查",
            codeValue: "6857"
        },
        {
            codeName: "鹤山海关",
            codeValue: "6860"
        },
        {
            codeName: "鹤山码头",
            codeValue: "6861"
        },
        {
            codeName: "南方电商",
            codeValue: "6866"
        },
        {
            codeName: "鹤松电商",
            codeValue: "6867"
        },
        {
            codeName: "阳江海关",
            codeValue: "6870"
        },
        {
            codeName: "阳江港",
            codeValue: "6871"
        },
        {
            codeName: "阳江车场",
            codeValue: "6872"
        },
        {
            codeName: "阳江稽查",
            codeValue: "6877"
        },
        {
            codeName: "南宁关区",
            codeValue: "7200"
        },
        {
            codeName: "邕州海关",
            codeValue: "7201"
        },
        {
            codeName: "北海海关",
            codeValue: "7202"
        },
        {
            codeName: "梧州海关",
            codeValue: "7203"
        },
        {
            codeName: "桂林海关",
            codeValue: "7204"
        },
        {
            codeName: "柳州海关",
            codeValue: "7205"
        },
        {
            codeName: "防城海关",
            codeValue: "7206"
        },
        {
            codeName: "东兴海关",
            codeValue: "7207"
        },
        {
            codeName: "凭祥海关",
            codeValue: "7208"
        },
        {
            codeName: "贵港海关",
            codeValue: "7209"
        },
        {
            codeName: "水口海关",
            codeValue: "7210"
        },
        {
            codeName: "龙邦海关",
            codeValue: "7211"
        },
        {
            codeName: "钦州海关",
            codeValue: "7212"
        },
        {
            codeName: "桂林机办",
            codeValue: "7213"
        },
        {
            codeName: "北海综保",
            codeValue: "7214"
        },
        {
            codeName: "钦州综保",
            codeValue: "7215"
        },
        {
            codeName: "南宁综保",
            codeValue: "7216"
        },
        {
            codeName: "钦州港关",
            codeValue: "7217"
        },
        {
            codeName: "玉林海关",
            codeValue: "7218"
        },
        {
            codeName: "南凭综保",
            codeValue: "7219"
        },
        {
            codeName: "友谊关",
            codeValue: "7220"
        },
        {
            codeName: "邕机场关",
            codeValue: "7221"
        },
        {
            codeName: "邕邮局关",
            codeValue: "7222"
        },
        {
            codeName: "贺州海关",
            codeValue: "7223"
        },
        {
            codeName: "河池海关",
            codeValue: "7224"
        },
        {
            codeName: "爱店海关",
            codeValue: "7225"
        },
        {
            codeName: "峒中海关",
            codeValue: "7226"
        },
        {
            codeName: "防港保B",
            codeValue: "7227"
        },
        {
            codeName: "硕龙海关",
            codeValue: "7228"
        },
        {
            codeName: "平孟海关",
            codeValue: "7229"
        },
        {
            codeName: "柳州保B",
            codeValue: "7230"
        },
        {
            codeName: "梧州综保",
            codeValue: "7231"
        },
        {
            codeName: "成都关区",
            codeValue: "7900"
        },
        {
            codeName: "蓉青关",
            codeValue: "7901"
        },
        {
            codeName: "蓉机双流",
            codeValue: "7902"
        },
        {
            codeName: "蓉乐关",
            codeValue: "7903"
        },
        {
            codeName: "蓉攀关",
            codeValue: "7904"
        },
        {
            codeName: "蓉绵关",
            codeValue: "7905"
        },
        {
            codeName: "蓉邮关",
            codeValue: "7906"
        },
        {
            codeName: "蓉盐关",
            codeValue: "7907"
        },
        {
            codeName: "蓉内关",
            codeValue: "7908"
        },
        {
            codeName: "公路场站",
            codeValue: "7909"
        },
        {
            codeName: "蓉机快件",
            codeValue: "7910"
        },
        {
            codeName: "蓉泸关",
            codeValue: "7911"
        },
        {
            codeName: "蓉戎关",
            codeValue: "7912"
        },
        {
            codeName: "蓉南关",
            codeValue: "7913"
        },
        {
            codeName: "蓉绵加工",
            codeValue: "7914"
        },
        {
            codeName: "蓉锦关",
            codeValue: "7915"
        },
        {
            codeName: "蓉锦西区",
            codeValue: "7916"
        },
        {
            codeName: "蓉遂关",
            codeValue: "7917"
        },
        {
            codeName: "蓉旌关",
            codeValue: "7918"
        },
        {
            codeName: "蓉通关",
            codeValue: "7919"
        },
        {
            codeName: "蓉机保B",
            codeValue: "7920"
        },
        {
            codeName: "蓉泸保B",
            codeValue: "7921"
        },
        {
            codeName: "蓉锦双流",
            codeValue: "7922"
        },
        {
            codeName: "蓉戎保B",
            codeValue: "7923"
        },
        {
            codeName: "蓉青保B",
            codeValue: "7924"
        },
        {
            codeName: "蓉新关",
            codeValue: "7925"
        },
        {
            codeName: "蓉利关",
            codeValue: "7926"
        },
        {
            codeName: "蓉新物流",
            codeValue: "7927"
        },
        {
            codeName: "蓉青综保",
            codeValue: "7928"
        },
        {
            codeName: "蓉泸综保",
            codeValue: "7929"
        },
        {
            codeName: "蓉戎综保",
            codeValue: "7930"
        },
        {
            codeName: "蓉锦综保",
            codeValue: "7931"
        },
        {
            codeName: "蓉绵综保",
            codeValue: "7932"
        },
        {
            codeName: "蓉南保B",
            codeValue: "7933"
        },
        {
            codeName: "蓉賨关",
            codeValue: "7934"
        },
        {
            codeName: "蓉机天府",
            codeValue: "7935"
        },
        {
            codeName: "天府快件",
            codeValue: "7936"
        },
        {
            codeName: "蓉内保B",
            codeValue: "7937"
        },
        {
            codeName: "重庆关区",
            codeValue: "8000"
        },
        {
            codeName: "重庆海关",
            codeValue: "8001"
        },
        {
            codeName: "两江海关",
            codeValue: "8002"
        },
        {
            codeName: "重庆机场",
            codeValue: "8003"
        },
        {
            codeName: "重庆邮局",
            codeValue: "8004"
        },
        {
            codeName: "万州海关",
            codeValue: "8005"
        },
        {
            codeName: "渝州海关",
            codeValue: "8006"
        },
        {
            codeName: "重庆水港",
            codeValue: "8007"
        },
        {
            codeName: "两寸海关",
            codeValue: "8008"
        },
        {
            codeName: "涪陵海关",
            codeValue: "8009"
        },
        {
            codeName: "寸滩水港",
            codeValue: "8010"
        },
        {
            codeName: "渝关快件",
            codeValue: "8011"
        },
        {
            codeName: "两果两路",
            codeValue: "8012"
        },
        {
            codeName: "西永综保",
            codeValue: "8013"
        },
        {
            codeName: "西永海关",
            codeValue: "8014"
        },
        {
            codeName: "渝贸园区",
            codeValue: "8015"
        },
        {
            codeName: "渝铁物流",
            codeValue: "8016"
        },
        {
            codeName: "渝公物流",
            codeValue: "8017"
        },
        {
            codeName: "黔江海关",
            codeValue: "8018"
        },
        {
            codeName: "江津综保",
            codeValue: "8019"
        },
        {
            codeName: "永川海关",
            codeValue: "8020"
        },
        {
            codeName: "涪陵综保",
            codeValue: "8021"
        },
        {
            codeName: "两果果园",
            codeValue: "8022"
        },
        {
            codeName: "万州综保",
            codeValue: "8023"
        },
        {
            codeName: "永川综保",
            codeValue: "8024"
        },
        {
            codeName: "贵阳海关",
            codeValue: "8300"
        },
        {
            codeName: "筑城海关",
            codeValue: "8301"
        },
        {
            codeName: "黔机场关",
            codeValue: "8302"
        },
        {
            codeName: "遵义海关",
            codeValue: "8303"
        },
        {
            codeName: "贵阳综保",
            codeValue: "8304"
        },
        {
            codeName: "贵阳现场",
            codeValue: "8305"
        },
        {
            codeName: "贵安综保",
            codeValue: "8306"
        },
        {
            codeName: "贵安海关",
            codeValue: "8307"
        },
        {
            codeName: "六盘水关",
            codeValue: "8308"
        },
        {
            codeName: "遵义综保",
            codeValue: "8309"
        },
        {
            codeName: "凯里海关",
            codeValue: "8310"
        },
        {
            codeName: "毕节海关",
            codeValue: "8311"
        },
        {
            codeName: "兴义海关",
            codeValue: "8312"
        },
        {
            codeName: "铜仁海关",
            codeValue: "8313"
        },
        {
            codeName: "昆明关区",
            codeValue: "8600"
        },
        {
            codeName: "滇中海关",
            codeValue: "8601"
        },
        {
            codeName: "畹町海关",
            codeValue: "8602"
        },
        {
            codeName: "瑞丽海关",
            codeValue: "8603"
        },
        {
            codeName: "章凤海关",
            codeValue: "8604"
        },
        {
            codeName: "盈江海关",
            codeValue: "8605"
        },
        {
            codeName: "孟连海关",
            codeValue: "8606"
        },
        {
            codeName: "南伞海关",
            codeValue: "8607"
        },
        {
            codeName: "孟定海关",
            codeValue: "8608"
        },
        {
            codeName: "打洛海关",
            codeValue: "8609"
        },
        {
            codeName: "腾冲海关",
            codeValue: "8610"
        },
        {
            codeName: "沧源海关",
            codeValue: "8611"
        },
        {
            codeName: "勐腊海关",
            codeValue: "8612"
        },
        {
            codeName: "河口海关",
            codeValue: "8613"
        },
        {
            codeName: "金水河关",
            codeValue: "8614"
        },
        {
            codeName: "天保海关",
            codeValue: "8615"
        },
        {
            codeName: "田蓬海关",
            codeValue: "8616"
        },
        {
            codeName: "大理海关",
            codeValue: "8617"
        },
        {
            codeName: "芒市海关",
            codeValue: "8618"
        },
        {
            codeName: "腾驻隆阳",
            codeValue: "8619"
        },
        {
            codeName: "昆明机场",
            codeValue: "8620"
        },
        {
            codeName: "邮局海关",
            codeValue: "8621"
        },
        {
            codeName: "西双版纳",
            codeValue: "8622"
        },
        {
            codeName: "丽江海关",
            codeValue: "8623"
        },
        {
            codeName: "思茅海关",
            codeValue: "8624"
        },
        {
            codeName: "河口山腰",
            codeValue: "8625"
        },
        {
            codeName: "怒江海关",
            codeValue: "8626"
        },
        {
            codeName: "昆明高新",
            codeValue: "8627"
        },
        {
            codeName: "昆明加工",
            codeValue: "8628"
        },
        {
            codeName: "香格里拉",
            codeValue: "8629"
        },
        {
            codeName: "勐康海关",
            codeValue: "8631"
        },
        {
            codeName: "昆明快件",
            codeValue: "8632"
        },
        {
            codeName: "红河综保",
            codeValue: "8633"
        },
        {
            codeName: "昆明综保",
            codeValue: "8634"
        },
        {
            codeName: "昆综口岸",
            codeValue: "8635"
        },
        {
            codeName: "高新物流",
            codeValue: "8636"
        },
        {
            codeName: "红综口岸",
            codeValue: "8637"
        },
        {
            codeName: "磨憨快件",
            codeValue: "8638"
        },
        {
            codeName: "机场电商",
            codeValue: "8639"
        },
        {
            codeName: "腾俊物流",
            codeValue: "8640"
        },
        {
            codeName: "都龙海关",
            codeValue: "8641"
        },
        {
            codeName: "瑞驻姐告",
            codeValue: "8642"
        },
        {
            codeName: "瑞驻弄岛",
            codeValue: "8643"
        },
        {
            codeName: "孟驻临翔",
            codeValue: "8644"
        },
        {
            codeName: "西驻关累",
            codeValue: "8645"
        },
        {
            codeName: "蒙自海关",
            codeValue: "8646"
        },
        {
            codeName: "曲靖海关",
            codeValue: "8647"
        },
        {
            codeName: "玉溪海关",
            codeValue: "8648"
        },
        {
            codeName: "磨憨铁路",
            codeValue: "8649"
        },
        {
            codeName: "拉萨海关",
            codeValue: "8800"
        },
        {
            codeName: "聂拉木关",
            codeValue: "8801"
        },
        {
            codeName: "日喀则关",
            codeValue: "8802"
        },
        {
            codeName: "狮泉河关",
            codeValue: "8803"
        },
        {
            codeName: "贡嘎机场",
            codeValue: "8804"
        },
        {
            codeName: "八廓海关",
            codeValue: "8805"
        },
        {
            codeName: "普兰海关",
            codeValue: "8806"
        },
        {
            codeName: "亚东海关",
            codeValue: "8807"
        },
        {
            codeName: "吉隆海关",
            codeValue: "8808"
        },
        {
            codeName: "林芝海关",
            codeValue: "8809"
        },
        {
            codeName: "拉萨综保",
            codeValue: "8810"
        },
        {
            codeName: "里孜口岸",
            codeValue: "8811"
        },
        {
            codeName: "西安关区",
            codeValue: "9000"
        },
        {
            codeName: "关中海关",
            codeValue: "9001"
        },
        {
            codeName: "咸阳机场",
            codeValue: "9002"
        },
        {
            codeName: "宝鸡海关",
            codeValue: "9003"
        },
        {
            codeName: "邮局海关",
            codeValue: "9004"
        },
        {
            codeName: "关中综A",
            codeValue: "9005"
        },
        {
            codeName: "关中综B",
            codeValue: "9006"
        },
        {
            codeName: "西安综保",
            codeValue: "9007"
        },
        {
            codeName: "高新综保",
            codeValue: "9008"
        },
        {
            codeName: "车站海关",
            codeValue: "9009"
        },
        {
            codeName: "延安海关",
            codeValue: "9010"
        },
        {
            codeName: "渭南海关",
            codeValue: "9011"
        },
        {
            codeName: "榆林海关",
            codeValue: "9012"
        },
        {
            codeName: "西咸综保",
            codeValue: "9013"
        },
        {
            codeName: "汉中海关",
            codeValue: "9014"
        },
        {
            codeName: "商洛海关",
            codeValue: "9015"
        },
        {
            codeName: "航空综保",
            codeValue: "9016"
        },
        {
            codeName: "宝鸡综保",
            codeValue: "9017"
        },
        {
            codeName: "杨凌综保",
            codeValue: "9018"
        },
        {
            codeName: "乌关区",
            codeValue: "9400"
        },
        {
            codeName: "乌昌公路",
            codeValue: "9401"
        },
        {
            codeName: "霍尔果斯",
            codeValue: "9402"
        },
        {
            codeName: "吐尔尕特",
            codeValue: "9403"
        },
        {
            codeName: "阿拉山口",
            codeValue: "9404"
        },
        {
            codeName: "塔城海关",
            codeValue: "9405"
        },
        {
            codeName: "伊宁海关",
            codeValue: "9406"
        },
        {
            codeName: "吉木乃关",
            codeValue: "9407"
        },
        {
            codeName: "喀什海关",
            codeValue: "9408"
        },
        {
            codeName: "红其拉甫",
            codeValue: "9409"
        },
        {
            codeName: "阿勒泰关",
            codeValue: "9410"
        },
        {
            codeName: "塔克什肯",
            codeValue: "9411"
        },
        {
            codeName: "乌拉斯太",
            codeValue: "9412"
        },
        {
            codeName: "哈密关",
            codeValue: "9413"
        },
        {
            codeName: "红山嘴",
            codeValue: "9414"
        },
        {
            codeName: "伊尔克什",
            codeValue: "9415"
        },
        {
            codeName: "库尔勒关",
            codeValue: "9416"
        },
        {
            codeName: "乌机场关",
            codeValue: "9417"
        },
        {
            codeName: "乌加工区",
            codeValue: "9418"
        },
        {
            codeName: "都拉塔关",
            codeValue: "9419"
        },
        {
            codeName: "乌昌关",
            codeValue: "9420"
        },
        {
            codeName: "霍中心A",
            codeValue: "9421"
        },
        {
            codeName: "石河子关",
            codeValue: "9422"
        },
        {
            codeName: "山口综保",
            codeValue: "9423"
        },
        {
            codeName: "喀什综保",
            codeValue: "9424"
        },
        {
            codeName: "卡拉苏关",
            codeValue: "9425"
        },
        {
            codeName: "奎屯物流",
            codeValue: "9426"
        },
        {
            codeName: "中哈合作中心配套区",
            codeValue: "9427"
        },
        {
            codeName: "乌邮局关",
            codeValue: "9428"
        },
        {
            codeName: "乌综保区",
            codeValue: "9429"
        },
        {
            codeName: "阿克苏关",
            codeValue: "9430"
        },
        {
            codeName: "和田海关",
            codeValue: "9431"
        },
        {
            codeName: "兰州关区",
            codeValue: "9500"
        },
        {
            codeName: "金城海关",
            codeValue: "9501"
        },
        {
            codeName: "酒泉海关",
            codeValue: "9502"
        },
        {
            codeName: "中川机场",
            codeValue: "9503"
        },
        {
            codeName: "武威物流",
            codeValue: "9504"
        },
        {
            codeName: "天水海关",
            codeValue: "9505"
        },
        {
            codeName: "金昌海关",
            codeValue: "9506"
        },
        {
            codeName: "兰州综保",
            codeValue: "9507"
        },
        {
            codeName: "敦煌机场",
            codeValue: "9508"
        },
        {
            codeName: "平凉海关",
            codeValue: "9509"
        },
        {
            codeName: "银川海关",
            codeValue: "9600"
        },
        {
            codeName: "兴庆海关",
            codeValue: "9601"
        },
        {
            codeName: "河东机场",
            codeValue: "9602"
        },
        {
            codeName: "石嘴山关",
            codeValue: "9603"
        },
        {
            codeName: "银川综保",
            codeValue: "9604"
        },
        {
            codeName: "银关快件",
            codeValue: "9605"
        },
        {
            codeName: "石嘴山物流",
            codeValue: "9606"
        },
        {
            codeName: "中卫海关",
            codeValue: "9607"
        },
        {
            codeName: "西宁关区",
            codeValue: "9700"
        },
        {
            codeName: "西海海关",
            codeValue: "9701"
        },
        {
            codeName: "青海物流",
            codeValue: "9702"
        },
        {
            codeName: "西宁机场",
            codeValue: "9703"
        },
        {
            codeName: "格尔木海关",
            codeValue: "9704"
        },
        {
            codeName: "西宁综保",
            codeValue: "9705"
        },
        {
            codeName: "香港海关",
            codeValue: "9800"
        },
        {
            codeName: "政法司",
            codeValue: "9900"
        },
        {
            codeName: "澳门海关",
            codeValue: "A100"
        }
    ],
    // 征免性质
    CUS_LEVYTYPE: [
        {
            codeName: "一般征税",
            codeValue: "101"
        },
        {
            codeName: "整车征税",
            codeValue: "118"
        },
        {
            codeName: "零部件征税",
            codeValue: "119"
        },
        {
            codeName: "无偿援助",
            codeValue: "201"
        },
        {
            codeName: "其他法定",
            codeValue: "299"
        },
        {
            codeName: "特定区域",
            codeValue: "301"
        },
        {
            codeName: "保税区  ",
            codeValue: "307"
        },
        {
            codeName: "其他地区",
            codeValue: "399"
        },
        {
            codeName: "科教用品",
            codeValue: "401"
        },
        {
            codeName: "示范平台用品",
            codeValue: "402"
        },
        {
            codeName: "技术改造",
            codeValue: "403"
        },
        {
            codeName: "科技开发用品",
            codeValue: "405"
        },
        {
            codeName: "重大项目",
            codeValue: "406"
        },
        {
            codeName: "动漫用品",
            codeValue: "407"
        },
        {
            codeName: "重大技术装备",
            codeValue: "408"
        },
        {
            codeName: "科技重大专项",
            codeValue: "409"
        },
        {
            codeName: "基础设施",
            codeValue: "412"
        },
        {
            codeName: "残疾人  ",
            codeValue: "413"
        },
        {
            codeName: "远洋渔业",
            codeValue: "417"
        },
        {
            codeName: "国产化  ",
            codeValue: "418"
        },
        {
            codeName: "整车特征",
            codeValue: "419"
        },
        {
            codeName: "集成电路",
            codeValue: "422"
        },
        {
            codeName: "新型显示器件",
            codeValue: "423"
        },
        {
            codeName: "集成电路和软件企业进口设备",
            codeValue: "426"
        },
        {
            codeName: "集成电路产业进口货物",
            codeValue: "428"
        },
        {
            codeName: "海南免税药械",
            codeValue: "430"
        },
        {
            codeName: "海南免税药械缴增值税",
            codeValue: "431"
        },
        {
            codeName: "合作区自用设备",
            codeValue: "481"
        },
        {
            codeName: "合作区基建物资",
            codeValue: "482"
        },
        {
            codeName: "暂出修理货物",
            codeValue: "490"
        },
        {
            codeName: "零关税自用生产设备",
            codeValue: "491"
        },
        {
            codeName: "零关税交通工具及游艇",
            codeValue: "492"
        },
        {
            codeName: "零关税一般货物",
            codeValue: "493"
        },
        {
            codeName: "暂进修理内销货物",
            codeValue: "495"
        },
        {
            codeName: "含进口料件加工增值货物",
            codeValue: "496"
        },
        {
            codeName: "不含进口料件加工增值货物",
            codeValue: "497"
        },
        {
            codeName: "加工贸易副产品",
            codeValue: "498"
        },
        {
            codeName: "ITA产品",
            codeValue: "499"
        },
        {
            codeName: "加工设备",
            codeValue: "501"
        },
        {
            codeName: "来料加工",
            codeValue: "502"
        },
        {
            codeName: "进料加工",
            codeValue: "503"
        },
        {
            codeName: "边境小额",
            codeValue: "506"
        },
        {
            codeName: "港澳OPA",
            codeValue: "510"
        },
        {
            codeName: "零关税原辅料",
            codeValue: "591"
        },
        {
            codeName: "原辅料部分征税",
            codeValue: "592"
        },
        {
            codeName: "内外贸同船运输加注保税油",
            codeValue: "593"
        },
        {
            codeName: "内外贸同船运输加注本地生产燃料油",
            codeValue: "594"
        },
        {
            codeName: "进出岛航班加注保税油全免",
            codeValue: "595"
        },
        {
            codeName: "进出岛航班加注保税油部分征税",
            codeValue: "596"
        },
        {
            codeName: "中外合资",
            codeValue: "601"
        },
        {
            codeName: "中外合作",
            codeValue: "602"
        },
        {
            codeName: "外资企业",
            codeValue: "603"
        },
        {
            codeName: "勘探开发煤层气",
            codeValue: "605"
        },
        {
            codeName: "海洋石油",
            codeValue: "606"
        },
        {
            codeName: "陆上石油",
            codeValue: "608"
        },
        {
            codeName: "贷款项目",
            codeValue: "609"
        },
        {
            codeName: "海上应急救援",
            codeValue: "610"
        },
        {
            codeName: "贷款中标",
            codeValue: "611"
        },
        {
            codeName: "加征关税排除措施",
            codeValue: "666"
        },
        {
            codeName: "市场化组织采购排除措施",
            codeValue: "686"
        },
        {
            codeName: "公益收藏",
            codeValue: "698"
        },
        {
            codeName: "部分进口饲料",
            codeValue: "701"
        },
        {
            codeName: "中资\"方便旗\"船",
            codeValue: "702"
        },
        {
            codeName: "航空公司进口飞机",
            codeValue: "703"
        },
        {
            codeName: "花卉种子",
            codeValue: "704"
        },
        {
            codeName: "科普事业",
            codeValue: "705"
        },
        {
            codeName: "租赁企业进口飞机",
            codeValue: "706"
        },
        {
            codeName: "博览会留购展品",
            codeValue: "707"
        },
        {
            codeName: "替代种植农产品",
            codeValue: "708"
        },
        {
            codeName: "鼓励项目",
            codeValue: "789"
        },
        {
            codeName: "自有资金",
            codeValue: "799"
        },
        {
            codeName: "救灾捐赠",
            codeValue: "801"
        },
        {
            codeName: "慈善捐赠",
            codeValue: "802"
        },
        {
            codeName: "抗艾滋病药物",
            codeValue: "803"
        },
        {
            codeName: "种子种源",
            codeValue: "811"
        },
        {
            codeName: "野生动植物",
            codeValue: "815"
        },
        {
            codeName: "中央储备粮油",
            codeValue: "818"
        },
        {
            codeName: "科教图书",
            codeValue: "819"
        },
        {
            codeName: "航材减免",
            codeValue: "888"
        },
        {
            codeName: "国批减免",
            codeValue: "898"
        },
        {
            codeName: "选择征税",
            codeValue: "899"
        },
        {
            codeName: "科研院所\n",
            codeValue: "901"
        },
        {
            codeName: "高等学校\n",
            codeValue: "902"
        },
        {
            codeName: "工程研究中心\n",
            codeValue: "903"
        },
        {
            codeName: "国家企业技术中心\n",
            codeValue: "904"
        },
        {
            codeName: "转制科研机构\n",
            codeValue: "905"
        },
        {
            codeName: "重点实验室\n",
            codeValue: "906"
        },
        {
            codeName: "国家工程技术研究中心\n",
            codeValue: "907"
        },
        {
            codeName: "社会研发机构",
            codeValue: "908"
        },
        {
            codeName: "示范平台\n",
            codeValue: "909"
        },
        {
            codeName: "外资研发中心\n",
            codeValue: "910"
        },
        {
            codeName: "出版物进口单位",
            codeValue: "911"
        },
        {
            codeName: "国家实验室",
            codeValue: "912"
        },
        {
            codeName: "国家产业创新中心",
            codeValue: "913"
        },
        {
            codeName: "国家制造业创新中心",
            codeValue: "915"
        },
        {
            codeName: "国家技术创新中心",
            codeValue: "916"
        },
        {
            codeName: "公共图书馆",
            codeValue: "917"
        },
        {
            codeName: "国家临床医学研究中心",
            codeValue: "918"
        },
        {
            codeName: "党校（行政学院）",
            codeValue: "919"
        },
        {
            codeName: "大型客机研制物资",
            codeValue: "921"
        },
        {
            codeName: "进博会留购展品",
            codeValue: "922"
        },
        {
            codeName: "消防救援装备",
            codeValue: "924"
        },
        {
            codeName: "服贸会留购展品",
            codeValue: "926"
        },
        {
            codeName: "进口钻石",
            codeValue: "927"
        },
        {
            codeName: "三代核电",
            codeValue: "928"
        },
        {
            codeName: "疫情防控物资",
            codeValue: "930"
        },
        {
            codeName: "消博会留购展品",
            codeValue: "931"
        },
        {
            codeName: "运动会",
            codeValue: "939"
        },
        {
            codeName: "技能大赛",
            codeValue: "940"
        },
        {
            codeName: "广交会留购展品",
            codeValue: "941"
        },
        {
            codeName: "高水平医院",
            codeValue: "942"
        },
        {
            codeName: "高水平医院科教图书",
            codeValue: "943"
        },
        {
            codeName: "邮轮直供",
            codeValue: "944"
        },
        {
            codeName: "自贸协定",
            codeValue: "997"
        },
        {
            codeName: "内部暂定",
            codeValue: "998"
        },
        {
            codeName: "例外减免",
            codeValue: "999"
        }
    ],
    // 监管方式
    CUS_MAPPING_TRADE_CODE_V: [
        {
            codeName: "一般贸易",
            cusCode: "0110",
            codeValue: "0110",
            gbName: "一般贸易",
            gbCode: "0110",
            ciqCode: "11"
        },
        {
            codeName: "易货贸易",
            cusCode: "0130",
            codeValue: "0130",
            gbName: "易货贸易",
            gbCode: "0130",
            ciqCode: "14"
        },
        {
            codeName: "料件销毁",
            cusCode: "0200",
            codeValue: "0200",
            gbName: "料件销毁",
            gbCode: "0200",
            ciqCode: "19"
        },
        {
            codeName: "来料加工",
            cusCode: "0214",
            codeValue: "0214",
            gbName: "来料加工",
            gbCode: "0214",
            ciqCode: "12"
        },
        {
            codeName: "来料料件内销",
            cusCode: "0245",
            codeValue: "0245",
            gbName: "来料料件内销",
            gbCode: "0245",
            ciqCode: "12"
        },
        {
            codeName: "来料深加工",
            cusCode: "0255",
            codeValue: "0255",
            gbName: "来料深加工",
            gbCode: "0255",
            ciqCode: "12"
        },
        {
            codeName: "来料余料结转",
            cusCode: "0258",
            codeValue: "0258",
            gbName: "来料余料结转",
            gbCode: "0258",
            ciqCode: "12"
        },
        {
            codeName: "来料料件复出",
            cusCode: "0265",
            codeValue: "0265",
            gbName: "来料料件复出",
            gbCode: "0265",
            ciqCode: "12"
        },
        {
            codeName: "来料料件退换",
            cusCode: "0300",
            codeValue: "0300",
            gbName: "来料料件退换",
            gbCode: "0300",
            ciqCode: "12"
        },
        {
            codeName: "加工专用油",
            cusCode: "0314",
            codeValue: "0314",
            gbName: "加工专用油",
            gbCode: "0314",
            ciqCode: "12"
        },
        {
            codeName: "不作价设备",
            cusCode: "0320",
            codeValue: "0320",
            gbName: "不作价设备",
            gbCode: "0320",
            ciqCode: "12"
        },
        {
            codeName: "来料成品减免",
            cusCode: "0345",
            codeValue: "0345",
            gbName: "来料成品减免",
            gbCode: "0345",
            ciqCode: "12"
        },
        {
            codeName: "边角料销毁",
            cusCode: "0400",
            codeValue: "0400",
            gbName: "边角料销毁",
            gbCode: "0400",
            ciqCode: "19"
        },
        {
            codeName: "加工贸易设备",
            cusCode: "0420",
            codeValue: "0420",
            gbName: "加工贸易设备",
            gbCode: "0420",
            ciqCode: "19"
        },
        {
            codeName: "保区进料成品",
            cusCode: "0444",
            codeValue: "0444",
            gbName: "保区进料成品",
            gbCode: "0444",
            ciqCode: "43"
        },
        {
            codeName: "保区来料成品",
            cusCode: "0445",
            codeValue: "0445",
            gbName: "保区来料成品",
            gbCode: "0445",
            ciqCode: "43"
        },
        {
            codeName: "加工设备内销",
            cusCode: "0446",
            codeValue: "0446",
            gbName: "加工设备内销",
            gbCode: "0446",
            ciqCode: "19"
        },
        {
            codeName: "加工设备结转",
            cusCode: "0456",
            codeValue: "0456",
            gbName: "加工设备结转",
            gbCode: "0456",
            ciqCode: "19"
        },
        {
            codeName: "加工设备退运",
            cusCode: "0466",
            codeValue: "0466",
            gbName: "加工设备退运",
            gbCode: "0466",
            ciqCode: "19"
        },
        {
            codeName: "减免设备结转",
            cusCode: "0500",
            codeValue: "0500",
            gbName: "减免设备结转",
            gbCode: "0500",
            ciqCode: "19"
        },
        {
            codeName: "补偿贸易",
            cusCode: "0513",
            codeValue: "0513",
            gbName: "补偿贸易",
            gbCode: "0513",
            ciqCode: "15"
        },
        {
            codeName: "保区进料料件",
            cusCode: "0544",
            codeValue: "0544",
            gbName: "保区进料料件",
            gbCode: "0544",
            ciqCode: "43"
        },
        {
            codeName: "保区来料料件",
            cusCode: "0545",
            codeValue: "0545",
            gbName: "保区来料料件",
            gbCode: "0545",
            ciqCode: "43"
        },
        {
            codeName: "进料对口",
            cusCode: "0615",
            codeValue: "0615",
            gbName: "进料对口",
            gbCode: "0615",
            ciqCode: "13"
        },
        {
            codeName: "进料以产顶进",
            cusCode: "0642",
            codeValue: "0642",
            gbName: "进料以产顶进",
            gbCode: "0642",
            ciqCode: "13"
        },
        {
            codeName: "进料料件内销",
            cusCode: "0644",
            codeValue: "0644",
            gbName: "进料料件内销",
            gbCode: "0644",
            ciqCode: "13"
        },
        {
            codeName: "进料深加工",
            cusCode: "0654",
            codeValue: "0654",
            gbName: "进料深加工",
            gbCode: "0654",
            ciqCode: "13"
        },
        {
            codeName: "进料余料结转",
            cusCode: "0657",
            codeValue: "0657",
            gbName: "进料余料结转",
            gbCode: "0657",
            ciqCode: "13"
        },
        {
            codeName: "进料料件复出",
            cusCode: "0664",
            codeValue: "0664",
            gbName: "进料料件复出",
            gbCode: "0664",
            ciqCode: "13"
        },
        {
            codeName: "进料料件退换",
            cusCode: "0700",
            codeValue: "0700",
            gbName: "进料料件退换",
            gbCode: "0700",
            ciqCode: "13"
        },
        {
            codeName: "进料非对口",
            cusCode: "0715",
            codeValue: "0715",
            gbName: "进料非对口",
            gbCode: "0715",
            ciqCode: "13"
        },
        {
            codeName: "进料成品减免",
            cusCode: "0744",
            codeValue: "0744",
            gbName: "进料成品减免",
            gbCode: "0744",
            ciqCode: "13"
        },
        {
            codeName: "低值辅料",
            cusCode: "0815",
            codeValue: "0815",
            gbName: "低值辅料",
            gbCode: "0815",
            ciqCode: "13"
        },
        {
            codeName: "进料边角料内销",
            cusCode: "0844",
            codeValue: "0844",
            gbName: "进料边角料内销",
            gbCode: "0844",
            ciqCode: "13"
        },
        {
            codeName: "来料边角料内销",
            cusCode: "0845",
            codeValue: "0845",
            gbName: "来料边角料内销",
            gbCode: "0845",
            ciqCode: "12"
        },
        {
            codeName: "进料边角料复出",
            cusCode: "0864",
            codeValue: "0864",
            gbName: "进料边角料复出",
            gbCode: "0864",
            ciqCode: "13"
        },
        {
            codeName: "来料边角料复出",
            cusCode: "0865",
            codeValue: "0865",
            gbName: "来料边角料复出",
            gbCode: "0865",
            ciqCode: "12"
        },
        {
            codeName: "市场采购",
            cusCode: "1039",
            codeValue: "1039",
            gbName: "市场采购",
            gbCode: "1039",
            ciqCode: "19"
        },
        {
            codeName: "国轮油物料",
            cusCode: "1139",
            codeValue: "1139",
            gbName: "国轮油物料",
            gbCode: "1139",
            ciqCode: "19"
        },
        {
            codeName: "保税间货物",
            cusCode: "1200",
            codeValue: "1200",
            gbName: "保税间货物",
            gbCode: "1200",
            ciqCode: "24"
        },
        {
            codeName: "保税电商",
            cusCode: "1210",
            codeValue: "1210",
            gbName: "保税电商",
            gbCode: "1210",
            ciqCode: "42"
        },
        {
            codeName: "保税工厂",
            cusCode: "1215",
            codeValue: "1215",
            gbName: "保税工厂",
            gbCode: "1215",
            ciqCode: "13"
        },
        {
            codeName: "保税仓库货物",
            cusCode: "1233",
            codeValue: "1233",
            gbName: "保税仓库货物",
            gbCode: "1233",
            ciqCode: "23"
        },
        {
            codeName: "保税区仓储转口",
            cusCode: "1234",
            codeValue: "1234",
            gbName: "保税区仓储转口",
            gbCode: "1234",
            ciqCode: "23"
        },
        {
            codeName: "保税电商A",
            cusCode: "1239",
            codeValue: "1239",
            gbName: "保税电商A",
            gbCode: "1239",
            ciqCode: "42"
        },
        {
            codeName: "修理物品",
            cusCode: "1300",
            codeValue: "1300",
            gbName: "修理物品",
            gbCode: "1300",
            ciqCode: "35"
        },
        {
            codeName: "保税维修",
            cusCode: "1371",
            codeValue: "1371",
            gbName: "保税维修",
            gbCode: "1371",
            ciqCode: "35"
        },
        {
            codeName: "出料加工",
            cusCode: "1427",
            codeValue: "1427",
            gbName: "出料加工",
            gbCode: "1427",
            ciqCode: "19"
        },
        {
            codeName: "租赁不满1年",
            cusCode: "1500",
            codeValue: "1500",
            gbName: "租赁不满1年",
            gbCode: "1500",
            ciqCode: "19"
        },
        {
            codeName: "租赁贸易",
            cusCode: "1523",
            codeValue: "1523",
            gbName: "租赁贸易",
            gbCode: "1523",
            ciqCode: "19"
        },
        {
            codeName: "寄售代销",
            cusCode: "1616",
            codeValue: "1616",
            gbName: "寄售代销",
            gbCode: "1616",
            ciqCode: "19"
        },
        {
            codeName: "免税品",
            cusCode: "1741",
            codeValue: "1741",
            gbName: "免税品",
            gbCode: "1741",
            ciqCode: "41"
        },
        {
            codeName: "外汇商品",
            cusCode: "1831",
            codeValue: "1831",
            gbName: "外汇商品",
            gbCode: "1831",
            ciqCode: "41"
        },
        {
            codeName: "合资合作设备",
            cusCode: "2025",
            codeValue: "2025",
            gbName: "合资合作设备",
            gbCode: "2025",
            ciqCode: "18"
        },
        {
            codeName: "对外投资",
            cusCode: "2210",
            codeValue: "2210",
            gbName: "对外投资",
            gbCode: "2210",
            ciqCode: "19"
        },
        {
            codeName: "外资设备物品",
            cusCode: "2225",
            codeValue: "2225",
            gbName: "外资设备物品",
            gbCode: "2225",
            ciqCode: "18"
        },
        {
            codeName: "常驻机构公用",
            cusCode: "2439",
            codeValue: "2439",
            gbName: "常驻机构公用",
            gbCode: "2439",
            ciqCode: "37"
        },
        {
            codeName: "暂时进出货物",
            cusCode: "2600",
            codeValue: "2600",
            gbName: "暂时进出货物",
            gbCode: "2600",
            ciqCode: "29"
        },
        {
            codeName: "展览品",
            cusCode: "2700",
            codeValue: "2700",
            gbName: "展览品",
            gbCode: "2700",
            ciqCode: "30"
        },
        {
            codeName: "陈列样品",
            cusCode: "2939",
            codeValue: "2939",
            gbName: "陈列样品",
            gbCode: "2939",
            ciqCode: "20"
        },
        {
            codeName: "货样广告品",
            cusCode: "3010",
            codeValue: "3010",
            gbName: "货样广告品",
            gbCode: "3010",
            ciqCode: "11"
        },
        {
            codeName: "无代价抵偿",
            cusCode: "3100",
            codeValue: "3100",
            gbName: "无代价抵偿",
            gbCode: "3100",
            ciqCode: "38"
        },
        {
            codeName: "其他进出口免费",
            cusCode: "3339",
            codeValue: "3339",
            gbName: "其他进出口免费",
            gbCode: "3339",
            ciqCode: "31"
        },
        {
            codeName: "承包工程进口",
            cusCode: "3410",
            codeValue: "3410",
            gbName: "承包工程进口",
            gbCode: "3410",
            ciqCode: "21"
        },
        {
            codeName: "对外承包出口",
            cusCode: "3422",
            codeValue: "3422",
            gbName: "对外承包出口",
            gbCode: "3422",
            ciqCode: "21"
        },
        {
            codeName: "援助物资",
            cusCode: "3511",
            codeValue: "3511",
            gbName: "援助物资",
            gbCode: "3511",
            ciqCode: "17"
        },
        {
            codeName: "无偿军援",
            cusCode: "3611",
            codeValue: "3611",
            gbName: "无偿军援",
            gbCode: "3611",
            ciqCode: "40"
        },
        {
            codeName: "捐赠物资",
            cusCode: "3612",
            codeValue: "3612",
            gbName: "捐赠物资",
            gbCode: "3612",
            ciqCode: "31"
        },
        {
            codeName: "军事装备",
            cusCode: "3910",
            codeValue: "3910",
            gbName: "军事装备",
            gbCode: "3910",
            ciqCode: "40"
        },
        {
            codeName: "边境小额",
            cusCode: "4019",
            codeValue: "4019",
            gbName: "边境小额",
            gbCode: "4019",
            ciqCode: "16"
        },
        {
            codeName: "对台小额",
            cusCode: "4039",
            codeValue: "4039",
            gbName: "对台小额",
            gbCode: "4039",
            ciqCode: "34"
        },
        {
            codeName: "对台小额商品交易市场",
            cusCode: "4139",
            codeValue: "4139",
            gbName: "对台小额商品交易市场",
            gbCode: "4139",
            ciqCode: "34"
        },
        {
            codeName: "驻外机构运回",
            cusCode: "4200",
            codeValue: "4200",
            gbName: "驻外机构运回",
            gbCode: "4200",
            ciqCode: "31"
        },
        {
            codeName: "驻外机构购进",
            cusCode: "4239",
            codeValue: "4239",
            gbName: "驻外机构购进",
            gbCode: "4239",
            ciqCode: "31"
        },
        {
            codeName: "来料成品退换",
            cusCode: "4400",
            codeValue: "4400",
            gbName: "来料成品退换",
            gbCode: "4400",
            ciqCode: "12"
        },
        {
            codeName: "直接退运",
            cusCode: "4500",
            codeValue: "4500",
            gbName: "直接退运",
            gbCode: "4500",
            ciqCode: "35"
        },
        {
            codeName: "进口溢误卸",
            cusCode: "4539",
            codeValue: "4539",
            gbName: "进口溢误卸",
            gbCode: "4539",
            ciqCode: "31"
        },
        {
            codeName: "退运货物",
            cusCode: "4561",
            codeValue: "4561",
            gbName: "退运货物",
            gbCode: "4561",
            ciqCode: "27"
        },
        {
            codeName: "进料成品退换",
            cusCode: "4600",
            codeValue: "4600",
            gbName: "进料成品退换",
            gbCode: "4600",
            ciqCode: "13"
        },
        {
            codeName: "料件进出区",
            cusCode: "5000",
            codeValue: "5000",
            gbName: "料件进出区",
            gbCode: "5000",
            ciqCode: "43"
        },
        {
            codeName: "特殊区域研发货物",
            cusCode: "5010",
            codeValue: "5010",
            gbName: "特殊区域研发货物",
            gbCode: "5010",
            ciqCode: "11"
        },
        {
            codeName: "区内来料加工",
            cusCode: "5014",
            codeValue: "5014",
            gbName: "区内来料加工",
            gbCode: "5014",
            ciqCode: "12"
        },
        {
            codeName: "区内进料加工货物",
            cusCode: "5015",
            codeValue: "5015",
            gbName: "区内进料加工货物",
            gbCode: "5015",
            ciqCode: "13"
        },
        {
            codeName: "区内仓储货物",
            cusCode: "5033",
            codeValue: "5033",
            gbName: "区内仓储货物",
            gbCode: "5033",
            ciqCode: "43"
        },
        {
            codeName: "区内物流货物",
            cusCode: "5034",
            codeValue: "5034",
            gbName: "区内物流货物",
            gbCode: "5034",
            ciqCode: "43"
        },
        {
            codeName: "区内保税展品",
            cusCode: "5072",
            codeValue: "5072",
            gbName: "区内保税展品",
            gbCode: "5072",
            ciqCode: null
        },
        {
            codeName: "区内国际中转",
            cusCode: "5073",
            codeValue: "5073",
            gbName: "区内国际中转",
            gbCode: "5073",
            ciqCode: null
        },
        {
            codeName: "成品进出区",
            cusCode: "5100",
            codeValue: "5100",
            gbName: "成品进出区",
            gbCode: "5100",
            ciqCode: "43"
        },
        {
            codeName: "设备进出区",
            cusCode: "5300",
            codeValue: "5300",
            gbName: "设备进出区",
            gbCode: "5300",
            ciqCode: "43"
        },
        {
            codeName: "境外设备进区",
            cusCode: "5335",
            codeValue: "5335",
            gbName: "境外设备进区",
            gbCode: "5335",
            ciqCode: "43"
        },
        {
            codeName: "区内设备退运",
            cusCode: "5361",
            codeValue: "5361",
            gbName: "区内设备退运",
            gbCode: "5361",
            ciqCode: "43"
        },
        {
            codeName: "物流中心进出境货物",
            cusCode: "6033",
            codeValue: "6033",
            gbName: "物流中心进出境货物",
            gbCode: "6033",
            ciqCode: "43"
        },
        {
            codeName: "中心保税展品",
            cusCode: "6072",
            codeValue: "6072",
            gbName: "中心保税展品",
            gbCode: "6072",
            ciqCode: null
        },
        {
            codeName: "中心国际中转",
            cusCode: "6073",
            codeValue: "6073",
            gbName: "中心国际中转",
            gbCode: "6073",
            ciqCode: null
        },
        {
            codeName: "特许权使用费后续征税",
            cusCode: "9500",
            codeValue: "9500",
            gbName: "特许权使用费后续征税",
            gbCode: "9500",
            ciqCode: "31"
        },
        {
            codeName: "内贸货物跨境运输",
            cusCode: "9600",
            codeValue: "9600",
            gbName: "内贸货物跨境运输",
            gbCode: "9600",
            ciqCode: "35"
        },
        {
            codeName: "电子商务",
            cusCode: "9610",
            codeValue: "9610",
            gbName: "电子商务",
            gbCode: "9610",
            ciqCode: "42"
        },
        {
            codeName: "海关处理货物",
            cusCode: "9639",
            codeValue: "9639",
            gbName: "海关处理货物",
            gbCode: "9639",
            ciqCode: "31"
        },
        {
            codeName: "后续补税",
            cusCode: "9700",
            codeValue: "9700",
            gbName: "后续补税",
            gbCode: "9700",
            ciqCode: "31"
        },
        {
            codeName: "跨境电商B2B直接出口",
            cusCode: "9710",
            codeValue: "9710",
            gbName: "跨境电商B2B直接出口",
            gbCode: "9710",
            ciqCode: "11"
        },
        {
            codeName: "其他贸易",
            cusCode: "9739",
            codeValue: "9739",
            gbName: "其他贸易",
            gbCode: "9739",
            ciqCode: "35"
        },
        {
            codeName: "租赁征税",
            cusCode: "9800",
            codeValue: "9800",
            gbName: "租赁征税",
            gbCode: "9800",
            ciqCode: "31"
        },
        {
            codeName: "跨境电商出口海外仓",
            cusCode: "9810",
            codeValue: "9810",
            gbName: "跨境电商出口海外仓",
            gbCode: "9810",
            ciqCode: "11"
        },
        {
            codeName: "留赠转卖物品",
            cusCode: "9839",
            codeValue: "9839",
            gbName: "留赠转卖物品",
            gbCode: "9839",
            ciqCode: "31"
        },
        {
            codeName: "其他",
            cusCode: "9900",
            codeValue: "9900",
            gbName: "其他",
            gbCode: "9900",
            ciqCode: "19"
        }
    ],
    // 国家地区，启运国
    CUS_MAPPING_COUNTRY_CODE_V: [
        {
            codeName: "阿鲁巴",
            enName: "Aruba",
            cusCode: "403",
            codeValue: "ABW",
            gbName: "阿鲁巴",
            gbCode: "ABW",
            ciqCode: "533"
        },
        {
            codeName: "阿富汗",
            enName: "Afghanistan",
            cusCode: "101",
            codeValue: "AFG",
            gbName: "阿富汗",
            gbCode: "AFG",
            ciqCode: "004"
        },
        {
            codeName: "安哥拉",
            enName: "Angola",
            cusCode: "202",
            codeValue: "AGO",
            gbName: "安哥拉",
            gbCode: "AGO",
            ciqCode: "024"
        },
        {
            codeName: "安圭拉",
            enName: "Anguilla",
            cusCode: "456",
            codeValue: "AIA",
            gbName: "安圭拉",
            gbCode: "AIA",
            ciqCode: "660"
        },
        {
            codeName: "奥兰群岛",
            enName: "?land Islands",
            cusCode: "360",
            codeValue: "ALA",
            gbName: "奥兰群岛",
            gbCode: "ALA",
            ciqCode: "248"
        },
        {
            codeName: "阿尔巴尼亚",
            enName: "Albania",
            cusCode: "313",
            codeValue: "ALB",
            gbName: "阿尔巴尼亚",
            gbCode: "ALB",
            ciqCode: "008"
        },
        {
            codeName: "安道尔",
            enName: "Andorra",
            cusCode: "314",
            codeValue: "AND",
            gbName: "安道尔",
            gbCode: "AND",
            ciqCode: "020"
        },
        {
            codeName: "阿联酋",
            enName: "United Arab Emirates",
            cusCode: "138",
            codeValue: "ARE",
            gbName: "阿联酋",
            gbCode: "ARE",
            ciqCode: "784"
        },
        {
            codeName: "阿根廷",
            enName: "Argentina",
            cusCode: "402",
            codeValue: "ARG",
            gbName: "阿根廷",
            gbCode: "ARG",
            ciqCode: "032"
        },
        {
            codeName: "亚美尼亚",
            enName: "Armenia",
            cusCode: "151",
            codeValue: "ARM",
            gbName: "亚美尼亚",
            gbCode: "ARM",
            ciqCode: "051"
        },
        {
            codeName: "美属萨摩亚",
            enName: "American Samoa",
            cusCode: "626",
            codeValue: "ASM",
            gbName: "美属萨摩亚",
            gbCode: "ASM",
            ciqCode: "016"
        },
        {
            codeName: "南极洲",
            enName: "Antarctica",
            cusCode: "700",
            codeValue: "ATA",
            gbName: "南极洲",
            gbCode: "ATA",
            ciqCode: "010"
        },
        {
            codeName: "法属南方领地",
            enName: "French Southern Territories",
            cusCode: "261",
            codeValue: "ATF",
            gbName: "法属南方领地",
            gbCode: "ATF",
            ciqCode: "260"
        },
        {
            codeName: "安提瓜和巴布达",
            enName: "Antigua and Barbuda",
            cusCode: "401",
            codeValue: "ATG",
            gbName: "安提瓜和巴布达",
            gbCode: "ATG",
            ciqCode: "028"
        },
        {
            codeName: "澳大利亚",
            enName: "Australia",
            cusCode: "601",
            codeValue: "AUS",
            gbName: "澳大利亚",
            gbCode: "AUS",
            ciqCode: "036"
        },
        {
            codeName: "奥地利",
            enName: "Austria",
            cusCode: "315",
            codeValue: "AUT",
            gbName: "奥地利",
            gbCode: "AUT",
            ciqCode: "040"
        },
        {
            codeName: "阿塞拜疆",
            enName: "Azerbaijan",
            cusCode: "152",
            codeValue: "AZE",
            gbName: "阿塞拜疆",
            gbCode: "AZE",
            ciqCode: "031"
        },
        {
            codeName: "布隆迪",
            enName: "Burundi",
            cusCode: "205",
            codeValue: "BDI",
            gbName: "布隆迪",
            gbCode: "BDI",
            ciqCode: "108"
        },
        {
            codeName: "比利时",
            enName: "Belgium",
            cusCode: "301",
            codeValue: "BEL",
            gbName: "比利时",
            gbCode: "BEL",
            ciqCode: "056"
        },
        {
            codeName: "贝宁",
            enName: "Benin",
            cusCode: "203",
            codeValue: "BEN",
            gbName: "贝宁",
            gbCode: "BEN",
            ciqCode: "204"
        },
        {
            codeName: "博纳尔，圣俄斯塔休斯和萨巴",
            enName: "Bonaire, Sint Eustatius and Saba",
            cusCode: "449",
            codeValue: "BES",
            gbName: "博纳尔，圣俄斯塔休斯和萨巴",
            gbCode: "BES",
            ciqCode: "535"
        },
        {
            codeName: "布基纳法索",
            enName: "Burkina Faso",
            cusCode: "251",
            codeValue: "BFA",
            gbName: "布基纳法索",
            gbCode: "BFA",
            ciqCode: "854"
        },
        {
            codeName: "孟加拉国",
            enName: "Bangladesh",
            cusCode: "103",
            codeValue: "BGD",
            gbName: "孟加拉国",
            gbCode: "BGD",
            ciqCode: "050"
        },
        {
            codeName: "保加利亚",
            enName: "Bulgaria",
            cusCode: "316",
            codeValue: "BGR",
            gbName: "保加利亚",
            gbCode: "BGR",
            ciqCode: "100"
        },
        {
            codeName: "巴林",
            enName: "Bahrain",
            cusCode: "102",
            codeValue: "BHR",
            gbName: "巴林",
            gbCode: "BHR",
            ciqCode: "048"
        },
        {
            codeName: "巴哈马",
            enName: "Bahamas",
            cusCode: "404",
            codeValue: "BHS",
            gbName: "巴哈马",
            gbCode: "BHS",
            ciqCode: "044"
        },
        {
            codeName: "波斯尼亚和黑塞哥维那",
            enName: "Bosnia and Herzegovina",
            cusCode: "355",
            codeValue: "BIH",
            gbName: "波斯尼亚和黑塞哥维那",
            gbCode: "BIH",
            ciqCode: "070"
        },
        {
            codeName: "圣巴泰勒米",
            enName: "Saint Barthélemy",
            cusCode: "450",
            codeValue: "BLM",
            gbName: "圣巴泰勒米",
            gbCode: "BLM",
            ciqCode: "652"
        },
        {
            codeName: "白俄罗斯",
            enName: "Belarus",
            cusCode: "340",
            codeValue: "BLR",
            gbName: "白俄罗斯",
            gbCode: "BLR",
            ciqCode: "112"
        },
        {
            codeName: "伯利兹",
            enName: "Belize",
            cusCode: "406",
            codeValue: "BLZ",
            gbName: "伯利兹",
            gbCode: "BLZ",
            ciqCode: "084"
        },
        {
            codeName: "百慕大",
            enName: "Bermuda",
            cusCode: "504",
            codeValue: "BMU",
            gbName: "百慕大",
            gbCode: "BMU",
            ciqCode: "060"
        },
        {
            codeName: "玻利维亚",
            enName: "Bolivia",
            cusCode: "408",
            codeValue: "BOL",
            gbName: "玻利维亚",
            gbCode: "BOL",
            ciqCode: "068"
        },
        {
            codeName: "巴西",
            enName: "Brazil",
            cusCode: "410",
            codeValue: "BRA",
            gbName: "巴西",
            gbCode: "BRA",
            ciqCode: "076"
        },
        {
            codeName: "巴巴多斯",
            enName: "Barbados",
            cusCode: "405",
            codeValue: "BRB",
            gbName: "巴巴多斯",
            gbCode: "BRB",
            ciqCode: "052"
        },
        {
            codeName: "文莱",
            enName: "Brunei",
            cusCode: "105",
            codeValue: "BRN",
            gbName: "文莱",
            gbCode: "BRN",
            ciqCode: "096"
        },
        {
            codeName: "不丹",
            enName: "Bhutan",
            cusCode: "104",
            codeValue: "BTN",
            gbName: "不丹",
            gbCode: "BTN",
            ciqCode: "064"
        },
        {
            codeName: "布维岛",
            enName: "Bouvet Island",
            cusCode: "451",
            codeValue: "BVT",
            gbName: "布维岛",
            gbCode: "BVT",
            ciqCode: "074"
        },
        {
            codeName: "博茨瓦纳",
            enName: "Botswana",
            cusCode: "204",
            codeValue: "BWA",
            gbName: "博茨瓦纳",
            gbCode: "BWA",
            ciqCode: "072"
        },
        {
            codeName: "中非",
            enName: "Central African Republic",
            cusCode: "209",
            codeValue: "CAF",
            gbName: "中非",
            gbCode: "CAF",
            ciqCode: "140"
        },
        {
            codeName: "加那利群岛",
            enName: "Canary Islands",
            cusCode: "207",
            codeValue: "CAI",
            gbName: "加那利群岛",
            gbCode: "CAI",
            ciqCode: "999"
        },
        {
            codeName: "加拿大",
            enName: "Canada",
            cusCode: "501",
            codeValue: "CAN",
            gbName: "加拿大",
            gbCode: "CAN",
            ciqCode: "124"
        },
        {
            codeName: "科科斯（基林）群岛",
            enName: "Cocos (Keeling) Islands",
            cusCode: "627",
            codeValue: "CCK",
            gbName: "科科斯（基林）群岛",
            gbCode: "CCK",
            ciqCode: "166"
        },
        {
            codeName: "塞卜泰（休达）",
            enName: "Ceuta",
            cusCode: "210",
            codeValue: "CEU",
            gbName: "塞卜泰（休达）",
            gbCode: "CEU",
            ciqCode: "142"
        },
        {
            codeName: "瑞士",
            enName: "Switzerland",
            cusCode: "331",
            codeValue: "CHE",
            gbName: "瑞士",
            gbCode: "CHE",
            ciqCode: "756"
        },
        {
            codeName: "智利",
            enName: "Chile",
            cusCode: "412",
            codeValue: "CHL",
            gbName: "智利",
            gbCode: "CHL",
            ciqCode: "152"
        },
        {
            codeName: "中国",
            enName: "China",
            cusCode: "142",
            codeValue: "CHN",
            gbName: "中国",
            gbCode: "CHN",
            ciqCode: "156"
        },
        {
            codeName: "科特迪瓦",
            enName: "Cote d'Ivoire",
            cusCode: "223",
            codeValue: "CIV",
            gbName: "科特迪瓦",
            gbCode: "CIV",
            ciqCode: "384"
        },
        {
            codeName: "喀麦隆",
            enName: "Cameroon",
            cusCode: "206",
            codeValue: "CMR",
            gbName: "喀麦隆",
            gbCode: "CMR",
            ciqCode: "120"
        },
        {
            codeName: "刚果民主共和国",
            enName: "Democratic Republic of Congo",
            cusCode: "252",
            codeValue: "COD",
            gbName: "刚果民主共和国",
            gbCode: "COD",
            ciqCode: "180"
        },
        {
            codeName: "刚果共和国",
            enName: "Congo",
            cusCode: "213",
            codeValue: "COG",
            gbName: "刚果共和国",
            gbCode: "COG",
            ciqCode: "178"
        },
        {
            codeName: "库克群岛",
            enName: "Cook Islands",
            cusCode: "602",
            codeValue: "COK",
            gbName: "库克群岛",
            gbCode: "COK",
            ciqCode: "184"
        },
        {
            codeName: "哥伦比亚",
            enName: "Colombia",
            cusCode: "413",
            codeValue: "COL",
            gbName: "哥伦比亚",
            gbCode: "COL",
            ciqCode: "170"
        },
        {
            codeName: "科摩罗",
            enName: "Comoros",
            cusCode: "212",
            codeValue: "COM",
            gbName: "科摩罗",
            gbCode: "COM",
            ciqCode: "174"
        },
        {
            codeName: "佛得角",
            enName: "Cabo Verde",
            cusCode: "208",
            codeValue: "CPV",
            gbName: "佛得角",
            gbCode: "CPV",
            ciqCode: "132"
        },
        {
            codeName: "哥斯达黎加",
            enName: "Costa Rica",
            cusCode: "415",
            codeValue: "CRI",
            gbName: "哥斯达黎加",
            gbCode: "CRI",
            ciqCode: "188"
        },
        {
            codeName: "古巴",
            enName: "Cuba",
            cusCode: "416",
            codeValue: "CUB",
            gbName: "古巴",
            gbCode: "CUB",
            ciqCode: "192"
        },
        {
            codeName: "库拉索",
            enName: "Cura?ao",
            cusCode: "417",
            codeValue: "CUW",
            gbName: "库拉索",
            gbCode: "CUW",
            ciqCode: "531"
        },
        {
            codeName: "圣诞岛",
            enName: "Christmas Island",
            cusCode: "628",
            codeValue: "CXR",
            gbName: "圣诞岛",
            gbCode: "CXR",
            ciqCode: "162"
        },
        {
            codeName: "开曼群岛",
            enName: "Cayman Islands",
            cusCode: "411",
            codeValue: "CYM",
            gbName: "开曼群岛",
            gbCode: "CYM",
            ciqCode: "136"
        },
        {
            codeName: "塞浦路斯",
            enName: "Cyprus",
            cusCode: "108",
            codeValue: "CYP",
            gbName: "塞浦路斯",
            gbCode: "CYP",
            ciqCode: "196"
        },
        {
            codeName: "捷克",
            enName: "Czechia（Czech Republic）",
            cusCode: "352",
            codeValue: "CZE",
            gbName: "捷克",
            gbCode: "CZE",
            ciqCode: "203"
        },
        {
            codeName: "德国",
            enName: "Germany",
            cusCode: "304",
            codeValue: "DEU",
            gbName: "德国",
            gbCode: "DEU",
            ciqCode: "276"
        },
        {
            codeName: "吉布提",
            enName: "Djibouti",
            cusCode: "214",
            codeValue: "DJI",
            gbName: "吉布提",
            gbCode: "DJI",
            ciqCode: "262"
        },
        {
            codeName: "多米尼克",
            enName: "Dominica",
            cusCode: "414",
            codeValue: "DMA",
            gbName: "多米尼克",
            gbCode: "DMA",
            ciqCode: "212"
        },
        {
            codeName: "丹麦",
            enName: "Denmark",
            cusCode: "302",
            codeValue: "DNK",
            gbName: "丹麦",
            gbCode: "DNK",
            ciqCode: "208"
        },
        {
            codeName: "多米尼加",
            enName: "Dominican Republic",
            cusCode: "418",
            codeValue: "DOM",
            gbName: "多米尼加",
            gbCode: "DOM",
            ciqCode: "214"
        },
        {
            codeName: "阿尔及利亚",
            enName: "Algeria",
            cusCode: "201",
            codeValue: "DZA",
            gbName: "阿尔及利亚",
            gbCode: "DZA",
            ciqCode: "012"
        },
        {
            codeName: "厄瓜多尔",
            enName: "Ecuador",
            cusCode: "419",
            codeValue: "ECU",
            gbName: "厄瓜多尔",
            gbCode: "ECU",
            ciqCode: "218"
        },
        {
            codeName: "埃及",
            enName: "Egypt",
            cusCode: "215",
            codeValue: "EGY",
            gbName: "埃及",
            gbCode: "EGY",
            ciqCode: "818"
        },
        {
            codeName: "厄立特里亚",
            enName: "Eritrea",
            cusCode: "258",
            codeValue: "ERI",
            gbName: "厄立特里亚",
            gbCode: "ERI",
            ciqCode: "232"
        },
        {
            codeName: "西撒哈拉",
            enName: "Western Sahara",
            cusCode: "245",
            codeValue: "ESH",
            gbName: "西撒哈拉",
            gbCode: "ESH",
            ciqCode: "732"
        },
        {
            codeName: "西班牙",
            enName: "Spain",
            cusCode: "312",
            codeValue: "ESP",
            gbName: "西班牙",
            gbCode: "ESP",
            ciqCode: "724"
        },
        {
            codeName: "爱沙尼亚",
            enName: "Estonia",
            cusCode: "334",
            codeValue: "EST",
            gbName: "爱沙尼亚",
            gbCode: "EST",
            ciqCode: "233"
        },
        {
            codeName: "埃塞俄比亚",
            enName: "Ethiopia",
            cusCode: "217",
            codeValue: "ETH",
            gbName: "埃塞俄比亚",
            gbCode: "ETH",
            ciqCode: "231"
        },
        {
            codeName: "芬兰",
            enName: "Finland",
            cusCode: "318",
            codeValue: "FIN",
            gbName: "芬兰",
            gbCode: "FIN",
            ciqCode: "246"
        },
        {
            codeName: "斐济",
            enName: "Fiji",
            cusCode: "603",
            codeValue: "FJI",
            gbName: "斐济",
            gbCode: "FJI",
            ciqCode: "242"
        },
        {
            codeName: "福克兰群岛（马尔维纳斯）",
            enName: "Falkland Islands (Malvinas)",
            cusCode: "452",
            codeValue: "FLK",
            gbName: "福克兰群岛（马尔维纳斯）",
            gbCode: "FLK",
            ciqCode: "238"
        },
        {
            codeName: "法国",
            enName: "France",
            cusCode: "305",
            codeValue: "FRA",
            gbName: "法国",
            gbCode: "FRA",
            ciqCode: "250"
        },
        {
            codeName: "法罗群岛",
            enName: "Faroe Islands",
            cusCode: "357",
            codeValue: "FRO",
            gbName: "法罗群岛",
            gbCode: "FRO",
            ciqCode: "234"
        },
        {
            codeName: "密克罗尼西亚联邦",
            enName: "The Federated States of Micronesia",
            cusCode: "620",
            codeValue: "FSM",
            gbName: "密克罗尼西亚联邦",
            gbCode: "FSM",
            ciqCode: "583"
        },
        {
            codeName: "加蓬",
            enName: "Gabon",
            cusCode: "218",
            codeValue: "GAB",
            gbName: "加蓬",
            gbCode: "GAB",
            ciqCode: "266"
        },
        {
            codeName: "盖比群岛",
            enName: "Gambier Islands",
            cusCode: "604",
            codeValue: "GAM",
            gbName: "盖比群岛",
            gbCode: "GAM",
            ciqCode: "999"
        },
        {
            codeName: "英国",
            enName: "United Kingdom",
            cusCode: "303",
            codeValue: "GBR",
            gbName: "英国",
            gbCode: "GBR",
            ciqCode: "826"
        },
        {
            codeName: "格鲁吉亚",
            enName: "Georgia",
            cusCode: "150",
            codeValue: "GEO",
            gbName: "格鲁吉亚",
            gbCode: "GEO",
            ciqCode: "268"
        },
        {
            codeName: "格恩西",
            enName: "Guernsey",
            cusCode: "361",
            codeValue: "GGY",
            gbName: "格恩西",
            gbCode: "GGY",
            ciqCode: "831"
        },
        {
            codeName: "加纳",
            enName: "Ghana",
            cusCode: "220",
            codeValue: "GHA",
            gbName: "加纳",
            gbCode: "GHA",
            ciqCode: "288"
        },
        {
            codeName: "直布罗陀",
            enName: "Gibraltar",
            cusCode: "320",
            codeValue: "GIB",
            gbName: "直布罗陀",
            gbCode: "GIB",
            ciqCode: "292"
        },
        {
            codeName: "几内亚",
            enName: "Guinea",
            cusCode: "221",
            codeValue: "GIN",
            gbName: "几内亚",
            gbCode: "GIN",
            ciqCode: "324"
        },
        {
            codeName: "瓜德罗普",
            enName: "Guadeloupe",
            cusCode: "422",
            codeValue: "GLP",
            gbName: "瓜德罗普",
            gbCode: "GLP",
            ciqCode: "312"
        },
        {
            codeName: "冈比亚",
            enName: "Gambia",
            cusCode: "219",
            codeValue: "GMB",
            gbName: "冈比亚",
            gbCode: "GMB",
            ciqCode: "270"
        },
        {
            codeName: "几内亚比绍",
            enName: "Guinea-Bissau",
            cusCode: "222",
            codeValue: "GNB",
            gbName: "几内亚比绍",
            gbCode: "GNB",
            ciqCode: "624"
        },
        {
            codeName: "赤道几内亚",
            enName: "Equatorial Guinea",
            cusCode: "216",
            codeValue: "GNQ",
            gbName: "赤道几内亚",
            gbCode: "GNQ",
            ciqCode: "226"
        },
        {
            codeName: "希腊",
            enName: "Greece",
            cusCode: "310",
            codeValue: "GRC",
            gbName: "希腊",
            gbCode: "GRC",
            ciqCode: "300"
        },
        {
            codeName: "格林纳达",
            enName: "Grenada",
            cusCode: "421",
            codeValue: "GRD",
            gbName: "格林纳达",
            gbCode: "GRD",
            ciqCode: "308"
        },
        {
            codeName: "格陵兰",
            enName: "Greenland",
            cusCode: "503",
            codeValue: "GRL",
            gbName: "格陵兰",
            gbCode: "GRL",
            ciqCode: "304"
        },
        {
            codeName: "危地马拉",
            enName: "Guatemala",
            cusCode: "423",
            codeValue: "GTM",
            gbName: "危地马拉",
            gbCode: "GTM",
            ciqCode: "320"
        },
        {
            codeName: "法属圭亚那",
            enName: "French Guiana",
            cusCode: "420",
            codeValue: "GUF",
            gbName: "法属圭亚那",
            gbCode: "GUF",
            ciqCode: "254"
        },
        {
            codeName: "关岛",
            enName: "Guam",
            cusCode: "629",
            codeValue: "GUM",
            gbName: "关岛",
            gbCode: "GUM",
            ciqCode: "316"
        },
        {
            codeName: "圭亚那",
            enName: "Guyana",
            cusCode: "424",
            codeValue: "GUY",
            gbName: "圭亚那",
            gbCode: "GUY",
            ciqCode: "328"
        },
        {
            codeName: "中国香港",
            enName: "Hong Kong,China",
            cusCode: "110",
            codeValue: "HKG",
            gbName: "中国香港",
            gbCode: "HKG",
            ciqCode: "344"
        },
        {
            codeName: "赫德岛和麦克唐纳岛",
            enName: "Heard Island and McDonald Islands",
            cusCode: "630",
            codeValue: "HMD",
            gbName: "赫德岛和麦克唐纳岛",
            gbCode: "HMD",
            ciqCode: "334"
        },
        {
            codeName: "洪都拉斯",
            enName: "Honduras",
            cusCode: "426",
            codeValue: "HND",
            gbName: "洪都拉斯",
            gbCode: "HND",
            ciqCode: "340"
        },
        {
            codeName: "原产地不明（按相关成员最高税率）",
            enName: "Highest Rate A",
            cusCode: "801",
            codeValue: "HRA",
            gbName: "原产地不明（按相关成员最高税率）",
            gbCode: "HRA",
            ciqCode: "   "
        },
        {
            codeName: "原产地不明（按所有成员最高税率）",
            enName: "Highest Rate B",
            cusCode: "802",
            codeValue: "HRB",
            gbName: "原产地不明（按所有成员最高税率）",
            gbCode: "HRB",
            ciqCode: "   "
        },
        {
            codeName: "克罗地亚",
            enName: "Croatia",
            cusCode: "351",
            codeValue: "HRV",
            gbName: "克罗地亚",
            gbCode: "HRV",
            ciqCode: "191"
        },
        {
            codeName: "海地",
            enName: "Haiti",
            cusCode: "425",
            codeValue: "HTI",
            gbName: "海地",
            gbCode: "HTI",
            ciqCode: "332"
        },
        {
            codeName: "匈牙利",
            enName: "Hungary",
            cusCode: "321",
            codeValue: "HUN",
            gbName: "匈牙利",
            gbCode: "HUN",
            ciqCode: "348"
        },
        {
            codeName: "印度尼西亚",
            enName: "Indonesia",
            cusCode: "112",
            codeValue: "IDN",
            gbName: "印度尼西亚",
            gbCode: "IDN",
            ciqCode: "360"
        },
        {
            codeName: "马恩岛",
            enName: "Isle of Man",
            cusCode: "362",
            codeValue: "IMN",
            gbName: "马恩岛",
            gbCode: "IMN",
            ciqCode: "833"
        },
        {
            codeName: "印度",
            enName: "India",
            cusCode: "111",
            codeValue: "IND",
            gbName: "印度",
            gbCode: "IND",
            ciqCode: "356"
        },
        {
            codeName: "英属印度洋领地",
            enName: "British Indian Ocean Territory",
            cusCode: "262",
            codeValue: "IOT",
            gbName: "英属印度洋领地",
            gbCode: "IOT",
            ciqCode: "086"
        },
        {
            codeName: "爱尔兰",
            enName: "Ireland",
            cusCode: "306",
            codeValue: "IRL",
            gbName: "爱尔兰",
            gbCode: "IRL",
            ciqCode: "372"
        },
        {
            codeName: "伊朗",
            enName: "Iran",
            cusCode: "113",
            codeValue: "IRN",
            gbName: "伊朗",
            gbCode: "IRN",
            ciqCode: "364"
        },
        {
            codeName: "伊拉克",
            enName: "Iraq",
            cusCode: "114",
            codeValue: "IRQ",
            gbName: "伊拉克",
            gbCode: "IRQ",
            ciqCode: "368"
        },
        {
            codeName: "冰岛",
            enName: "Iceland",
            cusCode: "322",
            codeValue: "ISL",
            gbName: "冰岛",
            gbCode: "ISL",
            ciqCode: "352"
        },
        {
            codeName: "以色列",
            enName: "Israel",
            cusCode: "115",
            codeValue: "ISR",
            gbName: "以色列",
            gbCode: "ISR",
            ciqCode: "376"
        },
        {
            codeName: "意大利",
            enName: "Italy",
            cusCode: "307",
            codeValue: "ITA",
            gbName: "意大利",
            gbCode: "ITA",
            ciqCode: "380"
        },
        {
            codeName: "牙买加",
            enName: "Jamaica",
            cusCode: "427",
            codeValue: "JAM",
            gbName: "牙买加",
            gbCode: "JAM",
            ciqCode: "388"
        },
        {
            codeName: "泽西",
            enName: "Jersey",
            cusCode: "363",
            codeValue: "JEY",
            gbName: "泽西",
            gbCode: "JEY",
            ciqCode: "832"
        },
        {
            codeName: "约旦",
            enName: "Jordan",
            cusCode: "117",
            codeValue: "JOR",
            gbName: "约旦",
            gbCode: "JOR",
            ciqCode: "400"
        },
        {
            codeName: "日本",
            enName: "Japan",
            cusCode: "116",
            codeValue: "JPN",
            gbName: "日本",
            gbCode: "JPN",
            ciqCode: "392"
        },
        {
            codeName: "哈萨克斯坦",
            enName: "Kazakhstan",
            cusCode: "145",
            codeValue: "KAZ",
            gbName: "哈萨克斯坦",
            gbCode: "KAZ",
            ciqCode: "398"
        },
        {
            codeName: "肯尼亚",
            enName: "Kenya",
            cusCode: "224",
            codeValue: "KEN",
            gbName: "肯尼亚",
            gbCode: "KEN",
            ciqCode: "404"
        },
        {
            codeName: "吉尔吉斯斯坦",
            enName: "Kyrgyzstan",
            cusCode: "146",
            codeValue: "KGZ",
            gbName: "吉尔吉斯斯坦",
            gbCode: "KGZ",
            ciqCode: "417"
        },
        {
            codeName: "柬埔寨",
            enName: "Cambodia",
            cusCode: "107",
            codeValue: "KHM",
            gbName: "柬埔寨",
            gbCode: "KHM",
            ciqCode: "116"
        },
        {
            codeName: "基里巴斯",
            enName: "Kiribati",
            cusCode: "618",
            codeValue: "KIR",
            gbName: "基里巴斯",
            gbCode: "KIR",
            ciqCode: "296"
        },
        {
            codeName: "圣基茨和尼维斯",
            enName: "Saint Kitts and Nevis",
            cusCode: "447",
            codeValue: "KNA",
            gbName: "圣基茨和尼维斯",
            gbCode: "KNA",
            ciqCode: "659"
        },
        {
            codeName: "韩国",
            enName: "Republic of Korea",
            cusCode: "133",
            codeValue: "KOR",
            gbName: "韩国",
            gbCode: "KOR",
            ciqCode: "410"
        },
        {
            codeName: "科威特",
            enName: "Kuwait",
            cusCode: "118",
            codeValue: "KWT",
            gbName: "科威特",
            gbCode: "KWT",
            ciqCode: "414"
        },
        {
            codeName: "老挝",
            enName: "Lao",
            cusCode: "119",
            codeValue: "LAO",
            gbName: "老挝",
            gbCode: "LAO",
            ciqCode: "418"
        },
        {
            codeName: "黎巴嫩",
            enName: "Lebanon",
            cusCode: "120",
            codeValue: "LBN",
            gbName: "黎巴嫩",
            gbCode: "LBN",
            ciqCode: "422"
        },
        {
            codeName: "利比里亚",
            enName: "Liberia",
            cusCode: "225",
            codeValue: "LBR",
            gbName: "利比里亚",
            gbCode: "LBR",
            ciqCode: "430"
        },
        {
            codeName: "利比亚",
            enName: "Libya",
            cusCode: "226",
            codeValue: "LBY",
            gbName: "利比亚",
            gbCode: "LBY",
            ciqCode: "434"
        },
        {
            codeName: "圣卢西亚",
            enName: "Saint Lucia",
            cusCode: "437",
            codeValue: "LCA",
            gbName: "圣卢西亚",
            gbCode: "LCA",
            ciqCode: "662"
        },
        {
            codeName: "列支敦士登",
            enName: "Liechtenstein",
            cusCode: "323",
            codeValue: "LIE",
            gbName: "列支敦士登",
            gbCode: "LIE",
            ciqCode: "438"
        },
        {
            codeName: "斯里兰卡",
            enName: "Sri Lanka",
            cusCode: "134",
            codeValue: "LKA",
            gbName: "斯里兰卡",
            gbCode: "LKA",
            ciqCode: "144"
        },
        {
            codeName: "莱索托",
            enName: "Lesotho",
            cusCode: "255",
            codeValue: "LSO",
            gbName: "莱索托",
            gbCode: "LSO",
            ciqCode: "426"
        },
        {
            codeName: "立陶宛",
            enName: "Lithuania",
            cusCode: "336",
            codeValue: "LTU",
            gbName: "立陶宛",
            gbCode: "LTU",
            ciqCode: "440"
        },
        {
            codeName: "卢森堡",
            enName: "Luxembourg",
            cusCode: "308",
            codeValue: "LUX",
            gbName: "卢森堡",
            gbCode: "LUX",
            ciqCode: "442"
        },
        {
            codeName: "拉脱维亚",
            enName: "Latvia",
            cusCode: "335",
            codeValue: "LVA",
            gbName: "拉脱维亚",
            gbCode: "LVA",
            ciqCode: "428"
        },
        {
            codeName: "中国澳门",
            enName: "Macao,China",
            cusCode: "121",
            codeValue: "MAC",
            gbName: "中国澳门",
            gbCode: "MAC",
            ciqCode: "446"
        },
        {
            codeName: "法属圣马丁",
            enName: "Saint Martin (French Part)",
            cusCode: "438",
            codeValue: "MAF",
            gbName: "法属圣马丁",
            gbCode: "MAF",
            ciqCode: "663"
        },
        {
            codeName: "马克萨斯群岛",
            enName: "Marquesas Islands",
            cusCode: "605",
            codeValue: "MAI",
            gbName: "马克萨斯群岛",
            gbCode: "MAI",
            ciqCode: "999"
        },
        {
            codeName: "摩洛哥",
            enName: "Morocco",
            cusCode: "232",
            codeValue: "MAR",
            gbName: "摩洛哥",
            gbCode: "MAR",
            ciqCode: "504"
        },
        {
            codeName: "摩纳哥",
            enName: "Monaco",
            cusCode: "325",
            codeValue: "MCO",
            gbName: "摩纳哥",
            gbCode: "MCO",
            ciqCode: "492"
        },
        {
            codeName: "摩尔多瓦",
            enName: "Moldova",
            cusCode: "343",
            codeValue: "MDA",
            gbName: "摩尔多瓦",
            gbCode: "MDA",
            ciqCode: "498"
        },
        {
            codeName: "马达加斯加",
            enName: "Madagascar",
            cusCode: "227",
            codeValue: "MDG",
            gbName: "马达加斯加",
            gbCode: "MDG",
            ciqCode: "450"
        },
        {
            codeName: "马尔代夫",
            enName: "Maldives",
            cusCode: "123",
            codeValue: "MDV",
            gbName: "马尔代夫",
            gbCode: "MDV",
            ciqCode: "462"
        },
        {
            codeName: "梅利利亚",
            enName: "Melilla",
            cusCode: "256",
            codeValue: "MEL",
            gbName: "梅利利亚",
            gbCode: "MEL",
            ciqCode: "482"
        },
        {
            codeName: "墨西哥",
            enName: "Mexico",
            cusCode: "429",
            codeValue: "MEX",
            gbName: "墨西哥",
            gbCode: "MEX",
            ciqCode: "484"
        },
        {
            codeName: "马绍尔群岛",
            enName: "Marshall Islands",
            cusCode: "621",
            codeValue: "MHL",
            gbName: "马绍尔群岛",
            gbCode: "MHL",
            ciqCode: "584"
        },
        {
            codeName: "北马其顿",
            enName: "North Macedonia",
            cusCode: "354",
            codeValue: "MKD",
            gbName: "北马其顿",
            gbCode: "MKD",
            ciqCode: "807"
        },
        {
            codeName: "马里",
            enName: "Mali",
            cusCode: "229",
            codeValue: "MLI",
            gbName: "马里",
            gbCode: "MLI",
            ciqCode: "466"
        },
        {
            codeName: "马耳他",
            enName: "Malta",
            cusCode: "324",
            codeValue: "MLT",
            gbName: "马耳他",
            gbCode: "MLT",
            ciqCode: "470"
        },
        {
            codeName: "缅甸",
            enName: "Myanmar",
            cusCode: "106",
            codeValue: "MMR",
            gbName: "缅甸",
            gbCode: "MMR",
            ciqCode: "104"
        },
        {
            codeName: "黑山",
            enName: "Montenegro",
            cusCode: "359",
            codeValue: "MNE",
            gbName: "黑山",
            gbCode: "MNE",
            ciqCode: "499"
        },
        {
            codeName: "蒙古",
            enName: "Mongolia",
            cusCode: "124",
            codeValue: "MNG",
            gbName: "蒙古",
            gbCode: "MNG",
            ciqCode: "496"
        },
        {
            codeName: "北马里亚纳群岛",
            enName: "Northern Mariana Islands",
            cusCode: "631",
            codeValue: "MNP",
            gbName: "北马里亚纳群岛",
            gbCode: "MNP",
            ciqCode: "580"
        },
        {
            codeName: "莫桑比克",
            enName: "Mozambique",
            cusCode: "233",
            codeValue: "MOZ",
            gbName: "莫桑比克",
            gbCode: "MOZ",
            ciqCode: "508"
        },
        {
            codeName: "毛里塔尼亚",
            enName: "Mauritania",
            cusCode: "230",
            codeValue: "MRT",
            gbName: "毛里塔尼亚",
            gbCode: "MRT",
            ciqCode: "478"
        },
        {
            codeName: "蒙特塞拉特",
            enName: "Montserrat",
            cusCode: "430",
            codeValue: "MSR",
            gbName: "蒙特塞拉特",
            gbCode: "MSR",
            ciqCode: "500"
        },
        {
            codeName: "马提尼克",
            enName: "Martinique",
            cusCode: "428",
            codeValue: "MTQ",
            gbName: "马提尼克",
            gbCode: "MTQ",
            ciqCode: "474"
        },
        {
            codeName: "毛里求斯",
            enName: "Mauritius",
            cusCode: "231",
            codeValue: "MUS",
            gbName: "毛里求斯",
            gbCode: "MUS",
            ciqCode: "480"
        },
        {
            codeName: "马拉维",
            enName: "Malawi",
            cusCode: "228",
            codeValue: "MWI",
            gbName: "马拉维",
            gbCode: "MWI",
            ciqCode: "454"
        },
        {
            codeName: "马来西亚",
            enName: "Malaysia",
            cusCode: "122",
            codeValue: "MYS",
            gbName: "马来西亚",
            gbCode: "MYS",
            ciqCode: "458"
        },
        {
            codeName: "马约特",
            enName: "Mayotte",
            cusCode: "259",
            codeValue: "MYT",
            gbName: "马约特",
            gbCode: "MYT",
            ciqCode: "175"
        },
        {
            codeName: "纳米比亚",
            enName: "Namibia",
            cusCode: "234",
            codeValue: "NAM",
            gbName: "纳米比亚",
            gbCode: "NAM",
            ciqCode: "516"
        },
        {
            codeName: "新喀里多尼亚",
            enName: "New Caledonia",
            cusCode: "607",
            codeValue: "NCL",
            gbName: "新喀里多尼亚",
            gbCode: "NCL",
            ciqCode: "540"
        },
        {
            codeName: "尼日尔",
            enName: "Niger",
            cusCode: "235",
            codeValue: "NER",
            gbName: "尼日尔",
            gbCode: "NER",
            ciqCode: "562"
        },
        {
            codeName: "诺福克岛",
            enName: "Norfolk Island",
            cusCode: "610",
            codeValue: "NFK",
            gbName: "诺福克岛",
            gbCode: "NFK",
            ciqCode: "574"
        },
        {
            codeName: "尼日利亚",
            enName: "Nigeria",
            cusCode: "236",
            codeValue: "NGA",
            gbName: "尼日利亚",
            gbCode: "NGA",
            ciqCode: "566"
        },
        {
            codeName: "尼加拉瓜",
            enName: "Nicaragua",
            cusCode: "431",
            codeValue: "NIC",
            gbName: "尼加拉瓜",
            gbCode: "NIC",
            ciqCode: "558"
        },
        {
            codeName: "纽埃",
            enName: "Niue",
            cusCode: "632",
            codeValue: "NIU",
            gbName: "纽埃",
            gbCode: "NIU",
            ciqCode: "570"
        },
        {
            codeName: "荷兰",
            enName: "Netherlands",
            cusCode: "309",
            codeValue: "NLD",
            gbName: "荷兰",
            gbCode: "NLD",
            ciqCode: "528"
        },
        {
            codeName: "挪威",
            enName: "Norway",
            cusCode: "326",
            codeValue: "NOR",
            gbName: "挪威",
            gbCode: "NOR",
            ciqCode: "578"
        },
        {
            codeName: "尼泊尔",
            enName: "Nepal",
            cusCode: "125",
            codeValue: "NPL",
            gbName: "尼泊尔",
            gbCode: "NPL",
            ciqCode: "524"
        },
        {
            codeName: "瑙鲁",
            enName: "Nauru",
            cusCode: "606",
            codeValue: "NRU",
            gbName: "瑙鲁",
            gbCode: "NRU",
            ciqCode: "520"
        },
        {
            codeName: "新西兰",
            enName: "New Zealand",
            cusCode: "609",
            codeValue: "NZL",
            gbName: "新西兰",
            gbCode: "NZL",
            ciqCode: "554"
        },
        {
            codeName: "阿曼",
            enName: "Oman",
            cusCode: "126",
            codeValue: "OMN",
            gbName: "阿曼",
            gbCode: "OMN",
            ciqCode: "512"
        },
        {
            codeName: "巴基斯坦",
            enName: "Pakistan",
            cusCode: "127",
            codeValue: "PAK",
            gbName: "巴基斯坦",
            gbCode: "PAK",
            ciqCode: "586"
        },
        {
            codeName: "巴拿马",
            enName: "Panama",
            cusCode: "432",
            codeValue: "PAN",
            gbName: "巴拿马",
            gbCode: "PAN",
            ciqCode: "591"
        },
        {
            codeName: "皮特凯恩",
            enName: "Pitcairn",
            cusCode: "633",
            codeValue: "PCN",
            gbName: "皮特凯恩",
            gbCode: "PCN",
            ciqCode: "612"
        },
        {
            codeName: "秘鲁",
            enName: "Peru",
            cusCode: "434",
            codeValue: "PER",
            gbName: "秘鲁",
            gbCode: "PER",
            ciqCode: "604"
        },
        {
            codeName: "菲律宾",
            enName: "Philippines",
            cusCode: "129",
            codeValue: "PHL",
            gbName: "菲律宾",
            gbCode: "PHL",
            ciqCode: "608"
        },
        {
            codeName: "帕劳",
            enName: "Palau",
            cusCode: "622",
            codeValue: "PLW",
            gbName: "帕劳",
            gbCode: "PLW",
            ciqCode: "585"
        },
        {
            codeName: "巴布亚新几内亚",
            enName: "Papua New Guinea",
            cusCode: "611",
            codeValue: "PNG",
            gbName: "巴布亚新几内亚",
            gbCode: "PNG",
            ciqCode: "598"
        },
        {
            codeName: "波兰",
            enName: "Poland",
            cusCode: "327",
            codeValue: "POL",
            gbName: "波兰",
            gbCode: "POL",
            ciqCode: "616"
        },
        {
            codeName: "波多黎各",
            enName: "Puerto Rico",
            cusCode: "435",
            codeValue: "PRI",
            gbName: "波多黎各",
            gbCode: "PRI",
            ciqCode: "630"
        },
        {
            codeName: "朝鲜",
            enName: "Democratic People's Republic of Korea",
            cusCode: "109",
            codeValue: "PRK",
            gbName: "朝鲜",
            gbCode: "PRK",
            ciqCode: "408"
        },
        {
            codeName: "葡萄牙",
            enName: "Portugal",
            cusCode: "311",
            codeValue: "PRT",
            gbName: "葡萄牙",
            gbCode: "PRT",
            ciqCode: "620"
        },
        {
            codeName: "巴拉圭",
            enName: "Paraguay",
            cusCode: "433",
            codeValue: "PRY",
            gbName: "巴拉圭",
            gbCode: "PRY",
            ciqCode: "600"
        },
        {
            codeName: "巴勒斯坦",
            enName: "Palestine",
            cusCode: "128",
            codeValue: "PSE",
            gbName: "巴勒斯坦",
            gbCode: "PSE",
            ciqCode: "275"
        },
        {
            codeName: "法属波利尼西亚",
            enName: "French Polynesia",
            cusCode: "623",
            codeValue: "PYF",
            gbName: "法属波利尼西亚",
            gbCode: "PYF",
            ciqCode: "258"
        },
        {
            codeName: "卡塔尔",
            enName: "Qatar",
            cusCode: "130",
            codeValue: "QAT",
            gbName: "卡塔尔",
            gbCode: "QAT",
            ciqCode: "634"
        },
        {
            codeName: "留尼汪",
            enName: "Réunion",
            cusCode: "237",
            codeValue: "REU",
            gbName: "留尼汪",
            gbCode: "REU",
            ciqCode: "638"
        },
        {
            codeName: "罗马尼亚",
            enName: "Romania",
            cusCode: "328",
            codeValue: "ROU",
            gbName: "罗马尼亚",
            gbCode: "ROU",
            ciqCode: "642"
        },
        {
            codeName: "俄罗斯",
            enName: "Russia",
            cusCode: "344",
            codeValue: "RUS",
            gbName: "俄罗斯",
            gbCode: "RUS",
            ciqCode: "643"
        },
        {
            codeName: "卢旺达",
            enName: "Rwanda",
            cusCode: "238",
            codeValue: "RWA",
            gbName: "卢旺达",
            gbCode: "RWA",
            ciqCode: "646"
        },
        {
            codeName: "沙特阿拉伯",
            enName: "Saudi Arabia",
            cusCode: "131",
            codeValue: "SAU",
            gbName: "沙特阿拉伯",
            gbCode: "SAU",
            ciqCode: "682"
        },
        {
            codeName: "苏丹",
            enName: "Sudan",
            cusCode: "246",
            codeValue: "SDN",
            gbName: "苏丹",
            gbCode: "SDN",
            ciqCode: "729"
        },
        {
            codeName: "塞内加尔",
            enName: "Senegal",
            cusCode: "240",
            codeValue: "SEN",
            gbName: "塞内加尔",
            gbCode: "SEN",
            ciqCode: "686"
        },
        {
            codeName: "新加坡",
            enName: "Singapore",
            cusCode: "132",
            codeValue: "SGP",
            gbName: "新加坡",
            gbCode: "SGP",
            ciqCode: "702"
        },
        {
            codeName: "南乔治亚岛和南桑德韦奇岛",
            enName: "South Georgia and the South Sandwich Islands",
            cusCode: "453",
            codeValue: "SGS",
            gbName: "南乔治亚岛和南桑德韦奇岛",
            gbCode: "SGS",
            ciqCode: "239"
        },
        {
            codeName: "圣赫勒拿",
            enName: "Saint Helena",
            cusCode: "263",
            codeValue: "SHN",
            gbName: "圣赫勒拿",
            gbCode: "SHN",
            ciqCode: "654"
        },
        {
            codeName: "斯瓦尔巴群岛和扬马延岛",
            enName: "Svalbard and Jan Mayen Islands",
            cusCode: "364",
            codeValue: "SJM",
            gbName: "斯瓦尔巴群岛和扬马延岛",
            gbCode: "SJM",
            ciqCode: "744"
        },
        {
            codeName: "所罗门群岛",
            enName: "Solomon Islands",
            cusCode: "613",
            codeValue: "SLB",
            gbName: "所罗门群岛",
            gbCode: "SLB",
            ciqCode: "090"
        },
        {
            codeName: "塞拉利昂",
            enName: "Sierra Leone",
            cusCode: "242",
            codeValue: "SLE",
            gbName: "塞拉利昂",
            gbCode: "SLE",
            ciqCode: "694"
        },
        {
            codeName: "萨尔瓦多",
            enName: "El Salvador",
            cusCode: "440",
            codeValue: "SLV",
            gbName: "萨尔瓦多",
            gbCode: "SLV",
            ciqCode: "222"
        },
        {
            codeName: "圣马力诺",
            enName: "San Marino",
            cusCode: "329",
            codeValue: "SMR",
            gbName: "圣马力诺",
            gbCode: "SMR",
            ciqCode: "674"
        },
        {
            codeName: "社会群岛",
            enName: "Society Islands",
            cusCode: "612",
            codeValue: "SOC",
            gbName: "社会群岛",
            gbCode: "SOC",
            ciqCode: "999"
        },
        {
            codeName: "索马里",
            enName: "Somalia",
            cusCode: "243",
            codeValue: "SOM",
            gbName: "索马里",
            gbCode: "SOM",
            ciqCode: "706"
        },
        {
            codeName: "圣皮埃尔和密克隆",
            enName: "Saint Pierre and Miquelon",
            cusCode: "505",
            codeValue: "SPM",
            gbName: "圣皮埃尔和密克隆",
            gbCode: "SPM",
            ciqCode: "666"
        },
        {
            codeName: "塞尔维亚",
            enName: "Serbia",
            cusCode: "358",
            codeValue: "SRB",
            gbName: "塞尔维亚",
            gbCode: "SRB",
            ciqCode: "688"
        },
        {
            codeName: "南苏丹",
            enName: "South Sudan",
            cusCode: "260",
            codeValue: "SSD",
            gbName: "南苏丹",
            gbCode: "SSD",
            ciqCode: "728"
        },
        {
            codeName: "圣多美和普林西比",
            enName: "Sao Tome and Principe",
            cusCode: "239",
            codeValue: "STP",
            gbName: "圣多美和普林西比",
            gbCode: "STP",
            ciqCode: "678"
        },
        {
            codeName: "苏里南",
            enName: "Suriname",
            cusCode: "441",
            codeValue: "SUR",
            gbName: "苏里南",
            gbCode: "SUR",
            ciqCode: "740"
        },
        {
            codeName: "斯洛伐克",
            enName: "Slovakia",
            cusCode: "353",
            codeValue: "SVK",
            gbName: "斯洛伐克",
            gbCode: "SVK",
            ciqCode: "703"
        },
        {
            codeName: "斯洛文尼亚",
            enName: "Slovenia",
            cusCode: "350",
            codeValue: "SVN",
            gbName: "斯洛文尼亚",
            gbCode: "SVN",
            ciqCode: "705"
        },
        {
            codeName: "瑞典",
            enName: "Sweden",
            cusCode: "330",
            codeValue: "SWE",
            gbName: "瑞典",
            gbCode: "SWE",
            ciqCode: "752"
        },
        {
            codeName: "斯威士兰",
            enName: "Eswatini（Swaziland）",
            cusCode: "257",
            codeValue: "SWZ",
            gbName: "斯威士兰",
            gbCode: "SWZ",
            ciqCode: "748"
        },
        {
            codeName: "荷属圣马丁",
            enName: "Sint Maarten (Dutch part)",
            cusCode: "454",
            codeValue: "SXM",
            gbName: "荷属圣马丁",
            gbCode: "SXM",
            ciqCode: "534"
        },
        {
            codeName: "塞舌尔",
            enName: "Seychelles",
            cusCode: "241",
            codeValue: "SYC",
            gbName: "塞舌尔",
            gbCode: "SYC",
            ciqCode: "690"
        },
        {
            codeName: "叙利亚",
            enName: "Syria",
            cusCode: "135",
            codeValue: "SYR",
            gbName: "叙利亚",
            gbCode: "SYR",
            ciqCode: "760"
        },
        {
            codeName: "特克斯和凯科斯群岛",
            enName: "Turks and Caicos Islands",
            cusCode: "443",
            codeValue: "TCA",
            gbName: "特克斯和凯科斯群岛",
            gbCode: "TCA",
            ciqCode: "796"
        },
        {
            codeName: "乍得",
            enName: "Chad",
            cusCode: "211",
            codeValue: "TCD",
            gbName: "乍得",
            gbCode: "TCD",
            ciqCode: "148"
        },
        {
            codeName: "多哥",
            enName: "Togo",
            cusCode: "248",
            codeValue: "TGO",
            gbName: "多哥",
            gbCode: "TGO",
            ciqCode: "768"
        },
        {
            codeName: "泰国",
            enName: "Thailand",
            cusCode: "136",
            codeValue: "THA",
            gbName: "泰国",
            gbCode: "THA",
            ciqCode: "764"
        },
        {
            codeName: "塔吉克斯坦",
            enName: "Tajikistan",
            cusCode: "147",
            codeValue: "TJK",
            gbName: "塔吉克斯坦",
            gbCode: "TJK",
            ciqCode: "762"
        },
        {
            codeName: "托克劳",
            enName: "Tokelau",
            cusCode: "634",
            codeValue: "TKL",
            gbName: "托克劳",
            gbCode: "TKL",
            ciqCode: "772"
        },
        {
            codeName: "土库曼斯坦",
            enName: "Turkmenistan",
            cusCode: "148",
            codeValue: "TKM",
            gbName: "土库曼斯坦",
            gbCode: "TKM",
            ciqCode: "795"
        },
        {
            codeName: "东帝汶",
            enName: "Timor-Leste",
            cusCode: "144",
            codeValue: "TLS",
            gbName: "东帝汶",
            gbCode: "TLS",
            ciqCode: "626"
        },
        {
            codeName: "汤加",
            enName: "Tonga",
            cusCode: "614",
            codeValue: "TON",
            gbName: "汤加",
            gbCode: "TON",
            ciqCode: "776"
        },
        {
            codeName: "特立尼达和多巴哥",
            enName: "Trinidad and Tobago",
            cusCode: "442",
            codeValue: "TTO",
            gbName: "特立尼达和多巴哥",
            gbCode: "TTO",
            ciqCode: "780"
        },
        {
            codeName: "土阿莫土群岛",
            enName: "Tuamotu Islands ",
            cusCode: "615",
            codeValue: "TUA",
            gbName: "土阿莫土群岛",
            gbCode: "TUA",
            ciqCode: "999"
        },
        {
            codeName: "土布艾群岛",
            enName: "Tubai Islands",
            cusCode: "616",
            codeValue: "TUB",
            gbName: "土布艾群岛",
            gbCode: "TUB",
            ciqCode: "999"
        },
        {
            codeName: "突尼斯",
            enName: "Tunisia",
            cusCode: "249",
            codeValue: "TUN",
            gbName: "突尼斯",
            gbCode: "TUN",
            ciqCode: "788"
        },
        {
            codeName: "土耳其",
            enName: "Türkiye",
            cusCode: "137",
            codeValue: "TUR",
            gbName: "土耳其",
            gbCode: "TUR",
            ciqCode: "792"
        },
        {
            codeName: "图瓦卢",
            enName: "Tuvalu",
            cusCode: "619",
            codeValue: "TUV",
            gbName: "图瓦卢",
            gbCode: "TUV",
            ciqCode: "798"
        },
        {
            codeName: "中国台湾",
            enName: "Taiwan, China",
            cusCode: "143",
            codeValue: "TWN",
            gbName: "中国台湾",
            gbCode: "TWN",
            ciqCode: "158"
        },
        {
            codeName: "坦桑尼亚",
            enName: "Tanzania",
            cusCode: "247",
            codeValue: "TZA",
            gbName: "坦桑尼亚",
            gbCode: "TZA",
            ciqCode: "834"
        },
        {
            codeName: "乌干达",
            enName: "Uganda",
            cusCode: "250",
            codeValue: "UGA",
            gbName: "乌干达",
            gbCode: "UGA",
            ciqCode: "800"
        },
        {
            codeName: "乌克兰",
            enName: "Ukraine",
            cusCode: "347",
            codeValue: "UKR",
            gbName: "乌克兰",
            gbCode: "UKR",
            ciqCode: "804"
        },
        {
            codeName: "美国本土外小岛屿",
            enName: "United States Minor Outlying Islands",
            cusCode: "635",
            codeValue: "UMI",
            gbName: "美国本土外小岛屿",
            gbCode: "UMI",
            ciqCode: "581"
        },
        {
            codeName: "乌拉圭",
            enName: "Uruguay",
            cusCode: "444",
            codeValue: "URY",
            gbName: "乌拉圭",
            gbCode: "URY",
            ciqCode: "858"
        },
        {
            codeName: "美国",
            enName: "United States",
            cusCode: "502",
            codeValue: "USA",
            gbName: "美国",
            gbCode: "USA",
            ciqCode: "840"
        },
        {
            codeName: "乌兹别克斯坦",
            enName: "Uzbekistan",
            cusCode: "149",
            codeValue: "UZB",
            gbName: "乌兹别克斯坦",
            gbCode: "UZB",
            ciqCode: "860"
        },
        {
            codeName: "梵蒂冈",
            enName: "Holy See",
            cusCode: "356",
            codeValue: "VAT",
            gbName: "梵蒂冈",
            gbCode: "VAT",
            ciqCode: "336"
        },
        {
            codeName: "圣文森特和格林纳丁斯",
            enName: "Saint Vincent and the Grenadines",
            cusCode: "439",
            codeValue: "VCT",
            gbName: "圣文森特和格林纳丁斯",
            gbCode: "VCT",
            ciqCode: "670"
        },
        {
            codeName: "委内瑞拉",
            enName: "Venezuela",
            cusCode: "445",
            codeValue: "VEN",
            gbName: "委内瑞拉",
            gbCode: "VEN",
            ciqCode: "862"
        },
        {
            codeName: "英属维尔京群岛",
            enName: "British Virgin Islands",
            cusCode: "446",
            codeValue: "VGB",
            gbName: "英属维尔京群岛",
            gbCode: "VGB",
            ciqCode: "092"
        },
        {
            codeName: "美属维尔京群岛",
            enName: "United States Virgin Islands",
            cusCode: "455",
            codeValue: "VIR",
            gbName: "美属维尔京群岛",
            gbCode: "VIR",
            ciqCode: "850"
        },
        {
            codeName: "越南",
            enName: "Viet Nam",
            cusCode: "141",
            codeValue: "VNM",
            gbName: "越南",
            gbCode: "VNM",
            ciqCode: "704"
        },
        {
            codeName: "瓦努阿图",
            enName: "Vanuatu",
            cusCode: "608",
            codeValue: "VUT",
            gbName: "瓦努阿图",
            gbCode: "VUT",
            ciqCode: "548"
        },
        {
            codeName: "瓦利斯和富图纳",
            enName: "Wallis and Futuna",
            cusCode: "625",
            codeValue: "WLF",
            gbName: "瓦利斯和富图纳",
            gbCode: "WLF",
            ciqCode: "876"
        },
        {
            codeName: "萨摩亚",
            enName: "Samoa",
            cusCode: "617",
            codeValue: "WSM",
            gbName: "萨摩亚",
            gbCode: "WSM",
            ciqCode: "882"
        },
        {
            codeName: "也门",
            enName: "Yemen",
            cusCode: "139",
            codeValue: "YEM",
            gbName: "也门",
            gbCode: "YEM",
            ciqCode: "887"
        },
        {
            codeName: "南非",
            enName: "South Africa",
            cusCode: "244",
            codeValue: "ZAF",
            gbName: "南非",
            gbCode: "ZAF",
            ciqCode: "710"
        },
        {
            codeName: "非洲其他国家(地区)",
            enName: "Other African Territories",
            cusCode: "299",
            codeValue: "ZAO",
            gbName: "非洲其他国家(地区)",
            gbCode: "ZAO",
            ciqCode: "906"
        },
        {
            codeName: "亚洲其他国家(地区)",
            enName: "Other Asian Territories",
            cusCode: "199",
            codeValue: "ZAS",
            gbName: "亚洲其他国家(地区)",
            gbCode: "ZAS",
            ciqCode: "903"
        },
        {
            codeName: "欧洲其他国家(地区)",
            enName: "Other European Territories",
            cusCode: "399",
            codeValue: "ZEU",
            gbName: "欧洲其他国家(地区)",
            gbCode: "ZEU",
            ciqCode: "909"
        },
        {
            codeName: "赞比亚",
            enName: "Zambia",
            cusCode: "253",
            codeValue: "ZMB",
            gbName: "赞比亚",
            gbCode: "ZMB",
            ciqCode: "894"
        },
        {
            codeName: "北美洲其他国家(地区)",
            enName: "Other North American Territories",
            cusCode: "599",
            codeValue: "ZNA",
            gbName: "北美洲其他国家(地区)",
            gbCode: "ZNA",
            ciqCode: "915"
        },
        {
            codeName: "大洋洲其他国家(地区)",
            enName: "Other Oceanian Territories",
            cusCode: "699",
            codeValue: "ZOC",
            gbName: "大洋洲其他国家(地区)",
            gbCode: "ZOC",
            ciqCode: "918"
        },
        {
            codeName: "拉丁美洲其他国家(地区)",
            enName: "Other Latin American Territories",
            cusCode: "499",
            codeValue: "ZSA",
            gbName: "拉丁美洲其他国家(地区)",
            gbCode: "ZSA",
            ciqCode: "912"
        },
        {
            codeName: "联合国及机构和国际组织",
            enName: "UN and oth.int'l org",
            cusCode: "702",
            codeValue: "ZUN",
            gbName: "联合国及机构和国际组织",
            gbCode: "ZUN",
            ciqCode: "998"
        },
        {
            codeName: "津巴布韦",
            enName: "Zimbabwe",
            cusCode: "254",
            codeValue: "ZWE",
            gbName: "津巴布韦",
            gbCode: "ZWE",
            ciqCode: "716"
        },
        {
            codeName: "国家（地区）不明",
            enName: "Countries（Territories）Unknown",
            cusCode: "701",
            codeValue: "ZZZ",
            gbName: "国家（地区）不明",
            gbCode: "ZZZ",
            ciqCode: "999"
        }
    ],
    // 港口信息，经停港
    CUS_MAPPING_PORT_CODE_V: [
        {
            codeName: "北京天竺综合保税区",
            cusCode: "142",
            codeValue: "991101",
            gbName: "北京天竺综合保税区",
            gbCode: "991101",
            ciqCode: "991101"
        },
        {
            codeName: "天津出口加工区",
            cusCode: "142",
            codeValue: "991201",
            gbName: "天津出口加工区",
            gbCode: "991201",
            ciqCode: "991201"
        },
        {
            codeName: "天津保税物流园区",
            cusCode: "142",
            codeValue: "991202",
            gbName: "天津保税物流园区",
            gbCode: "991202",
            ciqCode: "991202"
        },
        {
            codeName: "天津港保税区",
            cusCode: "142",
            codeValue: "991203",
            gbName: "天津港保税区",
            gbCode: "991203",
            ciqCode: "991203"
        },
        {
            codeName: "天津东疆保税港区",
            cusCode: "142",
            codeValue: "991204",
            gbName: "天津东疆保税港区",
            gbCode: "991204",
            ciqCode: "991204"
        },
        {
            codeName: "天津滨海新区综合保税区",
            cusCode: "142",
            codeValue: "991205",
            gbName: "天津滨海新区综合保税区",
            gbCode: "991205",
            ciqCode: "991205"
        },
        {
            codeName: "中国（天津）自由贸易试验区",
            cusCode: "142",
            codeValue: "991206",
            gbName: "中国（天津）自由贸易试验区",
            gbCode: "991206",
            ciqCode: "991206"
        },
        {
            codeName: "石家庄综合保税区",
            cusCode: "142",
            codeValue: "991301",
            gbName: "石家庄综合保税区",
            gbCode: "991301",
            ciqCode: "991301"
        },
        {
            codeName: "曹妃甸综合保税区",
            cusCode: "142",
            codeValue: "991302",
            gbName: "曹妃甸综合保税区",
            gbCode: "991302",
            ciqCode: "991302"
        },
        {
            codeName: "秦皇岛出口加工区",
            cusCode: "142",
            codeValue: "991303",
            gbName: "秦皇岛出口加工区",
            gbCode: "991303",
            ciqCode: "991303"
        },
        {
            codeName: "廊坊出口加工区",
            cusCode: "142",
            codeValue: "991304",
            gbName: "廊坊出口加工区",
            gbCode: "991304",
            ciqCode: "991304"
        },
        {
            codeName: "太原武宿综合保税区",
            cusCode: "142",
            codeValue: "991401",
            gbName: "太原武宿综合保税区",
            gbCode: "991401",
            ciqCode: "991401"
        },
        {
            codeName: "呼和浩特出口加工区",
            cusCode: "142",
            codeValue: "991501",
            gbName: "呼和浩特出口加工区",
            gbCode: "991501",
            ciqCode: "991501"
        },
        {
            codeName: "满洲里综合保税区",
            cusCode: "142",
            codeValue: "991502",
            gbName: "满洲里综合保税区",
            gbCode: "991502",
            ciqCode: "991502"
        },
        {
            codeName: "沈阳综合保税区",
            cusCode: "142",
            codeValue: "992101",
            gbName: "沈阳综合保税区",
            gbCode: "992101",
            ciqCode: "992101"
        },
        {
            codeName: "大连保税区",
            cusCode: "142",
            codeValue: "992102",
            gbName: "大连保税区",
            gbCode: "992102",
            ciqCode: "992102"
        },
        {
            codeName: "大连出口加工区",
            cusCode: "142",
            codeValue: "992103",
            gbName: "大连出口加工区",
            gbCode: "992103",
            ciqCode: "992103"
        },
        {
            codeName: "大连大窑湾保税港区",
            cusCode: "142",
            codeValue: "992104",
            gbName: "大连大窑湾保税港区",
            gbCode: "992104",
            ciqCode: "992104"
        },
        {
            codeName: "营口港保税物流园区",
            cusCode: "142",
            codeValue: "992105",
            gbName: "营口港保税物流园区",
            gbCode: "992105",
            ciqCode: "992105"
        },
        {
            codeName: "长春兴隆综合保税区",
            cusCode: "142",
            codeValue: "992201",
            gbName: "长春兴隆综合保税区",
            gbCode: "992201",
            ciqCode: "992201"
        },
        {
            codeName: "珲春出口加工区",
            cusCode: "142",
            codeValue: "992202",
            gbName: "珲春出口加工区",
            gbCode: "992202",
            ciqCode: "992202"
        },
        {
            codeName: "绥芬河综合保税区",
            cusCode: "142",
            codeValue: "992301",
            gbName: "绥芬河综合保税区",
            gbCode: "992301",
            ciqCode: "992301"
        },
        {
            codeName: "上海漕河泾出口加工区",
            cusCode: "142",
            codeValue: "993101",
            gbName: "上海漕河泾出口加工区",
            gbCode: "993101",
            ciqCode: "993101"
        },
        {
            codeName: "上海闵行出口加工区",
            cusCode: "142",
            codeValue: "993102",
            gbName: "上海闵行出口加工区",
            gbCode: "993102",
            ciqCode: "993102"
        },
        {
            codeName: "上海嘉定出口加工区",
            cusCode: "142",
            codeValue: "993103",
            gbName: "上海嘉定出口加工区",
            gbCode: "993103",
            ciqCode: "993103"
        },
        {
            codeName: "上海金桥出口加工区",
            cusCode: "142",
            codeValue: "993104",
            gbName: "上海金桥出口加工区",
            gbCode: "993104",
            ciqCode: "993104"
        },
        {
            codeName: "上海浦东机场综合保税区",
            cusCode: "142",
            codeValue: "993105",
            gbName: "上海浦东机场综合保税区",
            gbCode: "993105",
            ciqCode: "993105"
        },
        {
            codeName: "上海外高桥保税物流园区",
            cusCode: "142",
            codeValue: "993106",
            gbName: "上海外高桥保税物流园区",
            gbCode: "993106",
            ciqCode: "993106"
        },
        {
            codeName: "上海外高桥保税区",
            cusCode: "142",
            codeValue: "993107",
            gbName: "上海外高桥保税区",
            gbCode: "993107",
            ciqCode: "993107"
        },
        {
            codeName: "上海松江出口加工区A区",
            cusCode: "142",
            codeValue: "993108",
            gbName: "上海松江出口加工区A区",
            gbCode: "993108",
            ciqCode: "993108"
        },
        {
            codeName: "上海松江出口加工区B区",
            cusCode: "142",
            codeValue: "993109",
            gbName: "上海松江出口加工区B区",
            gbCode: "993109",
            ciqCode: "993109"
        },
        {
            codeName: "上海青浦出口加工区",
            cusCode: "142",
            codeValue: "993110",
            gbName: "上海青浦出口加工区",
            gbCode: "993110",
            ciqCode: "993110"
        },
        {
            codeName: "洋山保税港区",
            cusCode: "142",
            codeValue: "993111",
            gbName: "洋山保税港区",
            gbCode: "993111",
            ciqCode: "993111"
        },
        {
            codeName: "中国（上海）自由贸易试验区",
            cusCode: "142",
            codeValue: "993112",
            gbName: "中国（上海）自由贸易试验区",
            gbCode: "993112",
            ciqCode: "993112"
        },
        {
            codeName: "南京出口加工区",
            cusCode: "142",
            codeValue: "993201",
            gbName: "南京出口加工区",
            gbCode: "993201",
            ciqCode: "993201"
        },
        {
            codeName: "南京综合保税区",
            cusCode: "142",
            codeValue: "993202",
            gbName: "南京综合保税区",
            gbCode: "993202",
            ciqCode: "993202"
        },
        {
            codeName: "无锡高新区综合保税区",
            cusCode: "142",
            codeValue: "993203",
            gbName: "无锡高新区综合保税区",
            gbCode: "993203",
            ciqCode: "993203"
        },
        {
            codeName: "无锡出口加工区",
            cusCode: "142",
            codeValue: "993204",
            gbName: "无锡出口加工区",
            gbCode: "993204",
            ciqCode: "993204"
        },
        {
            codeName: "常州出口加工区",
            cusCode: "142",
            codeValue: "993205",
            gbName: "常州出口加工区",
            gbCode: "993205",
            ciqCode: "993205"
        },
        {
            codeName: "武进出口加工区",
            cusCode: "142",
            codeValue: "993206",
            gbName: "武进出口加工区",
            gbCode: "993206",
            ciqCode: "993206"
        },
        {
            codeName: "苏州工业园综合保税区",
            cusCode: "142",
            codeValue: "993207",
            gbName: "苏州工业园综合保税区",
            gbCode: "993207",
            ciqCode: "993207"
        },
        {
            codeName: "苏州高新技术产业开发区综合保税区",
            cusCode: "142",
            codeValue: "993208",
            gbName: "苏州高新技术产业开发区综合保税区",
            gbCode: "993208",
            ciqCode: "993208"
        },
        {
            codeName: "太仓港综合保税区",
            cusCode: "142",
            codeValue: "993209",
            gbName: "太仓港综合保税区",
            gbCode: "993209",
            ciqCode: "993209"
        },
        {
            codeName: "吴中出口加工区",
            cusCode: "142",
            codeValue: "993210",
            gbName: "吴中出口加工区",
            gbCode: "993210",
            ciqCode: "993210"
        },
        {
            codeName: "常熟出口加工区",
            cusCode: "142",
            codeValue: "993211",
            gbName: "常熟出口加工区",
            gbCode: "993211",
            ciqCode: "993211"
        },
        {
            codeName: "张家港保税港区",
            cusCode: "142",
            codeValue: "993212",
            gbName: "张家港保税港区",
            gbCode: "993212",
            ciqCode: "993212"
        },
        {
            codeName: "昆山综合保税区",
            cusCode: "142",
            codeValue: "993213",
            gbName: "昆山综合保税区",
            gbCode: "993213",
            ciqCode: "993213"
        },
        {
            codeName: "吴江出口加工区",
            cusCode: "142",
            codeValue: "993214",
            gbName: "吴江出口加工区",
            gbCode: "993214",
            ciqCode: "993214"
        },
        {
            codeName: "南通综合保税区",
            cusCode: "142",
            codeValue: "993215",
            gbName: "南通综合保税区",
            gbCode: "993215",
            ciqCode: "993215"
        },
        {
            codeName: "南通出口加工区",
            cusCode: "142",
            codeValue: "993216",
            gbName: "南通出口加工区",
            gbCode: "993216",
            ciqCode: "993216"
        },
        {
            codeName: "连云港出口加工区",
            cusCode: "142",
            codeValue: "993217",
            gbName: "连云港出口加工区",
            gbCode: "993217",
            ciqCode: "993217"
        },
        {
            codeName: "淮安综合保税区",
            cusCode: "142",
            codeValue: "993218",
            gbName: "淮安综合保税区",
            gbCode: "993218",
            ciqCode: "993218"
        },
        {
            codeName: "淮安出口加工区",
            cusCode: "142",
            codeValue: "993219",
            gbName: "淮安出口加工区",
            gbCode: "993219",
            ciqCode: "993219"
        },
        {
            codeName: "盐城综合保税区",
            cusCode: "142",
            codeValue: "993220",
            gbName: "盐城综合保税区",
            gbCode: "993220",
            ciqCode: "993220"
        },
        {
            codeName: "扬州出口加工区",
            cusCode: "142",
            codeValue: "993221",
            gbName: "扬州出口加工区",
            gbCode: "993221",
            ciqCode: "993221"
        },
        {
            codeName: "镇江出口加工区",
            cusCode: "142",
            codeValue: "993222",
            gbName: "镇江出口加工区",
            gbCode: "993222",
            ciqCode: "993222"
        },
        {
            codeName: "泰州出口加工区",
            cusCode: "142",
            codeValue: "993223",
            gbName: "泰州出口加工区",
            gbCode: "993223",
            ciqCode: "993223"
        },
        {
            codeName: "杭州出口加工区",
            cusCode: "142",
            codeValue: "993301",
            gbName: "杭州出口加工区",
            gbCode: "993301",
            ciqCode: "993301"
        },
        {
            codeName: "杭州保税物流园区（B型）",
            cusCode: "142",
            codeValue: "993302",
            gbName: "杭州保税物流园区（B型）",
            gbCode: "993302",
            ciqCode: "993302"
        },
        {
            codeName: "杭州中和保税区",
            cusCode: "142",
            codeValue: "993303",
            gbName: "杭州中和保税区",
            gbCode: "993303",
            ciqCode: "993303"
        },
        {
            codeName: "舟山港综合保税区",
            cusCode: "142",
            codeValue: "993304",
            gbName: "舟山港综合保税区",
            gbCode: "993304",
            ciqCode: "993304"
        },
        {
            codeName: "嘉兴出口加工区A区",
            cusCode: "142",
            codeValue: "993305",
            gbName: "嘉兴出口加工区A区",
            gbCode: "993305",
            ciqCode: "993305"
        },
        {
            codeName: "嘉兴出口加工区B区",
            cusCode: "142",
            codeValue: "993306",
            gbName: "嘉兴出口加工区B区",
            gbCode: "993306",
            ciqCode: "993306"
        },
        {
            codeName: "金义综合保税区",
            cusCode: "142",
            codeValue: "993307",
            gbName: "金义综合保税区",
            gbCode: "993307",
            ciqCode: "993307"
        },
        {
            codeName: "合肥出口加工区",
            cusCode: "142",
            codeValue: "993401",
            gbName: "合肥出口加工区",
            gbCode: "993401",
            ciqCode: "993401"
        },
        {
            codeName: "合肥综合保税区",
            cusCode: "142",
            codeValue: "993402",
            gbName: "合肥综合保税区",
            gbCode: "993402",
            ciqCode: "993402"
        },
        {
            codeName: "芜湖出口加工区",
            cusCode: "142",
            codeValue: "993403",
            gbName: "芜湖出口加工区",
            gbCode: "993403",
            ciqCode: "993403"
        },
        {
            codeName: "福州保税港区",
            cusCode: "142",
            codeValue: "993501",
            gbName: "福州保税港区",
            gbCode: "993501",
            ciqCode: "993501"
        },
        {
            codeName: "福州保税区",
            cusCode: "142",
            codeValue: "993502",
            gbName: "福州保税区",
            gbCode: "993502",
            ciqCode: "993502"
        },
        {
            codeName: "福州出口加工区",
            cusCode: "142",
            codeValue: "993503",
            gbName: "福州出口加工区",
            gbCode: "993503",
            ciqCode: "993503"
        },
        {
            codeName: "贵安综合保税区",
            cusCode: "142",
            codeValue: "993504",
            gbName: "贵安综合保税区",
            gbCode: "993504",
            ciqCode: "993504"
        },
        {
            codeName: "泉州出口加工区",
            cusCode: "142",
            codeValue: "993505",
            gbName: "泉州出口加工区",
            gbCode: "993505",
            ciqCode: "993505"
        },
        {
            codeName: "中国（福建）自由贸易试验区",
            cusCode: "142",
            codeValue: "993506",
            gbName: "中国（福建）自由贸易试验区",
            gbCode: "993506",
            ciqCode: "993506"
        },
        {
            codeName: "南昌出口加工区",
            cusCode: "142",
            codeValue: "993601",
            gbName: "南昌出口加工区",
            gbCode: "993601",
            ciqCode: "993601"
        },
        {
            codeName: "九江出口加工区",
            cusCode: "142",
            codeValue: "993602",
            gbName: "九江出口加工区",
            gbCode: "993602",
            ciqCode: "993602"
        },
        {
            codeName: "赣州出口加工区",
            cusCode: "142",
            codeValue: "993603",
            gbName: "赣州出口加工区",
            gbCode: "993603",
            ciqCode: "993603"
        },
        {
            codeName: "赣州综合保税区",
            cusCode: "142",
            codeValue: "993604",
            gbName: "赣州综合保税区",
            gbCode: "993604",
            ciqCode: "993604"
        },
        {
            codeName: "井冈山出口加工区",
            cusCode: "142",
            codeValue: "993605",
            gbName: "井冈山出口加工区",
            gbCode: "993605",
            ciqCode: "993605"
        },
        {
            codeName: "济南综合保税区",
            cusCode: "142",
            codeValue: "993701",
            gbName: "济南综合保税区",
            gbCode: "993701",
            ciqCode: "993701"
        },
        {
            codeName: "济南出口加工区",
            cusCode: "142",
            codeValue: "993702",
            gbName: "济南出口加工区",
            gbCode: "993702",
            ciqCode: "993702"
        },
        {
            codeName: "青岛出口加工区",
            cusCode: "142",
            codeValue: "993703",
            gbName: "青岛出口加工区",
            gbCode: "993703",
            ciqCode: "993703"
        },
        {
            codeName: "青岛前湾保税港区",
            cusCode: "142",
            codeValue: "993704",
            gbName: "青岛前湾保税港区",
            gbCode: "993704",
            ciqCode: "993704"
        },
        {
            codeName: "青岛西海岸出口加工区",
            cusCode: "142",
            codeValue: "993705",
            gbName: "青岛西海岸出口加工区",
            gbCode: "993705",
            ciqCode: "993705"
        },
        {
            codeName: "东营综合保税区",
            cusCode: "142",
            codeValue: "993706",
            gbName: "东营综合保税区",
            gbCode: "993706",
            ciqCode: "993706"
        },
        {
            codeName: "烟台保税港区A区",
            cusCode: "142",
            codeValue: "993707",
            gbName: "烟台保税港区A区",
            gbCode: "993707",
            ciqCode: "993707"
        },
        {
            codeName: "烟台保税港区B区",
            cusCode: "142",
            codeValue: "993708",
            gbName: "烟台保税港区B区",
            gbCode: "993708",
            ciqCode: "993708"
        },
        {
            codeName: "潍坊综合保税区",
            cusCode: "142",
            codeValue: "993709",
            gbName: "潍坊综合保税区",
            gbCode: "993709",
            ciqCode: "993709"
        },
        {
            codeName: "威海出口加工区",
            cusCode: "142",
            codeValue: "993710",
            gbName: "威海出口加工区",
            gbCode: "993710",
            ciqCode: "993710"
        },
        {
            codeName: "临沂综合保税区",
            cusCode: "142",
            codeValue: "993711",
            gbName: "临沂综合保税区",
            gbCode: "993711",
            ciqCode: "993711"
        },
        {
            codeName: "宁波出口加工区",
            cusCode: "142",
            codeValue: "993801",
            gbName: "宁波出口加工区",
            gbCode: "993801",
            ciqCode: "993801"
        },
        {
            codeName: "宁波保税区",
            cusCode: "142",
            codeValue: "993802",
            gbName: "宁波保税区",
            gbCode: "993802",
            ciqCode: "993802"
        },
        {
            codeName: "宁波梅山保税港区",
            cusCode: "142",
            codeValue: "993803",
            gbName: "宁波梅山保税港区",
            gbCode: "993803",
            ciqCode: "993803"
        },
        {
            codeName: "慈溪出口加工区",
            cusCode: "142",
            codeValue: "993804",
            gbName: "慈溪出口加工区",
            gbCode: "993804",
            ciqCode: "993804"
        },
        {
            codeName: "厦门保税区",
            cusCode: "142",
            codeValue: "993901",
            gbName: "厦门保税区",
            gbCode: "993901",
            ciqCode: "993901"
        },
        {
            codeName: "厦门海沧保税港区",
            cusCode: "142",
            codeValue: "993902",
            gbName: "厦门海沧保税港区",
            gbCode: "993902",
            ciqCode: "993902"
        },
        {
            codeName: "厦门象屿保税物流园区",
            cusCode: "142",
            codeValue: "993903",
            gbName: "厦门象屿保税物流园区",
            gbCode: "993903",
            ciqCode: "993903"
        },
        {
            codeName: "厦门翔安火炬保税物流园区",
            cusCode: "142",
            codeValue: "993904",
            gbName: "厦门翔安火炬保税物流园区",
            gbCode: "993904",
            ciqCode: "993904"
        },
        {
            codeName: "郑州出口加工区",
            cusCode: "142",
            codeValue: "994101",
            gbName: "郑州出口加工区",
            gbCode: "994101",
            ciqCode: "994101"
        },
        {
            codeName: "郑州新郑综合保税区",
            cusCode: "142",
            codeValue: "994102",
            gbName: "郑州新郑综合保税区",
            gbCode: "994102",
            ciqCode: "994102"
        },
        {
            codeName: "南阳卧龙综合保税区",
            cusCode: "142",
            codeValue: "994103",
            gbName: "南阳卧龙综合保税区",
            gbCode: "994103",
            ciqCode: "994103"
        },
        {
            codeName: "武汉出口加工区",
            cusCode: "142",
            codeValue: "994201",
            gbName: "武汉出口加工区",
            gbCode: "994201",
            ciqCode: "994201"
        },
        {
            codeName: "武汉东西湖保税物流园区",
            cusCode: "142",
            codeValue: "994202",
            gbName: "武汉东西湖保税物流园区",
            gbCode: "994202",
            ciqCode: "994202"
        },
        {
            codeName: "武汉东湖综合保税区",
            cusCode: "142",
            codeValue: "994203",
            gbName: "武汉东湖综合保税区",
            gbCode: "994203",
            ciqCode: "994203"
        },
        {
            codeName: "武汉新港空港综合保税区",
            cusCode: "142",
            codeValue: "994204",
            gbName: "武汉新港空港综合保税区",
            gbCode: "994204",
            ciqCode: "994204"
        },
        {
            codeName: "长沙金霞保税物流园区",
            cusCode: "142",
            codeValue: "994301",
            gbName: "长沙金霞保税物流园区",
            gbCode: "994301",
            ciqCode: "994301"
        },
        {
            codeName: "湘潭综合保税区",
            cusCode: "142",
            codeValue: "994302",
            gbName: "湘潭综合保税区",
            gbCode: "994302",
            ciqCode: "994302"
        },
        {
            codeName: "衡阳综合保税区",
            cusCode: "142",
            codeValue: "994303",
            gbName: "衡阳综合保税区",
            gbCode: "994303",
            ciqCode: "994303"
        },
        {
            codeName: "岳阳城陵矶综合保税区",
            cusCode: "142",
            codeValue: "994304",
            gbName: "岳阳城陵矶综合保税区",
            gbCode: "994304",
            ciqCode: "994304"
        },
        {
            codeName: "郴州出口加工区",
            cusCode: "142",
            codeValue: "994305",
            gbName: "郴州出口加工区",
            gbCode: "994305",
            ciqCode: "994305"
        },
        {
            codeName: "长沙黄花综合保税区",
            cusCode: "142",
            codeValue: "994306",
            gbName: "长沙黄花综合保税区",
            gbCode: "994306",
            ciqCode: "994306"
        },
        {
            codeName: "广州保税物流园区",
            cusCode: "142",
            codeValue: "994401",
            gbName: "广州保税物流园区",
            gbCode: "994401",
            ciqCode: "994401"
        },
        {
            codeName: "广州保税区",
            cusCode: "142",
            codeValue: "994402",
            gbName: "广州保税区",
            gbCode: "994402",
            ciqCode: "994402"
        },
        {
            codeName: "广州出口加工区",
            cusCode: "142",
            codeValue: "994403",
            gbName: "广州出口加工区",
            gbCode: "994403",
            ciqCode: "994403"
        },
        {
            codeName: "广州白云机场综合保税区",
            cusCode: "142",
            codeValue: "994404",
            gbName: "广州白云机场综合保税区",
            gbCode: "994404",
            ciqCode: "994404"
        },
        {
            codeName: "广州南沙保税港区",
            cusCode: "142",
            codeValue: "994405",
            gbName: "广州南沙保税港区",
            gbCode: "994405",
            ciqCode: "994405"
        },
        {
            codeName: "汕头保税区",
            cusCode: "142",
            codeValue: "994406",
            gbName: "汕头保税区",
            gbCode: "994406",
            ciqCode: "994406"
        },
        {
            codeName: "中国（广东）自由贸易试验区",
            cusCode: "142",
            codeValue: "994407",
            gbName: "中国（广东）自由贸易试验区",
            gbCode: "994407",
            ciqCode: "994407"
        },
        {
            codeName: "北海出口加工区",
            cusCode: "142",
            codeValue: "994501",
            gbName: "北海出口加工区",
            gbCode: "994501",
            ciqCode: "994501"
        },
        {
            codeName: "钦州保税港区",
            cusCode: "142",
            codeValue: "994502",
            gbName: "钦州保税港区",
            gbCode: "994502",
            ciqCode: "994502"
        },
        {
            codeName: "凭祥综合保税区",
            cusCode: "142",
            codeValue: "994503",
            gbName: "凭祥综合保税区",
            gbCode: "994503",
            ciqCode: "994503"
        },
        {
            codeName: "海口综合保税区",
            cusCode: "142",
            codeValue: "994601",
            gbName: "海口综合保税区",
            gbCode: "994601",
            ciqCode: "994601"
        },
        {
            codeName: "洋浦保税港区",
            cusCode: "142",
            codeValue: "994602",
            gbName: "洋浦保税港区",
            gbCode: "994602",
            ciqCode: "994602"
        },
        {
            codeName: "深圳出口加工区",
            cusCode: "142",
            codeValue: "994701",
            gbName: "深圳出口加工区",
            gbCode: "994701",
            ciqCode: "994701"
        },
        {
            codeName: "深圳福田保税区",
            cusCode: "142",
            codeValue: "994702",
            gbName: "深圳福田保税区",
            gbCode: "994702",
            ciqCode: "994702"
        },
        {
            codeName: "深圳前海湾保税港区",
            cusCode: "142",
            codeValue: "994703",
            gbName: "深圳前海湾保税港区",
            gbCode: "994703",
            ciqCode: "994703"
        },
        {
            codeName: "深圳盐田保税物流园区",
            cusCode: "142",
            codeValue: "994704",
            gbName: "深圳盐田保税物流园区",
            gbCode: "994704",
            ciqCode: "994704"
        },
        {
            codeName: "深圳盐田保税区",
            cusCode: "142",
            codeValue: "994705",
            gbName: "深圳盐田保税区",
            gbCode: "994705",
            ciqCode: "994705"
        },
        {
            codeName: "深圳沙头角保税区",
            cusCode: "142",
            codeValue: "994706",
            gbName: "深圳沙头角保税区",
            gbCode: "994706",
            ciqCode: "994706"
        },
        {
            codeName: "珠海保税区加华码头",
            cusCode: "142",
            codeValue: "994801",
            gbName: "珠海保税区加华码头",
            gbCode: "994801",
            ciqCode: "994801"
        },
        {
            codeName: "珠海保税区货场",
            cusCode: "142",
            codeValue: "994802",
            gbName: "珠海保税区货场",
            gbCode: "994802",
            ciqCode: "994802"
        },
        {
            codeName: "珠澳跨境工业区（珠海园区）货场",
            cusCode: "142",
            codeValue: "994803",
            gbName: "珠澳跨境工业区（珠海园区）货场",
            gbCode: "994803",
            ciqCode: "994803"
        },
        {
            codeName: "珠澳跨境工业区（珠海园区）旅检通道",
            cusCode: "142",
            codeValue: "994804",
            gbName: "珠澳跨境工业区（珠海园区）旅检通道",
            gbCode: "994804",
            ciqCode: "994804"
        },
        {
            codeName: "重庆两路寸滩保税港区水港",
            cusCode: "142",
            codeValue: "995001",
            gbName: "重庆两路寸滩保税港区水港",
            gbCode: "995001",
            ciqCode: "995001"
        },
        {
            codeName: "重庆两路寸滩保税港区空港",
            cusCode: "142",
            codeValue: "995002",
            gbName: "重庆两路寸滩保税港区空港",
            gbCode: "995002",
            ciqCode: "995002"
        },
        {
            codeName: "重庆西永综合保税区",
            cusCode: "142",
            codeValue: "995003",
            gbName: "重庆西永综合保税区",
            gbCode: "995003",
            ciqCode: "995003"
        },
        {
            codeName: "成都高新综合保税区双流园区",
            cusCode: "142",
            codeValue: "995101",
            gbName: "成都高新综合保税区双流园区",
            gbCode: "995101",
            ciqCode: "995101"
        },
        {
            codeName: "成都高新综合保税区A区",
            cusCode: "142",
            codeValue: "995102",
            gbName: "成都高新综合保税区A区",
            gbCode: "995102",
            ciqCode: "995102"
        },
        {
            codeName: "成都高新综合保税区B区",
            cusCode: "142",
            codeValue: "995103",
            gbName: "成都高新综合保税区B区",
            gbCode: "995103",
            ciqCode: "995103"
        },
        {
            codeName: "成都高新综合保税区C区",
            cusCode: "142",
            codeValue: "995104",
            gbName: "成都高新综合保税区C区",
            gbCode: "995104",
            ciqCode: "995104"
        },
        {
            codeName: "绵阳出口加工区",
            cusCode: "142",
            codeValue: "995105",
            gbName: "绵阳出口加工区",
            gbCode: "995105",
            ciqCode: "995105"
        },
        {
            codeName: "贵阳综合保税区",
            cusCode: "142",
            codeValue: "995201",
            gbName: "贵阳综合保税区",
            gbCode: "995201",
            ciqCode: "995201"
        },
        {
            codeName: "昆明出口加工区",
            cusCode: "142",
            codeValue: "995301",
            gbName: "昆明出口加工区",
            gbCode: "995301",
            ciqCode: "995301"
        },
        {
            codeName: "昆明综合保税区",
            cusCode: "142",
            codeValue: "995302",
            gbName: "昆明综合保税区",
            gbCode: "995302",
            ciqCode: "995302"
        },
        {
            codeName: "红河综合保税区",
            cusCode: "142",
            codeValue: "995303",
            gbName: "红河综合保税区",
            gbCode: "995303",
            ciqCode: "995303"
        },
        {
            codeName: "西安综合保税区",
            cusCode: "142",
            codeValue: "996101",
            gbName: "西安综合保税区",
            gbCode: "996101",
            ciqCode: "996101"
        },
        {
            codeName: "西安出口加工区",
            cusCode: "142",
            codeValue: "996102",
            gbName: "西安出口加工区",
            gbCode: "996102",
            ciqCode: "996102"
        },
        {
            codeName: "西安高新综合保税区",
            cusCode: "142",
            codeValue: "996103",
            gbName: "西安高新综合保税区",
            gbCode: "996103",
            ciqCode: "996103"
        },
        {
            codeName: "兰州新区综合保税区",
            cusCode: "142",
            codeValue: "996201",
            gbName: "兰州新区综合保税区",
            gbCode: "996201",
            ciqCode: "996201"
        },
        {
            codeName: "乌鲁木齐出口加工区",
            cusCode: "142",
            codeValue: "996501",
            gbName: "乌鲁木齐出口加工区",
            gbCode: "996501",
            ciqCode: "996501"
        },
        {
            codeName: "阿拉山口综合保税区",
            cusCode: "142",
            codeValue: "996502",
            gbName: "阿拉山口综合保税区",
            gbCode: "996502",
            ciqCode: "996502"
        },
        {
            codeName: "喀什综合保税区",
            cusCode: "142",
            codeValue: "996503",
            gbName: "喀什综合保税区",
            gbCode: "996503",
            ciqCode: "996503"
        },
        {
            codeName: "霍尔果斯国际边境合作中心（中方配套区）",
            cusCode: "142",
            codeValue: "996504",
            gbName: "霍尔果斯国际边境合作中心（中方配套区）",
            gbCode: "996504",
            ciqCode: "996504"
        },
        {
            codeName: "阿鲁巴",
            cusCode: "403",
            codeValue: "ABW000",
            gbName: "阿鲁巴",
            gbCode: "ABW000",
            ciqCode: "533000"
        },
        {
            codeName: "阿鲁巴岛（阿鲁巴）",
            cusCode: "4031",
            codeValue: "ABW001",
            gbName: "阿鲁巴岛（阿鲁巴）",
            gbCode: "ABW001",
            ciqCode: "533001"
        },
        {
            codeName: "奥拉涅斯塔德（阿鲁巴）",
            cusCode: "4032",
            codeValue: "ABW003",
            gbName: "奥拉涅斯塔德（阿鲁巴）",
            gbCode: "ABW003",
            ciqCode: "533003"
        },
        {
            codeName: "圣尼古拉斯湾（阿鲁巴）",
            cusCode: "403",
            codeValue: "ABW006",
            gbName: "圣尼古拉斯湾（阿鲁巴）",
            gbCode: "ABW006",
            ciqCode: "533006"
        },
        {
            codeName: "阿富汗",
            cusCode: "101",
            codeValue: "AFG000",
            gbName: "阿富汗",
            gbCode: "AFG000",
            ciqCode: "004000"
        },
        {
            codeName: "喀布尔（阿富汗）",
            cusCode: "1002",
            codeValue: "AFG001",
            gbName: "喀布尔（阿富汗）",
            gbCode: "AFG001",
            ciqCode: "004001"
        },
        {
            codeName: "坎大哈（阿富汗）",
            cusCode: "1003",
            codeValue: "AFG002",
            gbName: "坎大哈（阿富汗）",
            gbCode: "AFG002",
            ciqCode: "004002"
        },
        {
            codeName: "安哥拉",
            cusCode: "202",
            codeValue: "AGO000",
            gbName: "安哥拉",
            gbCode: "AGO000",
            ciqCode: "024000"
        },
        {
            codeName: "安布里什（安哥拉）",
            cusCode: "202",
            codeValue: "AGO003",
            gbName: "安布里什（安哥拉）",
            gbCode: "AGO003",
            ciqCode: "024003"
        },
        {
            codeName: "安布里泽特（安哥拉）",
            cusCode: "202",
            codeValue: "AGO006",
            gbName: "安布里泽特（安哥拉）",
            gbCode: "AGO006",
            ciqCode: "024006"
        },
        {
            codeName: "木格拉（安哥拉）",
            cusCode: "202",
            codeValue: "AGO009",
            gbName: "木格拉（安哥拉）",
            gbCode: "AGO009",
            ciqCode: "024009"
        },
        {
            codeName: "卡宾达（安哥拉）",
            cusCode: "202",
            codeValue: "AGO012",
            gbName: "卡宾达（安哥拉）",
            gbCode: "AGO012",
            ciqCode: "024012"
        },
        {
            codeName: "洛比托（安哥拉）",
            cusCode: "1583",
            codeValue: "AGO015",
            gbName: "洛比托（安哥拉）",
            gbCode: "AGO015",
            ciqCode: "024015"
        },
        {
            codeName: "罗安达（安哥拉）",
            cusCode: "1584",
            codeValue: "AGO018",
            gbName: "罗安达（安哥拉）",
            gbCode: "AGO018",
            ciqCode: "024018"
        },
        {
            codeName: "木萨米迪什（安哥拉）",
            cusCode: "1585",
            codeValue: "AGO021",
            gbName: "木萨米迪什（安哥拉）",
            gbCode: "AGO021",
            ciqCode: "024021"
        },
        {
            codeName: "松贝（新里东杜）（安哥拉）",
            cusCode: "1587",
            codeValue: "AGO024",
            gbName: "松贝（新里东杜）（安哥拉）",
            gbCode: "AGO024",
            ciqCode: "024024"
        },
        {
            codeName: "纳米贝（安哥拉）",
            cusCode: "202",
            codeValue: "AGO026",
            gbName: "纳米贝（安哥拉）",
            gbCode: "AGO026",
            ciqCode: "024026"
        },
        {
            codeName: "亚历山大港（安哥拉）",
            cusCode: "1589",
            codeValue: "AGO027",
            gbName: "亚历山大港（安哥拉）",
            gbCode: "AGO027",
            ciqCode: "024027"
        },
        {
            codeName: "安博因港（安哥拉）",
            cusCode: "1588",
            codeValue: "AGO030",
            gbName: "安博因港（安哥拉）",
            gbCode: "AGO030",
            ciqCode: "024030"
        },
        {
            codeName: "萨拉萨尔港（安哥拉）",
            cusCode: "202",
            codeValue: "AGO033",
            gbName: "萨拉萨尔港（安哥拉）",
            gbCode: "AGO033",
            ciqCode: "024033"
        },
        {
            codeName: "安圭拉",
            cusCode: "456",
            codeValue: "AIA000",
            gbName: "安圭拉",
            gbCode: "AIA000",
            ciqCode: "660000"
        },
        {
            codeName: "路德湾（安圭拉）",
            cusCode: "499",
            codeValue: "AIA003",
            gbName: "路德湾（安圭拉）",
            gbCode: "AIA003",
            ciqCode: "660003"
        },
        {
            codeName: "奥兰群岛",
            cusCode: "360",
            codeValue: "ALA000",
            gbName: "奥兰群岛",
            gbCode: "ALA000",
            ciqCode: "248000"
        },
        {
            codeName: "阿尔巴尼亚",
            cusCode: "313",
            codeValue: "ALB000",
            gbName: "阿尔巴尼亚",
            gbCode: "ALB000",
            ciqCode: "008000"
        },
        {
            codeName: "都拉斯（阿尔巴尼亚）",
            cusCode: "2417",
            codeValue: "ALB003",
            gbName: "都拉斯（阿尔巴尼亚）",
            gbCode: "ALB003",
            ciqCode: "008003"
        },
        {
            codeName: "萨兰达（阿尔巴尼亚）",
            cusCode: "2418",
            codeValue: "ALB006",
            gbName: "萨兰达（阿尔巴尼亚）",
            gbCode: "ALB006",
            ciqCode: "008006"
        },
        {
            codeName: "圣吉尼（阿尔巴尼亚）",
            cusCode: "313",
            codeValue: "ALB009",
            gbName: "圣吉尼（阿尔巴尼亚）",
            gbCode: "ALB009",
            ciqCode: "008009"
        },
        {
            codeName: "发罗拉（阿尔巴尼亚）",
            cusCode: "2419",
            codeValue: "ALB012",
            gbName: "发罗拉（阿尔巴尼亚）",
            gbCode: "ALB012",
            ciqCode: "008012"
        },
        {
            codeName: "安道尔",
            cusCode: "314",
            codeValue: "AND000",
            gbName: "安道尔",
            gbCode: "AND000",
            ciqCode: "020000"
        },
        {
            codeName: "安道尔（安道尔）",
            cusCode: "2421",
            codeValue: "AND001",
            gbName: "安道尔（安道尔）",
            gbCode: "AND001",
            ciqCode: "020001"
        },
        {
            codeName: "阿联酋",
            cusCode: "138",
            codeValue: "ARE000",
            gbName: "阿联酋",
            gbCode: "ARE000",
            ciqCode: "784000"
        },
        {
            codeName: "阿布埃尔布霍希（阿联酋）",
            cusCode: "138",
            codeValue: "ARE003",
            gbName: "阿布埃尔布霍希（阿联酋）",
            gbCode: "ARE003",
            ciqCode: "784003"
        },
        {
            codeName: "阿布扎比（阿联酋）",
            cusCode: "1539",
            codeValue: "ARE006",
            gbName: "阿布扎比（阿联酋）",
            gbCode: "ARE006",
            ciqCode: "784006"
        },
        {
            codeName: "阿治曼（阿联酋）",
            cusCode: "138",
            codeValue: "ARE009",
            gbName: "阿治曼（阿联酋）",
            gbCode: "ARE009",
            ciqCode: "784009"
        },
        {
            codeName: "达斯岛（阿联酋）",
            cusCode: "1541",
            codeValue: "ARE015",
            gbName: "达斯岛（阿联酋）",
            gbCode: "ARE015",
            ciqCode: "784015"
        },
        {
            codeName: "迪拜（阿联酋）",
            cusCode: "1543",
            codeValue: "ARE018",
            gbName: "迪拜（阿联酋）",
            gbCode: "ARE018",
            ciqCode: "784018"
        },
        {
            codeName: "法特油码头（阿联酋）",
            cusCode: "138",
            codeValue: "ARE021",
            gbName: "法特油码头（阿联酋）",
            gbCode: "ARE021",
            ciqCode: "784021"
        },
        {
            codeName: "富查伊拉（阿联酋）",
            cusCode: "138",
            codeValue: "ARE024",
            gbName: "富查伊拉（阿联酋）",
            gbCode: "ARE024",
            ciqCode: "784024"
        },
        {
            codeName: "阿里山（阿联酋）",
            cusCode: "138",
            codeValue: "ARE027",
            gbName: "阿里山（阿联酋）",
            gbCode: "ARE027",
            ciqCode: "784027"
        },
        {
            codeName: "杰贝尔丹那（阿联酋）",
            cusCode: "1545",
            codeValue: "ARE030",
            gbName: "杰贝尔丹那（阿联酋）",
            gbCode: "ARE030",
            ciqCode: "784030"
        },
        {
            codeName: "豪尔费坎（阿联酋）",
            cusCode: "138",
            codeValue: "ARE033",
            gbName: "豪尔费坎（阿联酋）",
            gbCode: "ARE033",
            ciqCode: "784033"
        },
        {
            codeName: "沙奎港（阿联酋）",
            cusCode: "138",
            codeValue: "ARE036",
            gbName: "沙奎港（阿联酋）",
            gbCode: "ARE036",
            ciqCode: "784036"
        },
        {
            codeName: "扎伊德港（阿联酋）",
            cusCode: "138",
            codeValue: "ARE039",
            gbName: "扎伊德港（阿联酋）",
            gbCode: "ARE039",
            ciqCode: "784039"
        },
        {
            codeName: "穆巴腊岛（阿联酋）",
            cusCode: "138",
            codeValue: "ARE042",
            gbName: "穆巴腊岛（阿联酋）",
            gbCode: "ARE042",
            ciqCode: "784042"
        },
        {
            codeName: "哈伊马角（阿联酋）",
            cusCode: "138",
            codeValue: "ARE045",
            gbName: "哈伊马角（阿联酋）",
            gbCode: "ARE045",
            ciqCode: "784045"
        },
        {
            codeName: "乌姆盖万（阿联酋）",
            cusCode: "138",
            codeValue: "ARE051",
            gbName: "乌姆盖万（阿联酋）",
            gbCode: "ARE051",
            ciqCode: "784051"
        },
        {
            codeName: "拉希德港（阿联酋）",
            cusCode: "138",
            codeValue: "ARE054",
            gbName: "拉希德港（阿联酋）",
            gbCode: "ARE054",
            ciqCode: "784054"
        },
        {
            codeName: "沙迦（阿联酋）",
            cusCode: "1546",
            codeValue: "ARE901",
            gbName: "沙迦（阿联酋）",
            gbCode: "ARE901",
            ciqCode: "784901"
        },
        {
            codeName: "阿根廷",
            cusCode: "402",
            codeValue: "ARG000",
            gbName: "阿根廷",
            gbCode: "ARG000",
            ciqCode: "032000"
        },
        {
            codeName: "皮拖（阿根廷）",
            cusCode: "2714",
            codeValue: "ARG001",
            gbName: "皮拖（阿根廷）",
            gbCode: "ARG001",
            ciqCode: "032001"
        },
        {
            codeName: "白奥哥港（阿根廷）",
            cusCode: "2717",
            codeValue: "ARG002",
            gbName: "白奥哥港（阿根廷）",
            gbCode: "ARG002",
            ciqCode: "032002"
        },
        {
            codeName: "布兰卡港（阿根廷）",
            cusCode: "2704",
            codeValue: "ARG003",
            gbName: "布兰卡港（阿根廷）",
            gbCode: "ARG003",
            ciqCode: "032003"
        },
        {
            codeName: "布宜诺斯艾利斯（阿根廷）",
            cusCode: "2705",
            codeValue: "ARG006",
            gbName: "布宜诺斯艾利斯（阿根廷）",
            gbCode: "ARG006",
            ciqCode: "032006"
        },
        {
            codeName: "奥利维亚（阿根廷）",
            cusCode: "402",
            codeValue: "ARG008",
            gbName: "奥利维亚（阿根廷）",
            gbCode: "ARG008",
            ciqCode: "032008"
        },
        {
            codeName: "坎帕纳（阿根廷）",
            cusCode: "2706",
            codeValue: "ARG009",
            gbName: "坎帕纳（阿根廷）",
            gbCode: "ARG009",
            ciqCode: "032009"
        },
        {
            codeName: "里瓦达维亚海军准将城（阿根廷）",
            cusCode: "402",
            codeValue: "ARG012",
            gbName: "里瓦达维亚海军准将城（阿根廷）",
            gbCode: "ARG012",
            ciqCode: "032012"
        },
        {
            codeName: "康塞普西翁（阿根廷）",
            cusCode: "402",
            codeValue: "ARG015",
            gbName: "康塞普西翁（阿根廷）",
            gbCode: "ARG015",
            ciqCode: "032015"
        },
        {
            codeName: "迪亚曼泰（阿根廷）",
            cusCode: "402",
            codeValue: "ARG018",
            gbName: "迪亚曼泰（阿根廷）",
            gbCode: "ARG018",
            ciqCode: "032018"
        },
        {
            codeName: "伊比奎（阿根廷）",
            cusCode: "2708",
            codeValue: "ARG021",
            gbName: "伊比奎（阿根廷）",
            gbCode: "ARG021",
            ciqCode: "032021"
        },
        {
            codeName: "拉普拉塔（阿根廷）",
            cusCode: "2709",
            codeValue: "ARG024",
            gbName: "拉普拉塔（阿根廷）",
            gbCode: "ARG024",
            ciqCode: "032024"
        },
        {
            codeName: "马德普拉塔（阿根廷）",
            cusCode: "2711",
            codeValue: "ARG027",
            gbName: "马德普拉塔（阿根廷）",
            gbCode: "ARG027",
            ciqCode: "032027"
        },
        {
            codeName: "内科切阿（阿根廷）",
            cusCode: "402",
            codeValue: "ARG030",
            gbName: "内科切阿（阿根廷）",
            gbCode: "ARG030",
            ciqCode: "032030"
        },
        {
            codeName: "阿塞维多港（阿根廷）",
            cusCode: "2716",
            codeValue: "ARG033",
            gbName: "阿塞维多港（阿根廷）",
            gbCode: "ARG033",
            ciqCode: "032033"
        },
        {
            codeName: "德塞阿多港（阿根廷）",
            cusCode: "2707",
            codeValue: "ARG036",
            gbName: "德塞阿多港（阿根廷）",
            gbCode: "ARG036",
            ciqCode: "032036"
        },
        {
            codeName: "马德林港（阿根廷）",
            cusCode: "2710",
            codeValue: "ARG039",
            gbName: "马德林港（阿根廷）",
            gbCode: "ARG039",
            ciqCode: "032039"
        },
        {
            codeName: "科罗拉多角（阿根廷）",
            cusCode: "402",
            codeValue: "ARG042",
            gbName: "科罗拉多角（阿根廷）",
            gbCode: "ARG042",
            ciqCode: "032042"
        },
        {
            codeName: "蓬塔基利亚（阿根廷）",
            cusCode: "402",
            codeValue: "ARG045",
            gbName: "蓬塔基利亚（阿根廷）",
            gbCode: "ARG045",
            ciqCode: "032045"
        },
        {
            codeName: "克肯（阿根廷）",
            cusCode: "2721",
            codeValue: "ARG048",
            gbName: "克肯（阿根廷）",
            gbCode: "ARG048",
            ciqCode: "032048"
        },
        {
            codeName: "拉马约（阿根廷）",
            cusCode: "402",
            codeValue: "ARG051",
            gbName: "拉马约（阿根廷）",
            gbCode: "ARG051",
            ciqCode: "032051"
        },
        {
            codeName: "雷卡拉达（阿根廷）",
            cusCode: "402",
            codeValue: "ARG054",
            gbName: "雷卡拉达（阿根廷）",
            gbCode: "ARG054",
            ciqCode: "032054"
        },
        {
            codeName: "里奥加耶戈斯（阿根廷）",
            cusCode: "402",
            codeValue: "ARG057",
            gbName: "里奥加耶戈斯（阿根廷）",
            gbCode: "ARG057",
            ciqCode: "032057"
        },
        {
            codeName: "里奥格兰德（阿根廷）",
            cusCode: "402",
            codeValue: "ARG060",
            gbName: "里奥格兰德（阿根廷）",
            gbCode: "ARG060",
            ciqCode: "032060"
        },
        {
            codeName: "罗萨里奥（阿根廷）",
            cusCode: "2722",
            codeValue: "ARG063",
            gbName: "罗萨里奥（阿根廷）",
            gbCode: "ARG063",
            ciqCode: "032063"
        },
        {
            codeName: "圣安东尼奥（阿根廷）",
            cusCode: "402",
            codeValue: "ARG066",
            gbName: "圣安东尼奥（阿根廷）",
            gbCode: "ARG066",
            ciqCode: "032066"
        },
        {
            codeName: "圣弗尔南多（阿根廷）",
            cusCode: "402",
            codeValue: "ARG069",
            gbName: "圣弗尔南多（阿根廷）",
            gbCode: "ARG069",
            ciqCode: "032069"
        },
        {
            codeName: "圣洛伦索（阿根廷）",
            cusCode: "2723",
            codeValue: "ARG072",
            gbName: "圣洛伦索（阿根廷）",
            gbCode: "ARG072",
            ciqCode: "032072"
        },
        {
            codeName: "圣胡利安（阿根廷）",
            cusCode: "402",
            codeValue: "ARG074",
            gbName: "圣胡利安（阿根廷）",
            gbCode: "ARG074",
            ciqCode: "032074"
        },
        {
            codeName: "圣尼古拉斯（阿根廷）",
            cusCode: "2724",
            codeValue: "ARG075",
            gbName: "圣尼古拉斯（阿根廷）",
            gbCode: "ARG075",
            ciqCode: "032075"
        },
        {
            codeName: "圣佩德罗（阿根廷）",
            cusCode: "2725",
            codeValue: "ARG078",
            gbName: "圣佩德罗（阿根廷）",
            gbCode: "ARG078",
            ciqCode: "032078"
        },
        {
            codeName: "圣塞瓦斯蒂安（阿根廷）",
            cusCode: "402",
            codeValue: "ARG081",
            gbName: "圣塞瓦斯蒂安（阿根廷）",
            gbCode: "ARG081",
            ciqCode: "032081"
        },
        {
            codeName: "圣克鲁斯（阿根廷）",
            cusCode: "402",
            codeValue: "ARG084",
            gbName: "圣克鲁斯（阿根廷）",
            gbCode: "ARG084",
            ciqCode: "032084"
        },
        {
            codeName: "圣菲（阿根廷）",
            cusCode: "2726",
            codeValue: "ARG087",
            gbName: "圣菲（阿根廷）",
            gbCode: "ARG087",
            ciqCode: "032087"
        },
        {
            codeName: "乌斯怀亚（阿根廷）",
            cusCode: "402",
            codeValue: "ARG090",
            gbName: "乌斯怀亚（阿根廷）",
            gbCode: "ARG090",
            ciqCode: "032090"
        },
        {
            codeName: "孔斯蒂图西翁镇（阿根廷）",
            cusCode: "2727",
            codeValue: "ARG093",
            gbName: "孔斯蒂图西翁镇（阿根廷）",
            gbCode: "ARG093",
            ciqCode: "032093"
        },
        {
            codeName: "萨拉特（阿根廷）",
            cusCode: "2728",
            codeValue: "ARG096",
            gbName: "萨拉特（阿根廷）",
            gbCode: "ARG096",
            ciqCode: "032096"
        },
        {
            codeName: "亚美尼亚",
            cusCode: "151",
            codeValue: "ARM000",
            gbName: "亚美尼亚",
            gbCode: "ARM000",
            ciqCode: "051000"
        },
        {
            codeName: "美属萨摩亚",
            cusCode: "626",
            codeValue: "ASM000",
            gbName: "美属萨摩亚",
            gbCode: "ASM000",
            ciqCode: "016000"
        },
        {
            codeName: "帕果帕果（美属萨摩亚）",
            cusCode: "3398",
            codeValue: "ASM003",
            gbName: "帕果帕果（美属萨摩亚）",
            gbCode: "ASM003",
            ciqCode: "016003"
        },
        {
            codeName: "图图伊拉（美属萨摩亚）",
            cusCode: "3409",
            codeValue: "ASM004",
            gbName: "图图伊拉（美属萨摩亚）",
            gbCode: "ASM004",
            ciqCode: "016004"
        },
        {
            codeName: "南极洲",
            cusCode: "700",
            codeValue: "ATA000",
            gbName: "南极洲",
            gbCode: "ATA000",
            ciqCode: "010000"
        },
        {
            codeName: "法属南方领地",
            cusCode: "261",
            codeValue: "ATF000",
            gbName: "法属南方领地",
            gbCode: "ATF000",
            ciqCode: "260000"
        },
        {
            codeName: "安提瓜和巴布达",
            cusCode: "401",
            codeValue: "ATG000",
            gbName: "安提瓜和巴布达",
            gbCode: "ATG000",
            ciqCode: "028000"
        },
        {
            codeName: "圣约翰斯（安提瓜和巴布达）",
            cusCode: "2703",
            codeValue: "ATG003",
            gbName: "圣约翰斯（安提瓜和巴布达）",
            gbCode: "ATG003",
            ciqCode: "028003"
        },
        {
            codeName: "澳大利亚",
            cusCode: "601",
            codeValue: "AUS000",
            gbName: "澳大利亚",
            gbCode: "AUS000",
            ciqCode: "036000"
        },
        {
            codeName: "阿伯特湾（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS003",
            gbName: "阿伯特湾（澳大利亚）",
            gbCode: "AUS003",
            ciqCode: "036003"
        },
        {
            codeName: "调查岛（阿根廷）",
            cusCode: "3235",
            codeValue: "AUS004",
            gbName: "调查岛（阿根廷）",
            gbCode: "AUS004",
            ciqCode: "032004"
        },
        {
            codeName: "阿德莱德（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS006",
            gbName: "阿德莱德（澳大利亚）",
            gbCode: "AUS006",
            ciqCode: "036006"
        },
        {
            codeName: "奥尔巴尼（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS009",
            gbName: "奥尔巴尼（澳大利亚）",
            gbCode: "AUS009",
            ciqCode: "036009"
        },
        {
            codeName: "阿德罗森（澳大利亚）",
            cusCode: "3210",
            codeValue: "AUS012",
            gbName: "阿德罗森（澳大利亚）",
            gbCode: "AUS012",
            ciqCode: "036012"
        },
        {
            codeName: "巴拉斯特黑德（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS015",
            gbName: "巴拉斯特黑德（澳大利亚）",
            gbCode: "AUS015",
            ciqCode: "036015"
        },
        {
            codeName: "巴罗岛（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS018",
            gbName: "巴罗岛（澳大利亚）",
            gbCode: "AUS018",
            ciqCode: "036018"
        },
        {
            codeName: "搏尤替角（澳大利亚）",
            cusCode: "3211",
            codeValue: "AUS021",
            gbName: "搏尤替角（澳大利亚）",
            gbCode: "AUS021",
            ciqCode: "036021"
        },
        {
            codeName: "贝尔贝（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS024",
            gbName: "贝尔贝（澳大利亚）",
            gbCode: "AUS024",
            ciqCode: "036024"
        },
        {
            codeName: "植物学湾（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS027",
            gbName: "植物学湾（澳大利亚）",
            gbCode: "AUS027",
            ciqCode: "036027"
        },
        {
            codeName: "鲍恩（澳大利亚）",
            cusCode: "3212",
            codeValue: "AUS030",
            gbName: "鲍恩（澳大利亚）",
            gbCode: "AUS030",
            ciqCode: "036030"
        },
        {
            codeName: "布里斯班（澳大利亚）",
            cusCode: "3213",
            codeValue: "AUS033",
            gbName: "布里斯班（澳大利亚）",
            gbCode: "AUS033",
            ciqCode: "036033"
        },
        {
            codeName: "布鲁姆（澳大利亚）",
            cusCode: "3214",
            codeValue: "AUS036",
            gbName: "布鲁姆（澳大利亚）",
            gbCode: "AUS036",
            ciqCode: "036036"
        },
        {
            codeName: "班伯里（澳大利亚）",
            cusCode: "3225",
            codeValue: "AUS039",
            gbName: "班伯里（澳大利亚）",
            gbCode: "AUS039",
            ciqCode: "036039"
        },
        {
            codeName: "班达伯格（澳大利亚）",
            cusCode: "3215",
            codeValue: "AUS042",
            gbName: "班达伯格（澳大利亚）",
            gbCode: "AUS042",
            ciqCode: "036042"
        },
        {
            codeName: "伯尼（澳大利亚）",
            cusCode: "3216",
            codeValue: "AUS045",
            gbName: "伯尼（澳大利亚）",
            gbCode: "AUS045",
            ciqCode: "036045"
        },
        {
            codeName: "巴瑟尔顿（澳大利亚）",
            cusCode: "3217",
            codeValue: "AUS048",
            gbName: "巴瑟尔顿（澳大利亚）",
            gbCode: "AUS048",
            ciqCode: "036048"
        },
        {
            codeName: "凯恩斯（澳大利亚）",
            cusCode: "3218",
            codeValue: "AUS051",
            gbName: "凯恩斯（澳大利亚）",
            gbCode: "AUS051",
            ciqCode: "036051"
        },
        {
            codeName: "库维恩角（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS054",
            gbName: "库维恩角（澳大利亚）",
            gbCode: "AUS054",
            ciqCode: "036054"
        },
        {
            codeName: "拉姆贝特角（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS057",
            gbName: "拉姆贝特角（澳大利亚）",
            gbCode: "AUS057",
            ciqCode: "036057"
        },
        {
            codeName: "卡那封（澳大利亚）",
            cusCode: "3220",
            codeValue: "AUS060",
            gbName: "卡那封（澳大利亚）",
            gbCode: "AUS060",
            ciqCode: "036060"
        },
        {
            codeName: "喀斯喀特湾（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS063",
            gbName: "喀斯喀特湾（澳大利亚）",
            gbCode: "AUS063",
            ciqCode: "036063"
        },
        {
            codeName: "科夫斯港（澳大利亚）",
            cusCode: "3223",
            codeValue: "AUS066",
            gbName: "科夫斯港（澳大利亚）",
            gbCode: "AUS066",
            ciqCode: "036066"
        },
        {
            codeName: "库克敦（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS069",
            gbName: "库克敦（澳大利亚）",
            gbCode: "AUS069",
            ciqCode: "036069"
        },
        {
            codeName: "丹皮尔（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS072",
            gbName: "丹皮尔（澳大利亚）",
            gbCode: "AUS072",
            ciqCode: "036072"
        },
        {
            codeName: "达尔文（澳大利亚）",
            cusCode: "3224",
            codeValue: "AUS075",
            gbName: "达尔文（澳大利亚）",
            gbCode: "AUS075",
            ciqCode: "036075"
        },
        {
            codeName: "德比（澳大利亚）",
            cusCode: "3228",
            codeValue: "AUS078",
            gbName: "德比（澳大利亚）",
            gbCode: "AUS078",
            ciqCode: "036078"
        },
        {
            codeName: "德文波特（澳大利亚）",
            cusCode: "3229",
            codeValue: "AUS081",
            gbName: "德文波特（澳大利亚）",
            gbCode: "AUS081",
            ciqCode: "036081"
        },
        {
            codeName: "伊登（澳大利亚）",
            cusCode: "3230",
            codeValue: "AUS084",
            gbName: "伊登（澳大利亚）",
            gbCode: "AUS084",
            ciqCode: "036084"
        },
        {
            codeName: "伊迪斯堡（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS087",
            gbName: "伊迪斯堡（澳大利亚）",
            gbCode: "AUS087",
            ciqCode: "036087"
        },
        {
            codeName: "埃斯佩兰斯（澳大利亚）",
            cusCode: "3231",
            codeValue: "AUS090",
            gbName: "埃斯佩兰斯（澳大利亚）",
            gbCode: "AUS090",
            ciqCode: "036090"
        },
        {
            codeName: "弗里曼特尔（澳大利亚）",
            cusCode: "3232",
            codeValue: "AUS093",
            gbName: "弗里曼特尔（澳大利亚）",
            gbCode: "AUS093",
            ciqCode: "036093"
        },
        {
            codeName: "吉朗（澳大利亚）",
            cusCode: "3233",
            codeValue: "AUS096",
            gbName: "吉朗（澳大利亚）",
            gbCode: "AUS096",
            ciqCode: "036096"
        },
        {
            codeName: "杰拉尔顿（澳大利亚）",
            cusCode: "3226",
            codeValue: "AUS099",
            gbName: "杰拉尔顿（澳大利亚）",
            gbCode: "AUS099",
            ciqCode: "036099"
        },
        {
            codeName: "格拉德斯通（澳大利亚）",
            cusCode: "3227",
            codeValue: "AUS102",
            gbName: "格拉德斯通（澳大利亚）",
            gbCode: "AUS102",
            ciqCode: "036102"
        },
        {
            codeName: "戈弗（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS105",
            gbName: "戈弗（澳大利亚）",
            gbCode: "AUS105",
            ciqCode: "036105"
        },
        {
            codeName: "格拉夫顿（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS108",
            gbName: "格拉夫顿（澳大利亚）",
            gbCode: "AUS108",
            ciqCode: "036108"
        },
        {
            codeName: "格鲁特岛（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS111",
            gbName: "格鲁特岛（澳大利亚）",
            gbCode: "AUS111",
            ciqCode: "036111"
        },
        {
            codeName: "海波因特（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS114",
            gbName: "海波因特（澳大利亚）",
            gbCode: "AUS114",
            ciqCode: "036114"
        },
        {
            codeName: "霍巴特（澳大利亚）",
            cusCode: "3234",
            codeValue: "AUS117",
            gbName: "霍巴特（澳大利亚）",
            gbCode: "AUS117",
            ciqCode: "036117"
        },
        {
            codeName: "因尼斯费尔（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS120",
            gbName: "因尼斯费尔（澳大利亚）",
            gbCode: "AUS120",
            ciqCode: "036120"
        },
        {
            codeName: "金斯科特（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS123",
            gbName: "金斯科特（澳大利亚）",
            gbCode: "AUS123",
            ciqCode: "036123"
        },
        {
            codeName: "金斯敦（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS126",
            gbName: "金斯敦（澳大利亚）",
            gbCode: "AUS126",
            ciqCode: "036126"
        },
        {
            codeName: "奎纳纳（澳大利亚）",
            cusCode: "3237",
            codeValue: "AUS129",
            gbName: "奎纳纳（澳大利亚）",
            gbCode: "AUS129",
            ciqCode: "036129"
        },
        {
            codeName: "朗塞斯顿（澳大利亚）",
            cusCode: "3238",
            codeValue: "AUS132",
            gbName: "朗塞斯顿（澳大利亚）",
            gbCode: "AUS132",
            ciqCode: "036132"
        },
        {
            codeName: "户辛达（澳大利亚）",
            cusCode: "3239",
            codeValue: "AUS135",
            gbName: "户辛达（澳大利亚）",
            gbCode: "AUS135",
            ciqCode: "036135"
        },
        {
            codeName: "麦凯（澳大利亚）",
            cusCode: "3240",
            codeValue: "AUS138",
            gbName: "麦凯（澳大利亚）",
            gbCode: "AUS138",
            ciqCode: "036138"
        },
        {
            codeName: "麦克坦（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS141",
            gbName: "麦克坦（澳大利亚）",
            gbCode: "AUS141",
            ciqCode: "036141"
        },
        {
            codeName: "马里伯勒（澳大利亚）",
            cusCode: "3241",
            codeValue: "AUS144",
            gbName: "马里伯勒（澳大利亚）",
            gbCode: "AUS144",
            ciqCode: "036144"
        },
        {
            codeName: "墨尔本（澳大利亚）",
            cusCode: "3242",
            codeValue: "AUS147",
            gbName: "墨尔本（澳大利亚）",
            gbCode: "AUS147",
            ciqCode: "036147"
        },
        {
            codeName: "莫里扬港（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS150",
            gbName: "莫里扬港（澳大利亚）",
            gbCode: "AUS150",
            ciqCode: "036150"
        },
        {
            codeName: "纽卡斯尔（澳大利亚）",
            cusCode: "3245",
            codeValue: "AUS153",
            gbName: "纽卡斯尔（澳大利亚）",
            gbCode: "AUS153",
            ciqCode: "036153"
        },
        {
            codeName: "帕斯（澳大利亚）",
            cusCode: "3247",
            codeValue: "AUS156",
            gbName: "帕斯（澳大利亚）",
            gbCode: "AUS156",
            ciqCode: "036156"
        },
        {
            codeName: "阿德莱德港（澳大利亚）",
            cusCode: "3209",
            codeValue: "AUS159",
            gbName: "阿德莱德港（澳大利亚）",
            gbCode: "AUS159",
            ciqCode: "036159"
        },
        {
            codeName: "艾尔弗雷德港（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS162",
            gbName: "艾尔弗雷德港（澳大利亚）",
            gbCode: "AUS162",
            ciqCode: "036162"
        },
        {
            codeName: "阿尔马港（澳大利亚）",
            cusCode: "3250",
            codeValue: "AUS165",
            gbName: "阿尔马港（澳大利亚）",
            gbCode: "AUS165",
            ciqCode: "036165"
        },
        {
            codeName: "奥古斯塔港（澳大利亚）",
            cusCode: "3251",
            codeValue: "AUS168",
            gbName: "奥古斯塔港（澳大利亚）",
            gbCode: "AUS168",
            ciqCode: "036168"
        },
        {
            codeName: "吉利港（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS171",
            gbName: "吉利港（澳大利亚）",
            gbCode: "AUS171",
            ciqCode: "036171"
        },
        {
            codeName: "黑德兰港（澳大利亚）",
            cusCode: "3252",
            codeValue: "AUS174",
            gbName: "黑德兰港（澳大利亚）",
            gbCode: "AUS174",
            ciqCode: "036174"
        },
        {
            codeName: "会翁港（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS177",
            gbName: "会翁港（澳大利亚）",
            gbCode: "AUS177",
            ciqCode: "036177"
        },
        {
            codeName: "杰克逊港（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS180",
            gbName: "杰克逊港（澳大利亚）",
            gbCode: "AUS180",
            ciqCode: "036180"
        },
        {
            codeName: "肯布拉港（澳大利亚）",
            cusCode: "3254",
            codeValue: "AUS183",
            gbName: "肯布拉港（澳大利亚）",
            gbCode: "AUS183",
            ciqCode: "036183"
        },
        {
            codeName: "拉塔港（澳大利亚）",
            cusCode: "3256",
            codeValue: "AUS186",
            gbName: "拉塔港（澳大利亚）",
            gbCode: "AUS186",
            ciqCode: "036186"
        },
        {
            codeName: "林肯港（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS189",
            gbName: "林肯港（澳大利亚）",
            gbCode: "AUS189",
            ciqCode: "036189"
        },
        {
            codeName: "麦夸里港（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS192",
            gbName: "麦夸里港（澳大利亚）",
            gbCode: "AUS192",
            ciqCode: "036192"
        },
        {
            codeName: "皮里港（澳大利亚）",
            cusCode: "3259",
            codeValue: "AUS195",
            gbName: "皮里港（澳大利亚）",
            gbCode: "AUS195",
            ciqCode: "036195"
        },
        {
            codeName: "斯坦瓦克港（澳大利亚）",
            cusCode: "3260",
            codeValue: "AUS198",
            gbName: "斯坦瓦克港（澳大利亚）",
            gbCode: "AUS198",
            ciqCode: "036198"
        },
        {
            codeName: "沃尔科特港（澳大利亚）",
            cusCode: "3261",
            codeValue: "AUS201",
            gbName: "沃尔科特港（澳大利亚）",
            gbCode: "AUS201",
            ciqCode: "036201"
        },
        {
            codeName: "波特兰（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS204",
            gbName: "波特兰（澳大利亚）",
            gbCode: "AUS204",
            ciqCode: "036204"
        },
        {
            codeName: "拉皮德湾（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS207",
            gbName: "拉皮德湾（澳大利亚）",
            gbCode: "AUS207",
            ciqCode: "036207"
        },
        {
            codeName: "里司登（澳大利亚）",
            cusCode: "3263",
            codeValue: "AUS210",
            gbName: "里司登（澳大利亚）",
            gbCode: "AUS210",
            ciqCode: "036210"
        },
        {
            codeName: "罗克汉普顿（澳大利亚）",
            cusCode: "3264",
            codeValue: "AUS213",
            gbName: "罗克汉普顿（澳大利亚）",
            gbCode: "AUS213",
            ciqCode: "036213"
        },
        {
            codeName: "斯坦利（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS216",
            gbName: "斯坦利（澳大利亚）",
            gbCode: "AUS216",
            ciqCode: "036216"
        },
        {
            codeName: "斯坦豪斯湾（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS219",
            gbName: "斯坦豪斯湾（澳大利亚）",
            gbCode: "AUS219",
            ciqCode: "036219"
        },
        {
            codeName: "斯特拉恩（澳大利亚）",
            cusCode: "3265",
            codeValue: "AUS222",
            gbName: "斯特拉恩（澳大利亚）",
            gbCode: "AUS222",
            ciqCode: "036222"
        },
        {
            codeName: "悉尼（澳大利亚）",
            cusCode: "3266",
            codeValue: "AUS225",
            gbName: "悉尼（澳大利亚）",
            gbCode: "AUS225",
            ciqCode: "036225"
        },
        {
            codeName: "泰弗纳德（澳大利亚）",
            cusCode: "3267",
            codeValue: "AUS228",
            gbName: "泰弗纳德（澳大利亚）",
            gbCode: "AUS228",
            ciqCode: "036228"
        },
        {
            codeName: "星期四岛（澳大利亚）",
            cusCode: "3268",
            codeValue: "AUS231",
            gbName: "星期四岛（澳大利亚）",
            gbCode: "AUS231",
            ciqCode: "036231"
        },
        {
            codeName: "汤斯维尔（澳大利亚）",
            cusCode: "3269",
            codeValue: "AUS234",
            gbName: "汤斯维尔（澳大利亚）",
            gbCode: "AUS234",
            ciqCode: "036234"
        },
        {
            codeName: "尤兰根（澳大利亚）",
            cusCode: "3270",
            codeValue: "AUS237",
            gbName: "尤兰根（澳大利亚）",
            gbCode: "AUS237",
            ciqCode: "036237"
        },
        {
            codeName: "乌塞勒斯卢普（澳大利亚）",
            cusCode: "3271",
            codeValue: "AUS240",
            gbName: "乌塞勒斯卢普（澳大利亚）",
            gbCode: "AUS240",
            ciqCode: "036240"
        },
        {
            codeName: "沃拉鲁（澳大利亚）",
            cusCode: "3272",
            codeValue: "AUS243",
            gbName: "沃拉鲁（澳大利亚）",
            gbCode: "AUS243",
            ciqCode: "036243"
        },
        {
            codeName: "韦帕（澳大利亚）",
            cusCode: "3273",
            codeValue: "AUS246",
            gbName: "韦帕（澳大利亚）",
            gbCode: "AUS246",
            ciqCode: "036246"
        },
        {
            codeName: "西港（澳大利亚）",
            cusCode: "3274",
            codeValue: "AUS249",
            gbName: "西港（澳大利亚）",
            gbCode: "AUS249",
            ciqCode: "036249"
        },
        {
            codeName: "怀阿拉（澳大利亚）",
            cusCode: "3275",
            codeValue: "AUS252",
            gbName: "怀阿拉（澳大利亚）",
            gbCode: "AUS252",
            ciqCode: "036252"
        },
        {
            codeName: "温德姆（澳大利亚）",
            cusCode: "3276",
            codeValue: "AUS255",
            gbName: "温德姆（澳大利亚）",
            gbCode: "AUS255",
            ciqCode: "036255"
        },
        {
            codeName: "杨巴（澳大利亚）",
            cusCode: "601",
            codeValue: "AUS258",
            gbName: "杨巴（澳大利亚）",
            gbCode: "AUS258",
            ciqCode: "036258"
        },
        {
            codeName: "扬皮桑德（澳大利亚）",
            cusCode: "3277",
            codeValue: "AUS261",
            gbName: "扬皮桑德（澳大利亚）",
            gbCode: "AUS261",
            ciqCode: "036261"
        },
        {
            codeName: "菲利普港（澳大利亚）",
            cusCode: "3258",
            codeValue: "AUS903",
            gbName: "菲利普港（澳大利亚）",
            gbCode: "AUS903",
            ciqCode: "036903"
        },
        {
            codeName: "堪培拉（澳大利亚）",
            cusCode: "3219",
            codeValue: "AUS904",
            gbName: "堪培拉（澳大利亚）",
            gbCode: "AUS904",
            ciqCode: "036904"
        },
        {
            codeName: "克拉伦斯河（澳大利亚）",
            cusCode: "3222",
            codeValue: "AUS905",
            gbName: "克拉伦斯河（澳大利亚）",
            gbCode: "AUS905",
            ciqCode: "036905"
        },
        {
            codeName: "穆里兰港（澳大利亚）",
            cusCode: "3243",
            codeValue: "AUS908",
            gbName: "穆里兰港（澳大利亚）",
            gbCode: "AUS908",
            ciqCode: "036908"
        },
        {
            codeName: "朴次伊（澳大利亚）",
            cusCode: "3262",
            codeValue: "AUS909",
            gbName: "朴次伊（澳大利亚）",
            gbCode: "AUS909",
            ciqCode: "036909"
        },
        {
            codeName: "圣诞岛（澳大利亚）",
            cusCode: "3221",
            codeValue: "AUS911",
            gbName: "圣诞岛（澳大利亚）",
            gbCode: "AUS911",
            ciqCode: "036911"
        },
        {
            codeName: "翁斯洛（澳大利亚）",
            cusCode: "3246",
            codeValue: "AUS913",
            gbName: "翁斯洛（澳大利亚）",
            gbCode: "AUS913",
            ciqCode: "036913"
        },
        {
            codeName: "奥地利",
            cusCode: "315",
            codeValue: "AUT000",
            gbName: "奥地利",
            gbCode: "AUT000",
            ciqCode: "040000"
        },
        {
            codeName: "林茨（奥地利）",
            cusCode: "2422",
            codeValue: "AUT001",
            gbName: "林茨（奥地利）",
            gbCode: "AUT001",
            ciqCode: "040001"
        },
        {
            codeName: "维也纳（奥地利）",
            cusCode: "2423",
            codeValue: "AUT901",
            gbName: "维也纳（奥地利）",
            gbCode: "AUT901",
            ciqCode: "040901"
        },
        {
            codeName: "阿塞拜疆",
            cusCode: "152",
            codeValue: "AZE000",
            gbName: "阿塞拜疆",
            gbCode: "AZE000",
            ciqCode: "031000"
        },
        {
            codeName: "巴库（阿塞拜疆）",
            cusCode: "152",
            codeValue: "AZE901",
            gbName: "巴库（阿塞拜疆）",
            gbCode: "AZE901",
            ciqCode: "031901"
        },
        {
            codeName: "布隆迪",
            cusCode: "205",
            codeValue: "BDI000",
            gbName: "布隆迪",
            gbCode: "BDI000",
            ciqCode: "108000"
        },
        {
            codeName: "比利时",
            cusCode: "301",
            codeValue: "BEL000",
            gbName: "比利时",
            gbCode: "BEL000",
            ciqCode: "056000"
        },
        {
            codeName: "安特卫普（比利时）",
            cusCode: "1787",
            codeValue: "BEL003",
            gbName: "安特卫普（比利时）",
            gbCode: "BEL003",
            ciqCode: "056003"
        },
        {
            codeName: "布鲁日（比利时）",
            cusCode: "1788",
            codeValue: "BEL006",
            gbName: "布鲁日（比利时）",
            gbCode: "BEL006",
            ciqCode: "056006"
        },
        {
            codeName: "布鲁塞尔（比利时）",
            cusCode: "1789",
            codeValue: "BEL009",
            gbName: "布鲁塞尔（比利时）",
            gbCode: "BEL009",
            ciqCode: "056009"
        },
        {
            codeName: "根特（比利时）",
            cusCode: "1790",
            codeValue: "BEL012",
            gbName: "根特（比利时）",
            gbCode: "BEL012",
            ciqCode: "056012"
        },
        {
            codeName: "海米克瑟姆（比利时）",
            cusCode: "301",
            codeValue: "BEL015",
            gbName: "海米克瑟姆（比利时）",
            gbCode: "BEL015",
            ciqCode: "056015"
        },
        {
            codeName: "列日（比利时）",
            cusCode: "1791",
            codeValue: "BEL018",
            gbName: "列日（比利时）",
            gbCode: "BEL018",
            ciqCode: "056018"
        },
        {
            codeName: "尼乌波特（比利时）",
            cusCode: "1792",
            codeValue: "BEL021",
            gbName: "尼乌波特（比利时）",
            gbCode: "BEL021",
            ciqCode: "056021"
        },
        {
            codeName: "奥斯坦德（比利时）",
            cusCode: "1793",
            codeValue: "BEL024",
            gbName: "奥斯坦德（比利时）",
            gbCode: "BEL024",
            ciqCode: "056024"
        },
        {
            codeName: "泽布吕赫/泽布腊赫（比利时）",
            cusCode: "1794",
            codeValue: "BEL027",
            gbName: "泽布吕赫/泽布腊赫（比利时）",
            gbCode: "BEL027",
            ciqCode: "056027"
        },
        {
            codeName: "贝宁",
            cusCode: "203",
            codeValue: "BEN000",
            gbName: "贝宁",
            gbCode: "BEN000",
            ciqCode: "204000"
        },
        {
            codeName: "科托努（贝宁）",
            cusCode: "1590",
            codeValue: "BEN003",
            gbName: "科托努（贝宁）",
            gbCode: "BEN003",
            ciqCode: "204003"
        },
        {
            codeName: "波多诺伏（贝宁）",
            cusCode: "1592",
            codeValue: "BEN006",
            gbName: "波多诺伏（贝宁）",
            gbCode: "BEN006",
            ciqCode: "204006"
        },
        {
            codeName: "博纳尔，圣俄斯塔休斯和萨巴",
            cusCode: "449",
            codeValue: "BES000",
            gbName: "博纳尔，圣俄斯塔休斯和萨巴",
            gbCode: "BES000",
            ciqCode: "535000"
        },
        {
            codeName: "克拉伦代克（博内尔岛、圣尤斯特歇斯岛和萨巴岛）",
            cusCode: "2735",
            codeValue: "BES003",
            gbName: "克拉伦代克（博内尔岛、圣尤斯特歇斯岛和萨巴岛）",
            gbCode: "BES003",
            ciqCode: "535003"
        },
        {
            codeName: "萨巴（博内尔岛、圣尤斯特歇斯岛和萨巴岛）",
            cusCode: "2932",
            codeValue: "BES004",
            gbName: "萨巴（博内尔岛、圣尤斯特歇斯岛和萨巴岛）",
            gbCode: "BES004",
            ciqCode: "535004"
        },
        {
            codeName: "布基纳法索",
            cusCode: "251",
            codeValue: "BFA000",
            gbName: "布基纳法索",
            gbCode: "BFA000",
            ciqCode: "854000"
        },
        {
            codeName: "孟加拉国",
            cusCode: "103",
            codeValue: "BGD000",
            gbName: "孟加拉国",
            gbCode: "BGD000",
            ciqCode: "050000"
        },
        {
            codeName: "达卡（孟加拉国）",
            cusCode: "1008",
            codeValue: "BGD001",
            gbName: "达卡（孟加拉国）",
            gbCode: "BGD001",
            ciqCode: "050001"
        },
        {
            codeName: "贾尔纳（孟加拉国）",
            cusCode: "103",
            codeValue: "BGD003",
            gbName: "贾尔纳（孟加拉国）",
            gbCode: "BGD003",
            ciqCode: "050003"
        },
        {
            codeName: "吉大港（孟加拉国）",
            cusCode: "1007",
            codeValue: "BGD006",
            gbName: "吉大港（孟加拉国）",
            gbCode: "BGD006",
            ciqCode: "050006"
        },
        {
            codeName: "库尔纳（孟加拉国）",
            cusCode: "1009",
            codeValue: "BGD009",
            gbName: "库尔纳（孟加拉国）",
            gbCode: "BGD009",
            ciqCode: "050009"
        },
        {
            codeName: "蒙拉（孟加拉国）",
            cusCode: "103",
            codeValue: "BGD012",
            gbName: "蒙拉（孟加拉国）",
            gbCode: "BGD012",
            ciqCode: "050012"
        },
        {
            codeName: "保加利亚",
            cusCode: "316",
            codeValue: "BGR000",
            gbName: "保加利亚",
            gbCode: "BGR000",
            ciqCode: "100000"
        },
        {
            codeName: "巴尔奇克（保加利亚）",
            cusCode: "316",
            codeValue: "BGR003",
            gbName: "巴尔奇克（保加利亚）",
            gbCode: "BGR003",
            ciqCode: "100003"
        },
        {
            codeName: "布尔加斯（保加利亚）",
            cusCode: "2424",
            codeValue: "BGR006",
            gbName: "布尔加斯（保加利亚）",
            gbCode: "BGR006",
            ciqCode: "100006"
        },
        {
            codeName: "卡瓦尔纳（保加利亚）",
            cusCode: "316",
            codeValue: "BGR009",
            gbName: "卡瓦尔纳（保加利亚）",
            gbCode: "BGR009",
            ciqCode: "100009"
        },
        {
            codeName: "米丘林（保加利亚）",
            cusCode: "316",
            codeValue: "BGR012",
            gbName: "米丘林（保加利亚）",
            gbCode: "BGR012",
            ciqCode: "100012"
        },
        {
            codeName: "纳塞巴尔（保加利亚）",
            cusCode: "316",
            codeValue: "BGR015",
            gbName: "纳塞巴尔（保加利亚）",
            gbCode: "BGR015",
            ciqCode: "100015"
        },
        {
            codeName: "索佐波尔（保加利亚）",
            cusCode: "316",
            codeValue: "BGR017",
            gbName: "索佐波尔（保加利亚）",
            gbCode: "BGR017",
            ciqCode: "100017"
        },
        {
            codeName: "瓦尔纳（保加利亚）",
            cusCode: "2425",
            codeValue: "BGR018",
            gbName: "瓦尔纳（保加利亚）",
            gbCode: "BGR018",
            ciqCode: "100018"
        },
        {
            codeName: "巴林",
            cusCode: "102",
            codeValue: "BHR000",
            gbName: "巴林",
            gbCode: "BHR000",
            ciqCode: "048000"
        },
        {
            codeName: "奥巴杰蒂（巴林）",
            cusCode: "102",
            codeValue: "BHR003",
            gbName: "奥巴杰蒂（巴林）",
            gbCode: "BHR003",
            ciqCode: "048003"
        },
        {
            codeName: "巴林（巴林）",
            cusCode: "102",
            codeValue: "BHR004",
            gbName: "巴林（巴林）",
            gbCode: "BHR004",
            ciqCode: "048004"
        },
        {
            codeName: "麦纳麦（巴林）",
            cusCode: "1004",
            codeValue: "BHR005",
            gbName: "麦纳麦（巴林）",
            gbCode: "BHR005",
            ciqCode: "048005"
        },
        {
            codeName: "米纳苏尔曼（巴林）",
            cusCode: "1005",
            codeValue: "BHR006",
            gbName: "米纳苏尔曼（巴林）",
            gbCode: "BHR006",
            ciqCode: "048006"
        },
        {
            codeName: "锡特拉（巴林）",
            cusCode: "1006",
            codeValue: "BHR009",
            gbName: "锡特拉（巴林）",
            gbCode: "BHR009",
            ciqCode: "048009"
        },
        {
            codeName: "巴哈马",
            cusCode: "404",
            codeValue: "BHS000",
            gbName: "巴哈马",
            gbCode: "BHS000",
            ciqCode: "044000"
        },
        {
            codeName: "弗里波特（巴哈马）",
            cusCode: "404",
            codeValue: "BHS003",
            gbName: "弗里波特（巴哈马）",
            gbCode: "BHS003",
            ciqCode: "044003"
        },
        {
            codeName: "小圣萨尔瓦多岛（巴哈马）",
            cusCode: "404",
            codeValue: "BHS006",
            gbName: "小圣萨尔瓦多岛（巴哈马）",
            gbCode: "BHS006",
            ciqCode: "044006"
        },
        {
            codeName: "拿骚（巴哈马）",
            cusCode: "2729",
            codeValue: "BHS009",
            gbName: "拿骚（巴哈马）",
            gbCode: "BHS009",
            ciqCode: "044009"
        },
        {
            codeName: "南里登角（巴哈马）",
            cusCode: "404",
            codeValue: "BHS012",
            gbName: "南里登角（巴哈马）",
            gbCode: "BHS012",
            ciqCode: "044012"
        },
        {
            codeName: "波斯尼亚和黑塞哥维那",
            cusCode: "355",
            codeValue: "BIH000",
            gbName: "波斯尼亚和黑塞哥维那",
            gbCode: "BIH000",
            ciqCode: "070000"
        },
        {
            codeName: "圣巴泰勒米",
            cusCode: "450",
            codeValue: "BLM000",
            gbName: "圣巴泰勒米",
            gbCode: "BLM000",
            ciqCode: "652000"
        },
        {
            codeName: "白俄罗斯",
            cusCode: "340",
            codeValue: "BLR000",
            gbName: "白俄罗斯",
            gbCode: "BLR000",
            ciqCode: "112000"
        },
        {
            codeName: "伯利兹",
            cusCode: "406",
            codeValue: "BLZ000",
            gbName: "伯利兹",
            gbCode: "BLZ000",
            ciqCode: "084000"
        },
        {
            codeName: "贝尔莫潘（伯利兹）",
            cusCode: "2732",
            codeValue: "BLZ001",
            gbName: "贝尔莫潘（伯利兹）",
            gbCode: "BLZ001",
            ciqCode: "084001"
        },
        {
            codeName: "伯利兹城（伯利兹）",
            cusCode: "2731",
            codeValue: "BLZ003",
            gbName: "伯利兹城（伯利兹）",
            gbCode: "BLZ003",
            ciqCode: "084003"
        },
        {
            codeName: "百慕大",
            cusCode: "504",
            codeValue: "BMU000",
            gbName: "百慕大",
            gbCode: "BMU000",
            ciqCode: "060000"
        },
        {
            codeName: "哈密尔顿（百慕大）",
            cusCode: "2733",
            codeValue: "BMU003",
            gbName: "哈密尔顿（百慕大）",
            gbCode: "BMU003",
            ciqCode: "060003"
        },
        {
            codeName: "圣乔治（百慕大）",
            cusCode: "2734",
            codeValue: "BMU006",
            gbName: "圣乔治（百慕大）",
            gbCode: "BMU006",
            ciqCode: "060006"
        },
        {
            codeName: "玻利维亚",
            cusCode: "408",
            codeValue: "BOL000",
            gbName: "玻利维亚",
            gbCode: "BOL000",
            ciqCode: "068000"
        },
        {
            codeName: "巴西",
            cusCode: "410",
            codeValue: "BRA000",
            gbName: "巴西",
            gbCode: "BRA000",
            ciqCode: "076000"
        },
        {
            codeName: "安格拉-杜斯雷斯（巴西）",
            cusCode: "2736",
            codeValue: "BRA003",
            gbName: "安格拉-杜斯雷斯（巴西）",
            gbCode: "BRA003",
            ciqCode: "076003"
        },
        {
            codeName: "阿拉卡茹（巴西）",
            cusCode: "410",
            codeValue: "BRA006",
            gbName: "阿拉卡茹（巴西）",
            gbCode: "BRA006",
            ciqCode: "076006"
        },
        {
            codeName: "阿拉卡蒂（巴西）",
            cusCode: "410",
            codeValue: "BRA009",
            gbName: "阿拉卡蒂（巴西）",
            gbCode: "BRA009",
            ciqCode: "076009"
        },
        {
            codeName: "阿拉图（巴西）",
            cusCode: "410",
            codeValue: "BRA012",
            gbName: "阿拉图（巴西）",
            gbCode: "BRA012",
            ciqCode: "076012"
        },
        {
            codeName: "阿里亚布兰卡（巴西）",
            cusCode: "410",
            codeValue: "BRA015",
            gbName: "阿里亚布兰卡（巴西）",
            gbCode: "BRA015",
            ciqCode: "076015"
        },
        {
            codeName: "巴拉奥特菲（巴西）",
            cusCode: "410",
            codeValue: "BRA018",
            gbName: "巴拉奥特菲（巴西）",
            gbCode: "BRA018",
            ciqCode: "076018"
        },
        {
            codeName: "贝伦（巴西）",
            cusCode: "2739",
            codeValue: "BRA021",
            gbName: "贝伦（巴西）",
            gbCode: "BRA021",
            ciqCode: "076021"
        },
        {
            codeName: "卡贝德卢（巴西）",
            cusCode: "410",
            codeValue: "BRA024",
            gbName: "卡贝德卢（巴西）",
            gbCode: "BRA024",
            ciqCode: "076024"
        },
        {
            codeName: "弗洛里亚诺波利斯（巴西）",
            cusCode: "410",
            codeValue: "BRA027",
            gbName: "弗洛里亚诺波利斯（巴西）",
            gbCode: "BRA027",
            ciqCode: "076027"
        },
        {
            codeName: "福塔莱萨（巴西）",
            cusCode: "2742",
            codeValue: "BRA030",
            gbName: "福塔莱萨（巴西）",
            gbCode: "BRA030",
            ciqCode: "076030"
        },
        {
            codeName: "伊列乌斯（巴西）",
            cusCode: "410",
            codeValue: "BRA033",
            gbName: "伊列乌斯（巴西）",
            gbCode: "BRA033",
            ciqCode: "076033"
        },
        {
            codeName: "因比图巴（巴西）",
            cusCode: "2741",
            codeValue: "BRA036",
            gbName: "因比图巴（巴西）",
            gbCode: "BRA036",
            ciqCode: "076036"
        },
        {
            codeName: "伊塔雅伊（巴西）",
            cusCode: "2743",
            codeValue: "BRA039",
            gbName: "伊塔雅伊（巴西）",
            gbCode: "BRA039",
            ciqCode: "076039"
        },
        {
            codeName: "伊塔基（巴西）",
            cusCode: "410",
            codeValue: "BRA042",
            gbName: "伊塔基（巴西）",
            gbCode: "BRA042",
            ciqCode: "076042"
        },
        {
            codeName: "若昂佩索阿（巴西）",
            cusCode: "410",
            codeValue: "BRA045",
            gbName: "若昂佩索阿（巴西）",
            gbCode: "BRA045",
            ciqCode: "076045"
        },
        {
            codeName: "马卡帕（巴西）",
            cusCode: "2744",
            codeValue: "BRA048",
            gbName: "马卡帕（巴西）",
            gbCode: "BRA048",
            ciqCode: "076048"
        },
        {
            codeName: "马塞约（巴西）",
            cusCode: "2745",
            codeValue: "BRA051",
            gbName: "马塞约（巴西）",
            gbCode: "BRA051",
            ciqCode: "076051"
        },
        {
            codeName: "马瑙斯（巴西）",
            cusCode: "2746",
            codeValue: "BRA054",
            gbName: "马瑙斯（巴西）",
            gbCode: "BRA054",
            ciqCode: "076054"
        },
        {
            codeName: "纳塔尔（巴西）",
            cusCode: "2748",
            codeValue: "BRA057",
            gbName: "纳塔尔（巴西）",
            gbCode: "BRA057",
            ciqCode: "076057"
        },
        {
            codeName: "尼泰罗伊（巴西）",
            cusCode: "2749",
            codeValue: "BRA060",
            gbName: "尼泰罗伊（巴西）",
            gbCode: "BRA060",
            ciqCode: "076060"
        },
        {
            codeName: "巴拉那瓜（巴西）",
            cusCode: "2751",
            codeValue: "BRA063",
            gbName: "巴拉那瓜（巴西）",
            gbCode: "BRA063",
            ciqCode: "076063"
        },
        {
            codeName: "巴纳伊巴（巴西）",
            cusCode: "410",
            codeValue: "BRA066",
            gbName: "巴纳伊巴（巴西）",
            gbCode: "BRA066",
            ciqCode: "076066"
        },
        {
            codeName: "佩洛塔斯（巴西）",
            cusCode: "2752",
            codeValue: "BRA069",
            gbName: "佩洛塔斯（巴西）",
            gbCode: "BRA069",
            ciqCode: "076069"
        },
        {
            codeName: "乌布角（巴西）",
            cusCode: "410",
            codeValue: "BRA072",
            gbName: "乌布角（巴西）",
            gbCode: "BRA072",
            ciqCode: "076072"
        },
        {
            codeName: "阿雷格里港（巴西）",
            cusCode: "2753",
            codeValue: "BRA075",
            gbName: "阿雷格里港（巴西）",
            gbCode: "BRA075",
            ciqCode: "076075"
        },
        {
            codeName: "波图塞尔（巴西）",
            cusCode: "410",
            codeValue: "BRA078",
            gbName: "波图塞尔（巴西）",
            gbCode: "BRA078",
            ciqCode: "076078"
        },
        {
            codeName: "累西腓（巴西）",
            cusCode: "2758",
            codeValue: "BRA081",
            gbName: "累西腓（巴西）",
            gbCode: "BRA081",
            ciqCode: "076081"
        },
        {
            codeName: "里约热内卢（巴西）",
            cusCode: "2754",
            codeValue: "BRA084",
            gbName: "里约热内卢（巴西）",
            gbCode: "BRA084",
            ciqCode: "076084"
        },
        {
            codeName: "里奥格兰德（巴西）",
            cusCode: "2755",
            codeValue: "BRA087",
            gbName: "里奥格兰德（巴西）",
            gbCode: "BRA087",
            ciqCode: "076087"
        },
        {
            codeName: "萨尔瓦多（巴西）",
            cusCode: "2738",
            codeValue: "BRA090",
            gbName: "萨尔瓦多（巴西）",
            gbCode: "BRA090",
            ciqCode: "076090"
        },
        {
            codeName: "圣安娜（巴西）",
            cusCode: "2761",
            codeValue: "BRA093",
            gbName: "圣安娜（巴西）",
            gbCode: "BRA093",
            ciqCode: "076093"
        },
        {
            codeName: "圣塔伦（巴西）",
            cusCode: "410",
            codeValue: "BRA096",
            gbName: "圣塔伦（巴西）",
            gbCode: "BRA096",
            ciqCode: "076096"
        },
        {
            codeName: "桑托斯（巴西）",
            cusCode: "2762",
            codeValue: "BRA099",
            gbName: "桑托斯（巴西）",
            gbCode: "BRA099",
            ciqCode: "076099"
        },
        {
            codeName: "南圣弗兰西斯科（巴西）",
            cusCode: "2763",
            codeValue: "BRA102",
            gbName: "南圣弗兰西斯科（巴西）",
            gbCode: "BRA102",
            ciqCode: "076102"
        },
        {
            codeName: "圣路易斯（巴西）",
            cusCode: "2764",
            codeValue: "BRA105",
            gbName: "圣路易斯（巴西）",
            gbCode: "BRA105",
            ciqCode: "076105"
        },
        {
            codeName: "圣保罗（巴西）",
            cusCode: "410",
            codeValue: "BRA108",
            gbName: "圣保罗（巴西）",
            gbCode: "BRA108",
            ciqCode: "076108"
        },
        {
            codeName: "圣塞巴斯蒂昂（巴西）",
            cusCode: "2765",
            codeValue: "BRA111",
            gbName: "圣塞巴斯蒂昂（巴西）",
            gbCode: "BRA111",
            ciqCode: "076111"
        },
        {
            codeName: "塞佩提巴（巴西）",
            cusCode: "410",
            codeValue: "BRA114",
            gbName: "塞佩提巴（巴西）",
            gbCode: "BRA114",
            ciqCode: "076114"
        },
        {
            codeName: "特拉曼达伊（巴西）",
            cusCode: "410",
            codeValue: "BRA117",
            gbName: "特拉曼达伊（巴西）",
            gbCode: "BRA117",
            ciqCode: "076117"
        },
        {
            codeName: "特龙贝塔斯（巴西）",
            cusCode: "410",
            codeValue: "BRA120",
            gbName: "特龙贝塔斯（巴西）",
            gbCode: "BRA120",
            ciqCode: "076120"
        },
        {
            codeName: "图巴朗（巴西）",
            cusCode: "2757",
            codeValue: "BRA123",
            gbName: "图巴朗（巴西）",
            gbCode: "BRA123",
            ciqCode: "076123"
        },
        {
            codeName: "维多利亚（巴西）",
            cusCode: "2766",
            codeValue: "BRA126",
            gbName: "维多利亚（巴西）",
            gbCode: "BRA126",
            ciqCode: "076126"
        },
        {
            codeName: "安托尼纳（巴西）",
            cusCode: "2737",
            codeValue: "BRA127",
            gbName: "安托尼纳（巴西）",
            gbCode: "BRA127",
            ciqCode: "076127"
        },
        {
            codeName: "福塔雷扎（巴西）",
            cusCode: "2747",
            codeValue: "BRA128",
            gbName: "福塔雷扎（巴西）",
            gbCode: "BRA128",
            ciqCode: "076128"
        },
        {
            codeName: "海纳（巴西）",
            cusCode: "2756",
            codeValue: "BRA129",
            gbName: "海纳（巴西）",
            gbCode: "BRA129",
            ciqCode: "076129"
        },
        {
            codeName: "里亚桥（巴西）",
            cusCode: "2740",
            codeValue: "BRA130",
            gbName: "里亚桥（巴西）",
            gbCode: "BRA130",
            ciqCode: "076130"
        },
        {
            codeName: "萨尔塔卡瓦略（巴西）",
            cusCode: "2760",
            codeValue: "BRA132",
            gbName: "萨尔塔卡瓦略（巴西）",
            gbCode: "BRA132",
            ciqCode: "076132"
        },
        {
            codeName: "巴巴多斯",
            cusCode: "405",
            codeValue: "BRB000",
            gbName: "巴巴多斯",
            gbCode: "BRB000",
            ciqCode: "052000"
        },
        {
            codeName: "布里奇敦（巴巴多斯）",
            cusCode: "2730",
            codeValue: "BRB003",
            gbName: "布里奇敦（巴巴多斯）",
            gbCode: "BRB003",
            ciqCode: "052003"
        },
        {
            codeName: "文莱",
            cusCode: "105",
            codeValue: "BRN000",
            gbName: "文莱",
            gbCode: "BRN000",
            ciqCode: "096000"
        },
        {
            codeName: "文莱（文莱）",
            cusCode: "1011",
            codeValue: "BRN001",
            gbName: "文莱（文莱）",
            gbCode: "BRN001",
            ciqCode: "096001"
        },
        {
            codeName: "斯里巴加湾港（文莱）",
            cusCode: "1010",
            codeValue: "BRN003",
            gbName: "斯里巴加湾港（文莱）",
            gbCode: "BRN003",
            ciqCode: "096003"
        },
        {
            codeName: "白拉奕（文莱）",
            cusCode: "105",
            codeValue: "BRN006",
            gbName: "白拉奕（文莱）",
            gbCode: "BRN006",
            ciqCode: "096006"
        },
        {
            codeName: "麻拉（文莱）",
            cusCode: "105",
            codeValue: "BRN008",
            gbName: "麻拉（文莱）",
            gbCode: "BRN008",
            ciqCode: "096008"
        },
        {
            codeName: "穆阿拉港（文莱）",
            cusCode: "105",
            codeValue: "BRN009",
            gbName: "穆阿拉港（文莱）",
            gbCode: "BRN009",
            ciqCode: "096009"
        },
        {
            codeName: "诗里亚（文莱）",
            cusCode: "105",
            codeValue: "BRN012",
            gbName: "诗里亚（文莱）",
            gbCode: "BRN012",
            ciqCode: "096012"
        },
        {
            codeName: "丹戎沙利隆（文莱）",
            cusCode: "105",
            codeValue: "BRN015",
            gbName: "丹戎沙利隆（文莱）",
            gbCode: "BRN015",
            ciqCode: "096015"
        },
        {
            codeName: "不丹",
            cusCode: "104",
            codeValue: "BTN000",
            gbName: "不丹",
            gbCode: "BTN000",
            ciqCode: "064000"
        },
        {
            codeName: "布维岛",
            cusCode: "451",
            codeValue: "BVT000",
            gbName: "布维岛",
            gbCode: "BVT000",
            ciqCode: "074000"
        },
        {
            codeName: "博茨瓦纳",
            cusCode: "204",
            codeValue: "BWA000",
            gbName: "博茨瓦纳",
            gbCode: "BWA000",
            ciqCode: "072000"
        },
        {
            codeName: "中非",
            cusCode: "209",
            codeValue: "CAF000",
            gbName: "中非",
            gbCode: "CAF000",
            ciqCode: "140000"
        },
        {
            codeName: "加那利群岛",
            cusCode: "207",
            codeValue: "CAI000",
            gbName: "加那利群岛",
            gbCode: "CAI000",
            ciqCode: "710901"
        },
        {
            codeName: "加拿大",
            cusCode: "501",
            codeValue: "CAN000",
            gbName: "加拿大",
            gbCode: "CAN000",
            ciqCode: "124000"
        },
        {
            codeName: "阿克拉维克（加拿大）",
            cusCode: "501",
            codeValue: "CAN003",
            gbName: "阿克拉维克（加拿大）",
            gbCode: "CAN003",
            ciqCode: "124003"
        },
        {
            codeName: "阿默斯特（加拿大）",
            cusCode: "501",
            codeValue: "CAN006",
            gbName: "阿默斯特（加拿大）",
            gbCode: "CAN006",
            ciqCode: "124006"
        },
        {
            codeName: "阿默斯特堡 ，阿默斯特港（加拿大）",
            cusCode: "2990",
            codeValue: "CAN009",
            gbName: "阿默斯特堡 ，阿默斯特港（加拿大）",
            gbCode: "CAN009",
            ciqCode: "124009"
        },
        {
            codeName: "安纳波利斯（加拿大）",
            cusCode: "501",
            codeValue: "CAN012",
            gbName: "安纳波利斯（加拿大）",
            gbCode: "CAN012",
            ciqCode: "124012"
        },
        {
            codeName: "阿真舍（加拿大）",
            cusCode: "501",
            codeValue: "CAN015",
            gbName: "阿真舍（加拿大）",
            gbCode: "CAN015",
            ciqCode: "124015"
        },
        {
            codeName: "阿里沙特（加拿大）",
            cusCode: "2991",
            codeValue: "CAN018",
            gbName: "阿里沙特（加拿大）",
            gbCode: "CAN018",
            ciqCode: "124018"
        },
        {
            codeName: "巴德克（加拿大）",
            cusCode: "2992",
            codeValue: "CAN021",
            gbName: "巴德克（加拿大）",
            gbCode: "CAN021",
            ciqCode: "124021"
        },
        {
            codeName: "巴戈特维尔（加拿大）",
            cusCode: "501",
            codeValue: "CAN024",
            gbName: "巴戈特维尔（加拿大）",
            gbCode: "CAN024",
            ciqCode: "124024"
        },
        {
            codeName: "贝科莫（加拿大）",
            cusCode: "3001",
            codeValue: "CAN027",
            gbName: "贝科莫（加拿大）",
            gbCode: "CAN027",
            ciqCode: "124027"
        },
        {
            codeName: "巴斯克湾（加拿大）",
            cusCode: "501",
            codeValue: "CAN030",
            gbName: "巴斯克湾（加拿大）",
            gbCode: "CAN030",
            ciqCode: "124030"
        },
        {
            codeName: "巴瑟斯特（加拿大）",
            cusCode: "2993",
            codeValue: "CAN033",
            gbName: "巴瑟斯特（加拿大）",
            gbCode: "CAN033",
            ciqCode: "124033"
        },
        {
            codeName: "贝罗伯茨（加拿大）",
            cusCode: "2994",
            codeValue: "CAN036",
            gbName: "贝罗伯茨（加拿大）",
            gbCode: "CAN036",
            ciqCode: "124036"
        },
        {
            codeName: "比弗港（加拿大）",
            cusCode: "501",
            codeValue: "CAN039",
            gbName: "比弗港（加拿大）",
            gbCode: "CAN039",
            ciqCode: "124039"
        },
        {
            codeName: "贝拉顿（加拿大）",
            cusCode: "501",
            codeValue: "CAN045",
            gbName: "贝拉顿（加拿大）",
            gbCode: "CAN045",
            ciqCode: "124045"
        },
        {
            codeName: "博特伍德（加拿大）",
            cusCode: "2995",
            codeValue: "CAN048",
            gbName: "博特伍德（加拿大）",
            gbCode: "CAN048",
            ciqCode: "124048"
        },
        {
            codeName: "布里奇沃特（加拿大）",
            cusCode: "2996",
            codeValue: "CAN051",
            gbName: "布里奇沃特（加拿大）",
            gbCode: "CAN051",
            ciqCode: "124051"
        },
        {
            codeName: "布罗克维尔（加拿大）",
            cusCode: "2997",
            codeValue: "CAN054",
            gbName: "布罗克维尔（加拿大）",
            gbCode: "CAN054",
            ciqCode: "124054"
        },
        {
            codeName: "巴克图什（加拿大）",
            cusCode: "2999",
            codeValue: "CAN057",
            gbName: "巴克图什（加拿大）",
            gbCode: "CAN057",
            ciqCode: "124057"
        },
        {
            codeName: "伯吉奥（加拿大）",
            cusCode: "501",
            codeValue: "CAN060",
            gbName: "伯吉奥（加拿大）",
            gbCode: "CAN060",
            ciqCode: "124060"
        },
        {
            codeName: "布林（加拿大）",
            cusCode: "501",
            codeValue: "CAN063",
            gbName: "布林（加拿大）",
            gbCode: "CAN063",
            ciqCode: "124063"
        },
        {
            codeName: "坎贝尔顿（加拿大）",
            cusCode: "3000",
            codeValue: "CAN066",
            gbName: "坎贝尔顿（加拿大）",
            gbCode: "CAN066",
            ciqCode: "124066"
        },
        {
            codeName: "坎索港（加拿大）",
            cusCode: "501",
            codeValue: "CAN069",
            gbName: "坎索港（加拿大）",
            gbCode: "CAN069",
            ciqCode: "124069"
        },
        {
            codeName: "卡拉凯特（加拿大）",
            cusCode: "3009",
            codeValue: "CAN072",
            gbName: "卡拉凯特（加拿大）",
            gbCode: "CAN072",
            ciqCode: "124072"
        },
        {
            codeName: "卡尔顿（加拿大）",
            cusCode: "3010",
            codeValue: "CAN075",
            gbName: "卡尔顿（加拿大）",
            gbCode: "CAN075",
            ciqCode: "124075"
        },
        {
            codeName: "夏洛特敦（加拿大）",
            cusCode: "3002",
            codeValue: "CAN078",
            gbName: "夏洛特敦（加拿大）",
            gbCode: "CAN078",
            ciqCode: "124078"
        },
        {
            codeName: "查塔姆（加拿大）",
            cusCode: "3011",
            codeValue: "CAN084",
            gbName: "查塔姆（加拿大）",
            gbCode: "CAN084",
            ciqCode: "124084"
        },
        {
            codeName: "彻梅纳斯（加拿大）",
            cusCode: "3012",
            codeValue: "CAN087",
            gbName: "彻梅纳斯（加拿大）",
            gbCode: "CAN087",
            ciqCode: "124087"
        },
        {
            codeName: "谢蒂坎普（加拿大）",
            cusCode: "501",
            codeValue: "CAN090",
            gbName: "谢蒂坎普（加拿大）",
            gbCode: "CAN090",
            ciqCode: "124090"
        },
        {
            codeName: "希库提米（加拿大）",
            cusCode: "501",
            codeValue: "CAN093",
            gbName: "希库提米（加拿大）",
            gbCode: "CAN093",
            ciqCode: "124093"
        },
        {
            codeName: "丘吉尔（加拿大）",
            cusCode: "3013",
            codeValue: "CAN096",
            gbName: "丘吉尔（加拿大）",
            gbCode: "CAN096",
            ciqCode: "124096"
        },
        {
            codeName: "克拉伦维尔（加拿大）",
            cusCode: "501",
            codeValue: "CAN099",
            gbName: "克拉伦维尔（加拿大）",
            gbCode: "CAN099",
            ciqCode: "124099"
        },
        {
            codeName: "科堡（加拿大）",
            cusCode: "501",
            codeValue: "CAN102",
            gbName: "科堡（加拿大）",
            gbCode: "CAN102",
            ciqCode: "124102"
        },
        {
            codeName: "科灵伍德（加拿大）",
            cusCode: "3016",
            codeValue: "CAN105",
            gbName: "科灵伍德（加拿大）",
            gbCode: "CAN105",
            ciqCode: "124105"
        },
        {
            codeName: "卡姆拜钱斯（加拿大）",
            cusCode: "501",
            codeValue: "CAN108",
            gbName: "卡姆拜钱斯（加拿大）",
            gbCode: "CAN108",
            ciqCode: "124108"
        },
        {
            codeName: "科纳－布鲁特（加拿大）",
            cusCode: "3019",
            codeValue: "CAN111",
            gbName: "科纳－布鲁特（加拿大）",
            gbCode: "CAN111",
            ciqCode: "124111"
        },
        {
            codeName: "科莫克斯（加拿大）",
            cusCode: "3017",
            codeValue: "CAN114",
            gbName: "科莫克斯（加拿大）",
            gbCode: "CAN114",
            ciqCode: "124114"
        },
        {
            codeName: "孔特勒科尔（加拿大）",
            cusCode: "3018",
            codeValue: "CAN117",
            gbName: "孔特勒科尔（加拿大）",
            gbCode: "CAN117",
            ciqCode: "124117"
        },
        {
            codeName: "康沃尔（加拿大）",
            cusCode: "3020",
            codeValue: "CAN120",
            gbName: "康沃尔（加拿大）",
            gbCode: "CAN120",
            ciqCode: "124120"
        },
        {
            codeName: "康特里港（加拿大）",
            cusCode: "3021",
            codeValue: "CAN123",
            gbName: "康特里港（加拿大）",
            gbCode: "CAN123",
            ciqCode: "124123"
        },
        {
            codeName: "科威恰湾（加拿大）",
            cusCode: "501",
            codeValue: "CAN126",
            gbName: "科威恰湾（加拿大）",
            gbCode: "CAN126",
            ciqCode: "124126"
        },
        {
            codeName: "克罗夫顿（加拿大）",
            cusCode: "501",
            codeValue: "CAN129",
            gbName: "克罗夫顿（加拿大）",
            gbCode: "CAN129",
            ciqCode: "124129"
        },
        {
            codeName: "达尔豪西（加拿大）",
            cusCode: "3022",
            codeValue: "CAN132",
            gbName: "达尔豪西（加拿大）",
            gbCode: "CAN132",
            ciqCode: "124132"
        },
        {
            codeName: "迪格比（加拿大）",
            cusCode: "3023",
            codeValue: "CAN135",
            gbName: "迪格比（加拿大）",
            gbCode: "CAN135",
            ciqCode: "124135"
        },
        {
            codeName: "丁沃尔（加拿大）",
            cusCode: "501",
            codeValue: "CAN138",
            gbName: "丁沃尔（加拿大）",
            gbCode: "CAN138",
            ciqCode: "124138"
        },
        {
            codeName: "多米诺（加拿大）",
            cusCode: "501",
            codeValue: "CAN141",
            gbName: "多米诺（加拿大）",
            gbCode: "CAN141",
            ciqCode: "124141"
        },
        {
            codeName: "埃斯奎莫尔特（加拿大）",
            cusCode: "501",
            codeValue: "CAN144",
            gbName: "埃斯奎莫尔特（加拿大）",
            gbCode: "CAN144",
            ciqCode: "124144"
        },
        {
            codeName: "福雷斯特维尔（加拿大）",
            cusCode: "501",
            codeValue: "CAN147",
            gbName: "福雷斯特维尔（加拿大）",
            gbCode: "CAN147",
            ciqCode: "124147"
        },
        {
            codeName: "弗罗比舍湾（加拿大）",
            cusCode: "501",
            codeValue: "CAN150",
            gbName: "弗罗比舍湾（加拿大）",
            gbCode: "CAN150",
            ciqCode: "124150"
        },
        {
            codeName: "加斯佩（加拿大）",
            cusCode: "501",
            codeValue: "CAN153",
            gbName: "加斯佩（加拿大）",
            gbCode: "CAN153",
            ciqCode: "124153"
        },
        {
            codeName: "乔治敦（加拿大）",
            cusCode: "3003",
            codeValue: "CAN156",
            gbName: "乔治敦（加拿大）",
            gbCode: "CAN156",
            ciqCode: "124156"
        },
        {
            codeName: "戈德里奇（加拿大）",
            cusCode: "501",
            codeValue: "CAN159",
            gbName: "戈德里奇（加拿大）",
            gbCode: "CAN159",
            ciqCode: "124159"
        },
        {
            codeName: "戈尔德里弗（加拿大）",
            cusCode: "501",
            codeValue: "CAN162",
            gbName: "戈尔德里弗（加拿大）",
            gbCode: "CAN162",
            ciqCode: "124162"
        },
        {
            codeName: "古斯湾（加拿大）",
            cusCode: "3004",
            codeValue: "CAN165",
            gbName: "古斯湾（加拿大）",
            gbCode: "CAN165",
            ciqCode: "124165"
        },
        {
            codeName: "格兰德班克（加拿大）",
            cusCode: "501",
            codeValue: "CAN168",
            gbName: "格兰德班克（加拿大）",
            gbCode: "CAN168",
            ciqCode: "124168"
        },
        {
            codeName: "哈利法克斯（加拿大）",
            cusCode: "3005",
            codeValue: "CAN171",
            gbName: "哈利法克斯（加拿大）",
            gbCode: "CAN171",
            ciqCode: "124171"
        },
        {
            codeName: "哈密尔顿（加拿大）",
            cusCode: "3006",
            codeValue: "CAN174",
            gbName: "哈密尔顿（加拿大）",
            gbCode: "CAN174",
            ciqCode: "124174"
        },
        {
            codeName: "汉茨波特（加拿大）",
            cusCode: "3024",
            codeValue: "CAN177",
            gbName: "汉茨波特（加拿大）",
            gbCode: "CAN177",
            ciqCode: "124177"
        },
        {
            codeName: "格雷斯港（加拿大）",
            cusCode: "3025",
            codeValue: "CAN180",
            gbName: "格雷斯港（加拿大）",
            gbCode: "CAN180",
            ciqCode: "124180"
        },
        {
            codeName: "哈麦克（加拿大）",
            cusCode: "501",
            codeValue: "CAN183",
            gbName: "哈麦克（加拿大）",
            gbCode: "CAN183",
            ciqCode: "124183"
        },
        {
            codeName: "哈佛圣皮埃尔（加拿大）",
            cusCode: "3026",
            codeValue: "CAN186",
            gbName: "哈佛圣皮埃尔（加拿大）",
            gbCode: "CAN186",
            ciqCode: "124186"
        },
        {
            codeName: "哈茨康滕特（加拿大）",
            cusCode: "3028",
            codeValue: "CAN189",
            gbName: "哈茨康滕特（加拿大）",
            gbCode: "CAN189",
            ciqCode: "124189"
        },
        {
            codeName: "霍利鲁德（加拿大）",
            cusCode: "501",
            codeValue: "CAN192",
            gbName: "霍利鲁德（加拿大）",
            gbCode: "CAN192",
            ciqCode: "124192"
        },
        {
            codeName: "约纳（加拿大）",
            cusCode: "501",
            codeValue: "CAN195",
            gbName: "约纳（加拿大）",
            gbCode: "CAN195",
            ciqCode: "124195"
        },
        {
            codeName: "艾萨克斯港（加拿大）",
            cusCode: "3007",
            codeValue: "CAN198",
            gbName: "艾萨克斯港（加拿大）",
            gbCode: "CAN198",
            ciqCode: "124198"
        },
        {
            codeName: "金斯顿（加拿大）",
            cusCode: "3029",
            codeValue: "CAN201",
            gbName: "金斯顿（加拿大）",
            gbCode: "CAN201",
            ciqCode: "124201"
        },
        {
            codeName: "基提马特（加拿大）",
            cusCode: "3030",
            codeValue: "CAN204",
            gbName: "基提马特（加拿大）",
            gbCode: "CAN204",
            ciqCode: "124204"
        },
        {
            codeName: "拉阿沃（加拿大）",
            cusCode: "3031",
            codeValue: "CAN207",
            gbName: "拉阿沃（加拿大）",
            gbCode: "CAN207",
            ciqCode: "124207"
        },
        {
            codeName: "利明顿（加拿大）",
            cusCode: "3032",
            codeValue: "CAN210",
            gbName: "利明顿（加拿大）",
            gbCode: "CAN210",
            ciqCode: "124210"
        },
        {
            codeName: "利斯科姆（加拿大）",
            cusCode: "3034",
            codeValue: "CAN213",
            gbName: "利斯科姆（加拿大）",
            gbCode: "CAN213",
            ciqCode: "124213"
        },
        {
            codeName: "小窄峡（加拿大）",
            cusCode: "501",
            codeValue: "CAN216",
            gbName: "小窄峡（加拿大）",
            gbCode: "CAN216",
            ciqCode: "124216"
        },
        {
            codeName: "利物浦（加拿大）",
            cusCode: "501",
            codeValue: "CAN219",
            gbName: "利物浦（加拿大）",
            gbCode: "CAN219",
            ciqCode: "124219"
        },
        {
            codeName: "洛克波特（加拿大）",
            cusCode: "501",
            codeValue: "CAN222",
            gbName: "洛克波特（加拿大）",
            gbCode: "CAN222",
            ciqCode: "124222"
        },
        {
            codeName: "洛蒙德（加拿大）",
            cusCode: "501",
            codeValue: "CAN225",
            gbName: "洛蒙德（加拿大）",
            gbCode: "CAN225",
            ciqCode: "124225"
        },
        {
            codeName: "路易斯堡（加拿大）",
            cusCode: "3035",
            codeValue: "CAN228",
            gbName: "路易斯堡（加拿大）",
            gbCode: "CAN228",
            ciqCode: "124228"
        },
        {
            codeName: "卢嫩堡（加拿大）",
            cusCode: "3036",
            codeValue: "CAN231",
            gbName: "卢嫩堡（加拿大）",
            gbCode: "CAN231",
            ciqCode: "124231"
        },
        {
            codeName: "马塔讷（加拿大）",
            cusCode: "3037",
            codeValue: "CAN234",
            gbName: "马塔讷（加拿大）",
            gbCode: "CAN234",
            ciqCode: "124234"
        },
        {
            codeName: "梅泰根（加拿大）",
            cusCode: "3038",
            codeValue: "CAN237",
            gbName: "梅泰根（加拿大）",
            gbCode: "CAN237",
            ciqCode: "124237"
        },
        {
            codeName: "米奇皮科滕（加拿大）",
            cusCode: "501",
            codeValue: "CAN240",
            gbName: "米奇皮科滕（加拿大）",
            gbCode: "CAN240",
            ciqCode: "124240"
        },
        {
            codeName: "米德兰（加拿大）",
            cusCode: "3039",
            codeValue: "CAN243",
            gbName: "米德兰（加拿大）",
            gbCode: "CAN243",
            ciqCode: "124243"
        },
        {
            codeName: "蒙路易（加拿大）",
            cusCode: "3041",
            codeValue: "CAN246",
            gbName: "蒙路易（加拿大）",
            gbCode: "CAN246",
            ciqCode: "124246"
        },
        {
            codeName: "蒙塔古（加拿大）",
            cusCode: "501",
            codeValue: "CAN249",
            gbName: "蒙塔古（加拿大）",
            gbCode: "CAN249",
            ciqCode: "124249"
        },
        {
            codeName: "蒙特利尔（加拿大）",
            cusCode: "3042",
            codeValue: "CAN252",
            gbName: "蒙特利尔（加拿大）",
            gbCode: "CAN252",
            ciqCode: "124252"
        },
        {
            codeName: "纳奈莫（加拿大）",
            cusCode: "3043",
            codeValue: "CAN255",
            gbName: "纳奈莫（加拿大）",
            gbCode: "CAN255",
            ciqCode: "124255"
        },
        {
            codeName: "纳尼斯维克（加拿大）",
            cusCode: "501",
            codeValue: "CAN258",
            gbName: "纳尼斯维克（加拿大）",
            gbCode: "CAN258",
            ciqCode: "124258"
        },
        {
            codeName: "新格拉斯哥（加拿大）",
            cusCode: "3045",
            codeValue: "CAN261",
            gbName: "新格拉斯哥（加拿大）",
            gbCode: "CAN261",
            ciqCode: "124261"
        },
        {
            codeName: "新里士满（加拿大）",
            cusCode: "501",
            codeValue: "CAN264",
            gbName: "新里士满（加拿大）",
            gbCode: "CAN264",
            ciqCode: "124264"
        },
        {
            codeName: "新威斯敏斯特（加拿大）",
            cusCode: "3046",
            codeValue: "CAN267",
            gbName: "新威斯敏斯特（加拿大）",
            gbCode: "CAN267",
            ciqCode: "124267"
        },
        {
            codeName: "纽卡斯尔（加拿大）",
            cusCode: "501",
            codeValue: "CAN270",
            gbName: "纽卡斯尔（加拿大）",
            gbCode: "CAN270",
            ciqCode: "124270"
        },
        {
            codeName: "北锡德尼（加拿大）",
            cusCode: "3047",
            codeValue: "CAN273",
            gbName: "北锡德尼（加拿大）",
            gbCode: "CAN273",
            ciqCode: "124273"
        },
        {
            codeName: "奥克维尔（加拿大）",
            cusCode: "3048",
            codeValue: "CAN276",
            gbName: "奥克维尔（加拿大）",
            gbCode: "CAN276",
            ciqCode: "124276"
        },
        {
            codeName: "福尔斯海（加拿大）",
            cusCode: "3050",
            codeValue: "CAN279",
            gbName: "福尔斯海（加拿大）",
            gbCode: "CAN279",
            ciqCode: "124279"
        },
        {
            codeName: "奥沙瓦（加拿大）",
            cusCode: "3051",
            codeValue: "CAN282",
            gbName: "奥沙瓦（加拿大）",
            gbCode: "CAN282",
            ciqCode: "124282"
        },
        {
            codeName: "欧文桑德（加拿大）",
            cusCode: "3049",
            codeValue: "CAN285",
            gbName: "欧文桑德（加拿大）",
            gbCode: "CAN285",
            ciqCode: "124285"
        },
        {
            codeName: "帕斯博勒（加拿大）",
            cusCode: "3053",
            codeValue: "CAN288",
            gbName: "帕斯博勒（加拿大）",
            gbCode: "CAN288",
            ciqCode: "124288"
        },
        {
            codeName: "帕里桑德（加拿大）",
            cusCode: "3054",
            codeValue: "CAN291",
            gbName: "帕里桑德（加拿大）",
            gbCode: "CAN291",
            ciqCode: "124291"
        },
        {
            codeName: "帕斯佩比亚克（加拿大）",
            cusCode: "3055",
            codeValue: "CAN294",
            gbName: "帕斯佩比亚克（加拿大）",
            gbCode: "CAN294",
            ciqCode: "124294"
        },
        {
            codeName: "皮克图（加拿大）",
            cusCode: "3056",
            codeValue: "CAN297",
            gbName: "皮克图（加拿大）",
            gbCode: "CAN297",
            ciqCode: "124297"
        },
        {
            codeName: "图佩尔角（加拿大）",
            cusCode: "501",
            codeValue: "CAN300",
            gbName: "图佩尔角（加拿大）",
            gbCode: "CAN300",
            ciqCode: "124300"
        },
        {
            codeName: "黑角（加拿大）",
            cusCode: "501",
            codeValue: "CAN303",
            gbName: "黑角（加拿大）",
            gbCode: "CAN303",
            ciqCode: "124303"
        },
        {
            codeName: "艾伯尼港（加拿大）",
            cusCode: "3058",
            codeValue: "CAN306",
            gbName: "艾伯尼港（加拿大）",
            gbCode: "CAN306",
            ciqCode: "124306"
        },
        {
            codeName: "艾尔弗雷德港（加拿大）",
            cusCode: "501",
            codeValue: "CAN309",
            gbName: "艾尔弗雷德港（加拿大）",
            gbCode: "CAN309",
            ciqCode: "124309"
        },
        {
            codeName: "艾利斯港（加拿大）",
            cusCode: "501",
            codeValue: "CAN312",
            gbName: "艾利斯港（加拿大）",
            gbCode: "CAN312",
            ciqCode: "124312"
        },
        {
            codeName: "奥克斯巴凯斯港（加拿大）",
            cusCode: "501",
            codeValue: "CAN315",
            gbName: "奥克斯巴凯斯港（加拿大）",
            gbCode: "CAN315",
            ciqCode: "124315"
        },
        {
            codeName: "卡捷港（加拿大）",
            cusCode: "501",
            codeValue: "CAN318",
            gbName: "卡捷港（加拿大）",
            gbCode: "CAN318",
            ciqCode: "124318"
        },
        {
            codeName: "科尔本港（加拿大）",
            cusCode: "3060",
            codeValue: "CAN321",
            gbName: "科尔本港（加拿大）",
            gbCode: "CAN321",
            ciqCode: "124321"
        },
        {
            codeName: "克雷迪特港（加拿大）",
            cusCode: "3061",
            codeValue: "CAN324",
            gbName: "克雷迪特港（加拿大）",
            gbCode: "CAN324",
            ciqCode: "124324"
        },
        {
            codeName: "达尔胡西港（加拿大）",
            cusCode: "501",
            codeValue: "CAN327",
            gbName: "达尔胡西港（加拿大）",
            gbCode: "CAN327",
            ciqCode: "124327"
        },
        {
            codeName: "霍克斯伯里港（加拿大）",
            cusCode: "3027",
            codeValue: "CAN330",
            gbName: "霍克斯伯里港（加拿大）",
            gbCode: "CAN330",
            ciqCode: "124330"
        },
        {
            codeName: "霍普辛普森港（加拿大）",
            cusCode: "501",
            codeValue: "CAN333",
            gbName: "霍普辛普森港（加拿大）",
            gbCode: "CAN333",
            ciqCode: "124333"
        },
        {
            codeName: "霍普港（加拿大）",
            cusCode: "501",
            codeValue: "CAN336",
            gbName: "霍普港（加拿大）",
            gbCode: "CAN336",
            ciqCode: "124336"
        },
        {
            codeName: "梅德韦港（加拿大）",
            cusCode: "501",
            codeValue: "CAN339",
            gbName: "梅德韦港（加拿大）",
            gbCode: "CAN339",
            ciqCode: "124339"
        },
        {
            codeName: "穆尔格拉维港（加拿大）",
            cusCode: "501",
            codeValue: "CAN342",
            gbName: "穆尔格拉维港（加拿大）",
            gbCode: "CAN342",
            ciqCode: "124342"
        },
        {
            codeName: "威莱尔港（加拿大）",
            cusCode: "501",
            codeValue: "CAN345",
            gbName: "威莱尔港（加拿大）",
            gbCode: "CAN345",
            ciqCode: "124345"
        },
        {
            codeName: "鲍威尔（加拿大）",
            cusCode: "501",
            codeValue: "CAN348",
            gbName: "鲍威尔（加拿大）",
            gbCode: "CAN348",
            ciqCode: "124348"
        },
        {
            codeName: "普雷斯科特（加拿大）",
            cusCode: "3062",
            codeValue: "CAN351",
            gbName: "普雷斯科特（加拿大）",
            gbCode: "CAN351",
            ciqCode: "124351"
        },
        {
            codeName: "鲁珀特港（加拿大）",
            cusCode: "3063",
            codeValue: "CAN354",
            gbName: "鲁珀特港（加拿大）",
            gbCode: "CAN354",
            ciqCode: "124354"
        },
        {
            codeName: "帕格沃希（加拿大）",
            cusCode: "3064",
            codeValue: "CAN357",
            gbName: "帕格沃希（加拿大）",
            gbCode: "CAN357",
            ciqCode: "124357"
        },
        {
            codeName: "魁北克（加拿大）",
            cusCode: "3065",
            codeValue: "CAN360",
            gbName: "魁北克（加拿大）",
            gbCode: "CAN360",
            ciqCode: "124360"
        },
        {
            codeName: "里奇巴克托（加拿大）",
            cusCode: "501",
            codeValue: "CAN363",
            gbName: "里奇巴克托（加拿大）",
            gbCode: "CAN363",
            ciqCode: "124363"
        },
        {
            codeName: "里穆斯基（加拿大）",
            cusCode: "501",
            codeValue: "CAN366",
            gbName: "里穆斯基（加拿大）",
            gbCode: "CAN366",
            ciqCode: "124366"
        },
        {
            codeName: "里维耶尔-迪卢（加拿大）",
            cusCode: "3066",
            codeValue: "CAN369",
            gbName: "里维耶尔-迪卢（加拿大）",
            gbCode: "CAN369",
            ciqCode: "124369"
        },
        {
            codeName: "罗伯茨湾（加拿大）",
            cusCode: "501",
            codeValue: "CAN372",
            gbName: "罗伯茨湾（加拿大）",
            gbCode: "CAN372",
            ciqCode: "124372"
        },
        {
            codeName: "萨尔尼亚（加拿大）",
            cusCode: "3067",
            codeValue: "CAN378",
            gbName: "萨尔尼亚（加拿大）",
            gbCode: "CAN378",
            ciqCode: "124378"
        },
        {
            codeName: "苏圣马丽（加拿大）",
            cusCode: "3068",
            codeValue: "CAN381",
            gbName: "苏圣马丽（加拿大）",
            gbCode: "CAN381",
            ciqCode: "124381"
        },
        {
            codeName: "七岛（塞提尔）（加拿大）",
            cusCode: "3069",
            codeValue: "CAN384",
            gbName: "七岛（塞提尔）（加拿大）",
            gbCode: "CAN384",
            ciqCode: "124384"
        },
        {
            codeName: "谢迪艾克（加拿大）",
            cusCode: "3070",
            codeValue: "CAN387",
            gbName: "谢迪艾克（加拿大）",
            gbCode: "CAN387",
            ciqCode: "124387"
        },
        {
            codeName: "希特港（加拿大）",
            cusCode: "501",
            codeValue: "CAN390",
            gbName: "希特港（加拿大）",
            gbCode: "CAN390",
            ciqCode: "124390"
        },
        {
            codeName: "谢尔本（加拿大）",
            cusCode: "3072",
            codeValue: "CAN393",
            gbName: "谢尔本（加拿大）",
            gbCode: "CAN393",
            ciqCode: "124393"
        },
        {
            codeName: "希布洛克（加拿大）",
            cusCode: "501",
            codeValue: "CAN396",
            gbName: "希布洛克（加拿大）",
            gbCode: "CAN396",
            ciqCode: "124396"
        },
        {
            codeName: "希普港（加拿大）",
            cusCode: "3071",
            codeValue: "CAN399",
            gbName: "希普港（加拿大）",
            gbCode: "CAN399",
            ciqCode: "124399"
        },
        {
            codeName: "希皮根（加拿大）",
            cusCode: "3073",
            codeValue: "CAN402",
            gbName: "希皮根（加拿大）",
            gbCode: "CAN402",
            ciqCode: "124402"
        },
        {
            codeName: "索雷尔（加拿大）",
            cusCode: "3074",
            codeValue: "CAN405",
            gbName: "索雷尔（加拿大）",
            gbCode: "CAN405",
            ciqCode: "124405"
        },
        {
            codeName: "苏里斯（加拿大）",
            cusCode: "3075",
            codeValue: "CAN408",
            gbName: "苏里斯（加拿大）",
            gbCode: "CAN408",
            ciqCode: "124408"
        },
        {
            codeName: "斯普林代尔（加拿大）",
            cusCode: "3076",
            codeValue: "CAN411",
            gbName: "斯普林代尔（加拿大）",
            gbCode: "CAN411",
            ciqCode: "124411"
        },
        {
            codeName: "斯阔米什（加拿大）",
            cusCode: "501",
            codeValue: "CAN414",
            gbName: "斯阔米什（加拿大）",
            gbCode: "CAN414",
            ciqCode: "124414"
        },
        {
            codeName: "圣安德鲁斯（加拿大）",
            cusCode: "3077",
            codeValue: "CAN417",
            gbName: "圣安德鲁斯（加拿大）",
            gbCode: "CAN417",
            ciqCode: "124417"
        },
        {
            codeName: "圣凯瑟琳斯（加拿大）",
            cusCode: "501",
            codeValue: "CAN420",
            gbName: "圣凯瑟琳斯（加拿大）",
            gbCode: "CAN420",
            ciqCode: "124420"
        },
        {
            codeName: "圣约翰（加拿大）",
            cusCode: "3078",
            codeValue: "CAN422",
            gbName: "圣约翰（加拿大）",
            gbCode: "CAN422",
            ciqCode: "124422"
        },
        {
            codeName: "圣约翰斯（加拿大）",
            cusCode: "3079",
            codeValue: "CAN423",
            gbName: "圣约翰斯（加拿大）",
            gbCode: "CAN423",
            ciqCode: "124423"
        },
        {
            codeName: "圣劳伦斯（加拿大）",
            cusCode: "501",
            codeValue: "CAN426",
            gbName: "圣劳伦斯（加拿大）",
            gbCode: "CAN426",
            ciqCode: "124426"
        },
        {
            codeName: "斯蒂芬维尔（加拿大）",
            cusCode: "501",
            codeValue: "CAN429",
            gbName: "斯蒂芬维尔（加拿大）",
            gbCode: "CAN429",
            ciqCode: "124429"
        },
        {
            codeName: "斯图尔特（加拿大）",
            cusCode: "501",
            codeValue: "CAN432",
            gbName: "斯图尔特（加拿大）",
            gbCode: "CAN432",
            ciqCode: "124432"
        },
        {
            codeName: "萨默塞德（加拿大）",
            cusCode: "3083",
            codeValue: "CAN435",
            gbName: "萨默塞德（加拿大）",
            gbCode: "CAN435",
            ciqCode: "124435"
        },
        {
            codeName: "悉尼（加拿大）",
            cusCode: "3082",
            codeValue: "CAN438",
            gbName: "悉尼（加拿大）",
            gbCode: "CAN438",
            ciqCode: "124438"
        },
        {
            codeName: "塔杜萨克（加拿大）",
            cusCode: "501",
            codeValue: "CAN441",
            gbName: "塔杜萨克（加拿大）",
            gbCode: "CAN441",
            ciqCode: "124441"
        },
        {
            codeName: "塔西斯（加拿大）",
            cusCode: "501",
            codeValue: "CAN444",
            gbName: "塔西斯（加拿大）",
            gbCode: "CAN444",
            ciqCode: "124444"
        },
        {
            codeName: "索罗尔德（加拿大）",
            cusCode: "3084",
            codeValue: "CAN447",
            gbName: "索罗尔德（加拿大）",
            gbCode: "CAN447",
            ciqCode: "124447"
        },
        {
            codeName: "三河城（加拿大）",
            cusCode: "3085",
            codeValue: "CAN450",
            gbName: "三河城（加拿大）",
            gbCode: "CAN450",
            ciqCode: "124450"
        },
        {
            codeName: "桑德贝（加拿大）",
            cusCode: "501",
            codeValue: "CAN453",
            gbName: "桑德贝（加拿大）",
            gbCode: "CAN453",
            ciqCode: "124453"
        },
        {
            codeName: "多伦多（加拿大）",
            cusCode: "3086",
            codeValue: "CAN456",
            gbName: "多伦多（加拿大）",
            gbCode: "CAN456",
            ciqCode: "124456"
        },
        {
            codeName: "特威林盖特（加拿大）",
            cusCode: "3088",
            codeValue: "CAN459",
            gbName: "特威林盖特（加拿大）",
            gbCode: "CAN459",
            ciqCode: "124459"
        },
        {
            codeName: "瓦利菲尔德（加拿大）",
            cusCode: "501",
            codeValue: "CAN462",
            gbName: "瓦利菲尔德（加拿大）",
            gbCode: "CAN462",
            ciqCode: "124462"
        },
        {
            codeName: "温哥华（加拿大）",
            cusCode: "3089",
            codeValue: "CAN465",
            gbName: "温哥华（加拿大）",
            gbCode: "CAN465",
            ciqCode: "124465"
        },
        {
            codeName: "维多利亚（加拿大）",
            cusCode: "3090",
            codeValue: "CAN468",
            gbName: "维多利亚（加拿大）",
            gbCode: "CAN468",
            ciqCode: "124468"
        },
        {
            codeName: "瓦巴纳（加拿大）",
            cusCode: "3091",
            codeValue: "CAN471",
            gbName: "瓦巴纳（加拿大）",
            gbCode: "CAN471",
            ciqCode: "124471"
        },
        {
            codeName: "沃尔顿（加拿大）",
            cusCode: "501",
            codeValue: "CAN474",
            gbName: "沃尔顿（加拿大）",
            gbCode: "CAN474",
            ciqCode: "124474"
        },
        {
            codeName: "瓦特逊岛（加拿大）",
            cusCode: "501",
            codeValue: "CAN477",
            gbName: "瓦特逊岛（加拿大）",
            gbCode: "CAN477",
            ciqCode: "124477"
        },
        {
            codeName: "CAP DE LA MADELEINE（加拿大）",
            cusCode: "3008",
            codeValue: "CAN478",
            gbName: "CAP DE LA MADELEINE（加拿大）",
            gbCode: "CAN478",
            ciqCode: "124478"
        },
        {
            codeName: "CLARKE CITY（加拿大）",
            cusCode: "3014",
            codeValue: "CAN479",
            gbName: "CLARKE CITY（加拿大）",
            gbCode: "CAN479",
            ciqCode: "124479"
        },
        {
            codeName: "威兰（加拿大）",
            cusCode: "3092",
            codeValue: "CAN480",
            gbName: "威兰（加拿大）",
            gbCode: "CAN480",
            ciqCode: "124480"
        },
        {
            codeName: "韦默思（加拿大）",
            cusCode: "3093",
            codeValue: "CAN483",
            gbName: "韦默思（加拿大）",
            gbCode: "CAN483",
            ciqCode: "124483"
        },
        {
            codeName: "卡提尔港（加拿大）",
            cusCode: "3059",
            codeValue: "CAN485",
            gbName: "卡提尔港（加拿大）",
            gbCode: "CAN485",
            ciqCode: "124485"
        },
        {
            codeName: "温泽尔（加拿大）",
            cusCode: "3094",
            codeValue: "CAN486",
            gbName: "温泽尔（加拿大）",
            gbCode: "CAN486",
            ciqCode: "124486"
        },
        {
            codeName: "伍德菲伯（加拿大）",
            cusCode: "3095",
            codeValue: "CAN489",
            gbName: "伍德菲伯（加拿大）",
            gbCode: "CAN489",
            ciqCode: "124489"
        },
        {
            codeName: "纳尔逊（加拿大）",
            cusCode: "3044",
            codeValue: "CAN490",
            gbName: "纳尔逊（加拿大）",
            gbCode: "CAN490",
            ciqCode: "124490"
        },
        {
            codeName: "南纳尔逊（加拿大）",
            cusCode: "3081",
            codeValue: "CAN491",
            gbName: "南纳尔逊（加拿大）",
            gbCode: "CAN491",
            ciqCode: "124491"
        },
        {
            codeName: "雅茅思（加拿大）",
            cusCode: "3096",
            codeValue: "CAN492",
            gbName: "雅茅思（加拿大）",
            gbCode: "CAN492",
            ciqCode: "124492"
        },
        {
            codeName: "图克托亚克图克（加拿大）",
            cusCode: "3087",
            codeValue: "CAN494",
            gbName: "图克托亚克图克（加拿大）",
            gbCode: "CAN494",
            ciqCode: "124494"
        },
        {
            codeName: "渥太华（加拿大）",
            cusCode: "3052",
            codeValue: "CAN495",
            gbName: "渥太华（加拿大）",
            gbCode: "CAN495",
            ciqCode: "124495"
        },
        {
            codeName: "斜堡（加拿大）",
            cusCode: "3015",
            codeValue: "CAN497",
            gbName: "斜堡（加拿大）",
            gbCode: "CAN497",
            ciqCode: "124497"
        },
        {
            codeName: "波珀斯港（加拿大）",
            cusCode: "3057",
            codeValue: "CAN504",
            gbName: "波珀斯港（加拿大）",
            gbCode: "CAN504",
            ciqCode: "124504"
        },
        {
            codeName: "布朗斯维尔（加拿大）",
            cusCode: "2998",
            codeValue: "CAN507",
            gbName: "布朗斯维尔（加拿大）",
            gbCode: "CAN507",
            ciqCode: "124507"
        },
        {
            codeName: "莱塞斯库明（加拿大）",
            cusCode: "3033",
            codeValue: "CAN510",
            gbName: "莱塞斯库明（加拿大）",
            gbCode: "CAN510",
            ciqCode: "124510"
        },
        {
            codeName: "米耳丘陵（加拿大）",
            cusCode: "3040",
            codeValue: "CAN514",
            gbName: "米耳丘陵（加拿大）",
            gbCode: "CAN514",
            ciqCode: "124514"
        },
        {
            codeName: "恰塔姆（加拿大）",
            cusCode: "501",
            codeValue: "CAN517",
            gbName: "恰塔姆（加拿大）",
            gbCode: "CAN517",
            ciqCode: "124517"
        },
        {
            codeName: "科科斯（基林）群岛",
            cusCode: "627",
            codeValue: "CCK000",
            gbName: "科科斯（基林）群岛",
            gbCode: "CCK000",
            ciqCode: "166000"
        },
        {
            codeName: "塞卜泰(休达)",
            cusCode: "210",
            codeValue: "CEU000",
            gbName: "塞卜泰(休达)",
            gbCode: "CEU000",
            ciqCode: "142000"
        },
        {
            codeName: "休达（塞卜泰(休达)）",
            cusCode: "210",
            codeValue: "CEU003",
            gbName: "休达（塞卜泰(休达)）",
            gbCode: "CEU003",
            ciqCode: "142003"
        },
        {
            codeName: "瑞士",
            cusCode: "331",
            codeValue: "CHE000",
            gbName: "瑞士",
            gbCode: "CHE000",
            ciqCode: "756000"
        },
        {
            codeName: "苏黎世（瑞士）",
            cusCode: "331",
            codeValue: "CHE901",
            gbName: "苏黎世（瑞士）",
            gbCode: "CHE901",
            ciqCode: "756901"
        },
        {
            codeName: "洛桑（瑞士）",
            cusCode: "2640",
            codeValue: "CHE902",
            gbName: "洛桑（瑞士）",
            gbCode: "CHE902",
            ciqCode: "756902"
        },
        {
            codeName: "巴塞尔（瑞士）",
            cusCode: "2639",
            codeValue: "CHE903",
            gbName: "巴塞尔（瑞士）",
            gbCode: "CHE903",
            ciqCode: "756903"
        },
        {
            codeName: "智利",
            cusCode: "412",
            codeValue: "CHL000",
            gbName: "智利",
            gbCode: "CHL000",
            ciqCode: "152000"
        },
        {
            codeName: "安库德（智利）",
            cusCode: "412",
            codeValue: "CHL003",
            gbName: "安库德（智利）",
            gbCode: "CHL003",
            ciqCode: "152003"
        },
        {
            codeName: "安托法加斯塔（智利）",
            cusCode: "2767",
            codeValue: "CHL006",
            gbName: "安托法加斯塔（智利）",
            gbCode: "CHL006",
            ciqCode: "152006"
        },
        {
            codeName: "阿里卡（智利）",
            cusCode: "2768",
            codeValue: "CHL009",
            gbName: "阿里卡（智利）",
            gbCode: "CHL009",
            ciqCode: "152009"
        },
        {
            codeName: "卡博内格罗（智利）",
            cusCode: "412",
            codeValue: "CHL012",
            gbName: "卡博内格罗（智利）",
            gbCode: "CHL012",
            ciqCode: "152012"
        },
        {
            codeName: "卡尔德拉（智利）",
            cusCode: "412",
            codeValue: "CHL015",
            gbName: "卡尔德拉（智利）",
            gbCode: "CHL015",
            ciqCode: "152015"
        },
        {
            codeName: "卡尔德里拉（智利）",
            cusCode: "412",
            codeValue: "CHL018",
            gbName: "卡尔德里拉（智利）",
            gbCode: "CHL018",
            ciqCode: "152018"
        },
        {
            codeName: "克拉伦西亚（智利）",
            cusCode: "412",
            codeValue: "CHL024",
            gbName: "克拉伦西亚（智利）",
            gbCode: "CHL024",
            ciqCode: "152024"
        },
        {
            codeName: "帕蒂略斯（智利）",
            cusCode: "412",
            codeValue: "CHL027",
            gbName: "帕蒂略斯（智利）",
            gbCode: "CHL027",
            ciqCode: "152027"
        },
        {
            codeName: "卡斯特罗（智利）",
            cusCode: "412",
            codeValue: "CHL030",
            gbName: "卡斯特罗（智利）",
            gbCode: "CHL030",
            ciqCode: "152030"
        },
        {
            codeName: "查卡布科（智利）",
            cusCode: "412",
            codeValue: "CHL033",
            gbName: "查卡布科（智利）",
            gbCode: "CHL033",
            ciqCode: "152033"
        },
        {
            codeName: "查尼亚拉尔（智利）",
            cusCode: "2770",
            codeValue: "CHL036",
            gbName: "查尼亚拉尔（智利）",
            gbCode: "CHL036",
            ciqCode: "152036"
        },
        {
            codeName: "科金博（智利）",
            cusCode: "2771",
            codeValue: "CHL039",
            gbName: "科金博（智利）",
            gbCode: "CHL039",
            ciqCode: "152039"
        },
        {
            codeName: "科罗内尔（智利）",
            cusCode: "2772",
            codeValue: "CHL042",
            gbName: "科罗内尔（智利）",
            gbCode: "CHL042",
            ciqCode: "152042"
        },
        {
            codeName: "科拉尔（智利）",
            cusCode: "412",
            codeValue: "CHL045",
            gbName: "科拉尔（智利）",
            gbCode: "CHL045",
            ciqCode: "152045"
        },
        {
            codeName: "克鲁斯格兰德（智利）",
            cusCode: "412",
            codeValue: "CHL048",
            gbName: "克鲁斯格兰德（智利）",
            gbCode: "CHL048",
            ciqCode: "152048"
        },
        {
            codeName: "复活节岛（智利）",
            cusCode: "412",
            codeValue: "CHL051",
            gbName: "复活节岛（智利）",
            gbCode: "CHL051",
            ciqCode: "152051"
        },
        {
            codeName: "格雷戈里乌（智利）",
            cusCode: "412",
            codeValue: "CHL054",
            gbName: "格雷戈里乌（智利）",
            gbCode: "CHL054",
            ciqCode: "152054"
        },
        {
            codeName: "瓜亚坎（智利）",
            cusCode: "412",
            codeValue: "CHL057",
            gbName: "瓜亚坎（智利）",
            gbCode: "CHL057",
            ciqCode: "152057"
        },
        {
            codeName: "瓦斯科（智利）",
            cusCode: "2773",
            codeValue: "CHL060",
            gbName: "瓦斯科（智利）",
            gbCode: "CHL060",
            ciqCode: "152060"
        },
        {
            codeName: "伊基克（智利）",
            cusCode: "2774",
            codeValue: "CHL063",
            gbName: "伊基克（智利）",
            gbCode: "CHL063",
            ciqCode: "152063"
        },
        {
            codeName: "拉塞雷纳（智利）",
            cusCode: "412",
            codeValue: "CHL066",
            gbName: "拉塞雷纳（智利）",
            gbCode: "CHL066",
            ciqCode: "152066"
        },
        {
            codeName: "利尔奎（智利）",
            cusCode: "2775",
            codeValue: "CHL069",
            gbName: "利尔奎（智利）",
            gbCode: "CHL069",
            ciqCode: "152069"
        },
        {
            codeName: "洛塔（智利）",
            cusCode: "412",
            codeValue: "CHL072",
            gbName: "洛塔（智利）",
            gbCode: "CHL072",
            ciqCode: "152072"
        },
        {
            codeName: "梅希约内斯（智利）",
            cusCode: "2776",
            codeValue: "CHL075",
            gbName: "梅希约内斯（智利）",
            gbCode: "CHL075",
            ciqCode: "152075"
        },
        {
            codeName: "彭科（智利）",
            cusCode: "412",
            codeValue: "CHL078",
            gbName: "彭科（智利）",
            gbCode: "CHL078",
            ciqCode: "152078"
        },
        {
            codeName: "博里奥斯港（智利）",
            cusCode: "412",
            codeValue: "CHL081",
            gbName: "博里奥斯港（智利）",
            gbCode: "CHL081",
            ciqCode: "152081"
        },
        {
            codeName: "蒙特港（智利）",
            cusCode: "2777",
            codeValue: "CHL084",
            gbName: "蒙特港（智利）",
            gbCode: "CHL084",
            ciqCode: "152084"
        },
        {
            codeName: "纳塔莱斯港（智利）",
            cusCode: "412",
            codeValue: "CHL087",
            gbName: "纳塔莱斯港（智利）",
            gbCode: "CHL087",
            ciqCode: "152087"
        },
        {
            codeName: "克永港（智利）",
            cusCode: "412",
            codeValue: "CHL090",
            gbName: "克永港（智利）",
            gbCode: "CHL090",
            ciqCode: "152090"
        },
        {
            codeName: "奎姆什（智利）",
            cusCode: "412",
            codeValue: "CHL093",
            gbName: "奎姆什（智利）",
            gbCode: "CHL093",
            ciqCode: "152093"
        },
        {
            codeName: "蓬塔阿雷纳斯（智利）",
            cusCode: "2778",
            codeValue: "CHL096",
            gbName: "蓬塔阿雷纳斯（智利）",
            gbCode: "CHL096",
            ciqCode: "152096"
        },
        {
            codeName: "金特罗（智利）",
            cusCode: "412",
            codeValue: "CHL099",
            gbName: "金特罗（智利）",
            gbCode: "CHL099",
            ciqCode: "152099"
        },
        {
            codeName: "圣安东尼奥（智利）",
            cusCode: "2779",
            codeValue: "CHL102",
            gbName: "圣安东尼奥（智利）",
            gbCode: "CHL102",
            ciqCode: "152102"
        },
        {
            codeName: "圣维森特（智利）",
            cusCode: "2780",
            codeValue: "CHL105",
            gbName: "圣维森特（智利）",
            gbCode: "CHL105",
            ciqCode: "152105"
        },
        {
            codeName: "塔尔卡瓦诺（智利）",
            cusCode: "2781",
            codeValue: "CHL108",
            gbName: "塔尔卡瓦诺（智利）",
            gbCode: "CHL108",
            ciqCode: "152108"
        },
        {
            codeName: "塔尔塔尔（智利）",
            cusCode: "2782",
            codeValue: "CHL111",
            gbName: "塔尔塔尔（智利）",
            gbCode: "CHL111",
            ciqCode: "152111"
        },
        {
            codeName: "托科皮亚（智利）",
            cusCode: "2783",
            codeValue: "CHL114",
            gbName: "托科皮亚（智利）",
            gbCode: "CHL114",
            ciqCode: "152114"
        },
        {
            codeName: "托梅（智利）",
            cusCode: "2784",
            codeValue: "CHL117",
            gbName: "托梅（智利）",
            gbCode: "CHL117",
            ciqCode: "152117"
        },
        {
            codeName: "瓦尔迪维亚（智利）",
            cusCode: "2785",
            codeValue: "CHL120",
            gbName: "瓦尔迪维亚（智利）",
            gbCode: "CHL120",
            ciqCode: "152120"
        },
        {
            codeName: "瓦尔帕莱索（智利）",
            cusCode: "2786",
            codeValue: "CHL123",
            gbName: "瓦尔帕莱索（智利）",
            gbCode: "CHL123",
            ciqCode: "152123"
        },
        {
            codeName: "圣地亚哥（智利）",
            cusCode: "412",
            codeValue: "CHL901",
            gbName: "圣地亚哥（智利）",
            gbCode: "CHL901",
            ciqCode: "152901"
        },
        {
            codeName: "BARQUJTO（智利）",
            cusCode: "2769",
            codeValue: "CHL902",
            gbName: "BARQUJTO（智利）",
            gbCode: "CHL902",
            ciqCode: "152902"
        },
        {
            codeName: "中国境内",
            cusCode: "142",
            codeValue: "CHN000",
            gbName: "中国境内",
            gbCode: "CHN000",
            ciqCode: "156000"
        },
        {
            codeName: "南通（中国）",
            cusCode: "142",
            codeValue: "CHN030",
            gbName: "南通（中国）",
            gbCode: "CHN030",
            ciqCode: "156030"
        },
        {
            codeName: "泰州（中国）",
            cusCode: "142",
            codeValue: "CHN033",
            gbName: "泰州（中国）",
            gbCode: "CHN033",
            ciqCode: "156033"
        },
        {
            codeName: "扬州（中国）",
            cusCode: "142",
            codeValue: "CHN036",
            gbName: "扬州（中国）",
            gbCode: "CHN036",
            ciqCode: "156036"
        },
        {
            codeName: "南京（中国）",
            cusCode: "142",
            codeValue: "CHN039",
            gbName: "南京（中国）",
            gbCode: "CHN039",
            ciqCode: "156039"
        },
        {
            codeName: "镇江（中国）",
            cusCode: "142",
            codeValue: "CHN041",
            gbName: "镇江（中国）",
            gbCode: "CHN041",
            ciqCode: "156041"
        },
        {
            codeName: "常州（中国）",
            cusCode: "142",
            codeValue: "CHN042",
            gbName: "常州（中国）",
            gbCode: "CHN042",
            ciqCode: "156042"
        },
        {
            codeName: "高港（中国）",
            cusCode: "142",
            codeValue: "CHN043",
            gbName: "高港（中国）",
            gbCode: "CHN043",
            ciqCode: "156043"
        },
        {
            codeName: "江阴（中国）",
            cusCode: "142",
            codeValue: "CHN045",
            gbName: "江阴（中国）",
            gbCode: "CHN045",
            ciqCode: "156045"
        },
        {
            codeName: "苏州（中国）",
            cusCode: "142",
            codeValue: "CHN046",
            gbName: "苏州（中国）",
            gbCode: "CHN046",
            ciqCode: "156046"
        },
        {
            codeName: "张家港（中国）",
            cusCode: "142",
            codeValue: "CHN047",
            gbName: "张家港（中国）",
            gbCode: "CHN047",
            ciqCode: "156047"
        },
        {
            codeName: "常熟（中国）",
            cusCode: "142",
            codeValue: "CHN050",
            gbName: "常熟（中国）",
            gbCode: "CHN050",
            ciqCode: "156050"
        },
        {
            codeName: "太仓（中国）",
            cusCode: "142",
            codeValue: "CHN053",
            gbName: "太仓（中国）",
            gbCode: "CHN053",
            ciqCode: "156053"
        },
        {
            codeName: "南京禄口国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN056",
            gbName: "南京禄口国际机场（中国）",
            gbCode: "CHN056",
            ciqCode: "156056"
        },
        {
            codeName: "盐城机场（中国）",
            cusCode: "142",
            codeValue: "CHN059",
            gbName: "盐城机场（中国）",
            gbCode: "CHN059",
            ciqCode: "156059"
        },
        {
            codeName: "丹东（中国）",
            cusCode: "142",
            codeValue: "CHN101",
            gbName: "丹东（中国）",
            gbCode: "CHN101",
            ciqCode: "156101"
        },
        {
            codeName: "大连（中国）",
            cusCode: "142",
            codeValue: "CHN113",
            gbName: "大连（中国）",
            gbCode: "CHN113",
            ciqCode: "156113"
        },
        {
            codeName: "大连新港（中国）",
            cusCode: "142",
            codeValue: "CHN114",
            gbName: "大连新港（中国）",
            gbCode: "CHN114",
            ciqCode: "156114"
        },
        {
            codeName: "营口（中国）",
            cusCode: "142",
            codeValue: "CHN119",
            gbName: "营口（中国）",
            gbCode: "CHN119",
            ciqCode: "156119"
        },
        {
            codeName: "锦州（中国）",
            cusCode: "142",
            codeValue: "CHN122",
            gbName: "锦州（中国）",
            gbCode: "CHN122",
            ciqCode: "156122"
        },
        {
            codeName: "葫芦岛（中国）",
            cusCode: "142",
            codeValue: "CHN124",
            gbName: "葫芦岛（中国）",
            gbCode: "CHN124",
            ciqCode: "156124"
        },
        {
            codeName: "沈阳桃仙国际机场口岸（中国）",
            cusCode: "142",
            codeValue: "CHN126",
            gbName: "沈阳桃仙国际机场口岸（中国）",
            gbCode: "CHN126",
            ciqCode: "156126"
        },
        {
            codeName: "大连周水子国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN128",
            gbName: "大连周水子国际机场（中国）",
            gbCode: "CHN128",
            ciqCode: "156128"
        },
        {
            codeName: "长春大房身机场（中国）",
            cusCode: "142",
            codeValue: "CHN130",
            gbName: "长春大房身机场（中国）",
            gbCode: "CHN130",
            ciqCode: "156130"
        },
        {
            codeName: "延吉朝阳川机场（中国）",
            cusCode: "142",
            codeValue: "CHN132",
            gbName: "延吉朝阳川机场（中国）",
            gbCode: "CHN132",
            ciqCode: "156132"
        },
        {
            codeName: "哈尔滨太平国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN134",
            gbName: "哈尔滨太平国际机场（中国）",
            gbCode: "CHN134",
            ciqCode: "156134"
        },
        {
            codeName: "佳木斯东郊机场（中国）",
            cusCode: "142",
            codeValue: "CHN136",
            gbName: "佳木斯东郊机场（中国）",
            gbCode: "CHN136",
            ciqCode: "156136"
        },
        {
            codeName: "牡丹江海浪机场（中国）",
            cusCode: "142",
            codeValue: "CHN138",
            gbName: "牡丹江海浪机场（中国）",
            gbCode: "CHN138",
            ciqCode: "156138"
        },
        {
            codeName: "齐齐哈尔三家子机场（中国）",
            cusCode: "142",
            codeValue: "CHN140",
            gbName: "齐齐哈尔三家子机场（中国）",
            gbCode: "CHN140",
            ciqCode: "156140"
        },
        {
            codeName: "秦皇岛（中国）",
            cusCode: "142",
            codeValue: "CHN151",
            gbName: "秦皇岛（中国）",
            gbCode: "CHN151",
            ciqCode: "156151"
        },
        {
            codeName: "唐山（中国）",
            cusCode: "142",
            codeValue: "CHN153",
            gbName: "唐山（中国）",
            gbCode: "CHN153",
            ciqCode: "156153"
        },
        {
            codeName: "京唐港（中国）",
            cusCode: "142",
            codeValue: "CHN154",
            gbName: "京唐港（中国）",
            gbCode: "CHN154",
            ciqCode: "156154"
        },
        {
            codeName: "曹妃甸（中国）",
            cusCode: "142",
            codeValue: "CHN156",
            gbName: "曹妃甸（中国）",
            gbCode: "CHN156",
            ciqCode: "156156"
        },
        {
            codeName: "石家庄正定机场（中国）",
            cusCode: "142",
            codeValue: "CHN159",
            gbName: "石家庄正定机场（中国）",
            gbCode: "CHN159",
            ciqCode: "156159"
        },
        {
            codeName: "天津（中国）",
            cusCode: "142",
            codeValue: "CHN181",
            gbName: "天津（中国）",
            gbCode: "CHN181",
            ciqCode: "156181"
        },
        {
            codeName: "天津滨海国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN184",
            gbName: "天津滨海国际机场（中国）",
            gbCode: "CHN184",
            ciqCode: "156184"
        },
        {
            codeName: "天津新港（中国）",
            cusCode: "142",
            codeValue: "CHN185",
            gbName: "天津新港（中国）",
            gbCode: "CHN185",
            ciqCode: "156185"
        },
        {
            codeName: "首都国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN188",
            gbName: "首都国际机场（中国）",
            gbCode: "CHN188",
            ciqCode: "156188"
        },
        {
            codeName: "太原太武宿机场（中国）",
            cusCode: "142",
            codeValue: "CHN190",
            gbName: "太原太武宿机场（中国）",
            gbCode: "CHN190",
            ciqCode: "156190"
        },
        {
            codeName: "呼和浩特白塔机场（中国）",
            cusCode: "142",
            codeValue: "CHN192",
            gbName: "呼和浩特白塔机场（中国）",
            gbCode: "CHN192",
            ciqCode: "156192"
        },
        {
            codeName: "海拉尔东山机场（中国）",
            cusCode: "142",
            codeValue: "CHN194",
            gbName: "海拉尔东山机场（中国）",
            gbCode: "CHN194",
            ciqCode: "156194"
        },
        {
            codeName: "黄骅（中国）",
            cusCode: "142",
            codeValue: "CHN213",
            gbName: "黄骅（中国）",
            gbCode: "CHN213",
            ciqCode: "156213"
        },
        {
            codeName: "东营（中国）",
            cusCode: "142",
            codeValue: "CHN216",
            gbName: "东营（中国）",
            gbCode: "CHN216",
            ciqCode: "156216"
        },
        {
            codeName: "莱州（中国）",
            cusCode: "142",
            codeValue: "CHN219",
            gbName: "莱州（中国）",
            gbCode: "CHN219",
            ciqCode: "156219"
        },
        {
            codeName: "龙口（中国）",
            cusCode: "142",
            codeValue: "CHN222",
            gbName: "龙口（中国）",
            gbCode: "CHN222",
            ciqCode: "156222"
        },
        {
            codeName: "蓬莱（中国）",
            cusCode: "142",
            codeValue: "CHN225",
            gbName: "蓬莱（中国）",
            gbCode: "CHN225",
            ciqCode: "156225"
        },
        {
            codeName: "烟台（中国）",
            cusCode: "142",
            codeValue: "CHN231",
            gbName: "烟台（中国）",
            gbCode: "CHN231",
            ciqCode: "156231"
        },
        {
            codeName: "威海（中国）",
            cusCode: "142",
            codeValue: "CHN240",
            gbName: "威海（中国）",
            gbCode: "CHN240",
            ciqCode: "156240"
        },
        {
            codeName: "石岛（中国）",
            cusCode: "142",
            codeValue: "CHN249",
            gbName: "石岛（中国）",
            gbCode: "CHN249",
            ciqCode: "156249"
        },
        {
            codeName: "黄岛（中国）",
            cusCode: "142",
            codeValue: "CHN260",
            gbName: "黄岛（中国）",
            gbCode: "CHN260",
            ciqCode: "156260"
        },
        {
            codeName: "青岛（中国）",
            cusCode: "142",
            codeValue: "CHN261",
            gbName: "青岛（中国）",
            gbCode: "CHN261",
            ciqCode: "156261"
        },
        {
            codeName: "日照（中国）",
            cusCode: "142",
            codeValue: "CHN273",
            gbName: "日照（中国）",
            gbCode: "CHN273",
            ciqCode: "156273"
        },
        {
            codeName: "岚山（中国）",
            cusCode: "142",
            codeValue: "CHN276",
            gbName: "岚山（中国）",
            gbCode: "CHN276",
            ciqCode: "156276"
        },
        {
            codeName: "济南遥墙机场（中国）",
            cusCode: "142",
            codeValue: "CHN278",
            gbName: "济南遥墙机场（中国）",
            gbCode: "CHN278",
            ciqCode: "156278"
        },
        {
            codeName: "青岛流亭机场（中国）",
            cusCode: "142",
            codeValue: "CHN280",
            gbName: "青岛流亭机场（中国）",
            gbCode: "CHN280",
            ciqCode: "156280"
        },
        {
            codeName: "威海机场（中国）",
            cusCode: "142",
            codeValue: "CHN282",
            gbName: "威海机场（中国）",
            gbCode: "CHN282",
            ciqCode: "156282"
        },
        {
            codeName: "烟台莱山机场（中国）",
            cusCode: "142",
            codeValue: "CHN284",
            gbName: "烟台莱山机场（中国）",
            gbCode: "CHN284",
            ciqCode: "156284"
        },
        {
            codeName: "郑州新郑国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN286",
            gbName: "郑州新郑国际机场（中国）",
            gbCode: "CHN286",
            ciqCode: "156286"
        },
        {
            codeName: "洛阳北郊机场（中国）",
            cusCode: "142",
            codeValue: "CHN288",
            gbName: "洛阳北郊机场（中国）",
            gbCode: "CHN288",
            ciqCode: "156288"
        },
        {
            codeName: "武汉天河机场（中国）",
            cusCode: "142",
            codeValue: "CHN290",
            gbName: "武汉天河机场（中国）",
            gbCode: "CHN290",
            ciqCode: "156290"
        },
        {
            codeName: "宜昌三峡机场（中国）",
            cusCode: "142",
            codeValue: "CHN292",
            gbName: "宜昌三峡机场（中国）",
            gbCode: "CHN292",
            ciqCode: "156292"
        },
        {
            codeName: "长沙黄花国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN294",
            gbName: "长沙黄花国际机场（中国）",
            gbCode: "CHN294",
            ciqCode: "156294"
        },
        {
            codeName: "张家界荷花机场（中国）",
            cusCode: "142",
            codeValue: "CHN296",
            gbName: "张家界荷花机场（中国）",
            gbCode: "CHN296",
            ciqCode: "156296"
        },
        {
            codeName: "连云港（中国）",
            cusCode: "142",
            codeValue: "CHN301",
            gbName: "连云港（中国）",
            gbCode: "CHN301",
            ciqCode: "156301"
        },
        {
            codeName: "上海（中国）",
            cusCode: "142",
            codeValue: "CHN331",
            gbName: "上海（中国）",
            gbCode: "CHN331",
            ciqCode: "156331"
        },
        {
            codeName: "宝山马头（中国）",
            cusCode: "142",
            codeValue: "CHN333",
            gbName: "宝山马头（中国）",
            gbCode: "CHN333",
            ciqCode: "156333"
        },
        {
            codeName: "外高桥（中国）",
            cusCode: "142",
            codeValue: "CHN336",
            gbName: "外高桥（中国）",
            gbCode: "CHN336",
            ciqCode: "156336"
        },
        {
            codeName: "吴淞（中国）",
            cusCode: "142",
            codeValue: "CHN339",
            gbName: "吴淞（中国）",
            gbCode: "CHN339",
            ciqCode: "156339"
        },
        {
            codeName: "上海浦东国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN340",
            gbName: "上海浦东国际机场（中国）",
            gbCode: "CHN340",
            ciqCode: "156340"
        },
        {
            codeName: "上海虹桥国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN341",
            gbName: "上海虹桥国际机场（中国）",
            gbCode: "CHN341",
            ciqCode: "156341"
        },
        {
            codeName: "洋山（中国）",
            cusCode: "142",
            codeValue: "CHN342",
            gbName: "洋山（中国）",
            gbCode: "CHN342",
            ciqCode: "156342"
        },
        {
            codeName: "嘉兴（中国）",
            cusCode: "142",
            codeValue: "CHN345",
            gbName: "嘉兴（中国）",
            gbCode: "CHN345",
            ciqCode: "156345"
        },
        {
            codeName: "乍浦（中国）",
            cusCode: "142",
            codeValue: "CHN351",
            gbName: "乍浦（中国）",
            gbCode: "CHN351",
            ciqCode: "156351"
        },
        {
            codeName: "镇海港（中国）",
            cusCode: "142",
            codeValue: "CHN358",
            gbName: "镇海港（中国）",
            gbCode: "CHN358",
            ciqCode: "156358"
        },
        {
            codeName: "梅山港（中国）",
            cusCode: "142",
            codeValue: "CHN359",
            gbName: "梅山港（中国）",
            gbCode: "CHN359",
            ciqCode: "156359"
        },
        {
            codeName: "宁波（中国）",
            cusCode: "142",
            codeValue: "CHN360",
            gbName: "宁波（中国）",
            gbCode: "CHN360",
            ciqCode: "156360"
        },
        {
            codeName: "北仑港（中国）",
            cusCode: "142",
            codeValue: "CHN361",
            gbName: "北仑港（中国）",
            gbCode: "CHN361",
            ciqCode: "156361"
        },
        {
            codeName: "大榭港（中国）",
            cusCode: "142",
            codeValue: "CHN362",
            gbName: "大榭港（中国）",
            gbCode: "CHN362",
            ciqCode: "156362"
        },
        {
            codeName: "穿山港（中国）",
            cusCode: "142",
            codeValue: "CHN363",
            gbName: "穿山港（中国）",
            gbCode: "CHN363",
            ciqCode: "156363"
        },
        {
            codeName: "宁海港（中国）",
            cusCode: "142",
            codeValue: "CHN364",
            gbName: "宁海港（中国）",
            gbCode: "CHN364",
            ciqCode: "156364"
        },
        {
            codeName: "象山港（中国）",
            cusCode: "142",
            codeValue: "CHN365",
            gbName: "象山港（中国）",
            gbCode: "CHN365",
            ciqCode: "156365"
        },
        {
            codeName: "舟山（中国）",
            cusCode: "142",
            codeValue: "CHN366",
            gbName: "舟山（中国）",
            gbCode: "CHN366",
            ciqCode: "156366"
        },
        {
            codeName: "普陀港（中国）",
            cusCode: "142",
            codeValue: "CHN367",
            gbName: "普陀港（中国）",
            gbCode: "CHN367",
            ciqCode: "156367"
        },
        {
            codeName: "台州（中国）",
            cusCode: "142",
            codeValue: "CHN450",
            gbName: "台州（中国）",
            gbCode: "CHN450",
            ciqCode: "156450"
        },
        {
            codeName: "海门（中国）",
            cusCode: "142",
            codeValue: "CHN453",
            gbName: "海门（中国）",
            gbCode: "CHN453",
            ciqCode: "156453"
        },
        {
            codeName: "温岭港（中国）",
            cusCode: "142",
            codeValue: "CHN456",
            gbName: "温岭港（中国）",
            gbCode: "CHN456",
            ciqCode: "156456"
        },
        {
            codeName: "温州（中国）",
            cusCode: "142",
            codeValue: "CHN483",
            gbName: "温州（中国）",
            gbCode: "CHN483",
            ciqCode: "156483"
        },
        {
            codeName: "杭州萧山国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN566",
            gbName: "杭州萧山国际机场（中国）",
            gbCode: "CHN566",
            ciqCode: "156566"
        },
        {
            codeName: "合肥骆岗机场（中国）",
            cusCode: "142",
            codeValue: "CHN568",
            gbName: "合肥骆岗机场（中国）",
            gbCode: "CHN568",
            ciqCode: "156568"
        },
        {
            codeName: "黄山屯溪机场（中国）",
            cusCode: "142",
            codeValue: "CHN570",
            gbName: "黄山屯溪机场（中国）",
            gbCode: "CHN570",
            ciqCode: "156570"
        },
        {
            codeName: "宁德（中国）",
            cusCode: "142",
            codeValue: "CHN572",
            gbName: "宁德（中国）",
            gbCode: "CHN572",
            ciqCode: "156572"
        },
        {
            codeName: "城澳（中国）",
            cusCode: "142",
            codeValue: "CHN575",
            gbName: "城澳（中国）",
            gbCode: "CHN575",
            ciqCode: "156575"
        },
        {
            codeName: "福州（中国）",
            cusCode: "142",
            codeValue: "CHN578",
            gbName: "福州（中国）",
            gbCode: "CHN578",
            ciqCode: "156578"
        },
        {
            codeName: "马尾（中国）",
            cusCode: "142",
            codeValue: "CHN579",
            gbName: "马尾（中国）",
            gbCode: "CHN579",
            ciqCode: "156579"
        },
        {
            codeName: "松下（中国）",
            cusCode: "142",
            codeValue: "CHN582",
            gbName: "松下（中国）",
            gbCode: "CHN582",
            ciqCode: "156582"
        },
        {
            codeName: "莆田（中国）",
            cusCode: "142",
            codeValue: "CHN585",
            gbName: "莆田（中国）",
            gbCode: "CHN585",
            ciqCode: "156585"
        },
        {
            codeName: "秀屿（中国）",
            cusCode: "142",
            codeValue: "CHN611",
            gbName: "秀屿（中国）",
            gbCode: "CHN611",
            ciqCode: "156611"
        },
        {
            codeName: "泉州（中国）",
            cusCode: "142",
            codeValue: "CHN638",
            gbName: "泉州（中国）",
            gbCode: "CHN638",
            ciqCode: "156638"
        },
        {
            codeName: "厦门（中国）",
            cusCode: "142",
            codeValue: "CHN674",
            gbName: "厦门（中国）",
            gbCode: "CHN674",
            ciqCode: "156674"
        },
        {
            codeName: "漳州（中国）",
            cusCode: "142",
            codeValue: "CHN677",
            gbName: "漳州（中国）",
            gbCode: "CHN677",
            ciqCode: "156677"
        },
        {
            codeName: "福州长乐国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN679",
            gbName: "福州长乐国际机场（中国）",
            gbCode: "CHN679",
            ciqCode: "156679"
        },
        {
            codeName: "武夷山机场（中国）",
            cusCode: "142",
            codeValue: "CHN681",
            gbName: "武夷山机场（中国）",
            gbCode: "CHN681",
            ciqCode: "156681"
        },
        {
            codeName: "厦门高崎国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN683",
            gbName: "厦门高崎国际机场（中国）",
            gbCode: "CHN683",
            ciqCode: "156683"
        },
        {
            codeName: "南昌昌北机场（中国）",
            cusCode: "142",
            codeValue: "CHN685",
            gbName: "南昌昌北机场（中国）",
            gbCode: "CHN685",
            ciqCode: "156685"
        },
        {
            codeName: "东山（中国）",
            cusCode: "142",
            codeValue: "CHN686",
            gbName: "东山（中国）",
            gbCode: "CHN686",
            ciqCode: "156686"
        },
        {
            codeName: "潮州（中国）",
            cusCode: "142",
            codeValue: "CHN704",
            gbName: "潮州（中国）",
            gbCode: "CHN704",
            ciqCode: "156704"
        },
        {
            codeName: "汕头（中国）",
            cusCode: "142",
            codeValue: "CHN710",
            gbName: "汕头（中国）",
            gbCode: "CHN710",
            ciqCode: "156710"
        },
        {
            codeName: "广澳（中国）",
            cusCode: "142",
            codeValue: "CHN713",
            gbName: "广澳（中国）",
            gbCode: "CHN713",
            ciqCode: "156713"
        },
        {
            codeName: "潮阳（中国）",
            cusCode: "142",
            codeValue: "CHN716",
            gbName: "潮阳（中国）",
            gbCode: "CHN716",
            ciqCode: "156716"
        },
        {
            codeName: "汕尾（中国）",
            cusCode: "142",
            codeValue: "CHN725",
            gbName: "汕尾（中国）",
            gbCode: "CHN725",
            ciqCode: "156725"
        },
        {
            codeName: "惠州（中国）",
            cusCode: "142",
            codeValue: "CHN728",
            gbName: "惠州（中国）",
            gbCode: "CHN728",
            ciqCode: "156728"
        },
        {
            codeName: "深圳（中国）",
            cusCode: "142",
            codeValue: "CHN731",
            gbName: "深圳（中国）",
            gbCode: "CHN731",
            ciqCode: "156731"
        },
        {
            codeName: "东角头（中国）",
            cusCode: "142",
            codeValue: "CHN734",
            gbName: "东角头（中国）",
            gbCode: "CHN734",
            ciqCode: "156734"
        },
        {
            codeName: "盐田（中国）",
            cusCode: "142",
            codeValue: "CHN737",
            gbName: "盐田（中国）",
            gbCode: "CHN737",
            ciqCode: "156737"
        },
        {
            codeName: "蛇口（中国）",
            cusCode: "142",
            codeValue: "CHN740",
            gbName: "蛇口（中国）",
            gbCode: "CHN740",
            ciqCode: "156740"
        },
        {
            codeName: "赤湾（中国）",
            cusCode: "142",
            codeValue: "CHN743",
            gbName: "赤湾（中国）",
            gbCode: "CHN743",
            ciqCode: "156743"
        },
        {
            codeName: "妈湾（中国）",
            cusCode: "142",
            codeValue: "CHN746",
            gbName: "妈湾（中国）",
            gbCode: "CHN746",
            ciqCode: "156746"
        },
        {
            codeName: "东莞（中国）",
            cusCode: "142",
            codeValue: "CHN748",
            gbName: "东莞（中国）",
            gbCode: "CHN748",
            ciqCode: "156748"
        },
        {
            codeName: "黄埔（中国）",
            cusCode: "142",
            codeValue: "CHN750",
            gbName: "黄埔（中国）",
            gbCode: "CHN750",
            ciqCode: "156750"
        },
        {
            codeName: "虎门（中国）",
            cusCode: "142",
            codeValue: "CHN751",
            gbName: "虎门（中国）",
            gbCode: "CHN751",
            ciqCode: "156751"
        },
        {
            codeName: "广州（中国）",
            cusCode: "142",
            codeValue: "CHN752",
            gbName: "广州（中国）",
            gbCode: "CHN752",
            ciqCode: "156752"
        },
        {
            codeName: "阳江（中国）",
            cusCode: "142",
            codeValue: "CHN753",
            gbName: "阳江（中国）",
            gbCode: "CHN753",
            ciqCode: "156753"
        },
        {
            codeName: "南沙（中国）",
            cusCode: "142",
            codeValue: "CHN754",
            gbName: "南沙（中国）",
            gbCode: "CHN754",
            ciqCode: "156754"
        },
        {
            codeName: "茂名（中国）",
            cusCode: "142",
            codeValue: "CHN755",
            gbName: "茂名（中国）",
            gbCode: "CHN755",
            ciqCode: "156755"
        },
        {
            codeName: "珠海（中国）",
            cusCode: "142",
            codeValue: "CHN756",
            gbName: "珠海（中国）",
            gbCode: "CHN756",
            ciqCode: "156756"
        },
        {
            codeName: "中山（中国）",
            cusCode: "142",
            codeValue: "CHN758",
            gbName: "中山（中国）",
            gbCode: "CHN758",
            ciqCode: "156758"
        },
        {
            codeName: "九州（中国）",
            cusCode: "142",
            codeValue: "CHN761",
            gbName: "九州（中国）",
            gbCode: "CHN761",
            ciqCode: "156761"
        },
        {
            codeName: "江门（中国）",
            cusCode: "142",
            codeValue: "CHN764",
            gbName: "江门（中国）",
            gbCode: "CHN764",
            ciqCode: "156764"
        },
        {
            codeName: "北津（中国）",
            cusCode: "142",
            codeValue: "CHN767",
            gbName: "北津（中国）",
            gbCode: "CHN767",
            ciqCode: "156767"
        },
        {
            codeName: "广海（中国）",
            cusCode: "142",
            codeValue: "CHN768",
            gbName: "广海（中国）",
            gbCode: "CHN768",
            ciqCode: "156768"
        },
        {
            codeName: "斗门(中国）",
            cusCode: "142",
            codeValue: "CHN770",
            gbName: "斗门(中国）",
            gbCode: "CHN770",
            ciqCode: "156770"
        },
        {
            codeName: "湛江（中国）",
            cusCode: "142",
            codeValue: "CHN785",
            gbName: "湛江（中国）",
            gbCode: "CHN785",
            ciqCode: "156785"
        },
        {
            codeName: "广州白云国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN793",
            gbName: "广州白云国际机场（中国）",
            gbCode: "CHN793",
            ciqCode: "156793"
        },
        {
            codeName: "梅州机场（中国）",
            cusCode: "142",
            codeValue: "CHN795",
            gbName: "梅州机场（中国）",
            gbCode: "CHN795",
            ciqCode: "156795"
        },
        {
            codeName: "汕头机场（中国）",
            cusCode: "142",
            codeValue: "CHN797",
            gbName: "汕头机场（中国）",
            gbCode: "CHN797",
            ciqCode: "156797"
        },
        {
            codeName: "深圳宝安国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN799",
            gbName: "深圳宝安国际机场（中国）",
            gbCode: "CHN799",
            ciqCode: "156799"
        },
        {
            codeName: "湛江机场（中国）",
            cusCode: "142",
            codeValue: "CHN801",
            gbName: "湛江机场（中国）",
            gbCode: "CHN801",
            ciqCode: "156801"
        },
        {
            codeName: "北海（中国）",
            cusCode: "142",
            codeValue: "CHN851",
            gbName: "北海（中国）",
            gbCode: "CHN851",
            ciqCode: "156851"
        },
        {
            codeName: "石头埠（中国）",
            cusCode: "142",
            codeValue: "CHN866",
            gbName: "石头埠（中国）",
            gbCode: "CHN866",
            ciqCode: "156866"
        },
        {
            codeName: "钦州（中国）",
            cusCode: "142",
            codeValue: "CHN867",
            gbName: "钦州（中国）",
            gbCode: "CHN867",
            ciqCode: "156867"
        },
        {
            codeName: "企沙（中国）",
            cusCode: "142",
            codeValue: "CHN875",
            gbName: "企沙（中国）",
            gbCode: "CHN875",
            ciqCode: "156875"
        },
        {
            codeName: "防城港（中国）",
            cusCode: "142",
            codeValue: "CHN878",
            gbName: "防城港（中国）",
            gbCode: "CHN878",
            ciqCode: "156878"
        },
        {
            codeName: "江山（中国）",
            cusCode: "142",
            codeValue: "CHN881",
            gbName: "江山（中国）",
            gbCode: "CHN881",
            ciqCode: "156881"
        },
        {
            codeName: "南宁吴圩机场（中国）",
            cusCode: "142",
            codeValue: "CHN883",
            gbName: "南宁吴圩机场（中国）",
            gbCode: "CHN883",
            ciqCode: "156883"
        },
        {
            codeName: "北海福成机场（中国）",
            cusCode: "142",
            codeValue: "CHN885",
            gbName: "北海福成机场（中国）",
            gbCode: "CHN885",
            ciqCode: "156885"
        },
        {
            codeName: "桂林两江国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN887",
            gbName: "桂林两江国际机场（中国）",
            gbCode: "CHN887",
            ciqCode: "156887"
        },
        {
            codeName: "海口（中国）",
            cusCode: "142",
            codeValue: "CHN901",
            gbName: "海口（中国）",
            gbCode: "CHN901",
            ciqCode: "156901"
        },
        {
            codeName: "海口新港（中国）",
            cusCode: "142",
            codeValue: "CHN904",
            gbName: "海口新港（中国）",
            gbCode: "CHN904",
            ciqCode: "156904"
        },
        {
            codeName: "清澜（中国）",
            cusCode: "142",
            codeValue: "CHN913",
            gbName: "清澜（中国）",
            gbCode: "CHN913",
            ciqCode: "156913"
        },
        {
            codeName: "三亚（中国）",
            cusCode: "142",
            codeValue: "CHN919",
            gbName: "三亚（中国）",
            gbCode: "CHN919",
            ciqCode: "156919"
        },
        {
            codeName: "榆林（中国）",
            cusCode: "142",
            codeValue: "CHN920",
            gbName: "榆林（中国）",
            gbCode: "CHN920",
            ciqCode: "156920"
        },
        {
            codeName: "八所（中国）",
            cusCode: "142",
            codeValue: "CHN922",
            gbName: "八所（中国）",
            gbCode: "CHN922",
            ciqCode: "156922"
        },
        {
            codeName: "洋浦（中国）",
            cusCode: "142",
            codeValue: "CHN925",
            gbName: "洋浦（中国）",
            gbCode: "CHN925",
            ciqCode: "156925"
        },
        {
            codeName: "海口美兰机场（中国）",
            cusCode: "142",
            codeValue: "CHN928",
            gbName: "海口美兰机场（中国）",
            gbCode: "CHN928",
            ciqCode: "156928"
        },
        {
            codeName: "三亚凤凰机场（中国）",
            cusCode: "142",
            codeValue: "CHN931",
            gbName: "三亚凤凰机场（中国）",
            gbCode: "CHN931",
            ciqCode: "156931"
        },
        {
            codeName: "重庆江北国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN934",
            gbName: "重庆江北国际机场（中国）",
            gbCode: "CHN934",
            ciqCode: "156934"
        },
        {
            codeName: "成都双流国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN937",
            gbName: "成都双流国际机场（中国）",
            gbCode: "CHN937",
            ciqCode: "156937"
        },
        {
            codeName: "贵阳龙洞堡机场（中国）",
            cusCode: "142",
            codeValue: "CHN940",
            gbName: "贵阳龙洞堡机场（中国）",
            gbCode: "CHN940",
            ciqCode: "156940"
        },
        {
            codeName: "昆明巫家坝国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN943",
            gbName: "昆明巫家坝国际机场（中国）",
            gbCode: "CHN943",
            ciqCode: "156943"
        },
        {
            codeName: "西双版纳嘎洒机场（中国）",
            cusCode: "142",
            codeValue: "CHN946",
            gbName: "西双版纳嘎洒机场（中国）",
            gbCode: "CHN946",
            ciqCode: "156946"
        },
        {
            codeName: "拉萨贡嘎机场（中国）",
            cusCode: "142",
            codeValue: "CHN949",
            gbName: "拉萨贡嘎机场（中国）",
            gbCode: "CHN949",
            ciqCode: "156949"
        },
        {
            codeName: "西安咸阳国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN952",
            gbName: "西安咸阳国际机场（中国）",
            gbCode: "CHN952",
            ciqCode: "156952"
        },
        {
            codeName: "兰州中川机场（中国）",
            cusCode: "142",
            codeValue: "CHN955",
            gbName: "兰州中川机场（中国）",
            gbCode: "CHN955",
            ciqCode: "156955"
        },
        {
            codeName: "西宁曹家堡机场（中国）",
            cusCode: "142",
            codeValue: "CHN958",
            gbName: "西宁曹家堡机场（中国）",
            gbCode: "CHN958",
            ciqCode: "156958"
        },
        {
            codeName: "银川河东机场（中国）",
            cusCode: "142",
            codeValue: "CHN961",
            gbName: "银川河东机场（中国）",
            gbCode: "CHN961",
            ciqCode: "156961"
        },
        {
            codeName: "乌鲁木齐地窝堡国际机场（中国）",
            cusCode: "142",
            codeValue: "CHN964",
            gbName: "乌鲁木齐地窝堡国际机场（中国）",
            gbCode: "CHN964",
            ciqCode: "156964"
        },
        {
            codeName: "喀什机场（中国）",
            cusCode: "142",
            codeValue: "CHN967",
            gbName: "喀什机场（中国）",
            gbCode: "CHN967",
            ciqCode: "156967"
        },
        {
            codeName: "科特迪瓦",
            cusCode: "223",
            codeValue: "CIV000",
            gbName: "科特迪瓦",
            gbCode: "CIV000",
            ciqCode: "384000"
        },
        {
            codeName: "阿比让（科特迪瓦）",
            cusCode: "1651",
            codeValue: "CIV003",
            gbName: "阿比让（科特迪瓦）",
            gbCode: "CIV003",
            ciqCode: "384003"
        },
        {
            codeName: "阿西尼（科特迪瓦）",
            cusCode: "223",
            codeValue: "CIV006",
            gbName: "阿西尼（科特迪瓦）",
            gbCode: "CIV006",
            ciqCode: "384006"
        },
        {
            codeName: "弗雷斯科（科特迪瓦）",
            cusCode: "1654",
            codeValue: "CIV009",
            gbName: "弗雷斯科（科特迪瓦）",
            gbCode: "CIV009",
            ciqCode: "384009"
        },
        {
            codeName: "大巴萨姆（科特迪瓦）",
            cusCode: "1655",
            codeValue: "CIV012",
            gbName: "大巴萨姆（科特迪瓦）",
            gbCode: "CIV012",
            ciqCode: "384012"
        },
        {
            codeName: "达布（科特迪瓦）",
            cusCode: "223",
            codeValue: "CIV014",
            gbName: "达布（科特迪瓦）",
            gbCode: "CIV014",
            ciqCode: "384014"
        },
        {
            codeName: "圣佩德罗（科特迪瓦）",
            cusCode: "223",
            codeValue: "CIV015",
            gbName: "圣佩德罗（科特迪瓦）",
            gbCode: "CIV015",
            ciqCode: "384015"
        },
        {
            codeName: "萨桑德拉（科特迪瓦）",
            cusCode: "1653",
            codeValue: "CIV018",
            gbName: "萨桑德拉（科特迪瓦）",
            gbCode: "CIV018",
            ciqCode: "384018"
        },
        {
            codeName: "塔布（科特迪瓦）",
            cusCode: "223",
            codeValue: "CIV021",
            gbName: "塔布（科特迪瓦）",
            gbCode: "CIV021",
            ciqCode: "384021"
        },
        {
            codeName: "布埃港（科特迪瓦）",
            cusCode: "1652",
            codeValue: "CIV022",
            gbName: "布埃港（科特迪瓦）",
            gbCode: "CIV022",
            ciqCode: "384022"
        },
        {
            codeName: "喀麦隆",
            cusCode: "206",
            codeValue: "CMR000",
            gbName: "喀麦隆",
            gbCode: "CMR000",
            ciqCode: "120000"
        },
        {
            codeName: "杜阿拉（喀麦隆）",
            cusCode: "1593",
            codeValue: "CMR003",
            gbName: "杜阿拉（喀麦隆）",
            gbCode: "CMR003",
            ciqCode: "120003"
        },
        {
            codeName: "克里比（喀麦隆）",
            cusCode: "206",
            codeValue: "CMR006",
            gbName: "克里比（喀麦隆）",
            gbCode: "CMR006",
            ciqCode: "120006"
        },
        {
            codeName: "提科（喀麦隆）",
            cusCode: "1595",
            codeValue: "CMR009",
            gbName: "提科（喀麦隆）",
            gbCode: "CMR009",
            ciqCode: "120009"
        },
        {
            codeName: "维多利亚（喀麦隆）",
            cusCode: "206",
            codeValue: "CMR012",
            gbName: "维多利亚（喀麦隆）",
            gbCode: "CMR012",
            ciqCode: "120012"
        },
        {
            codeName: "雅温得（喀麦隆）",
            cusCode: "1596",
            codeValue: "CMR015",
            gbName: "雅温得（喀麦隆）",
            gbCode: "CMR015",
            ciqCode: "120015"
        },
        {
            codeName: "刚果民主共和国",
            cusCode: "252",
            codeValue: "COD000",
            gbName: "刚果民主共和国",
            gbCode: "COD000",
            ciqCode: "180000"
        },
        {
            codeName: "巴纳纳（刚果民主共和国）",
            cusCode: "1782",
            codeValue: "COD003",
            gbName: "巴纳纳（刚果民主共和国）",
            gbCode: "COD003",
            ciqCode: "180003"
        },
        {
            codeName: "博马（刚果民主共和国）",
            cusCode: "1783",
            codeValue: "COD006",
            gbName: "博马（刚果民主共和国）",
            gbCode: "COD006",
            ciqCode: "180006"
        },
        {
            codeName: "马塔迪（刚果民主共和国）",
            cusCode: "1784",
            codeValue: "COD009",
            gbName: "马塔迪（刚果民主共和国）",
            gbCode: "COD009",
            ciqCode: "180009"
        },
        {
            codeName: "金沙萨（刚果民主共和国）",
            cusCode: "252",
            codeValue: "COD901",
            gbName: "金沙萨（刚果民主共和国）",
            gbCode: "COD901",
            ciqCode: "180901"
        },
        {
            codeName: "刚果共和国",
            cusCode: "213",
            codeValue: "COG000",
            gbName: "刚果共和国",
            gbCode: "COG000",
            ciqCode: "178000"
        },
        {
            codeName: "哲诺油码头（刚果共和国）",
            cusCode: "213",
            codeValue: "COG003",
            gbName: "哲诺油码头（刚果共和国）",
            gbCode: "COG003",
            ciqCode: "178003"
        },
        {
            codeName: "黑角（刚果共和国）",
            cusCode: "1610",
            codeValue: "COG006",
            gbName: "黑角（刚果共和国）",
            gbCode: "COG006",
            ciqCode: "178006"
        },
        {
            codeName: "库克群岛",
            cusCode: "602",
            codeValue: "COK000",
            gbName: "库克群岛",
            gbCode: "COK000",
            ciqCode: "184000"
        },
        {
            codeName: "阿鲁通加（库克群岛）",
            cusCode: "602",
            codeValue: "COK003",
            gbName: "阿鲁通加（库克群岛）",
            gbCode: "COK003",
            ciqCode: "184003"
        },
        {
            codeName: "阿瓦鲁阿（库克群岛）",
            cusCode: "3278",
            codeValue: "COK005",
            gbName: "阿瓦鲁阿（库克群岛）",
            gbCode: "COK005",
            ciqCode: "184005"
        },
        {
            codeName: "拉罗通加岛（库克群岛）",
            cusCode: "602",
            codeValue: "COK006",
            gbName: "拉罗通加岛（库克群岛）",
            gbCode: "COK006",
            ciqCode: "184006"
        },
        {
            codeName: "哥伦比亚",
            cusCode: "413",
            codeValue: "COL000",
            gbName: "哥伦比亚",
            gbCode: "COL000",
            ciqCode: "170000"
        },
        {
            codeName: "巴兰基利亚（哥伦比亚）",
            cusCode: "2787",
            codeValue: "COL003",
            gbName: "巴兰基利亚（哥伦比亚）",
            gbCode: "COL003",
            ciqCode: "170003"
        },
        {
            codeName: "布韦那文图拉（哥伦比亚）",
            cusCode: "2790",
            codeValue: "COL006",
            gbName: "布韦那文图拉（哥伦比亚）",
            gbCode: "COL006",
            ciqCode: "170006"
        },
        {
            codeName: "卡塔赫纳（哥伦比亚）",
            cusCode: "2791",
            codeValue: "COL009",
            gbName: "卡塔赫纳（哥伦比亚）",
            gbCode: "COL009",
            ciqCode: "170009"
        },
        {
            codeName: "科韦尼亚斯（哥伦比亚）",
            cusCode: "413",
            codeValue: "COL012",
            gbName: "科韦尼亚斯（哥伦比亚）",
            gbCode: "COL012",
            ciqCode: "170012"
        },
        {
            codeName: "波佐科罗拉多斯（哥伦比亚）",
            cusCode: "413",
            codeValue: "COL015",
            gbName: "波佐科罗拉多斯（哥伦比亚）",
            gbCode: "COL015",
            ciqCode: "170015"
        },
        {
            codeName: "哥伦比亚港（哥伦比亚）",
            cusCode: "413",
            codeValue: "COL018",
            gbName: "哥伦比亚港（哥伦比亚）",
            gbCode: "COL018",
            ciqCode: "170018"
        },
        {
            codeName: "卡雷尼奥港（哥伦比亚）",
            cusCode: "413",
            codeValue: "COL023",
            gbName: "卡雷尼奥港（哥伦比亚）",
            gbCode: "COL023",
            ciqCode: "170023"
        },
        {
            codeName: "圣玛尔塔（哥伦比亚）",
            cusCode: "2789",
            codeValue: "COL024",
            gbName: "圣玛尔塔（哥伦比亚）",
            gbCode: "COL024",
            ciqCode: "170024"
        },
        {
            codeName: "图马科（哥伦比亚）",
            cusCode: "2788",
            codeValue: "COL027",
            gbName: "图马科（哥伦比亚）",
            gbCode: "COL027",
            ciqCode: "170027"
        },
        {
            codeName: "图尔博（哥伦比亚）",
            cusCode: "413",
            codeValue: "COL030",
            gbName: "图尔博（哥伦比亚）",
            gbCode: "COL030",
            ciqCode: "170030"
        },
        {
            codeName: "科维纳斯（哥伦比亚）",
            cusCode: "2792",
            codeValue: "COL031",
            gbName: "科维纳斯（哥伦比亚）",
            gbCode: "COL031",
            ciqCode: "170031"
        },
        {
            codeName: "科摩罗",
            cusCode: "212",
            codeValue: "COM000",
            gbName: "科摩罗",
            gbCode: "COM000",
            ciqCode: "174000"
        },
        {
            codeName: "昂儒昂岛（科摩罗）",
            cusCode: "1605",
            codeValue: "COM001",
            gbName: "昂儒昂岛（科摩罗）",
            gbCode: "COM001",
            ciqCode: "174001"
        },
        {
            codeName: "莫埃利岛（科摩罗）",
            cusCode: "1606",
            codeValue: "COM002",
            gbName: "莫埃利岛（科摩罗）",
            gbCode: "COM002",
            ciqCode: "174002"
        },
        {
            codeName: "藻德济（科摩罗）",
            cusCode: "212",
            codeValue: "COM003",
            gbName: "藻德济（科摩罗）",
            gbCode: "COM003",
            ciqCode: "174003"
        },
        {
            codeName: "丰博尼（科摩罗）",
            cusCode: "1607",
            codeValue: "COM006",
            gbName: "丰博尼（科摩罗）",
            gbCode: "COM006",
            ciqCode: "174006"
        },
        {
            codeName: "莫罗尼（科摩罗）",
            cusCode: "1609",
            codeValue: "COM009",
            gbName: "莫罗尼（科摩罗）",
            gbCode: "COM009",
            ciqCode: "174009"
        },
        {
            codeName: "穆察穆杜（科摩罗）",
            cusCode: "1608",
            codeValue: "COM012",
            gbName: "穆察穆杜（科摩罗）",
            gbCode: "COM012",
            ciqCode: "174012"
        },
        {
            codeName: "佛得角",
            cusCode: "208",
            codeValue: "CPV000",
            gbName: "佛得角",
            gbCode: "CPV000",
            ciqCode: "132000"
        },
        {
            codeName: "明德卢（佛得角）",
            cusCode: "1601",
            codeValue: "CPV002",
            gbName: "明德卢（佛得角）",
            gbCode: "CPV002",
            ciqCode: "132002"
        },
        {
            codeName: "帕尔梅拉（佛得角）",
            cusCode: "208",
            codeValue: "CPV003",
            gbName: "帕尔梅拉（佛得角）",
            gbCode: "CPV003",
            ciqCode: "132003"
        },
        {
            codeName: "格兰德港（佛得角）",
            cusCode: "1602",
            codeValue: "CPV006",
            gbName: "格兰德港（佛得角）",
            gbCode: "CPV006",
            ciqCode: "132006"
        },
        {
            codeName: "普拉亚（佛得角）",
            cusCode: "208",
            codeValue: "CPV009",
            gbName: "普拉亚（佛得角）",
            gbCode: "CPV009",
            ciqCode: "132009"
        },
        {
            codeName: "哥斯达黎加",
            cusCode: "415",
            codeValue: "CRI000",
            gbName: "哥斯达黎加",
            gbCode: "CRI000",
            ciqCode: "188000"
        },
        {
            codeName: "卡尔德拉（哥斯达黎加）",
            cusCode: "415",
            codeValue: "CRI003",
            gbName: "卡尔德拉（哥斯达黎加）",
            gbCode: "CRI003",
            ciqCode: "188003"
        },
        {
            codeName: "戈尔菲托（哥斯达黎加）",
            cusCode: "2796",
            codeValue: "CRI006",
            gbName: "戈尔菲托（哥斯达黎加）",
            gbCode: "CRI006",
            ciqCode: "188006"
        },
        {
            codeName: "利蒙港（哥斯达黎加）",
            cusCode: "2797",
            codeValue: "CRI009",
            gbName: "利蒙港（哥斯达黎加）",
            gbCode: "CRI009",
            ciqCode: "188009"
        },
        {
            codeName: "彭塔雷纳斯（哥斯达黎加）",
            cusCode: "2795",
            codeValue: "CRI012",
            gbName: "彭塔雷纳斯（哥斯达黎加）",
            gbCode: "CRI012",
            ciqCode: "188012"
        },
        {
            codeName: "克波斯（哥斯达黎加）",
            cusCode: "2798",
            codeValue: "CRI015",
            gbName: "克波斯（哥斯达黎加）",
            gbCode: "CRI015",
            ciqCode: "188015"
        },
        {
            codeName: "古巴",
            cusCode: "416",
            codeValue: "CUB000",
            gbName: "古巴",
            gbCode: "CUB000",
            ciqCode: "192000"
        },
        {
            codeName: "安蒂亚（古巴）",
            cusCode: "2802",
            codeValue: "CUB003",
            gbName: "安蒂亚（古巴）",
            gbCode: "CUB003",
            ciqCode: "192003"
        },
        {
            codeName: "翁达港（古巴）",
            cusCode: "2803",
            codeValue: "CUB006",
            gbName: "翁达港（古巴）",
            gbCode: "CUB006",
            ciqCode: "192006"
        },
        {
            codeName: "巴内斯（古巴）",
            cusCode: "416",
            codeValue: "CUB009",
            gbName: "巴内斯（古巴）",
            gbCode: "CUB009",
            ciqCode: "192009"
        },
        {
            codeName: "巴拉科阿（古巴）",
            cusCode: "2804",
            codeValue: "CUB012",
            gbName: "巴拉科阿（古巴）",
            gbCode: "CUB012",
            ciqCode: "192012"
        },
        {
            codeName: "博卡格兰德（古巴）",
            cusCode: "416",
            codeValue: "CUB015",
            gbName: "博卡格兰德（古巴）",
            gbCode: "CUB015",
            ciqCode: "192015"
        },
        {
            codeName: "博克龙（古巴）",
            cusCode: "416",
            codeValue: "CUB018",
            gbName: "博克龙（古巴）",
            gbCode: "CUB018",
            ciqCode: "192018"
        },
        {
            codeName: "卡瓦尼亚斯（古巴）",
            cusCode: "416",
            codeValue: "CUB021",
            gbName: "卡瓦尼亚斯（古巴）",
            gbCode: "CUB021",
            ciqCode: "192021"
        },
        {
            codeName: "凯巴连（古巴）",
            cusCode: "2800",
            codeValue: "CUB024",
            gbName: "凯巴连（古巴）",
            gbCode: "CUB024",
            ciqCode: "192024"
        },
        {
            codeName: "凯马勒那（古巴）",
            cusCode: "416",
            codeValue: "CUB027",
            gbName: "凯马勒那（古巴）",
            gbCode: "CUB027",
            ciqCode: "192027"
        },
        {
            codeName: "萨瓜塔那摩（古巴）",
            cusCode: "2817",
            codeValue: "CUB029",
            gbName: "萨瓜塔那摩（古巴）",
            gbCode: "CUB029",
            ciqCode: "192029"
        },
        {
            codeName: "卡德纳斯（古巴）",
            cusCode: "2799",
            codeValue: "CUB030",
            gbName: "卡德纳斯（古巴）",
            gbCode: "CUB030",
            ciqCode: "192030"
        },
        {
            codeName: "卡西尔达（古巴）",
            cusCode: "416",
            codeValue: "CUB033",
            gbName: "卡西尔达（古巴）",
            gbCode: "CUB033",
            ciqCode: "192033"
        },
        {
            codeName: "塞巴胡埃萨（古巴）",
            cusCode: "416",
            codeValue: "CUB036",
            gbName: "塞巴胡埃萨（古巴）",
            gbCode: "CUB036",
            ciqCode: "192036"
        },
        {
            codeName: "西恩富戈斯（古巴）",
            cusCode: "2801",
            codeValue: "CUB039",
            gbName: "西恩富戈斯（古巴）",
            gbCode: "CUB039",
            ciqCode: "192039"
        },
        {
            codeName: "费尔顿（古巴）",
            cusCode: "416",
            codeValue: "CUB042",
            gbName: "费尔顿（古巴）",
            gbCode: "CUB042",
            ciqCode: "192042"
        },
        {
            codeName: "瓜亚瓦尔（古巴）",
            cusCode: "416",
            codeValue: "CUB045",
            gbName: "瓜亚瓦尔（古巴）",
            gbCode: "CUB045",
            ciqCode: "192045"
        },
        {
            codeName: "哈瓦那（古巴）",
            cusCode: "2806",
            codeValue: "CUB048",
            gbName: "哈瓦那（古巴）",
            gbCode: "CUB048",
            ciqCode: "192048"
        },
        {
            codeName: "伊萨贝拉（古巴）",
            cusCode: "416",
            codeValue: "CUB051",
            gbName: "伊萨贝拉（古巴）",
            gbCode: "CUB051",
            ciqCode: "192051"
        },
        {
            codeName: "胡卡罗（古巴）",
            cusCode: "2807",
            codeValue: "CUB054",
            gbName: "胡卡罗（古巴）",
            gbCode: "CUB054",
            ciqCode: "192054"
        },
        {
            codeName: "马纳蒂（古巴）",
            cusCode: "2810",
            codeValue: "CUB057",
            gbName: "马纳蒂（古巴）",
            gbCode: "CUB057",
            ciqCode: "192057"
        },
        {
            codeName: "马诺普拉（古巴）",
            cusCode: "2811",
            codeValue: "CUB060",
            gbName: "马诺普拉（古巴）",
            gbCode: "CUB060",
            ciqCode: "192060"
        },
        {
            codeName: "曼萨尼略（古巴）",
            cusCode: "2812",
            codeValue: "CUB063",
            gbName: "曼萨尼略（古巴）",
            gbCode: "CUB063",
            ciqCode: "192063"
        },
        {
            codeName: "马里埃尔（古巴）",
            cusCode: "416",
            codeValue: "CUB066",
            gbName: "马里埃尔（古巴）",
            gbCode: "CUB066",
            ciqCode: "192066"
        },
        {
            codeName: "马坦萨斯（古巴）",
            cusCode: "2813",
            codeValue: "CUB069",
            gbName: "马坦萨斯（古巴）",
            gbCode: "CUB069",
            ciqCode: "192069"
        },
        {
            codeName: "梅迪亚卢纳（古巴）",
            cusCode: "416",
            codeValue: "CUB072",
            gbName: "梅迪亚卢纳（古巴）",
            gbCode: "CUB072",
            ciqCode: "192072"
        },
        {
            codeName: "莫阿（古巴）",
            cusCode: "416",
            codeValue: "CUB075",
            gbName: "莫阿（古巴）",
            gbCode: "CUB075",
            ciqCode: "192075"
        },
        {
            codeName: "尼卡罗（古巴）",
            cusCode: "416",
            codeValue: "CUB078",
            gbName: "尼卡罗（古巴）",
            gbCode: "CUB078",
            ciqCode: "192078"
        },
        {
            codeName: "尼克罗（古巴）",
            cusCode: "416",
            codeValue: "CUB081",
            gbName: "尼克罗（古巴）",
            gbCode: "CUB081",
            ciqCode: "192081"
        },
        {
            codeName: "新赫罗纳（古巴）",
            cusCode: "416",
            codeValue: "CUB084",
            gbName: "新赫罗纳（古巴）",
            gbCode: "CUB084",
            ciqCode: "192084"
        },
        {
            codeName: "努埃维塔斯（古巴）",
            cusCode: "2815",
            codeValue: "CUB087",
            gbName: "努埃维塔斯（古巴）",
            gbCode: "CUB087",
            ciqCode: "192087"
        },
        {
            codeName: "帕洛阿尔托（古巴）",
            cusCode: "416",
            codeValue: "CUB090",
            gbName: "帕洛阿尔托（古巴）",
            gbCode: "CUB090",
            ciqCode: "192090"
        },
        {
            codeName: "帕斯特利洛（古巴）",
            cusCode: "416",
            codeValue: "CUB093",
            gbName: "帕斯特利洛（古巴）",
            gbCode: "CUB093",
            ciqCode: "192093"
        },
        {
            codeName: "皮隆（古巴）",
            cusCode: "416",
            codeValue: "CUB096",
            gbName: "皮隆（古巴）",
            gbCode: "CUB096",
            ciqCode: "192096"
        },
        {
            codeName: "普雷斯顿（古巴）",
            cusCode: "416",
            codeValue: "CUB099",
            gbName: "普雷斯顿（古巴）",
            gbCode: "CUB099",
            ciqCode: "192099"
        },
        {
            codeName: "帕德雷港（古巴）",
            cusCode: "2816",
            codeValue: "CUB102",
            gbName: "帕德雷港（古巴）",
            gbCode: "CUB102",
            ciqCode: "192102"
        },
        {
            codeName: "塔拉法港（古巴）",
            cusCode: "2822",
            codeValue: "CUB105",
            gbName: "塔拉法港（古巴）",
            gbCode: "CUB105",
            ciqCode: "192105"
        },
        {
            codeName: "大萨瓜（古巴）",
            cusCode: "416",
            codeValue: "CUB108",
            gbName: "大萨瓜（古巴）",
            gbCode: "CUB108",
            ciqCode: "192108"
        },
        {
            codeName: "南圣克鲁斯（古巴）",
            cusCode: "2819",
            codeValue: "CUB111",
            gbName: "南圣克鲁斯（古巴）",
            gbCode: "CUB111",
            ciqCode: "192111"
        },
        {
            codeName: "圣卡西亚（古巴）",
            cusCode: "416",
            codeValue: "CUB114",
            gbName: "圣卡西亚（古巴）",
            gbCode: "CUB114",
            ciqCode: "192114"
        },
        {
            codeName: "圣地亚哥（古巴）",
            cusCode: "2821",
            codeValue: "CUB117",
            gbName: "圣地亚哥（古巴）",
            gbCode: "CUB117",
            ciqCode: "192117"
        },
        {
            codeName: "塔纳莫（古巴）",
            cusCode: "416",
            codeValue: "CUB120",
            gbName: "塔纳莫（古巴）",
            gbCode: "CUB120",
            ciqCode: "192120"
        },
        {
            codeName: "图纳斯德萨萨（古巴）",
            cusCode: "2823",
            codeValue: "CUB123",
            gbName: "图纳斯德萨萨（古巴）",
            gbCode: "CUB123",
            ciqCode: "192123"
        },
        {
            codeName: "维塔（古巴）",
            cusCode: "416",
            codeValue: "CUB126",
            gbName: "维塔（古巴）",
            gbCode: "CUB126",
            ciqCode: "192126"
        },
        {
            codeName: "DESEO（古巴）",
            cusCode: "2805",
            codeValue: "CUB127",
            gbName: "DESEO（古巴）",
            gbCode: "CUB127",
            ciqCode: "192127"
        },
        {
            codeName: "库拉索",
            cusCode: "417",
            codeValue: "CUW000",
            gbName: "库拉索",
            gbCode: "CUW000",
            ciqCode: "531000"
        },
        {
            codeName: "圣米歇尔湾（库拉索）",
            cusCode: "2824",
            codeValue: "CUW003",
            gbName: "圣米歇尔湾（库拉索）",
            gbCode: "CUW003",
            ciqCode: "531003"
        },
        {
            codeName: "圣诞岛",
            cusCode: "628",
            codeValue: "CXR000",
            gbName: "圣诞岛",
            gbCode: "CXR000",
            ciqCode: "162000"
        },
        {
            codeName: "开曼群岛",
            cusCode: "411",
            codeValue: "CYM000",
            gbName: "开曼群岛",
            gbCode: "CYM000",
            ciqCode: "136000"
        },
        {
            codeName: "乔治敦（开曼群岛）",
            cusCode: "411",
            codeValue: "CYM003",
            gbName: "乔治敦（开曼群岛）",
            gbCode: "CYM003",
            ciqCode: "136003"
        },
        {
            codeName: "塞浦路斯",
            cusCode: "108",
            codeValue: "CYP000",
            gbName: "塞浦路斯",
            gbCode: "CYP000",
            ciqCode: "196000"
        },
        {
            codeName: "阿克罗蒂里（塞浦路斯）",
            cusCode: "108",
            codeValue: "CYP003",
            gbName: "阿克罗蒂里（塞浦路斯）",
            gbCode: "CYP003",
            ciqCode: "196003"
        },
        {
            codeName: "泽凯利亚（塞浦路斯）",
            cusCode: "108",
            codeValue: "CYP006",
            gbName: "泽凯利亚（塞浦路斯）",
            gbCode: "CYP006",
            ciqCode: "196006"
        },
        {
            codeName: "法马古斯塔（塞浦路斯）",
            cusCode: "108",
            codeValue: "CYP009",
            gbName: "法马古斯塔（塞浦路斯）",
            gbCode: "CYP009",
            ciqCode: "196009"
        },
        {
            codeName: "吉兰丹（塞浦路斯）",
            cusCode: "1021",
            codeValue: "CYP010",
            gbName: "吉兰丹（塞浦路斯）",
            gbCode: "CYP010",
            ciqCode: "196010"
        },
        {
            codeName: "卡拉沃斯塔西（塞浦路斯）",
            cusCode: "108",
            codeValue: "CYP012",
            gbName: "卡拉沃斯塔西（塞浦路斯）",
            gbCode: "CYP012",
            ciqCode: "196012"
        },
        {
            codeName: "凯里尼亚（塞浦路斯）",
            cusCode: "108",
            codeValue: "CYP015",
            gbName: "凯里尼亚（塞浦路斯）",
            gbCode: "CYP015",
            ciqCode: "196015"
        },
        {
            codeName: "拉纳卡（塞浦路斯）",
            cusCode: "108",
            codeValue: "CYP018",
            gbName: "拉纳卡（塞浦路斯）",
            gbCode: "CYP018",
            ciqCode: "196018"
        },
        {
            codeName: "腊基（塞浦路斯）",
            cusCode: "1023",
            codeValue: "CYP021",
            gbName: "腊基（塞浦路斯）",
            gbCode: "CYP021",
            ciqCode: "196021"
        },
        {
            codeName: "利马索尔（塞浦路斯）",
            cusCode: "1024",
            codeValue: "CYP024",
            gbName: "利马索尔（塞浦路斯）",
            gbCode: "CYP024",
            ciqCode: "196024"
        },
        {
            codeName: "莫尼安克雷奇（塞浦路斯）",
            cusCode: "108",
            codeValue: "CYP027",
            gbName: "莫尼安克雷奇（塞浦路斯）",
            gbCode: "CYP027",
            ciqCode: "196027"
        },
        {
            codeName: "尼科西亚（塞浦路斯）",
            cusCode: "1026",
            codeValue: "CYP028",
            gbName: "尼科西亚（塞浦路斯）",
            gbCode: "CYP028",
            ciqCode: "196028"
        },
        {
            codeName: "莫尔富湾（塞浦路斯）",
            cusCode: "1025",
            codeValue: "CYP030",
            gbName: "莫尔富湾（塞浦路斯）",
            gbCode: "CYP030",
            ciqCode: "196030"
        },
        {
            codeName: "帕福斯（塞浦路斯）",
            cusCode: "1027",
            codeValue: "CYP033",
            gbName: "帕福斯（塞浦路斯）",
            gbCode: "CYP033",
            ciqCode: "196033"
        },
        {
            codeName: "瓦西利科湾（塞浦路斯）",
            cusCode: "1029",
            codeValue: "CYP036",
            gbName: "瓦西利科湾（塞浦路斯）",
            gbCode: "CYP036",
            ciqCode: "196036"
        },
        {
            codeName: "捷克",
            cusCode: "352",
            codeValue: "CZE000",
            gbName: "捷克",
            gbCode: "CZE000",
            ciqCode: "203000"
        },
        {
            codeName: "德国",
            cusCode: "304",
            codeValue: "DEU000",
            gbName: "德国",
            gbCode: "DEU000",
            ciqCode: "276000"
        },
        {
            codeName: "阿尔托纳（德国）",
            cusCode: "304",
            codeValue: "DEU003",
            gbName: "阿尔托纳（德国）",
            gbCode: "DEU003",
            ciqCode: "276003"
        },
        {
            codeName: "布莱克森（德国）",
            cusCode: "304",
            codeValue: "DEU006",
            gbName: "布莱克森（德国）",
            gbCode: "DEU006",
            ciqCode: "276006"
        },
        {
            codeName: "波恩（德国）",
            cusCode: "304",
            codeValue: "DEU009",
            gbName: "波恩（德国）",
            gbCode: "DEU009",
            ciqCode: "276009"
        },
        {
            codeName: "布腊克（德国）",
            cusCode: "2100",
            codeValue: "DEU012",
            gbName: "布腊克（德国）",
            gbCode: "DEU012",
            ciqCode: "276012"
        },
        {
            codeName: "不来梅（德国）",
            cusCode: "2101",
            codeValue: "DEU015",
            gbName: "不来梅（德国）",
            gbCode: "DEU015",
            ciqCode: "276015"
        },
        {
            codeName: "不来梅港（德国）",
            cusCode: "2102",
            codeValue: "DEU018",
            gbName: "不来梅港（德国）",
            gbCode: "DEU018",
            ciqCode: "276018"
        },
        {
            codeName: "布伦斯比特尔（德国）",
            cusCode: "2103",
            codeValue: "DEU021",
            gbName: "布伦斯比特尔（德国）",
            gbCode: "DEU021",
            ciqCode: "276021"
        },
        {
            codeName: "比瑟姆（德国）",
            cusCode: "304",
            codeValue: "DEU024",
            gbName: "比瑟姆（德国）",
            gbCode: "DEU024",
            ciqCode: "276024"
        },
        {
            codeName: "比茨费莱特（德国）",
            cusCode: "304",
            codeValue: "DEU027",
            gbName: "比茨费莱特（德国）",
            gbCode: "DEU027",
            ciqCode: "276027"
        },
        {
            codeName: "科布伦茨（德国）",
            cusCode: "304",
            codeValue: "DEU030",
            gbName: "科布伦茨（德国）",
            gbCode: "DEU030",
            ciqCode: "276030"
        },
        {
            codeName: "科隆（德国）",
            cusCode: "2104",
            codeValue: "DEU033",
            gbName: "科隆（德国）",
            gbCode: "DEU033",
            ciqCode: "276033"
        },
        {
            codeName: "库克斯港（德国）",
            cusCode: "2105",
            codeValue: "DEU036",
            gbName: "库克斯港（德国）",
            gbCode: "DEU036",
            ciqCode: "276036"
        },
        {
            codeName: "杜伊斯堡（德国）",
            cusCode: "2106",
            codeValue: "DEU039",
            gbName: "杜伊斯堡（德国）",
            gbCode: "DEU039",
            ciqCode: "276039"
        },
        {
            codeName: "杜塞尔多夫（德国）",
            cusCode: "2107",
            codeValue: "DEU042",
            gbName: "杜塞尔多夫（德国）",
            gbCode: "DEU042",
            ciqCode: "276042"
        },
        {
            codeName: "埃肯弗尔德（德国）",
            cusCode: "2108",
            codeValue: "DEU045",
            gbName: "埃肯弗尔德（德国）",
            gbCode: "DEU045",
            ciqCode: "276045"
        },
        {
            codeName: "埃尔斯费莱特（德国）",
            cusCode: "304",
            codeValue: "DEU048",
            gbName: "埃尔斯费莱特（德国）",
            gbCode: "DEU048",
            ciqCode: "276048"
        },
        {
            codeName: "埃姆登（德国）",
            cusCode: "2109",
            codeValue: "DEU051",
            gbName: "埃姆登（德国）",
            gbCode: "DEU051",
            ciqCode: "276051"
        },
        {
            codeName: "弗伦斯堡（德国）",
            cusCode: "304",
            codeValue: "DEU054",
            gbName: "弗伦斯堡（德国）",
            gbCode: "DEU054",
            ciqCode: "276054"
        },
        {
            codeName: "法兰克福（德国）",
            cusCode: "304",
            codeValue: "DEU057",
            gbName: "法兰克福（德国）",
            gbCode: "DEU057",
            ciqCode: "276057"
        },
        {
            codeName: "格吕克施塔特（德国）",
            cusCode: "304",
            codeValue: "DEU060",
            gbName: "格吕克施塔特（德国）",
            gbCode: "DEU060",
            ciqCode: "276060"
        },
        {
            codeName: "汉堡（德国）",
            cusCode: "2110",
            codeValue: "DEU063",
            gbName: "汉堡（德国）",
            gbCode: "DEU063",
            ciqCode: "276063"
        },
        {
            codeName: "海利根港（德国）",
            cusCode: "2111",
            codeValue: "DEU066",
            gbName: "海利根港（德国）",
            gbCode: "DEU066",
            ciqCode: "276066"
        },
        {
            codeName: "霍尔特瑙（德国）",
            cusCode: "2112",
            codeValue: "DEU069",
            gbName: "霍尔特瑙（德国）",
            gbCode: "DEU069",
            ciqCode: "276069"
        },
        {
            codeName: "胡苏姆（德国）",
            cusCode: "2113",
            codeValue: "DEU072",
            gbName: "胡苏姆（德国）",
            gbCode: "DEU072",
            ciqCode: "276072"
        },
        {
            codeName: "伊策霍（德国）",
            cusCode: "304",
            codeValue: "DEU075",
            gbName: "伊策霍（德国）",
            gbCode: "DEU075",
            ciqCode: "276075"
        },
        {
            codeName: "卡珀尔恩（德国）",
            cusCode: "304",
            codeValue: "DEU078",
            gbName: "卡珀尔恩（德国）",
            gbCode: "DEU078",
            ciqCode: "276078"
        },
        {
            codeName: "基尔（德国）",
            cusCode: "2114",
            codeValue: "DEU081",
            gbName: "基尔（德国）",
            gbCode: "DEU081",
            ciqCode: "276081"
        },
        {
            codeName: "克雷菲尔德（德国）",
            cusCode: "2117",
            codeValue: "DEU084",
            gbName: "克雷菲尔德（德国）",
            gbCode: "DEU084",
            ciqCode: "276084"
        },
        {
            codeName: "拉伯（德国）",
            cusCode: "2118",
            codeValue: "DEU087",
            gbName: "拉伯（德国）",
            gbCode: "DEU087",
            ciqCode: "276087"
        },
        {
            codeName: "累尔（德国）",
            cusCode: "2119",
            codeValue: "DEU090",
            gbName: "累尔（德国）",
            gbCode: "DEU090",
            ciqCode: "276090"
        },
        {
            codeName: "吕贝克（德国）",
            cusCode: "2120",
            codeValue: "DEU093",
            gbName: "吕贝克（德国）",
            gbCode: "DEU093",
            ciqCode: "276093"
        },
        {
            codeName: "路德维希港（德国）",
            cusCode: "304",
            codeValue: "DEU096",
            gbName: "路德维希港（德国）",
            gbCode: "DEU096",
            ciqCode: "276096"
        },
        {
            codeName: "美因茨（德国）",
            cusCode: "304",
            codeValue: "DEU099",
            gbName: "美因茨（德国）",
            gbCode: "DEU099",
            ciqCode: "276099"
        },
        {
            codeName: "曼海姆（德国）",
            cusCode: "304",
            codeValue: "DEU102",
            gbName: "曼海姆（德国）",
            gbCode: "DEU102",
            ciqCode: "276102"
        },
        {
            codeName: "诺伊豪斯（德国）",
            cusCode: "304",
            codeValue: "DEU105",
            gbName: "诺伊豪斯（德国）",
            gbCode: "DEU105",
            ciqCode: "276105"
        },
        {
            codeName: "诺伊斯（德国）",
            cusCode: "2122",
            codeValue: "DEU108",
            gbName: "诺伊斯（德国）",
            gbCode: "DEU108",
            ciqCode: "276108"
        },
        {
            codeName: "诺伊施塔特（德国）",
            cusCode: "304",
            codeValue: "DEU111",
            gbName: "诺伊施塔特（德国）",
            gbCode: "DEU111",
            ciqCode: "276111"
        },
        {
            codeName: "诺登哈姆（德国）",
            cusCode: "2123",
            codeValue: "DEU114",
            gbName: "诺登哈姆（德国）",
            gbCode: "DEU114",
            ciqCode: "276114"
        },
        {
            codeName: "奥尔登堡（德国）",
            cusCode: "2124",
            codeValue: "DEU116",
            gbName: "奥尔登堡（德国）",
            gbCode: "DEU116",
            ciqCode: "276116"
        },
        {
            codeName: "奥尔特（德国）",
            cusCode: "304",
            codeValue: "DEU117",
            gbName: "奥尔特（德国）",
            gbCode: "DEU117",
            ciqCode: "276117"
        },
        {
            codeName: "帕彭堡（德国）",
            cusCode: "2125",
            codeValue: "DEU120",
            gbName: "帕彭堡（德国）",
            gbCode: "DEU120",
            ciqCode: "276120"
        },
        {
            codeName: "伦茨堡（德国）",
            cusCode: "304",
            codeValue: "DEU123",
            gbName: "伦茨堡（德国）",
            gbCode: "DEU123",
            ciqCode: "276123"
        },
        {
            codeName: "罗斯托克（德国）",
            cusCode: "2458",
            codeValue: "DEU126",
            gbName: "罗斯托克（德国）",
            gbCode: "DEU126",
            ciqCode: "276126"
        },
        {
            codeName: "许劳（德国）",
            cusCode: "2126",
            codeValue: "DEU129",
            gbName: "许劳（德国）",
            gbCode: "DEU129",
            ciqCode: "276129"
        },
        {
            codeName: "施瓦苓郝廷（德国）",
            cusCode: "304",
            codeValue: "DEU132",
            gbName: "施瓦苓郝廷（德国）",
            gbCode: "DEU132",
            ciqCode: "276132"
        },
        {
            codeName: "施塔德（德国）",
            cusCode: "304",
            codeValue: "DEU135",
            gbName: "施塔德（德国）",
            gbCode: "DEU135",
            ciqCode: "276135"
        },
        {
            codeName: "施塔德桑德（德国）",
            cusCode: "304",
            codeValue: "DEU138",
            gbName: "施塔德桑德（德国）",
            gbCode: "DEU138",
            ciqCode: "276138"
        },
        {
            codeName: "斯特拉尔松（德国）",
            cusCode: "2459",
            codeValue: "DEU141",
            gbName: "斯特拉尔松（德国）",
            gbCode: "DEU141",
            ciqCode: "276141"
        },
        {
            codeName: "滕宁（德国）",
            cusCode: "2127",
            codeValue: "DEU144",
            gbName: "滕宁（德国）",
            gbCode: "DEU144",
            ciqCode: "276144"
        },
        {
            codeName: "特罗弗明德（德国）",
            cusCode: "304",
            codeValue: "DEU147",
            gbName: "特罗弗明德（德国）",
            gbCode: "DEU147",
            ciqCode: "276147"
        },
        {
            codeName: "弗格萨克（德国）",
            cusCode: "2128",
            codeValue: "DEU150",
            gbName: "弗格萨克（德国）",
            gbCode: "DEU150",
            ciqCode: "276150"
        },
        {
            codeName: "瓦尔内明德（德国）",
            cusCode: "304",
            codeValue: "DEU153",
            gbName: "瓦尔内明德（德国）",
            gbCode: "DEU153",
            ciqCode: "276153"
        },
        {
            codeName: "威廉斯堡（德国）",
            cusCode: "304",
            codeValue: "DEU156",
            gbName: "威廉斯堡（德国）",
            gbCode: "DEU156",
            ciqCode: "276156"
        },
        {
            codeName: "威廉港（德国）",
            cusCode: "2129",
            codeValue: "DEU159",
            gbName: "威廉港（德国）",
            gbCode: "DEU159",
            ciqCode: "276159"
        },
        {
            codeName: "维斯马（德国）",
            cusCode: "2461",
            codeValue: "DEU162",
            gbName: "维斯马（德国）",
            gbCode: "DEU162",
            ciqCode: "276162"
        },
        {
            codeName: "柏林（德国）",
            cusCode: "304",
            codeValue: "DEU901",
            gbName: "柏林（德国）",
            gbCode: "DEU901",
            ciqCode: "276901"
        },
        {
            codeName: "慕尼黑（德国）",
            cusCode: "304",
            codeValue: "DEU904",
            gbName: "慕尼黑（德国）",
            gbCode: "DEU904",
            ciqCode: "276904"
        },
        {
            codeName: "吉布提",
            cusCode: "214",
            codeValue: "DJI000",
            gbName: "吉布提",
            gbCode: "DJI000",
            ciqCode: "262000"
        },
        {
            codeName: "吉布提（吉布提）",
            cusCode: "214",
            codeValue: "DJI003",
            gbName: "吉布提（吉布提）",
            gbCode: "DJI003",
            ciqCode: "262003"
        },
        {
            codeName: "奥博克（吉布提）",
            cusCode: "1611",
            codeValue: "DJI004",
            gbName: "奥博克（吉布提）",
            gbCode: "DJI004",
            ciqCode: "262004"
        },
        {
            codeName: "塔朱拉（吉布提）",
            cusCode: "1612",
            codeValue: "DJI005",
            gbName: "塔朱拉（吉布提）",
            gbCode: "DJI005",
            ciqCode: "262005"
        },
        {
            codeName: "多米尼克",
            cusCode: "414",
            codeValue: "DMA000",
            gbName: "多米尼克",
            gbCode: "DMA000",
            ciqCode: "212000"
        },
        {
            codeName: "朴次茅斯（多米尼克）",
            cusCode: "414",
            codeValue: "DMA003",
            gbName: "朴次茅斯（多米尼克）",
            gbCode: "DMA003",
            ciqCode: "212003"
        },
        {
            codeName: "罗索（多米尼克）",
            cusCode: "2794",
            codeValue: "DMA006",
            gbName: "罗索（多米尼克）",
            gbCode: "DMA006",
            ciqCode: "212006"
        },
        {
            codeName: "DOMINICA（多米尼克）",
            cusCode: "2793",
            codeValue: "DMA009",
            gbName: "DOMINICA（多米尼克）",
            gbCode: "DMA009",
            ciqCode: "212009"
        },
        {
            codeName: "丹麦",
            cusCode: "302",
            codeValue: "DNK000",
            gbName: "丹麦",
            gbCode: "DNK000",
            ciqCode: "208000"
        },
        {
            codeName: "奥本罗（丹麦）",
            cusCode: "1795",
            codeValue: "DNK003",
            gbName: "奥本罗（丹麦）",
            gbCode: "DNK003",
            ciqCode: "208003"
        },
        {
            codeName: "奥尔堡（丹麦）",
            cusCode: "1796",
            codeValue: "DNK006",
            gbName: "奥尔堡（丹麦）",
            gbCode: "DNK006",
            ciqCode: "208006"
        },
        {
            codeName: "奥胡斯（丹麦）",
            cusCode: "1797",
            codeValue: "DNK009",
            gbName: "奥胡斯（丹麦）",
            gbCode: "DNK009",
            ciqCode: "208009"
        },
        {
            codeName: "埃勒斯克平（丹麦）",
            cusCode: "1798",
            codeValue: "DNK012",
            gbName: "埃勒斯克平（丹麦）",
            gbCode: "DNK012",
            ciqCode: "208012"
        },
        {
            codeName: "阿灵厄（丹麦）",
            cusCode: "1799",
            codeValue: "DNK015",
            gbName: "阿灵厄（丹麦）",
            gbCode: "DNK015",
            ciqCode: "208015"
        },
        {
            codeName: "阿森斯（丹麦）",
            cusCode: "1801",
            codeValue: "DNK018",
            gbName: "阿森斯（丹麦）",
            gbCode: "DNK018",
            ciqCode: "208018"
        },
        {
            codeName: "阿斯尼斯（丹麦）",
            cusCode: "1800",
            codeValue: "DNK019",
            gbName: "阿斯尼斯（丹麦）",
            gbCode: "DNK019",
            ciqCode: "208019"
        },
        {
            codeName: "班霍尔姆（丹麦）",
            cusCode: "1802",
            codeValue: "DNK021",
            gbName: "班霍尔姆（丹麦）",
            gbCode: "DNK021",
            ciqCode: "208021"
        },
        {
            codeName: "博恩瑟（丹麦）",
            cusCode: "1803",
            codeValue: "DNK024",
            gbName: "博恩瑟（丹麦）",
            gbCode: "DNK024",
            ciqCode: "208024"
        },
        {
            codeName: "哥本哈根（丹麦）",
            cusCode: "1804",
            codeValue: "DNK027",
            gbName: "哥本哈根（丹麦）",
            gbCode: "DNK027",
            ciqCode: "208027"
        },
        {
            codeName: "埃伯尔措夫特（丹麦）",
            cusCode: "302",
            codeValue: "DNK030",
            gbName: "埃伯尔措夫特（丹麦）",
            gbCode: "DNK030",
            ciqCode: "208030"
        },
        {
            codeName: "埃尔西诺（丹麦）",
            cusCode: "302",
            codeValue: "DNK033",
            gbName: "埃尔西诺（丹麦）",
            gbCode: "DNK033",
            ciqCode: "208033"
        },
        {
            codeName: "埃斯比约（丹麦）",
            cusCode: "3414",
            codeValue: "DNK036",
            gbName: "埃斯比约（丹麦）",
            gbCode: "DNK036",
            ciqCode: "208036"
        },
        {
            codeName: "福堡（丹麦）",
            cusCode: "302",
            codeValue: "DNK039",
            gbName: "福堡（丹麦）",
            gbCode: "DNK039",
            ciqCode: "208039"
        },
        {
            codeName: "恩舍尔兹维克（丹麦）",
            cusCode: "1833",
            codeValue: "DNK041",
            gbName: "恩舍尔兹维克（丹麦）",
            gbCode: "DNK041",
            ciqCode: "208041"
        },
        {
            codeName: "法克瑟莱泽普拉斯（丹麦）",
            cusCode: "302",
            codeValue: "DNK042",
            gbName: "法克瑟莱泽普拉斯（丹麦）",
            gbCode: "DNK042",
            ciqCode: "208042"
        },
        {
            codeName: "腓特烈西亚（丹麦）",
            cusCode: "302",
            codeValue: "DNK045",
            gbName: "腓特烈西亚（丹麦）",
            gbCode: "DNK045",
            ciqCode: "208045"
        },
        {
            codeName: "腓特烈港（丹麦）",
            cusCode: "302",
            codeValue: "DNK048",
            gbName: "腓特烈港（丹麦）",
            gbCode: "DNK048",
            ciqCode: "208048"
        },
        {
            codeName: "腓特烈松（丹麦）",
            cusCode: "302",
            codeValue: "DNK051",
            gbName: "腓特烈松（丹麦）",
            gbCode: "DNK051",
            ciqCode: "208051"
        },
        {
            codeName: "腓特烈斯韦克（丹麦）",
            cusCode: "302",
            codeValue: "DNK054",
            gbName: "腓特烈斯韦克（丹麦）",
            gbCode: "DNK054",
            ciqCode: "208054"
        },
        {
            codeName: "格罗斯滕（丹麦）",
            cusCode: "302",
            codeValue: "DNK057",
            gbName: "格罗斯滕（丹麦）",
            gbCode: "DNK057",
            ciqCode: "208057"
        },
        {
            codeName: "格雷诺（丹麦）",
            cusCode: "302",
            codeValue: "DNK060",
            gbName: "格雷诺（丹麦）",
            gbCode: "DNK060",
            ciqCode: "208060"
        },
        {
            codeName: "基尔夫港（丹麦）",
            cusCode: "302",
            codeValue: "DNK063",
            gbName: "基尔夫港（丹麦）",
            gbCode: "DNK063",
            ciqCode: "208063"
        },
        {
            codeName: "吉尔夫哈文（丹麦）",
            cusCode: "1846",
            codeValue: "DNK064",
            gbName: "吉尔夫哈文（丹麦）",
            gbCode: "DNK064",
            ciqCode: "208064"
        },
        {
            codeName: "哈梅哈夫楠（丹麦）",
            cusCode: "1806",
            codeValue: "DNK065",
            gbName: "哈梅哈夫楠（丹麦）",
            gbCode: "DNK065",
            ciqCode: "208065"
        },
        {
            codeName: "哈泽斯莱乌（丹麦）",
            cusCode: "302",
            codeValue: "DNK066",
            gbName: "哈泽斯莱乌（丹麦）",
            gbCode: "DNK066",
            ciqCode: "208066"
        },
        {
            codeName: "海松（丹麦）",
            cusCode: "302",
            codeValue: "DNK069",
            gbName: "海松（丹麦）",
            gbCode: "DNK069",
            ciqCode: "208069"
        },
        {
            codeName: "海斯勒（丹麦）",
            cusCode: "1807",
            codeValue: "DNK072",
            gbName: "海斯勒（丹麦）",
            gbCode: "DNK072",
            ciqCode: "208072"
        },
        {
            codeName: "沃斯托克岛（丹麦）",
            cusCode: "1858",
            codeValue: "DNK074",
            gbName: "沃斯托克岛（丹麦）",
            gbCode: "DNK074",
            ciqCode: "208074"
        },
        {
            codeName: "希茨海尔斯（丹麦）",
            cusCode: "1809",
            codeValue: "DNK075",
            gbName: "希茨海尔斯（丹麦）",
            gbCode: "DNK075",
            ciqCode: "208075"
        },
        {
            codeName: "谢累夫斯科尔（丹麦）",
            cusCode: "1834",
            codeValue: "DNK076",
            gbName: "谢累夫斯科尔（丹麦）",
            gbCode: "DNK076",
            ciqCode: "208076"
        },
        {
            codeName: "霍布罗（丹麦）",
            cusCode: "1810",
            codeValue: "DNK078",
            gbName: "霍布罗（丹麦）",
            gbCode: "DNK078",
            ciqCode: "208078"
        },
        {
            codeName: "霍尔拜克（丹麦）",
            cusCode: "1811",
            codeValue: "DNK081",
            gbName: "霍尔拜克（丹麦）",
            gbCode: "DNK081",
            ciqCode: "208081"
        },
        {
            codeName: "霍森斯（丹麦）",
            cusCode: "1812",
            codeValue: "DNK084",
            gbName: "霍森斯（丹麦）",
            gbCode: "DNK084",
            ciqCode: "208084"
        },
        {
            codeName: "赫尔辛格（丹麦）",
            cusCode: "1808",
            codeValue: "DNK086",
            gbName: "赫尔辛格（丹麦）",
            gbCode: "DNK086",
            ciqCode: "208086"
        },
        {
            codeName: "凯隆堡（丹麦）",
            cusCode: "1813",
            codeValue: "DNK087",
            gbName: "凯隆堡（丹麦）",
            gbCode: "DNK087",
            ciqCode: "208087"
        },
        {
            codeName: "卡勒拜克斯明讷（丹麦）",
            cusCode: "1814",
            codeValue: "DNK090",
            gbName: "卡勒拜克斯明讷（丹麦）",
            gbCode: "DNK090",
            ciqCode: "208090"
        },
        {
            codeName: "凯特明讷（丹麦）",
            cusCode: "1815",
            codeValue: "DNK093",
            gbName: "凯特明讷（丹麦）",
            gbCode: "DNK093",
            ciqCode: "208093"
        },
        {
            codeName: "克厄（丹麦）",
            cusCode: "1817",
            codeValue: "DNK096",
            gbName: "克厄（丹麦）",
            gbCode: "DNK096",
            ciqCode: "208096"
        },
        {
            codeName: "克拉克斯维克（丹麦）",
            cusCode: "1816",
            codeValue: "DNK097",
            gbName: "克拉克斯维克（丹麦）",
            gbCode: "DNK097",
            ciqCode: "208097"
        },
        {
            codeName: "科灵（丹麦）",
            cusCode: "1818",
            codeValue: "DNK099",
            gbName: "科灵（丹麦）",
            gbCode: "DNK099",
            ciqCode: "208099"
        },
        {
            codeName: "科瑟（丹麦）",
            cusCode: "1819",
            codeValue: "DNK102",
            gbName: "科瑟（丹麦）",
            gbCode: "DNK102",
            ciqCode: "208102"
        },
        {
            codeName: "金比（丹麦）",
            cusCode: "1820",
            codeValue: "DNK105",
            gbName: "金比（丹麦）",
            gbCode: "DNK105",
            ciqCode: "208105"
        },
        {
            codeName: "莱姆维（丹麦）",
            cusCode: "1821",
            codeValue: "DNK108",
            gbName: "莱姆维（丹麦）",
            gbCode: "DNK108",
            ciqCode: "208108"
        },
        {
            codeName: "林斯奥得（丹麦）",
            cusCode: "302",
            codeValue: "DNK111",
            gbName: "林斯奥得（丹麦）",
            gbCode: "DNK111",
            ciqCode: "208111"
        },
        {
            codeName: "玛丽艾厄（丹麦）",
            cusCode: "1822",
            codeValue: "DNK114",
            gbName: "玛丽艾厄（丹麦）",
            gbCode: "DNK114",
            ciqCode: "208114"
        },
        {
            codeName: "马斯内多韦尔凯特港（丹麦）",
            cusCode: "1823",
            codeValue: "DNK116",
            gbName: "马斯内多韦尔凯特港（丹麦）",
            gbCode: "DNK116",
            ciqCode: "208116"
        },
        {
            codeName: "马斯塔尔（丹麦）",
            cusCode: "302",
            codeValue: "DNK117",
            gbName: "马斯塔尔（丹麦）",
            gbCode: "DNK117",
            ciqCode: "208117"
        },
        {
            codeName: "马斯讷松（丹麦）",
            cusCode: "1824",
            codeValue: "DNK120",
            gbName: "马斯讷松（丹麦）",
            gbCode: "DNK120",
            ciqCode: "208120"
        },
        {
            codeName: "米泽尔法特（丹麦）",
            cusCode: "1825",
            codeValue: "DNK123",
            gbName: "米泽尔法特（丹麦）",
            gbCode: "DNK123",
            ciqCode: "208123"
        },
        {
            codeName: "奈斯特韦兹（丹麦）",
            cusCode: "1826",
            codeValue: "DNK126",
            gbName: "奈斯特韦兹（丹麦）",
            gbCode: "DNK126",
            ciqCode: "208126"
        },
        {
            codeName: "纳克斯考（丹麦）",
            cusCode: "1827",
            codeValue: "DNK129",
            gbName: "纳克斯考（丹麦）",
            gbCode: "DNK129",
            ciqCode: "208129"
        },
        {
            codeName: "讷克塞（丹麦）",
            cusCode: "1828",
            codeValue: "DNK131",
            gbName: "讷克塞（丹麦）",
            gbCode: "DNK131",
            ciqCode: "208131"
        },
        {
            codeName: "内克瑟（丹麦）",
            cusCode: "302",
            codeValue: "DNK132",
            gbName: "内克瑟（丹麦）",
            gbCode: "DNK132",
            ciqCode: "208132"
        },
        {
            codeName: "诺勒松比（丹麦）",
            cusCode: "302",
            codeValue: "DNK135",
            gbName: "诺勒松比（丹麦）",
            gbCode: "DNK135",
            ciqCode: "208135"
        },
        {
            codeName: "尼堡（丹麦）",
            cusCode: "1829",
            codeValue: "DNK138",
            gbName: "尼堡（丹麦）",
            gbCode: "DNK138",
            ciqCode: "208138"
        },
        {
            codeName: "尼克宾（Fal.）（丹麦）",
            cusCode: "302",
            codeValue: "DNK141",
            gbName: "尼克宾（Fal.）（丹麦）",
            gbCode: "DNK141",
            ciqCode: "208141"
        },
        {
            codeName: "尼克宾（Mors）（丹麦）",
            cusCode: "1830",
            codeValue: "DNK144",
            gbName: "尼克宾（Mors）（丹麦）",
            gbCode: "DNK144",
            ciqCode: "208144"
        },
        {
            codeName: "尼克宾（Sja.）（丹麦）",
            cusCode: "1831",
            codeValue: "DNK147",
            gbName: "尼克宾（Sja.）（丹麦）",
            gbCode: "DNK147",
            ciqCode: "208147"
        },
        {
            codeName: "欧登塞（丹麦）",
            cusCode: "1832",
            codeValue: "DNK150",
            gbName: "欧登塞（丹麦）",
            gbCode: "DNK150",
            ciqCode: "208150"
        },
        {
            codeName: "奥勒霍兹（丹麦）",
            cusCode: "302",
            codeValue: "DNK153",
            gbName: "奥勒霍兹（丹麦）",
            gbCode: "DNK153",
            ciqCode: "208153"
        },
        {
            codeName: "兰讷斯（丹麦）",
            cusCode: "302",
            codeValue: "DNK156",
            gbName: "兰讷斯（丹麦）",
            gbCode: "DNK156",
            ciqCode: "208156"
        },
        {
            codeName: "勒兹比港（丹麦）",
            cusCode: "302",
            codeValue: "DNK159",
            gbName: "勒兹比港（丹麦）",
            gbCode: "DNK159",
            ciqCode: "208159"
        },
        {
            codeName: "勒兹维（丹麦）",
            cusCode: "302",
            codeValue: "DNK162",
            gbName: "勒兹维（丹麦）",
            gbCode: "DNK162",
            ciqCode: "208162"
        },
        {
            codeName: "伦讷（丹麦）",
            cusCode: "1836",
            codeValue: "DNK165",
            gbName: "伦讷（丹麦）",
            gbCode: "DNK165",
            ciqCode: "208165"
        },
        {
            codeName: "鲁兹克宾（丹麦）",
            cusCode: "1839",
            codeValue: "DNK168",
            gbName: "鲁兹克宾（丹麦）",
            gbCode: "DNK168",
            ciqCode: "208168"
        },
        {
            codeName: "朴次茅斯（丹麦）",
            cusCode: "1835",
            codeValue: "DNK170",
            gbName: "朴次茅斯（丹麦）",
            gbCode: "DNK170",
            ciqCode: "208170"
        },
        {
            codeName: "萨克斯克宾（丹麦）",
            cusCode: "1840",
            codeValue: "DNK171",
            gbName: "萨克斯克宾（丹麦）",
            gbCode: "DNK171",
            ciqCode: "208171"
        },
        {
            codeName: "斯凯尔克（丹麦）",
            cusCode: "302",
            codeValue: "DNK174",
            gbName: "斯凯尔克（丹麦）",
            gbCode: "DNK174",
            ciqCode: "208174"
        },
        {
            codeName: "斯凯拜克（丹麦）",
            cusCode: "302",
            codeValue: "DNK177",
            gbName: "斯凯拜克（丹麦）",
            gbCode: "DNK177",
            ciqCode: "208177"
        },
        {
            codeName: "斯卡恩（丹麦）",
            cusCode: "1841",
            codeValue: "DNK180",
            gbName: "斯卡恩（丹麦）",
            gbCode: "DNK180",
            ciqCode: "208180"
        },
        {
            codeName: "斯基沃（丹麦）",
            cusCode: "1843",
            codeValue: "DNK183",
            gbName: "斯基沃（丹麦）",
            gbCode: "DNK183",
            ciqCode: "208183"
        },
        {
            codeName: "桑讷堡（丹麦）",
            cusCode: "1844",
            codeValue: "DNK186",
            gbName: "桑讷堡（丹麦）",
            gbCode: "DNK186",
            ciqCode: "208186"
        },
        {
            codeName: "斯凯尔斯科尔（丹麦）",
            cusCode: "1842",
            codeValue: "DNK188",
            gbName: "斯凯尔斯科尔（丹麦）",
            gbCode: "DNK188",
            ciqCode: "208188"
        },
        {
            codeName: "斯泰厄（丹麦）",
            cusCode: "1845",
            codeValue: "DNK189",
            gbName: "斯泰厄（丹麦）",
            gbCode: "DNK189",
            ciqCode: "208189"
        },
        {
            codeName: "斯楚厄（丹麦）",
            cusCode: "1847",
            codeValue: "DNK195",
            gbName: "斯楚厄（丹麦）",
            gbCode: "DNK195",
            ciqCode: "208195"
        },
        {
            codeName: "斯图伯克宾（丹麦）",
            cusCode: "1848",
            codeValue: "DNK198",
            gbName: "斯图伯克宾（丹麦）",
            gbCode: "DNK198",
            ciqCode: "208198"
        },
        {
            codeName: "斯图德斯特鲁普（丹麦）",
            cusCode: "302",
            codeValue: "DNK201",
            gbName: "斯图德斯特鲁普（丹麦）",
            gbCode: "DNK201",
            ciqCode: "208201"
        },
        {
            codeName: "斯瓦讷克（丹麦）",
            cusCode: "1849",
            codeValue: "DNK204",
            gbName: "斯瓦讷克（丹麦）",
            gbCode: "DNK204",
            ciqCode: "208204"
        },
        {
            codeName: "斯文堡（丹麦）",
            cusCode: "1850",
            codeValue: "DNK207",
            gbName: "斯文堡（丹麦）",
            gbCode: "DNK207",
            ciqCode: "208207"
        },
        {
            codeName: "特沃罗伊尔（丹麦）",
            cusCode: "1853",
            codeValue: "DNK209",
            gbName: "特沃罗伊尔（丹麦）",
            gbCode: "DNK209",
            ciqCode: "208209"
        },
        {
            codeName: "提斯特德（丹麦）",
            cusCode: "1851",
            codeValue: "DNK210",
            gbName: "提斯特德（丹麦）",
            gbCode: "DNK210",
            ciqCode: "208210"
        },
        {
            codeName: "图堡港（丹麦）",
            cusCode: "302",
            codeValue: "DNK213",
            gbName: "图堡港（丹麦）",
            gbCode: "DNK213",
            ciqCode: "208213"
        },
        {
            codeName: "吐伯堡（丹麦）",
            cusCode: "1838",
            codeValue: "DNK214",
            gbName: "吐伯堡（丹麦）",
            gbCode: "DNK214",
            ciqCode: "208214"
        },
        {
            codeName: "托尔斯港（丹麦）",
            cusCode: "1852",
            codeValue: "DNK215",
            gbName: "托尔斯港（丹麦）",
            gbCode: "DNK215",
            ciqCode: "208215"
        },
        {
            codeName: "瓦埃勒（丹麦）",
            cusCode: "1855",
            codeValue: "DNK216",
            gbName: "瓦埃勒（丹麦）",
            gbCode: "DNK216",
            ciqCode: "208216"
        },
        {
            codeName: "瓦古尔（丹麦）",
            cusCode: "1854",
            codeValue: "DNK218",
            gbName: "瓦古尔（丹麦）",
            gbCode: "DNK218",
            ciqCode: "208218"
        },
        {
            codeName: "沃尔丁堡（丹麦）",
            cusCode: "302",
            codeValue: "DNK219",
            gbName: "沃尔丁堡（丹麦）",
            gbCode: "DNK219",
            ciqCode: "208219"
        },
        {
            codeName: "韦斯特马纳（丹麦）",
            cusCode: "1856",
            codeValue: "DNK220",
            gbName: "韦斯特马纳（丹麦）",
            gbCode: "DNK220",
            ciqCode: "208220"
        },
        {
            codeName: "ROSBYHAVN（丹麦）",
            cusCode: "1837",
            codeValue: "DNK221",
            gbName: "ROSBYHAVN（丹麦）",
            gbCode: "DNK221",
            ciqCode: "208221"
        },
        {
            codeName: "多米尼加",
            cusCode: "418",
            codeValue: "DOM000",
            gbName: "多米尼加",
            gbCode: "DOM000",
            ciqCode: "214000"
        },
        {
            codeName: "阿苏阿（多米尼加）",
            cusCode: "2830",
            codeValue: "DOM003",
            gbName: "阿苏阿（多米尼加）",
            gbCode: "DOM003",
            ciqCode: "214003"
        },
        {
            codeName: "巴拉奥纳（多米尼加）",
            cusCode: "2826",
            codeValue: "DOM006",
            gbName: "巴拉奥纳（多米尼加）",
            gbCode: "DOM006",
            ciqCode: "214006"
        },
        {
            codeName: "博卡奇卡（多米尼加）",
            cusCode: "418",
            codeValue: "DOM009",
            gbName: "博卡奇卡（多米尼加）",
            gbCode: "DOM009",
            ciqCode: "214009"
        },
        {
            codeName: "卡沃罗霍（多米尼加）",
            cusCode: "418",
            codeValue: "DOM012",
            gbName: "卡沃罗霍（多米尼加）",
            gbCode: "DOM012",
            ciqCode: "214012"
        },
        {
            codeName: "拉罗马纳（多米尼加）",
            cusCode: "2827",
            codeValue: "DOM015",
            gbName: "拉罗马纳（多米尼加）",
            gbCode: "DOM015",
            ciqCode: "214015"
        },
        {
            codeName: "曼萨尼约（多米尼加）",
            cusCode: "418",
            codeValue: "DOM018",
            gbName: "曼萨尼约（多米尼加）",
            gbCode: "DOM018",
            ciqCode: "214018"
        },
        {
            codeName: "帕伦克（多米尼加）",
            cusCode: "2828",
            codeValue: "DOM021",
            gbName: "帕伦克（多米尼加）",
            gbCode: "DOM021",
            ciqCode: "214021"
        },
        {
            codeName: "普拉塔港（多米尼加）",
            cusCode: "2829",
            codeValue: "DOM024",
            gbName: "普拉塔港（多米尼加）",
            gbCode: "DOM024",
            ciqCode: "214024"
        },
        {
            codeName: "海纳（多米尼加）",
            cusCode: "418",
            codeValue: "DOM027",
            gbName: "海纳（多米尼加）",
            gbCode: "DOM027",
            ciqCode: "214027"
        },
        {
            codeName: "萨马纳（多米尼加）",
            cusCode: "418",
            codeValue: "DOM030",
            gbName: "萨马纳（多米尼加）",
            gbCode: "DOM030",
            ciqCode: "214030"
        },
        {
            codeName: "圣佩得罗德马科里斯（多米尼加）",
            cusCode: "2832",
            codeValue: "DOM033",
            gbName: "圣佩得罗德马科里斯（多米尼加）",
            gbCode: "DOM033",
            ciqCode: "214033"
        },
        {
            codeName: "桑切斯（多米尼加）",
            cusCode: "2833",
            codeValue: "DOM036",
            gbName: "桑切斯（多米尼加）",
            gbCode: "DOM036",
            ciqCode: "214036"
        },
        {
            codeName: "圣多明各（多米尼加）",
            cusCode: "2831",
            codeValue: "DOM039",
            gbName: "圣多明各（多米尼加）",
            gbCode: "DOM039",
            ciqCode: "214039"
        },
        {
            codeName: "阿尔及利亚",
            cusCode: "201",
            codeValue: "DZA000",
            gbName: "阿尔及利亚",
            gbCode: "DZA000",
            ciqCode: "012000"
        },
        {
            codeName: "阿尔及尔（阿尔及利亚）",
            cusCode: "1562",
            codeValue: "DZA002",
            gbName: "阿尔及尔（阿尔及利亚）",
            gbCode: "DZA002",
            ciqCode: "012002"
        },
        {
            codeName: "安纳巴（阿尔及利亚）",
            cusCode: "1563",
            codeValue: "DZA003",
            gbName: "安纳巴（阿尔及利亚）",
            gbCode: "DZA003",
            ciqCode: "012003"
        },
        {
            codeName: "阿尔泽（阿尔及利亚）",
            cusCode: "1564",
            codeValue: "DZA006",
            gbName: "阿尔泽（阿尔及利亚）",
            gbCode: "DZA006",
            ciqCode: "012006"
        },
        {
            codeName: "贝贾亚（阿尔及利亚）",
            cusCode: "1565",
            codeValue: "DZA009",
            gbName: "贝贾亚（阿尔及利亚）",
            gbCode: "DZA009",
            ciqCode: "012009"
        },
        {
            codeName: "贝尼萨夫（阿尔及利亚）",
            cusCode: "1567",
            codeValue: "DZA012",
            gbName: "贝尼萨夫（阿尔及利亚）",
            gbCode: "DZA012",
            ciqCode: "012012"
        },
        {
            codeName: "布赖拉港（阿尔及利亚）",
            cusCode: "1570",
            codeValue: "DZA013",
            gbName: "布赖拉港（阿尔及利亚）",
            gbCode: "DZA013",
            ciqCode: "012013"
        },
        {
            codeName: "圭敦港（阿尔及利亚）",
            cusCode: "1579",
            codeValue: "DZA014",
            gbName: "圭敦港（阿尔及利亚）",
            gbCode: "DZA014",
            ciqCode: "012014"
        },
        {
            codeName: "舍尔沙勒（阿尔及利亚）",
            cusCode: "201",
            codeValue: "DZA015",
            gbName: "舍尔沙勒（阿尔及利亚）",
            gbCode: "DZA015",
            ciqCode: "012015"
        },
        {
            codeName: "凯拉赫港（阿尔及利亚）",
            cusCode: "1580",
            codeValue: "DZA016",
            gbName: "凯拉赫港（阿尔及利亚）",
            gbCode: "DZA016",
            ciqCode: "012016"
        },
        {
            codeName: "奈穆尔（阿尔及利亚）",
            cusCode: "1574",
            codeValue: "DZA017",
            gbName: "奈穆尔（阿尔及利亚）",
            gbCode: "DZA017",
            ciqCode: "012017"
        },
        {
            codeName: "塞港（阿尔及利亚）",
            cusCode: "1581",
            codeValue: "DZA018",
            gbName: "塞港（阿尔及利亚）",
            gbCode: "DZA018",
            ciqCode: "012019"
        },
        {
            codeName: "科洛（阿尔及利亚）",
            cusCode: "201",
            codeValue: "DZA019",
            gbName: "科洛（阿尔及利亚）",
            gbCode: "DZA019",
            ciqCode: "012018"
        },
        {
            codeName: "代利斯（阿尔及利亚）",
            cusCode: "1571",
            codeValue: "DZA021",
            gbName: "代利斯（阿尔及利亚）",
            gbCode: "DZA021",
            ciqCode: "012021"
        },
        {
            codeName: "贾扎伊尔（阿尔及利亚）",
            cusCode: "201",
            codeValue: "DZA024",
            gbName: "贾扎伊尔（阿尔及利亚）",
            gbCode: "DZA024",
            ciqCode: "012024"
        },
        {
            codeName: "加扎韦特（阿尔及利亚）",
            cusCode: "1578",
            codeValue: "DZA027",
            gbName: "加扎韦特（阿尔及利亚）",
            gbCode: "DZA027",
            ciqCode: "012027"
        },
        {
            codeName: "吉杰勒（阿尔及利亚）",
            cusCode: "1572",
            codeValue: "DZA030",
            gbName: "吉杰勒（阿尔及利亚）",
            gbCode: "DZA030",
            ciqCode: "012030"
        },
        {
            codeName: "莫斯塔加内姆（阿尔及利亚）",
            cusCode: "1573",
            codeValue: "DZA033",
            gbName: "莫斯塔加内姆（阿尔及利亚）",
            gbCode: "DZA033",
            ciqCode: "012033"
        },
        {
            codeName: "奥兰（阿尔及利亚）",
            cusCode: "1575",
            codeValue: "DZA035",
            gbName: "奥兰（阿尔及利亚）",
            gbCode: "DZA035",
            ciqCode: "012035"
        },
        {
            codeName: "斯基克达（阿尔及利亚）",
            cusCode: "1582",
            codeValue: "DZA036",
            gbName: "斯基克达（阿尔及利亚）",
            gbCode: "DZA036",
            ciqCode: "012036"
        },
        {
            codeName: "提奈斯（阿尔及利亚）",
            cusCode: "201",
            codeValue: "DZA039",
            gbName: "提奈斯（阿尔及利亚）",
            gbCode: "DZA039",
            ciqCode: "012039"
        },
        {
            codeName: "瓦赫兰（阿尔及利亚）",
            cusCode: "201",
            codeValue: "DZA042",
            gbName: "瓦赫兰（阿尔及利亚）",
            gbCode: "DZA042",
            ciqCode: "012042"
        },
        {
            codeName: "厄瓜多尔",
            cusCode: "419",
            codeValue: "ECU000",
            gbName: "厄瓜多尔",
            gbCode: "ECU000",
            ciqCode: "218000"
        },
        {
            codeName: "卡拉克斯湾（厄瓜多尔）",
            cusCode: "2836",
            codeValue: "ECU003",
            gbName: "卡拉克斯湾（厄瓜多尔）",
            gbCode: "ECU003",
            ciqCode: "218003"
        },
        {
            codeName: "巴诺特米拉尔（厄瓜多尔）",
            cusCode: "419",
            codeValue: "ECU006",
            gbName: "巴诺特米拉尔（厄瓜多尔）",
            gbCode: "ECU006",
            ciqCode: "218006"
        },
        {
            codeName: "埃斯梅拉达斯（厄瓜多尔）",
            cusCode: "419",
            codeValue: "ECU009",
            gbName: "埃斯梅拉达斯（厄瓜多尔）",
            gbCode: "ECU009",
            ciqCode: "218009"
        },
        {
            codeName: "瓜亚基尔（厄瓜多尔）",
            cusCode: "2837",
            codeValue: "ECU012",
            gbName: "瓜亚基尔（厄瓜多尔）",
            gbCode: "ECU012",
            ciqCode: "218012"
        },
        {
            codeName: "拉利伯塔德（厄瓜多尔）",
            cusCode: "2834",
            codeValue: "ECU015",
            gbName: "拉利伯塔德（厄瓜多尔）",
            gbCode: "ECU015",
            ciqCode: "218015"
        },
        {
            codeName: "曼塔（厄瓜多尔）",
            cusCode: "2835",
            codeValue: "ECU018",
            gbName: "曼塔（厄瓜多尔）",
            gbCode: "ECU018",
            ciqCode: "218018"
        },
        {
            codeName: "玻利瓦尔港（厄瓜多尔）",
            cusCode: "419",
            codeValue: "ECU021",
            gbName: "玻利瓦尔港（厄瓜多尔）",
            gbCode: "ECU021",
            ciqCode: "218021"
        },
        {
            codeName: "萨利纳斯（厄瓜多尔）",
            cusCode: "419",
            codeValue: "ECU024",
            gbName: "萨利纳斯（厄瓜多尔）",
            gbCode: "ECU024",
            ciqCode: "218024"
        },
        {
            codeName: "圣洛伦索（厄瓜多尔）",
            cusCode: "419",
            codeValue: "ECU027",
            gbName: "圣洛伦索（厄瓜多尔）",
            gbCode: "ECU027",
            ciqCode: "218027"
        },
        {
            codeName: "埃及",
            cusCode: "215",
            codeValue: "EGY000",
            gbName: "埃及",
            gbCode: "EGY000",
            ciqCode: "818000"
        },
        {
            codeName: "阿布宰尼迈（埃及）",
            cusCode: "1613",
            codeValue: "EGY003",
            gbName: "阿布宰尼迈（埃及）",
            gbCode: "EGY003",
            ciqCode: "818003"
        },
        {
            codeName: "阿代比耶（埃及）",
            cusCode: "215",
            codeValue: "EGY006",
            gbName: "阿代比耶（埃及）",
            gbCode: "EGY006",
            ciqCode: "818006"
        },
        {
            codeName: "艾因苏赫纳（埃及）",
            cusCode: "215",
            codeValue: "EGY009",
            gbName: "艾因苏赫纳（埃及）",
            gbCode: "EGY009",
            ciqCode: "818009"
        },
        {
            codeName: "亚历山大（埃及）",
            cusCode: "1615",
            codeValue: "EGY012",
            gbName: "亚历山大（埃及）",
            gbCode: "EGY012",
            ciqCode: "818012"
        },
        {
            codeName: "达米埃塔（埃及）",
            cusCode: "1616",
            codeValue: "EGY015",
            gbName: "达米埃塔（埃及）",
            gbCode: "EGY015",
            ciqCode: "818015"
        },
        {
            codeName: "库赛尔（埃及）",
            cusCode: "1617",
            codeValue: "EGY018",
            gbName: "库赛尔（埃及）",
            gbCode: "EGY018",
            ciqCode: "818018"
        },
        {
            codeName: "哈姆拉港（埃及）",
            cusCode: "215",
            codeValue: "EGY021",
            gbName: "哈姆拉港（埃及）",
            gbCode: "EGY021",
            ciqCode: "818021"
        },
        {
            codeName: "马特鲁港（埃及）",
            cusCode: "215",
            codeValue: "EGY024",
            gbName: "马特鲁港（埃及）",
            gbCode: "EGY024",
            ciqCode: "818024"
        },
        {
            codeName: "易卜拉欣港（埃及）",
            cusCode: "1618",
            codeValue: "EGY027",
            gbName: "易卜拉欣港（埃及）",
            gbCode: "EGY027",
            ciqCode: "818027"
        },
        {
            codeName: "塞得港（埃及）",
            cusCode: "1620",
            codeValue: "EGY030",
            gbName: "塞得港（埃及）",
            gbCode: "EGY030",
            ciqCode: "818030"
        },
        {
            codeName: "陶菲克港（埃及）",
            cusCode: "215",
            codeValue: "EGY033",
            gbName: "陶菲克港（埃及）",
            gbCode: "EGY033",
            ciqCode: "818033"
        },
        {
            codeName: "拉斯加里卜（埃及）",
            cusCode: "215",
            codeValue: "EGY036",
            gbName: "拉斯加里卜（埃及）",
            gbCode: "EGY036",
            ciqCode: "818036"
        },
        {
            codeName: "喇斯舒海尔（埃及）",
            cusCode: "215",
            codeValue: "EGY039",
            gbName: "喇斯舒海尔（埃及）",
            gbCode: "EGY039",
            ciqCode: "818039"
        },
        {
            codeName: "塞法杰（埃及）",
            cusCode: "1621",
            codeValue: "EGY042",
            gbName: "塞法杰（埃及）",
            gbCode: "EGY042",
            ciqCode: "818042"
        },
        {
            codeName: "塞卢姆（埃及）",
            cusCode: "1625",
            codeValue: "EGY045",
            gbName: "塞卢姆（埃及）",
            gbCode: "EGY045",
            ciqCode: "818045"
        },
        {
            codeName: "西迪基里尔（埃及）",
            cusCode: "215",
            codeValue: "EGY048",
            gbName: "西迪基里尔（埃及）",
            gbCode: "EGY048",
            ciqCode: "818048"
        },
        {
            codeName: "苏伊士（埃及）",
            cusCode: "1622",
            codeValue: "EGY051",
            gbName: "苏伊士（埃及）",
            gbCode: "EGY051",
            ciqCode: "818051"
        },
        {
            codeName: "瓦迪费兰（埃及）",
            cusCode: "1624",
            codeValue: "EGY054",
            gbName: "瓦迪费兰（埃及）",
            gbCode: "EGY054",
            ciqCode: "818054"
        },
        {
            codeName: "伊斯梅利亚（埃及）",
            cusCode: "1619",
            codeValue: "EGY055",
            gbName: "伊斯梅利亚（埃及）",
            gbCode: "EGY055",
            ciqCode: "818055"
        },
        {
            codeName: "开罗（埃及）",
            cusCode: "215",
            codeValue: "EGY901",
            gbName: "开罗（埃及）",
            gbCode: "EGY901",
            ciqCode: "818901"
        },
        {
            codeName: "厄立特里亚",
            cusCode: "258",
            codeValue: "ERI000",
            gbName: "厄立特里亚",
            gbCode: "ERI000",
            ciqCode: "232000"
        },
        {
            codeName: "阿萨布（厄立特里亚）",
            cusCode: "258",
            codeValue: "ERI003",
            gbName: "阿萨布（厄立特里亚）",
            gbCode: "ERI003",
            ciqCode: "232003"
        },
        {
            codeName: "马萨瓦（厄立特里亚）",
            cusCode: "258",
            codeValue: "ERI006",
            gbName: "马萨瓦（厄立特里亚）",
            gbCode: "ERI006",
            ciqCode: "232006"
        },
        {
            codeName: "西撒哈拉",
            cusCode: "245",
            codeValue: "ESH000",
            gbName: "西撒哈拉",
            gbCode: "ESH000",
            ciqCode: "732000"
        },
        {
            codeName: "达赫拉（西撒哈拉）",
            cusCode: "245",
            codeValue: "ESH003",
            gbName: "达赫拉（西撒哈拉）",
            gbCode: "ESH003",
            ciqCode: "732003"
        },
        {
            codeName: "欧云（阿龙恩）（西撒哈拉）",
            cusCode: "245",
            codeValue: "ESH006",
            gbName: "欧云（阿龙恩）（西撒哈拉）",
            gbCode: "ESH006",
            ciqCode: "732006"
        },
        {
            codeName: "锡兹内罗斯城（西撒哈拉）",
            cusCode: "1759",
            codeValue: "ESH007",
            gbName: "锡兹内罗斯城（西撒哈拉）",
            gbCode: "ESH007",
            ciqCode: "732007"
        },
        {
            codeName: "西班牙",
            cusCode: "312",
            codeValue: "ESP000",
            gbName: "西班牙",
            gbCode: "ESP000",
            ciqCode: "724000"
        },
        {
            codeName: "阿德拉（西班牙）",
            cusCode: "2374",
            codeValue: "ESP003",
            gbName: "阿德拉（西班牙）",
            gbCode: "ESP003",
            ciqCode: "724003"
        },
        {
            codeName: "阿吉拉斯（西班牙）",
            cusCode: "2375",
            codeValue: "ESP006",
            gbName: "阿吉拉斯（西班牙）",
            gbCode: "ESP006",
            ciqCode: "724006"
        },
        {
            codeName: "阿尔库迪亚（西班牙）",
            cusCode: "312",
            codeValue: "ESP009",
            gbName: "阿尔库迪亚（西班牙）",
            gbCode: "ESP009",
            ciqCode: "724009"
        },
        {
            codeName: "阿尔赫西拉斯（西班牙）",
            cusCode: "2368",
            codeValue: "ESP012",
            gbName: "阿尔赫西拉斯（西班牙）",
            gbCode: "ESP012",
            ciqCode: "724012"
        },
        {
            codeName: "阿利坎特（西班牙）",
            cusCode: "2376",
            codeValue: "ESP015",
            gbName: "阿利坎特（西班牙）",
            gbCode: "ESP015",
            ciqCode: "724015"
        },
        {
            codeName: "阿尔梅里亚（西班牙）",
            cusCode: "2377",
            codeValue: "ESP018",
            gbName: "阿尔梅里亚（西班牙）",
            gbCode: "ESP018",
            ciqCode: "724018"
        },
        {
            codeName: "阿雷西费（西班牙）",
            cusCode: "1597",
            codeValue: "ESP020",
            gbName: "阿雷西费（西班牙）",
            gbCode: "ESP020",
            ciqCode: "724020"
        },
        {
            codeName: "阿维莱斯（西班牙）",
            cusCode: "2380",
            codeValue: "ESP021",
            gbName: "阿维莱斯（西班牙）",
            gbCode: "ESP021",
            ciqCode: "724021"
        },
        {
            codeName: "巴塞罗那（西班牙）",
            cusCode: "2382",
            codeValue: "ESP024",
            gbName: "巴塞罗那（西班牙）",
            gbCode: "ESP024",
            ciqCode: "724024"
        },
        {
            codeName: "毕尔巴鄂（西班牙）",
            cusCode: "2383",
            codeValue: "ESP027",
            gbName: "毕尔巴鄂（西班牙）",
            gbCode: "ESP027",
            ciqCode: "724027"
        },
        {
            codeName: "布拉内斯（西班牙）",
            cusCode: "312",
            codeValue: "ESP030",
            gbName: "布拉内斯（西班牙）",
            gbCode: "ESP030",
            ciqCode: "724030"
        },
        {
            codeName: "布雷拉（西班牙）",
            cusCode: "312",
            codeValue: "ESP033",
            gbName: "布雷拉（西班牙）",
            gbCode: "ESP033",
            ciqCode: "724033"
        },
        {
            codeName: "布里亚纳（西班牙）",
            cusCode: "2369",
            codeValue: "ESP036",
            gbName: "布里亚纳（西班牙）",
            gbCode: "ESP036",
            ciqCode: "724036"
        },
        {
            codeName: "加的斯（西班牙）",
            cusCode: "2384",
            codeValue: "ESP039",
            gbName: "加的斯（西班牙）",
            gbCode: "ESP039",
            ciqCode: "724039"
        },
        {
            codeName: "菲力斯特里（西班牙）",
            cusCode: "312",
            codeValue: "ESP042",
            gbName: "菲力斯特里（西班牙）",
            gbCode: "ESP042",
            ciqCode: "724042"
        },
        {
            codeName: "卡塔赫纳（西班牙）",
            cusCode: "2370",
            codeValue: "ESP045",
            gbName: "卡塔赫纳（西班牙）",
            gbCode: "ESP045",
            ciqCode: "724045"
        },
        {
            codeName: "休达（西班牙）",
            cusCode: "312",
            codeValue: "ESP047",
            gbName: "休达（西班牙）",
            gbCode: "ESP047",
            ciqCode: "724047"
        },
        {
            codeName: "卡斯特利翁（西班牙）",
            cusCode: "2371",
            codeValue: "ESP048",
            gbName: "卡斯特利翁（西班牙）",
            gbCode: "ESP048",
            ciqCode: "724048"
        },
        {
            codeName: "乌迪亚莱斯堡（西班牙）",
            cusCode: "312",
            codeValue: "ESP051",
            gbName: "乌迪亚莱斯堡（西班牙）",
            gbCode: "ESP051",
            ciqCode: "724051"
        },
        {
            codeName: "锡列罗（西班牙）",
            cusCode: "312",
            codeValue: "ESP054",
            gbName: "锡列罗（西班牙）",
            gbCode: "ESP054",
            ciqCode: "724054"
        },
        {
            codeName: "科尔库维翁（西班牙）",
            cusCode: "312",
            codeValue: "ESP057",
            gbName: "科尔库维翁（西班牙）",
            gbCode: "ESP057",
            ciqCode: "724057"
        },
        {
            codeName: "科伦纳（西班牙）",
            cusCode: "312",
            codeValue: "ESP060",
            gbName: "科伦纳（西班牙）",
            gbCode: "ESP060",
            ciqCode: "724060"
        },
        {
            codeName: "德尼亚（西班牙）",
            cusCode: "2386",
            codeValue: "ESP063",
            gbName: "德尼亚（西班牙）",
            gbCode: "ESP063",
            ciqCode: "724063"
        },
        {
            codeName: "埃斯孔布雷阿斯（西班牙）",
            cusCode: "312",
            codeValue: "ESP066",
            gbName: "埃斯孔布雷阿斯（西班牙）",
            gbCode: "ESP066",
            ciqCode: "724066"
        },
        {
            codeName: "费罗尔（西班牙）",
            cusCode: "2372",
            codeValue: "ESP069",
            gbName: "费罗尔（西班牙）",
            gbCode: "ESP069",
            ciqCode: "724069"
        },
        {
            codeName: "刚迪亚（西班牙）",
            cusCode: "2373",
            codeValue: "ESP072",
            gbName: "刚迪亚（西班牙）",
            gbCode: "ESP072",
            ciqCode: "724072"
        },
        {
            codeName: "加鲁查（西班牙）",
            cusCode: "312",
            codeValue: "ESP075",
            gbName: "加鲁查（西班牙）",
            gbCode: "ESP075",
            ciqCode: "724075"
        },
        {
            codeName: "希洪（西班牙）",
            cusCode: "2387",
            codeValue: "ESP078",
            gbName: "希洪（西班牙）",
            gbCode: "ESP078",
            ciqCode: "724078"
        },
        {
            codeName: "拉科鲁尼亚（西班牙）",
            cusCode: "312",
            codeValue: "ESP079",
            gbName: "拉科鲁尼亚（西班牙）",
            gbCode: "ESP079",
            ciqCode: "724079"
        },
        {
            codeName: "拉斯帕尔马斯（西班牙）",
            cusCode: "1598",
            codeValue: "ESP080",
            gbName: "拉斯帕尔马斯（西班牙）",
            gbCode: "ESP080",
            ciqCode: "724080"
        },
        {
            codeName: "韦尔瓦（西班牙）",
            cusCode: "2388",
            codeValue: "ESP081",
            gbName: "韦尔瓦（西班牙）",
            gbCode: "ESP081",
            ciqCode: "724081"
        },
        {
            codeName: "伊维萨（西班牙）",
            cusCode: "2389",
            codeValue: "ESP084",
            gbName: "伊维萨（西班牙）",
            gbCode: "ESP084",
            ciqCode: "724084"
        },
        {
            codeName: "哈韦阿（西班牙）",
            cusCode: "2390",
            codeValue: "ESP087",
            gbName: "哈韦阿（西班牙）",
            gbCode: "ESP087",
            ciqCode: "724087"
        },
        {
            codeName: "拉卡莱拉（西班牙）",
            cusCode: "2391",
            codeValue: "ESP090",
            gbName: "拉卡莱拉（西班牙）",
            gbCode: "ESP090",
            ciqCode: "724090"
        },
        {
            codeName: "卢阿尔卡（西班牙）",
            cusCode: "312",
            codeValue: "ESP093",
            gbName: "卢阿尔卡（西班牙）",
            gbCode: "ESP093",
            ciqCode: "724093"
        },
        {
            codeName: "马翁（西班牙）",
            cusCode: "2393",
            codeValue: "ESP096",
            gbName: "马翁（西班牙）",
            gbCode: "ESP096",
            ciqCode: "724096"
        },
        {
            codeName: "马拉加（西班牙）",
            cusCode: "2394",
            codeValue: "ESP099",
            gbName: "马拉加（西班牙）",
            gbCode: "ESP099",
            ciqCode: "724099"
        },
        {
            codeName: "梅利利亚（西班牙）",
            cusCode: "312",
            codeValue: "ESP100",
            gbName: "梅利利亚（西班牙）",
            gbCode: "ESP100",
            ciqCode: "724100"
        },
        {
            codeName: "马林（西班牙）",
            cusCode: "2395",
            codeValue: "ESP102",
            gbName: "马林（西班牙）",
            gbCode: "ESP102",
            ciqCode: "724102"
        },
        {
            codeName: "马萨龙（西班牙）",
            cusCode: "2396",
            codeValue: "ESP105",
            gbName: "马萨龙（西班牙）",
            gbCode: "ESP105",
            ciqCode: "724105"
        },
        {
            codeName: "莫特里尔（西班牙）",
            cusCode: "2397",
            codeValue: "ESP108",
            gbName: "莫特里尔（西班牙）",
            gbCode: "ESP108",
            ciqCode: "724108"
        },
        {
            codeName: "穆罗斯（西班牙）",
            cusCode: "2398",
            codeValue: "ESP111",
            gbName: "穆罗斯（西班牙）",
            gbCode: "ESP111",
            ciqCode: "724111"
        },
        {
            codeName: "帕拉莫斯（西班牙）",
            cusCode: "2399",
            codeValue: "ESP114",
            gbName: "帕拉莫斯（西班牙）",
            gbCode: "ESP114",
            ciqCode: "724114"
        },
        {
            codeName: "帕尔马（西班牙）",
            cusCode: "2400",
            codeValue: "ESP117",
            gbName: "帕尔马（西班牙）",
            gbCode: "ESP117",
            ciqCode: "724117"
        },
        {
            codeName: "帕萨赫斯（西班牙）",
            cusCode: "2401",
            codeValue: "ESP120",
            gbName: "帕萨赫斯（西班牙）",
            gbCode: "ESP120",
            ciqCode: "724120"
        },
        {
            codeName: "波图加莱特（西班牙）",
            cusCode: "312",
            codeValue: "ESP123",
            gbName: "波图加莱特（西班牙）",
            gbCode: "ESP123",
            ciqCode: "724123"
        },
        {
            codeName: "萨尔塔卡瓦略（西班牙）",
            cusCode: "312",
            codeValue: "ESP126",
            gbName: "萨尔塔卡瓦略（西班牙）",
            gbCode: "ESP126",
            ciqCode: "724126"
        },
        {
            codeName: "里瓦德奥（西班牙）",
            cusCode: "2405",
            codeValue: "ESP129",
            gbName: "里瓦德奥（西班牙）",
            gbCode: "ESP129",
            ciqCode: "724129"
        },
        {
            codeName: "里瓦德塞利亚（西班牙）",
            cusCode: "2403",
            codeValue: "ESP132",
            gbName: "里瓦德塞利亚（西班牙）",
            gbCode: "ESP132",
            ciqCode: "724132"
        },
        {
            codeName: "罗萨斯（西班牙）",
            cusCode: "2404",
            codeValue: "ESP135",
            gbName: "罗萨斯（西班牙）",
            gbCode: "ESP135",
            ciqCode: "724135"
        },
        {
            codeName: "罗萨里奥港（西班牙）",
            cusCode: "312",
            codeValue: "ESP137",
            gbName: "罗萨里奥港（西班牙）",
            gbCode: "ESP137",
            ciqCode: "724137"
        },
        {
            codeName: "罗塔（西班牙）",
            cusCode: "2406",
            codeValue: "ESP138",
            gbName: "罗塔（西班牙）",
            gbCode: "ESP138",
            ciqCode: "724138"
        },
        {
            codeName: "萨贡托（西班牙）",
            cusCode: "2407",
            codeValue: "ESP141",
            gbName: "萨贡托（西班牙）",
            gbCode: "ESP141",
            ciqCode: "724141"
        },
        {
            codeName: "圣卡洛斯（西班牙）",
            cusCode: "312",
            codeValue: "ESP144",
            gbName: "圣卡洛斯（西班牙）",
            gbCode: "ESP144",
            ciqCode: "724144"
        },
        {
            codeName: "圣西普里安（西班牙）",
            cusCode: "312",
            codeValue: "ESP147",
            gbName: "圣西普里安（西班牙）",
            gbCode: "ESP147",
            ciqCode: "724147"
        },
        {
            codeName: "圣埃斯特班（西班牙）",
            cusCode: "312",
            codeValue: "ESP150",
            gbName: "圣埃斯特班（西班牙）",
            gbCode: "ESP150",
            ciqCode: "724150"
        },
        {
            codeName: "圣费里乌德古绍尔斯（西班牙）",
            cusCode: "2408",
            codeValue: "ESP153",
            gbName: "圣费里乌德古绍尔斯（西班牙）",
            gbCode: "ESP153",
            ciqCode: "724153"
        },
        {
            codeName: "圣费尔南多（西班牙）",
            cusCode: "312",
            codeValue: "ESP156",
            gbName: "圣费尔南多（西班牙）",
            gbCode: "ESP156",
            ciqCode: "724156"
        },
        {
            codeName: "圣塞瓦斯蒂安（西班牙）",
            cusCode: "312",
            codeValue: "ESP159",
            gbName: "圣塞瓦斯蒂安（西班牙）",
            gbCode: "ESP159",
            ciqCode: "724159"
        },
        {
            codeName: "圣克鲁斯（西班牙）",
            cusCode: "1600",
            codeValue: "ESP161",
            gbName: "圣克鲁斯（西班牙）",
            gbCode: "ESP161",
            ciqCode: "724161"
        },
        {
            codeName: "桑坦德（西班牙）",
            cusCode: "2410",
            codeValue: "ESP162",
            gbName: "桑坦德（西班牙）",
            gbCode: "ESP162",
            ciqCode: "724162"
        },
        {
            codeName: "塞维利亚（西班牙）",
            cusCode: "312",
            codeValue: "ESP165",
            gbName: "塞维利亚（西班牙）",
            gbCode: "ESP165",
            ciqCode: "724165"
        },
        {
            codeName: "索列尔（西班牙）",
            cusCode: "312",
            codeValue: "ESP168",
            gbName: "索列尔（西班牙）",
            gbCode: "ESP168",
            ciqCode: "724168"
        },
        {
            codeName: "塔拉戈纳（西班牙）",
            cusCode: "2411",
            codeValue: "ESP171",
            gbName: "塔拉戈纳（西班牙）",
            gbCode: "ESP171",
            ciqCode: "724171"
        },
        {
            codeName: "托雷维耶哈（西班牙）",
            cusCode: "2412",
            codeValue: "ESP174",
            gbName: "托雷维耶哈（西班牙）",
            gbCode: "ESP174",
            ciqCode: "724174"
        },
        {
            codeName: "巴伦西亚（西班牙）",
            cusCode: "2413",
            codeValue: "ESP177",
            gbName: "巴伦西亚（西班牙）",
            gbCode: "ESP177",
            ciqCode: "724177"
        },
        {
            codeName: "维哥（西班牙）",
            cusCode: "2414",
            codeValue: "ESP180",
            gbName: "维哥（西班牙）",
            gbCode: "ESP180",
            ciqCode: "724180"
        },
        {
            codeName: "维利亚加西（西班牙）",
            cusCode: "2415",
            codeValue: "ESP183",
            gbName: "维利亚加西（西班牙）",
            gbCode: "ESP183",
            ciqCode: "724183"
        },
        {
            codeName: "比韦罗（西班牙）",
            cusCode: "2416",
            codeValue: "ESP186",
            gbName: "比韦罗（西班牙）",
            gbCode: "ESP186",
            ciqCode: "724186"
        },
        {
            codeName: "ASTILLERO（西班牙）",
            cusCode: "2379",
            codeValue: "ESP201",
            gbName: "ASTILLERO（西班牙）",
            gbCode: "ESP201",
            ciqCode: "724201"
        },
        {
            codeName: "BALEARIC IA.（西班牙）",
            cusCode: "2381",
            codeValue: "ESP202",
            gbName: "BALEARIC IA.（西班牙）",
            gbCode: "ESP202",
            ciqCode: "724202"
        },
        {
            codeName: "阿斯塔科斯（西班牙）",
            cusCode: "2378",
            codeValue: "ESP203",
            gbName: "阿斯塔科斯（西班牙）",
            gbCode: "ESP203",
            ciqCode: "724203"
        },
        {
            codeName: "波尔曼（西班牙）",
            cusCode: "2402",
            codeValue: "ESP205",
            gbName: "波尔曼（西班牙）",
            gbCode: "ESP205",
            ciqCode: "724205"
        },
        {
            codeName: "库列腊（西班牙）",
            cusCode: "2385",
            codeValue: "ESP206",
            gbName: "库列腊（西班牙）",
            gbCode: "ESP206",
            ciqCode: "724206"
        },
        {
            codeName: "拉萨利内塔（大西洋群岛）",
            cusCode: "1599",
            codeValue: "ESP209",
            gbName: "拉萨利内塔（大西洋群岛）",
            gbCode: "ESP209",
            ciqCode: "724209"
        },
        {
            codeName: "马德里（西班牙）",
            cusCode: "2392",
            codeValue: "ESP901",
            gbName: "马德里（西班牙）",
            gbCode: "ESP901",
            ciqCode: "724901"
        },
        {
            codeName: "爱沙尼亚",
            cusCode: "334",
            codeValue: "EST000",
            gbName: "爱沙尼亚",
            gbCode: "EST000",
            ciqCode: "233000"
        },
        {
            codeName: "纳尔瓦约埃苏（爱沙尼亚）",
            cusCode: "334",
            codeValue: "EST003",
            gbName: "纳尔瓦约埃苏（爱沙尼亚）",
            gbCode: "EST003",
            ciqCode: "233003"
        },
        {
            codeName: "派尔努/皮亚尔努（爱沙尼亚）",
            cusCode: "334",
            codeValue: "EST006",
            gbName: "派尔努/皮亚尔努（爱沙尼亚）",
            gbCode: "EST006",
            ciqCode: "233006"
        },
        {
            codeName: "塔林（爱沙尼亚）",
            cusCode: "2669",
            codeValue: "EST009",
            gbName: "塔林（爱沙尼亚）",
            gbCode: "EST009",
            ciqCode: "233009"
        },
        {
            codeName: "埃塞俄比亚",
            cusCode: "217",
            codeValue: "ETH000",
            gbName: "埃塞俄比亚",
            gbCode: "ETH000",
            ciqCode: "231000"
        },
        {
            codeName: "阿萨布（埃塞俄比亚）",
            cusCode: "1629",
            codeValue: "ETH003",
            gbName: "阿萨布（埃塞俄比亚）",
            gbCode: "ETH003",
            ciqCode: "231003"
        },
        {
            codeName: "蒂奥（埃塞俄比亚）",
            cusCode: "1631",
            codeValue: "ETH005",
            gbName: "蒂奥（埃塞俄比亚）",
            gbCode: "ETH005",
            ciqCode: "231005"
        },
        {
            codeName: "马萨瓦（埃塞俄比亚）",
            cusCode: "1630",
            codeValue: "ETH006",
            gbName: "马萨瓦（埃塞俄比亚）",
            gbCode: "ETH006",
            ciqCode: "231006"
        },
        {
            codeName: "芬兰",
            cusCode: "318",
            codeValue: "FIN000",
            gbName: "芬兰",
            gbCode: "FIN000",
            ciqCode: "246000"
        },
        {
            codeName: "巴罗生特（芬兰）",
            cusCode: "318",
            codeValue: "FIN003",
            gbName: "巴罗生特（芬兰）",
            gbCode: "FIN003",
            ciqCode: "246003"
        },
        {
            codeName: "代格比（芬兰）",
            cusCode: "318",
            codeValue: "FIN006",
            gbName: "代格比（芬兰）",
            gbCode: "FIN006",
            ciqCode: "246006"
        },
        {
            codeName: "哈米纳（芬兰）",
            cusCode: "2428",
            codeValue: "FIN009",
            gbName: "哈米纳（芬兰）",
            gbCode: "FIN009",
            ciqCode: "246009"
        },
        {
            codeName: "汉科（芬兰）",
            cusCode: "2429",
            codeValue: "FIN012",
            gbName: "汉科（芬兰）",
            gbCode: "FIN012",
            ciqCode: "246012"
        },
        {
            codeName: "卡斯基嫩（芬兰）",
            cusCode: "2432",
            codeValue: "FIN013",
            gbName: "卡斯基嫩（芬兰）",
            gbCode: "FIN013",
            ciqCode: "246013"
        },
        {
            codeName: "贾科布斯塔德（芬兰）",
            cusCode: "2431",
            codeValue: "FIN014",
            gbName: "贾科布斯塔德（芬兰）",
            gbCode: "FIN014",
            ciqCode: "246014"
        },
        {
            codeName: "赫尔辛基（芬兰）",
            cusCode: "2430",
            codeValue: "FIN015",
            gbName: "赫尔辛基（芬兰）",
            gbCode: "FIN015",
            ciqCode: "246015"
        },
        {
            codeName: "因科（芬兰）",
            cusCode: "318",
            codeValue: "FIN018",
            gbName: "因科（芬兰）",
            gbCode: "FIN018",
            ciqCode: "246018"
        },
        {
            codeName: "伊斯奈斯（芬兰）",
            cusCode: "318",
            codeValue: "FIN021",
            gbName: "伊斯奈斯（芬兰）",
            gbCode: "FIN021",
            ciqCode: "246021"
        },
        {
            codeName: "卡斯基宁（芬兰）",
            cusCode: "318",
            codeValue: "FIN024",
            gbName: "卡斯基宁（芬兰）",
            gbCode: "FIN024",
            ciqCode: "246024"
        },
        {
            codeName: "凯米（芬兰）",
            cusCode: "2439",
            codeValue: "FIN027",
            gbName: "凯米（芬兰）",
            gbCode: "FIN027",
            ciqCode: "246027"
        },
        {
            codeName: "科科拉（芬兰）",
            cusCode: "2440",
            codeValue: "FIN030",
            gbName: "科科拉（芬兰）",
            gbCode: "FIN030",
            ciqCode: "246030"
        },
        {
            codeName: "科特卡（芬兰）",
            cusCode: "2433",
            codeValue: "FIN033",
            gbName: "科特卡（芬兰）",
            gbCode: "FIN033",
            ciqCode: "246033"
        },
        {
            codeName: "科维尔哈（芬兰）",
            cusCode: "318",
            codeValue: "FIN036",
            gbName: "科维尔哈（芬兰）",
            gbCode: "FIN036",
            ciqCode: "246036"
        },
        {
            codeName: "克里斯蒂娜城（芬兰）",
            cusCode: "318",
            codeValue: "FIN039",
            gbName: "克里斯蒂娜城（芬兰）",
            gbCode: "FIN039",
            ciqCode: "246039"
        },
        {
            codeName: "克里斯提内斯塔德（芬兰）",
            cusCode: "2434",
            codeValue: "FIN041",
            gbName: "克里斯提内斯塔德（芬兰）",
            gbCode: "FIN041",
            ciqCode: "246041"
        },
        {
            codeName: "拉柏罗吐（芬兰）",
            cusCode: "318",
            codeValue: "FIN042",
            gbName: "拉柏罗吐（芬兰）",
            gbCode: "FIN042",
            ciqCode: "246042"
        },
        {
            codeName: "洛维萨（芬兰）",
            cusCode: "2437",
            codeValue: "FIN045",
            gbName: "洛维萨（芬兰）",
            gbCode: "FIN045",
            ciqCode: "246045"
        },
        {
            codeName: "曼蒂卢奥托（芬兰）",
            cusCode: "2438",
            codeValue: "FIN048",
            gbName: "曼蒂卢奥托（芬兰）",
            gbCode: "FIN048",
            ciqCode: "246048"
        },
        {
            codeName: "玛丽港（芬兰）",
            cusCode: "318",
            codeValue: "FIN051",
            gbName: "玛丽港（芬兰）",
            gbCode: "FIN051",
            ciqCode: "246051"
        },
        {
            codeName: "梅里卡尔维亚（芬兰）",
            cusCode: "318",
            codeValue: "FIN054",
            gbName: "梅里卡尔维亚（芬兰）",
            gbCode: "FIN054",
            ciqCode: "246054"
        },
        {
            codeName: "楠塔利（芬兰）",
            cusCode: "318",
            codeValue: "FIN057",
            gbName: "楠塔利（芬兰）",
            gbCode: "FIN057",
            ciqCode: "246057"
        },
        {
            codeName: "尼斯塔德（芬兰）",
            cusCode: "2441",
            codeValue: "FIN060",
            gbName: "尼斯塔德（芬兰）",
            gbCode: "FIN060",
            ciqCode: "246060"
        },
        {
            codeName: "ROYTTA（芬兰）",
            cusCode: "2446",
            codeValue: "FIN062",
            gbName: "ROYTTA（芬兰）",
            gbCode: "FIN062",
            ciqCode: "246062"
        },
        {
            codeName: "奥鲁（芬兰）",
            cusCode: "2442",
            codeValue: "FIN063",
            gbName: "奥鲁（芬兰）",
            gbCode: "FIN063",
            ciqCode: "246063"
        },
        {
            codeName: "柏尔加斯（芬兰）",
            cusCode: "318",
            codeValue: "FIN066",
            gbName: "柏尔加斯（芬兰）",
            gbCode: "FIN066",
            ciqCode: "246066"
        },
        {
            codeName: "帕特尼安密（芬兰）",
            cusCode: "318",
            codeValue: "FIN069",
            gbName: "帕特尼安密（芬兰）",
            gbCode: "FIN069",
            ciqCode: "246069"
        },
        {
            codeName: "皮耶塔尔萨里（芬兰）",
            cusCode: "318",
            codeValue: "FIN072",
            gbName: "皮耶塔尔萨里（芬兰）",
            gbCode: "FIN072",
            ciqCode: "246072"
        },
        {
            codeName: "波里（芬兰）",
            cusCode: "2445",
            codeValue: "FIN075",
            gbName: "波里（芬兰）",
            gbCode: "FIN075",
            ciqCode: "246075"
        },
        {
            codeName: "波卡拉（芬兰）",
            cusCode: "318",
            codeValue: "FIN078",
            gbName: "波卡拉（芬兰）",
            gbCode: "FIN078",
            ciqCode: "246078"
        },
        {
            codeName: "波尔沃（芬兰）",
            cusCode: "318",
            codeValue: "FIN081",
            gbName: "波尔沃（芬兰）",
            gbCode: "FIN081",
            ciqCode: "246081"
        },
        {
            codeName: "拉赫（芬兰）",
            cusCode: "2443",
            codeValue: "FIN084",
            gbName: "拉赫（芬兰）",
            gbCode: "FIN084",
            ciqCode: "246084"
        },
        {
            codeName: "拉赫提（芬兰）",
            cusCode: "2436",
            codeValue: "FIN086",
            gbName: "拉赫提（芬兰）",
            gbCode: "FIN086",
            ciqCode: "246086"
        },
        {
            codeName: "劳马（芬兰）",
            cusCode: "2444",
            codeValue: "FIN087",
            gbName: "劳马（芬兰）",
            gbCode: "FIN087",
            ciqCode: "246087"
        },
        {
            codeName: "雷波萨里（芬兰）",
            cusCode: "318",
            codeValue: "FIN090",
            gbName: "雷波萨里（芬兰）",
            gbCode: "FIN090",
            ciqCode: "246090"
        },
        {
            codeName: "塞马运河（芬兰）",
            cusCode: "318",
            codeValue: "FIN093",
            gbName: "塞马运河（芬兰）",
            gbCode: "FIN093",
            ciqCode: "246093"
        },
        {
            codeName: "斯库卢（芬兰）",
            cusCode: "318",
            codeValue: "FIN096",
            gbName: "斯库卢（芬兰）",
            gbCode: "FIN096",
            ciqCode: "246096"
        },
        {
            codeName: "塔米萨里（芬兰）",
            cusCode: "2447",
            codeValue: "FIN099",
            gbName: "塔米萨里（芬兰）",
            gbCode: "FIN099",
            ciqCode: "246099"
        },
        {
            codeName: "托基斯（芬兰）",
            cusCode: "318",
            codeValue: "FIN102",
            gbName: "托基斯（芬兰）",
            gbCode: "FIN102",
            ciqCode: "246102"
        },
        {
            codeName: "托比拉（芬兰）",
            cusCode: "318",
            codeValue: "FIN105",
            gbName: "托比拉（芬兰）",
            gbCode: "FIN105",
            ciqCode: "246105"
        },
        {
            codeName: "托尔尼奥（芬兰）",
            cusCode: "2450",
            codeValue: "FIN108",
            gbName: "托尔尼奥（芬兰）",
            gbCode: "FIN108",
            ciqCode: "246108"
        },
        {
            codeName: "坦佩雷（芬兰）",
            cusCode: "2448",
            codeValue: "FIN110",
            gbName: "坦佩雷（芬兰）",
            gbCode: "FIN110",
            ciqCode: "246110"
        },
        {
            codeName: "图尔库（芬兰）",
            cusCode: "2427",
            codeValue: "FIN111",
            gbName: "图尔库（芬兰）",
            gbCode: "FIN111",
            ciqCode: "246111"
        },
        {
            codeName: "新考蓬基（芬兰）",
            cusCode: "2453",
            codeValue: "FIN114",
            gbName: "新考蓬基（芬兰）",
            gbCode: "FIN114",
            ciqCode: "246114"
        },
        {
            codeName: "瓦萨（芬兰）",
            cusCode: "2454",
            codeValue: "FIN117",
            gbName: "瓦萨（芬兰）",
            gbCode: "FIN117",
            ciqCode: "246117"
        },
        {
            codeName: "瓦斯克尔良托（芬兰）",
            cusCode: "318",
            codeValue: "FIN120",
            gbName: "瓦斯克尔良托（芬兰）",
            gbCode: "FIN120",
            ciqCode: "246120"
        },
        {
            codeName: "卫特什露土（芬兰）",
            cusCode: "318",
            codeValue: "FIN123",
            gbName: "卫特什露土（芬兰）",
            gbCode: "FIN123",
            ciqCode: "246123"
        },
        {
            codeName: "瓦尔卡姆（芬兰）",
            cusCode: "2455",
            codeValue: "FIN126",
            gbName: "瓦尔卡姆（芬兰）",
            gbCode: "FIN126",
            ciqCode: "246126"
        },
        {
            codeName: "伊克斯皮拉雅（芬兰）",
            cusCode: "2456",
            codeValue: "FIN129",
            gbName: "伊克斯皮拉雅（芬兰）",
            gbCode: "FIN129",
            ciqCode: "246129"
        },
        {
            codeName: "斐济",
            cusCode: "603",
            codeValue: "FJI000",
            gbName: "斐济",
            gbCode: "FJI000",
            ciqCode: "242000"
        },
        {
            codeName: "埃灵顿（斐济）",
            cusCode: "603",
            codeValue: "FJI003",
            gbName: "埃灵顿（斐济）",
            gbCode: "FJI003",
            ciqCode: "242003"
        },
        {
            codeName: "兰巴萨（斐济）",
            cusCode: "3279",
            codeValue: "FJI006",
            gbName: "兰巴萨（斐济）",
            gbCode: "FJI006",
            ciqCode: "242006"
        },
        {
            codeName: "劳托卡（斐济）",
            cusCode: "3280",
            codeValue: "FJI009",
            gbName: "劳托卡（斐济）",
            gbCode: "FJI009",
            ciqCode: "242009"
        },
        {
            codeName: "累武卡（斐济）",
            cusCode: "3281",
            codeValue: "FJI012",
            gbName: "累武卡（斐济）",
            gbCode: "FJI012",
            ciqCode: "242012"
        },
        {
            codeName: "萨武萨武湾（斐济）",
            cusCode: "3282",
            codeValue: "FJI015",
            gbName: "萨武萨武湾（斐济）",
            gbCode: "FJI015",
            ciqCode: "242015"
        },
        {
            codeName: "苏瓦（斐济）",
            cusCode: "3283",
            codeValue: "FJI018",
            gbName: "苏瓦（斐济）",
            gbCode: "FJI018",
            ciqCode: "242018"
        },
        {
            codeName: "瓦提亚角（斐济）",
            cusCode: "603",
            codeValue: "FJI021",
            gbName: "瓦提亚角（斐济）",
            gbCode: "FJI021",
            ciqCode: "242021"
        },
        {
            codeName: "楠迪（斐济）",
            cusCode: "603",
            codeValue: "FJI901",
            gbName: "楠迪（斐济）",
            gbCode: "FJI901",
            ciqCode: "242901"
        },
        {
            codeName: "福克兰群岛（马尔维纳斯）",
            cusCode: "452",
            codeValue: "FLK000",
            gbName: "福克兰群岛（马尔维纳斯）",
            gbCode: "FLK000",
            ciqCode: "238000"
        },
        {
            codeName: "斯坦利港（福克兰群岛(马尔维纳斯)）",
            cusCode: "2987",
            codeValue: "FLK003",
            gbName: "斯坦利港（福克兰群岛(马尔维纳斯)）",
            gbCode: "FLK003",
            ciqCode: "238003"
        },
        {
            codeName: "法国",
            cusCode: "305",
            codeValue: "FRA000",
            gbName: "法国",
            gbCode: "FRA000",
            ciqCode: "250000"
        },
        {
            codeName: "AMBES（法国）",
            cusCode: "2132",
            codeValue: "FRA002",
            gbName: "AMBES（法国）",
            gbCode: "FRA002",
            ciqCode: "250002"
        },
        {
            codeName: "阿布维尔（法国）",
            cusCode: "2130",
            codeValue: "FRA003",
            gbName: "阿布维尔（法国）",
            gbCode: "FRA003",
            ciqCode: "250003"
        },
        {
            codeName: "阿雅克肖（法国）",
            cusCode: "2131",
            codeValue: "FRA006",
            gbName: "阿雅克肖（法国）",
            gbCode: "FRA006",
            ciqCode: "250006"
        },
        {
            codeName: "昂蒂布（法国）",
            cusCode: "2133",
            codeValue: "FRA009",
            gbName: "昂蒂布（法国）",
            gbCode: "FRA009",
            ciqCode: "250009"
        },
        {
            codeName: "昂蒂弗（法国）",
            cusCode: "305",
            codeValue: "FRA012",
            gbName: "昂蒂弗（法国）",
            gbCode: "FRA012",
            ciqCode: "250012"
        },
        {
            codeName: "阿尔卡雄（法国）",
            cusCode: "2134",
            codeValue: "FRA015",
            gbName: "阿尔卡雄（法国）",
            gbCode: "FRA015",
            ciqCode: "250015"
        },
        {
            codeName: "巴森（法国）",
            cusCode: "2135",
            codeValue: "FRA018",
            gbName: "巴森（法国）",
            gbCode: "FRA018",
            ciqCode: "250018"
        },
        {
            codeName: "巴斯蒂亚（法国）",
            cusCode: "2136",
            codeValue: "FRA021",
            gbName: "巴斯蒂亚（法国）",
            gbCode: "FRA021",
            ciqCode: "250021"
        },
        {
            codeName: "巴约讷（法国）",
            cusCode: "2137",
            codeValue: "FRA024",
            gbName: "巴约讷（法国）",
            gbCode: "FRA024",
            ciqCode: "250024"
        },
        {
            codeName: "贝克德阿姆比斯（法国）",
            cusCode: "2138",
            codeValue: "FRA027",
            gbName: "贝克德阿姆比斯（法国）",
            gbCode: "FRA027",
            ciqCode: "250027"
        },
        {
            codeName: "布莱（法国）",
            cusCode: "2139",
            codeValue: "FRA030",
            gbName: "布莱（法国）",
            gbCode: "FRA030",
            ciqCode: "250030"
        },
        {
            codeName: "博尼法乔（法国）",
            cusCode: "2140",
            codeValue: "FRA033",
            gbName: "博尼法乔（法国）",
            gbCode: "FRA033",
            ciqCode: "250033"
        },
        {
            codeName: "波尔多（法国）",
            cusCode: "2141",
            codeValue: "FRA036",
            gbName: "波尔多（法国）",
            gbCode: "FRA036",
            ciqCode: "250036"
        },
        {
            codeName: "布洛涅（法国）",
            cusCode: "2142",
            codeValue: "FRA039",
            gbName: "布洛涅（法国）",
            gbCode: "FRA039",
            ciqCode: "250039"
        },
        {
            codeName: "布雷斯特（法国）",
            cusCode: "2143",
            codeValue: "FRA042",
            gbName: "布雷斯特（法国）",
            gbCode: "FRA042",
            ciqCode: "250042"
        },
        {
            codeName: "卡昂（法国）",
            cusCode: "2146",
            codeValue: "FRA045",
            gbName: "卡昂（法国）",
            gbCode: "FRA045",
            ciqCode: "250045"
        },
        {
            codeName: "加来（法国）",
            cusCode: "2144",
            codeValue: "FRA048",
            gbName: "加来（法国）",
            gbCode: "FRA048",
            ciqCode: "250048"
        },
        {
            codeName: "卡尔维（法国）",
            cusCode: "2147",
            codeValue: "FRA051",
            gbName: "卡尔维（法国）",
            gbCode: "FRA051",
            ciqCode: "250051"
        },
        {
            codeName: "卡马雷（法国）",
            cusCode: "2148",
            codeValue: "FRA054",
            gbName: "卡马雷（法国）",
            gbCode: "FRA054",
            ciqCode: "250054"
        },
        {
            codeName: "康卡勒（法国）",
            cusCode: "305",
            codeValue: "FRA057",
            gbName: "康卡勒（法国）",
            gbCode: "FRA057",
            ciqCode: "250057"
        },
        {
            codeName: "戛纳（法国）",
            cusCode: "2149",
            codeValue: "FRA060",
            gbName: "戛纳（法国）",
            gbCode: "FRA060",
            ciqCode: "250060"
        },
        {
            codeName: "卡隆特（法国）",
            cusCode: "305",
            codeValue: "FRA063",
            gbName: "卡隆特（法国）",
            gbCode: "FRA063",
            ciqCode: "250063"
        },
        {
            codeName: "瑟堡（法国）",
            cusCode: "2145",
            codeValue: "FRA066",
            gbName: "瑟堡（法国）",
            gbCode: "FRA066",
            ciqCode: "250066"
        },
        {
            codeName: "孔卡尔诺（法国）",
            cusCode: "2150",
            codeValue: "FRA069",
            gbName: "孔卡尔诺（法国）",
            gbCode: "FRA069",
            ciqCode: "250069"
        },
        {
            codeName: "达乌埃（法国）",
            cusCode: "2151",
            codeValue: "FRA072",
            gbName: "达乌埃（法国）",
            gbCode: "FRA072",
            ciqCode: "250072"
        },
        {
            codeName: "多维尔（法国）",
            cusCode: "305",
            codeValue: "FRA075",
            gbName: "多维尔（法国）",
            gbCode: "FRA075",
            ciqCode: "250075"
        },
        {
            codeName: "迪耶普（法国）",
            cusCode: "2152",
            codeValue: "FRA078",
            gbName: "迪耶普（法国）",
            gbCode: "FRA078",
            ciqCode: "250078"
        },
        {
            codeName: "栋日（法国）",
            cusCode: "2153",
            codeValue: "FRA081",
            gbName: "栋日（法国）",
            gbCode: "FRA081",
            ciqCode: "250081"
        },
        {
            codeName: "杜阿梅勒兹（法国）",
            cusCode: "305",
            codeValue: "FRA084",
            gbName: "杜阿梅勒兹（法国）",
            gbCode: "FRA084",
            ciqCode: "250084"
        },
        {
            codeName: "敦刻尔克（法国）",
            cusCode: "2154",
            codeValue: "FRA087",
            gbName: "敦刻尔克（法国）",
            gbCode: "FRA087",
            ciqCode: "250087"
        },
        {
            codeName: "埃塔普勒（法国）",
            cusCode: "305",
            codeValue: "FRA090",
            gbName: "埃塔普勒（法国）",
            gbCode: "FRA090",
            ciqCode: "250090"
        },
        {
            codeName: "费康（法国）",
            cusCode: "2155",
            codeValue: "FRA093",
            gbName: "费康（法国）",
            gbCode: "FRA093",
            ciqCode: "250093"
        },
        {
            codeName: "福斯（法国）",
            cusCode: "305",
            codeValue: "FRA096",
            gbName: "福斯（法国）",
            gbCode: "FRA096",
            ciqCode: "250096"
        },
        {
            codeName: "贡夫勒维尔（法国）",
            cusCode: "305",
            codeValue: "FRA099",
            gbName: "贡夫勒维尔（法国）",
            gbCode: "FRA099",
            ciqCode: "250099"
        },
        {
            codeName: "格兰维尔（法国）",
            cusCode: "305",
            codeValue: "FRA102",
            gbName: "格兰维尔（法国）",
            gbCode: "FRA102",
            ciqCode: "250102"
        },
        {
            codeName: "格拉沃利讷（法国）",
            cusCode: "305",
            codeValue: "FRA105",
            gbName: "格拉沃利讷（法国）",
            gbCode: "FRA105",
            ciqCode: "250105"
        },
        {
            codeName: "阿弗尔（法国）",
            cusCode: "305",
            codeValue: "FRA108",
            gbName: "阿弗尔（法国）",
            gbCode: "FRA108",
            ciqCode: "250108"
        },
        {
            codeName: "翁弗勒尔（法国）",
            cusCode: "2156",
            codeValue: "FRA111",
            gbName: "翁弗勒尔（法国）",
            gbCode: "FRA111",
            ciqCode: "250111"
        },
        {
            codeName: "伊尔鲁斯（法国）",
            cusCode: "2157",
            codeValue: "FRA114",
            gbName: "伊尔鲁斯（法国）",
            gbCode: "FRA114",
            ciqCode: "250114"
        },
        {
            codeName: "拉西约塔（法国）",
            cusCode: "2158",
            codeValue: "FRA117",
            gbName: "拉西约塔（法国）",
            gbCode: "FRA117",
            ciqCode: "250117"
        },
        {
            codeName: "拉努韦勒（法国）",
            cusCode: "2159",
            codeValue: "FRA120",
            gbName: "拉努韦勒（法国）",
            gbCode: "FRA120",
            ciqCode: "250120"
        },
        {
            codeName: "拉帕利斯（法国）",
            cusCode: "2160",
            codeValue: "FRA123",
            gbName: "拉帕利斯（法国）",
            gbCode: "FRA123",
            ciqCode: "250123"
        },
        {
            codeName: "拉罗谢尔（法国）",
            cusCode: "2161",
            codeValue: "FRA126",
            gbName: "拉罗谢尔（法国）",
            gbCode: "FRA126",
            ciqCode: "250126"
        },
        {
            codeName: "朗代诺（法国）",
            cusCode: "2162",
            codeValue: "FRA129",
            gbName: "朗代诺（法国）",
            gbCode: "FRA129",
            ciqCode: "250129"
        },
        {
            codeName: "拉瓦拉（法国）",
            cusCode: "305",
            codeValue: "FRA132",
            gbName: "拉瓦拉（法国）",
            gbCode: "FRA132",
            ciqCode: "250132"
        },
        {
            codeName: "奥来龙堡（法国）",
            cusCode: "2163",
            codeValue: "FRA135",
            gbName: "奥来龙堡（法国）",
            gbCode: "FRA135",
            ciqCode: "250135"
        },
        {
            codeName: "勒吉尔多（法国）",
            cusCode: "2164",
            codeValue: "FRA138",
            gbName: "勒吉尔多（法国）",
            gbCode: "FRA138",
            ciqCode: "250138"
        },
        {
            codeName: "利布尔讷（法国）",
            cusCode: "2167",
            codeValue: "FRA141",
            gbName: "利布尔讷（法国）",
            gbCode: "FRA141",
            ciqCode: "250141"
        },
        {
            codeName: "洛克蒂迪（法国）",
            cusCode: "2168",
            codeValue: "FRA144",
            gbName: "洛克蒂迪（法国）",
            gbCode: "FRA144",
            ciqCode: "250144"
        },
        {
            codeName: "洛里昂（法国）",
            cusCode: "2169",
            codeValue: "FRA147",
            gbName: "洛里昂（法国）",
            gbCode: "FRA147",
            ciqCode: "250147"
        },
        {
            codeName: "马朗（法国）",
            cusCode: "305",
            codeValue: "FRA150",
            gbName: "马朗（法国）",
            gbCode: "FRA150",
            ciqCode: "250150"
        },
        {
            codeName: "马赛（法国）",
            cusCode: "2170",
            codeValue: "FRA153",
            gbName: "马赛（法国）",
            gbCode: "FRA153",
            ciqCode: "250153"
        },
        {
            codeName: "马蒂格（法国）",
            cusCode: "305",
            codeValue: "FRA156",
            gbName: "马蒂格（法国）",
            gbCode: "FRA156",
            ciqCode: "250156"
        },
        {
            codeName: "蒙托伊尔（法国）",
            cusCode: "305",
            codeValue: "FRA159",
            gbName: "蒙托伊尔（法国）",
            gbCode: "FRA159",
            ciqCode: "250159"
        },
        {
            codeName: "莫尔莱（法国）",
            cusCode: "2171",
            codeValue: "FRA162",
            gbName: "莫尔莱（法国）",
            gbCode: "FRA162",
            ciqCode: "250162"
        },
        {
            codeName: "南特（法国）",
            cusCode: "2172",
            codeValue: "FRA165",
            gbName: "南特（法国）",
            gbCode: "FRA165",
            ciqCode: "250165"
        },
        {
            codeName: "尼斯（法国）",
            cusCode: "2173",
            codeValue: "FRA168",
            gbName: "尼斯（法国）",
            gbCode: "FRA168",
            ciqCode: "250168"
        },
        {
            codeName: "乌伊斯特勒昂（法国）",
            cusCode: "305",
            codeValue: "FRA171",
            gbName: "乌伊斯特勒昂（法国）",
            gbCode: "FRA171",
            ciqCode: "250171"
        },
        {
            codeName: "潘伯夫（法国）",
            cusCode: "2174",
            codeValue: "FRA174",
            gbName: "潘伯夫（法国）",
            gbCode: "FRA174",
            ciqCode: "250174"
        },
        {
            codeName: "潘波勒（法国）",
            cusCode: "2175",
            codeValue: "FRA177",
            gbName: "潘波勒（法国）",
            gbCode: "FRA177",
            ciqCode: "250177"
        },
        {
            codeName: "帕里斯（法国）",
            cusCode: "305",
            codeValue: "FRA180",
            gbName: "帕里斯（法国）",
            gbCode: "FRA180",
            ciqCode: "250180"
        },
        {
            codeName: "波亚克（法国）",
            cusCode: "2177",
            codeValue: "FRA183",
            gbName: "波亚克（法国）",
            gbCode: "FRA183",
            ciqCode: "250183"
        },
        {
            codeName: "彭拉贝（法国）",
            cusCode: "2178",
            codeValue: "FRA186",
            gbName: "彭拉贝（法国）",
            gbCode: "FRA186",
            ciqCode: "250186"
        },
        {
            codeName: "布克港（法国）",
            cusCode: "305",
            codeValue: "FRA189",
            gbName: "布克港（法国）",
            gbCode: "FRA189",
            ciqCode: "250189"
        },
        {
            codeName: "杰罗姆港（法国）",
            cusCode: "305",
            codeValue: "FRA192",
            gbName: "杰罗姆港（法国）",
            gbCode: "FRA192",
            ciqCode: "250192"
        },
        {
            codeName: "旺德尔港（法国）",
            cusCode: "2179",
            codeValue: "FRA195",
            gbName: "旺德尔港（法国）",
            gbCode: "FRA195",
            ciqCode: "250195"
        },
        {
            codeName: "韦基奥港（法国）",
            cusCode: "2180",
            codeValue: "FRA198",
            gbName: "韦基奥港（法国）",
            gbCode: "FRA198",
            ciqCode: "250198"
        },
        {
            codeName: "普罗普里亚诺（法国）",
            cusCode: "2181",
            codeValue: "FRA201",
            gbName: "普罗普里亚诺（法国）",
            gbCode: "FRA201",
            ciqCode: "250201"
        },
        {
            codeName: "坎佩尔（法国）",
            cusCode: "2182",
            codeValue: "FRA204",
            gbName: "坎佩尔（法国）",
            gbCode: "FRA204",
            ciqCode: "250204"
        },
        {
            codeName: "罗什福尔（法国）",
            cusCode: "2183",
            codeValue: "FRA207",
            gbName: "罗什福尔（法国）",
            gbCode: "FRA207",
            ciqCode: "250207"
        },
        {
            codeName: "罗斯科夫（法国）",
            cusCode: "2184",
            codeValue: "FRA210",
            gbName: "罗斯科夫（法国）",
            gbCode: "FRA210",
            ciqCode: "250210"
        },
        {
            codeName: "鲁昂（法国）",
            cusCode: "2185",
            codeValue: "FRA213",
            gbName: "鲁昂（法国）",
            gbCode: "FRA213",
            ciqCode: "250213"
        },
        {
            codeName: "萨布勒多隆（法国）",
            cusCode: "2186",
            codeValue: "FRA216",
            gbName: "萨布勒多隆（法国）",
            gbCode: "FRA216",
            ciqCode: "250216"
        },
        {
            codeName: "塞特（法国）",
            cusCode: "2187",
            codeValue: "FRA219",
            gbName: "塞特（法国）",
            gbCode: "FRA219",
            ciqCode: "250219"
        },
        {
            codeName: "圣布里厄（法国）",
            cusCode: "2166",
            codeValue: "FRA222",
            gbName: "圣布里厄（法国）",
            gbCode: "FRA222",
            ciqCode: "250222"
        },
        {
            codeName: "圣让德吕兹（法国）",
            cusCode: "305",
            codeValue: "FRA225",
            gbName: "圣让德吕兹（法国）",
            gbCode: "FRA225",
            ciqCode: "250225"
        },
        {
            codeName: "圣路易罗纳（法国）",
            cusCode: "2189",
            codeValue: "FRA228",
            gbName: "圣路易罗纳（法国）",
            gbCode: "FRA228",
            ciqCode: "250228"
        },
        {
            codeName: "圣马洛（法国）",
            cusCode: "2190",
            codeValue: "FRA231",
            gbName: "圣马洛（法国）",
            gbCode: "FRA231",
            ciqCode: "250231"
        },
        {
            codeName: "圣纳泽尔（法国）",
            cusCode: "2191",
            codeValue: "FRA234",
            gbName: "圣纳泽尔（法国）",
            gbCode: "FRA234",
            ciqCode: "250234"
        },
        {
            codeName: "圣塞尔旺（法国）",
            cusCode: "305",
            codeValue: "FRA237",
            gbName: "圣塞尔旺（法国）",
            gbCode: "FRA237",
            ciqCode: "250237"
        },
        {
            codeName: "圣瓦勒利（法国）",
            cusCode: "305",
            codeValue: "FRA240",
            gbName: "圣瓦勒利（法国）",
            gbCode: "FRA240",
            ciqCode: "250240"
        },
        {
            codeName: "圣瓦莱里昂科（法国）",
            cusCode: "2192",
            codeValue: "FRA243",
            gbName: "圣瓦莱里昂科（法国）",
            gbCode: "FRA243",
            ciqCode: "250243"
        },
        {
            codeName: "斯特拉斯堡（法国）",
            cusCode: "2193",
            codeValue: "FRA246",
            gbName: "斯特拉斯堡（法国）",
            gbCode: "FRA246",
            ciqCode: "250246"
        },
        {
            codeName: "托内沙朗特（法国）",
            cusCode: "2194",
            codeValue: "FRA249",
            gbName: "托内沙朗特（法国）",
            gbCode: "FRA249",
            ciqCode: "250249"
        },
        {
            codeName: "土伦（法国）",
            cusCode: "2195",
            codeValue: "FRA252",
            gbName: "土伦（法国）",
            gbCode: "FRA252",
            ciqCode: "250252"
        },
        {
            codeName: "特雷吉耶（法国）",
            cusCode: "305",
            codeValue: "FRA255",
            gbName: "特雷吉耶（法国）",
            gbCode: "FRA255",
            ciqCode: "250255"
        },
        {
            codeName: "特雷波特（法国）",
            cusCode: "2197",
            codeValue: "FRA258",
            gbName: "特雷波特（法国）",
            gbCode: "FRA258",
            ciqCode: "250258"
        },
        {
            codeName: "特鲁维尔（法国）",
            cusCode: "2198",
            codeValue: "FRA261",
            gbName: "特鲁维尔（法国）",
            gbCode: "FRA261",
            ciqCode: "250261"
        },
        {
            codeName: "瓦讷（法国）",
            cusCode: "305",
            codeValue: "FRA264",
            gbName: "瓦讷（法国）",
            gbCode: "FRA264",
            ciqCode: "250264"
        },
        {
            codeName: "韦尔东（法国）",
            cusCode: "2199",
            codeValue: "FRA267",
            gbName: "韦尔东（法国）",
            gbCode: "FRA267",
            ciqCode: "250267"
        },
        {
            codeName: "巴黎（法国）",
            cusCode: "2176",
            codeValue: "FRA901",
            gbName: "巴黎（法国）",
            gbCode: "FRA901",
            ciqCode: "250901"
        },
        {
            codeName: "勒阿弗尔（法国）",
            cusCode: "2165",
            codeValue: "FRA902",
            gbName: "勒阿弗尔（法国）",
            gbCode: "FRA902",
            ciqCode: "250902"
        },
        {
            codeName: "里昂圣图拉斯（法国）",
            cusCode: "305",
            codeValue: "FRA903",
            gbName: "里昂圣图拉斯（法国）",
            gbCode: "FRA903",
            ciqCode: "250903"
        },
        {
            codeName: "法罗群岛",
            cusCode: "357",
            codeValue: "FRO000",
            gbName: "法罗群岛",
            gbCode: "FRO000",
            ciqCode: "234000"
        },
        {
            codeName: "克拉克斯维克（法罗群岛）",
            cusCode: "357",
            codeValue: "FRO003",
            gbName: "克拉克斯维克（法罗群岛）",
            gbCode: "FRO003",
            ciqCode: "234003"
        },
        {
            codeName: "托尔斯港（法罗群岛）",
            cusCode: "357",
            codeValue: "FRO006",
            gbName: "托尔斯港（法罗群岛）",
            gbCode: "FRO006",
            ciqCode: "234006"
        },
        {
            codeName: "特朗斯瓦格（法罗群岛）",
            cusCode: "357",
            codeValue: "FRO009",
            gbName: "特朗斯瓦格（法罗群岛）",
            gbCode: "FRO009",
            ciqCode: "234009"
        },
        {
            codeName: "特瓦罗伊里（法罗群岛）",
            cusCode: "357",
            codeValue: "FRO012",
            gbName: "特瓦罗伊里（法罗群岛）",
            gbCode: "FRO012",
            ciqCode: "234012"
        },
        {
            codeName: "瓦格（法罗群岛）",
            cusCode: "357",
            codeValue: "FRO015",
            gbName: "瓦格（法罗群岛）",
            gbCode: "FRO015",
            ciqCode: "234015"
        },
        {
            codeName: "韦斯特门港（法罗群岛）",
            cusCode: "357",
            codeValue: "FRO018",
            gbName: "韦斯特门港（法罗群岛）",
            gbCode: "FRO018",
            ciqCode: "234018"
        },
        {
            codeName: "密克罗尼西亚联邦",
            cusCode: "620",
            codeValue: "FSM000",
            gbName: "密克罗尼西亚联邦",
            gbCode: "FSM000",
            ciqCode: "583000"
        },
        {
            codeName: "丘克群岛（密克罗尼西亚联邦）",
            cusCode: "3408",
            codeValue: "FSM003",
            gbName: "丘克群岛（密克罗尼西亚联邦）",
            gbCode: "FSM003",
            ciqCode: "583003"
        },
        {
            codeName: "波纳佩（密克罗尼西亚联邦）",
            cusCode: "3402",
            codeValue: "FSM006",
            gbName: "波纳佩（密克罗尼西亚联邦）",
            gbCode: "FSM006",
            ciqCode: "583006"
        },
        {
            codeName: "雅浦（密克罗尼西亚联邦）",
            cusCode: "3413",
            codeValue: "FSM009",
            gbName: "雅浦（密克罗尼西亚联邦）",
            gbCode: "FSM009",
            ciqCode: "583009"
        },
        {
            codeName: "库赛埃岛（密克罗尼西亚联邦）",
            cusCode: "3391",
            codeValue: "FSM011",
            gbName: "库赛埃岛（密克罗尼西亚联邦）",
            gbCode: "FSM011",
            ciqCode: "583011"
        },
        {
            codeName: "瓦兰岛（密克罗尼西亚联邦）",
            cusCode: "3410",
            codeValue: "FSM012",
            gbName: "瓦兰岛（密克罗尼西亚联邦）",
            gbCode: "FSM012",
            ciqCode: "583012"
        },
        {
            codeName: "加蓬",
            cusCode: "218",
            codeValue: "GAB000",
            gbName: "加蓬",
            gbCode: "GAB000",
            ciqCode: "266000"
        },
        {
            codeName: "马永巴（加蓬）",
            cusCode: "1634",
            codeValue: "GAB002",
            gbName: "马永巴（加蓬）",
            gbCode: "GAB002",
            ciqCode: "266002"
        },
        {
            codeName: "洛佩斯角（加蓬）",
            cusCode: "218",
            codeValue: "GAB003",
            gbName: "洛佩斯角（加蓬）",
            gbCode: "GAB003",
            ciqCode: "266003"
        },
        {
            codeName: "甘巴（加蓬）",
            cusCode: "218",
            codeValue: "GAB006",
            gbName: "甘巴（加蓬）",
            gbCode: "GAB006",
            ciqCode: "266006"
        },
        {
            codeName: "利伯维尔（加蓬）",
            cusCode: "1633",
            codeValue: "GAB009",
            gbName: "利伯维尔（加蓬）",
            gbCode: "GAB009",
            ciqCode: "266009"
        },
        {
            codeName: "卢西纳码头（加蓬）",
            cusCode: "218",
            codeValue: "GAB012",
            gbName: "卢西纳码头（加蓬）",
            gbCode: "GAB012",
            ciqCode: "266012"
        },
        {
            codeName: "奥文多（加蓬）",
            cusCode: "1635",
            codeValue: "GAB015",
            gbName: "奥文多（加蓬）",
            gbCode: "GAB015",
            ciqCode: "266015"
        },
        {
            codeName: "让蒂尔港（加蓬）",
            cusCode: "1632",
            codeValue: "GAB018",
            gbName: "让蒂尔港（加蓬）",
            gbCode: "GAB018",
            ciqCode: "266018"
        },
        {
            codeName: "英国",
            cusCode: "303",
            codeValue: "GBR000",
            gbName: "英国",
            gbCode: "GBR000",
            ciqCode: "826000"
        },
        {
            codeName: "阿伯丁（英国）",
            cusCode: "1859",
            codeValue: "GBR003",
            gbName: "阿伯丁（英国）",
            gbCode: "GBR003",
            ciqCode: "826003"
        },
        {
            codeName: "阿伯道尔（英国）",
            cusCode: "1860",
            codeValue: "GBR006",
            gbName: "阿伯道尔（英国）",
            gbCode: "GBR006",
            ciqCode: "826006"
        },
        {
            codeName: "阿伯多维（英国）",
            cusCode: "1861",
            codeValue: "GBR009",
            gbName: "阿伯多维（英国）",
            gbCode: "GBR009",
            ciqCode: "826009"
        },
        {
            codeName: "阿伯里斯特威斯（英国）",
            cusCode: "303",
            codeValue: "GBR012",
            gbName: "阿伯里斯特威斯（英国）",
            gbCode: "GBR012",
            ciqCode: "826012"
        },
        {
            codeName: "奥尔德尼（英国）",
            cusCode: "1862",
            codeValue: "GBR015",
            gbName: "奥尔德尼（英国）",
            gbCode: "GBR015",
            ciqCode: "826015"
        },
        {
            codeName: "阿姆卢赫（英国）",
            cusCode: "1864",
            codeValue: "GBR018",
            gbName: "阿姆卢赫（英国）",
            gbCode: "GBR018",
            ciqCode: "826018"
        },
        {
            codeName: "安纳隆（英国）",
            cusCode: "1867",
            codeValue: "GBR021",
            gbName: "安纳隆（英国）",
            gbCode: "GBR021",
            ciqCode: "826021"
        },
        {
            codeName: "安嫩（英国）",
            cusCode: "1868",
            codeValue: "GBR024",
            gbName: "安嫩（英国）",
            gbCode: "GBR024",
            ciqCode: "826024"
        },
        {
            codeName: "安斯特拉瑟（英国）",
            cusCode: "1869",
            codeValue: "GBR027",
            gbName: "安斯特拉瑟（英国）",
            gbCode: "GBR027",
            ciqCode: "826027"
        },
        {
            codeName: "阿普尔多尔（英国）",
            cusCode: "1870",
            codeValue: "GBR030",
            gbName: "阿普尔多尔（英国）",
            gbCode: "GBR030",
            ciqCode: "826030"
        },
        {
            codeName: "阿布罗斯（英国）",
            cusCode: "1871",
            codeValue: "GBR033",
            gbName: "阿布罗斯（英国）",
            gbCode: "GBR033",
            ciqCode: "826033"
        },
        {
            codeName: "阿德格拉斯（英国）",
            cusCode: "1872",
            codeValue: "GBR036",
            gbName: "阿德格拉斯（英国）",
            gbCode: "GBR036",
            ciqCode: "826036"
        },
        {
            codeName: "阿德里希格（英国）",
            cusCode: "1873",
            codeValue: "GBR039",
            gbName: "阿德里希格（英国）",
            gbCode: "GBR039",
            ciqCode: "826039"
        },
        {
            codeName: "阿德罗森（英国）",
            cusCode: "303",
            codeValue: "GBR042",
            gbName: "阿德罗森（英国）",
            gbCode: "GBR042",
            ciqCode: "826042"
        },
        {
            codeName: "埃文茅斯（英国）",
            cusCode: "1874",
            codeValue: "GBR045",
            gbName: "埃文茅斯（英国）",
            gbCode: "GBR045",
            ciqCode: "826045"
        },
        {
            codeName: "艾尔（英国）",
            cusCode: "1875",
            codeValue: "GBR048",
            gbName: "艾尔（英国）",
            gbCode: "GBR048",
            ciqCode: "826048"
        },
        {
            codeName: "班戈（W.C.）（英国）",
            cusCode: "303",
            codeValue: "GBR051",
            gbName: "班戈（W.C.）（英国）",
            gbCode: "GBR051",
            ciqCode: "826051"
        },
        {
            codeName: "班戈（Co.Down）（英国）",
            cusCode: "303",
            codeValue: "GBR054",
            gbName: "班戈（Co.Down）（英国）",
            gbCode: "GBR054",
            ciqCode: "826054"
        },
        {
            codeName: "巴茅思（英国）",
            cusCode: "1879",
            codeValue: "GBR057",
            gbName: "巴茅思（英国）",
            gbCode: "GBR057",
            ciqCode: "826057"
        },
        {
            codeName: "巴恩斯特珀尔（英国）",
            cusCode: "1880",
            codeValue: "GBR060",
            gbName: "巴恩斯特珀尔（英国）",
            gbCode: "GBR060",
            ciqCode: "826060"
        },
        {
            codeName: "巴罗（英国）",
            cusCode: "1881",
            codeValue: "GBR063",
            gbName: "巴罗（英国）",
            gbCode: "GBR063",
            ciqCode: "826063"
        },
        {
            codeName: "巴里（英国）",
            cusCode: "303",
            codeValue: "GBR066",
            gbName: "巴里（英国）",
            gbCode: "GBR066",
            ciqCode: "826066"
        },
        {
            codeName: "巴顿（E.C.）（英国）",
            cusCode: "303",
            codeValue: "GBR069",
            gbName: "巴顿（E.C.）（英国）",
            gbCode: "GBR069",
            ciqCode: "826069"
        },
        {
            codeName: "巴顿（W.C.）（英国）",
            cusCode: "303",
            codeValue: "GBR072",
            gbName: "巴顿（W.C.）（英国）",
            gbCode: "GBR072",
            ciqCode: "826072"
        },
        {
            codeName: "博马里斯（英国）",
            cusCode: "1883",
            codeValue: "GBR075",
            gbName: "博马里斯（英国）",
            gbCode: "GBR075",
            ciqCode: "826075"
        },
        {
            codeName: "贝尔法斯特（英国）",
            cusCode: "303",
            codeValue: "GBR078",
            gbName: "贝尔法斯特（英国）",
            gbCode: "GBR078",
            ciqCode: "826078"
        },
        {
            codeName: "伯威克（英国）",
            cusCode: "303",
            codeValue: "GBR081",
            gbName: "伯威克（英国）",
            gbCode: "GBR081",
            ciqCode: "826081"
        },
        {
            codeName: "比迪福德（英国）",
            cusCode: "1887",
            codeValue: "GBR084",
            gbName: "比迪福德（英国）",
            gbCode: "GBR084",
            ciqCode: "826084"
        },
        {
            codeName: "伯肯黑德（英国）",
            cusCode: "1888",
            codeValue: "GBR087",
            gbName: "伯肯黑德（英国）",
            gbCode: "GBR087",
            ciqCode: "826087"
        },
        {
            codeName: "布莱斯（英国）",
            cusCode: "1890",
            codeValue: "GBR090",
            gbName: "布莱斯（英国）",
            gbCode: "GBR090",
            ciqCode: "826090"
        },
        {
            codeName: "波士顿（英国）",
            cusCode: "1891",
            codeValue: "GBR093",
            gbName: "波士顿（英国）",
            gbCode: "GBR093",
            ciqCode: "826093"
        },
        {
            codeName: "布里奇沃特（英国）",
            cusCode: "1893",
            codeValue: "GBR096",
            gbName: "布里奇沃特（英国）",
            gbCode: "GBR096",
            ciqCode: "826096"
        },
        {
            codeName: "布里德灵顿（英国）",
            cusCode: "1894",
            codeValue: "GBR099",
            gbName: "布里德灵顿（英国）",
            gbCode: "GBR099",
            ciqCode: "826099"
        },
        {
            codeName: "布里德波特（英国）",
            cusCode: "1895",
            codeValue: "GBR102",
            gbName: "布里德波特（英国）",
            gbCode: "GBR102",
            ciqCode: "826102"
        },
        {
            codeName: "布赖特灵西（英国）",
            cusCode: "303",
            codeValue: "GBR105",
            gbName: "布赖特灵西（英国）",
            gbCode: "GBR105",
            ciqCode: "826105"
        },
        {
            codeName: "布赖顿（英国）",
            cusCode: "303",
            codeValue: "GBR108",
            gbName: "布赖顿（英国）",
            gbCode: "GBR108",
            ciqCode: "826108"
        },
        {
            codeName: "布里斯托尔（英国）",
            cusCode: "1896",
            codeValue: "GBR111",
            gbName: "布里斯托尔（英国）",
            gbCode: "GBR111",
            ciqCode: "826111"
        },
        {
            codeName: "布里克瑟姆（英国）",
            cusCode: "1898",
            codeValue: "GBR114",
            gbName: "布里克瑟姆（英国）",
            gbCode: "GBR114",
            ciqCode: "826114"
        },
        {
            codeName: "布朗巴勒（英国）",
            cusCode: "1899",
            codeValue: "GBR117",
            gbName: "布朗巴勒（英国）",
            gbCode: "GBR117",
            ciqCode: "826117"
        },
        {
            codeName: "巴基（英国）",
            cusCode: "1901",
            codeValue: "GBR120",
            gbName: "巴基（英国）",
            gbCode: "GBR120",
            ciqCode: "826120"
        },
        {
            codeName: "伯格黑德（英国）",
            cusCode: "1903",
            codeValue: "GBR123",
            gbName: "伯格黑德（英国）",
            gbCode: "GBR123",
            ciqCode: "826123"
        },
        {
            codeName: "本泰兰（英国）",
            cusCode: "303",
            codeValue: "GBR126",
            gbName: "本泰兰（英国）",
            gbCode: "GBR126",
            ciqCode: "826126"
        },
        {
            codeName: "卡那封（英国）",
            cusCode: "1904",
            codeValue: "GBR129",
            gbName: "卡那封（英国）",
            gbCode: "GBR129",
            ciqCode: "826129"
        },
        {
            codeName: "坎贝尔敦（英国）",
            cusCode: "1906",
            codeValue: "GBR132",
            gbName: "坎贝尔敦（英国）",
            gbCode: "GBR132",
            ciqCode: "826132"
        },
        {
            codeName: "加的夫（英国）",
            cusCode: "1907",
            codeValue: "GBR135",
            gbName: "加的夫（英国）",
            gbCode: "GBR135",
            ciqCode: "826135"
        },
        {
            codeName: "卡里克弗格斯（英国）",
            cusCode: "1909",
            codeValue: "GBR138",
            gbName: "卡里克弗格斯（英国）",
            gbCode: "GBR138",
            ciqCode: "826138"
        },
        {
            codeName: "卡斯尔敦（英国）",
            cusCode: "303",
            codeValue: "GBR141",
            gbName: "卡斯尔敦（英国）",
            gbCode: "GBR141",
            ciqCode: "826141"
        },
        {
            codeName: "查尔斯敦（Corn.）（英国）",
            cusCode: "1910",
            codeValue: "GBR144",
            gbName: "查尔斯敦（Corn.）（英国）",
            gbCode: "GBR144",
            ciqCode: "826144"
        },
        {
            codeName: "查尔斯敦（Fife）（英国）",
            cusCode: "303",
            codeValue: "GBR147",
            gbName: "查尔斯敦（Fife）（英国）",
            gbCode: "GBR147",
            ciqCode: "826147"
        },
        {
            codeName: "科尔切斯特（英国）",
            cusCode: "1912",
            codeValue: "GBR150",
            gbName: "科尔切斯特（英国）",
            gbCode: "GBR150",
            ciqCode: "826150"
        },
        {
            codeName: "科尔雷恩（英国）",
            cusCode: "303",
            codeValue: "GBR153",
            gbName: "科尔雷恩（英国）",
            gbCode: "GBR153",
            ciqCode: "826153"
        },
        {
            codeName: "康纳斯基（英国）",
            cusCode: "1913",
            codeValue: "GBR156",
            gbName: "康纳斯基（英国）",
            gbCode: "GBR156",
            ciqCode: "826156"
        },
        {
            codeName: "科珀赫（英国）",
            cusCode: "303",
            codeValue: "GBR159",
            gbName: "科珀赫（英国）",
            gbCode: "GBR159",
            ciqCode: "826159"
        },
        {
            codeName: "考斯（英国）",
            cusCode: "1915",
            codeValue: "GBR162",
            gbName: "考斯（英国）",
            gbCode: "GBR162",
            ciqCode: "826162"
        },
        {
            codeName: "克罗默蒂（英国）",
            cusCode: "303",
            codeValue: "GBR165",
            gbName: "克罗默蒂（英国）",
            gbCode: "GBR165",
            ciqCode: "826165"
        },
        {
            codeName: "达特茅斯（英国）",
            cusCode: "1919",
            codeValue: "GBR168",
            gbName: "达特茅斯（英国）",
            gbCode: "GBR168",
            ciqCode: "826168"
        },
        {
            codeName: "丁沃尔（英国）",
            cusCode: "303",
            codeValue: "GBR171",
            gbName: "丁沃尔（英国）",
            gbCode: "GBR171",
            ciqCode: "826171"
        },
        {
            codeName: "道格拉斯（英国）",
            cusCode: "1922",
            codeValue: "GBR174",
            gbName: "道格拉斯（英国）",
            gbCode: "GBR174",
            ciqCode: "826174"
        },
        {
            codeName: "克莱德港（英国）",
            cusCode: "1911",
            codeValue: "GBR176",
            gbName: "克莱德港（英国）",
            gbCode: "GBR176",
            ciqCode: "826176"
        },
        {
            codeName: "多佛尔（英国）",
            cusCode: "1921",
            codeValue: "GBR177",
            gbName: "多佛尔（英国）",
            gbCode: "GBR177",
            ciqCode: "826177"
        },
        {
            codeName: "邓弗里斯（英国）",
            cusCode: "1924",
            codeValue: "GBR180",
            gbName: "邓弗里斯（英国）",
            gbCode: "GBR180",
            ciqCode: "826180"
        },
        {
            codeName: "邓巴（英国）",
            cusCode: "1925",
            codeValue: "GBR183",
            gbName: "邓巴（英国）",
            gbCode: "GBR183",
            ciqCode: "826183"
        },
        {
            codeName: "邓迪（英国）",
            cusCode: "1926",
            codeValue: "GBR186",
            gbName: "邓迪（英国）",
            gbCode: "GBR186",
            ciqCode: "826186"
        },
        {
            codeName: "邓德拉姆（英国）",
            cusCode: "303",
            codeValue: "GBR189",
            gbName: "邓德拉姆（英国）",
            gbCode: "GBR189",
            ciqCode: "826189"
        },
        {
            codeName: "埃尔斯米尔港（英国）",
            cusCode: "303",
            codeValue: "GBR192",
            gbName: "埃尔斯米尔港（英国）",
            gbCode: "GBR192",
            ciqCode: "826192"
        },
        {
            codeName: "埃克塞特（英国）",
            cusCode: "1929",
            codeValue: "GBR195",
            gbName: "埃克塞特（英国）",
            gbCode: "GBR195",
            ciqCode: "826195"
        },
        {
            codeName: "埃克斯茅斯（英国）",
            cusCode: "1930",
            codeValue: "GBR198",
            gbName: "埃克斯茅斯（英国）",
            gbCode: "GBR198",
            ciqCode: "826198"
        },
        {
            codeName: "艾茅斯（英国）",
            cusCode: "1931",
            codeValue: "GBR201",
            gbName: "艾茅斯（英国）",
            gbCode: "GBR201",
            ciqCode: "826201"
        },
        {
            codeName: "法尔茅斯（英国）",
            cusCode: "1932",
            codeValue: "GBR204",
            gbName: "法尔茅斯（英国）",
            gbCode: "GBR204",
            ciqCode: "826204"
        },
        {
            codeName: "福利（英国）",
            cusCode: "303",
            codeValue: "GBR207",
            gbName: "福利（英国）",
            gbCode: "GBR207",
            ciqCode: "826207"
        },
        {
            codeName: "弗利克斯托（英国）",
            cusCode: "3419",
            codeValue: "GBR210",
            gbName: "弗利克斯托（英国）",
            gbCode: "GBR210",
            ciqCode: "826210"
        },
        {
            codeName: "芬纳特（英国）",
            cusCode: "1933",
            codeValue: "GBR213",
            gbName: "芬纳特（英国）",
            gbCode: "GBR213",
            ciqCode: "826213"
        },
        {
            codeName: "菲什加德（英国）",
            cusCode: "1934",
            codeValue: "GBR216",
            gbName: "菲什加德（英国）",
            gbCode: "GBR216",
            ciqCode: "826216"
        },
        {
            codeName: "弗利特伍德（英国）",
            cusCode: "303",
            codeValue: "GBR219",
            gbName: "弗利特伍德（英国）",
            gbCode: "GBR219",
            ciqCode: "826219"
        },
        {
            codeName: "福克斯通（英国）",
            cusCode: "303",
            codeValue: "GBR222",
            gbName: "福克斯通（英国）",
            gbCode: "GBR222",
            ciqCode: "826222"
        },
        {
            codeName: "福伊（英国）",
            cusCode: "303",
            codeValue: "GBR225",
            gbName: "福伊（英国）",
            gbCode: "GBR225",
            ciqCode: "826225"
        },
        {
            codeName: "弗雷泽堡（英国）",
            cusCode: "303",
            codeValue: "GBR228",
            gbName: "弗雷泽堡（英国）",
            gbCode: "GBR228",
            ciqCode: "826228"
        },
        {
            codeName: "盖恩斯伯勒（英国）",
            cusCode: "303",
            codeValue: "GBR231",
            gbName: "盖恩斯伯勒（英国）",
            gbCode: "GBR231",
            ciqCode: "826231"
        },
        {
            codeName: "加利斯敦（英国）",
            cusCode: "303",
            codeValue: "GBR234",
            gbName: "加利斯敦（英国）",
            gbCode: "GBR234",
            ciqCode: "826234"
        },
        {
            codeName: "加斯顿（英国）",
            cusCode: "303",
            codeValue: "GBR237",
            gbName: "加斯顿（英国）",
            gbCode: "GBR237",
            ciqCode: "826237"
        },
        {
            codeName: "格文（英国）",
            cusCode: "303",
            codeValue: "GBR240",
            gbName: "格文（英国）",
            gbCode: "GBR240",
            ciqCode: "826240"
        },
        {
            codeName: "格拉斯哥（英国）",
            cusCode: "1937",
            codeValue: "GBR243",
            gbName: "格拉斯哥（英国）",
            gbCode: "GBR243",
            ciqCode: "826243"
        },
        {
            codeName: "格莱纳姆（英国）",
            cusCode: "303",
            codeValue: "GBR246",
            gbName: "格莱纳姆（英国）",
            gbCode: "GBR246",
            ciqCode: "826246"
        },
        {
            codeName: "格洛斯特（英国）",
            cusCode: "303",
            codeValue: "GBR249",
            gbName: "格洛斯特（英国）",
            gbCode: "GBR249",
            ciqCode: "826249"
        },
        {
            codeName: "古尔（英国）",
            cusCode: "303",
            codeValue: "GBR252",
            gbName: "古尔（英国）",
            gbCode: "GBR252",
            ciqCode: "826252"
        },
        {
            codeName: "古罗克（英国）",
            cusCode: "303",
            codeValue: "GBR255",
            gbName: "古罗克（英国）",
            gbCode: "GBR255",
            ciqCode: "826255"
        },
        {
            codeName: "格兰奇茅斯（英国）",
            cusCode: "303",
            codeValue: "GBR258",
            gbName: "格兰奇茅斯（英国）",
            gbCode: "GBR258",
            ciqCode: "826258"
        },
        {
            codeName: "格雷夫森德（英国）",
            cusCode: "303",
            codeValue: "GBR261",
            gbName: "格雷夫森德（英国）",
            gbCode: "GBR261",
            ciqCode: "826261"
        },
        {
            codeName: "大雅茅斯（英国）",
            cusCode: "1938",
            codeValue: "GBR264",
            gbName: "大雅茅斯（英国）",
            gbCode: "GBR264",
            ciqCode: "826264"
        },
        {
            codeName: "格里诺克（英国）",
            cusCode: "1939",
            codeValue: "GBR267",
            gbName: "格里诺克（英国）",
            gbCode: "GBR267",
            ciqCode: "826267"
        },
        {
            codeName: "格里姆斯比（英国）",
            cusCode: "303",
            codeValue: "GBR270",
            gbName: "格里姆斯比（英国）",
            gbCode: "GBR270",
            ciqCode: "826270"
        },
        {
            codeName: "冈纳斯（英国）",
            cusCode: "303",
            codeValue: "GBR273",
            gbName: "冈纳斯（英国）",
            gbCode: "GBR273",
            ciqCode: "826273"
        },
        {
            codeName: "哈特尔浦（英国）",
            cusCode: "1940",
            codeValue: "GBR276",
            gbName: "哈特尔浦（英国）",
            gbCode: "GBR276",
            ciqCode: "826276"
        },
        {
            codeName: "哈里奇（英国）",
            cusCode: "1941",
            codeValue: "GBR279",
            gbName: "哈里奇（英国）",
            gbCode: "GBR279",
            ciqCode: "826279"
        },
        {
            codeName: "海尔（英国）",
            cusCode: "1942",
            codeValue: "GBR282",
            gbName: "海尔（英国）",
            gbCode: "GBR282",
            ciqCode: "826282"
        },
        {
            codeName: "希舍姆（英国）",
            cusCode: "1943",
            codeValue: "GBR285",
            gbName: "希舍姆（英国）",
            gbCode: "GBR285",
            ciqCode: "826285"
        },
        {
            codeName: "霍利黑德（英国）",
            cusCode: "1944",
            codeValue: "GBR288",
            gbName: "霍利黑德（英国）",
            gbCode: "GBR288",
            ciqCode: "826288"
        },
        {
            codeName: "霍德角（英国）",
            cusCode: "303",
            codeValue: "GBR291",
            gbName: "霍德角（英国）",
            gbCode: "GBR291",
            ciqCode: "826291"
        },
        {
            codeName: "赫尔（英国）",
            cusCode: "1945",
            codeValue: "GBR294",
            gbName: "赫尔（英国）",
            gbCode: "GBR294",
            ciqCode: "826294"
        },
        {
            codeName: "亨特斯顿（英国）",
            cusCode: "303",
            codeValue: "GBR297",
            gbName: "亨特斯顿（英国）",
            gbCode: "GBR297",
            ciqCode: "826297"
        },
        {
            codeName: "伊明赫姆（英国）",
            cusCode: "1947",
            codeValue: "GBR300",
            gbName: "伊明赫姆（英国）",
            gbCode: "GBR300",
            ciqCode: "826300"
        },
        {
            codeName: "因弗戈登（英国）",
            cusCode: "1948",
            codeValue: "GBR303",
            gbName: "因弗戈登（英国）",
            gbCode: "GBR303",
            ciqCode: "826303"
        },
        {
            codeName: "因弗内斯（英国）",
            cusCode: "1949",
            codeValue: "GBR306",
            gbName: "因弗内斯（英国）",
            gbCode: "GBR306",
            ciqCode: "826306"
        },
        {
            codeName: "伊普斯威奇（英国）",
            cusCode: "1950",
            codeValue: "GBR309",
            gbName: "伊普斯威奇（英国）",
            gbCode: "GBR309",
            ciqCode: "826309"
        },
        {
            codeName: "欧文（英国）",
            cusCode: "1951",
            codeValue: "GBR312",
            gbName: "欧文（英国）",
            gbCode: "GBR312",
            ciqCode: "826312"
        },
        {
            codeName: "谷岛（英国）",
            cusCode: "1952",
            codeValue: "GBR315",
            gbName: "谷岛（英国）",
            gbCode: "GBR315",
            ciqCode: "826315"
        },
        {
            codeName: "基尔基尔（英国）",
            cusCode: "1957",
            codeValue: "GBR318",
            gbName: "基尔基尔（英国）",
            gbCode: "GBR318",
            ciqCode: "826318"
        },
        {
            codeName: "基林霍尔姆（英国）",
            cusCode: "303",
            codeValue: "GBR321",
            gbName: "基林霍尔姆（英国）",
            gbCode: "GBR321",
            ciqCode: "826321"
        },
        {
            codeName: "金斯林（英国）",
            cusCode: "1958",
            codeValue: "GBR324",
            gbName: "金斯林（英国）",
            gbCode: "GBR324",
            ciqCode: "826324"
        },
        {
            codeName: "柯科迪（英国）",
            cusCode: "303",
            codeValue: "GBR327",
            gbName: "柯科迪（英国）",
            gbCode: "GBR327",
            ciqCode: "826327"
        },
        {
            codeName: "柯克沃尔（英国）",
            cusCode: "1960",
            codeValue: "GBR330",
            gbName: "柯克沃尔（英国）",
            gbCode: "GBR330",
            ciqCode: "826330"
        },
        {
            codeName: "洛哈尔什教区凯尔（英国）",
            cusCode: "1961",
            codeValue: "GBR333",
            gbName: "洛哈尔什教区凯尔（英国）",
            gbCode: "GBR333",
            ciqCode: "826333"
        },
        {
            codeName: "朗姆（英国）",
            cusCode: "303",
            codeValue: "GBR336",
            gbName: "朗姆（英国）",
            gbCode: "GBR336",
            ciqCode: "826336"
        },
        {
            codeName: "兰开斯特（英国）",
            cusCode: "1963",
            codeValue: "GBR339",
            gbName: "兰开斯特（英国）",
            gbCode: "GBR339",
            ciqCode: "826339"
        },
        {
            codeName: "拉格斯（英国）",
            cusCode: "1964",
            codeValue: "GBR342",
            gbName: "拉格斯（英国）",
            gbCode: "GBR342",
            ciqCode: "826342"
        },
        {
            codeName: "拉恩（英国）",
            cusCode: "1965",
            codeValue: "GBR345",
            gbName: "拉恩（英国）",
            gbCode: "GBR345",
            ciqCode: "826345"
        },
        {
            codeName: "利斯（英国）",
            cusCode: "1968",
            codeValue: "GBR348",
            gbName: "利斯（英国）",
            gbCode: "GBR348",
            ciqCode: "826348"
        },
        {
            codeName: "勒威克（英国）",
            cusCode: "1969",
            codeValue: "GBR351",
            gbName: "勒威克（英国）",
            gbCode: "GBR351",
            ciqCode: "826351"
        },
        {
            codeName: "利特尔汉普顿（英国）",
            cusCode: "1970",
            codeValue: "GBR354",
            gbName: "利特尔汉普顿（英国）",
            gbCode: "GBR354",
            ciqCode: "826354"
        },
        {
            codeName: "利物浦（英国）",
            cusCode: "1966",
            codeValue: "GBR357",
            gbName: "利物浦（英国）",
            gbCode: "GBR357",
            ciqCode: "826357"
        },
        {
            codeName: "兰杜拉斯（英国）",
            cusCode: "303",
            codeValue: "GBR360",
            gbName: "兰杜拉斯（英国）",
            gbCode: "GBR360",
            ciqCode: "826360"
        },
        {
            codeName: "拉内利（英国）",
            cusCode: "303",
            codeValue: "GBR363",
            gbName: "拉内利（英国）",
            gbCode: "GBR363",
            ciqCode: "826363"
        },
        {
            codeName: "洛赫博伊斯代尔（英国）",
            cusCode: "1972",
            codeValue: "GBR366",
            gbName: "洛赫博伊斯代尔（英国）",
            gbCode: "GBR366",
            ciqCode: "826366"
        },
        {
            codeName: "洛赫马迪（英国）",
            cusCode: "1973",
            codeValue: "GBR369",
            gbName: "洛赫马迪（英国）",
            gbCode: "GBR369",
            ciqCode: "826369"
        },
        {
            codeName: "洛哈林（英国）",
            cusCode: "1971",
            codeValue: "GBR372",
            gbName: "洛哈林（英国）",
            gbCode: "GBR372",
            ciqCode: "826372"
        },
        {
            codeName: "伦敦（英国）",
            cusCode: "1974",
            codeValue: "GBR375",
            gbName: "伦敦（英国）",
            gbCode: "GBR375",
            ciqCode: "826375"
        },
        {
            codeName: "伦敦德里（英国）",
            cusCode: "1975",
            codeValue: "GBR378",
            gbName: "伦敦德里（英国）",
            gbCode: "GBR378",
            ciqCode: "826378"
        },
        {
            codeName: "卢港（英国）",
            cusCode: "1976",
            codeValue: "GBR381",
            gbName: "卢港（英国）",
            gbCode: "GBR381",
            ciqCode: "826381"
        },
        {
            codeName: "洛西茅斯（英国）",
            cusCode: "1977",
            codeValue: "GBR384",
            gbName: "洛西茅斯（英国）",
            gbCode: "GBR384",
            ciqCode: "826384"
        },
        {
            codeName: "洛斯托夫特（英国）",
            cusCode: "1979",
            codeValue: "GBR387",
            gbName: "洛斯托夫特（英国）",
            gbCode: "GBR387",
            ciqCode: "826387"
        },
        {
            codeName: "利布斯特（英国）",
            cusCode: "1980",
            codeValue: "GBR390",
            gbName: "利布斯特（英国）",
            gbCode: "GBR390",
            ciqCode: "826390"
        },
        {
            codeName: "利德尼（英国）",
            cusCode: "1981",
            codeValue: "GBR393",
            gbName: "利德尼（英国）",
            gbCode: "GBR393",
            ciqCode: "826393"
        },
        {
            codeName: "麦克达夫（英国）",
            cusCode: "1983",
            codeValue: "GBR396",
            gbName: "麦克达夫（英国）",
            gbCode: "GBR396",
            ciqCode: "826396"
        },
        {
            codeName: "莫尔登（英国）",
            cusCode: "1984",
            codeValue: "GBR399",
            gbName: "莫尔登（英国）",
            gbCode: "GBR399",
            ciqCode: "826399"
        },
        {
            codeName: "马莱格（英国）",
            cusCode: "303",
            codeValue: "GBR402",
            gbName: "马莱格（英国）",
            gbCode: "GBR402",
            ciqCode: "826402"
        },
        {
            codeName: "曼彻斯特（英国）",
            cusCode: "1985",
            codeValue: "GBR405",
            gbName: "曼彻斯特（英国）",
            gbCode: "GBR405",
            ciqCode: "826405"
        },
        {
            codeName: "梅西尔（英国）",
            cusCode: "303",
            codeValue: "GBR408",
            gbName: "梅西尔（英国）",
            gbCode: "GBR408",
            ciqCode: "826408"
        },
        {
            codeName: "梅瓦吉西（英国）",
            cusCode: "1988",
            codeValue: "GBR411",
            gbName: "梅瓦吉西（英国）",
            gbCode: "GBR411",
            ciqCode: "826411"
        },
        {
            codeName: "米德尔斯伯勒（英国）",
            cusCode: "1989",
            codeValue: "GBR414",
            gbName: "米德尔斯伯勒（英国）",
            gbCode: "GBR414",
            ciqCode: "826414"
        },
        {
            codeName: "米勒姆（英国）",
            cusCode: "1991",
            codeValue: "GBR417",
            gbName: "米勒姆（英国）",
            gbCode: "GBR417",
            ciqCode: "826417"
        },
        {
            codeName: "迈恩黑德（英国）",
            cusCode: "1993",
            codeValue: "GBR420",
            gbName: "迈恩黑德（英国）",
            gbCode: "GBR420",
            ciqCode: "826420"
        },
        {
            codeName: "米斯特利（英国）",
            cusCode: "1994",
            codeValue: "GBR423",
            gbName: "米斯特利（英国）",
            gbCode: "GBR423",
            ciqCode: "826423"
        },
        {
            codeName: "蒙特罗斯（英国）",
            cusCode: "1995",
            codeValue: "GBR426",
            gbName: "蒙特罗斯（英国）",
            gbCode: "GBR426",
            ciqCode: "826426"
        },
        {
            codeName: "莫斯廷（英国）",
            cusCode: "1996",
            codeValue: "GBR429",
            gbName: "莫斯廷（英国）",
            gbCode: "GBR429",
            ciqCode: "826429"
        },
        {
            codeName: "奈恩（英国）",
            cusCode: "1997",
            codeValue: "GBR432",
            gbName: "奈恩（英国）",
            gbCode: "GBR432",
            ciqCode: "826432"
        },
        {
            codeName: "尼思（英国）",
            cusCode: "1998",
            codeValue: "GBR435",
            gbName: "尼思（英国）",
            gbCode: "GBR435",
            ciqCode: "826435"
        },
        {
            codeName: "纽堡（英国）",
            cusCode: "1999",
            codeValue: "GBR438",
            gbName: "纽堡（英国）",
            gbCode: "GBR438",
            ciqCode: "826438"
        },
        {
            codeName: "米尔福德港（英国）",
            cusCode: "1990",
            codeValue: "GBR443",
            gbName: "米尔福德港（英国）",
            gbCode: "GBR443",
            ciqCode: "826443"
        },
        {
            codeName: "纽卡斯尔（英国）",
            cusCode: "2000",
            codeValue: "GBR444",
            gbName: "纽卡斯尔（英国）",
            gbCode: "GBR444",
            ciqCode: "826444"
        },
        {
            codeName: "纽黑文（英国）",
            cusCode: "2001",
            codeValue: "GBR447",
            gbName: "纽黑文（英国）",
            gbCode: "GBR447",
            ciqCode: "826447"
        },
        {
            codeName: "纽林（英国）",
            cusCode: "2002",
            codeValue: "GBR450",
            gbName: "纽林（英国）",
            gbCode: "GBR450",
            ciqCode: "826450"
        },
        {
            codeName: "纽波特（英国）",
            cusCode: "303",
            codeValue: "GBR453",
            gbName: "纽波特（英国）",
            gbCode: "GBR453",
            ciqCode: "826453"
        },
        {
            codeName: "纽里（英国）",
            cusCode: "2003",
            codeValue: "GBR459",
            gbName: "纽里（英国）",
            gbCode: "GBR459",
            ciqCode: "826459"
        },
        {
            codeName: "北森德兰（英国）",
            cusCode: "2005",
            codeValue: "GBR462",
            gbName: "北森德兰（英国）",
            gbCode: "GBR462",
            ciqCode: "826462"
        },
        {
            codeName: "诺里奇（英国）",
            cusCode: "2006",
            codeValue: "GBR465",
            gbName: "诺里奇（英国）",
            gbCode: "GBR465",
            ciqCode: "826465"
        },
        {
            codeName: "奥本（英国）",
            cusCode: "2008",
            codeValue: "GBR468",
            gbName: "奥本（英国）",
            gbCode: "GBR468",
            ciqCode: "826468"
        },
        {
            codeName: "帕德斯托（英国）",
            cusCode: "2009",
            codeValue: "GBR471",
            gbName: "帕德斯托（英国）",
            gbCode: "GBR471",
            ciqCode: "826471"
        },
        {
            codeName: "帕尔纳基（英国）",
            cusCode: "2010",
            codeValue: "GBR474",
            gbName: "帕尔纳基（英国）",
            gbCode: "GBR474",
            ciqCode: "826474"
        },
        {
            codeName: "帕（英国）",
            cusCode: "2011",
            codeValue: "GBR477",
            gbName: "帕（英国）",
            gbCode: "GBR477",
            ciqCode: "826477"
        },
        {
            codeName: "帕克斯顿瓜伊（英国）",
            cusCode: "303",
            codeValue: "GBR480",
            gbName: "帕克斯顿瓜伊（英国）",
            gbCode: "GBR480",
            ciqCode: "826480"
        },
        {
            codeName: "帕廷顿（英国）",
            cusCode: "303",
            codeValue: "GBR483",
            gbName: "帕廷顿（英国）",
            gbCode: "GBR483",
            ciqCode: "826483"
        },
        {
            codeName: "皮尔（英国）",
            cusCode: "303",
            codeValue: "GBR486",
            gbName: "皮尔（英国）",
            gbCode: "GBR486",
            ciqCode: "826486"
        },
        {
            codeName: "彭布罗克（英国）",
            cusCode: "303",
            codeValue: "GBR489",
            gbName: "彭布罗克（英国）",
            gbCode: "GBR489",
            ciqCode: "826489"
        },
        {
            codeName: "彭迈恩毛尔（英国）",
            cusCode: "2014",
            codeValue: "GBR492",
            gbName: "彭迈恩毛尔（英国）",
            gbCode: "GBR492",
            ciqCode: "826492"
        },
        {
            codeName: "彭林（英国）",
            cusCode: "2015",
            codeValue: "GBR495",
            gbName: "彭林（英国）",
            gbCode: "GBR495",
            ciqCode: "826495"
        },
        {
            codeName: "彭赞斯（英国）",
            cusCode: "2016",
            codeValue: "GBR498",
            gbName: "彭赞斯（英国）",
            gbCode: "GBR498",
            ciqCode: "826498"
        },
        {
            codeName: "珀斯（英国）",
            cusCode: "303",
            codeValue: "GBR501",
            gbName: "珀斯（英国）",
            gbCode: "GBR501",
            ciqCode: "826501"
        },
        {
            codeName: "彼得黑德（英国）",
            cusCode: "2017",
            codeValue: "GBR504",
            gbName: "彼得黑德（英国）",
            gbCode: "GBR504",
            ciqCode: "826504"
        },
        {
            codeName: "普利茅斯（英国）",
            cusCode: "2019",
            codeValue: "GBR507",
            gbName: "普利茅斯（英国）",
            gbCode: "GBR507",
            ciqCode: "826507"
        },
        {
            codeName: "普尔（英国）",
            cusCode: "2020",
            codeValue: "GBR510",
            gbName: "普尔（英国）",
            gbCode: "GBR510",
            ciqCode: "826510"
        },
        {
            codeName: "波塔斯凯格（英国）",
            cusCode: "303",
            codeValue: "GBR513",
            gbName: "波塔斯凯格（英国）",
            gbCode: "GBR513",
            ciqCode: "826513"
        },
        {
            codeName: "埃伦港（英国）",
            cusCode: "2022",
            codeValue: "GBR516",
            gbName: "埃伦港（英国）",
            gbCode: "GBR516",
            ciqCode: "826516"
        },
        {
            codeName: "圣马里港（英国）",
            cusCode: "303",
            codeValue: "GBR519",
            gbName: "圣马里港（英国）",
            gbCode: "GBR519",
            ciqCode: "826519"
        },
        {
            codeName: "塔尔伯特港（英国）",
            cusCode: "2025",
            codeValue: "GBR522",
            gbName: "塔尔伯特港（英国）",
            gbCode: "GBR522",
            ciqCode: "826522"
        },
        {
            codeName: "威廉港（英国）",
            cusCode: "1935",
            codeValue: "GBR525",
            gbName: "威廉港（英国）",
            gbCode: "GBR525",
            ciqCode: "826525"
        },
        {
            codeName: "波尔特布里（英国）",
            cusCode: "303",
            codeValue: "GBR528",
            gbName: "波尔特布里（英国）",
            gbCode: "GBR528",
            ciqCode: "826528"
        },
        {
            codeName: "波特马多克（英国）",
            cusCode: "2029",
            codeValue: "GBR531",
            gbName: "波特马多克（英国）",
            gbCode: "GBR531",
            ciqCode: "826531"
        },
        {
            codeName: "波蒂斯黑德（英国）",
            cusCode: "2027",
            codeValue: "GBR534",
            gbName: "波蒂斯黑德（英国）",
            gbCode: "GBR534",
            ciqCode: "826534"
        },
        {
            codeName: "波特兰角（英国）",
            cusCode: "303",
            codeValue: "GBR537",
            gbName: "波特兰角（英国）",
            gbCode: "GBR537",
            ciqCode: "826537"
        },
        {
            codeName: "波特兰（英国）",
            cusCode: "303",
            codeValue: "GBR540",
            gbName: "波特兰（英国）",
            gbCode: "GBR540",
            ciqCode: "826540"
        },
        {
            codeName: "波特里（英国）",
            cusCode: "2030",
            codeValue: "GBR543",
            gbName: "波特里（英国）",
            gbCode: "GBR543",
            ciqCode: "826543"
        },
        {
            codeName: "波特拉什（英国）",
            cusCode: "2031",
            codeValue: "GBR546",
            gbName: "波特拉什（英国）",
            gbCode: "GBR546",
            ciqCode: "826546"
        },
        {
            codeName: "朴次茅斯（英国）",
            cusCode: "303",
            codeValue: "GBR549",
            gbName: "朴次茅斯（英国）",
            gbCode: "GBR549",
            ciqCode: "826549"
        },
        {
            codeName: "普雷斯顿（英国）",
            cusCode: "2032",
            codeValue: "GBR552",
            gbName: "普雷斯顿（英国）",
            gbCode: "GBR552",
            ciqCode: "826552"
        },
        {
            codeName: "普尔黑利（英国）",
            cusCode: "303",
            codeValue: "GBR555",
            gbName: "普尔黑利（英国）",
            gbCode: "GBR555",
            ciqCode: "826555"
        },
        {
            codeName: "昆伯勒（英国）",
            cusCode: "2034",
            codeValue: "GBR558",
            gbName: "昆伯勒（英国）",
            gbCode: "GBR558",
            ciqCode: "826558"
        },
        {
            codeName: "昆斯费里（英国）",
            cusCode: "2035",
            codeValue: "GBR561",
            gbName: "昆斯费里（英国）",
            gbCode: "GBR561",
            ciqCode: "826561"
        },
        {
            codeName: "雷纳姆（英国）",
            cusCode: "303",
            codeValue: "GBR564",
            gbName: "雷纳姆（英国）",
            gbCode: "GBR564",
            ciqCode: "826564"
        },
        {
            codeName: "拉姆西（英国）",
            cusCode: "303",
            codeValue: "GBR567",
            gbName: "拉姆西（英国）",
            gbCode: "GBR567",
            ciqCode: "826567"
        },
        {
            codeName: "拉姆斯盖特（英国）",
            cusCode: "303",
            codeValue: "GBR570",
            gbName: "拉姆斯盖特（英国）",
            gbCode: "GBR570",
            ciqCode: "826570"
        },
        {
            codeName: "雷德卡（英国）",
            cusCode: "303",
            codeValue: "GBR573",
            gbName: "雷德卡（英国）",
            gbCode: "GBR573",
            ciqCode: "826573"
        },
        {
            codeName: "里尔（英国）",
            cusCode: "2036",
            codeValue: "GBR576",
            gbName: "里尔（英国）",
            gbCode: "GBR576",
            ciqCode: "826576"
        },
        {
            codeName: "里奇伯勒（英国）",
            cusCode: "303",
            codeValue: "GBR579",
            gbName: "里奇伯勒（英国）",
            gbCode: "GBR579",
            ciqCode: "826579"
        },
        {
            codeName: "利德哈姆多克（英国）",
            cusCode: "303",
            codeValue: "GBR582",
            gbName: "利德哈姆多克（英国）",
            gbCode: "GBR582",
            ciqCode: "826582"
        },
        {
            codeName: "罗切斯特（英国）",
            cusCode: "303",
            codeValue: "GBR585",
            gbName: "罗切斯特（英国）",
            gbCode: "GBR585",
            ciqCode: "826585"
        },
        {
            codeName: "罗赛斯（英国）",
            cusCode: "2037",
            codeValue: "GBR588",
            gbName: "罗赛斯（英国）",
            gbCode: "GBR588",
            ciqCode: "826588"
        },
        {
            codeName: "罗斯西（英国）",
            cusCode: "2038",
            codeValue: "GBR591",
            gbName: "罗斯西（英国）",
            gbCode: "GBR591",
            ciqCode: "826591"
        },
        {
            codeName: "朗科恩（英国）",
            cusCode: "2039",
            codeValue: "GBR594",
            gbName: "朗科恩（英国）",
            gbCode: "GBR594",
            ciqCode: "826594"
        },
        {
            codeName: "拉伊（英国）",
            cusCode: "2040",
            codeValue: "GBR597",
            gbName: "拉伊（英国）",
            gbCode: "GBR597",
            ciqCode: "826597"
        },
        {
            codeName: "桑迪（英国）",
            cusCode: "2042",
            codeValue: "GBR600",
            gbName: "桑迪（英国）",
            gbCode: "GBR600",
            ciqCode: "826600"
        },
        {
            codeName: "桑德威奇（英国）",
            cusCode: "2043",
            codeValue: "GBR603",
            gbName: "桑德威奇（英国）",
            gbCode: "GBR603",
            ciqCode: "826603"
        },
        {
            codeName: "桑德斯富特（英国）",
            cusCode: "2044",
            codeValue: "GBR606",
            gbName: "桑德斯富特（英国）",
            gbCode: "GBR606",
            ciqCode: "826606"
        },
        {
            codeName: "斯卡洛韦（英国）",
            cusCode: "2045",
            codeValue: "GBR609",
            gbName: "斯卡洛韦（英国）",
            gbCode: "GBR609",
            ciqCode: "826609"
        },
        {
            codeName: "斯卡帕夫洛（英国）",
            cusCode: "303",
            codeValue: "GBR612",
            gbName: "斯卡帕夫洛（英国）",
            gbCode: "GBR612",
            ciqCode: "826612"
        },
        {
            codeName: "斯卡伯勒（英国）",
            cusCode: "2046",
            codeValue: "GBR615",
            gbName: "斯卡伯勒（英国）",
            gbCode: "GBR615",
            ciqCode: "826615"
        },
        {
            codeName: "斯克拉布斯特（英国）",
            cusCode: "2048",
            codeValue: "GBR618",
            gbName: "斯克拉布斯特（英国）",
            gbCode: "GBR618",
            ciqCode: "826618"
        },
        {
            codeName: "锡厄姆（英国）",
            cusCode: "2049",
            codeValue: "GBR621",
            gbName: "锡厄姆（英国）",
            gbCode: "GBR621",
            ciqCode: "826621"
        },
        {
            codeName: "塞尔比（英国）",
            cusCode: "303",
            codeValue: "GBR624",
            gbName: "塞尔比（英国）",
            gbCode: "GBR624",
            ciqCode: "826624"
        },
        {
            codeName: "夏普内斯（英国）",
            cusCode: "2050",
            codeValue: "GBR627",
            gbName: "夏普内斯（英国）",
            gbCode: "GBR627",
            ciqCode: "826627"
        },
        {
            codeName: "希尔内斯（英国）",
            cusCode: "2051",
            codeValue: "GBR630",
            gbName: "希尔内斯（英国）",
            gbCode: "GBR630",
            ciqCode: "826630"
        },
        {
            codeName: "谢尔赫文（英国）",
            cusCode: "303",
            codeValue: "GBR633",
            gbName: "谢尔赫文（英国）",
            gbCode: "GBR633",
            ciqCode: "826633"
        },
        {
            codeName: "肖勒姆（英国）",
            cusCode: "2054",
            codeValue: "GBR636",
            gbName: "肖勒姆（英国）",
            gbCode: "GBR636",
            ciqCode: "826636"
        },
        {
            codeName: "南安普顿（英国）",
            cusCode: "2057",
            codeValue: "GBR639",
            gbName: "南安普顿（英国）",
            gbCode: "GBR639",
            ciqCode: "826639"
        },
        {
            codeName: "绍森德（英国）",
            cusCode: "2058",
            codeValue: "GBR642",
            gbName: "绍森德（英国）",
            gbCode: "GBR642",
            ciqCode: "826642"
        },
        {
            codeName: "圣赫利尔（英国）",
            cusCode: "2059",
            codeValue: "GBR645",
            gbName: "圣赫利尔（英国）",
            gbCode: "GBR645",
            ciqCode: "826645"
        },
        {
            codeName: "圣艾夫斯（英国）",
            cusCode: "2060",
            codeValue: "GBR648",
            gbName: "圣艾夫斯（英国）",
            gbCode: "GBR648",
            ciqCode: "826648"
        },
        {
            codeName: "圣马格丽茨贝（英国）",
            cusCode: "2061",
            codeValue: "GBR651",
            gbName: "圣马格丽茨贝（英国）",
            gbCode: "GBR651",
            ciqCode: "826651"
        },
        {
            codeName: "圣彼德港（英国）",
            cusCode: "2063",
            codeValue: "GBR654",
            gbName: "圣彼德港（英国）",
            gbCode: "GBR654",
            ciqCode: "826654"
        },
        {
            codeName: "斯坦洛（英国）",
            cusCode: "303",
            codeValue: "GBR657",
            gbName: "斯坦洛（英国）",
            gbCode: "GBR657",
            ciqCode: "826657"
        },
        {
            codeName: "斯托克顿（英国）",
            cusCode: "303",
            codeValue: "GBR660",
            gbName: "斯托克顿（英国）",
            gbCode: "GBR660",
            ciqCode: "826660"
        },
        {
            codeName: "斯通黑文（英国）",
            cusCode: "2064",
            codeValue: "GBR663",
            gbName: "斯通黑文（英国）",
            gbCode: "GBR663",
            ciqCode: "826663"
        },
        {
            codeName: "斯托诺韦（英国）",
            cusCode: "2065",
            codeValue: "GBR666",
            gbName: "斯托诺韦（英国）",
            gbCode: "GBR666",
            ciqCode: "826666"
        },
        {
            codeName: "斯特兰福德（英国）",
            cusCode: "2066",
            codeValue: "GBR669",
            gbName: "斯特兰福德（英国）",
            gbCode: "GBR669",
            ciqCode: "826669"
        },
        {
            codeName: "斯特兰拉尔（英国）",
            cusCode: "2067",
            codeValue: "GBR672",
            gbName: "斯特兰拉尔（英国）",
            gbCode: "GBR672",
            ciqCode: "826672"
        },
        {
            codeName: "斯特罗姆内斯（英国）",
            cusCode: "2068",
            codeValue: "GBR675",
            gbName: "斯特罗姆内斯（英国）",
            gbCode: "GBR675",
            ciqCode: "826675"
        },
        {
            codeName: "萨洛姆湾（英国）",
            cusCode: "303",
            codeValue: "GBR678",
            gbName: "萨洛姆湾（英国）",
            gbCode: "GBR678",
            ciqCode: "826678"
        },
        {
            codeName: "森德兰（英国）",
            cusCode: "2069",
            codeValue: "GBR681",
            gbName: "森德兰（英国）",
            gbCode: "GBR681",
            ciqCode: "826681"
        },
        {
            codeName: "萨顿布里奇（英国）",
            cusCode: "2070",
            codeValue: "GBR684",
            gbName: "萨顿布里奇（英国）",
            gbCode: "GBR684",
            ciqCode: "826684"
        },
        {
            codeName: "斯旺西（英国）",
            cusCode: "2071",
            codeValue: "GBR687",
            gbName: "斯旺西（英国）",
            gbCode: "GBR687",
            ciqCode: "826687"
        },
        {
            codeName: "塔伯特（英国）",
            cusCode: "2072",
            codeValue: "GBR690",
            gbName: "塔伯特（英国）",
            gbCode: "GBR690",
            ciqCode: "826690"
        },
        {
            codeName: "提斯港（英国）",
            cusCode: "303",
            codeValue: "GBR693",
            gbName: "提斯港（英国）",
            gbCode: "GBR693",
            ciqCode: "826693"
        },
        {
            codeName: "廷茅斯（英国）",
            cusCode: "2074",
            codeValue: "GBR696",
            gbName: "廷茅斯（英国）",
            gbCode: "GBR696",
            ciqCode: "826696"
        },
        {
            codeName: "滕比（英国）",
            cusCode: "2075",
            codeValue: "GBR699",
            gbName: "滕比（英国）",
            gbCode: "GBR699",
            ciqCode: "826699"
        },
        {
            codeName: "特奈特米纳尔（英国）",
            cusCode: "303",
            codeValue: "GBR702",
            gbName: "特奈特米纳尔（英国）",
            gbCode: "GBR702",
            ciqCode: "826702"
        },
        {
            codeName: "瑟索（英国）",
            cusCode: "2076",
            codeValue: "GBR705",
            gbName: "瑟索（英国）",
            gbCode: "GBR705",
            ciqCode: "826705"
        },
        {
            codeName: "蒂尔伯里（英国）",
            cusCode: "303",
            codeValue: "GBR708",
            gbName: "蒂尔伯里（英国）",
            gbCode: "GBR708",
            ciqCode: "826708"
        },
        {
            codeName: "托伯莫里（英国）",
            cusCode: "2077",
            codeValue: "GBR711",
            gbName: "托伯莫里（英国）",
            gbCode: "GBR711",
            ciqCode: "826711"
        },
        {
            codeName: "托普瑟姆（英国）",
            cusCode: "2078",
            codeValue: "GBR714",
            gbName: "托普瑟姆（英国）",
            gbCode: "GBR714",
            ciqCode: "826714"
        },
        {
            codeName: "托基（英国）",
            cusCode: "2079",
            codeValue: "GBR717",
            gbName: "托基（英国）",
            gbCode: "GBR717",
            ciqCode: "826717"
        },
        {
            codeName: "托特尼斯（英国）",
            cusCode: "303",
            codeValue: "GBR720",
            gbName: "托特尼斯（英国）",
            gbCode: "GBR720",
            ciqCode: "826720"
        },
        {
            codeName: "特伦（英国）",
            cusCode: "2080",
            codeValue: "GBR723",
            gbName: "特伦（英国）",
            gbCode: "GBR723",
            ciqCode: "826723"
        },
        {
            codeName: "特鲁罗（英国）",
            cusCode: "2081",
            codeValue: "GBR726",
            gbName: "特鲁罗（英国）",
            gbCode: "GBR726",
            ciqCode: "826726"
        },
        {
            codeName: "太恩港（英国）",
            cusCode: "2082",
            codeValue: "GBR729",
            gbName: "太恩港（英国）",
            gbCode: "GBR729",
            ciqCode: "826729"
        },
        {
            codeName: "阿勒浦（英国）",
            cusCode: "2083",
            codeValue: "GBR732",
            gbName: "阿勒浦（英国）",
            gbCode: "GBR732",
            ciqCode: "826732"
        },
        {
            codeName: "沃克沃思（英国）",
            cusCode: "2084",
            codeValue: "GBR735",
            gbName: "沃克沃思（英国）",
            gbCode: "GBR735",
            ciqCode: "826735"
        },
        {
            codeName: "沃伦波因特（英国）",
            cusCode: "2085",
            codeValue: "GBR738",
            gbName: "沃伦波因特（英国）",
            gbCode: "GBR738",
            ciqCode: "826738"
        },
        {
            codeName: "沃切特（英国）",
            cusCode: "2086",
            codeValue: "GBR741",
            gbName: "沃切特（英国）",
            gbCode: "GBR741",
            ciqCode: "826741"
        },
        {
            codeName: "韦尔斯（英国）",
            cusCode: "2087",
            codeValue: "GBR744",
            gbName: "韦尔斯（英国）",
            gbCode: "GBR744",
            ciqCode: "826744"
        },
        {
            codeName: "韦斯特雷（英国）",
            cusCode: "2091",
            codeValue: "GBR747",
            gbName: "韦斯特雷（英国）",
            gbCode: "GBR747",
            ciqCode: "826747"
        },
        {
            codeName: "韦茅斯（英国）",
            cusCode: "303",
            codeValue: "GBR750",
            gbName: "韦茅斯（英国）",
            gbCode: "GBR750",
            ciqCode: "826750"
        },
        {
            codeName: "惠特比（英国）",
            cusCode: "2092",
            codeValue: "GBR753",
            gbName: "惠特比（英国）",
            gbCode: "GBR753",
            ciqCode: "826753"
        },
        {
            codeName: "怀特黑文（英国）",
            cusCode: "2094",
            codeValue: "GBR756",
            gbName: "怀特黑文（英国）",
            gbCode: "GBR756",
            ciqCode: "826756"
        },
        {
            codeName: "惠特斯特布尔（英国）",
            cusCode: "2095",
            codeValue: "GBR759",
            gbName: "惠特斯特布尔（英国）",
            gbCode: "GBR759",
            ciqCode: "826759"
        },
        {
            codeName: "威克（英国）",
            cusCode: "2096",
            codeValue: "GBR762",
            gbName: "威克（英国）",
            gbCode: "GBR762",
            ciqCode: "826762"
        },
        {
            codeName: "威斯贝奇（英国）",
            cusCode: "2097",
            codeValue: "GBR765",
            gbName: "威斯贝奇（英国）",
            gbCode: "GBR765",
            ciqCode: "826765"
        },
        {
            codeName: "沃金顿（英国）",
            cusCode: "2099",
            codeValue: "GBR768",
            gbName: "沃金顿（英国）",
            gbCode: "GBR768",
            ciqCode: "826768"
        },
        {
            codeName: "雅茅斯（英国）",
            cusCode: "303",
            codeValue: "GBR771",
            gbName: "雅茅斯（英国）",
            gbCode: "GBR771",
            ciqCode: "826771"
        },
        {
            codeName: "泰晤士港（英国）",
            cusCode: "303",
            codeValue: "GBR901",
            gbName: "泰晤士港（英国）",
            gbCode: "GBR901",
            ciqCode: "826901"
        },
        {
            codeName: "利兹（英国）",
            cusCode: "303",
            codeValue: "GBR902",
            gbName: "利兹（英国）",
            gbCode: "GBR902",
            ciqCode: "826902"
        },
        {
            codeName: "AMNLE（英国）",
            cusCode: "1865",
            codeValue: "GBR903",
            gbName: "AMNLE（英国）",
            gbCode: "GBR903",
            ciqCode: "826903"
        },
        {
            codeName: "BALFAST（英国）",
            cusCode: "1877",
            codeValue: "GBR904",
            gbName: "BALFAST（英国）",
            gbCode: "GBR904",
            ciqCode: "826904"
        },
        {
            codeName: "BATSKARSNAS（英国）",
            cusCode: "1882",
            codeValue: "GBR905",
            gbName: "BATSKARSNAS（英国）",
            gbCode: "GBR905",
            ciqCode: "826905"
        },
        {
            codeName: "BRRAY DOCKS（英国）",
            cusCode: "1900",
            codeValue: "GBR906",
            gbName: "BRRAY DOCKS（英国）",
            gbCode: "GBR906",
            ciqCode: "826906"
        },
        {
            codeName: "EDINBURGH（英国）",
            cusCode: "1928",
            codeValue: "GBR907",
            gbName: "EDINBURGH（英国）",
            gbCode: "GBR907",
            ciqCode: "826907"
        },
        {
            codeName: "PORTKNOCKIE（英国）",
            cusCode: "2028",
            codeValue: "GBR908",
            gbName: "PORTKNOCKIE（英国）",
            gbCode: "GBR908",
            ciqCode: "826908"
        },
        {
            codeName: "PURFLEET（英国）",
            cusCode: "2033",
            codeValue: "GBR909",
            gbName: "PURFLEET（英国）",
            gbCode: "GBR909",
            ciqCode: "826909"
        },
        {
            codeName: "阿尔赫西拉斯（英国）",
            cusCode: "1863",
            codeValue: "GBR910",
            gbName: "阿尔赫西拉斯（英国）",
            gbCode: "GBR910",
            ciqCode: "826910"
        },
        {
            codeName: "阿斯凯格皮尔港（英国）",
            cusCode: "2021",
            codeValue: "GBR911",
            gbName: "阿斯凯格皮尔港（英国）",
            gbCode: "GBR911",
            ciqCode: "826911"
        },
        {
            codeName: "艾泽耳沃思（英国）",
            cusCode: "1954",
            codeValue: "GBR912",
            gbName: "艾泽耳沃思（英国）",
            gbCode: "GBR912",
            ciqCode: "826912"
        },
        {
            codeName: "安德顿德波（英国）",
            cusCode: "1866",
            codeValue: "GBR913",
            gbName: "安德顿德波（英国）",
            gbCode: "GBR913",
            ciqCode: "826913"
        },
        {
            codeName: "巴金（英国）",
            cusCode: "1878",
            codeValue: "GBR914",
            gbName: "巴金（英国）",
            gbCode: "GBR914",
            ciqCode: "826914"
        },
        {
            codeName: "贝尔波特（英国）",
            cusCode: "1884",
            codeValue: "GBR915",
            gbName: "贝尔波特（英国）",
            gbCode: "GBR915",
            ciqCode: "826915"
        },
        {
            codeName: "波里莱文（英国）",
            cusCode: "2026",
            codeValue: "GBR916",
            gbName: "波里莱文（英国）",
            gbCode: "GBR916",
            ciqCode: "826916"
        },
        {
            codeName: "博林（英国）",
            cusCode: "1892",
            codeValue: "GBR917",
            gbName: "博林（英国）",
            gbCode: "GBR917",
            ciqCode: "826917"
        },
        {
            codeName: "伯明翰（英国）",
            cusCode: "1889",
            codeValue: "GBR919",
            gbName: "伯明翰（英国）",
            gbCode: "GBR919",
            ciqCode: "826919"
        },
        {
            codeName: "布德（英国）",
            cusCode: "1902",
            codeValue: "GBR920",
            gbName: "布德（英国）",
            gbCode: "GBR920",
            ciqCode: "826920"
        },
        {
            codeName: "达农（英国）",
            cusCode: "1927",
            codeValue: "GBR921",
            gbName: "达农（英国）",
            gbCode: "GBR921",
            ciqCode: "826921"
        },
        {
            codeName: "戴根纳姆（英国）",
            cusCode: "1918",
            codeValue: "GBR922",
            gbName: "戴根纳姆（英国）",
            gbCode: "GBR922",
            ciqCode: "826922"
        },
        {
            codeName: "当斯（英国）",
            cusCode: "1923",
            codeValue: "GBR923",
            gbName: "当斯（英国）",
            gbCode: "GBR923",
            ciqCode: "826923"
        },
        {
            codeName: "迪甘韦港（英国）",
            cusCode: "1920",
            codeValue: "GBR924",
            gbName: "迪甘韦港（英国）",
            gbCode: "GBR924",
            ciqCode: "826924"
        },
        {
            codeName: "福恩港（英国）",
            cusCode: "1936",
            codeValue: "GBR925",
            gbName: "福恩港（英国）",
            gbCode: "GBR925",
            ciqCode: "826925"
        },
        {
            codeName: "福思港（英国）",
            cusCode: "1959",
            codeValue: "GBR926",
            gbName: "福思港（英国）",
            gbCode: "GBR926",
            ciqCode: "826926"
        },
        {
            codeName: "怀特霍耳（英国）",
            cusCode: "2093",
            codeValue: "GBR927",
            gbName: "怀特霍耳（英国）",
            gbCode: "GBR927",
            ciqCode: "826927"
        },
        {
            codeName: "喀利多尼亚运河（英国）",
            cusCode: "1905",
            codeValue: "GBR928",
            gbName: "喀利多尼亚运河（英国）",
            gbCode: "GBR928",
            ciqCode: "826928"
        },
        {
            codeName: "卡恩拉夫（英国）",
            cusCode: "1908",
            codeValue: "GBR929",
            gbName: "卡恩拉夫（英国）",
            gbCode: "GBR929",
            ciqCode: "826929"
        },
        {
            codeName: "科尔帕奇-喀里多尼亚（英国）",
            cusCode: "1914",
            codeValue: "GBR930",
            gbName: "科尔帕奇-喀里多尼亚（英国）",
            gbCode: "GBR930",
            ciqCode: "826930"
        },
        {
            codeName: "克赖根多兰（英国）",
            cusCode: "1916",
            codeValue: "GBR931",
            gbName: "克赖根多兰（英国）",
            gbCode: "GBR931",
            ciqCode: "826931"
        },
        {
            codeName: "克里南运河（英国）",
            cusCode: "1917",
            codeValue: "GBR932",
            gbName: "克里南运河（英国）",
            gbCode: "GBR932",
            ciqCode: "826932"
        },
        {
            codeName: "洛桑（英国）",
            cusCode: "1967",
            codeValue: "GBR933",
            gbName: "洛桑（英国）",
            gbCode: "GBR933",
            ciqCode: "826933"
        },
        {
            codeName: "诺丁汉（英国）",
            cusCode: "2007",
            codeValue: "GBR934",
            gbName: "诺丁汉（英国）",
            gbCode: "GBR934",
            ciqCode: "826934"
        },
        {
            codeName: "圣墨利厄尔（英国）",
            cusCode: "1956",
            codeValue: "GBR935",
            gbName: "圣墨利厄尔（英国）",
            gbCode: "GBR935",
            ciqCode: "826935"
        },
        {
            codeName: "太国（英国）",
            cusCode: "2004",
            codeValue: "GBR936",
            gbName: "太国（英国）",
            gbCode: "GBR936",
            ciqCode: "826936"
        },
        {
            codeName: "特威德河畔伯里克（英国）",
            cusCode: "1886",
            codeValue: "GBR937",
            gbName: "特威德河畔伯里克（英国）",
            gbCode: "GBR937",
            ciqCode: "826937"
        },
        {
            codeName: "威姆斯贝（英国）",
            cusCode: "2088",
            codeValue: "GBR939",
            gbName: "威姆斯贝（英国）",
            gbCode: "GBR939",
            ciqCode: "826939"
        },
        {
            codeName: "韦斯顿波因特（英国）",
            cusCode: "2090",
            codeValue: "GBR940",
            gbName: "韦斯顿波因特（英国）",
            gbCode: "GBR940",
            ciqCode: "826940"
        },
        {
            codeName: "维文霍（英国）",
            cusCode: "2098",
            codeValue: "GBR941",
            gbName: "维文霍（英国）",
            gbCode: "GBR941",
            ciqCode: "826941"
        },
        {
            codeName: "锡利群岛（英国）",
            cusCode: "2047",
            codeValue: "GBR943",
            gbName: "锡利群岛（英国）",
            gbCode: "GBR943",
            ciqCode: "826943"
        },
        {
            codeName: "锡洛思（英国）",
            cusCode: "2055",
            codeValue: "GBR945",
            gbName: "锡洛思（英国）",
            gbCode: "GBR945",
            ciqCode: "826945"
        },
        {
            codeName: "伊夫腊库姆（英国）",
            cusCode: "1946",
            codeValue: "GBR946",
            gbName: "伊夫腊库姆（英国）",
            gbCode: "GBR946",
            ciqCode: "826946"
        },
        {
            codeName: "曼岛（英国）",
            cusCode: "1953",
            codeValue: "GBR947",
            gbName: "曼岛（英国）",
            gbCode: "GBR947",
            ciqCode: "826947"
        },
        {
            codeName: "格鲁吉亚",
            cusCode: "150",
            codeValue: "GEO000",
            gbName: "格鲁吉亚",
            gbCode: "GEO000",
            ciqCode: "268000"
        },
        {
            codeName: "巴统（格鲁吉亚）",
            cusCode: "2642",
            codeValue: "GEO003",
            gbName: "巴统（格鲁吉亚）",
            gbCode: "GEO003",
            ciqCode: "268003"
        },
        {
            codeName: "波季（格鲁吉亚）",
            cusCode: "150",
            codeValue: "GEO006",
            gbName: "波季（格鲁吉亚）",
            gbCode: "GEO006",
            ciqCode: "268006"
        },
        {
            codeName: "苏呼米（格鲁吉亚）",
            cusCode: "2667",
            codeValue: "GEO009",
            gbName: "苏呼米（格鲁吉亚）",
            gbCode: "GEO009",
            ciqCode: "268009"
        },
        {
            codeName: "格恩西",
            cusCode: "361",
            codeValue: "GGY000",
            gbName: "格恩西",
            gbCode: "GGY000",
            ciqCode: "831000"
        },
        {
            codeName: "加纳",
            cusCode: "220",
            codeValue: "GHA000",
            gbName: "加纳",
            gbCode: "GHA000",
            ciqCode: "288000"
        },
        {
            codeName: "阿克拉（加纳）",
            cusCode: "1640",
            codeValue: "GHA003",
            gbName: "阿克拉（加纳）",
            gbCode: "GHA003",
            ciqCode: "288003"
        },
        {
            codeName: "阿达（加纳）",
            cusCode: "1637",
            codeValue: "GHA006",
            gbName: "阿达（加纳）",
            gbCode: "GHA006",
            ciqCode: "288006"
        },
        {
            codeName: "阿克西姆（加纳）",
            cusCode: "220",
            codeValue: "GHA009",
            gbName: "阿克西姆（加纳）",
            gbCode: "GHA009",
            ciqCode: "288009"
        },
        {
            codeName: "海岸角（加纳）",
            cusCode: "1638",
            codeValue: "GHA012",
            gbName: "海岸角（加纳）",
            gbCode: "GHA012",
            ciqCode: "288012"
        },
        {
            codeName: "凯塔（加纳）",
            cusCode: "220",
            codeValue: "GHA015",
            gbName: "凯塔（加纳）",
            gbCode: "GHA015",
            ciqCode: "288015"
        },
        {
            codeName: "塞康第（加纳）",
            cusCode: "220",
            codeValue: "GHA018",
            gbName: "塞康第（加纳）",
            gbCode: "GHA018",
            ciqCode: "288018"
        },
        {
            codeName: "塔科拉迪（加纳）",
            cusCode: "1641",
            codeValue: "GHA021",
            gbName: "塔科拉迪（加纳）",
            gbCode: "GHA021",
            ciqCode: "288021"
        },
        {
            codeName: "特马（加纳）",
            cusCode: "1642",
            codeValue: "GHA024",
            gbName: "特马（加纳）",
            gbCode: "GHA024",
            ciqCode: "288024"
        },
        {
            codeName: "温尼巴（加纳）",
            cusCode: "1639",
            codeValue: "GHA027",
            gbName: "温尼巴（加纳）",
            gbCode: "GHA027",
            ciqCode: "288027"
        },
        {
            codeName: "直布罗陀",
            cusCode: "320",
            codeValue: "GIB000",
            gbName: "直布罗陀",
            gbCode: "GIB000",
            ciqCode: "292000"
        },
        {
            codeName: "直布罗陀（直布罗陀）",
            cusCode: "320",
            codeValue: "GIB003",
            gbName: "直布罗陀（直布罗陀）",
            gbCode: "GIB003",
            ciqCode: "292003"
        },
        {
            codeName: "几内亚",
            cusCode: "221",
            codeValue: "GIN000",
            gbName: "几内亚",
            gbCode: "GIN000",
            ciqCode: "324000"
        },
        {
            codeName: "科纳克里（几内亚）",
            cusCode: "1645",
            codeValue: "GIN003",
            gbName: "科纳克里（几内亚）",
            gbCode: "GIN003",
            ciqCode: "324003"
        },
        {
            codeName: "卡姆萨尔（几内亚）",
            cusCode: "221",
            codeValue: "GIN006",
            gbName: "卡姆萨尔（几内亚）",
            gbCode: "GIN006",
            ciqCode: "324006"
        },
        {
            codeName: "维多利亚（几内亚）",
            cusCode: "1646",
            codeValue: "GIN009",
            gbName: "维多利亚（几内亚）",
            gbCode: "GIN009",
            ciqCode: "324009"
        },
        {
            codeName: "本蒂（几内亚）",
            cusCode: "1643",
            codeValue: "GIN012",
            gbName: "本蒂（几内亚）",
            gbCode: "GIN012",
            ciqCode: "324012"
        },
        {
            codeName: "瓜德罗普",
            cusCode: "422",
            codeValue: "GLP000",
            gbName: "瓜德罗普",
            gbCode: "GLP000",
            ciqCode: "312000"
        },
        {
            codeName: "巴斯特尔（瓜德罗普）",
            cusCode: "2841",
            codeValue: "GLP003",
            gbName: "巴斯特尔（瓜德罗普）",
            gbCode: "GLP003",
            ciqCode: "312003"
        },
        {
            codeName: "皮特尔角城（瓜德罗普）",
            cusCode: "2842",
            codeValue: "GLP006",
            gbName: "皮特尔角城（瓜德罗普）",
            gbCode: "GLP006",
            ciqCode: "312006"
        },
        {
            codeName: "冈比亚",
            cusCode: "219",
            codeValue: "GMB000",
            gbName: "冈比亚",
            gbCode: "GMB000",
            ciqCode: "270000"
        },
        {
            codeName: "班珠尔（冈比亚）",
            cusCode: "1636",
            codeValue: "GMB003",
            gbName: "班珠尔（冈比亚）",
            gbCode: "GMB003",
            ciqCode: "270003"
        },
        {
            codeName: "几内亚比绍",
            cusCode: "222",
            codeValue: "GNB000",
            gbName: "几内亚比绍",
            gbCode: "GNB000",
            ciqCode: "624000"
        },
        {
            codeName: "比绍（几内亚比绍）",
            cusCode: "1647",
            codeValue: "GNB003",
            gbName: "比绍（几内亚比绍）",
            gbCode: "GNB003",
            ciqCode: "624003"
        },
        {
            codeName: "博拉多（几内亚比绍）",
            cusCode: "1648",
            codeValue: "GNB006",
            gbName: "博拉多（几内亚比绍）",
            gbCode: "GNB006",
            ciqCode: "624006"
        },
        {
            codeName: "布巴克（几内亚比绍）",
            cusCode: "1649",
            codeValue: "GNB009",
            gbName: "布巴克（几内亚比绍）",
            gbCode: "GNB009",
            ciqCode: "624009"
        },
        {
            codeName: "卡谢马（几内亚比绍）",
            cusCode: "1650",
            codeValue: "GNB012",
            gbName: "卡谢马（几内亚比绍）",
            gbCode: "GNB012",
            ciqCode: "624012"
        },
        {
            codeName: "赤道几内亚",
            cusCode: "216",
            codeValue: "GNQ000",
            gbName: "赤道几内亚",
            gbCode: "GNQ000",
            ciqCode: "226000"
        },
        {
            codeName: "巴塔（赤道几内亚）",
            cusCode: "216",
            codeValue: "GNQ003",
            gbName: "巴塔（赤道几内亚）",
            gbCode: "GNQ003",
            ciqCode: "226003"
        },
        {
            codeName: "布图库卢巴（赤道几内亚）",
            cusCode: "216",
            codeValue: "GNQ006",
            gbName: "布图库卢巴（赤道几内亚）",
            gbCode: "GNQ006",
            ciqCode: "226006"
        },
        {
            codeName: "圣卡尔洛斯（赤道几内亚）",
            cusCode: "1626",
            codeValue: "GNQ007",
            gbName: "圣卡尔洛斯（赤道几内亚）",
            gbCode: "GNQ007",
            ciqCode: "226007"
        },
        {
            codeName: "里奥白尼托（赤道几内亚）",
            cusCode: "1628",
            codeValue: "GNQ008",
            gbName: "里奥白尼托（赤道几内亚）",
            gbCode: "GNQ008",
            ciqCode: "226008"
        },
        {
            codeName: "马拉博（赤道几内亚）",
            cusCode: "216",
            codeValue: "GNQ009",
            gbName: "马拉博（赤道几内亚）",
            gbCode: "GNQ009",
            ciqCode: "226009"
        },
        {
            codeName: "圣伊萨贝尔（赤道几内亚）",
            cusCode: "1627",
            codeValue: "GNQ012",
            gbName: "圣伊萨贝尔（赤道几内亚）",
            gbCode: "GNQ012",
            ciqCode: "226012"
        },
        {
            codeName: "希腊",
            cusCode: "310",
            codeValue: "GRC000",
            gbName: "希腊",
            gbCode: "GRC000",
            ciqCode: "300000"
        },
        {
            codeName: "圣洛安尼斯（希腊）",
            cusCode: "310",
            codeValue: "GRC003",
            gbName: "圣洛安尼斯（希腊）",
            gbCode: "GRC003",
            ciqCode: "300003"
        },
        {
            codeName: "HERMUPOLIS（希腊）",
            cusCode: "2327",
            codeValue: "GRC004",
            gbName: "HERMUPOLIS（希腊）",
            gbCode: "GRC004",
            ciqCode: "300004"
        },
        {
            codeName: "LIXURI（希腊）",
            cusCode: "2339",
            codeValue: "GRC005",
            gbName: "LIXURI（希腊）",
            gbCode: "GRC005",
            ciqCode: "300005"
        },
        {
            codeName: "圣尼古拉奥斯（希腊）",
            cusCode: "310",
            codeValue: "GRC006",
            gbName: "圣尼古拉奥斯（希腊）",
            gbCode: "GRC006",
            ciqCode: "300006"
        },
        {
            codeName: "扎金索斯（希腊）",
            cusCode: "2352",
            codeValue: "GRC007",
            gbName: "扎金索斯（希腊）",
            gbCode: "GRC007",
            ciqCode: "300007"
        },
        {
            codeName: "圣塞多罗伊（希腊）",
            cusCode: "310",
            codeValue: "GRC009",
            gbName: "圣塞多罗伊（希腊）",
            gbCode: "GRC009",
            ciqCode: "300009"
        },
        {
            codeName: "亚历山德鲁波利斯（希腊）",
            cusCode: "310",
            codeValue: "GRC012",
            gbName: "亚历山德鲁波利斯（希腊）",
            gbCode: "GRC012",
            ciqCode: "300012"
        },
        {
            codeName: "阿尔戈斯托利（希腊）",
            cusCode: "310",
            codeValue: "GRC015",
            gbName: "阿尔戈斯托利（希腊）",
            gbCode: "GRC015",
            ciqCode: "300015"
        },
        {
            codeName: "阿斯普罗皮戈斯（希腊）",
            cusCode: "2323",
            codeValue: "GRC018",
            gbName: "阿斯普罗皮戈斯（希腊）",
            gbCode: "GRC018",
            ciqCode: "300018"
        },
        {
            codeName: "阿哥斯托利昂（希腊）",
            cusCode: "2322",
            codeValue: "GRC019",
            gbName: "阿哥斯托利昂（希腊）",
            gbCode: "GRC019",
            ciqCode: "300019"
        },
        {
            codeName: "阿斯塔科斯（希腊）",
            cusCode: "310",
            codeValue: "GRC021",
            gbName: "阿斯塔科斯（希腊）",
            gbCode: "GRC021",
            ciqCode: "300021"
        },
        {
            codeName: "阿伊阿特里阿斯（希腊）",
            cusCode: "2321",
            codeValue: "GRC022",
            gbName: "阿伊阿特里阿斯（希腊）",
            gbCode: "GRC022",
            ciqCode: "300022"
        },
        {
            codeName: "干尼亚（希腊）",
            cusCode: "2325",
            codeValue: "GRC024",
            gbName: "干尼亚（希腊）",
            gbCode: "GRC024",
            ciqCode: "300024"
        },
        {
            codeName: "哈尔基斯（希腊）",
            cusCode: "2320",
            codeValue: "GRC027",
            gbName: "哈尔基斯（希腊）",
            gbCode: "GRC027",
            ciqCode: "300027"
        },
        {
            codeName: "希俄斯（希腊）",
            cusCode: "310",
            codeValue: "GRC030",
            gbName: "希俄斯（希腊）",
            gbCode: "GRC030",
            ciqCode: "300030"
        },
        {
            codeName: "科孚（希腊）",
            cusCode: "310",
            codeValue: "GRC033",
            gbName: "科孚（希腊）",
            gbCode: "GRC033",
            ciqCode: "300033"
        },
        {
            codeName: "科林斯（希腊）",
            cusCode: "310",
            codeValue: "GRC036",
            gbName: "科林斯（希腊）",
            gbCode: "GRC036",
            ciqCode: "300036"
        },
        {
            codeName: "德拉佩特佐拉（希腊）",
            cusCode: "2326",
            codeValue: "GRC039",
            gbName: "德拉佩特佐拉（希腊）",
            gbCode: "GRC039",
            ciqCode: "300039"
        },
        {
            codeName: "代提（希腊）",
            cusCode: "2350",
            codeValue: "GRC040",
            gbName: "代提（希腊）",
            gbCode: "GRC040",
            ciqCode: "300040"
        },
        {
            codeName: "埃莱夫西斯（希腊）",
            cusCode: "310",
            codeValue: "GRC042",
            gbName: "埃莱夫西斯（希腊）",
            gbCode: "GRC042",
            ciqCode: "300042"
        },
        {
            codeName: "加夫里翁（希腊）",
            cusCode: "310",
            codeValue: "GRC045",
            gbName: "加夫里翁（希腊）",
            gbCode: "GRC045",
            ciqCode: "300045"
        },
        {
            codeName: "伊西翁（希腊）",
            cusCode: "310",
            codeValue: "GRC048",
            gbName: "伊西翁（希腊）",
            gbCode: "GRC048",
            ciqCode: "300048"
        },
        {
            codeName: "伊古迈尼察（希腊）",
            cusCode: "310",
            codeValue: "GRC051",
            gbName: "伊古迈尼察（希腊）",
            gbCode: "GRC051",
            ciqCode: "300051"
        },
        {
            codeName: "伊拉克利翁（希腊）",
            cusCode: "2328",
            codeValue: "GRC054",
            gbName: "伊拉克利翁（希腊）",
            gbCode: "GRC054",
            ciqCode: "300054"
        },
        {
            codeName: "伊斯米亚（希腊）",
            cusCode: "310",
            codeValue: "GRC057",
            gbName: "伊斯米亚（希腊）",
            gbCode: "GRC057",
            ciqCode: "300057"
        },
        {
            codeName: "伊泰阿（希腊）",
            cusCode: "310",
            codeValue: "GRC060",
            gbName: "伊泰阿（希腊）",
            gbCode: "GRC060",
            ciqCode: "300060"
        },
        {
            codeName: "伊萨基（希腊）",
            cusCode: "2329",
            codeValue: "GRC063",
            gbName: "伊萨基（希腊）",
            gbCode: "GRC063",
            ciqCode: "300063"
        },
        {
            codeName: "卡拉马基角（希腊）",
            cusCode: "2331",
            codeValue: "GRC066",
            gbName: "卡拉马基角（希腊）",
            gbCode: "GRC066",
            ciqCode: "300066"
        },
        {
            codeName: "卡拉迈（希腊）",
            cusCode: "2332",
            codeValue: "GRC069",
            gbName: "卡拉迈（希腊）",
            gbCode: "GRC069",
            ciqCode: "300069"
        },
        {
            codeName: "卡利利梅内斯（希腊）",
            cusCode: "2333",
            codeValue: "GRC072",
            gbName: "卡利利梅内斯（希腊）",
            gbCode: "GRC072",
            ciqCode: "300072"
        },
        {
            codeName: "卡利姆诺斯（希腊）",
            cusCode: "310",
            codeValue: "GRC075",
            gbName: "卡利姆诺斯（希腊）",
            gbCode: "GRC075",
            ciqCode: "300075"
        },
        {
            codeName: "卡梅纳基（希腊）",
            cusCode: "310",
            codeValue: "GRC078",
            gbName: "卡梅纳基（希腊）",
            gbCode: "GRC078",
            ciqCode: "300078"
        },
        {
            codeName: "卡塔科洛（希腊）",
            cusCode: "310",
            codeValue: "GRC081",
            gbName: "卡塔科洛（希腊）",
            gbCode: "GRC081",
            ciqCode: "300081"
        },
        {
            codeName: "卡瓦拉（希腊）",
            cusCode: "2319",
            codeValue: "GRC084",
            gbName: "卡瓦拉（希腊）",
            gbCode: "GRC084",
            ciqCode: "300084"
        },
        {
            codeName: "凯阿（希腊）",
            cusCode: "310",
            codeValue: "GRC087",
            gbName: "凯阿（希腊）",
            gbCode: "GRC087",
            ciqCode: "300087"
        },
        {
            codeName: "基亚托（希腊）",
            cusCode: "310",
            codeValue: "GRC090",
            gbName: "基亚托（希腊）",
            gbCode: "GRC090",
            ciqCode: "300090"
        },
        {
            codeName: "科斯岛（希腊）",
            cusCode: "310",
            codeValue: "GRC093",
            gbName: "科斯岛（希腊）",
            gbCode: "GRC093",
            ciqCode: "300093"
        },
        {
            codeName: "库塔拉（希腊）",
            cusCode: "310",
            codeValue: "GRC096",
            gbName: "库塔拉（希腊）",
            gbCode: "GRC096",
            ciqCode: "300096"
        },
        {
            codeName: "拉夫里翁（希腊）",
            cusCode: "2338",
            codeValue: "GRC102",
            gbName: "拉夫里翁（希腊）",
            gbCode: "GRC102",
            ciqCode: "300102"
        },
        {
            codeName: "莱罗斯岛（希腊）",
            cusCode: "310",
            codeValue: "GRC105",
            gbName: "莱罗斯岛（希腊）",
            gbCode: "GRC105",
            ciqCode: "300105"
        },
        {
            codeName: "利明西鲁（希腊）",
            cusCode: "310",
            codeValue: "GRC108",
            gbName: "利明西鲁（希腊）",
            gbCode: "GRC108",
            ciqCode: "300108"
        },
        {
            codeName: "拉克利昂（希腊）",
            cusCode: "310",
            codeValue: "GRC111",
            gbName: "拉克利昂（希腊）",
            gbCode: "GRC111",
            ciqCode: "300111"
        },
        {
            codeName: "迈加拉（希腊）",
            cusCode: "310",
            codeValue: "GRC114",
            gbName: "迈加拉（希腊）",
            gbCode: "GRC114",
            ciqCode: "300114"
        },
        {
            codeName: "迈索隆吉翁（希腊）",
            cusCode: "310",
            codeValue: "GRC117",
            gbName: "迈索隆吉翁（希腊）",
            gbCode: "GRC117",
            ciqCode: "300117"
        },
        {
            codeName: "迈索尼（希腊）",
            cusCode: "310",
            codeValue: "GRC120",
            gbName: "迈索尼（希腊）",
            gbCode: "GRC120",
            ciqCode: "300120"
        },
        {
            codeName: "米洛斯岛（希腊）",
            cusCode: "310",
            codeValue: "GRC123",
            gbName: "米洛斯岛（希腊）",
            gbCode: "GRC123",
            ciqCode: "300123"
        },
        {
            codeName: "米提林尼（希腊）",
            cusCode: "2340",
            codeValue: "GRC126",
            gbName: "米提林尼（希腊）",
            gbCode: "GRC126",
            ciqCode: "300126"
        },
        {
            codeName: "纳夫普利亚（希腊）",
            cusCode: "310",
            codeValue: "GRC129",
            gbName: "纳夫普利亚（希腊）",
            gbCode: "GRC129",
            ciqCode: "300129"
        },
        {
            codeName: "纳夫帕克托斯（希腊）",
            cusCode: "310",
            codeValue: "GRC132",
            gbName: "纳夫帕克托斯（希腊）",
            gbCode: "GRC132",
            ciqCode: "300132"
        },
        {
            codeName: "内亚卡瓦利（希腊）",
            cusCode: "310",
            codeValue: "GRC135",
            gbName: "内亚卡瓦利（希腊）",
            gbCode: "GRC135",
            ciqCode: "300135"
        },
        {
            codeName: "帕尔加（希腊）",
            cusCode: "2341",
            codeValue: "GRC136",
            gbName: "帕尔加（希腊）",
            gbCode: "GRC136",
            ciqCode: "300136"
        },
        {
            codeName: "佩特莫斯（希腊）",
            cusCode: "310",
            codeValue: "GRC138",
            gbName: "佩特莫斯（希腊）",
            gbCode: "GRC138",
            ciqCode: "300138"
        },
        {
            codeName: "佩特雷（希腊）",
            cusCode: "2342",
            codeValue: "GRC141",
            gbName: "佩特雷（希腊）",
            gbCode: "GRC141",
            ciqCode: "300141"
        },
        {
            codeName: "比雷埃夫斯（希腊）",
            cusCode: "2343",
            codeValue: "GRC144",
            gbName: "比雷埃夫斯（希腊）",
            gbCode: "GRC144",
            ciqCode: "300144"
        },
        {
            codeName: "利瓦德希港（希腊）",
            cusCode: "310",
            codeValue: "GRC147",
            gbName: "利瓦德希港（希腊）",
            gbCode: "GRC147",
            ciqCode: "300147"
        },
        {
            codeName: "瓦锡港（希腊）",
            cusCode: "310",
            codeValue: "GRC150",
            gbName: "瓦锡港（希腊）",
            gbCode: "GRC150",
            ciqCode: "300150"
        },
        {
            codeName: "普雷韦扎（希腊）",
            cusCode: "310",
            codeValue: "GRC153",
            gbName: "普雷韦扎（希腊）",
            gbCode: "GRC153",
            ciqCode: "300153"
        },
        {
            codeName: "皮洛斯（希腊）",
            cusCode: "310",
            codeValue: "GRC156",
            gbName: "皮洛斯（希腊）",
            gbCode: "GRC156",
            ciqCode: "300156"
        },
        {
            codeName: "雷西姆农（希腊）",
            cusCode: "310",
            codeValue: "GRC159",
            gbName: "雷西姆农（希腊）",
            gbCode: "GRC159",
            ciqCode: "300159"
        },
        {
            codeName: "罗得（希腊）",
            cusCode: "310",
            codeValue: "GRC162",
            gbName: "罗得（希腊）",
            gbCode: "GRC162",
            ciqCode: "300162"
        },
        {
            codeName: "萨摩斯岛（希腊）",
            cusCode: "310",
            codeValue: "GRC165",
            gbName: "萨摩斯岛（希腊）",
            gbCode: "GRC165",
            ciqCode: "300165"
        },
        {
            codeName: "斯科派洛斯（希腊）",
            cusCode: "310",
            codeValue: "GRC168",
            gbName: "斯科派洛斯（希腊）",
            gbCode: "GRC168",
            ciqCode: "300168"
        },
        {
            codeName: "斯特拉托尼（希腊）",
            cusCode: "310",
            codeValue: "GRC171",
            gbName: "斯特拉托尼（希腊）",
            gbCode: "GRC171",
            ciqCode: "300171"
        },
        {
            codeName: "苏达湾（希腊）",
            cusCode: "2346",
            codeValue: "GRC174",
            gbName: "苏达湾（希腊）",
            gbCode: "GRC174",
            ciqCode: "300174"
        },
        {
            codeName: "锡罗斯（希腊）",
            cusCode: "2347",
            codeValue: "GRC176",
            gbName: "锡罗斯（希腊）",
            gbCode: "GRC176",
            ciqCode: "300176"
        },
        {
            codeName: "塞萨洛尼基（希腊）",
            cusCode: "2344",
            codeValue: "GRC177",
            gbName: "塞萨洛尼基（希腊）",
            gbCode: "GRC177",
            ciqCode: "300177"
        },
        {
            codeName: "塞里福斯岛（希腊）",
            cusCode: "2345",
            codeValue: "GRC179",
            gbName: "塞里福斯岛（希腊）",
            gbCode: "GRC179",
            ciqCode: "300179"
        },
        {
            codeName: "伏洛斯（希腊）",
            cusCode: "2351",
            codeValue: "GRC180",
            gbName: "伏洛斯（希腊）",
            gbCode: "GRC180",
            ciqCode: "300180"
        },
        {
            codeName: "亚利岛（希腊）",
            cusCode: "310",
            codeValue: "GRC183",
            gbName: "亚利岛（希腊）",
            gbCode: "GRC183",
            ciqCode: "300183"
        },
        {
            codeName: "雅典（希腊）",
            cusCode: "2324",
            codeValue: "GRC184",
            gbName: "雅典（希腊）",
            gbCode: "GRC184",
            ciqCode: "300184"
        },
        {
            codeName: "耶兰基尼（希腊）",
            cusCode: "310",
            codeValue: "GRC186",
            gbName: "耶兰基尼（希腊）",
            gbCode: "GRC186",
            ciqCode: "300186"
        },
        {
            codeName: "赞特（希腊）",
            cusCode: "2353",
            codeValue: "GRC189",
            gbName: "赞特（希腊）",
            gbCode: "GRC189",
            ciqCode: "300189"
        },
        {
            codeName: "格林纳达",
            cusCode: "421",
            codeValue: "GRD000",
            gbName: "格林纳达",
            gbCode: "GRD000",
            ciqCode: "308000"
        },
        {
            codeName: "圣乔治（格林纳达）",
            cusCode: "2840",
            codeValue: "GRD003",
            gbName: "圣乔治（格林纳达）",
            gbCode: "GRD003",
            ciqCode: "308003"
        },
        {
            codeName: "格陵兰",
            cusCode: "503",
            codeValue: "GRL000",
            gbName: "格陵兰",
            gbCode: "GRL000",
            ciqCode: "304000"
        },
        {
            codeName: "克里斯蒂安斯霍布（格陵兰）",
            cusCode: "503",
            codeValue: "GRL003",
            gbName: "克里斯蒂安斯霍布（格陵兰）",
            gbCode: "GRL003",
            ciqCode: "304003"
        },
        {
            codeName: "奥希奥特（格陵兰）",
            cusCode: "503",
            codeValue: "GRL006",
            gbName: "奥希奥特（格陵兰）",
            gbCode: "GRL006",
            ciqCode: "304006"
        },
        {
            codeName: "费灵厄港（格陵兰）",
            cusCode: "503",
            codeValue: "GRL009",
            gbName: "费灵厄港（格陵兰）",
            gbCode: "GRL009",
            ciqCode: "304009"
        },
        {
            codeName: "腓特烈斯霍布（格陵兰）",
            cusCode: "503",
            codeValue: "GRL012",
            gbName: "腓特烈斯霍布（格陵兰）",
            gbCode: "GRL012",
            ciqCode: "304012"
        },
        {
            codeName: "戈德港（格陵兰）",
            cusCode: "503",
            codeValue: "GRL015",
            gbName: "戈德港（格陵兰）",
            gbCode: "GRL015",
            ciqCode: "304015"
        },
        {
            codeName: "努克（格陵兰）",
            cusCode: "503",
            codeValue: "GRL018",
            gbName: "努克（格陵兰）",
            gbCode: "GRL018",
            ciqCode: "304018"
        },
        {
            codeName: "荷尔斯泰因斯堡（格陵兰）",
            cusCode: "503",
            codeValue: "GRL021",
            gbName: "荷尔斯泰因斯堡（格陵兰）",
            gbCode: "GRL021",
            ciqCode: "304021"
        },
        {
            codeName: "伊维赫图特（格陵兰）",
            cusCode: "503",
            codeValue: "GRL024",
            gbName: "伊维赫图特（格陵兰）",
            gbCode: "GRL024",
            ciqCode: "304024"
        },
        {
            codeName: "雅各布港（格陵兰）",
            cusCode: "503",
            codeValue: "GRL027",
            gbName: "雅各布港（格陵兰）",
            gbCode: "GRL027",
            ciqCode: "304027"
        },
        {
            codeName: "尤利安娜霍布（格陵兰）",
            cusCode: "503",
            codeValue: "GRL030",
            gbName: "尤利安娜霍布（格陵兰）",
            gbCode: "GRL030",
            ciqCode: "304030"
        },
        {
            codeName: "康加米尤特（格陵兰）",
            cusCode: "503",
            codeValue: "GRL033",
            gbName: "康加米尤特（格陵兰）",
            gbCode: "GRL033",
            ciqCode: "304033"
        },
        {
            codeName: "马莫里利克（格陵兰）",
            cusCode: "503",
            codeValue: "GRL036",
            gbName: "马莫里利克（格陵兰）",
            gbCode: "GRL036",
            ciqCode: "304036"
        },
        {
            codeName: "纳萨尔苏瓦克（格陵兰）",
            cusCode: "503",
            codeValue: "GRL039",
            gbName: "纳萨尔苏瓦克（格陵兰）",
            gbCode: "GRL039",
            ciqCode: "304039"
        },
        {
            codeName: "马尼措克（格陵兰）",
            cusCode: "503",
            codeValue: "GRL042",
            gbName: "马尼措克（格陵兰）",
            gbCode: "GRL042",
            ciqCode: "304042"
        },
        {
            codeName: "乌马纳克（格陵兰）",
            cusCode: "503",
            codeValue: "GRL045",
            gbName: "乌马纳克（格陵兰）",
            gbCode: "GRL045",
            ciqCode: "304045"
        },
        {
            codeName: "乌佩尼维克（格陵兰）",
            cusCode: "503",
            codeValue: "GRL048",
            gbName: "乌佩尼维克（格陵兰）",
            gbCode: "GRL048",
            ciqCode: "304048"
        },
        {
            codeName: "危地马拉",
            cusCode: "423",
            codeValue: "GTM000",
            gbName: "危地马拉",
            gbCode: "GTM000",
            ciqCode: "320000"
        },
        {
            codeName: "钱佩里科（危地马拉）",
            cusCode: "2843",
            codeValue: "GTM003",
            gbName: "钱佩里科（危地马拉）",
            gbCode: "GTM003",
            ciqCode: "320003"
        },
        {
            codeName: "利文斯顿（危地马拉）",
            cusCode: "2844",
            codeValue: "GTM006",
            gbName: "利文斯顿（危地马拉）",
            gbCode: "GTM006",
            ciqCode: "320006"
        },
        {
            codeName: "PAYARDI（危地马拉）",
            cusCode: "2845",
            codeValue: "GTM008",
            gbName: "PAYARDI（危地马拉）",
            gbCode: "GTM008",
            ciqCode: "320008"
        },
        {
            codeName: "巴里奥斯港（危地马拉）",
            cusCode: "2846",
            codeValue: "GTM009",
            gbName: "巴里奥斯港（危地马拉）",
            gbCode: "GTM009",
            ciqCode: "320009"
        },
        {
            codeName: "夸特扎尔港（危地马拉）",
            cusCode: "423",
            codeValue: "GTM010",
            gbName: "夸特扎尔港（危地马拉）",
            gbCode: "GTM010",
            ciqCode: "320010"
        },
        {
            codeName: "圣何塞（危地马拉）",
            cusCode: "2847",
            codeValue: "GTM012",
            gbName: "圣何塞（危地马拉）",
            gbCode: "GTM012",
            ciqCode: "320012"
        },
        {
            codeName: "圣托马斯德卡斯蒂利亚（危地马拉）",
            cusCode: "2848",
            codeValue: "GTM015",
            gbName: "圣托马斯德卡斯蒂利亚（危地马拉）",
            gbCode: "GTM015",
            ciqCode: "320015"
        },
        {
            codeName: "法属圭亚那",
            cusCode: "420",
            codeValue: "GUF000",
            gbName: "法属圭亚那",
            gbCode: "GUF000",
            ciqCode: "254000"
        },
        {
            codeName: "卡宴（法属圭亚那）",
            cusCode: "2838",
            codeValue: "GUF003",
            gbName: "卡宴（法属圭亚那）",
            gbCode: "GUF003",
            ciqCode: "254003"
        },
        {
            codeName: "库鲁（法属圭亚那）",
            cusCode: "2839",
            codeValue: "GUF005",
            gbName: "库鲁（法属圭亚那）",
            gbCode: "GUF005",
            ciqCode: "254005"
        },
        {
            codeName: "德格拉德卡内斯（法属圭亚那）",
            cusCode: "420",
            codeValue: "GUF006",
            gbName: "德格拉德卡内斯（法属圭亚那）",
            gbCode: "GUF006",
            ciqCode: "254006"
        },
        {
            codeName: "关岛",
            cusCode: "629",
            codeValue: "GUM000",
            gbName: "关岛",
            gbCode: "GUM000",
            ciqCode: "316000"
        },
        {
            codeName: "阿加尼亚（关岛）",
            cusCode: "629",
            codeValue: "GUM003",
            gbName: "阿加尼亚（关岛）",
            gbCode: "GUM003",
            ciqCode: "316003"
        },
        {
            codeName: "阿普拉（关岛）",
            cusCode: "3386",
            codeValue: "GUM006",
            gbName: "阿普拉（关岛）",
            gbCode: "GUM006",
            ciqCode: "316006"
        },
        {
            codeName: "关岛（关岛）",
            cusCode: "629",
            codeValue: "GUM009",
            gbName: "关岛（关岛）",
            gbCode: "GUM009",
            ciqCode: "316009"
        },
        {
            codeName: "圭亚那",
            cusCode: "424",
            codeValue: "GUY000",
            gbName: "圭亚那",
            gbCode: "GUY000",
            ciqCode: "328000"
        },
        {
            codeName: "巴提卡（圭亚那）",
            cusCode: "2849",
            codeValue: "GUY003",
            gbName: "巴提卡（圭亚那）",
            gbCode: "GUY003",
            ciqCode: "328003"
        },
        {
            codeName: "乔治敦（圭亚那）",
            cusCode: "2851",
            codeValue: "GUY006",
            gbName: "乔治敦（圭亚那）",
            gbCode: "GUY006",
            ciqCode: "328006"
        },
        {
            codeName: "新阿姆斯特丹（圭亚那）",
            cusCode: "2852",
            codeValue: "GUY009",
            gbName: "新阿姆斯特丹（圭亚那）",
            gbCode: "GUY009",
            ciqCode: "328009"
        },
        {
            codeName: "查里提（圭亚那）",
            cusCode: "2850",
            codeValue: "GUY020",
            gbName: "查里提（圭亚那）",
            gbCode: "GUY020",
            ciqCode: "328020"
        },
        {
            codeName: "中国香港",
            cusCode: "110",
            codeValue: "HKG000",
            gbName: "中国香港",
            gbCode: "HKG000",
            ciqCode: "344000"
        },
        {
            codeName: "香港（中国香港）",
            cusCode: "1039",
            codeValue: "HKG003",
            gbName: "香港（中国香港）",
            gbCode: "HKG003",
            ciqCode: "344003"
        },
        {
            codeName: "赫德岛和麦克唐纳岛",
            cusCode: "630",
            codeValue: "HMD000",
            gbName: "赫德岛和麦克唐纳岛",
            gbCode: "HMD000",
            ciqCode: "334000"
        },
        {
            codeName: "洪都拉斯",
            cusCode: "426",
            codeValue: "HND000",
            gbName: "洪都拉斯",
            gbCode: "HND000",
            ciqCode: "340000"
        },
        {
            codeName: "阿马帕拉（洪都拉斯）",
            cusCode: "2859",
            codeValue: "HND003",
            gbName: "阿马帕拉（洪都拉斯）",
            gbCode: "HND003",
            ciqCode: "340003"
        },
        {
            codeName: "拉塞瓦（洪都拉斯）",
            cusCode: "2860",
            codeValue: "HND006",
            gbName: "拉塞瓦（洪都拉斯）",
            gbCode: "HND006",
            ciqCode: "340006"
        },
        {
            codeName: "卡斯蒂利亚港（洪都拉斯）",
            cusCode: "426",
            codeValue: "HND009",
            gbName: "卡斯蒂利亚港（洪都拉斯）",
            gbCode: "HND009",
            ciqCode: "340009"
        },
        {
            codeName: "科尔特斯港（洪都拉斯）",
            cusCode: "2861",
            codeValue: "HND012",
            gbName: "科尔特斯港（洪都拉斯）",
            gbCode: "HND012",
            ciqCode: "340012"
        },
        {
            codeName: "罗阿坦（洪都拉斯）",
            cusCode: "426",
            codeValue: "HND015",
            gbName: "罗阿坦（洪都拉斯）",
            gbCode: "HND015",
            ciqCode: "340015"
        },
        {
            codeName: "圣洛伦索（洪都拉斯）",
            cusCode: "426",
            codeValue: "HND018",
            gbName: "圣洛伦索（洪都拉斯）",
            gbCode: "HND018",
            ciqCode: "340018"
        },
        {
            codeName: "特拉（洪都拉斯）",
            cusCode: "2862",
            codeValue: "HND021",
            gbName: "特拉（洪都拉斯）",
            gbCode: "HND021",
            ciqCode: "340021"
        },
        {
            codeName: "特鲁希略（洪都拉斯）",
            cusCode: "2863",
            codeValue: "HND024",
            gbName: "特鲁希略（洪都拉斯）",
            gbCode: "HND024",
            ciqCode: "340024"
        },
        {
            codeName: "克罗地亚",
            cusCode: "351",
            codeValue: "HRV000",
            gbName: "克罗地亚",
            gbCode: "HRV000",
            ciqCode: "191000"
        },
        {
            codeName: "巴卡尔（克罗地亚）",
            cusCode: "351",
            codeValue: "HRV003",
            gbName: "巴卡尔（克罗地亚）",
            gbCode: "HRV003",
            ciqCode: "191003"
        },
        {
            codeName: "杜布罗夫尼克（克罗地亚）",
            cusCode: "2678",
            codeValue: "HRV006",
            gbName: "杜布罗夫尼克（克罗地亚）",
            gbCode: "HRV006",
            ciqCode: "191006"
        },
        {
            codeName: "杜吉腊特（克罗地亚）",
            cusCode: "351",
            codeValue: "HRV009",
            gbName: "杜吉腊特（克罗地亚）",
            gbCode: "HRV009",
            ciqCode: "191009"
        },
        {
            codeName: "赫瓦尔（克罗地亚）",
            cusCode: "2679",
            codeValue: "HRV012",
            gbName: "赫瓦尔（克罗地亚）",
            gbCode: "HRV012",
            ciqCode: "191012"
        },
        {
            codeName: "普洛切（克罗地亚）",
            cusCode: "2691",
            codeValue: "HRV015",
            gbName: "普洛切（克罗地亚）",
            gbCode: "HRV015",
            ciqCode: "191015"
        },
        {
            codeName: "科尔丘拉（克罗地亚）",
            cusCode: "2686",
            codeValue: "HRV018",
            gbName: "科尔丘拉（克罗地亚）",
            gbCode: "HRV018",
            ciqCode: "191018"
        },
        {
            codeName: "马斯利尼索（克罗地亚）",
            cusCode: "2689",
            codeValue: "HRV021",
            gbName: "马斯利尼索（克罗地亚）",
            gbCode: "HRV021",
            ciqCode: "191021"
        },
        {
            codeName: "奥米沙利（克罗地亚）",
            cusCode: "351",
            codeValue: "HRV024",
            gbName: "奥米沙利（克罗地亚）",
            gbCode: "HRV024",
            ciqCode: "191024"
        },
        {
            codeName: "普拉（克罗地亚）",
            cusCode: "2692",
            codeValue: "HRV027",
            gbName: "普拉（克罗地亚）",
            gbCode: "HRV027",
            ciqCode: "191027"
        },
        {
            codeName: "拉萨（克罗地亚）",
            cusCode: "351",
            codeValue: "HRV030",
            gbName: "拉萨（克罗地亚）",
            gbCode: "HRV030",
            ciqCode: "191030"
        },
        {
            codeName: "里耶卡（克罗地亚）",
            cusCode: "2693",
            codeValue: "HRV033",
            gbName: "里耶卡（克罗地亚）",
            gbCode: "HRV033",
            ciqCode: "191033"
        },
        {
            codeName: "罗维尼（克罗地亚）",
            cusCode: "2694",
            codeValue: "HRV036",
            gbName: "罗维尼（克罗地亚）",
            gbCode: "HRV036",
            ciqCode: "191036"
        },
        {
            codeName: "塞尼（克罗地亚）",
            cusCode: "2695",
            codeValue: "HRV039",
            gbName: "塞尼（克罗地亚）",
            gbCode: "HRV039",
            ciqCode: "191039"
        },
        {
            codeName: "希贝尼克（克罗地亚）",
            cusCode: "2696",
            codeValue: "HRV042",
            gbName: "希贝尼克（克罗地亚）",
            gbCode: "HRV042",
            ciqCode: "191042"
        },
        {
            codeName: "斯普利特（克罗地亚）",
            cusCode: "2697",
            codeValue: "HRV045",
            gbName: "斯普利特（克罗地亚）",
            gbCode: "HRV045",
            ciqCode: "191045"
        },
        {
            codeName: "扎达尔（克罗地亚）",
            cusCode: "2701",
            codeValue: "HRV048",
            gbName: "扎达尔（克罗地亚）",
            gbCode: "HRV048",
            ciqCode: "191048"
        },
        {
            codeName: "SVETI KAJO（克罗地亚）",
            cusCode: "2699",
            codeValue: "HRV050",
            gbName: "SVETI KAJO（克罗地亚）",
            gbCode: "HRV050",
            ciqCode: "191050"
        },
        {
            codeName: "SUCURAC（克罗地亚）",
            cusCode: "2698",
            codeValue: "HRV052",
            gbName: "SUCURAC（克罗地亚）",
            gbCode: "HRV052",
            ciqCode: "191052"
        },
        {
            codeName: "卡托罗（克罗地亚）",
            cusCode: "2680",
            codeValue: "HRV053",
            gbName: "卡托罗（克罗地亚）",
            gbCode: "HRV053",
            ciqCode: "191053"
        },
        {
            codeName: "海地",
            cusCode: "425",
            codeValue: "HTI000",
            gbName: "海地",
            gbCode: "HTI000",
            ciqCode: "332000"
        },
        {
            codeName: "莱凯（海地）",
            cusCode: "425",
            codeValue: "HTI003",
            gbName: "莱凯（海地）",
            gbCode: "HTI003",
            ciqCode: "332003"
        },
        {
            codeName: "海地角（海地）",
            cusCode: "2854",
            codeValue: "HTI006",
            gbName: "海地角（海地）",
            gbCode: "HTI006",
            ciqCode: "332006"
        },
        {
            codeName: "利贝泰堡（海地）",
            cusCode: "425",
            codeValue: "HTI009",
            gbName: "利贝泰堡（海地）",
            gbCode: "HTI009",
            ciqCode: "332009"
        },
        {
            codeName: "戈纳伊夫（海地）",
            cusCode: "425",
            codeValue: "HTI012",
            gbName: "戈纳伊夫（海地）",
            gbCode: "HTI012",
            ciqCode: "332012"
        },
        {
            codeName: "热雷米（海地）",
            cusCode: "2855",
            codeValue: "HTI015",
            gbName: "热雷米（海地）",
            gbCode: "HTI015",
            ciqCode: "332015"
        },
        {
            codeName: "米腊关（海地）",
            cusCode: "2856",
            codeValue: "HTI018",
            gbName: "米腊关（海地）",
            gbCode: "HTI018",
            ciqCode: "332018"
        },
        {
            codeName: "欧凯（海地）",
            cusCode: "2853",
            codeValue: "HTI019",
            gbName: "欧凯（海地）",
            gbCode: "HTI019",
            ciqCode: "332019"
        },
        {
            codeName: "太子港（海地）",
            cusCode: "2857",
            codeValue: "HTI021",
            gbName: "太子港（海地）",
            gbCode: "HTI021",
            ciqCode: "332021"
        },
        {
            codeName: "圣马克（海地）",
            cusCode: "2858",
            codeValue: "HTI024",
            gbName: "圣马克（海地）",
            gbCode: "HTI024",
            ciqCode: "332024"
        },
        {
            codeName: "匈牙利",
            cusCode: "321",
            codeValue: "HUN000",
            gbName: "匈牙利",
            gbCode: "HUN000",
            ciqCode: "348000"
        },
        {
            codeName: "布达佩斯（匈牙利）",
            cusCode: "3453",
            codeValue: "HUN003",
            gbName: "布达佩斯（匈牙利）",
            gbCode: "HUN003",
            ciqCode: "348003"
        },
        {
            codeName: "印度尼西亚",
            cusCode: "112",
            codeValue: "IDN000",
            gbName: "印度尼西亚",
            gbCode: "IDN000",
            ciqCode: "360000"
        },
        {
            codeName: "安汶（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN003",
            gbName: "安汶（印度尼西亚）",
            gbCode: "IDN003",
            ciqCode: "360003"
        },
        {
            codeName: "安佩南（印度尼西亚）",
            cusCode: "1082",
            codeValue: "IDN006",
            gbName: "安佩南（印度尼西亚）",
            gbCode: "IDN006",
            ciqCode: "360006"
        },
        {
            codeName: "BALAWAN（印度尼西亚）",
            cusCode: "1086",
            codeValue: "IDN008",
            gbName: "BALAWAN（印度尼西亚）",
            gbCode: "IDN008",
            ciqCode: "360008"
        },
        {
            codeName: "阿米纳油码头（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN009",
            gbName: "阿米纳油码头（印度尼西亚）",
            gbCode: "IDN009",
            ciqCode: "360009"
        },
        {
            codeName: "阿罗湾（印度尼西亚）",
            cusCode: "1083",
            codeValue: "IDN010",
            gbName: "阿罗湾（印度尼西亚）",
            gbCode: "IDN010",
            ciqCode: "360010"
        },
        {
            codeName: "阿萨汗（印度尼西亚）",
            cusCode: "1084",
            codeValue: "IDN011",
            gbName: "阿萨汗（印度尼西亚）",
            gbCode: "IDN011",
            ciqCode: "360011"
        },
        {
            codeName: "巴眼牙比（印度尼西亚）",
            cusCode: "1085",
            codeValue: "IDN012",
            gbName: "巴眼牙比（印度尼西亚）",
            gbCode: "IDN012",
            ciqCode: "360012"
        },
        {
            codeName: "巴厘巴板（印度尼西亚）",
            cusCode: "1087",
            codeValue: "IDN015",
            gbName: "巴厘巴板（印度尼西亚）",
            gbCode: "IDN015",
            ciqCode: "360015"
        },
        {
            codeName: "马辰（印度尼西亚）",
            cusCode: "1088",
            codeValue: "IDN018",
            gbName: "马辰（印度尼西亚）",
            gbCode: "IDN018",
            ciqCode: "360018"
        },
        {
            codeName: "洛塞马韦（印度尼西亚）",
            cusCode: "1115",
            codeValue: "IDN019",
            gbName: "洛塞马韦（印度尼西亚）",
            gbCode: "IDN019",
            ciqCode: "360019"
        },
        {
            codeName: "巴纽旺宣（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN021",
            gbName: "巴纽旺宣（印度尼西亚）",
            gbCode: "IDN021",
            ciqCode: "360021"
        },
        {
            codeName: "勿拉湾（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN024",
            gbName: "勿拉湾（印度尼西亚）",
            gbCode: "IDN024",
            ciqCode: "360024"
        },
        {
            codeName: "望加丽（印度尼西亚）",
            cusCode: "1091",
            codeValue: "IDN027",
            gbName: "望加丽（印度尼西亚）",
            gbCode: "IDN027",
            ciqCode: "360027"
        },
        {
            codeName: "佩纳巴（印度尼西亚）",
            cusCode: "1143",
            codeValue: "IDN029",
            gbName: "佩纳巴（印度尼西亚）",
            gbCode: "IDN029",
            ciqCode: "360029"
        },
        {
            codeName: "朋古鲁（印度尼西亚）",
            cusCode: "1092",
            codeValue: "IDN030",
            gbName: "朋古鲁（印度尼西亚）",
            gbCode: "IDN030",
            ciqCode: "360030"
        },
        {
            codeName: "伯诺阿（印度尼西亚）",
            cusCode: "1093",
            codeValue: "IDN033",
            gbName: "伯诺阿（印度尼西亚）",
            gbCode: "IDN033",
            ciqCode: "360033"
        },
        {
            codeName: "比马（印度尼西亚）",
            cusCode: "1094",
            codeValue: "IDN036",
            gbName: "比马（印度尼西亚）",
            gbCode: "IDN036",
            ciqCode: "360036"
        },
        {
            codeName: "比通（印度尼西亚）",
            cusCode: "1095",
            codeValue: "IDN039",
            gbName: "比通（印度尼西亚）",
            gbCode: "IDN039",
            ciqCode: "360039"
        },
        {
            codeName: "勿里洋（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN042",
            gbName: "勿里洋（印度尼西亚）",
            gbCode: "IDN042",
            ciqCode: "360042"
        },
        {
            codeName: "布莱伦（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN045",
            gbName: "布莱伦（印度尼西亚）",
            gbCode: "IDN045",
            ciqCode: "360045"
        },
        {
            codeName: "芝格丁（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN048",
            gbName: "芝格丁（印度尼西亚）",
            gbCode: "IDN048",
            ciqCode: "360048"
        },
        {
            codeName: "芝拉扎（印度尼西亚）",
            cusCode: "1177",
            codeValue: "IDN051",
            gbName: "芝拉扎（印度尼西亚）",
            gbCode: "IDN051",
            ciqCode: "360051"
        },
        {
            codeName: "信塔油码头（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN054",
            gbName: "信塔油码头（印度尼西亚）",
            gbCode: "IDN054",
            ciqCode: "360054"
        },
        {
            codeName: "井里汶（印度尼西亚）",
            cusCode: "1096",
            codeValue: "IDN057",
            gbName: "井里汶（印度尼西亚）",
            gbCode: "IDN057",
            ciqCode: "360057"
        },
        {
            codeName: "达博（印度尼西亚）",
            cusCode: "1097",
            codeValue: "IDN060",
            gbName: "达博（印度尼西亚）",
            gbCode: "IDN060",
            ciqCode: "360060"
        },
        {
            codeName: "栋加拉（印度尼西亚）",
            cusCode: "1102",
            codeValue: "IDN063",
            gbName: "栋加拉（印度尼西亚）",
            gbCode: "IDN063",
            ciqCode: "360063"
        },
        {
            codeName: "杜迈（印度尼西亚）",
            cusCode: "1103",
            codeValue: "IDN066",
            gbName: "杜迈（印度尼西亚）",
            gbCode: "IDN066",
            ciqCode: "360066"
        },
        {
            codeName: "法克法克（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN069",
            gbName: "法克法克（印度尼西亚）",
            gbCode: "IDN069",
            ciqCode: "360069"
        },
        {
            codeName: "哥伦打洛（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN072",
            gbName: "哥伦打洛（印度尼西亚）",
            gbCode: "IDN072",
            ciqCode: "360072"
        },
        {
            codeName: "格雷西（锦石）（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN075",
            gbName: "格雷西（锦石）（印度尼西亚）",
            gbCode: "IDN075",
            ciqCode: "360075"
        },
        {
            codeName: "古农西托利（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN078",
            gbName: "古农西托利（印度尼西亚）",
            gbCode: "IDN078",
            ciqCode: "360078"
        },
        {
            codeName: "雅加达（印度尼西亚）",
            cusCode: "1105",
            codeValue: "IDN081",
            gbName: "雅加达（印度尼西亚）",
            gbCode: "IDN081",
            ciqCode: "360081"
        },
        {
            codeName: "占碑（印度尼西亚）",
            cusCode: "1100",
            codeValue: "IDN084",
            gbName: "占碑（印度尼西亚）",
            gbCode: "IDN084",
            ciqCode: "360084"
        },
        {
            codeName: "查亚普拉（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN087",
            gbName: "查亚普拉（印度尼西亚）",
            gbCode: "IDN087",
            ciqCode: "360087"
        },
        {
            codeName: "卡利昂厄特（印度尼西亚）",
            cusCode: "1108",
            codeValue: "IDN090",
            gbName: "卡利昂厄特（印度尼西亚）",
            gbCode: "IDN090",
            ciqCode: "360090"
        },
        {
            codeName: "卡西姆（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN093",
            gbName: "卡西姆（印度尼西亚）",
            gbCode: "IDN093",
            ciqCode: "360093"
        },
        {
            codeName: "肯达里（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN096",
            gbName: "肯达里（印度尼西亚）",
            gbCode: "IDN096",
            ciqCode: "360096"
        },
        {
            codeName: "贺兰狄亚（印度尼西亚）",
            cusCode: "1104",
            codeValue: "IDN098",
            gbName: "贺兰狄亚（印度尼西亚）",
            gbCode: "IDN098",
            ciqCode: "360098"
        },
        {
            codeName: "吉打邦（印度尼西亚）",
            cusCode: "1110",
            codeValue: "IDN099",
            gbName: "吉打邦（印度尼西亚）",
            gbCode: "IDN099",
            ciqCode: "360099"
        },
        {
            codeName: "贾贾普拉（印度尼西亚）",
            cusCode: "1098",
            codeValue: "IDN100",
            gbName: "贾贾普拉（印度尼西亚）",
            gbCode: "IDN100",
            ciqCode: "360100"
        },
        {
            codeName: "哥打巴鲁（印度尼西亚）",
            cusCode: "1111",
            codeValue: "IDN102",
            gbName: "哥打巴鲁（印度尼西亚）",
            gbCode: "IDN102",
            ciqCode: "360102"
        },
        {
            codeName: "格鲁（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN105",
            gbName: "格鲁（印度尼西亚）",
            gbCode: "IDN105",
            ciqCode: "360105"
        },
        {
            codeName: "瓜拉卡普阿斯（印度尼西亚）",
            cusCode: "1112",
            codeValue: "IDN108",
            gbName: "瓜拉卡普阿斯（印度尼西亚）",
            gbCode: "IDN108",
            ciqCode: "360108"
        },
        {
            codeName: "古邦（印度尼西亚）",
            cusCode: "1114",
            codeValue: "IDN111",
            gbName: "古邦（印度尼西亚）",
            gbCode: "IDN111",
            ciqCode: "360111"
        },
        {
            codeName: "马卡萨（印度尼西亚）",
            cusCode: "1116",
            codeValue: "IDN114",
            gbName: "马卡萨（印度尼西亚）",
            gbCode: "IDN114",
            ciqCode: "360114"
        },
        {
            codeName: "马德拉斯（印度尼西亚）",
            cusCode: "1118",
            codeValue: "IDN115",
            gbName: "马德拉斯（印度尼西亚）",
            gbCode: "IDN115",
            ciqCode: "360115"
        },
        {
            codeName: "马利利（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN117",
            gbName: "马利利（印度尼西亚）",
            gbCode: "IDN117",
            ciqCode: "360117"
        },
        {
            codeName: "马穆朱（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN120",
            gbName: "马穆朱（印度尼西亚）",
            gbCode: "IDN120",
            ciqCode: "360120"
        },
        {
            codeName: "马诺夸里（印度尼西亚）",
            cusCode: "1123",
            codeValue: "IDN123",
            gbName: "马诺夸里（印度尼西亚）",
            gbCode: "IDN123",
            ciqCode: "360123"
        },
        {
            codeName: "满各里（印度尼西亚）",
            cusCode: "1122",
            codeValue: "IDN124",
            gbName: "满各里（印度尼西亚）",
            gbCode: "IDN124",
            ciqCode: "360124"
        },
        {
            codeName: "毛梅雷（印度尼西亚）",
            cusCode: "1124",
            codeValue: "IDN125",
            gbName: "毛梅雷（印度尼西亚）",
            gbCode: "IDN125",
            ciqCode: "360125"
        },
        {
            codeName: "棉兰（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN126",
            gbName: "棉兰（印度尼西亚）",
            gbCode: "IDN126",
            ciqCode: "360126"
        },
        {
            codeName: "蒙法尔科内（印度尼西亚）",
            cusCode: "1128",
            codeValue: "IDN127",
            gbName: "蒙法尔科内（印度尼西亚）",
            gbCode: "IDN127",
            ciqCode: "360127"
        },
        {
            codeName: "万隆（印度尼西亚）",
            cusCode: "1089",
            codeValue: "IDN128",
            gbName: "万隆（印度尼西亚）",
            gbCode: "IDN128",
            ciqCode: "360128"
        },
        {
            codeName: "万鸦老（印度尼西亚）",
            cusCode: "1121",
            codeValue: "IDN129",
            gbName: "万鸦老（印度尼西亚）",
            gbCode: "IDN129",
            ciqCode: "360129"
        },
        {
            codeName: "默拉克（孔雀岛）（印度尼西亚）",
            cusCode: "1126",
            codeValue: "IDN132",
            gbName: "默拉克（孔雀岛）（印度尼西亚）",
            gbCode: "IDN132",
            ciqCode: "360132"
        },
        {
            codeName: "马老奇（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN135",
            gbName: "马老奇（印度尼西亚）",
            gbCode: "IDN135",
            ciqCode: "360135"
        },
        {
            codeName: "马都拉岛（印度尼西亚）",
            cusCode: "1119",
            codeValue: "IDN136",
            gbName: "马都拉岛（印度尼西亚）",
            gbCode: "IDN136",
            ciqCode: "360136"
        },
        {
            codeName: "马杰尼（印度尼西亚）",
            cusCode: "1117",
            codeValue: "IDN137",
            gbName: "马杰尼（印度尼西亚）",
            gbCode: "IDN137",
            ciqCode: "360137"
        },
        {
            codeName: "米拉务（印度尼西亚）",
            cusCode: "1127",
            codeValue: "IDN138",
            gbName: "米拉务（印度尼西亚）",
            gbCode: "IDN138",
            ciqCode: "360138"
        },
        {
            codeName: "蒙托克（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN141",
            gbName: "蒙托克（印度尼西亚）",
            gbCode: "IDN141",
            ciqCode: "360141"
        },
        {
            codeName: "巴东（印度尼西亚）",
            cusCode: "1130",
            codeValue: "IDN144",
            gbName: "巴东（印度尼西亚）",
            gbCode: "IDN144",
            ciqCode: "360144"
        },
        {
            codeName: "北千巴鲁（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN147",
            gbName: "北千巴鲁（印度尼西亚）",
            gbCode: "IDN147",
            ciqCode: "360147"
        },
        {
            codeName: "巨港（印度尼西亚）",
            cusCode: "1134",
            codeValue: "IDN150",
            gbName: "巨港（印度尼西亚）",
            gbCode: "IDN150",
            ciqCode: "360150"
        },
        {
            codeName: "帕干巴鲁（印度尼西亚）",
            cusCode: "1131",
            codeValue: "IDN152",
            gbName: "帕干巴鲁（印度尼西亚）",
            gbCode: "IDN152",
            ciqCode: "360152"
        },
        {
            codeName: "帕洛波（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN153",
            gbName: "帕洛波（印度尼西亚）",
            gbCode: "IDN153",
            ciqCode: "360153"
        },
        {
            codeName: "帕马努坎（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN156",
            gbName: "帕马努坎（印度尼西亚）",
            gbCode: "IDN156",
            ciqCode: "360156"
        },
        {
            codeName: "巴那鲁干（印度尼西亚）",
            cusCode: "1135",
            codeValue: "IDN159",
            gbName: "巴那鲁干（印度尼西亚）",
            gbCode: "IDN159",
            ciqCode: "360159"
        },
        {
            codeName: "庞卡尔（印度尼西亚）",
            cusCode: "1137",
            codeValue: "IDN162",
            gbName: "庞卡尔（印度尼西亚）",
            gbCode: "IDN162",
            ciqCode: "360162"
        },
        {
            codeName: "槟港（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN165",
            gbName: "槟港（印度尼西亚）",
            gbCode: "IDN165",
            ciqCode: "360165"
        },
        {
            codeName: "庞卡兰苏苏（印度尼西亚）",
            cusCode: "1138",
            codeValue: "IDN168",
            gbName: "庞卡兰苏苏（印度尼西亚）",
            gbCode: "IDN168",
            ciqCode: "360168"
        },
        {
            codeName: "潘吉姆（印度尼西亚）",
            cusCode: "1139",
            codeValue: "IDN170",
            gbName: "潘吉姆（印度尼西亚）",
            gbCode: "IDN170",
            ciqCode: "360170"
        },
        {
            codeName: "潘姜（印度尼西亚）",
            cusCode: "1136",
            codeValue: "IDN171",
            gbName: "潘姜（印度尼西亚）",
            gbCode: "IDN171",
            ciqCode: "360171"
        },
        {
            codeName: "巴里巴里（印度尼西亚）",
            cusCode: "1140",
            codeValue: "IDN174",
            gbName: "巴里巴里（印度尼西亚）",
            gbCode: "IDN174",
            ciqCode: "360174"
        },
        {
            codeName: "巴苏鲁安（印度尼西亚）",
            cusCode: "1141",
            codeValue: "IDN177",
            gbName: "巴苏鲁安（印度尼西亚）",
            gbCode: "IDN177",
            ciqCode: "360177"
        },
        {
            codeName: "北加浪岸（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN180",
            gbName: "北加浪岸（印度尼西亚）",
            gbCode: "IDN180",
            ciqCode: "360180"
        },
        {
            codeName: "班马吉（印度尼西亚）",
            cusCode: "1142",
            codeValue: "IDN183",
            gbName: "班马吉（印度尼西亚）",
            gbCode: "IDN183",
            ciqCode: "360183"
        },
        {
            codeName: "波马拉（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN186",
            gbName: "波马拉（印度尼西亚）",
            gbCode: "IDN186",
            ciqCode: "360186"
        },
        {
            codeName: "库迈（印度尼西亚）",
            cusCode: "1113",
            codeValue: "IDN188",
            gbName: "库迈（印度尼西亚）",
            gbCode: "IDN188",
            ciqCode: "360188"
        },
        {
            codeName: "坤甸（印度尼西亚）",
            cusCode: "1145",
            codeValue: "IDN189",
            gbName: "坤甸（印度尼西亚）",
            gbCode: "IDN189",
            ciqCode: "360189"
        },
        {
            codeName: "波索（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN192",
            gbName: "波索（印度尼西亚）",
            gbCode: "IDN192",
            ciqCode: "360192"
        },
        {
            codeName: "普罗博林戈（印度尼西亚）",
            cusCode: "1147",
            codeValue: "IDN195",
            gbName: "普罗博林戈（印度尼西亚）",
            gbCode: "IDN195",
            ciqCode: "360195"
        },
        {
            codeName: "普劳桑布（印度尼西亚）",
            cusCode: "1148",
            codeValue: "IDN198",
            gbName: "普劳桑布（印度尼西亚）",
            gbCode: "IDN198",
            ciqCode: "360198"
        },
        {
            codeName: "沙璜（印度尼西亚）",
            cusCode: "1149",
            codeValue: "IDN201",
            gbName: "沙璜（印度尼西亚）",
            gbCode: "IDN201",
            ciqCode: "360201"
        },
        {
            codeName: "桑坦港（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN203",
            gbName: "桑坦港（印度尼西亚）",
            gbCode: "IDN203",
            ciqCode: "360203"
        },
        {
            codeName: "沙拉瓦蒂（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN204",
            gbName: "沙拉瓦蒂（印度尼西亚）",
            gbCode: "IDN204",
            ciqCode: "360204"
        },
        {
            codeName: "三马林达（印度尼西亚）",
            cusCode: "1150",
            codeValue: "IDN207",
            gbName: "三马林达（印度尼西亚）",
            gbCode: "IDN207",
            ciqCode: "360207"
        },
        {
            codeName: "三发（印度尼西亚）",
            cusCode: "1151",
            codeValue: "IDN210",
            gbName: "三发（印度尼西亚）",
            gbCode: "IDN210",
            ciqCode: "360210"
        },
        {
            codeName: "桑皮特（印度尼西亚）",
            cusCode: "1152",
            codeValue: "IDN213",
            gbName: "桑皮特（印度尼西亚）",
            gbCode: "IDN213",
            ciqCode: "360213"
        },
        {
            codeName: "桑库利朗（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN216",
            gbName: "桑库利朗（印度尼西亚）",
            gbCode: "IDN216",
            ciqCode: "360216"
        },
        {
            codeName: "塞拉潘姜（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN219",
            gbName: "塞拉潘姜（印度尼西亚）",
            gbCode: "IDN219",
            ciqCode: "360218"
        },
        {
            codeName: "三宝垄（印度尼西亚）",
            cusCode: "1154",
            codeValue: "IDN222",
            gbName: "三宝垄（印度尼西亚）",
            gbCode: "IDN222",
            ciqCode: "360222"
        },
        {
            codeName: "苏拉威西（印度尼西亚）",
            cusCode: "1161",
            codeValue: "IDN223",
            gbName: "苏拉威西（印度尼西亚）",
            gbCode: "IDN223",
            ciqCode: "360223"
        },
        {
            codeName: "泗水（印度尼西亚）",
            cusCode: "1164",
            codeValue: "IDN224",
            gbName: "泗水（印度尼西亚）",
            gbCode: "IDN224",
            ciqCode: "360224"
        },
        {
            codeName: "塞尼帕油码头（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN225",
            gbName: "塞尼帕油码头（印度尼西亚）",
            gbCode: "IDN225",
            ciqCode: "360225"
        },
        {
            codeName: "山口羊（印度尼西亚）",
            cusCode: "1158",
            codeValue: "IDN227",
            gbName: "山口羊（印度尼西亚）",
            gbCode: "IDN227",
            ciqCode: "360227"
        },
        {
            codeName: "实武牙（印度尼西亚）",
            cusCode: "1155",
            codeValue: "IDN228",
            gbName: "实武牙（印度尼西亚）",
            gbCode: "IDN228",
            ciqCode: "360228"
        },
        {
            codeName: "苏门达腊（印度尼西亚）",
            cusCode: "1162",
            codeValue: "IDN229",
            gbName: "苏门达腊（印度尼西亚）",
            gbCode: "IDN229",
            ciqCode: "360229"
        },
        {
            codeName: "苏苏（印度尼西亚）",
            cusCode: "1166",
            codeValue: "IDN230",
            gbName: "苏苏（印度尼西亚）",
            gbCode: "IDN230",
            ciqCode: "360230"
        },
        {
            codeName: "索龙（印度尼西亚）",
            cusCode: "1159",
            codeValue: "IDN231",
            gbName: "索龙（印度尼西亚）",
            gbCode: "IDN231",
            ciqCode: "360231"
        },
        {
            codeName: "双溪格龙（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN234",
            gbName: "双溪格龙（印度尼西亚）",
            gbCode: "IDN234",
            ciqCode: "360234"
        },
        {
            codeName: "双溪克拉克（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN237",
            gbName: "双溪克拉克（印度尼西亚）",
            gbCode: "IDN237",
            ciqCode: "360237"
        },
        {
            codeName: "巴宁河（印度尼西亚）",
            cusCode: "1163",
            codeValue: "IDN240",
            gbName: "巴宁河（印度尼西亚）",
            gbCode: "IDN240",
            ciqCode: "360240"
        },
        {
            codeName: "丹戎潘丹（印度尼西亚）",
            cusCode: "1167",
            codeValue: "IDN246",
            gbName: "丹戎潘丹（印度尼西亚）",
            gbCode: "IDN246",
            ciqCode: "360246"
        },
        {
            codeName: "丹戎槟榔（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN249",
            gbName: "丹戎槟榔（印度尼西亚）",
            gbCode: "IDN249",
            ciqCode: "360249"
        },
        {
            codeName: "丹戎不碌（印度尼西亚）",
            cusCode: "1169",
            codeValue: "IDN252",
            gbName: "丹戎不碌（印度尼西亚）",
            gbCode: "IDN252",
            ciqCode: "360252"
        },
        {
            codeName: "丹戎勒德布（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN255",
            gbName: "丹戎勒德布（印度尼西亚）",
            gbCode: "IDN255",
            ciqCode: "360255"
        },
        {
            codeName: "丹戎索法（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN258",
            gbName: "丹戎索法（印度尼西亚）",
            gbCode: "IDN258",
            ciqCode: "360258"
        },
        {
            codeName: "丹戎乌班（印度尼西亚）",
            cusCode: "1171",
            codeValue: "IDN261",
            gbName: "丹戎乌班（印度尼西亚）",
            gbCode: "IDN261",
            ciqCode: "360261"
        },
        {
            codeName: "打拉根（印度尼西亚）",
            cusCode: "1173",
            codeValue: "IDN264",
            gbName: "打拉根（印度尼西亚）",
            gbCode: "IDN264",
            ciqCode: "360264"
        },
        {
            codeName: "直落巴由（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN266",
            gbName: "直落巴由（印度尼西亚）",
            gbCode: "IDN266",
            ciqCode: "360266"
        },
        {
            codeName: "直葛（印度尼西亚）",
            cusCode: "1174",
            codeValue: "IDN267",
            gbName: "直葛（印度尼西亚）",
            gbCode: "IDN267",
            ciqCode: "360267"
        },
        {
            codeName: "直落勿洞（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN270",
            gbName: "直落勿洞（印度尼西亚）",
            gbCode: "IDN270",
            ciqCode: "360270"
        },
        {
            codeName: "淡美拉汉（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN273",
            gbName: "淡美拉汉（印度尼西亚）",
            gbCode: "IDN273",
            ciqCode: "360273"
        },
        {
            codeName: "德那第（印度尼西亚）",
            cusCode: "1176",
            codeValue: "IDN276",
            gbName: "德那第（印度尼西亚）",
            gbCode: "IDN276",
            ciqCode: "360276"
        },
        {
            codeName: "乌戎潘当（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN278",
            gbName: "乌戎潘当（印度尼西亚）",
            gbCode: "IDN278",
            ciqCode: "360278"
        },
        {
            codeName: "都保里（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN279",
            gbName: "都保里（印度尼西亚）",
            gbCode: "IDN279",
            ciqCode: "360279"
        },
        {
            codeName: "托利托利（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN282",
            gbName: "托利托利（印度尼西亚）",
            gbCode: "IDN282",
            ciqCode: "360282"
        },
        {
            codeName: "塔帕土安（印度尼西亚）",
            cusCode: "1172",
            codeValue: "IDN283",
            gbName: "塔帕土安（印度尼西亚）",
            gbCode: "IDN283",
            ciqCode: "360283"
        },
        {
            codeName: "特卢巴尤尔（印度尼西亚）",
            cusCode: "1175",
            codeValue: "IDN284",
            gbName: "特卢巴尤尔（印度尼西亚）",
            gbCode: "IDN284",
            ciqCode: "360284"
        },
        {
            codeName: "图班（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN285",
            gbName: "图班（印度尼西亚）",
            gbCode: "IDN285",
            ciqCode: "360285"
        },
        {
            codeName: "米瓦纳（印度尼西亚）",
            cusCode: "1101",
            codeValue: "IDN300",
            gbName: "米瓦纳（印度尼西亚）",
            gbCode: "IDN300",
            ciqCode: "360300"
        },
        {
            codeName: "文古尔拉（印度尼西亚）",
            cusCode: "1179",
            codeValue: "IDN302",
            gbName: "文古尔拉（印度尼西亚）",
            gbCode: "IDN302",
            ciqCode: "360302"
        },
        {
            codeName: "西姆拉（印度尼西亚）",
            cusCode: "1157",
            codeValue: "IDN303",
            gbName: "西姆拉（印度尼西亚）",
            gbCode: "IDN303",
            ciqCode: "360303"
        },
        {
            codeName: "锡卡（印度尼西亚）",
            cusCode: "1156",
            codeValue: "IDN304",
            gbName: "锡卡（印度尼西亚）",
            gbCode: "IDN304",
            ciqCode: "360304"
        },
        {
            codeName: "雅加达海港（印度尼西亚）",
            cusCode: "1170",
            codeValue: "IDN305",
            gbName: "雅加达海港（印度尼西亚）",
            gbCode: "IDN305",
            ciqCode: "360305"
        },
        {
            codeName: "爪畦岛（印度尼西亚）",
            cusCode: "1106",
            codeValue: "IDN306",
            gbName: "爪畦岛（印度尼西亚）",
            gbCode: "IDN306",
            ciqCode: "360306"
        },
        {
            codeName: "奥莱勒厄（印度尼西亚）",
            cusCode: "1129",
            codeValue: "IDN900",
            gbName: "奥莱勒厄（印度尼西亚）",
            gbCode: "IDN900",
            ciqCode: "360900"
        },
        {
            codeName: "巴淡（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN901",
            gbName: "巴淡（印度尼西亚）",
            gbCode: "IDN901",
            ciqCode: "360901"
        },
        {
            codeName: "乌戎潘生（印度尼西亚）",
            cusCode: "112",
            codeValue: "IDN902",
            gbName: "乌戎潘生（印度尼西亚）",
            gbCode: "IDN902",
            ciqCode: "360902"
        },
        {
            codeName: "马恩岛",
            cusCode: "362",
            codeValue: "IMN000",
            gbName: "马恩岛",
            gbCode: "IMN000",
            ciqCode: "833000"
        },
        {
            codeName: "印度",
            cusCode: "111",
            codeValue: "IND000",
            gbName: "印度",
            gbCode: "IND000",
            ciqCode: "356000"
        },
        {
            codeName: "阿勒皮（印度）",
            cusCode: "1040",
            codeValue: "IND003",
            gbName: "阿勒皮（印度）",
            gbCode: "IND003",
            ciqCode: "356003"
        },
        {
            codeName: "贝迪（印度）",
            cusCode: "1041",
            codeValue: "IND006",
            gbName: "贝迪（印度）",
            gbCode: "IND006",
            ciqCode: "356006"
        },
        {
            codeName: "贝莱克里（印度）",
            cusCode: "1042",
            codeValue: "IND009",
            gbName: "贝莱克里（印度）",
            gbCode: "IND009",
            ciqCode: "356009"
        },
        {
            codeName: "包纳加尔（印度）",
            cusCode: "111",
            codeValue: "IND012",
            gbName: "包纳加尔（印度）",
            gbCode: "IND012",
            ciqCode: "356012"
        },
        {
            codeName: "比穆尼帕特南（印度）",
            cusCode: "111",
            codeValue: "IND015",
            gbName: "比穆尼帕特南（印度）",
            gbCode: "IND015",
            ciqCode: "356015"
        },
        {
            codeName: "孟买（印度）",
            cusCode: "1045",
            codeValue: "IND018",
            gbName: "孟买（印度）",
            gbCode: "IND018",
            ciqCode: "356018"
        },
        {
            codeName: "加尔格答（印度）",
            cusCode: "111",
            codeValue: "IND021",
            gbName: "加尔格答（印度）",
            gbCode: "IND021",
            ciqCode: "356021"
        },
        {
            codeName: "卡利卡特（印度）",
            cusCode: "1046",
            codeValue: "IND024",
            gbName: "卡利卡特（印度）",
            gbCode: "IND024",
            ciqCode: "356024"
        },
        {
            codeName: "格灵格伯德讷姆（印度）",
            cusCode: "1047",
            codeValue: "IND027",
            gbName: "格灵格伯德讷姆（印度）",
            gbCode: "IND027",
            ciqCode: "356027"
        },
        {
            codeName: "坎纳诺尔（印度）",
            cusCode: "111",
            codeValue: "IND030",
            gbName: "坎纳诺尔（印度）",
            gbCode: "IND030",
            ciqCode: "356030"
        },
        {
            codeName: "科钦（印度）",
            cusCode: "1049",
            codeValue: "IND033",
            gbName: "科钦（印度）",
            gbCode: "IND033",
            ciqCode: "356033"
        },
        {
            codeName: "科拉歇尔（印度）",
            cusCode: "111",
            codeValue: "IND036",
            gbName: "科拉歇尔（印度）",
            gbCode: "IND036",
            ciqCode: "356036"
        },
        {
            codeName: "贡达布尔（印度）",
            cusCode: "111",
            codeValue: "IND039",
            gbName: "贡达布尔（印度）",
            gbCode: "IND039",
            ciqCode: "356039"
        },
        {
            codeName: "库达洛尔（印度）",
            cusCode: "111",
            codeValue: "IND042",
            gbName: "库达洛尔（印度）",
            gbCode: "IND042",
            ciqCode: "356042"
        },
        {
            codeName: "达曼（印度）",
            cusCode: "1050",
            codeValue: "IND045",
            gbName: "达曼（印度）",
            gbCode: "IND045",
            ciqCode: "356045"
        },
        {
            codeName: "第乌（印度）",
            cusCode: "111",
            codeValue: "IND048",
            gbName: "第乌（印度）",
            gbCode: "IND048",
            ciqCode: "356048"
        },
        {
            codeName: "杜瓦尔卡（印度）",
            cusCode: "111",
            codeValue: "IND051",
            gbName: "杜瓦尔卡（印度）",
            gbCode: "IND051",
            ciqCode: "356051"
        },
        {
            codeName: "戈巴尔布尔（印度）",
            cusCode: "111",
            codeValue: "IND054",
            gbName: "戈巴尔布尔（印度）",
            gbCode: "IND054",
            ciqCode: "356054"
        },
        {
            codeName: "霍尔迪亚（印度）",
            cusCode: "111",
            codeValue: "IND057",
            gbName: "霍尔迪亚（印度）",
            gbCode: "IND057",
            ciqCode: "356057"
        },
        {
            codeName: "霍纳沃尔（印度）",
            cusCode: "1052",
            codeValue: "IND060",
            gbName: "霍纳沃尔（印度）",
            gbCode: "IND060",
            ciqCode: "356060"
        },
        {
            codeName: "加法拉巴德（印度）",
            cusCode: "111",
            codeValue: "IND063",
            gbName: "加法拉巴德（印度）",
            gbCode: "IND063",
            ciqCode: "356063"
        },
        {
            codeName: "杰考（印度）",
            cusCode: "111",
            codeValue: "IND066",
            gbName: "杰考（印度）",
            gbCode: "IND066",
            ciqCode: "356066"
        },
        {
            codeName: "卡基纳达（印度）",
            cusCode: "1053",
            codeValue: "IND069",
            gbName: "卡基纳达（印度）",
            gbCode: "IND069",
            ciqCode: "356069"
        },
        {
            codeName: "根德拉（印度）",
            cusCode: "1054",
            codeValue: "IND072",
            gbName: "根德拉（印度）",
            gbCode: "IND072",
            ciqCode: "356072"
        },
        {
            codeName: "加里加尔（印度）",
            cusCode: "111",
            codeValue: "IND075",
            gbName: "加里加尔（印度）",
            gbCode: "IND075",
            ciqCode: "356075"
        },
        {
            codeName: "加尔瓦尔（印度）",
            cusCode: "1055",
            codeValue: "IND078",
            gbName: "加尔瓦尔（印度）",
            gbCode: "IND078",
            ciqCode: "356078"
        },
        {
            codeName: "默吉利伯德讷姆（印度）",
            cusCode: "111",
            codeValue: "IND081",
            gbName: "默吉利伯德讷姆（印度）",
            gbCode: "IND081",
            ciqCode: "356081"
        },
        {
            codeName: "金奈（印度）",
            cusCode: "1057",
            codeValue: "IND084",
            gbName: "金奈（印度）",
            gbCode: "IND084",
            ciqCode: "356084"
        },
        {
            codeName: "马埃（印度）",
            cusCode: "1061",
            codeValue: "IND087",
            gbName: "马埃（印度）",
            gbCode: "IND087",
            ciqCode: "356087"
        },
        {
            codeName: "马苏利帕特南（印度）",
            cusCode: "1062",
            codeValue: "IND088",
            gbName: "马苏利帕特南（印度）",
            gbCode: "IND088",
            ciqCode: "356088"
        },
        {
            codeName: "马尔佩（印度）",
            cusCode: "1058",
            codeValue: "IND090",
            gbName: "马尔佩（印度）",
            gbCode: "IND090",
            ciqCode: "356090"
        },
        {
            codeName: "曼达帕姆（印度）",
            cusCode: "111",
            codeValue: "IND093",
            gbName: "曼达帕姆（印度）",
            gbCode: "IND093",
            ciqCode: "356093"
        },
        {
            codeName: "曼德维（印度）",
            cusCode: "1059",
            codeValue: "IND096",
            gbName: "曼德维（印度）",
            gbCode: "IND096",
            ciqCode: "356096"
        },
        {
            codeName: "芒格洛尔（印度）",
            cusCode: "1060",
            codeValue: "IND099",
            gbName: "芒格洛尔（印度）",
            gbCode: "IND099",
            ciqCode: "356099"
        },
        {
            codeName: "曼格罗尔（印度）",
            cusCode: "111",
            codeValue: "IND102",
            gbName: "曼格罗尔（印度）",
            gbCode: "IND102",
            ciqCode: "356102"
        },
        {
            codeName: "米尼科伊岛（印度）",
            cusCode: "111",
            codeValue: "IND105",
            gbName: "米尼科伊岛（印度）",
            gbCode: "IND105",
            ciqCode: "356105"
        },
        {
            codeName: "莫尔穆冈（印度）",
            cusCode: "1063",
            codeValue: "IND108",
            gbName: "莫尔穆冈（印度）",
            gbCode: "IND108",
            ciqCode: "356108"
        },
        {
            codeName: "蒙德拉（印度）",
            cusCode: "111",
            codeValue: "IND111",
            gbName: "蒙德拉（印度）",
            gbCode: "IND111",
            ciqCode: "356111"
        },
        {
            codeName: "纳加伯蒂讷姆（印度）",
            cusCode: "1064",
            codeValue: "IND114",
            gbName: "纳加伯蒂讷姆（印度）",
            gbCode: "IND114",
            ciqCode: "356114"
        },
        {
            codeName: "瑙勒基（印度）",
            cusCode: "1065",
            codeValue: "IND117",
            gbName: "瑙勒基（印度）",
            gbCode: "IND117",
            ciqCode: "356117"
        },
        {
            codeName: "新芒格洛尔（印度）",
            cusCode: "111",
            codeValue: "IND120",
            gbName: "新芒格洛尔（印度）",
            gbCode: "IND120",
            ciqCode: "356120"
        },
        {
            codeName: "哈瓦舍瓦（尼赫鲁）（印度）",
            cusCode: "111",
            codeValue: "IND122",
            gbName: "哈瓦舍瓦（尼赫鲁）（印度）",
            gbCode: "IND122",
            ciqCode: "356122"
        },
        {
            codeName: "新土提科林（印度）",
            cusCode: "1078",
            codeValue: "IND123",
            gbName: "新土提科林（印度）",
            gbCode: "IND123",
            ciqCode: "356123"
        },
        {
            codeName: "班本（印度）",
            cusCode: "111",
            codeValue: "IND126",
            gbName: "班本（印度）",
            gbCode: "IND126",
            ciqCode: "356126"
        },
        {
            codeName: "潘吉姆（印度）",
            cusCode: "1066",
            codeValue: "IND129",
            gbName: "潘吉姆（印度）",
            gbCode: "IND129",
            ciqCode: "356129"
        },
        {
            codeName: "巴拉迪布（印度）",
            cusCode: "1072",
            codeValue: "IND132",
            gbName: "巴拉迪布（印度）",
            gbCode: "IND132",
            ciqCode: "356132"
        },
        {
            codeName: "本地治里（印度）",
            cusCode: "1069",
            codeValue: "IND135",
            gbName: "本地治里（印度）",
            gbCode: "IND135",
            ciqCode: "356135"
        },
        {
            codeName: "博尔本德尔（印度）",
            cusCode: "1073",
            codeValue: "IND138",
            gbName: "博尔本德尔（印度）",
            gbCode: "IND138",
            ciqCode: "356138"
        },
        {
            codeName: "布莱尔港（印度）",
            cusCode: "1070",
            codeValue: "IND141",
            gbName: "布莱尔港（印度）",
            gbCode: "IND141",
            ciqCode: "356141"
        },
        {
            codeName: "奥卡港（印度）",
            cusCode: "1071",
            codeValue: "IND144",
            gbName: "奥卡港（印度）",
            gbCode: "IND144",
            ciqCode: "356144"
        },
        {
            codeName: "波多诺伏港（印度）",
            cusCode: "111",
            codeValue: "IND147",
            gbName: "波多诺伏港（印度）",
            gbCode: "IND147",
            ciqCode: "356147"
        },
        {
            codeName: "普里（印度）",
            cusCode: "111",
            codeValue: "IND150",
            gbName: "普里（印度）",
            gbCode: "IND150",
            ciqCode: "356150"
        },
        {
            codeName: "奎隆（印度）",
            cusCode: "1075",
            codeValue: "IND153",
            gbName: "奎隆（印度）",
            gbCode: "IND153",
            ciqCode: "356153"
        },
        {
            codeName: "勒德纳吉里（印度）",
            cusCode: "111",
            codeValue: "IND156",
            gbName: "勒德纳吉里（印度）",
            gbCode: "IND156",
            ciqCode: "356156"
        },
        {
            codeName: "雷迪（印度）",
            cusCode: "1074",
            codeValue: "IND159",
            gbName: "雷迪（印度）",
            gbCode: "IND159",
            ciqCode: "356159"
        },
        {
            codeName: "瑟拉亚（印度）",
            cusCode: "111",
            codeValue: "IND162",
            gbName: "瑟拉亚（印度）",
            gbCode: "IND162",
            ciqCode: "356162"
        },
        {
            codeName: "色纳加尔（印度）",
            cusCode: "1043",
            codeValue: "IND163",
            gbName: "色纳加尔（印度）",
            gbCode: "IND163",
            ciqCode: "356163"
        },
        {
            codeName: "锡卡（印度）",
            cusCode: "111",
            codeValue: "IND165",
            gbName: "锡卡（印度）",
            gbCode: "IND165",
            ciqCode: "356165"
        },
        {
            codeName: "新德里（印度）",
            cusCode: "1067",
            codeValue: "IND166",
            gbName: "新德里（印度）",
            gbCode: "IND166",
            ciqCode: "356166"
        },
        {
            codeName: "苏拉特（印度）",
            cusCode: "111",
            codeValue: "IND168",
            gbName: "苏拉特（印度）",
            gbCode: "IND168",
            ciqCode: "356168"
        },
        {
            codeName: "塔德里（印度）",
            cusCode: "1076",
            codeValue: "IND169",
            gbName: "塔德里（印度）",
            gbCode: "IND169",
            ciqCode: "356169"
        },
        {
            codeName: "代利杰里（印度）",
            cusCode: "1077",
            codeValue: "IND171",
            gbName: "代利杰里（印度）",
            gbCode: "IND171",
            ciqCode: "356171"
        },
        {
            codeName: "特里凡得琅（印度）",
            cusCode: "111",
            codeValue: "IND174",
            gbName: "特里凡得琅（印度）",
            gbCode: "IND174",
            ciqCode: "356174"
        },
        {
            codeName: "杜蒂戈林（印度）",
            cusCode: "111",
            codeValue: "IND177",
            gbName: "杜蒂戈林（印度）",
            gbCode: "IND177",
            ciqCode: "356177"
        },
        {
            codeName: "文古尔拉（印度）",
            cusCode: "111",
            codeValue: "IND180",
            gbName: "文古尔拉（印度）",
            gbCode: "IND180",
            ciqCode: "356180"
        },
        {
            codeName: "韦拉沃尔（印度）",
            cusCode: "1079",
            codeValue: "IND183",
            gbName: "韦拉沃尔（印度）",
            gbCode: "IND183",
            ciqCode: "356183"
        },
        {
            codeName: "维沙卡帕特南（印度）",
            cusCode: "1080",
            codeValue: "IND186",
            gbName: "维沙卡帕特南（印度）",
            gbCode: "IND186",
            ciqCode: "356186"
        },
        {
            codeName: "德里（印度）",
            cusCode: "1051",
            codeValue: "IND901",
            gbName: "德里（印度）",
            gbCode: "IND901",
            ciqCode: "356901"
        },
        {
            codeName: "加尔各答（印度）",
            cusCode: "1044",
            codeValue: "IND904",
            gbName: "加尔各答（印度）",
            gbCode: "IND904",
            ciqCode: "356904"
        },
        {
            codeName: "班加罗尔（印度）",
            cusCode: "111",
            codeValue: "IND907",
            gbName: "班加罗尔（印度）",
            gbCode: "IND907",
            ciqCode: "356907"
        },
        {
            codeName: "英属印度洋领地",
            cusCode: "262",
            codeValue: "IOT000",
            gbName: "英属印度洋领地",
            gbCode: "IOT000",
            ciqCode: "086000"
        },
        {
            codeName: "爱尔兰",
            cusCode: "306",
            codeValue: "IRL000",
            gbName: "爱尔兰",
            gbCode: "IRL000",
            ciqCode: "372000"
        },
        {
            codeName: "阿克洛（爱尔兰）",
            cusCode: "2200",
            codeValue: "IRL003",
            gbName: "阿克洛（爱尔兰）",
            gbCode: "IRL003",
            ciqCode: "372003"
        },
        {
            codeName: "巴尔布里根（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL006",
            gbName: "巴尔布里根（爱尔兰）",
            gbCode: "IRL006",
            ciqCode: "372006"
        },
        {
            codeName: "巴利纳（爱尔兰）",
            cusCode: "2201",
            codeValue: "IRL009",
            gbName: "巴利纳（爱尔兰）",
            gbCode: "IRL009",
            ciqCode: "372009"
        },
        {
            codeName: "巴尔的摩（爱尔兰）",
            cusCode: "2202",
            codeValue: "IRL012",
            gbName: "巴尔的摩（爱尔兰）",
            gbCode: "IRL012",
            ciqCode: "372012"
        },
        {
            codeName: "班特里（爱尔兰）",
            cusCode: "2203",
            codeValue: "IRL015",
            gbName: "班特里（爱尔兰）",
            gbCode: "IRL015",
            ciqCode: "372015"
        },
        {
            codeName: "伯顿波特（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL018",
            gbName: "伯顿波特（爱尔兰）",
            gbCode: "IRL018",
            ciqCode: "372018"
        },
        {
            codeName: "克尔西文（爱尔兰）",
            cusCode: "2204",
            codeValue: "IRL021",
            gbName: "克尔西文（爱尔兰）",
            gbCode: "IRL021",
            ciqCode: "372021"
        },
        {
            codeName: "卡斯尔顿贝尔（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL024",
            gbName: "卡斯尔顿贝尔（爱尔兰）",
            gbCode: "IRL024",
            ciqCode: "372024"
        },
        {
            codeName: "克莱尔卡斯尔（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL027",
            gbName: "克莱尔卡斯尔（爱尔兰）",
            gbCode: "IRL027",
            ciqCode: "372027"
        },
        {
            codeName: "克洛纳基尔蒂（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL030",
            gbName: "克洛纳基尔蒂（爱尔兰）",
            gbCode: "IRL030",
            ciqCode: "372030"
        },
        {
            codeName: "科夫（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL033",
            gbName: "科夫（爱尔兰）",
            gbCode: "IRL033",
            ciqCode: "372033"
        },
        {
            codeName: "科克（爱尔兰）",
            cusCode: "2206",
            codeValue: "IRL036",
            gbName: "科克（爱尔兰）",
            gbCode: "IRL036",
            ciqCode: "372036"
        },
        {
            codeName: "多尼戈尔（爱尔兰）",
            cusCode: "2208",
            codeValue: "IRL039",
            gbName: "多尼戈尔（爱尔兰）",
            gbCode: "IRL039",
            ciqCode: "372039"
        },
        {
            codeName: "德罗赫达（爱尔兰）",
            cusCode: "2209",
            codeValue: "IRL042",
            gbName: "德罗赫达（爱尔兰）",
            gbCode: "IRL042",
            ciqCode: "372042"
        },
        {
            codeName: "都柏林（爱尔兰）",
            cusCode: "2210",
            codeValue: "IRL045",
            gbName: "都柏林（爱尔兰）",
            gbCode: "IRL045",
            ciqCode: "372045"
        },
        {
            codeName: "邓莱里（爱尔兰）",
            cusCode: "2211",
            codeValue: "IRL048",
            gbName: "邓莱里（爱尔兰）",
            gbCode: "IRL048",
            ciqCode: "372048"
        },
        {
            codeName: "邓坎嫩（爱尔兰）",
            cusCode: "2212",
            codeValue: "IRL051",
            gbName: "邓坎嫩（爱尔兰）",
            gbCode: "IRL051",
            ciqCode: "372051"
        },
        {
            codeName: "邓多克（爱尔兰）",
            cusCode: "2213",
            codeValue: "IRL054",
            gbName: "邓多克（爱尔兰）",
            gbCode: "IRL054",
            ciqCode: "372054"
        },
        {
            codeName: "邓加文（爱尔兰）",
            cusCode: "2207",
            codeValue: "IRL057",
            gbName: "邓加文（爱尔兰）",
            gbCode: "IRL057",
            ciqCode: "372057"
        },
        {
            codeName: "邓莫尔（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL060",
            gbName: "邓莫尔（爱尔兰）",
            gbCode: "IRL060",
            ciqCode: "372060"
        },
        {
            codeName: "费尼特（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL063",
            gbName: "费尼特（爱尔兰）",
            gbCode: "IRL063",
            ciqCode: "372063"
        },
        {
            codeName: "福因斯（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL066",
            gbName: "福因斯（爱尔兰）",
            gbCode: "IRL066",
            ciqCode: "372066"
        },
        {
            codeName: "戈尔韦（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL069",
            gbName: "戈尔韦（爱尔兰）",
            gbCode: "IRL069",
            ciqCode: "372069"
        },
        {
            codeName: "格里诺尔（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL072",
            gbName: "格里诺尔（爱尔兰）",
            gbCode: "IRL072",
            ciqCode: "372072"
        },
        {
            codeName: "霍思（爱尔兰）",
            cusCode: "2214",
            codeValue: "IRL075",
            gbName: "霍思（爱尔兰）",
            gbCode: "IRL075",
            ciqCode: "372075"
        },
        {
            codeName: "基拉拉（爱尔兰）",
            cusCode: "2215",
            codeValue: "IRL078",
            gbName: "基拉拉（爱尔兰）",
            gbCode: "IRL078",
            ciqCode: "372078"
        },
        {
            codeName: "基利贝格斯（爱尔兰）",
            cusCode: "2216",
            codeValue: "IRL081",
            gbName: "基利贝格斯（爱尔兰）",
            gbCode: "IRL081",
            ciqCode: "372081"
        },
        {
            codeName: "基尔罗南（爱尔兰）",
            cusCode: "2218",
            codeValue: "IRL084",
            gbName: "基尔罗南（爱尔兰）",
            gbCode: "IRL084",
            ciqCode: "372084"
        },
        {
            codeName: "基尔拉什（爱尔兰）",
            cusCode: "2219",
            codeValue: "IRL087",
            gbName: "基尔拉什（爱尔兰）",
            gbCode: "IRL087",
            ciqCode: "372087"
        },
        {
            codeName: "金塞尔（爱尔兰）",
            cusCode: "2220",
            codeValue: "IRL090",
            gbName: "金塞尔（爱尔兰）",
            gbCode: "IRL090",
            ciqCode: "372090"
        },
        {
            codeName: "利默里克（爱尔兰）",
            cusCode: "2221",
            codeValue: "IRL093",
            gbName: "利默里克（爱尔兰）",
            gbCode: "IRL093",
            ciqCode: "372093"
        },
        {
            codeName: "莫维尔（爱尔兰）",
            cusCode: "2222",
            codeValue: "IRL096",
            gbName: "莫维尔（爱尔兰）",
            gbCode: "IRL096",
            ciqCode: "372096"
        },
        {
            codeName: "新罗斯（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL099",
            gbName: "新罗斯（爱尔兰）",
            gbCode: "IRL099",
            ciqCode: "372099"
        },
        {
            codeName: "拉斯马伦（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL102",
            gbName: "拉斯马伦（爱尔兰）",
            gbCode: "IRL102",
            ciqCode: "372102"
        },
        {
            codeName: "罗斯莱尔（爱尔兰）",
            cusCode: "2224",
            codeValue: "IRL105",
            gbName: "罗斯莱尔（爱尔兰）",
            gbCode: "IRL105",
            ciqCode: "372105"
        },
        {
            codeName: "斯卡尔（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL108",
            gbName: "斯卡尔（爱尔兰）",
            gbCode: "IRL108",
            ciqCode: "372108"
        },
        {
            codeName: "斯莱戈（爱尔兰）",
            cusCode: "2225",
            codeValue: "IRL111",
            gbName: "斯莱戈（爱尔兰）",
            gbCode: "IRL111",
            ciqCode: "372111"
        },
        {
            codeName: "特拉利（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL114",
            gbName: "特拉利（爱尔兰）",
            gbCode: "IRL114",
            ciqCode: "372114"
        },
        {
            codeName: "瓦伦西亚（爱尔兰）",
            cusCode: "2226",
            codeValue: "IRL117",
            gbName: "瓦伦西亚（爱尔兰）",
            gbCode: "IRL117",
            ciqCode: "372117"
        },
        {
            codeName: "沃特福德（爱尔兰）",
            cusCode: "2227",
            codeValue: "IRL120",
            gbName: "沃特福德（爱尔兰）",
            gbCode: "IRL120",
            ciqCode: "372120"
        },
        {
            codeName: "韦克斯福德（爱尔兰）",
            cusCode: "306",
            codeValue: "IRL123",
            gbName: "韦克斯福德（爱尔兰）",
            gbCode: "IRL123",
            ciqCode: "372123"
        },
        {
            codeName: "威克洛（爱尔兰）",
            cusCode: "2229",
            codeValue: "IRL126",
            gbName: "威克洛（爱尔兰）",
            gbCode: "IRL126",
            ciqCode: "372126"
        },
        {
            codeName: "约尔（爱尔兰）",
            cusCode: "2230",
            codeValue: "IRL129",
            gbName: "约尔（爱尔兰）",
            gbCode: "IRL129",
            ciqCode: "372129"
        },
        {
            codeName: "基尔马西蒙港（爱尔兰）",
            cusCode: "2217",
            codeValue: "IRL130",
            gbName: "基尔马西蒙港（爱尔兰）",
            gbCode: "IRL130",
            ciqCode: "372130"
        },
        {
            codeName: "克里弗登（爱尔兰）",
            cusCode: "2205",
            codeValue: "IRL131",
            gbName: "克里弗登（爱尔兰）",
            gbCode: "IRL131",
            ciqCode: "372131"
        },
        {
            codeName: "马尔罗伊（爱尔兰）",
            cusCode: "2223",
            codeValue: "IRL132",
            gbName: "马尔罗伊（爱尔兰）",
            gbCode: "IRL132",
            ciqCode: "372132"
        },
        {
            codeName: "韦斯特波特（爱尔兰）",
            cusCode: "2228",
            codeValue: "IRL133",
            gbName: "韦斯特波特（爱尔兰）",
            gbCode: "IRL133",
            ciqCode: "372133"
        },
        {
            codeName: "伊朗",
            cusCode: "113",
            codeValue: "IRN000",
            gbName: "伊朗",
            gbCode: "IRN000",
            ciqCode: "364000"
        },
        {
            codeName: "阿巴丹（伊朗）",
            cusCode: "1180",
            codeValue: "IRN003",
            gbName: "阿巴丹（伊朗）",
            gbCode: "IRN003",
            ciqCode: "364003"
        },
        {
            codeName: "阿巴斯港（伊朗）",
            cusCode: "1183",
            codeValue: "IRN006",
            gbName: "阿巴斯港（伊朗）",
            gbCode: "IRN006",
            ciqCode: "364006"
        },
        {
            codeName: "霍梅尼港（伊朗）",
            cusCode: "113",
            codeValue: "IRN009",
            gbName: "霍梅尼港（伊朗）",
            gbCode: "IRN009",
            ciqCode: "364009"
        },
        {
            codeName: "马赫沙赫尔港（伊朗）",
            cusCode: "1184",
            codeValue: "IRN012",
            gbName: "马赫沙赫尔港（伊朗）",
            gbCode: "IRN012",
            ciqCode: "364012"
        },
        {
            codeName: "布什尔（伊朗）",
            cusCode: "113",
            codeValue: "IRN015",
            gbName: "布什尔（伊朗）",
            gbCode: "IRN015",
            ciqCode: "364015"
        },
        {
            codeName: "居鲁士码头（伊朗）",
            cusCode: "113",
            codeValue: "IRN018",
            gbName: "居鲁士码头（伊朗）",
            gbCode: "IRN018",
            ciqCode: "364018"
        },
        {
            codeName: "贾斯克（伊朗）",
            cusCode: "113",
            codeValue: "IRN021",
            gbName: "贾斯克（伊朗）",
            gbCode: "IRN021",
            ciqCode: "364021"
        },
        {
            codeName: "恰赫巴哈尔（伊朗）",
            cusCode: "113",
            codeValue: "IRN023",
            gbName: "恰赫巴哈尔（伊朗）",
            gbCode: "IRN023",
            ciqCode: "364023"
        },
        {
            codeName: "哈尔克岛（伊朗）",
            cusCode: "1186",
            codeValue: "IRN024",
            gbName: "哈尔克岛（伊朗）",
            gbCode: "IRN024",
            ciqCode: "364024"
        },
        {
            codeName: "胡宁沙赫尔（伊朗）",
            cusCode: "1187",
            codeValue: "IRN027",
            gbName: "胡宁沙赫尔（伊朗）",
            gbCode: "IRN027",
            ciqCode: "364027"
        },
        {
            codeName: "拉万岛（伊朗）",
            cusCode: "113",
            codeValue: "IRN030",
            gbName: "拉万岛（伊朗）",
            gbCode: "IRN030",
            ciqCode: "364030"
        },
        {
            codeName: "林格（伊朗）",
            cusCode: "113",
            codeValue: "IRN033",
            gbName: "林格（伊朗）",
            gbCode: "IRN033",
            ciqCode: "364033"
        },
        {
            codeName: "巴里根角（伊朗）",
            cusCode: "113",
            codeValue: "IRN036",
            gbName: "巴里根角（伊朗）",
            gbCode: "IRN036",
            ciqCode: "364036"
        },
        {
            codeName: "大不里士（伊朗）",
            cusCode: "1190",
            codeValue: "IRN040",
            gbName: "大不里士（伊朗）",
            gbCode: "IRN040",
            ciqCode: "364040"
        },
        {
            codeName: "帕勒维（伊朗）",
            cusCode: "1192",
            codeValue: "IRN042",
            gbName: "帕勒维（伊朗）",
            gbCode: "IRN042",
            ciqCode: "364042"
        },
        {
            codeName: "沙赫普尔港（伊朗）",
            cusCode: "1185",
            codeValue: "IRN043",
            gbName: "沙赫普尔港（伊朗）",
            gbCode: "IRN043",
            ciqCode: "364043"
        },
        {
            codeName: "德黑兰（伊朗）",
            cusCode: "1191",
            codeValue: "IRN901",
            gbName: "德黑兰（伊朗）",
            gbCode: "IRN901",
            ciqCode: "364901"
        },
        {
            codeName: "伊拉克",
            cusCode: "114",
            codeValue: "IRQ000",
            gbName: "伊拉克",
            gbCode: "IRQ000",
            ciqCode: "368000"
        },
        {
            codeName: "巴士拉（伊拉克）",
            cusCode: "1194",
            codeValue: "IRQ003",
            gbName: "巴士拉（伊拉克）",
            gbCode: "IRQ003",
            ciqCode: "368003"
        },
        {
            codeName: "法奥（伊拉克）",
            cusCode: "1201",
            codeValue: "IRQ006",
            gbName: "法奥（伊拉克）",
            gbCode: "IRQ006",
            ciqCode: "368006"
        },
        {
            codeName: "豪尔艾迈耶（伊拉克）",
            cusCode: "114",
            codeValue: "IRQ009",
            gbName: "豪尔艾迈耶（伊拉克）",
            gbCode: "IRQ009",
            ciqCode: "368009"
        },
        {
            codeName: "阿巴克（伊拉克）",
            cusCode: "114",
            codeValue: "IRQ012",
            gbName: "阿巴克（伊拉克）",
            gbCode: "IRQ012",
            ciqCode: "368012"
        },
        {
            codeName: "乌姆盖斯尔（伊拉克）",
            cusCode: "1199",
            codeValue: "IRQ015",
            gbName: "乌姆盖斯尔（伊拉克）",
            gbCode: "IRQ015",
            ciqCode: "368015"
        },
        {
            codeName: "ZUBAIR（伊拉克）",
            cusCode: "1200",
            codeValue: "IRQ016",
            gbName: "ZUBAIR（伊拉克）",
            gbCode: "IRQ016",
            ciqCode: "368016"
        },
        {
            codeName: "霍尔阿米亚（伊拉克）",
            cusCode: "1195",
            codeValue: "IRQ018",
            gbName: "霍尔阿米亚（伊拉克）",
            gbCode: "IRQ018",
            ciqCode: "368018"
        },
        {
            codeName: "基尔库克（伊拉克）",
            cusCode: "1196",
            codeValue: "IRQ019",
            gbName: "基尔库克（伊拉克）",
            gbCode: "IRQ019",
            ciqCode: "368019"
        },
        {
            codeName: "摩苏尔（伊拉克）",
            cusCode: "1197",
            codeValue: "IRQ020",
            gbName: "摩苏尔（伊拉克）",
            gbCode: "IRQ020",
            ciqCode: "368020"
        },
        {
            codeName: "巴格达（伊拉克）",
            cusCode: "1193",
            codeValue: "IRQ901",
            gbName: "巴格达（伊拉克）",
            gbCode: "IRQ901",
            ciqCode: "368901"
        },
        {
            codeName: "冰岛",
            cusCode: "322",
            codeValue: "ISL000",
            gbName: "冰岛",
            gbCode: "ISL000",
            ciqCode: "352000"
        },
        {
            codeName: "阿克拉内斯（冰岛）",
            cusCode: "322",
            codeValue: "ISL003",
            gbName: "阿克拉内斯（冰岛）",
            gbCode: "ISL003",
            ciqCode: "352003"
        },
        {
            codeName: "阿克雷里（冰岛）",
            cusCode: "2462",
            codeValue: "ISL006",
            gbName: "阿克雷里（冰岛）",
            gbCode: "ISL006",
            ciqCode: "352006"
        },
        {
            codeName: "哈布纳菲厄泽（冰岛）",
            cusCode: "322",
            codeValue: "ISL009",
            gbName: "哈布纳菲厄泽（冰岛）",
            gbCode: "ISL009",
            ciqCode: "352009"
        },
        {
            codeName: "胡萨维克（冰岛）",
            cusCode: "322",
            codeValue: "ISL012",
            gbName: "胡萨维克（冰岛）",
            gbCode: "ISL012",
            ciqCode: "352012"
        },
        {
            codeName: "伊萨菲厄泽（冰岛）",
            cusCode: "322",
            codeValue: "ISL015",
            gbName: "伊萨菲厄泽（冰岛）",
            gbCode: "ISL015",
            ciqCode: "352015"
        },
        {
            codeName: "凯夫拉维克（冰岛）",
            cusCode: "2463",
            codeValue: "ISL018",
            gbName: "凯夫拉维克（冰岛）",
            gbCode: "ISL018",
            ciqCode: "352018"
        },
        {
            codeName: "内斯克伊斯塔泽（冰岛）",
            cusCode: "322",
            codeValue: "ISL021",
            gbName: "内斯克伊斯塔泽（冰岛）",
            gbCode: "ISL021",
            ciqCode: "352021"
        },
        {
            codeName: "帕特雷克峡湾（冰岛）",
            cusCode: "322",
            codeValue: "ISL024",
            gbName: "帕特雷克峡湾（冰岛）",
            gbCode: "ISL024",
            ciqCode: "352024"
        },
        {
            codeName: "雷克雅末克（冰岛）",
            cusCode: "2464",
            codeValue: "ISL027",
            gbName: "雷克雅末克（冰岛）",
            gbCode: "ISL027",
            ciqCode: "352027"
        },
        {
            codeName: "塞济斯菲厄泽（冰岛）",
            cusCode: "2465",
            codeValue: "ISL030",
            gbName: "塞济斯菲厄泽（冰岛）",
            gbCode: "ISL030",
            ciqCode: "352030"
        },
        {
            codeName: "锡格吕菲厄泽（冰岛）",
            cusCode: "322",
            codeValue: "ISL033",
            gbName: "锡格吕菲厄泽（冰岛）",
            gbCode: "ISL033",
            ciqCode: "352033"
        },
        {
            codeName: "斯卡加斯特伦（冰岛）",
            cusCode: "322",
            codeValue: "ISL036",
            gbName: "斯卡加斯特伦（冰岛）",
            gbCode: "ISL036",
            ciqCode: "352036"
        },
        {
            codeName: "斯特勒伊姆维克（冰岛）",
            cusCode: "2466",
            codeValue: "ISL039",
            gbName: "斯特勒伊姆维克（冰岛）",
            gbCode: "ISL039",
            ciqCode: "352039"
        },
        {
            codeName: "韦斯特曼纳岛（冰岛）",
            cusCode: "2467",
            codeValue: "ISL042",
            gbName: "韦斯特曼纳岛（冰岛）",
            gbCode: "ISL042",
            ciqCode: "352042"
        },
        {
            codeName: "以色列",
            cusCode: "115",
            codeValue: "ISR000",
            gbName: "以色列",
            gbCode: "ISR000",
            ciqCode: "376000"
        },
        {
            codeName: "阿卡（以色列）",
            cusCode: "115",
            codeValue: "ISR003",
            gbName: "阿卡（以色列）",
            gbCode: "ISR003",
            ciqCode: "376003"
        },
        {
            codeName: "阿什杜德（以色列）",
            cusCode: "3455",
            codeValue: "ISR006",
            gbName: "阿什杜德（以色列）",
            gbCode: "ISR006",
            ciqCode: "376006"
        },
        {
            codeName: "阿什克伦（以色列）",
            cusCode: "115",
            codeValue: "ISR009",
            gbName: "阿什克伦（以色列）",
            gbCode: "ISR009",
            ciqCode: "376009"
        },
        {
            codeName: "埃拉特（以色列）",
            cusCode: "115",
            codeValue: "ISR012",
            gbName: "埃拉特（以色列）",
            gbCode: "ISR012",
            ciqCode: "376012"
        },
        {
            codeName: "哈代拉（以色列）",
            cusCode: "115",
            codeValue: "ISR015",
            gbName: "哈代拉（以色列）",
            gbCode: "ISR015",
            ciqCode: "376015"
        },
        {
            codeName: "海法（以色列）",
            cusCode: "115",
            codeValue: "ISR018",
            gbName: "海法（以色列）",
            gbCode: "ISR018",
            ciqCode: "376018"
        },
        {
            codeName: "特拉维夫-雅法（以色列）",
            cusCode: "115",
            codeValue: "ISR024",
            gbName: "特拉维夫-雅法（以色列）",
            gbCode: "ISR024",
            ciqCode: "376024"
        },
        {
            codeName: "意大利",
            cusCode: "307",
            codeValue: "ITA000",
            gbName: "意大利",
            gbCode: "ITA000",
            ciqCode: "380000"
        },
        {
            codeName: "阿尔盖罗（意大利）",
            cusCode: "307",
            codeValue: "ITA003",
            gbName: "阿尔盖罗（意大利）",
            gbCode: "ITA003",
            ciqCode: "380003"
        },
        {
            codeName: "安科纳（意大利）",
            cusCode: "2231",
            codeValue: "ITA006",
            gbName: "安科纳（意大利）",
            gbCode: "ITA006",
            ciqCode: "380006"
        },
        {
            codeName: "安齐奥（意大利）",
            cusCode: "2232",
            codeValue: "ITA009",
            gbName: "安齐奥（意大利）",
            gbCode: "ITA009",
            ciqCode: "380009"
        },
        {
            codeName: "阿尔巴塔克斯（意大利）",
            cusCode: "307",
            codeValue: "ITA012",
            gbName: "阿尔巴塔克斯（意大利）",
            gbCode: "ITA012",
            ciqCode: "380012"
        },
        {
            codeName: "奥古斯塔（意大利）",
            cusCode: "2233",
            codeValue: "ITA015",
            gbName: "奥古斯塔（意大利）",
            gbCode: "ITA015",
            ciqCode: "380015"
        },
        {
            codeName: "阿沃拉（意大利）",
            cusCode: "2234",
            codeValue: "ITA018",
            gbName: "阿沃拉（意大利）",
            gbCode: "ITA018",
            ciqCode: "380018"
        },
        {
            codeName: "巴尼奥利（意大利）",
            cusCode: "2235",
            codeValue: "ITA021",
            gbName: "巴尼奥利（意大利）",
            gbCode: "ITA021",
            ciqCode: "380021"
        },
        {
            codeName: "巴里（意大利）",
            cusCode: "2236",
            codeValue: "ITA024",
            gbName: "巴里（意大利）",
            gbCode: "ITA024",
            ciqCode: "380024"
        },
        {
            codeName: "巴列塔（意大利）",
            cusCode: "2237",
            codeValue: "ITA027",
            gbName: "巴列塔（意大利）",
            gbCode: "ITA027",
            ciqCode: "380027"
        },
        {
            codeName: "布林迪西（意大利）",
            cusCode: "2239",
            codeValue: "ITA030",
            gbName: "布林迪西（意大利）",
            gbCode: "ITA030",
            ciqCode: "380030"
        },
        {
            codeName: "卡利亚里（意大利）",
            cusCode: "2240",
            codeValue: "ITA033",
            gbName: "卡利亚里（意大利）",
            gbCode: "ITA033",
            ciqCode: "380033"
        },
        {
            codeName: "卡洛福泰（意大利）",
            cusCode: "2241",
            codeValue: "ITA036",
            gbName: "卡洛福泰（意大利）",
            gbCode: "ITA036",
            ciqCode: "380036"
        },
        {
            codeName: "斯塔比亚海堡（意大利）",
            cusCode: "307",
            codeValue: "ITA039",
            gbName: "斯塔比亚海堡（意大利）",
            gbCode: "ITA039",
            ciqCode: "380039"
        },
        {
            codeName: "卡塔尼亚（意大利）",
            cusCode: "307",
            codeValue: "ITA042",
            gbName: "卡塔尼亚（意大利）",
            gbCode: "ITA042",
            ciqCode: "380042"
        },
        {
            codeName: "卡坦扎罗（意大利）",
            cusCode: "307",
            codeValue: "ITA045",
            gbName: "卡坦扎罗（意大利）",
            gbCode: "ITA045",
            ciqCode: "380045"
        },
        {
            codeName: "基奥贾（意大利）",
            cusCode: "307",
            codeValue: "ITA048",
            gbName: "基奥贾（意大利）",
            gbCode: "ITA048",
            ciqCode: "380048"
        },
        {
            codeName: "奇维塔韦基亚（意大利）",
            cusCode: "2242",
            codeValue: "ITA051",
            gbName: "奇维塔韦基亚（意大利）",
            gbCode: "ITA051",
            ciqCode: "380051"
        },
        {
            codeName: "克罗托内（意大利）",
            cusCode: "2243",
            codeValue: "ITA054",
            gbName: "克罗托内（意大利）",
            gbCode: "ITA054",
            ciqCode: "380054"
        },
        {
            codeName: "法尔科纳拉（意大利）",
            cusCode: "307",
            codeValue: "ITA056",
            gbName: "法尔科纳拉（意大利）",
            gbCode: "ITA056",
            ciqCode: "380056"
        },
        {
            codeName: "菲乌米奇诺（意大利）",
            cusCode: "307",
            codeValue: "ITA057",
            gbName: "菲乌米奇诺（意大利）",
            gbCode: "ITA057",
            ciqCode: "380057"
        },
        {
            codeName: "福洛尼卡（意大利）",
            cusCode: "307",
            codeValue: "ITA060",
            gbName: "福洛尼卡（意大利）",
            gbCode: "ITA060",
            ciqCode: "380060"
        },
        {
            codeName: "福尔米亚（意大利）",
            cusCode: "307",
            codeValue: "ITA063",
            gbName: "福尔米亚（意大利）",
            gbCode: "ITA063",
            ciqCode: "380063"
        },
        {
            codeName: "加埃塔（意大利）",
            cusCode: "307",
            codeValue: "ITA066",
            gbName: "加埃塔（意大利）",
            gbCode: "ITA066",
            ciqCode: "380066"
        },
        {
            codeName: "加利波利（意大利）",
            cusCode: "307",
            codeValue: "ITA069",
            gbName: "加利波利（意大利）",
            gbCode: "ITA069",
            ciqCode: "380069"
        },
        {
            codeName: "杰拉（意大利）",
            cusCode: "307",
            codeValue: "ITA072",
            gbName: "杰拉（意大利）",
            gbCode: "ITA072",
            ciqCode: "380072"
        },
        {
            codeName: "热那亚（意大利）",
            cusCode: "2245",
            codeValue: "ITA075",
            gbName: "热那亚（意大利）",
            gbCode: "ITA075",
            ciqCode: "380075"
        },
        {
            codeName: "因佩里亚（意大利）",
            cusCode: "307",
            codeValue: "ITA078",
            gbName: "因佩里亚（意大利）",
            gbCode: "ITA078",
            ciqCode: "380078"
        },
        {
            codeName: "拉马达莱那（意大利）",
            cusCode: "307",
            codeValue: "ITA081",
            gbName: "拉马达莱那（意大利）",
            gbCode: "ITA081",
            ciqCode: "380081"
        },
        {
            codeName: "里窝那（意大利）",
            cusCode: "2249",
            codeValue: "ITA084",
            gbName: "里窝那（意大利）",
            gbCode: "ITA084",
            ciqCode: "380084"
        },
        {
            codeName: "利卡塔（意大利）",
            cusCode: "2248",
            codeValue: "ITA087",
            gbName: "利卡塔（意大利）",
            gbCode: "ITA087",
            ciqCode: "380087"
        },
        {
            codeName: "曼夫雷多尼亚（意大利）",
            cusCode: "307",
            codeValue: "ITA090",
            gbName: "曼夫雷多尼亚（意大利）",
            gbCode: "ITA090",
            ciqCode: "380090"
        },
        {
            codeName: "马里纳迪卡拉拉（意大利）",
            cusCode: "2250",
            codeValue: "ITA093",
            gbName: "马里纳迪卡拉拉（意大利）",
            gbCode: "ITA093",
            ciqCode: "380093"
        },
        {
            codeName: "马尔萨拉（意大利）",
            cusCode: "2251",
            codeValue: "ITA096",
            gbName: "马尔萨拉（意大利）",
            gbCode: "ITA096",
            ciqCode: "380096"
        },
        {
            codeName: "马扎拉德尔瓦洛（意大利）",
            cusCode: "2252",
            codeValue: "ITA099",
            gbName: "马扎拉德尔瓦洛（意大利）",
            gbCode: "ITA099",
            ciqCode: "380099"
        },
        {
            codeName: "梅利利（意大利）",
            cusCode: "307",
            codeValue: "ITA102",
            gbName: "梅利利（意大利）",
            gbCode: "ITA102",
            ciqCode: "380102"
        },
        {
            codeName: "墨西拿（意大利）",
            cusCode: "2253",
            codeValue: "ITA105",
            gbName: "墨西拿（意大利）",
            gbCode: "ITA105",
            ciqCode: "380105"
        },
        {
            codeName: "米拉佐（意大利）",
            cusCode: "2254",
            codeValue: "ITA108",
            gbName: "米拉佐（意大利）",
            gbCode: "ITA108",
            ciqCode: "380108"
        },
        {
            codeName: "莫尔费塔（意大利）",
            cusCode: "2256",
            codeValue: "ITA111",
            gbName: "莫尔费塔（意大利）",
            gbCode: "ITA111",
            ciqCode: "380111"
        },
        {
            codeName: "蒙法尔科内（意大利）",
            cusCode: "307",
            codeValue: "ITA114",
            gbName: "蒙法尔科内（意大利）",
            gbCode: "ITA114",
            ciqCode: "380114"
        },
        {
            codeName: "莫诺波利（意大利）",
            cusCode: "2257",
            codeValue: "ITA117",
            gbName: "莫诺波利（意大利）",
            gbCode: "ITA117",
            ciqCode: "380117"
        },
        {
            codeName: "那波利（意大利）",
            cusCode: "307",
            codeValue: "ITA120",
            gbName: "那波利（意大利）",
            gbCode: "ITA120",
            ciqCode: "380120"
        },
        {
            codeName: "奥尔比亚（意大利）",
            cusCode: "2259",
            codeValue: "ITA123",
            gbName: "奥尔比亚（意大利）",
            gbCode: "ITA123",
            ciqCode: "380123"
        },
        {
            codeName: "奥里斯塔诺（意大利）",
            cusCode: "3420",
            codeValue: "ITA126",
            gbName: "奥里斯塔诺（意大利）",
            gbCode: "ITA126",
            ciqCode: "380126"
        },
        {
            codeName: "奥托纳（意大利）",
            cusCode: "307",
            codeValue: "ITA129",
            gbName: "奥托纳（意大利）",
            gbCode: "ITA129",
            ciqCode: "380129"
        },
        {
            codeName: "巴勒莫（意大利）",
            cusCode: "2260",
            codeValue: "ITA132",
            gbName: "巴勒莫（意大利）",
            gbCode: "ITA132",
            ciqCode: "380132"
        },
        {
            codeName: "佩萨罗（意大利）",
            cusCode: "2261",
            codeValue: "ITA135",
            gbName: "佩萨罗（意大利）",
            gbCode: "ITA135",
            ciqCode: "380135"
        },
        {
            codeName: "佩斯卡拉（意大利）",
            cusCode: "307",
            codeValue: "ITA138",
            gbName: "佩斯卡拉（意大利）",
            gbCode: "ITA138",
            ciqCode: "380138"
        },
        {
            codeName: "皮翁比诺（意大利）",
            cusCode: "2262",
            codeValue: "ITA141",
            gbName: "皮翁比诺（意大利）",
            gbCode: "ITA141",
            ciqCode: "380141"
        },
        {
            codeName: "波蒂奇（意大利）",
            cusCode: "307",
            codeValue: "ITA144",
            gbName: "波蒂奇（意大利）",
            gbCode: "ITA144",
            ciqCode: "380144"
        },
        {
            codeName: "波蒂格里欧内（意大利）",
            cusCode: "2263",
            codeValue: "ITA147",
            gbName: "波蒂格里欧内（意大利）",
            gbCode: "ITA147",
            ciqCode: "380147"
        },
        {
            codeName: "阿祖罗港（意大利）",
            cusCode: "2264",
            codeValue: "ITA150",
            gbName: "阿祖罗港（意大利）",
            gbCode: "ITA150",
            ciqCode: "380150"
        },
        {
            codeName: "恩佩多克莱港（意大利）",
            cusCode: "2265",
            codeValue: "ITA153",
            gbName: "恩佩多克莱港（意大利）",
            gbCode: "ITA153",
            ciqCode: "380153"
        },
        {
            codeName: "马尔盖腊港（意大利）",
            cusCode: "307",
            codeValue: "ITA156",
            gbName: "马尔盖腊港（意大利）",
            gbCode: "ITA156",
            ciqCode: "380156"
        },
        {
            codeName: "圣托斯特凡诺港（意大利）",
            cusCode: "2266",
            codeValue: "ITA159",
            gbName: "圣托斯特凡诺港（意大利）",
            gbCode: "ITA159",
            ciqCode: "380159"
        },
        {
            codeName: "托雷斯港（意大利）",
            cusCode: "2267",
            codeValue: "ITA162",
            gbName: "托雷斯港（意大利）",
            gbCode: "ITA162",
            ciqCode: "380162"
        },
        {
            codeName: "韦斯梅港（意大利）",
            cusCode: "2270",
            codeValue: "ITA165",
            gbName: "韦斯梅港（意大利）",
            gbCode: "ITA165",
            ciqCode: "380165"
        },
        {
            codeName: "费拉约港（意大利）",
            cusCode: "2268",
            codeValue: "ITA168",
            gbName: "费拉约港（意大利）",
            gbCode: "ITA168",
            ciqCode: "380168"
        },
        {
            codeName: "斯库索港（意大利）",
            cusCode: "2269",
            codeValue: "ITA171",
            gbName: "斯库索港（意大利）",
            gbCode: "ITA171",
            ciqCode: "380171"
        },
        {
            codeName: "波佐利（意大利）",
            cusCode: "2271",
            codeValue: "ITA174",
            gbName: "波佐利（意大利）",
            gbCode: "ITA174",
            ciqCode: "380174"
        },
        {
            codeName: "普里奥洛（意大利）",
            cusCode: "2273",
            codeValue: "ITA177",
            gbName: "普里奥洛（意大利）",
            gbCode: "ITA177",
            ciqCode: "380177"
        },
        {
            codeName: "腊万纳（意大利）",
            cusCode: "2274",
            codeValue: "ITA180",
            gbName: "腊万纳（意大利）",
            gbCode: "ITA180",
            ciqCode: "380180"
        },
        {
            codeName: "雷焦（意大利）",
            cusCode: "307",
            codeValue: "ITA183",
            gbName: "雷焦（意大利）",
            gbCode: "ITA183",
            ciqCode: "380183"
        },
        {
            codeName: "里奥马里纳（意大利）",
            cusCode: "2275",
            codeValue: "ITA186",
            gbName: "里奥马里纳（意大利）",
            gbCode: "ITA186",
            ciqCode: "380186"
        },
        {
            codeName: "萨莱诺（意大利）",
            cusCode: "2276",
            codeValue: "ITA189",
            gbName: "萨莱诺（意大利）",
            gbCode: "ITA189",
            ciqCode: "380189"
        },
        {
            codeName: "圣雷莫（意大利）",
            cusCode: "2277",
            codeValue: "ITA192",
            gbName: "圣雷莫（意大利）",
            gbCode: "ITA192",
            ciqCode: "380192"
        },
        {
            codeName: "萨罗克（福克西港）（意大利）",
            cusCode: "2280",
            codeValue: "ITA195",
            gbName: "萨罗克（福克西港）（意大利）",
            gbCode: "ITA195",
            ciqCode: "380195"
        },
        {
            codeName: "萨沃纳（意大利）",
            cusCode: "2281",
            codeValue: "ITA198",
            gbName: "萨沃纳（意大利）",
            gbCode: "ITA198",
            ciqCode: "380198"
        },
        {
            codeName: "锡拉库萨（意大利）",
            cusCode: "307",
            codeValue: "ITA201",
            gbName: "锡拉库萨（意大利）",
            gbCode: "ITA201",
            ciqCode: "380201"
        },
        {
            codeName: "斯佩齐亚（意大利）",
            cusCode: "2246",
            codeValue: "ITA204",
            gbName: "斯佩齐亚（意大利）",
            gbCode: "ITA204",
            ciqCode: "380204"
        },
        {
            codeName: "塔拉莫内（意大利）",
            cusCode: "2286",
            codeValue: "ITA207",
            gbName: "塔拉莫内（意大利）",
            gbCode: "ITA207",
            ciqCode: "380207"
        },
        {
            codeName: "塔兰托（意大利）",
            cusCode: "2287",
            codeValue: "ITA210",
            gbName: "塔兰托（意大利）",
            gbCode: "ITA210",
            ciqCode: "380210"
        },
        {
            codeName: "托雷德尔格雷科（意大利）",
            cusCode: "307",
            codeValue: "ITA213",
            gbName: "托雷德尔格雷科（意大利）",
            gbCode: "ITA213",
            ciqCode: "380213"
        },
        {
            codeName: "托雷安农齐亚塔（意大利）",
            cusCode: "2289",
            codeValue: "ITA216",
            gbName: "托雷安农齐亚塔（意大利）",
            gbCode: "ITA216",
            ciqCode: "380216"
        },
        {
            codeName: "特拉帕尼（意大利）",
            cusCode: "307",
            codeValue: "ITA219",
            gbName: "特拉帕尼（意大利）",
            gbCode: "ITA219",
            ciqCode: "380219"
        },
        {
            codeName: "的里雅斯特（意大利）",
            cusCode: "2290",
            codeValue: "ITA222",
            gbName: "的里雅斯特（意大利）",
            gbCode: "ITA222",
            ciqCode: "380222"
        },
        {
            codeName: "瓦斯托（意大利）",
            cusCode: "307",
            codeValue: "ITA225",
            gbName: "瓦斯托（意大利）",
            gbCode: "ITA225",
            ciqCode: "380225"
        },
        {
            codeName: "威尼斯（意大利）",
            cusCode: "2291",
            codeValue: "ITA228",
            gbName: "威尼斯（意大利）",
            gbCode: "ITA228",
            ciqCode: "380228"
        },
        {
            codeName: "维亚雷焦（意大利）",
            cusCode: "307",
            codeValue: "ITA231",
            gbName: "维亚雷焦（意大利）",
            gbCode: "ITA231",
            ciqCode: "380231"
        },
        {
            codeName: "奥克里卡（意大利）",
            cusCode: "2288",
            codeValue: "ITA242",
            gbName: "奥克里卡（意大利）",
            gbCode: "ITA242",
            ciqCode: "380242"
        },
        {
            codeName: "博洛尼亚（意大利）",
            cusCode: "2238",
            codeValue: "ITA243",
            gbName: "博洛尼亚（意大利）",
            gbCode: "ITA243",
            ciqCode: "380243"
        },
        {
            codeName: "利窝那（意大利）",
            cusCode: "2247",
            codeValue: "ITA244",
            gbName: "利窝那（意大利）",
            gbCode: "ITA244",
            ciqCode: "380244"
        },
        {
            codeName: "那不勒斯（意大利）",
            cusCode: "2258",
            codeValue: "ITA245",
            gbName: "那不勒斯（意大利）",
            gbCode: "ITA245",
            ciqCode: "380245"
        },
        {
            codeName: "普腊托（意大利）",
            cusCode: "2272",
            codeValue: "ITA247",
            gbName: "普腊托（意大利）",
            gbCode: "ITA247",
            ciqCode: "380247"
        },
        {
            codeName: "撒丁岛（意大利）",
            cusCode: "2279",
            codeValue: "ITA248",
            gbName: "撒丁岛（意大利）",
            gbCode: "ITA248",
            ciqCode: "380248"
        },
        {
            codeName: "桑达基斯达（意大利）",
            cusCode: "2278",
            codeValue: "ITA249",
            gbName: "桑达基斯达（意大利）",
            gbCode: "ITA249",
            ciqCode: "380249"
        },
        {
            codeName: "西西里（意大利）",
            cusCode: "2282",
            codeValue: "ITA252",
            gbName: "西西里（意大利）",
            gbCode: "ITA252",
            ciqCode: "380252"
        },
        {
            codeName: "锡腊丘斯（意大利）",
            cusCode: "2285",
            codeValue: "ITA253",
            gbName: "锡腊丘斯（意大利）",
            gbCode: "ITA253",
            ciqCode: "380253"
        },
        {
            codeName: "罗马（意大利）",
            cusCode: "307",
            codeValue: "ITA901",
            gbName: "罗马（意大利）",
            gbCode: "ITA901",
            ciqCode: "380901"
        },
        {
            codeName: "米兰（意大利）",
            cusCode: "2255",
            codeValue: "ITA902",
            gbName: "米兰（意大利）",
            gbCode: "ITA902",
            ciqCode: "380902"
        },
        {
            codeName: "牙买加",
            cusCode: "427",
            codeValue: "JAM000",
            gbName: "牙买加",
            gbCode: "JAM000",
            ciqCode: "388000"
        },
        {
            codeName: "阿利盖德庞德（牙买加）",
            cusCode: "427",
            codeValue: "JAM003",
            gbName: "阿利盖德庞德（牙买加）",
            gbCode: "JAM003",
            ciqCode: "388003"
        },
        {
            codeName: "布莱克河（牙买加）",
            cusCode: "2864",
            codeValue: "JAM006",
            gbName: "布莱克河（牙买加）",
            gbCode: "JAM006",
            ciqCode: "388006"
        },
        {
            codeName: "布卢菲尔兹（牙买加）",
            cusCode: "427",
            codeValue: "JAM009",
            gbName: "布卢菲尔兹（牙买加）",
            gbCode: "JAM009",
            ciqCode: "388009"
        },
        {
            codeName: "法尔茅斯（牙买加）",
            cusCode: "427",
            codeValue: "JAM012",
            gbName: "法尔茅斯（牙买加）",
            gbCode: "JAM012",
            ciqCode: "388012"
        },
        {
            codeName: "金斯敦（牙买加）",
            cusCode: "2865",
            codeValue: "JAM015",
            gbName: "金斯敦（牙买加）",
            gbCode: "JAM015",
            ciqCode: "388015"
        },
        {
            codeName: "卢西（牙买加）",
            cusCode: "427",
            codeValue: "JAM018",
            gbName: "卢西（牙买加）",
            gbCode: "JAM018",
            ciqCode: "388018"
        },
        {
            codeName: "蒙特哥湾（牙买加）",
            cusCode: "2866",
            codeValue: "JAM021",
            gbName: "蒙特哥湾（牙买加）",
            gbCode: "JAM021",
            ciqCode: "388021"
        },
        {
            codeName: "奥乔里奥斯湾（牙买加）",
            cusCode: "2867",
            codeValue: "JAM024",
            gbName: "奥乔里奥斯湾（牙买加）",
            gbCode: "JAM024",
            ciqCode: "388024"
        },
        {
            codeName: "安东尼奥港（牙买加）",
            cusCode: "2868",
            codeValue: "JAM027",
            gbName: "安东尼奥港（牙买加）",
            gbCode: "JAM027",
            ciqCode: "388027"
        },
        {
            codeName: "埃斯基韦尔港（牙买加）",
            cusCode: "2869",
            codeValue: "JAM030",
            gbName: "埃斯基韦尔港（牙买加）",
            gbCode: "JAM030",
            ciqCode: "388030"
        },
        {
            codeName: "凯泽港（牙买加）",
            cusCode: "2870",
            codeValue: "JAM033",
            gbName: "凯泽港（牙买加）",
            gbCode: "JAM033",
            ciqCode: "388033"
        },
        {
            codeName: "莫兰特港（牙买加）",
            cusCode: "2871",
            codeValue: "JAM036",
            gbName: "莫兰特港（牙买加）",
            gbCode: "JAM036",
            ciqCode: "388036"
        },
        {
            codeName: "罗德港（牙买加）",
            cusCode: "427",
            codeValue: "JAM039",
            gbName: "罗德港（牙买加）",
            gbCode: "JAM039",
            ciqCode: "388039"
        },
        {
            codeName: "罗亚尔港（牙买加）",
            cusCode: "2872",
            codeValue: "JAM042",
            gbName: "罗亚尔港（牙买加）",
            gbCode: "JAM042",
            ciqCode: "388042"
        },
        {
            codeName: "里奥布埃诺（牙买加）",
            cusCode: "427",
            codeValue: "JAM045",
            gbName: "里奥布埃诺（牙买加）",
            gbCode: "JAM045",
            ciqCode: "388045"
        },
        {
            codeName: "罗基波因特（牙买加）",
            cusCode: "427",
            codeValue: "JAM048",
            gbName: "罗基波因特（牙买加）",
            gbCode: "JAM048",
            ciqCode: "388048"
        },
        {
            codeName: "萨尔特里弗（牙买加）",
            cusCode: "2873",
            codeValue: "JAM051",
            gbName: "萨尔特里弗（牙买加）",
            gbCode: "JAM051",
            ciqCode: "388051"
        },
        {
            codeName: "滨海萨凡纳（牙买加）",
            cusCode: "427",
            codeValue: "JAM054",
            gbName: "滨海萨凡纳（牙买加）",
            gbCode: "JAM054",
            ciqCode: "388054"
        },
        {
            codeName: "泽西",
            cusCode: "363",
            codeValue: "JEY000",
            gbName: "泽西",
            gbCode: "JEY000",
            ciqCode: "832000"
        },
        {
            codeName: "约旦",
            cusCode: "117",
            codeValue: "JOR000",
            gbName: "约旦",
            gbCode: "JOR000",
            ciqCode: "400000"
        },
        {
            codeName: "亚喀巴（约旦）",
            cusCode: "1359",
            codeValue: "JOR003",
            gbName: "亚喀巴（约旦）",
            gbCode: "JOR003",
            ciqCode: "400003"
        },
        {
            codeName: "纳布鲁斯（约旦）",
            cusCode: "1361",
            codeValue: "JOR004",
            gbName: "纳布鲁斯（约旦）",
            gbCode: "JOR004",
            ciqCode: "400004"
        },
        {
            codeName: "伊尔比德（约旦）",
            cusCode: "1360",
            codeValue: "JOR005",
            gbName: "伊尔比德（约旦）",
            gbCode: "JOR005",
            ciqCode: "400005"
        },
        {
            codeName: "日本",
            cusCode: "116",
            codeValue: "JPN000",
            gbName: "日本",
            gbCode: "JPN000",
            ciqCode: "392000"
        },
        {
            codeName: "网走（日本）",
            cusCode: "1202",
            codeValue: "JPN003",
            gbName: "网走（日本）",
            gbCode: "JPN003",
            ciqCode: "392003"
        },
        {
            codeName: "网干（日本）",
            cusCode: "1203",
            codeValue: "JPN006",
            gbName: "网干（日本）",
            gbCode: "JPN006",
            ciqCode: "392006"
        },
        {
            codeName: "相浦（日本）",
            cusCode: "116",
            codeValue: "JPN009",
            gbName: "相浦（日本）",
            gbCode: "JPN009",
            ciqCode: "392009"
        },
        {
            codeName: "相生（日本）",
            cusCode: "1204",
            codeValue: "JPN012",
            gbName: "相生（日本）",
            gbCode: "JPN012",
            ciqCode: "392012"
        },
        {
            codeName: "秋田（日本）",
            cusCode: "1206",
            codeValue: "JPN015",
            gbName: "秋田（日本）",
            gbCode: "JPN015",
            ciqCode: "392015"
        },
        {
            codeName: "赤穗湾（日本）",
            cusCode: "116",
            codeValue: "JPN018",
            gbName: "赤穗湾（日本）",
            gbCode: "JPN018",
            ciqCode: "392018"
        },
        {
            codeName: "尼崎（日本）",
            cusCode: "1208",
            codeValue: "JPN021",
            gbName: "尼崎（日本）",
            gbCode: "JPN021",
            ciqCode: "392021"
        },
        {
            codeName: "阿南（日本）",
            cusCode: "1209",
            codeValue: "JPN024",
            gbName: "阿南（日本）",
            gbCode: "JPN024",
            ciqCode: "392024"
        },
        {
            codeName: "青森（日本）",
            cusCode: "1210",
            codeValue: "JPN027",
            gbName: "青森（日本）",
            gbCode: "JPN027",
            ciqCode: "392027"
        },
        {
            codeName: "渥美（日本）",
            cusCode: "1211",
            codeValue: "JPN030",
            gbName: "渥美（日本）",
            gbCode: "JPN030",
            ciqCode: "392030"
        },
        {
            codeName: "别府（日本）",
            cusCode: "116",
            codeValue: "JPN033",
            gbName: "别府（日本）",
            gbCode: "JPN033",
            ciqCode: "392033"
        },
        {
            codeName: "千叶（日本）",
            cusCode: "1212",
            codeValue: "JPN036",
            gbName: "千叶（日本）",
            gbCode: "JPN036",
            ciqCode: "392036"
        },
        {
            codeName: "知多（日本）",
            cusCode: "116",
            codeValue: "JPN039",
            gbName: "知多（日本）",
            gbCode: "JPN039",
            ciqCode: "392039"
        },
        {
            codeName: "江名（日本）",
            cusCode: "116",
            codeValue: "JPN042",
            gbName: "江名（日本）",
            gbCode: "JPN042",
            ciqCode: "392042"
        },
        {
            codeName: "江田岛（日本）",
            cusCode: "116",
            codeValue: "JPN045",
            gbName: "江田岛（日本）",
            gbCode: "JPN045",
            ciqCode: "392045"
        },
        {
            codeName: "福冈（日本）",
            cusCode: "116",
            codeValue: "JPN048",
            gbName: "福冈（日本）",
            gbCode: "JPN048",
            ciqCode: "392048"
        },
        {
            codeName: "福山（日本）",
            cusCode: "1214",
            codeValue: "JPN051",
            gbName: "福山（日本）",
            gbCode: "JPN051",
            ciqCode: "392051"
        },
        {
            codeName: "船桥（日本）",
            cusCode: "1215",
            codeValue: "JPN054",
            gbName: "船桥（日本）",
            gbCode: "JPN054",
            ciqCode: "392054"
        },
        {
            codeName: "船川（日本）",
            cusCode: "1216",
            codeValue: "JPN057",
            gbName: "船川（日本）",
            gbCode: "JPN057",
            ciqCode: "392057"
        },
        {
            codeName: "伏木（日本）",
            cusCode: "1217",
            codeValue: "JPN060",
            gbName: "伏木（日本）",
            gbCode: "JPN060",
            ciqCode: "392060"
        },
        {
            codeName: "蒲郡（日本）",
            cusCode: "1218",
            codeValue: "JPN063",
            gbName: "蒲郡（日本）",
            gbCode: "JPN063",
            ciqCode: "392063"
        },
        {
            codeName: "八户（日本）",
            cusCode: "1219",
            codeValue: "JPN066",
            gbName: "八户（日本）",
            gbCode: "JPN066",
            ciqCode: "392066"
        },
        {
            codeName: "荻（日本）",
            cusCode: "1220",
            codeValue: "JPN069",
            gbName: "荻（日本）",
            gbCode: "JPN069",
            ciqCode: "392069"
        },
        {
            codeName: "博多（日本）",
            cusCode: "1221",
            codeValue: "JPN072",
            gbName: "博多（日本）",
            gbCode: "JPN072",
            ciqCode: "392072"
        },
        {
            codeName: "函馆（日本）",
            cusCode: "1222",
            codeValue: "JPN075",
            gbName: "函馆（日本）",
            gbCode: "JPN075",
            ciqCode: "392075"
        },
        {
            codeName: "滨田（日本）",
            cusCode: "1223",
            codeValue: "JPN078",
            gbName: "滨田（日本）",
            gbCode: "JPN078",
            ciqCode: "392078"
        },
        {
            codeName: "滨松（日本）",
            cusCode: "116",
            codeValue: "JPN081",
            gbName: "滨松（日本）",
            gbCode: "JPN081",
            ciqCode: "392081"
        },
        {
            codeName: "半田（日本）",
            cusCode: "116",
            codeValue: "JPN084",
            gbName: "半田（日本）",
            gbCode: "JPN084",
            ciqCode: "392084"
        },
        {
            codeName: "阪南（日本）",
            cusCode: "1224",
            codeValue: "JPN087",
            gbName: "阪南（日本）",
            gbCode: "JPN087",
            ciqCode: "392087"
        },
        {
            codeName: "日明（日本）",
            cusCode: "1225",
            codeValue: "JPN090",
            gbName: "日明（日本）",
            gbCode: "JPN090",
            ciqCode: "392090"
        },
        {
            codeName: "响滩湾（日本）",
            cusCode: "1226",
            codeValue: "JPN093",
            gbName: "响滩湾（日本）",
            gbCode: "JPN093",
            ciqCode: "392093"
        },
        {
            codeName: "光市（日本）",
            cusCode: "116",
            codeValue: "JPN096",
            gbName: "光市（日本）",
            gbCode: "JPN096",
            ciqCode: "392096"
        },
        {
            codeName: "姬路（日本）",
            cusCode: "1228",
            codeValue: "JPN099",
            gbName: "姬路（日本）",
            gbCode: "JPN099",
            ciqCode: "392099"
        },
        {
            codeName: "平生（日本）",
            cusCode: "116",
            codeValue: "JPN102",
            gbName: "平生（日本）",
            gbCode: "JPN102",
            ciqCode: "392102"
        },
        {
            codeName: "广田（日本）",
            cusCode: "1229",
            codeValue: "JPN105",
            gbName: "广田（日本）",
            gbCode: "JPN105",
            ciqCode: "392105"
        },
        {
            codeName: "广岛（日本）",
            cusCode: "1230",
            codeValue: "JPN108",
            gbName: "广岛（日本）",
            gbCode: "JPN108",
            ciqCode: "392108"
        },
        {
            codeName: "久之滨（日本）",
            cusCode: "116",
            codeValue: "JPN111",
            gbName: "久之滨（日本）",
            gbCode: "JPN111",
            ciqCode: "392111"
        },
        {
            codeName: "日立（日本）",
            cusCode: "1231",
            codeValue: "JPN114",
            gbName: "日立（日本）",
            gbCode: "JPN114",
            ciqCode: "392114"
        },
        {
            codeName: "细岛（日本）",
            cusCode: "1232",
            codeValue: "JPN117",
            gbName: "细岛（日本）",
            gbCode: "JPN117",
            ciqCode: "392117"
        },
        {
            codeName: "辑保（日本）",
            cusCode: "116",
            codeValue: "JPN120",
            gbName: "辑保（日本）",
            gbCode: "JPN120",
            ciqCode: "392120"
        },
        {
            codeName: "今治（日本）",
            cusCode: "1233",
            codeValue: "JPN123",
            gbName: "今治（日本）",
            gbCode: "JPN123",
            ciqCode: "392123"
        },
        {
            codeName: "伊万里（日本）",
            cusCode: "1234",
            codeValue: "JPN126",
            gbName: "伊万里（日本）",
            gbCode: "JPN126",
            ciqCode: "392126"
        },
        {
            codeName: "因岛（日本）",
            cusCode: "1235",
            codeValue: "JPN129",
            gbName: "因岛（日本）",
            gbCode: "JPN129",
            ciqCode: "392129"
        },
        {
            codeName: "伊良湖（日本）",
            cusCode: "116",
            codeValue: "JPN132",
            gbName: "伊良湖（日本）",
            gbCode: "JPN132",
            ciqCode: "392132"
        },
        {
            codeName: "石垣（日本）",
            cusCode: "116",
            codeValue: "JPN135",
            gbName: "石垣（日本）",
            gbCode: "JPN135",
            ciqCode: "392135"
        },
        {
            codeName: "石卷（日本）",
            cusCode: "1236",
            codeValue: "JPN138",
            gbName: "石卷（日本）",
            gbCode: "JPN138",
            ciqCode: "392138"
        },
        {
            codeName: "系崎（日本）",
            cusCode: "1237",
            codeValue: "JPN141",
            gbName: "系崎（日本）",
            gbCode: "JPN141",
            ciqCode: "392141"
        },
        {
            codeName: "岩国（日本）",
            cusCode: "1238",
            codeValue: "JPN144",
            gbName: "岩国（日本）",
            gbCode: "JPN144",
            ciqCode: "392144"
        },
        {
            codeName: "伊予三岛（日本）",
            cusCode: "1240",
            codeValue: "JPN147",
            gbName: "伊予三岛（日本）",
            gbCode: "JPN147",
            ciqCode: "392147"
        },
        {
            codeName: "严原（日本）",
            cusCode: "116",
            codeValue: "JPN150",
            gbName: "严原（日本）",
            gbCode: "JPN150",
            ciqCode: "392150"
        },
        {
            codeName: "泉佐野（日本）",
            cusCode: "116",
            codeValue: "JPN153",
            gbName: "泉佐野（日本）",
            gbCode: "JPN153",
            ciqCode: "392153"
        },
        {
            codeName: "鹿儿岛（日本）",
            cusCode: "1241",
            codeValue: "JPN156",
            gbName: "鹿儿岛（日本）",
            gbCode: "JPN156",
            ciqCode: "392156"
        },
        {
            codeName: "海南（日本）",
            cusCode: "1243",
            codeValue: "JPN159",
            gbName: "海南（日本）",
            gbCode: "JPN159",
            ciqCode: "392159"
        },
        {
            codeName: "加古川（日本）",
            cusCode: "1244",
            codeValue: "JPN162",
            gbName: "加古川（日本）",
            gbCode: "JPN162",
            ciqCode: "392162"
        },
        {
            codeName: "釜石（日本）",
            cusCode: "1245",
            codeValue: "JPN165",
            gbName: "釜石（日本）",
            gbCode: "JPN165",
            ciqCode: "392165"
        },
        {
            codeName: "金泽（日本）",
            cusCode: "1246",
            codeValue: "JPN168",
            gbName: "金泽（日本）",
            gbCode: "JPN168",
            ciqCode: "392168"
        },
        {
            codeName: "刈田（日本）",
            cusCode: "1247",
            codeValue: "JPN171",
            gbName: "刈田（日本）",
            gbCode: "JPN171",
            ciqCode: "392171"
        },
        {
            codeName: "关门（日本）",
            cusCode: "1248",
            codeValue: "JPN174",
            gbName: "关门（日本）",
            gbCode: "JPN174",
            ciqCode: "392174"
        },
        {
            codeName: "鹿川（日本）",
            cusCode: "1249",
            codeValue: "JPN177",
            gbName: "鹿川（日本）",
            gbCode: "JPN177",
            ciqCode: "392177"
        },
        {
            codeName: "唐津（日本）",
            cusCode: "116",
            codeValue: "JPN180",
            gbName: "唐津（日本）",
            gbCode: "JPN180",
            ciqCode: "392180"
        },
        {
            codeName: "笠冈（日本）",
            cusCode: "1250",
            codeValue: "JPN183",
            gbName: "笠冈（日本）",
            gbCode: "JPN183",
            ciqCode: "392183"
        },
        {
            codeName: "鹿岛（日本）",
            cusCode: "1251",
            codeValue: "JPN186",
            gbName: "鹿岛（日本）",
            gbCode: "JPN186",
            ciqCode: "392186"
        },
        {
            codeName: "川之江（日本）",
            cusCode: "116",
            codeValue: "JPN189",
            gbName: "川之江（日本）",
            gbCode: "JPN189",
            ciqCode: "392189"
        },
        {
            codeName: "川崎（日本）",
            cusCode: "1252",
            codeValue: "JPN192",
            gbName: "川崎（日本）",
            gbCode: "JPN192",
            ciqCode: "392192"
        },
        {
            codeName: "喜入（日本）",
            cusCode: "1254",
            codeValue: "JPN195",
            gbName: "喜入（日本）",
            gbCode: "JPN195",
            ciqCode: "392195"
        },
        {
            codeName: "菊间（日本）",
            cusCode: "1255",
            codeValue: "JPN198",
            gbName: "菊间（日本）",
            gbCode: "JPN198",
            ciqCode: "392198"
        },
        {
            codeName: "金湾（日本）",
            cusCode: "116",
            codeValue: "JPN201",
            gbName: "金湾（日本）",
            gbCode: "JPN201",
            ciqCode: "392201"
        },
        {
            codeName: "衣浦（日本）",
            cusCode: "1257",
            codeValue: "JPN204",
            gbName: "衣浦（日本）",
            gbCode: "JPN204",
            ciqCode: "392204"
        },
        {
            codeName: "木更津（日本）",
            cusCode: "1258",
            codeValue: "JPN207",
            gbName: "木更津（日本）",
            gbCode: "JPN207",
            ciqCode: "392207"
        },
        {
            codeName: "北九州（日本）",
            cusCode: "116",
            codeValue: "JPN210",
            gbName: "北九州（日本）",
            gbCode: "JPN210",
            ciqCode: "392210"
        },
        {
            codeName: "神户（日本）",
            cusCode: "1259",
            codeValue: "JPN213",
            gbName: "神户（日本）",
            gbCode: "JPN213",
            ciqCode: "392213"
        },
        {
            codeName: "高知（日本）",
            cusCode: "1260",
            codeValue: "JPN216",
            gbName: "高知（日本）",
            gbCode: "JPN216",
            ciqCode: "392216"
        },
        {
            codeName: "小仓（日本）",
            cusCode: "1261",
            codeValue: "JPN219",
            gbName: "小仓（日本）",
            gbCode: "JPN219",
            ciqCode: "392219"
        },
        {
            codeName: "小松岛（日本）",
            cusCode: "1262",
            codeValue: "JPN222",
            gbName: "小松岛（日本）",
            gbCode: "JPN222",
            ciqCode: "392222"
        },
        {
            codeName: "神岛（日本）",
            cusCode: "116",
            codeValue: "JPN225",
            gbName: "神岛（日本）",
            gbCode: "JPN225",
            ciqCode: "392225"
        },
        {
            codeName: "下松（日本）",
            cusCode: "1263",
            codeValue: "JPN228",
            gbName: "下松（日本）",
            gbCode: "JPN228",
            ciqCode: "392228"
        },
        {
            codeName: "吴（日本）",
            cusCode: "1264",
            codeValue: "JPN231",
            gbName: "吴（日本）",
            gbCode: "JPN231",
            ciqCode: "392231"
        },
        {
            codeName: "黑崎（日本）",
            cusCode: "1265",
            codeValue: "JPN234",
            gbName: "黑崎（日本）",
            gbCode: "JPN234",
            ciqCode: "392234"
        },
        {
            codeName: "钏路（日本）",
            cusCode: "1266",
            codeValue: "JPN237",
            gbName: "钏路（日本）",
            gbCode: "JPN237",
            ciqCode: "392237"
        },
        {
            codeName: "舞鹤（日本）",
            cusCode: "1267",
            codeValue: "JPN240",
            gbName: "舞鹤（日本）",
            gbCode: "JPN240",
            ciqCode: "392240"
        },
        {
            codeName: "牧山（日本）",
            cusCode: "1268",
            codeValue: "JPN243",
            gbName: "牧山（日本）",
            gbCode: "JPN243",
            ciqCode: "392243"
        },
        {
            codeName: "丸龟（日本）",
            cusCode: "116",
            codeValue: "JPN246",
            gbName: "丸龟（日本）",
            gbCode: "JPN246",
            ciqCode: "392246"
        },
        {
            codeName: "马刀泻（日本）",
            cusCode: "1270",
            codeValue: "JPN249",
            gbName: "马刀泻（日本）",
            gbCode: "JPN249",
            ciqCode: "392249"
        },
        {
            codeName: "松永（日本）",
            cusCode: "116",
            codeValue: "JPN252",
            gbName: "松永（日本）",
            gbCode: "JPN252",
            ciqCode: "392252"
        },
        {
            codeName: "松山（日本）",
            cusCode: "1271",
            codeValue: "JPN255",
            gbName: "松山（日本）",
            gbCode: "JPN255",
            ciqCode: "392255"
        },
        {
            codeName: "松坂（日本）",
            cusCode: "116",
            codeValue: "JPN258",
            gbName: "松坂（日本）",
            gbCode: "JPN258",
            ciqCode: "392258"
        },
        {
            codeName: "妻鹿（日本）",
            cusCode: "116",
            codeValue: "JPN261",
            gbName: "妻鹿（日本）",
            gbCode: "JPN261",
            ciqCode: "392261"
        },
        {
            codeName: "三原（日本）",
            cusCode: "116",
            codeValue: "JPN264",
            gbName: "三原（日本）",
            gbCode: "JPN264",
            ciqCode: "392264"
        },
        {
            codeName: "三池（日本）",
            cusCode: "1272",
            codeValue: "JPN267",
            gbName: "三池（日本）",
            gbCode: "JPN267",
            ciqCode: "392267"
        },
        {
            codeName: "美川（日本）",
            cusCode: "116",
            codeValue: "JPN270",
            gbName: "美川（日本）",
            gbCode: "JPN270",
            ciqCode: "392270"
        },
        {
            codeName: "水俣（日本）",
            cusCode: "1273",
            codeValue: "JPN273",
            gbName: "水俣（日本）",
            gbCode: "JPN273",
            ciqCode: "392273"
        },
        {
            codeName: "三岛（日本）",
            cusCode: "116",
            codeValue: "JPN276",
            gbName: "三岛（日本）",
            gbCode: "JPN276",
            ciqCode: "392276"
        },
        {
            codeName: "三角（日本）",
            cusCode: "1275",
            codeValue: "JPN279",
            gbName: "三角（日本）",
            gbCode: "JPN279",
            ciqCode: "392279"
        },
        {
            codeName: "三子岛（日本）",
            cusCode: "116",
            codeValue: "JPN282",
            gbName: "三子岛（日本）",
            gbCode: "JPN282",
            ciqCode: "392282"
        },
        {
            codeName: "宫古（日本）",
            cusCode: "1277",
            codeValue: "JPN285",
            gbName: "宫古（日本）",
            gbCode: "JPN285",
            ciqCode: "392285"
        },
        {
            codeName: "宫崎（日本）",
            cusCode: "116",
            codeValue: "JPN288",
            gbName: "宫崎（日本）",
            gbCode: "JPN288",
            ciqCode: "392288"
        },
        {
            codeName: "宫津（日本）",
            cusCode: "1278",
            codeValue: "JPN291",
            gbName: "宫津（日本）",
            gbCode: "JPN291",
            ciqCode: "392291"
        },
        {
            codeName: "水岛（日本）",
            cusCode: "1279",
            codeValue: "JPN294",
            gbName: "水岛（日本）",
            gbCode: "JPN294",
            ciqCode: "392294"
        },
        {
            codeName: "门司（日本）",
            cusCode: "1280",
            codeValue: "JPN297",
            gbName: "门司（日本）",
            gbCode: "JPN297",
            ciqCode: "392297"
        },
        {
            codeName: "门别（日本）",
            cusCode: "1281",
            codeValue: "JPN300",
            gbName: "门别（日本）",
            gbCode: "JPN300",
            ciqCode: "392300"
        },
        {
            codeName: "向岛（日本）",
            cusCode: "1282",
            codeValue: "JPN303",
            gbName: "向岛（日本）",
            gbCode: "JPN303",
            ciqCode: "392303"
        },
        {
            codeName: "室兰（日本）",
            cusCode: "1283",
            codeValue: "JPN306",
            gbName: "室兰（日本）",
            gbCode: "JPN306",
            ciqCode: "392306"
        },
        {
            codeName: "六连（日本）",
            cusCode: "1284",
            codeValue: "JPN309",
            gbName: "六连（日本）",
            gbCode: "JPN309",
            ciqCode: "392309"
        },
        {
            codeName: "长崎（日本）",
            cusCode: "1286",
            codeValue: "JPN312",
            gbName: "长崎（日本）",
            gbCode: "JPN312",
            ciqCode: "392312"
        },
        {
            codeName: "长浦（日本）",
            cusCode: "116",
            codeValue: "JPN315",
            gbName: "长浦（日本）",
            gbCode: "JPN315",
            ciqCode: "392315"
        },
        {
            codeName: "名古屋（日本）",
            cusCode: "1287",
            codeValue: "JPN318",
            gbName: "名古屋（日本）",
            gbCode: "JPN318",
            ciqCode: "392318"
        },
        {
            codeName: "那霸（日本）",
            cusCode: "1288",
            codeValue: "JPN321",
            gbName: "那霸（日本）",
            gbCode: "JPN321",
            ciqCode: "392321"
        },
        {
            codeName: "新泻（日本）",
            cusCode: "1294",
            codeValue: "JPN322",
            gbName: "新泻（日本）",
            gbCode: "JPN322",
            ciqCode: "392322"
        },
        {
            codeName: "中城（日本）",
            cusCode: "1289",
            codeValue: "JPN324",
            gbName: "中城（日本）",
            gbCode: "JPN324",
            ciqCode: "392324"
        },
        {
            codeName: "七尾（日本）",
            cusCode: "1290",
            codeValue: "JPN327",
            gbName: "七尾（日本）",
            gbCode: "JPN327",
            ciqCode: "392327"
        },
        {
            codeName: "直江津（日本）",
            cusCode: "1291",
            codeValue: "JPN330",
            gbName: "直江津（日本）",
            gbCode: "JPN330",
            ciqCode: "392330"
        },
        {
            codeName: "直岛（日本）",
            cusCode: "1292",
            codeValue: "JPN333",
            gbName: "直岛（日本）",
            gbCode: "JPN333",
            ciqCode: "392333"
        },
        {
            codeName: "根岸（日本）",
            cusCode: "116",
            codeValue: "JPN336",
            gbName: "根岸（日本）",
            gbCode: "JPN336",
            ciqCode: "392336"
        },
        {
            codeName: "根室（日本）",
            cusCode: "116",
            codeValue: "JPN339",
            gbName: "根室（日本）",
            gbCode: "JPN339",
            ciqCode: "392339"
        },
        {
            codeName: "新舄东（日本）",
            cusCode: "1293",
            codeValue: "JPN345",
            gbName: "新舄东（日本）",
            gbCode: "JPN345",
            ciqCode: "392345"
        },
        {
            codeName: "新居滨（日本）",
            cusCode: "1295",
            codeValue: "JPN348",
            gbName: "新居滨（日本）",
            gbCode: "JPN348",
            ciqCode: "392348"
        },
        {
            codeName: "西宫（日本）",
            cusCode: "116",
            codeValue: "JPN351",
            gbName: "西宫（日本）",
            gbCode: "JPN351",
            ciqCode: "392351"
        },
        {
            codeName: "能代（日本）",
            cusCode: "116",
            codeValue: "JPN354",
            gbName: "能代（日本）",
            gbCode: "JPN354",
            ciqCode: "392354"
        },
        {
            codeName: "大船渡（日本）",
            cusCode: "1296",
            codeValue: "JPN357",
            gbName: "大船渡（日本）",
            gbCode: "JPN357",
            ciqCode: "392357"
        },
        {
            codeName: "扇岛（日本）",
            cusCode: "1297",
            codeValue: "JPN360",
            gbName: "扇岛（日本）",
            gbCode: "JPN360",
            ciqCode: "392360"
        },
        {
            codeName: "大分（日本）",
            cusCode: "1298",
            codeValue: "JPN363",
            gbName: "大分（日本）",
            gbCode: "JPN363",
            ciqCode: "392363"
        },
        {
            codeName: "冈山（日本）",
            cusCode: "116",
            codeValue: "JPN366",
            gbName: "冈山（日本）",
            gbCode: "JPN366",
            ciqCode: "392366"
        },
        {
            codeName: "御前崎（日本）",
            cusCode: "1300",
            codeValue: "JPN369",
            gbName: "御前崎（日本）",
            gbCode: "JPN369",
            ciqCode: "392369"
        },
        {
            codeName: "大凑（日本）",
            cusCode: "116",
            codeValue: "JPN372",
            gbName: "大凑（日本）",
            gbCode: "JPN372",
            ciqCode: "392372"
        },
        {
            codeName: "大三岛（日本）",
            cusCode: "116",
            codeValue: "JPN375",
            gbName: "大三岛（日本）",
            gbCode: "JPN375",
            ciqCode: "392375"
        },
        {
            codeName: "小名滨（日本）",
            cusCode: "1301",
            codeValue: "JPN378",
            gbName: "小名滨（日本）",
            gbCode: "JPN378",
            ciqCode: "392378"
        },
        {
            codeName: "尾道（日本）",
            cusCode: "1302",
            codeValue: "JPN381",
            gbName: "尾道（日本）",
            gbCode: "JPN381",
            ciqCode: "392381"
        },
        {
            codeName: "大阪（日本）",
            cusCode: "1303",
            codeValue: "JPN384",
            gbName: "大阪（日本）",
            gbCode: "JPN384",
            ciqCode: "392384"
        },
        {
            codeName: "小樽（日本）",
            cusCode: "1304",
            codeValue: "JPN387",
            gbName: "小樽（日本）",
            gbCode: "JPN387",
            ciqCode: "392387"
        },
        {
            codeName: "尾鹫（日本）",
            cusCode: "1305",
            codeValue: "JPN390",
            gbName: "尾鹫（日本）",
            gbCode: "JPN390",
            ciqCode: "392390"
        },
        {
            codeName: "留萌（日本）",
            cusCode: "1306",
            codeValue: "JPN393",
            gbName: "留萌（日本）",
            gbCode: "JPN393",
            ciqCode: "392393"
        },
        {
            codeName: "佐贺关（日本）",
            cusCode: "1307",
            codeValue: "JPN396",
            gbName: "佐贺关（日本）",
            gbCode: "JPN396",
            ciqCode: "392396"
        },
        {
            codeName: "佐伯（日本）",
            cusCode: "1308",
            codeValue: "JPN399",
            gbName: "佐伯（日本）",
            gbCode: "JPN399",
            ciqCode: "392399"
        },
        {
            codeName: "界（日本）",
            cusCode: "1309",
            codeValue: "JPN402",
            gbName: "界（日本）",
            gbCode: "JPN402",
            ciqCode: "392402"
        },
        {
            codeName: "坂出（日本）",
            cusCode: "1310",
            codeValue: "JPN405",
            gbName: "坂出（日本）",
            gbCode: "JPN405",
            ciqCode: "392405"
        },
        {
            codeName: "境港（日本）",
            cusCode: "1311",
            codeValue: "JPN408",
            gbName: "境港（日本）",
            gbCode: "JPN408",
            ciqCode: "392408"
        },
        {
            codeName: "界泉北（日本）",
            cusCode: "116",
            codeValue: "JPN411",
            gbName: "界泉北（日本）",
            gbCode: "JPN411",
            ciqCode: "392411"
        },
        {
            codeName: "酒田（日本）",
            cusCode: "1313",
            codeValue: "JPN414",
            gbName: "酒田（日本）",
            gbCode: "JPN414",
            ciqCode: "392414"
        },
        {
            codeName: "崎户（日本）",
            cusCode: "116",
            codeValue: "JPN417",
            gbName: "崎户（日本）",
            gbCode: "JPN417",
            ciqCode: "392417"
        },
        {
            codeName: "佐世保（日本）",
            cusCode: "1314",
            codeValue: "JPN420",
            gbName: "佐世保（日本）",
            gbCode: "JPN420",
            ciqCode: "392420"
        },
        {
            codeName: "仙台（日本）",
            cusCode: "1315",
            codeValue: "JPN423",
            gbName: "仙台（日本）",
            gbCode: "JPN423",
            ciqCode: "392423"
        },
        {
            codeName: "芝浦（日本）",
            cusCode: "116",
            codeValue: "JPN426",
            gbName: "芝浦（日本）",
            gbCode: "JPN426",
            ciqCode: "392426"
        },
        {
            codeName: "饰磨（日本）",
            cusCode: "1316",
            codeValue: "JPN429",
            gbName: "饰磨（日本）",
            gbCode: "JPN429",
            ciqCode: "392429"
        },
        {
            codeName: "清水（日本）",
            cusCode: "1317",
            codeValue: "JPN432",
            gbName: "清水（日本）",
            gbCode: "JPN432",
            ciqCode: "392432"
        },
        {
            codeName: "下田（日本）",
            cusCode: "116",
            codeValue: "JPN435",
            gbName: "下田（日本）",
            gbCode: "JPN435",
            ciqCode: "392435"
        },
        {
            codeName: "下关（日本）",
            cusCode: "1318",
            codeValue: "JPN438",
            gbName: "下关（日本）",
            gbCode: "JPN438",
            ciqCode: "392438"
        },
        {
            codeName: "下津（日本）",
            cusCode: "1319",
            codeValue: "JPN441",
            gbName: "下津（日本）",
            gbCode: "JPN441",
            ciqCode: "392441"
        },
        {
            codeName: "师崎（日本）",
            cusCode: "116",
            codeValue: "JPN444",
            gbName: "师崎（日本）",
            gbCode: "JPN444",
            ciqCode: "392444"
        },
        {
            codeName: "盐斧（日本）",
            cusCode: "1320",
            codeValue: "JPN447",
            gbName: "盐斧（日本）",
            gbCode: "JPN447",
            ciqCode: "392447"
        },
        {
            codeName: "新凑（日本）",
            cusCode: "116",
            codeValue: "JPN450",
            gbName: "新凑（日本）",
            gbCode: "JPN450",
            ciqCode: "392450"
        },
        {
            codeName: "须崎（日本）",
            cusCode: "1322",
            codeValue: "JPN453",
            gbName: "须崎（日本）",
            gbCode: "JPN453",
            ciqCode: "392453"
        },
        {
            codeName: "桔（日本）",
            cusCode: "1323",
            codeValue: "JPN456",
            gbName: "桔（日本）",
            gbCode: "JPN456",
            ciqCode: "392456"
        },
        {
            codeName: "多度津（日本）",
            cusCode: "116",
            codeValue: "JPN459",
            gbName: "多度津（日本）",
            gbCode: "JPN459",
            ciqCode: "392459"
        },
        {
            codeName: "田子浦（日本）",
            cusCode: "1324",
            codeValue: "JPN462",
            gbName: "田子浦（日本）",
            gbCode: "JPN462",
            ciqCode: "392462"
        },
        {
            codeName: "高松（日本）",
            cusCode: "1325",
            codeValue: "JPN465",
            gbName: "高松（日本）",
            gbCode: "JPN465",
            ciqCode: "392465"
        },
        {
            codeName: "诧间（日本）",
            cusCode: "1326",
            codeValue: "JPN471",
            gbName: "诧间（日本）",
            gbCode: "JPN471",
            ciqCode: "392471"
        },
        {
            codeName: "玉岛（日本）",
            cusCode: "116",
            codeValue: "JPN474",
            gbName: "玉岛（日本）",
            gbCode: "JPN474",
            ciqCode: "392474"
        },
        {
            codeName: "玉野（日本）",
            cusCode: "116",
            codeValue: "JPN477",
            gbName: "玉野（日本）",
            gbCode: "JPN477",
            ciqCode: "392477"
        },
        {
            codeName: "田边（日本）",
            cusCode: "1327",
            codeValue: "JPN480",
            gbName: "田边（日本）",
            gbCode: "JPN480",
            ciqCode: "392480"
        },
        {
            codeName: "馆山（日本）",
            cusCode: "116",
            codeValue: "JPN483",
            gbName: "馆山（日本）",
            gbCode: "JPN483",
            ciqCode: "392483"
        },
        {
            codeName: "谷山（日本）",
            cusCode: "116",
            codeValue: "JPN486",
            gbName: "谷山（日本）",
            gbCode: "JPN486",
            ciqCode: "392486"
        },
        {
            codeName: "户田（日本）",
            cusCode: "1328",
            codeValue: "JPN489",
            gbName: "户田（日本）",
            gbCode: "JPN489",
            ciqCode: "392489"
        },
        {
            codeName: "十胜（日本）",
            cusCode: "116",
            codeValue: "JPN492",
            gbName: "十胜（日本）",
            gbCode: "JPN492",
            ciqCode: "392492"
        },
        {
            codeName: "东海（日本）",
            cusCode: "1329",
            codeValue: "JPN495",
            gbName: "东海（日本）",
            gbCode: "JPN495",
            ciqCode: "392495"
        },
        {
            codeName: "德山（日本）",
            cusCode: "1330",
            codeValue: "JPN498",
            gbName: "德山（日本）",
            gbCode: "JPN498",
            ciqCode: "392498"
        },
        {
            codeName: "东京（日本）",
            cusCode: "1331",
            codeValue: "JPN501",
            gbName: "东京（日本）",
            gbCode: "JPN501",
            ciqCode: "392501"
        },
        {
            codeName: "苫小牧（日本）",
            cusCode: "1332",
            codeValue: "JPN504",
            gbName: "苫小牧（日本）",
            gbCode: "JPN504",
            ciqCode: "392504"
        },
        {
            codeName: "富田（日本）",
            cusCode: "1333",
            codeValue: "JPN507",
            gbName: "富田（日本）",
            gbCode: "JPN507",
            ciqCode: "392507"
        },
        {
            codeName: "鸟取（日本）",
            cusCode: "1334",
            codeValue: "JPN510",
            gbName: "鸟取（日本）",
            gbCode: "JPN510",
            ciqCode: "392510"
        },
        {
            codeName: "富山（日本）",
            cusCode: "1335",
            codeValue: "JPN513",
            gbName: "富山（日本）",
            gbCode: "JPN513",
            ciqCode: "392513"
        },
        {
            codeName: "富山新港（日本）",
            cusCode: "1336",
            codeValue: "JPN516",
            gbName: "富山新港（日本）",
            gbCode: "JPN516",
            ciqCode: "392516"
        },
        {
            codeName: "丰桥（日本）",
            cusCode: "1337",
            codeValue: "JPN519",
            gbName: "丰桥（日本）",
            gbCode: "JPN519",
            ciqCode: "392519"
        },
        {
            codeName: "津（日本）",
            cusCode: "116",
            codeValue: "JPN522",
            gbName: "津（日本）",
            gbCode: "JPN522",
            ciqCode: "392522"
        },
        {
            codeName: "津居山（日本）",
            cusCode: "1338",
            codeValue: "JPN525",
            gbName: "津居山（日本）",
            gbCode: "JPN525",
            ciqCode: "392525"
        },
        {
            codeName: "津久见（日本）",
            cusCode: "1339",
            codeValue: "JPN528",
            gbName: "津久见（日本）",
            gbCode: "JPN528",
            ciqCode: "392528"
        },
        {
            codeName: "敦贺（日本）",
            cusCode: "1340",
            codeValue: "JPN531",
            gbName: "敦贺（日本）",
            gbCode: "JPN531",
            ciqCode: "392531"
        },
        {
            codeName: "鹤见（日本）",
            cusCode: "116",
            codeValue: "JPN534",
            gbName: "鹤见（日本）",
            gbCode: "JPN534",
            ciqCode: "392534"
        },
        {
            codeName: "鹤崎（日本）",
            cusCode: "1341",
            codeValue: "JPN537",
            gbName: "鹤崎（日本）",
            gbCode: "JPN537",
            ciqCode: "392537"
        },
        {
            codeName: "宇部（日本）",
            cusCode: "1342",
            codeValue: "JPN540",
            gbName: "宇部（日本）",
            gbCode: "JPN540",
            ciqCode: "392540"
        },
        {
            codeName: "内浦（日本）",
            cusCode: "1343",
            codeValue: "JPN543",
            gbName: "内浦（日本）",
            gbCode: "JPN543",
            ciqCode: "392543"
        },
        {
            codeName: "宇野（日本）",
            cusCode: "1344",
            codeValue: "JPN546",
            gbName: "宇野（日本）",
            gbCode: "JPN546",
            ciqCode: "392546"
        },
        {
            codeName: "若松（日本）",
            cusCode: "1346",
            codeValue: "JPN549",
            gbName: "若松（日本）",
            gbCode: "JPN549",
            ciqCode: "392549"
        },
        {
            codeName: "和歌山（日本）",
            cusCode: "1347",
            codeValue: "JPN552",
            gbName: "和歌山（日本）",
            gbCode: "JPN552",
            ciqCode: "392552"
        },
        {
            codeName: "稚内（日本）",
            cusCode: "1348",
            codeValue: "JPN555",
            gbName: "稚内（日本）",
            gbCode: "JPN555",
            ciqCode: "392555"
        },
        {
            codeName: "八代（日本）",
            cusCode: "1350",
            codeValue: "JPN558",
            gbName: "八代（日本）",
            gbCode: "JPN558",
            ciqCode: "392558"
        },
        {
            codeName: "八幡（日本）",
            cusCode: "1352",
            codeValue: "JPN561",
            gbName: "八幡（日本）",
            gbCode: "JPN561",
            ciqCode: "392561"
        },
        {
            codeName: "八恬滨（日本）",
            cusCode: "116",
            codeValue: "JPN564",
            gbName: "八恬滨（日本）",
            gbCode: "JPN564",
            ciqCode: "392564"
        },
        {
            codeName: "四日市（日本）",
            cusCode: "1353",
            codeValue: "JPN567",
            gbName: "四日市（日本）",
            gbCode: "JPN567",
            ciqCode: "392567"
        },
        {
            codeName: "横滨（日本）",
            cusCode: "1354",
            codeValue: "JPN570",
            gbName: "横滨（日本）",
            gbCode: "JPN570",
            ciqCode: "392570"
        },
        {
            codeName: "横须贺（日本）",
            cusCode: "1355",
            codeValue: "JPN573",
            gbName: "横须贺（日本）",
            gbCode: "JPN573",
            ciqCode: "392573"
        },
        {
            codeName: "寄岛（日本）",
            cusCode: "116",
            codeValue: "JPN576",
            gbName: "寄岛（日本）",
            gbCode: "JPN576",
            ciqCode: "392576"
        },
        {
            codeName: "四仓（日本）",
            cusCode: "116",
            codeValue: "JPN579",
            gbName: "四仓（日本）",
            gbCode: "JPN579",
            ciqCode: "392579"
        },
        {
            codeName: "由良（日本）",
            cusCode: "116",
            codeValue: "JPN582",
            gbName: "由良（日本）",
            gbCode: "JPN582",
            ciqCode: "392582"
        },
        {
            codeName: "AJIGAWA（日本）",
            cusCode: "1205",
            codeValue: "JPN590",
            gbName: "AJIGAWA（日本）",
            gbCode: "JPN590",
            ciqCode: "392590"
        },
        {
            codeName: "AKITSU（日本）",
            cusCode: "1207",
            codeValue: "JPN591",
            gbName: "AKITSU（日本）",
            gbCode: "JPN591",
            ciqCode: "392591"
        },
        {
            codeName: "DOKAI（日本）",
            cusCode: "1213",
            codeValue: "JPN592",
            gbName: "DOKAI（日本）",
            gbCode: "JPN592",
            ciqCode: "392592"
        },
        {
            codeName: "KEIHIN PORT（日本）",
            cusCode: "1253",
            codeValue: "JPN593",
            gbName: "KEIHIN PORT（日本）",
            gbCode: "JPN593",
            ciqCode: "392593"
        },
        {
            codeName: "东播磨(IHO)（日本）",
            cusCode: "1227",
            codeValue: "JPN595",
            gbName: "东播磨(IHO)（日本）",
            gbCode: "JPN595",
            ciqCode: "392595"
        },
        {
            codeName: "浮岛（日本）",
            cusCode: "1276",
            codeValue: "JPN596",
            gbName: "浮岛（日本）",
            gbCode: "JPN596",
            ciqCode: "392596"
        },
        {
            codeName: "君津（日本）",
            cusCode: "1256",
            codeValue: "JPN597",
            gbName: "君津（日本）",
            gbCode: "JPN597",
            ciqCode: "392597"
        },
        {
            codeName: "鹿儿岛新港（日本）",
            cusCode: "1242",
            codeValue: "JPN598",
            gbName: "鹿儿岛新港（日本）",
            gbCode: "JPN598",
            ciqCode: "392598"
        },
        {
            codeName: "三岛 川三江（日本）",
            cusCode: "1274",
            codeValue: "JPN600",
            gbName: "三岛 川三江（日本）",
            gbCode: "JPN600",
            ciqCode: "392600"
        },
        {
            codeName: "苏萨（日本）",
            cusCode: "1321",
            codeValue: "JPN602",
            gbName: "苏萨（日本）",
            gbCode: "JPN602",
            ciqCode: "392602"
        },
        {
            codeName: "宇野和玉野（日本）",
            cusCode: "1345",
            codeValue: "JPN605",
            gbName: "宇野和玉野（日本）",
            gbCode: "JPN605",
            ciqCode: "392605"
        },
        {
            codeName: "枕崎（日本）",
            cusCode: "1269",
            codeValue: "JPN606",
            gbName: "枕崎（日本）",
            gbCode: "JPN606",
            ciqCode: "392606"
        },
        {
            codeName: "札幌（日本）",
            cusCode: "116",
            codeValue: "JPN901",
            gbName: "札幌（日本）",
            gbCode: "JPN901",
            ciqCode: "392901"
        },
        {
            codeName: "冲绳（日本）",
            cusCode: "116",
            codeValue: "JPN902",
            gbName: "冲绳（日本）",
            gbCode: "JPN902",
            ciqCode: "392902"
        },
        {
            codeName: "哈萨克斯坦",
            cusCode: "145",
            codeValue: "KAZ000",
            gbName: "哈萨克斯坦",
            gbCode: "KAZ000",
            ciqCode: "398000"
        },
        {
            codeName: "十月市（哈萨克斯坦）",
            cusCode: "145",
            codeValue: "KAZ901",
            gbName: "十月市（哈萨克斯坦）",
            gbCode: "KAZ901",
            ciqCode: "398901"
        },
        {
            codeName: "尤日内（哈萨克斯坦）",
            cusCode: "145",
            codeValue: "KAZ902",
            gbName: "尤日内（哈萨克斯坦）",
            gbCode: "KAZ902",
            ciqCode: "398902"
        },
        {
            codeName: "迈哈布奇盖（哈萨克斯坦）",
            cusCode: "145",
            codeValue: "KAZ903",
            gbName: "迈哈布奇盖（哈萨克斯坦）",
            gbCode: "KAZ903",
            ciqCode: "398903"
        },
        {
            codeName: "阿连谢夫卡（哈萨克斯坦）",
            cusCode: "145",
            codeValue: "KAZ904",
            gbName: "阿连谢夫卡（哈萨克斯坦）",
            gbCode: "KAZ904",
            ciqCode: "398904"
        },
        {
            codeName: "巴克特（哈萨克斯坦）",
            cusCode: "145",
            codeValue: "KAZ905",
            gbName: "巴克特（哈萨克斯坦）",
            gbCode: "KAZ905",
            ciqCode: "398905"
        },
        {
            codeName: "德鲁日巴（哈萨克斯坦）",
            cusCode: "145",
            codeValue: "KAZ906",
            gbName: "德鲁日巴（哈萨克斯坦）",
            gbCode: "KAZ906",
            ciqCode: "398906"
        },
        {
            codeName: "霍尔果斯（哈萨克斯坦）",
            cusCode: "145",
            codeValue: "KAZ907",
            gbName: "霍尔果斯（哈萨克斯坦）",
            gbCode: "KAZ907",
            ciqCode: "398907"
        },
        {
            codeName: "科里扎特（哈萨克斯坦）",
            cusCode: "145",
            codeValue: "KAZ908",
            gbName: "科里扎特（哈萨克斯坦）",
            gbCode: "KAZ908",
            ciqCode: "398908"
        },
        {
            codeName: "纳林果勒（哈萨克斯坦）",
            cusCode: "145",
            codeValue: "KAZ909",
            gbName: "纳林果勒（哈萨克斯坦）",
            gbCode: "KAZ909",
            ciqCode: "398909"
        },
        {
            codeName: "肯尼亚",
            cusCode: "224",
            codeValue: "KEN000",
            gbName: "肯尼亚",
            gbCode: "KEN000",
            ciqCode: "404000"
        },
        {
            codeName: "拉穆（肯尼亚）",
            cusCode: "1656",
            codeValue: "KEN003",
            gbName: "拉穆（肯尼亚）",
            gbCode: "KEN003",
            ciqCode: "404003"
        },
        {
            codeName: "马林迪（肯尼亚）",
            cusCode: "1657",
            codeValue: "KEN006",
            gbName: "马林迪（肯尼亚）",
            gbCode: "KEN006",
            ciqCode: "404006"
        },
        {
            codeName: "蒙巴萨（肯尼亚）",
            cusCode: "1658",
            codeValue: "KEN009",
            gbName: "蒙巴萨（肯尼亚）",
            gbCode: "KEN009",
            ciqCode: "404009"
        },
        {
            codeName: "万加（肯尼亚）",
            cusCode: "224",
            codeValue: "KEN012",
            gbName: "万加（肯尼亚）",
            gbCode: "KEN012",
            ciqCode: "404012"
        },
        {
            codeName: "内罗毕（肯尼亚）",
            cusCode: "1659",
            codeValue: "KEN901",
            gbName: "内罗毕（肯尼亚）",
            gbCode: "KEN901",
            ciqCode: "404901"
        },
        {
            codeName: "吉尔吉斯斯坦",
            cusCode: "146",
            codeValue: "KGZ000",
            gbName: "吉尔吉斯斯坦",
            gbCode: "KGZ000",
            ciqCode: "417000"
        },
        {
            codeName: "图鲁噶尔（吉尔吉斯斯坦）",
            cusCode: "146",
            codeValue: "KGZ901",
            gbName: "图鲁噶尔（吉尔吉斯斯坦）",
            gbCode: "KGZ901",
            ciqCode: "417901"
        },
        {
            codeName: "比什凯克（吉尔吉斯斯坦）",
            cusCode: "146",
            codeValue: "KGZ902",
            gbName: "比什凯克（吉尔吉斯斯坦）",
            gbCode: "KGZ902",
            ciqCode: "417902"
        },
        {
            codeName: "伊尔克什坦（吉尔吉斯斯坦）",
            cusCode: "146",
            codeValue: "KGZ903",
            gbName: "伊尔克什坦（吉尔吉斯斯坦）",
            gbCode: "KGZ903",
            ciqCode: "417903"
        },
        {
            codeName: "纳伦（吉尔吉斯斯坦）",
            cusCode: "146",
            codeValue: "KGZ904",
            gbName: "纳伦（吉尔吉斯斯坦）",
            gbCode: "KGZ904",
            ciqCode: "417904"
        },
        {
            codeName: "奥什（吉尔吉斯斯坦）",
            cusCode: "146",
            codeValue: "KGZ905",
            gbName: "奥什（吉尔吉斯斯坦）",
            gbCode: "KGZ905",
            ciqCode: "417905"
        },
        {
            codeName: "柬埔寨",
            cusCode: "107",
            codeValue: "KHM000",
            gbName: "柬埔寨",
            gbCode: "KHM000",
            ciqCode: "116000"
        },
        {
            codeName: "磅逊（柬埔寨）",
            cusCode: "1018",
            codeValue: "KHM003",
            gbName: "磅逊（柬埔寨）",
            gbCode: "KHM003",
            ciqCode: "116003"
        },
        {
            codeName: "金边（柬埔寨）",
            cusCode: "1020",
            codeValue: "KHM006",
            gbName: "金边（柬埔寨）",
            gbCode: "KHM006",
            ciqCode: "116006"
        },
        {
            codeName: "基里巴斯",
            cusCode: "618",
            codeValue: "KIR000",
            gbName: "基里巴斯",
            gbCode: "KIR000",
            ciqCode: "296000"
        },
        {
            codeName: "巴纳巴岛（基里巴斯）",
            cusCode: "3357",
            codeValue: "KIR003",
            gbName: "巴纳巴岛（基里巴斯）",
            gbCode: "KIR003",
            ciqCode: "296003"
        },
        {
            codeName: "圣诞岛（基里巴斯）",
            cusCode: "3362",
            codeValue: "KIR006",
            gbName: "圣诞岛（基里巴斯）",
            gbCode: "KIR006",
            ciqCode: "296006"
        },
        {
            codeName: "范宁岛（基里巴斯）",
            cusCode: "3359",
            codeValue: "KIR009",
            gbName: "范宁岛（基里巴斯）",
            gbCode: "KIR009",
            ciqCode: "296009"
        },
        {
            codeName: "塔拉瓦（基里巴斯）",
            cusCode: "3381",
            codeValue: "KIR012",
            gbName: "塔拉瓦（基里巴斯）",
            gbCode: "KIR012",
            ciqCode: "296012"
        },
        {
            codeName: "ARANUKA I.（基里巴斯）",
            cusCode: "3355",
            codeValue: "KIR020",
            gbName: "ARANUKA I.（基里巴斯）",
            gbCode: "KIR020",
            ciqCode: "296020"
        },
        {
            codeName: "BAIRIKI（基里巴斯）",
            cusCode: "3356",
            codeValue: "KIR021",
            gbName: "BAIRIKI（基里巴斯）",
            gbCode: "KIR021",
            ciqCode: "296021"
        },
        {
            codeName: "BUKINTERIKE（基里巴斯）",
            cusCode: "3358",
            codeValue: "KIR022",
            gbName: "BUKINTERIKE（基里巴斯）",
            gbCode: "KIR022",
            ciqCode: "296022"
        },
        {
            codeName: "阿拜昂岛（基里巴斯）",
            cusCode: "3354",
            codeValue: "KIR023",
            gbName: "阿拜昂岛（基里巴斯）",
            gbCode: "KIR023",
            ciqCode: "296023"
        },
        {
            codeName: "奥罗纳岛（基里巴斯）",
            cusCode: "3374",
            codeValue: "KIR024",
            gbName: "奥罗纳岛（基里巴斯）",
            gbCode: "KIR024",
            ciqCode: "296024"
        },
        {
            codeName: "奥诺托阿岛（基里巴斯）",
            cusCode: "3372",
            codeValue: "KIR025",
            gbName: "奥诺托阿岛（基里巴斯）",
            gbCode: "KIR025",
            ciqCode: "296025"
        },
        {
            codeName: "赫尔岛（基里巴斯）",
            cusCode: "3360",
            codeValue: "KIR026",
            gbName: "赫尔岛（基里巴斯）",
            gbCode: "KIR026",
            ciqCode: "296026"
        },
        {
            codeName: "华盛顿岛（基里巴斯）",
            cusCode: "3382",
            codeValue: "KIR027",
            gbName: "华盛顿岛（基里巴斯）",
            gbCode: "KIR027",
            ciqCode: "296027"
        },
        {
            codeName: "坎顿岛（基里巴斯）",
            cusCode: "3361",
            codeValue: "KIR030",
            gbName: "坎顿岛（基里巴斯）",
            gbCode: "KIR030",
            ciqCode: "296030"
        },
        {
            codeName: "库里亚岛（基里巴斯）",
            cusCode: "3363",
            codeValue: "KIR031",
            gbName: "库里亚岛（基里巴斯）",
            gbCode: "KIR031",
            ciqCode: "296031"
        },
        {
            codeName: "马拉凯伊岛（基里巴斯）",
            cusCode: "3367",
            codeValue: "KIR032",
            gbName: "马拉凯伊岛（基里巴斯）",
            gbCode: "KIR032",
            ciqCode: "296032"
        },
        {
            codeName: "马亚纳岛（基里巴斯）",
            cusCode: "3364",
            codeValue: "KIR033",
            gbName: "马亚纳岛（基里巴斯）",
            gbCode: "KIR033",
            ciqCode: "296033"
        },
        {
            codeName: "麦基恩岛（基里巴斯）",
            cusCode: "3368",
            codeValue: "KIR034",
            gbName: "麦基恩岛（基里巴斯）",
            gbCode: "KIR034",
            ciqCode: "296034"
        },
        {
            codeName: "曼拉岛（基里巴斯）",
            cusCode: "3366",
            codeValue: "KIR035",
            gbName: "曼拉岛（基里巴斯）",
            gbCode: "KIR035",
            ciqCode: "296035"
        },
        {
            codeName: "莫尔登（基里巴斯）",
            cusCode: "3365",
            codeValue: "KIR036",
            gbName: "莫尔登（基里巴斯）",
            gbCode: "KIR036",
            ciqCode: "296036"
        },
        {
            codeName: "尼库马罗罗岛（基里巴斯）",
            cusCode: "3369",
            codeValue: "KIR037",
            gbName: "尼库马罗罗岛（基里巴斯）",
            gbCode: "KIR037",
            ciqCode: "296037"
        },
        {
            codeName: "尼库瑙岛（基里巴斯）",
            cusCode: "3370",
            codeValue: "KIR038",
            gbName: "尼库瑙岛（基里巴斯）",
            gbCode: "KIR038",
            ciqCode: "296038"
        },
        {
            codeName: "诺诺乌蒂岛（基里巴斯）",
            cusCode: "3371",
            codeValue: "KIR039",
            gbName: "诺诺乌蒂岛（基里巴斯）",
            gbCode: "KIR039",
            ciqCode: "296039"
        },
        {
            codeName: "斯塔巴克岛（基里巴斯）",
            cusCode: "3375",
            codeValue: "KIR040",
            gbName: "斯塔巴克岛（基里巴斯）",
            gbCode: "KIR040",
            ciqCode: "296040"
        },
        {
            codeName: "塔邦泰拜克（基里巴斯）",
            cusCode: "3377",
            codeValue: "KIR041",
            gbName: "塔邦泰拜克（基里巴斯）",
            gbCode: "KIR041",
            ciqCode: "296041"
        },
        {
            codeName: "塔比泰韦阿岛（基里巴斯）",
            cusCode: "3376",
            codeValue: "KIR042",
            gbName: "塔比泰韦阿岛（基里巴斯）",
            gbCode: "KIR042",
            ciqCode: "296042"
        },
        {
            codeName: "塔布阿埃兰岛（基里巴斯）",
            cusCode: "3378",
            codeValue: "KIR043",
            gbName: "塔布阿埃兰岛（基里巴斯）",
            gbCode: "KIR043",
            ciqCode: "296043"
        },
        {
            codeName: "塔马纳岛（基里巴斯）",
            cusCode: "3379",
            codeValue: "KIR050",
            gbName: "塔马纳岛（基里巴斯）",
            gbCode: "KIR050",
            ciqCode: "296050"
        },
        {
            codeName: "塔皮瓦（基里巴斯）",
            cusCode: "3380",
            codeValue: "KIR051",
            gbName: "塔皮瓦（基里巴斯）",
            gbCode: "KIR051",
            ciqCode: "296051"
        },
        {
            codeName: "乌马（基里巴斯）",
            cusCode: "3373",
            codeValue: "KIR052",
            gbName: "乌马（基里巴斯）",
            gbCode: "KIR052",
            ciqCode: "296052"
        },
        {
            codeName: "圣基茨和尼维斯",
            cusCode: "447",
            codeValue: "KNA000",
            gbName: "圣基茨和尼维斯",
            gbCode: "KNA000",
            ciqCode: "659000"
        },
        {
            codeName: "巴斯特尔（圣基茨和尼维斯）",
            cusCode: "2982",
            codeValue: "KNA003",
            gbName: "巴斯特尔（圣基茨和尼维斯）",
            gbCode: "KNA003",
            ciqCode: "659003"
        },
        {
            codeName: "查尔斯敦（圣基茨和尼维斯）",
            cusCode: "2981",
            codeValue: "KNA006",
            gbName: "查尔斯敦（圣基茨和尼维斯）",
            gbCode: "KNA006",
            ciqCode: "659006"
        },
        {
            codeName: "韩国",
            cusCode: "133",
            codeValue: "KOR000",
            gbName: "韩国",
            gbCode: "KOR000",
            ciqCode: "410000"
        },
        {
            codeName: "釜山（韩国）",
            cusCode: "1480",
            codeValue: "KOR003",
            gbName: "釜山（韩国）",
            gbCode: "KOR003",
            ciqCode: "410003"
        },
        {
            codeName: "光阳（韩国）",
            cusCode: "133",
            codeValue: "KOR004",
            gbName: "光阳（韩国）",
            gbCode: "KOR004",
            ciqCode: "410004"
        },
        {
            codeName: "长项（韩国）",
            cusCode: "133",
            codeValue: "KOR006",
            gbName: "长项（韩国）",
            gbCode: "KOR006",
            ciqCode: "410006"
        },
        {
            codeName: "济州（韩国）",
            cusCode: "133",
            codeValue: "KOR009",
            gbName: "济州（韩国）",
            gbCode: "KOR009",
            ciqCode: "410009"
        },
        {
            codeName: "镇海（韩国）",
            cusCode: "1484",
            codeValue: "KOR012",
            gbName: "镇海（韩国）",
            gbCode: "KOR012",
            ciqCode: "410012"
        },
        {
            codeName: "台普（韩国）",
            cusCode: "133",
            codeValue: "KOR015",
            gbName: "台普（韩国）",
            gbCode: "KOR015",
            ciqCode: "410015"
        },
        {
            codeName: "仁川（韩国）",
            cusCode: "1482",
            codeValue: "KOR018",
            gbName: "仁川（韩国）",
            gbCode: "KOR018",
            ciqCode: "410018"
        },
        {
            codeName: "群山（韩国）",
            cusCode: "1481",
            codeValue: "KOR021",
            gbName: "群山（韩国）",
            gbCode: "KOR021",
            ciqCode: "410021"
        },
        {
            codeName: "马山（韩国）",
            cusCode: "1483",
            codeValue: "KOR024",
            gbName: "马山（韩国）",
            gbCode: "KOR024",
            ciqCode: "410024"
        },
        {
            codeName: "木浦（韩国）",
            cusCode: "1485",
            codeValue: "KOR027",
            gbName: "木浦（韩国）",
            gbCode: "KOR027",
            ciqCode: "410027"
        },
        {
            codeName: "墨湖（韩国）",
            cusCode: "133",
            codeValue: "KOR030",
            gbName: "墨湖（韩国）",
            gbCode: "KOR030",
            ciqCode: "410030"
        },
        {
            codeName: "浦项（韩国）",
            cusCode: "1486",
            codeValue: "KOR033",
            gbName: "浦项（韩国）",
            gbCode: "KOR033",
            ciqCode: "410033"
        },
        {
            codeName: "平泽（韩国）",
            cusCode: "133",
            codeValue: "KOR034",
            gbName: "平泽（韩国）",
            gbCode: "KOR034",
            ciqCode: "410034"
        },
        {
            codeName: "三陟（韩国）",
            cusCode: "133",
            codeValue: "KOR036",
            gbName: "三陟（韩国）",
            gbCode: "KOR036",
            ciqCode: "410036"
        },
        {
            codeName: "蔚山（韩国）",
            cusCode: "1487",
            codeValue: "KOR039",
            gbName: "蔚山（韩国）",
            gbCode: "KOR039",
            ciqCode: "410039"
        },
        {
            codeName: "丽水（韩国）",
            cusCode: "1488",
            codeValue: "KOR042",
            gbName: "丽水（韩国）",
            gbCode: "KOR042",
            ciqCode: "410042"
        },
        {
            codeName: "首尔（韩国）",
            cusCode: "133",
            codeValue: "KOR901",
            gbName: "首尔（韩国）",
            gbCode: "KOR901",
            ciqCode: "410901"
        },
        {
            codeName: "科威特",
            cusCode: "118",
            codeValue: "KWT000",
            gbName: "科威特",
            gbCode: "KWT000",
            ciqCode: "414000"
        },
        {
            codeName: "霍尔姆法塔（科威特）",
            cusCode: "118",
            codeValue: "KWT003",
            gbName: "霍尔姆法塔（科威特）",
            gbCode: "KWT003",
            ciqCode: "414003"
        },
        {
            codeName: "科威特（科威特）",
            cusCode: "1362",
            codeValue: "KWT006",
            gbName: "科威特（科威特）",
            gbCode: "KWT006",
            ciqCode: "414006"
        },
        {
            codeName: "艾哈迈迪港（科威特）",
            cusCode: "118",
            codeValue: "KWT009",
            gbName: "艾哈迈迪港（科威特）",
            gbCode: "KWT009",
            ciqCode: "414009"
        },
        {
            codeName: "米纳阿卜杜拉（科威特）",
            cusCode: "1364",
            codeValue: "KWT012",
            gbName: "米纳阿卜杜拉（科威特）",
            gbCode: "KWT012",
            ciqCode: "414012"
        },
        {
            codeName: "米纳索特（科威特）",
            cusCode: "1365",
            codeValue: "KWT015",
            gbName: "米纳索特（科威特）",
            gbCode: "KWT015",
            ciqCode: "414015"
        },
        {
            codeName: "舒艾拜（科威特）",
            cusCode: "1366",
            codeValue: "KWT018",
            gbName: "舒艾拜（科威特）",
            gbCode: "KWT018",
            ciqCode: "414018"
        },
        {
            codeName: "舒韦赫（科威特）",
            cusCode: "1367",
            codeValue: "KWT021",
            gbName: "舒韦赫（科威特）",
            gbCode: "KWT021",
            ciqCode: "414021"
        },
        {
            codeName: "米内艾哈迈迪（科威特）",
            cusCode: "1363",
            codeValue: "KWT022",
            gbName: "米内艾哈迈迪（科威特）",
            gbCode: "KWT022",
            ciqCode: "414022"
        },
        {
            codeName: "老挝",
            cusCode: "119",
            codeValue: "LAO000",
            gbName: "老挝",
            gbCode: "LAO000",
            ciqCode: "418000"
        },
        {
            codeName: "万象（老挝）",
            cusCode: "1368",
            codeValue: "LAO901",
            gbName: "万象（老挝）",
            gbCode: "LAO901",
            ciqCode: "418901"
        },
        {
            codeName: "黎巴嫩",
            cusCode: "120",
            codeValue: "LBN000",
            gbName: "黎巴嫩",
            gbCode: "LBN000",
            ciqCode: "422000"
        },
        {
            codeName: "贝鲁特（黎巴嫩）",
            cusCode: "1369",
            codeValue: "LBN003",
            gbName: "贝鲁特（黎巴嫩）",
            gbCode: "LBN003",
            ciqCode: "422003"
        },
        {
            codeName: "舍卡（黎巴嫩）",
            cusCode: "120",
            codeValue: "LBN006",
            gbName: "舍卡（黎巴嫩）",
            gbCode: "LBN006",
            ciqCode: "422006"
        },
        {
            codeName: "朱尼耶（黎巴嫩）",
            cusCode: "120",
            codeValue: "LBN009",
            gbName: "朱尼耶（黎巴嫩）",
            gbCode: "LBN009",
            ciqCode: "422009"
        },
        {
            codeName: "腊斯塞拉塔（黎巴嫩）",
            cusCode: "120",
            codeValue: "LBN012",
            gbName: "腊斯塞拉塔（黎巴嫩）",
            gbCode: "LBN012",
            ciqCode: "422012"
        },
        {
            codeName: "赛达（黎巴嫩）",
            cusCode: "120",
            codeValue: "LBN015",
            gbName: "赛达（黎巴嫩）",
            gbCode: "LBN015",
            ciqCode: "422015"
        },
        {
            codeName: "苏尔（黎巴嫩）",
            cusCode: "120",
            codeValue: "LBN018",
            gbName: "苏尔（黎巴嫩）",
            gbCode: "LBN018",
            ciqCode: "422018"
        },
        {
            codeName: "的黎波里（黎巴嫩）",
            cusCode: "1371",
            codeValue: "LBN021",
            gbName: "的黎波里（黎巴嫩）",
            gbCode: "LBN021",
            ciqCode: "422021"
        },
        {
            codeName: "宰赫拉尼（黎巴嫩）",
            cusCode: "120",
            codeValue: "LBN024",
            gbName: "宰赫拉尼（黎巴嫩）",
            gbCode: "LBN024",
            ciqCode: "422024"
        },
        {
            codeName: "西顿（黎巴嫩）",
            cusCode: "1370",
            codeValue: "LBN030",
            gbName: "西顿（黎巴嫩）",
            gbCode: "LBN030",
            ciqCode: "422030"
        },
        {
            codeName: "利比里亚",
            cusCode: "225",
            codeValue: "LBR000",
            gbName: "利比里亚",
            gbCode: "LBR000",
            ciqCode: "430000"
        },
        {
            codeName: "布坎南（利比里亚）",
            cusCode: "1660",
            codeValue: "LBR003",
            gbName: "布坎南（利比里亚）",
            gbCode: "LBR003",
            ciqCode: "430003"
        },
        {
            codeName: "帕尔马斯角（利比里亚）",
            cusCode: "1665",
            codeValue: "LBR006",
            gbName: "帕尔马斯角（利比里亚）",
            gbCode: "LBR006",
            ciqCode: "430006"
        },
        {
            codeName: "大巴萨（利比里亚）",
            cusCode: "225",
            codeValue: "LBR009",
            gbName: "大巴萨（利比里亚）",
            gbCode: "LBR009",
            ciqCode: "430009"
        },
        {
            codeName: "格林维尔（利比里亚）",
            cusCode: "225",
            codeValue: "LBR012",
            gbName: "格林维尔（利比里亚）",
            gbCode: "LBR012",
            ciqCode: "430012"
        },
        {
            codeName: "马歇尔（利比里亚）",
            cusCode: "1663",
            codeValue: "LBR015",
            gbName: "马歇尔（利比里亚）",
            gbCode: "LBR015",
            ciqCode: "430015"
        },
        {
            codeName: "蒙罗维亚（利比里亚）",
            cusCode: "1664",
            codeValue: "LBR018",
            gbName: "蒙罗维亚（利比里亚）",
            gbCode: "LBR018",
            ciqCode: "430018"
        },
        {
            codeName: "里弗塞斯（利比里亚）",
            cusCode: "225",
            codeValue: "LBR021",
            gbName: "里弗塞斯（利比里亚）",
            gbCode: "LBR021",
            ciqCode: "430021"
        },
        {
            codeName: "HARPER C.（利比里亚）",
            cusCode: "1661",
            codeValue: "LBR030",
            gbName: "HARPER C.（利比里亚）",
            gbCode: "LBR030",
            ciqCode: "430030"
        },
        {
            codeName: "下布坎南（利比里亚）",
            cusCode: "1662",
            codeValue: "LBR031",
            gbName: "下布坎南（利比里亚）",
            gbCode: "LBR031",
            ciqCode: "430031"
        },
        {
            codeName: "利比亚",
            cusCode: "226",
            codeValue: "LBY000",
            gbName: "利比亚",
            gbCode: "LBY000",
            ciqCode: "434000"
        },
        {
            codeName: "阿济伟亚（利比亚）",
            cusCode: "226",
            codeValue: "LBY003",
            gbName: "阿济伟亚（利比亚）",
            gbCode: "LBY003",
            ciqCode: "434003"
        },
        {
            codeName: "巴迪亚（利比亚）",
            cusCode: "1670",
            codeValue: "LBY006",
            gbName: "巴迪亚（利比亚）",
            gbCode: "LBY006",
            ciqCode: "434006"
        },
        {
            codeName: "班加西（利比亚）",
            cusCode: "1666",
            codeValue: "LBY009",
            gbName: "班加西（利比亚）",
            gbCode: "LBY009",
            ciqCode: "434009"
        },
        {
            codeName: "德尔纳（利比亚）",
            cusCode: "1671",
            codeValue: "LBY012",
            gbName: "德尔纳（利比亚）",
            gbCode: "LBY012",
            ciqCode: "434012"
        },
        {
            codeName: "锡德尔（利比亚）",
            cusCode: "226",
            codeValue: "LBY015",
            gbName: "锡德尔（利比亚）",
            gbCode: "LBY015",
            ciqCode: "434015"
        },
        {
            codeName: "卜雷加港（利比亚）",
            cusCode: "1667",
            codeValue: "LBY017",
            gbName: "卜雷加港（利比亚）",
            gbCode: "LBY017",
            ciqCode: "434017"
        },
        {
            codeName: "哈里盖港（利比亚）",
            cusCode: "226",
            codeValue: "LBY018",
            gbName: "哈里盖港（利比亚）",
            gbCode: "LBY018",
            ciqCode: "434018"
        },
        {
            codeName: "米苏拉塔区（利比亚）",
            cusCode: "1672",
            codeValue: "LBY021",
            gbName: "米苏拉塔区（利比亚）",
            gbCode: "LBY021",
            ciqCode: "434021"
        },
        {
            codeName: "拉斯拉努夫（利比亚）",
            cusCode: "1673",
            codeValue: "LBY024",
            gbName: "拉斯拉努夫（利比亚）",
            gbCode: "LBY024",
            ciqCode: "434024"
        },
        {
            codeName: "图卜鲁格（利比亚）",
            cusCode: "1668",
            codeValue: "LBY027",
            gbName: "图卜鲁格（利比亚）",
            gbCode: "LBY027",
            ciqCode: "434027"
        },
        {
            codeName: "的黎波里（利比亚）",
            cusCode: "1674",
            codeValue: "LBY030",
            gbName: "的黎波里（利比亚）",
            gbCode: "LBY030",
            ciqCode: "434030"
        },
        {
            codeName: "兹利坦（利比亚）",
            cusCode: "226",
            codeValue: "LBY033",
            gbName: "兹利坦（利比亚）",
            gbCode: "LBY033",
            ciqCode: "434033"
        },
        {
            codeName: "兹瓦拉（利比亚）",
            cusCode: "226",
            codeValue: "LBY036",
            gbName: "兹瓦拉（利比亚）",
            gbCode: "LBY036",
            ciqCode: "434036"
        },
        {
            codeName: "祖埃提纳（利比亚）",
            cusCode: "1669",
            codeValue: "LBY039",
            gbName: "祖埃提纳（利比亚）",
            gbCode: "LBY039",
            ciqCode: "434039"
        },
        {
            codeName: "圣卢西亚",
            cusCode: "437",
            codeValue: "LCA000",
            gbName: "圣卢西亚",
            gbCode: "LCA000",
            ciqCode: "662000"
        },
        {
            codeName: "卡斯特里（圣卢西亚）",
            cusCode: "2933",
            codeValue: "LCA003",
            gbName: "卡斯特里（圣卢西亚）",
            gbCode: "LCA003",
            ciqCode: "662003"
        },
        {
            codeName: "苏弗里耶尔（圣卢西亚）",
            cusCode: "437",
            codeValue: "LCA006",
            gbName: "苏弗里耶尔（圣卢西亚）",
            gbCode: "LCA006",
            ciqCode: "662006"
        },
        {
            codeName: "维约堡（圣卢西亚）",
            cusCode: "437",
            codeValue: "LCA009",
            gbName: "维约堡（圣卢西亚）",
            gbCode: "LCA009",
            ciqCode: "662009"
        },
        {
            codeName: "列支敦士登",
            cusCode: "323",
            codeValue: "LIE000",
            gbName: "列支敦士登",
            gbCode: "LIE000",
            ciqCode: "438000"
        },
        {
            codeName: "斯里兰卡",
            cusCode: "134",
            codeValue: "LKA000",
            gbName: "斯里兰卡",
            gbCode: "LKA000",
            ciqCode: "144000"
        },
        {
            codeName: "拜蒂克洛（斯里兰卡）",
            cusCode: "134",
            codeValue: "LKA003",
            gbName: "拜蒂克洛（斯里兰卡）",
            gbCode: "LKA003",
            ciqCode: "144003"
        },
        {
            codeName: "科伦坡（斯里兰卡）",
            cusCode: "1489",
            codeValue: "LKA006",
            gbName: "科伦坡（斯里兰卡）",
            gbCode: "LKA006",
            ciqCode: "144006"
        },
        {
            codeName: "加勒（斯里兰卡）",
            cusCode: "1490",
            codeValue: "LKA009",
            gbName: "加勒（斯里兰卡）",
            gbCode: "LKA009",
            ciqCode: "144009"
        },
        {
            codeName: "贾夫纳（斯里兰卡）",
            cusCode: "134",
            codeValue: "LKA012",
            gbName: "贾夫纳（斯里兰卡）",
            gbCode: "LKA012",
            ciqCode: "144012"
        },
        {
            codeName: "卡卢特勒（斯里兰卡）",
            cusCode: "134",
            codeValue: "LKA015",
            gbName: "卡卢特勒（斯里兰卡）",
            gbCode: "LKA015",
            ciqCode: "144015"
        },
        {
            codeName: "坎凯桑图赖（斯里兰卡）",
            cusCode: "134",
            codeValue: "LKA018",
            gbName: "坎凯桑图赖（斯里兰卡）",
            gbCode: "LKA018",
            ciqCode: "144018"
        },
        {
            codeName: "凯茨（斯里兰卡）",
            cusCode: "134",
            codeValue: "LKA021",
            gbName: "凯茨（斯里兰卡）",
            gbCode: "LKA021",
            ciqCode: "144021"
        },
        {
            codeName: "马特勒（斯里兰卡）",
            cusCode: "134",
            codeValue: "LKA024",
            gbName: "马特勒（斯里兰卡）",
            gbCode: "LKA024",
            ciqCode: "144024"
        },
        {
            codeName: "尼甘布（斯里兰卡）",
            cusCode: "134",
            codeValue: "LKA027",
            gbName: "尼甘布（斯里兰卡）",
            gbCode: "LKA027",
            ciqCode: "144027"
        },
        {
            codeName: "马纳尔（斯里兰卡）",
            cusCode: "134",
            codeValue: "LKA028",
            gbName: "马纳尔（斯里兰卡）",
            gbCode: "LKA028",
            ciqCode: "144028"
        },
        {
            codeName: "塔莱曼纳尔（斯里兰卡）",
            cusCode: "134",
            codeValue: "LKA029",
            gbName: "塔莱曼纳尔（斯里兰卡）",
            gbCode: "LKA029",
            ciqCode: "144029"
        },
        {
            codeName: "亭可马里（斯里兰卡）",
            cusCode: "1491",
            codeValue: "LKA030",
            gbName: "亭可马里（斯里兰卡）",
            gbCode: "LKA030",
            ciqCode: "144030"
        },
        {
            codeName: "莱索托",
            cusCode: "255",
            codeValue: "LSO000",
            gbName: "莱索托",
            gbCode: "LSO000",
            ciqCode: "426000"
        },
        {
            codeName: "立陶宛",
            cusCode: "336",
            codeValue: "LTU000",
            gbName: "立陶宛",
            gbCode: "LTU000",
            ciqCode: "440000"
        },
        {
            codeName: "克莱佩达（立陶宛）",
            cusCode: "336",
            codeValue: "LTU002",
            gbName: "克莱佩达（立陶宛）",
            gbCode: "LTU002",
            ciqCode: "440002"
        },
        {
            codeName: "卢森堡",
            cusCode: "308",
            codeValue: "LUX000",
            gbName: "卢森堡",
            gbCode: "LUX000",
            ciqCode: "442000"
        },
        {
            codeName: "卢森堡（卢森堡）",
            cusCode: "2293",
            codeValue: "LUX001",
            gbName: "卢森堡（卢森堡）",
            gbCode: "LUX001",
            ciqCode: "442001"
        },
        {
            codeName: "拉脱维亚",
            cusCode: "335",
            codeValue: "LVA000",
            gbName: "拉脱维亚",
            gbCode: "LVA000",
            ciqCode: "428000"
        },
        {
            codeName: "里加（拉脱维亚）",
            cusCode: "2663",
            codeValue: "LVA003",
            gbName: "里加（拉脱维亚）",
            gbCode: "LVA003",
            ciqCode: "428003"
        },
        {
            codeName: "利耶帕亚（拉脱维亚）",
            cusCode: "3421",
            codeValue: "LVA006",
            gbName: "利耶帕亚（拉脱维亚）",
            gbCode: "LVA006",
            ciqCode: "428006"
        },
        {
            codeName: "文茨皮尔斯（拉脱维亚）",
            cusCode: "335",
            codeValue: "LVA009",
            gbName: "文茨皮尔斯（拉脱维亚）",
            gbCode: "LVA009",
            ciqCode: "428009"
        },
        {
            codeName: "中国澳门",
            cusCode: "121",
            codeValue: "MAC000",
            gbName: "中国澳门",
            gbCode: "MAC000",
            ciqCode: "446000"
        },
        {
            codeName: "澳门（中国澳门）",
            cusCode: "1373",
            codeValue: "MAC003",
            gbName: "澳门（中国澳门）",
            gbCode: "MAC003",
            ciqCode: "446003"
        },
        {
            codeName: "法属圣马丁",
            cusCode: "438",
            codeValue: "MAF000",
            gbName: "法属圣马丁",
            gbCode: "MAF000",
            ciqCode: "663000"
        },
        {
            codeName: "菲利普斯堡（圣马丁(法国)）",
            cusCode: "438",
            codeValue: "MAF003",
            gbName: "菲利普斯堡（圣马丁(法国)）",
            gbCode: "MAF003",
            ciqCode: "663003"
        },
        {
            codeName: "摩洛哥",
            cusCode: "232",
            codeValue: "MAR000",
            gbName: "摩洛哥",
            gbCode: "MAR000",
            ciqCode: "504000"
        },
        {
            codeName: "阿加迪尔（摩洛哥）",
            cusCode: "1693",
            codeValue: "MAR003",
            gbName: "阿加迪尔（摩洛哥）",
            gbCode: "MAR003",
            ciqCode: "504003"
        },
        {
            codeName: "卡萨布兰卡（摩洛哥）",
            cusCode: "232",
            codeValue: "MAR006",
            gbName: "卡萨布兰卡（摩洛哥）",
            gbCode: "MAR006",
            ciqCode: "504006"
        },
        {
            codeName: "贾迪达（摩洛哥）",
            cusCode: "232",
            codeValue: "MAR009",
            gbName: "贾迪达（摩洛哥）",
            gbCode: "MAR009",
            ciqCode: "504009"
        },
        {
            codeName: "索维拉（摩洛哥）",
            cusCode: "232",
            codeValue: "MAR012",
            gbName: "索维拉（摩洛哥）",
            gbCode: "MAR012",
            ciqCode: "504012"
        },
        {
            codeName: "朱尔夫莱斯费尔（摩洛哥）",
            cusCode: "232",
            codeValue: "MAR015",
            gbName: "朱尔夫莱斯费尔（摩洛哥）",
            gbCode: "MAR015",
            ciqCode: "504015"
        },
        {
            codeName: "盖尼特拉（摩洛哥）",
            cusCode: "1694",
            codeValue: "MAR018",
            gbName: "盖尼特拉（摩洛哥）",
            gbCode: "MAR018",
            ciqCode: "504018"
        },
        {
            codeName: "拉腊什（摩洛哥）",
            cusCode: "1695",
            codeValue: "MAR021",
            gbName: "拉腊什（摩洛哥）",
            gbCode: "MAR021",
            ciqCode: "504021"
        },
        {
            codeName: "穆罕默迪耶（摩洛哥）",
            cusCode: "1698",
            codeValue: "MAR024",
            gbName: "穆罕默迪耶（摩洛哥）",
            gbCode: "MAR024",
            ciqCode: "504024"
        },
        {
            codeName: "纳祖尔（摩洛哥）",
            cusCode: "232",
            codeValue: "MAR027",
            gbName: "纳祖尔（摩洛哥）",
            gbCode: "MAR027",
            ciqCode: "504027"
        },
        {
            codeName: "拉巴特（摩洛哥）",
            cusCode: "232",
            codeValue: "MAR030",
            gbName: "拉巴特（摩洛哥）",
            gbCode: "MAR030",
            ciqCode: "504030"
        },
        {
            codeName: "萨菲（摩洛哥）",
            cusCode: "1701",
            codeValue: "MAR033",
            gbName: "萨菲（摩洛哥）",
            gbCode: "MAR033",
            ciqCode: "504033"
        },
        {
            codeName: "丹吉尔（摩洛哥）",
            cusCode: "1702",
            codeValue: "MAR036",
            gbName: "丹吉尔（摩洛哥）",
            gbCode: "MAR036",
            ciqCode: "504036"
        },
        {
            codeName: "塔尔法亚（摩洛哥）",
            cusCode: "232",
            codeValue: "MAR039",
            gbName: "塔尔法亚（摩洛哥）",
            gbCode: "MAR039",
            ciqCode: "504039"
        },
        {
            codeName: "得土安（摩洛哥）",
            cusCode: "232",
            codeValue: "MAR042",
            gbName: "得土安（摩洛哥）",
            gbCode: "MAR042",
            ciqCode: "504042"
        },
        {
            codeName: "RIO MARTIN（摩洛哥）",
            cusCode: "1700",
            codeValue: "MAR051",
            gbName: "RIO MARTIN（摩洛哥）",
            gbCode: "MAR051",
            ciqCode: "504051"
        },
        {
            codeName: "克尼特拉（摩洛哥）",
            cusCode: "1699",
            codeValue: "MAR054",
            gbName: "克尼特拉（摩洛哥）",
            gbCode: "MAR054",
            ciqCode: "504054"
        },
        {
            codeName: "马尔提勒（摩洛哥）",
            cusCode: "1696",
            codeValue: "MAR055",
            gbName: "马尔提勒（摩洛哥）",
            gbCode: "MAR055",
            ciqCode: "504055"
        },
        {
            codeName: "Tetuan（摩洛哥）",
            cusCode: "1703",
            codeValue: "MAR056",
            gbName: "Tetuan（摩洛哥）",
            gbCode: "MAR056",
            ciqCode: "504056"
        },
        {
            codeName: "伊萨奥伊拉（摩洛哥）",
            cusCode: "1697",
            codeValue: "MAR057",
            gbName: "伊萨奥伊拉（摩洛哥）",
            gbCode: "MAR057",
            ciqCode: "504057"
        },
        {
            codeName: "摩纳哥",
            cusCode: "325",
            codeValue: "MCO000",
            gbName: "摩纳哥",
            gbCode: "MCO000",
            ciqCode: "492000"
        },
        {
            codeName: "摩纳哥（摩纳哥）",
            cusCode: "2468",
            codeValue: "MCO002",
            gbName: "摩纳哥（摩纳哥）",
            gbCode: "MCO002",
            ciqCode: "492002"
        },
        {
            codeName: "蒙特卡洛（摩纳哥）",
            cusCode: "325",
            codeValue: "MCO003",
            gbName: "蒙特卡洛（摩纳哥）",
            gbCode: "MCO003",
            ciqCode: "492003"
        },
        {
            codeName: "摩尔多瓦",
            cusCode: "343",
            codeValue: "MDA000",
            gbName: "摩尔多瓦",
            gbCode: "MDA000",
            ciqCode: "498000"
        },
        {
            codeName: "马达加斯加",
            cusCode: "227",
            codeValue: "MDG000",
            gbName: "马达加斯加",
            gbCode: "MDG000",
            ciqCode: "450000"
        },
        {
            codeName: "阿纳拉拉瓦（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG003",
            gbName: "阿纳拉拉瓦（马达加斯加）",
            gbCode: "MDG003",
            ciqCode: "450003"
        },
        {
            codeName: "安塔拉哈（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG006",
            gbName: "安塔拉哈（马达加斯加）",
            gbCode: "MDG006",
            ciqCode: "450006"
        },
        {
            codeName: "安齐拉纳纳（马达加斯加）",
            cusCode: "1684",
            codeValue: "MDG009",
            gbName: "安齐拉纳纳（马达加斯加）",
            gbCode: "MDG009",
            ciqCode: "450009"
        },
        {
            codeName: "法拉凡加纳（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG012",
            gbName: "法拉凡加纳（马达加斯加）",
            gbCode: "MDG012",
            ciqCode: "450012"
        },
        {
            codeName: "多凡堡（马达加斯加）",
            cusCode: "1681",
            codeValue: "MDG015",
            gbName: "多凡堡（马达加斯加）",
            gbCode: "MDG015",
            ciqCode: "450015"
        },
        {
            codeName: "马任加（马达加斯加）",
            cusCode: "1675",
            codeValue: "MDG018",
            gbName: "马任加（马达加斯加）",
            gbCode: "MDG018",
            ciqCode: "450018"
        },
        {
            codeName: "马纳卡拉（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG021",
            gbName: "马纳卡拉（马达加斯加）",
            gbCode: "MDG021",
            ciqCode: "450021"
        },
        {
            codeName: "马南扎里河（马达加斯加）",
            cusCode: "1676",
            codeValue: "MDG024",
            gbName: "马南扎里河（马达加斯加）",
            gbCode: "MDG024",
            ciqCode: "450024"
        },
        {
            codeName: "马鲁安采特拉（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG027",
            gbName: "马鲁安采特拉（马达加斯加）",
            gbCode: "MDG027",
            ciqCode: "450027"
        },
        {
            codeName: "穆龙贝（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG030",
            gbName: "穆龙贝（马达加斯加）",
            gbCode: "MDG030",
            ciqCode: "450030"
        },
        {
            codeName: "穆龙达瓦（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG033",
            gbName: "穆龙达瓦（马达加斯加）",
            gbCode: "MDG033",
            ciqCode: "450033"
        },
        {
            codeName: "贝岛（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG036",
            gbName: "贝岛（马达加斯加）",
            gbCode: "MDG036",
            ciqCode: "450036"
        },
        {
            codeName: "桑巴瓦（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG039",
            gbName: "桑巴瓦（马达加斯加）",
            gbCode: "MDG039",
            ciqCode: "450039"
        },
        {
            codeName: "图阿马西纳（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG042",
            gbName: "图阿马西纳（马达加斯加）",
            gbCode: "MDG042",
            ciqCode: "450042"
        },
        {
            codeName: "托拉纳罗（马达加斯加）",
            cusCode: "227",
            codeValue: "MDG045",
            gbName: "托拉纳罗（马达加斯加）",
            gbCode: "MDG045",
            ciqCode: "450045"
        },
        {
            codeName: "图莱亚尔（马达加斯加）",
            cusCode: "1680",
            codeValue: "MDG048",
            gbName: "图莱亚尔（马达加斯加）",
            gbCode: "MDG048",
            ciqCode: "450048"
        },
        {
            codeName: "努西贝（马达加斯加）",
            cusCode: "1677",
            codeValue: "MDG050",
            gbName: "努西贝（马达加斯加）",
            gbCode: "MDG050",
            ciqCode: "450050"
        },
        {
            codeName: "塔那那利佛（马达加斯加）",
            cusCode: "1678",
            codeValue: "MDG051",
            gbName: "塔那那利佛（马达加斯加）",
            gbCode: "MDG051",
            ciqCode: "450051"
        },
        {
            codeName: "马尔代夫",
            cusCode: "123",
            codeValue: "MDV000",
            gbName: "马尔代夫",
            gbCode: "MDV000",
            ciqCode: "462000"
        },
        {
            codeName: "阿杜环礁（马尔代夫）",
            cusCode: "123",
            codeValue: "MDV003",
            gbName: "阿杜环礁（马尔代夫）",
            gbCode: "MDV003",
            ciqCode: "462003"
        },
        {
            codeName: "马累岛（马尔代夫）",
            cusCode: "1412",
            codeValue: "MDV006",
            gbName: "马累岛（马尔代夫）",
            gbCode: "MDV006",
            ciqCode: "462006"
        },
        {
            codeName: "梅利利亚",
            cusCode: "256",
            codeValue: "MEL000",
            gbName: "梅利利亚",
            gbCode: "MEL000",
            ciqCode: "482000"
        },
        {
            codeName: "梅利利亚（梅利利亚）",
            cusCode: "256",
            codeValue: "MEL003",
            gbName: "梅利利亚（梅利利亚）",
            gbCode: "MEL003",
            ciqCode: "482003"
        },
        {
            codeName: "墨西哥",
            cusCode: "429",
            codeValue: "MEX000",
            gbName: "墨西哥",
            gbCode: "MEX000",
            ciqCode: "484000"
        },
        {
            codeName: "阿卡普尔科（墨西哥）",
            cusCode: "2876",
            codeValue: "MEX003",
            gbName: "阿卡普尔科（墨西哥）",
            gbCode: "MEX003",
            ciqCode: "484003"
        },
        {
            codeName: "阿尔瓦拉多（墨西哥）",
            cusCode: "2877",
            codeValue: "MEX006",
            gbName: "阿尔瓦拉多（墨西哥）",
            gbCode: "MEX006",
            ciqCode: "484006"
        },
        {
            codeName: "坎佩切（墨西哥）",
            cusCode: "429",
            codeValue: "MEX009",
            gbName: "坎佩切（墨西哥）",
            gbCode: "MEX009",
            ciqCode: "484009"
        },
        {
            codeName: "阿卡斯群岛码头（墨西哥）",
            cusCode: "429",
            codeValue: "MEX012",
            gbName: "阿卡斯群岛码头（墨西哥）",
            gbCode: "MEX012",
            ciqCode: "484012"
        },
        {
            codeName: "卡门城（墨西哥）",
            cusCode: "2878",
            codeValue: "MEX015",
            gbName: "卡门城（墨西哥）",
            gbCode: "MEX015",
            ciqCode: "484015"
        },
        {
            codeName: "夸察夸尔科斯（墨西哥）",
            cusCode: "429",
            codeValue: "MEX018",
            gbName: "夸察夸尔科斯（墨西哥）",
            gbCode: "MEX018",
            ciqCode: "484018"
        },
        {
            codeName: "科苏梅尔岛（墨西哥）",
            cusCode: "429",
            codeValue: "MEX021",
            gbName: "科苏梅尔岛（墨西哥）",
            gbCode: "MEX021",
            ciqCode: "484021"
        },
        {
            codeName: "多斯博卡斯（墨西哥）",
            cusCode: "429",
            codeValue: "MEX024",
            gbName: "多斯博卡斯（墨西哥）",
            gbCode: "MEX024",
            ciqCode: "484024"
        },
        {
            codeName: "恩塞纳达（墨西哥）",
            cusCode: "429",
            codeValue: "MEX027",
            gbName: "恩塞纳达（墨西哥）",
            gbCode: "MEX027",
            ciqCode: "484027"
        },
        {
            codeName: "弗龙特拉（墨西哥）",
            cusCode: "2879",
            codeValue: "MEX030",
            gbName: "弗龙特拉（墨西哥）",
            gbCode: "MEX030",
            ciqCode: "484030"
        },
        {
            codeName: "瓜伊马斯（墨西哥）",
            cusCode: "2880",
            codeValue: "MEX033",
            gbName: "瓜伊马斯（墨西哥）",
            gbCode: "MEX033",
            ciqCode: "484033"
        },
        {
            codeName: "拉巴斯（墨西哥）",
            cusCode: "2882",
            codeValue: "MEX036",
            gbName: "拉巴斯（墨西哥）",
            gbCode: "MEX036",
            ciqCode: "484036"
        },
        {
            codeName: "拉萨罗卡德纳斯（墨西哥）",
            cusCode: "429",
            codeValue: "MEX039",
            gbName: "拉萨罗卡德纳斯（墨西哥）",
            gbCode: "MEX039",
            ciqCode: "484039"
        },
        {
            codeName: "曼萨尼略（墨西哥）",
            cusCode: "2881",
            codeValue: "MEX042",
            gbName: "曼萨尼略（墨西哥）",
            gbCode: "MEX042",
            ciqCode: "484042"
        },
        {
            codeName: "马萨特兰（墨西哥）",
            cusCode: "2883",
            codeValue: "MEX045",
            gbName: "马萨特兰（墨西哥）",
            gbCode: "MEX045",
            ciqCode: "484045"
        },
        {
            codeName: "米纳蒂特兰（墨西哥）",
            cusCode: "429",
            codeValue: "MEX048",
            gbName: "米纳蒂特兰（墨西哥）",
            gbCode: "MEX048",
            ciqCode: "484048"
        },
        {
            codeName: "莫罗雷东杜（墨西哥）",
            cusCode: "429",
            codeValue: "MEX051",
            gbName: "莫罗雷东杜（墨西哥）",
            gbCode: "MEX051",
            ciqCode: "484051"
        },
        {
            codeName: "南吉塔（墨西哥）",
            cusCode: "2884",
            codeValue: "MEX054",
            gbName: "南吉塔（墨西哥）",
            gbCode: "MEX054",
            ciqCode: "484054"
        },
        {
            codeName: "瑙特拉（墨西哥）",
            cusCode: "429",
            codeValue: "MEX057",
            gbName: "瑙特拉（墨西哥）",
            gbCode: "MEX057",
            ciqCode: "484057"
        },
        {
            codeName: "普罗格雷索（墨西哥）",
            cusCode: "429",
            codeValue: "MEX060",
            gbName: "普罗格雷索（墨西哥）",
            gbCode: "MEX060",
            ciqCode: "484060"
        },
        {
            codeName: "马德罗港（墨西哥）",
            cusCode: "429",
            codeValue: "MEX063",
            gbName: "马德罗港（墨西哥）",
            gbCode: "MEX063",
            ciqCode: "484063"
        },
        {
            codeName: "罗萨里托码头（墨西哥）",
            cusCode: "429",
            codeValue: "MEX066",
            gbName: "罗萨里托码头（墨西哥）",
            gbCode: "MEX066",
            ciqCode: "484066"
        },
        {
            codeName: "萨利纳克鲁斯（墨西哥）",
            cusCode: "2886",
            codeValue: "MEX069",
            gbName: "萨利纳克鲁斯（墨西哥）",
            gbCode: "MEX069",
            ciqCode: "484069"
        },
        {
            codeName: "圣罗萨利亚（墨西哥）",
            cusCode: "2887",
            codeValue: "MEX072",
            gbName: "圣罗萨利亚（墨西哥）",
            gbCode: "MEX072",
            ciqCode: "484072"
        },
        {
            codeName: "坦皮科（墨西哥）",
            cusCode: "2889",
            codeValue: "MEX075",
            gbName: "坦皮科（墨西哥）",
            gbCode: "MEX075",
            ciqCode: "484075"
        },
        {
            codeName: "托波洛班波（墨西哥）",
            cusCode: "2890",
            codeValue: "MEX078",
            gbName: "托波洛班波（墨西哥）",
            gbCode: "MEX078",
            ciqCode: "484078"
        },
        {
            codeName: "图斯潘（墨西哥）",
            cusCode: "2891",
            codeValue: "MEX081",
            gbName: "图斯潘（墨西哥）",
            gbCode: "MEX081",
            ciqCode: "484081"
        },
        {
            codeName: "韦拉克鲁斯（墨西哥）",
            cusCode: "2892",
            codeValue: "MEX084",
            gbName: "韦拉克鲁斯（墨西哥）",
            gbCode: "MEX084",
            ciqCode: "484084"
        },
        {
            codeName: "瓦哈卡（墨西哥）",
            cusCode: "2885",
            codeValue: "MEX091",
            gbName: "瓦哈卡（墨西哥）",
            gbCode: "MEX091",
            ciqCode: "484091"
        },
        {
            codeName: "锡纳洛阿（墨西哥）",
            cusCode: "2888",
            codeValue: "MEX092",
            gbName: "锡纳洛阿（墨西哥）",
            gbCode: "MEX092",
            ciqCode: "484092"
        },
        {
            codeName: "墨西长利（墨西哥）",
            cusCode: "429",
            codeValue: "MEX901",
            gbName: "墨西长利（墨西哥）",
            gbCode: "MEX901",
            ciqCode: "484901"
        },
        {
            codeName: "墨西哥城（墨西哥）",
            cusCode: "429",
            codeValue: "MEX904",
            gbName: "墨西哥城（墨西哥）",
            gbCode: "MEX904",
            ciqCode: "484904"
        },
        {
            codeName: "马绍尔群岛",
            cusCode: "621",
            codeValue: "MHL000",
            gbName: "马绍尔群岛",
            gbCode: "MHL000",
            ciqCode: "584000"
        },
        {
            codeName: "塔罗阿（马绍尔群岛）",
            cusCode: "3405",
            codeValue: "MHL003",
            gbName: "塔罗阿（马绍尔群岛）",
            gbCode: "MHL003",
            ciqCode: "584003"
        },
        {
            codeName: "马朱罗（马绍尔群岛）",
            cusCode: "621",
            codeValue: "MHL006",
            gbName: "马朱罗（马绍尔群岛）",
            gbCode: "MHL006",
            ciqCode: "584006"
        },
        {
            codeName: "贾卢伊特（马绍尔群岛）",
            cusCode: "3387",
            codeValue: "MHL007",
            gbName: "贾卢伊特（马绍尔群岛）",
            gbCode: "MHL007",
            ciqCode: "584007"
        },
        {
            codeName: "夸贾林（马绍尔群岛）",
            cusCode: "3392",
            codeValue: "MHL008",
            gbName: "夸贾林（马绍尔群岛）",
            gbCode: "MHL008",
            ciqCode: "584008"
        },
        {
            codeName: "莱岛（马绍尔群岛）",
            cusCode: "3393",
            codeValue: "MHL009",
            gbName: "莱岛（马绍尔群岛）",
            gbCode: "MHL009",
            ciqCode: "584009"
        },
        {
            codeName: "沃特杰（马绍尔群岛）",
            cusCode: "3412",
            codeValue: "MHL010",
            gbName: "沃特杰（马绍尔群岛）",
            gbCode: "MHL010",
            ciqCode: "584010"
        },
        {
            codeName: "查尔里特（马绍尔群岛）",
            cusCode: "3388",
            codeValue: "MHL011",
            gbName: "查尔里特（马绍尔群岛）",
            gbCode: "MHL011",
            ciqCode: "584011"
        },
        {
            codeName: "北马其顿",
            cusCode: "354",
            codeValue: "MKD000",
            gbName: "北马其顿",
            gbCode: "MKD000",
            ciqCode: "807000"
        },
        {
            codeName: "马里",
            cusCode: "229",
            codeValue: "MLI000",
            gbName: "马里",
            gbCode: "MLI000",
            ciqCode: "466000"
        },
        {
            codeName: "凯斯（马里）",
            cusCode: "1686",
            codeValue: "MLI001",
            gbName: "凯斯（马里）",
            gbCode: "MLI001",
            ciqCode: "466001"
        },
        {
            codeName: "塞古（马里）",
            cusCode: "1687",
            codeValue: "MLI002",
            gbName: "塞古（马里）",
            gbCode: "MLI002",
            ciqCode: "466002"
        },
        {
            codeName: "廷巴克图（马里）",
            cusCode: "1689",
            codeValue: "MLI003",
            gbName: "廷巴克图（马里）",
            gbCode: "MLI003",
            ciqCode: "466003"
        },
        {
            codeName: "锡卡索（马里）",
            cusCode: "1688",
            codeValue: "MLI004",
            gbName: "锡卡索（马里）",
            gbCode: "MLI004",
            ciqCode: "466004"
        },
        {
            codeName: "马耳他",
            cusCode: "324",
            codeValue: "MLT000",
            gbName: "马耳他",
            gbCode: "MLT000",
            ciqCode: "470000"
        },
        {
            codeName: "瓦莱塔（马耳他）",
            cusCode: "3452",
            codeValue: "MLT003",
            gbName: "瓦莱塔（马耳他）",
            gbCode: "MLT003",
            ciqCode: "470003"
        },
        {
            codeName: "马尔萨什洛克（马耳他）",
            cusCode: "324",
            codeValue: "MLT006",
            gbName: "马尔萨什洛克（马耳他）",
            gbCode: "MLT006",
            ciqCode: "470006"
        },
        {
            codeName: "缅甸",
            cusCode: "106",
            codeValue: "MMR000",
            gbName: "缅甸",
            gbCode: "MMR000",
            ciqCode: "104000"
        },
        {
            codeName: "八莫（缅甸）",
            cusCode: "1015",
            codeValue: "MMR001",
            gbName: "八莫（缅甸）",
            gbCode: "MMR001",
            ciqCode: "104001"
        },
        {
            codeName: "实兑（缅甸）",
            cusCode: "1013",
            codeValue: "MMR003",
            gbName: "实兑（缅甸）",
            gbCode: "MMR003",
            ciqCode: "104003"
        },
        {
            codeName: "勃生（缅甸）",
            cusCode: "1014",
            codeValue: "MMR006",
            gbName: "勃生（缅甸）",
            gbCode: "MMR006",
            ciqCode: "104006"
        },
        {
            codeName: "皎漂（缅甸）",
            cusCode: "106",
            codeValue: "MMR009",
            gbName: "皎漂（缅甸）",
            gbCode: "MMR009",
            ciqCode: "104009"
        },
        {
            codeName: "墨吉（缅甸）",
            cusCode: "106",
            codeValue: "MMR012",
            gbName: "墨吉（缅甸）",
            gbCode: "MMR012",
            ciqCode: "104012"
        },
        {
            codeName: "毛淡棉（缅甸）",
            cusCode: "1016",
            codeValue: "MMR015",
            gbName: "毛淡棉（缅甸）",
            gbCode: "MMR015",
            ciqCode: "104015"
        },
        {
            codeName: "仰光（缅甸）",
            cusCode: "106",
            codeValue: "MMR018",
            gbName: "仰光（缅甸）",
            gbCode: "MMR018",
            ciqCode: "104018"
        },
        {
            codeName: "丹兑（山多威）（缅甸）",
            cusCode: "106",
            codeValue: "MMR021",
            gbName: "丹兑（山多威）（缅甸）",
            gbCode: "MMR021",
            ciqCode: "104021"
        },
        {
            codeName: "土瓦（缅甸）",
            cusCode: "106",
            codeValue: "MMR024",
            gbName: "土瓦（缅甸）",
            gbCode: "MMR024",
            ciqCode: "104024"
        },
        {
            codeName: "耶城（缅甸）",
            cusCode: "106",
            codeValue: "MMR026",
            gbName: "耶城（缅甸）",
            gbCode: "MMR026",
            ciqCode: "104026"
        },
        {
            codeName: "德林达伊（缅甸）",
            cusCode: "106",
            codeValue: "MMR027",
            gbName: "德林达伊（缅甸）",
            gbCode: "MMR027",
            ciqCode: "104027"
        },
        {
            codeName: "维多利亚角（缅甸）",
            cusCode: "106",
            codeValue: "MMR030",
            gbName: "维多利亚角（缅甸）",
            gbCode: "MMR030",
            ciqCode: "104030"
        },
        {
            codeName: "黑山",
            cusCode: "359",
            codeValue: "MNE000",
            gbName: "黑山",
            gbCode: "MNE000",
            ciqCode: "499000"
        },
        {
            codeName: "巴尔（黑山共和国）",
            cusCode: "2677",
            codeValue: "MNE003",
            gbName: "巴尔（黑山共和国）",
            gbCode: "MNE003",
            ciqCode: "499003"
        },
        {
            codeName: "科托尔（黑山共和国）",
            cusCode: "2687",
            codeValue: "MNE006",
            gbName: "科托尔（黑山共和国）",
            gbCode: "MNE006",
            ciqCode: "499006"
        },
        {
            codeName: "卡达尔耶娃（黑山共和国）",
            cusCode: "2684",
            codeValue: "MNE009",
            gbName: "卡达尔耶娃（黑山共和国）",
            gbCode: "MNE009",
            ciqCode: "499009"
        },
        {
            codeName: "蒙古",
            cusCode: "124",
            codeValue: "MNG000",
            gbName: "蒙古",
            gbCode: "MNG000",
            ciqCode: "496000"
        },
        {
            codeName: "乌兰巴托（蒙古）",
            cusCode: "1413",
            codeValue: "MNG901",
            gbName: "乌兰巴托（蒙古）",
            gbCode: "MNG901",
            ciqCode: "496901"
        },
        {
            codeName: "扎门乌德（蒙古）",
            cusCode: "124",
            codeValue: "MNG902",
            gbName: "扎门乌德（蒙古）",
            gbCode: "MNG902",
            ciqCode: "496902"
        },
        {
            codeName: "赛音山达（蒙古）",
            cusCode: "124",
            codeValue: "MNG903",
            gbName: "赛音山达（蒙古）",
            gbCode: "MNG903",
            ciqCode: "496903"
        },
        {
            codeName: "苏赫巴托（蒙古）",
            cusCode: "124",
            codeValue: "MNG904",
            gbName: "苏赫巴托（蒙古）",
            gbCode: "MNG904",
            ciqCode: "496904"
        },
        {
            codeName: "温都尔汗（蒙古）",
            cusCode: "124",
            codeValue: "MNG905",
            gbName: "温都尔汗（蒙古）",
            gbCode: "MNG905",
            ciqCode: "496905"
        },
        {
            codeName: "达尔汗（蒙古）",
            cusCode: "124",
            codeValue: "MNG906",
            gbName: "达尔汗（蒙古）",
            gbCode: "MNG906",
            ciqCode: "496906"
        },
        {
            codeName: "哈比日嘎（蒙古）",
            cusCode: "124",
            codeValue: "MNG907",
            gbName: "哈比日嘎（蒙古）",
            gbCode: "MNG907",
            ciqCode: "496907"
        },
        {
            codeName: "白音胡硕（蒙古）",
            cusCode: "124",
            codeValue: "MNG908",
            gbName: "白音胡硕（蒙古）",
            gbCode: "MNG908",
            ciqCode: "496908"
        },
        {
            codeName: "松布尔（蒙古）",
            cusCode: "124",
            codeValue: "MNG909",
            gbName: "松布尔（蒙古）",
            gbCode: "MNG909",
            ciqCode: "496909"
        },
        {
            codeName: "布尔干（蒙古）",
            cusCode: "124",
            codeValue: "MNG910",
            gbName: "布尔干（蒙古）",
            gbCode: "MNG910",
            ciqCode: "496910"
        },
        {
            codeName: "大洋（蒙古）",
            cusCode: "124",
            codeValue: "MNG911",
            gbName: "大洋（蒙古）",
            gbCode: "MNG911",
            ciqCode: "496911"
        },
        {
            codeName: "布尔嘎斯台（蒙古）",
            cusCode: "124",
            codeValue: "MNG912",
            gbName: "布尔嘎斯台（蒙古）",
            gbCode: "MNG912",
            ciqCode: "496912"
        },
        {
            codeName: "北塔格（蒙古）",
            cusCode: "124",
            codeValue: "MNG913",
            gbName: "北塔格（蒙古）",
            gbCode: "MNG913",
            ciqCode: "496913"
        },
        {
            codeName: "北马里亚纳群岛",
            cusCode: "631",
            codeValue: "MNP000",
            gbName: "北马里亚纳群岛",
            gbCode: "MNP000",
            ciqCode: "580000"
        },
        {
            codeName: "塞班岛（北马里亚纳群岛）",
            cusCode: "3403",
            codeValue: "MNP003",
            gbName: "塞班岛（北马里亚纳群岛）",
            gbCode: "MNP003",
            ciqCode: "580003"
        },
        {
            codeName: "提尼安岛（北马里亚纳群岛）",
            cusCode: "3406",
            codeValue: "MNP006",
            gbName: "提尼安岛（北马里亚纳群岛）",
            gbCode: "MNP006",
            ciqCode: "580006"
        },
        {
            codeName: "马里亚纳群岛（北马里亚纳群岛）",
            cusCode: "3394",
            codeValue: "MNP007",
            gbName: "马里亚纳群岛（北马里亚纳群岛）",
            gbCode: "MNP007",
            ciqCode: "580007"
        },
        {
            codeName: "莫桑比克",
            cusCode: "233",
            codeValue: "MOZ000",
            gbName: "莫桑比克",
            gbCode: "MOZ000",
            ciqCode: "508000"
        },
        {
            codeName: "安托尼奥埃尼什（莫桑比克）",
            cusCode: "233",
            codeValue: "MOZ003",
            gbName: "安托尼奥埃尼什（莫桑比克）",
            gbCode: "MOZ003",
            ciqCode: "508003"
        },
        {
            codeName: "贝拉（莫桑比克）",
            cusCode: "1704",
            codeValue: "MOZ006",
            gbName: "贝拉（莫桑比克）",
            gbCode: "MOZ006",
            ciqCode: "508006"
        },
        {
            codeName: "欣代（莫桑比克）",
            cusCode: "1713",
            codeValue: "MOZ009",
            gbName: "欣代（莫桑比克）",
            gbCode: "MOZ009",
            ciqCode: "508009"
        },
        {
            codeName: "伊博（莫桑比克）",
            cusCode: "233",
            codeValue: "MOZ012",
            gbName: "伊博（莫桑比克）",
            gbCode: "MOZ012",
            ciqCode: "508012"
        },
        {
            codeName: "伊尼扬巴内（莫桑比克）",
            cusCode: "1705",
            codeValue: "MOZ015",
            gbName: "伊尼扬巴内（莫桑比克）",
            gbCode: "MOZ015",
            ciqCode: "508015"
        },
        {
            codeName: "马普托（莫桑比克）",
            cusCode: "1707",
            codeValue: "MOZ018",
            gbName: "马普托（莫桑比克）",
            gbCode: "MOZ018",
            ciqCode: "508018"
        },
        {
            codeName: "莫辛布瓦（莫桑比克）",
            cusCode: "233",
            codeValue: "MOZ021",
            gbName: "莫辛布瓦（莫桑比克）",
            gbCode: "MOZ021",
            ciqCode: "508021"
        },
        {
            codeName: "莫马（莫桑比克）",
            cusCode: "233",
            codeValue: "MOZ024",
            gbName: "莫马（莫桑比克）",
            gbCode: "MOZ024",
            ciqCode: "508024"
        },
        {
            codeName: "莫桑比克（莫桑比克）",
            cusCode: "1709",
            codeValue: "MOZ027",
            gbName: "莫桑比克（莫桑比克）",
            gbCode: "MOZ027",
            ciqCode: "508027"
        },
        {
            codeName: "纳卡拉（莫桑比克）",
            cusCode: "1710",
            codeValue: "MOZ030",
            gbName: "纳卡拉（莫桑比克）",
            gbCode: "MOZ030",
            ciqCode: "508030"
        },
        {
            codeName: "彭巴（莫桑比克）",
            cusCode: "233",
            codeValue: "MOZ033",
            gbName: "彭巴（莫桑比克）",
            gbCode: "MOZ033",
            ciqCode: "508033"
        },
        {
            codeName: "克利马内（莫桑比克）",
            cusCode: "1712",
            codeValue: "MOZ036",
            gbName: "克利马内（莫桑比克）",
            gbCode: "MOZ036",
            ciqCode: "508036"
        },
        {
            codeName: "阿梅利亚港（莫桑比克）",
            cusCode: "1711",
            codeValue: "MOZ041",
            gbName: "阿梅利亚港（莫桑比克）",
            gbCode: "MOZ041",
            ciqCode: "508041"
        },
        {
            codeName: "杰迪达（莫桑比克）",
            cusCode: "1708",
            codeValue: "MOZ042",
            gbName: "杰迪达（莫桑比克）",
            gbCode: "MOZ042",
            ciqCode: "508042"
        },
        {
            codeName: "洛伦索-马贵斯（莫桑比克）",
            cusCode: "1706",
            codeValue: "MOZ043",
            gbName: "洛伦索-马贵斯（莫桑比克）",
            gbCode: "MOZ043",
            ciqCode: "508043"
        },
        {
            codeName: "毛里塔尼亚",
            cusCode: "230",
            codeValue: "MRT000",
            gbName: "毛里塔尼亚",
            gbCode: "MRT000",
            ciqCode: "478000"
        },
        {
            codeName: "努瓦迪布（毛里塔尼亚）",
            cusCode: "1690",
            codeValue: "MRT003",
            gbName: "努瓦迪布（毛里塔尼亚）",
            gbCode: "MRT003",
            ciqCode: "478003"
        },
        {
            codeName: "努瓦克肖特（毛里塔尼亚）",
            cusCode: "1691",
            codeValue: "MRT006",
            gbName: "努瓦克肖特（毛里塔尼亚）",
            gbCode: "MRT006",
            ciqCode: "478006"
        },
        {
            codeName: "蒙特塞拉特",
            cusCode: "430",
            codeValue: "MSR000",
            gbName: "蒙特塞拉特",
            gbCode: "MSR000",
            ciqCode: "500000"
        },
        {
            codeName: "普里茅斯（蒙特塞拉特）",
            cusCode: "2893",
            codeValue: "MSR003",
            gbName: "普里茅斯（蒙特塞拉特）",
            gbCode: "MSR003",
            ciqCode: "500003"
        },
        {
            codeName: "马提尼克",
            cusCode: "428",
            codeValue: "MTQ000",
            gbName: "马提尼克",
            gbCode: "MTQ000",
            ciqCode: "474000"
        },
        {
            codeName: "法兰西堡（马提尼克）",
            cusCode: "2874",
            codeValue: "MTQ003",
            gbName: "法兰西堡（马提尼克）",
            gbCode: "MTQ003",
            ciqCode: "474003"
        },
        {
            codeName: "特里尼泰（马提尼克）",
            cusCode: "428",
            codeValue: "MTQ006",
            gbName: "特里尼泰（马提尼克）",
            gbCode: "MTQ006",
            ciqCode: "474006"
        },
        {
            codeName: "圣皮埃尔（马提尼克）",
            cusCode: "2875",
            codeValue: "MTQ007",
            gbName: "圣皮埃尔（马提尼克）",
            gbCode: "MTQ007",
            ciqCode: "474007"
        },
        {
            codeName: "毛里求斯",
            cusCode: "231",
            codeValue: "MUS000",
            gbName: "毛里求斯",
            gbCode: "MUS000",
            ciqCode: "480000"
        },
        {
            codeName: "路易港（毛里求斯）",
            cusCode: "1692",
            codeValue: "MUS003",
            gbName: "路易港（毛里求斯）",
            gbCode: "MUS003",
            ciqCode: "480003"
        },
        {
            codeName: "马拉维",
            cusCode: "228",
            codeValue: "MWI000",
            gbName: "马拉维",
            gbCode: "MWI000",
            ciqCode: "454000"
        },
        {
            codeName: "利隆圭（马拉维）",
            cusCode: "1685",
            codeValue: "MWI001",
            gbName: "利隆圭（马拉维）",
            gbCode: "MWI001",
            ciqCode: "454001"
        },
        {
            codeName: "马来西亚",
            cusCode: "122",
            codeValue: "MYS000",
            gbName: "马来西亚",
            gbCode: "MYS000",
            ciqCode: "458000"
        },
        {
            codeName: "巴眼拿督（马来西亚）",
            cusCode: "122",
            codeValue: "MYS003",
            gbName: "巴眼拿督（马来西亚）",
            gbCode: "MYS003",
            ciqCode: "458003"
        },
        {
            codeName: "巴拉姆（马来西亚）",
            cusCode: "122",
            codeValue: "MYS006",
            gbName: "巴拉姆（马来西亚）",
            gbCode: "MYS006",
            ciqCode: "458006"
        },
        {
            codeName: "巴株巴辖（马来西亚）",
            cusCode: "122",
            codeValue: "MYS009",
            gbName: "巴株巴辖（马来西亚）",
            gbCode: "MYS009",
            ciqCode: "458009"
        },
        {
            codeName: "民那丹（马来西亚）",
            cusCode: "1376",
            codeValue: "MYS012",
            gbName: "民那丹（马来西亚）",
            gbCode: "MYS012",
            ciqCode: "458012"
        },
        {
            codeName: "民都鲁（马来西亚）",
            cusCode: "122",
            codeValue: "MYS015",
            gbName: "民都鲁（马来西亚）",
            gbCode: "MYS015",
            ciqCode: "458015"
        },
        {
            codeName: "新山（马来西亚）",
            cusCode: "1378",
            codeValue: "MYS017",
            gbName: "新山（马来西亚）",
            gbCode: "MYS017",
            ciqCode: "458017"
        },
        {
            codeName: "巴特沃思（马来西亚）",
            cusCode: "122",
            codeValue: "MYS018",
            gbName: "巴特沃思（马来西亚）",
            gbCode: "MYS018",
            ciqCode: "458018"
        },
        {
            codeName: "龙运（马来西亚）",
            cusCode: "122",
            codeValue: "MYS021",
            gbName: "龙运（马来西亚）",
            gbCode: "MYS021",
            ciqCode: "458021"
        },
        {
            codeName: "恩达乌（马来西亚）",
            cusCode: "122",
            codeValue: "MYS024",
            gbName: "恩达乌（马来西亚）",
            gbCode: "MYS024",
            ciqCode: "458024"
        },
        {
            codeName: "乔治敦（马来西亚）",
            cusCode: "1377",
            codeValue: "MYS027",
            gbName: "乔治敦（马来西亚）",
            gbCode: "MYS027",
            ciqCode: "458027"
        },
        {
            codeName: "哥打基纳巴卢（马来西亚）",
            cusCode: "1381",
            codeValue: "MYS032",
            gbName: "哥打基纳巴卢（马来西亚）",
            gbCode: "MYS032",
            ciqCode: "458032"
        },
        {
            codeName: "甘马挽（马来西亚）",
            cusCode: "1379",
            codeValue: "MYS033",
            gbName: "甘马挽（马来西亚）",
            gbCode: "MYS033",
            ciqCode: "458033"
        },
        {
            codeName: "居茶（马来西亚）",
            cusCode: "122",
            codeValue: "MYS036",
            gbName: "居茶（马来西亚）",
            gbCode: "MYS036",
            ciqCode: "458036"
        },
        {
            codeName: "哥打巴鲁（马来西亚）",
            cusCode: "122",
            codeValue: "MYS039",
            gbName: "哥打巴鲁（马来西亚）",
            gbCode: "MYS039",
            ciqCode: "458039"
        },
        {
            codeName: "瓜拉彭亨（马来西亚）",
            cusCode: "122",
            codeValue: "MYS045",
            gbName: "瓜拉彭亨（马来西亚）",
            gbCode: "MYS045",
            ciqCode: "458045"
        },
        {
            codeName: "瓜拉弄宾（马来西亚）",
            cusCode: "122",
            codeValue: "MYS048",
            gbName: "瓜拉弄宾（马来西亚）",
            gbCode: "MYS048",
            ciqCode: "458048"
        },
        {
            codeName: "瓜拉雪兰莪（马来西亚）",
            cusCode: "122",
            codeValue: "MYS051",
            gbName: "瓜拉雪兰莪（马来西亚）",
            gbCode: "MYS051",
            ciqCode: "458051"
        },
        {
            codeName: "瓜拉苏埃（马来西亚）",
            cusCode: "122",
            codeValue: "MYS054",
            gbName: "瓜拉苏埃（马来西亚）",
            gbCode: "MYS054",
            ciqCode: "458054"
        },
        {
            codeName: "瓜拉丁加奴（马来西亚）",
            cusCode: "122",
            codeValue: "MYS057",
            gbName: "瓜拉丁加奴（马来西亚）",
            gbCode: "MYS057",
            ciqCode: "458057"
        },
        {
            codeName: "关丹（马来西亚）",
            cusCode: "122",
            codeValue: "MYS060",
            gbName: "关丹（马来西亚）",
            gbCode: "MYS060",
            ciqCode: "458060"
        },
        {
            codeName: "古晋（马来西亚）",
            cusCode: "1384",
            codeValue: "MYS063",
            gbName: "古晋（马来西亚）",
            gbCode: "MYS063",
            ciqCode: "458063"
        },
        {
            codeName: "古达（马来西亚）",
            cusCode: "1385",
            codeValue: "MYS066",
            gbName: "古达（马来西亚）",
            gbCode: "MYS066",
            ciqCode: "458066"
        },
        {
            codeName: "纳闽（马来西亚）",
            cusCode: "1387",
            codeValue: "MYS068",
            gbName: "纳闽（马来西亚）",
            gbCode: "MYS068",
            ciqCode: "458068"
        },
        {
            codeName: "库纳克（马来西亚）",
            cusCode: "1386",
            codeValue: "MYS069",
            gbName: "库纳克（马来西亚）",
            gbCode: "MYS069",
            ciqCode: "458069"
        },
        {
            codeName: "拉哈达图（马来西亚）",
            cusCode: "1388",
            codeValue: "MYS075",
            gbName: "拉哈达图（马来西亚）",
            gbCode: "MYS075",
            ciqCode: "458075"
        },
        {
            codeName: "林加（马来西亚）",
            cusCode: "1391",
            codeValue: "MYS078",
            gbName: "林加（马来西亚）",
            gbCode: "MYS078",
            ciqCode: "458078"
        },
        {
            codeName: "卢穆特（马来西亚）",
            cusCode: "122",
            codeValue: "MYS081",
            gbName: "卢穆特（马来西亚）",
            gbCode: "MYS081",
            ciqCode: "458081"
        },
        {
            codeName: "隆杜（马来西亚）",
            cusCode: "122",
            codeValue: "MYS084",
            gbName: "隆杜（马来西亚）",
            gbCode: "MYS084",
            ciqCode: "458084"
        },
        {
            codeName: "马六甲（马来西亚）",
            cusCode: "1393",
            codeValue: "MYS087",
            gbName: "马六甲（马来西亚）",
            gbCode: "MYS087",
            ciqCode: "458087"
        },
        {
            codeName: "米里（马来西亚）",
            cusCode: "1394",
            codeValue: "MYS090",
            gbName: "米里（马来西亚）",
            gbCode: "MYS090",
            ciqCode: "458090"
        },
        {
            codeName: "尼亚（马来西亚）",
            cusCode: "122",
            codeValue: "MYS093",
            gbName: "尼亚（马来西亚）",
            gbCode: "MYS093",
            ciqCode: "458093"
        },
        {
            codeName: "帕西古当（马来西亚）",
            cusCode: "1395",
            codeValue: "MYS096",
            gbName: "帕西古当（马来西亚）",
            gbCode: "MYS096",
            ciqCode: "458096"
        },
        {
            codeName: "槟城（马来西亚）",
            cusCode: "1396",
            codeValue: "MYS099",
            gbName: "槟城（马来西亚）",
            gbCode: "MYS099",
            ciqCode: "458099"
        },
        {
            codeName: "波德申（马来西亚）",
            cusCode: "1398",
            codeValue: "MYS102",
            gbName: "波德申（马来西亚）",
            gbCode: "MYS102",
            ciqCode: "458102"
        },
        {
            codeName: "巴生港（马来西亚）",
            cusCode: "1399",
            codeValue: "MYS105",
            gbName: "巴生港（马来西亚）",
            gbCode: "MYS105",
            ciqCode: "458105"
        },
        {
            codeName: "文德港（马来西亚）",
            cusCode: "122",
            codeValue: "MYS108",
            gbName: "文德港（马来西亚）",
            gbCode: "MYS108",
            ciqCode: "458108"
        },
        {
            codeName: "布莱（马来西亚）",
            cusCode: "1401",
            codeValue: "MYS111",
            gbName: "布莱（马来西亚）",
            gbCode: "MYS111",
            ciqCode: "458111"
        },
        {
            codeName: "山打根（马来西亚）",
            cusCode: "1402",
            codeValue: "MYS114",
            gbName: "山打根（马来西亚）",
            gbCode: "MYS114",
            ciqCode: "458114"
        },
        {
            codeName: "泗里奎（马来西亚）",
            cusCode: "1403",
            codeValue: "MYS117",
            gbName: "泗里奎（马来西亚）",
            gbCode: "MYS117",
            ciqCode: "458117"
        },
        {
            codeName: "塞京卡（马来西亚）",
            cusCode: "1404",
            codeValue: "MYS120",
            gbName: "塞京卡（马来西亚）",
            gbCode: "MYS120",
            ciqCode: "458120"
        },
        {
            codeName: "仙本那（马来西亚）",
            cusCode: "1405",
            codeValue: "MYS123",
            gbName: "仙本那（马来西亚）",
            gbCode: "MYS123",
            ciqCode: "458123"
        },
        {
            codeName: "诗巫（马来西亚）",
            cusCode: "1406",
            codeValue: "MYS124",
            gbName: "诗巫（马来西亚）",
            gbCode: "MYS124",
            ciqCode: "458124"
        },
        {
            codeName: "双溪麻坡（马来西亚）",
            cusCode: "122",
            codeValue: "MYS129",
            gbName: "双溪麻坡（马来西亚）",
            gbCode: "MYS129",
            ciqCode: "458129"
        },
        {
            codeName: "丹章马尼（马来西亚）",
            cusCode: "122",
            codeValue: "MYS132",
            gbName: "丹章马尼（马来西亚）",
            gbCode: "MYS132",
            ciqCode: "458132"
        },
        {
            codeName: "斗湖（马来西亚）",
            cusCode: "1407",
            codeValue: "MYS133",
            gbName: "斗湖（马来西亚）",
            gbCode: "MYS133",
            ciqCode: "458133"
        },
        {
            codeName: "安顺（马来西亚）",
            cusCode: "122",
            codeValue: "MYS138",
            gbName: "安顺（马来西亚）",
            gbCode: "MYS138",
            ciqCode: "458138"
        },
        {
            codeName: "特洛拉穆尼亚（马来西亚）",
            cusCode: "1408",
            codeValue: "MYS141",
            gbName: "特洛拉穆尼亚（马来西亚）",
            gbCode: "MYS141",
            ciqCode: "458141"
        },
        {
            codeName: "通北（马来西亚）",
            cusCode: "122",
            codeValue: "MYS144",
            gbName: "通北（马来西亚）",
            gbCode: "MYS144",
            ciqCode: "458144"
        },
        {
            codeName: "华莱士（马来西亚）",
            cusCode: "1411",
            codeValue: "MYS147",
            gbName: "华莱士（马来西亚）",
            gbCode: "MYS147",
            ciqCode: "458147"
        },
        {
            codeName: "韦斯顿（马来西亚）",
            cusCode: "122",
            codeValue: "MYS150",
            gbName: "韦斯顿（马来西亚）",
            gbCode: "MYS150",
            ciqCode: "458150"
        },
        {
            codeName: "TG.MANIS（马来西亚）",
            cusCode: "1409",
            codeValue: "MYS200",
            gbName: "TG.MANIS（马来西亚）",
            gbCode: "MYS200",
            ciqCode: "458200"
        },
        {
            codeName: "巴卡皮（马来西亚）",
            cusCode: "1375",
            codeValue: "MYS201",
            gbName: "巴卡皮（马来西亚）",
            gbCode: "MYS201",
            ciqCode: "458201"
        },
        {
            codeName: "拉布安（马来西亚）",
            cusCode: "1410",
            codeValue: "MYS204",
            gbName: "拉布安（马来西亚）",
            gbCode: "MYS204",
            ciqCode: "458072"
        },
        {
            codeName: "拉瓦斯（马来西亚）",
            cusCode: "1389",
            codeValue: "MYS205",
            gbName: "拉瓦斯（马来西亚）",
            gbCode: "MYS205",
            ciqCode: "458205"
        },
        {
            codeName: "林邦（马来西亚）",
            cusCode: "1390",
            codeValue: "MYS206",
            gbName: "林邦（马来西亚）",
            gbCode: "MYS206",
            ciqCode: "458206"
        },
        {
            codeName: "吉隆坡（马来西亚）",
            cusCode: "1382",
            codeValue: "MYS901",
            gbName: "吉隆坡（马来西亚）",
            gbCode: "MYS901",
            ciqCode: "458901"
        },
        {
            codeName: "马约特",
            cusCode: "259",
            codeValue: "MYT000",
            gbName: "马约特",
            gbCode: "MYT000",
            ciqCode: "175000"
        },
        {
            codeName: "藻德济（马约特）",
            cusCode: "259",
            codeValue: "MYT003",
            gbName: "藻德济（马约特）",
            gbCode: "MYT003",
            ciqCode: "175003"
        },
        {
            codeName: "纳米比亚",
            cusCode: "234",
            codeValue: "NAM000",
            gbName: "纳米比亚",
            gbCode: "NAM000",
            ciqCode: "516000"
        },
        {
            codeName: "吕德里茨（纳米比亚）",
            cusCode: "1715",
            codeValue: "NAM003",
            gbName: "吕德里茨（纳米比亚）",
            gbCode: "NAM003",
            ciqCode: "516003"
        },
        {
            codeName: "鲸湾港（纳米比亚）",
            cusCode: "1717",
            codeValue: "NAM006",
            gbName: "鲸湾港（纳米比亚）",
            gbCode: "NAM006",
            ciqCode: "516006"
        },
        {
            codeName: "奥兰治蒙德（纳米比亚）",
            cusCode: "1714",
            codeValue: "NAM007",
            gbName: "奥兰治蒙德（纳米比亚）",
            gbCode: "NAM007",
            ciqCode: "516007"
        },
        {
            codeName: "温得和克（纳米比亚）",
            cusCode: "1718",
            codeValue: "NAM008",
            gbName: "温得和克（纳米比亚）",
            gbCode: "NAM008",
            ciqCode: "516008"
        },
        {
            codeName: "新喀里多尼亚",
            cusCode: "607",
            codeValue: "NCL000",
            gbName: "新喀里多尼亚",
            gbCode: "NCL000",
            ciqCode: "540000"
        },
        {
            codeName: "新喀里多尼亚（新喀里多尼亚）",
            cusCode: "3286",
            codeValue: "NCL001",
            gbName: "新喀里多尼亚（新喀里多尼亚）",
            gbCode: "NCL001",
            ciqCode: "540001"
        },
        {
            codeName: "巴布勒特（新喀里多尼亚）",
            cusCode: "607",
            codeValue: "NCL003",
            gbName: "巴布勒特（新喀里多尼亚）",
            gbCode: "NCL003",
            ciqCode: "540003"
        },
        {
            codeName: "努美阿（新喀里多尼亚）",
            cusCode: "3287",
            codeValue: "NCL006",
            gbName: "努美阿（新喀里多尼亚）",
            gbCode: "NCL006",
            ciqCode: "540006"
        },
        {
            codeName: "尼日尔",
            cusCode: "235",
            codeValue: "NER000",
            gbName: "尼日尔",
            gbCode: "NER000",
            ciqCode: "562000"
        },
        {
            codeName: "津德尔（尼日尔）",
            cusCode: "1721",
            codeValue: "NER001",
            gbName: "津德尔（尼日尔）",
            gbCode: "NER001",
            ciqCode: "562001"
        },
        {
            codeName: "阿加德兹（尼日尔）",
            cusCode: "1719",
            codeValue: "NER002",
            gbName: "阿加德兹（尼日尔）",
            gbCode: "NER002",
            ciqCode: "562002"
        },
        {
            codeName: "尼亚美（尼日尔）",
            cusCode: "1720",
            codeValue: "NER003",
            gbName: "尼亚美（尼日尔）",
            gbCode: "NER003",
            ciqCode: "562003"
        },
        {
            codeName: "诺福克岛",
            cusCode: "610",
            codeValue: "NFK000",
            gbName: "诺福克岛",
            gbCode: "NFK000",
            ciqCode: "574000"
        },
        {
            codeName: "金斯敦（诺福克岛）",
            cusCode: "610",
            codeValue: "NFK003",
            gbName: "金斯敦（诺福克岛）",
            gbCode: "NFK003",
            ciqCode: "574003"
        },
        {
            codeName: "诺福克岛（诺福克岛）",
            cusCode: "610",
            codeValue: "NFK006",
            gbName: "诺福克岛（诺福克岛）",
            gbCode: "NFK006",
            ciqCode: "574006"
        },
        {
            codeName: "尼日利亚",
            cusCode: "236",
            codeValue: "NGA000",
            gbName: "尼日利亚",
            gbCode: "NGA000",
            ciqCode: "566000"
        },
        {
            codeName: "阿卡萨（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA003",
            gbName: "阿卡萨（尼日利亚）",
            gbCode: "NGA003",
            ciqCode: "566003"
        },
        {
            codeName: "阿帕帕（尼日利亚）",
            cusCode: "1723",
            codeValue: "NGA006",
            gbName: "阿帕帕（尼日利亚）",
            gbCode: "NGA006",
            ciqCode: "566006"
        },
        {
            codeName: "巴达格里（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA009",
            gbName: "巴达格里（尼日利亚）",
            gbCode: "NGA009",
            ciqCode: "566009"
        },
        {
            codeName: "邦尼（尼日利亚）",
            cusCode: "1731",
            codeValue: "NGA012",
            gbName: "邦尼（尼日利亚）",
            gbCode: "NGA012",
            ciqCode: "566012"
        },
        {
            codeName: "布拉斯（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA015",
            gbName: "布拉斯（尼日利亚）",
            gbCode: "NGA015",
            ciqCode: "566015"
        },
        {
            codeName: "布鲁图（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA018",
            gbName: "布鲁图（尼日利亚）",
            gbCode: "NGA018",
            ciqCode: "566018"
        },
        {
            codeName: "卡拉巴尔（尼日利亚）",
            cusCode: "1732",
            codeValue: "NGA021",
            gbName: "卡拉巴尔（尼日利亚）",
            gbCode: "NGA021",
            ciqCode: "566021"
        },
        {
            codeName: "代盖马（尼日利亚）",
            cusCode: "1724",
            codeValue: "NGA024",
            gbName: "代盖马（尼日利亚）",
            gbCode: "NGA024",
            ciqCode: "566024"
        },
        {
            codeName: "拉沃斯河（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA027",
            gbName: "拉沃斯河（尼日利亚）",
            gbCode: "NGA027",
            ciqCode: "566027"
        },
        {
            codeName: "福卡多斯（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA030",
            gbName: "福卡多斯（尼日利亚）",
            gbCode: "NGA030",
            ciqCode: "566030"
        },
        {
            codeName: "科科（尼日利亚）",
            cusCode: "1726",
            codeValue: "NGA033",
            gbName: "科科（尼日利亚）",
            gbCode: "NGA033",
            ciqCode: "566033"
        },
        {
            codeName: "拉各斯（尼日利亚）",
            cusCode: "1727",
            codeValue: "NGA036",
            gbName: "拉各斯（尼日利亚）",
            gbCode: "NGA036",
            ciqCode: "566036"
        },
        {
            codeName: "奥克里卡（尼日利亚）",
            cusCode: "1728",
            codeValue: "NGA039",
            gbName: "奥克里卡（尼日利亚）",
            gbCode: "NGA039",
            ciqCode: "566039"
        },
        {
            codeName: "奥波博（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA042",
            gbName: "奥波博（尼日利亚）",
            gbCode: "NGA042",
            ciqCode: "566042"
        },
        {
            codeName: "彭宁顿码头（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA045",
            gbName: "彭宁顿码头（尼日利亚）",
            gbCode: "NGA045",
            ciqCode: "566045"
        },
        {
            codeName: "哈科特港（尼日利亚）",
            cusCode: "1733",
            codeValue: "NGA047",
            gbName: "哈科特港（尼日利亚）",
            gbCode: "NGA047",
            ciqCode: "566047"
        },
        {
            codeName: "奥尼（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA048",
            gbName: "奥尼（尼日利亚）",
            gbCode: "NGA048",
            ciqCode: "566048"
        },
        {
            codeName: "夸伊博（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA051",
            gbName: "夸伊博（尼日利亚）",
            gbCode: "NGA051",
            ciqCode: "566051"
        },
        {
            codeName: "萨佩莱（尼日利亚）",
            cusCode: "1729",
            codeValue: "NGA054",
            gbName: "萨佩莱（尼日利亚）",
            gbCode: "NGA054",
            ciqCode: "566054"
        },
        {
            codeName: "延坎岛（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA056",
            gbName: "延坎岛（尼日利亚）",
            gbCode: "NGA056",
            ciqCode: "566056"
        },
        {
            codeName: "瓦里（尼日利亚）",
            cusCode: "1730",
            codeValue: "NGA057",
            gbName: "瓦里（尼日利亚）",
            gbCode: "NGA057",
            ciqCode: "566057"
        },
        {
            codeName: "IDDO（尼日利亚）",
            cusCode: "1725",
            codeValue: "NGA060",
            gbName: "IDDO（尼日利亚）",
            gbCode: "NGA060",
            ciqCode: "566060"
        },
        {
            codeName: "卡诺（尼日利亚）",
            cusCode: "236",
            codeValue: "NGA901",
            gbName: "卡诺（尼日利亚）",
            gbCode: "NGA901",
            ciqCode: "566901"
        },
        {
            codeName: "尼加拉瓜",
            cusCode: "431",
            codeValue: "NIC000",
            gbName: "尼加拉瓜",
            gbCode: "NIC000",
            ciqCode: "558000"
        },
        {
            codeName: "布卢菲尔兹（尼加拉瓜）",
            cusCode: "2894",
            codeValue: "NIC003",
            gbName: "布卢菲尔兹（尼加拉瓜）",
            gbCode: "NIC003",
            ciqCode: "558003"
        },
        {
            codeName: "科林托（尼加拉瓜）",
            cusCode: "2895",
            codeValue: "NIC006",
            gbName: "科林托（尼加拉瓜）",
            gbCode: "NIC006",
            ciqCode: "558006"
        },
        {
            codeName: "卡贝萨斯港（尼加拉瓜）",
            cusCode: "431",
            codeValue: "NIC009",
            gbName: "卡贝萨斯港（尼加拉瓜）",
            gbCode: "NIC009",
            ciqCode: "558009"
        },
        {
            codeName: "马那瓜（尼加拉瓜）",
            cusCode: "2896",
            codeValue: "NIC010",
            gbName: "马那瓜（尼加拉瓜）",
            gbCode: "NIC010",
            ciqCode: "558010"
        },
        {
            codeName: "圣蒂诺港（尼加拉瓜）",
            cusCode: "2897",
            codeValue: "NIC012",
            gbName: "圣蒂诺港（尼加拉瓜）",
            gbCode: "NIC012",
            ciqCode: "558012"
        },
        {
            codeName: "南圣胡安（尼加拉瓜）",
            cusCode: "2898",
            codeValue: "NIC015",
            gbName: "南圣胡安（尼加拉瓜）",
            gbCode: "NIC015",
            ciqCode: "558015"
        },
        {
            codeName: "纽埃",
            cusCode: "632",
            codeValue: "NIU000",
            gbName: "纽埃",
            gbCode: "NIU000",
            ciqCode: "570000"
        },
        {
            codeName: "阿洛菲（纽埃）",
            cusCode: "632",
            codeValue: "NIU003",
            gbName: "阿洛菲（纽埃）",
            gbCode: "NIU003",
            ciqCode: "570003"
        },
        {
            codeName: "纽埃岛（纽埃）",
            cusCode: "3397",
            codeValue: "NIU006",
            gbName: "纽埃岛（纽埃）",
            gbCode: "NIU006",
            ciqCode: "570006"
        },
        {
            codeName: "荷兰",
            cusCode: "309",
            codeValue: "NLD000",
            gbName: "荷兰",
            gbCode: "NLD000",
            ciqCode: "528000"
        },
        {
            codeName: "阿尔克马（荷兰）",
            cusCode: "2294",
            codeValue: "NLD003",
            gbName: "阿尔克马（荷兰）",
            gbCode: "NLD003",
            ciqCode: "528003"
        },
        {
            codeName: "阿姆斯特丹（荷兰）",
            cusCode: "2295",
            codeValue: "NLD006",
            gbName: "阿姆斯特丹（荷兰）",
            gbCode: "NLD006",
            ciqCode: "528006"
        },
        {
            codeName: "阿纳姆（荷兰）",
            cusCode: "309",
            codeValue: "NLD009",
            gbName: "阿纳姆（荷兰）",
            gbCode: "NLD009",
            ciqCode: "528009"
        },
        {
            codeName: "布劳沃斯港（荷兰）",
            cusCode: "309",
            codeValue: "NLD012",
            gbName: "布劳沃斯港（荷兰）",
            gbCode: "NLD012",
            ciqCode: "528012"
        },
        {
            codeName: "比瑟姆（荷兰）",
            cusCode: "309",
            codeValue: "NLD015",
            gbName: "比瑟姆（荷兰）",
            gbCode: "NLD015",
            ciqCode: "528015"
        },
        {
            codeName: "代尔夫宰尔（荷兰）",
            cusCode: "2296",
            codeValue: "NLD018",
            gbName: "代尔夫宰尔（荷兰）",
            gbCode: "NLD018",
            ciqCode: "528018"
        },
        {
            codeName: "多德雷赫特（荷兰）",
            cusCode: "2297",
            codeValue: "NLD021",
            gbName: "多德雷赫特（荷兰）",
            gbCode: "NLD021",
            ciqCode: "528021"
        },
        {
            codeName: "埃姆斯哈文（荷兰）",
            cusCode: "309",
            codeValue: "NLD024",
            gbName: "埃姆斯哈文（荷兰）",
            gbCode: "NLD024",
            ciqCode: "528024"
        },
        {
            codeName: "欧罗波特（荷兰）",
            cusCode: "309",
            codeValue: "NLD027",
            gbName: "欧罗波特（荷兰）",
            gbCode: "NLD027",
            ciqCode: "528027"
        },
        {
            codeName: "符拉辛（荷兰）",
            cusCode: "309",
            codeValue: "NLD030",
            gbName: "符拉辛（荷兰）",
            gbCode: "NLD030",
            ciqCode: "528030"
        },
        {
            codeName: "格罗宁根（荷兰）",
            cusCode: "309",
            codeValue: "NLD033",
            gbName: "格罗宁根（荷兰）",
            gbCode: "NLD033",
            ciqCode: "528033"
        },
        {
            codeName: "汉斯韦尔特（荷兰）",
            cusCode: "2299",
            codeValue: "NLD036",
            gbName: "汉斯韦尔特（荷兰）",
            gbCode: "NLD036",
            ciqCode: "528036"
        },
        {
            codeName: "哈灵根（荷兰）",
            cusCode: "2300",
            codeValue: "NLD039",
            gbName: "哈灵根（荷兰）",
            gbCode: "NLD039",
            ciqCode: "528039"
        },
        {
            codeName: "海尔蒙德（荷兰）",
            cusCode: "2302",
            codeValue: "NLD042",
            gbName: "海尔蒙德（荷兰）",
            gbCode: "NLD042",
            ciqCode: "528042"
        },
        {
            codeName: "荷兰角（荷兰）",
            cusCode: "309",
            codeValue: "NLD045",
            gbName: "荷兰角（荷兰）",
            gbCode: "NLD045",
            ciqCode: "528045"
        },
        {
            codeName: "坎彭（荷兰）",
            cusCode: "309",
            codeValue: "NLD048",
            gbName: "坎彭（荷兰）",
            gbCode: "NLD048",
            ciqCode: "528048"
        },
        {
            codeName: "吕伐登（荷兰）",
            cusCode: "309",
            codeValue: "NLD051",
            gbName: "吕伐登（荷兰）",
            gbCode: "NLD051",
            ciqCode: "528051"
        },
        {
            codeName: "莱顿（荷兰）",
            cusCode: "2305",
            codeValue: "NLD054",
            gbName: "莱顿（荷兰）",
            gbCode: "NLD054",
            ciqCode: "528054"
        },
        {
            codeName: "马斯莱斯（荷兰）",
            cusCode: "2306",
            codeValue: "NLD057",
            gbName: "马斯莱斯（荷兰）",
            gbCode: "NLD057",
            ciqCode: "528057"
        },
        {
            codeName: "梅珀尔（荷兰）",
            cusCode: "309",
            codeValue: "NLD060",
            gbName: "梅珀尔（荷兰）",
            gbCode: "NLD060",
            ciqCode: "528060"
        },
        {
            codeName: "米德尔堡（荷兰）",
            cusCode: "2307",
            codeValue: "NLD063",
            gbName: "米德尔堡（荷兰）",
            gbCode: "NLD063",
            ciqCode: "528063"
        },
        {
            codeName: "鹿特丹（荷兰）",
            cusCode: "2309",
            codeValue: "NLD066",
            gbName: "鹿特丹（荷兰）",
            gbCode: "NLD066",
            ciqCode: "528066"
        },
        {
            codeName: "罗曾堡（荷兰）",
            cusCode: "309",
            codeValue: "NLD069",
            gbName: "罗曾堡（荷兰）",
            gbCode: "NLD069",
            ciqCode: "528069"
        },
        {
            codeName: "萨斯范亨特（荷兰）",
            cusCode: "309",
            codeValue: "NLD072",
            gbName: "萨斯范亨特（荷兰）",
            gbCode: "NLD072",
            ciqCode: "528072"
        },
        {
            codeName: "斯海弗宁恩（荷兰）",
            cusCode: "2310",
            codeValue: "NLD075",
            gbName: "斯海弗宁恩（荷兰）",
            gbCode: "NLD075",
            ciqCode: "528075"
        },
        {
            codeName: "斯希丹（荷兰）",
            cusCode: "2311",
            codeValue: "NLD078",
            gbName: "斯希丹（荷兰）",
            gbCode: "NLD078",
            ciqCode: "528078"
        },
        {
            codeName: "斯勒伊斯基尔（荷兰）",
            cusCode: "2312",
            codeValue: "NLD081",
            gbName: "斯勒伊斯基尔（荷兰）",
            gbCode: "NLD081",
            ciqCode: "528081"
        },
        {
            codeName: "泰尔讷曾（荷兰）",
            cusCode: "2313",
            codeValue: "NLD084",
            gbName: "泰尔讷曾（荷兰）",
            gbCode: "NLD084",
            ciqCode: "528084"
        },
        {
            codeName: "蒂尔堡（荷兰）",
            cusCode: "309",
            codeValue: "NLD087",
            gbName: "蒂尔堡（荷兰）",
            gbCode: "NLD087",
            ciqCode: "528087"
        },
        {
            codeName: "文洛（荷兰）",
            cusCode: "309",
            codeValue: "NLD090",
            gbName: "文洛（荷兰）",
            gbCode: "NLD090",
            ciqCode: "528090"
        },
        {
            codeName: "弗拉尔丁恩（荷兰）",
            cusCode: "2314",
            codeValue: "NLD093",
            gbName: "弗拉尔丁恩（荷兰）",
            gbCode: "NLD093",
            ciqCode: "528093"
        },
        {
            codeName: "威廉斯塔德（荷兰）",
            cusCode: "2825",
            codeValue: "NLD099",
            gbName: "威廉斯塔德（荷兰）",
            gbCode: "NLD099",
            ciqCode: "528099"
        },
        {
            codeName: "艾默伊登（荷兰）",
            cusCode: "2304",
            codeValue: "NLD102",
            gbName: "艾默伊登（荷兰）",
            gbCode: "NLD102",
            ciqCode: "528102"
        },
        {
            codeName: "弗利辛恩（荷兰）",
            cusCode: "2315",
            codeValue: "NLD104",
            gbName: "弗利辛恩（荷兰）",
            gbCode: "NLD104",
            ciqCode: "528104"
        },
        {
            codeName: "赞丹（荷兰）",
            cusCode: "2317",
            codeValue: "NLD105",
            gbName: "赞丹（荷兰）",
            gbCode: "NLD105",
            ciqCode: "528105"
        },
        {
            codeName: "济里克泽（荷兰）",
            cusCode: "2318",
            codeValue: "NLD108",
            gbName: "济里克泽（荷兰）",
            gbCode: "NLD108",
            ciqCode: "528108"
        },
        {
            codeName: "聚特芬（荷兰）",
            cusCode: "309",
            codeValue: "NLD111",
            gbName: "聚特芬（荷兰）",
            gbCode: "NLD111",
            ciqCode: "528111"
        },
        {
            codeName: "兹沃勒（荷兰）",
            cusCode: "309",
            codeValue: "NLD114",
            gbName: "兹沃勒（荷兰）",
            gbCode: "NLD114",
            ciqCode: "528114"
        },
        {
            codeName: "海勒武特斯莱斯（荷兰）",
            cusCode: "2301",
            codeValue: "NLD121",
            gbName: "海勒武特斯莱斯（荷兰）",
            gbCode: "NLD121",
            ciqCode: "528121"
        },
        {
            codeName: "赫尔德（荷兰）",
            cusCode: "2298",
            codeValue: "NLD122",
            gbName: "赫尔德（荷兰）",
            gbCode: "NLD122",
            ciqCode: "528122"
        },
        {
            codeName: "摩的克（荷兰）",
            cusCode: "3463",
            codeValue: "NLD123",
            gbName: "摩的克（荷兰）",
            gbCode: "NLD123",
            ciqCode: "528123"
        },
        {
            codeName: "奈梅根（荷兰）",
            cusCode: "2308",
            codeValue: "NLD124",
            gbName: "奈梅根（荷兰）",
            gbCode: "NLD124",
            ciqCode: "528124"
        },
        {
            codeName: "希尔佛苏姆（荷兰）",
            cusCode: "2303",
            codeValue: "NLD125",
            gbName: "希尔佛苏姆（荷兰）",
            gbCode: "NLD125",
            ciqCode: "528125"
        },
        {
            codeName: "伊默伊登（荷兰）",
            cusCode: "2316",
            codeValue: "NLD126",
            gbName: "伊默伊登（荷兰）",
            gbCode: "NLD126",
            ciqCode: "528126"
        },
        {
            codeName: "挪威",
            cusCode: "326",
            codeValue: "NOR000",
            gbName: "挪威",
            gbCode: "NOR000",
            ciqCode: "578000"
        },
        {
            codeName: "RISOBANK（挪威）",
            cusCode: "2511",
            codeValue: "NOR001",
            gbName: "RISOBANK（挪威）",
            gbCode: "NOR001",
            ciqCode: "578001"
        },
        {
            codeName: "奥勒松（挪威）",
            cusCode: "2469",
            codeValue: "NOR003",
            gbName: "奥勒松（挪威）",
            gbCode: "NOR003",
            ciqCode: "578003"
        },
        {
            codeName: "阿尔达尔斯坦根（挪威）",
            cusCode: "2470",
            codeValue: "NOR006",
            gbName: "阿尔达尔斯坦根（挪威）",
            gbCode: "NOR006",
            ciqCode: "578006"
        },
        {
            codeName: "阿伦达尔（挪威）",
            cusCode: "2471",
            codeValue: "NOR012",
            gbName: "阿伦达尔（挪威）",
            gbCode: "NOR012",
            ciqCode: "578012"
        },
        {
            codeName: "卑尔根（挪威）",
            cusCode: "2472",
            codeValue: "NOR018",
            gbName: "卑尔根（挪威）",
            gbCode: "NOR018",
            ciqCode: "578018"
        },
        {
            codeName: "博多（挪威）",
            cusCode: "2473",
            codeValue: "NOR021",
            gbName: "博多（挪威）",
            gbCode: "NOR021",
            ciqCode: "578021"
        },
        {
            codeName: "布雷维克（挪威）",
            cusCode: "2474",
            codeValue: "NOR024",
            gbName: "布雷维克（挪威）",
            gbCode: "NOR024",
            ciqCode: "578024"
        },
        {
            codeName: "布伦讷于松（挪威）",
            cusCode: "326",
            codeValue: "NOR027",
            gbName: "布伦讷于松（挪威）",
            gbCode: "NOR027",
            ciqCode: "578027"
        },
        {
            codeName: "德拉门（挪威）",
            cusCode: "2476",
            codeValue: "NOR030",
            gbName: "德拉门（挪威）",
            gbCode: "NOR030",
            ciqCode: "578030"
        },
        {
            codeName: "艾格松（挪威）",
            cusCode: "326",
            codeValue: "NOR033",
            gbName: "艾格松（挪威）",
            gbCode: "NOR033",
            ciqCode: "578033"
        },
        {
            codeName: "艾特尔海姆（挪威）",
            cusCode: "326",
            codeValue: "NOR036",
            gbName: "艾特尔海姆（挪威）",
            gbCode: "NOR036",
            ciqCode: "578036"
        },
        {
            codeName: "法格斯特兰德（挪威）",
            cusCode: "326",
            codeValue: "NOR039",
            gbName: "法格斯特兰德（挪威）",
            gbCode: "NOR039",
            ciqCode: "578039"
        },
        {
            codeName: "法尔松德（挪威）",
            cusCode: "326",
            codeValue: "NOR042",
            gbName: "法尔松德（挪威）",
            gbCode: "NOR042",
            ciqCode: "578042"
        },
        {
            codeName: "弗莱克菲尤尔（挪威）",
            cusCode: "326",
            codeValue: "NOR048",
            gbName: "弗莱克菲尤尔（挪威）",
            gbCode: "NOR048",
            ciqCode: "578048"
        },
        {
            codeName: "弗卢勒（挪威）",
            cusCode: "326",
            codeValue: "NOR051",
            gbName: "弗卢勒（挪威）",
            gbCode: "NOR051",
            ciqCode: "578051"
        },
        {
            codeName: "腓特烈斯塔（挪威）",
            cusCode: "326",
            codeValue: "NOR054",
            gbName: "腓特烈斯塔（挪威）",
            gbCode: "NOR054",
            ciqCode: "578054"
        },
        {
            codeName: "格洛姆菲尤尔（挪威）",
            cusCode: "326",
            codeValue: "NOR057",
            gbName: "格洛姆菲尤尔（挪威）",
            gbCode: "NOR057",
            ciqCode: "578057"
        },
        {
            codeName: "格里姆斯塔（挪威）",
            cusCode: "326",
            codeValue: "NOR060",
            gbName: "格里姆斯塔（挪威）",
            gbCode: "NOR060",
            ciqCode: "578060"
        },
        {
            codeName: "哈尔登（挪威）",
            cusCode: "326",
            codeValue: "NOR063",
            gbName: "哈尔登（挪威）",
            gbCode: "NOR063",
            ciqCode: "578063"
        },
        {
            codeName: "哈默弗斯特（挪威）",
            cusCode: "2477",
            codeValue: "NOR066",
            gbName: "哈默弗斯特（挪威）",
            gbCode: "NOR066",
            ciqCode: "578066"
        },
        {
            codeName: "哈尔斯塔（挪威）",
            cusCode: "2478",
            codeValue: "NOR069",
            gbName: "哈尔斯塔（挪威）",
            gbCode: "NOR069",
            ciqCode: "578069"
        },
        {
            codeName: "海于格松（挪威）",
            cusCode: "2479",
            codeValue: "NOR072",
            gbName: "海于格松（挪威）",
            gbCode: "NOR072",
            ciqCode: "578072"
        },
        {
            codeName: "哈维克（挪威）",
            cusCode: "326",
            codeValue: "NOR075",
            gbName: "哈维克（挪威）",
            gbCode: "NOR075",
            ciqCode: "578075"
        },
        {
            codeName: "哈略（挪威）",
            cusCode: "2480",
            codeValue: "NOR078",
            gbName: "哈略（挪威）",
            gbCode: "NOR078",
            ciqCode: "578078"
        },
        {
            codeName: "霍尔默斯特兰（挪威）",
            cusCode: "2481",
            codeValue: "NOR081",
            gbName: "霍尔默斯特兰（挪威）",
            gbCode: "NOR081",
            ciqCode: "578081"
        },
        {
            codeName: "霍腾（挪威）",
            cusCode: "2482",
            codeValue: "NOR084",
            gbName: "霍腾（挪威）",
            gbCode: "NOR084",
            ciqCode: "578084"
        },
        {
            codeName: "赫杨厄尔（挪威）",
            cusCode: "2483",
            codeValue: "NOR087",
            gbName: "赫杨厄尔（挪威）",
            gbCode: "NOR087",
            ciqCode: "578087"
        },
        {
            codeName: "许斯内斯（挪威）",
            cusCode: "2484",
            codeValue: "NOR090",
            gbName: "许斯内斯（挪威）",
            gbCode: "NOR090",
            ciqCode: "578090"
        },
        {
            codeName: "希尔克内斯（挪威）",
            cusCode: "2486",
            codeValue: "NOR093",
            gbName: "希尔克内斯（挪威）",
            gbCode: "NOR093",
            ciqCode: "578093"
        },
        {
            codeName: "克来文（挪威）",
            cusCode: "2487",
            codeValue: "NOR096",
            gbName: "克来文（挪威）",
            gbCode: "NOR096",
            ciqCode: "578096"
        },
        {
            codeName: "科珀维克（挪威）",
            cusCode: "2488",
            codeValue: "NOR099",
            gbName: "科珀维克（挪威）",
            gbCode: "NOR099",
            ciqCode: "578099"
        },
        {
            codeName: "克拉格勒（挪威）",
            cusCode: "2489",
            codeValue: "NOR102",
            gbName: "克拉格勒（挪威）",
            gbCode: "NOR102",
            ciqCode: "578102"
        },
        {
            codeName: "克里斯蒂安桑（挪威）",
            cusCode: "2508",
            codeValue: "NOR105",
            gbName: "克里斯蒂安桑（挪威）",
            gbCode: "NOR105",
            ciqCode: "578105"
        },
        {
            codeName: "克里斯蒂安松（挪威）",
            cusCode: "2490",
            codeValue: "NOR108",
            gbName: "克里斯蒂安松（挪威）",
            gbCode: "NOR108",
            ciqCode: "578108"
        },
        {
            codeName: "克维内斯达尔（挪威）",
            cusCode: "326",
            codeValue: "NOR111",
            gbName: "克维内斯达尔（挪威）",
            gbCode: "NOR111",
            ciqCode: "578111"
        },
        {
            codeName: "朗厄松（挪威）",
            cusCode: "326",
            codeValue: "NOR114",
            gbName: "朗厄松（挪威）",
            gbCode: "NOR114",
            ciqCode: "578114"
        },
        {
            codeName: "拉尔维克（挪威）",
            cusCode: "2492",
            codeValue: "NOR117",
            gbName: "拉尔维克（挪威）",
            gbCode: "NOR117",
            ciqCode: "578117"
        },
        {
            codeName: "利勒桑（挪威）",
            cusCode: "2495",
            codeValue: "NOR120",
            gbName: "利勒桑（挪威）",
            gbCode: "NOR120",
            ciqCode: "578120"
        },
        {
            codeName: "勒丁恩（挪威）",
            cusCode: "2496",
            codeValue: "NOR123",
            gbName: "勒丁恩（挪威）",
            gbCode: "NOR123",
            ciqCode: "578123"
        },
        {
            codeName: "林厄尔（挪威）",
            cusCode: "2497",
            codeValue: "NOR126",
            gbName: "林厄尔（挪威）",
            gbCode: "NOR126",
            ciqCode: "578126"
        },
        {
            codeName: "马洛于（挪威）",
            cusCode: "2498",
            codeValue: "NOR129",
            gbName: "马洛于（挪威）",
            gbCode: "NOR129",
            ciqCode: "578129"
        },
        {
            codeName: "马尔姆（挪威）",
            cusCode: "326",
            codeValue: "NOR132",
            gbName: "马尔姆（挪威）",
            gbCode: "NOR132",
            ciqCode: "578132"
        },
        {
            codeName: "曼达尔（挪威）",
            cusCode: "2499",
            codeValue: "NOR135",
            gbName: "曼达尔（挪威）",
            gbCode: "NOR135",
            ciqCode: "578135"
        },
        {
            codeName: "曼斯塔德（挪威）",
            cusCode: "326",
            codeValue: "NOR138",
            gbName: "曼斯塔德（挪威）",
            gbCode: "NOR138",
            ciqCode: "578138"
        },
        {
            codeName: "摩城（挪威）",
            cusCode: "2500",
            codeValue: "NOR141",
            gbName: "摩城（挪威）",
            gbCode: "NOR141",
            ciqCode: "578141"
        },
        {
            codeName: "莫尔德（挪威）",
            cusCode: "2501",
            codeValue: "NOR144",
            gbName: "莫尔德（挪威）",
            gbCode: "NOR144",
            ciqCode: "578144"
        },
        {
            codeName: "蒙斯塔德（挪威）",
            cusCode: "326",
            codeValue: "NOR147",
            gbName: "蒙斯塔德（挪威）",
            gbCode: "NOR147",
            ciqCode: "578147"
        },
        {
            codeName: "莫舍恩（挪威）",
            cusCode: "2502",
            codeValue: "NOR150",
            gbName: "莫舍恩（挪威）",
            gbCode: "NOR150",
            ciqCode: "578150"
        },
        {
            codeName: "莫斯（挪威）",
            cusCode: "2503",
            codeValue: "NOR153",
            gbName: "莫斯（挪威）",
            gbCode: "NOR153",
            ciqCode: "578153"
        },
        {
            codeName: "奈斯内斯（挪威）",
            cusCode: "2504",
            codeValue: "NOR156",
            gbName: "奈斯内斯（挪威）",
            gbCode: "NOR156",
            ciqCode: "578156"
        },
        {
            codeName: "纳姆索斯（挪威）",
            cusCode: "2505",
            codeValue: "NOR159",
            gbName: "纳姆索斯（挪威）",
            gbCode: "NOR159",
            ciqCode: "578159"
        },
        {
            codeName: "纳尔维克（挪威）",
            cusCode: "2506",
            codeValue: "NOR162",
            gbName: "纳尔维克（挪威）",
            gbCode: "NOR162",
            ciqCode: "578162"
        },
        {
            codeName: "奥达（挪威）",
            cusCode: "2507",
            codeValue: "NOR165",
            gbName: "奥达（挪威）",
            gbCode: "NOR165",
            ciqCode: "578165"
        },
        {
            codeName: "奥普洛（挪威）",
            cusCode: "326",
            codeValue: "NOR168",
            gbName: "奥普洛（挪威）",
            gbCode: "NOR168",
            ciqCode: "578168"
        },
        {
            codeName: "奥斯陆（挪威）",
            cusCode: "2509",
            codeValue: "NOR171",
            gbName: "奥斯陆（挪威）",
            gbCode: "NOR171",
            ciqCode: "578171"
        },
        {
            codeName: "波斯格伦（挪威）",
            cusCode: "2510",
            codeValue: "NOR174",
            gbName: "波斯格伦（挪威）",
            gbCode: "NOR174",
            ciqCode: "578174"
        },
        {
            codeName: "里瑟尔（挪威）",
            cusCode: "2512",
            codeValue: "NOR177",
            gbName: "里瑟尔（挪威）",
            gbCode: "NOR177",
            ciqCode: "578177"
        },
        {
            codeName: "桑讷菲尤尔（挪威）",
            cusCode: "2513",
            codeValue: "NOR180",
            gbName: "桑讷菲尤尔（挪威）",
            gbCode: "NOR180",
            ciqCode: "578180"
        },
        {
            codeName: "桑内斯（挪威）",
            cusCode: "2514",
            codeValue: "NOR183",
            gbName: "桑内斯（挪威）",
            gbCode: "NOR183",
            ciqCode: "578183"
        },
        {
            codeName: "萨尔普斯堡（挪威）",
            cusCode: "2515",
            codeValue: "NOR186",
            gbName: "萨尔普斯堡（挪威）",
            gbCode: "NOR186",
            ciqCode: "578186"
        },
        {
            codeName: "赛于达（挪威）",
            cusCode: "2516",
            codeValue: "NOR189",
            gbName: "赛于达（挪威）",
            gbCode: "NOR189",
            ciqCode: "578189"
        },
        {
            codeName: "希恩（挪威）",
            cusCode: "2517",
            codeValue: "NOR192",
            gbName: "希恩（挪威）",
            gbCode: "NOR192",
            ciqCode: "578192"
        },
        {
            codeName: "斯屈德内斯港（挪威）",
            cusCode: "2518",
            codeValue: "NOR195",
            gbName: "斯屈德内斯港（挪威）",
            gbCode: "NOR195",
            ciqCode: "578195"
        },
        {
            codeName: "斯拉根（挪威）",
            cusCode: "2519",
            codeValue: "NOR198",
            gbName: "斯拉根（挪威）",
            gbCode: "NOR198",
            ciqCode: "578198"
        },
        {
            codeName: "斯塔万格（挪威）",
            cusCode: "2520",
            codeValue: "NOR201",
            gbName: "斯塔万格（挪威）",
            gbCode: "NOR201",
            ciqCode: "578201"
        },
        {
            codeName: "斯泰恩谢尔（挪威）",
            cusCode: "2521",
            codeValue: "NOR204",
            gbName: "斯泰恩谢尔（挪威）",
            gbCode: "NOR204",
            ciqCode: "578204"
        },
        {
            codeName: "孙达尔瑟拉（挪威）",
            cusCode: "326",
            codeValue: "NOR207",
            gbName: "孙达尔瑟拉（挪威）",
            gbCode: "NOR207",
            ciqCode: "578207"
        },
        {
            codeName: "斯韦尔根（挪威）",
            cusCode: "2522",
            codeValue: "NOR210",
            gbName: "斯韦尔根（挪威）",
            gbCode: "NOR210",
            ciqCode: "578210"
        },
        {
            codeName: "斯瓦尔维克（挪威）",
            cusCode: "326",
            codeValue: "NOR213",
            gbName: "斯瓦尔维克（挪威）",
            gbCode: "NOR213",
            ciqCode: "578213"
        },
        {
            codeName: "斯沃尔韦尔（挪威）",
            cusCode: "2523",
            codeValue: "NOR216",
            gbName: "斯沃尔韦尔（挪威）",
            gbCode: "NOR216",
            ciqCode: "578216"
        },
        {
            codeName: "塔姆港（挪威）",
            cusCode: "2524",
            codeValue: "NOR219",
            gbName: "塔姆港（挪威）",
            gbCode: "NOR219",
            ciqCode: "578219"
        },
        {
            codeName: "托夫特（挪威）",
            cusCode: "326",
            codeValue: "NOR222",
            gbName: "托夫特（挪威）",
            gbCode: "NOR222",
            ciqCode: "578222"
        },
        {
            codeName: "滕斯贝格（挪威）",
            cusCode: "2525",
            codeValue: "NOR225",
            gbName: "滕斯贝格（挪威）",
            gbCode: "NOR225",
            ciqCode: "578225"
        },
        {
            codeName: "塔乌（挪威）",
            cusCode: "2526",
            codeValue: "NOR228",
            gbName: "塔乌（挪威）",
            gbCode: "NOR228",
            ciqCode: "578228"
        },
        {
            codeName: "特罗姆瑟（挪威）",
            cusCode: "2527",
            codeValue: "NOR231",
            gbName: "特罗姆瑟（挪威）",
            gbCode: "NOR231",
            ciqCode: "578231"
        },
        {
            codeName: "特隆赫姆（挪威）",
            cusCode: "326",
            codeValue: "NOR234",
            gbName: "特隆赫姆（挪威）",
            gbCode: "NOR234",
            ciqCode: "578234"
        },
        {
            codeName: "特维德斯特兰德（挪威）",
            cusCode: "2528",
            codeValue: "NOR237",
            gbName: "特维德斯特兰德（挪威）",
            gbCode: "NOR237",
            ciqCode: "578237"
        },
        {
            codeName: "瓦德瑟（挪威）",
            cusCode: "2529",
            codeValue: "NOR240",
            gbName: "瓦德瑟（挪威）",
            gbCode: "NOR240",
            ciqCode: "578240"
        },
        {
            codeName: "瓦克斯达尔（挪威）",
            cusCode: "326",
            codeValue: "NOR243",
            gbName: "瓦克斯达尔（挪威）",
            gbCode: "NOR243",
            ciqCode: "578243"
        },
        {
            codeName: "沃尔德（挪威）",
            cusCode: "2530",
            codeValue: "NOR246",
            gbName: "沃尔德（挪威）",
            gbCode: "NOR246",
            ciqCode: "578246"
        },
        {
            codeName: "沃尔达（挪威）",
            cusCode: "326",
            codeValue: "NOR249",
            gbName: "沃尔达（挪威）",
            gbCode: "NOR249",
            ciqCode: "578249"
        },
        {
            codeName: "BYE（挪威）",
            cusCode: "2475",
            codeValue: "NOR252",
            gbName: "BYE（挪威）",
            gbCode: "NOR252",
            ciqCode: "578252"
        },
        {
            codeName: "尼泊尔",
            cusCode: "125",
            codeValue: "NPL000",
            gbName: "尼泊尔",
            gbCode: "NPL000",
            ciqCode: "524000"
        },
        {
            codeName: "加德满都（尼泊尔）",
            cusCode: "125",
            codeValue: "NPL901",
            gbName: "加德满都（尼泊尔）",
            gbCode: "NPL901",
            ciqCode: "524901"
        },
        {
            codeName: "科达里（尼泊尔）",
            cusCode: "125",
            codeValue: "NPL902",
            gbName: "科达里（尼泊尔）",
            gbCode: "NPL902",
            ciqCode: "524902"
        },
        {
            codeName: "瑙鲁",
            cusCode: "606",
            codeValue: "NRU000",
            gbName: "瑙鲁",
            gbCode: "NRU000",
            ciqCode: "520000"
        },
        {
            codeName: "瑙鲁岛（瑙鲁）",
            cusCode: "606",
            codeValue: "NRU003",
            gbName: "瑙鲁岛（瑙鲁）",
            gbCode: "NRU003",
            ciqCode: "520003"
        },
        {
            codeName: "亚伦（瑙鲁）",
            cusCode: "606",
            codeValue: "NRU006",
            gbName: "亚伦（瑙鲁）",
            gbCode: "NRU006",
            ciqCode: "520006"
        },
        {
            codeName: "新西兰",
            cusCode: "609",
            codeValue: "NZL000",
            gbName: "新西兰",
            gbCode: "NZL000",
            ciqCode: "554000"
        },
        {
            codeName: "璜加雷（新西兰）",
            cusCode: "3304",
            codeValue: "NZL001",
            gbName: "璜加雷（新西兰）",
            gbCode: "NZL001",
            ciqCode: "554001"
        },
        {
            codeName: "奥克兰（新西兰）",
            cusCode: "3295",
            codeValue: "NZL003",
            gbName: "奥克兰（新西兰）",
            gbCode: "NZL003",
            ciqCode: "554003"
        },
        {
            codeName: "克马德克群岛（新西兰）",
            cusCode: "3302",
            codeValue: "NZL004",
            gbName: "克马德克群岛（新西兰）",
            gbCode: "NZL004",
            ciqCode: "554004"
        },
        {
            codeName: "布拉夫（新西兰）",
            cusCode: "3296",
            codeValue: "NZL006",
            gbName: "布拉夫（新西兰）",
            gbCode: "NZL006",
            ciqCode: "554006"
        },
        {
            codeName: "克赖斯特彻奇（新西兰）",
            cusCode: "609",
            codeValue: "NZL008",
            gbName: "克赖斯特彻奇（新西兰）",
            gbCode: "NZL008",
            ciqCode: "554008"
        },
        {
            codeName: "达尼丁（新西兰）",
            cusCode: "3298",
            codeValue: "NZL009",
            gbName: "达尼丁（新西兰）",
            gbCode: "NZL009",
            ciqCode: "554009"
        },
        {
            codeName: "塔拉纳基港（新西兰）",
            cusCode: "3315",
            codeValue: "NZL011",
            gbName: "塔拉纳基港（新西兰）",
            gbCode: "NZL011",
            ciqCode: "554011"
        },
        {
            codeName: "吉斯珀恩（新西兰）",
            cusCode: "3299",
            codeValue: "NZL012",
            gbName: "吉斯珀恩（新西兰）",
            gbCode: "NZL012",
            ciqCode: "554012"
        },
        {
            codeName: "格雷茅斯（新西兰）",
            cusCode: "3300",
            codeValue: "NZL015",
            gbName: "格雷茅斯（新西兰）",
            gbCode: "NZL015",
            ciqCode: "554015"
        },
        {
            codeName: "因弗卡吉尔（新西兰）",
            cusCode: "609",
            codeValue: "NZL018",
            gbName: "因弗卡吉尔（新西兰）",
            gbCode: "NZL018",
            ciqCode: "554018"
        },
        {
            codeName: "利特尔顿（新西兰）",
            cusCode: "3313",
            codeValue: "NZL021",
            gbName: "利特尔顿（新西兰）",
            gbCode: "NZL021",
            ciqCode: "554021"
        },
        {
            codeName: "芒特芒阿努伊（新西兰）",
            cusCode: "3305",
            codeValue: "NZL024",
            gbName: "芒特芒阿努伊（新西兰）",
            gbCode: "NZL024",
            ciqCode: "554024"
        },
        {
            codeName: "内皮尔（新西兰）",
            cusCode: "3306",
            codeValue: "NZL027",
            gbName: "内皮尔（新西兰）",
            gbCode: "NZL027",
            ciqCode: "554027"
        },
        {
            codeName: "纳尔逊（新西兰）",
            cusCode: "3301",
            codeValue: "NZL030",
            gbName: "纳尔逊（新西兰）",
            gbCode: "NZL030",
            ciqCode: "554030"
        },
        {
            codeName: "新普利茅斯（新西兰）",
            cusCode: "3307",
            codeValue: "NZL033",
            gbName: "新普利茅斯（新西兰）",
            gbCode: "NZL033",
            ciqCode: "554033"
        },
        {
            codeName: "奥马鲁（新西兰）",
            cusCode: "3308",
            codeValue: "NZL036",
            gbName: "奥马鲁（新西兰）",
            gbCode: "NZL036",
            ciqCode: "554036"
        },
        {
            codeName: "奥尼洪加（新西兰）",
            cusCode: "3309",
            codeValue: "NZL039",
            gbName: "奥尼洪加（新西兰）",
            gbCode: "NZL039",
            ciqCode: "554039"
        },
        {
            codeName: "奥普阿（新西兰）",
            cusCode: "609",
            codeValue: "NZL042",
            gbName: "奥普阿（新西兰）",
            gbCode: "NZL042",
            ciqCode: "554042"
        },
        {
            codeName: "奥塔戈（新西兰）",
            cusCode: "3310",
            codeValue: "NZL044",
            gbName: "奥塔戈（新西兰）",
            gbCode: "NZL044",
            ciqCode: "554044"
        },
        {
            codeName: "皮克顿（新西兰）",
            cusCode: "3311",
            codeValue: "NZL045",
            gbName: "皮克顿（新西兰）",
            gbCode: "NZL045",
            ciqCode: "554045"
        },
        {
            codeName: "查默斯港（新西兰）",
            cusCode: "609",
            codeValue: "NZL048",
            gbName: "查默斯港（新西兰）",
            gbCode: "NZL048",
            ciqCode: "554048"
        },
        {
            codeName: "罗塞尔港（新西兰）",
            cusCode: "609",
            codeValue: "NZL051",
            gbName: "罗塞尔港（新西兰）",
            gbCode: "NZL051",
            ciqCode: "554051"
        },
        {
            codeName: "塔哈罗阿（新西兰）",
            cusCode: "609",
            codeValue: "NZL056",
            gbName: "塔哈罗阿（新西兰）",
            gbCode: "NZL056",
            ciqCode: "554056"
        },
        {
            codeName: "陶朗阿（新西兰）",
            cusCode: "3318",
            codeValue: "NZL057",
            gbName: "陶朗阿（新西兰）",
            gbCode: "NZL057",
            ciqCode: "554057"
        },
        {
            codeName: "蒂马鲁（新西兰）",
            cusCode: "3319",
            codeValue: "NZL060",
            gbName: "蒂马鲁（新西兰）",
            gbCode: "NZL060",
            ciqCode: "554060"
        },
        {
            codeName: "怀劳（新西兰）",
            cusCode: "609",
            codeValue: "NZL063",
            gbName: "怀劳（新西兰）",
            gbCode: "NZL063",
            ciqCode: "554063"
        },
        {
            codeName: "旺加努伊（新西兰）",
            cusCode: "3320",
            codeValue: "NZL066",
            gbName: "旺加努伊（新西兰）",
            gbCode: "NZL066",
            ciqCode: "554066"
        },
        {
            codeName: "韦弗利港（新西兰）",
            cusCode: "609",
            codeValue: "NZL069",
            gbName: "韦弗利港（新西兰）",
            gbCode: "NZL069",
            ciqCode: "554069"
        },
        {
            codeName: "惠灵顿（新西兰）",
            cusCode: "3321",
            codeValue: "NZL072",
            gbName: "惠灵顿（新西兰）",
            gbCode: "NZL072",
            ciqCode: "554072"
        },
        {
            codeName: "韦斯特皮特（新西兰）",
            cusCode: "3322",
            codeValue: "NZL075",
            gbName: "韦斯特皮特（新西兰）",
            gbCode: "NZL075",
            ciqCode: "554075"
        },
        {
            codeName: "旺阿雷（新西兰）",
            cusCode: "3323",
            codeValue: "NZL078",
            gbName: "旺阿雷（新西兰）",
            gbCode: "NZL078",
            ciqCode: "554078"
        },
        {
            codeName: "邦蒂群岛（新西兰）",
            cusCode: "3297",
            codeValue: "NZL102",
            gbName: "邦蒂群岛（新西兰）",
            gbCode: "NZL102",
            ciqCode: "554102"
        },
        {
            codeName: "阿卡罗亚（新西兰）",
            cusCode: "3294",
            codeValue: "NZL103",
            gbName: "阿卡罗亚（新西兰）",
            gbCode: "NZL103",
            ciqCode: "554103"
        },
        {
            codeName: "阿曼",
            cusCode: "126",
            codeValue: "OMN000",
            gbName: "阿曼",
            gbCode: "OMN000",
            ciqCode: "512000"
        },
        {
            codeName: "费赫勒港（阿曼）",
            cusCode: "1416",
            codeValue: "OMN003",
            gbName: "费赫勒港（阿曼）",
            gbCode: "OMN003",
            ciqCode: "512003"
        },
        {
            codeName: "卡布斯港（阿曼）",
            cusCode: "1417",
            codeValue: "OMN006",
            gbName: "卡布斯港（阿曼）",
            gbCode: "OMN006",
            ciqCode: "512006"
        },
        {
            codeName: "马特拉（阿曼）",
            cusCode: "126",
            codeValue: "OMN009",
            gbName: "马特拉（阿曼）",
            gbCode: "OMN009",
            ciqCode: "512009"
        },
        {
            codeName: "塞拉莱（阿曼）",
            cusCode: "126",
            codeValue: "OMN012",
            gbName: "塞拉莱（阿曼）",
            gbCode: "OMN012",
            ciqCode: "512012"
        },
        {
            codeName: "马斯喀特（阿曼）",
            cusCode: "126",
            codeValue: "OMN015",
            gbName: "马斯喀特（阿曼）",
            gbCode: "OMN015",
            ciqCode: "512015"
        },
        {
            codeName: "赖苏特（阿曼）",
            cusCode: "126",
            codeValue: "OMN018",
            gbName: "赖苏特（阿曼）",
            gbCode: "OMN018",
            ciqCode: "512018"
        },
        {
            codeName: "索哈（阿曼）",
            cusCode: "126",
            codeValue: "OMN021",
            gbName: "索哈（阿曼）",
            gbCode: "OMN021",
            ciqCode: "512021"
        },
        {
            codeName: "巴基斯坦",
            cusCode: "127",
            codeValue: "PAK000",
            gbName: "巴基斯坦",
            gbCode: "PAK000",
            ciqCode: "586000"
        },
        {
            codeName: "瓜德尔（巴基斯坦）",
            cusCode: "127",
            codeValue: "PAK003",
            gbName: "瓜德尔（巴基斯坦）",
            gbCode: "PAK003",
            ciqCode: "586003"
        },
        {
            codeName: "卡拉奇（巴基斯坦）",
            cusCode: "1418",
            codeValue: "PAK006",
            gbName: "卡拉奇（巴基斯坦）",
            gbCode: "PAK006",
            ciqCode: "586006"
        },
        {
            codeName: "穆罕默德宾加西姆（巴基斯坦）",
            cusCode: "127",
            codeValue: "PAK008",
            gbName: "穆罕默德宾加西姆（巴基斯坦）",
            gbCode: "PAK008",
            ciqCode: "586008"
        },
        {
            codeName: "奥尔马拉（巴基斯坦）",
            cusCode: "127",
            codeValue: "PAK009",
            gbName: "奥尔马拉（巴基斯坦）",
            gbCode: "PAK009",
            ciqCode: "586009"
        },
        {
            codeName: "伯斯尼（巴基斯坦）",
            cusCode: "127",
            codeValue: "PAK012",
            gbName: "伯斯尼（巴基斯坦）",
            gbCode: "PAK012",
            ciqCode: "586012"
        },
        {
            codeName: "苏斯特（巴基斯坦）",
            cusCode: "127",
            codeValue: "PAK901",
            gbName: "苏斯特（巴基斯坦）",
            gbCode: "PAK901",
            ciqCode: "586901"
        },
        {
            codeName: "伊斯兰堡（巴基斯坦）",
            cusCode: "127",
            codeValue: "PAK902",
            gbName: "伊斯兰堡（巴基斯坦）",
            gbCode: "PAK902",
            ciqCode: "586902"
        },
        {
            codeName: "巴拿马",
            cusCode: "432",
            codeValue: "PAN000",
            gbName: "巴拿马",
            gbCode: "PAN000",
            ciqCode: "591000"
        },
        {
            codeName: "PUERTO DELABAHIA DE（巴拿马）",
            cusCode: "2909",
            codeValue: "PAN001",
            gbName: "PUERTO DELABAHIA DE（巴拿马）",
            gbCode: "PAN001",
            ciqCode: "591001"
        },
        {
            codeName: "巴拿马运河（巴拿马）",
            cusCode: "2908",
            codeValue: "PAN002",
            gbName: "巴拿马运河（巴拿马）",
            gbCode: "PAN002",
            ciqCode: "591002"
        },
        {
            codeName: "阿瓜杜尔塞（巴拿马）",
            cusCode: "2899",
            codeValue: "PAN003",
            gbName: "阿瓜杜尔塞（巴拿马）",
            gbCode: "PAN003",
            ciqCode: "591003"
        },
        {
            codeName: "贝略港（巴拿马）",
            cusCode: "2903",
            codeValue: "PAN004",
            gbName: "贝略港（巴拿马）",
            gbCode: "PAN004",
            ciqCode: "591004"
        },
        {
            codeName: "博卡斯-德尔扎罗（巴拿马）",
            cusCode: "2901",
            codeValue: "PAN005",
            gbName: "博卡斯-德尔扎罗（巴拿马）",
            gbCode: "PAN005",
            ciqCode: "591005"
        },
        {
            codeName: "阿尔米兰特（巴拿马）",
            cusCode: "432",
            codeValue: "PAN006",
            gbName: "阿尔米兰特（巴拿马）",
            gbCode: "PAN006",
            ciqCode: "591006"
        },
        {
            codeName: "托斯米纳斯湾（巴拿马）",
            cusCode: "2906",
            codeValue: "PAN007",
            gbName: "托斯米纳斯湾（巴拿马）",
            gbCode: "PAN007",
            ciqCode: "591007"
        },
        {
            codeName: "拉斯米纳斯湾港（巴拿马）",
            cusCode: "2907",
            codeValue: "PAN008",
            gbName: "拉斯米纳斯湾港（巴拿马）",
            gbCode: "PAN008",
            ciqCode: "591008"
        },
        {
            codeName: "安蒙勒斯（巴拿马）",
            cusCode: "2900",
            codeValue: "PAN009",
            gbName: "安蒙勒斯（巴拿马）",
            gbCode: "PAN009",
            ciqCode: "591009"
        },
        {
            codeName: "巴尔博亚（巴拿马）",
            cusCode: "2905",
            codeValue: "PAN012",
            gbName: "巴尔博亚（巴拿马）",
            gbCode: "PAN012",
            ciqCode: "591012"
        },
        {
            codeName: "大奇里基（巴拿马）",
            cusCode: "432",
            codeValue: "PAN015",
            gbName: "大奇里基（巴拿马）",
            gbCode: "PAN015",
            ciqCode: "591015"
        },
        {
            codeName: "科隆（巴拿马）",
            cusCode: "2902",
            codeValue: "PAN018",
            gbName: "科隆（巴拿马）",
            gbCode: "PAN018",
            ciqCode: "591018"
        },
        {
            codeName: "克里斯托瓦尔（巴拿马）",
            cusCode: "432",
            codeValue: "PAN021",
            gbName: "克里斯托瓦尔（巴拿马）",
            gbCode: "PAN021",
            ciqCode: "591021"
        },
        {
            codeName: "曼萨尼约（巴拿马）",
            cusCode: "432",
            codeValue: "PAN022",
            gbName: "曼萨尼约（巴拿马）",
            gbCode: "PAN022",
            ciqCode: "591022"
        },
        {
            codeName: "巴拿马城（巴拿马）",
            cusCode: "2904",
            codeValue: "PAN023",
            gbName: "巴拿马城（巴拿马）",
            gbCode: "PAN023",
            ciqCode: "591023"
        },
        {
            codeName: "拉帕尔马（巴拿马）",
            cusCode: "432",
            codeValue: "PAN024",
            gbName: "拉帕尔马（巴拿马）",
            gbCode: "PAN024",
            ciqCode: "591024"
        },
        {
            codeName: "帕纳马（巴拿马）",
            cusCode: "432",
            codeValue: "PAN027",
            gbName: "帕纳马（巴拿马）",
            gbCode: "PAN027",
            ciqCode: "591027"
        },
        {
            codeName: "佩德雷加尔（巴拿马）",
            cusCode: "432",
            codeValue: "PAN030",
            gbName: "佩德雷加尔（巴拿马）",
            gbCode: "PAN030",
            ciqCode: "591030"
        },
        {
            codeName: "巴尔蒙特（巴拿马）",
            cusCode: "432",
            codeValue: "PAN033",
            gbName: "巴尔蒙特（巴拿马）",
            gbCode: "PAN033",
            ciqCode: "591033"
        },
        {
            codeName: "皮特凯恩",
            cusCode: "633",
            codeValue: "PCN000",
            gbName: "皮特凯恩",
            gbCode: "PCN000",
            ciqCode: "612000"
        },
        {
            codeName: "亚当斯敦（皮特凯恩）",
            cusCode: "3385",
            codeValue: "PCN003",
            gbName: "亚当斯敦（皮特凯恩）",
            gbCode: "PCN003",
            ciqCode: "612003"
        },
        {
            codeName: "皮特凯恩岛（皮特凯恩）",
            cusCode: "3401",
            codeValue: "PCN006",
            gbName: "皮特凯恩岛（皮特凯恩）",
            gbCode: "PCN006",
            ciqCode: "612006"
        },
        {
            codeName: "秘鲁",
            cusCode: "434",
            codeValue: "PER000",
            gbName: "秘鲁",
            gbCode: "PER000",
            ciqCode: "604000"
        },
        {
            codeName: "BESIQUE（秘鲁）",
            cusCode: "2910",
            codeValue: "PER002",
            gbName: "BESIQUE（秘鲁）",
            gbCode: "PER002",
            ciqCode: "604002"
        },
        {
            codeName: "安孔（秘鲁）",
            cusCode: "434",
            codeValue: "PER003",
            gbName: "安孔（秘鲁）",
            gbCode: "PER003",
            ciqCode: "604003"
        },
        {
            codeName: "阿蒂科（秘鲁）",
            cusCode: "434",
            codeValue: "PER006",
            gbName: "阿蒂科（秘鲁）",
            gbCode: "PER006",
            ciqCode: "604006"
        },
        {
            codeName: "卡沃布兰科（秘鲁）",
            cusCode: "434",
            codeValue: "PER009",
            gbName: "卡沃布兰科（秘鲁）",
            gbCode: "PER009",
            ciqCode: "604009"
        },
        {
            codeName: "卡亚俄（秘鲁）",
            cusCode: "2914",
            codeValue: "PER012",
            gbName: "卡亚俄（秘鲁）",
            gbCode: "PER012",
            ciqCode: "604012"
        },
        {
            codeName: "塞罗阿苏尔（秘鲁）",
            cusCode: "434",
            codeValue: "PER015",
            gbName: "塞罗阿苏尔（秘鲁）",
            gbCode: "PER015",
            ciqCode: "604015"
        },
        {
            codeName: "钱凯（秘鲁）",
            cusCode: "434",
            codeValue: "PER018",
            gbName: "钱凯（秘鲁）",
            gbCode: "PER018",
            ciqCode: "604018"
        },
        {
            codeName: "奇卡马（秘鲁）",
            cusCode: "2915",
            codeValue: "PER021",
            gbName: "奇卡马（秘鲁）",
            gbCode: "PER021",
            ciqCode: "604021"
        },
        {
            codeName: "钦博塔（秘鲁）",
            cusCode: "2911",
            codeValue: "PER024",
            gbName: "钦博塔（秘鲁）",
            gbCode: "PER024",
            ciqCode: "604024"
        },
        {
            codeName: "科伊希科（秘鲁）",
            cusCode: "434",
            codeValue: "PER027",
            gbName: "科伊希科（秘鲁）",
            gbCode: "PER027",
            ciqCode: "604027"
        },
        {
            codeName: "康昌（秘鲁）",
            cusCode: "434",
            codeValue: "PER030",
            gbName: "康昌（秘鲁）",
            gbCode: "PER030",
            ciqCode: "604030"
        },
        {
            codeName: "埃腾（秘鲁）",
            cusCode: "434",
            codeValue: "PER033",
            gbName: "埃腾（秘鲁）",
            gbCode: "PER033",
            ciqCode: "604033"
        },
        {
            codeName: "圣马丁将军镇（秘鲁）",
            cusCode: "434",
            codeValue: "PER036",
            gbName: "圣马丁将军镇（秘鲁）",
            gbCode: "PER036",
            ciqCode: "604036"
        },
        {
            codeName: "瓦乔（秘鲁）",
            cusCode: "2912",
            codeValue: "PER039",
            gbName: "瓦乔（秘鲁）",
            gbCode: "PER039",
            ciqCode: "604039"
        },
        {
            codeName: "瓦尔梅（秘鲁）",
            cusCode: "434",
            codeValue: "PER042",
            gbName: "瓦尔梅（秘鲁）",
            gbCode: "PER042",
            ciqCode: "604042"
        },
        {
            codeName: "伊洛（秘鲁）",
            cusCode: "2913",
            codeValue: "PER045",
            gbName: "伊洛（秘鲁）",
            gbCode: "PER045",
            ciqCode: "604045"
        },
        {
            codeName: "伊基托斯（秘鲁）",
            cusCode: "434",
            codeValue: "PER048",
            gbName: "伊基托斯（秘鲁）",
            gbCode: "PER048",
            ciqCode: "604048"
        },
        {
            codeName: "拉帕姆皮拉（秘鲁）",
            cusCode: "434",
            codeValue: "PER051",
            gbName: "拉帕姆皮拉（秘鲁）",
            gbCode: "PER051",
            ciqCode: "604051"
        },
        {
            codeName: "洛维托斯（秘鲁）",
            cusCode: "434",
            codeValue: "PER054",
            gbName: "洛维托斯（秘鲁）",
            gbCode: "PER054",
            ciqCode: "604054"
        },
        {
            codeName: "洛布斯岛（秘鲁）",
            cusCode: "434",
            codeValue: "PER057",
            gbName: "洛布斯岛（秘鲁）",
            gbCode: "PER057",
            ciqCode: "604057"
        },
        {
            codeName: "洛马斯（秘鲁）",
            cusCode: "434",
            codeValue: "PER060",
            gbName: "洛马斯（秘鲁）",
            gbCode: "PER060",
            ciqCode: "604060"
        },
        {
            codeName: "马塔拉尼（秘鲁）",
            cusCode: "2916",
            codeValue: "PER063",
            gbName: "马塔拉尼（秘鲁）",
            gbCode: "PER063",
            ciqCode: "604063"
        },
        {
            codeName: "莫延多（秘鲁）",
            cusCode: "434",
            codeValue: "PER066",
            gbName: "莫延多（秘鲁）",
            gbCode: "PER066",
            ciqCode: "604066"
        },
        {
            codeName: "帕卡斯马约（秘鲁）",
            cusCode: "2917",
            codeValue: "PER069",
            gbName: "帕卡斯马约（秘鲁）",
            gbCode: "PER069",
            ciqCode: "604069"
        },
        {
            codeName: "派塔（秘鲁）",
            cusCode: "2918",
            codeValue: "PER072",
            gbName: "派塔（秘鲁）",
            gbCode: "PER072",
            ciqCode: "604072"
        },
        {
            codeName: "帕拉蒙加（秘鲁）",
            cusCode: "434",
            codeValue: "PER075",
            gbName: "帕拉蒙加（秘鲁）",
            gbCode: "PER075",
            ciqCode: "604075"
        },
        {
            codeName: "皮门特尔（秘鲁）",
            cusCode: "2919",
            codeValue: "PER078",
            gbName: "皮门特尔（秘鲁）",
            gbCode: "PER078",
            ciqCode: "604078"
        },
        {
            codeName: "皮萨瓜（秘鲁）",
            cusCode: "434",
            codeValue: "PER081",
            gbName: "皮萨瓜（秘鲁）",
            gbCode: "PER081",
            ciqCode: "604081"
        },
        {
            codeName: "皮斯科（秘鲁）",
            cusCode: "2920",
            codeValue: "PER084",
            gbName: "皮斯科（秘鲁）",
            gbCode: "PER084",
            ciqCode: "604084"
        },
        {
            codeName: "巴约瓦尔港（秘鲁）",
            cusCode: "434",
            codeValue: "PER087",
            gbName: "巴约瓦尔港（秘鲁）",
            gbCode: "PER087",
            ciqCode: "604087"
        },
        {
            codeName: "萨拉韦里（秘鲁）",
            cusCode: "2921",
            codeValue: "PER090",
            gbName: "萨拉韦里（秘鲁）",
            gbCode: "PER090",
            ciqCode: "604090"
        },
        {
            codeName: "圣胡安（秘鲁）",
            cusCode: "434",
            codeValue: "PER093",
            gbName: "圣胡安（秘鲁）",
            gbCode: "PER093",
            ciqCode: "604093"
        },
        {
            codeName: "圣尼古拉斯（秘鲁）",
            cusCode: "434",
            codeValue: "PER096",
            gbName: "圣尼古拉斯（秘鲁）",
            gbCode: "PER096",
            ciqCode: "604096"
        },
        {
            codeName: "苏佩（秘鲁）",
            cusCode: "2922",
            codeValue: "PER099",
            gbName: "苏佩（秘鲁）",
            gbCode: "PER099",
            ciqCode: "604099"
        },
        {
            codeName: "塔拉拉（秘鲁）",
            cusCode: "2923",
            codeValue: "PER102",
            gbName: "塔拉拉（秘鲁）",
            gbCode: "PER102",
            ciqCode: "604102"
        },
        {
            codeName: "特鲁希略（秘鲁）",
            cusCode: "434",
            codeValue: "PER104",
            gbName: "特鲁希略（秘鲁）",
            gbCode: "PER104",
            ciqCode: "604104"
        },
        {
            codeName: "坦博-德莫拉（秘鲁）",
            cusCode: "2924",
            codeValue: "PER105",
            gbName: "坦博-德莫拉（秘鲁）",
            gbCode: "PER105",
            ciqCode: "604105"
        },
        {
            codeName: "菲律宾",
            cusCode: "129",
            codeValue: "PHL000",
            gbName: "菲律宾",
            gbCode: "PHL000",
            ciqCode: "608000"
        },
        {
            codeName: "碧瑶（菲律宾）",
            cusCode: "1423",
            codeValue: "PHL002",
            gbName: "碧瑶（菲律宾）",
            gbCode: "PHL002",
            ciqCode: "608002"
        },
        {
            codeName: "阿布约（菲律宾）",
            cusCode: "129",
            codeValue: "PHL003",
            gbName: "阿布约（菲律宾）",
            gbCode: "PHL003",
            ciqCode: "608003"
        },
        {
            codeName: "班乃岛（菲律宾）",
            cusCode: "1445",
            codeValue: "PHL004",
            gbName: "班乃岛（菲律宾）",
            gbCode: "PHL004",
            ciqCode: "608004"
        },
        {
            codeName: "保和（菲律宾）",
            cusCode: "1426",
            codeValue: "PHL005",
            gbName: "保和（菲律宾）",
            gbCode: "PHL005",
            ciqCode: "608005"
        },
        {
            codeName: "阿姆尼坦（菲律宾）",
            cusCode: "129",
            codeValue: "PHL006",
            gbName: "阿姆尼坦（菲律宾）",
            gbCode: "PHL006",
            ciqCode: "608006"
        },
        {
            codeName: "布瓦杨（菲律宾）",
            cusCode: "1427",
            codeValue: "PHL007",
            gbName: "布瓦杨（菲律宾）",
            gbCode: "PHL007",
            ciqCode: "608007"
        },
        {
            codeName: "阿纳根（菲律宾）",
            cusCode: "129",
            codeValue: "PHL009",
            gbName: "阿纳根（菲律宾）",
            gbCode: "PHL009",
            ciqCode: "608009"
        },
        {
            codeName: "棉兰老岛（菲律宾）",
            cusCode: "1444",
            codeValue: "PHL011",
            gbName: "棉兰老岛（菲律宾）",
            gbCode: "PHL011",
            ciqCode: "608011"
        },
        {
            codeName: "安蒂莫纳（菲律宾）",
            cusCode: "129",
            codeValue: "PHL012",
            gbName: "安蒂莫纳（菲律宾）",
            gbCode: "PHL012",
            ciqCode: "608012"
        },
        {
            codeName: "萨马岛（菲律宾）",
            cusCode: "1449",
            codeValue: "PHL013",
            gbName: "萨马岛（菲律宾）",
            gbCode: "PHL013",
            ciqCode: "608013"
        },
        {
            codeName: "阿帕里（菲律宾）",
            cusCode: "1422",
            codeValue: "PHL015",
            gbName: "阿帕里（菲律宾）",
            gbCode: "PHL015",
            ciqCode: "608015"
        },
        {
            codeName: "巴科洛德（菲律宾）",
            cusCode: "129",
            codeValue: "PHL018",
            gbName: "巴科洛德（菲律宾）",
            gbCode: "PHL018",
            ciqCode: "608018"
        },
        {
            codeName: "拜斯（菲律宾）",
            cusCode: "129",
            codeValue: "PHL021",
            gbName: "拜斯（菲律宾）",
            gbCode: "PHL021",
            ciqCode: "608021"
        },
        {
            codeName: "巴丹（菲律宾）",
            cusCode: "129",
            codeValue: "PHL024",
            gbName: "巴丹（菲律宾）",
            gbCode: "PHL024",
            ciqCode: "608024"
        },
        {
            codeName: "八打雁（菲律宾）",
            cusCode: "1424",
            codeValue: "PHL027",
            gbName: "八打雁（菲律宾）",
            gbCode: "PHL027",
            ciqCode: "608027"
        },
        {
            codeName: "比斯利格（菲律宾）",
            cusCode: "1425",
            codeValue: "PHL030",
            gbName: "比斯利格（菲律宾）",
            gbCode: "PHL030",
            ciqCode: "608030"
        },
        {
            codeName: "博哥（菲律宾）",
            cusCode: "129",
            codeValue: "PHL033",
            gbName: "博哥（菲律宾）",
            gbCode: "PHL033",
            ciqCode: "608033"
        },
        {
            codeName: "武端（菲律宾）",
            cusCode: "129",
            codeValue: "PHL036",
            gbName: "武端（菲律宾）",
            gbCode: "PHL036",
            ciqCode: "608036"
        },
        {
            codeName: "加的斯（菲律宾）",
            cusCode: "129",
            codeValue: "PHL039",
            gbName: "加的斯（菲律宾）",
            gbCode: "PHL039",
            ciqCode: "608039"
        },
        {
            codeName: "卡加延德奥罗（菲律宾）",
            cusCode: "1429",
            codeValue: "PHL042",
            gbName: "卡加延德奥罗（菲律宾）",
            gbCode: "PHL042",
            ciqCode: "608042"
        },
        {
            codeName: "甲描育（菲律宾）",
            cusCode: "129",
            codeValue: "PHL045",
            gbName: "甲描育（菲律宾）",
            gbCode: "PHL045",
            ciqCode: "608045"
        },
        {
            codeName: "卡皮斯（菲律宾）",
            cusCode: "129",
            codeValue: "PHL048",
            gbName: "卡皮斯（菲律宾）",
            gbCode: "PHL048",
            ciqCode: "608048"
        },
        {
            codeName: "甲米地（菲律宾）",
            cusCode: "129",
            codeValue: "PHL051",
            gbName: "甲米地（菲律宾）",
            gbCode: "PHL051",
            ciqCode: "608051"
        },
        {
            codeName: "宿务（菲律宾）",
            cusCode: "1428",
            codeValue: "PHL054",
            gbName: "宿务（菲律宾）",
            gbCode: "PHL054",
            ciqCode: "608054"
        },
        {
            codeName: "达沃（菲律宾）",
            cusCode: "1430",
            codeValue: "PHL057",
            gbName: "达沃（菲律宾）",
            gbCode: "PHL057",
            ciqCode: "608057"
        },
        {
            codeName: "迪纳加特（菲律宾）",
            cusCode: "129",
            codeValue: "PHL060",
            gbName: "迪纳加特（菲律宾）",
            gbCode: "PHL060",
            ciqCode: "608060"
        },
        {
            codeName: "丁阿兰湾（菲律宾）",
            cusCode: "129",
            codeValue: "PHL063",
            gbName: "丁阿兰湾（菲律宾）",
            gbCode: "PHL063",
            ciqCode: "608063"
        },
        {
            codeName: "第波罗（菲律宾）",
            cusCode: "129",
            codeValue: "PHL066",
            gbName: "第波罗（菲律宾）",
            gbCode: "PHL066",
            ciqCode: "608066"
        },
        {
            codeName: "杜马格特（菲律宾）",
            cusCode: "1431",
            codeValue: "PHL069",
            gbName: "杜马格特（菲律宾）",
            gbCode: "PHL069",
            ciqCode: "608069"
        },
        {
            codeName: "桑托斯（菲律宾）",
            cusCode: "129",
            codeValue: "PHL072",
            gbName: "桑托斯（菲律宾）",
            gbCode: "PHL072",
            ciqCode: "608072"
        },
        {
            codeName: "吉马拉斯岛（菲律宾）",
            cusCode: "1432",
            codeValue: "PHL075",
            gbName: "吉马拉斯岛（菲律宾）",
            gbCode: "PHL075",
            ciqCode: "608075"
        },
        {
            codeName: "希尼加兰（菲律宾）",
            cusCode: "129",
            codeValue: "PHL078",
            gbName: "希尼加兰（菲律宾）",
            gbCode: "PHL078",
            ciqCode: "608078"
        },
        {
            codeName: "伊利甘（菲律宾）",
            cusCode: "1433",
            codeValue: "PHL081",
            gbName: "伊利甘（菲律宾）",
            gbCode: "PHL081",
            ciqCode: "608081"
        },
        {
            codeName: "伊洛伊洛（菲律宾）",
            cusCode: "1434",
            codeValue: "PHL084",
            gbName: "伊洛伊洛（菲律宾）",
            gbCode: "PHL084",
            ciqCode: "608084"
        },
        {
            codeName: "伊萨贝尔（菲律宾）",
            cusCode: "129",
            codeValue: "PHL087",
            gbName: "伊萨贝尔（菲律宾）",
            gbCode: "PHL087",
            ciqCode: "608087"
        },
        {
            codeName: "伊萨贝拉（菲律宾）",
            cusCode: "1436",
            codeValue: "PHL090",
            gbName: "伊萨贝拉（菲律宾）",
            gbCode: "PHL090",
            ciqCode: "608090"
        },
        {
            codeName: "霍洛（菲律宾）",
            cusCode: "1437",
            codeValue: "PHL093",
            gbName: "霍洛（菲律宾）",
            gbCode: "PHL093",
            ciqCode: "608093"
        },
        {
            codeName: "何塞庞阿尼班村（菲律宾）",
            cusCode: "1438",
            codeValue: "PHL096",
            gbName: "何塞庞阿尼班村（菲律宾）",
            gbCode: "PHL096",
            ciqCode: "608096"
        },
        {
            codeName: "拉乌尼翁（菲律宾）",
            cusCode: "129",
            codeValue: "PHL099",
            gbName: "拉乌尼翁（菲律宾）",
            gbCode: "PHL099",
            ciqCode: "608099"
        },
        {
            codeName: "拉瓦格（菲律宾）",
            cusCode: "129",
            codeValue: "PHL102",
            gbName: "拉瓦格（菲律宾）",
            gbCode: "PHL102",
            ciqCode: "608102"
        },
        {
            codeName: "莱巴克（菲律宾）",
            cusCode: "129",
            codeValue: "PHL105",
            gbName: "莱巴克（菲律宾）",
            gbCode: "PHL105",
            ciqCode: "608105"
        },
        {
            codeName: "黎牙实比（菲律宾）",
            cusCode: "1439",
            codeValue: "PHL108",
            gbName: "黎牙实比（菲律宾）",
            gbCode: "PHL108",
            ciqCode: "608108"
        },
        {
            codeName: "林加延（菲律宾）",
            cusCode: "129",
            codeValue: "PHL111",
            gbName: "林加延（菲律宾）",
            gbCode: "PHL111",
            ciqCode: "608111"
        },
        {
            codeName: "马尼拉（菲律宾）",
            cusCode: "1441",
            codeValue: "PHL114",
            gbName: "马尼拉（菲律宾）",
            gbCode: "PHL114",
            ciqCode: "608114"
        },
        {
            codeName: "马里韦莱斯（菲律宾）",
            cusCode: "129",
            codeValue: "PHL117",
            gbName: "马里韦莱斯（菲律宾）",
            gbCode: "PHL117",
            ciqCode: "608117"
        },
        {
            codeName: "马萨豪（菲律宾）",
            cusCode: "129",
            codeValue: "PHL120",
            gbName: "马萨豪（菲律宾）",
            gbCode: "PHL120",
            ciqCode: "608120"
        },
        {
            codeName: "马斯巴特（菲律宾）",
            cusCode: "129",
            codeValue: "PHL123",
            gbName: "马斯巴特（菲律宾）",
            gbCode: "PHL123",
            ciqCode: "608123"
        },
        {
            codeName: "马辛洛克（菲律宾）",
            cusCode: "1442",
            codeValue: "PHL126",
            gbName: "马辛洛克（菲律宾）",
            gbCode: "PHL126",
            ciqCode: "608126"
        },
        {
            codeName: "马蒂（菲律宾）",
            cusCode: "129",
            codeValue: "PHL129",
            gbName: "马蒂（菲律宾）",
            gbCode: "PHL129",
            ciqCode: "608129"
        },
        {
            codeName: "米尔布克（菲律宾）",
            cusCode: "129",
            codeValue: "PHL132",
            gbName: "米尔布克（菲律宾）",
            gbCode: "PHL132",
            ciqCode: "608132"
        },
        {
            codeName: "那牙（菲律宾）",
            cusCode: "129",
            codeValue: "PHL135",
            gbName: "那牙（菲律宾）",
            gbCode: "PHL135",
            ciqCode: "608135"
        },
        {
            codeName: "纳斯皮特（菲律宾）",
            cusCode: "129",
            codeValue: "PHL138",
            gbName: "纳斯皮特（菲律宾）",
            gbCode: "PHL138",
            ciqCode: "608138"
        },
        {
            codeName: "纳苏格布（菲律宾）",
            cusCode: "129",
            codeValue: "PHL141",
            gbName: "纳苏格布（菲律宾）",
            gbCode: "PHL141",
            ciqCode: "608141"
        },
        {
            codeName: "奥隆阿坡（菲律宾）",
            cusCode: "129",
            codeValue: "PHL144",
            gbName: "奥隆阿坡（菲律宾）",
            gbCode: "PHL144",
            ciqCode: "608144"
        },
        {
            codeName: "奥尔莫克（菲律宾）",
            cusCode: "129",
            codeValue: "PHL147",
            gbName: "奥尔莫克（菲律宾）",
            gbCode: "PHL147",
            ciqCode: "608147"
        },
        {
            codeName: "潘普洛纳（菲律宾）",
            cusCode: "129",
            codeValue: "PHL150",
            gbName: "潘普洛纳（菲律宾）",
            gbCode: "PHL150",
            ciqCode: "608150"
        },
        {
            codeName: "帕兰（菲律宾）",
            cusCode: "129",
            codeValue: "PHL153",
            gbName: "帕兰（菲律宾）",
            gbCode: "PHL153",
            ciqCode: "608153"
        },
        {
            codeName: "波略克（菲律宾）",
            cusCode: "129",
            codeValue: "PHL156",
            gbName: "波略克（菲律宾）",
            gbCode: "PHL156",
            ciqCode: "608156"
        },
        {
            codeName: "波罗（Luzon）（菲律宾）",
            cusCode: "129",
            codeValue: "PHL159",
            gbName: "波罗（Luzon）（菲律宾）",
            gbCode: "PHL159",
            ciqCode: "608159"
        },
        {
            codeName: "波罗（Poro I.）（菲律宾）",
            cusCode: "129",
            codeValue: "PHL162",
            gbName: "波罗（Poro I.）（菲律宾）",
            gbCode: "PHL162",
            ciqCode: "608162"
        },
        {
            codeName: "荷兰港（菲律宾）",
            cusCode: "129",
            codeValue: "PHL165",
            gbName: "荷兰港（菲律宾）",
            gbCode: "PHL165",
            ciqCode: "608165"
        },
        {
            codeName: "圣玛丽亚港（菲律宾）",
            cusCode: "129",
            codeValue: "PHL168",
            gbName: "圣玛丽亚港（菲律宾）",
            gbCode: "PHL168",
            ciqCode: "608168"
        },
        {
            codeName: "普林塞萨港（菲律宾）",
            cusCode: "1446",
            codeValue: "PHL171",
            gbName: "普林塞萨港（菲律宾）",
            gbCode: "PHL171",
            ciqCode: "608171"
        },
        {
            codeName: "普卢潘丹（菲律宾）",
            cusCode: "1447",
            codeValue: "PHL174",
            gbName: "普卢潘丹（菲律宾）",
            gbCode: "PHL174",
            ciqCode: "608174"
        },
        {
            codeName: "圣卡洛斯（菲律宾）",
            cusCode: "129",
            codeValue: "PHL177",
            gbName: "圣卡洛斯（菲律宾）",
            gbCode: "PHL177",
            ciqCode: "608177"
        },
        {
            codeName: "圣弗尔南多（菲律宾）",
            cusCode: "1450",
            codeValue: "PHL180",
            gbName: "圣弗尔南多（菲律宾）",
            gbCode: "PHL180",
            ciqCode: "608180"
        },
        {
            codeName: "桑义（菲律宾）",
            cusCode: "1451",
            codeValue: "PHL183",
            gbName: "桑义（菲律宾）",
            gbCode: "PHL183",
            ciqCode: "608183"
        },
        {
            codeName: "圣克鲁斯（菲律宾）",
            cusCode: "129",
            codeValue: "PHL186",
            gbName: "圣克鲁斯（菲律宾）",
            gbCode: "PHL186",
            ciqCode: "608186"
        },
        {
            codeName: "索索贡（菲律宾）",
            cusCode: "129",
            codeValue: "PHL189",
            gbName: "索索贡（菲律宾）",
            gbCode: "PHL189",
            ciqCode: "608189"
        },
        {
            codeName: "苏里高（菲律宾）",
            cusCode: "129",
            codeValue: "PHL192",
            gbName: "苏里高（菲律宾）",
            gbCode: "PHL192",
            ciqCode: "608192"
        },
        {
            codeName: "塔瓦科（菲律宾）",
            cusCode: "1452",
            codeValue: "PHL195",
            gbName: "塔瓦科（菲律宾）",
            gbCode: "PHL195",
            ciqCode: "608195"
        },
        {
            codeName: "塔克洛班（菲律宾）",
            cusCode: "1453",
            codeValue: "PHL198",
            gbName: "塔克洛班（菲律宾）",
            gbCode: "PHL198",
            ciqCode: "608198"
        },
        {
            codeName: "塔比拉兰（菲律宾）",
            cusCode: "129",
            codeValue: "PHL201",
            gbName: "塔比拉兰（菲律宾）",
            gbCode: "PHL201",
            ciqCode: "608201"
        },
        {
            codeName: "坦多哥（菲律宾）",
            cusCode: "1454",
            codeValue: "PHL204",
            gbName: "坦多哥（菲律宾）",
            gbCode: "PHL204",
            ciqCode: "608204"
        },
        {
            codeName: "托莱多（菲律宾）",
            cusCode: "129",
            codeValue: "PHL207",
            gbName: "托莱多（菲律宾）",
            gbCode: "PHL207",
            ciqCode: "608207"
        },
        {
            codeName: "维拉努埃瓦（菲律宾）",
            cusCode: "129",
            codeValue: "PHL210",
            gbName: "维拉努埃瓦（菲律宾）",
            gbCode: "PHL210",
            ciqCode: "608210"
        },
        {
            codeName: "三宝颜（菲律宾）",
            cusCode: "1457",
            codeValue: "PHL213",
            gbName: "三宝颜（菲律宾）",
            gbCode: "PHL213",
            ciqCode: "608213"
        },
        {
            codeName: "奎松城（菲律宾）",
            cusCode: "1448",
            codeValue: "PHL216",
            gbName: "奎松城（菲律宾）",
            gbCode: "PHL216",
            ciqCode: "608216"
        },
        {
            codeName: "民多罗岛（菲律宾）",
            cusCode: "129",
            codeValue: "PHL219",
            gbName: "民多罗岛（菲律宾）",
            gbCode: "PHL219",
            ciqCode: "608219"
        },
        {
            codeName: "吕宋岛（菲律宾）",
            cusCode: "1440",
            codeValue: "PHL910",
            gbName: "吕宋岛（菲律宾）",
            gbCode: "PHL910",
            ciqCode: "608910"
        },
        {
            codeName: "帕劳",
            cusCode: "622",
            codeValue: "PLW000",
            gbName: "帕劳",
            gbCode: "PLW000",
            ciqCode: "585000"
        },
        {
            codeName: "科罗尔（帕劳）",
            cusCode: "3390",
            codeValue: "PLW003",
            gbName: "科罗尔（帕劳）",
            gbCode: "PLW003",
            ciqCode: "585003"
        },
        {
            codeName: "帕劳群岛（帕劳）",
            cusCode: "3399",
            codeValue: "PLW004",
            gbName: "帕劳群岛（帕劳）",
            gbCode: "PLW004",
            ciqCode: "585004"
        },
        {
            codeName: "巴布亚新几内亚",
            cusCode: "611",
            codeValue: "PNG000",
            gbName: "巴布亚新几内亚",
            gbCode: "PNG000",
            ciqCode: "598000"
        },
        {
            codeName: "布干维尔岛（巴布亚新几内亚）",
            cusCode: "3324",
            codeValue: "PNG001",
            gbName: "布干维尔岛（巴布亚新几内亚）",
            gbCode: "PNG001",
            ciqCode: "598001"
        },
        {
            codeName: "新爱尔兰（巴布亚新几内亚）",
            cusCode: "3325",
            codeValue: "PNG002",
            gbName: "新爱尔兰（巴布亚新几内亚）",
            gbCode: "PNG002",
            ciqCode: "598002"
        },
        {
            codeName: "艾塔佩（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG003",
            gbName: "艾塔佩（巴布亚新几内亚）",
            gbCode: "PNG003",
            ciqCode: "598003"
        },
        {
            codeName: "阿洛陶（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG006",
            gbName: "阿洛陶（巴布亚新几内亚）",
            gbCode: "PNG006",
            ciqCode: "598006"
        },
        {
            codeName: "阿内瓦湾（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG009",
            gbName: "阿内瓦湾（巴布亚新几内亚）",
            gbCode: "PNG009",
            ciqCode: "598009"
        },
        {
            codeName: "布卡（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG012",
            gbName: "布卡（巴布亚新几内亚）",
            gbCode: "PNG012",
            ciqCode: "598012"
        },
        {
            codeName: "布纳（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG015",
            gbName: "布纳（巴布亚新几内亚）",
            gbCode: "PNG015",
            ciqCode: "598015"
        },
        {
            codeName: "霍斯金斯角（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG018",
            gbName: "霍斯金斯角（巴布亚新几内亚）",
            gbCode: "PNG018",
            ciqCode: "598018"
        },
        {
            codeName: "达鲁（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG021",
            gbName: "达鲁（巴布亚新几内亚）",
            gbCode: "PNG021",
            ciqCode: "598021"
        },
        {
            codeName: "芬什哈芬（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG024",
            gbName: "芬什哈芬（巴布亚新几内亚）",
            gbCode: "PNG024",
            ciqCode: "598024"
        },
        {
            codeName: "加斯马塔岛（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG027",
            gbName: "加斯马塔岛（巴布亚新几内亚）",
            gbCode: "PNG027",
            ciqCode: "598027"
        },
        {
            codeName: "卡维恩（巴布亚新几内亚）",
            cusCode: "3327",
            codeValue: "PNG030",
            gbName: "卡维恩（巴布亚新几内亚）",
            gbCode: "PNG030",
            ciqCode: "598030"
        },
        {
            codeName: "基埃塔（巴布亚新几内亚）",
            cusCode: "3328",
            codeValue: "PNG033",
            gbName: "基埃塔（巴布亚新几内亚）",
            gbCode: "PNG033",
            ciqCode: "598033"
        },
        {
            codeName: "金贝（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG036",
            gbName: "金贝（巴布亚新几内亚）",
            gbCode: "PNG036",
            ciqCode: "598036"
        },
        {
            codeName: "莱城（巴布亚新几内亚）",
            cusCode: "3329",
            codeValue: "PNG039",
            gbName: "莱城（巴布亚新几内亚）",
            gbCode: "PNG039",
            ciqCode: "598039"
        },
        {
            codeName: "洛伦高（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG042",
            gbName: "洛伦高（巴布亚新几内亚）",
            gbCode: "PNG042",
            ciqCode: "598042"
        },
        {
            codeName: "马当（巴布亚新几内亚）",
            cusCode: "3330",
            codeValue: "PNG045",
            gbName: "马当（巴布亚新几内亚）",
            gbCode: "PNG045",
            ciqCode: "598045"
        },
        {
            codeName: "莫罗贝（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG048",
            gbName: "莫罗贝（巴布亚新几内亚）",
            gbCode: "PNG048",
            ciqCode: "598048"
        },
        {
            codeName: "奥鲁湾（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG051",
            gbName: "奥鲁湾（巴布亚新几内亚）",
            gbCode: "PNG051",
            ciqCode: "598051"
        },
        {
            codeName: "莫尔兹比港（巴布亚新几内亚）",
            cusCode: "3331",
            codeValue: "PNG054",
            gbName: "莫尔兹比港（巴布亚新几内亚）",
            gbCode: "PNG054",
            ciqCode: "598054"
        },
        {
            codeName: "拉包尔（巴布亚新几内亚）",
            cusCode: "3326",
            codeValue: "PNG057",
            gbName: "拉包尔（巴布亚新几内亚）",
            gbCode: "PNG057",
            ciqCode: "598057"
        },
        {
            codeName: "萨拉毛亚（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG060",
            gbName: "萨拉毛亚（巴布亚新几内亚）",
            gbCode: "PNG060",
            ciqCode: "598060"
        },
        {
            codeName: "萨马赖（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG063",
            gbName: "萨马赖（巴布亚新几内亚）",
            gbCode: "PNG063",
            ciqCode: "598063"
        },
        {
            codeName: "威瓦克（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG066",
            gbName: "威瓦克（巴布亚新几内亚）",
            gbCode: "PNG066",
            ciqCode: "598066"
        },
        {
            codeName: "伍德拉克岛（巴布亚新几内亚）",
            cusCode: "611",
            codeValue: "PNG069",
            gbName: "伍德拉克岛（巴布亚新几内亚）",
            gbCode: "PNG069",
            ciqCode: "598069"
        },
        {
            codeName: "波兰",
            cusCode: "327",
            codeValue: "POL000",
            gbName: "波兰",
            gbCode: "POL000",
            ciqCode: "616000"
        },
        {
            codeName: "达尔沃沃（波兰）",
            cusCode: "2532",
            codeValue: "POL003",
            gbName: "达尔沃沃（波兰）",
            gbCode: "POL003",
            ciqCode: "616003"
        },
        {
            codeName: "格但斯克（波兰）",
            cusCode: "4033",
            codeValue: "POL006",
            gbName: "格但斯克（波兰）",
            gbCode: "POL006",
            ciqCode: "616006"
        },
        {
            codeName: "格丁尼亚（波兰）",
            cusCode: "2533",
            codeValue: "POL009",
            gbName: "格丁尼亚（波兰）",
            gbCode: "POL009",
            ciqCode: "616009"
        },
        {
            codeName: "海尔（波兰）",
            cusCode: "327",
            codeValue: "POL012",
            gbName: "海尔（波兰）",
            gbCode: "POL012",
            ciqCode: "616012"
        },
        {
            codeName: "科沃布热格（波兰）",
            cusCode: "2534",
            codeValue: "POL015",
            gbName: "科沃布热格（波兰）",
            gbCode: "POL015",
            ciqCode: "616015"
        },
        {
            codeName: "希维诺乌伊希切（波兰）",
            cusCode: "2535",
            codeValue: "POL018",
            gbName: "希维诺乌伊希切（波兰）",
            gbCode: "POL018",
            ciqCode: "616018"
        },
        {
            codeName: "什切青（波兰）",
            cusCode: "2536",
            codeValue: "POL021",
            gbName: "什切青（波兰）",
            gbCode: "POL021",
            ciqCode: "616021"
        },
        {
            codeName: "乌斯特卡（波兰）",
            cusCode: "2537",
            codeValue: "POL024",
            gbName: "乌斯特卡（波兰）",
            gbCode: "POL024",
            ciqCode: "616024"
        },
        {
            codeName: "弗瓦迪斯瓦沃沃（波兰）",
            cusCode: "2538",
            codeValue: "POL027",
            gbName: "弗瓦迪斯瓦沃沃（波兰）",
            gbCode: "POL027",
            ciqCode: "616027"
        },
        {
            codeName: "波多黎各",
            cusCode: "435",
            codeValue: "PRI000",
            gbName: "波多黎各",
            gbCode: "PRI000",
            ciqCode: "630000"
        },
        {
            codeName: "阿瓜迪亚（波多黎各）",
            cusCode: "2925",
            codeValue: "PRI003",
            gbName: "阿瓜迪亚（波多黎各）",
            gbCode: "PRI003",
            ciqCode: "630003"
        },
        {
            codeName: "阿雷西沃（波多黎各）",
            cusCode: "2926",
            codeValue: "PRI006",
            gbName: "阿雷西沃（波多黎各）",
            gbCode: "PRI006",
            ciqCode: "630006"
        },
        {
            codeName: "法哈多（波多黎各）",
            cusCode: "435",
            codeValue: "PRI009",
            gbName: "法哈多（波多黎各）",
            gbCode: "PRI009",
            ciqCode: "630009"
        },
        {
            codeName: "瓜尼卡（波多黎各）",
            cusCode: "435",
            codeValue: "PRI012",
            gbName: "瓜尼卡（波多黎各）",
            gbCode: "PRI012",
            ciqCode: "630012"
        },
        {
            codeName: "拉斯马雷亚斯（波多黎各）",
            cusCode: "435",
            codeValue: "PRI015",
            gbName: "拉斯马雷亚斯（波多黎各）",
            gbCode: "PRI015",
            ciqCode: "630015"
        },
        {
            codeName: "瓜亚尼亚（波多黎各）",
            cusCode: "435",
            codeValue: "PRI018",
            gbName: "瓜亚尼亚（波多黎各）",
            gbCode: "PRI018",
            ciqCode: "630018"
        },
        {
            codeName: "乔布斯（波多黎各）",
            cusCode: "2930",
            codeValue: "PRI021",
            gbName: "乔布斯（波多黎各）",
            gbCode: "PRI021",
            ciqCode: "630021"
        },
        {
            codeName: "马亚圭斯（波多黎各）",
            cusCode: "2927",
            codeValue: "PRI024",
            gbName: "马亚圭斯（波多黎各）",
            gbCode: "PRI024",
            ciqCode: "630024"
        },
        {
            codeName: "蓬塞（波多黎各）",
            cusCode: "2928",
            codeValue: "PRI027",
            gbName: "蓬塞（波多黎各）",
            gbCode: "PRI027",
            ciqCode: "630027"
        },
        {
            codeName: "圣胡安（波多黎各）",
            cusCode: "3418",
            codeValue: "PRI030",
            gbName: "圣胡安（波多黎各）",
            gbCode: "PRI030",
            ciqCode: "630030"
        },
        {
            codeName: "亚武科阿（波多黎各）",
            cusCode: "435",
            codeValue: "PRI033",
            gbName: "亚武科阿（波多黎各）",
            gbCode: "PRI033",
            ciqCode: "630033"
        },
        {
            codeName: "托斯马雷阿斯港（波多黎各）",
            cusCode: "2931",
            codeValue: "PRI034",
            gbName: "托斯马雷阿斯港（波多黎各）",
            gbCode: "PRI034",
            ciqCode: "630034"
        },
        {
            codeName: "亚布夸港（波多黎各）",
            cusCode: "2929",
            codeValue: "PRI035",
            gbName: "亚布夸港（波多黎各）",
            gbCode: "PRI035",
            ciqCode: "630035"
        },
        {
            codeName: "朝鲜",
            cusCode: "109",
            codeValue: "PRK000",
            gbName: "朝鲜",
            gbCode: "PRK000",
            ciqCode: "408000"
        },
        {
            codeName: "镇南浦（朝鲜）",
            cusCode: "109",
            codeValue: "PRK003",
            gbName: "镇南浦（朝鲜）",
            gbCode: "PRK003",
            ciqCode: "408003"
        },
        {
            codeName: "清津（朝鲜）",
            cusCode: "1035",
            codeValue: "PRK006",
            gbName: "清津（朝鲜）",
            gbCode: "PRK006",
            ciqCode: "408006"
        },
        {
            codeName: "海州（朝鲜）",
            cusCode: "1030",
            codeValue: "PRK009",
            gbName: "海州（朝鲜）",
            gbCode: "PRK009",
            ciqCode: "408009"
        },
        {
            codeName: "兴南（朝鲜）",
            cusCode: "1031",
            codeValue: "PRK012",
            gbName: "兴南（朝鲜）",
            gbCode: "PRK012",
            ciqCode: "408012"
        },
        {
            codeName: "罗津（朝鲜）",
            cusCode: "109",
            codeValue: "PRK015",
            gbName: "罗津（朝鲜）",
            gbCode: "PRK015",
            ciqCode: "408015"
        },
        {
            codeName: "松林（朝鲜）",
            cusCode: "109",
            codeValue: "PRK018",
            gbName: "松林（朝鲜）",
            gbCode: "PRK018",
            ciqCode: "408018"
        },
        {
            codeName: "元山（朝鲜）",
            cusCode: "1038",
            codeValue: "PRK021",
            gbName: "元山（朝鲜）",
            gbCode: "PRK021",
            ciqCode: "408021"
        },
        {
            codeName: "新浦（朝鲜）",
            cusCode: "109",
            codeValue: "PRK024",
            gbName: "新浦（朝鲜）",
            gbCode: "PRK024",
            ciqCode: "408024"
        },
        {
            codeName: "开城（朝鲜）",
            cusCode: "1032",
            codeValue: "PRK030",
            gbName: "开城（朝鲜）",
            gbCode: "PRK030",
            ciqCode: "408030"
        },
        {
            codeName: "平壤（朝鲜）",
            cusCode: "109",
            codeValue: "PRK901",
            gbName: "平壤（朝鲜）",
            gbCode: "PRK901",
            ciqCode: "408901"
        },
        {
            codeName: "普通江（朝鲜）",
            cusCode: "109",
            codeValue: "PRK902",
            gbName: "普通江（朝鲜）",
            gbCode: "PRK902",
            ciqCode: "408902"
        },
        {
            codeName: "新义州（朝鲜）",
            cusCode: "1037",
            codeValue: "PRK903",
            gbName: "新义州（朝鲜）",
            gbCode: "PRK903",
            ciqCode: "408903"
        },
        {
            codeName: "西浦（朝鲜）",
            cusCode: "109",
            codeValue: "PRK904",
            gbName: "西浦（朝鲜）",
            gbCode: "PRK904",
            ciqCode: "408904"
        },
        {
            codeName: "南浦（朝鲜）",
            cusCode: "1033",
            codeValue: "PRK905",
            gbName: "南浦（朝鲜）",
            gbCode: "PRK905",
            ciqCode: "408905"
        },
        {
            codeName: "会宁（朝鲜）",
            cusCode: "109",
            codeValue: "PRK906",
            gbName: "会宁（朝鲜）",
            gbCode: "PRK906",
            ciqCode: "408906"
        },
        {
            codeName: "七星里（朝鲜）",
            cusCode: "109",
            codeValue: "PRK907",
            gbName: "七星里（朝鲜）",
            gbCode: "PRK907",
            ciqCode: "408907"
        },
        {
            codeName: "赛别尔（朝鲜）",
            cusCode: "109",
            codeValue: "PRK908",
            gbName: "赛别尔（朝鲜）",
            gbCode: "PRK908",
            ciqCode: "408908"
        },
        {
            codeName: "沅丁（朝鲜）",
            cusCode: "109",
            codeValue: "PRK909",
            gbName: "沅丁（朝鲜）",
            gbCode: "PRK909",
            ciqCode: "408909"
        },
        {
            codeName: "南阳（朝鲜）",
            cusCode: "109",
            codeValue: "PRK910",
            gbName: "南阳（朝鲜）",
            gbCode: "PRK910",
            ciqCode: "408910"
        },
        {
            codeName: "山峰（朝鲜）",
            cusCode: "109",
            codeValue: "PRK911",
            gbName: "山峰（朝鲜）",
            gbCode: "PRK911",
            ciqCode: "408911"
        },
        {
            codeName: "三长（朝鲜）",
            cusCode: "109",
            codeValue: "PRK912",
            gbName: "三长（朝鲜）",
            gbCode: "PRK912",
            ciqCode: "408912"
        },
        {
            codeName: "满浦（朝鲜）",
            cusCode: "109",
            codeValue: "PRK913",
            gbName: "满浦（朝鲜）",
            gbCode: "PRK913",
            ciqCode: "408913"
        },
        {
            codeName: "渭源（朝鲜）",
            cusCode: "109",
            codeValue: "PRK914",
            gbName: "渭源（朝鲜）",
            gbCode: "PRK914",
            ciqCode: "408914"
        },
        {
            codeName: "中江（朝鲜）",
            cusCode: "109",
            codeValue: "PRK915",
            gbName: "中江（朝鲜）",
            gbCode: "PRK915",
            ciqCode: "408915"
        },
        {
            codeName: "惠山（朝鲜）",
            cusCode: "109",
            codeValue: "PRK916",
            gbName: "惠山（朝鲜）",
            gbCode: "PRK916",
            ciqCode: "408916"
        },
        {
            codeName: "葡萄牙",
            cusCode: "311",
            codeValue: "PRT000",
            gbName: "葡萄牙",
            gbCode: "PRT000",
            ciqCode: "620000"
        },
        {
            codeName: "阿威罗（葡萄牙）",
            cusCode: "2354",
            codeValue: "PRT003",
            gbName: "阿威罗（葡萄牙）",
            gbCode: "PRT003",
            ciqCode: "620003"
        },
        {
            codeName: "BANATICA（葡萄牙）",
            cusCode: "2355",
            codeValue: "PRT004",
            gbName: "BANATICA（葡萄牙）",
            gbCode: "PRT004",
            ciqCode: "620004"
        },
        {
            codeName: "巴雷鲁（葡萄牙）",
            cusCode: "311",
            codeValue: "PRT006",
            gbName: "巴雷鲁（葡萄牙）",
            gbCode: "PRT006",
            ciqCode: "620006"
        },
        {
            codeName: "贝伦（葡萄牙）",
            cusCode: "311",
            codeValue: "PRT009",
            gbName: "贝伦（葡萄牙）",
            gbCode: "PRT009",
            ciqCode: "620009"
        },
        {
            codeName: "法鲁（葡萄牙）",
            cusCode: "2356",
            codeValue: "PRT012",
            gbName: "法鲁（葡萄牙）",
            gbCode: "PRT012",
            ciqCode: "620012"
        },
        {
            codeName: "圣安东尼奥城（葡萄牙）",
            cusCode: "2367",
            codeValue: "PRT013",
            gbName: "圣安东尼奥城（葡萄牙）",
            gbCode: "PRT013",
            ciqCode: "620013"
        },
        {
            codeName: "英雄港（葡萄牙）",
            cusCode: "311",
            codeValue: "PRT014",
            gbName: "英雄港（葡萄牙）",
            gbCode: "PRT014",
            ciqCode: "620014"
        },
        {
            codeName: "菲盖拉（葡萄牙）",
            cusCode: "2357",
            codeValue: "PRT015",
            gbName: "菲盖拉（葡萄牙）",
            gbCode: "PRT015",
            ciqCode: "620015"
        },
        {
            codeName: "丰沙尔（葡萄牙）",
            cusCode: "311",
            codeValue: "PRT016",
            gbName: "丰沙尔（葡萄牙）",
            gbCode: "PRT016",
            ciqCode: "620016"
        },
        {
            codeName: "奥尔塔（葡萄牙）",
            cusCode: "311",
            codeValue: "PRT017",
            gbName: "奥尔塔（葡萄牙）",
            gbCode: "PRT017",
            ciqCode: "620017"
        },
        {
            codeName: "雷克索斯（葡萄牙）",
            cusCode: "2358",
            codeValue: "PRT018",
            gbName: "雷克索斯（葡萄牙）",
            gbCode: "PRT018",
            ciqCode: "620018"
        },
        {
            codeName: "里斯本（葡萄牙）",
            cusCode: "2359",
            codeValue: "PRT021",
            gbName: "里斯本（葡萄牙）",
            gbCode: "PRT021",
            ciqCode: "620021"
        },
        {
            codeName: "奥良（葡萄牙）",
            cusCode: "2360",
            codeValue: "PRT024",
            gbName: "奥良（葡萄牙）",
            gbCode: "PRT024",
            ciqCode: "620024"
        },
        {
            codeName: "波尔图（葡萄牙）",
            cusCode: "2361",
            codeValue: "PRT027",
            gbName: "波尔图（葡萄牙）",
            gbCode: "PRT027",
            ciqCode: "620027"
        },
        {
            codeName: "波马朗（葡萄牙）",
            cusCode: "2362",
            codeValue: "PRT030",
            gbName: "波马朗（葡萄牙）",
            gbCode: "PRT030",
            ciqCode: "620030"
        },
        {
            codeName: "蓬塔德尔加达港（葡萄牙）",
            cusCode: "1786",
            codeValue: "PRT032",
            gbName: "蓬塔德尔加达港（葡萄牙）",
            gbCode: "PRT032",
            ciqCode: "620032"
        },
        {
            codeName: "波尔蒂芒（葡萄牙）",
            cusCode: "2363",
            codeValue: "PRT033",
            gbName: "波尔蒂芒（葡萄牙）",
            gbCode: "PRT033",
            ciqCode: "620033"
        },
        {
            codeName: "塞图巴尔（葡萄牙）",
            cusCode: "2364",
            codeValue: "PRT036",
            gbName: "塞图巴尔（葡萄牙）",
            gbCode: "PRT036",
            ciqCode: "620036"
        },
        {
            codeName: "锡尼什（葡萄牙）",
            cusCode: "2365",
            codeValue: "PRT039",
            gbName: "锡尼什（葡萄牙）",
            gbCode: "PRT039",
            ciqCode: "620039"
        },
        {
            codeName: "维亚纳堡（葡萄牙）",
            cusCode: "2366",
            codeValue: "PRT042",
            gbName: "维亚纳堡（葡萄牙）",
            gbCode: "PRT042",
            ciqCode: "620042"
        },
        {
            codeName: "雷阿尔城（葡萄牙）",
            cusCode: "311",
            codeValue: "PRT045",
            gbName: "雷阿尔城（葡萄牙）",
            gbCode: "PRT045",
            ciqCode: "620045"
        },
        {
            codeName: "巴拉圭",
            cusCode: "433",
            codeValue: "PRY000",
            gbName: "巴拉圭",
            gbCode: "PRY000",
            ciqCode: "600000"
        },
        {
            codeName: "亚松森（巴拉圭）",
            cusCode: "433",
            codeValue: "PRY003",
            gbName: "亚松森（巴拉圭）",
            gbCode: "PRY003",
            ciqCode: "600003"
        },
        {
            codeName: "巴勒斯坦",
            cusCode: "128",
            codeValue: "PSE000",
            gbName: "巴勒斯坦",
            gbCode: "PSE000",
            ciqCode: "275000"
        },
        {
            codeName: "阿什杜德（巴勒斯坦）",
            cusCode: "1421",
            codeValue: "PSE003",
            gbName: "阿什杜德（巴勒斯坦）",
            gbCode: "PSE003",
            ciqCode: "275003"
        },
        {
            codeName: "埃拉特（巴勒斯坦）",
            cusCode: "3451",
            codeValue: "PSE006",
            gbName: "埃拉特（巴勒斯坦）",
            gbCode: "PSE006",
            ciqCode: "275006"
        },
        {
            codeName: "利达（巴勒斯坦）",
            cusCode: "1420",
            codeValue: "PSE008",
            gbName: "利达（巴勒斯坦）",
            gbCode: "PSE008",
            ciqCode: "275008"
        },
        {
            codeName: "耶路撒冷（巴勒斯坦）",
            cusCode: "1419",
            codeValue: "PSE010",
            gbName: "耶路撒冷（巴勒斯坦）",
            gbCode: "PSE010",
            ciqCode: "275010"
        },
        {
            codeName: "法属波利尼西亚",
            cusCode: "623",
            codeValue: "PYF000",
            gbName: "法属波利尼西亚",
            gbCode: "PYF000",
            ciqCode: "258000"
        },
        {
            codeName: "豪岛（法属波利尼西亚）",
            cusCode: "623",
            codeValue: "PYF003",
            gbName: "豪岛（法属波利尼西亚）",
            gbCode: "PYF003",
            ciqCode: "258003"
        },
        {
            codeName: "麦卡梯（法属波利尼西亚）",
            cusCode: "623",
            codeValue: "PYF006",
            gbName: "麦卡梯（法属波利尼西亚）",
            gbCode: "PYF006",
            ciqCode: "258006"
        },
        {
            codeName: "穆鲁路（法属波利尼西亚）",
            cusCode: "623",
            codeValue: "PYF009",
            gbName: "穆鲁路（法属波利尼西亚）",
            gbCode: "PYF009",
            ciqCode: "258009"
        },
        {
            codeName: "波拉波拉（法属波利尼西亚）",
            cusCode: "623",
            codeValue: "PYF011",
            gbName: "波拉波拉（法属波利尼西亚）",
            gbCode: "PYF011",
            ciqCode: "258011"
        },
        {
            codeName: "帕皮提（法属波利尼西亚）",
            cusCode: "3332",
            codeValue: "PYF012",
            gbName: "帕皮提（法属波利尼西亚）",
            gbCode: "PYF012",
            ciqCode: "258012"
        },
        {
            codeName: "韦他佩（法属波利尼西亚）",
            cusCode: "623",
            codeValue: "PYF015",
            gbName: "韦他佩（法属波利尼西亚）",
            gbCode: "PYF015",
            ciqCode: "258015"
        },
        {
            codeName: "马克萨斯群岛（法属波利尼西亚）",
            cusCode: "3285",
            codeValue: "PYF016",
            gbName: "马克萨斯群岛（法属波利尼西亚）",
            gbCode: "PYF016",
            ciqCode: "258016"
        },
        {
            codeName: "塔希提岛（法属波利尼西亚）",
            cusCode: "3333",
            codeValue: "PYF017",
            gbName: "塔希提岛（法属波利尼西亚）",
            gbCode: "PYF017",
            ciqCode: "258017"
        },
        {
            codeName: "土阿莫土群岛（法属波利尼西亚）",
            cusCode: "3346",
            codeValue: "PYF018",
            gbName: "土阿莫土群岛（法属波利尼西亚）",
            gbCode: "PYF018",
            ciqCode: "258018"
        },
        {
            codeName: "土布艾群岛（法属波利尼西亚）",
            cusCode: "3347",
            codeValue: "PYF019",
            gbName: "土布艾群岛（法属波利尼西亚）",
            gbCode: "PYF019",
            ciqCode: "258019"
        },
        {
            codeName: "卡塔尔",
            cusCode: "130",
            codeValue: "QAT000",
            gbName: "卡塔尔",
            gbCode: "QAT000",
            ciqCode: "634000"
        },
        {
            codeName: "多哈（卡塔尔）",
            cusCode: "1458",
            codeValue: "QAT003",
            gbName: "多哈（卡塔尔）",
            gbCode: "QAT003",
            ciqCode: "634003"
        },
        {
            codeName: "哈卢勒岛（卡塔尔）",
            cusCode: "130",
            codeValue: "QAT006",
            gbName: "哈卢勒岛（卡塔尔）",
            gbCode: "QAT006",
            ciqCode: "634006"
        },
        {
            codeName: "乌姆赛义德（卡塔尔）",
            cusCode: "1459",
            codeValue: "QAT009",
            gbName: "乌姆赛义德（卡塔尔）",
            gbCode: "QAT009",
            ciqCode: "634009"
        },
        {
            codeName: "留尼汪",
            cusCode: "237",
            codeValue: "REU000",
            gbName: "留尼汪",
            gbCode: "REU000",
            ciqCode: "638000"
        },
        {
            codeName: "勒波尔（留尼汪）",
            cusCode: "237",
            codeValue: "REU002",
            gbName: "勒波尔（留尼汪）",
            gbCode: "REU002",
            ciqCode: "638002"
        },
        {
            codeName: "加勒茨角港（留尼汪）",
            cusCode: "1735",
            codeValue: "REU003",
            gbName: "加勒茨角港（留尼汪）",
            gbCode: "REU003",
            ciqCode: "638003"
        },
        {
            codeName: "圣但尼（留尼汪）",
            cusCode: "1734",
            codeValue: "REU006",
            gbName: "圣但尼（留尼汪）",
            gbCode: "REU006",
            ciqCode: "638006"
        },
        {
            codeName: "圣路易（留尼汪）",
            cusCode: "237",
            codeValue: "REU009",
            gbName: "圣路易（留尼汪）",
            gbCode: "REU009",
            ciqCode: "638009"
        },
        {
            codeName: "罗马尼亚",
            cusCode: "328",
            codeValue: "ROU000",
            gbName: "罗马尼亚",
            gbCode: "ROU000",
            ciqCode: "642000"
        },
        {
            codeName: "布勒伊拉（罗马尼亚）",
            cusCode: "2539",
            codeValue: "ROU003",
            gbName: "布勒伊拉（罗马尼亚）",
            gbCode: "ROU003",
            ciqCode: "642003"
        },
        {
            codeName: "康斯坦察（罗马尼亚）",
            cusCode: "2541",
            codeValue: "ROU006",
            gbName: "康斯坦察（罗马尼亚）",
            gbCode: "ROU006",
            ciqCode: "642006"
        },
        {
            codeName: "加拉茨（罗马尼亚）",
            cusCode: "2542",
            codeValue: "ROU009",
            gbName: "加拉茨（罗马尼亚）",
            gbCode: "ROU009",
            ciqCode: "642009"
        },
        {
            codeName: "曼加利亚（罗马尼亚）",
            cusCode: "328",
            codeValue: "ROU012",
            gbName: "曼加利亚（罗马尼亚）",
            gbCode: "ROU012",
            ciqCode: "642012"
        },
        {
            codeName: "苏利纳（罗马尼亚）",
            cusCode: "2543",
            codeValue: "ROU015",
            gbName: "苏利纳（罗马尼亚）",
            gbCode: "ROU015",
            ciqCode: "642015"
        },
        {
            codeName: "图耳恰（罗马尼亚）",
            cusCode: "328",
            codeValue: "ROU018",
            gbName: "图耳恰（罗马尼亚）",
            gbCode: "ROU018",
            ciqCode: "642018"
        },
        {
            codeName: "布加勒斯特（罗马尼亚）",
            cusCode: "2540",
            codeValue: "ROU901",
            gbName: "布加勒斯特（罗马尼亚）",
            gbCode: "ROU901",
            ciqCode: "642901"
        },
        {
            codeName: "俄罗斯",
            cusCode: "344",
            codeValue: "RUS000",
            gbName: "俄罗斯",
            gbCode: "RUS000",
            ciqCode: "643000"
        },
        {
            codeName: "亚历山大罗夫斯克（俄罗斯）",
            cusCode: "3422",
            codeValue: "RUS003",
            gbName: "亚历山大罗夫斯克（俄罗斯）",
            gbCode: "RUS003",
            ciqCode: "643003"
        },
        {
            codeName: "阿纳德尔（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS004",
            gbName: "阿纳德尔（俄罗斯）",
            gbCode: "RUS004",
            ciqCode: "643004"
        },
        {
            codeName: "阿尔汉格尔斯克（俄罗斯）",
            cusCode: "2641",
            codeValue: "RUS006",
            gbName: "阿尔汉格尔斯克（俄罗斯）",
            gbCode: "RUS006",
            ciqCode: "643006"
        },
        {
            codeName: "德卡斯特莱（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS009",
            gbName: "德卡斯特莱（俄罗斯）",
            gbCode: "RUS009",
            ciqCode: "643009"
        },
        {
            codeName: "加里宁格勒（俄罗斯）",
            cusCode: "2647",
            codeValue: "RUS012",
            gbName: "加里宁格勒（俄罗斯）",
            gbCode: "RUS012",
            ciqCode: "643012"
        },
        {
            codeName: "克烈季（俄罗斯）",
            cusCode: "2649",
            codeValue: "RUS015",
            gbName: "克烈季（俄罗斯）",
            gbCode: "RUS015",
            ciqCode: "643015"
        },
        {
            codeName: "霍尔姆斯克（俄罗斯）",
            cusCode: "2651",
            codeValue: "RUS018",
            gbName: "霍尔姆斯克（俄罗斯）",
            gbCode: "RUS018",
            ciqCode: "643018"
        },
        {
            codeName: "科尔萨科夫（俄罗斯）",
            cusCode: "3423",
            codeValue: "RUS021",
            gbName: "科尔萨科夫（俄罗斯）",
            gbCode: "RUS021",
            ciqCode: "643021"
        },
        {
            codeName: "拉扎烈夫（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS024",
            gbName: "拉扎烈夫（俄罗斯）",
            gbCode: "RUS024",
            ciqCode: "643024"
        },
        {
            codeName: "马加丹（俄罗斯）",
            cusCode: "3424",
            codeValue: "RUS027",
            gbName: "马加丹（俄罗斯）",
            gbCode: "RUS027",
            ciqCode: "643027"
        },
        {
            codeName: "马戈（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS030",
            gbName: "马戈（俄罗斯）",
            gbCode: "RUS030",
            ciqCode: "643030"
        },
        {
            codeName: "马卡洛夫（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS033",
            gbName: "马卡洛夫（俄罗斯）",
            gbCode: "RUS033",
            ciqCode: "643033"
        },
        {
            codeName: "美晋（俄罗斯）",
            cusCode: "2655",
            codeValue: "RUS036",
            gbName: "美晋（俄罗斯）",
            gbCode: "RUS036",
            ciqCode: "643036"
        },
        {
            codeName: "摩尔曼斯克（俄罗斯）",
            cusCode: "2656",
            codeValue: "RUS039",
            gbName: "摩尔曼斯克（俄罗斯）",
            gbCode: "RUS039",
            ciqCode: "643039"
        },
        {
            codeName: "纳霍德卡（俄罗斯）",
            cusCode: "2657",
            codeValue: "RUS042",
            gbName: "纳霍德卡（俄罗斯）",
            gbCode: "RUS042",
            ciqCode: "643042"
        },
        {
            codeName: "纳里扬马尔（俄罗斯）",
            cusCode: "3431",
            codeValue: "RUS045",
            gbName: "纳里扬马尔（俄罗斯）",
            gbCode: "RUS045",
            ciqCode: "643045"
        },
        {
            codeName: "涅韦尔斯克（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS048",
            gbName: "涅韦尔斯克（俄罗斯）",
            gbCode: "RUS048",
            ciqCode: "643048"
        },
        {
            codeName: "尼古拉耶夫（俄罗斯）",
            cusCode: "3430",
            codeValue: "RUS051",
            gbName: "尼古拉耶夫（俄罗斯）",
            gbCode: "RUS051",
            ciqCode: "643051"
        },
        {
            codeName: "新罗西斯克（俄罗斯）",
            cusCode: "2658",
            codeValue: "RUS054",
            gbName: "新罗西斯克（俄罗斯）",
            gbCode: "RUS054",
            ciqCode: "643054"
        },
        {
            codeName: "奥哈（俄罗斯）",
            cusCode: "3425",
            codeValue: "RUS057",
            gbName: "奥哈（俄罗斯）",
            gbCode: "RUS057",
            ciqCode: "643057"
        },
        {
            codeName: "鄂霍次克（俄罗斯）",
            cusCode: "3426",
            codeValue: "RUS060",
            gbName: "鄂霍次克（俄罗斯）",
            gbCode: "RUS060",
            ciqCode: "643060"
        },
        {
            codeName: "十月市（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS063",
            gbName: "十月市（俄罗斯）",
            gbCode: "RUS063",
            ciqCode: "643063"
        },
        {
            codeName: "奥涅加（俄罗斯）",
            cusCode: "2660",
            codeValue: "RUS066",
            gbName: "奥涅加（俄罗斯）",
            gbCode: "RUS066",
            ciqCode: "643066"
        },
        {
            codeName: "彼得罗巴甫洛夫斯克（俄罗斯）",
            cusCode: "2661",
            codeValue: "RUS069",
            gbName: "彼得罗巴甫洛夫斯克（俄罗斯）",
            gbCode: "RUS069",
            ciqCode: "643069"
        },
        {
            codeName: "波罗奈斯克（俄罗斯）",
            cusCode: "3428",
            codeValue: "RUS072",
            gbName: "波罗奈斯克（俄罗斯）",
            gbCode: "RUS072",
            ciqCode: "643072"
        },
        {
            codeName: "普里莫尔斯克（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS075",
            gbName: "普里莫尔斯克（俄罗斯）",
            gbCode: "RUS075",
            ciqCode: "643075"
        },
        {
            codeName: "罗斯托夫（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS078",
            gbName: "罗斯托夫（俄罗斯）",
            gbCode: "RUS078",
            ciqCode: "643078"
        },
        {
            codeName: "沙赫乔特斯克（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS081",
            gbName: "沙赫乔特斯克（俄罗斯）",
            gbCode: "RUS081",
            ciqCode: "643081"
        },
        {
            codeName: "索契（俄罗斯）",
            cusCode: "2666",
            codeValue: "RUS084",
            gbName: "索契（俄罗斯）",
            gbCode: "RUS084",
            ciqCode: "643084"
        },
        {
            codeName: "苏维埃港（俄罗斯）",
            cusCode: "3429",
            codeValue: "RUS087",
            gbName: "苏维埃港（俄罗斯）",
            gbCode: "RUS087",
            ciqCode: "643087"
        },
        {
            codeName: "圣彼得堡（俄罗斯）",
            cusCode: "2654",
            codeValue: "RUS090",
            gbName: "圣彼得堡（俄罗斯）",
            gbCode: "RUS090",
            ciqCode: "643090"
        },
        {
            codeName: "斯伟特拉亚河（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS093",
            gbName: "斯伟特拉亚河（俄罗斯）",
            gbCode: "RUS093",
            ciqCode: "643093"
        },
        {
            codeName: "塔甘罗格（俄罗斯）",
            cusCode: "2668",
            codeValue: "RUS096",
            gbName: "塔甘罗格（俄罗斯）",
            gbCode: "RUS096",
            ciqCode: "643096"
        },
        {
            codeName: "图阿普谢（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS099",
            gbName: "图阿普谢（俄罗斯）",
            gbCode: "RUS099",
            ciqCode: "643099"
        },
        {
            codeName: "乌格里哥斯克（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS102",
            gbName: "乌格里哥斯克（俄罗斯）",
            gbCode: "RUS102",
            ciqCode: "643102"
        },
        {
            codeName: "乌斯季堪察茨克（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS104",
            gbName: "乌斯季堪察茨克（俄罗斯）",
            gbCode: "RUS104",
            ciqCode: "643104"
        },
        {
            codeName: "翁巴（俄罗斯）",
            cusCode: "2670",
            codeValue: "RUS105",
            gbName: "翁巴（俄罗斯）",
            gbCode: "RUS105",
            ciqCode: "643105"
        },
        {
            codeName: "瓦尼诺（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS108",
            gbName: "瓦尼诺（俄罗斯）",
            gbCode: "RUS108",
            ciqCode: "643108"
        },
        {
            codeName: "符拉迪沃斯托克/海参葳（俄罗斯）",
            cusCode: "2672",
            codeValue: "RUS111",
            gbName: "符拉迪沃斯托克/海参葳（俄罗斯）",
            gbCode: "RUS111",
            ciqCode: "643111"
        },
        {
            codeName: "东方港（俄罗斯）",
            cusCode: "2673",
            codeValue: "RUS114",
            gbName: "东方港（俄罗斯）",
            gbCode: "RUS114",
            ciqCode: "643114"
        },
        {
            codeName: "维堡（俄罗斯）",
            cusCode: "2674",
            codeValue: "RUS117",
            gbName: "维堡（俄罗斯）",
            gbCode: "RUS117",
            ciqCode: "643117"
        },
        {
            codeName: "维索茨克（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS120",
            gbName: "维索茨克（俄罗斯）",
            gbCode: "RUS120",
            ciqCode: "643120"
        },
        {
            codeName: "扎鲁比诺（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS123",
            gbName: "扎鲁比诺（俄罗斯）",
            gbCode: "RUS123",
            ciqCode: "643123"
        },
        {
            codeName: "日丹诺夫（俄罗斯）",
            cusCode: "2676",
            codeValue: "RUS126",
            gbName: "日丹诺夫（俄罗斯）",
            gbCode: "RUS126",
            ciqCode: "643126"
        },
        {
            codeName: "莫斯科（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS901",
            gbName: "莫斯科（俄罗斯）",
            gbCode: "RUS901",
            ciqCode: "643901"
        },
        {
            codeName: "波格拉尼奇内（俄罗斯）",
            cusCode: "344",
            codeValue: "RUS902",
            gbName: "波格拉尼奇内（俄罗斯）",
            gbCode: "RUS902",
            ciqCode: "643902"
        },
        {
            codeName: "别尔迪杨斯克（俄罗斯）",
            cusCode: "2643",
            codeValue: "RUS903",
            gbName: "别尔迪杨斯克（俄罗斯）",
            gbCode: "RUS903",
            ciqCode: "643903"
        },
        {
            codeName: "波季（俄罗斯）",
            cusCode: "2662",
            codeValue: "RUS904",
            gbName: "波季（俄罗斯）",
            gbCode: "RUS904",
            ciqCode: "643904"
        },
        {
            codeName: "都普西（俄罗斯）",
            cusCode: "2664",
            codeValue: "RUS905",
            gbName: "都普西（俄罗斯）",
            gbCode: "RUS905",
            ciqCode: "643905"
        },
        {
            codeName: "赫尔松（俄罗斯）",
            cusCode: "2650",
            codeValue: "RUS906",
            gbName: "赫尔松（俄罗斯）",
            gbCode: "RUS906",
            ciqCode: "643906"
        },
        {
            codeName: "基利亚（俄罗斯）",
            cusCode: "2652",
            codeValue: "RUS907",
            gbName: "基利亚（俄罗斯）",
            gbCode: "RUS907",
            ciqCode: "643907"
        },
        {
            codeName: "克耒彼达（俄罗斯）",
            cusCode: "2653",
            codeValue: "RUS908",
            gbName: "克耒彼达（俄罗斯）",
            gbCode: "RUS908",
            ciqCode: "643908"
        },
        {
            codeName: "温次匹尔斯（俄罗斯）",
            cusCode: "2671",
            codeValue: "RUS910",
            gbName: "温次匹尔斯（俄罗斯）",
            gbCode: "RUS910",
            ciqCode: "643910"
        },
        {
            codeName: "伊加尔卡（俄罗斯）",
            cusCode: "2644",
            codeValue: "RUS911",
            gbName: "伊加尔卡（俄罗斯）",
            gbCode: "RUS911",
            ciqCode: "643911"
        },
        {
            codeName: "伊利切夫斯克（俄罗斯）",
            cusCode: "2645",
            codeValue: "RUS912",
            gbName: "伊利切夫斯克（俄罗斯）",
            gbCode: "RUS912",
            ciqCode: "643912"
        },
        {
            codeName: "伊兹马伊耳（俄罗斯）",
            cusCode: "2646",
            codeValue: "RUS913",
            gbName: "伊兹马伊耳（俄罗斯）",
            gbCode: "RUS913",
            ciqCode: "643913"
        },
        {
            codeName: "卢旺达",
            cusCode: "238",
            codeValue: "RWA000",
            gbName: "卢旺达",
            gbCode: "RWA000",
            ciqCode: "646000"
        },
        {
            codeName: "沙特阿拉伯",
            cusCode: "131",
            codeValue: "SAU000",
            gbName: "沙特阿拉伯",
            gbCode: "SAU000",
            ciqCode: "682000"
        },
        {
            codeName: "达曼（沙特阿拉伯）",
            cusCode: "1463",
            codeValue: "SAU003",
            gbName: "达曼（沙特阿拉伯）",
            gbCode: "SAU003",
            ciqCode: "682003"
        },
        {
            codeName: "吉赞（沙特阿拉伯）",
            cusCode: "131",
            codeValue: "SAU006",
            gbName: "吉赞（沙特阿拉伯）",
            gbCode: "SAU006",
            ciqCode: "682006"
        },
        {
            codeName: "吉达（沙特阿拉伯）",
            cusCode: "1464",
            codeValue: "SAU009",
            gbName: "吉达（沙特阿拉伯）",
            gbCode: "SAU009",
            ciqCode: "682009"
        },
        {
            codeName: "朱阿马港（沙特阿拉伯）",
            cusCode: "131",
            codeValue: "SAU012",
            gbName: "朱阿马港（沙特阿拉伯）",
            gbCode: "SAU012",
            ciqCode: "682012"
        },
        {
            codeName: "朱拜勒（沙特阿拉伯）",
            cusCode: "1460",
            codeValue: "SAU015",
            gbName: "朱拜勒（沙特阿拉伯）",
            gbCode: "SAU015",
            ciqCode: "682015"
        },
        {
            codeName: "拉斯海夫吉（沙特阿拉伯）",
            cusCode: "131",
            codeValue: "SAU018",
            gbName: "拉斯海夫吉（沙特阿拉伯）",
            gbCode: "SAU018",
            ciqCode: "682018"
        },
        {
            codeName: "米萨卜角（沙特阿拉伯）",
            cusCode: "131",
            codeValue: "SAU021",
            gbName: "米萨卜角（沙特阿拉伯）",
            gbCode: "SAU021",
            ciqCode: "682021"
        },
        {
            codeName: "拉斯坦努拉（沙特阿拉伯）",
            cusCode: "131",
            codeValue: "SAU024",
            gbName: "拉斯坦努拉（沙特阿拉伯）",
            gbCode: "SAU024",
            ciqCode: "682024"
        },
        {
            codeName: "延布（沙特阿拉伯）",
            cusCode: "1471",
            codeValue: "SAU027",
            gbName: "延布（沙特阿拉伯）",
            gbCode: "SAU027",
            ciqCode: "682027"
        },
        {
            codeName: "利雅得（沙特阿拉伯）",
            cusCode: "1470",
            codeValue: "SAU030",
            gbName: "利雅得（沙特阿拉伯）",
            gbCode: "SAU030",
            ciqCode: "682030"
        },
        {
            codeName: "布赖代（沙特阿拉伯）",
            cusCode: "1462",
            codeValue: "SAU033",
            gbName: "布赖代（沙特阿拉伯）",
            gbCode: "SAU033",
            ciqCode: "682033"
        },
        {
            codeName: "麦加（沙特阿拉伯）",
            cusCode: "1469",
            codeValue: "SAU039",
            gbName: "麦加（沙特阿拉伯）",
            gbCode: "SAU039",
            ciqCode: "682039"
        },
        {
            codeName: "苏丹",
            cusCode: "246",
            codeValue: "SDN000",
            gbName: "苏丹",
            gbCode: "SDN000",
            ciqCode: "729000"
        },
        {
            codeName: "苏丹港（苏丹）",
            cusCode: "1761",
            codeValue: "SDN003",
            gbName: "苏丹港（苏丹）",
            gbCode: "SDN003",
            ciqCode: "729003"
        },
        {
            codeName: "萨瓦金（苏丹）",
            cusCode: "1760",
            codeValue: "SDN006",
            gbName: "萨瓦金（苏丹）",
            gbCode: "SDN006",
            ciqCode: "729006"
        },
        {
            codeName: "喀士穆（苏丹）",
            cusCode: "246",
            codeValue: "SDN901",
            gbName: "喀士穆（苏丹）",
            gbCode: "SDN901",
            ciqCode: "729901"
        },
        {
            codeName: "塞内加尔",
            cusCode: "240",
            codeValue: "SEN000",
            gbName: "塞内加尔",
            gbCode: "SEN000",
            ciqCode: "686000"
        },
        {
            codeName: "达喀尔（塞内加尔）",
            cusCode: "1739",
            codeValue: "SEN003",
            gbName: "达喀尔（塞内加尔）",
            gbCode: "SEN003",
            ciqCode: "686003"
        },
        {
            codeName: "考拉克（塞内加尔）",
            cusCode: "1740",
            codeValue: "SEN006",
            gbName: "考拉克（塞内加尔）",
            gbCode: "SEN006",
            ciqCode: "686006"
        },
        {
            codeName: "圣路易（塞内加尔）",
            cusCode: "1738",
            codeValue: "SEN008",
            gbName: "圣路易（塞内加尔）",
            gbCode: "SEN008",
            ciqCode: "686008"
        },
        {
            codeName: "济金绍尔（塞内加尔）",
            cusCode: "1741",
            codeValue: "SEN009",
            gbName: "济金绍尔（塞内加尔）",
            gbCode: "SEN009",
            ciqCode: "686009"
        },
        {
            codeName: "丰迪乌涅（塞内加尔）",
            cusCode: "1737",
            codeValue: "SEN012",
            gbName: "丰迪乌涅（塞内加尔）",
            gbCode: "SEN012",
            ciqCode: "686012"
        },
        {
            codeName: "新加坡",
            cusCode: "132",
            codeValue: "SGP000",
            gbName: "新加坡",
            gbCode: "SGP000",
            ciqCode: "702000"
        },
        {
            codeName: "普劳艾亚却文（新加坡）",
            cusCode: "1473",
            codeValue: "SGP001",
            gbName: "普劳艾亚却文（新加坡）",
            gbCode: "SGP001",
            ciqCode: "702001"
        },
        {
            codeName: "裕廊（新加坡）",
            cusCode: "132",
            codeValue: "SGP003",
            gbName: "裕廊（新加坡）",
            gbCode: "SGP003",
            ciqCode: "702003"
        },
        {
            codeName: "普劳萨巴洛克（新加坡）",
            cusCode: "1476",
            codeValue: "SGP004",
            gbName: "普劳萨巴洛克（新加坡）",
            gbCode: "SGP004",
            ciqCode: "702004"
        },
        {
            codeName: "丹戎巴葛（新加坡）",
            cusCode: "1478",
            codeValue: "SGP005",
            gbName: "丹戎巴葛（新加坡）",
            gbCode: "SGP005",
            ciqCode: "702005"
        },
        {
            codeName: "普劳布科姆（新加坡）",
            cusCode: "1472",
            codeValue: "SGP006",
            gbName: "普劳布科姆（新加坡）",
            gbCode: "SGP006",
            ciqCode: "702006"
        },
        {
            codeName: "森巴旺（新加坡）",
            cusCode: "132",
            codeValue: "SGP009",
            gbName: "森巴旺（新加坡）",
            gbCode: "SGP009",
            ciqCode: "702009"
        },
        {
            codeName: "新加坡（新加坡）",
            cusCode: "1477",
            codeValue: "SGP012",
            gbName: "新加坡（新加坡）",
            gbCode: "SGP012",
            ciqCode: "702012"
        },
        {
            codeName: "丹章彭鲁（新加坡）",
            cusCode: "1479",
            codeValue: "SGP015",
            gbName: "丹章彭鲁（新加坡）",
            gbCode: "SGP015",
            ciqCode: "702015"
        },
        {
            codeName: "南乔治亚岛和南桑德韦奇岛",
            cusCode: "453",
            codeValue: "SGS000",
            gbName: "南乔治亚岛和南桑德韦奇岛",
            gbCode: "SGS000",
            ciqCode: "239000"
        },
        {
            codeName: "圣赫勒拿",
            cusCode: "263",
            codeValue: "SHN000",
            gbName: "圣赫勒拿",
            gbCode: "SHN000",
            ciqCode: "654000"
        },
        {
            codeName: "乔治敦（圣赫勒拿）",
            cusCode: "263",
            codeValue: "SHN003",
            gbName: "乔治敦（圣赫勒拿）",
            gbCode: "SHN003",
            ciqCode: "654003"
        },
        {
            codeName: "詹姆斯敦（圣赫勒拿）",
            cusCode: "263",
            codeValue: "SHN006",
            gbName: "詹姆斯敦（圣赫勒拿）",
            gbCode: "SHN006",
            ciqCode: "654006"
        },
        {
            codeName: "斯瓦尔巴群岛和扬马延岛",
            cusCode: "364",
            codeValue: "SJM000",
            gbName: "斯瓦尔巴群岛和扬马延岛",
            gbCode: "SJM000",
            ciqCode: "744000"
        },
        {
            codeName: "所罗门群岛",
            cusCode: "613",
            codeValue: "SLB000",
            gbName: "所罗门群岛",
            gbCode: "SLB000",
            ciqCode: "090000"
        },
        {
            codeName: "LOLAHO（所罗门群岛）",
            cusCode: "3339",
            codeValue: "SLB001",
            gbName: "LOLAHO（所罗门群岛）",
            gbCode: "SLB001",
            ciqCode: "090001"
        },
        {
            codeName: "安诺瓦湾（所罗门群岛）",
            cusCode: "3337",
            codeValue: "SLB002",
            gbName: "安诺瓦湾（所罗门群岛）",
            gbCode: "SLB002",
            ciqCode: "090002"
        },
        {
            codeName: "阿拉迪斯港（所罗门群岛）",
            cusCode: "613",
            codeValue: "SLB003",
            gbName: "阿拉迪斯港（所罗门群岛）",
            gbCode: "SLB003",
            ciqCode: "090003"
        },
        {
            codeName: "奥基（所罗门群岛）",
            cusCode: "3336",
            codeValue: "SLB004",
            gbName: "奥基（所罗门群岛）",
            gbCode: "SLB004",
            ciqCode: "090004"
        },
        {
            codeName: "吉佐（所罗门群岛）",
            cusCode: "3334",
            codeValue: "SLB006",
            gbName: "吉佐（所罗门群岛）",
            gbCode: "SLB006",
            ciqCode: "090006"
        },
        {
            codeName: "霍尼亚拉（所罗门群岛）",
            cusCode: "3338",
            codeValue: "SLB009",
            gbName: "霍尼亚拉（所罗门群岛）",
            gbCode: "SLB009",
            ciqCode: "090009"
        },
        {
            codeName: "诺鲁（所罗门群岛）",
            cusCode: "613",
            codeValue: "SLB012",
            gbName: "诺鲁（所罗门群岛）",
            gbCode: "SLB012",
            ciqCode: "090012"
        },
        {
            codeName: "林吉科弗（所罗门群岛）",
            cusCode: "613",
            codeValue: "SLB015",
            gbName: "林吉科弗（所罗门群岛）",
            gbCode: "SLB015",
            ciqCode: "090015"
        },
        {
            codeName: "肖特兰岛（所罗门群岛）",
            cusCode: "613",
            codeValue: "SLB018",
            gbName: "肖特兰岛（所罗门群岛）",
            gbCode: "SLB018",
            ciqCode: "090018"
        },
        {
            codeName: "图拉吉（所罗门群岛）",
            cusCode: "613",
            codeValue: "SLB021",
            gbName: "图拉吉（所罗门群岛）",
            gbCode: "SLB021",
            ciqCode: "090021"
        },
        {
            codeName: "扬迪纳（所罗门群岛）",
            cusCode: "3340",
            codeValue: "SLB024",
            gbName: "扬迪纳（所罗门群岛）",
            gbCode: "SLB024",
            ciqCode: "090024"
        },
        {
            codeName: "塞拉利昂",
            cusCode: "242",
            codeValue: "SLE000",
            gbName: "塞拉利昂",
            gbCode: "SLE000",
            ciqCode: "694000"
        },
        {
            codeName: "邦特（塞拉利昂）",
            cusCode: "1745",
            codeValue: "SLE002",
            gbName: "邦特（塞拉利昂）",
            gbCode: "SLE002",
            ciqCode: "694002"
        },
        {
            codeName: "弗里敦（塞拉利昂）",
            cusCode: "1746",
            codeValue: "SLE003",
            gbName: "弗里敦（塞拉利昂）",
            gbCode: "SLE003",
            ciqCode: "694003"
        },
        {
            codeName: "佩佩尔（塞拉利昂）",
            cusCode: "1743",
            codeValue: "SLE006",
            gbName: "佩佩尔（塞拉利昂）",
            gbCode: "SLE006",
            ciqCode: "694006"
        },
        {
            codeName: "歇尔布罗岛（塞拉利昂）",
            cusCode: "1744",
            codeValue: "SLE009",
            gbName: "歇尔布罗岛（塞拉利昂）",
            gbCode: "SLE009",
            ciqCode: "694009"
        },
        {
            codeName: "萨尔瓦多",
            cusCode: "440",
            codeValue: "SLV000",
            gbName: "萨尔瓦多",
            gbCode: "SLV000",
            ciqCode: "222000"
        },
        {
            codeName: "阿卡胡特拉（萨尔瓦多）",
            cusCode: "2937",
            codeValue: "SLV003",
            gbName: "阿卡胡特拉（萨尔瓦多）",
            gbCode: "SLV003",
            ciqCode: "222003"
        },
        {
            codeName: "库图科（萨尔瓦多）",
            cusCode: "2935",
            codeValue: "SLV006",
            gbName: "库图科（萨尔瓦多）",
            gbCode: "SLV006",
            ciqCode: "222006"
        },
        {
            codeName: "拉利贝塔德（萨尔瓦多）",
            cusCode: "2938",
            codeValue: "SLV009",
            gbName: "拉利贝塔德（萨尔瓦多）",
            gbCode: "SLV009",
            ciqCode: "222009"
        },
        {
            codeName: "拉乌尼翁（萨尔瓦多）",
            cusCode: "2936",
            codeValue: "SLV012",
            gbName: "拉乌尼翁（萨尔瓦多）",
            gbCode: "SLV012",
            ciqCode: "222012"
        },
        {
            codeName: "圣马力诺",
            cusCode: "329",
            codeValue: "SMR000",
            gbName: "圣马力诺",
            gbCode: "SMR000",
            ciqCode: "674000"
        },
        {
            codeName: "圣马力诺（圣马力诺）",
            cusCode: "2544",
            codeValue: "SMR001",
            gbName: "圣马力诺（圣马力诺）",
            gbCode: "SMR001",
            ciqCode: "674001"
        },
        {
            codeName: "索马里",
            cusCode: "243",
            codeValue: "SOM000",
            gbName: "索马里",
            gbCode: "SOM000",
            ciqCode: "706000"
        },
        {
            codeName: "阿鲁拉（索马里）",
            cusCode: "243",
            codeValue: "SOM003",
            gbName: "阿鲁拉（索马里）",
            gbCode: "SOM003",
            ciqCode: "706003"
        },
        {
            codeName: "柏培拉（索马里）",
            cusCode: "1747",
            codeValue: "SOM006",
            gbName: "柏培拉（索马里）",
            gbCode: "SOM006",
            ciqCode: "706006"
        },
        {
            codeName: "博萨索（索马里）",
            cusCode: "243",
            codeValue: "SOM009",
            gbName: "博萨索（索马里）",
            gbCode: "SOM009",
            ciqCode: "706009"
        },
        {
            codeName: "布拉瓦（索马里）",
            cusCode: "243",
            codeValue: "SOM012",
            gbName: "布拉瓦（索马里）",
            gbCode: "SOM012",
            ciqCode: "706012"
        },
        {
            codeName: "丹特（索马里）",
            cusCode: "243",
            codeValue: "SOM015",
            gbName: "丹特（索马里）",
            gbCode: "SOM015",
            ciqCode: "706015"
        },
        {
            codeName: "基斯马尤（索马里）",
            cusCode: "1748",
            codeValue: "SOM018",
            gbName: "基斯马尤（索马里）",
            gbCode: "SOM018",
            ciqCode: "706018"
        },
        {
            codeName: "马尔卡（索马里）",
            cusCode: "1750",
            codeValue: "SOM021",
            gbName: "马尔卡（索马里）",
            gbCode: "SOM021",
            ciqCode: "706021"
        },
        {
            codeName: "摩加迪沙（索马里）",
            cusCode: "1749",
            codeValue: "SOM024",
            gbName: "摩加迪沙（索马里）",
            gbCode: "SOM024",
            ciqCode: "706024"
        },
        {
            codeName: "奥比亚（索马里）",
            cusCode: "243",
            codeValue: "SOM027",
            gbName: "奥比亚（索马里）",
            gbCode: "SOM027",
            ciqCode: "706027"
        },
        {
            codeName: "圣皮埃尔和密克隆",
            cusCode: "505",
            codeValue: "SPM000",
            gbName: "圣皮埃尔和密克隆",
            gbCode: "SPM000",
            ciqCode: "666000"
        },
        {
            codeName: "圣皮埃尔（圣皮埃尔和密克隆）",
            cusCode: "505",
            codeValue: "SPM003",
            gbName: "圣皮埃尔（圣皮埃尔和密克隆）",
            gbCode: "SPM003",
            ciqCode: "666003"
        },
        {
            codeName: "塞尔维亚",
            cusCode: "358",
            codeValue: "SRB000",
            gbName: "塞尔维亚",
            gbCode: "SRB000",
            ciqCode: "688000"
        },
        {
            codeName: "巴尔（塞尔维亚）",
            cusCode: "358",
            codeValue: "SRB003",
            gbName: "巴尔（塞尔维亚）",
            gbCode: "SRB003",
            ciqCode: "688003"
        },
        {
            codeName: "科托尔（塞尔维亚）",
            cusCode: "358",
            codeValue: "SRB006",
            gbName: "科托尔（塞尔维亚）",
            gbCode: "SRB006",
            ciqCode: "688006"
        },
        {
            codeName: "泽莱尼卡（塞尔维亚）",
            cusCode: "2702",
            codeValue: "SRB009",
            gbName: "泽莱尼卡（塞尔维亚）",
            gbCode: "SRB009",
            ciqCode: "688009"
        },
        {
            codeName: "杰姆斯敦（塞尔维亚）",
            cusCode: "2683",
            codeValue: "SRB012",
            gbName: "杰姆斯敦（塞尔维亚）",
            gbCode: "SRB012",
            ciqCode: "688012"
        },
        {
            codeName: "南苏丹",
            cusCode: "260",
            codeValue: "SSD000",
            gbName: "南苏丹",
            gbCode: "SSD000",
            ciqCode: "728000"
        },
        {
            codeName: "圣多美和普林西比",
            cusCode: "239",
            codeValue: "STP000",
            gbName: "圣多美和普林西比",
            gbCode: "STP000",
            ciqCode: "678000"
        },
        {
            codeName: "普林西比岛（圣多美和普林西比）",
            cusCode: "239",
            codeValue: "STP003",
            gbName: "普林西比岛（圣多美和普林西比）",
            gbCode: "STP003",
            ciqCode: "678003"
        },
        {
            codeName: "圣多美（圣多美和普林西比）",
            cusCode: "1736",
            codeValue: "STP006",
            gbName: "圣多美（圣多美和普林西比）",
            gbCode: "STP006",
            ciqCode: "678006"
        },
        {
            codeName: "苏里南",
            cusCode: "441",
            codeValue: "SUR000",
            gbName: "苏里南",
            gbCode: "SUR000",
            ciqCode: "740000"
        },
        {
            codeName: "蒙戈（苏里南）",
            cusCode: "2939",
            codeValue: "SUR003",
            gbName: "蒙戈（苏里南）",
            gbCode: "SUR003",
            ciqCode: "740003"
        },
        {
            codeName: "帕拉马里博（苏里南）",
            cusCode: "2942",
            codeValue: "SUR006",
            gbName: "帕拉马里博（苏里南）",
            gbCode: "SUR006",
            ciqCode: "740006"
        },
        {
            codeName: "帕拉南（苏里南）",
            cusCode: "441",
            codeValue: "SUR009",
            gbName: "帕拉南（苏里南）",
            gbCode: "SUR009",
            ciqCode: "740009"
        },
        {
            codeName: "斯马卡尔登（苏里南）",
            cusCode: "2943",
            codeValue: "SUR012",
            gbName: "斯马卡尔登（苏里南）",
            gbCode: "SUR012",
            ciqCode: "740012"
        },
        {
            codeName: "瓦黑宁恩（苏里南）",
            cusCode: "2944",
            codeValue: "SUR015",
            gbName: "瓦黑宁恩（苏里南）",
            gbCode: "SUR015",
            ciqCode: "740015"
        },
        {
            codeName: "新尼克里（苏里南）",
            cusCode: "2940",
            codeValue: "SUR016",
            gbName: "新尼克里（苏里南）",
            gbCode: "SUR016",
            ciqCode: "740016"
        },
        {
            codeName: "斯洛伐克",
            cusCode: "353",
            codeValue: "SVK000",
            gbName: "斯洛伐克",
            gbCode: "SVK000",
            ciqCode: "703000"
        },
        {
            codeName: "PRAHA（斯洛伐克）",
            cusCode: "2426",
            codeValue: "SVK001",
            gbName: "PRAHA（斯洛伐克）",
            gbCode: "SVK001",
            ciqCode: "703001"
        },
        {
            codeName: "斯洛文尼亚",
            cusCode: "350",
            codeValue: "SVN000",
            gbName: "斯洛文尼亚",
            gbCode: "SVN000",
            ciqCode: "705000"
        },
        {
            codeName: "卢布尔雅那（斯洛文尼亚）",
            cusCode: "2688",
            codeValue: "SVN002",
            gbName: "卢布尔雅那（斯洛文尼亚）",
            gbCode: "SVN002",
            ciqCode: "705002"
        },
        {
            codeName: "伊佐拉（斯洛文尼亚）",
            cusCode: "2682",
            codeValue: "SVN003",
            gbName: "伊佐拉（斯洛文尼亚）",
            gbCode: "SVN003",
            ciqCode: "705003"
        },
        {
            codeName: "科佩尔（斯洛文尼亚）",
            cusCode: "2681",
            codeValue: "SVN006",
            gbName: "科佩尔（斯洛文尼亚）",
            gbCode: "SVN006",
            ciqCode: "705006"
        },
        {
            codeName: "皮兰（斯洛文尼亚）",
            cusCode: "2690",
            codeValue: "SVN009",
            gbName: "皮兰（斯洛文尼亚）",
            gbCode: "SVN009",
            ciqCode: "705009"
        },
        {
            codeName: "瑞典",
            cusCode: "330",
            codeValue: "SWE000",
            gbName: "瑞典",
            gbCode: "SWE000",
            ciqCode: "752000"
        },
        {
            codeName: "奥胡斯（瑞典）",
            cusCode: "2545",
            codeValue: "SWE003",
            gbName: "奥胡斯（瑞典）",
            gbCode: "SWE003",
            ciqCode: "752003"
        },
        {
            codeName: "阿拉（瑞典）",
            cusCode: "2546",
            codeValue: "SWE006",
            gbName: "阿拉（瑞典）",
            gbCode: "SWE006",
            ciqCode: "752006"
        },
        {
            codeName: "阿尔博加（瑞典）",
            cusCode: "2547",
            codeValue: "SWE009",
            gbName: "阿尔博加（瑞典）",
            gbCode: "SWE009",
            ciqCode: "752009"
        },
        {
            codeName: "博里霍尔姆（瑞典）",
            cusCode: "2548",
            codeValue: "SWE012",
            gbName: "博里霍尔姆（瑞典）",
            gbCode: "SWE012",
            ciqCode: "752012"
        },
        {
            codeName: "布罗夫约尔丹（瑞典）",
            cusCode: "330",
            codeValue: "SWE015",
            gbName: "布罗夫约尔丹（瑞典）",
            gbCode: "SWE015",
            ciqCode: "752015"
        },
        {
            codeName: "布雷奥（瑞典）",
            cusCode: "330",
            codeValue: "SWE018",
            gbName: "布雷奥（瑞典）",
            gbCode: "SWE018",
            ciqCode: "752018"
        },
        {
            codeName: "达拉勒（瑞典）",
            cusCode: "330",
            codeValue: "SWE021",
            gbName: "达拉勒（瑞典）",
            gbCode: "SWE021",
            ciqCode: "752021"
        },
        {
            codeName: "代格港（瑞典）",
            cusCode: "330",
            codeValue: "SWE024",
            gbName: "代格港（瑞典）",
            gbCode: "SWE024",
            ciqCode: "752024"
        },
        {
            codeName: "杜姆舍（瑞典）",
            cusCode: "330",
            codeValue: "SWE027",
            gbName: "杜姆舍（瑞典）",
            gbCode: "SWE027",
            ciqCode: "752027"
        },
        {
            codeName: "恩雪平（瑞典）",
            cusCode: "2549",
            codeValue: "SWE030",
            gbName: "恩雪平（瑞典）",
            gbCode: "SWE030",
            ciqCode: "752030"
        },
        {
            codeName: "法尔肯贝里（瑞典）",
            cusCode: "330",
            codeValue: "SWE033",
            gbName: "法尔肯贝里（瑞典）",
            gbCode: "SWE033",
            ciqCode: "752033"
        },
        {
            codeName: "福勒松德（瑞典）",
            cusCode: "330",
            codeValue: "SWE036",
            gbName: "福勒松德（瑞典）",
            gbCode: "SWE036",
            ciqCode: "752036"
        },
        {
            codeName: "耶夫勒（瑞典）",
            cusCode: "2550",
            codeValue: "SWE039",
            gbName: "耶夫勒（瑞典）",
            gbCode: "SWE039",
            ciqCode: "752039"
        },
        {
            codeName: "哥德堡（瑞典）",
            cusCode: "2551",
            codeValue: "SWE042",
            gbName: "哥德堡（瑞典）",
            gbCode: "SWE042",
            ciqCode: "752042"
        },
        {
            codeName: "哈尔斯塔维克（瑞典）",
            cusCode: "330",
            codeValue: "SWE045",
            gbName: "哈尔斯塔维克（瑞典）",
            gbCode: "SWE045",
            ciqCode: "752045"
        },
        {
            codeName: "哈尔姆斯塔德（瑞典）",
            cusCode: "330",
            codeValue: "SWE048",
            gbName: "哈尔姆斯塔德（瑞典）",
            gbCode: "SWE048",
            ciqCode: "752048"
        },
        {
            codeName: "哈帕兰达（瑞典）",
            cusCode: "2552",
            codeValue: "SWE051",
            gbName: "哈帕兰达（瑞典）",
            gbCode: "SWE051",
            ciqCode: "752051"
        },
        {
            codeName: "哈拉霍尔梅（瑞典）",
            cusCode: "2553",
            codeValue: "SWE054",
            gbName: "哈拉霍尔梅（瑞典）",
            gbCode: "SWE054",
            ciqCode: "752054"
        },
        {
            codeName: "哈里港（瑞典）",
            cusCode: "2554",
            codeValue: "SWE057",
            gbName: "哈里港（瑞典）",
            gbCode: "SWE057",
            ciqCode: "752057"
        },
        {
            codeName: "赫尔辛堡（瑞典）",
            cusCode: "2556",
            codeValue: "SWE063",
            gbName: "赫尔辛堡（瑞典）",
            gbCode: "SWE063",
            ciqCode: "752063"
        },
        {
            codeName: "海讷桑德（瑞典）",
            cusCode: "2555",
            codeValue: "SWE066",
            gbName: "海讷桑德（瑞典）",
            gbCode: "SWE066",
            ciqCode: "752066"
        },
        {
            codeName: "赫加奈斯（瑞典）",
            cusCode: "2558",
            codeValue: "SWE069",
            gbName: "赫加奈斯（瑞典）",
            gbCode: "SWE069",
            ciqCode: "752069"
        },
        {
            codeName: "霍尔姆松德（瑞典）",
            cusCode: "330",
            codeValue: "SWE072",
            gbName: "霍尔姆松德（瑞典）",
            gbCode: "SWE072",
            ciqCode: "752072"
        },
        {
            codeName: "霍讷福什（瑞典）",
            cusCode: "2559",
            codeValue: "SWE075",
            gbName: "霍讷福什（瑞典）",
            gbCode: "SWE075",
            ciqCode: "752075"
        },
        {
            codeName: "胡迪克斯瓦尔（瑞典）",
            cusCode: "2560",
            codeValue: "SWE078",
            gbName: "胡迪克斯瓦尔（瑞典）",
            gbCode: "SWE078",
            ciqCode: "752078"
        },
        {
            codeName: "胡苏姆（瑞典）",
            cusCode: "330",
            codeValue: "SWE081",
            gbName: "胡苏姆（瑞典）",
            gbCode: "SWE081",
            ciqCode: "752081"
        },
        {
            codeName: "伊格松德（瑞典）",
            cusCode: "330",
            codeValue: "SWE084",
            gbName: "伊格松德（瑞典）",
            gbCode: "SWE084",
            ciqCode: "752084"
        },
        {
            codeName: "延雪平（瑞典）",
            cusCode: "2561",
            codeValue: "SWE087",
            gbName: "延雪平（瑞典）",
            gbCode: "SWE087",
            ciqCode: "752087"
        },
        {
            codeName: "卡利克斯（瑞典）",
            cusCode: "2562",
            codeValue: "SWE090",
            gbName: "卡利克斯（瑞典）",
            gbCode: "SWE090",
            ciqCode: "752090"
        },
        {
            codeName: "卡尔马（瑞典）",
            cusCode: "2563",
            codeValue: "SWE093",
            gbName: "卡尔马（瑞典）",
            gbCode: "SWE093",
            ciqCode: "752093"
        },
        {
            codeName: "卡尔斯堡（瑞典）",
            cusCode: "330",
            codeValue: "SWE096",
            gbName: "卡尔斯堡（瑞典）",
            gbCode: "SWE096",
            ciqCode: "752096"
        },
        {
            codeName: "卡尔斯港（瑞典）",
            cusCode: "2566",
            codeValue: "SWE099",
            gbName: "卡尔斯港（瑞典）",
            gbCode: "SWE099",
            ciqCode: "752099"
        },
        {
            codeName: "卡尔斯克鲁纳（瑞典）",
            cusCode: "2564",
            codeValue: "SWE102",
            gbName: "卡尔斯克鲁纳（瑞典）",
            gbCode: "SWE102",
            ciqCode: "752102"
        },
        {
            codeName: "卡尔斯塔德（瑞典）",
            cusCode: "2565",
            codeValue: "SWE105",
            gbName: "卡尔斯塔德（瑞典）",
            gbCode: "SWE105",
            ciqCode: "752105"
        },
        {
            codeName: "卡斯卡（瑞典）",
            cusCode: "2567",
            codeValue: "SWE108",
            gbName: "卡斯卡（瑞典）",
            gbCode: "SWE108",
            ciqCode: "752108"
        },
        {
            codeName: "克拉格斯港（瑞典）",
            cusCode: "330",
            codeValue: "SWE111",
            gbName: "克拉格斯港（瑞典）",
            gbCode: "SWE111",
            ciqCode: "752111"
        },
        {
            codeName: "克林特港（瑞典）",
            cusCode: "2568",
            codeValue: "SWE114",
            gbName: "克林特港（瑞典）",
            gbCode: "SWE114",
            ciqCode: "752114"
        },
        {
            codeName: "雪平（瑞典）",
            cusCode: "2569",
            codeValue: "SWE117",
            gbName: "雪平（瑞典）",
            gbCode: "SWE117",
            ciqCode: "752117"
        },
        {
            codeName: "克拉姆福什（瑞典）",
            cusCode: "330",
            codeValue: "SWE120",
            gbName: "克拉姆福什（瑞典）",
            gbCode: "SWE120",
            ciqCode: "752120"
        },
        {
            codeName: "克里斯蒂娜港（瑞典）",
            cusCode: "2572",
            codeValue: "SWE123",
            gbName: "克里斯蒂娜港（瑞典）",
            gbCode: "SWE123",
            ciqCode: "752123"
        },
        {
            codeName: "兰斯克鲁纳（瑞典）",
            cusCode: "2573",
            codeValue: "SWE126",
            gbName: "兰斯克鲁纳（瑞典）",
            gbCode: "SWE126",
            ciqCode: "752126"
        },
        {
            codeName: "利德雪平（瑞典）",
            cusCode: "2574",
            codeValue: "SWE129",
            gbName: "利德雪平（瑞典）",
            gbCode: "SWE129",
            ciqCode: "752129"
        },
        {
            codeName: "利姆港（瑞典）",
            cusCode: "2575",
            codeValue: "SWE132",
            gbName: "利姆港（瑞典）",
            gbCode: "SWE132",
            ciqCode: "752132"
        },
        {
            codeName: "于斯讷（瑞典）",
            cusCode: "2576",
            codeValue: "SWE135",
            gbName: "于斯讷（瑞典）",
            gbCode: "SWE135",
            ciqCode: "752135"
        },
        {
            codeName: "卢马（瑞典）",
            cusCode: "2577",
            codeValue: "SWE138",
            gbName: "卢马（瑞典）",
            gbCode: "SWE138",
            ciqCode: "752138"
        },
        {
            codeName: "吕勒奥（瑞典）",
            cusCode: "2579",
            codeValue: "SWE141",
            gbName: "吕勒奥（瑞典）",
            gbCode: "SWE141",
            ciqCode: "752141"
        },
        {
            codeName: "吕瑟希尔（瑞典）",
            cusCode: "2580",
            codeValue: "SWE144",
            gbName: "吕瑟希尔（瑞典）",
            gbCode: "SWE144",
            ciqCode: "752144"
        },
        {
            codeName: "马尔默（瑞典）",
            cusCode: "2581",
            codeValue: "SWE147",
            gbName: "马尔默（瑞典）",
            gbCode: "SWE147",
            ciqCode: "752147"
        },
        {
            codeName: "马斯特兰德（瑞典）",
            cusCode: "2583",
            codeValue: "SWE150",
            gbName: "马斯特兰德（瑞典）",
            gbCode: "SWE150",
            ciqCode: "752150"
        },
        {
            codeName: "穆塔拉（瑞典）",
            cusCode: "2585",
            codeValue: "SWE153",
            gbName: "穆塔拉（瑞典）",
            gbCode: "SWE153",
            ciqCode: "752153"
        },
        {
            codeName: "诺尔雪平（瑞典）",
            cusCode: "2587",
            codeValue: "SWE156",
            gbName: "诺尔雪平（瑞典）",
            gbCode: "SWE156",
            ciqCode: "752156"
        },
        {
            codeName: "诺尔松德（瑞典）",
            cusCode: "2588",
            codeValue: "SWE159",
            gbName: "诺尔松德（瑞典）",
            gbCode: "SWE159",
            ciqCode: "752159"
        },
        {
            codeName: "尼雪平（瑞典）",
            cusCode: "2590",
            codeValue: "SWE162",
            gbName: "尼雪平（瑞典）",
            gbCode: "SWE162",
            ciqCode: "752162"
        },
        {
            codeName: "尼奈斯港（瑞典）",
            cusCode: "2591",
            codeValue: "SWE165",
            gbName: "尼奈斯港（瑞典）",
            gbCode: "SWE165",
            ciqCode: "752165"
        },
        {
            codeName: "瓦克森（瑞典）",
            cusCode: "330",
            codeValue: "SWE168",
            gbName: "瓦克森（瑞典）",
            gbCode: "SWE168",
            ciqCode: "752168"
        },
        {
            codeName: "恩舍尔兹维克（瑞典）",
            cusCode: "330",
            codeValue: "SWE171",
            gbName: "恩舍尔兹维克（瑞典）",
            gbCode: "SWE171",
            ciqCode: "752171"
        },
        {
            codeName: "奥斯卡港（瑞典）",
            cusCode: "2592",
            codeValue: "SWE174",
            gbName: "奥斯卡港（瑞典）",
            gbCode: "SWE174",
            ciqCode: "752174"
        },
        {
            codeName: "乌特拜肯（瑞典）",
            cusCode: "2593",
            codeValue: "SWE177",
            gbName: "乌特拜肯（瑞典）",
            gbCode: "SWE177",
            ciqCode: "752177"
        },
        {
            codeName: "乌克瑟勒松德（瑞典）",
            cusCode: "2594",
            codeValue: "SWE180",
            gbName: "乌克瑟勒松德（瑞典）",
            gbCode: "SWE180",
            ciqCode: "752180"
        },
        {
            codeName: "波斯卡拉维克（瑞典）",
            cusCode: "330",
            codeValue: "SWE183",
            gbName: "波斯卡拉维克（瑞典）",
            gbCode: "SWE183",
            ciqCode: "752183"
        },
        {
            codeName: "帕塔霍尔姆（瑞典）",
            cusCode: "330",
            codeValue: "SWE186",
            gbName: "帕塔霍尔姆（瑞典）",
            gbCode: "SWE186",
            ciqCode: "752186"
        },
        {
            codeName: "皮特奥（瑞典）",
            cusCode: "2595",
            codeValue: "SWE189",
            gbName: "皮特奥（瑞典）",
            gbCode: "SWE189",
            ciqCode: "752189"
        },
        {
            codeName: "鲁讷港（瑞典）",
            cusCode: "330",
            codeValue: "SWE192",
            gbName: "鲁讷港（瑞典）",
            gbCode: "SWE192",
            ciqCode: "752192"
        },
        {
            codeName: "尤讷比港（瑞典）",
            cusCode: "330",
            codeValue: "SWE195",
            gbName: "尤讷比港（瑞典）",
            gbCode: "SWE195",
            ciqCode: "752195"
        },
        {
            codeName: "桑达讷（瑞典）",
            cusCode: "2598",
            codeValue: "SWE198",
            gbName: "桑达讷（瑞典）",
            gbCode: "SWE198",
            ciqCode: "752198"
        },
        {
            codeName: "桑德维肯（瑞典）",
            cusCode: "330",
            codeValue: "SWE201",
            gbName: "桑德维肯（瑞典）",
            gbCode: "SWE201",
            ciqCode: "752201"
        },
        {
            codeName: "锡克奥（瑞典）",
            cusCode: "2602",
            codeValue: "SWE204",
            gbName: "锡克奥（瑞典）",
            gbCode: "SWE204",
            ciqCode: "752204"
        },
        {
            codeName: "锡姆里斯港（瑞典）",
            cusCode: "2603",
            codeValue: "SWE207",
            gbName: "锡姆里斯港（瑞典）",
            gbCode: "SWE207",
            ciqCode: "752207"
        },
        {
            codeName: "谢莱夫特奥（瑞典）",
            cusCode: "2604",
            codeValue: "SWE210",
            gbName: "谢莱夫特奥（瑞典）",
            gbCode: "SWE210",
            ciqCode: "752210"
        },
        {
            codeName: "谢莱夫特港（瑞典）",
            cusCode: "330",
            codeValue: "SWE213",
            gbName: "谢莱夫特港（瑞典）",
            gbCode: "SWE213",
            ciqCode: "752213"
        },
        {
            codeName: "斯库格哈尔（瑞典）",
            cusCode: "2605",
            codeValue: "SWE216",
            gbName: "斯库格哈尔（瑞典）",
            gbCode: "SWE216",
            ciqCode: "752216"
        },
        {
            codeName: "斯克雷特维克（瑞典）",
            cusCode: "330",
            codeValue: "SWE219",
            gbName: "斯克雷特维克（瑞典）",
            gbCode: "SWE219",
            ciqCode: "752219"
        },
        {
            codeName: "斯屈特谢尔（瑞典）",
            cusCode: "2606",
            codeValue: "SWE222",
            gbName: "斯屈特谢尔（瑞典）",
            gbCode: "SWE222",
            ciqCode: "752222"
        },
        {
            codeName: "斯利特（瑞典）",
            cusCode: "2607",
            codeValue: "SWE225",
            gbName: "斯利特（瑞典）",
            gbCode: "SWE225",
            ciqCode: "752225"
        },
        {
            codeName: "瑟德港（瑞典）",
            cusCode: "2608",
            codeValue: "SWE228",
            gbName: "瑟德港（瑞典）",
            gbCode: "SWE228",
            ciqCode: "752228"
        },
        {
            codeName: "南雪平（瑞典）",
            cusCode: "2609",
            codeValue: "SWE231",
            gbName: "南雪平（瑞典）",
            gbCode: "SWE231",
            ciqCode: "752231"
        },
        {
            codeName: "南泰利耶（瑞典）",
            cusCode: "2610",
            codeValue: "SWE234",
            gbName: "南泰利耶（瑞典）",
            gbCode: "SWE234",
            ciqCode: "752234"
        },
        {
            codeName: "瑟尔沃斯堡（瑞典）",
            cusCode: "2611",
            codeValue: "SWE237",
            gbName: "瑟尔沃斯堡（瑞典）",
            gbCode: "SWE237",
            ciqCode: "752237"
        },
        {
            codeName: "斯泰农松德（瑞典）",
            cusCode: "2612",
            codeValue: "SWE240",
            gbName: "斯泰农松德（瑞典）",
            gbCode: "SWE240",
            ciqCode: "752240"
        },
        {
            codeName: "斯德哥尔摩（瑞典）",
            cusCode: "2616",
            codeValue: "SWE243",
            gbName: "斯德哥尔摩（瑞典）",
            gbCode: "SWE243",
            ciqCode: "752243"
        },
        {
            codeName: "斯图龙恩斯（瑞典）",
            cusCode: "2614",
            codeValue: "SWE246",
            gbName: "斯图龙恩斯（瑞典）",
            gbCode: "SWE246",
            ciqCode: "752246"
        },
        {
            codeName: "斯特兰奈斯（瑞典）",
            cusCode: "2615",
            codeValue: "SWE249",
            gbName: "斯特兰奈斯（瑞典）",
            gbCode: "SWE249",
            ciqCode: "752249"
        },
        {
            codeName: "斯特伦斯塔德（瑞典）",
            cusCode: "2617",
            codeValue: "SWE252",
            gbName: "斯特伦斯塔德（瑞典）",
            gbCode: "SWE252",
            ciqCode: "752252"
        },
        {
            codeName: "斯图格松德（瑞典）",
            cusCode: "330",
            codeValue: "SWE255",
            gbName: "斯图格松德（瑞典）",
            gbCode: "SWE255",
            ciqCode: "752255"
        },
        {
            codeName: "松兹瓦尔（瑞典）",
            cusCode: "2618",
            codeValue: "SWE258",
            gbName: "松兹瓦尔（瑞典）",
            gbCode: "SWE258",
            ciqCode: "752258"
        },
        {
            codeName: "特勒（瑞典）",
            cusCode: "330",
            codeValue: "SWE261",
            gbName: "特勒（瑞典）",
            gbCode: "SWE261",
            ciqCode: "752261"
        },
        {
            codeName: "特雷勒堡（瑞典）",
            cusCode: "2622",
            codeValue: "SWE264",
            gbName: "特雷勒堡（瑞典）",
            gbCode: "SWE264",
            ciqCode: "752264"
        },
        {
            codeName: "特罗尔海坦（瑞典）",
            cusCode: "330",
            codeValue: "SWE267",
            gbName: "特罗尔海坦（瑞典）",
            gbCode: "SWE267",
            ciqCode: "752267"
        },
        {
            codeName: "突亚多尔（瑞典）",
            cusCode: "330",
            codeValue: "SWE270",
            gbName: "突亚多尔（瑞典）",
            gbCode: "SWE270",
            ciqCode: "752270"
        },
        {
            codeName: "乌德瓦拉（瑞典）",
            cusCode: "2624",
            codeValue: "SWE273",
            gbName: "乌德瓦拉（瑞典）",
            gbCode: "SWE273",
            ciqCode: "752273"
        },
        {
            codeName: "于默奥（瑞典）",
            cusCode: "2625",
            codeValue: "SWE276",
            gbName: "于默奥（瑞典）",
            gbCode: "SWE276",
            ciqCode: "752276"
        },
        {
            codeName: "友丹佐（瑞典）",
            cusCode: "330",
            codeValue: "SWE279",
            gbName: "友丹佐（瑞典）",
            gbCode: "SWE279",
            ciqCode: "752279"
        },
        {
            codeName: "瓦尔德马什维克（瑞典）",
            cusCode: "2628",
            codeValue: "SWE282",
            gbName: "瓦尔德马什维克（瑞典）",
            gbCode: "SWE282",
            ciqCode: "752282"
        },
        {
            codeName: "瓦尔贝里（瑞典）",
            cusCode: "2631",
            codeValue: "SWE285",
            gbName: "瓦尔贝里（瑞典）",
            gbCode: "SWE285",
            ciqCode: "752285"
        },
        {
            codeName: "维斯特拉斯（瑞典）",
            cusCode: "2632",
            codeValue: "SWE288",
            gbName: "维斯特拉斯（瑞典）",
            gbCode: "SWE288",
            ciqCode: "752288"
        },
        {
            codeName: "维弗斯塔瓦夫（瑞典）",
            cusCode: "330",
            codeValue: "SWE291",
            gbName: "维弗斯塔瓦夫（瑞典）",
            gbCode: "SWE291",
            ciqCode: "752291"
        },
        {
            codeName: "维斯比（瑞典）",
            cusCode: "2633",
            codeValue: "SWE294",
            gbName: "维斯比（瑞典）",
            gbCode: "SWE294",
            ciqCode: "752294"
        },
        {
            codeName: "瓦贾（瑞典）",
            cusCode: "330",
            codeValue: "SWE297",
            gbName: "瓦贾（瑞典）",
            gbCode: "SWE297",
            ciqCode: "752297"
        },
        {
            codeName: "瓦尔港（瑞典）",
            cusCode: "2635",
            codeValue: "SWE300",
            gbName: "瓦尔港（瑞典）",
            gbCode: "SWE300",
            ciqCode: "752300"
        },
        {
            codeName: "喔尔维尔（瑞典）",
            cusCode: "330",
            codeValue: "SWE303",
            gbName: "喔尔维尔（瑞典）",
            gbCode: "SWE303",
            ciqCode: "752303"
        },
        {
            codeName: "韦斯特维克（瑞典）",
            cusCode: "2636",
            codeValue: "SWE306",
            gbName: "韦斯特维克（瑞典）",
            gbCode: "SWE306",
            ciqCode: "752306"
        },
        {
            codeName: "于斯塔德（瑞典）",
            cusCode: "2638",
            codeValue: "SWE309",
            gbName: "于斯塔德（瑞典）",
            gbCode: "SWE309",
            ciqCode: "752309"
        },
        {
            codeName: "HJO（瑞典）",
            cusCode: "2557",
            codeValue: "SWE312",
            gbName: "HJO（瑞典）",
            gbCode: "SWE312",
            ciqCode: "752312"
        },
        {
            codeName: "伦斯卡（瑞典）",
            cusCode: "2597",
            codeValue: "SWE318",
            gbName: "伦斯卡（瑞典）",
            gbCode: "SWE318",
            ciqCode: "752318"
        },
        {
            codeName: "罗内比（瑞典）",
            cusCode: "2596",
            codeValue: "SWE321",
            gbName: "罗内比（瑞典）",
            gbCode: "SWE321",
            ciqCode: "752321"
        },
        {
            codeName: "马里厄斯塔德（瑞典）",
            cusCode: "2582",
            codeValue: "SWE324",
            gbName: "马里厄斯塔德（瑞典）",
            gbCode: "SWE324",
            ciqCode: "752324"
        },
        {
            codeName: "散维克（瑞典）",
            cusCode: "2599",
            codeValue: "SWE330",
            gbName: "散维克（瑞典）",
            gbCode: "SWE330",
            ciqCode: "752330"
        },
        {
            codeName: "特罗尔黑特运河（瑞典）",
            cusCode: "2623",
            codeValue: "SWE333",
            gbName: "特罗尔黑特运河（瑞典）",
            gbCode: "SWE333",
            ciqCode: "752333"
        },
        {
            codeName: "瓦尔维克（瑞典）",
            cusCode: "2629",
            codeValue: "SWE336",
            gbName: "瓦尔维克（瑞典）",
            gbCode: "SWE336",
            ciqCode: "752336"
        },
        {
            codeName: "韦纳斯堡（瑞典）",
            cusCode: "2630",
            codeValue: "SWE339",
            gbName: "韦纳斯堡（瑞典）",
            gbCode: "SWE339",
            ciqCode: "752339"
        },
        {
            codeName: "斯威士兰",
            cusCode: "257",
            codeValue: "SWZ000",
            gbName: "斯威士兰",
            gbCode: "SWZ000",
            ciqCode: "748000"
        },
        {
            codeName: "荷属圣马丁",
            cusCode: "454",
            codeValue: "SXM000",
            gbName: "荷属圣马丁",
            gbCode: "SXM000",
            ciqCode: "534000"
        },
        {
            codeName: "塞舌尔",
            cusCode: "241",
            codeValue: "SYC000",
            gbName: "塞舌尔",
            gbCode: "SYC000",
            ciqCode: "690000"
        },
        {
            codeName: "维多利亚港（塞舌尔）",
            cusCode: "241",
            codeValue: "SYC003",
            gbName: "维多利亚港（塞舌尔）",
            gbCode: "SYC003",
            ciqCode: "690003"
        },
        {
            codeName: "维多利亚（塞舌尔）",
            cusCode: "1742",
            codeValue: "SYC901",
            gbName: "维多利亚（塞舌尔）",
            gbCode: "SYC901",
            ciqCode: "690901"
        },
        {
            codeName: "叙利亚",
            cusCode: "135",
            codeValue: "SYR000",
            gbName: "叙利亚",
            gbCode: "SYR000",
            ciqCode: "760000"
        },
        {
            codeName: "大马士革（叙利亚）",
            cusCode: "1493",
            codeValue: "SYR001",
            gbName: "大马士革（叙利亚）",
            gbCode: "SYR001",
            ciqCode: "760001"
        },
        {
            codeName: "巴尼亚斯（叙利亚）",
            cusCode: "1492",
            codeValue: "SYR003",
            gbName: "巴尼亚斯（叙利亚）",
            gbCode: "SYR003",
            ciqCode: "760003"
        },
        {
            codeName: "拉塔基亚（叙利亚）",
            cusCode: "1494",
            codeValue: "SYR006",
            gbName: "拉塔基亚（叙利亚）",
            gbCode: "SYR006",
            ciqCode: "760006"
        },
        {
            codeName: "塔尔图斯（叙利亚）",
            cusCode: "1495",
            codeValue: "SYR009",
            gbName: "塔尔图斯（叙利亚）",
            gbCode: "SYR009",
            ciqCode: "760009"
        },
        {
            codeName: "特克斯和凯科斯群岛",
            cusCode: "443",
            codeValue: "TCA000",
            gbName: "特克斯和凯科斯群岛",
            gbCode: "TCA000",
            ciqCode: "796000"
        },
        {
            codeName: "大特克（特克斯和凯科斯群岛）",
            cusCode: "2953",
            codeValue: "TCA003",
            gbName: "大特克（特克斯和凯科斯群岛）",
            gbCode: "TCA003",
            ciqCode: "796003"
        },
        {
            codeName: "乍得",
            cusCode: "211",
            codeValue: "TCD000",
            gbName: "乍得",
            gbCode: "TCD000",
            ciqCode: "148000"
        },
        {
            codeName: "ATI（乍得）",
            cusCode: "1604",
            codeValue: "TCD001",
            gbName: "ATI（乍得）",
            gbCode: "TCD001",
            ciqCode: "148001"
        },
        {
            codeName: "多哥",
            cusCode: "248",
            codeValue: "TGO000",
            gbName: "多哥",
            gbCode: "TGO000",
            ciqCode: "768000"
        },
        {
            codeName: "佩梅（多哥）",
            cusCode: "248",
            codeValue: "TGO003",
            gbName: "佩梅（多哥）",
            gbCode: "TGO003",
            ciqCode: "768003"
        },
        {
            codeName: "洛美（多哥）",
            cusCode: "1771",
            codeValue: "TGO006",
            gbName: "洛美（多哥）",
            gbCode: "TGO006",
            ciqCode: "768006"
        },
        {
            codeName: "小波波（多哥）",
            cusCode: "1773",
            codeValue: "TGO009",
            gbName: "小波波（多哥）",
            gbCode: "TGO009",
            ciqCode: "768009"
        },
        {
            codeName: "阿内乔（多哥）",
            cusCode: "1772",
            codeValue: "TGO012",
            gbName: "阿内乔（多哥）",
            gbCode: "TGO012",
            ciqCode: "768012"
        },
        {
            codeName: "泰国",
            cusCode: "136",
            codeValue: "THA000",
            gbName: "泰国",
            gbCode: "THA000",
            ciqCode: "764000"
        },
        {
            codeName: "曼谷（泰国）",
            cusCode: "1497",
            codeValue: "THA003",
            gbName: "曼谷（泰国）",
            gbCode: "THA003",
            ciqCode: "764003"
        },
        {
            codeName: "林查班（泰国）",
            cusCode: "136",
            codeValue: "THA005",
            gbName: "林查班（泰国）",
            gbCode: "THA005",
            ciqCode: "764005"
        },
        {
            codeName: "干当（泰国）",
            cusCode: "136",
            codeValue: "THA006",
            gbName: "干当（泰国）",
            gbCode: "THA006",
            ciqCode: "764006"
        },
        {
            codeName: "锡昌岛（泰国）",
            cusCode: "136",
            codeValue: "THA009",
            gbName: "锡昌岛（泰国）",
            gbCode: "THA009",
            ciqCode: "764009"
        },
        {
            codeName: "那拉提瓦（泰国）",
            cusCode: "136",
            codeValue: "THA012",
            gbName: "那拉提瓦（泰国）",
            gbCode: "THA012",
            ciqCode: "764012"
        },
        {
            codeName: "北榄（泰国）",
            cusCode: "136",
            codeValue: "THA015",
            gbName: "北榄（泰国）",
            gbCode: "THA015",
            ciqCode: "764015"
        },
        {
            codeName: "北大年（泰国）",
            cusCode: "1498",
            codeValue: "THA018",
            gbName: "北大年（泰国）",
            gbCode: "THA018",
            ciqCode: "764018"
        },
        {
            codeName: "普吉（泰国）",
            cusCode: "1499",
            codeValue: "THA021",
            gbName: "普吉（泰国）",
            gbCode: "THA021",
            ciqCode: "764021"
        },
        {
            codeName: "棱桃邑（泰国）",
            cusCode: "1500",
            codeValue: "THA024",
            gbName: "棱桃邑（泰国）",
            gbCode: "THA024",
            ciqCode: "764024"
        },
        {
            codeName: "是拉差（泰国）",
            cusCode: "1501",
            codeValue: "THA027",
            gbName: "是拉差（泰国）",
            gbCode: "THA027",
            ciqCode: "764027"
        },
        {
            codeName: "宋卡（泰国）",
            cusCode: "1502",
            codeValue: "THA030",
            gbName: "宋卡（泰国）",
            gbCode: "THA030",
            ciqCode: "764030"
        },
        {
            codeName: "斯瑞拉察（泰国）",
            cusCode: "136",
            codeValue: "THA033",
            gbName: "斯瑞拉察（泰国）",
            gbCode: "THA033",
            ciqCode: "764033"
        },
        {
            codeName: "AYUTTHSYA（泰国）",
            cusCode: "1496",
            codeValue: "THA036",
            gbName: "AYUTTHSYA（泰国）",
            gbCode: "THA036",
            ciqCode: "764036"
        },
        {
            codeName: "塔吉克斯坦",
            cusCode: "147",
            codeValue: "TJK000",
            gbName: "塔吉克斯坦",
            gbCode: "TJK000",
            ciqCode: "762000"
        },
        {
            codeName: "卡拉苏（塔吉克斯坦）",
            cusCode: "147",
            codeValue: "TJK901",
            gbName: "卡拉苏（塔吉克斯坦）",
            gbCode: "TJK901",
            ciqCode: "762901"
        },
        {
            codeName: "托克劳",
            cusCode: "634",
            codeValue: "TKL000",
            gbName: "托克劳",
            gbCode: "TKL000",
            ciqCode: "772000"
        },
        {
            codeName: "阿塔富（托克劳）",
            cusCode: "634",
            codeValue: "TKL003",
            gbName: "阿塔富（托克劳）",
            gbCode: "TKL003",
            ciqCode: "772003"
        },
        {
            codeName: "托克劳群岛（托克劳）",
            cusCode: "3407",
            codeValue: "TKL004",
            gbName: "托克劳群岛（托克劳）",
            gbCode: "TKL004",
            ciqCode: "772004"
        },
        {
            codeName: "土库曼斯坦",
            cusCode: "148",
            codeValue: "TKM000",
            gbName: "土库曼斯坦",
            gbCode: "TKM000",
            ciqCode: "795000"
        },
        {
            codeName: "东帝汶",
            cusCode: "144",
            codeValue: "TLS000",
            gbName: "东帝汶",
            gbCode: "TLS000",
            ciqCode: "626000"
        },
        {
            codeName: "帝力（东帝汶）",
            cusCode: "144",
            codeValue: "TLS003",
            gbName: "帝力（东帝汶）",
            gbCode: "TLS003",
            ciqCode: "626003"
        },
        {
            codeName: "汤加",
            cusCode: "614",
            codeValue: "TON000",
            gbName: "汤加",
            gbCode: "TON000",
            ciqCode: "776000"
        },
        {
            codeName: "内亚富（汤加）",
            cusCode: "3341",
            codeValue: "TON003",
            gbName: "内亚富（汤加）",
            gbCode: "TON003",
            ciqCode: "776003"
        },
        {
            codeName: "诺穆卡岛（汤加）",
            cusCode: "3344",
            codeValue: "TON006",
            gbName: "诺穆卡岛（汤加）",
            gbCode: "TON006",
            ciqCode: "776006"
        },
        {
            codeName: "努库阿洛法（汤加）",
            cusCode: "3342",
            codeValue: "TON009",
            gbName: "努库阿洛法（汤加）",
            gbCode: "TON009",
            ciqCode: "776009"
        },
        {
            codeName: "庞艾（汤加）",
            cusCode: "3343",
            codeValue: "TON012",
            gbName: "庞艾（汤加）",
            gbCode: "TON012",
            ciqCode: "776012"
        },
        {
            codeName: "瓦瓦乌岛（汤加）",
            cusCode: "3345",
            codeValue: "TON015",
            gbName: "瓦瓦乌岛（汤加）",
            gbCode: "TON015",
            ciqCode: "776015"
        },
        {
            codeName: "特立尼达和多巴哥",
            cusCode: "442",
            codeValue: "TTO000",
            gbName: "特立尼达和多巴哥",
            gbCode: "TTO000",
            ciqCode: "780000"
        },
        {
            codeName: "布赖顿（特立尼达和多巴哥）",
            cusCode: "2951",
            codeValue: "TTO003",
            gbName: "布赖顿（特立尼达和多巴哥）",
            gbCode: "TTO003",
            ciqCode: "780003"
        },
        {
            codeName: "查瓜拉马斯（特立尼达和多巴哥）",
            cusCode: "2948",
            codeValue: "TTO006",
            gbName: "查瓜拉马斯（特立尼达和多巴哥）",
            gbCode: "TTO006",
            ciqCode: "780006"
        },
        {
            codeName: "加莱奥塔角（特立尼达和多巴哥）",
            cusCode: "442",
            codeValue: "TTO009",
            gbName: "加莱奥塔角（特立尼达和多巴哥）",
            gbCode: "TTO009",
            ciqCode: "780009"
        },
        {
            codeName: "普利茅斯（特立尼达和多巴哥）",
            cusCode: "442",
            codeValue: "TTO012",
            gbName: "普利茅斯（特立尼达和多巴哥）",
            gbCode: "TTO012",
            ciqCode: "780012"
        },
        {
            codeName: "福廷角（特立尼达和多巴哥）",
            cusCode: "2946",
            codeValue: "TTO015",
            gbName: "福廷角（特立尼达和多巴哥）",
            gbCode: "TTO015",
            ciqCode: "780015"
        },
        {
            codeName: "利萨斯角（特立尼达和多巴哥）",
            cusCode: "442",
            codeValue: "TTO018",
            gbName: "利萨斯角（特立尼达和多巴哥）",
            gbCode: "TTO018",
            ciqCode: "780018"
        },
        {
            codeName: "皮埃尔角城（特立尼达和多巴哥）",
            cusCode: "2947",
            codeValue: "TTO021",
            gbName: "皮埃尔角城（特立尼达和多巴哥）",
            gbCode: "TTO021",
            ciqCode: "780021"
        },
        {
            codeName: "西班牙港（特立尼达和多巴哥）",
            cusCode: "2949",
            codeValue: "TTO024",
            gbName: "西班牙港（特立尼达和多巴哥）",
            gbCode: "TTO024",
            ciqCode: "780024"
        },
        {
            codeName: "圣费尔南多（特立尼达和多巴哥）",
            cusCode: "2945",
            codeValue: "TTO027",
            gbName: "圣费尔南多（特立尼达和多巴哥）",
            gbCode: "TTO027",
            ciqCode: "780027"
        },
        {
            codeName: "斯卡伯勒（特立尼达和多巴哥）",
            cusCode: "2950",
            codeValue: "TTO030",
            gbName: "斯卡伯勒（特立尼达和多巴哥）",
            gbCode: "TTO030",
            ciqCode: "780030"
        },
        {
            codeName: "滕布拉多腊（特立尼达和多巴哥）",
            cusCode: "2952",
            codeValue: "TTO033",
            gbName: "滕布拉多腊（特立尼达和多巴哥）",
            gbCode: "TTO033",
            ciqCode: "780033"
        },
        {
            codeName: "突尼斯",
            cusCode: "249",
            codeValue: "TUN000",
            gbName: "突尼斯",
            gbCode: "TUN000",
            ciqCode: "788000"
        },
        {
            codeName: "阿什塔特码头（突尼斯）",
            cusCode: "249",
            codeValue: "TUN003",
            gbName: "阿什塔特码头（突尼斯）",
            gbCode: "TUN003",
            ciqCode: "788003"
        },
        {
            codeName: "比塞大（突尼斯）",
            cusCode: "1774",
            codeValue: "TUN006",
            gbName: "比塞大（突尼斯）",
            gbCode: "TUN006",
            ciqCode: "788006"
        },
        {
            codeName: "杰尔巴岛（突尼斯）",
            cusCode: "249",
            codeValue: "TUN009",
            gbName: "杰尔巴岛（突尼斯）",
            gbCode: "TUN009",
            ciqCode: "788009"
        },
        {
            codeName: "加贝斯（突尼斯）",
            cusCode: "1775",
            codeValue: "TUN012",
            gbName: "加贝斯（突尼斯）",
            gbCode: "TUN012",
            ciqCode: "788012"
        },
        {
            codeName: "拉古莱特（突尼斯）",
            cusCode: "1776",
            codeValue: "TUN015",
            gbName: "拉古莱特（突尼斯）",
            gbCode: "TUN015",
            ciqCode: "788015"
        },
        {
            codeName: "拉斯基拉（突尼斯）",
            cusCode: "1777",
            codeValue: "TUN018",
            gbName: "拉斯基拉（突尼斯）",
            gbCode: "TUN018",
            ciqCode: "788018"
        },
        {
            codeName: "斯法克斯（突尼斯）",
            cusCode: "1778",
            codeValue: "TUN021",
            gbName: "斯法克斯（突尼斯）",
            gbCode: "TUN021",
            ciqCode: "788021"
        },
        {
            codeName: "苏塞（突尼斯）",
            cusCode: "1779",
            codeValue: "TUN024",
            gbName: "苏塞（突尼斯）",
            gbCode: "TUN024",
            ciqCode: "788024"
        },
        {
            codeName: "突尼斯（突尼斯）",
            cusCode: "1781",
            codeValue: "TUN027",
            gbName: "突尼斯（突尼斯）",
            gbCode: "TUN027",
            ciqCode: "788027"
        },
        {
            codeName: "土耳其",
            cusCode: "137",
            codeValue: "TUR000",
            gbName: "土耳其",
            gbCode: "TUR000",
            ciqCode: "792000"
        },
        {
            codeName: "阿拉尼亚（土耳其）",
            cusCode: "137",
            codeValue: "TUR003",
            gbName: "阿拉尼亚（土耳其）",
            gbCode: "TUR003",
            ciqCode: "792003"
        },
        {
            codeName: "阿利亚加（土耳其）",
            cusCode: "137",
            codeValue: "TUR006",
            gbName: "阿利亚加（土耳其）",
            gbCode: "TUR006",
            ciqCode: "792006"
        },
        {
            codeName: "阿马斯腊（土耳其）",
            cusCode: "1505",
            codeValue: "TUR009",
            gbName: "阿马斯腊（土耳其）",
            gbCode: "TUR009",
            ciqCode: "792009"
        },
        {
            codeName: "安塔利亚（土耳其）",
            cusCode: "1506",
            codeValue: "TUR012",
            gbName: "安塔利亚（土耳其）",
            gbCode: "TUR012",
            ciqCode: "792012"
        },
        {
            codeName: "艾瓦勒克（土耳其）",
            cusCode: "137",
            codeValue: "TUR015",
            gbName: "艾瓦勒克（土耳其）",
            gbCode: "TUR015",
            ciqCode: "792015"
        },
        {
            codeName: "班德尔马（土耳其）",
            cusCode: "1507",
            codeValue: "TUR018",
            gbName: "班德尔马（土耳其）",
            gbCode: "TUR018",
            ciqCode: "792018"
        },
        {
            codeName: "恰纳卡莱（土耳其）",
            cusCode: "137",
            codeValue: "TUR021",
            gbName: "恰纳卡莱（土耳其）",
            gbCode: "TUR021",
            ciqCode: "792021"
        },
        {
            codeName: "吉代（土耳其）",
            cusCode: "137",
            codeValue: "TUR024",
            gbName: "吉代（土耳其）",
            gbCode: "TUR024",
            ciqCode: "792024"
        },
        {
            codeName: "代林杰（土耳其）",
            cusCode: "1509",
            codeValue: "TUR027",
            gbName: "代林杰（土耳其）",
            gbCode: "TUR027",
            ciqCode: "792027"
        },
        {
            codeName: "迪基利（土耳其）",
            cusCode: "137",
            codeValue: "TUR030",
            gbName: "迪基利（土耳其）",
            gbCode: "TUR030",
            ciqCode: "792030"
        },
        {
            codeName: "德尔特约尔（土耳其）",
            cusCode: "137",
            codeValue: "TUR033",
            gbName: "德尔特约尔（土耳其）",
            gbCode: "TUR033",
            ciqCode: "792033"
        },
        {
            codeName: "埃丁吉克（土耳其）",
            cusCode: "137",
            codeValue: "TUR036",
            gbName: "埃丁吉克（土耳其）",
            gbCode: "TUR036",
            ciqCode: "792036"
        },
        {
            codeName: "埃雷利（土耳其）",
            cusCode: "1510",
            codeValue: "TUR039",
            gbName: "埃雷利（土耳其）",
            gbCode: "TUR039",
            ciqCode: "792039"
        },
        {
            codeName: "法特萨（土耳其）",
            cusCode: "1511",
            codeValue: "TUR042",
            gbName: "法特萨（土耳其）",
            gbCode: "TUR042",
            ciqCode: "792042"
        },
        {
            codeName: "费特希耶（土耳其）",
            cusCode: "137",
            codeValue: "TUR045",
            gbName: "费特希耶（土耳其）",
            gbCode: "TUR045",
            ciqCode: "792045"
        },
        {
            codeName: "菲尼凯（土耳其）",
            cusCode: "137",
            codeValue: "TUR048",
            gbName: "菲尼凯（土耳其）",
            gbCode: "TUR048",
            ciqCode: "792048"
        },
        {
            codeName: "盖利博卢（土耳其）",
            cusCode: "137",
            codeValue: "TUR051",
            gbName: "盖利博卢（土耳其）",
            gbCode: "TUR051",
            ciqCode: "792051"
        },
        {
            codeName: "盖姆利克（土耳其）",
            cusCode: "1513",
            codeValue: "TUR054",
            gbName: "盖姆利克（土耳其）",
            gbCode: "TUR054",
            ciqCode: "792054"
        },
        {
            codeName: "吉雷松（土耳其）",
            cusCode: "1512",
            codeValue: "TUR057",
            gbName: "吉雷松（土耳其）",
            gbCode: "TUR057",
            ciqCode: "792057"
        },
        {
            codeName: "戈西克（土耳其）",
            cusCode: "137",
            codeValue: "TUR060",
            gbName: "戈西克（土耳其）",
            gbCode: "TUR060",
            ciqCode: "792060"
        },
        {
            codeName: "格尔居克（土耳其）",
            cusCode: "137",
            codeValue: "TUR063",
            gbName: "格尔居克（土耳其）",
            gbCode: "TUR063",
            ciqCode: "792063"
        },
        {
            codeName: "格雷莱（土耳其）",
            cusCode: "137",
            codeValue: "TUR066",
            gbName: "格雷莱（土耳其）",
            gbCode: "TUR066",
            ciqCode: "792066"
        },
        {
            codeName: "居吕克（土耳其）",
            cusCode: "137",
            codeValue: "TUR069",
            gbName: "居吕克（土耳其）",
            gbCode: "TUR069",
            ciqCode: "792069"
        },
        {
            codeName: "海达尔帕夏（土耳其）",
            cusCode: "1514",
            codeValue: "TUR072",
            gbName: "海达尔帕夏（土耳其）",
            gbCode: "TUR072",
            ciqCode: "792072"
        },
        {
            codeName: "海雷凯（土耳其）",
            cusCode: "137",
            codeValue: "TUR075",
            gbName: "海雷凯（土耳其）",
            gbCode: "TUR075",
            ciqCode: "792075"
        },
        {
            codeName: "霍帕（土耳其）",
            cusCode: "1515",
            codeValue: "TUR078",
            gbName: "霍帕（土耳其）",
            gbCode: "TUR078",
            ciqCode: "792078"
        },
        {
            codeName: "伊内博卢（土耳其）",
            cusCode: "1516",
            codeValue: "TUR081",
            gbName: "伊内博卢（土耳其）",
            gbCode: "TUR081",
            ciqCode: "792081"
        },
        {
            codeName: "伊斯肯德伦（土耳其）",
            cusCode: "1517",
            codeValue: "TUR084",
            gbName: "伊斯肯德伦（土耳其）",
            gbCode: "TUR084",
            ciqCode: "792084"
        },
        {
            codeName: "伊斯坦布尔（土耳其）",
            cusCode: "1518",
            codeValue: "TUR087",
            gbName: "伊斯坦布尔（土耳其）",
            gbCode: "TUR087",
            ciqCode: "792087"
        },
        {
            codeName: "伊兹密尔（土耳其）",
            cusCode: "1519",
            codeValue: "TUR090",
            gbName: "伊兹密尔（土耳其）",
            gbCode: "TUR090",
            ciqCode: "792090"
        },
        {
            codeName: "伊兹米特（土耳其）",
            cusCode: "137",
            codeValue: "TUR093",
            gbName: "伊兹米特（土耳其）",
            gbCode: "TUR093",
            ciqCode: "792093"
        },
        {
            codeName: "库沙达瑟（土耳其）",
            cusCode: "137",
            codeValue: "TUR096",
            gbName: "库沙达瑟（土耳其）",
            gbCode: "TUR096",
            ciqCode: "792096"
        },
        {
            codeName: "马尔马里斯（土耳其）",
            cusCode: "1522",
            codeValue: "TUR099",
            gbName: "马尔马里斯（土耳其）",
            gbCode: "TUR099",
            ciqCode: "792099"
        },
        {
            codeName: "梅尔辛（土耳其）",
            cusCode: "1523",
            codeValue: "TUR102",
            gbName: "梅尔辛（土耳其）",
            gbCode: "TUR102",
            ciqCode: "792102"
        },
        {
            codeName: "穆达尼亚（土耳其）",
            cusCode: "1524",
            codeValue: "TUR105",
            gbName: "穆达尼亚（土耳其）",
            gbCode: "TUR105",
            ciqCode: "792105"
        },
        {
            codeName: "奥尔杜（土耳其）",
            cusCode: "1525",
            codeValue: "TUR108",
            gbName: "奥尔杜（土耳其）",
            gbCode: "TUR108",
            ciqCode: "792108"
        },
        {
            codeName: "里泽（土耳其）",
            cusCode: "1526",
            codeValue: "TUR111",
            gbName: "里泽（土耳其）",
            gbCode: "TUR111",
            ciqCode: "792111"
        },
        {
            codeName: "萨姆松（土耳其）",
            cusCode: "1527",
            codeValue: "TUR114",
            gbName: "萨姆松（土耳其）",
            gbCode: "TUR114",
            ciqCode: "792114"
        },
        {
            codeName: "锡诺普（土耳其）",
            cusCode: "1528",
            codeValue: "TUR117",
            gbName: "锡诺普（土耳其）",
            gbCode: "TUR117",
            ciqCode: "792117"
        },
        {
            codeName: "塔舒朱（土耳其）",
            cusCode: "137",
            codeValue: "TUR120",
            gbName: "塔舒朱（土耳其）",
            gbCode: "TUR120",
            ciqCode: "792120"
        },
        {
            codeName: "泰基尔达（土耳其）",
            cusCode: "1530",
            codeValue: "TUR123",
            gbName: "泰基尔达（土耳其）",
            gbCode: "TUR123",
            ciqCode: "792123"
        },
        {
            codeName: "蒂雷博卢（土耳其）",
            cusCode: "1531",
            codeValue: "TUR126",
            gbName: "蒂雷博卢（土耳其）",
            gbCode: "TUR126",
            ciqCode: "792126"
        },
        {
            codeName: "特拉布宗（土耳其）",
            cusCode: "1533",
            codeValue: "TUR129",
            gbName: "特拉布宗（土耳其）",
            gbCode: "TUR129",
            ciqCode: "792129"
        },
        {
            codeName: "图吞西夫特利克（土耳其）",
            cusCode: "137",
            codeValue: "TUR132",
            gbName: "图吞西夫特利克（土耳其）",
            gbCode: "TUR132",
            ciqCode: "792132"
        },
        {
            codeName: "云耶（土耳其）",
            cusCode: "1534",
            codeValue: "TUR135",
            gbName: "云耶（土耳其）",
            gbCode: "TUR135",
            ciqCode: "792135"
        },
        {
            codeName: "于斯屈达尔（土耳其）",
            cusCode: "137",
            codeValue: "TUR138",
            gbName: "于斯屈达尔（土耳其）",
            gbCode: "TUR138",
            ciqCode: "792138"
        },
        {
            codeName: "亚勒姆贾（土耳其）",
            cusCode: "137",
            codeValue: "TUR141",
            gbName: "亚勒姆贾（土耳其）",
            gbCode: "TUR141",
            ciqCode: "792141"
        },
        {
            codeName: "宗古尔达克（土耳其）",
            cusCode: "1537",
            codeValue: "TUR144",
            gbName: "宗古尔达克（土耳其）",
            gbCode: "TUR144",
            ciqCode: "792144"
        },
        {
            codeName: "阿达比亚（土耳其）",
            cusCode: "1503",
            codeValue: "TUR147",
            gbName: "阿达比亚（土耳其）",
            gbCode: "TUR147",
            ciqCode: "792147"
        },
        {
            codeName: "澳纳（土耳其）",
            cusCode: "1536",
            codeValue: "TUR150",
            gbName: "澳纳（土耳其）",
            gbCode: "TUR150",
            ciqCode: "792150"
        },
        {
            codeName: "地里斯凯里斯（土耳其）",
            cusCode: "1508",
            codeValue: "TUR153",
            gbName: "地里斯凯里斯（土耳其）",
            gbCode: "TUR153",
            ciqCode: "792153"
        },
        {
            codeName: "卡拉（土耳其）",
            cusCode: "1520",
            codeValue: "TUR156",
            gbName: "卡拉（土耳其）",
            gbCode: "TUR156",
            ciqCode: "792156"
        },
        {
            codeName: "开塞利（土耳其）",
            cusCode: "1521",
            codeValue: "TUR159",
            gbName: "开塞利（土耳其）",
            gbCode: "TUR159",
            ciqCode: "792159"
        },
        {
            codeName: "特拉帕尼（土耳其）",
            cusCode: "1532",
            codeValue: "TUR162",
            gbName: "特拉帕尼（土耳其）",
            gbCode: "TUR162",
            ciqCode: "792162"
        },
        {
            codeName: "图瓦卢",
            cusCode: "619",
            codeValue: "TUV000",
            gbName: "图瓦卢",
            gbCode: "TUV000",
            ciqCode: "798000"
        },
        {
            codeName: "纳努梅阿岛（图瓦卢）",
            cusCode: "3383",
            codeValue: "TUV001",
            gbName: "纳努梅阿岛（图瓦卢）",
            gbCode: "TUV001",
            ciqCode: "798001"
        },
        {
            codeName: "努库费塔乌岛（图瓦卢）",
            cusCode: "3384",
            codeValue: "TUV002",
            gbName: "努库费塔乌岛（图瓦卢）",
            gbCode: "TUV002",
            ciqCode: "798002"
        },
        {
            codeName: "富纳富提（图瓦卢）",
            cusCode: "619",
            codeValue: "TUV003",
            gbName: "富纳富提（图瓦卢）",
            gbCode: "TUV003",
            ciqCode: "798003"
        },
        {
            codeName: "中国台湾",
            cusCode: "143",
            codeValue: "TWN000",
            gbName: "中国台湾",
            gbCode: "TWN000",
            ciqCode: "158000"
        },
        {
            codeName: "台北（中国台湾）",
            cusCode: "143",
            codeValue: "TWN103",
            gbName: "台北（中国台湾）",
            gbCode: "TWN103",
            ciqCode: "158103"
        },
        {
            codeName: "基隆（中国台湾）",
            cusCode: "1561",
            codeValue: "TWN107",
            gbName: "基隆（中国台湾）",
            gbCode: "TWN107",
            ciqCode: "158107"
        },
        {
            codeName: "苏奥（中国台湾）",
            cusCode: "143",
            codeValue: "TWN114",
            gbName: "苏奥（中国台湾）",
            gbCode: "TWN114",
            ciqCode: "158114"
        },
        {
            codeName: "花莲（中国台湾）",
            cusCode: "143",
            codeValue: "TWN121",
            gbName: "花莲（中国台湾）",
            gbCode: "TWN121",
            ciqCode: "158121"
        },
        {
            codeName: "高雄（中国台湾）",
            cusCode: "1560",
            codeValue: "TWN128",
            gbName: "高雄（中国台湾）",
            gbCode: "TWN128",
            ciqCode: "158128"
        },
        {
            codeName: "台南（中国台湾）",
            cusCode: "143",
            codeValue: "TWN135",
            gbName: "台南（中国台湾）",
            gbCode: "TWN135",
            ciqCode: "158135"
        },
        {
            codeName: "澎湖（中国台湾）",
            cusCode: "143",
            codeValue: "TWN142",
            gbName: "澎湖（中国台湾）",
            gbCode: "TWN142",
            ciqCode: "158142"
        },
        {
            codeName: "台中（中国台湾）",
            cusCode: "3416",
            codeValue: "TWN149",
            gbName: "台中（中国台湾）",
            gbCode: "TWN149",
            ciqCode: "158149"
        },
        {
            codeName: "坦桑尼亚",
            cusCode: "247",
            codeValue: "TZA000",
            gbName: "坦桑尼亚",
            gbCode: "TZA000",
            ciqCode: "834000"
        },
        {
            codeName: "达累斯萨拉姆（坦桑尼亚）",
            cusCode: "1762",
            codeValue: "TZA003",
            gbName: "达累斯萨拉姆（坦桑尼亚）",
            gbCode: "TZA003",
            ciqCode: "834003"
        },
        {
            codeName: "基卢瓦基温杰（坦桑尼亚）",
            cusCode: "1763",
            codeValue: "TZA006",
            gbName: "基卢瓦基温杰（坦桑尼亚）",
            gbCode: "TZA006",
            ciqCode: "834006"
        },
        {
            codeName: "基卢瓦马索科（坦桑尼亚）",
            cusCode: "1764",
            codeValue: "TZA009",
            gbName: "基卢瓦马索科（坦桑尼亚）",
            gbCode: "TZA009",
            ciqCode: "834009"
        },
        {
            codeName: "林迪（坦桑尼亚）",
            cusCode: "1765",
            codeValue: "TZA012",
            gbName: "林迪（坦桑尼亚）",
            gbCode: "TZA012",
            ciqCode: "834012"
        },
        {
            codeName: "米金达尼（坦桑尼亚）",
            cusCode: "247",
            codeValue: "TZA015",
            gbName: "米金达尼（坦桑尼亚）",
            gbCode: "TZA015",
            ciqCode: "834015"
        },
        {
            codeName: "姆特瓦拉（坦桑尼亚）",
            cusCode: "1766",
            codeValue: "TZA018",
            gbName: "姆特瓦拉（坦桑尼亚）",
            gbCode: "TZA018",
            ciqCode: "834018"
        },
        {
            codeName: "潘加尼（坦桑尼亚）",
            cusCode: "1767",
            codeValue: "TZA021",
            gbName: "潘加尼（坦桑尼亚）",
            gbCode: "TZA021",
            ciqCode: "834021"
        },
        {
            codeName: "奔巴岛（坦桑尼亚）",
            cusCode: "1768",
            codeValue: "TZA024",
            gbName: "奔巴岛（坦桑尼亚）",
            gbCode: "TZA024",
            ciqCode: "834024"
        },
        {
            codeName: "坦噶（坦桑尼亚）",
            cusCode: "1769",
            codeValue: "TZA027",
            gbName: "坦噶（坦桑尼亚）",
            gbCode: "TZA027",
            ciqCode: "834027"
        },
        {
            codeName: "桑给巴尔岛（坦桑尼亚）",
            cusCode: "1770",
            codeValue: "TZA030",
            gbName: "桑给巴尔岛（坦桑尼亚）",
            gbCode: "TZA030",
            ciqCode: "834030"
        },
        {
            codeName: "乌干达",
            cusCode: "250",
            codeValue: "UGA000",
            gbName: "乌干达",
            gbCode: "UGA000",
            ciqCode: "800000"
        },
        {
            codeName: "乌克兰",
            cusCode: "347",
            codeValue: "UKR000",
            gbName: "乌克兰",
            gbCode: "UKR000",
            ciqCode: "804000"
        },
        {
            codeName: "别尔哥罗德德涅斯罗夫（乌克兰）",
            cusCode: "347",
            codeValue: "UKR003",
            gbName: "别尔哥罗德德涅斯罗夫（乌克兰）",
            gbCode: "UKR003",
            ciqCode: "804003"
        },
        {
            codeName: "别尔江斯克（乌克兰）",
            cusCode: "347",
            codeValue: "UKR006",
            gbName: "别尔江斯克（乌克兰）",
            gbCode: "UKR006",
            ciqCode: "804006"
        },
        {
            codeName: "伊利乔夫斯克（乌克兰）",
            cusCode: "347",
            codeValue: "UKR009",
            gbName: "伊利乔夫斯克（乌克兰）",
            gbCode: "UKR009",
            ciqCode: "804009"
        },
        {
            codeName: "伊兹梅尔（乌克兰）",
            cusCode: "347",
            codeValue: "UKR012",
            gbName: "伊兹梅尔（乌克兰）",
            gbCode: "UKR012",
            ciqCode: "804012"
        },
        {
            codeName: "刻赤（乌克兰）",
            cusCode: "2648",
            codeValue: "UKR015",
            gbName: "刻赤（乌克兰）",
            gbCode: "UKR015",
            ciqCode: "804015"
        },
        {
            codeName: "赫尔松（乌克兰）",
            cusCode: "347",
            codeValue: "UKR018",
            gbName: "赫尔松（乌克兰）",
            gbCode: "UKR018",
            ciqCode: "804018"
        },
        {
            codeName: "马里乌波尔（乌克兰）",
            cusCode: "3432",
            codeValue: "UKR020",
            gbName: "马里乌波尔（乌克兰）",
            gbCode: "UKR020",
            ciqCode: "804020"
        },
        {
            codeName: "基里拉（乌克兰）",
            cusCode: "347",
            codeValue: "UKR021",
            gbName: "基里拉（乌克兰）",
            gbCode: "UKR021",
            ciqCode: "804021"
        },
        {
            codeName: "尼古拉耶夫（乌克兰）",
            cusCode: "347",
            codeValue: "UKR024",
            gbName: "尼古拉耶夫（乌克兰）",
            gbCode: "UKR024",
            ciqCode: "804024"
        },
        {
            codeName: "敖德萨（乌克兰）",
            cusCode: "2659",
            codeValue: "UKR027",
            gbName: "敖德萨（乌克兰）",
            gbCode: "UKR027",
            ciqCode: "804027"
        },
        {
            codeName: "烈尼（乌克兰）",
            cusCode: "347",
            codeValue: "UKR030",
            gbName: "烈尼（乌克兰）",
            gbCode: "UKR030",
            ciqCode: "804030"
        },
        {
            codeName: "塞瓦斯托波尔（乌克兰）",
            cusCode: "2665",
            codeValue: "UKR033",
            gbName: "塞瓦斯托波尔（乌克兰）",
            gbCode: "UKR033",
            ciqCode: "804033"
        },
        {
            codeName: "斯卡多夫斯克（乌克兰）",
            cusCode: "347",
            codeValue: "UKR036",
            gbName: "斯卡多夫斯克（乌克兰）",
            gbCode: "UKR036",
            ciqCode: "804036"
        },
        {
            codeName: "费奥多西亚（乌克兰）",
            cusCode: "347",
            codeValue: "UKR039",
            gbName: "费奥多西亚（乌克兰）",
            gbCode: "UKR039",
            ciqCode: "804039"
        },
        {
            codeName: "乌斯列戈尔斯克（乌克兰）",
            cusCode: "347",
            codeValue: "UKR042",
            gbName: "乌斯列戈尔斯克（乌克兰）",
            gbCode: "UKR042",
            ciqCode: "804042"
        },
        {
            codeName: "雅尔塔（乌克兰）",
            cusCode: "2675",
            codeValue: "UKR045",
            gbName: "雅尔塔（乌克兰）",
            gbCode: "UKR045",
            ciqCode: "804045"
        },
        {
            codeName: "尤日内（乌克兰）",
            cusCode: "347",
            codeValue: "UKR048",
            gbName: "尤日内（乌克兰）",
            gbCode: "UKR048",
            ciqCode: "804048"
        },
        {
            codeName: "美国本土外小岛屿",
            cusCode: "635",
            codeValue: "UMI000",
            gbName: "美国本土外小岛屿",
            gbCode: "UMI000",
            ciqCode: "581000"
        },
        {
            codeName: "希洛（美国本土外小岛屿）",
            cusCode: "3140",
            codeValue: "UMI003",
            gbName: "希洛（美国本土外小岛屿）",
            gbCode: "UMI003",
            ciqCode: "581003"
        },
        {
            codeName: "火奴鲁鲁（美国本土外小岛屿）",
            cusCode: "635",
            codeValue: "UMI006",
            gbName: "火奴鲁鲁（美国本土外小岛屿）",
            gbCode: "UMI006",
            ciqCode: "581006"
        },
        {
            codeName: "卡胡卢伊（美国本土外小岛屿）",
            cusCode: "635",
            codeValue: "UMI009",
            gbName: "卡胡卢伊（美国本土外小岛屿）",
            gbCode: "UMI009",
            ciqCode: "581009"
        },
        {
            codeName: "纳威利威利（美国本土外小岛屿）",
            cusCode: "3162",
            codeValue: "UMI012",
            gbName: "纳威利威利（美国本土外小岛屿）",
            gbCode: "UMI012",
            ciqCode: "581012"
        },
        {
            codeName: "巴尔米拉岛（美国本土外小岛屿）",
            cusCode: "3400",
            codeValue: "UMI013",
            gbName: "巴尔米拉岛（美国本土外小岛屿）",
            gbCode: "UMI013",
            ciqCode: "581013"
        },
        {
            codeName: "威克岛（美国本土外小岛屿）",
            cusCode: "3411",
            codeValue: "UMI014",
            gbName: "威克岛（美国本土外小岛屿）",
            gbCode: "UMI014",
            ciqCode: "581014"
        },
        {
            codeName: "约翰斯顿岛（美国本土外小岛屿）",
            cusCode: "3389",
            codeValue: "UMI015",
            gbName: "约翰斯顿岛（美国本土外小岛屿）",
            gbCode: "UMI015",
            ciqCode: "581015"
        },
        {
            codeName: "中途岛（美国本土外小岛屿）",
            cusCode: "3395",
            codeValue: "UMI016",
            gbName: "中途岛（美国本土外小岛屿）",
            gbCode: "UMI016",
            ciqCode: "581016"
        },
        {
            codeName: "乌拉圭",
            cusCode: "444",
            codeValue: "URY000",
            gbName: "乌拉圭",
            gbCode: "URY000",
            ciqCode: "858000"
        },
        {
            codeName: "科洛尼亚（乌拉圭）",
            cusCode: "2954",
            codeValue: "URY003",
            gbName: "科洛尼亚（乌拉圭）",
            gbCode: "URY003",
            ciqCode: "858003"
        },
        {
            codeName: "弗赖本托斯（乌拉圭）",
            cusCode: "444",
            codeValue: "URY006",
            gbName: "弗赖本托斯（乌拉圭）",
            gbCode: "URY006",
            ciqCode: "858006"
        },
        {
            codeName: "何塞伊格纳西奥（乌拉圭）",
            cusCode: "2955",
            codeValue: "URY009",
            gbName: "何塞伊格纳西奥（乌拉圭）",
            gbCode: "URY009",
            ciqCode: "858009"
        },
        {
            codeName: "马尔多纳多（乌拉圭）",
            cusCode: "2956",
            codeValue: "URY012",
            gbName: "马尔多纳多（乌拉圭）",
            gbCode: "URY012",
            ciqCode: "858012"
        },
        {
            codeName: "蒙得维的亚（乌拉圭）",
            cusCode: "2957",
            codeValue: "URY015",
            gbName: "蒙得维的亚（乌拉圭）",
            gbCode: "URY015",
            ciqCode: "858015"
        },
        {
            codeName: "新帕尔米拉（乌拉圭）",
            cusCode: "2958",
            codeValue: "URY018",
            gbName: "新帕尔米拉（乌拉圭）",
            gbCode: "URY018",
            ciqCode: "858018"
        },
        {
            codeName: "派桑杜（乌拉圭）",
            cusCode: "2959",
            codeValue: "URY021",
            gbName: "派桑杜（乌拉圭）",
            gbCode: "URY021",
            ciqCode: "858021"
        },
        {
            codeName: "埃斯特角（乌拉圭）",
            cusCode: "444",
            codeValue: "URY024",
            gbName: "埃斯特角（乌拉圭）",
            gbCode: "URY024",
            ciqCode: "858024"
        },
        {
            codeName: "美国",
            cusCode: "502",
            codeValue: "USA000",
            gbName: "美国",
            gbCode: "USA000",
            ciqCode: "840000"
        },
        {
            codeName: "阿伯丁（美国）",
            cusCode: "502",
            codeValue: "USA003",
            gbName: "阿伯丁（美国）",
            gbCode: "USA003",
            ciqCode: "840003"
        },
        {
            codeName: "阿拉梅达（美国）",
            cusCode: "502",
            codeValue: "USA006",
            gbName: "阿拉梅达（美国）",
            gbCode: "USA006",
            ciqCode: "840006"
        },
        {
            codeName: "亚当斯顿（美国）",
            cusCode: "502",
            codeValue: "USA008",
            gbName: "亚当斯顿（美国）",
            gbCode: "USA008",
            ciqCode: "840008"
        },
        {
            codeName: "奥尔巴尼（美国）",
            cusCode: "502",
            codeValue: "USA009",
            gbName: "奥尔巴尼（美国）",
            gbCode: "USA009",
            ciqCode: "840009"
        },
        {
            codeName: "亚历山德里亚（美国）",
            cusCode: "502",
            codeValue: "USA012",
            gbName: "亚历山德里亚（美国）",
            gbCode: "USA012",
            ciqCode: "840012"
        },
        {
            codeName: "阿尔皮纳（美国）",
            cusCode: "3097",
            codeValue: "USA015",
            gbName: "阿尔皮纳（美国）",
            gbCode: "USA015",
            ciqCode: "840015"
        },
        {
            codeName: "阿纳科特斯（美国）",
            cusCode: "3098",
            codeValue: "USA018",
            gbName: "阿纳科特斯（美国）",
            gbCode: "USA018",
            ciqCode: "840018"
        },
        {
            codeName: "安科雷奇（美国）",
            cusCode: "3099",
            codeValue: "USA021",
            gbName: "安科雷奇（美国）",
            gbCode: "USA021",
            ciqCode: "840021"
        },
        {
            codeName: "阿巴拉契科拉（美国）",
            cusCode: "3100",
            codeValue: "USA024",
            gbName: "阿巴拉契科拉（美国）",
            gbCode: "USA024",
            ciqCode: "840024"
        },
        {
            codeName: "阿什兰（美国）",
            cusCode: "3101",
            codeValue: "USA027",
            gbName: "阿什兰（美国）",
            gbCode: "USA027",
            ciqCode: "840027"
        },
        {
            codeName: "阿什塔比拉（美国）",
            cusCode: "3102",
            codeValue: "USA030",
            gbName: "阿什塔比拉（美国）",
            gbCode: "USA030",
            ciqCode: "840030"
        },
        {
            codeName: "阿斯托里亚（美国）",
            cusCode: "3106",
            codeValue: "USA033",
            gbName: "阿斯托里亚（美国）",
            gbCode: "USA033",
            ciqCode: "840033"
        },
        {
            codeName: "阿特雷科（美国）",
            cusCode: "502",
            codeValue: "USA036",
            gbName: "阿特雷科（美国）",
            gbCode: "USA036",
            ciqCode: "840036"
        },
        {
            codeName: "巴尔的摩（美国）",
            cusCode: "3103",
            codeValue: "USA039",
            gbName: "巴尔的摩（美国）",
            gbCode: "USA039",
            ciqCode: "840039"
        },
        {
            codeName: "班戈（美国）",
            cusCode: "502",
            codeValue: "USA042",
            gbName: "班戈（美国）",
            gbCode: "USA042",
            ciqCode: "840042"
        },
        {
            codeName: "巴斯（美国）",
            cusCode: "3108",
            codeValue: "USA045",
            gbName: "巴斯（美国）",
            gbCode: "USA045",
            ciqCode: "840045"
        },
        {
            codeName: "巴吞鲁日（美国）",
            cusCode: "3109",
            codeValue: "USA048",
            gbName: "巴吞鲁日（美国）",
            gbCode: "USA048",
            ciqCode: "840048"
        },
        {
            codeName: "贝敦（美国）",
            cusCode: "3110",
            codeValue: "USA051",
            gbName: "贝敦（美国）",
            gbCode: "USA051",
            ciqCode: "840051"
        },
        {
            codeName: "博蒙特（美国）",
            cusCode: "3111",
            codeValue: "USA054",
            gbName: "博蒙特（美国）",
            gbCode: "USA054",
            ciqCode: "840054"
        },
        {
            codeName: "贝灵哈姆（美国）",
            cusCode: "3112",
            codeValue: "USA057",
            gbName: "贝灵哈姆（美国）",
            gbCode: "USA057",
            ciqCode: "840057"
        },
        {
            codeName: "伯克利（美国）",
            cusCode: "502",
            codeValue: "USA060",
            gbName: "伯克利（美国）",
            gbCode: "USA060",
            ciqCode: "840060"
        },
        {
            codeName: "波卡洛兰德（美国）",
            cusCode: "502",
            codeValue: "USA063",
            gbName: "波卡洛兰德（美国）",
            gbCode: "USA063",
            ciqCode: "840063"
        },
        {
            codeName: "波士顿（美国）",
            cusCode: "3104",
            codeValue: "USA066",
            gbName: "波士顿（美国）",
            gbCode: "USA066",
            ciqCode: "840066"
        },
        {
            codeName: "布雷默顿（美国）",
            cusCode: "502",
            codeValue: "USA069",
            gbName: "布雷默顿（美国）",
            gbCode: "USA069",
            ciqCode: "840069"
        },
        {
            codeName: "布里奇波特（美国）",
            cusCode: "502",
            codeValue: "USA072",
            gbName: "布里奇波特（美国）",
            gbCode: "USA072",
            ciqCode: "840072"
        },
        {
            codeName: "布朗斯维尔（美国）",
            cusCode: "502",
            codeValue: "USA075",
            gbName: "布朗斯维尔（美国）",
            gbCode: "USA075",
            ciqCode: "840075"
        },
        {
            codeName: "不伦瑞克（美国）",
            cusCode: "3113",
            codeValue: "USA078",
            gbName: "不伦瑞克（美国）",
            gbCode: "USA078",
            ciqCode: "840078"
        },
        {
            codeName: "布坎南（美国）",
            cusCode: "502",
            codeValue: "USA081",
            gbName: "布坎南（美国）",
            gbCode: "USA081",
            ciqCode: "840081"
        },
        {
            codeName: "巴克斯波特（美国）",
            cusCode: "3114",
            codeValue: "USA084",
            gbName: "巴克斯波特（美国）",
            gbCode: "USA084",
            ciqCode: "840084"
        },
        {
            codeName: "布法罗（美国）",
            cusCode: "3115",
            codeValue: "USA087",
            gbName: "布法罗（美国）",
            gbCode: "USA087",
            ciqCode: "840087"
        },
        {
            codeName: "伯恩斯港（美国）",
            cusCode: "502",
            codeValue: "USA090",
            gbName: "伯恩斯港（美国）",
            gbCode: "USA090",
            ciqCode: "840090"
        },
        {
            codeName: "伯恩赛德（美国）",
            cusCode: "3116",
            codeValue: "USA093",
            gbName: "伯恩赛德（美国）",
            gbCode: "USA093",
            ciqCode: "840093"
        },
        {
            codeName: "剑桥（美国）",
            cusCode: "3117",
            codeValue: "USA096",
            gbName: "剑桥（美国）",
            gbCode: "USA096",
            ciqCode: "840096"
        },
        {
            codeName: "卡姆登（美国）",
            cusCode: "3118",
            codeValue: "USA099",
            gbName: "卡姆登（美国）",
            gbCode: "USA099",
            ciqCode: "840099"
        },
        {
            codeName: "卡拉贝尔（美国）",
            cusCode: "3120",
            codeValue: "USA102",
            gbName: "卡拉贝尔（美国）",
            gbCode: "USA102",
            ciqCode: "840102"
        },
        {
            codeName: "查尔斯顿（美国）",
            cusCode: "3121",
            codeValue: "USA105",
            gbName: "查尔斯顿（美国）",
            gbCode: "USA105",
            ciqCode: "840105"
        },
        {
            codeName: "希博伊甘（美国）",
            cusCode: "3123",
            codeValue: "USA108",
            gbName: "希博伊甘（美国）",
            gbCode: "USA108",
            ciqCode: "840108"
        },
        {
            codeName: "切萨皮克城（美国）",
            cusCode: "502",
            codeValue: "USA111",
            gbName: "切萨皮克城（美国）",
            gbCode: "USA111",
            ciqCode: "840111"
        },
        {
            codeName: "切斯特（美国）",
            cusCode: "3124",
            codeValue: "USA114",
            gbName: "切斯特（美国）",
            gbCode: "USA114",
            ciqCode: "840114"
        },
        {
            codeName: "芝加哥（美国）",
            cusCode: "3125",
            codeValue: "USA117",
            gbName: "芝加哥（美国）",
            gbCode: "USA117",
            ciqCode: "840117"
        },
        {
            codeName: "克利夫兰（美国）",
            cusCode: "3126",
            codeValue: "USA120",
            gbName: "克利夫兰（美国）",
            gbCode: "USA120",
            ciqCode: "840120"
        },
        {
            codeName: "康尼奥特港（美国）",
            cusCode: "3127",
            codeValue: "USA123",
            gbName: "康尼奥特港（美国）",
            gbCode: "USA123",
            ciqCode: "840123"
        },
        {
            codeName: "科尔多瓦（美国）",
            cusCode: "3130",
            codeValue: "USA126",
            gbName: "科尔多瓦（美国）",
            gbCode: "USA126",
            ciqCode: "840126"
        },
        {
            codeName: "科珀斯克里斯蒂（美国）",
            cusCode: "3131",
            codeValue: "USA129",
            gbName: "科珀斯克里斯蒂（美国）",
            gbCode: "USA129",
            ciqCode: "840129"
        },
        {
            codeName: "德拉华湾（美国）",
            cusCode: "3133",
            codeValue: "USA132",
            gbName: "德拉华湾（美国）",
            gbCode: "USA132",
            ciqCode: "840132"
        },
        {
            codeName: "特斯特汉（美国）",
            cusCode: "502",
            codeValue: "USA135",
            gbName: "特斯特汉（美国）",
            gbCode: "USA135",
            ciqCode: "840135"
        },
        {
            codeName: "底特律（美国）",
            cusCode: "3134",
            codeValue: "USA138",
            gbName: "底特律（美国）",
            gbCode: "USA138",
            ciqCode: "840138"
        },
        {
            codeName: "唐纳森维尔（美国）",
            cusCode: "502",
            codeValue: "USA141",
            gbName: "唐纳森维尔（美国）",
            gbCode: "USA141",
            ciqCode: "840141"
        },
        {
            codeName: "德卢斯（美国）",
            cusCode: "3135",
            codeValue: "USA144",
            gbName: "德卢斯（美国）",
            gbCode: "USA144",
            ciqCode: "840144"
        },
        {
            codeName: "荷兰港（美国）",
            cusCode: "502",
            codeValue: "USA147",
            gbName: "荷兰港（美国）",
            gbCode: "USA147",
            ciqCode: "840147"
        },
        {
            codeName: "埃尔塞贡多（美国）",
            cusCode: "502",
            codeValue: "USA150",
            gbName: "埃尔塞贡多（美国）",
            gbCode: "USA150",
            ciqCode: "840150"
        },
        {
            codeName: "伊利（美国）",
            cusCode: "3136",
            codeValue: "USA153",
            gbName: "伊利（美国）",
            gbCode: "USA153",
            ciqCode: "840153"
        },
        {
            codeName: "尤里卡（美国）",
            cusCode: "502",
            codeValue: "USA156",
            gbName: "尤里卡（美国）",
            gbCode: "USA156",
            ciqCode: "840156"
        },
        {
            codeName: "埃弗里特（美国）",
            cusCode: "3105",
            codeValue: "USA159",
            gbName: "埃弗里特（美国）",
            gbCode: "USA159",
            ciqCode: "840159"
        },
        {
            codeName: "福尔里弗（美国）",
            cusCode: "3137",
            codeValue: "USA162",
            gbName: "福尔里弗（美国）",
            gbCode: "USA162",
            ciqCode: "840162"
        },
        {
            codeName: "费南迪纳（美国）",
            cusCode: "3138",
            codeValue: "USA165",
            gbName: "费南迪纳（美国）",
            gbCode: "USA165",
            ciqCode: "840165"
        },
        {
            codeName: "芬代尔（美国）",
            cusCode: "502",
            codeValue: "USA168",
            gbName: "芬代尔（美国）",
            gbCode: "USA168",
            ciqCode: "840168"
        },
        {
            codeName: "弗里波特（美国）",
            cusCode: "502",
            codeValue: "USA171",
            gbName: "弗里波特（美国）",
            gbCode: "USA171",
            ciqCode: "840171"
        },
        {
            codeName: "加尔维斯顿（美国）",
            cusCode: "3107",
            codeValue: "USA174",
            gbName: "加尔维斯顿（美国）",
            gbCode: "USA174",
            ciqCode: "840174"
        },
        {
            codeName: "盖斯马（美国）",
            cusCode: "502",
            codeValue: "USA177",
            gbName: "盖斯马（美国）",
            gbCode: "USA177",
            ciqCode: "840177"
        },
        {
            codeName: "乔治敦（美国）",
            cusCode: "502",
            codeValue: "USA180",
            gbName: "乔治敦（美国）",
            gbCode: "USA180",
            ciqCode: "840180"
        },
        {
            codeName: "格洛斯特（美国）",
            cusCode: "502",
            codeValue: "USA183",
            gbName: "格洛斯特（美国）",
            gbCode: "USA183",
            ciqCode: "840183"
        },
        {
            codeName: "好望角（美国）",
            cusCode: "502",
            codeValue: "USA186",
            gbName: "好望角（美国）",
            gbCode: "USA186",
            ciqCode: "840186"
        },
        {
            codeName: "格拉梅西（美国）",
            cusCode: "502",
            codeValue: "USA189",
            gbName: "格拉梅西（美国）",
            gbCode: "USA189",
            ciqCode: "840189"
        },
        {
            codeName: "格兰德黑文（美国）",
            cusCode: "502",
            codeValue: "USA192",
            gbName: "格兰德黑文（美国）",
            gbCode: "USA192",
            ciqCode: "840192"
        },
        {
            codeName: "格雷斯港（美国）",
            cusCode: "502",
            codeValue: "USA195",
            gbName: "格雷斯港（美国）",
            gbCode: "USA195",
            ciqCode: "840195"
        },
        {
            codeName: "格林贝（美国）",
            cusCode: "502",
            codeValue: "USA198",
            gbName: "格林贝（美国）",
            gbCode: "USA198",
            ciqCode: "840198"
        },
        {
            codeName: "格尔夫波特（美国）",
            cusCode: "502",
            codeValue: "USA201",
            gbName: "格尔夫波特（美国）",
            gbCode: "USA201",
            ciqCode: "840201"
        },
        {
            codeName: "汉普顿港群（美国）",
            cusCode: "3139",
            codeValue: "USA204",
            gbName: "汉普顿港群（美国）",
            gbCode: "USA204",
            ciqCode: "840204"
        },
        {
            codeName: "霍姆（美国）",
            cusCode: "502",
            codeValue: "USA207",
            gbName: "霍姆（美国）",
            gbCode: "USA207",
            ciqCode: "840207"
        },
        {
            codeName: "荷马（美国）",
            cusCode: "3141",
            codeValue: "USA210",
            gbName: "荷马（美国）",
            gbCode: "USA210",
            ciqCode: "840210"
        },
        {
            codeName: "霍普韦尔（美国）",
            cusCode: "502",
            codeValue: "USA213",
            gbName: "霍普韦尔（美国）",
            gbCode: "USA213",
            ciqCode: "840213"
        },
        {
            codeName: "火奴鲁鲁（美国）",
            cusCode: "3142",
            codeValue: "USA215",
            gbName: "火奴鲁鲁（美国）",
            gbCode: "USA215",
            ciqCode: "840215"
        },
        {
            codeName: "休斯敦（美国）",
            cusCode: "3143",
            codeValue: "USA216",
            gbName: "休斯敦（美国）",
            gbCode: "USA216",
            ciqCode: "840216"
        },
        {
            codeName: "休伦（美国）",
            cusCode: "3144",
            codeValue: "USA219",
            gbName: "休伦（美国）",
            gbCode: "USA219",
            ciqCode: "840219"
        },
        {
            codeName: "杰克逊维尔（美国）",
            cusCode: "3145",
            codeValue: "USA222",
            gbName: "杰克逊维尔（美国）",
            gbCode: "USA222",
            ciqCode: "840222"
        },
        {
            codeName: "泽西城（美国）",
            cusCode: "502",
            codeValue: "USA225",
            gbName: "泽西城（美国）",
            gbCode: "USA225",
            ciqCode: "840225"
        },
        {
            codeName: "朱诺（美国）",
            cusCode: "3148",
            codeValue: "USA228",
            gbName: "朱诺（美国）",
            gbCode: "USA228",
            ciqCode: "840228"
        },
        {
            codeName: "卡拉马（美国）",
            cusCode: "502",
            codeValue: "USA231",
            gbName: "卡拉马（美国）",
            gbCode: "USA231",
            ciqCode: "840231"
        },
        {
            codeName: "克奈（美国）",
            cusCode: "502",
            codeValue: "USA234",
            gbName: "克奈（美国）",
            gbCode: "USA234",
            ciqCode: "840234"
        },
        {
            codeName: "基诺沙（美国）",
            cusCode: "3149",
            codeValue: "USA237",
            gbName: "基诺沙（美国）",
            gbCode: "USA237",
            ciqCode: "840237"
        },
        {
            codeName: "凯奇坎（美国）",
            cusCode: "502",
            codeValue: "USA240",
            gbName: "凯奇坎（美国）",
            gbCode: "USA240",
            ciqCode: "840240"
        },
        {
            codeName: "基韦斯特（美国）",
            cusCode: "502",
            codeValue: "USA243",
            gbName: "基韦斯特（美国）",
            gbCode: "USA243",
            ciqCode: "840243"
        },
        {
            codeName: "金斯湾（美国）",
            cusCode: "502",
            codeValue: "USA246",
            gbName: "金斯湾（美国）",
            gbCode: "USA246",
            ciqCode: "840246"
        },
        {
            codeName: "科迪亚克（美国）",
            cusCode: "502",
            codeValue: "USA249",
            gbName: "科迪亚克（美国）",
            gbCode: "USA249",
            ciqCode: "840249"
        },
        {
            codeName: "简斯维尔（美国）",
            cusCode: "502",
            codeValue: "USA251",
            gbName: "简斯维尔（美国）",
            gbCode: "USA251",
            ciqCode: "840251"
        },
        {
            codeName: "莱克查尔斯（美国）",
            cusCode: "3150",
            codeValue: "USA252",
            gbName: "莱克查尔斯（美国）",
            gbCode: "USA252",
            ciqCode: "840252"
        },
        {
            codeName: "长滩（美国）",
            cusCode: "3151",
            codeValue: "USA255",
            gbName: "长滩（美国）",
            gbCode: "USA255",
            ciqCode: "840255"
        },
        {
            codeName: "隆维尤（美国）",
            cusCode: "3152",
            codeValue: "USA258",
            gbName: "隆维尤（美国）",
            gbCode: "USA258",
            ciqCode: "840258"
        },
        {
            codeName: "洛雷恩（美国）",
            cusCode: "3153",
            codeValue: "USA261",
            gbName: "洛雷恩（美国）",
            gbCode: "USA261",
            ciqCode: "840261"
        },
        {
            codeName: "洛杉矶（美国）",
            cusCode: "3154",
            codeValue: "USA264",
            gbName: "洛杉矶（美国）",
            gbCode: "USA264",
            ciqCode: "840264"
        },
        {
            codeName: "马尼托沃克（美国）",
            cusCode: "3156",
            codeValue: "USA267",
            gbName: "马尼托沃克（美国）",
            gbCode: "USA267",
            ciqCode: "840267"
        },
        {
            codeName: "梅特拉卡特拉（美国）",
            cusCode: "502",
            codeValue: "USA270",
            gbName: "梅特拉卡特拉（美国）",
            gbCode: "USA270",
            ciqCode: "840270"
        },
        {
            codeName: "迈阿密（美国）",
            cusCode: "3157",
            codeValue: "USA273",
            gbName: "迈阿密（美国）",
            gbCode: "USA273",
            ciqCode: "840273"
        },
        {
            codeName: "蜜尔沃基（美国）",
            cusCode: "3146",
            codeValue: "USA276",
            gbName: "蜜尔沃基（美国）",
            gbCode: "USA276",
            ciqCode: "840276"
        },
        {
            codeName: "莫比尔（美国）",
            cusCode: "3158",
            codeValue: "USA279",
            gbName: "莫比尔（美国）",
            gbCode: "USA279",
            ciqCode: "840279"
        },
        {
            codeName: "门罗（美国）",
            cusCode: "3159",
            codeValue: "USA282",
            gbName: "门罗（美国）",
            gbCode: "USA282",
            ciqCode: "840282"
        },
        {
            codeName: "莫尔黑德城（美国）",
            cusCode: "3160",
            codeValue: "USA285",
            gbName: "莫尔黑德城（美国）",
            gbCode: "USA285",
            ciqCode: "840285"
        },
        {
            codeName: "马斯基根（美国）",
            cusCode: "3161",
            codeValue: "USA288",
            gbName: "马斯基根（美国）",
            gbCode: "USA288",
            ciqCode: "840288"
        },
        {
            codeName: "默特尔克里克（美国）",
            cusCode: "502",
            codeValue: "USA291",
            gbName: "默特尔克里克（美国）",
            gbCode: "USA291",
            ciqCode: "840291"
        },
        {
            codeName: "新贝德福德（美国）",
            cusCode: "3163",
            codeValue: "USA294",
            gbName: "新贝德福德（美国）",
            gbCode: "USA294",
            ciqCode: "840294"
        },
        {
            codeName: "纽卡斯尔（美国）",
            cusCode: "502",
            codeValue: "USA297",
            gbName: "纽卡斯尔（美国）",
            gbCode: "USA297",
            ciqCode: "840297"
        },
        {
            codeName: "纽黑文（美国）",
            cusCode: "3147",
            codeValue: "USA300",
            gbName: "纽黑文（美国）",
            gbCode: "USA300",
            ciqCode: "840300"
        },
        {
            codeName: "新伦敦（美国）",
            cusCode: "3164",
            codeValue: "USA303",
            gbName: "新伦敦（美国）",
            gbCode: "USA303",
            ciqCode: "840303"
        },
        {
            codeName: "新奥尔良（美国）",
            cusCode: "3165",
            codeValue: "USA306",
            gbName: "新奥尔良（美国）",
            gbCode: "USA306",
            ciqCode: "840306"
        },
        {
            codeName: "纽约（美国）",
            cusCode: "3166",
            codeValue: "USA309",
            gbName: "纽约（美国）",
            gbCode: "USA309",
            ciqCode: "840309"
        },
        {
            codeName: "纽瓦克（美国）",
            cusCode: "502",
            codeValue: "USA312",
            gbName: "纽瓦克（美国）",
            gbCode: "USA312",
            ciqCode: "840312"
        },
        {
            codeName: "纽波特纽斯（美国）",
            cusCode: "502",
            codeValue: "USA315",
            gbName: "纽波特纽斯（美国）",
            gbCode: "USA315",
            ciqCode: "840315"
        },
        {
            codeName: "纽波特（Oreg.）（美国）",
            cusCode: "502",
            codeValue: "USA318",
            gbName: "纽波特（Oreg.）（美国）",
            gbCode: "USA318",
            ciqCode: "840318"
        },
        {
            codeName: "纽波特（R.I.）（美国）",
            cusCode: "502",
            codeValue: "USA321",
            gbName: "纽波特（R.I.）（美国）",
            gbCode: "USA321",
            ciqCode: "840321"
        },
        {
            codeName: "尼基斯基（美国）",
            cusCode: "502",
            codeValue: "USA324",
            gbName: "尼基斯基（美国）",
            gbCode: "USA324",
            ciqCode: "840324"
        },
        {
            codeName: "诺姆（美国）",
            cusCode: "3168",
            codeValue: "USA327",
            gbName: "诺姆（美国）",
            gbCode: "USA327",
            ciqCode: "840327"
        },
        {
            codeName: "诺福克（美国）",
            cusCode: "502",
            codeValue: "USA330",
            gbName: "诺福克（美国）",
            gbCode: "USA330",
            ciqCode: "840330"
        },
        {
            codeName: "诺思贝（美国）",
            cusCode: "502",
            codeValue: "USA333",
            gbName: "诺思贝（美国）",
            gbCode: "USA333",
            ciqCode: "840333"
        },
        {
            codeName: "奥克兰（美国）",
            cusCode: "3170",
            codeValue: "USA336",
            gbName: "奥克兰（美国）",
            gbCode: "USA336",
            ciqCode: "840336"
        },
        {
            codeName: "奥林匹亚（美国）",
            cusCode: "3172",
            codeValue: "USA339",
            gbName: "奥林匹亚（美国）",
            gbCode: "USA339",
            ciqCode: "840339"
        },
        {
            codeName: "奥兰治（美国）",
            cusCode: "502",
            codeValue: "USA342",
            gbName: "奥兰治（美国）",
            gbCode: "USA342",
            ciqCode: "840342"
        },
        {
            codeName: "奥斯特里卡（美国）",
            cusCode: "502",
            codeValue: "USA345",
            gbName: "奥斯特里卡（美国）",
            gbCode: "USA345",
            ciqCode: "840345"
        },
        {
            codeName: "奥斯威戈（美国）",
            cusCode: "3173",
            codeValue: "USA348",
            gbName: "奥斯威戈（美国）",
            gbCode: "USA348",
            ciqCode: "840348"
        },
        {
            codeName: "棕榈滩（美国）",
            cusCode: "3174",
            codeValue: "USA351",
            gbName: "棕榈滩（美国）",
            gbCode: "USA351",
            ciqCode: "840351"
        },
        {
            codeName: "巴拿马城（美国）",
            cusCode: "502",
            codeValue: "USA354",
            gbName: "巴拿马城（美国）",
            gbCode: "USA354",
            ciqCode: "840354"
        },
        {
            codeName: "帕萨迪纳（美国）",
            cusCode: "502",
            codeValue: "USA357",
            gbName: "帕萨迪纳（美国）",
            gbCode: "USA357",
            ciqCode: "840357"
        },
        {
            codeName: "帕斯卡古拉（美国）",
            cusCode: "3175",
            codeValue: "USA360",
            gbName: "帕斯卡古拉（美国）",
            gbCode: "USA360",
            ciqCode: "840360"
        },
        {
            codeName: "保罗斯伯罗（美国）",
            cusCode: "502",
            codeValue: "USA363",
            gbName: "保罗斯伯罗（美国）",
            gbCode: "USA363",
            ciqCode: "840363"
        },
        {
            codeName: "彭萨科拉（美国）",
            cusCode: "3177",
            codeValue: "USA366",
            gbName: "彭萨科拉（美国）",
            gbCode: "USA366",
            ciqCode: "840366"
        },
        {
            codeName: "彼得斯堡（美国）",
            cusCode: "3178",
            codeValue: "USA369",
            gbName: "彼得斯堡（美国）",
            gbCode: "USA369",
            ciqCode: "840369"
        },
        {
            codeName: "费城（美国）",
            cusCode: "3179",
            codeValue: "USA372",
            gbName: "费城（美国）",
            gbCode: "USA372",
            ciqCode: "840372"
        },
        {
            codeName: "皮内角（美国）",
            cusCode: "502",
            codeValue: "USA375",
            gbName: "皮内角（美国）",
            gbCode: "USA375",
            ciqCode: "840375"
        },
        {
            codeName: "普列茅斯（美国）",
            cusCode: "502",
            codeValue: "USA378",
            gbName: "普列茅斯（美国）",
            gbCode: "USA378",
            ciqCode: "840378"
        },
        {
            codeName: "奥巴斯克斯港（美国）",
            cusCode: "502",
            codeValue: "USA381",
            gbName: "奥巴斯克斯港（美国）",
            gbCode: "USA381",
            ciqCode: "840381"
        },
        {
            codeName: "亚当斯港（美国）",
            cusCode: "502",
            codeValue: "USA384",
            gbName: "亚当斯港（美国）",
            gbCode: "USA384",
            ciqCode: "840384"
        },
        {
            codeName: "安吉利斯港（美国）",
            cusCode: "502",
            codeValue: "USA387",
            gbName: "安吉利斯港（美国）",
            gbCode: "USA387",
            ciqCode: "840387"
        },
        {
            codeName: "阿瑟港（美国）",
            cusCode: "502",
            codeValue: "USA390",
            gbName: "阿瑟港（美国）",
            gbCode: "USA390",
            ciqCode: "840390"
        },
        {
            codeName: "卡纳维拉尔港（美国）",
            cusCode: "3119",
            codeValue: "USA393",
            gbName: "卡纳维拉尔港（美国）",
            gbCode: "USA393",
            ciqCode: "840393"
        },
        {
            codeName: "埃弗格雷斯港（美国）",
            cusCode: "3181",
            codeValue: "USA396",
            gbName: "埃弗格雷斯港（美国）",
            gbCode: "USA396",
            ciqCode: "840396"
        },
        {
            codeName: "怀尼米港（美国）",
            cusCode: "502",
            codeValue: "USA399",
            gbName: "怀尼米港（美国）",
            gbCode: "USA399",
            ciqCode: "840399"
        },
        {
            codeName: "休伦港（美国）",
            cusCode: "502",
            codeValue: "USA402",
            gbName: "休伦港（美国）",
            gbCode: "USA402",
            ciqCode: "840402"
        },
        {
            codeName: "伊萨贝尔港（美国）",
            cusCode: "502",
            codeValue: "USA405",
            gbName: "伊萨贝尔港（美国）",
            gbCode: "USA405",
            ciqCode: "840405"
        },
        {
            codeName: "拉瓦卡港（美国）",
            cusCode: "502",
            codeValue: "USA408",
            gbName: "拉瓦卡港（美国）",
            gbCode: "USA408",
            ciqCode: "840408"
        },
        {
            codeName: "内奇斯港（美国）",
            cusCode: "502",
            codeValue: "USA411",
            gbName: "内奇斯港（美国）",
            gbCode: "USA411",
            ciqCode: "840411"
        },
        {
            codeName: "罗亚尔港（美国）",
            cusCode: "502",
            codeValue: "USA414",
            gbName: "罗亚尔港（美国）",
            gbCode: "USA414",
            ciqCode: "840414"
        },
        {
            codeName: "圣路易斯港（美国）",
            cusCode: "3182",
            codeValue: "USA417",
            gbName: "圣路易斯港（美国）",
            gbCode: "USA417",
            ciqCode: "840417"
        },
        {
            codeName: "圣乔港（美国）",
            cusCode: "502",
            codeValue: "USA420",
            gbName: "圣乔港（美国）",
            gbCode: "USA420",
            ciqCode: "840420"
        },
        {
            codeName: "萨尔弗港（美国）",
            cusCode: "3183",
            codeValue: "USA423",
            gbName: "萨尔弗港（美国）",
            gbCode: "USA423",
            ciqCode: "840423"
        },
        {
            codeName: "汤森港（美国）",
            cusCode: "3184",
            codeValue: "USA426",
            gbName: "汤森港（美国）",
            gbCode: "USA426",
            ciqCode: "840426"
        },
        {
            codeName: "波特兰（Me.）（美国）",
            cusCode: "3185",
            codeValue: "USA429",
            gbName: "波特兰（Me.）（美国）",
            gbCode: "USA429",
            ciqCode: "840429"
        },
        {
            codeName: "波特兰（Oreg.）（美国）",
            cusCode: "502",
            codeValue: "USA432",
            gbName: "波特兰（Oreg.）（美国）",
            gbCode: "USA432",
            ciqCode: "840432"
        },
        {
            codeName: "波次茅斯（美国）",
            cusCode: "502",
            codeValue: "USA435",
            gbName: "波次茅斯（美国）",
            gbCode: "USA435",
            ciqCode: "840435"
        },
        {
            codeName: "普罗维登斯（美国）",
            cusCode: "3186",
            codeValue: "USA438",
            gbName: "普罗维登斯（美国）",
            gbCode: "USA438",
            ciqCode: "840438"
        },
        {
            codeName: "拉辛（美国）",
            cusCode: "502",
            codeValue: "USA441",
            gbName: "拉辛（美国）",
            gbCode: "USA441",
            ciqCode: "840441"
        },
        {
            codeName: "里士满（VA）（美国）",
            cusCode: "3187",
            codeValue: "USA444",
            gbName: "里士满（VA）（美国）",
            gbCode: "USA444",
            ciqCode: "840444"
        },
        {
            codeName: "里士满（OH）（美国）",
            cusCode: "502",
            codeValue: "USA447",
            gbName: "里士满（OH）（美国）",
            gbCode: "USA447",
            ciqCode: "840447"
        },
        {
            codeName: "里弗黑德（美国）",
            cusCode: "502",
            codeValue: "USA450",
            gbName: "里弗黑德（美国）",
            gbCode: "USA450",
            ciqCode: "840450"
        },
        {
            codeName: "罗切斯特（美国）",
            cusCode: "502",
            codeValue: "USA453",
            gbName: "罗切斯特（美国）",
            gbCode: "USA453",
            ciqCode: "840453"
        },
        {
            codeName: "萨宾（美国）",
            cusCode: "3191",
            codeValue: "USA456",
            gbName: "萨宾（美国）",
            gbCode: "USA456",
            ciqCode: "840456"
        },
        {
            codeName: "萨克拉门托（美国）",
            cusCode: "3192",
            codeValue: "USA459",
            gbName: "萨克拉门托（美国）",
            gbCode: "USA459",
            ciqCode: "840459"
        },
        {
            codeName: "圣迭戈（美国）",
            cusCode: "3188",
            codeValue: "USA462",
            gbName: "圣迭戈（美国）",
            gbCode: "USA462",
            ciqCode: "840462"
        },
        {
            codeName: "圣弗朗西斯科（美国）",
            cusCode: "3193",
            codeValue: "USA465",
            gbName: "圣弗朗西斯科（美国）",
            gbCode: "USA465",
            ciqCode: "840465"
        },
        {
            codeName: "圣佩德罗（美国）",
            cusCode: "502",
            codeValue: "USA468",
            gbName: "圣佩德罗（美国）",
            gbCode: "USA468",
            ciqCode: "840468"
        },
        {
            codeName: "圣巴巴拉（美国）",
            cusCode: "3189",
            codeValue: "USA471",
            gbName: "圣巴巴拉（美国）",
            gbCode: "USA471",
            ciqCode: "840471"
        },
        {
            codeName: "圣克鲁斯（美国）",
            cusCode: "502",
            codeValue: "USA474",
            gbName: "圣克鲁斯（美国）",
            gbCode: "USA474",
            ciqCode: "840474"
        },
        {
            codeName: "萨凡纳（美国）",
            cusCode: "3190",
            codeValue: "USA477",
            gbName: "萨凡纳（美国）",
            gbCode: "USA477",
            ciqCode: "840477"
        },
        {
            codeName: "锡斯波特（美国）",
            cusCode: "3194",
            codeValue: "USA480",
            gbName: "锡斯波特（美国）",
            gbCode: "USA480",
            ciqCode: "840480"
        },
        {
            codeName: "西雅图（美国）",
            cusCode: "3195",
            codeValue: "USA483",
            gbName: "西雅图（美国）",
            gbCode: "USA483",
            ciqCode: "840483"
        },
        {
            codeName: "苏厄德（美国）",
            cusCode: "3196",
            codeValue: "USA486",
            gbName: "苏厄德（美国）",
            gbCode: "USA486",
            ciqCode: "840486"
        },
        {
            codeName: "锡特卡（美国）",
            cusCode: "502",
            codeValue: "USA489",
            gbName: "锡特卡（美国）",
            gbCode: "USA489",
            ciqCode: "840489"
        },
        {
            codeName: "斯卡圭（美国）",
            cusCode: "502",
            codeValue: "USA492",
            gbName: "斯卡圭（美国）",
            gbCode: "USA492",
            ciqCode: "840492"
        },
        {
            codeName: "斯密斯布卢夫（美国）",
            cusCode: "3197",
            codeValue: "USA495",
            gbName: "斯密斯布卢夫（美国）",
            gbCode: "USA495",
            ciqCode: "840495"
        },
        {
            codeName: "圣彼得斯堡（美国）",
            cusCode: "3198",
            codeValue: "USA498",
            gbName: "圣彼得斯堡（美国）",
            gbCode: "USA498",
            ciqCode: "840498"
        },
        {
            codeName: "斯托克顿（美国）",
            cusCode: "3199",
            codeValue: "USA501",
            gbName: "斯托克顿（美国）",
            gbCode: "USA501",
            ciqCode: "840501"
        },
        {
            codeName: "塔科马（美国）",
            cusCode: "3201",
            codeValue: "USA504",
            gbName: "塔科马（美国）",
            gbCode: "USA504",
            ciqCode: "840504"
        },
        {
            codeName: "塔科尼特港（美国）",
            cusCode: "3202",
            codeValue: "USA507",
            gbName: "塔科尼特港（美国）",
            gbCode: "USA507",
            ciqCode: "840507"
        },
        {
            codeName: "坦帕（美国）",
            cusCode: "3415",
            codeValue: "USA510",
            gbName: "坦帕（美国）",
            gbCode: "USA510",
            ciqCode: "840510"
        },
        {
            codeName: "得克萨斯城（美国）",
            cusCode: "3203",
            codeValue: "USA513",
            gbName: "得克萨斯城（美国）",
            gbCode: "USA513",
            ciqCode: "840513"
        },
        {
            codeName: "托莱多（美国）",
            cusCode: "502",
            codeValue: "USA516",
            gbName: "托莱多（美国）",
            gbCode: "USA516",
            ciqCode: "840516"
        },
        {
            codeName: "特伦顿（美国）",
            cusCode: "502",
            codeValue: "USA519",
            gbName: "特伦顿（美国）",
            gbCode: "USA519",
            ciqCode: "840519"
        },
        {
            codeName: "瓦尔迪兹（美国）",
            cusCode: "3204",
            codeValue: "USA522",
            gbName: "瓦尔迪兹（美国）",
            gbCode: "USA522",
            ciqCode: "840522"
        },
        {
            codeName: "温哥华（美国）",
            cusCode: "502",
            codeValue: "USA525",
            gbName: "温哥华（美国）",
            gbCode: "USA525",
            ciqCode: "840525"
        },
        {
            codeName: "华盛顿（美国）",
            cusCode: "502",
            codeValue: "USA528",
            gbName: "华盛顿（美国）",
            gbCode: "USA528",
            ciqCode: "840528"
        },
        {
            codeName: "威霍肯（美国）",
            cusCode: "502",
            codeValue: "USA531",
            gbName: "威霍肯（美国）",
            gbCode: "USA531",
            ciqCode: "840531"
        },
        {
            codeName: "威拉帕（美国）",
            cusCode: "502",
            codeValue: "USA534",
            gbName: "威拉帕（美国）",
            gbCode: "USA534",
            ciqCode: "840534"
        },
        {
            codeName: "威尔明顿（美国）",
            cusCode: "3206",
            codeValue: "USA543",
            gbName: "威尔明顿（美国）",
            gbCode: "USA543",
            ciqCode: "840543"
        },
        {
            codeName: "兰格尔（美国）",
            cusCode: "3207",
            codeValue: "USA546",
            gbName: "兰格尔（美国）",
            gbCode: "USA546",
            ciqCode: "840546"
        },
        {
            codeName: "亚特兰大（美国）",
            cusCode: "502",
            codeValue: "USA905",
            gbName: "亚特兰大（美国）",
            gbCode: "USA905",
            ciqCode: "840905"
        },
        {
            codeName: "伯明翰（美国）",
            cusCode: "502",
            codeValue: "USA906",
            gbName: "伯明翰（美国）",
            gbCode: "USA906",
            ciqCode: "840906"
        },
        {
            codeName: "威士康辛（美国）",
            cusCode: "502",
            codeValue: "USA907",
            gbName: "威士康辛（美国）",
            gbCode: "USA907",
            ciqCode: "840907"
        },
        {
            codeName: "奥马哈（美国）",
            cusCode: "502",
            codeValue: "USA908",
            gbName: "奥马哈（美国）",
            gbCode: "USA908",
            ciqCode: "840908"
        },
        {
            codeName: "达拉斯-沃斯堡（美国）",
            cusCode: "3454",
            codeValue: "USA909",
            gbName: "达拉斯-沃斯堡（美国）",
            gbCode: "USA909",
            ciqCode: "840909"
        },
        {
            codeName: "孟菲斯（美国）",
            cusCode: "502",
            codeValue: "USA910",
            gbName: "孟菲斯（美国）",
            gbCode: "USA910",
            ciqCode: "840910"
        },
        {
            codeName: "韦斯特维戈（美国）",
            cusCode: "502",
            codeValue: "USA911",
            gbName: "韦斯特维戈（美国）",
            gbCode: "USA911",
            ciqCode: "840911"
        },
        {
            codeName: "珍珠港（美国）",
            cusCode: "3176",
            codeValue: "USA912",
            gbName: "珍珠港（美国）",
            gbCode: "USA912",
            ciqCode: "840912"
        },
        {
            codeName: "亚库塔特（美国）",
            cusCode: "3208",
            codeValue: "USA913",
            gbName: "亚库塔特（美国）",
            gbCode: "USA913",
            ciqCode: "840913"
        },
        {
            codeName: "摩斯贝（美国）",
            cusCode: "3128",
            codeValue: "USA914",
            gbName: "摩斯贝（美国）",
            gbCode: "USA914",
            ciqCode: "840914"
        },
        {
            codeName: "马尼斯蒂（美国）",
            cusCode: "3155",
            codeValue: "USA915",
            gbName: "马尼斯蒂（美国）",
            gbCode: "USA915",
            ciqCode: "840915"
        },
        {
            codeName: "奥格登斯堡（美国）",
            cusCode: "3171",
            codeValue: "USA916",
            gbName: "奥格登斯堡（美国）",
            gbCode: "USA916",
            ciqCode: "840916"
        },
        {
            codeName: "阿鲁克鲁（美国）",
            cusCode: "3180",
            codeValue: "USA917",
            gbName: "阿鲁克鲁（美国）",
            gbCode: "USA917",
            ciqCode: "840917"
        },
        {
            codeName: "VAN BC（美国）",
            cusCode: "3205",
            codeValue: "USA918",
            gbName: "VAN BC（美国）",
            gbCode: "USA918",
            ciqCode: "840918"
        },
        {
            codeName: "COOSAW RIVER（美国）",
            cusCode: "3129",
            codeValue: "USA919",
            gbName: "COOSAW RIVER（美国）",
            gbCode: "USA919",
            ciqCode: "840919"
        },
        {
            codeName: "CHEAPEAKE（美国）",
            cusCode: "3122",
            codeValue: "USA920",
            gbName: "CHEAPEAKE（美国）",
            gbCode: "USA920",
            ciqCode: "840920"
        },
        {
            codeName: "康文特（美国）",
            cusCode: "3456",
            codeValue: "USA921",
            gbName: "康文特（美国）",
            gbCode: "USA921",
            ciqCode: "840921"
        },
        {
            codeName: "乌兹别克斯坦",
            cusCode: "149",
            codeValue: "UZB000",
            gbName: "乌兹别克斯坦",
            gbCode: "UZB000",
            ciqCode: "860000"
        },
        {
            codeName: "塔什干（乌兹别克斯坦）",
            cusCode: "149",
            codeValue: "UZB003",
            gbName: "塔什干（乌兹别克斯坦）",
            gbCode: "UZB003",
            ciqCode: "860003"
        },
        {
            codeName: "梵蒂冈",
            cusCode: "356",
            codeValue: "VAT000",
            gbName: "梵蒂冈",
            gbCode: "VAT000",
            ciqCode: "336000"
        },
        {
            codeName: "圣文森特和格林纳丁斯",
            cusCode: "439",
            codeValue: "VCT000",
            gbName: "圣文森特和格林纳丁斯",
            gbCode: "VCT000",
            ciqCode: "670000"
        },
        {
            codeName: "乔治敦（圣文森特和格林纳丁斯）",
            cusCode: "439",
            codeValue: "VCT003",
            gbName: "乔治敦（圣文森特和格林纳丁斯）",
            gbCode: "VCT003",
            ciqCode: "670003"
        },
        {
            codeName: "金斯敦（圣文森特和格林纳丁斯）",
            cusCode: "2934",
            codeValue: "VCT006",
            gbName: "金斯敦（圣文森特和格林纳丁斯）",
            gbCode: "VCT006",
            ciqCode: "670006"
        },
        {
            codeName: "委内瑞拉",
            cusCode: "445",
            codeValue: "VEN000",
            gbName: "委内瑞拉",
            gbCode: "VEN000",
            ciqCode: "862000"
        },
        {
            codeName: "阿穆艾（委内瑞拉）",
            cusCode: "2960",
            codeValue: "VEN003",
            gbName: "阿穆艾（委内瑞拉）",
            gbCode: "VEN003",
            ciqCode: "862003"
        },
        {
            codeName: "阿拉亚（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN006",
            gbName: "阿拉亚（委内瑞拉）",
            gbCode: "VEN006",
            ciqCode: "862006"
        },
        {
            codeName: "巴查克罗（委内瑞拉）",
            cusCode: "2961",
            codeValue: "VEN009",
            gbName: "巴查克罗（委内瑞拉）",
            gbCode: "VEN009",
            ciqCode: "862009"
        },
        {
            codeName: "巴霍格兰德（委内瑞拉）",
            cusCode: "2962",
            codeValue: "VEN012",
            gbName: "巴霍格兰德（委内瑞拉）",
            gbCode: "VEN012",
            ciqCode: "862012"
        },
        {
            codeName: "卡维马斯（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN015",
            gbName: "卡维马斯（委内瑞拉）",
            gbCode: "VEN015",
            ciqCode: "862015"
        },
        {
            codeName: "卡里皮托（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN018",
            gbName: "卡里皮托（委内瑞拉）",
            gbCode: "VEN018",
            ciqCode: "862018"
        },
        {
            codeName: "卡鲁帕诺（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN021",
            gbName: "卡鲁帕诺（委内瑞拉）",
            gbCode: "VEN021",
            ciqCode: "862021"
        },
        {
            codeName: "奇奇里维切（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN024",
            gbName: "奇奇里维切（委内瑞拉）",
            gbCode: "VEN024",
            ciqCode: "862024"
        },
        {
            codeName: "玻利瓦尔城（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN027",
            gbName: "玻利瓦尔城（委内瑞拉）",
            gbCode: "VEN027",
            ciqCode: "862027"
        },
        {
            codeName: "科隆查（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN030",
            gbName: "科隆查（委内瑞拉）",
            gbCode: "VEN030",
            ciqCode: "862030"
        },
        {
            codeName: "库马纳（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN033",
            gbName: "库马纳（委内瑞拉）",
            gbCode: "VEN033",
            ciqCode: "862033"
        },
        {
            codeName: "埃尔乔雷（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN036",
            gbName: "埃尔乔雷（委内瑞拉）",
            gbCode: "VEN036",
            ciqCode: "862036"
        },
        {
            codeName: "埃尔瓜马切（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN039",
            gbName: "埃尔瓜马切（委内瑞拉）",
            gbCode: "VEN039",
            ciqCode: "862039"
        },
        {
            codeName: "埃尔巴利托（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN042",
            gbName: "埃尔巴利托（委内瑞拉）",
            gbCode: "VEN042",
            ciqCode: "862042"
        },
        {
            codeName: "埃尔塔布拉齐奥（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN045",
            gbName: "埃尔塔布拉齐奥（委内瑞拉）",
            gbCode: "VEN045",
            ciqCode: "862045"
        },
        {
            codeName: "关塔（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN048",
            gbName: "关塔（委内瑞拉）",
            gbCode: "VEN048",
            ciqCode: "862048"
        },
        {
            codeName: "关腊关沃（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN051",
            gbName: "关腊关沃（委内瑞拉）",
            gbCode: "VEN051",
            ciqCode: "862051"
        },
        {
            codeName: "圭里亚（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN054",
            gbName: "圭里亚（委内瑞拉）",
            gbCode: "VEN054",
            ciqCode: "862054"
        },
        {
            codeName: "拉斯塔加达（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN057",
            gbName: "拉斯塔加达（委内瑞拉）",
            gbCode: "VEN057",
            ciqCode: "862057"
        },
        {
            codeName: "拉瓜伊拉（委内瑞拉）",
            cusCode: "2965",
            codeValue: "VEN060",
            gbName: "拉瓜伊拉（委内瑞拉）",
            gbCode: "VEN060",
            ciqCode: "862060"
        },
        {
            codeName: "拉萨利纳（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN063",
            gbName: "拉萨利纳（委内瑞拉）",
            gbCode: "VEN063",
            ciqCode: "862063"
        },
        {
            codeName: "马拉开波（委内瑞拉）",
            cusCode: "2967",
            codeValue: "VEN066",
            gbName: "马拉开波（委内瑞拉）",
            gbCode: "VEN066",
            ciqCode: "862066"
        },
        {
            codeName: "马坦萨斯（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN069",
            gbName: "马坦萨斯（委内瑞拉）",
            gbCode: "VEN069",
            ciqCode: "862069"
        },
        {
            codeName: "莫龙（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN072",
            gbName: "莫龙（委内瑞拉）",
            gbCode: "VEN072",
            ciqCode: "862072"
        },
        {
            codeName: "帕卢亚（委内瑞拉）",
            cusCode: "2969",
            codeValue: "VEN075",
            gbName: "帕卢亚（委内瑞拉）",
            gbCode: "VEN075",
            ciqCode: "862075"
        },
        {
            codeName: "帕马塔克亚尔（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN078",
            gbName: "帕马塔克亚尔（委内瑞拉）",
            gbCode: "VEN078",
            ciqCode: "862078"
        },
        {
            codeName: "潘帕塔尔（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN081",
            gbName: "潘帕塔尔（委内瑞拉）",
            gbCode: "VEN081",
            ciqCode: "862081"
        },
        {
            codeName: "佩蒂格来特（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN084",
            gbName: "佩蒂格来特（委内瑞拉）",
            gbCode: "VEN084",
            ciqCode: "862084"
        },
        {
            codeName: "波拉马尔（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN087",
            gbName: "波拉马尔（委内瑞拉）",
            gbCode: "VEN087",
            ciqCode: "862087"
        },
        {
            codeName: "耶罗港（委内瑞拉）",
            cusCode: "2970",
            codeValue: "VEN090",
            gbName: "耶罗港（委内瑞拉）",
            gbCode: "VEN090",
            ciqCode: "862090"
        },
        {
            codeName: "拉克鲁斯港（委内瑞拉）",
            cusCode: "2971",
            codeValue: "VEN093",
            gbName: "拉克鲁斯港（委内瑞拉）",
            gbCode: "VEN093",
            ciqCode: "862093"
        },
        {
            codeName: "卡贝略港（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN096",
            gbName: "卡贝略港（委内瑞拉）",
            gbCode: "VEN096",
            ciqCode: "862096"
        },
        {
            codeName: "米兰达港（委内瑞拉）",
            cusCode: "2972",
            codeValue: "VEN099",
            gbName: "米兰达港（委内瑞拉）",
            gbCode: "VEN099",
            ciqCode: "862099"
        },
        {
            codeName: "奥尔达斯港（委内瑞拉）",
            cusCode: "2973",
            codeValue: "VEN102",
            gbName: "奥尔达斯港（委内瑞拉）",
            gbCode: "VEN102",
            ciqCode: "862102"
        },
        {
            codeName: "苏克里港（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN105",
            gbName: "苏克里港（委内瑞拉）",
            gbCode: "VEN105",
            ciqCode: "862105"
        },
        {
            codeName: "篷塔卡尔东（委内瑞拉）",
            cusCode: "2974",
            codeValue: "VEN108",
            gbName: "篷塔卡尔东（委内瑞拉）",
            gbCode: "VEN108",
            ciqCode: "862108"
        },
        {
            codeName: "库希略角（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN111",
            gbName: "库希略角（委内瑞拉）",
            gbCode: "VEN111",
            ciqCode: "862111"
        },
        {
            codeName: "南帕尔马斯角（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN114",
            gbName: "南帕尔马斯角（委内瑞拉）",
            gbCode: "VEN114",
            ciqCode: "862114"
        },
        {
            codeName: "蓬塔-德彼德拉斯（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN116",
            gbName: "蓬塔-德彼德拉斯（委内瑞拉）",
            gbCode: "VEN116",
            ciqCode: "862116"
        },
        {
            codeName: "圣费利克斯（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN117",
            gbName: "圣费利克斯（委内瑞拉）",
            gbCode: "VEN117",
            ciqCode: "862117"
        },
        {
            codeName: "圣洛伦索（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN120",
            gbName: "圣洛伦索（委内瑞拉）",
            gbCode: "VEN120",
            ciqCode: "862120"
        },
        {
            codeName: "图卡卡斯（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN123",
            gbName: "图卡卡斯（委内瑞拉）",
            gbCode: "VEN123",
            ciqCode: "862123"
        },
        {
            codeName: "图里亚莫（委内瑞拉）",
            cusCode: "445",
            codeValue: "VEN126",
            gbName: "图里亚莫（委内瑞拉）",
            gbCode: "VEN126",
            ciqCode: "862126"
        },
        {
            codeName: "加拉加斯（委内瑞拉）",
            cusCode: "2963",
            codeValue: "VEN901",
            gbName: "加拉加斯（委内瑞拉）",
            gbCode: "VEN901",
            ciqCode: "862901"
        },
        {
            codeName: "英属维尔京群岛",
            cusCode: "446",
            codeValue: "VGB000",
            gbName: "英属维尔京群岛",
            gbCode: "VGB000",
            ciqCode: "092000"
        },
        {
            codeName: "阿内加达岛（英属维尔京群岛）",
            cusCode: "2980",
            codeValue: "VGB001",
            gbName: "阿内加达岛（英属维尔京群岛）",
            gbCode: "VGB001",
            ciqCode: "092001"
        },
        {
            codeName: "毖尔京-戈达岛（英属维尔京群岛）",
            cusCode: "2978",
            codeValue: "VGB002",
            gbName: "毖尔京-戈达岛（英属维尔京群岛）",
            gbCode: "VGB002",
            ciqCode: "092002"
        },
        {
            codeName: "托托拉岛（英属维尔京群岛）",
            cusCode: "2977",
            codeValue: "VGB003",
            gbName: "托托拉岛（英属维尔京群岛）",
            gbCode: "VGB003",
            ciqCode: "092003"
        },
        {
            codeName: "罗德城（英属维尔京群岛）",
            cusCode: "2979",
            codeValue: "VGB006",
            gbName: "罗德城（英属维尔京群岛）",
            gbCode: "VGB006",
            ciqCode: "092006"
        },
        {
            codeName: "美属维尔京群岛",
            cusCode: "455",
            codeValue: "VIR000",
            gbName: "美属维尔京群岛",
            gbCode: "VIR000",
            ciqCode: "850000"
        },
        {
            codeName: "夏洛特阿马利亚（美属维尔京群岛）",
            cusCode: "455",
            codeValue: "VIR002",
            gbName: "夏洛特阿马利亚（美属维尔京群岛）",
            gbCode: "VIR002",
            ciqCode: "850002"
        },
        {
            codeName: "克里斯琴斯特德（美属维尔京群岛）",
            cusCode: "455",
            codeValue: "VIR003",
            gbName: "克里斯琴斯特德（美属维尔京群岛）",
            gbCode: "VIR003",
            ciqCode: "850003"
        },
        {
            codeName: "弗雷德里克斯特德（美属维尔京群岛）",
            cusCode: "455",
            codeValue: "VIR006",
            gbName: "弗雷德里克斯特德（美属维尔京群岛）",
            gbCode: "VIR006",
            ciqCode: "850006"
        },
        {
            codeName: "圣约翰岛（美属维尔京群岛）",
            cusCode: "2985",
            codeValue: "VIR007",
            gbName: "圣约翰岛（美属维尔京群岛）",
            gbCode: "VIR007",
            ciqCode: "850007"
        },
        {
            codeName: "圣托马（美属维尔京群岛）",
            cusCode: "2986",
            codeValue: "VIR008",
            gbName: "圣托马（美属维尔京群岛）",
            gbCode: "VIR008",
            ciqCode: "850009"
        },
        {
            codeName: "美属维尔京（美属维尔京群岛）",
            cusCode: "2988",
            codeValue: "VIR009",
            gbName: "美属维尔京（美属维尔京群岛）",
            gbCode: "VIR009",
            ciqCode: "850011"
        },
        {
            codeName: "莱姆特里贝（美属维尔京群岛）",
            cusCode: "2984",
            codeValue: "VIR010",
            gbName: "莱姆特里贝（美属维尔京群岛）",
            gbCode: "VIR010",
            ciqCode: "850010"
        },
        {
            codeName: "越南",
            cusCode: "141",
            codeValue: "VNM000",
            gbName: "越南",
            gbCode: "VNM000",
            ciqCode: "704000"
        },
        {
            codeName: "金兰（越南）",
            cusCode: "141",
            codeValue: "VNM001",
            gbName: "金兰（越南）",
            gbCode: "VNM001",
            ciqCode: "704001"
        },
        {
            codeName: "边水（越南）",
            cusCode: "141",
            codeValue: "VNM003",
            gbName: "边水（越南）",
            gbCode: "VNM003",
            ciqCode: "704003"
        },
        {
            codeName: "岘港（越南）",
            cusCode: "1552",
            codeValue: "VNM006",
            gbName: "岘港（越南）",
            gbCode: "VNM006",
            ciqCode: "704006"
        },
        {
            codeName: "海防（越南）",
            cusCode: "1554",
            codeValue: "VNM009",
            gbName: "海防（越南）",
            gbCode: "VNM009",
            ciqCode: "704009"
        },
        {
            codeName: "胡志明市（越南）",
            cusCode: "1558",
            codeValue: "VNM012",
            gbName: "胡志明市（越南）",
            gbCode: "VNM012",
            ciqCode: "704012"
        },
        {
            codeName: "鸿基（越南）",
            cusCode: "1555",
            codeValue: "VNM015",
            gbName: "鸿基（越南）",
            gbCode: "VNM015",
            ciqCode: "704015"
        },
        {
            codeName: "顺化（越南）",
            cusCode: "141",
            codeValue: "VNM018",
            gbName: "顺化（越南）",
            gbCode: "VNM018",
            ciqCode: "704018"
        },
        {
            codeName: "广义（越南）",
            cusCode: "141",
            codeValue: "VNM021",
            gbName: "广义（越南）",
            gbCode: "VNM021",
            ciqCode: "704021"
        },
        {
            codeName: "美富（越南）",
            cusCode: "141",
            codeValue: "VNM024",
            gbName: "美富（越南）",
            gbCode: "VNM024",
            ciqCode: "704024"
        },
        {
            codeName: "芽庄（越南）",
            cusCode: "141",
            codeValue: "VNM027",
            gbName: "芽庄（越南）",
            gbCode: "VNM027",
            ciqCode: "704027"
        },
        {
            codeName: "锦普港（越南）",
            cusCode: "1557",
            codeValue: "VNM030",
            gbName: "锦普港（越南）",
            gbCode: "VNM030",
            ciqCode: "704030"
        },
        {
            codeName: "雷东港（越南）",
            cusCode: "141",
            codeValue: "VNM033",
            gbName: "雷东港（越南）",
            gbCode: "VNM033",
            ciqCode: "704033"
        },
        {
            codeName: "归仁（越南）",
            cusCode: "141",
            codeValue: "VNM036",
            gbName: "归仁（越南）",
            gbCode: "VNM036",
            ciqCode: "704036"
        },
        {
            codeName: "荣市（越南）",
            cusCode: "141",
            codeValue: "VNM039",
            gbName: "荣市（越南）",
            gbCode: "VNM039",
            ciqCode: "704039"
        },
        {
            codeName: "头顿（越南）",
            cusCode: "141",
            codeValue: "VNM042",
            gbName: "头顿（越南）",
            gbCode: "VNM042",
            ciqCode: "704042"
        },
        {
            codeName: "河内（越南）",
            cusCode: "1553",
            codeValue: "VNM901",
            gbName: "河内（越南）",
            gbCode: "VNM901",
            ciqCode: "704901"
        },
        {
            codeName: "金兰湾（越南）",
            cusCode: "141",
            codeValue: "VNM902",
            gbName: "金兰湾（越南）",
            gbCode: "VNM902",
            ciqCode: "704902"
        },
        {
            codeName: "友谊关（越南）",
            cusCode: "141",
            codeValue: "VNM903",
            gbName: "友谊关（越南）",
            gbCode: "VNM903",
            ciqCode: "704903"
        },
        {
            codeName: "同登（越南）",
            cusCode: "141",
            codeValue: "VNM904",
            gbName: "同登（越南）",
            gbCode: "VNM904",
            ciqCode: "704904"
        },
        {
            codeName: "新青（越南）",
            cusCode: "141",
            codeValue: "VNM905",
            gbName: "新青（越南）",
            gbCode: "VNM905",
            ciqCode: "704905"
        },
        {
            codeName: "寺马（越南）",
            cusCode: "141",
            codeValue: "VNM906",
            gbName: "寺马（越南）",
            gbCode: "VNM906",
            ciqCode: "704906"
        },
        {
            codeName: "驮龙（越南）",
            cusCode: "141",
            codeValue: "VNM907",
            gbName: "驮龙（越南）",
            gbCode: "VNM907",
            ciqCode: "704907"
        },
        {
            codeName: "茶岭（越南）",
            cusCode: "141",
            codeValue: "VNM908",
            gbName: "茶岭（越南）",
            gbCode: "VNM908",
            ciqCode: "704908"
        },
        {
            codeName: "朔江（越南）",
            cusCode: "141",
            codeValue: "VNM909",
            gbName: "朔江（越南）",
            gbCode: "VNM909",
            ciqCode: "704909"
        },
        {
            codeName: "老街（越南）",
            cusCode: "1556",
            codeValue: "VNM910",
            gbName: "老街（越南）",
            gbCode: "VNM910",
            ciqCode: "704910"
        },
        {
            codeName: "瓦努阿图",
            cusCode: "608",
            codeValue: "VUT000",
            gbName: "瓦努阿图",
            gbCode: "VUT000",
            ciqCode: "548000"
        },
        {
            codeName: "马勒库拉岛（瓦努阿图）",
            cusCode: "3291",
            codeValue: "VUT001",
            gbName: "马勒库拉岛（瓦努阿图）",
            gbCode: "VUT001",
            ciqCode: "548001"
        },
        {
            codeName: "埃罗芒加岛（瓦努阿图）",
            cusCode: "3289",
            codeValue: "VUT002",
            gbName: "埃罗芒加岛（瓦努阿图）",
            gbCode: "VUT002",
            ciqCode: "548002"
        },
        {
            codeName: "卢甘维尔港（瓦努阿图）",
            cusCode: "608",
            codeValue: "VUT003",
            gbName: "卢甘维尔港（瓦努阿图）",
            gbCode: "VUT003",
            ciqCode: "548003"
        },
        {
            codeName: "圣埃斯皮里图岛（瓦努阿图）",
            cusCode: "3290",
            codeValue: "VUT004",
            gbName: "圣埃斯皮里图岛（瓦努阿图）",
            gbCode: "VUT004",
            ciqCode: "548004"
        },
        {
            codeName: "圣多明各（瓦努阿图）",
            cusCode: "3288",
            codeValue: "VUT005",
            gbName: "圣多明各（瓦努阿图）",
            gbCode: "VUT005",
            ciqCode: "548005"
        },
        {
            codeName: "维拉港（瓦努阿图）",
            cusCode: "3292",
            codeValue: "VUT006",
            gbName: "维拉港（瓦努阿图）",
            gbCode: "VUT006",
            ciqCode: "548006"
        },
        {
            codeName: "塔纳岛（瓦努阿图）",
            cusCode: "3293",
            codeValue: "VUT007",
            gbName: "塔纳岛（瓦努阿图）",
            gbCode: "VUT007",
            ciqCode: "548007"
        },
        {
            codeName: "桑托（瓦努阿图）",
            cusCode: "608",
            codeValue: "VUT009",
            gbName: "桑托（瓦努阿图）",
            gbCode: "VUT009",
            ciqCode: "548009"
        },
        {
            codeName: "瓦利斯和富图纳",
            cusCode: "625",
            codeValue: "WLF000",
            gbName: "瓦利斯和富图纳",
            gbCode: "WLF000",
            ciqCode: "876000"
        },
        {
            codeName: "马塔乌图（瓦利斯和富图纳）",
            cusCode: "625",
            codeValue: "WLF003",
            gbName: "马塔乌图（瓦利斯和富图纳）",
            gbCode: "WLF003",
            ciqCode: "876003"
        },
        {
            codeName: "锡加维（瓦利斯和富图纳）",
            cusCode: "3404",
            codeValue: "WLF004",
            gbName: "锡加维（瓦利斯和富图纳）",
            gbCode: "WLF004",
            ciqCode: "876004"
        },
        {
            codeName: "穆阿（瓦利斯和富图纳）",
            cusCode: "3396",
            codeValue: "WLF005",
            gbName: "穆阿（瓦利斯和富图纳）",
            gbCode: "WLF005",
            ciqCode: "876005"
        },
        {
            codeName: "萨摩亚",
            cusCode: "617",
            codeValue: "WSM000",
            gbName: "萨摩亚",
            gbCode: "WSM000",
            ciqCode: "882000"
        },
        {
            codeName: "阿皮亚（萨摩亚）",
            cusCode: "3348",
            codeValue: "WSM003",
            gbName: "阿皮亚（萨摩亚）",
            gbCode: "WSM003",
            ciqCode: "882003"
        },
        {
            codeName: "阿绍（萨摩亚）",
            cusCode: "3349",
            codeValue: "WSM004",
            gbName: "阿绍（萨摩亚）",
            gbCode: "WSM004",
            ciqCode: "882004"
        },
        {
            codeName: "木利努乌（萨摩亚）",
            cusCode: "3352",
            codeValue: "WSM005",
            gbName: "木利努乌（萨摩亚）",
            gbCode: "WSM005",
            ciqCode: "882005"
        },
        {
            codeName: "萨瓦伊（萨摩亚）",
            cusCode: "3350",
            codeValue: "WSM006",
            gbName: "萨瓦伊（萨摩亚）",
            gbCode: "WSM006",
            ciqCode: "882006"
        },
        {
            codeName: "萨瓦伊岛（萨摩亚）",
            cusCode: "3353",
            codeValue: "WSM007",
            gbName: "萨瓦伊岛（萨摩亚）",
            gbCode: "WSM007",
            ciqCode: "882007"
        },
        {
            codeName: "乌波卢岛（萨摩亚）",
            cusCode: "3351",
            codeValue: "WSM008",
            gbName: "乌波卢岛（萨摩亚）",
            gbCode: "WSM008",
            ciqCode: "882008"
        },
        {
            codeName: "也门",
            cusCode: "139",
            codeValue: "YEM000",
            gbName: "也门",
            gbCode: "YEM000",
            ciqCode: "887000"
        },
        {
            codeName: "萨那（也门）",
            cusCode: "1548",
            codeValue: "YEM001",
            gbName: "萨那（也门）",
            gbCode: "YEM001",
            ciqCode: "887001"
        },
        {
            codeName: "亚丁（也门）",
            cusCode: "1549",
            codeValue: "YEM003",
            gbName: "亚丁（也门）",
            gbCode: "YEM003",
            ciqCode: "887003"
        },
        {
            codeName: "荷台达（也门）",
            cusCode: "1547",
            codeValue: "YEM006",
            gbName: "荷台达（也门）",
            gbCode: "YEM006",
            ciqCode: "887006"
        },
        {
            codeName: "穆哈（也门）",
            cusCode: "139",
            codeValue: "YEM009",
            gbName: "穆哈（也门）",
            gbCode: "YEM009",
            ciqCode: "887009"
        },
        {
            codeName: "穆卡拉（也门）",
            cusCode: "1550",
            codeValue: "YEM012",
            gbName: "穆卡拉（也门）",
            gbCode: "YEM012",
            ciqCode: "887012"
        },
        {
            codeName: "萨利夫（也门）",
            cusCode: "139",
            codeValue: "YEM013",
            gbName: "萨利夫（也门）",
            gbCode: "YEM013",
            ciqCode: "887013"
        },
        {
            codeName: "卡塞卜角（也门）",
            cusCode: "139",
            codeValue: "YEM015",
            gbName: "卡塞卜角（也门）",
            gbCode: "YEM015",
            ciqCode: "887015"
        },
        {
            codeName: "索科特拉岛（也门）",
            cusCode: "1551",
            codeValue: "YEM021",
            gbName: "索科特拉岛（也门）",
            gbCode: "YEM021",
            ciqCode: "887021"
        },
        {
            codeName: "南非",
            cusCode: "244",
            codeValue: "ZAF000",
            gbName: "南非",
            gbCode: "ZAF000",
            ciqCode: "710000"
        },
        {
            codeName: "开普敦（南非）",
            cusCode: "1754",
            codeValue: "ZAF003",
            gbName: "开普敦（南非）",
            gbCode: "ZAF003",
            ciqCode: "906000"
        },
        {
            codeName: "德班（南非）",
            cusCode: "1752",
            codeValue: "ZAF006",
            gbName: "德班（南非）",
            gbCode: "ZAF006",
            ciqCode: "710003"
        },
        {
            codeName: "东伦敦（南非）",
            cusCode: "1755",
            codeValue: "ZAF009",
            gbName: "东伦敦（南非）",
            gbCode: "ZAF009",
            ciqCode: "710006"
        },
        {
            codeName: "莫塞尔贝（南非）",
            cusCode: "244",
            codeValue: "ZAF012",
            gbName: "莫塞尔贝（南非）",
            gbCode: "ZAF012",
            ciqCode: "710009"
        },
        {
            codeName: "伊丽莎白港（南非）",
            cusCode: "1756",
            codeValue: "ZAF015",
            gbName: "伊丽莎白港（南非）",
            gbCode: "ZAF015",
            ciqCode: "710012"
        },
        {
            codeName: "里查德湾（南非）",
            cusCode: "244",
            codeValue: "ZAF018",
            gbName: "里查德湾（南非）",
            gbCode: "ZAF018",
            ciqCode: "710015"
        },
        {
            codeName: "萨尔达尼亚湾（南非）",
            cusCode: "244",
            codeValue: "ZAF021",
            gbName: "萨尔达尼亚湾（南非）",
            gbCode: "ZAF021",
            ciqCode: "710018"
        },
        {
            codeName: "西蒙斯敦（南非）",
            cusCode: "1758",
            codeValue: "ZAF024",
            gbName: "西蒙斯敦（南非）",
            gbCode: "ZAF024",
            ciqCode: "710021"
        },
        {
            codeName: "诺洛斯港（南非）",
            cusCode: "1757",
            codeValue: "ZAF027",
            gbName: "诺洛斯港（南非）",
            gbCode: "ZAF027",
            ciqCode: "710024"
        },
        {
            codeName: "约翰内斯堡（南非）",
            cusCode: "1753",
            codeValue: "ZAF901",
            gbName: "约翰内斯堡（南非）",
            gbCode: "ZAF901",
            ciqCode: "710027"
        },
        {
            codeName: "非洲其他国家(地区)",
            cusCode: "299",
            codeValue: "ZAO000",
            gbName: "非洲其他国家(地区)",
            gbCode: "ZAO000",
            ciqCode: "710901"
        },
        {
            codeName: "亚洲其他国家(地区)",
            cusCode: "199",
            codeValue: "ZAS000",
            gbName: "亚洲其他国家(地区)",
            gbCode: "ZAS000",
            ciqCode: "903000"
        },
        {
            codeName: "欧洲其他国家(地区)",
            cusCode: "399",
            codeValue: "ZEU000",
            gbName: "欧洲其他国家(地区)",
            gbCode: "ZEU000",
            ciqCode: "909000"
        },
        {
            codeName: "赞比亚",
            cusCode: "253",
            codeValue: "ZMB000",
            gbName: "赞比亚",
            gbCode: "ZMB000",
            ciqCode: "894000"
        },
        {
            codeName: "恩多拉（赞比亚）",
            cusCode: "1785",
            codeValue: "ZMB001",
            gbName: "恩多拉（赞比亚）",
            gbCode: "ZMB001",
            ciqCode: "894001"
        },
        {
            codeName: "北美洲其他国家(地区)",
            cusCode: "599",
            codeValue: "ZNA000",
            gbName: "北美洲其他国家(地区)",
            gbCode: "ZNA000",
            ciqCode: "915000"
        },
        {
            codeName: "大洋洲其他国家(地区)",
            cusCode: "699",
            codeValue: "ZOC000",
            gbName: "大洋洲其他国家(地区)",
            gbCode: "ZOC000",
            ciqCode: "918000"
        },
        {
            codeName: "拉丁美洲其他国家(地区)",
            cusCode: "499",
            codeValue: "ZSA000",
            gbName: "拉丁美洲其他国家(地区)",
            gbCode: "ZSA000",
            ciqCode: "912000"
        },
        {
            codeName: "津巴布韦",
            cusCode: "254",
            codeValue: "ZWE000",
            gbName: "津巴布韦",
            gbCode: "ZWE000",
            ciqCode: "716000"
        },
        {
            codeName: "未列出的特殊监管区",
            cusCode: "142",
            codeValue: "ZZZ900",
            gbName: "未列出的特殊监管区",
            gbCode: "ZZZ900",
            ciqCode: "999900"
        },
        {
            codeName: "未列出的国家或地区贸易港",
            cusCode: "701",
            codeValue: "ZZZ999",
            gbName: "未列出的国家或地区贸易港",
            gbCode: "ZZZ999",
            ciqCode: "999999"
        }
    ],
    // 境内货源地
    CUS_DISTRICT: [
        {
            codeName: "中关村国家自主创新示范区（东城园）",
            codeValue: "11013"
        },
        {
            codeName: "东城区",
            codeValue: "11019"
        },
        {
            codeName: "中关村国家自主创新示范区（西城园）",
            codeValue: "11023"
        },
        {
            codeName: "西城区",
            codeValue: "11029"
        },
        {
            codeName: "崇文区",
            codeValue: "11039"
        },
        {
            codeName: "宣武区",
            codeValue: "11049"
        },
        {
            codeName: "中关村国家自主创新示范区（朝阳园）",
            codeValue: "11053"
        },
        {
            codeName: "朝阳区",
            codeValue: "11059"
        },
        {
            codeName: "中关村国家自主创新示范区（丰台园）",
            codeValue: "11063"
        },
        {
            codeName: "丰台区",
            codeValue: "11069"
        },
        {
            codeName: "中关村国家自主创新示范区（石景山园）",
            codeValue: "11073"
        },
        {
            codeName: "石景山",
            codeValue: "11079"
        },
        {
            codeName: "中关村国家自主创新示范区（海淀园）",
            codeValue: "11083"
        },
        {
            codeName: "中关村综合保税区",
            codeValue: "11086"
        },
        {
            codeName: "海淀区其他",
            codeValue: "11089"
        },
        {
            codeName: "中关村国家自主创新示范区（门头沟园）",
            codeValue: "11093"
        },
        {
            codeName: "门头沟",
            codeValue: "11099"
        },
        {
            codeName: "中关村国家自主创新示范区（房山园）",
            codeValue: "11103"
        },
        {
            codeName: "房山",
            codeValue: "11109"
        },
        {
            codeName: "中关村国家自主创新示范区（顺义园）",
            codeValue: "11113"
        },
        {
            codeName: "北京天竺出口加工区",
            codeValue: "11115"
        },
        {
            codeName: "北京天竺综合保税区",
            codeValue: "11116"
        },
        {
            codeName: "顺义",
            codeValue: "11119"
        },
        {
            codeName: "中关村国家自主创新示范区（昌平园）",
            codeValue: "11123"
        },
        {
            codeName: "昌平",
            codeValue: "11129"
        },
        {
            codeName: "北京经济技术开发区",
            codeValue: "11132"
        },
        {
            codeName: "中关村国家自主创新示范区（大兴-亦庄园）",
            codeValue: "11133"
        },
        {
            codeName: "北京大兴国际机场综合保税区（北京区域）",
            codeValue: "11136"
        },
        {
            codeName: "大兴其他",
            codeValue: "11139"
        },
        {
            codeName: "北京亦庄保税物流中心",
            codeValue: "1113W"
        },
        {
            codeName: "中关村国家自主创新示范区（通州园）",
            codeValue: "11143"
        },
        {
            codeName: "通县",
            codeValue: "11149"
        },
        {
            codeName: "中关村国家自主创新示范区（怀柔园）",
            codeValue: "11153"
        },
        {
            codeName: "怀柔",
            codeValue: "11159"
        },
        {
            codeName: "中关村国家自主创新示范区（平谷园）",
            codeValue: "11163"
        },
        {
            codeName: "平谷",
            codeValue: "11169"
        },
        {
            codeName: "中关村国家自主创新示范区（延庆园）",
            codeValue: "11173"
        },
        {
            codeName: "延庆",
            codeValue: "11179"
        },
        {
            codeName: "中关村国家自主创新示范区（密云园）",
            codeValue: "11183"
        },
        {
            codeName: "密云",
            codeValue: "11189"
        },
        {
            codeName: "北京其他",
            codeValue: "11909"
        },
        {
            codeName: "和平区",
            codeValue: "12019"
        },
        {
            codeName: "河东区",
            codeValue: "12029"
        },
        {
            codeName: "河西区",
            codeValue: "12039"
        },
        {
            codeName: "天津新技术产业园区",
            codeValue: "12043"
        },
        {
            codeName: "南开区其他",
            codeValue: "12049"
        },
        {
            codeName: "河北区",
            codeValue: "12059"
        },
        {
            codeName: "红桥区",
            codeValue: "12069"
        },
        {
            codeName: "天津经济技术开发区",
            codeValue: "12072"
        },
        {
            codeName: "天津港保税区",
            codeValue: "12074"
        },
        {
            codeName: "天津出口加工区",
            codeValue: "12075"
        },
        {
            codeName: "天津东疆、泰达、天津港、临港综合保税区",
            codeValue: "12076"
        },
        {
            codeName: "天津保税物流园",
            codeValue: "12077"
        },
        {
            codeName: "滨海新区(塘沽其他)",
            codeValue: "12079"
        },
        {
            codeName: "天津经济技术开发区保税物流中心",
            codeValue: "1207W"
        },
        {
            codeName: "滨海新区(汉沽)",
            codeValue: "12089"
        },
        {
            codeName: "滨海新区(大港)",
            codeValue: "12099"
        },
        {
            codeName: "天津滨海新区综合保税区",
            codeValue: "12106"
        },
        {
            codeName: "东丽区",
            codeValue: "12109"
        },
        {
            codeName: "西青区",
            codeValue: "12119"
        },
        {
            codeName: "津南区",
            codeValue: "12129"
        },
        {
            codeName: "北辰区",
            codeValue: "12139"
        },
        {
            codeName: "宁河县",
            codeValue: "12149"
        },
        {
            codeName: "武清县",
            codeValue: "12159"
        },
        {
            codeName: "静海县",
            codeValue: "12169"
        },
        {
            codeName: "宝坻县",
            codeValue: "12179"
        },
        {
            codeName: "蓟县",
            codeValue: "12189"
        },
        {
            codeName: "蓟州保税物流中心（B型）",
            codeValue: "1218W"
        },
        {
            codeName: "天津其他",
            codeValue: "12909"
        },
        {
            codeName: "石家庄高新技术产业开发实验区",
            codeValue: "13013"
        },
        {
            codeName: "石家庄综合保税区",
            codeValue: "13016"
        },
        {
            codeName: "石家庄其他",
            codeValue: "13019"
        },
        {
            codeName: " 辛集、石 家庄国际陆港保税物流中心（ B 型 ）",
            codeValue: "1301W"
        },
        {
            codeName: "曹妃甸经济技术开发区",
            codeValue: "13022"
        },
        {
            codeName: "曹妃甸综合保税区",
            codeValue: "13026"
        },
        {
            codeName: "唐山",
            codeValue: "13029"
        },
        {
            codeName: "唐山港京唐港区保税物流中心（B型）",
            codeValue: "1302W"
        },
        {
            codeName: "秦皇岛经济技术开发区",
            codeValue: "13032"
        },
        {
            codeName: "河北秦皇岛出口加工区",
            codeValue: "13035"
        },
        {
            codeName: "秦皇岛综合保税区",
            codeValue: "13036"
        },
        {
            codeName: "秦皇岛其他",
            codeValue: "13039"
        },
        {
            codeName: "邯郸",
            codeValue: "13049"
        },
        {
            codeName: "邢台",
            codeValue: "13059"
        },
        {
            codeName: "保定高新技术产业开发区",
            codeValue: "13063"
        },
        {
            codeName: "保定其他",
            codeValue: "13069"
        },
        {
            codeName: "雄安新区（保定）",
            codeValue: "1306N"
        },
        {
            codeName: "张家口",
            codeValue: "13079"
        },
        {
            codeName: "承德",
            codeValue: "13089"
        },
        {
            codeName: "沧州",
            codeValue: "13099"
        },
        {
            codeName: "雄安新区（沧州）",
            codeValue: "1309N"
        },
        {
            codeName: "廊坊经济技术开发区",
            codeValue: "13102"
        },
        {
            codeName: "河北廊坊出口加工区",
            codeValue: "13105"
        },
        {
            codeName: "廊坊、北京大兴国际机场（河北区域）综合保税区",
            codeValue: "13106"
        },
        {
            codeName: "廊坊",
            codeValue: "13109"
        },
        {
            codeName: "衡水",
            codeValue: "13119"
        },
        {
            codeName: "武安",
            codeValue: "13129"
        },
        {
            codeName: "河北武安保税物流中心（B型）",
            codeValue: "1312W"
        },
        {
            codeName: "雄安综合保税区",
            codeValue: "13316"
        },
        {
            codeName: "河北雄安新区",
            codeValue: "1331N"
        },
        {
            codeName: "河北其他",
            codeValue: "13909"
        },
        {
            codeName: "山西太原经济技术开发区",
            codeValue: "14012"
        },
        {
            codeName: "太原高新技术产业开发区",
            codeValue: "14013"
        },
        {
            codeName: "太原武宿综合保税区",
            codeValue: "14016"
        },
        {
            codeName: "太原其他",
            codeValue: "14019"
        },
        {
            codeName: "大同经济技术开发区",
            codeValue: "14022"
        },
        {
            codeName: "大同",
            codeValue: "14029"
        },
        {
            codeName: "大同国际陆港保税物流中心（B型）",
            codeValue: "1402W"
        },
        {
            codeName: "阳泉",
            codeValue: "14039"
        },
        {
            codeName: "长治高新技术产业开发区",
            codeValue: "14043"
        },
        {
            codeName: "长治",
            codeValue: "14049"
        },
        {
            codeName: "晋城",
            codeValue: "14059"
        },
        {
            codeName: "山西兰花保税物流中心（B型）",
            codeValue: "1405W"
        },
        {
            codeName: "朔州",
            codeValue: "14069"
        },
        {
            codeName: "雁北",
            codeValue: "14079"
        },
        {
            codeName: "忻州",
            codeValue: "14089"
        },
        {
            codeName: "吕梁",
            codeValue: "14099"
        },
        {
            codeName: "晋中经济技术开发区",
            codeValue: "14102"
        },
        {
            codeName: "晋中",
            codeValue: "14109"
        },
        {
            codeName: "临汾",
            codeValue: "14119"
        },
        {
            codeName: "山西方略保税物流中心",
            codeValue: "1411W"
        },
        {
            codeName: "运城",
            codeValue: "14129"
        },
        {
            codeName: "古交",
            codeValue: "14139"
        },
        {
            codeName: "山西其他",
            codeValue: "14909"
        },
        {
            codeName: "内蒙古呼和浩特出口加工区",
            codeValue: "15015"
        },
        {
            codeName: "呼和浩特综合保税区",
            codeValue: "15016"
        },
        {
            codeName: "呼和浩特",
            codeValue: "15019"
        },
        {
            codeName: "包头高新技术产业开发区",
            codeValue: "15023"
        },
        {
            codeName: "包头其他",
            codeValue: "15029"
        },
        {
            codeName: "包头保税物流中心（B型）",
            codeValue: "1502W"
        },
        {
            codeName: "乌海",
            codeValue: "15039"
        },
        {
            codeName: "赤峰",
            codeValue: "15049"
        },
        {
            codeName: "赤峰保税物流中心",
            codeValue: "1504W"
        },
        {
            codeName: "二连",
            codeValue: "15059"
        },
        {
            codeName: "满洲里综合保税区",
            codeValue: "15066"
        },
        {
            codeName: "满洲里",
            codeValue: "15069"
        },
        {
            codeName: "呼伦贝尔盟",
            codeValue: "15079"
        },
        {
            codeName: "哲里木盟",
            codeValue: "15089"
        },
        {
            codeName: "通辽保税物流中心（B型）",
            codeValue: "1508W"
        },
        {
            codeName: "兴安盟",
            codeValue: "15099"
        },
        {
            codeName: "乌兰察布盟",
            codeValue: "15109"
        },
        {
            codeName: "七苏木保税物流中心（B型）",
            codeValue: "1510W"
        },
        {
            codeName: "巴彦淖尔市",
            codeValue: "15119"
        },
        {
            codeName: "巴彦淖尔市保税物流中心（B型）",
            codeValue: "1511W"
        },
        {
            codeName: "鄂尔多斯综合保税区",
            codeValue: "15126"
        },
        {
            codeName: "伊克昭盟",
            codeValue: "15129"
        },
        {
            codeName: "阿拉善盟",
            codeValue: "15139"
        },
        {
            codeName: "锡林郭勒盟",
            codeValue: "15149"
        },
        {
            codeName: "内蒙古其他",
            codeValue: "15909"
        },
        {
            codeName: "沈阳经济技术开发区",
            codeValue: "21012"
        },
        {
            codeName: "沈阳南湖科技开发区",
            codeValue: "21013"
        },
        {
            codeName: "辽宁沈阳、张士出口加工区",
            codeValue: "21015"
        },
        {
            codeName: "沈阳综合保税区",
            codeValue: "21016"
        },
        {
            codeName: "沈阳其他",
            codeValue: "21019"
        },
        {
            codeName: "大连经济技术开发区",
            codeValue: "21022"
        },
        {
            codeName: "大连高新技术产业园区",
            codeValue: "21023"
        },
        {
            codeName: "大连大窑湾保税区",
            codeValue: "21024"
        },
        {
            codeName: "辽宁大连出口加工区",
            codeValue: "21025"
        },
        {
            codeName: "大连大窑湾、湾里综合保税区",
            codeValue: "21026"
        },
        {
            codeName: "大连保税物流园区",
            codeValue: "21027"
        },
        {
            codeName: "大连其他",
            codeValue: "21029"
        },
        {
            codeName: "大连大窑湾保税物流中心（B型）",
            codeValue: "2102W"
        },
        {
            codeName: "鞍山高新技术产业开发区",
            codeValue: "21033"
        },
        {
            codeName: "鞍山其他",
            codeValue: "21039"
        },
        {
            codeName: "抚顺",
            codeValue: "21049"
        },
        {
            codeName: "本溪",
            codeValue: "21059"
        },
        {
            codeName: "丹东",
            codeValue: "21069"
        },
        {
            codeName: "锦州",
            codeValue: "21079"
        },
        {
            codeName: "锦州港保税物流中心（B型）",
            codeValue: "2107W"
        },
        {
            codeName: "营口经济技术开发区",
            codeValue: "21082"
        },
        {
            codeName: "营口综合保税区",
            codeValue: "21086"
        },
        {
            codeName: "营口",
            codeValue: "21089"
        },
        {
            codeName: "营口港保税物流中心",
            codeValue: "2108W"
        },
        {
            codeName: "阜新",
            codeValue: "21099"
        },
        {
            codeName: "辽阳",
            codeValue: "21109"
        },
        {
            codeName: "盘锦",
            codeValue: "21119"
        },
        {
            codeName: "盘锦港保税物流中心（B型）",
            codeValue: "2111W"
        },
        {
            codeName: "铁岭",
            codeValue: "21129"
        },
        {
            codeName: "铁岭保税物流中心（B型）",
            codeValue: "2112W"
        },
        {
            codeName: "朝阳",
            codeValue: "21139"
        },
        {
            codeName: "葫芦岛市",
            codeValue: "21149"
        },
        {
            codeName: "瓦房店",
            codeValue: "21159"
        },
        {
            codeName: "海城",
            codeValue: "21169"
        },
        {
            codeName: "兴城",
            codeValue: "21179"
        },
        {
            codeName: "铁法",
            codeValue: "21189"
        },
        {
            codeName: "北票",
            codeValue: "21199"
        },
        {
            codeName: "开源",
            codeValue: "21209"
        },
        {
            codeName: "辽宁其他",
            codeValue: "21909"
        },
        {
            codeName: "长春经济技术开发区",
            codeValue: "22012"
        },
        {
            codeName: "长春南湖-南岭新技术产业园区",
            codeValue: "22013"
        },
        {
            codeName: "长春兴隆综合保税区",
            codeValue: "22016"
        },
        {
            codeName: "长春其他",
            codeValue: "22019"
        },
        {
            codeName: "吉林高新技术产业开发区",
            codeValue: "22023"
        },
        {
            codeName: "吉林其他",
            codeValue: "22029"
        },
        {
            codeName: "吉林市保税物流中心（B型）",
            codeValue: "2202W"
        },
        {
            codeName: "四平",
            codeValue: "22039"
        },
        {
            codeName: "辽源",
            codeValue: "22049"
        },
        {
            codeName: "通化",
            codeValue: "22059"
        },
        {
            codeName: "白山",
            codeValue: "22069"
        },
        {
            codeName: "吉林珲春出口加工区",
            codeValue: "22075"
        },
        {
            codeName: "珲春综合保税区",
            codeValue: "22076"
        },
        {
            codeName: "珲春",
            codeValue: "22079"
        },
        {
            codeName: "图们",
            codeValue: "22089"
        },
        {
            codeName: "白城",
            codeValue: "22099"
        },
        {
            codeName: "延边",
            codeValue: "22109"
        },
        {
            codeName: "公主岭",
            codeValue: "22119"
        },
        {
            codeName: "梅河口",
            codeValue: "22129"
        },
        {
            codeName: "集安",
            codeValue: "22139"
        },
        {
            codeName: "桦甸",
            codeValue: "22149"
        },
        {
            codeName: "九台",
            codeValue: "22159"
        },
        {
            codeName: "蛟河",
            codeValue: "22169"
        },
        {
            codeName: "松原",
            codeValue: "22179"
        },
        {
            codeName: "延吉市",
            codeValue: "22189"
        },
        {
            codeName: "延吉国际空港经济开发区保税物流中心（B型）",
            codeValue: "2218W"
        },
        {
            codeName: "吉林其他",
            codeValue: "22909"
        },
        {
            codeName: "哈尔滨经济技术开发区",
            codeValue: "23012"
        },
        {
            codeName: "哈尔滨高技术开发区",
            codeValue: "23013"
        },
        {
            codeName: "哈尔滨综合保税区",
            codeValue: "23016"
        },
        {
            codeName: "哈尔滨其他",
            codeValue: "23019"
        },
        {
            codeName: "齐齐哈尔",
            codeValue: "23029"
        },
        {
            codeName: "鸡西",
            codeValue: "23039"
        },
        {
            codeName: "鹤岗",
            codeValue: "23049"
        },
        {
            codeName: "双鸭山",
            codeValue: "23059"
        },
        {
            codeName: "大庆高新技术产业开发区",
            codeValue: "23063"
        },
        {
            codeName: "大庆其他",
            codeValue: "23069"
        },
        {
            codeName: "伊春",
            codeValue: "23079"
        },
        {
            codeName: "佳木斯",
            codeValue: "23089"
        },
        {
            codeName: "七台河",
            codeValue: "23099"
        },
        {
            codeName: "牡丹江",
            codeValue: "23109"
        },
        {
            codeName: "牡丹江保税物流中心（B型）",
            codeValue: "2310W"
        },
        {
            codeName: "黑河",
            codeValue: "23119"
        },
        {
            codeName: "黑河保税物流中心（B型）",
            codeValue: "2311W"
        },
        {
            codeName: "绥芬河综合保税区",
            codeValue: "23126"
        },
        {
            codeName: "绥芬河",
            codeValue: "23129"
        },
        {
            codeName: "松花江",
            codeValue: "23139"
        },
        {
            codeName: "绥化经济技术开发区",
            codeValue: "23142"
        },
        {
            codeName: "绥化",
            codeValue: "23149"
        },
        {
            codeName: "大兴安岭",
            codeValue: "23159"
        },
        {
            codeName: "阿城",
            codeValue: "23169"
        },
        {
            codeName: "同江",
            codeValue: "23179"
        },
        {
            codeName: "富锦",
            codeValue: "23189"
        },
        {
            codeName: "铁力",
            codeValue: "23199"
        },
        {
            codeName: "密山",
            codeValue: "23209"
        },
        {
            codeName: "黑龙江其他",
            codeValue: "23909"
        },
        {
            codeName: "黄浦",
            codeValue: "31019"
        },
        {
            codeName: "南市",
            codeValue: "31029"
        },
        {
            codeName: "卢湾",
            codeValue: "31039"
        },
        {
            codeName: "上海漕河泾新技术开发区",
            codeValue: "31043"
        },
        {
            codeName: "徐汇其他",
            codeValue: "31049"
        },
        {
            codeName: "上海经济技术开发区",
            codeValue: "31052"
        },
        {
            codeName: "长宁",
            codeValue: "31059"
        },
        {
            codeName: "静安",
            codeValue: "31069"
        },
        {
            codeName: "普陀",
            codeValue: "31079"
        },
        {
            codeName: "上海西北物流园区保税物流中心",
            codeValue: "3107W"
        },
        {
            codeName: "闸北",
            codeValue: "31089"
        },
        {
            codeName: "虹口",
            codeValue: "31099"
        },
        {
            codeName: "杨浦",
            codeValue: "31109"
        },
        {
            codeName: "上海闵行经济技术开发区",
            codeValue: "31112"
        },
        {
            codeName: "上海浦江高科技园区",
            codeValue: "31113"
        },
        {
            codeName: "上海漕河泾出口加工区",
            codeValue: "31115"
        },
        {
            codeName: "漕河泾综合保税区",
            codeValue: "31116"
        },
        {
            codeName: "闵行其他",
            codeValue: "31119"
        },
        {
            codeName: "虹桥商务区保税物流中心（B型）",
            codeValue: "3111W"
        },
        {
            codeName: "宝山",
            codeValue: "31129"
        },
        {
            codeName: "上海嘉定出口加工区",
            codeValue: "31145"
        },
        {
            codeName: "上海嘉定综合保税区",
            codeValue: "31146"
        },
        {
            codeName: "嘉定",
            codeValue: "31149"
        },
        {
            codeName: "川沙",
            codeValue: "31159"
        },
        {
            codeName: "上海闵行经济技术开发区（临港新城）",
            codeValue: "31162"
        },
        {
            codeName: "洋山保税港区",
            codeValue: "31166"
        },
        {
            codeName: "南汇",
            codeValue: "31169"
        },
        {
            codeName: "上海闵行出口加工区",
            codeValue: "31175"
        },
        {
            codeName: "奉贤综合保税区",
            codeValue: "31176"
        },
        {
            codeName: "奉贤",
            codeValue: "31179"
        },
        {
            codeName: "上海松江出口加工区",
            codeValue: "31185"
        },
        {
            codeName: "松江综合保税区",
            codeValue: "31186"
        },
        {
            codeName: "松江",
            codeValue: "31189"
        },
        {
            codeName: "金山",
            codeValue: "31199"
        },
        {
            codeName: "上海青浦出口加工区",
            codeValue: "31205"
        },
        {
            codeName: "青浦综合保税区",
            codeValue: "31206"
        },
        {
            codeName: "青浦",
            codeValue: "31209"
        },
        {
            codeName: "崇明",
            codeValue: "31219"
        },
        {
            codeName: "上海浦东新区",
            codeValue: "31222"
        },
        {
            codeName: "上海外高桥保税区",
            codeValue: "31224"
        },
        {
            codeName: "上海金桥出口加工区南区",
            codeValue: "31225"
        },
        {
            codeName: "上海外高桥、上海浦东机场或金桥综合保税区",
            codeValue: "31226"
        },
        {
            codeName: "上海保税物流园区",
            codeValue: "31227"
        },
        {
            codeName: "浦东其他",
            codeValue: "31229"
        },
        {
            codeName: "洋山特殊综合保税区",
            codeValue: "3122S"
        },
        {
            codeName: "上海其他",
            codeValue: "31909"
        },
        {
            codeName: "南京浦口高新技术外向型开发区",
            codeValue: "32013"
        },
        {
            codeName: "江苏南京出口加工区",
            codeValue: "32015"
        },
        {
            codeName: "南京综合保税区",
            codeValue: "32016"
        },
        {
            codeName: "南京其他",
            codeValue: "32019"
        },
        {
            codeName: "南京空港保税物流中心（B型）",
            codeValue: "3201W"
        },
        {
            codeName: "无锡高新技术产业开发区",
            codeValue: "32023"
        },
        {
            codeName: "江苏无锡出口加工区",
            codeValue: "32025"
        },
        {
            codeName: "无锡高新区综合保税区",
            codeValue: "32026"
        },
        {
            codeName: "无锡其他",
            codeValue: "32029"
        },
        {
            codeName: "徐州综合保税区",
            codeValue: "32036"
        },
        {
            codeName: "徐州",
            codeValue: "32039"
        },
        {
            codeName: "徐州、新沂保税物流中心（B型）",
            codeValue: "3203W"
        },
        {
            codeName: "常州高新技术产业开发区",
            codeValue: "32043"
        },
        {
            codeName: "江苏常州出口加工区",
            codeValue: "32045"
        },
        {
            codeName: "常州综合保税区",
            codeValue: "32046"
        },
        {
            codeName: "常州其他",
            codeValue: "32049"
        },
        {
            codeName: "苏州工业园区",
            codeValue: "32052"
        },
        {
            codeName: "苏州高新技术产业开发区",
            codeValue: "32053"
        },
        {
            codeName: "江苏苏州工业园区加工区",
            codeValue: "32055"
        },
        {
            codeName: "苏州工业园综合保税区、苏州高新综保区",
            codeValue: "32056"
        },
        {
            codeName: "苏州其他",
            codeValue: "32059"
        },
        {
            codeName: "南通经济技术开发区",
            codeValue: "32062"
        },
        {
            codeName: "江苏南通出口加工区",
            codeValue: "32065"
        },
        {
            codeName: "南通综合保税区",
            codeValue: "32066"
        },
        {
            codeName: "南通其他",
            codeValue: "32069"
        },
        {
            codeName: "如皋港保税物流中心（B型）",
            codeValue: "3206W"
        },
        {
            codeName: "连云港经济技术开发区",
            codeValue: "32072"
        },
        {
            codeName: "江苏连云港出口加工区",
            codeValue: "32075"
        },
        {
            codeName: "连云港综合保税区",
            codeValue: "32076"
        },
        {
            codeName: "连云港其他",
            codeValue: "32079"
        },
        {
            codeName: "连云港保税物流中心",
            codeValue: "3207W"
        },
        {
            codeName: "江苏省淮安出口加工区",
            codeValue: "32085"
        },
        {
            codeName: "淮安综合保税区",
            codeValue: "32086"
        },
        {
            codeName: "淮安市",
            codeValue: "32089"
        },
        {
            codeName: "盐城综合保税区",
            codeValue: "32096"
        },
        {
            codeName: "盐城",
            codeValue: "32099"
        },
        {
            codeName: "大丰港保税物流中心（B型）",
            codeValue: "3209W"
        },
        {
            codeName: "江苏扬州出口加工区",
            codeValue: "32105"
        },
        {
            codeName: "扬州综合保税区",
            codeValue: "32106"
        },
        {
            codeName: "扬州",
            codeValue: "32109"
        },
        {
            codeName: "江苏镇江出口加工区",
            codeValue: "32115"
        },
        {
            codeName: "镇江综合保税区",
            codeValue: "32116"
        },
        {
            codeName: "镇江",
            codeValue: "32119"
        },
        {
            codeName: "江苏泰州出口加工区",
            codeValue: "32125"
        },
        {
            codeName: "泰州综合保税区",
            codeValue: "32126"
        },
        {
            codeName: "泰州",
            codeValue: "32129"
        },
        {
            codeName: "靖江保税物流中心（B型）",
            codeValue: "3212W"
        },
        {
            codeName: "仪征",
            codeValue: "32139"
        },
        {
            codeName: "江苏常熟出口加工区",
            codeValue: "32145"
        },
        {
            codeName: "常熟综合保税区",
            codeValue: "32146"
        },
        {
            codeName: "常熟",
            codeValue: "32149"
        },
        {
            codeName: "江苏张家港保税区",
            codeValue: "32154"
        },
        {
            codeName: "张家港保税港区",
            codeValue: "32156"
        },
        {
            codeName: "张家港保税物流园",
            codeValue: "32157"
        },
        {
            codeName: "张家港其他",
            codeValue: "32159"
        },
        {
            codeName: "江阴综合保税区",
            codeValue: "32166"
        },
        {
            codeName: "江阴",
            codeValue: "32169"
        },
        {
            codeName: "江阴保税物流中心",
            codeValue: "3216W"
        },
        {
            codeName: "宿迁",
            codeValue: "32179"
        },
        {
            codeName: "丹阳",
            codeValue: "32189"
        },
        {
            codeName: "东台",
            codeValue: "32199"
        },
        {
            codeName: "兴化",
            codeValue: "32209"
        },
        {
            codeName: "宜兴",
            codeValue: "32229"
        },
        {
            codeName: "江苏昆山出口加工区",
            codeValue: "32235"
        },
        {
            codeName: "昆山综合保税区",
            codeValue: "32236"
        },
        {
            codeName: "昆山",
            codeValue: "32239"
        },
        {
            codeName: "启东",
            codeValue: "32249"
        },
        {
            codeName: "江苏吴江出口加工区",
            codeValue: "32255"
        },
        {
            codeName: "吴江综合保税区",
            codeValue: "32256"
        },
        {
            codeName: "吴江市",
            codeValue: "32259"
        },
        {
            codeName: "太仓港综合保税区",
            codeValue: "32266"
        },
        {
            codeName: "太仓市",
            codeValue: "32269"
        },
        {
            codeName: "太仓保税物流中心",
            codeValue: "3226W"
        },
        {
            codeName: "武进综合保税区",
            codeValue: "32546"
        },
        {
            codeName: "江苏海安保税物流中心（B型）",
            codeValue: "3256W"
        },
        {
            codeName: "江苏其他",
            codeValue: "32909"
        },
        {
            codeName: "杭州经济技术开发区",
            codeValue: "33012"
        },
        {
            codeName: "杭州高新技术产业开发区",
            codeValue: "33013"
        },
        {
            codeName: "浙江杭州出口加工区",
            codeValue: "33015"
        },
        {
            codeName: "杭州综合保税区",
            codeValue: "33016"
        },
        {
            codeName: "杭州其他",
            codeValue: "33019"
        },
        {
            codeName: "宁波经济技术开发区",
            codeValue: "33022"
        },
        {
            codeName: "宁波高新技术产业开发区",
            codeValue: "33023"
        },
        {
            codeName: "宁波北仑港保税区",
            codeValue: "33024"
        },
        {
            codeName: "浙江宁波出口加工区",
            codeValue: "33025"
        },
        {
            codeName: "宁波梅山、北仑港综合保税区",
            codeValue: "33026"
        },
        {
            codeName: "宁波保税物流园",
            codeValue: "33027"
        },
        {
            codeName: "宁波其他",
            codeValue: "33029"
        },
        {
            codeName: "宁波栎社保税物流中心",
            codeValue: "3302W"
        },
        {
            codeName: "温州经济技术开发区",
            codeValue: "33032"
        },
        {
            codeName: "温州综合保税区",
            codeValue: "33036"
        },
        {
            codeName: "温州其他",
            codeValue: "33039"
        },
        {
            codeName: "温州保税物流中心（B型）",
            codeValue: "3303W"
        },
        {
            codeName: "浙江嘉兴出口加工区",
            codeValue: "33045"
        },
        {
            codeName: "嘉兴综合保税区",
            codeValue: "33046"
        },
        {
            codeName: "嘉兴",
            codeValue: "33049"
        },
        {
            codeName: "湖州经济技术开发区",
            codeValue: "33052"
        },
        {
            codeName: "湖州莫干山高新技术产业开发区",
            codeValue: "33053"
        },
        {
            codeName: "湖州",
            codeValue: "33059"
        },
        {
            codeName: "湖州及湖州德清物流中心（B型）",
            codeValue: "3305W"
        },
        {
            codeName: "绍兴综合保税区",
            codeValue: "33066"
        },
        {
            codeName: "绍兴",
            codeValue: "33069"
        },
        {
            codeName: "金华经济技术开发区",
            codeValue: "33072"
        },
        {
            codeName: "金义综合保税区（一期）",
            codeValue: "33076"
        },
        {
            codeName: "金华",
            codeValue: "33079"
        },
        {
            codeName: "衢州综合保税区",
            codeValue: "33086"
        },
        {
            codeName: "衢州",
            codeValue: "33089"
        },
        {
            codeName: "舟山港综合保税区",
            codeValue: "33096"
        },
        {
            codeName: "舟山",
            codeValue: "33099"
        },
        {
            codeName: "丽水",
            codeValue: "33109"
        },
        {
            codeName: "台州湾经济技术开发区",
            codeValue: "33112"
        },
        {
            codeName: "台州综合保税区",
            codeValue: "33116"
        },
        {
            codeName: "台州",
            codeValue: "33119"
        },
        {
            codeName: "余姚",
            codeValue: "33129"
        },
        {
            codeName: "海宁",
            codeValue: "33139"
        },
        {
            codeName: "兰溪",
            codeValue: "33149"
        },
        {
            codeName: "瑞安",
            codeValue: "33159"
        },
        {
            codeName: "萧山",
            codeValue: "33169"
        },
        {
            codeName: "杭州保税物流中心",
            codeValue: "3316W"
        },
        {
            codeName: "江山",
            codeValue: "33179"
        },
        {
            codeName: "义乌综合保税区",
            codeValue: "33186"
        },
        {
            codeName: "义乌",
            codeValue: "33189"
        },
        {
            codeName: "义乌保税物流中心",
            codeValue: "3318W"
        },
        {
            codeName: "东阳",
            codeValue: "33199"
        },
        {
            codeName: "宁波杭州湾经济技术开发区",
            codeValue: "33202"
        },
        {
            codeName: "浙江慈溪出口加工区",
            codeValue: "33205"
        },
        {
            codeName: "宁波前湾综合保税区",
            codeValue: "33206"
        },
        {
            codeName: "慈溪",
            codeValue: "33209"
        },
        {
            codeName: "奉化",
            codeValue: "33219"
        },
        {
            codeName: "诸暨",
            codeValue: "33229"
        },
        {
            codeName: "黄岩",
            codeValue: "33239"
        },
        {
            codeName: "宁波镇海保税物流中心（B型）",
            codeValue: "3352W"
        },
        {
            codeName: "浙江其他",
            codeValue: "33909"
        },
        {
            codeName: "合肥经济技术开发区",
            codeValue: "34012"
        },
        {
            codeName: "合肥科技工业园区",
            codeValue: "34013"
        },
        {
            codeName: "安徽合肥出口加工区",
            codeValue: "34015"
        },
        {
            codeName: "合肥或合肥经济技术开发区综合保税区",
            codeValue: "34016"
        },
        {
            codeName: "合肥其他",
            codeValue: "34019"
        },
        {
            codeName: "合肥空港保税物流中心（B型）",
            codeValue: "3401W"
        },
        {
            codeName: "芜湖经济技术开发区",
            codeValue: "34022"
        },
        {
            codeName: "芜湖高新技术产业开发区",
            codeValue: "34023"
        },
        {
            codeName: "安徽芜湖出口加工区",
            codeValue: "34025"
        },
        {
            codeName: "芜湖综合保税区",
            codeValue: "34026"
        },
        {
            codeName: "芜湖其他",
            codeValue: "34029"
        },
        {
            codeName: "蚌埠高新技术产业开发区",
            codeValue: "34033"
        },
        {
            codeName: "蚌埠综合保税区",
            codeValue: "34036"
        },
        {
            codeName: "蚌埠",
            codeValue: "34039"
        },
        {
            codeName: "蚌埠（皖北）保税物流中心",
            codeValue: "3403W"
        },
        {
            codeName: "安徽淮南经济技术开发区",
            codeValue: "34042"
        },
        {
            codeName: "淮南高新技术产业开发区",
            codeValue: "34043"
        },
        {
            codeName: "淮南",
            codeValue: "34049"
        },
        {
            codeName: "马鞍山经济技术开发区",
            codeValue: "34052"
        },
        {
            codeName: "马鞍山慈湖高新技术产业开发区",
            codeValue: "34053"
        },
        {
            codeName: "马鞍山综合保税区",
            codeValue: "34056"
        },
        {
            codeName: "马鞍山",
            codeValue: "34059"
        },
        {
            codeName: "淮北",
            codeValue: "34069"
        },
        {
            codeName: "铜陵经济技术开发区",
            codeValue: "34072"
        },
        {
            codeName: "铜陵",
            codeValue: "34079"
        },
        {
            codeName: "铜陵（皖中南）保税物流中心（B型）",
            codeValue: "3407W"
        },
        {
            codeName: "安庆桐城经济技术开发区",
            codeValue: "34082"
        },
        {
            codeName: "安庆综合保税区",
            codeValue: "34086"
        },
        {
            codeName: "安庆",
            codeValue: "34089"
        },
        {
            codeName: "安庆（皖西南）保税物流中心（B型）",
            codeValue: "3408W"
        },
        {
            codeName: "黄山",
            codeValue: "34099"
        },
        {
            codeName: "阜阳",
            codeValue: "34109"
        },
        {
            codeName: "宿州",
            codeValue: "34119"
        },
        {
            codeName: "滁州经济技术开发区",
            codeValue: "34122"
        },
        {
            codeName: "滁州",
            codeValue: "34129"
        },
        {
            codeName: "安徽六安经济技术开发区",
            codeValue: "34132"
        },
        {
            codeName: "六安",
            codeValue: "34139"
        },
        {
            codeName: "宣城宁国经济技术开发区",
            codeValue: "34142"
        },
        {
            codeName: "宣城",
            codeValue: "34149"
        },
        {
            codeName: "安徽皖东南保税物流中心（B型）",
            codeValue: "3414W"
        },
        {
            codeName: "巢湖",
            codeValue: "34159"
        },
        {
            codeName: "池州经济技术开发区",
            codeValue: "34162"
        },
        {
            codeName: "池州",
            codeValue: "34169"
        },
        {
            codeName: "皖江江南保税物流中心",
            codeValue: "3416W"
        },
        {
            codeName: "亳州",
            codeValue: "34179"
        },
        {
            codeName: "安徽其他",
            codeValue: "34909"
        },
        {
            codeName: "福州经济技术开发区",
            codeValue: "35012"
        },
        {
            codeName: "福州科技园区",
            codeValue: "35013"
        },
        {
            codeName: "福建马尾保税区",
            codeValue: "35014"
        },
        {
            codeName: "福建福州、福清出口加工区",
            codeValue: "35015"
        },
        {
            codeName: "福州江阴港和福州综合保税区",
            codeValue: "35016"
        },
        {
            codeName: "福州保税物流园区",
            codeValue: "35017"
        },
        {
            codeName: "福州其他",
            codeValue: "35019"
        },
        {
            codeName: "翔福保税物流中心（B型）",
            codeValue: "3501W"
        },
        {
            codeName: "厦门特区",
            codeValue: "35021"
        },
        {
            codeName: "厦门火炬高技术产业开发区",
            codeValue: "35023"
        },
        {
            codeName: "厦门象屿保税区",
            codeValue: "35024"
        },
        {
            codeName: "福建厦门出口加工区",
            codeValue: "35025"
        },
        {
            codeName: "厦门海沧港、象屿综合保税区",
            codeValue: "35026"
        },
        {
            codeName: "厦门象屿保税物流园",
            codeValue: "35027"
        },
        {
            codeName: "厦门其他",
            codeValue: "35029"
        },
        {
            codeName: "厦门火炬（翔安）保税物流中心",
            codeValue: "3502W"
        },
        {
            codeName: "莆田",
            codeValue: "35039"
        },
        {
            codeName: "三明",
            codeValue: "35049"
        },
        {
            codeName: "福建泉州出口加工区",
            codeValue: "35055"
        },
        {
            codeName: "泉州综合保税区",
            codeValue: "35056"
        },
        {
            codeName: "泉州",
            codeValue: "35059"
        },
        {
            codeName: "漳州",
            codeValue: "35069"
        },
        {
            codeName: "漳州台商投资区保税物流中心（B型）",
            codeValue: "3506W"
        },
        {
            codeName: "南平",
            codeValue: "35079"
        },
        {
            codeName: "宁德",
            codeValue: "35089"
        },
        {
            codeName: "宁德保税物流中心（B型）",
            codeValue: "3508W"
        },
        {
            codeName: "龙岩",
            codeValue: "35099"
        },
        {
            codeName: "永安",
            codeValue: "35109"
        },
        {
            codeName: "石狮",
            codeValue: "35119"
        },
        {
            codeName: "泉州石湖港保税物流中心（B型）",
            codeValue: "3511W"
        },
        {
            codeName: "平潭综合试验区",
            codeValue: "35128"
        },
        {
            codeName: "平潭",
            codeValue: "35129"
        },
        {
            codeName: "福建其他",
            codeValue: "35909"
        },
        {
            codeName: "南昌及南昌小蓝经济技术开发区",
            codeValue: "36012"
        },
        {
            codeName: "南昌高新技术产业开发区",
            codeValue: "36013"
        },
        {
            codeName: "江西南昌出口加工区",
            codeValue: "36015"
        },
        {
            codeName: "南昌综合保税区",
            codeValue: "36016"
        },
        {
            codeName: "南昌其他",
            codeValue: "36019"
        },
        {
            codeName: "南昌保税物流中心",
            codeValue: "3601W"
        },
        {
            codeName: "景德镇高新技术产业开发区",
            codeValue: "36023"
        },
        {
            codeName: "景德镇",
            codeValue: "36029"
        },
        {
            codeName: "萍乡经济技术开发区",
            codeValue: "36032"
        },
        {
            codeName: "萍乡",
            codeValue: "36039"
        },
        {
            codeName: "九江经济技术开发区",
            codeValue: "36042"
        },
        {
            codeName: "九江共青城高新技术产业开发区",
            codeValue: "36043"
        },
        {
            codeName: "江西九江出口加工区",
            codeValue: "36045"
        },
        {
            codeName: "九江综合保税区",
            codeValue: "36046"
        },
        {
            codeName: "九江",
            codeValue: "36049"
        },
        {
            codeName: "新余高新技术产业开发区",
            codeValue: "36053"
        },
        {
            codeName: "新余",
            codeValue: "36059"
        },
        {
            codeName: "贵溪经济技术开发区",
            codeValue: "36062"
        },
        {
            codeName: "鹰潭高新技术产业开发区",
            codeValue: "36063"
        },
        {
            codeName: "鹰潭",
            codeValue: "36069"
        },
        {
            codeName: "赣州、龙南及瑞金经济技术开发区",
            codeValue: "36072"
        },
        {
            codeName: "赣州高新技术产业开发区",
            codeValue: "36073"
        },
        {
            codeName: "江西赣州出口加工区",
            codeValue: "36075"
        },
        {
            codeName: "赣州综合保税区",
            codeValue: "36076"
        },
        {
            codeName: "赣州",
            codeValue: "36079"
        },
        {
            codeName: "龙南保税物流中心（B型）",
            codeValue: "3607W"
        },
        {
            codeName: "宜春经济技术开发区",
            codeValue: "36082"
        },
        {
            codeName: "宜春丰城高新技术产业开发区",
            codeValue: "36083"
        },
        {
            codeName: "宜春",
            codeValue: "36089"
        },
        {
            codeName: "上饶经济技术开发区",
            codeValue: "36092"
        },
        {
            codeName: "上饶综合保税区",
            codeValue: "36096"
        },
        {
            codeName: "上饶",
            codeValue: "36099"
        },
        {
            codeName: "井冈山经济技术开发区",
            codeValue: "36102"
        },
        {
            codeName: "吉安高新技术产业开发区",
            codeValue: "36103"
        },
        {
            codeName: "井冈山出口加工区",
            codeValue: "36105"
        },
        {
            codeName: "井冈山综合保税区",
            codeValue: "36106"
        },
        {
            codeName: "吉安",
            codeValue: "36109"
        },
        {
            codeName: "抚州高新技术产业开发区",
            codeValue: "36113"
        },
        {
            codeName: "抚州",
            codeValue: "36119"
        },
        {
            codeName: "瑞昌",
            codeValue: "36129"
        },
        {
            codeName: "江西其他",
            codeValue: "36909"
        },
        {
            codeName: "济南高技术产业开发区",
            codeValue: "37013"
        },
        {
            codeName: "山东济南出口加工区",
            codeValue: "37015"
        },
        {
            codeName: "济南或济南章锦综合保税区",
            codeValue: "37016"
        },
        {
            codeName: "济南其他",
            codeValue: "37019"
        },
        {
            codeName: "青岛经济技术开发区",
            codeValue: "37022"
        },
        {
            codeName: "青岛高新技术产业开发区",
            codeValue: "37023"
        },
        {
            codeName: "青岛保税区",
            codeValue: "37024"
        },
        {
            codeName: "山东青岛出口加工区",
            codeValue: "37025"
        },
        {
            codeName: "青岛前湾保税港区、青岛西海岸和胶州湾综合保税区",
            codeValue: "37026"
        },
        {
            codeName: "青岛保税物流园",
            codeValue: "37027"
        },
        {
            codeName: "青岛其他",
            codeValue: "37029"
        },
        {
            codeName: "青岛保税物流中心",
            codeValue: "3702W"
        },
        {
            codeName: "淄博高新技术产业开发区",
            codeValue: "37033"
        },
        {
            codeName: "淄博综合保税区",
            codeValue: "37036"
        },
        {
            codeName: "淄博",
            codeValue: "37039"
        },
        {
            codeName: "淄博保税物流中心",
            codeValue: "3703W"
        },
        {
            codeName: "枣庄",
            codeValue: "37049"
        },
        {
            codeName: "东营综合保税区",
            codeValue: "37056"
        },
        {
            codeName: "东营",
            codeValue: "37059"
        },
        {
            codeName: "烟台经济技术开发区",
            codeValue: "37062"
        },
        {
            codeName: "山东烟台出口加工区",
            codeValue: "37065"
        },
        {
            codeName: "烟台综合保税区",
            codeValue: "37066"
        },
        {
            codeName: "烟台其他",
            codeValue: "37069"
        },
        {
            codeName: "烟台福山回里保税物流中心（B型）",
            codeValue: "3706W"
        },
        {
            codeName: "潍坊高新技术产业开发区",
            codeValue: "37073"
        },
        {
            codeName: "山东潍坊出口加工区",
            codeValue: "37075"
        },
        {
            codeName: "潍坊综合保税区",
            codeValue: "37076"
        },
        {
            codeName: "潍坊其他",
            codeValue: "37079"
        },
        {
            codeName: "济宁高新技术产业开发区",
            codeValue: "37083"
        },
        {
            codeName: "济宁",
            codeValue: "37089"
        },
        {
            codeName: "济宁高新保税物流中心（B型）",
            codeValue: "3708W"
        },
        {
            codeName: "泰安",
            codeValue: "37099"
        },
        {
            codeName: "威海火炬高技术产业开发区",
            codeValue: "37103"
        },
        {
            codeName: "山东威海出口加工区",
            codeValue: "37105"
        },
        {
            codeName: "威海综合保税区北区",
            codeValue: "37106"
        },
        {
            codeName: "威海其他",
            codeValue: "37109"
        },
        {
            codeName: "日照经济技术开发区",
            codeValue: "37112"
        },
        {
            codeName: "日照综合保税区",
            codeValue: "37116"
        },
        {
            codeName: "日照",
            codeValue: "37119"
        },
        {
            codeName: "日照保税物流中心",
            codeValue: "3711W"
        },
        {
            codeName: "山东省滨州其他",
            codeValue: "37129"
        },
        {
            codeName: "鲁中运达保税物流中心",
            codeValue: "3712W"
        },
        {
            codeName: "德州",
            codeValue: "37139"
        },
        {
            codeName: "聊城",
            codeValue: "37149"
        },
        {
            codeName: "临沂综合保税区",
            codeValue: "37156"
        },
        {
            codeName: "临沂",
            codeValue: "37159"
        },
        {
            codeName: "菏泽",
            codeValue: "37169"
        },
        {
            codeName: "菏泽内陆港保税物流中心（B型）",
            codeValue: "3716W"
        },
        {
            codeName: "青州",
            codeValue: "37179"
        },
        {
            codeName: "龙口",
            codeValue: "37189"
        },
        {
            codeName: "曲阜",
            codeValue: "37199"
        },
        {
            codeName: "莱芜",
            codeValue: "37209"
        },
        {
            codeName: "新泰",
            codeValue: "37219"
        },
        {
            codeName: "青岛空港综合保税区",
            codeValue: "37226"
        },
        {
            codeName: "胶州",
            codeValue: "37229"
        },
        {
            codeName: "诸城",
            codeValue: "37239"
        },
        {
            codeName: "青岛保税港区诸城功能区保税物流中心（B型）",
            codeValue: "3723W"
        },
        {
            codeName: "莱阳",
            codeValue: "37249"
        },
        {
            codeName: "滕州",
            codeValue: "37259"
        },
        {
            codeName: "威海综合保税区南区",
            codeValue: "37266"
        },
        {
            codeName: "文登",
            codeValue: "37269"
        },
        {
            codeName: "荣城",
            codeValue: "37279"
        },
        {
            codeName: "青岛即墨综合保税区",
            codeValue: "37286"
        },
        {
            codeName: "即墨",
            codeValue: "37289"
        },
        {
            codeName: "平度",
            codeValue: "37299"
        },
        {
            codeName: "山东其他",
            codeValue: "37909"
        },
        {
            codeName: "郑州经济技术开发区",
            codeValue: "41012"
        },
        {
            codeName: "郑州高新技术开发区",
            codeValue: "41013"
        },
        {
            codeName: "河南郑州出口加工区",
            codeValue: "41015"
        },
        {
            codeName: "郑州新郑、经开综合保税区",
            codeValue: "41016"
        },
        {
            codeName: "郑州航空港经济综合实验区",
            codeValue: "41018"
        },
        {
            codeName: "郑州其他",
            codeValue: "41019"
        },
        {
            codeName: "河南保税物流中心",
            codeValue: "4101W"
        },
        {
            codeName: "开封综合保税区",
            codeValue: "41026"
        },
        {
            codeName: "开封",
            codeValue: "41029"
        },
        {
            codeName: "洛阳高新技术产业开发区",
            codeValue: "41033"
        },
        {
            codeName: "洛阳综合保税区",
            codeValue: "41036"
        },
        {
            codeName: "洛阳其他",
            codeValue: "41039"
        },
        {
            codeName: "平顶山",
            codeValue: "41049"
        },
        {
            codeName: "安阳",
            codeValue: "41059"
        },
        {
            codeName: "鹤壁",
            codeValue: "41069"
        },
        {
            codeName: "新乡",
            codeValue: "41079"
        },
        {
            codeName: "焦作",
            codeValue: "41089"
        },
        {
            codeName: "河南德众保税物流中心",
            codeValue: "4108W"
        },
        {
            codeName: "濮阳",
            codeValue: "41099"
        },
        {
            codeName: "许昌",
            codeValue: "41109"
        },
        {
            codeName: "河南许昌保税物流中心（B型）",
            codeValue: "4110W"
        },
        {
            codeName: "漯河",
            codeValue: "41119"
        },
        {
            codeName: "三门峡",
            codeValue: "41129"
        },
        {
            codeName: "商丘",
            codeValue: "41139"
        },
        {
            codeName: "河南商丘、民权保税物流中心（B型）",
            codeValue: "4113W"
        },
        {
            codeName: "周口",
            codeValue: "41149"
        },
        {
            codeName: "驻马店",
            codeValue: "41159"
        },
        {
            codeName: "南阳卧龙综合保税区",
            codeValue: "41166"
        },
        {
            codeName: "南阳",
            codeValue: "41169"
        },
        {
            codeName: "信阳",
            codeValue: "41179"
        },
        {
            codeName: "义马",
            codeValue: "41189"
        },
        {
            codeName: "汝州",
            codeValue: "41199"
        },
        {
            codeName: "济源",
            codeValue: "41209"
        },
        {
            codeName: "禹州",
            codeValue: "41219"
        },
        {
            codeName: "卫辉",
            codeValue: "41229"
        },
        {
            codeName: "辉县",
            codeValue: "41239"
        },
        {
            codeName: "泌阳",
            codeValue: "41249"
        },
        {
            codeName: "河南其他",
            codeValue: "41909"
        },
        {
            codeName: "武汉经济技术开发区",
            codeValue: "42012"
        },
        {
            codeName: "武汉东湖新技术开发区",
            codeValue: "42013"
        },
        {
            codeName: "湖北武汉出口加工区",
            codeValue: "42015"
        },
        {
            codeName: "武汉东湖、经开综合保税区",
            codeValue: "42016"
        },
        {
            codeName: "武汉其他",
            codeValue: "42019"
        },
        {
            codeName: "武汉东西湖保税物流中心",
            codeValue: "4201W"
        },
        {
            codeName: "黄石经济技术开发区",
            codeValue: "42022"
        },
        {
            codeName: "黄石棋盘洲综合保税区",
            codeValue: "42026"
        },
        {
            codeName: "黄石",
            codeValue: "42029"
        },
        {
            codeName: "黄石棋盘洲保税物流中心",
            codeValue: "4202W"
        },
        {
            codeName: "十堰经济技术开发区",
            codeValue: "42032"
        },
        {
            codeName: "十堰",
            codeValue: "42039"
        },
        {
            codeName: "沙市",
            codeValue: "42049"
        },
        {
            codeName: "宜昌综合保税区",
            codeValue: "42056"
        },
        {
            codeName: "宜昌",
            codeValue: "42059"
        },
        {
            codeName: "宜昌三峡保税物流中心（B型）",
            codeValue: "4205W"
        },
        {
            codeName: "襄阳经济技术开发区",
            codeValue: "42062"
        },
        {
            codeName: "襄阳高新技术产业开发区",
            codeValue: "42063"
        },
        {
            codeName: "襄阳综合保税区",
            codeValue: "42066"
        },
        {
            codeName: "襄阳其他",
            codeValue: "42069"
        },
        {
            codeName: "襄阳保税物流中心（B型）",
            codeValue: "4206W"
        },
        {
            codeName: "鄂州葛店经济技术开发区",
            codeValue: "42072"
        },
        {
            codeName: "鄂州",
            codeValue: "42079"
        },
        {
            codeName: "鄂州空港保税物流中心（B型）",
            codeValue: "4207W"
        },
        {
            codeName: "荆门",
            codeValue: "42089"
        },
        {
            codeName: "荆门保税物流中心（B型）",
            codeValue: "4208W"
        },
        {
            codeName: "黄冈",
            codeValue: "42099"
        },
        {
            codeName: "汉川经济技术开发区",
            codeValue: "42102"
        },
        {
            codeName: "孝感",
            codeValue: "42109"
        },
        {
            codeName: "咸宁",
            codeValue: "42119"
        },
        {
            codeName: "荆州经济技术开发区",
            codeValue: "42122"
        },
        {
            codeName: "荆州",
            codeValue: "42129"
        },
        {
            codeName: "郧阳",
            codeValue: "42139"
        },
        {
            codeName: "鄂西",
            codeValue: "42149"
        },
        {
            codeName: "随州",
            codeValue: "42159"
        },
        {
            codeName: "老河口",
            codeValue: "42169"
        },
        {
            codeName: "枣阳经济技术开发区",
            codeValue: "42172"
        },
        {
            codeName: "枣阳",
            codeValue: "42179"
        },
        {
            codeName: "神农架",
            codeValue: "42189"
        },
        {
            codeName: "仙桃市",
            codeValue: "42199"
        },
        {
            codeName: "仙桃保税物流中心（B型）",
            codeValue: "4219W"
        },
        {
            codeName: "潜江市",
            codeValue: "42209"
        },
        {
            codeName: "天门市",
            codeValue: "42219"
        },
        {
            codeName: "武汉新港空港",
            codeValue: "42506"
        },
        {
            codeName: "湖北其他",
            codeValue: "42909"
        },
        {
            codeName: "长沙经济技术开发区",
            codeValue: "43012"
        },
        {
            codeName: "长沙科技开发区",
            codeValue: "43013"
        },
        {
            codeName: "长沙黄花综合保税区",
            codeValue: "43016"
        },
        {
            codeName: "长沙其他",
            codeValue: "43019"
        },
        {
            codeName: "长沙金霞保税物流中心",
            codeValue: "4301W"
        },
        {
            codeName: "株洲高新技术产业开发区",
            codeValue: "43023"
        },
        {
            codeName: "株洲其他",
            codeValue: "43029"
        },
        {
            codeName: "株洲铜塘湾保税物流中心（B型）",
            codeValue: "4302W"
        },
        {
            codeName: "湘潭经济技术开发区",
            codeValue: "43032"
        },
        {
            codeName: "湘潭高新技术产业开发区",
            codeValue: "43033"
        },
        {
            codeName: "湘潭综合保税区",
            codeValue: "43036"
        },
        {
            codeName: "湘潭",
            codeValue: "43039"
        },
        {
            codeName: "衡阳高新技术产业开发区",
            codeValue: "43043"
        },
        {
            codeName: "衡阳综合保税区",
            codeValue: "43046"
        },
        {
            codeName: "衡阳",
            codeValue: "43049"
        },
        {
            codeName: "邵阳",
            codeValue: "43059"
        },
        {
            codeName: "岳阳经济技术开发区",
            codeValue: "43062"
        },
        {
            codeName: "岳阳城陵矶综合保税区",
            codeValue: "43066"
        },
        {
            codeName: "岳阳",
            codeValue: "43069"
        },
        {
            codeName: "常德经济技术开发区",
            codeValue: "43072"
        },
        {
            codeName: "常德高新技术产业开发区",
            codeValue: "43073"
        },
        {
            codeName: "常德",
            codeValue: "43079"
        },
        {
            codeName: "张家界",
            codeValue: "43089"
        },
        {
            codeName: "益阳高新技术产业开发区",
            codeValue: "43093"
        },
        {
            codeName: "益阳",
            codeValue: "43099"
        },
        {
            codeName: "娄底经济技术开发区",
            codeValue: "43102"
        },
        {
            codeName: "娄底",
            codeValue: "43109"
        },
        {
            codeName: "郴州高新技术产业开发区",
            codeValue: "43113"
        },
        {
            codeName: "湖南郴州出口加工区",
            codeValue: "43115"
        },
        {
            codeName: "郴州综合保税区",
            codeValue: "43116"
        },
        {
            codeName: "郴州",
            codeValue: "43119"
        },
        {
            codeName: "永州",
            codeValue: "43129"
        },
        {
            codeName: "怀化高新技术产业开发区",
            codeValue: "43133"
        },
        {
            codeName: "怀化",
            codeValue: "43139"
        },
        {
            codeName: "湘西",
            codeValue: "43149"
        },
        {
            codeName: "醴陵",
            codeValue: "43159"
        },
        {
            codeName: "湘乡",
            codeValue: "43169"
        },
        {
            codeName: "耒阳",
            codeValue: "43179"
        },
        {
            codeName: "汩罗",
            codeValue: "43189"
        },
        {
            codeName: "津市",
            codeValue: "43199"
        },
        {
            codeName: "浏阳经济技术开发区",
            codeValue: "43202"
        },
        {
            codeName: "浏阳其他",
            codeValue: "43209"
        },
        {
            codeName: "湖南其他",
            codeValue: "43909"
        },
        {
            codeName: "广州经济技术开发区",
            codeValue: "44012"
        },
        {
            codeName: "广州天河高新技术产业开发区",
            codeValue: "44013"
        },
        {
            codeName: "广州保税区",
            codeValue: "44014"
        },
        {
            codeName: "广东广州出口加工区",
            codeValue: "44015"
        },
        {
            codeName: "广州白云机场、黄埔综合保税区",
            codeValue: "44016"
        },
        {
            codeName: "广州保税物流园区",
            codeValue: "44017"
        },
        {
            codeName: "广州其他",
            codeValue: "44019"
        },
        {
            codeName: "韶关",
            codeValue: "44029"
        },
        {
            codeName: "深圳特区",
            codeValue: "44031"
        },
        {
            codeName: "深圳科技工业园",
            codeValue: "44033"
        },
        {
            codeName: "福田盐田沙头角保税区",
            codeValue: "44034"
        },
        {
            codeName: "广东深圳出口加工区",
            codeValue: "44035"
        },
        {
            codeName: "深圳前海、坪山综合保税区",
            codeValue: "44036"
        },
        {
            codeName: "深圳盐田保税物流园",
            codeValue: "44037"
        },
        {
            codeName: "深圳其他",
            codeValue: "44039"
        },
        {
            codeName: "深圳机场保税物流中心",
            codeValue: "4403W"
        },
        {
            codeName: "珠海特区",
            codeValue: "44041"
        },
        {
            codeName: "珠海高新技术产业开发区",
            codeValue: "44043"
        },
        {
            codeName: "珠海保税区",
            codeValue: "44044"
        },
        {
            codeName: "珠澳跨境工业区珠海园区",
            codeValue: "44045"
        },
        {
            codeName: "珠海高栏港综合保税区",
            codeValue: "44046"
        },
        {
            codeName: "横琴粤澳深度合作区",
            codeValue: "44048"
        },
        {
            codeName: "珠海其他",
            codeValue: "44049"
        },
        {
            codeName: "汕头特区",
            codeValue: "44051"
        },
        {
            codeName: "汕头保税区",
            codeValue: "44054"
        },
        {
            codeName: "汕头综合保税区",
            codeValue: "44056"
        },
        {
            codeName: "汕头其他",
            codeValue: "44059"
        },
        {
            codeName: "汕头保税物流中心（B型）",
            codeValue: "4405W"
        },
        {
            codeName: "佛山高新技术产业开发区",
            codeValue: "44063"
        },
        {
            codeName: "佛山其他",
            codeValue: "44069"
        },
        {
            codeName: "江门",
            codeValue: "44079"
        },
        {
            codeName: "江门大广海湾保税物流中心（B型）",
            codeValue: "4407W"
        },
        {
            codeName: "湛江经济技术开发区",
            codeValue: "44082"
        },
        {
            codeName: "湛江高新技术产业开发区",
            codeValue: "44083"
        },
        {
            codeName: "湛江综合保税区",
            codeValue: "44086"
        },
        {
            codeName: "湛江其他",
            codeValue: "44089"
        },
        {
            codeName: "湛江保税物流中心（B型）",
            codeValue: "4408W"
        },
        {
            codeName: "茂名高新技术产业开发区",
            codeValue: "44093"
        },
        {
            codeName: "茂名",
            codeValue: "44099"
        },
        {
            codeName: "肇庆",
            codeValue: "44129"
        },
        {
            codeName: "惠州高新技术产业开发区",
            codeValue: "44133"
        },
        {
            codeName: "惠州其他",
            codeValue: "44139"
        },
        {
            codeName: "梅州综合保税区",
            codeValue: "44146"
        },
        {
            codeName: "梅州",
            codeValue: "44149"
        },
        {
            codeName: "汕尾",
            codeValue: "44159"
        },
        {
            codeName: "河源",
            codeValue: "44169"
        },
        {
            codeName: "阳江",
            codeValue: "44179"
        },
        {
            codeName: "清远",
            codeValue: "44189"
        },
        {
            codeName: "东莞松山湖高新技术产业开发区",
            codeValue: "44193"
        },
        {
            codeName: "东莞虎门港综合保税区",
            codeValue: "44196"
        },
        {
            codeName: "东莞",
            codeValue: "44199"
        },
        {
            codeName: "东莞保税物流中心",
            codeValue: "4419W"
        },
        {
            codeName: "中山火炬高技术产业开发区",
            codeValue: "44203"
        },
        {
            codeName: "中山其他",
            codeValue: "44209"
        },
        {
            codeName: "中山保税物流中心",
            codeValue: "4420W"
        },
        {
            codeName: "潮州",
            codeValue: "44219"
        },
        {
            codeName: "佛山综合保税区",
            codeValue: "44226"
        },
        {
            codeName: "顺德",
            codeValue: "44229"
        },
        {
            codeName: "佛山国通保税物流中心（B型）",
            codeValue: "4422W"
        },
        {
            codeName: "广东南沙出口加工区",
            codeValue: "44235"
        },
        {
            codeName: "广州南沙保税港区",
            codeValue: "44236"
        },
        {
            codeName: "番禺",
            codeValue: "44239"
        },
        {
            codeName: "揭阳",
            codeValue: "44249"
        },
        {
            codeName: "南海",
            codeValue: "44289"
        },
        {
            codeName: "佛山国际陆港保税物流中心（B型）",
            codeValue: "4428W"
        },
        {
            codeName: "云浮市",
            codeValue: "44299"
        },
        {
            codeName: "广州南沙综合保税区",
            codeValue: "44306"
        },
        {
            codeName: "南沙其他",
            codeValue: "44309"
        },
        {
            codeName: "深圳盐田综合保税区（一期）",
            codeValue: "44536"
        },
        {
            codeName: "东莞清溪保税物流中心（B型）",
            codeValue: "4469W"
        },
        {
            codeName: "广东其他",
            codeValue: "44909"
        },
        {
            codeName: "广西-东盟、南宁经济技术开发区",
            codeValue: "45012"
        },
        {
            codeName: "南宁高新技术产业开发区",
            codeValue: "45013"
        },
        {
            codeName: "南宁综合保税区",
            codeValue: "45016"
        },
        {
            codeName: "南宁其他",
            codeValue: "45019"
        },
        {
            codeName: "南宁保税物流中心",
            codeValue: "4501W"
        },
        {
            codeName: "柳州高新技术产业开发区",
            codeValue: "45023"
        },
        {
            codeName: "柳州",
            codeValue: "45029"
        },
        {
            codeName: "柳州保税物流中心（B型）",
            codeValue: "4502W"
        },
        {
            codeName: "桂林高新技术产业开发区",
            codeValue: "45033"
        },
        {
            codeName: "桂林其他",
            codeValue: "45039"
        },
        {
            codeName: "梧州综合保税区",
            codeValue: "45046"
        },
        {
            codeName: "梧州",
            codeValue: "45049"
        },
        {
            codeName: "北海经济技术开发区",
            codeValue: "45052"
        },
        {
            codeName: "北海高新技术产业开发区",
            codeValue: "45053"
        },
        {
            codeName: "广西北海出口加工区",
            codeValue: "45055"
        },
        {
            codeName: "北海综合保税区",
            codeValue: "45056"
        },
        {
            codeName: "北海",
            codeValue: "45059"
        },
        {
            codeName: "玉林",
            codeValue: "45069"
        },
        {
            codeName: "百色",
            codeValue: "45079"
        },
        {
            codeName: "河池",
            codeValue: "45089"
        },
        {
            codeName: "钦州港经济技术开发区",
            codeValue: "45092"
        },
        {
            codeName: "钦州综合保税区",
            codeValue: "45096"
        },
        {
            codeName: "钦州",
            codeValue: "45099"
        },
        {
            codeName: "广西凭祥综合保税区",
            codeValue: "45106"
        },
        {
            codeName: "凭祥",
            codeValue: "45109"
        },
        {
            codeName: "东兴",
            codeValue: "45119"
        },
        {
            codeName: "防城港市",
            codeValue: "45129"
        },
        {
            codeName: "防城港保税物流中心（B型）",
            codeValue: "4512W"
        },
        {
            codeName: "贵港市",
            codeValue: "45139"
        },
        {
            codeName: "崇左",
            codeValue: "45149"
        },
        {
            codeName: "来宾",
            codeValue: "45159"
        },
        {
            codeName: "贺州",
            codeValue: "45169"
        },
        {
            codeName: "广西其他",
            codeValue: "45909"
        },
        {
            codeName: "海口",
            codeValue: "46011"
        },
        {
            codeName: "海南国际科技园区",
            codeValue: "46013"
        },
        {
            codeName: "海南海口保税区",
            codeValue: "46014"
        },
        {
            codeName: "海口综合保税区及海口空港综合保税区",
            codeValue: "46016"
        },
        {
            codeName: "三亚",
            codeValue: "46021"
        },
        {
            codeName: "海南三亚保税物流中心（B型）",
            codeValue: "4602W"
        },
        {
            codeName: "三沙",
            codeValue: "46031"
        },
        {
            codeName: "五指山",
            codeValue: "46041"
        },
        {
            codeName: "琼海",
            codeValue: "46051"
        },
        {
            codeName: "儋州",
            codeValue: "46061"
        },
        {
            codeName: "洋浦经济开发区",
            codeValue: "46062"
        },
        {
            codeName: "洋浦保税港区",
            codeValue: "46066"
        },
        {
            codeName: "文昌",
            codeValue: "46071"
        },
        {
            codeName: "万宁",
            codeValue: "46081"
        },
        {
            codeName: "东方",
            codeValue: "46091"
        },
        {
            codeName: "定安",
            codeValue: "46101"
        },
        {
            codeName: "屯昌",
            codeValue: "46111"
        },
        {
            codeName: "澄迈",
            codeValue: "46121"
        },
        {
            codeName: "临高",
            codeValue: "46131"
        },
        {
            codeName: "白沙",
            codeValue: "46141"
        },
        {
            codeName: "昌江",
            codeValue: "46151"
        },
        {
            codeName: "乐东",
            codeValue: "46161"
        },
        {
            codeName: "陵水",
            codeValue: "46171"
        },
        {
            codeName: "保亭",
            codeValue: "46181"
        },
        {
            codeName: "琼中",
            codeValue: "46191"
        },
        {
            codeName: "海南其他",
            codeValue: "46901"
        },
        {
            codeName: "海南洋浦经济技术开发区",
            codeValue: "46902"
        },
        {
            codeName: "海南洋浦保税港区",
            codeValue: "46906"
        },
        {
            codeName: "万州经济技术开发区",
            codeValue: "50012"
        },
        {
            codeName: "重庆万州综合保税区",
            codeValue: "50016"
        },
        {
            codeName: "万州区",
            codeValue: "50019"
        },
        {
            codeName: "涪陵经济技术开发区",
            codeValue: "50022"
        },
        {
            codeName: "重庆涪陵综合保税区",
            codeValue: "50026"
        },
        {
            codeName: "涪陵区",
            codeValue: "50029"
        },
        {
            codeName: "渝中区",
            codeValue: "50039"
        },
        {
            codeName: "大渡口区",
            codeValue: "50049"
        },
        {
            codeName: "重庆两江新区江北区",
            codeValue: "50052"
        },
        {
            codeName: "重庆两路果园港综合保税区果园港片区",
            codeValue: "50056"
        },
        {
            codeName: "江北区",
            codeValue: "50059"
        },
        {
            codeName: "重庆果园保税物流中心（B型）",
            codeValue: "5005W"
        },
        {
            codeName: "重庆西永、国际铁路港综合保税区",
            codeValue: "50066"
        },
        {
            codeName: "沙坪坝区",
            codeValue: "50069"
        },
        {
            codeName: "重庆铁路保税物流中心",
            codeValue: "5006W"
        },
        {
            codeName: "重庆高新技术产业开发区",
            codeValue: "50073"
        },
        {
            codeName: "九龙坡区",
            codeValue: "50079"
        },
        {
            codeName: "重庆经济技术开发区",
            codeValue: "50082"
        },
        {
            codeName: "南岸区",
            codeValue: "50089"
        },
        {
            codeName: "重庆两江新区北碚区",
            codeValue: "50092"
        },
        {
            codeName: "北碚区",
            codeValue: "50099"
        },
        {
            codeName: "万盛区",
            codeValue: "50109"
        },
        {
            codeName: "双桥区",
            codeValue: "50119"
        },
        {
            codeName: "重庆两江新区渝北区",
            codeValue: "50122"
        },
        {
            codeName: "重庆出口加工区",
            codeValue: "50125"
        },
        {
            codeName: "重庆两路果园港综合保税区两路片区",
            codeValue: "50126"
        },
        {
            codeName: "渝北区",
            codeValue: "50129"
        },
        {
            codeName: "巴南区",
            codeValue: "50139"
        },
        {
            codeName: "重庆南彭公路保税物流中心（B型）",
            codeValue: "5013W"
        },
        {
            codeName: "长寿经济技术开发区",
            codeValue: "50212"
        },
        {
            codeName: "长寿县",
            codeValue: "50219"
        },
        {
            codeName: "綦江区",
            codeValue: "50229"
        },
        {
            codeName: "潼南县",
            codeValue: "50239"
        },
        {
            codeName: "重庆市铜梁区",
            codeValue: "50249"
        },
        {
            codeName: "大足区",
            codeValue: "50259"
        },
        {
            codeName: "荣昌县",
            codeValue: "50269"
        },
        {
            codeName: "璧山高新技术产业开发区",
            codeValue: "50273"
        },
        {
            codeName: "重庆市璧山区",
            codeValue: "50279"
        },
        {
            codeName: "梁平县",
            codeValue: "50289"
        },
        {
            codeName: "城口县",
            codeValue: "50299"
        },
        {
            codeName: "丰都县",
            codeValue: "50309"
        },
        {
            codeName: "垫江县",
            codeValue: "50319"
        },
        {
            codeName: "武隆县",
            codeValue: "50329"
        },
        {
            codeName: "忠县",
            codeValue: "50339"
        },
        {
            codeName: "开县",
            codeValue: "50349"
        },
        {
            codeName: "云阳县",
            codeValue: "50359"
        },
        {
            codeName: "奉节县",
            codeValue: "50369"
        },
        {
            codeName: "巫山县",
            codeValue: "50379"
        },
        {
            codeName: "巫溪县",
            codeValue: "50389"
        },
        {
            codeName: "黔江",
            codeValue: "50399"
        },
        {
            codeName: "石柱土家族自治县",
            codeValue: "50409"
        },
        {
            codeName: "秀山土家族苗族自治县",
            codeValue: "50419"
        },
        {
            codeName: "酉阳土家族苗族自治县",
            codeValue: "50429"
        },
        {
            codeName: "彭水苗族土家族自治县",
            codeValue: "50439"
        },
        {
            codeName: "重庆江津综合保税区",
            codeValue: "50816"
        },
        {
            codeName: "江津区",
            codeValue: "50819"
        },
        {
            codeName: "合川区",
            codeValue: "50829"
        },
        {
            codeName: "重庆永川综合保税区",
            codeValue: "50836"
        },
        {
            codeName: "永川区",
            codeValue: "50839"
        },
        {
            codeName: "南川区",
            codeValue: "50849"
        },
        {
            codeName: "成都经济技术开发区",
            codeValue: "51012"
        },
        {
            codeName: "成都高新技术产业开发区",
            codeValue: "51013"
        },
        {
            codeName: "四川成都出口加工区",
            codeValue: "51015"
        },
        {
            codeName: "成都高新、国际铁路港综合保税区",
            codeValue: "51016"
        },
        {
            codeName: "成都其他",
            codeValue: "51019"
        },
        {
            codeName: "成都空港、天府新区成都片区保税物流中心",
            codeValue: "5101W"
        },
        {
            codeName: "自贡",
            codeValue: "51039"
        },
        {
            codeName: "攀枝花",
            codeValue: "51049"
        },
        {
            codeName: "泸州高新技术产业开发区",
            codeValue: "51053"
        },
        {
            codeName: "泸州综合保税区",
            codeValue: "51056"
        },
        {
            codeName: "泸州",
            codeValue: "51059"
        },
        {
            codeName: "泸州港保税物流中心（Ｂ型）",
            codeValue: "5105W"
        },
        {
            codeName: "德阳",
            codeValue: "51069"
        },
        {
            codeName: "绵阳经济技术开发区",
            codeValue: "51072"
        },
        {
            codeName: "绵阳高新技术产业开发区",
            codeValue: "51073"
        },
        {
            codeName: "四川绵阳出口加工区",
            codeValue: "51075"
        },
        {
            codeName: "绵阳综合保税区",
            codeValue: "51076"
        },
        {
            codeName: "绵阳其他",
            codeValue: "51079"
        },
        {
            codeName: "广元经济技术开发区",
            codeValue: "51082"
        },
        {
            codeName: "广元",
            codeValue: "51089"
        },
        {
            codeName: "遂宁",
            codeValue: "51099"
        },
        {
            codeName: "内江经济技术开发区",
            codeValue: "51102"
        },
        {
            codeName: "内江高新技术产业开发区",
            codeValue: "51103"
        },
        {
            codeName: "内江市其他地区",
            codeValue: "51109"
        },
        {
            codeName: "内江保税物流中心（ B 型）",
            codeValue: "5110W"
        },
        {
            codeName: "乐山高新技术产业开发区",
            codeValue: "51113"
        },
        {
            codeName: "乐山",
            codeValue: "51119"
        },
        {
            codeName: "宜宾临港经济开发区",
            codeValue: "51142"
        },
        {
            codeName: "宜宾综合保税区",
            codeValue: "51146"
        },
        {
            codeName: "宜宾",
            codeValue: "51149"
        },
        {
            codeName: "宜宾港保税物流中心（B型）",
            codeValue: "5114W"
        },
        {
            codeName: "南充",
            codeValue: "51159"
        },
        {
            codeName: "南充保税物流中心（B型）",
            codeValue: "5115W"
        },
        {
            codeName: "达县",
            codeValue: "51169"
        },
        {
            codeName: "雅安",
            codeValue: "51179"
        },
        {
            codeName: "阿坝",
            codeValue: "51189"
        },
        {
            codeName: "甘孜",
            codeValue: "51199"
        },
        {
            codeName: "凉山",
            codeValue: "51209"
        },
        {
            codeName: "广汉",
            codeValue: "51229"
        },
        {
            codeName: "江油",
            codeValue: "51239"
        },
        {
            codeName: "都江堰",
            codeValue: "51249"
        },
        {
            codeName: "峨眉山",
            codeValue: "51259"
        },
        {
            codeName: "资阳",
            codeValue: "51269"
        },
        {
            codeName: "眉山",
            codeValue: "51279"
        },
        {
            codeName: "广安",
            codeValue: "51289"
        },
        {
            codeName: "巴中",
            codeValue: "51299"
        },
        {
            codeName: "成都铁路保税物流中心（B型）",
            codeValue: "5151W"
        },
        {
            codeName: "四川其他",
            codeValue: "51909"
        },
        {
            codeName: "贵阳高新技术产业开发区",
            codeValue: "52013"
        },
        {
            codeName: "贵阳综合保税区",
            codeValue: "52016"
        },
        {
            codeName: "贵阳其他",
            codeValue: "52019"
        },
        {
            codeName: "六盘水",
            codeValue: "52029"
        },
        {
            codeName: "遵义综合保税区",
            codeValue: "52036"
        },
        {
            codeName: "遵义",
            codeValue: "52039"
        },
        {
            codeName: "铜仁",
            codeValue: "52049"
        },
        {
            codeName: "黔西南",
            codeValue: "52059"
        },
        {
            codeName: "毕节",
            codeValue: "52069"
        },
        {
            codeName: "安顺",
            codeValue: "52079"
        },
        {
            codeName: "黔东南",
            codeValue: "52089"
        },
        {
            codeName: "黔南",
            codeValue: "52099"
        },
        {
            codeName: "贵阳贵安新区",
            codeValue: "52502"
        },
        {
            codeName: "贵安综合保税区",
            codeValue: "52506"
        },
        {
            codeName: "贵州其他",
            codeValue: "52909"
        },
        {
            codeName: "昆明经济技术开发区",
            codeValue: "53012"
        },
        {
            codeName: "昆明高新技术产业开发区",
            codeValue: "53013"
        },
        {
            codeName: "云南昆明出口加工区",
            codeValue: "53015"
        },
        {
            codeName: "昆明综合保税区",
            codeValue: "53016"
        },
        {
            codeName: "昆明其他",
            codeValue: "53019"
        },
        {
            codeName: "昆明高新保税物流中心（B型）",
            codeValue: "5301W"
        },
        {
            codeName: "东川",
            codeValue: "53029"
        },
        {
            codeName: "昭通",
            codeValue: "53039"
        },
        {
            codeName: "曲靖经济技术开发区",
            codeValue: "53042"
        },
        {
            codeName: "曲靖",
            codeValue: "53049"
        },
        {
            codeName: "楚雄",
            codeValue: "53059"
        },
        {
            codeName: "玉溪",
            codeValue: "53069"
        },
        {
            codeName: "云南省蒙自经济技术开发区",
            codeValue: "53072"
        },
        {
            codeName: "云南红河综合保税区",
            codeValue: "53076"
        },
        {
            codeName: "红河",
            codeValue: "53079"
        },
        {
            codeName: "文山",
            codeValue: "53089"
        },
        {
            codeName: "普洱",
            codeValue: "53099"
        },
        {
            codeName: "西双版纳",
            codeValue: "53109"
        },
        {
            codeName: "大理经济技术开发区",
            codeValue: "53112"
        },
        {
            codeName: "大理",
            codeValue: "53119"
        },
        {
            codeName: "保山",
            codeValue: "53129"
        },
        {
            codeName: "德宏",
            codeValue: "53139"
        },
        {
            codeName: "丽江",
            codeValue: "53149"
        },
        {
            codeName: "怒江",
            codeValue: "53159"
        },
        {
            codeName: "迪庆",
            codeValue: "53169"
        },
        {
            codeName: "临沧",
            codeValue: "53179"
        },
        {
            codeName: "畹町",
            codeValue: "53189"
        },
        {
            codeName: "瑞丽",
            codeValue: "53199"
        },
        {
            codeName: "河口",
            codeValue: "53209"
        },
        {
            codeName: "腾俊国际陆港保税物流中心（B型）",
            codeValue: "5351W"
        },
        {
            codeName: "云南其他",
            codeValue: "53909"
        },
        {
            codeName: "拉萨经济技术开发区",
            codeValue: "54012"
        },
        {
            codeName: "拉萨综合保税区",
            codeValue: "54016"
        },
        {
            codeName: "拉萨",
            codeValue: "54019"
        },
        {
            codeName: "昌都",
            codeValue: "54029"
        },
        {
            codeName: "山南",
            codeValue: "54039"
        },
        {
            codeName: "日喀则",
            codeValue: "54049"
        },
        {
            codeName: "那曲",
            codeValue: "54059"
        },
        {
            codeName: "阿里",
            codeValue: "54069"
        },
        {
            codeName: "林芝",
            codeValue: "54079"
        },
        {
            codeName: "西藏其他",
            codeValue: "54909"
        },
        {
            codeName: "陕西航天、陕西航空、西安市经济技术开发区",
            codeValue: "61012"
        },
        {
            codeName: "西安新技术产业开发区",
            codeValue: "61013"
        },
        {
            codeName: "陕西西安出口加工区",
            codeValue: "61015"
        },
        {
            codeName: "西安、西安高新、西安航空基地和西安关中综合保税区",
            codeValue: "61016"
        },
        {
            codeName: "西安其他",
            codeValue: "61019"
        },
        {
            codeName: "铜川",
            codeValue: "61029"
        },
        {
            codeName: "宝鸡高新技术产业开发区",
            codeValue: "61033"
        },
        {
            codeName: "宝鸡综合保税区",
            codeValue: "61036"
        },
        {
            codeName: "宝鸡其他",
            codeValue: "61039"
        },
        {
            codeName: "杨凌农业高新技术产业示范区",
            codeValue: "61043"
        },
        {
            codeName: "陕西西咸空港、杨凌综合保税区",
            codeValue: "61046"
        },
        {
            codeName: "咸阳",
            codeValue: "61049"
        },
        {
            codeName: "陕西西咸保税物流中心",
            codeValue: "6104W"
        },
        {
            codeName: "渭南",
            codeValue: "61059"
        },
        {
            codeName: "汉中经济技术开发区",
            codeValue: "61062"
        },
        {
            codeName: "汉中",
            codeValue: "61069"
        },
        {
            codeName: "安康",
            codeValue: "61079"
        },
        {
            codeName: "商洛",
            codeValue: "61089"
        },
        {
            codeName: "延安",
            codeValue: "61099"
        },
        {
            codeName: "陕西榆林经济技术开发区",
            codeValue: "61102"
        },
        {
            codeName: "榆林",
            codeValue: "61109"
        },
        {
            codeName: "陕西其他",
            codeValue: "61909"
        },
        {
            codeName: "兰州宁卧庄新技术产业开发区",
            codeValue: "62013"
        },
        {
            codeName: "兰州新区综合保税区",
            codeValue: "62016"
        },
        {
            codeName: "兰州其他",
            codeValue: "62019"
        },
        {
            codeName: "嘉峪关",
            codeValue: "62029"
        },
        {
            codeName: "金昌",
            codeValue: "62039"
        },
        {
            codeName: "白银",
            codeValue: "62049"
        },
        {
            codeName: "天水",
            codeValue: "62059"
        },
        {
            codeName: "酒泉",
            codeValue: "62069"
        },
        {
            codeName: "张掖",
            codeValue: "62079"
        },
        {
            codeName: "武威",
            codeValue: "62089"
        },
        {
            codeName: "武威保税物流中心",
            codeValue: "6208W"
        },
        {
            codeName: "定西",
            codeValue: "62099"
        },
        {
            codeName: "陇南",
            codeValue: "62109"
        },
        {
            codeName: "平凉",
            codeValue: "62119"
        },
        {
            codeName: "庆阳",
            codeValue: "62129"
        },
        {
            codeName: "临夏",
            codeValue: "62139"
        },
        {
            codeName: "甘南",
            codeValue: "62149"
        },
        {
            codeName: "甘肃其他",
            codeValue: "62909"
        },
        {
            codeName: "西宁经济技术开发区",
            codeValue: "63012"
        },
        {
            codeName: "青海高新技术产业开发区",
            codeValue: "63013"
        },
        {
            codeName: "西宁综合保税区",
            codeValue: "63016"
        },
        {
            codeName: "西宁",
            codeValue: "63019"
        },
        {
            codeName: "海东",
            codeValue: "63029"
        },
        {
            codeName: "青海曹家堡保税物流中心（B型）",
            codeValue: "6302W"
        },
        {
            codeName: "海北",
            codeValue: "63039"
        },
        {
            codeName: "黄南",
            codeValue: "63049"
        },
        {
            codeName: "海南",
            codeValue: "63059"
        },
        {
            codeName: "果洛",
            codeValue: "63069"
        },
        {
            codeName: "玉树",
            codeValue: "63079"
        },
        {
            codeName: "格尔木昆仑经济技术开发区",
            codeValue: "63082"
        },
        {
            codeName: "海西",
            codeValue: "63089"
        },
        {
            codeName: "青海其他",
            codeValue: "63909"
        },
        {
            codeName: "银川经济技术开发区",
            codeValue: "64012"
        },
        {
            codeName: "银川综合保税区",
            codeValue: "64016"
        },
        {
            codeName: "银川",
            codeValue: "64019"
        },
        {
            codeName: "石嘴山",
            codeValue: "64029"
        },
        {
            codeName: "石嘴山保税物流中心（B型）",
            codeValue: "6402W"
        },
        {
            codeName: "吴忠",
            codeValue: "64039"
        },
        {
            codeName: "固原",
            codeValue: "64049"
        },
        {
            codeName: "中卫",
            codeValue: "64059"
        },
        {
            codeName: "宁夏其他",
            codeValue: "64909"
        },
        {
            codeName: "乌鲁木齐经济技术开发区和甘泉堡经济技术开发区",
            codeValue: "65012"
        },
        {
            codeName: "乌鲁木齐高新技术产业开发区",
            codeValue: "65013"
        },
        {
            codeName: "新疆乌鲁木齐出口加工区",
            codeValue: "65015"
        },
        {
            codeName: "乌鲁木齐综合保税区",
            codeValue: "65016"
        },
        {
            codeName: "乌鲁木齐其他",
            codeValue: "65019"
        },
        {
            codeName: "克拉玛依",
            codeValue: "65029"
        },
        {
            codeName: "阿拉山口综合保税区",
            codeValue: "65036"
        },
        {
            codeName: "博乐",
            codeValue: "65039"
        },
        {
            codeName: "巴音",
            codeValue: "65049"
        },
        {
            codeName: "阿克苏",
            codeValue: "65059"
        },
        {
            codeName: "克孜",
            codeValue: "65069"
        },
        {
            codeName: "喀什综合保税区",
            codeValue: "65076"
        },
        {
            codeName: "喀什",
            codeValue: "65079"
        },
        {
            codeName: "和田",
            codeValue: "65089"
        },
        {
            codeName: "中哈霍尔果斯国际边境合作中心中方配套区（一期）",
            codeValue: "65095"
        },
        {
            codeName: "霍尔果斯综合保税区",
            codeValue: "65096"
        },
        {
            codeName: "伊宁",
            codeValue: "65099"
        },
        {
            codeName: "中哈霍尔果斯国际边境合作中心中方区域",
            codeValue: "6509A"
        },
        {
            codeName: "奎屯保税物流中心",
            codeValue: "6509W"
        },
        {
            codeName: "塔城",
            codeValue: "65109"
        },
        {
            codeName: "阿勒泰",
            codeValue: "65119"
        },
        {
            codeName: "石河子经济技术开发区",
            codeValue: "65122"
        },
        {
            codeName: "石河子",
            codeValue: "65129"
        },
        {
            codeName: "吐鲁番",
            codeValue: "65219"
        },
        {
            codeName: "哈密",
            codeValue: "65229"
        },
        {
            codeName: "昌吉回族自治州",
            codeValue: "65239"
        },
        {
            codeName: "新疆其他",
            codeValue: "65909"
        }
    ],
    // 产地代码
    CIQ_CITY_CN: [
        {
            codeName: "北京市",
            codeValue: "110000"
        },
        {
            codeName: "北京市市辖区",
            codeValue: "110100"
        },
        {
            codeName: "北京市东城区",
            codeValue: "110101"
        },
        {
            codeName: "北京市西城区",
            codeValue: "110102"
        },
        {
            codeName: "北京市朝阳区",
            codeValue: "110105"
        },
        {
            codeName: "北京市丰台区",
            codeValue: "110106"
        },
        {
            codeName: "北京市石景山区",
            codeValue: "110107"
        },
        {
            codeName: "北京市海淀区",
            codeValue: "110108"
        },
        {
            codeName: "北京市门头沟区",
            codeValue: "110109"
        },
        {
            codeName: "北京市房山区",
            codeValue: "110111"
        },
        {
            codeName: "北京市通州区",
            codeValue: "110112"
        },
        {
            codeName: "北京市顺义区",
            codeValue: "110113"
        },
        {
            codeName: "北京市昌平区",
            codeValue: "110114"
        },
        {
            codeName: "北京市大兴区",
            codeValue: "110115"
        },
        {
            codeName: "北京市怀柔区",
            codeValue: "110116"
        },
        {
            codeName: "北京市平谷区",
            codeValue: "110117"
        },
        {
            codeName: "北京市密云区",
            codeValue: "110118"
        },
        {
            codeName: "北京市延庆区",
            codeValue: "110119"
        },
        {
            codeName: "天津市",
            codeValue: "120000"
        },
        {
            codeName: "天津市市辖区",
            codeValue: "120100"
        },
        {
            codeName: "天津市和平区",
            codeValue: "120101"
        },
        {
            codeName: "天津市河东区",
            codeValue: "120102"
        },
        {
            codeName: "天津市河西区",
            codeValue: "120103"
        },
        {
            codeName: "天津市南开区",
            codeValue: "120104"
        },
        {
            codeName: "天津市河北区",
            codeValue: "120105"
        },
        {
            codeName: "天津市红桥区",
            codeValue: "120106"
        },
        {
            codeName: "天津市东丽区",
            codeValue: "120110"
        },
        {
            codeName: "天津市西青区",
            codeValue: "120111"
        },
        {
            codeName: "天津市津南区",
            codeValue: "120112"
        },
        {
            codeName: "天津市北辰区",
            codeValue: "120113"
        },
        {
            codeName: "天津市武清区",
            codeValue: "120114"
        },
        {
            codeName: "天津市宝坻区",
            codeValue: "120115"
        },
        {
            codeName: "天津市滨海新区",
            codeValue: "120116"
        },
        {
            codeName: "天津市宁河区",
            codeValue: "120117"
        },
        {
            codeName: "天津市静海区",
            codeValue: "120118"
        },
        {
            codeName: "天津市蓟州区",
            codeValue: "120119"
        },
        {
            codeName: "天津市县",
            codeValue: "120200"
        },
        {
            codeName: "河北省",
            codeValue: "130000"
        },
        {
            codeName: "河北省石家庄市",
            codeValue: "130100"
        },
        {
            codeName: "石家庄市市辖区",
            codeValue: "130101"
        },
        {
            codeName: "石家庄市长安区",
            codeValue: "130102"
        },
        {
            codeName: "石家庄市桥西区",
            codeValue: "130104"
        },
        {
            codeName: "石家庄市新华区",
            codeValue: "130105"
        },
        {
            codeName: "石家庄市井陉矿区",
            codeValue: "130107"
        },
        {
            codeName: "石家庄市裕华区",
            codeValue: "130108"
        },
        {
            codeName: "石家庄市藁城区",
            codeValue: "130109"
        },
        {
            codeName: "石家庄市鹿泉区",
            codeValue: "130110"
        },
        {
            codeName: "石家庄市栾城区",
            codeValue: "130111"
        },
        {
            codeName: "石家庄市井陉县",
            codeValue: "130121"
        },
        {
            codeName: "石家庄市正定县",
            codeValue: "130123"
        },
        {
            codeName: "石家庄市行唐县",
            codeValue: "130125"
        },
        {
            codeName: "石家庄市灵寿县",
            codeValue: "130126"
        },
        {
            codeName: "石家庄市高邑县",
            codeValue: "130127"
        },
        {
            codeName: "石家庄市深泽县",
            codeValue: "130128"
        },
        {
            codeName: "石家庄市赞皇县",
            codeValue: "130129"
        },
        {
            codeName: "石家庄市无极县",
            codeValue: "130130"
        },
        {
            codeName: "石家庄市平山县",
            codeValue: "130131"
        },
        {
            codeName: "石家庄市元氏县",
            codeValue: "130132"
        },
        {
            codeName: "石家庄市赵县",
            codeValue: "130133"
        },
        {
            codeName: "石家庄市辛集市",
            codeValue: "130181"
        },
        {
            codeName: "石家庄市晋州市",
            codeValue: "130183"
        },
        {
            codeName: "石家庄市新乐市",
            codeValue: "130184"
        },
        {
            codeName: "河北省唐山市",
            codeValue: "130200"
        },
        {
            codeName: "唐山市市辖区",
            codeValue: "130201"
        },
        {
            codeName: "唐山市路南区",
            codeValue: "130202"
        },
        {
            codeName: "唐山市路北区",
            codeValue: "130203"
        },
        {
            codeName: "唐山市古冶区",
            codeValue: "130204"
        },
        {
            codeName: "唐山市开平区",
            codeValue: "130205"
        },
        {
            codeName: "唐山市丰南区",
            codeValue: "130207"
        },
        {
            codeName: "唐山市丰润区",
            codeValue: "130208"
        },
        {
            codeName: "唐山市曹妃甸区",
            codeValue: "130209"
        },
        {
            codeName: "唐山市滦县",
            codeValue: "130223"
        },
        {
            codeName: "唐山市滦南县",
            codeValue: "130224"
        },
        {
            codeName: "唐山市乐亭县",
            codeValue: "130225"
        },
        {
            codeName: "唐山市迁西县",
            codeValue: "130227"
        },
        {
            codeName: "唐山市玉田县",
            codeValue: "130229"
        },
        {
            codeName: "唐山市遵化市",
            codeValue: "130281"
        },
        {
            codeName: "唐山市迁安市",
            codeValue: "130283"
        },
        {
            codeName: "河北省秦皇岛市",
            codeValue: "130300"
        },
        {
            codeName: "秦皇岛市市辖区",
            codeValue: "130301"
        },
        {
            codeName: "秦皇岛市海港区",
            codeValue: "130302"
        },
        {
            codeName: "秦皇岛市山海关区",
            codeValue: "130303"
        },
        {
            codeName: "秦皇岛市北戴河区",
            codeValue: "130304"
        },
        {
            codeName: "秦皇岛市抚宁区",
            codeValue: "130306"
        },
        {
            codeName: "秦皇岛市青龙满族自治县",
            codeValue: "130321"
        },
        {
            codeName: "秦皇岛市昌黎县",
            codeValue: "130322"
        },
        {
            codeName: "秦皇岛市卢龙县",
            codeValue: "130324"
        },
        {
            codeName: "河北省邯郸市",
            codeValue: "130400"
        },
        {
            codeName: "邯郸市市辖区",
            codeValue: "130401"
        },
        {
            codeName: "邯郸市邯山区",
            codeValue: "130402"
        },
        {
            codeName: "邯郸市丛台区",
            codeValue: "130403"
        },
        {
            codeName: "邯郸市复兴区",
            codeValue: "130404"
        },
        {
            codeName: "邯郸市峰峰矿区",
            codeValue: "130406"
        },
        {
            codeName: "邯郸市肥乡区",
            codeValue: "130407"
        },
        {
            codeName: "邯郸市永年区",
            codeValue: "130408"
        },
        {
            codeName: "邯郸市邯郸县",
            codeValue: "130421"
        },
        {
            codeName: "邯郸市临漳县",
            codeValue: "130423"
        },
        {
            codeName: "邯郸市成安县",
            codeValue: "130424"
        },
        {
            codeName: "邯郸市大名县",
            codeValue: "130425"
        },
        {
            codeName: "邯郸市涉县",
            codeValue: "130426"
        },
        {
            codeName: "邯郸市磁县",
            codeValue: "130427"
        },
        {
            codeName: "邯郸市肥乡县",
            codeValue: "130428"
        },
        {
            codeName: "邯郸市永年县",
            codeValue: "130429"
        },
        {
            codeName: "邯郸市邱县",
            codeValue: "130430"
        },
        {
            codeName: "邯郸市鸡泽县",
            codeValue: "130431"
        },
        {
            codeName: "邯郸市广平县",
            codeValue: "130432"
        },
        {
            codeName: "邯郸市馆陶县",
            codeValue: "130433"
        },
        {
            codeName: "邯郸市魏县",
            codeValue: "130434"
        },
        {
            codeName: "邯郸市曲周县",
            codeValue: "130435"
        },
        {
            codeName: "邯郸市武安市",
            codeValue: "130481"
        },
        {
            codeName: "河北省邢台市",
            codeValue: "130500"
        },
        {
            codeName: "邢台市市辖区",
            codeValue: "130501"
        },
        {
            codeName: "邢台市桥东区",
            codeValue: "130502"
        },
        {
            codeName: "邢台市桥西区",
            codeValue: "130503"
        },
        {
            codeName: "邢台市邢台县",
            codeValue: "130521"
        },
        {
            codeName: "邢台市临城县",
            codeValue: "130522"
        },
        {
            codeName: "邢台市内丘县",
            codeValue: "130523"
        },
        {
            codeName: "邢台市柏乡县",
            codeValue: "130524"
        },
        {
            codeName: "邢台市隆尧县",
            codeValue: "130525"
        },
        {
            codeName: "邢台市任县",
            codeValue: "130526"
        },
        {
            codeName: "邢台市南和县",
            codeValue: "130527"
        },
        {
            codeName: "邢台市宁晋县",
            codeValue: "130528"
        },
        {
            codeName: "邢台市巨鹿县",
            codeValue: "130529"
        },
        {
            codeName: "邢台市新河县",
            codeValue: "130530"
        },
        {
            codeName: "邢台市广宗县",
            codeValue: "130531"
        },
        {
            codeName: "邢台市平乡县",
            codeValue: "130532"
        },
        {
            codeName: "邢台市威县",
            codeValue: "130533"
        },
        {
            codeName: "邢台市清河县",
            codeValue: "130534"
        },
        {
            codeName: "邢台市临西县",
            codeValue: "130535"
        },
        {
            codeName: "邢台市南宫市",
            codeValue: "130581"
        },
        {
            codeName: "邢台市沙河市",
            codeValue: "130582"
        },
        {
            codeName: "河北省保定市",
            codeValue: "130600"
        },
        {
            codeName: "保定市市辖区",
            codeValue: "130601"
        },
        {
            codeName: "保定市竞秀区",
            codeValue: "130602"
        },
        {
            codeName: "保定市南市区",
            codeValue: "130604"
        },
        {
            codeName: "保定市莲池区",
            codeValue: "130606"
        },
        {
            codeName: "保定市满城区",
            codeValue: "130607"
        },
        {
            codeName: "保定市清苑区",
            codeValue: "130608"
        },
        {
            codeName: "保定市徐水区",
            codeValue: "130609"
        },
        {
            codeName: "保定市涞水县",
            codeValue: "130623"
        },
        {
            codeName: "保定市阜平县",
            codeValue: "130624"
        },
        {
            codeName: "保定市定兴县",
            codeValue: "130626"
        },
        {
            codeName: "保定市唐县",
            codeValue: "130627"
        },
        {
            codeName: "保定市高阳县",
            codeValue: "130628"
        },
        {
            codeName: "保定市容城县",
            codeValue: "130629"
        },
        {
            codeName: "保定市涞源县",
            codeValue: "130630"
        },
        {
            codeName: "保定市望都县",
            codeValue: "130631"
        },
        {
            codeName: "保定市安新县",
            codeValue: "130632"
        },
        {
            codeName: "保定市易县",
            codeValue: "130633"
        },
        {
            codeName: "保定市曲阳县",
            codeValue: "130634"
        },
        {
            codeName: "保定市蠡县",
            codeValue: "130635"
        },
        {
            codeName: "保定市顺平县",
            codeValue: "130636"
        },
        {
            codeName: "保定市博野县",
            codeValue: "130637"
        },
        {
            codeName: "保定市雄县",
            codeValue: "130638"
        },
        {
            codeName: "保定市涿州市",
            codeValue: "130681"
        },
        {
            codeName: "保定市定州市",
            codeValue: "130682"
        },
        {
            codeName: "保定市安国市",
            codeValue: "130683"
        },
        {
            codeName: "保定市高碑店市",
            codeValue: "130684"
        },
        {
            codeName: "河北省张家口市",
            codeValue: "130700"
        },
        {
            codeName: "张家口市市辖区",
            codeValue: "130701"
        },
        {
            codeName: "张家口市桥东区",
            codeValue: "130702"
        },
        {
            codeName: "张家口市桥西区",
            codeValue: "130703"
        },
        {
            codeName: "张家口市宣化区",
            codeValue: "130705"
        },
        {
            codeName: "张家口市下花园区",
            codeValue: "130706"
        },
        {
            codeName: "张家口市万全区",
            codeValue: "130708"
        },
        {
            codeName: "张家口市崇礼区",
            codeValue: "130709"
        },
        {
            codeName: "张家口市张北县",
            codeValue: "130722"
        },
        {
            codeName: "张家口市康保县",
            codeValue: "130723"
        },
        {
            codeName: "张家口市沽源县",
            codeValue: "130724"
        },
        {
            codeName: "张家口市尚义县",
            codeValue: "130725"
        },
        {
            codeName: "张家口市蔚县",
            codeValue: "130726"
        },
        {
            codeName: "张家口市阳原县",
            codeValue: "130727"
        },
        {
            codeName: "张家口市怀安县",
            codeValue: "130728"
        },
        {
            codeName: "张家口市怀来县",
            codeValue: "130730"
        },
        {
            codeName: "张家口市涿鹿县",
            codeValue: "130731"
        },
        {
            codeName: "张家口市赤城县",
            codeValue: "130732"
        },
        {
            codeName: "河北省承德市",
            codeValue: "130800"
        },
        {
            codeName: "承德市市辖区",
            codeValue: "130801"
        },
        {
            codeName: "承德市双桥区",
            codeValue: "130802"
        },
        {
            codeName: "承德市双滦区",
            codeValue: "130803"
        },
        {
            codeName: "承德市鹰手营子矿区",
            codeValue: "130804"
        },
        {
            codeName: "承德市承德县",
            codeValue: "130821"
        },
        {
            codeName: "承德市兴隆县",
            codeValue: "130822"
        },
        {
            codeName: "承德市平泉县",
            codeValue: "130823"
        },
        {
            codeName: "承德市滦平县",
            codeValue: "130824"
        },
        {
            codeName: "承德市隆化县",
            codeValue: "130825"
        },
        {
            codeName: "承德市丰宁满族自治县",
            codeValue: "130826"
        },
        {
            codeName: "承德市宽城满族自治县",
            codeValue: "130827"
        },
        {
            codeName: "承德市围场满族蒙古族自治县",
            codeValue: "130828"
        },
        {
            codeName: "河北省沧州市",
            codeValue: "130900"
        },
        {
            codeName: "沧州市市辖区",
            codeValue: "130901"
        },
        {
            codeName: "沧州市新华区",
            codeValue: "130902"
        },
        {
            codeName: "沧州市运河区",
            codeValue: "130903"
        },
        {
            codeName: "沧州市沧县",
            codeValue: "130921"
        },
        {
            codeName: "沧州市青县",
            codeValue: "130922"
        },
        {
            codeName: "沧州市东光县",
            codeValue: "130923"
        },
        {
            codeName: "沧州市海兴县",
            codeValue: "130924"
        },
        {
            codeName: "沧州市盐山县",
            codeValue: "130925"
        },
        {
            codeName: "沧州市肃宁县",
            codeValue: "130926"
        },
        {
            codeName: "沧州市南皮县",
            codeValue: "130927"
        },
        {
            codeName: "沧州市吴桥县",
            codeValue: "130928"
        },
        {
            codeName: "沧州市献县",
            codeValue: "130929"
        },
        {
            codeName: "沧州市孟村回族自治县",
            codeValue: "130930"
        },
        {
            codeName: "沧州市泊头市",
            codeValue: "130981"
        },
        {
            codeName: "沧州市任丘市",
            codeValue: "130982"
        },
        {
            codeName: "沧州市黄骅市",
            codeValue: "130983"
        },
        {
            codeName: "沧州市河间市",
            codeValue: "130984"
        },
        {
            codeName: "河北省廊坊市",
            codeValue: "131000"
        },
        {
            codeName: "廊坊市市辖区",
            codeValue: "131001"
        },
        {
            codeName: "廊坊市安次区",
            codeValue: "131002"
        },
        {
            codeName: "廊坊市广阳区",
            codeValue: "131003"
        },
        {
            codeName: "廊坊市固安县",
            codeValue: "131022"
        },
        {
            codeName: "廊坊市永清县",
            codeValue: "131023"
        },
        {
            codeName: "廊坊市香河县",
            codeValue: "131024"
        },
        {
            codeName: "廊坊市大城县",
            codeValue: "131025"
        },
        {
            codeName: "廊坊市文安县",
            codeValue: "131026"
        },
        {
            codeName: "廊坊市大厂回族自治县",
            codeValue: "131028"
        },
        {
            codeName: "廊坊市霸州市",
            codeValue: "131081"
        },
        {
            codeName: "廊坊市三河市",
            codeValue: "131082"
        },
        {
            codeName: "河北省衡水市",
            codeValue: "131100"
        },
        {
            codeName: "衡水市市辖区",
            codeValue: "131101"
        },
        {
            codeName: "衡水市桃城区",
            codeValue: "131102"
        },
        {
            codeName: "衡水市冀州区",
            codeValue: "131103"
        },
        {
            codeName: "衡水市枣强县",
            codeValue: "131121"
        },
        {
            codeName: "衡水市武邑县",
            codeValue: "131122"
        },
        {
            codeName: "衡水市武强县",
            codeValue: "131123"
        },
        {
            codeName: "衡水市饶阳县",
            codeValue: "131124"
        },
        {
            codeName: "衡水市安平县",
            codeValue: "131125"
        },
        {
            codeName: "衡水市故城县",
            codeValue: "131126"
        },
        {
            codeName: "衡水市景县",
            codeValue: "131127"
        },
        {
            codeName: "衡水市阜城县",
            codeValue: "131128"
        },
        {
            codeName: "衡水市深州市",
            codeValue: "131182"
        },
        {
            codeName: "山西省",
            codeValue: "140000"
        },
        {
            codeName: "山西省太原市",
            codeValue: "140100"
        },
        {
            codeName: "太原市市辖区",
            codeValue: "140101"
        },
        {
            codeName: "太原市小店区",
            codeValue: "140105"
        },
        {
            codeName: "太原市迎泽区",
            codeValue: "140106"
        },
        {
            codeName: "太原市杏花岭区",
            codeValue: "140107"
        },
        {
            codeName: "太原市尖草坪区",
            codeValue: "140108"
        },
        {
            codeName: "太原市万柏林区",
            codeValue: "140109"
        },
        {
            codeName: "太原市晋源区",
            codeValue: "140110"
        },
        {
            codeName: "太原市清徐县",
            codeValue: "140121"
        },
        {
            codeName: "太原市阳曲县",
            codeValue: "140122"
        },
        {
            codeName: "太原市娄烦县",
            codeValue: "140123"
        },
        {
            codeName: "太原市古交市",
            codeValue: "140181"
        },
        {
            codeName: "山西省大同市",
            codeValue: "140200"
        },
        {
            codeName: "大同市市辖区",
            codeValue: "140201"
        },
        {
            codeName: "大同市城区",
            codeValue: "140202"
        },
        {
            codeName: "大同市矿区",
            codeValue: "140203"
        },
        {
            codeName: "大同市南郊区",
            codeValue: "140211"
        },
        {
            codeName: "大同市新荣区",
            codeValue: "140212"
        },
        {
            codeName: "大同市阳高县",
            codeValue: "140221"
        },
        {
            codeName: "大同市天镇县",
            codeValue: "140222"
        },
        {
            codeName: "大同市广灵县",
            codeValue: "140223"
        },
        {
            codeName: "大同市灵丘县",
            codeValue: "140224"
        },
        {
            codeName: "大同市浑源县",
            codeValue: "140225"
        },
        {
            codeName: "大同市左云县",
            codeValue: "140226"
        },
        {
            codeName: "大同市大同县",
            codeValue: "140227"
        },
        {
            codeName: "山西省阳泉市",
            codeValue: "140300"
        },
        {
            codeName: "阳泉市市辖区",
            codeValue: "140301"
        },
        {
            codeName: "阳泉市城区",
            codeValue: "140302"
        },
        {
            codeName: "阳泉市矿区",
            codeValue: "140303"
        },
        {
            codeName: "阳泉市郊区",
            codeValue: "140311"
        },
        {
            codeName: "阳泉市平定县",
            codeValue: "140321"
        },
        {
            codeName: "阳泉市盂县",
            codeValue: "140322"
        },
        {
            codeName: "山西省长治市",
            codeValue: "140400"
        },
        {
            codeName: "长治市市辖区",
            codeValue: "140401"
        },
        {
            codeName: "长治市城区",
            codeValue: "140402"
        },
        {
            codeName: "长治市郊区",
            codeValue: "140411"
        },
        {
            codeName: "长治市长治县",
            codeValue: "140421"
        },
        {
            codeName: "长治市襄垣县",
            codeValue: "140423"
        },
        {
            codeName: "长治市屯留县",
            codeValue: "140424"
        },
        {
            codeName: "长治市平顺县",
            codeValue: "140425"
        },
        {
            codeName: "长治市黎城县",
            codeValue: "140426"
        },
        {
            codeName: "长治市壶关县",
            codeValue: "140427"
        },
        {
            codeName: "长治市长子县",
            codeValue: "140428"
        },
        {
            codeName: "长治市武乡县",
            codeValue: "140429"
        },
        {
            codeName: "长治市沁县",
            codeValue: "140430"
        },
        {
            codeName: "长治市沁源县",
            codeValue: "140431"
        },
        {
            codeName: "长治市潞城市",
            codeValue: "140481"
        },
        {
            codeName: "山西省晋城市",
            codeValue: "140500"
        },
        {
            codeName: "晋城市市辖区",
            codeValue: "140501"
        },
        {
            codeName: "晋城市城区",
            codeValue: "140502"
        },
        {
            codeName: "晋城市沁水县",
            codeValue: "140521"
        },
        {
            codeName: "晋城市阳城县",
            codeValue: "140522"
        },
        {
            codeName: "晋城市陵川县",
            codeValue: "140524"
        },
        {
            codeName: "晋城市泽州县",
            codeValue: "140525"
        },
        {
            codeName: "晋城市高平市",
            codeValue: "140581"
        },
        {
            codeName: "山西省朔州市",
            codeValue: "140600"
        },
        {
            codeName: "朔州市市辖区",
            codeValue: "140601"
        },
        {
            codeName: "朔州市朔城区",
            codeValue: "140602"
        },
        {
            codeName: "朔州市平鲁区",
            codeValue: "140603"
        },
        {
            codeName: "朔州市山阴县",
            codeValue: "140621"
        },
        {
            codeName: "朔州市应县",
            codeValue: "140622"
        },
        {
            codeName: "朔州市右玉县",
            codeValue: "140623"
        },
        {
            codeName: "朔州市怀仁县",
            codeValue: "140624"
        },
        {
            codeName: "山西省晋中市",
            codeValue: "140700"
        },
        {
            codeName: "晋中市市辖区",
            codeValue: "140701"
        },
        {
            codeName: "晋中市榆次区",
            codeValue: "140702"
        },
        {
            codeName: "晋中市榆社县",
            codeValue: "140721"
        },
        {
            codeName: "晋中市左权县",
            codeValue: "140722"
        },
        {
            codeName: "晋中市和顺县",
            codeValue: "140723"
        },
        {
            codeName: "晋中市昔阳县",
            codeValue: "140724"
        },
        {
            codeName: "晋中市寿阳县",
            codeValue: "140725"
        },
        {
            codeName: "晋中市太谷县",
            codeValue: "140726"
        },
        {
            codeName: "晋中市祁县",
            codeValue: "140727"
        },
        {
            codeName: "晋中市平遥县",
            codeValue: "140728"
        },
        {
            codeName: "晋中市灵石县",
            codeValue: "140729"
        },
        {
            codeName: "晋中市介休市",
            codeValue: "140781"
        },
        {
            codeName: "山西省运城市",
            codeValue: "140800"
        },
        {
            codeName: "运城市市辖区",
            codeValue: "140801"
        },
        {
            codeName: "运城市盐湖区",
            codeValue: "140802"
        },
        {
            codeName: "运城市临猗县",
            codeValue: "140821"
        },
        {
            codeName: "运城市万荣县",
            codeValue: "140822"
        },
        {
            codeName: "运城市闻喜县",
            codeValue: "140823"
        },
        {
            codeName: "运城市稷山县",
            codeValue: "140824"
        },
        {
            codeName: "运城市新绛县",
            codeValue: "140825"
        },
        {
            codeName: "运城市绛县",
            codeValue: "140826"
        },
        {
            codeName: "运城市垣曲县",
            codeValue: "140827"
        },
        {
            codeName: "运城市夏县",
            codeValue: "140828"
        },
        {
            codeName: "运城市平陆县",
            codeValue: "140829"
        },
        {
            codeName: "运城市芮城县",
            codeValue: "140830"
        },
        {
            codeName: "运城市永济市",
            codeValue: "140881"
        },
        {
            codeName: "运城市河津市",
            codeValue: "140882"
        },
        {
            codeName: "山西省忻州市",
            codeValue: "140900"
        },
        {
            codeName: "忻州市市辖区",
            codeValue: "140901"
        },
        {
            codeName: "忻州市忻府区",
            codeValue: "140902"
        },
        {
            codeName: "忻州市定襄县",
            codeValue: "140921"
        },
        {
            codeName: "忻州市五台县",
            codeValue: "140922"
        },
        {
            codeName: "忻州市代县",
            codeValue: "140923"
        },
        {
            codeName: "忻州市繁峙县",
            codeValue: "140924"
        },
        {
            codeName: "忻州市宁武县",
            codeValue: "140925"
        },
        {
            codeName: "忻州市静乐县",
            codeValue: "140926"
        },
        {
            codeName: "忻州市神池县",
            codeValue: "140927"
        },
        {
            codeName: "忻州市五寨县",
            codeValue: "140928"
        },
        {
            codeName: "忻州市岢岚县",
            codeValue: "140929"
        },
        {
            codeName: "忻州市河曲县",
            codeValue: "140930"
        },
        {
            codeName: "忻州市保德县",
            codeValue: "140931"
        },
        {
            codeName: "忻州市偏关县",
            codeValue: "140932"
        },
        {
            codeName: "忻州市原平市",
            codeValue: "140981"
        },
        {
            codeName: "山西省临汾市",
            codeValue: "141000"
        },
        {
            codeName: "临汾市市辖区",
            codeValue: "141001"
        },
        {
            codeName: "临汾市尧都区",
            codeValue: "141002"
        },
        {
            codeName: "临汾市曲沃县",
            codeValue: "141021"
        },
        {
            codeName: "临汾市翼城县",
            codeValue: "141022"
        },
        {
            codeName: "临汾市襄汾县",
            codeValue: "141023"
        },
        {
            codeName: "临汾市洪洞县",
            codeValue: "141024"
        },
        {
            codeName: "临汾市古县",
            codeValue: "141025"
        },
        {
            codeName: "临汾市安泽县",
            codeValue: "141026"
        },
        {
            codeName: "临汾市浮山县",
            codeValue: "141027"
        },
        {
            codeName: "临汾市吉县",
            codeValue: "141028"
        },
        {
            codeName: "临汾市乡宁县",
            codeValue: "141029"
        },
        {
            codeName: "临汾市大宁县",
            codeValue: "141030"
        },
        {
            codeName: "临汾市隰县",
            codeValue: "141031"
        },
        {
            codeName: "临汾市永和县",
            codeValue: "141032"
        },
        {
            codeName: "临汾市蒲县",
            codeValue: "141033"
        },
        {
            codeName: "临汾市汾西县",
            codeValue: "141034"
        },
        {
            codeName: "临汾市侯马市",
            codeValue: "141081"
        },
        {
            codeName: "临汾市霍州市",
            codeValue: "141082"
        },
        {
            codeName: "山西省吕梁市",
            codeValue: "141100"
        },
        {
            codeName: "吕梁市市辖区",
            codeValue: "141101"
        },
        {
            codeName: "吕梁市离石区",
            codeValue: "141102"
        },
        {
            codeName: "吕梁市文水县",
            codeValue: "141121"
        },
        {
            codeName: "吕梁市交城县",
            codeValue: "141122"
        },
        {
            codeName: "吕梁市兴县",
            codeValue: "141123"
        },
        {
            codeName: "吕梁市临县",
            codeValue: "141124"
        },
        {
            codeName: "吕梁市柳林县",
            codeValue: "141125"
        },
        {
            codeName: "吕梁市石楼县",
            codeValue: "141126"
        },
        {
            codeName: "吕梁市岚县",
            codeValue: "141127"
        },
        {
            codeName: "吕梁市方山县",
            codeValue: "141128"
        },
        {
            codeName: "吕梁市中阳县",
            codeValue: "141129"
        },
        {
            codeName: "吕梁市交口县",
            codeValue: "141130"
        },
        {
            codeName: "吕梁市孝义市",
            codeValue: "141181"
        },
        {
            codeName: "吕梁市汾阳市",
            codeValue: "141182"
        },
        {
            codeName: "内蒙古自治区",
            codeValue: "150000"
        },
        {
            codeName: "内蒙古自治区呼和浩特市",
            codeValue: "150100"
        },
        {
            codeName: "呼和浩特市市辖区",
            codeValue: "150101"
        },
        {
            codeName: "呼和浩特市新城区",
            codeValue: "150102"
        },
        {
            codeName: "呼和浩特市回民区",
            codeValue: "150103"
        },
        {
            codeName: "呼和浩特市玉泉区",
            codeValue: "150104"
        },
        {
            codeName: "呼和浩特市赛罕区",
            codeValue: "150105"
        },
        {
            codeName: "呼和浩特市土默特左旗",
            codeValue: "150121"
        },
        {
            codeName: "呼和浩特市托克托县",
            codeValue: "150122"
        },
        {
            codeName: "呼和浩特市和林格尔县",
            codeValue: "150123"
        },
        {
            codeName: "呼和浩特市清水河县",
            codeValue: "150124"
        },
        {
            codeName: "呼和浩特市武川县",
            codeValue: "150125"
        },
        {
            codeName: "内蒙古自治区包头市",
            codeValue: "150200"
        },
        {
            codeName: "包头市市辖区",
            codeValue: "150201"
        },
        {
            codeName: "包头市东河区",
            codeValue: "150202"
        },
        {
            codeName: "包头市昆都仑区",
            codeValue: "150203"
        },
        {
            codeName: "包头市青山区",
            codeValue: "150204"
        },
        {
            codeName: "包头市石拐区",
            codeValue: "150205"
        },
        {
            codeName: "包头市白云鄂博矿区",
            codeValue: "150206"
        },
        {
            codeName: "包头市九原区",
            codeValue: "150207"
        },
        {
            codeName: "包头市土默特右旗",
            codeValue: "150221"
        },
        {
            codeName: "包头市固阳县",
            codeValue: "150222"
        },
        {
            codeName: "包头市达尔罕茂明安联合旗",
            codeValue: "150223"
        },
        {
            codeName: "内蒙古自治区乌海市",
            codeValue: "150300"
        },
        {
            codeName: "乌海市市辖区",
            codeValue: "150301"
        },
        {
            codeName: "乌海市海勃湾区",
            codeValue: "150302"
        },
        {
            codeName: "乌海市海南区",
            codeValue: "150303"
        },
        {
            codeName: "乌海市乌达区",
            codeValue: "150304"
        },
        {
            codeName: "内蒙古自治区赤峰市",
            codeValue: "150400"
        },
        {
            codeName: "赤峰市市辖区",
            codeValue: "150401"
        },
        {
            codeName: "赤峰市红山区",
            codeValue: "150402"
        },
        {
            codeName: "赤峰市元宝山区",
            codeValue: "150403"
        },
        {
            codeName: "赤峰市松山区",
            codeValue: "150404"
        },
        {
            codeName: "赤峰市阿鲁科尔沁旗",
            codeValue: "150421"
        },
        {
            codeName: "赤峰市巴林左旗",
            codeValue: "150422"
        },
        {
            codeName: "赤峰市巴林右旗",
            codeValue: "150423"
        },
        {
            codeName: "赤峰市林西县",
            codeValue: "150424"
        },
        {
            codeName: "赤峰市克什克腾旗",
            codeValue: "150425"
        },
        {
            codeName: "赤峰市翁牛特旗",
            codeValue: "150426"
        },
        {
            codeName: "赤峰市喀喇沁旗",
            codeValue: "150428"
        },
        {
            codeName: "赤峰市宁城县",
            codeValue: "150429"
        },
        {
            codeName: "赤峰市敖汉旗",
            codeValue: "150430"
        },
        {
            codeName: "内蒙古自治区通辽市",
            codeValue: "150500"
        },
        {
            codeName: "通辽市市辖区",
            codeValue: "150501"
        },
        {
            codeName: "通辽市科尔沁区",
            codeValue: "150502"
        },
        {
            codeName: "通辽市科尔沁左翼中旗",
            codeValue: "150521"
        },
        {
            codeName: "通辽市科尔沁左翼后旗",
            codeValue: "150522"
        },
        {
            codeName: "通辽市开鲁县",
            codeValue: "150523"
        },
        {
            codeName: "通辽市库伦旗",
            codeValue: "150524"
        },
        {
            codeName: "通辽市奈曼旗",
            codeValue: "150525"
        },
        {
            codeName: "通辽市扎鲁特旗",
            codeValue: "150526"
        },
        {
            codeName: "通辽市霍林郭勒市",
            codeValue: "150581"
        },
        {
            codeName: "内蒙古自治区鄂尔多斯市",
            codeValue: "150600"
        },
        {
            codeName: "鄂尔多斯市市辖区",
            codeValue: "150601"
        },
        {
            codeName: "鄂尔多斯市东胜区",
            codeValue: "150602"
        },
        {
            codeName: "鄂尔多斯市康巴什区",
            codeValue: "150603"
        },
        {
            codeName: "鄂尔多斯市达拉特旗",
            codeValue: "150621"
        },
        {
            codeName: "鄂尔多斯市准格尔旗",
            codeValue: "150622"
        },
        {
            codeName: "鄂尔多斯市鄂托克前旗",
            codeValue: "150623"
        },
        {
            codeName: "鄂尔多斯市鄂托克旗",
            codeValue: "150624"
        },
        {
            codeName: "鄂尔多斯市杭锦旗",
            codeValue: "150625"
        },
        {
            codeName: "鄂尔多斯市乌审旗",
            codeValue: "150626"
        },
        {
            codeName: "鄂尔多斯市伊金霍洛旗",
            codeValue: "150627"
        },
        {
            codeName: "内蒙古自治区呼伦贝尔市",
            codeValue: "150700"
        },
        {
            codeName: "呼伦贝尔市市辖区",
            codeValue: "150701"
        },
        {
            codeName: "呼伦贝尔市海拉尔区",
            codeValue: "150702"
        },
        {
            codeName: "呼伦贝尔盟扎赉诺尔区",
            codeValue: "150703"
        },
        {
            codeName: "呼伦贝尔市阿荣旗",
            codeValue: "150721"
        },
        {
            codeName: "呼伦贝尔市莫力达瓦达斡尔族自治旗",
            codeValue: "150722"
        },
        {
            codeName: "呼伦贝尔市鄂伦春自治旗",
            codeValue: "150723"
        },
        {
            codeName: "呼伦贝尔市鄂温克族自治旗",
            codeValue: "150724"
        },
        {
            codeName: "呼伦贝尔市陈巴尔虎旗",
            codeValue: "150725"
        },
        {
            codeName: "呼伦贝尔市新巴尔虎左旗",
            codeValue: "150726"
        },
        {
            codeName: "呼伦贝尔市新巴尔虎右旗",
            codeValue: "150727"
        },
        {
            codeName: "呼伦贝尔市满洲里市",
            codeValue: "150781"
        },
        {
            codeName: "呼伦贝尔市牙克石市",
            codeValue: "150782"
        },
        {
            codeName: "呼伦贝尔市扎兰屯市",
            codeValue: "150783"
        },
        {
            codeName: "呼伦贝尔市额尔古纳市",
            codeValue: "150784"
        },
        {
            codeName: "呼伦贝尔市根河市",
            codeValue: "150785"
        },
        {
            codeName: "内蒙古自治区巴彦淖尔市",
            codeValue: "150800"
        },
        {
            codeName: "巴彦淖尔市市辖区",
            codeValue: "150801"
        },
        {
            codeName: "巴彦淖尔市临河区",
            codeValue: "150802"
        },
        {
            codeName: "巴彦淖尔市五原县",
            codeValue: "150821"
        },
        {
            codeName: "巴彦淖尔市磴口县",
            codeValue: "150822"
        },
        {
            codeName: "巴彦淖尔市乌拉特前旗",
            codeValue: "150823"
        },
        {
            codeName: "巴彦淖尔市乌拉特中旗",
            codeValue: "150824"
        },
        {
            codeName: "巴彦淖尔市乌拉特后旗",
            codeValue: "150825"
        },
        {
            codeName: "巴彦淖尔市杭锦后旗",
            codeValue: "150826"
        },
        {
            codeName: "内蒙古自治区乌兰察布市",
            codeValue: "150900"
        },
        {
            codeName: "乌兰察布市市辖区",
            codeValue: "150901"
        },
        {
            codeName: "乌兰察布市集宁区",
            codeValue: "150902"
        },
        {
            codeName: "乌兰察布市卓资县",
            codeValue: "150921"
        },
        {
            codeName: "乌兰察布市化德县",
            codeValue: "150922"
        },
        {
            codeName: "乌兰察布市商都县",
            codeValue: "150923"
        },
        {
            codeName: "乌兰察布市兴和县",
            codeValue: "150924"
        },
        {
            codeName: "乌兰察布市凉城县",
            codeValue: "150925"
        },
        {
            codeName: "乌兰察布市察哈尔右翼前旗",
            codeValue: "150926"
        },
        {
            codeName: "乌兰察布市察哈尔右翼中旗",
            codeValue: "150927"
        },
        {
            codeName: "乌兰察布市察哈尔右翼后旗",
            codeValue: "150928"
        },
        {
            codeName: "乌兰察布市四子王旗",
            codeValue: "150929"
        },
        {
            codeName: "乌兰察布市丰镇市",
            codeValue: "150981"
        },
        {
            codeName: "内蒙古自治区兴安盟",
            codeValue: "152200"
        },
        {
            codeName: "兴安盟乌兰浩特市",
            codeValue: "152201"
        },
        {
            codeName: "兴安盟阿尔山市",
            codeValue: "152202"
        },
        {
            codeName: "兴安盟科尔沁右翼前旗",
            codeValue: "152221"
        },
        {
            codeName: "兴安盟科尔沁右翼中旗",
            codeValue: "152222"
        },
        {
            codeName: "兴安盟扎赉特旗",
            codeValue: "152223"
        },
        {
            codeName: "兴安盟突泉县",
            codeValue: "152224"
        },
        {
            codeName: "内蒙古自治区锡林郭勒盟",
            codeValue: "152500"
        },
        {
            codeName: "锡林郭勒盟二连浩特市",
            codeValue: "152501"
        },
        {
            codeName: "锡林郭勒盟锡林浩特市",
            codeValue: "152502"
        },
        {
            codeName: "锡林郭勒盟阿巴嘎旗",
            codeValue: "152522"
        },
        {
            codeName: "锡林郭勒盟苏尼特左旗",
            codeValue: "152523"
        },
        {
            codeName: "锡林郭勒盟苏尼特右旗",
            codeValue: "152524"
        },
        {
            codeName: "锡林郭勒盟东乌珠穆沁旗",
            codeValue: "152525"
        },
        {
            codeName: "锡林郭勒盟西乌珠穆沁旗",
            codeValue: "152526"
        },
        {
            codeName: "锡林郭勒盟太仆寺旗",
            codeValue: "152527"
        },
        {
            codeName: "锡林郭勒盟镶黄旗",
            codeValue: "152528"
        },
        {
            codeName: "锡林郭勒盟正镶白旗",
            codeValue: "152529"
        },
        {
            codeName: "锡林郭勒盟正蓝旗",
            codeValue: "152530"
        },
        {
            codeName: "锡林郭勒盟多伦县",
            codeValue: "152531"
        },
        {
            codeName: "内蒙古自治区阿拉善盟",
            codeValue: "152900"
        },
        {
            codeName: "阿拉善盟阿拉善左旗",
            codeValue: "152921"
        },
        {
            codeName: "阿拉善盟阿拉善右旗",
            codeValue: "152922"
        },
        {
            codeName: "阿拉善盟额济纳旗",
            codeValue: "152923"
        },
        {
            codeName: "辽宁省",
            codeValue: "210000"
        },
        {
            codeName: "辽宁省沈阳市",
            codeValue: "210100"
        },
        {
            codeName: "沈阳市市辖区",
            codeValue: "210101"
        },
        {
            codeName: "沈阳市和平区",
            codeValue: "210102"
        },
        {
            codeName: "沈阳市沈河区",
            codeValue: "210103"
        },
        {
            codeName: "沈阳市大东区",
            codeValue: "210104"
        },
        {
            codeName: "沈阳市皇姑区",
            codeValue: "210105"
        },
        {
            codeName: "沈阳市铁西区",
            codeValue: "210106"
        },
        {
            codeName: "沈阳市苏家屯区",
            codeValue: "210111"
        },
        {
            codeName: "沈阳市浑南区",
            codeValue: "210112"
        },
        {
            codeName: "沈阳市沈北新区",
            codeValue: "210113"
        },
        {
            codeName: "沈阳市于洪区",
            codeValue: "210114"
        },
        {
            codeName: "沈阳市辽中区",
            codeValue: "210115"
        },
        {
            codeName: "沈阳市康平县",
            codeValue: "210123"
        },
        {
            codeName: "沈阳市法库县",
            codeValue: "210124"
        },
        {
            codeName: "沈阳市新民市",
            codeValue: "210181"
        },
        {
            codeName: "辽宁省大连市",
            codeValue: "210200"
        },
        {
            codeName: "大连市市辖区",
            codeValue: "210201"
        },
        {
            codeName: "大连市中山区",
            codeValue: "210202"
        },
        {
            codeName: "大连市西岗区",
            codeValue: "210203"
        },
        {
            codeName: "大连市沙河口区",
            codeValue: "210204"
        },
        {
            codeName: "大连市甘井子区",
            codeValue: "210211"
        },
        {
            codeName: "大连市旅顺口区",
            codeValue: "210212"
        },
        {
            codeName: "大连市金州区",
            codeValue: "210213"
        },
        {
            codeName: "大连市普兰店区",
            codeValue: "210214"
        },
        {
            codeName: "大连市长海县",
            codeValue: "210224"
        },
        {
            codeName: "大连市瓦房店市",
            codeValue: "210281"
        },
        {
            codeName: "大连市庄河市",
            codeValue: "210283"
        },
        {
            codeName: "辽宁省鞍山市",
            codeValue: "210300"
        },
        {
            codeName: "鞍山市市辖区",
            codeValue: "210301"
        },
        {
            codeName: "鞍山市铁东区",
            codeValue: "210302"
        },
        {
            codeName: "鞍山市铁西区",
            codeValue: "210303"
        },
        {
            codeName: "鞍山市立山区",
            codeValue: "210304"
        },
        {
            codeName: "鞍山市千山区",
            codeValue: "210311"
        },
        {
            codeName: "鞍山市台安县",
            codeValue: "210321"
        },
        {
            codeName: "鞍山市岫岩满族自治县",
            codeValue: "210323"
        },
        {
            codeName: "鞍山市海城市",
            codeValue: "210381"
        },
        {
            codeName: "辽宁省抚顺市",
            codeValue: "210400"
        },
        {
            codeName: "抚顺市市辖区",
            codeValue: "210401"
        },
        {
            codeName: "抚顺市新抚区",
            codeValue: "210402"
        },
        {
            codeName: "抚顺市东洲区",
            codeValue: "210403"
        },
        {
            codeName: "抚顺市望花区",
            codeValue: "210404"
        },
        {
            codeName: "抚顺市顺城区",
            codeValue: "210411"
        },
        {
            codeName: "抚顺市抚顺县",
            codeValue: "210421"
        },
        {
            codeName: "抚顺市新宾满族自治县",
            codeValue: "210422"
        },
        {
            codeName: "抚顺市清原满族自治县",
            codeValue: "210423"
        },
        {
            codeName: "辽宁省本溪市",
            codeValue: "210500"
        },
        {
            codeName: "本溪市市辖区",
            codeValue: "210501"
        },
        {
            codeName: "本溪市平山区",
            codeValue: "210502"
        },
        {
            codeName: "本溪市溪湖区",
            codeValue: "210503"
        },
        {
            codeName: "本溪市明山区",
            codeValue: "210504"
        },
        {
            codeName: "本溪市南芬区",
            codeValue: "210505"
        },
        {
            codeName: "本溪市本溪满族自治县",
            codeValue: "210521"
        },
        {
            codeName: "本溪市桓仁满族自治县",
            codeValue: "210522"
        },
        {
            codeName: "辽宁省丹东市",
            codeValue: "210600"
        },
        {
            codeName: "丹东市市辖区",
            codeValue: "210601"
        },
        {
            codeName: "丹东市元宝区",
            codeValue: "210602"
        },
        {
            codeName: "丹东市振兴区",
            codeValue: "210603"
        },
        {
            codeName: "丹东市振安区",
            codeValue: "210604"
        },
        {
            codeName: "丹东市宽甸满族自治县",
            codeValue: "210624"
        },
        {
            codeName: "丹东市东港市",
            codeValue: "210681"
        },
        {
            codeName: "丹东市凤城市",
            codeValue: "210682"
        },
        {
            codeName: "辽宁省锦州市",
            codeValue: "210700"
        },
        {
            codeName: "锦州市市辖区",
            codeValue: "210701"
        },
        {
            codeName: "锦州市古塔区",
            codeValue: "210702"
        },
        {
            codeName: "锦州市凌河区",
            codeValue: "210703"
        },
        {
            codeName: "锦州市太和区",
            codeValue: "210711"
        },
        {
            codeName: "锦州市黑山县",
            codeValue: "210726"
        },
        {
            codeName: "锦州市义县",
            codeValue: "210727"
        },
        {
            codeName: "锦州市凌海市",
            codeValue: "210781"
        },
        {
            codeName: "锦州市北镇市",
            codeValue: "210782"
        },
        {
            codeName: "辽宁省营口市",
            codeValue: "210800"
        },
        {
            codeName: "营口市市辖区",
            codeValue: "210801"
        },
        {
            codeName: "营口市站前区",
            codeValue: "210802"
        },
        {
            codeName: "营口市西市区",
            codeValue: "210803"
        },
        {
            codeName: "营口市鲅鱼圈区",
            codeValue: "210804"
        },
        {
            codeName: "营口市老边区",
            codeValue: "210811"
        },
        {
            codeName: "营口市盖州市",
            codeValue: "210881"
        },
        {
            codeName: "营口市大石桥市",
            codeValue: "210882"
        },
        {
            codeName: "辽宁省阜新市",
            codeValue: "210900"
        },
        {
            codeName: "阜新市市辖区",
            codeValue: "210901"
        },
        {
            codeName: "阜新市海州区",
            codeValue: "210902"
        },
        {
            codeName: "阜新市新邱区",
            codeValue: "210903"
        },
        {
            codeName: "阜新市太平区",
            codeValue: "210904"
        },
        {
            codeName: "阜新市清河门区",
            codeValue: "210905"
        },
        {
            codeName: "阜新市细河区",
            codeValue: "210911"
        },
        {
            codeName: "阜新市阜新蒙古族自治县",
            codeValue: "210921"
        },
        {
            codeName: "阜新市彰武县",
            codeValue: "210922"
        },
        {
            codeName: "辽宁省辽阳市",
            codeValue: "211000"
        },
        {
            codeName: "辽阳市市辖区",
            codeValue: "211001"
        },
        {
            codeName: "辽阳市白塔区",
            codeValue: "211002"
        },
        {
            codeName: "辽阳市文圣区",
            codeValue: "211003"
        },
        {
            codeName: "辽阳市宏伟区",
            codeValue: "211004"
        },
        {
            codeName: "辽阳市弓长岭区",
            codeValue: "211005"
        },
        {
            codeName: "辽阳市太子河区",
            codeValue: "211011"
        },
        {
            codeName: "辽阳市辽阳县",
            codeValue: "211021"
        },
        {
            codeName: "辽阳市灯塔市",
            codeValue: "211081"
        },
        {
            codeName: "辽宁省盘锦市",
            codeValue: "211100"
        },
        {
            codeName: "盘锦市市辖区",
            codeValue: "211101"
        },
        {
            codeName: "盘锦市双台子区",
            codeValue: "211102"
        },
        {
            codeName: "盘锦市兴隆台区",
            codeValue: "211103"
        },
        {
            codeName: "盘锦市大洼区",
            codeValue: "211104"
        },
        {
            codeName: "盘锦市盘山县",
            codeValue: "211122"
        },
        {
            codeName: "辽宁省铁岭市",
            codeValue: "211200"
        },
        {
            codeName: "铁岭市市辖区",
            codeValue: "211201"
        },
        {
            codeName: "铁岭市银州区",
            codeValue: "211202"
        },
        {
            codeName: "铁岭市清河区",
            codeValue: "211204"
        },
        {
            codeName: "铁岭市铁岭县",
            codeValue: "211221"
        },
        {
            codeName: "铁岭市西丰县",
            codeValue: "211223"
        },
        {
            codeName: "铁岭市昌图县",
            codeValue: "211224"
        },
        {
            codeName: "铁岭市调兵山市",
            codeValue: "211281"
        },
        {
            codeName: "铁岭市开原市",
            codeValue: "211282"
        },
        {
            codeName: "辽宁省朝阳市",
            codeValue: "211300"
        },
        {
            codeName: "朝阳市市辖区",
            codeValue: "211301"
        },
        {
            codeName: "朝阳市双塔区",
            codeValue: "211302"
        },
        {
            codeName: "朝阳市龙城区",
            codeValue: "211303"
        },
        {
            codeName: "朝阳市朝阳县",
            codeValue: "211321"
        },
        {
            codeName: "朝阳市建平县",
            codeValue: "211322"
        },
        {
            codeName: "朝阳市喀喇沁左翼蒙古族自治县",
            codeValue: "211324"
        },
        {
            codeName: "朝阳市北票市",
            codeValue: "211381"
        },
        {
            codeName: "朝阳市凌源市",
            codeValue: "211382"
        },
        {
            codeName: "辽宁省葫芦岛市",
            codeValue: "211400"
        },
        {
            codeName: "葫芦岛市市辖区",
            codeValue: "211401"
        },
        {
            codeName: "葫芦岛市连山区",
            codeValue: "211402"
        },
        {
            codeName: "葫芦岛市龙港区",
            codeValue: "211403"
        },
        {
            codeName: "葫芦岛市南票区",
            codeValue: "211404"
        },
        {
            codeName: "葫芦岛市绥中县",
            codeValue: "211421"
        },
        {
            codeName: "葫芦岛市建昌县",
            codeValue: "211422"
        },
        {
            codeName: "葫芦岛市兴城市",
            codeValue: "211481"
        },
        {
            codeName: "吉林省",
            codeValue: "220000"
        },
        {
            codeName: "吉林省长春市",
            codeValue: "220100"
        },
        {
            codeName: "长春市市辖区",
            codeValue: "220101"
        },
        {
            codeName: "长春市南关区",
            codeValue: "220102"
        },
        {
            codeName: "长春市宽城区",
            codeValue: "220103"
        },
        {
            codeName: "长春市朝阳区",
            codeValue: "220104"
        },
        {
            codeName: "长春市二道区",
            codeValue: "220105"
        },
        {
            codeName: "长春市绿园区",
            codeValue: "220106"
        },
        {
            codeName: "长春市双阳区",
            codeValue: "220112"
        },
        {
            codeName: "长春市九台区",
            codeValue: "220113"
        },
        {
            codeName: "长春市农安县",
            codeValue: "220122"
        },
        {
            codeName: "长春市榆树市",
            codeValue: "220182"
        },
        {
            codeName: "长春市德惠市",
            codeValue: "220183"
        },
        {
            codeName: "吉林省吉林市",
            codeValue: "220200"
        },
        {
            codeName: "吉林市市辖区",
            codeValue: "220201"
        },
        {
            codeName: "吉林市昌邑区",
            codeValue: "220202"
        },
        {
            codeName: "吉林市龙潭区",
            codeValue: "220203"
        },
        {
            codeName: "吉林市船营区",
            codeValue: "220204"
        },
        {
            codeName: "吉林市丰满区",
            codeValue: "220211"
        },
        {
            codeName: "吉林市永吉县",
            codeValue: "220221"
        },
        {
            codeName: "吉林市蛟河市",
            codeValue: "220281"
        },
        {
            codeName: "吉林市桦甸市",
            codeValue: "220282"
        },
        {
            codeName: "吉林市舒兰市",
            codeValue: "220283"
        },
        {
            codeName: "吉林市磐石市",
            codeValue: "220284"
        },
        {
            codeName: "吉林省四平市",
            codeValue: "220300"
        },
        {
            codeName: "四平市市辖区",
            codeValue: "220301"
        },
        {
            codeName: "四平市铁西区",
            codeValue: "220302"
        },
        {
            codeName: "四平市铁东区",
            codeValue: "220303"
        },
        {
            codeName: "四平市梨树县",
            codeValue: "220322"
        },
        {
            codeName: "四平市伊通满族自治县",
            codeValue: "220323"
        },
        {
            codeName: "四平市公主岭市",
            codeValue: "220381"
        },
        {
            codeName: "四平市双辽市",
            codeValue: "220382"
        },
        {
            codeName: "吉林省辽源市",
            codeValue: "220400"
        },
        {
            codeName: "辽源市市辖区",
            codeValue: "220401"
        },
        {
            codeName: "辽源市龙山区",
            codeValue: "220402"
        },
        {
            codeName: "辽源市西安区",
            codeValue: "220403"
        },
        {
            codeName: "辽源市东丰县",
            codeValue: "220421"
        },
        {
            codeName: "辽源市东辽县",
            codeValue: "220422"
        },
        {
            codeName: "吉林省通化市",
            codeValue: "220500"
        },
        {
            codeName: "通化市市辖区",
            codeValue: "220501"
        },
        {
            codeName: "通化市东昌区",
            codeValue: "220502"
        },
        {
            codeName: "通化市二道江区",
            codeValue: "220503"
        },
        {
            codeName: "通化市通化县",
            codeValue: "220521"
        },
        {
            codeName: "通化市辉南县",
            codeValue: "220523"
        },
        {
            codeName: "通化市柳河县",
            codeValue: "220524"
        },
        {
            codeName: "通化市梅河口市",
            codeValue: "220581"
        },
        {
            codeName: "通化市集安市",
            codeValue: "220582"
        },
        {
            codeName: "吉林省白山市",
            codeValue: "220600"
        },
        {
            codeName: "白山市市辖区",
            codeValue: "220601"
        },
        {
            codeName: "白山市浑江区",
            codeValue: "220602"
        },
        {
            codeName: "白山市江源区",
            codeValue: "220605"
        },
        {
            codeName: "白山市抚松县",
            codeValue: "220621"
        },
        {
            codeName: "白山市靖宇县",
            codeValue: "220622"
        },
        {
            codeName: "白山市长白朝鲜族自治县",
            codeValue: "220623"
        },
        {
            codeName: "白山市临江市",
            codeValue: "220681"
        },
        {
            codeName: "吉林省松原市",
            codeValue: "220700"
        },
        {
            codeName: "松原市市辖区",
            codeValue: "220701"
        },
        {
            codeName: "松原市宁江区",
            codeValue: "220702"
        },
        {
            codeName: "松原市前郭尔罗斯蒙古族自治县",
            codeValue: "220721"
        },
        {
            codeName: "松原市长岭县",
            codeValue: "220722"
        },
        {
            codeName: "松原市乾安县",
            codeValue: "220723"
        },
        {
            codeName: "松原市扶余市",
            codeValue: "220781"
        },
        {
            codeName: "吉林省白城市",
            codeValue: "220800"
        },
        {
            codeName: "白城市市辖区",
            codeValue: "220801"
        },
        {
            codeName: "白城市洮北区",
            codeValue: "220802"
        },
        {
            codeName: "白城市镇赉县",
            codeValue: "220821"
        },
        {
            codeName: "白城市通榆县",
            codeValue: "220822"
        },
        {
            codeName: "白城市洮南市",
            codeValue: "220881"
        },
        {
            codeName: "白城市大安市",
            codeValue: "220882"
        },
        {
            codeName: "吉林省延边朝鲜族自治州",
            codeValue: "222400"
        },
        {
            codeName: "延边朝鲜族自治州延吉市",
            codeValue: "222401"
        },
        {
            codeName: "延边朝鲜族自治州图们市",
            codeValue: "222402"
        },
        {
            codeName: "延边朝鲜族自治州敦化市",
            codeValue: "222403"
        },
        {
            codeName: "延边朝鲜族自治州珲春市",
            codeValue: "222404"
        },
        {
            codeName: "延边朝鲜族自治州龙井市",
            codeValue: "222405"
        },
        {
            codeName: "延边朝鲜族自治州和龙市",
            codeValue: "222406"
        },
        {
            codeName: "延边朝鲜族自治州汪清县",
            codeValue: "222424"
        },
        {
            codeName: "延边朝鲜族自治州安图县",
            codeValue: "222426"
        },
        {
            codeName: "黑龙江省",
            codeValue: "230000"
        },
        {
            codeName: "黑龙江省哈尔滨市",
            codeValue: "230100"
        },
        {
            codeName: "哈尔滨市市辖区",
            codeValue: "230101"
        },
        {
            codeName: "哈尔滨市道里区",
            codeValue: "230102"
        },
        {
            codeName: "哈尔滨市南岗区",
            codeValue: "230103"
        },
        {
            codeName: "哈尔滨市道外区",
            codeValue: "230104"
        },
        {
            codeName: "哈尔滨市平房区",
            codeValue: "230108"
        },
        {
            codeName: "哈尔滨市松北区",
            codeValue: "230109"
        },
        {
            codeName: "哈尔滨市香坊区",
            codeValue: "230110"
        },
        {
            codeName: "哈尔滨市呼兰区",
            codeValue: "230111"
        },
        {
            codeName: "哈尔滨市阿城区",
            codeValue: "230112"
        },
        {
            codeName: "哈尔滨市双城区",
            codeValue: "230113"
        },
        {
            codeName: "哈尔滨市依兰县",
            codeValue: "230123"
        },
        {
            codeName: "哈尔滨市方正县",
            codeValue: "230124"
        },
        {
            codeName: "哈尔滨市宾县",
            codeValue: "230125"
        },
        {
            codeName: "哈尔滨市巴彦县",
            codeValue: "230126"
        },
        {
            codeName: "哈尔滨市木兰县",
            codeValue: "230127"
        },
        {
            codeName: "哈尔滨市通河县",
            codeValue: "230128"
        },
        {
            codeName: "哈尔滨市延寿县",
            codeValue: "230129"
        },
        {
            codeName: "哈尔滨市尚志市",
            codeValue: "230183"
        },
        {
            codeName: "哈尔滨市五常市",
            codeValue: "230184"
        },
        {
            codeName: "黑龙江省齐齐哈尔市",
            codeValue: "230200"
        },
        {
            codeName: "齐齐哈尔市市辖区",
            codeValue: "230201"
        },
        {
            codeName: "齐齐哈尔市龙沙区",
            codeValue: "230202"
        },
        {
            codeName: "齐齐哈尔市建华区",
            codeValue: "230203"
        },
        {
            codeName: "齐齐哈尔市铁锋区",
            codeValue: "230204"
        },
        {
            codeName: "齐齐哈尔市昂昂溪区",
            codeValue: "230205"
        },
        {
            codeName: "齐齐哈尔市富拉尔基区",
            codeValue: "230206"
        },
        {
            codeName: "齐齐哈尔市碾子山区",
            codeValue: "230207"
        },
        {
            codeName: "齐齐哈尔市梅里斯达斡尔族区",
            codeValue: "230208"
        },
        {
            codeName: "齐齐哈尔市龙江县",
            codeValue: "230221"
        },
        {
            codeName: "齐齐哈尔市依安县",
            codeValue: "230223"
        },
        {
            codeName: "齐齐哈尔市泰来县",
            codeValue: "230224"
        },
        {
            codeName: "齐齐哈尔市甘南县",
            codeValue: "230225"
        },
        {
            codeName: "齐齐哈尔市富裕县",
            codeValue: "230227"
        },
        {
            codeName: "齐齐哈尔市克山县",
            codeValue: "230229"
        },
        {
            codeName: "齐齐哈尔市克东县",
            codeValue: "230230"
        },
        {
            codeName: "齐齐哈尔市拜泉县",
            codeValue: "230231"
        },
        {
            codeName: "齐齐哈尔市讷河市",
            codeValue: "230281"
        },
        {
            codeName: "黑龙江省鸡西市",
            codeValue: "230300"
        },
        {
            codeName: "鸡西市市辖区",
            codeValue: "230301"
        },
        {
            codeName: "鸡西市鸡冠区",
            codeValue: "230302"
        },
        {
            codeName: "鸡西市恒山区",
            codeValue: "230303"
        },
        {
            codeName: "鸡西市滴道区",
            codeValue: "230304"
        },
        {
            codeName: "鸡西市梨树区",
            codeValue: "230305"
        },
        {
            codeName: "鸡西市城子河区",
            codeValue: "230306"
        },
        {
            codeName: "鸡西市麻山区",
            codeValue: "230307"
        },
        {
            codeName: "鸡西市鸡东县",
            codeValue: "230321"
        },
        {
            codeName: "鸡西市虎林市",
            codeValue: "230381"
        },
        {
            codeName: "鸡西市密山市",
            codeValue: "230382"
        },
        {
            codeName: "黑龙江省鹤岗市",
            codeValue: "230400"
        },
        {
            codeName: "鹤岗市市辖区",
            codeValue: "230401"
        },
        {
            codeName: "鹤岗市向阳区",
            codeValue: "230402"
        },
        {
            codeName: "鹤岗市工农区",
            codeValue: "230403"
        },
        {
            codeName: "鹤岗市南山区",
            codeValue: "230404"
        },
        {
            codeName: "鹤岗市兴安区",
            codeValue: "230405"
        },
        {
            codeName: "鹤岗市东山区",
            codeValue: "230406"
        },
        {
            codeName: "鹤岗市兴山区",
            codeValue: "230407"
        },
        {
            codeName: "鹤岗市萝北县",
            codeValue: "230421"
        },
        {
            codeName: "鹤岗市绥滨县",
            codeValue: "230422"
        },
        {
            codeName: "黑龙江省双鸭山市",
            codeValue: "230500"
        },
        {
            codeName: "双鸭山市市辖区",
            codeValue: "230501"
        },
        {
            codeName: "双鸭山市尖山区",
            codeValue: "230502"
        },
        {
            codeName: "双鸭山市岭东区",
            codeValue: "230503"
        },
        {
            codeName: "双鸭山市四方台区",
            codeValue: "230505"
        },
        {
            codeName: "双鸭山市宝山区",
            codeValue: "230506"
        },
        {
            codeName: "双鸭山市集贤县",
            codeValue: "230521"
        },
        {
            codeName: "双鸭山市友谊县",
            codeValue: "230522"
        },
        {
            codeName: "双鸭山市宝清县",
            codeValue: "230523"
        },
        {
            codeName: "双鸭山市饶河县",
            codeValue: "230524"
        },
        {
            codeName: "黑龙江省大庆市",
            codeValue: "230600"
        },
        {
            codeName: "大庆市市辖区",
            codeValue: "230601"
        },
        {
            codeName: "大庆市萨尔图区",
            codeValue: "230602"
        },
        {
            codeName: "大庆市龙凤区",
            codeValue: "230603"
        },
        {
            codeName: "大庆市让胡路区",
            codeValue: "230604"
        },
        {
            codeName: "大庆市红岗区",
            codeValue: "230605"
        },
        {
            codeName: "大庆市大同区",
            codeValue: "230606"
        },
        {
            codeName: "大庆市肇州县",
            codeValue: "230621"
        },
        {
            codeName: "大庆市肇源县",
            codeValue: "230622"
        },
        {
            codeName: "大庆市林甸县",
            codeValue: "230623"
        },
        {
            codeName: "大庆市杜尔伯特蒙古族自治县",
            codeValue: "230624"
        },
        {
            codeName: "黑龙江省伊春市",
            codeValue: "230700"
        },
        {
            codeName: "伊春市市辖区",
            codeValue: "230701"
        },
        {
            codeName: "伊春市伊春区",
            codeValue: "230702"
        },
        {
            codeName: "伊春市南岔区",
            codeValue: "230703"
        },
        {
            codeName: "伊春市友好区",
            codeValue: "230704"
        },
        {
            codeName: "伊春市西林区",
            codeValue: "230705"
        },
        {
            codeName: "伊春市翠峦区",
            codeValue: "230706"
        },
        {
            codeName: "伊春市新青区",
            codeValue: "230707"
        },
        {
            codeName: "伊春市美溪区",
            codeValue: "230708"
        },
        {
            codeName: "伊春市金山屯区",
            codeValue: "230709"
        },
        {
            codeName: "伊春市五营区",
            codeValue: "230710"
        },
        {
            codeName: "伊春市乌马河区",
            codeValue: "230711"
        },
        {
            codeName: "伊春市汤旺河区",
            codeValue: "230712"
        },
        {
            codeName: "伊春市带岭区",
            codeValue: "230713"
        },
        {
            codeName: "伊春市乌伊岭区",
            codeValue: "230714"
        },
        {
            codeName: "伊春市红星区",
            codeValue: "230715"
        },
        {
            codeName: "伊春市上甘岭区",
            codeValue: "230716"
        },
        {
            codeName: "伊春市嘉荫县",
            codeValue: "230722"
        },
        {
            codeName: "伊春市铁力市",
            codeValue: "230781"
        },
        {
            codeName: "黑龙江省佳木斯市",
            codeValue: "230800"
        },
        {
            codeName: "佳木斯市市辖区",
            codeValue: "230801"
        },
        {
            codeName: "佳木斯市向阳区",
            codeValue: "230803"
        },
        {
            codeName: "佳木斯市前进区",
            codeValue: "230804"
        },
        {
            codeName: "佳木斯市东风区",
            codeValue: "230805"
        },
        {
            codeName: "佳木斯市郊区",
            codeValue: "230811"
        },
        {
            codeName: "佳木斯市桦南县",
            codeValue: "230822"
        },
        {
            codeName: "佳木斯市桦川县",
            codeValue: "230826"
        },
        {
            codeName: "佳木斯市汤原县",
            codeValue: "230828"
        },
        {
            codeName: "佳木斯市同江市",
            codeValue: "230881"
        },
        {
            codeName: "佳木斯市富锦市",
            codeValue: "230882"
        },
        {
            codeName: "佳木斯市抚远市",
            codeValue: "230883"
        },
        {
            codeName: "黑龙江省七台河市",
            codeValue: "230900"
        },
        {
            codeName: "七台河市市辖区",
            codeValue: "230901"
        },
        {
            codeName: "七台河市新兴区",
            codeValue: "230902"
        },
        {
            codeName: "七台河市桃山区",
            codeValue: "230903"
        },
        {
            codeName: "七台河市茄子河区",
            codeValue: "230904"
        },
        {
            codeName: "七台河市勃利县",
            codeValue: "230921"
        },
        {
            codeName: "黑龙江省牡丹江市",
            codeValue: "231000"
        },
        {
            codeName: "牡丹江市市辖区",
            codeValue: "231001"
        },
        {
            codeName: "牡丹江市东安区",
            codeValue: "231002"
        },
        {
            codeName: "牡丹江市阳明区",
            codeValue: "231003"
        },
        {
            codeName: "牡丹江市爱民区",
            codeValue: "231004"
        },
        {
            codeName: "牡丹江市西安区",
            codeValue: "231005"
        },
        {
            codeName: "牡丹江市林口县",
            codeValue: "231025"
        },
        {
            codeName: "牡丹江市绥芬河市",
            codeValue: "231081"
        },
        {
            codeName: "牡丹江市海林市",
            codeValue: "231083"
        },
        {
            codeName: "牡丹江市宁安市",
            codeValue: "231084"
        },
        {
            codeName: "牡丹江市穆棱市",
            codeValue: "231085"
        },
        {
            codeName: "牡丹江市东宁市",
            codeValue: "231086"
        },
        {
            codeName: "黑龙江省黑河市",
            codeValue: "231100"
        },
        {
            codeName: "黑河市市辖区",
            codeValue: "231101"
        },
        {
            codeName: "黑河市爱辉区",
            codeValue: "231102"
        },
        {
            codeName: "黑河市嫩江县",
            codeValue: "231121"
        },
        {
            codeName: "黑河市逊克县",
            codeValue: "231123"
        },
        {
            codeName: "黑河市孙吴县",
            codeValue: "231124"
        },
        {
            codeName: "黑河市北安市",
            codeValue: "231181"
        },
        {
            codeName: "黑河市五大连池市",
            codeValue: "231182"
        },
        {
            codeName: "黑龙江省绥化市",
            codeValue: "231200"
        },
        {
            codeName: "绥化市市辖区",
            codeValue: "231201"
        },
        {
            codeName: "绥化市北林区",
            codeValue: "231202"
        },
        {
            codeName: "绥化市望奎县",
            codeValue: "231221"
        },
        {
            codeName: "绥化市兰西县",
            codeValue: "231222"
        },
        {
            codeName: "绥化市青冈县",
            codeValue: "231223"
        },
        {
            codeName: "绥化市庆安县",
            codeValue: "231224"
        },
        {
            codeName: "绥化市明水县",
            codeValue: "231225"
        },
        {
            codeName: "绥化市绥棱县",
            codeValue: "231226"
        },
        {
            codeName: "绥化市安达市",
            codeValue: "231281"
        },
        {
            codeName: "绥化市肇东市",
            codeValue: "231282"
        },
        {
            codeName: "绥化市海伦市",
            codeValue: "231283"
        },
        {
            codeName: "黑龙江省大兴安岭地区",
            codeValue: "232700"
        },
        {
            codeName: "大兴安岭地区呼玛县",
            codeValue: "232721"
        },
        {
            codeName: "大兴安岭地区塔河县",
            codeValue: "232722"
        },
        {
            codeName: "大兴安岭地区漠河县",
            codeValue: "232723"
        },
        {
            codeName: "上海市",
            codeValue: "310000"
        },
        {
            codeName: "上海市市辖区",
            codeValue: "310100"
        },
        {
            codeName: "上海市黄浦区",
            codeValue: "310101"
        },
        {
            codeName: "上海市徐汇区",
            codeValue: "310104"
        },
        {
            codeName: "上海市长宁区",
            codeValue: "310105"
        },
        {
            codeName: "上海市静安区",
            codeValue: "310106"
        },
        {
            codeName: "上海市普陀区",
            codeValue: "310107"
        },
        {
            codeName: "上海市虹口区",
            codeValue: "310109"
        },
        {
            codeName: "上海市杨浦区",
            codeValue: "310110"
        },
        {
            codeName: "上海市闵行区",
            codeValue: "310112"
        },
        {
            codeName: "上海市宝山区",
            codeValue: "310113"
        },
        {
            codeName: "上海市嘉定区",
            codeValue: "310114"
        },
        {
            codeName: "上海市浦东新区",
            codeValue: "310115"
        },
        {
            codeName: "上海市金山区",
            codeValue: "310116"
        },
        {
            codeName: "上海市松江区",
            codeValue: "310117"
        },
        {
            codeName: "上海市青浦区",
            codeValue: "310118"
        },
        {
            codeName: "上海市奉贤区",
            codeValue: "310120"
        },
        {
            codeName: "上海市崇明区",
            codeValue: "310151"
        },
        {
            codeName: "上海市县",
            codeValue: "310200"
        },
        {
            codeName: "江苏省",
            codeValue: "320000"
        },
        {
            codeName: "江苏省南京市",
            codeValue: "320100"
        },
        {
            codeName: "南京市市辖区",
            codeValue: "320101"
        },
        {
            codeName: "南京市玄武区",
            codeValue: "320102"
        },
        {
            codeName: "南京市秦淮区",
            codeValue: "320104"
        },
        {
            codeName: "南京市建邺区",
            codeValue: "320105"
        },
        {
            codeName: "南京市鼓楼区",
            codeValue: "320106"
        },
        {
            codeName: "南京市浦口区",
            codeValue: "320111"
        },
        {
            codeName: "南京市栖霞区",
            codeValue: "320113"
        },
        {
            codeName: "南京市雨花台区",
            codeValue: "320114"
        },
        {
            codeName: "南京市江宁区",
            codeValue: "320115"
        },
        {
            codeName: "南京市六合区",
            codeValue: "320116"
        },
        {
            codeName: "南京市溧水区",
            codeValue: "320117"
        },
        {
            codeName: "南京市高淳区",
            codeValue: "320118"
        },
        {
            codeName: "江苏省无锡市",
            codeValue: "320200"
        },
        {
            codeName: "无锡市市辖区",
            codeValue: "320201"
        },
        {
            codeName: "无锡市锡山区",
            codeValue: "320205"
        },
        {
            codeName: "无锡市惠山区",
            codeValue: "320206"
        },
        {
            codeName: "无锡市滨湖区",
            codeValue: "320211"
        },
        {
            codeName: "无锡市梁溪区",
            codeValue: "320213"
        },
        {
            codeName: "无锡市新吴区",
            codeValue: "320214"
        },
        {
            codeName: "无锡市江阴市",
            codeValue: "320281"
        },
        {
            codeName: "无锡市宜兴市",
            codeValue: "320282"
        },
        {
            codeName: "江苏省徐州市",
            codeValue: "320300"
        },
        {
            codeName: "徐州市市辖区",
            codeValue: "320301"
        },
        {
            codeName: "徐州市鼓楼区",
            codeValue: "320302"
        },
        {
            codeName: "徐州市云龙区",
            codeValue: "320303"
        },
        {
            codeName: "徐州市贾汪区",
            codeValue: "320305"
        },
        {
            codeName: "徐州市泉山区",
            codeValue: "320311"
        },
        {
            codeName: "徐州市铜山区",
            codeValue: "320312"
        },
        {
            codeName: "徐州市丰县",
            codeValue: "320321"
        },
        {
            codeName: "徐州市沛县",
            codeValue: "320322"
        },
        {
            codeName: "徐州市睢宁县",
            codeValue: "320324"
        },
        {
            codeName: "徐州市新沂市",
            codeValue: "320381"
        },
        {
            codeName: "徐州市邳州市",
            codeValue: "320382"
        },
        {
            codeName: "江苏省常州市",
            codeValue: "320400"
        },
        {
            codeName: "常州市市辖区",
            codeValue: "320401"
        },
        {
            codeName: "常州市天宁区",
            codeValue: "320402"
        },
        {
            codeName: "常州市钟楼区",
            codeValue: "320404"
        },
        {
            codeName: "常州市新北区",
            codeValue: "320411"
        },
        {
            codeName: "常州市武进区",
            codeValue: "320412"
        },
        {
            codeName: "常州市金坛区",
            codeValue: "320413"
        },
        {
            codeName: "常州市溧阳市",
            codeValue: "320481"
        },
        {
            codeName: "江苏省苏州市",
            codeValue: "320500"
        },
        {
            codeName: "苏州市市辖区",
            codeValue: "320501"
        },
        {
            codeName: "苏州市虎丘区",
            codeValue: "320505"
        },
        {
            codeName: "苏州市吴中区",
            codeValue: "320506"
        },
        {
            codeName: "苏州市相城区",
            codeValue: "320507"
        },
        {
            codeName: "苏州市姑苏区",
            codeValue: "320508"
        },
        {
            codeName: "苏州市吴江区",
            codeValue: "320509"
        },
        {
            codeName: "苏州市常熟市",
            codeValue: "320581"
        },
        {
            codeName: "苏州市张家港市",
            codeValue: "320582"
        },
        {
            codeName: "苏州市昆山市",
            codeValue: "320583"
        },
        {
            codeName: "苏州市太仓市",
            codeValue: "320585"
        },
        {
            codeName: "江苏省南通市",
            codeValue: "320600"
        },
        {
            codeName: "南通市市辖区",
            codeValue: "320601"
        },
        {
            codeName: "南通市崇川区",
            codeValue: "320602"
        },
        {
            codeName: "南通市港闸区",
            codeValue: "320611"
        },
        {
            codeName: "南通市通州区",
            codeValue: "320612"
        },
        {
            codeName: "南通市海安县",
            codeValue: "320621"
        },
        {
            codeName: "南通市如东县",
            codeValue: "320623"
        },
        {
            codeName: "南通市启东市",
            codeValue: "320681"
        },
        {
            codeName: "南通市如皋市",
            codeValue: "320682"
        },
        {
            codeName: "南通市海门市",
            codeValue: "320684"
        },
        {
            codeName: "江苏省连云港市",
            codeValue: "320700"
        },
        {
            codeName: "连云港市市辖区",
            codeValue: "320701"
        },
        {
            codeName: "连云港市连云区",
            codeValue: "320703"
        },
        {
            codeName: "连云港市海州区",
            codeValue: "320706"
        },
        {
            codeName: "连云港市赣榆区",
            codeValue: "320707"
        },
        {
            codeName: "连云港市东海县",
            codeValue: "320722"
        },
        {
            codeName: "连云港市灌云县",
            codeValue: "320723"
        },
        {
            codeName: "连云港市灌南县",
            codeValue: "320724"
        },
        {
            codeName: "江苏省淮安市",
            codeValue: "320800"
        },
        {
            codeName: "淮安市市辖区",
            codeValue: "320801"
        },
        {
            codeName: "淮安市淮安区",
            codeValue: "320803"
        },
        {
            codeName: "淮安市淮阴区",
            codeValue: "320804"
        },
        {
            codeName: "淮安市清江浦区",
            codeValue: "320812"
        },
        {
            codeName: "淮安市洪泽区",
            codeValue: "320813"
        },
        {
            codeName: "淮安市涟水县",
            codeValue: "320826"
        },
        {
            codeName: "淮安市盱眙县",
            codeValue: "320830"
        },
        {
            codeName: "淮安市金湖县",
            codeValue: "320831"
        },
        {
            codeName: "江苏省盐城市",
            codeValue: "320900"
        },
        {
            codeName: "盐城市市辖区",
            codeValue: "320901"
        },
        {
            codeName: "盐城市亭湖区",
            codeValue: "320902"
        },
        {
            codeName: "盐城市盐都区",
            codeValue: "320903"
        },
        {
            codeName: "盐城市大丰区",
            codeValue: "320904"
        },
        {
            codeName: "盐城市响水县",
            codeValue: "320921"
        },
        {
            codeName: "盐城市滨海县",
            codeValue: "320922"
        },
        {
            codeName: "盐城市阜宁县",
            codeValue: "320923"
        },
        {
            codeName: "盐城市射阳县",
            codeValue: "320924"
        },
        {
            codeName: "盐城市建湖县",
            codeValue: "320925"
        },
        {
            codeName: "盐城市东台市",
            codeValue: "320981"
        },
        {
            codeName: "江苏省扬州市",
            codeValue: "321000"
        },
        {
            codeName: "扬州市市辖区",
            codeValue: "321001"
        },
        {
            codeName: "扬州市广陵区",
            codeValue: "321002"
        },
        {
            codeName: "扬州市邗江区",
            codeValue: "321003"
        },
        {
            codeName: "扬州市江都区",
            codeValue: "321012"
        },
        {
            codeName: "扬州市宝应县",
            codeValue: "321023"
        },
        {
            codeName: "扬州市仪征市",
            codeValue: "321081"
        },
        {
            codeName: "扬州市高邮市",
            codeValue: "321084"
        },
        {
            codeName: "江苏省镇江市",
            codeValue: "321100"
        },
        {
            codeName: "镇江市市辖区",
            codeValue: "321101"
        },
        {
            codeName: "镇江市京口区",
            codeValue: "321102"
        },
        {
            codeName: "镇江市润州区",
            codeValue: "321111"
        },
        {
            codeName: "镇江市丹徒区",
            codeValue: "321112"
        },
        {
            codeName: "镇江市丹阳市",
            codeValue: "321181"
        },
        {
            codeName: "镇江市扬中市",
            codeValue: "321182"
        },
        {
            codeName: "镇江市句容市",
            codeValue: "321183"
        },
        {
            codeName: "江苏省泰州市",
            codeValue: "321200"
        },
        {
            codeName: "泰州市市辖区",
            codeValue: "321201"
        },
        {
            codeName: "泰州市海陵区",
            codeValue: "321202"
        },
        {
            codeName: "泰州市高港区",
            codeValue: "321203"
        },
        {
            codeName: "泰州市姜堰区",
            codeValue: "321204"
        },
        {
            codeName: "泰州市兴化市",
            codeValue: "321281"
        },
        {
            codeName: "泰州市靖江市",
            codeValue: "321282"
        },
        {
            codeName: "泰州市泰兴市",
            codeValue: "321283"
        },
        {
            codeName: "江苏省宿迁市",
            codeValue: "321300"
        },
        {
            codeName: "宿迁市市辖区",
            codeValue: "321301"
        },
        {
            codeName: "宿迁市宿城区",
            codeValue: "321302"
        },
        {
            codeName: "宿迁市宿豫区",
            codeValue: "321311"
        },
        {
            codeName: "宿迁市沭阳县",
            codeValue: "321322"
        },
        {
            codeName: "宿迁市泗阳县",
            codeValue: "321323"
        },
        {
            codeName: "宿迁市泗洪县",
            codeValue: "321324"
        },
        {
            codeName: "浙江省",
            codeValue: "330000"
        },
        {
            codeName: "浙江省杭州市",
            codeValue: "330100"
        },
        {
            codeName: "杭州市市辖区",
            codeValue: "330101"
        },
        {
            codeName: "杭州市上城区",
            codeValue: "330102"
        },
        {
            codeName: "杭州市下城区",
            codeValue: "330103"
        },
        {
            codeName: "杭州市江干区",
            codeValue: "330104"
        },
        {
            codeName: "杭州市拱墅区",
            codeValue: "330105"
        },
        {
            codeName: "杭州市西湖区",
            codeValue: "330106"
        },
        {
            codeName: "杭州市滨江区",
            codeValue: "330108"
        },
        {
            codeName: "杭州市萧山区",
            codeValue: "330109"
        },
        {
            codeName: "杭州市余杭区",
            codeValue: "330110"
        },
        {
            codeName: "杭州市富阳区",
            codeValue: "330111"
        },
        {
            codeName: "杭州市桐庐县",
            codeValue: "330122"
        },
        {
            codeName: "杭州市淳安县",
            codeValue: "330127"
        },
        {
            codeName: "杭州市建德市",
            codeValue: "330182"
        },
        {
            codeName: "杭州市临安市",
            codeValue: "330185"
        },
        {
            codeName: "浙江省宁波市",
            codeValue: "330200"
        },
        {
            codeName: "宁波市市辖区",
            codeValue: "330201"
        },
        {
            codeName: "宁波市海曙区",
            codeValue: "330203"
        },
        {
            codeName: "宁波市江东区",
            codeValue: "330204"
        },
        {
            codeName: "宁波市江北区",
            codeValue: "330205"
        },
        {
            codeName: "宁波市北仑区",
            codeValue: "330206"
        },
        {
            codeName: "宁波市镇海区",
            codeValue: "330211"
        },
        {
            codeName: "宁波市鄞州区",
            codeValue: "330212"
        },
        {
            codeName: "宁波市奉化区",
            codeValue: "330213"
        },
        {
            codeName: "宁波市象山县",
            codeValue: "330225"
        },
        {
            codeName: "宁波市宁海县",
            codeValue: "330226"
        },
        {
            codeName: "宁波市余姚市",
            codeValue: "330281"
        },
        {
            codeName: "宁波市慈溪市",
            codeValue: "330282"
        },
        {
            codeName: "宁波市奉化市",
            codeValue: "330283"
        },
        {
            codeName: "浙江省温州市",
            codeValue: "330300"
        },
        {
            codeName: "温州市市辖区",
            codeValue: "330301"
        },
        {
            codeName: "温州市鹿城区",
            codeValue: "330302"
        },
        {
            codeName: "温州市龙湾区",
            codeValue: "330303"
        },
        {
            codeName: "温州市瓯海区",
            codeValue: "330304"
        },
        {
            codeName: "温州市洞头区",
            codeValue: "330305"
        },
        {
            codeName: "温州市永嘉县",
            codeValue: "330324"
        },
        {
            codeName: "温州市平阳县",
            codeValue: "330326"
        },
        {
            codeName: "温州市苍南县",
            codeValue: "330327"
        },
        {
            codeName: "温州市文成县",
            codeValue: "330328"
        },
        {
            codeName: "温州市泰顺县",
            codeValue: "330329"
        },
        {
            codeName: "温州市瑞安市",
            codeValue: "330381"
        },
        {
            codeName: "温州市乐清市",
            codeValue: "330382"
        },
        {
            codeName: "浙江省嘉兴市",
            codeValue: "330400"
        },
        {
            codeName: "嘉兴市市辖区",
            codeValue: "330401"
        },
        {
            codeName: "嘉兴市南湖区",
            codeValue: "330402"
        },
        {
            codeName: "嘉兴市秀洲区",
            codeValue: "330411"
        },
        {
            codeName: "嘉兴市嘉善县",
            codeValue: "330421"
        },
        {
            codeName: "嘉兴市海盐县",
            codeValue: "330424"
        },
        {
            codeName: "嘉兴市海宁市",
            codeValue: "330481"
        },
        {
            codeName: "嘉兴市平湖市",
            codeValue: "330482"
        },
        {
            codeName: "嘉兴市桐乡市",
            codeValue: "330483"
        },
        {
            codeName: "浙江省湖州市",
            codeValue: "330500"
        },
        {
            codeName: "湖州市市辖区",
            codeValue: "330501"
        },
        {
            codeName: "湖州市吴兴区",
            codeValue: "330502"
        },
        {
            codeName: "湖州市南浔区",
            codeValue: "330503"
        },
        {
            codeName: "湖州市德清县",
            codeValue: "330521"
        },
        {
            codeName: "湖州市长兴县",
            codeValue: "330522"
        },
        {
            codeName: "湖州市安吉县",
            codeValue: "330523"
        },
        {
            codeName: "浙江省绍兴市",
            codeValue: "330600"
        },
        {
            codeName: "绍兴市市辖区",
            codeValue: "330601"
        },
        {
            codeName: "绍兴市越城区",
            codeValue: "330602"
        },
        {
            codeName: "绍兴市柯桥区",
            codeValue: "330603"
        },
        {
            codeName: "绍兴市上虞区",
            codeValue: "330604"
        },
        {
            codeName: "绍兴市新昌县",
            codeValue: "330624"
        },
        {
            codeName: "绍兴市诸暨市",
            codeValue: "330681"
        },
        {
            codeName: "绍兴市嵊州市",
            codeValue: "330683"
        },
        {
            codeName: "浙江省金华市",
            codeValue: "330700"
        },
        {
            codeName: "金华市市辖区",
            codeValue: "330701"
        },
        {
            codeName: "金华市婺城区",
            codeValue: "330702"
        },
        {
            codeName: "金华市金东区",
            codeValue: "330703"
        },
        {
            codeName: "金华市武义县",
            codeValue: "330723"
        },
        {
            codeName: "金华市浦江县",
            codeValue: "330726"
        },
        {
            codeName: "金华市磐安县",
            codeValue: "330727"
        },
        {
            codeName: "金华市兰溪市",
            codeValue: "330781"
        },
        {
            codeName: "金华市义乌市",
            codeValue: "330782"
        },
        {
            codeName: "金华市东阳市",
            codeValue: "330783"
        },
        {
            codeName: "金华市永康市",
            codeValue: "330784"
        },
        {
            codeName: "浙江省衢州市",
            codeValue: "330800"
        },
        {
            codeName: "衢州市市辖区",
            codeValue: "330801"
        },
        {
            codeName: "衢州市柯城区",
            codeValue: "330802"
        },
        {
            codeName: "衢州市衢江区",
            codeValue: "330803"
        },
        {
            codeName: "衢州市常山县",
            codeValue: "330822"
        },
        {
            codeName: "衢州市开化县",
            codeValue: "330824"
        },
        {
            codeName: "衢州市龙游县",
            codeValue: "330825"
        },
        {
            codeName: "衢州市江山市",
            codeValue: "330881"
        },
        {
            codeName: "浙江省舟山市",
            codeValue: "330900"
        },
        {
            codeName: "舟山市市辖区",
            codeValue: "330901"
        },
        {
            codeName: "舟山市定海区",
            codeValue: "330902"
        },
        {
            codeName: "舟山市普陀区",
            codeValue: "330903"
        },
        {
            codeName: "舟山市岱山县",
            codeValue: "330921"
        },
        {
            codeName: "舟山市嵊泗县",
            codeValue: "330922"
        },
        {
            codeName: "浙江省台州市",
            codeValue: "331000"
        },
        {
            codeName: "台州市市辖区",
            codeValue: "331001"
        },
        {
            codeName: "台州市椒江区",
            codeValue: "331002"
        },
        {
            codeName: "台州市黄岩区",
            codeValue: "331003"
        },
        {
            codeName: "台州市路桥区",
            codeValue: "331004"
        },
        {
            codeName: "台州市玉环县",
            codeValue: "331021"
        },
        {
            codeName: "台州市三门县",
            codeValue: "331022"
        },
        {
            codeName: "台州市天台县",
            codeValue: "331023"
        },
        {
            codeName: "台州市仙居县",
            codeValue: "331024"
        },
        {
            codeName: "台州市温岭市",
            codeValue: "331081"
        },
        {
            codeName: "台州市临海市",
            codeValue: "331082"
        },
        {
            codeName: "浙江省丽水市",
            codeValue: "331100"
        },
        {
            codeName: "丽水市市辖区",
            codeValue: "331101"
        },
        {
            codeName: "丽水市莲都区",
            codeValue: "331102"
        },
        {
            codeName: "丽水市青田县",
            codeValue: "331121"
        },
        {
            codeName: "丽水市缙云县",
            codeValue: "331122"
        },
        {
            codeName: "丽水市遂昌县",
            codeValue: "331123"
        },
        {
            codeName: "丽水市松阳县",
            codeValue: "331124"
        },
        {
            codeName: "丽水市云和县",
            codeValue: "331125"
        },
        {
            codeName: "丽水市庆元县",
            codeValue: "331126"
        },
        {
            codeName: "丽水市景宁畲族自治县",
            codeValue: "331127"
        },
        {
            codeName: "丽水市龙泉市",
            codeValue: "331181"
        },
        {
            codeName: "安徽省",
            codeValue: "340000"
        },
        {
            codeName: "安徽省合肥市",
            codeValue: "340100"
        },
        {
            codeName: "合肥市市辖区",
            codeValue: "340101"
        },
        {
            codeName: "合肥市瑶海区",
            codeValue: "340102"
        },
        {
            codeName: "合肥市庐阳区",
            codeValue: "340103"
        },
        {
            codeName: "合肥市蜀山区",
            codeValue: "340104"
        },
        {
            codeName: "合肥市包河区",
            codeValue: "340111"
        },
        {
            codeName: "合肥市长丰县",
            codeValue: "340121"
        },
        {
            codeName: "合肥市肥东县",
            codeValue: "340122"
        },
        {
            codeName: "合肥市肥西县",
            codeValue: "340123"
        },
        {
            codeName: "合肥市庐江县",
            codeValue: "340124"
        },
        {
            codeName: "合肥市巢湖市",
            codeValue: "340181"
        },
        {
            codeName: "安徽省芜湖市",
            codeValue: "340200"
        },
        {
            codeName: "芜湖市市辖区",
            codeValue: "340201"
        },
        {
            codeName: "芜湖市镜湖区",
            codeValue: "340202"
        },
        {
            codeName: "芜湖市弋江区",
            codeValue: "340203"
        },
        {
            codeName: "芜湖市鸠江区",
            codeValue: "340207"
        },
        {
            codeName: "芜湖市三山区",
            codeValue: "340208"
        },
        {
            codeName: "芜湖市芜湖县",
            codeValue: "340221"
        },
        {
            codeName: "芜湖市繁昌县",
            codeValue: "340222"
        },
        {
            codeName: "芜湖市南陵县",
            codeValue: "340223"
        },
        {
            codeName: "芜湖市无为县",
            codeValue: "340225"
        },
        {
            codeName: "安徽省蚌埠市",
            codeValue: "340300"
        },
        {
            codeName: "蚌埠市市辖区",
            codeValue: "340301"
        },
        {
            codeName: "蚌埠市龙子湖区",
            codeValue: "340302"
        },
        {
            codeName: "蚌埠市蚌山区",
            codeValue: "340303"
        },
        {
            codeName: "蚌埠市禹会区",
            codeValue: "340304"
        },
        {
            codeName: "蚌埠市淮上区",
            codeValue: "340311"
        },
        {
            codeName: "蚌埠市怀远县",
            codeValue: "340321"
        },
        {
            codeName: "蚌埠市五河县",
            codeValue: "340322"
        },
        {
            codeName: "蚌埠市固镇县",
            codeValue: "340323"
        },
        {
            codeName: "安徽省淮南市",
            codeValue: "340400"
        },
        {
            codeName: "淮南市市辖区",
            codeValue: "340401"
        },
        {
            codeName: "淮南市大通区",
            codeValue: "340402"
        },
        {
            codeName: "淮南市田家庵区",
            codeValue: "340403"
        },
        {
            codeName: "淮南市谢家集区",
            codeValue: "340404"
        },
        {
            codeName: "淮南市八公山区",
            codeValue: "340405"
        },
        {
            codeName: "淮南市潘集区",
            codeValue: "340406"
        },
        {
            codeName: "淮南市凤台县",
            codeValue: "340421"
        },
        {
            codeName: "淮南市寿县",
            codeValue: "340422"
        },
        {
            codeName: "安徽省马鞍山市",
            codeValue: "340500"
        },
        {
            codeName: "马鞍山市市辖区",
            codeValue: "340501"
        },
        {
            codeName: "马鞍山市花山区",
            codeValue: "340503"
        },
        {
            codeName: "马鞍山市雨山区",
            codeValue: "340504"
        },
        {
            codeName: "马鞍山市博望区",
            codeValue: "340506"
        },
        {
            codeName: "马鞍山市当涂县",
            codeValue: "340521"
        },
        {
            codeName: "马鞍山市含山县",
            codeValue: "340522"
        },
        {
            codeName: "马鞍山市和县",
            codeValue: "340523"
        },
        {
            codeName: "安徽省淮北市",
            codeValue: "340600"
        },
        {
            codeName: "淮北市市辖区",
            codeValue: "340601"
        },
        {
            codeName: "淮北市杜集区",
            codeValue: "340602"
        },
        {
            codeName: "淮北市相山区",
            codeValue: "340603"
        },
        {
            codeName: "淮北市烈山区",
            codeValue: "340604"
        },
        {
            codeName: "淮北市濉溪县",
            codeValue: "340621"
        },
        {
            codeName: "安徽省铜陵市",
            codeValue: "340700"
        },
        {
            codeName: "铜陵市市辖区",
            codeValue: "340701"
        },
        {
            codeName: "铜陵市铜官区",
            codeValue: "340705"
        },
        {
            codeName: "铜陵市义安区",
            codeValue: "340706"
        },
        {
            codeName: "铜陵市郊区",
            codeValue: "340711"
        },
        {
            codeName: "铜陵市枞阳县",
            codeValue: "340722"
        },
        {
            codeName: "安徽省安庆市",
            codeValue: "340800"
        },
        {
            codeName: "安庆市市辖区",
            codeValue: "340801"
        },
        {
            codeName: "安庆市迎江区",
            codeValue: "340802"
        },
        {
            codeName: "安庆市大观区",
            codeValue: "340803"
        },
        {
            codeName: "安庆市宜秀区",
            codeValue: "340811"
        },
        {
            codeName: "安庆市怀宁县",
            codeValue: "340822"
        },
        {
            codeName: "安庆市潜山县",
            codeValue: "340824"
        },
        {
            codeName: "安庆市太湖县",
            codeValue: "340825"
        },
        {
            codeName: "安庆市宿松县",
            codeValue: "340826"
        },
        {
            codeName: "安庆市望江县",
            codeValue: "340827"
        },
        {
            codeName: "安庆市岳西县",
            codeValue: "340828"
        },
        {
            codeName: "安庆市桐城市",
            codeValue: "340881"
        },
        {
            codeName: "安徽省黄山市",
            codeValue: "341000"
        },
        {
            codeName: "黄山市市辖区",
            codeValue: "341001"
        },
        {
            codeName: "黄山市屯溪区",
            codeValue: "341002"
        },
        {
            codeName: "黄山市黄山区",
            codeValue: "341003"
        },
        {
            codeName: "黄山市徽州区",
            codeValue: "341004"
        },
        {
            codeName: "黄山市歙县",
            codeValue: "341021"
        },
        {
            codeName: "黄山市休宁县",
            codeValue: "341022"
        },
        {
            codeName: "黄山市黟县",
            codeValue: "341023"
        },
        {
            codeName: "黄山市祁门县",
            codeValue: "341024"
        },
        {
            codeName: "安徽省滁州市",
            codeValue: "341100"
        },
        {
            codeName: "滁州市市辖区",
            codeValue: "341101"
        },
        {
            codeName: "滁州市琅琊区",
            codeValue: "341102"
        },
        {
            codeName: "滁州市南谯区",
            codeValue: "341103"
        },
        {
            codeName: "滁州市来安县",
            codeValue: "341122"
        },
        {
            codeName: "滁州市全椒县",
            codeValue: "341124"
        },
        {
            codeName: "滁州市定远县",
            codeValue: "341125"
        },
        {
            codeName: "滁州市凤阳县",
            codeValue: "341126"
        },
        {
            codeName: "滁州市天长市",
            codeValue: "341181"
        },
        {
            codeName: "滁州市明光市",
            codeValue: "341182"
        },
        {
            codeName: "安徽省阜阳市",
            codeValue: "341200"
        },
        {
            codeName: "阜阳市市辖区",
            codeValue: "341201"
        },
        {
            codeName: "阜阳市颍州区",
            codeValue: "341202"
        },
        {
            codeName: "阜阳市颍东区",
            codeValue: "341203"
        },
        {
            codeName: "阜阳市颍泉区",
            codeValue: "341204"
        },
        {
            codeName: "阜阳市临泉县",
            codeValue: "341221"
        },
        {
            codeName: "阜阳市太和县",
            codeValue: "341222"
        },
        {
            codeName: "阜阳市阜南县",
            codeValue: "341225"
        },
        {
            codeName: "阜阳市颍上县",
            codeValue: "341226"
        },
        {
            codeName: "阜阳市界首市",
            codeValue: "341282"
        },
        {
            codeName: "安徽省宿州市",
            codeValue: "341300"
        },
        {
            codeName: "宿州市市辖区",
            codeValue: "341301"
        },
        {
            codeName: "宿州市埇桥区",
            codeValue: "341302"
        },
        {
            codeName: "宿州市砀山县",
            codeValue: "341321"
        },
        {
            codeName: "宿州市萧县",
            codeValue: "341322"
        },
        {
            codeName: "宿州市灵璧县",
            codeValue: "341323"
        },
        {
            codeName: "宿州市泗县",
            codeValue: "341324"
        },
        {
            codeName: "安徽省六安市",
            codeValue: "341500"
        },
        {
            codeName: "六安市市辖区",
            codeValue: "341501"
        },
        {
            codeName: "六安市金安区",
            codeValue: "341502"
        },
        {
            codeName: "六安市裕安区",
            codeValue: "341503"
        },
        {
            codeName: "六安市叶集区",
            codeValue: "341504"
        },
        {
            codeName: "六安市霍邱县",
            codeValue: "341522"
        },
        {
            codeName: "六安市舒城县",
            codeValue: "341523"
        },
        {
            codeName: "六安市金寨县",
            codeValue: "341524"
        },
        {
            codeName: "六安市霍山县",
            codeValue: "341525"
        },
        {
            codeName: "安徽省亳州市",
            codeValue: "341600"
        },
        {
            codeName: "亳州市市辖区",
            codeValue: "341601"
        },
        {
            codeName: "亳州市谯城区",
            codeValue: "341602"
        },
        {
            codeName: "亳州市涡阳县",
            codeValue: "341621"
        },
        {
            codeName: "亳州市蒙城县",
            codeValue: "341622"
        },
        {
            codeName: "亳州市利辛县",
            codeValue: "341623"
        },
        {
            codeName: "安徽省池州市",
            codeValue: "341700"
        },
        {
            codeName: "池州市市辖区",
            codeValue: "341701"
        },
        {
            codeName: "池州市贵池区",
            codeValue: "341702"
        },
        {
            codeName: "池州市东至县",
            codeValue: "341721"
        },
        {
            codeName: "池州市石台县",
            codeValue: "341722"
        },
        {
            codeName: "池州市青阳县",
            codeValue: "341723"
        },
        {
            codeName: "安徽省宣城市",
            codeValue: "341800"
        },
        {
            codeName: "宣城市市辖区",
            codeValue: "341801"
        },
        {
            codeName: "宣城市宣州区",
            codeValue: "341802"
        },
        {
            codeName: "宣城市郎溪县",
            codeValue: "341821"
        },
        {
            codeName: "宣城市广德县",
            codeValue: "341822"
        },
        {
            codeName: "宣城市泾县",
            codeValue: "341823"
        },
        {
            codeName: "宣城市绩溪县",
            codeValue: "341824"
        },
        {
            codeName: "宣城市旌德县",
            codeValue: "341825"
        },
        {
            codeName: "宣城市宁国市",
            codeValue: "341881"
        },
        {
            codeName: "福建省",
            codeValue: "350000"
        },
        {
            codeName: "福建省福州市",
            codeValue: "350100"
        },
        {
            codeName: "福州市市辖区",
            codeValue: "350101"
        },
        {
            codeName: "福州市鼓楼区",
            codeValue: "350102"
        },
        {
            codeName: "福州市台江区",
            codeValue: "350103"
        },
        {
            codeName: "福州市仓山区",
            codeValue: "350104"
        },
        {
            codeName: "福州市马尾区",
            codeValue: "350105"
        },
        {
            codeName: "福州市晋安区",
            codeValue: "350111"
        },
        {
            codeName: "福州市闽侯县",
            codeValue: "350121"
        },
        {
            codeName: "福州市连江县",
            codeValue: "350122"
        },
        {
            codeName: "福州市罗源县",
            codeValue: "350123"
        },
        {
            codeName: "福州市闽清县",
            codeValue: "350124"
        },
        {
            codeName: "福州市永泰县",
            codeValue: "350125"
        },
        {
            codeName: "福州市平潭县",
            codeValue: "350128"
        },
        {
            codeName: "福州市福清市",
            codeValue: "350181"
        },
        {
            codeName: "福州市长乐市",
            codeValue: "350182"
        },
        {
            codeName: "福建省厦门市",
            codeValue: "350200"
        },
        {
            codeName: "厦门市市辖区",
            codeValue: "350201"
        },
        {
            codeName: "厦门市思明区",
            codeValue: "350203"
        },
        {
            codeName: "厦门市海沧区",
            codeValue: "350205"
        },
        {
            codeName: "厦门市湖里区",
            codeValue: "350206"
        },
        {
            codeName: "厦门市集美区",
            codeValue: "350211"
        },
        {
            codeName: "厦门市同安区",
            codeValue: "350212"
        },
        {
            codeName: "厦门市翔安区",
            codeValue: "350213"
        },
        {
            codeName: "福建省莆田市",
            codeValue: "350300"
        },
        {
            codeName: "莆田市市辖区",
            codeValue: "350301"
        },
        {
            codeName: "莆田市城厢区",
            codeValue: "350302"
        },
        {
            codeName: "莆田市涵江区",
            codeValue: "350303"
        },
        {
            codeName: "莆田市荔城区",
            codeValue: "350304"
        },
        {
            codeName: "莆田市秀屿区",
            codeValue: "350305"
        },
        {
            codeName: "莆田市仙游县",
            codeValue: "350322"
        },
        {
            codeName: "福建省三明市",
            codeValue: "350400"
        },
        {
            codeName: "三明市市辖区",
            codeValue: "350401"
        },
        {
            codeName: "三明市梅列区",
            codeValue: "350402"
        },
        {
            codeName: "三明市三元区",
            codeValue: "350403"
        },
        {
            codeName: "三明市明溪县",
            codeValue: "350421"
        },
        {
            codeName: "三明市清流县",
            codeValue: "350423"
        },
        {
            codeName: "三明市宁化县",
            codeValue: "350424"
        },
        {
            codeName: "三明市大田县",
            codeValue: "350425"
        },
        {
            codeName: "三明市尤溪县",
            codeValue: "350426"
        },
        {
            codeName: "三明市沙县",
            codeValue: "350427"
        },
        {
            codeName: "三明市将乐县",
            codeValue: "350428"
        },
        {
            codeName: "三明市泰宁县",
            codeValue: "350429"
        },
        {
            codeName: "三明市建宁县",
            codeValue: "350430"
        },
        {
            codeName: "三明市永安市",
            codeValue: "350481"
        },
        {
            codeName: "福建省泉州市",
            codeValue: "350500"
        },
        {
            codeName: "泉州市市辖区",
            codeValue: "350501"
        },
        {
            codeName: "泉州市鲤城区",
            codeValue: "350502"
        },
        {
            codeName: "泉州市丰泽区",
            codeValue: "350503"
        },
        {
            codeName: "泉州市洛江区",
            codeValue: "350504"
        },
        {
            codeName: "泉州市泉港区",
            codeValue: "350505"
        },
        {
            codeName: "泉州市惠安县",
            codeValue: "350521"
        },
        {
            codeName: "泉州市安溪县",
            codeValue: "350524"
        },
        {
            codeName: "泉州市永春县",
            codeValue: "350525"
        },
        {
            codeName: "泉州市德化县",
            codeValue: "350526"
        },
        {
            codeName: "泉州市金门县",
            codeValue: "350527"
        },
        {
            codeName: "泉州市石狮市",
            codeValue: "350581"
        },
        {
            codeName: "泉州市晋江市",
            codeValue: "350582"
        },
        {
            codeName: "泉州市南安市",
            codeValue: "350583"
        },
        {
            codeName: "福建省漳州市",
            codeValue: "350600"
        },
        {
            codeName: "漳州市市辖区",
            codeValue: "350601"
        },
        {
            codeName: "漳州市芗城区",
            codeValue: "350602"
        },
        {
            codeName: "漳州市龙文区",
            codeValue: "350603"
        },
        {
            codeName: "漳州市云霄县",
            codeValue: "350622"
        },
        {
            codeName: "漳州市漳浦县",
            codeValue: "350623"
        },
        {
            codeName: "漳州市诏安县",
            codeValue: "350624"
        },
        {
            codeName: "漳州市长泰县",
            codeValue: "350625"
        },
        {
            codeName: "漳州市东山县",
            codeValue: "350626"
        },
        {
            codeName: "漳州市南靖县",
            codeValue: "350627"
        },
        {
            codeName: "漳州市平和县",
            codeValue: "350628"
        },
        {
            codeName: "漳州市华安县",
            codeValue: "350629"
        },
        {
            codeName: "漳州市龙海市",
            codeValue: "350681"
        },
        {
            codeName: "福建省南平市",
            codeValue: "350700"
        },
        {
            codeName: "南平市市辖区",
            codeValue: "350701"
        },
        {
            codeName: "南平市延平区",
            codeValue: "350702"
        },
        {
            codeName: "南平市建阳区",
            codeValue: "350703"
        },
        {
            codeName: "南平市顺昌县",
            codeValue: "350721"
        },
        {
            codeName: "南平市浦城县",
            codeValue: "350722"
        },
        {
            codeName: "南平市光泽县",
            codeValue: "350723"
        },
        {
            codeName: "南平市松溪县",
            codeValue: "350724"
        },
        {
            codeName: "南平市政和县",
            codeValue: "350725"
        },
        {
            codeName: "南平市邵武市",
            codeValue: "350781"
        },
        {
            codeName: "南平市武夷山市",
            codeValue: "350782"
        },
        {
            codeName: "南平市建瓯市",
            codeValue: "350783"
        },
        {
            codeName: "福建省龙岩市",
            codeValue: "350800"
        },
        {
            codeName: "龙岩市市辖区",
            codeValue: "350801"
        },
        {
            codeName: "龙岩市新罗区",
            codeValue: "350802"
        },
        {
            codeName: "龙岩市永定区",
            codeValue: "350803"
        },
        {
            codeName: "龙岩市长汀县",
            codeValue: "350821"
        },
        {
            codeName: "龙岩市上杭县",
            codeValue: "350823"
        },
        {
            codeName: "龙岩市武平县",
            codeValue: "350824"
        },
        {
            codeName: "龙岩市连城县",
            codeValue: "350825"
        },
        {
            codeName: "龙岩市漳平市",
            codeValue: "350881"
        },
        {
            codeName: "福建省宁德市",
            codeValue: "350900"
        },
        {
            codeName: "宁德市市辖区",
            codeValue: "350901"
        },
        {
            codeName: "宁德市蕉城区",
            codeValue: "350902"
        },
        {
            codeName: "宁德市霞浦县",
            codeValue: "350921"
        },
        {
            codeName: "宁德市古田县",
            codeValue: "350922"
        },
        {
            codeName: "宁德市屏南县",
            codeValue: "350923"
        },
        {
            codeName: "宁德市寿宁县",
            codeValue: "350924"
        },
        {
            codeName: "宁德市周宁县",
            codeValue: "350925"
        },
        {
            codeName: "宁德市柘荣县",
            codeValue: "350926"
        },
        {
            codeName: "宁德市福安市",
            codeValue: "350981"
        },
        {
            codeName: "宁德市福鼎市",
            codeValue: "350982"
        },
        {
            codeName: "江西省",
            codeValue: "360000"
        },
        {
            codeName: "江西省南昌市",
            codeValue: "360100"
        },
        {
            codeName: "南昌市市辖区",
            codeValue: "360101"
        },
        {
            codeName: "南昌市东湖区",
            codeValue: "360102"
        },
        {
            codeName: "南昌市西湖区",
            codeValue: "360103"
        },
        {
            codeName: "南昌市青云谱区",
            codeValue: "360104"
        },
        {
            codeName: "南昌市湾里区",
            codeValue: "360105"
        },
        {
            codeName: "南昌市青山湖区",
            codeValue: "360111"
        },
        {
            codeName: "南昌市新建区",
            codeValue: "360112"
        },
        {
            codeName: "南昌市南昌县",
            codeValue: "360121"
        },
        {
            codeName: "南昌市安义县",
            codeValue: "360123"
        },
        {
            codeName: "南昌市进贤县",
            codeValue: "360124"
        },
        {
            codeName: "江西省景德镇市",
            codeValue: "360200"
        },
        {
            codeName: "景德镇市市辖区",
            codeValue: "360201"
        },
        {
            codeName: "景德镇市昌江区",
            codeValue: "360202"
        },
        {
            codeName: "景德镇市珠山区",
            codeValue: "360203"
        },
        {
            codeName: "景德镇市浮梁县",
            codeValue: "360222"
        },
        {
            codeName: "景德镇市乐平市",
            codeValue: "360281"
        },
        {
            codeName: "江西省萍乡市",
            codeValue: "360300"
        },
        {
            codeName: "萍乡市市辖区",
            codeValue: "360301"
        },
        {
            codeName: "萍乡市安源区",
            codeValue: "360302"
        },
        {
            codeName: "萍乡市湘东区",
            codeValue: "360313"
        },
        {
            codeName: "萍乡市莲花县",
            codeValue: "360321"
        },
        {
            codeName: "萍乡市上栗县",
            codeValue: "360322"
        },
        {
            codeName: "萍乡市芦溪县",
            codeValue: "360323"
        },
        {
            codeName: "江西省九江市",
            codeValue: "360400"
        },
        {
            codeName: "九江市市辖区",
            codeValue: "360401"
        },
        {
            codeName: "九江市濂溪区",
            codeValue: "360402"
        },
        {
            codeName: "九江市浔阳区",
            codeValue: "360403"
        },
        {
            codeName: "九江市九江县",
            codeValue: "360421"
        },
        {
            codeName: "九江市武宁县",
            codeValue: "360423"
        },
        {
            codeName: "九江市修水县",
            codeValue: "360424"
        },
        {
            codeName: "九江市永修县",
            codeValue: "360425"
        },
        {
            codeName: "九江市德安县",
            codeValue: "360426"
        },
        {
            codeName: "九江市都昌县",
            codeValue: "360428"
        },
        {
            codeName: "九江市湖口县",
            codeValue: "360429"
        },
        {
            codeName: "九江市彭泽县",
            codeValue: "360430"
        },
        {
            codeName: "九江市瑞昌市",
            codeValue: "360481"
        },
        {
            codeName: "九江市共青城市",
            codeValue: "360482"
        },
        {
            codeName: "九江市庐山市",
            codeValue: "360483"
        },
        {
            codeName: "江西省新余市",
            codeValue: "360500"
        },
        {
            codeName: "新余市市辖区",
            codeValue: "360501"
        },
        {
            codeName: "新余市渝水区",
            codeValue: "360502"
        },
        {
            codeName: "新余市分宜县",
            codeValue: "360521"
        },
        {
            codeName: "江西省鹰潭市",
            codeValue: "360600"
        },
        {
            codeName: "鹰潭市市辖区",
            codeValue: "360601"
        },
        {
            codeName: "鹰潭市月湖区",
            codeValue: "360602"
        },
        {
            codeName: "鹰潭市余江县",
            codeValue: "360622"
        },
        {
            codeName: "鹰潭市贵溪市",
            codeValue: "360681"
        },
        {
            codeName: "江西省赣州市",
            codeValue: "360700"
        },
        {
            codeName: "赣州市市辖区",
            codeValue: "360701"
        },
        {
            codeName: "赣州市章贡区",
            codeValue: "360702"
        },
        {
            codeName: "赣州市南康区",
            codeValue: "360703"
        },
        {
            codeName: "赣州市赣县区",
            codeValue: "360704"
        },
        {
            codeName: "赣州市赣县",
            codeValue: "360721"
        },
        {
            codeName: "赣州市信丰县",
            codeValue: "360722"
        },
        {
            codeName: "赣州市大余县",
            codeValue: "360723"
        },
        {
            codeName: "赣州市上犹县",
            codeValue: "360724"
        },
        {
            codeName: "赣州市崇义县",
            codeValue: "360725"
        },
        {
            codeName: "赣州市安远县",
            codeValue: "360726"
        },
        {
            codeName: "赣州市龙南县",
            codeValue: "360727"
        },
        {
            codeName: "赣州市定南县",
            codeValue: "360728"
        },
        {
            codeName: "赣州市全南县",
            codeValue: "360729"
        },
        {
            codeName: "赣州市宁都县",
            codeValue: "360730"
        },
        {
            codeName: "赣州市于都县",
            codeValue: "360731"
        },
        {
            codeName: "赣州市兴国县",
            codeValue: "360732"
        },
        {
            codeName: "赣州市会昌县",
            codeValue: "360733"
        },
        {
            codeName: "赣州市寻乌县",
            codeValue: "360734"
        },
        {
            codeName: "赣州市石城县",
            codeValue: "360735"
        },
        {
            codeName: "赣州市瑞金市",
            codeValue: "360781"
        },
        {
            codeName: "江西省吉安市",
            codeValue: "360800"
        },
        {
            codeName: "吉安市市辖区",
            codeValue: "360801"
        },
        {
            codeName: "吉安市吉州区",
            codeValue: "360802"
        },
        {
            codeName: "吉安市青原区",
            codeValue: "360803"
        },
        {
            codeName: "吉安市吉安县",
            codeValue: "360821"
        },
        {
            codeName: "吉安市吉水县",
            codeValue: "360822"
        },
        {
            codeName: "吉安市峡江县",
            codeValue: "360823"
        },
        {
            codeName: "吉安市新干县",
            codeValue: "360824"
        },
        {
            codeName: "吉安市永丰县",
            codeValue: "360825"
        },
        {
            codeName: "吉安市泰和县",
            codeValue: "360826"
        },
        {
            codeName: "吉安市遂川县",
            codeValue: "360827"
        },
        {
            codeName: "吉安市万安县",
            codeValue: "360828"
        },
        {
            codeName: "吉安市安福县",
            codeValue: "360829"
        },
        {
            codeName: "吉安市永新县",
            codeValue: "360830"
        },
        {
            codeName: "吉安市井冈山市",
            codeValue: "360881"
        },
        {
            codeName: "江西省宜春市",
            codeValue: "360900"
        },
        {
            codeName: "宜春市市辖区",
            codeValue: "360901"
        },
        {
            codeName: "宜春市袁州区",
            codeValue: "360902"
        },
        {
            codeName: "宜春市奉新县",
            codeValue: "360921"
        },
        {
            codeName: "宜春市万载县",
            codeValue: "360922"
        },
        {
            codeName: "宜春市上高县",
            codeValue: "360923"
        },
        {
            codeName: "宜春市宜丰县",
            codeValue: "360924"
        },
        {
            codeName: "宜春市靖安县",
            codeValue: "360925"
        },
        {
            codeName: "宜春市铜鼓县",
            codeValue: "360926"
        },
        {
            codeName: "宜春市丰城市",
            codeValue: "360981"
        },
        {
            codeName: "宜春市樟树市",
            codeValue: "360982"
        },
        {
            codeName: "宜春市高安市",
            codeValue: "360983"
        },
        {
            codeName: "江西省抚州市",
            codeValue: "361000"
        },
        {
            codeName: "抚州市市辖区",
            codeValue: "361001"
        },
        {
            codeName: "抚州市临川区",
            codeValue: "361002"
        },
        {
            codeName: "抚州市东乡区",
            codeValue: "361003"
        },
        {
            codeName: "抚州市南城县",
            codeValue: "361021"
        },
        {
            codeName: "抚州市黎川县",
            codeValue: "361022"
        },
        {
            codeName: "抚州市南丰县",
            codeValue: "361023"
        },
        {
            codeName: "抚州市崇仁县",
            codeValue: "361024"
        },
        {
            codeName: "抚州市乐安县",
            codeValue: "361025"
        },
        {
            codeName: "抚州市宜黄县",
            codeValue: "361026"
        },
        {
            codeName: "抚州市金溪县",
            codeValue: "361027"
        },
        {
            codeName: "抚州市资溪县",
            codeValue: "361028"
        },
        {
            codeName: "抚州市东乡县",
            codeValue: "361029"
        },
        {
            codeName: "抚州市广昌县",
            codeValue: "361030"
        },
        {
            codeName: "江西省上饶市",
            codeValue: "361100"
        },
        {
            codeName: "上饶市市辖区",
            codeValue: "361101"
        },
        {
            codeName: "上饶市信州区",
            codeValue: "361102"
        },
        {
            codeName: "上饶市广丰区",
            codeValue: "361103"
        },
        {
            codeName: "上饶市上饶县",
            codeValue: "361121"
        },
        {
            codeName: "上饶市玉山县",
            codeValue: "361123"
        },
        {
            codeName: "上饶市铅山县",
            codeValue: "361124"
        },
        {
            codeName: "上饶市横峰县",
            codeValue: "361125"
        },
        {
            codeName: "上饶市弋阳县",
            codeValue: "361126"
        },
        {
            codeName: "上饶市余干县",
            codeValue: "361127"
        },
        {
            codeName: "上饶市鄱阳县",
            codeValue: "361128"
        },
        {
            codeName: "上饶市万年县",
            codeValue: "361129"
        },
        {
            codeName: "上饶市婺源县",
            codeValue: "361130"
        },
        {
            codeName: "上饶市德兴市",
            codeValue: "361181"
        },
        {
            codeName: "山东省",
            codeValue: "370000"
        },
        {
            codeName: "山东省济南市",
            codeValue: "370100"
        },
        {
            codeName: "济南市市辖区",
            codeValue: "370101"
        },
        {
            codeName: "济南市历下区",
            codeValue: "370102"
        },
        {
            codeName: "济南市市中区",
            codeValue: "370103"
        },
        {
            codeName: "济南市槐荫区",
            codeValue: "370104"
        },
        {
            codeName: "济南市天桥区",
            codeValue: "370105"
        },
        {
            codeName: "济南市历城区",
            codeValue: "370112"
        },
        {
            codeName: "济南市长清区",
            codeValue: "370113"
        },
        {
            codeName: "济南市章丘区",
            codeValue: "370114"
        },
        {
            codeName: "济南市平阴县",
            codeValue: "370124"
        },
        {
            codeName: "济南市济阳县",
            codeValue: "370125"
        },
        {
            codeName: "济南市商河县",
            codeValue: "370126"
        },
        {
            codeName: "济南市章丘市",
            codeValue: "370181"
        },
        {
            codeName: "山东省青岛市",
            codeValue: "370200"
        },
        {
            codeName: "青岛市市辖区",
            codeValue: "370201"
        },
        {
            codeName: "青岛市市南区",
            codeValue: "370202"
        },
        {
            codeName: "青岛市市北区",
            codeValue: "370203"
        },
        {
            codeName: "青岛市黄岛区",
            codeValue: "370211"
        },
        {
            codeName: "青岛市崂山区",
            codeValue: "370212"
        },
        {
            codeName: "青岛市李沧区",
            codeValue: "370213"
        },
        {
            codeName: "青岛市城阳区",
            codeValue: "370214"
        },
        {
            codeName: "青岛市胶州市",
            codeValue: "370281"
        },
        {
            codeName: "青岛市即墨市",
            codeValue: "370282"
        },
        {
            codeName: "青岛市平度市",
            codeValue: "370283"
        },
        {
            codeName: "青岛市莱西市",
            codeValue: "370285"
        },
        {
            codeName: "山东省淄博市",
            codeValue: "370300"
        },
        {
            codeName: "淄博市市辖区",
            codeValue: "370301"
        },
        {
            codeName: "淄博市淄川区",
            codeValue: "370302"
        },
        {
            codeName: "淄博市张店区",
            codeValue: "370303"
        },
        {
            codeName: "淄博市博山区",
            codeValue: "370304"
        },
        {
            codeName: "淄博市临淄区",
            codeValue: "370305"
        },
        {
            codeName: "淄博市周村区",
            codeValue: "370306"
        },
        {
            codeName: "淄博市桓台县",
            codeValue: "370321"
        },
        {
            codeName: "淄博市高青县",
            codeValue: "370322"
        },
        {
            codeName: "淄博市沂源县",
            codeValue: "370323"
        },
        {
            codeName: "山东省枣庄市",
            codeValue: "370400"
        },
        {
            codeName: "枣庄市市辖区",
            codeValue: "370401"
        },
        {
            codeName: "枣庄市市中区",
            codeValue: "370402"
        },
        {
            codeName: "枣庄市薛城区",
            codeValue: "370403"
        },
        {
            codeName: "枣庄市峄城区",
            codeValue: "370404"
        },
        {
            codeName: "枣庄市台儿庄区",
            codeValue: "370405"
        },
        {
            codeName: "枣庄市山亭区",
            codeValue: "370406"
        },
        {
            codeName: "枣庄市滕州市",
            codeValue: "370481"
        },
        {
            codeName: "山东省东营市",
            codeValue: "370500"
        },
        {
            codeName: "东营市市辖区",
            codeValue: "370501"
        },
        {
            codeName: "东营市东营区",
            codeValue: "370502"
        },
        {
            codeName: "东营市河口区",
            codeValue: "370503"
        },
        {
            codeName: "东营市垦利区",
            codeValue: "370505"
        },
        {
            codeName: "东营市利津县",
            codeValue: "370522"
        },
        {
            codeName: "东营市广饶县",
            codeValue: "370523"
        },
        {
            codeName: "山东省烟台市",
            codeValue: "370600"
        },
        {
            codeName: "烟台市市辖区",
            codeValue: "370601"
        },
        {
            codeName: "烟台市芝罘区",
            codeValue: "370602"
        },
        {
            codeName: "烟台市福山区",
            codeValue: "370611"
        },
        {
            codeName: "烟台市牟平区",
            codeValue: "370612"
        },
        {
            codeName: "烟台市莱山区",
            codeValue: "370613"
        },
        {
            codeName: "烟台市长岛县",
            codeValue: "370634"
        },
        {
            codeName: "烟台市龙口市",
            codeValue: "370681"
        },
        {
            codeName: "烟台市莱阳市",
            codeValue: "370682"
        },
        {
            codeName: "烟台市莱州市",
            codeValue: "370683"
        },
        {
            codeName: "烟台市蓬莱市",
            codeValue: "370684"
        },
        {
            codeName: "烟台市招远市",
            codeValue: "370685"
        },
        {
            codeName: "烟台市栖霞市",
            codeValue: "370686"
        },
        {
            codeName: "烟台市海阳市",
            codeValue: "370687"
        },
        {
            codeName: "山东省潍坊市",
            codeValue: "370700"
        },
        {
            codeName: "潍坊市市辖区",
            codeValue: "370701"
        },
        {
            codeName: "潍坊市潍城区",
            codeValue: "370702"
        },
        {
            codeName: "潍坊市寒亭区",
            codeValue: "370703"
        },
        {
            codeName: "潍坊市坊子区",
            codeValue: "370704"
        },
        {
            codeName: "潍坊市奎文区",
            codeValue: "370705"
        },
        {
            codeName: "潍坊市临朐县",
            codeValue: "370724"
        },
        {
            codeName: "潍坊市昌乐县",
            codeValue: "370725"
        },
        {
            codeName: "潍坊市青州市",
            codeValue: "370781"
        },
        {
            codeName: "潍坊市诸城市",
            codeValue: "370782"
        },
        {
            codeName: "潍坊市寿光市",
            codeValue: "370783"
        },
        {
            codeName: "潍坊市安丘市",
            codeValue: "370784"
        },
        {
            codeName: "潍坊市高密市",
            codeValue: "370785"
        },
        {
            codeName: "潍坊市昌邑市",
            codeValue: "370786"
        },
        {
            codeName: "山东省济宁市",
            codeValue: "370800"
        },
        {
            codeName: "济宁市市辖区",
            codeValue: "370801"
        },
        {
            codeName: "济宁市任城区",
            codeValue: "370811"
        },
        {
            codeName: "济宁市兖州区",
            codeValue: "370812"
        },
        {
            codeName: "济宁市微山县",
            codeValue: "370826"
        },
        {
            codeName: "济宁市鱼台县",
            codeValue: "370827"
        },
        {
            codeName: "济宁市金乡县",
            codeValue: "370828"
        },
        {
            codeName: "济宁市嘉祥县",
            codeValue: "370829"
        },
        {
            codeName: "济宁市汶上县",
            codeValue: "370830"
        },
        {
            codeName: "济宁市泗水县",
            codeValue: "370831"
        },
        {
            codeName: "济宁市梁山县",
            codeValue: "370832"
        },
        {
            codeName: "济宁市曲阜市",
            codeValue: "370881"
        },
        {
            codeName: "济宁市邹城市",
            codeValue: "370883"
        },
        {
            codeName: "山东省泰安市",
            codeValue: "370900"
        },
        {
            codeName: "泰安市市辖区",
            codeValue: "370901"
        },
        {
            codeName: "泰安市泰山区",
            codeValue: "370902"
        },
        {
            codeName: "泰安市岱岳区",
            codeValue: "370911"
        },
        {
            codeName: "泰安市宁阳县",
            codeValue: "370921"
        },
        {
            codeName: "泰安市东平县",
            codeValue: "370923"
        },
        {
            codeName: "泰安市新泰市",
            codeValue: "370982"
        },
        {
            codeName: "泰安市肥城市",
            codeValue: "370983"
        },
        {
            codeName: "山东省威海市",
            codeValue: "371000"
        },
        {
            codeName: "威海市市辖区",
            codeValue: "371001"
        },
        {
            codeName: "威海市环翠区",
            codeValue: "371002"
        },
        {
            codeName: "威海市文登区",
            codeValue: "371003"
        },
        {
            codeName: "威海市荣成市",
            codeValue: "371082"
        },
        {
            codeName: "威海市乳山市",
            codeValue: "371083"
        },
        {
            codeName: "山东省日照市",
            codeValue: "371100"
        },
        {
            codeName: "日照市市辖区",
            codeValue: "371101"
        },
        {
            codeName: "日照市东港区",
            codeValue: "371102"
        },
        {
            codeName: "日照市岚山区",
            codeValue: "371103"
        },
        {
            codeName: "日照市五莲县",
            codeValue: "371121"
        },
        {
            codeName: "日照市莒县",
            codeValue: "371122"
        },
        {
            codeName: "山东省莱芜市",
            codeValue: "371200"
        },
        {
            codeName: "莱芜市市辖区",
            codeValue: "371201"
        },
        {
            codeName: "莱芜市莱城区",
            codeValue: "371202"
        },
        {
            codeName: "莱芜市钢城区",
            codeValue: "371203"
        },
        {
            codeName: "山东省临沂市",
            codeValue: "371300"
        },
        {
            codeName: "临沂市市辖区",
            codeValue: "371301"
        },
        {
            codeName: "临沂市兰山区",
            codeValue: "371302"
        },
        {
            codeName: "临沂市罗庄区",
            codeValue: "371311"
        },
        {
            codeName: "临沂市河东区",
            codeValue: "371312"
        },
        {
            codeName: "临沂市沂南县",
            codeValue: "371321"
        },
        {
            codeName: "临沂市郯城县",
            codeValue: "371322"
        },
        {
            codeName: "临沂市沂水县",
            codeValue: "371323"
        },
        {
            codeName: "临沂市兰陵县",
            codeValue: "371324"
        },
        {
            codeName: "临沂市费县",
            codeValue: "371325"
        },
        {
            codeName: "临沂市平邑县",
            codeValue: "371326"
        },
        {
            codeName: "临沂市莒南县",
            codeValue: "371327"
        },
        {
            codeName: "临沂市蒙阴县",
            codeValue: "371328"
        },
        {
            codeName: "临沂市临沭县",
            codeValue: "371329"
        },
        {
            codeName: "山东省德州市",
            codeValue: "371400"
        },
        {
            codeName: "德州市市辖区",
            codeValue: "371401"
        },
        {
            codeName: "德州市德城区",
            codeValue: "371402"
        },
        {
            codeName: "德州市陵城区",
            codeValue: "371403"
        },
        {
            codeName: "德州市宁津县",
            codeValue: "371422"
        },
        {
            codeName: "德州市庆云县",
            codeValue: "371423"
        },
        {
            codeName: "德州市临邑县",
            codeValue: "371424"
        },
        {
            codeName: "德州市齐河县",
            codeValue: "371425"
        },
        {
            codeName: "德州市平原县",
            codeValue: "371426"
        },
        {
            codeName: "德州市夏津县",
            codeValue: "371427"
        },
        {
            codeName: "德州市武城县",
            codeValue: "371428"
        },
        {
            codeName: "德州市乐陵市",
            codeValue: "371481"
        },
        {
            codeName: "德州市禹城市",
            codeValue: "371482"
        },
        {
            codeName: "山东省聊城市",
            codeValue: "371500"
        },
        {
            codeName: "聊城市市辖区",
            codeValue: "371501"
        },
        {
            codeName: "聊城市东昌府区",
            codeValue: "371502"
        },
        {
            codeName: "聊城市阳谷县",
            codeValue: "371521"
        },
        {
            codeName: "聊城市莘县",
            codeValue: "371522"
        },
        {
            codeName: "聊城市茌平县",
            codeValue: "371523"
        },
        {
            codeName: "聊城市东阿县",
            codeValue: "371524"
        },
        {
            codeName: "聊城市冠县",
            codeValue: "371525"
        },
        {
            codeName: "聊城市高唐县",
            codeValue: "371526"
        },
        {
            codeName: "聊城市临清市",
            codeValue: "371581"
        },
        {
            codeName: "山东省滨州市",
            codeValue: "371600"
        },
        {
            codeName: "滨州市市辖区",
            codeValue: "371601"
        },
        {
            codeName: "滨州市滨城区",
            codeValue: "371602"
        },
        {
            codeName: "滨州市沾化区",
            codeValue: "371603"
        },
        {
            codeName: "滨州市惠民县",
            codeValue: "371621"
        },
        {
            codeName: "滨州市阳信县",
            codeValue: "371622"
        },
        {
            codeName: "滨州市无棣县",
            codeValue: "371623"
        },
        {
            codeName: "滨州市博兴县",
            codeValue: "371625"
        },
        {
            codeName: "滨州市邹平县",
            codeValue: "371626"
        },
        {
            codeName: "山东省菏泽市",
            codeValue: "371700"
        },
        {
            codeName: "菏泽市市辖区",
            codeValue: "371701"
        },
        {
            codeName: "菏泽市牡丹区",
            codeValue: "371702"
        },
        {
            codeName: "菏泽市定陶区",
            codeValue: "371703"
        },
        {
            codeName: "菏泽市曹县",
            codeValue: "371721"
        },
        {
            codeName: "菏泽市单县",
            codeValue: "371722"
        },
        {
            codeName: "菏泽市成武县",
            codeValue: "371723"
        },
        {
            codeName: "菏泽市巨野县",
            codeValue: "371724"
        },
        {
            codeName: "菏泽市郓城县",
            codeValue: "371725"
        },
        {
            codeName: "菏泽市鄄城县",
            codeValue: "371726"
        },
        {
            codeName: "菏泽市东明县",
            codeValue: "371728"
        },
        {
            codeName: "河南省",
            codeValue: "410000"
        },
        {
            codeName: "河南省郑州市",
            codeValue: "410100"
        },
        {
            codeName: "郑州市市辖区",
            codeValue: "410101"
        },
        {
            codeName: "郑州市中原区",
            codeValue: "410102"
        },
        {
            codeName: "郑州市二七区",
            codeValue: "410103"
        },
        {
            codeName: "郑州市管城回族区",
            codeValue: "410104"
        },
        {
            codeName: "郑州市金水区",
            codeValue: "410105"
        },
        {
            codeName: "郑州市上街区",
            codeValue: "410106"
        },
        {
            codeName: "郑州市惠济区",
            codeValue: "410108"
        },
        {
            codeName: "郑州市中牟县",
            codeValue: "410122"
        },
        {
            codeName: "郑州市巩义市",
            codeValue: "410181"
        },
        {
            codeName: "郑州市荥阳市",
            codeValue: "410182"
        },
        {
            codeName: "郑州市新密市",
            codeValue: "410183"
        },
        {
            codeName: "郑州市新郑市",
            codeValue: "410184"
        },
        {
            codeName: "郑州市登封市",
            codeValue: "410185"
        },
        {
            codeName: "河南省开封市",
            codeValue: "410200"
        },
        {
            codeName: "开封市市辖区",
            codeValue: "410201"
        },
        {
            codeName: "开封市龙亭区",
            codeValue: "410202"
        },
        {
            codeName: "开封市顺河回族区",
            codeValue: "410203"
        },
        {
            codeName: "开封市鼓楼区",
            codeValue: "410204"
        },
        {
            codeName: "开封市禹王台区",
            codeValue: "410205"
        },
        {
            codeName: "开封市祥符区",
            codeValue: "410212"
        },
        {
            codeName: "开封市杞县",
            codeValue: "410221"
        },
        {
            codeName: "开封市通许县",
            codeValue: "410222"
        },
        {
            codeName: "开封市尉氏县",
            codeValue: "410223"
        },
        {
            codeName: "开封市兰考县",
            codeValue: "410225"
        },
        {
            codeName: "河南省洛阳市",
            codeValue: "410300"
        },
        {
            codeName: "洛阳市市辖区",
            codeValue: "410301"
        },
        {
            codeName: "洛阳市老城区",
            codeValue: "410302"
        },
        {
            codeName: "洛阳市西工区",
            codeValue: "410303"
        },
        {
            codeName: "洛阳市瀍河回族区",
            codeValue: "410304"
        },
        {
            codeName: "洛阳市涧西区",
            codeValue: "410305"
        },
        {
            codeName: "洛阳市吉利区",
            codeValue: "410306"
        },
        {
            codeName: "洛阳市洛龙区",
            codeValue: "410311"
        },
        {
            codeName: "洛阳市孟津县",
            codeValue: "410322"
        },
        {
            codeName: "洛阳市新安县",
            codeValue: "410323"
        },
        {
            codeName: "洛阳市栾川县",
            codeValue: "410324"
        },
        {
            codeName: "洛阳市嵩县",
            codeValue: "410325"
        },
        {
            codeName: "洛阳市汝阳县",
            codeValue: "410326"
        },
        {
            codeName: "洛阳市宜阳县",
            codeValue: "410327"
        },
        {
            codeName: "洛阳市洛宁县",
            codeValue: "410328"
        },
        {
            codeName: "洛阳市伊川县",
            codeValue: "410329"
        },
        {
            codeName: "洛阳市偃师市",
            codeValue: "410381"
        },
        {
            codeName: "河南省平顶山市",
            codeValue: "410400"
        },
        {
            codeName: "平顶山市市辖区",
            codeValue: "410401"
        },
        {
            codeName: "平顶山市新华区",
            codeValue: "410402"
        },
        {
            codeName: "平顶山市卫东区",
            codeValue: "410403"
        },
        {
            codeName: "平顶山市石龙区",
            codeValue: "410404"
        },
        {
            codeName: "平顶山市湛河区",
            codeValue: "410411"
        },
        {
            codeName: "平顶山市宝丰县",
            codeValue: "410421"
        },
        {
            codeName: "平顶山市叶县",
            codeValue: "410422"
        },
        {
            codeName: "平顶山市鲁山县",
            codeValue: "410423"
        },
        {
            codeName: "平顶山市郏县",
            codeValue: "410425"
        },
        {
            codeName: "平顶山市舞钢市",
            codeValue: "410481"
        },
        {
            codeName: "平顶山市汝州市",
            codeValue: "410482"
        },
        {
            codeName: "河南省安阳市",
            codeValue: "410500"
        },
        {
            codeName: "安阳市市辖区",
            codeValue: "410501"
        },
        {
            codeName: "安阳市文峰区",
            codeValue: "410502"
        },
        {
            codeName: "安阳市北关区",
            codeValue: "410503"
        },
        {
            codeName: "安阳市殷都区",
            codeValue: "410505"
        },
        {
            codeName: "安阳市龙安区　　　　　　　　",
            codeValue: "410506"
        },
        {
            codeName: "安阳市安阳县",
            codeValue: "410522"
        },
        {
            codeName: "安阳市汤阴县",
            codeValue: "410523"
        },
        {
            codeName: "安阳市滑县",
            codeValue: "410526"
        },
        {
            codeName: "安阳市内黄县",
            codeValue: "410527"
        },
        {
            codeName: "安阳市林州市",
            codeValue: "410581"
        },
        {
            codeName: "河南省鹤壁市",
            codeValue: "410600"
        },
        {
            codeName: "鹤壁市市辖区",
            codeValue: "410601"
        },
        {
            codeName: "鹤壁市鹤山区",
            codeValue: "410602"
        },
        {
            codeName: "鹤壁市山城区",
            codeValue: "410603"
        },
        {
            codeName: "鹤壁市淇滨区",
            codeValue: "410611"
        },
        {
            codeName: "鹤壁市浚县",
            codeValue: "410621"
        },
        {
            codeName: "鹤壁市淇县",
            codeValue: "410622"
        },
        {
            codeName: "河南省新乡市",
            codeValue: "410700"
        },
        {
            codeName: "新乡市市辖区",
            codeValue: "410701"
        },
        {
            codeName: "新乡市红旗区",
            codeValue: "410702"
        },
        {
            codeName: "新乡市卫滨区",
            codeValue: "410703"
        },
        {
            codeName: "新乡市凤泉区",
            codeValue: "410704"
        },
        {
            codeName: "新乡市牧野区",
            codeValue: "410711"
        },
        {
            codeName: "新乡市新乡县",
            codeValue: "410721"
        },
        {
            codeName: "新乡市获嘉县",
            codeValue: "410724"
        },
        {
            codeName: "新乡市原阳县",
            codeValue: "410725"
        },
        {
            codeName: "新乡市延津县",
            codeValue: "410726"
        },
        {
            codeName: "新乡市封丘县",
            codeValue: "410727"
        },
        {
            codeName: "新乡市长垣县",
            codeValue: "410728"
        },
        {
            codeName: "新乡市卫辉市",
            codeValue: "410781"
        },
        {
            codeName: "新乡市辉县市",
            codeValue: "410782"
        },
        {
            codeName: "河南省焦作市",
            codeValue: "410800"
        },
        {
            codeName: "焦作市市辖区",
            codeValue: "410801"
        },
        {
            codeName: "焦作市解放区",
            codeValue: "410802"
        },
        {
            codeName: "焦作市中站区",
            codeValue: "410803"
        },
        {
            codeName: "焦作市马村区",
            codeValue: "410804"
        },
        {
            codeName: "焦作市山阳区",
            codeValue: "410811"
        },
        {
            codeName: "焦作市修武县",
            codeValue: "410821"
        },
        {
            codeName: "焦作市博爱县",
            codeValue: "410822"
        },
        {
            codeName: "焦作市武陟县",
            codeValue: "410823"
        },
        {
            codeName: "焦作市温县",
            codeValue: "410825"
        },
        {
            codeName: "焦作市沁阳市",
            codeValue: "410882"
        },
        {
            codeName: "焦作市孟州市",
            codeValue: "410883"
        },
        {
            codeName: "河南省濮阳市",
            codeValue: "410900"
        },
        {
            codeName: "濮阳市市辖区",
            codeValue: "410901"
        },
        {
            codeName: "濮阳市华龙区",
            codeValue: "410902"
        },
        {
            codeName: "濮阳市清丰县",
            codeValue: "410922"
        },
        {
            codeName: "濮阳市南乐县",
            codeValue: "410923"
        },
        {
            codeName: "濮阳市范县",
            codeValue: "410926"
        },
        {
            codeName: "濮阳市台前县",
            codeValue: "410927"
        },
        {
            codeName: "濮阳市濮阳县",
            codeValue: "410928"
        },
        {
            codeName: "河南省许昌市",
            codeValue: "411000"
        },
        {
            codeName: "许昌市市辖区",
            codeValue: "411001"
        },
        {
            codeName: "许昌市魏都区",
            codeValue: "411002"
        },
        {
            codeName: "许昌市建安区",
            codeValue: "411003"
        },
        {
            codeName: "许昌市许昌县",
            codeValue: "411023"
        },
        {
            codeName: "许昌市鄢陵县",
            codeValue: "411024"
        },
        {
            codeName: "许昌市襄城县",
            codeValue: "411025"
        },
        {
            codeName: "许昌市禹州市",
            codeValue: "411081"
        },
        {
            codeName: "许昌市长葛市",
            codeValue: "411082"
        },
        {
            codeName: "河南省漯河市",
            codeValue: "411100"
        },
        {
            codeName: "漯河市市辖区",
            codeValue: "411101"
        },
        {
            codeName: "漯河市源汇区",
            codeValue: "411102"
        },
        {
            codeName: "漯河市郾城区",
            codeValue: "411103"
        },
        {
            codeName: "漯河市召陵区",
            codeValue: "411104"
        },
        {
            codeName: "漯河市舞阳县",
            codeValue: "411121"
        },
        {
            codeName: "漯河市临颍县",
            codeValue: "411122"
        },
        {
            codeName: "河南省三门峡市",
            codeValue: "411200"
        },
        {
            codeName: "三门峡市市辖区",
            codeValue: "411201"
        },
        {
            codeName: "三门峡市湖滨区",
            codeValue: "411202"
        },
        {
            codeName: "三门峡市陕州区",
            codeValue: "411203"
        },
        {
            codeName: "三门峡市渑池县",
            codeValue: "411221"
        },
        {
            codeName: "三门峡市卢氏县",
            codeValue: "411224"
        },
        {
            codeName: "三门峡市义马市",
            codeValue: "411281"
        },
        {
            codeName: "三门峡市灵宝市",
            codeValue: "411282"
        },
        {
            codeName: "河南省南阳市",
            codeValue: "411300"
        },
        {
            codeName: "南阳市市辖区",
            codeValue: "411301"
        },
        {
            codeName: "南阳市宛城区",
            codeValue: "411302"
        },
        {
            codeName: "南阳市卧龙区",
            codeValue: "411303"
        },
        {
            codeName: "南阳市南召县",
            codeValue: "411321"
        },
        {
            codeName: "南阳市方城县",
            codeValue: "411322"
        },
        {
            codeName: "南阳市西峡县",
            codeValue: "411323"
        },
        {
            codeName: "南阳市镇平县",
            codeValue: "411324"
        },
        {
            codeName: "南阳市内乡县",
            codeValue: "411325"
        },
        {
            codeName: "南阳市淅川县",
            codeValue: "411326"
        },
        {
            codeName: "南阳市社旗县",
            codeValue: "411327"
        },
        {
            codeName: "南阳市唐河县",
            codeValue: "411328"
        },
        {
            codeName: "南阳市新野县",
            codeValue: "411329"
        },
        {
            codeName: "南阳市桐柏县",
            codeValue: "411330"
        },
        {
            codeName: "南阳市邓州市",
            codeValue: "411381"
        },
        {
            codeName: "河南省商丘市",
            codeValue: "411400"
        },
        {
            codeName: "商丘市市辖区",
            codeValue: "411401"
        },
        {
            codeName: "商丘市梁园区",
            codeValue: "411402"
        },
        {
            codeName: "商丘市睢阳区",
            codeValue: "411403"
        },
        {
            codeName: "商丘市民权县",
            codeValue: "411421"
        },
        {
            codeName: "商丘市睢县",
            codeValue: "411422"
        },
        {
            codeName: "商丘市宁陵县",
            codeValue: "411423"
        },
        {
            codeName: "商丘市柘城县",
            codeValue: "411424"
        },
        {
            codeName: "商丘市虞城县",
            codeValue: "411425"
        },
        {
            codeName: "商丘市夏邑县",
            codeValue: "411426"
        },
        {
            codeName: "商丘市永城市",
            codeValue: "411481"
        },
        {
            codeName: "河南省信阳市",
            codeValue: "411500"
        },
        {
            codeName: "信阳市市辖区",
            codeValue: "411501"
        },
        {
            codeName: "信阳市浉河区",
            codeValue: "411502"
        },
        {
            codeName: "信阳市平桥区",
            codeValue: "411503"
        },
        {
            codeName: "信阳市罗山县",
            codeValue: "411521"
        },
        {
            codeName: "信阳市光山县",
            codeValue: "411522"
        },
        {
            codeName: "信阳市新县",
            codeValue: "411523"
        },
        {
            codeName: "信阳市商城县",
            codeValue: "411524"
        },
        {
            codeName: "信阳市固始县",
            codeValue: "411525"
        },
        {
            codeName: "信阳市潢川县",
            codeValue: "411526"
        },
        {
            codeName: "信阳市淮滨县",
            codeValue: "411527"
        },
        {
            codeName: "信阳市息县",
            codeValue: "411528"
        },
        {
            codeName: "河南省周口市",
            codeValue: "411600"
        },
        {
            codeName: "周口市市辖区",
            codeValue: "411601"
        },
        {
            codeName: "周口市川汇区",
            codeValue: "411602"
        },
        {
            codeName: "周口市扶沟县",
            codeValue: "411621"
        },
        {
            codeName: "周口市西华县",
            codeValue: "411622"
        },
        {
            codeName: "周口市商水县",
            codeValue: "411623"
        },
        {
            codeName: "周口市沈丘县",
            codeValue: "411624"
        },
        {
            codeName: "周口市郸城县",
            codeValue: "411625"
        },
        {
            codeName: "周口市淮阳县",
            codeValue: "411626"
        },
        {
            codeName: "周口市太康县",
            codeValue: "411627"
        },
        {
            codeName: "周口市鹿邑县",
            codeValue: "411628"
        },
        {
            codeName: "周口市项城市",
            codeValue: "411681"
        },
        {
            codeName: "河南省驻马店市",
            codeValue: "411700"
        },
        {
            codeName: "驻马店市市辖区",
            codeValue: "411701"
        },
        {
            codeName: "驻马店市驿城区",
            codeValue: "411702"
        },
        {
            codeName: "驻马店市西平县",
            codeValue: "411721"
        },
        {
            codeName: "驻马店市上蔡县",
            codeValue: "411722"
        },
        {
            codeName: "驻马店市平舆县",
            codeValue: "411723"
        },
        {
            codeName: "驻马店市正阳县",
            codeValue: "411724"
        },
        {
            codeName: "驻马店市确山县",
            codeValue: "411725"
        },
        {
            codeName: "驻马店市泌阳县",
            codeValue: "411726"
        },
        {
            codeName: "驻马店市汝南县",
            codeValue: "411727"
        },
        {
            codeName: "驻马店市遂平县",
            codeValue: "411728"
        },
        {
            codeName: "驻马店市新蔡县",
            codeValue: "411729"
        },
        {
            codeName: "河南省省直辖县级行政区划",
            codeValue: "419000"
        },
        {
            codeName: "河南省省直辖县级行政区划济源市",
            codeValue: "419001"
        },
        {
            codeName: "湖北省",
            codeValue: "420000"
        },
        {
            codeName: "湖北省武汉市",
            codeValue: "420100"
        },
        {
            codeName: "武汉市市辖区",
            codeValue: "420101"
        },
        {
            codeName: "武汉市江岸区",
            codeValue: "420102"
        },
        {
            codeName: "武汉市江汉区",
            codeValue: "420103"
        },
        {
            codeName: "武汉市硚口区",
            codeValue: "420104"
        },
        {
            codeName: "武汉市汉阳区",
            codeValue: "420105"
        },
        {
            codeName: "武汉市武昌区",
            codeValue: "420106"
        },
        {
            codeName: "武汉市青山区",
            codeValue: "420107"
        },
        {
            codeName: "武汉市洪山区",
            codeValue: "420111"
        },
        {
            codeName: "武汉市东西湖区",
            codeValue: "420112"
        },
        {
            codeName: "武汉市汉南区",
            codeValue: "420113"
        },
        {
            codeName: "武汉市蔡甸区",
            codeValue: "420114"
        },
        {
            codeName: "武汉市江夏区",
            codeValue: "420115"
        },
        {
            codeName: "武汉市黄陂区",
            codeValue: "420116"
        },
        {
            codeName: "武汉市新洲区",
            codeValue: "420117"
        },
        {
            codeName: "湖北省黄石市",
            codeValue: "420200"
        },
        {
            codeName: "黄石市市辖区",
            codeValue: "420201"
        },
        {
            codeName: "黄石市黄石港区",
            codeValue: "420202"
        },
        {
            codeName: "黄石市西塞山区",
            codeValue: "420203"
        },
        {
            codeName: "黄石市下陆区",
            codeValue: "420204"
        },
        {
            codeName: "黄石市铁山区",
            codeValue: "420205"
        },
        {
            codeName: "黄石市阳新县",
            codeValue: "420222"
        },
        {
            codeName: "黄石市大冶市",
            codeValue: "420281"
        },
        {
            codeName: "湖北省十堰市",
            codeValue: "420300"
        },
        {
            codeName: "十堰市市辖区",
            codeValue: "420301"
        },
        {
            codeName: "十堰市茅箭区",
            codeValue: "420302"
        },
        {
            codeName: "十堰市张湾区",
            codeValue: "420303"
        },
        {
            codeName: "十堰市郧阳区",
            codeValue: "420304"
        },
        {
            codeName: "十堰市郧西县",
            codeValue: "420322"
        },
        {
            codeName: "十堰市竹山县",
            codeValue: "420323"
        },
        {
            codeName: "十堰市竹溪县",
            codeValue: "420324"
        },
        {
            codeName: "十堰市房县",
            codeValue: "420325"
        },
        {
            codeName: "十堰市丹江口市",
            codeValue: "420381"
        },
        {
            codeName: "湖北省宜昌市",
            codeValue: "420500"
        },
        {
            codeName: "宜昌市市辖区",
            codeValue: "420501"
        },
        {
            codeName: "宜昌市西陵区",
            codeValue: "420502"
        },
        {
            codeName: "宜昌市伍家岗区",
            codeValue: "420503"
        },
        {
            codeName: "宜昌市点军区",
            codeValue: "420504"
        },
        {
            codeName: "宜昌市猇亭区",
            codeValue: "420505"
        },
        {
            codeName: "宜昌市夷陵区",
            codeValue: "420506"
        },
        {
            codeName: "宜昌市远安县",
            codeValue: "420525"
        },
        {
            codeName: "宜昌市兴山县",
            codeValue: "420526"
        },
        {
            codeName: "宜昌市秭归县",
            codeValue: "420527"
        },
        {
            codeName: "宜昌市长阳土家族自治县",
            codeValue: "420528"
        },
        {
            codeName: "宜昌市五峰土家族自治县",
            codeValue: "420529"
        },
        {
            codeName: "宜昌市宜都市",
            codeValue: "420581"
        },
        {
            codeName: "宜昌市当阳市",
            codeValue: "420582"
        },
        {
            codeName: "宜昌市枝江市",
            codeValue: "420583"
        },
        {
            codeName: "湖北省襄阳市",
            codeValue: "420600"
        },
        {
            codeName: "襄阳市市辖区",
            codeValue: "420601"
        },
        {
            codeName: "襄阳市襄城区",
            codeValue: "420602"
        },
        {
            codeName: "襄阳市樊城区",
            codeValue: "420606"
        },
        {
            codeName: "襄阳市襄州区",
            codeValue: "420607"
        },
        {
            codeName: "襄阳市南漳县",
            codeValue: "420624"
        },
        {
            codeName: "襄阳市谷城县",
            codeValue: "420625"
        },
        {
            codeName: "襄阳市保康县",
            codeValue: "420626"
        },
        {
            codeName: "襄阳市老河口市",
            codeValue: "420682"
        },
        {
            codeName: "襄阳市枣阳市",
            codeValue: "420683"
        },
        {
            codeName: "襄阳市宜城市",
            codeValue: "420684"
        },
        {
            codeName: "湖北省鄂州市",
            codeValue: "420700"
        },
        {
            codeName: "鄂州市市辖区",
            codeValue: "420701"
        },
        {
            codeName: "鄂州市梁子湖区",
            codeValue: "420702"
        },
        {
            codeName: "鄂州市华容区",
            codeValue: "420703"
        },
        {
            codeName: "鄂州市鄂城区",
            codeValue: "420704"
        },
        {
            codeName: "湖北省荆门市",
            codeValue: "420800"
        },
        {
            codeName: "荆门市市辖区",
            codeValue: "420801"
        },
        {
            codeName: "荆门市东宝区",
            codeValue: "420802"
        },
        {
            codeName: "荆门市掇刀区",
            codeValue: "420804"
        },
        {
            codeName: "荆门市京山县",
            codeValue: "420821"
        },
        {
            codeName: "荆门市沙洋县",
            codeValue: "420822"
        },
        {
            codeName: "荆门市钟祥市",
            codeValue: "420881"
        },
        {
            codeName: "湖北省孝感市",
            codeValue: "420900"
        },
        {
            codeName: "孝感市市辖区",
            codeValue: "420901"
        },
        {
            codeName: "孝感市孝南区",
            codeValue: "420902"
        },
        {
            codeName: "孝感市孝昌县",
            codeValue: "420921"
        },
        {
            codeName: "孝感市大悟县",
            codeValue: "420922"
        },
        {
            codeName: "孝感市云梦县",
            codeValue: "420923"
        },
        {
            codeName: "孝感市应城市",
            codeValue: "420981"
        },
        {
            codeName: "孝感市安陆市",
            codeValue: "420982"
        },
        {
            codeName: "孝感市汉川市",
            codeValue: "420984"
        },
        {
            codeName: "湖北省荆州市",
            codeValue: "421000"
        },
        {
            codeName: "荆州市市辖区",
            codeValue: "421001"
        },
        {
            codeName: "荆州市沙市区",
            codeValue: "421002"
        },
        {
            codeName: "荆州市荆州区",
            codeValue: "421003"
        },
        {
            codeName: "荆州市公安县",
            codeValue: "421022"
        },
        {
            codeName: "荆州市监利县",
            codeValue: "421023"
        },
        {
            codeName: "荆州市江陵县",
            codeValue: "421024"
        },
        {
            codeName: "荆州市石首市",
            codeValue: "421081"
        },
        {
            codeName: "荆州市洪湖市",
            codeValue: "421083"
        },
        {
            codeName: "荆州市松滋市",
            codeValue: "421087"
        },
        {
            codeName: "湖北省黄冈市",
            codeValue: "421100"
        },
        {
            codeName: "黄冈市市辖区",
            codeValue: "421101"
        },
        {
            codeName: "黄冈市黄州区",
            codeValue: "421102"
        },
        {
            codeName: "黄冈市团风县",
            codeValue: "421121"
        },
        {
            codeName: "黄冈市红安县",
            codeValue: "421122"
        },
        {
            codeName: "黄冈市罗田县",
            codeValue: "421123"
        },
        {
            codeName: "黄冈市英山县",
            codeValue: "421124"
        },
        {
            codeName: "黄冈市浠水县",
            codeValue: "421125"
        },
        {
            codeName: "黄冈市蕲春县",
            codeValue: "421126"
        },
        {
            codeName: "黄冈市黄梅县",
            codeValue: "421127"
        },
        {
            codeName: "黄冈市麻城市",
            codeValue: "421181"
        },
        {
            codeName: "黄冈市武穴市",
            codeValue: "421182"
        },
        {
            codeName: "湖北省咸宁市",
            codeValue: "421200"
        },
        {
            codeName: "咸宁市市辖区",
            codeValue: "421201"
        },
        {
            codeName: "咸宁市咸安区",
            codeValue: "421202"
        },
        {
            codeName: "咸宁市嘉鱼县",
            codeValue: "421221"
        },
        {
            codeName: "咸宁市通城县",
            codeValue: "421222"
        },
        {
            codeName: "咸宁市崇阳县",
            codeValue: "421223"
        },
        {
            codeName: "咸宁市通山县",
            codeValue: "421224"
        },
        {
            codeName: "咸宁市赤壁市",
            codeValue: "421281"
        },
        {
            codeName: "湖北省随州市",
            codeValue: "421300"
        },
        {
            codeName: "随州市市辖区",
            codeValue: "421301"
        },
        {
            codeName: "随州市曾都区",
            codeValue: "421303"
        },
        {
            codeName: "随州市随县",
            codeValue: "421321"
        },
        {
            codeName: "随州市广水市",
            codeValue: "421381"
        },
        {
            codeName: "湖北省恩施土家族苗族自治州",
            codeValue: "422800"
        },
        {
            codeName: "恩施土家族苗族自治州恩施市",
            codeValue: "422801"
        },
        {
            codeName: "恩施土家族苗族自治州利川市",
            codeValue: "422802"
        },
        {
            codeName: "恩施土家族苗族自治州建始县",
            codeValue: "422822"
        },
        {
            codeName: "恩施土家族苗族自治州巴东县",
            codeValue: "422823"
        },
        {
            codeName: "恩施土家族苗族自治州宣恩县",
            codeValue: "422825"
        },
        {
            codeName: "恩施土家族苗族自治州咸丰县",
            codeValue: "422826"
        },
        {
            codeName: "恩施土家族苗族自治州来凤县",
            codeValue: "422827"
        },
        {
            codeName: "恩施土家族苗族自治州鹤峰县",
            codeValue: "422828"
        },
        {
            codeName: "湖北省省直辖县级行政区划",
            codeValue: "429000"
        },
        {
            codeName: "湖北省省直辖县级行政区划仙桃市",
            codeValue: "429004"
        },
        {
            codeName: "湖北省省直辖县级行政区划潜江市",
            codeValue: "429005"
        },
        {
            codeName: "湖北省省直辖县级行政区划天门市",
            codeValue: "429006"
        },
        {
            codeName: "湖北省省直辖县级行政区划神农架林区",
            codeValue: "429021"
        },
        {
            codeName: "湖南省",
            codeValue: "430000"
        },
        {
            codeName: "湖南省长沙市",
            codeValue: "430100"
        },
        {
            codeName: "长沙市市辖区",
            codeValue: "430101"
        },
        {
            codeName: "长沙市芙蓉区",
            codeValue: "430102"
        },
        {
            codeName: "长沙市天心区",
            codeValue: "430103"
        },
        {
            codeName: "长沙市岳麓区",
            codeValue: "430104"
        },
        {
            codeName: "长沙市开福区",
            codeValue: "430105"
        },
        {
            codeName: "长沙市雨花区",
            codeValue: "430111"
        },
        {
            codeName: "长沙市望城区",
            codeValue: "430112"
        },
        {
            codeName: "长沙市长沙县",
            codeValue: "430121"
        },
        {
            codeName: "长沙市宁乡县",
            codeValue: "430124"
        },
        {
            codeName: "长沙市浏阳市",
            codeValue: "430181"
        },
        {
            codeName: "湖南省株洲市",
            codeValue: "430200"
        },
        {
            codeName: "株洲市市辖区",
            codeValue: "430201"
        },
        {
            codeName: "株洲市荷塘区",
            codeValue: "430202"
        },
        {
            codeName: "株洲市芦淞区",
            codeValue: "430203"
        },
        {
            codeName: "株洲市石峰区",
            codeValue: "430204"
        },
        {
            codeName: "株洲市天元区",
            codeValue: "430211"
        },
        {
            codeName: "株洲市株洲县",
            codeValue: "430221"
        },
        {
            codeName: "株洲市攸县",
            codeValue: "430223"
        },
        {
            codeName: "株洲市茶陵县",
            codeValue: "430224"
        },
        {
            codeName: "株洲市炎陵县",
            codeValue: "430225"
        },
        {
            codeName: "株洲市醴陵市",
            codeValue: "430281"
        },
        {
            codeName: "湖南省湘潭市",
            codeValue: "430300"
        },
        {
            codeName: "湘潭市市辖区",
            codeValue: "430301"
        },
        {
            codeName: "湘潭市雨湖区",
            codeValue: "430302"
        },
        {
            codeName: "湘潭市岳塘区",
            codeValue: "430304"
        },
        {
            codeName: "湘潭市湘潭县",
            codeValue: "430321"
        },
        {
            codeName: "湘潭市湘乡市",
            codeValue: "430381"
        },
        {
            codeName: "湘潭市韶山市",
            codeValue: "430382"
        },
        {
            codeName: "湖南省衡阳市",
            codeValue: "430400"
        },
        {
            codeName: "衡阳市市辖区",
            codeValue: "430401"
        },
        {
            codeName: "衡阳市珠晖区",
            codeValue: "430405"
        },
        {
            codeName: "衡阳市雁峰区",
            codeValue: "430406"
        },
        {
            codeName: "衡阳市石鼓区",
            codeValue: "430407"
        },
        {
            codeName: "衡阳市蒸湘区",
            codeValue: "430408"
        },
        {
            codeName: "衡阳市南岳区",
            codeValue: "430412"
        },
        {
            codeName: "衡阳市衡阳县",
            codeValue: "430421"
        },
        {
            codeName: "衡阳市衡南县",
            codeValue: "430422"
        },
        {
            codeName: "衡阳市衡山县",
            codeValue: "430423"
        },
        {
            codeName: "衡阳市衡东县",
            codeValue: "430424"
        },
        {
            codeName: "衡阳市祁东县",
            codeValue: "430426"
        },
        {
            codeName: "衡阳市耒阳市",
            codeValue: "430481"
        },
        {
            codeName: "衡阳市常宁市",
            codeValue: "430482"
        },
        {
            codeName: "湖南省邵阳市",
            codeValue: "430500"
        },
        {
            codeName: "邵阳市市辖区",
            codeValue: "430501"
        },
        {
            codeName: "邵阳市双清区",
            codeValue: "430502"
        },
        {
            codeName: "邵阳市大祥区",
            codeValue: "430503"
        },
        {
            codeName: "邵阳市北塔区",
            codeValue: "430511"
        },
        {
            codeName: "邵阳市邵东县",
            codeValue: "430521"
        },
        {
            codeName: "邵阳市新邵县",
            codeValue: "430522"
        },
        {
            codeName: "邵阳市邵阳县",
            codeValue: "430523"
        },
        {
            codeName: "邵阳市隆回县",
            codeValue: "430524"
        },
        {
            codeName: "邵阳市洞口县",
            codeValue: "430525"
        },
        {
            codeName: "邵阳市绥宁县",
            codeValue: "430527"
        },
        {
            codeName: "邵阳市新宁县",
            codeValue: "430528"
        },
        {
            codeName: "邵阳市城步苗族自治县",
            codeValue: "430529"
        },
        {
            codeName: "邵阳市武冈市",
            codeValue: "430581"
        },
        {
            codeName: "湖南省岳阳市",
            codeValue: "430600"
        },
        {
            codeName: "岳阳市市辖区",
            codeValue: "430601"
        },
        {
            codeName: "岳阳市岳阳楼区",
            codeValue: "430602"
        },
        {
            codeName: "岳阳市云溪区",
            codeValue: "430603"
        },
        {
            codeName: "岳阳市君山区",
            codeValue: "430611"
        },
        {
            codeName: "岳阳市岳阳县",
            codeValue: "430621"
        },
        {
            codeName: "岳阳市华容县",
            codeValue: "430623"
        },
        {
            codeName: "岳阳市湘阴县",
            codeValue: "430624"
        },
        {
            codeName: "岳阳市平江县",
            codeValue: "430626"
        },
        {
            codeName: "岳阳市汨罗市",
            codeValue: "430681"
        },
        {
            codeName: "岳阳市临湘市",
            codeValue: "430682"
        },
        {
            codeName: "湖南省常德市",
            codeValue: "430700"
        },
        {
            codeName: "常德市市辖区",
            codeValue: "430701"
        },
        {
            codeName: "常德市武陵区",
            codeValue: "430702"
        },
        {
            codeName: "常德市鼎城区",
            codeValue: "430703"
        },
        {
            codeName: "常德市安乡县",
            codeValue: "430721"
        },
        {
            codeName: "常德市汉寿县",
            codeValue: "430722"
        },
        {
            codeName: "常德市澧县",
            codeValue: "430723"
        },
        {
            codeName: "常德市临澧县",
            codeValue: "430724"
        },
        {
            codeName: "常德市桃源县",
            codeValue: "430725"
        },
        {
            codeName: "常德市石门县",
            codeValue: "430726"
        },
        {
            codeName: "常德市津市市",
            codeValue: "430781"
        },
        {
            codeName: "湖南省张家界市",
            codeValue: "430800"
        },
        {
            codeName: "张家界市市辖区",
            codeValue: "430801"
        },
        {
            codeName: "张家界市永定区",
            codeValue: "430802"
        },
        {
            codeName: "张家界市武陵源区",
            codeValue: "430811"
        },
        {
            codeName: "张家界市慈利县",
            codeValue: "430821"
        },
        {
            codeName: "张家界市桑植县",
            codeValue: "430822"
        },
        {
            codeName: "湖南省益阳市",
            codeValue: "430900"
        },
        {
            codeName: "益阳市市辖区",
            codeValue: "430901"
        },
        {
            codeName: "益阳市资阳区",
            codeValue: "430902"
        },
        {
            codeName: "益阳市赫山区",
            codeValue: "430903"
        },
        {
            codeName: "益阳市南县",
            codeValue: "430921"
        },
        {
            codeName: "益阳市桃江县",
            codeValue: "430922"
        },
        {
            codeName: "益阳市安化县",
            codeValue: "430923"
        },
        {
            codeName: "益阳市沅江市",
            codeValue: "430981"
        },
        {
            codeName: "湖南省郴州市",
            codeValue: "431000"
        },
        {
            codeName: "郴州市市辖区",
            codeValue: "431001"
        },
        {
            codeName: "郴州市北湖区",
            codeValue: "431002"
        },
        {
            codeName: "郴州市苏仙区",
            codeValue: "431003"
        },
        {
            codeName: "郴州市桂阳县",
            codeValue: "431021"
        },
        {
            codeName: "郴州市宜章县",
            codeValue: "431022"
        },
        {
            codeName: "郴州市永兴县",
            codeValue: "431023"
        },
        {
            codeName: "郴州市嘉禾县",
            codeValue: "431024"
        },
        {
            codeName: "郴州市临武县",
            codeValue: "431025"
        },
        {
            codeName: "郴州市汝城县",
            codeValue: "431026"
        },
        {
            codeName: "郴州市桂东县",
            codeValue: "431027"
        },
        {
            codeName: "郴州市安仁县",
            codeValue: "431028"
        },
        {
            codeName: "郴州市资兴市",
            codeValue: "431081"
        },
        {
            codeName: "湖南省永州市",
            codeValue: "431100"
        },
        {
            codeName: "永州市市辖区",
            codeValue: "431101"
        },
        {
            codeName: "永州市零陵区",
            codeValue: "431102"
        },
        {
            codeName: "永州市冷水滩区",
            codeValue: "431103"
        },
        {
            codeName: "永州市祁阳县",
            codeValue: "431121"
        },
        {
            codeName: "永州市东安县",
            codeValue: "431122"
        },
        {
            codeName: "永州市双牌县",
            codeValue: "431123"
        },
        {
            codeName: "永州市道县",
            codeValue: "431124"
        },
        {
            codeName: "永州市江永县",
            codeValue: "431125"
        },
        {
            codeName: "永州市宁远县",
            codeValue: "431126"
        },
        {
            codeName: "永州市蓝山县",
            codeValue: "431127"
        },
        {
            codeName: "永州市新田县",
            codeValue: "431128"
        },
        {
            codeName: "永州市江华瑶族自治县",
            codeValue: "431129"
        },
        {
            codeName: "湖南省怀化市",
            codeValue: "431200"
        },
        {
            codeName: "怀化市市辖区",
            codeValue: "431201"
        },
        {
            codeName: "怀化市鹤城区",
            codeValue: "431202"
        },
        {
            codeName: "怀化市中方县",
            codeValue: "431221"
        },
        {
            codeName: "怀化市沅陵县",
            codeValue: "431222"
        },
        {
            codeName: "怀化市辰溪县",
            codeValue: "431223"
        },
        {
            codeName: "怀化市溆浦县",
            codeValue: "431224"
        },
        {
            codeName: "怀化市会同县",
            codeValue: "431225"
        },
        {
            codeName: "怀化市麻阳苗族自治县",
            codeValue: "431226"
        },
        {
            codeName: "怀化市新晃侗族自治县",
            codeValue: "431227"
        },
        {
            codeName: "怀化市芷江侗族自治县",
            codeValue: "431228"
        },
        {
            codeName: "怀化市靖州苗族侗族自治县",
            codeValue: "431229"
        },
        {
            codeName: "怀化市通道侗族自治县",
            codeValue: "431230"
        },
        {
            codeName: "怀化市洪江市",
            codeValue: "431281"
        },
        {
            codeName: "湖南省娄底市",
            codeValue: "431300"
        },
        {
            codeName: "娄底市市辖区",
            codeValue: "431301"
        },
        {
            codeName: "娄底市娄星区",
            codeValue: "431302"
        },
        {
            codeName: "娄底市双峰县",
            codeValue: "431321"
        },
        {
            codeName: "娄底市新化县",
            codeValue: "431322"
        },
        {
            codeName: "娄底市冷水江市",
            codeValue: "431381"
        },
        {
            codeName: "娄底市涟源市",
            codeValue: "431382"
        },
        {
            codeName: "湖南省湘西土家族苗族自治州",
            codeValue: "433100"
        },
        {
            codeName: "湘西土家族苗族自治州吉首市",
            codeValue: "433101"
        },
        {
            codeName: "湘西土家族苗族自治州泸溪县",
            codeValue: "433122"
        },
        {
            codeName: "湘西土家族苗族自治州凤凰县",
            codeValue: "433123"
        },
        {
            codeName: "湘西土家族苗族自治州花垣县",
            codeValue: "433124"
        },
        {
            codeName: "湘西土家族苗族自治州保靖县",
            codeValue: "433125"
        },
        {
            codeName: "湘西土家族苗族自治州古丈县",
            codeValue: "433126"
        },
        {
            codeName: "湘西土家族苗族自治州永顺县",
            codeValue: "433127"
        },
        {
            codeName: "湘西土家族苗族自治州龙山县",
            codeValue: "433130"
        },
        {
            codeName: "广东省",
            codeValue: "440000"
        },
        {
            codeName: "广东省广州市",
            codeValue: "440100"
        },
        {
            codeName: "广州市市辖区",
            codeValue: "440101"
        },
        {
            codeName: "广州市荔湾区",
            codeValue: "440103"
        },
        {
            codeName: "广州市越秀区",
            codeValue: "440104"
        },
        {
            codeName: "广州市海珠区",
            codeValue: "440105"
        },
        {
            codeName: "广州市天河区",
            codeValue: "440106"
        },
        {
            codeName: "广州市白云区",
            codeValue: "440111"
        },
        {
            codeName: "广州市黄埔区",
            codeValue: "440112"
        },
        {
            codeName: "广州市番禺区",
            codeValue: "440113"
        },
        {
            codeName: "广州市花都区",
            codeValue: "440114"
        },
        {
            codeName: "广州市南沙区",
            codeValue: "440115"
        },
        {
            codeName: "广州市从化区",
            codeValue: "440117"
        },
        {
            codeName: "广州市增城区",
            codeValue: "440118"
        },
        {
            codeName: "广东省韶关市",
            codeValue: "440200"
        },
        {
            codeName: "韶关市市辖区",
            codeValue: "440201"
        },
        {
            codeName: "韶关市武江区",
            codeValue: "440203"
        },
        {
            codeName: "韶关市浈江区",
            codeValue: "440204"
        },
        {
            codeName: "韶关市曲江区",
            codeValue: "440205"
        },
        {
            codeName: "韶关市始兴县",
            codeValue: "440222"
        },
        {
            codeName: "韶关市仁化县",
            codeValue: "440224"
        },
        {
            codeName: "韶关市翁源县",
            codeValue: "440229"
        },
        {
            codeName: "韶关市乳源瑶族自治县",
            codeValue: "440232"
        },
        {
            codeName: "韶关市新丰县",
            codeValue: "440233"
        },
        {
            codeName: "韶关市乐昌市",
            codeValue: "440281"
        },
        {
            codeName: "韶关市南雄市",
            codeValue: "440282"
        },
        {
            codeName: "广东省深圳市",
            codeValue: "440300"
        },
        {
            codeName: "深圳市市辖区",
            codeValue: "440301"
        },
        {
            codeName: "深圳市罗湖区",
            codeValue: "440303"
        },
        {
            codeName: "深圳市福田区",
            codeValue: "440304"
        },
        {
            codeName: "深圳市南山区",
            codeValue: "440305"
        },
        {
            codeName: "深圳市宝安区",
            codeValue: "440306"
        },
        {
            codeName: "深圳市龙岗区",
            codeValue: "440307"
        },
        {
            codeName: "深圳市盐田区",
            codeValue: "440308"
        },
        {
            codeName: "深圳市龙华区",
            codeValue: "440309"
        },
        {
            codeName: "深圳市坪山区",
            codeValue: "440310"
        },
        {
            codeName: "广东省珠海市",
            codeValue: "440400"
        },
        {
            codeName: "珠海市市辖区",
            codeValue: "440401"
        },
        {
            codeName: "珠海市香洲区",
            codeValue: "440402"
        },
        {
            codeName: "珠海市斗门区",
            codeValue: "440403"
        },
        {
            codeName: "珠海市金湾区",
            codeValue: "440404"
        },
        {
            codeName: "广东省汕头市",
            codeValue: "440500"
        },
        {
            codeName: "汕头市市辖区",
            codeValue: "440501"
        },
        {
            codeName: "汕头市龙湖区",
            codeValue: "440507"
        },
        {
            codeName: "汕头市金平区",
            codeValue: "440511"
        },
        {
            codeName: "汕头市濠江区",
            codeValue: "440512"
        },
        {
            codeName: "汕头市潮阳区",
            codeValue: "440513"
        },
        {
            codeName: "汕头市潮南区",
            codeValue: "440514"
        },
        {
            codeName: "汕头市澄海区",
            codeValue: "440515"
        },
        {
            codeName: "汕头市南澳县",
            codeValue: "440523"
        },
        {
            codeName: "广东省佛山市",
            codeValue: "440600"
        },
        {
            codeName: "佛山市市辖区",
            codeValue: "440601"
        },
        {
            codeName: "佛山市禅城区",
            codeValue: "440604"
        },
        {
            codeName: "佛山市南海区",
            codeValue: "440605"
        },
        {
            codeName: "佛山市顺德区",
            codeValue: "440606"
        },
        {
            codeName: "佛山市三水区",
            codeValue: "440607"
        },
        {
            codeName: "佛山市高明区　　　　　　　　",
            codeValue: "440608"
        },
        {
            codeName: "广东省江门市",
            codeValue: "440700"
        },
        {
            codeName: "江门市市辖区",
            codeValue: "440701"
        },
        {
            codeName: "江门市蓬江区",
            codeValue: "440703"
        },
        {
            codeName: "江门市江海区",
            codeValue: "440704"
        },
        {
            codeName: "江门市新会区",
            codeValue: "440705"
        },
        {
            codeName: "江门市台山市",
            codeValue: "440781"
        },
        {
            codeName: "江门市开平市",
            codeValue: "440783"
        },
        {
            codeName: "江门市鹤山市",
            codeValue: "440784"
        },
        {
            codeName: "江门市恩平市",
            codeValue: "440785"
        },
        {
            codeName: "广东省湛江市",
            codeValue: "440800"
        },
        {
            codeName: "湛江市市辖区",
            codeValue: "440801"
        },
        {
            codeName: "湛江市赤坎区",
            codeValue: "440802"
        },
        {
            codeName: "湛江市霞山区",
            codeValue: "440803"
        },
        {
            codeName: "湛江市坡头区",
            codeValue: "440804"
        },
        {
            codeName: "湛江市麻章区",
            codeValue: "440811"
        },
        {
            codeName: "湛江市遂溪县",
            codeValue: "440823"
        },
        {
            codeName: "湛江市徐闻县",
            codeValue: "440825"
        },
        {
            codeName: "湛江市廉江市",
            codeValue: "440881"
        },
        {
            codeName: "湛江市雷州市",
            codeValue: "440882"
        },
        {
            codeName: "湛江市吴川市",
            codeValue: "440883"
        },
        {
            codeName: "广东省茂名市",
            codeValue: "440900"
        },
        {
            codeName: "茂名市市辖区",
            codeValue: "440901"
        },
        {
            codeName: "茂名市茂南区",
            codeValue: "440902"
        },
        {
            codeName: "茂名市电白区",
            codeValue: "440904"
        },
        {
            codeName: "茂名市高州市",
            codeValue: "440981"
        },
        {
            codeName: "茂名市化州市",
            codeValue: "440982"
        },
        {
            codeName: "茂名市信宜市",
            codeValue: "440983"
        },
        {
            codeName: "广东省肇庆市",
            codeValue: "441200"
        },
        {
            codeName: "肇庆市市辖区",
            codeValue: "441201"
        },
        {
            codeName: "肇庆市端州区",
            codeValue: "441202"
        },
        {
            codeName: "肇庆市鼎湖区",
            codeValue: "441203"
        },
        {
            codeName: "肇庆市高要区",
            codeValue: "441204"
        },
        {
            codeName: "肇庆市广宁县",
            codeValue: "441223"
        },
        {
            codeName: "肇庆市怀集县",
            codeValue: "441224"
        },
        {
            codeName: "肇庆市封开县",
            codeValue: "441225"
        },
        {
            codeName: "肇庆市德庆县",
            codeValue: "441226"
        },
        {
            codeName: "肇庆市四会市",
            codeValue: "441284"
        },
        {
            codeName: "广东省惠州市",
            codeValue: "441300"
        },
        {
            codeName: "惠州市市辖区",
            codeValue: "441301"
        },
        {
            codeName: "惠州市惠城区",
            codeValue: "441302"
        },
        {
            codeName: "惠州市惠阳区",
            codeValue: "441303"
        },
        {
            codeName: "惠州市博罗县",
            codeValue: "441322"
        },
        {
            codeName: "惠州市惠东县",
            codeValue: "441323"
        },
        {
            codeName: "惠州市龙门县",
            codeValue: "441324"
        },
        {
            codeName: "广东省梅州市",
            codeValue: "441400"
        },
        {
            codeName: "梅州市市辖区",
            codeValue: "441401"
        },
        {
            codeName: "梅州市梅江区",
            codeValue: "441402"
        },
        {
            codeName: "梅州市梅县区",
            codeValue: "441403"
        },
        {
            codeName: "梅州市大埔县",
            codeValue: "441422"
        },
        {
            codeName: "梅州市丰顺县",
            codeValue: "441423"
        },
        {
            codeName: "梅州市五华县",
            codeValue: "441424"
        },
        {
            codeName: "梅州市平远县",
            codeValue: "441426"
        },
        {
            codeName: "梅州市蕉岭县",
            codeValue: "441427"
        },
        {
            codeName: "梅州市兴宁市",
            codeValue: "441481"
        },
        {
            codeName: "广东省汕尾市",
            codeValue: "441500"
        },
        {
            codeName: "汕尾市市辖区",
            codeValue: "441501"
        },
        {
            codeName: "汕尾市城区",
            codeValue: "441502"
        },
        {
            codeName: "汕尾市海丰县",
            codeValue: "441521"
        },
        {
            codeName: "汕尾市陆河县",
            codeValue: "441523"
        },
        {
            codeName: "汕尾市陆丰市",
            codeValue: "441581"
        },
        {
            codeName: "广东省河源市",
            codeValue: "441600"
        },
        {
            codeName: "河源市市辖区",
            codeValue: "441601"
        },
        {
            codeName: "河源市源城区",
            codeValue: "441602"
        },
        {
            codeName: "河源市紫金县",
            codeValue: "441621"
        },
        {
            codeName: "河源市龙川县",
            codeValue: "441622"
        },
        {
            codeName: "河源市连平县",
            codeValue: "441623"
        },
        {
            codeName: "河源市和平县",
            codeValue: "441624"
        },
        {
            codeName: "河源市东源县",
            codeValue: "441625"
        },
        {
            codeName: "广东省阳江市",
            codeValue: "441700"
        },
        {
            codeName: "阳江市市辖区",
            codeValue: "441701"
        },
        {
            codeName: "阳江市江城区",
            codeValue: "441702"
        },
        {
            codeName: "阳江市阳东区",
            codeValue: "441704"
        },
        {
            codeName: "阳江市阳西县",
            codeValue: "441721"
        },
        {
            codeName: "阳江市阳春市",
            codeValue: "441781"
        },
        {
            codeName: "广东省清远市",
            codeValue: "441800"
        },
        {
            codeName: "清远市市辖区",
            codeValue: "441801"
        },
        {
            codeName: "清远市清城区",
            codeValue: "441802"
        },
        {
            codeName: "清远市清新区",
            codeValue: "441803"
        },
        {
            codeName: "清远市佛冈县",
            codeValue: "441821"
        },
        {
            codeName: "清远市阳山县",
            codeValue: "441823"
        },
        {
            codeName: "清远市连山壮族瑶族自治县",
            codeValue: "441825"
        },
        {
            codeName: "清远市连南瑶族自治县",
            codeValue: "441826"
        },
        {
            codeName: "清远市英德市",
            codeValue: "441881"
        },
        {
            codeName: "清远市连州市",
            codeValue: "441882"
        },
        {
            codeName: "广东省东莞市",
            codeValue: "441900"
        },
        {
            codeName: "广东省中山市",
            codeValue: "442000"
        },
        {
            codeName: "广东省潮州市",
            codeValue: "445100"
        },
        {
            codeName: "潮州市市辖区",
            codeValue: "445101"
        },
        {
            codeName: "潮州市湘桥区",
            codeValue: "445102"
        },
        {
            codeName: "潮州市潮安区",
            codeValue: "445103"
        },
        {
            codeName: "潮州市饶平县",
            codeValue: "445122"
        },
        {
            codeName: "广东省揭阳市",
            codeValue: "445200"
        },
        {
            codeName: "揭阳市市辖区",
            codeValue: "445201"
        },
        {
            codeName: "揭阳市榕城区",
            codeValue: "445202"
        },
        {
            codeName: "揭阳市揭东区",
            codeValue: "445203"
        },
        {
            codeName: "揭阳市揭西县",
            codeValue: "445222"
        },
        {
            codeName: "揭阳市惠来县",
            codeValue: "445224"
        },
        {
            codeName: "揭阳市普宁市",
            codeValue: "445281"
        },
        {
            codeName: "广东省云浮市",
            codeValue: "445300"
        },
        {
            codeName: "云浮市市辖区",
            codeValue: "445301"
        },
        {
            codeName: "云浮市云城区",
            codeValue: "445302"
        },
        {
            codeName: "云浮市云安区",
            codeValue: "445303"
        },
        {
            codeName: "云浮市新兴县",
            codeValue: "445321"
        },
        {
            codeName: "云浮市郁南县",
            codeValue: "445322"
        },
        {
            codeName: "云浮市罗定市",
            codeValue: "445381"
        },
        {
            codeName: "广西壮族自治区",
            codeValue: "450000"
        },
        {
            codeName: "广西壮族自治区南宁市",
            codeValue: "450100"
        },
        {
            codeName: "南宁市市辖区",
            codeValue: "450101"
        },
        {
            codeName: "南宁市兴宁区",
            codeValue: "450102"
        },
        {
            codeName: "南宁市青秀区",
            codeValue: "450103"
        },
        {
            codeName: "南宁市江南区",
            codeValue: "450105"
        },
        {
            codeName: "南宁市西乡塘区",
            codeValue: "450107"
        },
        {
            codeName: "南宁市良庆区",
            codeValue: "450108"
        },
        {
            codeName: "南宁市邕宁区",
            codeValue: "450109"
        },
        {
            codeName: "南宁市武鸣区",
            codeValue: "450110"
        },
        {
            codeName: "南宁市隆安县",
            codeValue: "450123"
        },
        {
            codeName: "南宁市马山县",
            codeValue: "450124"
        },
        {
            codeName: "南宁市上林县",
            codeValue: "450125"
        },
        {
            codeName: "南宁市宾阳县",
            codeValue: "450126"
        },
        {
            codeName: "南宁市横县",
            codeValue: "450127"
        },
        {
            codeName: "广西壮族自治区柳州市",
            codeValue: "450200"
        },
        {
            codeName: "柳州市市辖区",
            codeValue: "450201"
        },
        {
            codeName: "柳州市城中区",
            codeValue: "450202"
        },
        {
            codeName: "柳州市鱼峰区",
            codeValue: "450203"
        },
        {
            codeName: "柳州市柳南区",
            codeValue: "450204"
        },
        {
            codeName: "柳州市柳北区",
            codeValue: "450205"
        },
        {
            codeName: "柳州市柳江区",
            codeValue: "450206"
        },
        {
            codeName: "柳州市柳城县",
            codeValue: "450222"
        },
        {
            codeName: "柳州市鹿寨县",
            codeValue: "450223"
        },
        {
            codeName: "柳州市融安县",
            codeValue: "450224"
        },
        {
            codeName: "柳州市融水苗族自治县",
            codeValue: "450225"
        },
        {
            codeName: "柳州市三江侗族自治县",
            codeValue: "450226"
        },
        {
            codeName: "广西壮族自治区桂林市",
            codeValue: "450300"
        },
        {
            codeName: "桂林市市辖区",
            codeValue: "450301"
        },
        {
            codeName: "桂林市秀峰区",
            codeValue: "450302"
        },
        {
            codeName: "桂林市叠彩区",
            codeValue: "450303"
        },
        {
            codeName: "桂林市象山区",
            codeValue: "450304"
        },
        {
            codeName: "桂林市七星区",
            codeValue: "450305"
        },
        {
            codeName: "桂林市雁山区",
            codeValue: "450311"
        },
        {
            codeName: "桂林市临桂区",
            codeValue: "450312"
        },
        {
            codeName: "桂林市阳朔县",
            codeValue: "450321"
        },
        {
            codeName: "桂林市灵川县",
            codeValue: "450323"
        },
        {
            codeName: "桂林市全州县",
            codeValue: "450324"
        },
        {
            codeName: "桂林市兴安县",
            codeValue: "450325"
        },
        {
            codeName: "桂林市永福县",
            codeValue: "450326"
        },
        {
            codeName: "桂林市灌阳县",
            codeValue: "450327"
        },
        {
            codeName: "桂林市龙胜各族自治县",
            codeValue: "450328"
        },
        {
            codeName: "桂林市资源县",
            codeValue: "450329"
        },
        {
            codeName: "桂林市平乐县",
            codeValue: "450330"
        },
        {
            codeName: "桂林市荔浦县",
            codeValue: "450331"
        },
        {
            codeName: "桂林市恭城瑶族自治县",
            codeValue: "450332"
        },
        {
            codeName: "广西壮族自治区梧州市",
            codeValue: "450400"
        },
        {
            codeName: "梧州市市辖区",
            codeValue: "450401"
        },
        {
            codeName: "梧州市万秀区",
            codeValue: "450403"
        },
        {
            codeName: "梧州市长洲区",
            codeValue: "450405"
        },
        {
            codeName: "梧州市龙圩区",
            codeValue: "450406"
        },
        {
            codeName: "梧州市苍梧县",
            codeValue: "450421"
        },
        {
            codeName: "梧州市藤县",
            codeValue: "450422"
        },
        {
            codeName: "梧州市蒙山县",
            codeValue: "450423"
        },
        {
            codeName: "梧州市岑溪市",
            codeValue: "450481"
        },
        {
            codeName: "广西壮族自治区北海市",
            codeValue: "450500"
        },
        {
            codeName: "北海市市辖区",
            codeValue: "450501"
        },
        {
            codeName: "北海市海城区",
            codeValue: "450502"
        },
        {
            codeName: "北海市银海区",
            codeValue: "450503"
        },
        {
            codeName: "北海市铁山港区",
            codeValue: "450512"
        },
        {
            codeName: "北海市合浦县",
            codeValue: "450521"
        },
        {
            codeName: "广西壮族自治区防城港市",
            codeValue: "450600"
        },
        {
            codeName: "防城港市市辖区",
            codeValue: "450601"
        },
        {
            codeName: "防城港市港口区",
            codeValue: "450602"
        },
        {
            codeName: "防城港市防城区",
            codeValue: "450603"
        },
        {
            codeName: "防城港市上思县",
            codeValue: "450621"
        },
        {
            codeName: "防城港市东兴市",
            codeValue: "450681"
        },
        {
            codeName: "广西壮族自治区钦州市",
            codeValue: "450700"
        },
        {
            codeName: "钦州市市辖区",
            codeValue: "450701"
        },
        {
            codeName: "钦州市钦南区",
            codeValue: "450702"
        },
        {
            codeName: "钦州市钦北区",
            codeValue: "450703"
        },
        {
            codeName: "钦州市灵山县",
            codeValue: "450721"
        },
        {
            codeName: "钦州市浦北县",
            codeValue: "450722"
        },
        {
            codeName: "广西壮族自治区贵港市",
            codeValue: "450800"
        },
        {
            codeName: "贵港市市辖区",
            codeValue: "450801"
        },
        {
            codeName: "贵港市港北区",
            codeValue: "450802"
        },
        {
            codeName: "贵港市港南区",
            codeValue: "450803"
        },
        {
            codeName: "贵港市覃塘区",
            codeValue: "450804"
        },
        {
            codeName: "贵港市平南县",
            codeValue: "450821"
        },
        {
            codeName: "贵港市桂平市",
            codeValue: "450881"
        },
        {
            codeName: "广西壮族自治区玉林市",
            codeValue: "450900"
        },
        {
            codeName: "玉林市市辖区",
            codeValue: "450901"
        },
        {
            codeName: "玉林市玉州区",
            codeValue: "450902"
        },
        {
            codeName: "玉林市福绵区",
            codeValue: "450903"
        },
        {
            codeName: "玉林市容县",
            codeValue: "450921"
        },
        {
            codeName: "玉林市陆川县",
            codeValue: "450922"
        },
        {
            codeName: "玉林市博白县",
            codeValue: "450923"
        },
        {
            codeName: "玉林市兴业县",
            codeValue: "450924"
        },
        {
            codeName: "玉林市北流市",
            codeValue: "450981"
        },
        {
            codeName: "广西壮族自治区百色市",
            codeValue: "451000"
        },
        {
            codeName: "百色市市辖区",
            codeValue: "451001"
        },
        {
            codeName: "百色市右江区",
            codeValue: "451002"
        },
        {
            codeName: "百色市田阳县",
            codeValue: "451021"
        },
        {
            codeName: "百色市田东县",
            codeValue: "451022"
        },
        {
            codeName: "百色市平果县",
            codeValue: "451023"
        },
        {
            codeName: "百色市德保县",
            codeValue: "451024"
        },
        {
            codeName: "百色市那坡县",
            codeValue: "451026"
        },
        {
            codeName: "百色市凌云县",
            codeValue: "451027"
        },
        {
            codeName: "百色市乐业县",
            codeValue: "451028"
        },
        {
            codeName: "百色市田林县",
            codeValue: "451029"
        },
        {
            codeName: "百色市西林县",
            codeValue: "451030"
        },
        {
            codeName: "百色市隆林各族自治县",
            codeValue: "451031"
        },
        {
            codeName: "百色市靖西市",
            codeValue: "451081"
        },
        {
            codeName: "广西壮族自治区贺州市",
            codeValue: "451100"
        },
        {
            codeName: "贺州市市辖区",
            codeValue: "451101"
        },
        {
            codeName: "贺州市八步区",
            codeValue: "451102"
        },
        {
            codeName: "贺州市平桂区",
            codeValue: "451103"
        },
        {
            codeName: "贺州市昭平县",
            codeValue: "451121"
        },
        {
            codeName: "贺州市钟山县",
            codeValue: "451122"
        },
        {
            codeName: "贺州市富川瑶族自治县",
            codeValue: "451123"
        },
        {
            codeName: "广西壮族自治区河池市",
            codeValue: "451200"
        },
        {
            codeName: "河池市市辖区",
            codeValue: "451201"
        },
        {
            codeName: "河池市金城江区",
            codeValue: "451202"
        },
        {
            codeName: "河池市宜州区",
            codeValue: "451203"
        },
        {
            codeName: "河池市南丹县",
            codeValue: "451221"
        },
        {
            codeName: "河池市天峨县",
            codeValue: "451222"
        },
        {
            codeName: "河池市凤山县",
            codeValue: "451223"
        },
        {
            codeName: "河池市东兰县",
            codeValue: "451224"
        },
        {
            codeName: "河池市罗城仫佬族自治县",
            codeValue: "451225"
        },
        {
            codeName: "河池市环江毛南族自治县",
            codeValue: "451226"
        },
        {
            codeName: "河池市巴马瑶族自治县",
            codeValue: "451227"
        },
        {
            codeName: "河池市都安瑶族自治县",
            codeValue: "451228"
        },
        {
            codeName: "河池市大化瑶族自治县",
            codeValue: "451229"
        },
        {
            codeName: "河池市宜州市",
            codeValue: "451281"
        },
        {
            codeName: "广西壮族自治区来宾市",
            codeValue: "451300"
        },
        {
            codeName: "来宾市市辖区",
            codeValue: "451301"
        },
        {
            codeName: "来宾市兴宾区",
            codeValue: "451302"
        },
        {
            codeName: "来宾市忻城县",
            codeValue: "451321"
        },
        {
            codeName: "来宾市象州县",
            codeValue: "451322"
        },
        {
            codeName: "来宾市武宣县",
            codeValue: "451323"
        },
        {
            codeName: "来宾市金秀瑶族自治县",
            codeValue: "451324"
        },
        {
            codeName: "来宾市合山市",
            codeValue: "451381"
        },
        {
            codeName: "广西壮族自治区崇左市",
            codeValue: "451400"
        },
        {
            codeName: "崇左市市辖区",
            codeValue: "451401"
        },
        {
            codeName: "崇左市江州区",
            codeValue: "451402"
        },
        {
            codeName: "崇左市扶绥县",
            codeValue: "451421"
        },
        {
            codeName: "崇左市宁明县",
            codeValue: "451422"
        },
        {
            codeName: "崇左市龙州县",
            codeValue: "451423"
        },
        {
            codeName: "崇左市大新县",
            codeValue: "451424"
        },
        {
            codeName: "崇左市天等县",
            codeValue: "451425"
        },
        {
            codeName: "崇左市凭祥市",
            codeValue: "451481"
        },
        {
            codeName: "海南省",
            codeValue: "460000"
        },
        {
            codeName: "海南省海口市",
            codeValue: "460100"
        },
        {
            codeName: "海口市市辖区",
            codeValue: "460101"
        },
        {
            codeName: "海口市秀英区",
            codeValue: "460105"
        },
        {
            codeName: "海口市龙华区",
            codeValue: "460106"
        },
        {
            codeName: "海口市琼山区",
            codeValue: "460107"
        },
        {
            codeName: "海口市美兰区",
            codeValue: "460108"
        },
        {
            codeName: "海南省三亚市",
            codeValue: "460200"
        },
        {
            codeName: "三亚市市辖区",
            codeValue: "460201"
        },
        {
            codeName: "三亚市海棠区",
            codeValue: "460202"
        },
        {
            codeName: "三亚市吉阳区",
            codeValue: "460203"
        },
        {
            codeName: "三亚市天涯区",
            codeValue: "460204"
        },
        {
            codeName: "三亚市崖州区",
            codeValue: "460205"
        },
        {
            codeName: "海南省三沙市",
            codeValue: "460300"
        },
        {
            codeName: "海南省儋州市",
            codeValue: "460400"
        },
        {
            codeName: "海南省省直辖县级行政区划",
            codeValue: "469000"
        },
        {
            codeName: "海南省省直辖县级行政区划五指山市",
            codeValue: "469001"
        },
        {
            codeName: "海南省省直辖县级行政区划琼海市",
            codeValue: "469002"
        },
        {
            codeName: "海南省省直辖县级行政区划文昌市",
            codeValue: "469005"
        },
        {
            codeName: "海南省省直辖县级行政区划万宁市",
            codeValue: "469006"
        },
        {
            codeName: "海南省省直辖县级行政区划东方市",
            codeValue: "469007"
        },
        {
            codeName: "海南省省直辖县级行政区划定安县",
            codeValue: "469021"
        },
        {
            codeName: "海南省省直辖县级行政区划屯昌县",
            codeValue: "469022"
        },
        {
            codeName: "海南省省直辖县级行政区划澄迈县",
            codeValue: "469023"
        },
        {
            codeName: "海南省省直辖县级行政区划临高县",
            codeValue: "469024"
        },
        {
            codeName: "海南省省直辖县级行政区划白沙黎族自治县",
            codeValue: "469025"
        },
        {
            codeName: "海南省省直辖县级行政区划昌江黎族自治县",
            codeValue: "469026"
        },
        {
            codeName: "海南省省直辖县级行政区划乐东黎族自治县",
            codeValue: "469027"
        },
        {
            codeName: "海南省省直辖县级行政区划陵水黎族自治县",
            codeValue: "469028"
        },
        {
            codeName: "海南省省直辖县级行政区划保亭黎族苗族自治县",
            codeValue: "469029"
        },
        {
            codeName: "海南省省直辖县级行政区划琼中黎族苗族自治县",
            codeValue: "469030"
        },
        {
            codeName: "重庆市",
            codeValue: "500000"
        },
        {
            codeName: "重庆市市辖区",
            codeValue: "500100"
        },
        {
            codeName: "重庆市万州区",
            codeValue: "500101"
        },
        {
            codeName: "重庆市涪陵区",
            codeValue: "500102"
        },
        {
            codeName: "重庆市渝中区",
            codeValue: "500103"
        },
        {
            codeName: "重庆市大渡口区",
            codeValue: "500104"
        },
        {
            codeName: "重庆市江北区",
            codeValue: "500105"
        },
        {
            codeName: "重庆市沙坪坝区",
            codeValue: "500106"
        },
        {
            codeName: "重庆市九龙坡区",
            codeValue: "500107"
        },
        {
            codeName: "重庆市南岸区",
            codeValue: "500108"
        },
        {
            codeName: "重庆市北碚区",
            codeValue: "500109"
        },
        {
            codeName: "重庆市綦江区",
            codeValue: "500110"
        },
        {
            codeName: "重庆市大足区",
            codeValue: "500111"
        },
        {
            codeName: "重庆市渝北区",
            codeValue: "500112"
        },
        {
            codeName: "重庆市巴南区",
            codeValue: "500113"
        },
        {
            codeName: "重庆市黔江区",
            codeValue: "500114"
        },
        {
            codeName: "重庆市长寿区",
            codeValue: "500115"
        },
        {
            codeName: "重庆市江津区",
            codeValue: "500116"
        },
        {
            codeName: "重庆市合川区",
            codeValue: "500117"
        },
        {
            codeName: "重庆市永川区",
            codeValue: "500118"
        },
        {
            codeName: "重庆市南川区",
            codeValue: "500119"
        },
        {
            codeName: "重庆市璧山区",
            codeValue: "500120"
        },
        {
            codeName: "重庆市铜梁区",
            codeValue: "500151"
        },
        {
            codeName: "重庆市潼南区",
            codeValue: "500152"
        },
        {
            codeName: "重庆市荣昌区",
            codeValue: "500153"
        },
        {
            codeName: "重庆市开州区",
            codeValue: "500154"
        },
        {
            codeName: "重庆市梁平区",
            codeValue: "500155"
        },
        {
            codeName: "重庆市武隆区",
            codeValue: "500156"
        },
        {
            codeName: "重庆市县",
            codeValue: "500200"
        },
        {
            codeName: "重庆市梁平县",
            codeValue: "500228"
        },
        {
            codeName: "重庆市城口县",
            codeValue: "500229"
        },
        {
            codeName: "重庆市丰都县",
            codeValue: "500230"
        },
        {
            codeName: "重庆市垫江县",
            codeValue: "500231"
        },
        {
            codeName: "重庆市武隆县",
            codeValue: "500232"
        },
        {
            codeName: "重庆市忠县",
            codeValue: "500233"
        },
        {
            codeName: "重庆市云阳县",
            codeValue: "500235"
        },
        {
            codeName: "重庆市奉节县",
            codeValue: "500236"
        },
        {
            codeName: "重庆市巫山县",
            codeValue: "500237"
        },
        {
            codeName: "重庆市巫溪县",
            codeValue: "500238"
        },
        {
            codeName: "重庆市石柱土家族自治县",
            codeValue: "500240"
        },
        {
            codeName: "重庆市秀山土家族苗族自治县",
            codeValue: "500241"
        },
        {
            codeName: "重庆市酉阳土家族苗族自治县",
            codeValue: "500242"
        },
        {
            codeName: "重庆市彭水苗族土家族自治县",
            codeValue: "500243"
        },
        {
            codeName: "四川省",
            codeValue: "510000"
        },
        {
            codeName: "四川省成都市",
            codeValue: "510100"
        },
        {
            codeName: "成都市市辖区",
            codeValue: "510101"
        },
        {
            codeName: "成都市锦江区",
            codeValue: "510104"
        },
        {
            codeName: "成都市青羊区",
            codeValue: "510105"
        },
        {
            codeName: "成都市金牛区",
            codeValue: "510106"
        },
        {
            codeName: "成都市武侯区",
            codeValue: "510107"
        },
        {
            codeName: "成都市成华区",
            codeValue: "510108"
        },
        {
            codeName: "成都市龙泉驿区",
            codeValue: "510112"
        },
        {
            codeName: "成都市青白江区",
            codeValue: "510113"
        },
        {
            codeName: "成都市新都区",
            codeValue: "510114"
        },
        {
            codeName: "成都市温江区",
            codeValue: "510115"
        },
        {
            codeName: "成都市双流区",
            codeValue: "510116"
        },
        {
            codeName: "成都市郫都区",
            codeValue: "510117"
        },
        {
            codeName: "成都市金堂县",
            codeValue: "510121"
        },
        {
            codeName: "成都市郫县",
            codeValue: "510124"
        },
        {
            codeName: "成都市大邑县",
            codeValue: "510129"
        },
        {
            codeName: "成都市蒲江县",
            codeValue: "510131"
        },
        {
            codeName: "成都市新津县",
            codeValue: "510132"
        },
        {
            codeName: "成都市都江堰市",
            codeValue: "510181"
        },
        {
            codeName: "成都市彭州市",
            codeValue: "510182"
        },
        {
            codeName: "成都市邛崃市",
            codeValue: "510183"
        },
        {
            codeName: "成都市崇州市",
            codeValue: "510184"
        },
        {
            codeName: "成都市简阳市",
            codeValue: "510185"
        },
        {
            codeName: "四川省自贡市",
            codeValue: "510300"
        },
        {
            codeName: "自贡市市辖区",
            codeValue: "510301"
        },
        {
            codeName: "自贡市自流井区",
            codeValue: "510302"
        },
        {
            codeName: "自贡市贡井区",
            codeValue: "510303"
        },
        {
            codeName: "自贡市大安区",
            codeValue: "510304"
        },
        {
            codeName: "自贡市沿滩区",
            codeValue: "510311"
        },
        {
            codeName: "自贡市荣县",
            codeValue: "510321"
        },
        {
            codeName: "自贡市富顺县",
            codeValue: "510322"
        },
        {
            codeName: "四川省攀枝花市",
            codeValue: "510400"
        },
        {
            codeName: "攀枝花市市辖区",
            codeValue: "510401"
        },
        {
            codeName: "攀枝花市东区",
            codeValue: "510402"
        },
        {
            codeName: "攀枝花市西区",
            codeValue: "510403"
        },
        {
            codeName: "攀枝花市仁和区",
            codeValue: "510411"
        },
        {
            codeName: "攀枝花市米易县",
            codeValue: "510421"
        },
        {
            codeName: "攀枝花市盐边县",
            codeValue: "510422"
        },
        {
            codeName: "四川省泸州市",
            codeValue: "510500"
        },
        {
            codeName: "泸州市市辖区",
            codeValue: "510501"
        },
        {
            codeName: "泸州市江阳区",
            codeValue: "510502"
        },
        {
            codeName: "泸州市纳溪区",
            codeValue: "510503"
        },
        {
            codeName: "泸州市龙马潭区",
            codeValue: "510504"
        },
        {
            codeName: "泸州市泸县",
            codeValue: "510521"
        },
        {
            codeName: "泸州市合江县",
            codeValue: "510522"
        },
        {
            codeName: "泸州市叙永县",
            codeValue: "510524"
        },
        {
            codeName: "泸州市古蔺县",
            codeValue: "510525"
        },
        {
            codeName: "四川省德阳市",
            codeValue: "510600"
        },
        {
            codeName: "德阳市市辖区",
            codeValue: "510601"
        },
        {
            codeName: "德阳市旌阳区",
            codeValue: "510603"
        },
        {
            codeName: "德阳市中江县",
            codeValue: "510623"
        },
        {
            codeName: "德阳市罗江县",
            codeValue: "510626"
        },
        {
            codeName: "德阳市广汉市",
            codeValue: "510681"
        },
        {
            codeName: "德阳市什邡市",
            codeValue: "510682"
        },
        {
            codeName: "德阳市绵竹市",
            codeValue: "510683"
        },
        {
            codeName: "四川省绵阳市",
            codeValue: "510700"
        },
        {
            codeName: "绵阳市市辖区",
            codeValue: "510701"
        },
        {
            codeName: "绵阳市涪城区",
            codeValue: "510703"
        },
        {
            codeName: "绵阳市游仙区",
            codeValue: "510704"
        },
        {
            codeName: "绵阳市安州区",
            codeValue: "510705"
        },
        {
            codeName: "绵阳市三台县",
            codeValue: "510722"
        },
        {
            codeName: "绵阳市盐亭县",
            codeValue: "510723"
        },
        {
            codeName: "绵阳市梓潼县",
            codeValue: "510725"
        },
        {
            codeName: "绵阳市北川羌族自治县",
            codeValue: "510726"
        },
        {
            codeName: "绵阳市平武县",
            codeValue: "510727"
        },
        {
            codeName: "绵阳市江油市",
            codeValue: "510781"
        },
        {
            codeName: "四川省广元市",
            codeValue: "510800"
        },
        {
            codeName: "广元市市辖区",
            codeValue: "510801"
        },
        {
            codeName: "广元市利州区",
            codeValue: "510802"
        },
        {
            codeName: "广元市昭化区",
            codeValue: "510811"
        },
        {
            codeName: "广元市朝天区",
            codeValue: "510812"
        },
        {
            codeName: "广元市旺苍县",
            codeValue: "510821"
        },
        {
            codeName: "广元市青川县",
            codeValue: "510822"
        },
        {
            codeName: "广元市剑阁县",
            codeValue: "510823"
        },
        {
            codeName: "广元市苍溪县",
            codeValue: "510824"
        },
        {
            codeName: "四川省遂宁市",
            codeValue: "510900"
        },
        {
            codeName: "遂宁市市辖区",
            codeValue: "510901"
        },
        {
            codeName: "遂宁市船山区",
            codeValue: "510903"
        },
        {
            codeName: "遂宁市安居区",
            codeValue: "510904"
        },
        {
            codeName: "遂宁市蓬溪县",
            codeValue: "510921"
        },
        {
            codeName: "遂宁市射洪县",
            codeValue: "510922"
        },
        {
            codeName: "遂宁市大英县",
            codeValue: "510923"
        },
        {
            codeName: "四川省内江市",
            codeValue: "511000"
        },
        {
            codeName: "内江市市辖区",
            codeValue: "511001"
        },
        {
            codeName: "内江市市中区",
            codeValue: "511002"
        },
        {
            codeName: "内江市东兴区",
            codeValue: "511011"
        },
        {
            codeName: "内江市威远县",
            codeValue: "511024"
        },
        {
            codeName: "内江市资中县",
            codeValue: "511025"
        },
        {
            codeName: "内江市隆昌县",
            codeValue: "511028"
        },
        {
            codeName: "四川省乐山市",
            codeValue: "511100"
        },
        {
            codeName: "乐山市市辖区",
            codeValue: "511101"
        },
        {
            codeName: "乐山市市中区",
            codeValue: "511102"
        },
        {
            codeName: "乐山市沙湾区",
            codeValue: "511111"
        },
        {
            codeName: "乐山市五通桥区",
            codeValue: "511112"
        },
        {
            codeName: "乐山市金口河区",
            codeValue: "511113"
        },
        {
            codeName: "乐山市犍为县",
            codeValue: "511123"
        },
        {
            codeName: "乐山市井研县",
            codeValue: "511124"
        },
        {
            codeName: "乐山市夹江县",
            codeValue: "511126"
        },
        {
            codeName: "乐山市沐川县",
            codeValue: "511129"
        },
        {
            codeName: "乐山市峨边彝族自治县",
            codeValue: "511132"
        },
        {
            codeName: "乐山市马边彝族自治县",
            codeValue: "511133"
        },
        {
            codeName: "乐山市峨眉山市",
            codeValue: "511181"
        },
        {
            codeName: "四川省南充市",
            codeValue: "511300"
        },
        {
            codeName: "南充市市辖区",
            codeValue: "511301"
        },
        {
            codeName: "南充市顺庆区",
            codeValue: "511302"
        },
        {
            codeName: "南充市高坪区",
            codeValue: "511303"
        },
        {
            codeName: "南充市嘉陵区",
            codeValue: "511304"
        },
        {
            codeName: "南充市南部县",
            codeValue: "511321"
        },
        {
            codeName: "南充市营山县",
            codeValue: "511322"
        },
        {
            codeName: "南充市蓬安县",
            codeValue: "511323"
        },
        {
            codeName: "南充市仪陇县",
            codeValue: "511324"
        },
        {
            codeName: "南充市西充县",
            codeValue: "511325"
        },
        {
            codeName: "南充市阆中市",
            codeValue: "511381"
        },
        {
            codeName: "四川省眉山市",
            codeValue: "511400"
        },
        {
            codeName: "眉山市市辖区",
            codeValue: "511401"
        },
        {
            codeName: "眉山市东坡区",
            codeValue: "511402"
        },
        {
            codeName: "眉山市彭山区",
            codeValue: "511403"
        },
        {
            codeName: "眉山市仁寿县",
            codeValue: "511421"
        },
        {
            codeName: "眉山市洪雅县",
            codeValue: "511423"
        },
        {
            codeName: "眉山市丹棱县",
            codeValue: "511424"
        },
        {
            codeName: "眉山市青神县",
            codeValue: "511425"
        },
        {
            codeName: "四川省宜宾市",
            codeValue: "511500"
        },
        {
            codeName: "宜宾市市辖区",
            codeValue: "511501"
        },
        {
            codeName: "宜宾市翠屏区",
            codeValue: "511502"
        },
        {
            codeName: "宜宾市南溪区",
            codeValue: "511503"
        },
        {
            codeName: "宜宾市宜宾县",
            codeValue: "511521"
        },
        {
            codeName: "宜宾市江安县",
            codeValue: "511523"
        },
        {
            codeName: "宜宾市长宁县",
            codeValue: "511524"
        },
        {
            codeName: "宜宾市高县",
            codeValue: "511525"
        },
        {
            codeName: "宜宾市珙县",
            codeValue: "511526"
        },
        {
            codeName: "宜宾市筠连县",
            codeValue: "511527"
        },
        {
            codeName: "宜宾市兴文县",
            codeValue: "511528"
        },
        {
            codeName: "宜宾市屏山县",
            codeValue: "511529"
        },
        {
            codeName: "四川省广安市",
            codeValue: "511600"
        },
        {
            codeName: "广安市市辖区",
            codeValue: "511601"
        },
        {
            codeName: "广安市广安区",
            codeValue: "511602"
        },
        {
            codeName: "广安市前锋区",
            codeValue: "511603"
        },
        {
            codeName: "广安市岳池县",
            codeValue: "511621"
        },
        {
            codeName: "广安市武胜县",
            codeValue: "511622"
        },
        {
            codeName: "广安市邻水县",
            codeValue: "511623"
        },
        {
            codeName: "广安市华蓥市",
            codeValue: "511681"
        },
        {
            codeName: "四川省达州市",
            codeValue: "511700"
        },
        {
            codeName: "达州市市辖区",
            codeValue: "511701"
        },
        {
            codeName: "达州市通川区",
            codeValue: "511702"
        },
        {
            codeName: "达州市达川区",
            codeValue: "511703"
        },
        {
            codeName: "达州市宣汉县",
            codeValue: "511722"
        },
        {
            codeName: "达州市开江县",
            codeValue: "511723"
        },
        {
            codeName: "达州市大竹县",
            codeValue: "511724"
        },
        {
            codeName: "达州市渠县",
            codeValue: "511725"
        },
        {
            codeName: "达州市万源市",
            codeValue: "511781"
        },
        {
            codeName: "四川省雅安市",
            codeValue: "511800"
        },
        {
            codeName: "雅安市市辖区",
            codeValue: "511801"
        },
        {
            codeName: "雅安市雨城区",
            codeValue: "511802"
        },
        {
            codeName: "雅安市名山区",
            codeValue: "511803"
        },
        {
            codeName: "雅安市荥经县",
            codeValue: "511822"
        },
        {
            codeName: "雅安市汉源县",
            codeValue: "511823"
        },
        {
            codeName: "雅安市石棉县",
            codeValue: "511824"
        },
        {
            codeName: "雅安市天全县",
            codeValue: "511825"
        },
        {
            codeName: "雅安市芦山县",
            codeValue: "511826"
        },
        {
            codeName: "雅安市宝兴县",
            codeValue: "511827"
        },
        {
            codeName: "四川省巴中市",
            codeValue: "511900"
        },
        {
            codeName: "巴中市市辖区",
            codeValue: "511901"
        },
        {
            codeName: "巴中市巴州区",
            codeValue: "511902"
        },
        {
            codeName: "巴中市恩阳区",
            codeValue: "511903"
        },
        {
            codeName: "巴中市通江县",
            codeValue: "511921"
        },
        {
            codeName: "巴中市南江县",
            codeValue: "511922"
        },
        {
            codeName: "巴中市平昌县",
            codeValue: "511923"
        },
        {
            codeName: "四川省资阳市",
            codeValue: "512000"
        },
        {
            codeName: "资阳市市辖区",
            codeValue: "512001"
        },
        {
            codeName: "资阳市雁江区",
            codeValue: "512002"
        },
        {
            codeName: "资阳市安岳县",
            codeValue: "512021"
        },
        {
            codeName: "资阳市乐至县",
            codeValue: "512022"
        },
        {
            codeName: "四川省阿坝藏族羌族自治州",
            codeValue: "513200"
        },
        {
            codeName: "阿坝藏族羌族自治州马尔康市",
            codeValue: "513201"
        },
        {
            codeName: "阿坝藏族羌族自治州汶川县",
            codeValue: "513221"
        },
        {
            codeName: "阿坝藏族羌族自治州理县",
            codeValue: "513222"
        },
        {
            codeName: "阿坝藏族羌族自治州茂县",
            codeValue: "513223"
        },
        {
            codeName: "阿坝藏族羌族自治州松潘县",
            codeValue: "513224"
        },
        {
            codeName: "阿坝藏族羌族自治州九寨沟县",
            codeValue: "513225"
        },
        {
            codeName: "阿坝藏族羌族自治州金川县",
            codeValue: "513226"
        },
        {
            codeName: "阿坝藏族羌族自治州小金县",
            codeValue: "513227"
        },
        {
            codeName: "阿坝藏族羌族自治州黑水县",
            codeValue: "513228"
        },
        {
            codeName: "阿坝藏族羌族自治州壤塘县",
            codeValue: "513230"
        },
        {
            codeName: "阿坝藏族羌族自治州阿坝县",
            codeValue: "513231"
        },
        {
            codeName: "阿坝藏族羌族自治州若尔盖县",
            codeValue: "513232"
        },
        {
            codeName: "阿坝藏族羌族自治州红原县",
            codeValue: "513233"
        },
        {
            codeName: "四川省甘孜藏族自治州",
            codeValue: "513300"
        },
        {
            codeName: "甘孜藏族自治州康定市",
            codeValue: "513301"
        },
        {
            codeName: "甘孜藏族自治州泸定县",
            codeValue: "513322"
        },
        {
            codeName: "甘孜藏族自治州丹巴县",
            codeValue: "513323"
        },
        {
            codeName: "甘孜藏族自治州九龙县",
            codeValue: "513324"
        },
        {
            codeName: "甘孜藏族自治州雅江县",
            codeValue: "513325"
        },
        {
            codeName: "甘孜藏族自治州道孚县",
            codeValue: "513326"
        },
        {
            codeName: "甘孜藏族自治州炉霍县",
            codeValue: "513327"
        },
        {
            codeName: "甘孜藏族自治州甘孜县",
            codeValue: "513328"
        },
        {
            codeName: "甘孜藏族自治州新龙县",
            codeValue: "513329"
        },
        {
            codeName: "甘孜藏族自治州德格县",
            codeValue: "513330"
        },
        {
            codeName: "甘孜藏族自治州白玉县",
            codeValue: "513331"
        },
        {
            codeName: "甘孜藏族自治州石渠县",
            codeValue: "513332"
        },
        {
            codeName: "甘孜藏族自治州色达县",
            codeValue: "513333"
        },
        {
            codeName: "甘孜藏族自治州理塘县",
            codeValue: "513334"
        },
        {
            codeName: "甘孜藏族自治州巴塘县",
            codeValue: "513335"
        },
        {
            codeName: "甘孜藏族自治州乡城县",
            codeValue: "513336"
        },
        {
            codeName: "甘孜藏族自治州稻城县",
            codeValue: "513337"
        },
        {
            codeName: "甘孜藏族自治州得荣县",
            codeValue: "513338"
        },
        {
            codeName: "四川省凉山彝族自治州",
            codeValue: "513400"
        },
        {
            codeName: "凉山彝族自治州西昌市",
            codeValue: "513401"
        },
        {
            codeName: "凉山彝族自治州木里藏族自治县",
            codeValue: "513422"
        },
        {
            codeName: "凉山彝族自治州盐源县",
            codeValue: "513423"
        },
        {
            codeName: "凉山彝族自治州德昌县",
            codeValue: "513424"
        },
        {
            codeName: "凉山彝族自治州会理县",
            codeValue: "513425"
        },
        {
            codeName: "凉山彝族自治州会东县",
            codeValue: "513426"
        },
        {
            codeName: "凉山彝族自治州宁南县",
            codeValue: "513427"
        },
        {
            codeName: "凉山彝族自治州普格县",
            codeValue: "513428"
        },
        {
            codeName: "凉山彝族自治州布拖县",
            codeValue: "513429"
        },
        {
            codeName: "凉山彝族自治州金阳县",
            codeValue: "513430"
        },
        {
            codeName: "凉山彝族自治州昭觉县",
            codeValue: "513431"
        },
        {
            codeName: "凉山彝族自治州喜德县",
            codeValue: "513432"
        },
        {
            codeName: "凉山彝族自治州冕宁县",
            codeValue: "513433"
        },
        {
            codeName: "凉山彝族自治州越西县",
            codeValue: "513434"
        },
        {
            codeName: "凉山彝族自治州甘洛县",
            codeValue: "513435"
        },
        {
            codeName: "凉山彝族自治州美姑县",
            codeValue: "513436"
        },
        {
            codeName: "凉山彝族自治州雷波县",
            codeValue: "513437"
        },
        {
            codeName: "贵州省",
            codeValue: "520000"
        },
        {
            codeName: "贵州省贵阳市",
            codeValue: "520100"
        },
        {
            codeName: "贵阳市市辖区",
            codeValue: "520101"
        },
        {
            codeName: "贵阳市南明区",
            codeValue: "520102"
        },
        {
            codeName: "贵阳市云岩区",
            codeValue: "520103"
        },
        {
            codeName: "贵阳市花溪区",
            codeValue: "520111"
        },
        {
            codeName: "贵阳市乌当区",
            codeValue: "520112"
        },
        {
            codeName: "贵阳市白云区",
            codeValue: "520113"
        },
        {
            codeName: "贵阳市观山湖区",
            codeValue: "520115"
        },
        {
            codeName: "贵阳市开阳县",
            codeValue: "520121"
        },
        {
            codeName: "贵阳市息烽县",
            codeValue: "520122"
        },
        {
            codeName: "贵阳市修文县",
            codeValue: "520123"
        },
        {
            codeName: "贵阳市清镇市",
            codeValue: "520181"
        },
        {
            codeName: "贵州省六盘水市",
            codeValue: "520200"
        },
        {
            codeName: "六盘水市钟山区",
            codeValue: "520201"
        },
        {
            codeName: "六盘水市六枝特区",
            codeValue: "520203"
        },
        {
            codeName: "六盘水市水城县",
            codeValue: "520221"
        },
        {
            codeName: "六盘水市盘县",
            codeValue: "520222"
        },
        {
            codeName: "贵州省遵义市",
            codeValue: "520300"
        },
        {
            codeName: "遵义市市辖区",
            codeValue: "520301"
        },
        {
            codeName: "遵义市红花岗区",
            codeValue: "520302"
        },
        {
            codeName: "遵义市汇川区",
            codeValue: "520303"
        },
        {
            codeName: "遵义市播州区",
            codeValue: "520304"
        },
        {
            codeName: "遵义市桐梓县",
            codeValue: "520322"
        },
        {
            codeName: "遵义市绥阳县",
            codeValue: "520323"
        },
        {
            codeName: "遵义市正安县",
            codeValue: "520324"
        },
        {
            codeName: "遵义市道真仡佬族苗族自治县",
            codeValue: "520325"
        },
        {
            codeName: "遵义市务川仡佬族苗族自治县",
            codeValue: "520326"
        },
        {
            codeName: "遵义市凤冈县",
            codeValue: "520327"
        },
        {
            codeName: "遵义市湄潭县",
            codeValue: "520328"
        },
        {
            codeName: "遵义市余庆县",
            codeValue: "520329"
        },
        {
            codeName: "遵义市习水县",
            codeValue: "520330"
        },
        {
            codeName: "遵义市赤水市",
            codeValue: "520381"
        },
        {
            codeName: "遵义市仁怀市",
            codeValue: "520382"
        },
        {
            codeName: "贵州省安顺市",
            codeValue: "520400"
        },
        {
            codeName: "安顺市市辖区",
            codeValue: "520401"
        },
        {
            codeName: "安顺市西秀区",
            codeValue: "520402"
        },
        {
            codeName: "安顺市平坝区",
            codeValue: "520403"
        },
        {
            codeName: "安顺市普定县",
            codeValue: "520422"
        },
        {
            codeName: "安顺市镇宁布依族苗族自治县",
            codeValue: "520423"
        },
        {
            codeName: "安顺市关岭布依族苗族自治县",
            codeValue: "520424"
        },
        {
            codeName: "安顺市紫云苗族布依族自治县",
            codeValue: "520425"
        },
        {
            codeName: "贵州省毕节市",
            codeValue: "520500"
        },
        {
            codeName: "毕节市市辖区",
            codeValue: "520501"
        },
        {
            codeName: "毕节市七星关区",
            codeValue: "520502"
        },
        {
            codeName: "毕节市大方县",
            codeValue: "520521"
        },
        {
            codeName: "毕节市黔西县",
            codeValue: "520522"
        },
        {
            codeName: "毕节市金沙县",
            codeValue: "520523"
        },
        {
            codeName: "毕节市织金县",
            codeValue: "520524"
        },
        {
            codeName: "毕节市纳雍县",
            codeValue: "520525"
        },
        {
            codeName: "毕节市威宁彝族回族苗族自治县",
            codeValue: "520526"
        },
        {
            codeName: "毕节市赫章县",
            codeValue: "520527"
        },
        {
            codeName: "贵州省铜仁市",
            codeValue: "520600"
        },
        {
            codeName: "铜仁市市辖区",
            codeValue: "520601"
        },
        {
            codeName: "铜仁市碧江区",
            codeValue: "520602"
        },
        {
            codeName: "铜仁市万山区",
            codeValue: "520603"
        },
        {
            codeName: "铜仁市江口县",
            codeValue: "520621"
        },
        {
            codeName: "铜仁市玉屏侗族自治县",
            codeValue: "520622"
        },
        {
            codeName: "铜仁市石阡县",
            codeValue: "520623"
        },
        {
            codeName: "铜仁市思南县",
            codeValue: "520624"
        },
        {
            codeName: "铜仁市印江土家族苗族自治县",
            codeValue: "520625"
        },
        {
            codeName: "铜仁市德江县",
            codeValue: "520626"
        },
        {
            codeName: "铜仁市沿河土家族自治县",
            codeValue: "520627"
        },
        {
            codeName: "铜仁市松桃苗族自治县",
            codeValue: "520628"
        },
        {
            codeName: "贵州省黔西南布依族苗族自治州",
            codeValue: "522300"
        },
        {
            codeName: "黔西南布依族苗族自治州兴义市",
            codeValue: "522301"
        },
        {
            codeName: "黔西南布依族苗族自治州兴仁县",
            codeValue: "522322"
        },
        {
            codeName: "黔西南布依族苗族自治州普安县",
            codeValue: "522323"
        },
        {
            codeName: "黔西南布依族苗族自治州晴隆县",
            codeValue: "522324"
        },
        {
            codeName: "黔西南布依族苗族自治州贞丰县",
            codeValue: "522325"
        },
        {
            codeName: "黔西南布依族苗族自治州望谟县",
            codeValue: "522326"
        },
        {
            codeName: "黔西南布依族苗族自治州册亨县",
            codeValue: "522327"
        },
        {
            codeName: "黔西南布依族苗族自治州安龙县",
            codeValue: "522328"
        },
        {
            codeName: "贵州省黔东南苗族侗族自治州",
            codeValue: "522600"
        },
        {
            codeName: "黔东南苗族侗族自治州凯里市",
            codeValue: "522601"
        },
        {
            codeName: "黔东南苗族侗族自治州黄平县",
            codeValue: "522622"
        },
        {
            codeName: "黔东南苗族侗族自治州施秉县",
            codeValue: "522623"
        },
        {
            codeName: "黔东南苗族侗族自治州三穗县",
            codeValue: "522624"
        },
        {
            codeName: "黔东南苗族侗族自治州镇远县",
            codeValue: "522625"
        },
        {
            codeName: "黔东南苗族侗族自治州岑巩县",
            codeValue: "522626"
        },
        {
            codeName: "黔东南苗族侗族自治州天柱县",
            codeValue: "522627"
        },
        {
            codeName: "黔东南苗族侗族自治州锦屏县",
            codeValue: "522628"
        },
        {
            codeName: "黔东南苗族侗族自治州剑河县",
            codeValue: "522629"
        },
        {
            codeName: "黔东南苗族侗族自治州台江县",
            codeValue: "522630"
        },
        {
            codeName: "黔东南苗族侗族自治州黎平县",
            codeValue: "522631"
        },
        {
            codeName: "黔东南苗族侗族自治州榕江县",
            codeValue: "522632"
        },
        {
            codeName: "黔东南苗族侗族自治州从江县",
            codeValue: "522633"
        },
        {
            codeName: "黔东南苗族侗族自治州雷山县",
            codeValue: "522634"
        },
        {
            codeName: "黔东南苗族侗族自治州麻江县",
            codeValue: "522635"
        },
        {
            codeName: "黔东南苗族侗族自治州丹寨县",
            codeValue: "522636"
        },
        {
            codeName: "贵州省黔南布依族苗族自治州",
            codeValue: "522700"
        },
        {
            codeName: "黔南布依族苗族自治州都匀市",
            codeValue: "522701"
        },
        {
            codeName: "黔南布依族苗族自治州福泉市",
            codeValue: "522702"
        },
        {
            codeName: "黔南布依族苗族自治州荔波县",
            codeValue: "522722"
        },
        {
            codeName: "黔南布依族苗族自治州贵定县",
            codeValue: "522723"
        },
        {
            codeName: "黔南布依族苗族自治州瓮安县",
            codeValue: "522725"
        },
        {
            codeName: "黔南布依族苗族自治州独山县",
            codeValue: "522726"
        },
        {
            codeName: "黔南布依族苗族自治州平塘县",
            codeValue: "522727"
        },
        {
            codeName: "黔南布依族苗族自治州罗甸县",
            codeValue: "522728"
        },
        {
            codeName: "黔南布依族苗族自治州长顺县",
            codeValue: "522729"
        },
        {
            codeName: "黔南布依族苗族自治州龙里县",
            codeValue: "522730"
        },
        {
            codeName: "黔南布依族苗族自治州惠水县",
            codeValue: "522731"
        },
        {
            codeName: "黔南布依族苗族自治州三都水族自治县",
            codeValue: "522732"
        },
        {
            codeName: "云南省",
            codeValue: "530000"
        },
        {
            codeName: "云南省昆明市",
            codeValue: "530100"
        },
        {
            codeName: "昆明市市辖区",
            codeValue: "530101"
        },
        {
            codeName: "昆明市五华区",
            codeValue: "530102"
        },
        {
            codeName: "昆明市盘龙区",
            codeValue: "530103"
        },
        {
            codeName: "昆明市官渡区",
            codeValue: "530111"
        },
        {
            codeName: "昆明市西山区",
            codeValue: "530112"
        },
        {
            codeName: "昆明市东川区",
            codeValue: "530113"
        },
        {
            codeName: "昆明市呈贡区",
            codeValue: "530114"
        },
        {
            codeName: "昆明市晋宁区",
            codeValue: "530115"
        },
        {
            codeName: "昆明市晋宁县",
            codeValue: "530122"
        },
        {
            codeName: "昆明市富民县",
            codeValue: "530124"
        },
        {
            codeName: "昆明市宜良县",
            codeValue: "530125"
        },
        {
            codeName: "昆明市石林彝族自治县",
            codeValue: "530126"
        },
        {
            codeName: "昆明市嵩明县",
            codeValue: "530127"
        },
        {
            codeName: "昆明市禄劝彝族苗族自治县",
            codeValue: "530128"
        },
        {
            codeName: "昆明市寻甸回族彝族自治县",
            codeValue: "530129"
        },
        {
            codeName: "昆明市安宁市",
            codeValue: "530181"
        },
        {
            codeName: "云南省曲靖市",
            codeValue: "530300"
        },
        {
            codeName: "曲靖市市辖区",
            codeValue: "530301"
        },
        {
            codeName: "曲靖市麒麟区",
            codeValue: "530302"
        },
        {
            codeName: "曲靖市沾益区",
            codeValue: "530303"
        },
        {
            codeName: "曲靖市马龙县",
            codeValue: "530321"
        },
        {
            codeName: "曲靖市陆良县",
            codeValue: "530322"
        },
        {
            codeName: "曲靖市师宗县",
            codeValue: "530323"
        },
        {
            codeName: "曲靖市罗平县",
            codeValue: "530324"
        },
        {
            codeName: "曲靖市富源县",
            codeValue: "530325"
        },
        {
            codeName: "曲靖市会泽县",
            codeValue: "530326"
        },
        {
            codeName: "曲靖市宣威市",
            codeValue: "530381"
        },
        {
            codeName: "云南省玉溪市",
            codeValue: "530400"
        },
        {
            codeName: "玉溪市市辖区",
            codeValue: "530401"
        },
        {
            codeName: "玉溪市红塔区",
            codeValue: "530402"
        },
        {
            codeName: "玉溪市江川区",
            codeValue: "530403"
        },
        {
            codeName: "玉溪市澄江县",
            codeValue: "530422"
        },
        {
            codeName: "玉溪市通海县",
            codeValue: "530423"
        },
        {
            codeName: "玉溪市华宁县",
            codeValue: "530424"
        },
        {
            codeName: "玉溪市易门县",
            codeValue: "530425"
        },
        {
            codeName: "玉溪市峨山彝族自治县",
            codeValue: "530426"
        },
        {
            codeName: "玉溪市新平彝族傣族自治县",
            codeValue: "530427"
        },
        {
            codeName: "玉溪市元江哈尼族彝族傣族自治县",
            codeValue: "530428"
        },
        {
            codeName: "云南省保山市",
            codeValue: "530500"
        },
        {
            codeName: "保山市市辖区",
            codeValue: "530501"
        },
        {
            codeName: "保山市隆阳区",
            codeValue: "530502"
        },
        {
            codeName: "保山市施甸县",
            codeValue: "530521"
        },
        {
            codeName: "保山市龙陵县",
            codeValue: "530523"
        },
        {
            codeName: "保山市昌宁县",
            codeValue: "530524"
        },
        {
            codeName: "保山市腾冲市",
            codeValue: "530581"
        },
        {
            codeName: "云南省昭通市",
            codeValue: "530600"
        },
        {
            codeName: "昭通市市辖区",
            codeValue: "530601"
        },
        {
            codeName: "昭通市昭阳区",
            codeValue: "530602"
        },
        {
            codeName: "昭通市鲁甸县",
            codeValue: "530621"
        },
        {
            codeName: "昭通市巧家县",
            codeValue: "530622"
        },
        {
            codeName: "昭通市盐津县",
            codeValue: "530623"
        },
        {
            codeName: "昭通市大关县",
            codeValue: "530624"
        },
        {
            codeName: "昭通市永善县",
            codeValue: "530625"
        },
        {
            codeName: "昭通市绥江县",
            codeValue: "530626"
        },
        {
            codeName: "昭通市镇雄县",
            codeValue: "530627"
        },
        {
            codeName: "昭通市彝良县",
            codeValue: "530628"
        },
        {
            codeName: "昭通市威信县",
            codeValue: "530629"
        },
        {
            codeName: "昭通市水富县",
            codeValue: "530630"
        },
        {
            codeName: "云南省丽江市　　　　　　　",
            codeValue: "530700"
        },
        {
            codeName: "丽江市市辖区",
            codeValue: "530701"
        },
        {
            codeName: "丽江市古城区",
            codeValue: "530702"
        },
        {
            codeName: "丽江市玉龙纳西族自治县",
            codeValue: "530721"
        },
        {
            codeName: "丽江市永胜县",
            codeValue: "530722"
        },
        {
            codeName: "丽江市华坪县　　　　　　　　",
            codeValue: "530723"
        },
        {
            codeName: "丽江市宁蒗彝族自治县　　　　",
            codeValue: "530724"
        },
        {
            codeName: "云南省普洱市",
            codeValue: "530800"
        },
        {
            codeName: "普洱市市辖区",
            codeValue: "530801"
        },
        {
            codeName: "普洱市思茅区",
            codeValue: "530802"
        },
        {
            codeName: "普洱市宁洱哈尼族彝族自治县",
            codeValue: "530821"
        },
        {
            codeName: "普洱市墨江哈尼族自治县",
            codeValue: "530822"
        },
        {
            codeName: "普洱市景东彝族自治县",
            codeValue: "530823"
        },
        {
            codeName: "普洱市景谷傣族彝族自治县",
            codeValue: "530824"
        },
        {
            codeName: "普洱市镇沅彝族哈尼族拉祜族自治县",
            codeValue: "530825"
        },
        {
            codeName: "普洱市江城哈尼族彝族自治县",
            codeValue: "530826"
        },
        {
            codeName: "普洱市孟连傣族拉祜族佤族自治县",
            codeValue: "530827"
        },
        {
            codeName: "普洱市澜沧拉祜族自治县",
            codeValue: "530828"
        },
        {
            codeName: "普洱市西盟佤族自治县",
            codeValue: "530829"
        },
        {
            codeName: "云南省临沧市",
            codeValue: "530900"
        },
        {
            codeName: "临沧市市辖区",
            codeValue: "530901"
        },
        {
            codeName: "临沧市临翔区",
            codeValue: "530902"
        },
        {
            codeName: "临沧市凤庆县",
            codeValue: "530921"
        },
        {
            codeName: "临沧市云县",
            codeValue: "530922"
        },
        {
            codeName: "临沧市永德县",
            codeValue: "530923"
        },
        {
            codeName: "临沧市镇康县",
            codeValue: "530924"
        },
        {
            codeName: "临沧市双江拉祜族佤族布朗族傣族自治县",
            codeValue: "530925"
        },
        {
            codeName: "临沧市耿马傣族佤族自治县",
            codeValue: "530926"
        },
        {
            codeName: "临沧市沧源佤族自治县",
            codeValue: "530927"
        },
        {
            codeName: "云南省楚雄彝族自治州",
            codeValue: "532300"
        },
        {
            codeName: "楚雄彝族自治州楚雄市",
            codeValue: "532301"
        },
        {
            codeName: "楚雄彝族自治州双柏县",
            codeValue: "532322"
        },
        {
            codeName: "楚雄彝族自治州牟定县",
            codeValue: "532323"
        },
        {
            codeName: "楚雄彝族自治州南华县",
            codeValue: "532324"
        },
        {
            codeName: "楚雄彝族自治州姚安县",
            codeValue: "532325"
        },
        {
            codeName: "楚雄彝族自治州大姚县",
            codeValue: "532326"
        },
        {
            codeName: "楚雄彝族自治州永仁县",
            codeValue: "532327"
        },
        {
            codeName: "楚雄彝族自治州元谋县",
            codeValue: "532328"
        },
        {
            codeName: "楚雄彝族自治州武定县",
            codeValue: "532329"
        },
        {
            codeName: "楚雄彝族自治州禄丰县",
            codeValue: "532331"
        },
        {
            codeName: "云南省红河哈尼族彝族自治州",
            codeValue: "532500"
        },
        {
            codeName: "红河哈尼族彝族自治州个旧市",
            codeValue: "532501"
        },
        {
            codeName: "红河哈尼族彝族自治州开远市",
            codeValue: "532502"
        },
        {
            codeName: "红河哈尼族彝族自治州蒙自市",
            codeValue: "532503"
        },
        {
            codeName: "红河哈尼族彝族自治州弥勒市",
            codeValue: "532504"
        },
        {
            codeName: "红河哈尼族彝族自治州屏边苗族自治县",
            codeValue: "532523"
        },
        {
            codeName: "红河哈尼族彝族自治州建水县",
            codeValue: "532524"
        },
        {
            codeName: "红河哈尼族彝族自治州石屏县",
            codeValue: "532525"
        },
        {
            codeName: "红河哈尼族彝族自治州泸西县",
            codeValue: "532527"
        },
        {
            codeName: "红河哈尼族彝族自治州元阳县",
            codeValue: "532528"
        },
        {
            codeName: "红河哈尼族彝族自治州红河县",
            codeValue: "532529"
        },
        {
            codeName: "红河哈尼族彝族自治州金平苗族瑶族傣族自治县",
            codeValue: "532530"
        },
        {
            codeName: "红河哈尼族彝族自治州绿春县",
            codeValue: "532531"
        },
        {
            codeName: "红河哈尼族彝族自治州河口瑶族自治县",
            codeValue: "532532"
        },
        {
            codeName: "云南省文山壮族苗族自治州",
            codeValue: "532600"
        },
        {
            codeName: "文山壮族苗族自治州文山市",
            codeValue: "532601"
        },
        {
            codeName: "文山壮族苗族自治州砚山县",
            codeValue: "532622"
        },
        {
            codeName: "文山壮族苗族自治州西畴县",
            codeValue: "532623"
        },
        {
            codeName: "文山壮族苗族自治州麻栗坡县",
            codeValue: "532624"
        },
        {
            codeName: "文山壮族苗族自治州马关县",
            codeValue: "532625"
        },
        {
            codeName: "文山壮族苗族自治州丘北县",
            codeValue: "532626"
        },
        {
            codeName: "文山壮族苗族自治州广南县",
            codeValue: "532627"
        },
        {
            codeName: "文山壮族苗族自治州富宁县",
            codeValue: "532628"
        },
        {
            codeName: "云南省西双版纳傣族自治州",
            codeValue: "532800"
        },
        {
            codeName: "西双版纳傣族自治州景洪市",
            codeValue: "532801"
        },
        {
            codeName: "西双版纳傣族自治州勐海县",
            codeValue: "532822"
        },
        {
            codeName: "西双版纳傣族自治州勐腊县",
            codeValue: "532823"
        },
        {
            codeName: "云南省大理白族自治州",
            codeValue: "532900"
        },
        {
            codeName: "大理白族自治州大理市",
            codeValue: "532901"
        },
        {
            codeName: "大理白族自治州漾濞彝族自治县",
            codeValue: "532922"
        },
        {
            codeName: "大理白族自治州祥云县",
            codeValue: "532923"
        },
        {
            codeName: "大理白族自治州宾川县",
            codeValue: "532924"
        },
        {
            codeName: "大理白族自治州弥渡县",
            codeValue: "532925"
        },
        {
            codeName: "大理白族自治州南涧彝族自治县",
            codeValue: "532926"
        },
        {
            codeName: "大理白族自治州巍山彝族回族自治县",
            codeValue: "532927"
        },
        {
            codeName: "大理白族自治州永平县",
            codeValue: "532928"
        },
        {
            codeName: "大理白族自治州云龙县",
            codeValue: "532929"
        },
        {
            codeName: "大理白族自治州洱源县",
            codeValue: "532930"
        },
        {
            codeName: "大理白族自治州剑川县",
            codeValue: "532931"
        },
        {
            codeName: "大理白族自治州鹤庆县",
            codeValue: "532932"
        },
        {
            codeName: "云南省德宏傣族景颇族自治州",
            codeValue: "533100"
        },
        {
            codeName: "德宏傣族景颇族自治州瑞丽市",
            codeValue: "533102"
        },
        {
            codeName: "德宏傣族景颇族自治州芒市",
            codeValue: "533103"
        },
        {
            codeName: "德宏傣族景颇族自治州梁河县",
            codeValue: "533122"
        },
        {
            codeName: "德宏傣族景颇族自治州盈江县",
            codeValue: "533123"
        },
        {
            codeName: "德宏傣族景颇族自治州陇川县",
            codeValue: "533124"
        },
        {
            codeName: "云南省怒江傈僳族自治州",
            codeValue: "533300"
        },
        {
            codeName: "怒江傈僳族自治州泸水市",
            codeValue: "533301"
        },
        {
            codeName: "怒江傈僳族自治州福贡县",
            codeValue: "533323"
        },
        {
            codeName: "怒江傈僳族自治州贡山独龙族怒族自治县",
            codeValue: "533324"
        },
        {
            codeName: "怒江傈僳族自治州兰坪白族普米族自治县",
            codeValue: "533325"
        },
        {
            codeName: "云南省迪庆藏族自治州",
            codeValue: "533400"
        },
        {
            codeName: "迪庆藏族自治州香格里拉市",
            codeValue: "533401"
        },
        {
            codeName: "迪庆藏族自治州德钦县",
            codeValue: "533422"
        },
        {
            codeName: "迪庆藏族自治州维西傈僳族自治县",
            codeValue: "533423"
        },
        {
            codeName: "西藏自治区",
            codeValue: "540000"
        },
        {
            codeName: "西藏自治区拉萨市",
            codeValue: "540100"
        },
        {
            codeName: "拉萨市市辖区",
            codeValue: "540101"
        },
        {
            codeName: "拉萨市城关区",
            codeValue: "540102"
        },
        {
            codeName: "拉萨市堆龙德庆区",
            codeValue: "540103"
        },
        {
            codeName: "拉萨市林周县",
            codeValue: "540121"
        },
        {
            codeName: "拉萨市当雄县",
            codeValue: "540122"
        },
        {
            codeName: "拉萨市尼木县",
            codeValue: "540123"
        },
        {
            codeName: "拉萨市曲水县",
            codeValue: "540124"
        },
        {
            codeName: "拉萨市达孜县",
            codeValue: "540126"
        },
        {
            codeName: "拉萨市墨竹工卡县",
            codeValue: "540127"
        },
        {
            codeName: "西藏自治区日喀则市",
            codeValue: "540200"
        },
        {
            codeName: "日喀则市市辖区",
            codeValue: "540201"
        },
        {
            codeName: "日喀则市桑珠孜区",
            codeValue: "540202"
        },
        {
            codeName: "日喀则市南木林县",
            codeValue: "540221"
        },
        {
            codeName: "日喀则市江孜县",
            codeValue: "540222"
        },
        {
            codeName: "日喀则市定日县",
            codeValue: "540223"
        },
        {
            codeName: "日喀则市萨迦县",
            codeValue: "540224"
        },
        {
            codeName: "日喀则市拉孜县",
            codeValue: "540225"
        },
        {
            codeName: "日喀则市昂仁县",
            codeValue: "540226"
        },
        {
            codeName: "日喀则市谢通门县",
            codeValue: "540227"
        },
        {
            codeName: "日喀则市白朗县",
            codeValue: "540228"
        },
        {
            codeName: "日喀则市仁布县",
            codeValue: "540229"
        },
        {
            codeName: "日喀则市康马县",
            codeValue: "540230"
        },
        {
            codeName: "日喀则市定结县",
            codeValue: "540231"
        },
        {
            codeName: "日喀则市仲巴县",
            codeValue: "540232"
        },
        {
            codeName: "日喀则市亚东县",
            codeValue: "540233"
        },
        {
            codeName: "日喀则市吉隆县",
            codeValue: "540234"
        },
        {
            codeName: "日喀则市聂拉木县",
            codeValue: "540235"
        },
        {
            codeName: "日喀则市萨嘎县",
            codeValue: "540236"
        },
        {
            codeName: "日喀则市岗巴县",
            codeValue: "540237"
        },
        {
            codeName: "西藏自治区昌都市",
            codeValue: "540300"
        },
        {
            codeName: "昌都市市辖区",
            codeValue: "540301"
        },
        {
            codeName: "昌都市卡若区",
            codeValue: "540302"
        },
        {
            codeName: "昌都市江达县",
            codeValue: "540321"
        },
        {
            codeName: "昌都市贡觉县",
            codeValue: "540322"
        },
        {
            codeName: "昌都市类乌齐县",
            codeValue: "540323"
        },
        {
            codeName: "昌都市丁青县",
            codeValue: "540324"
        },
        {
            codeName: "昌都市察雅县",
            codeValue: "540325"
        },
        {
            codeName: "昌都市八宿县",
            codeValue: "540326"
        },
        {
            codeName: "昌都市左贡县",
            codeValue: "540327"
        },
        {
            codeName: "昌都市芒康县",
            codeValue: "540328"
        },
        {
            codeName: "昌都市洛隆县",
            codeValue: "540329"
        },
        {
            codeName: "昌都市边坝县",
            codeValue: "540330"
        },
        {
            codeName: "西藏自治区林芝市",
            codeValue: "540400"
        },
        {
            codeName: "林芝市市辖区",
            codeValue: "540401"
        },
        {
            codeName: "林芝市巴宜区",
            codeValue: "540402"
        },
        {
            codeName: "林芝市工布江达县",
            codeValue: "540421"
        },
        {
            codeName: "林芝市米林县",
            codeValue: "540422"
        },
        {
            codeName: "林芝市墨脱县",
            codeValue: "540423"
        },
        {
            codeName: "林芝市波密县",
            codeValue: "540424"
        },
        {
            codeName: "林芝市察隅县",
            codeValue: "540425"
        },
        {
            codeName: "林芝市朗县",
            codeValue: "540426"
        },
        {
            codeName: "西藏自治区山南市",
            codeValue: "540500"
        },
        {
            codeName: "山南市乃东区",
            codeValue: "540502"
        },
        {
            codeName: "山南市扎囊县",
            codeValue: "540521"
        },
        {
            codeName: "山南市贡嘎县",
            codeValue: "540522"
        },
        {
            codeName: "山南市桑日县",
            codeValue: "540523"
        },
        {
            codeName: "山南市琼结县",
            codeValue: "540524"
        },
        {
            codeName: "山南市曲松县",
            codeValue: "540525"
        },
        {
            codeName: "山南市措美县",
            codeValue: "540526"
        },
        {
            codeName: "山南市洛扎县",
            codeValue: "540527"
        },
        {
            codeName: "山南市加查县",
            codeValue: "540528"
        },
        {
            codeName: "山南市隆子县",
            codeValue: "540529"
        },
        {
            codeName: "山南市错那县",
            codeValue: "540530"
        },
        {
            codeName: "山南市浪卡子县",
            codeValue: "540531"
        },
        {
            codeName: "西藏自治区那曲地区",
            codeValue: "542400"
        },
        {
            codeName: "那曲地区那曲县",
            codeValue: "542421"
        },
        {
            codeName: "那曲地区嘉黎县",
            codeValue: "542422"
        },
        {
            codeName: "那曲地区比如县",
            codeValue: "542423"
        },
        {
            codeName: "那曲地区聂荣县",
            codeValue: "542424"
        },
        {
            codeName: "那曲地区安多县",
            codeValue: "542425"
        },
        {
            codeName: "那曲地区申扎县",
            codeValue: "542426"
        },
        {
            codeName: "那曲地区索县",
            codeValue: "542427"
        },
        {
            codeName: "那曲地区班戈县",
            codeValue: "542428"
        },
        {
            codeName: "那曲地区巴青县",
            codeValue: "542429"
        },
        {
            codeName: "那曲地区尼玛县",
            codeValue: "542430"
        },
        {
            codeName: "那曲地区双湖县",
            codeValue: "542431"
        },
        {
            codeName: "西藏自治区阿里地区",
            codeValue: "542500"
        },
        {
            codeName: "阿里地区普兰县",
            codeValue: "542521"
        },
        {
            codeName: "阿里地区札达县",
            codeValue: "542522"
        },
        {
            codeName: "阿里地区噶尔县",
            codeValue: "542523"
        },
        {
            codeName: "阿里地区日土县",
            codeValue: "542524"
        },
        {
            codeName: "阿里地区革吉县",
            codeValue: "542525"
        },
        {
            codeName: "阿里地区改则县",
            codeValue: "542526"
        },
        {
            codeName: "阿里地区措勤县",
            codeValue: "542527"
        },
        {
            codeName: "陕西省",
            codeValue: "610000"
        },
        {
            codeName: "陕西省西安市",
            codeValue: "610100"
        },
        {
            codeName: "西安市市辖区",
            codeValue: "610101"
        },
        {
            codeName: "西安市新城区",
            codeValue: "610102"
        },
        {
            codeName: "西安市碑林区",
            codeValue: "610103"
        },
        {
            codeName: "西安市莲湖区",
            codeValue: "610104"
        },
        {
            codeName: "西安市灞桥区",
            codeValue: "610111"
        },
        {
            codeName: "西安市未央区",
            codeValue: "610112"
        },
        {
            codeName: "西安市雁塔区",
            codeValue: "610113"
        },
        {
            codeName: "西安市阎良区",
            codeValue: "610114"
        },
        {
            codeName: "西安市临潼区",
            codeValue: "610115"
        },
        {
            codeName: "西安市长安区",
            codeValue: "610116"
        },
        {
            codeName: "西安市高陵区",
            codeValue: "610117"
        },
        {
            codeName: "西安市鄠邑区",
            codeValue: "610118"
        },
        {
            codeName: "西安市蓝田县",
            codeValue: "610122"
        },
        {
            codeName: "西安市周至县",
            codeValue: "610124"
        },
        {
            codeName: "西安市户县",
            codeValue: "610125"
        },
        {
            codeName: "陕西省铜川市",
            codeValue: "610200"
        },
        {
            codeName: "铜川市市辖区",
            codeValue: "610201"
        },
        {
            codeName: "铜川市王益区",
            codeValue: "610202"
        },
        {
            codeName: "铜川市印台区",
            codeValue: "610203"
        },
        {
            codeName: "铜川市耀州区",
            codeValue: "610204"
        },
        {
            codeName: "铜川市宜君县",
            codeValue: "610222"
        },
        {
            codeName: "陕西省宝鸡市",
            codeValue: "610300"
        },
        {
            codeName: "宝鸡市市辖区",
            codeValue: "610301"
        },
        {
            codeName: "宝鸡市渭滨区",
            codeValue: "610302"
        },
        {
            codeName: "宝鸡市金台区",
            codeValue: "610303"
        },
        {
            codeName: "宝鸡市陈仓区",
            codeValue: "610304"
        },
        {
            codeName: "宝鸡市凤翔县",
            codeValue: "610322"
        },
        {
            codeName: "宝鸡市岐山县",
            codeValue: "610323"
        },
        {
            codeName: "宝鸡市扶风县",
            codeValue: "610324"
        },
        {
            codeName: "宝鸡市眉县",
            codeValue: "610326"
        },
        {
            codeName: "宝鸡市陇县",
            codeValue: "610327"
        },
        {
            codeName: "宝鸡市千阳县",
            codeValue: "610328"
        },
        {
            codeName: "宝鸡市麟游县",
            codeValue: "610329"
        },
        {
            codeName: "宝鸡市凤县",
            codeValue: "610330"
        },
        {
            codeName: "宝鸡市太白县",
            codeValue: "610331"
        },
        {
            codeName: "陕西省咸阳市",
            codeValue: "610400"
        },
        {
            codeName: "咸阳市市辖区",
            codeValue: "610401"
        },
        {
            codeName: "咸阳市秦都区",
            codeValue: "610402"
        },
        {
            codeName: "咸阳市杨陵区",
            codeValue: "610403"
        },
        {
            codeName: "咸阳市渭城区",
            codeValue: "610404"
        },
        {
            codeName: "咸阳市三原县",
            codeValue: "610422"
        },
        {
            codeName: "咸阳市泾阳县",
            codeValue: "610423"
        },
        {
            codeName: "咸阳市乾县",
            codeValue: "610424"
        },
        {
            codeName: "咸阳市礼泉县",
            codeValue: "610425"
        },
        {
            codeName: "咸阳市永寿县",
            codeValue: "610426"
        },
        {
            codeName: "咸阳市彬县",
            codeValue: "610427"
        },
        {
            codeName: "咸阳市长武县",
            codeValue: "610428"
        },
        {
            codeName: "咸阳市旬邑县",
            codeValue: "610429"
        },
        {
            codeName: "咸阳市淳化县",
            codeValue: "610430"
        },
        {
            codeName: "咸阳市武功县",
            codeValue: "610431"
        },
        {
            codeName: "咸阳市兴平市",
            codeValue: "610481"
        },
        {
            codeName: "陕西省渭南市",
            codeValue: "610500"
        },
        {
            codeName: "渭南市市辖区",
            codeValue: "610501"
        },
        {
            codeName: "渭南市临渭区",
            codeValue: "610502"
        },
        {
            codeName: "渭南市华州区",
            codeValue: "610503"
        },
        {
            codeName: "渭南市潼关县",
            codeValue: "610522"
        },
        {
            codeName: "渭南市大荔县",
            codeValue: "610523"
        },
        {
            codeName: "渭南市合阳县",
            codeValue: "610524"
        },
        {
            codeName: "渭南市澄城县",
            codeValue: "610525"
        },
        {
            codeName: "渭南市蒲城县",
            codeValue: "610526"
        },
        {
            codeName: "渭南市白水县",
            codeValue: "610527"
        },
        {
            codeName: "渭南市富平县",
            codeValue: "610528"
        },
        {
            codeName: "渭南市韩城市",
            codeValue: "610581"
        },
        {
            codeName: "渭南市华阴市",
            codeValue: "610582"
        },
        {
            codeName: "陕西省延安市",
            codeValue: "610600"
        },
        {
            codeName: "延安市市辖区",
            codeValue: "610601"
        },
        {
            codeName: "延安市宝塔区",
            codeValue: "610602"
        },
        {
            codeName: "延安市安塞区",
            codeValue: "610603"
        },
        {
            codeName: "延安市延长县",
            codeValue: "610621"
        },
        {
            codeName: "延安市延川县",
            codeValue: "610622"
        },
        {
            codeName: "延安市子长县",
            codeValue: "610623"
        },
        {
            codeName: "延安市志丹县",
            codeValue: "610625"
        },
        {
            codeName: "延安市吴起县",
            codeValue: "610626"
        },
        {
            codeName: "延安市甘泉县",
            codeValue: "610627"
        },
        {
            codeName: "延安市富县",
            codeValue: "610628"
        },
        {
            codeName: "延安市洛川县",
            codeValue: "610629"
        },
        {
            codeName: "延安市宜川县",
            codeValue: "610630"
        },
        {
            codeName: "延安市黄龙县",
            codeValue: "610631"
        },
        {
            codeName: "延安市黄陵县",
            codeValue: "610632"
        },
        {
            codeName: "陕西省汉中市",
            codeValue: "610700"
        },
        {
            codeName: "汉中市市辖区",
            codeValue: "610701"
        },
        {
            codeName: "汉中市汉台区",
            codeValue: "610702"
        },
        {
            codeName: "汉中市南郑县",
            codeValue: "610721"
        },
        {
            codeName: "汉中市城固县",
            codeValue: "610722"
        },
        {
            codeName: "汉中市洋县",
            codeValue: "610723"
        },
        {
            codeName: "汉中市西乡县",
            codeValue: "610724"
        },
        {
            codeName: "汉中市勉县",
            codeValue: "610725"
        },
        {
            codeName: "汉中市宁强县",
            codeValue: "610726"
        },
        {
            codeName: "汉中市略阳县",
            codeValue: "610727"
        },
        {
            codeName: "汉中市镇巴县",
            codeValue: "610728"
        },
        {
            codeName: "汉中市留坝县",
            codeValue: "610729"
        },
        {
            codeName: "汉中市佛坪县",
            codeValue: "610730"
        },
        {
            codeName: "陕西省榆林市",
            codeValue: "610800"
        },
        {
            codeName: "榆林市市辖区",
            codeValue: "610801"
        },
        {
            codeName: "榆林市榆阳区",
            codeValue: "610802"
        },
        {
            codeName: "榆林市横山区",
            codeValue: "610803"
        },
        {
            codeName: "榆林市神木县",
            codeValue: "610821"
        },
        {
            codeName: "榆林市府谷县",
            codeValue: "610822"
        },
        {
            codeName: "榆林市靖边县",
            codeValue: "610824"
        },
        {
            codeName: "榆林市定边县",
            codeValue: "610825"
        },
        {
            codeName: "榆林市绥德县",
            codeValue: "610826"
        },
        {
            codeName: "榆林市米脂县",
            codeValue: "610827"
        },
        {
            codeName: "榆林市佳县",
            codeValue: "610828"
        },
        {
            codeName: "榆林市吴堡县",
            codeValue: "610829"
        },
        {
            codeName: "榆林市清涧县",
            codeValue: "610830"
        },
        {
            codeName: "榆林市子洲县",
            codeValue: "610831"
        },
        {
            codeName: "陕西省安康市",
            codeValue: "610900"
        },
        {
            codeName: "安康市市辖区",
            codeValue: "610901"
        },
        {
            codeName: "安康市汉滨区",
            codeValue: "610902"
        },
        {
            codeName: "安康市汉阴县",
            codeValue: "610921"
        },
        {
            codeName: "安康市石泉县",
            codeValue: "610922"
        },
        {
            codeName: "安康市宁陕县",
            codeValue: "610923"
        },
        {
            codeName: "安康市紫阳县",
            codeValue: "610924"
        },
        {
            codeName: "安康市岚皋县",
            codeValue: "610925"
        },
        {
            codeName: "安康市平利县",
            codeValue: "610926"
        },
        {
            codeName: "安康市镇坪县",
            codeValue: "610927"
        },
        {
            codeName: "安康市旬阳县",
            codeValue: "610928"
        },
        {
            codeName: "安康市白河县",
            codeValue: "610929"
        },
        {
            codeName: "陕西省商洛市",
            codeValue: "611000"
        },
        {
            codeName: "商洛市市辖区",
            codeValue: "611001"
        },
        {
            codeName: "商洛市商州区",
            codeValue: "611002"
        },
        {
            codeName: "商洛市洛南县",
            codeValue: "611021"
        },
        {
            codeName: "商洛市丹凤县",
            codeValue: "611022"
        },
        {
            codeName: "商洛市商南县",
            codeValue: "611023"
        },
        {
            codeName: "商洛市山阳县",
            codeValue: "611024"
        },
        {
            codeName: "商洛市镇安县",
            codeValue: "611025"
        },
        {
            codeName: "商洛市柞水县",
            codeValue: "611026"
        },
        {
            codeName: "甘肃省",
            codeValue: "620000"
        },
        {
            codeName: "甘肃省兰州市",
            codeValue: "620100"
        },
        {
            codeName: "兰州市市辖区",
            codeValue: "620101"
        },
        {
            codeName: "兰州市城关区",
            codeValue: "620102"
        },
        {
            codeName: "兰州市七里河区",
            codeValue: "620103"
        },
        {
            codeName: "兰州市西固区",
            codeValue: "620104"
        },
        {
            codeName: "兰州市安宁区",
            codeValue: "620105"
        },
        {
            codeName: "兰州市红古区",
            codeValue: "620111"
        },
        {
            codeName: "兰州市永登县",
            codeValue: "620121"
        },
        {
            codeName: "兰州市皋兰县",
            codeValue: "620122"
        },
        {
            codeName: "兰州市榆中县",
            codeValue: "620123"
        },
        {
            codeName: "甘肃省嘉峪关市",
            codeValue: "620200"
        },
        {
            codeName: "嘉峪关市市辖区",
            codeValue: "620201"
        },
        {
            codeName: "甘肃省金昌市",
            codeValue: "620300"
        },
        {
            codeName: "金昌市市辖区",
            codeValue: "620301"
        },
        {
            codeName: "金昌市金川区",
            codeValue: "620302"
        },
        {
            codeName: "金昌市永昌县",
            codeValue: "620321"
        },
        {
            codeName: "甘肃省白银市",
            codeValue: "620400"
        },
        {
            codeName: "白银市市辖区",
            codeValue: "620401"
        },
        {
            codeName: "白银市白银区",
            codeValue: "620402"
        },
        {
            codeName: "白银市平川区",
            codeValue: "620403"
        },
        {
            codeName: "白银市靖远县",
            codeValue: "620421"
        },
        {
            codeName: "白银市会宁县",
            codeValue: "620422"
        },
        {
            codeName: "白银市景泰县",
            codeValue: "620423"
        },
        {
            codeName: "甘肃省天水市",
            codeValue: "620500"
        },
        {
            codeName: "天水市市辖区",
            codeValue: "620501"
        },
        {
            codeName: "天水市秦州区",
            codeValue: "620502"
        },
        {
            codeName: "天水市麦积区",
            codeValue: "620503"
        },
        {
            codeName: "天水市清水县",
            codeValue: "620521"
        },
        {
            codeName: "天水市秦安县",
            codeValue: "620522"
        },
        {
            codeName: "天水市甘谷县",
            codeValue: "620523"
        },
        {
            codeName: "天水市武山县",
            codeValue: "620524"
        },
        {
            codeName: "天水市张家川回族自治县",
            codeValue: "620525"
        },
        {
            codeName: "甘肃省武威市",
            codeValue: "620600"
        },
        {
            codeName: "武威市市辖区",
            codeValue: "620601"
        },
        {
            codeName: "武威市凉州区",
            codeValue: "620602"
        },
        {
            codeName: "武威市民勤县",
            codeValue: "620621"
        },
        {
            codeName: "武威市古浪县",
            codeValue: "620622"
        },
        {
            codeName: "武威市天祝藏族自治县",
            codeValue: "620623"
        },
        {
            codeName: "甘肃省张掖市",
            codeValue: "620700"
        },
        {
            codeName: "张掖市市辖区",
            codeValue: "620701"
        },
        {
            codeName: "张掖市甘州区",
            codeValue: "620702"
        },
        {
            codeName: "张掖市肃南裕固族自治县",
            codeValue: "620721"
        },
        {
            codeName: "张掖市民乐县",
            codeValue: "620722"
        },
        {
            codeName: "张掖市临泽县",
            codeValue: "620723"
        },
        {
            codeName: "张掖市高台县",
            codeValue: "620724"
        },
        {
            codeName: "张掖市山丹县",
            codeValue: "620725"
        },
        {
            codeName: "甘肃省平凉市",
            codeValue: "620800"
        },
        {
            codeName: "平凉市市辖区",
            codeValue: "620801"
        },
        {
            codeName: "平凉市崆峒区",
            codeValue: "620802"
        },
        {
            codeName: "平凉市泾川县",
            codeValue: "620821"
        },
        {
            codeName: "平凉市灵台县",
            codeValue: "620822"
        },
        {
            codeName: "平凉市崇信县",
            codeValue: "620823"
        },
        {
            codeName: "平凉市华亭县",
            codeValue: "620824"
        },
        {
            codeName: "平凉市庄浪县",
            codeValue: "620825"
        },
        {
            codeName: "平凉市静宁县",
            codeValue: "620826"
        },
        {
            codeName: "甘肃省酒泉市",
            codeValue: "620900"
        },
        {
            codeName: "酒泉市市辖区",
            codeValue: "620901"
        },
        {
            codeName: "酒泉市肃州区",
            codeValue: "620902"
        },
        {
            codeName: "酒泉市金塔县",
            codeValue: "620921"
        },
        {
            codeName: "酒泉市瓜州县",
            codeValue: "620922"
        },
        {
            codeName: "酒泉市肃北蒙古族自治县",
            codeValue: "620923"
        },
        {
            codeName: "酒泉市阿克塞哈萨克族自治县",
            codeValue: "620924"
        },
        {
            codeName: "酒泉市玉门市",
            codeValue: "620981"
        },
        {
            codeName: "酒泉市敦煌市",
            codeValue: "620982"
        },
        {
            codeName: "甘肃省庆阳市",
            codeValue: "621000"
        },
        {
            codeName: "庆阳市市辖区",
            codeValue: "621001"
        },
        {
            codeName: "庆阳市西峰区",
            codeValue: "621002"
        },
        {
            codeName: "庆阳市庆城县",
            codeValue: "621021"
        },
        {
            codeName: "庆阳市环县",
            codeValue: "621022"
        },
        {
            codeName: "庆阳市华池县",
            codeValue: "621023"
        },
        {
            codeName: "庆阳市合水县",
            codeValue: "621024"
        },
        {
            codeName: "庆阳市正宁县",
            codeValue: "621025"
        },
        {
            codeName: "庆阳市宁县",
            codeValue: "621026"
        },
        {
            codeName: "庆阳市镇原县",
            codeValue: "621027"
        },
        {
            codeName: "甘肃省定西市",
            codeValue: "621100"
        },
        {
            codeName: "定西市市辖区",
            codeValue: "621101"
        },
        {
            codeName: "定西市安定区",
            codeValue: "621102"
        },
        {
            codeName: "定西市通渭县",
            codeValue: "621121"
        },
        {
            codeName: "定西市陇西县",
            codeValue: "621122"
        },
        {
            codeName: "定西市渭源县",
            codeValue: "621123"
        },
        {
            codeName: "定西市临洮县",
            codeValue: "621124"
        },
        {
            codeName: "定西市漳县",
            codeValue: "621125"
        },
        {
            codeName: "定西市岷县",
            codeValue: "621126"
        },
        {
            codeName: "甘肃省陇南市",
            codeValue: "621200"
        },
        {
            codeName: "陇南市市辖区",
            codeValue: "621201"
        },
        {
            codeName: "陇南市武都区",
            codeValue: "621202"
        },
        {
            codeName: "陇南市成县",
            codeValue: "621221"
        },
        {
            codeName: "陇南市文县",
            codeValue: "621222"
        },
        {
            codeName: "陇南市宕昌县",
            codeValue: "621223"
        },
        {
            codeName: "陇南市康县",
            codeValue: "621224"
        },
        {
            codeName: "陇南市西和县",
            codeValue: "621225"
        },
        {
            codeName: "陇南市礼县",
            codeValue: "621226"
        },
        {
            codeName: "陇南市徽县",
            codeValue: "621227"
        },
        {
            codeName: "陇南市两当县",
            codeValue: "621228"
        },
        {
            codeName: "甘肃省临夏回族自治州",
            codeValue: "622900"
        },
        {
            codeName: "临夏回族自治州临夏市",
            codeValue: "622901"
        },
        {
            codeName: "临夏回族自治州临夏县",
            codeValue: "622921"
        },
        {
            codeName: "临夏回族自治州康乐县",
            codeValue: "622922"
        },
        {
            codeName: "临夏回族自治州永靖县",
            codeValue: "622923"
        },
        {
            codeName: "临夏回族自治州广河县",
            codeValue: "622924"
        },
        {
            codeName: "临夏回族自治州和政县",
            codeValue: "622925"
        },
        {
            codeName: "临夏回族自治州东乡族自治县",
            codeValue: "622926"
        },
        {
            codeName: "临夏回族自治州积石山保安族东乡族撒拉族自治县",
            codeValue: "622927"
        },
        {
            codeName: "甘肃省甘南藏族自治州",
            codeValue: "623000"
        },
        {
            codeName: "甘南藏族自治州合作市",
            codeValue: "623001"
        },
        {
            codeName: "甘南藏族自治州临潭县",
            codeValue: "623021"
        },
        {
            codeName: "甘南藏族自治州卓尼县",
            codeValue: "623022"
        },
        {
            codeName: "甘南藏族自治州舟曲县",
            codeValue: "623023"
        },
        {
            codeName: "甘南藏族自治州迭部县",
            codeValue: "623024"
        },
        {
            codeName: "甘南藏族自治州玛曲县",
            codeValue: "623025"
        },
        {
            codeName: "甘南藏族自治州碌曲县",
            codeValue: "623026"
        },
        {
            codeName: "甘南藏族自治州夏河县",
            codeValue: "623027"
        },
        {
            codeName: "青海省",
            codeValue: "630000"
        },
        {
            codeName: "青海省西宁市",
            codeValue: "630100"
        },
        {
            codeName: "西宁市市辖区",
            codeValue: "630101"
        },
        {
            codeName: "西宁市城东区",
            codeValue: "630102"
        },
        {
            codeName: "西宁市城中区",
            codeValue: "630103"
        },
        {
            codeName: "西宁市城西区",
            codeValue: "630104"
        },
        {
            codeName: "西宁市城北区",
            codeValue: "630105"
        },
        {
            codeName: "西宁市大通回族土族自治县",
            codeValue: "630121"
        },
        {
            codeName: "西宁市湟中县",
            codeValue: "630122"
        },
        {
            codeName: "西宁市湟源县",
            codeValue: "630123"
        },
        {
            codeName: "青海省海东市",
            codeValue: "630200"
        },
        {
            codeName: "海东市乐都区",
            codeValue: "630202"
        },
        {
            codeName: "海东市平安区",
            codeValue: "630203"
        },
        {
            codeName: "海东市民和回族土族自治县",
            codeValue: "630222"
        },
        {
            codeName: "海东市互助土族自治县",
            codeValue: "630223"
        },
        {
            codeName: "海东市化隆回族自治县",
            codeValue: "630224"
        },
        {
            codeName: "海东市循化撒拉族自治县",
            codeValue: "630225"
        },
        {
            codeName: "青海省海北藏族自治州",
            codeValue: "632200"
        },
        {
            codeName: "海北藏族自治州门源回族自治县",
            codeValue: "632221"
        },
        {
            codeName: "海北藏族自治州祁连县",
            codeValue: "632222"
        },
        {
            codeName: "海北藏族自治州海晏县",
            codeValue: "632223"
        },
        {
            codeName: "海北藏族自治州刚察县",
            codeValue: "632224"
        },
        {
            codeName: "青海省黄南藏族自治州",
            codeValue: "632300"
        },
        {
            codeName: "黄南藏族自治州同仁县",
            codeValue: "632321"
        },
        {
            codeName: "黄南藏族自治州尖扎县",
            codeValue: "632322"
        },
        {
            codeName: "黄南藏族自治州泽库县",
            codeValue: "632323"
        },
        {
            codeName: "黄南藏族自治州河南蒙古族自治县",
            codeValue: "632324"
        },
        {
            codeName: "青海省海南藏族自治州",
            codeValue: "632500"
        },
        {
            codeName: "海南藏族自治州共和县",
            codeValue: "632521"
        },
        {
            codeName: "海南藏族自治州同德县",
            codeValue: "632522"
        },
        {
            codeName: "海南藏族自治州贵德县",
            codeValue: "632523"
        },
        {
            codeName: "海南藏族自治州兴海县",
            codeValue: "632524"
        },
        {
            codeName: "海南藏族自治州贵南县",
            codeValue: "632525"
        },
        {
            codeName: "青海省果洛藏族自治州",
            codeValue: "632600"
        },
        {
            codeName: "果洛藏族自治州玛沁县",
            codeValue: "632621"
        },
        {
            codeName: "果洛藏族自治州班玛县",
            codeValue: "632622"
        },
        {
            codeName: "果洛藏族自治州甘德县",
            codeValue: "632623"
        },
        {
            codeName: "果洛藏族自治州达日县",
            codeValue: "632624"
        },
        {
            codeName: "果洛藏族自治州久治县",
            codeValue: "632625"
        },
        {
            codeName: "果洛藏族自治州玛多县",
            codeValue: "632626"
        },
        {
            codeName: "青海省玉树藏族自治州",
            codeValue: "632700"
        },
        {
            codeName: "玉树藏族自治州玉树市",
            codeValue: "632701"
        },
        {
            codeName: "玉树藏族自治州杂多县",
            codeValue: "632722"
        },
        {
            codeName: "玉树藏族自治州称多县",
            codeValue: "632723"
        },
        {
            codeName: "玉树藏族自治州治多县",
            codeValue: "632724"
        },
        {
            codeName: "玉树藏族自治州囊谦县",
            codeValue: "632725"
        },
        {
            codeName: "玉树藏族自治州曲麻莱县",
            codeValue: "632726"
        },
        {
            codeName: "青海省海西蒙古族藏族自治州",
            codeValue: "632800"
        },
        {
            codeName: "海西蒙古族藏族自治州格尔木市",
            codeValue: "632801"
        },
        {
            codeName: "海西蒙古族藏族自治州德令哈市",
            codeValue: "632802"
        },
        {
            codeName: "海西蒙古族藏族自治州乌兰县",
            codeValue: "632821"
        },
        {
            codeName: "海西蒙古族藏族自治州都兰县",
            codeValue: "632822"
        },
        {
            codeName: "海西蒙古族藏族自治州天峻县",
            codeValue: "632823"
        },
        {
            codeName: "宁夏回族自治区",
            codeValue: "640000"
        },
        {
            codeName: "宁夏回族自治区银川市",
            codeValue: "640100"
        },
        {
            codeName: "银川市市辖区",
            codeValue: "640101"
        },
        {
            codeName: "银川市兴庆区",
            codeValue: "640104"
        },
        {
            codeName: "银川市西夏区",
            codeValue: "640105"
        },
        {
            codeName: "银川市金凤区",
            codeValue: "640106"
        },
        {
            codeName: "银川市永宁县",
            codeValue: "640121"
        },
        {
            codeName: "银川市贺兰县",
            codeValue: "640122"
        },
        {
            codeName: "银川市灵武市",
            codeValue: "640181"
        },
        {
            codeName: "宁夏回族自治区石嘴山市",
            codeValue: "640200"
        },
        {
            codeName: "石嘴山市市辖区",
            codeValue: "640201"
        },
        {
            codeName: "石嘴山市大武口区",
            codeValue: "640202"
        },
        {
            codeName: "石嘴山市惠农区",
            codeValue: "640205"
        },
        {
            codeName: "石嘴山市平罗县",
            codeValue: "640221"
        },
        {
            codeName: "宁夏回族自治区吴忠市",
            codeValue: "640300"
        },
        {
            codeName: "吴忠市市辖区",
            codeValue: "640301"
        },
        {
            codeName: "吴忠市利通区",
            codeValue: "640302"
        },
        {
            codeName: "吴忠市红寺堡区",
            codeValue: "640303"
        },
        {
            codeName: "吴忠市盐池县",
            codeValue: "640323"
        },
        {
            codeName: "吴忠市同心县",
            codeValue: "640324"
        },
        {
            codeName: "吴忠市青铜峡市",
            codeValue: "640381"
        },
        {
            codeName: "宁夏回族自治区固原市",
            codeValue: "640400"
        },
        {
            codeName: "固原市市辖区",
            codeValue: "640401"
        },
        {
            codeName: "固原市原州区",
            codeValue: "640402"
        },
        {
            codeName: "固原市西吉县",
            codeValue: "640422"
        },
        {
            codeName: "固原市隆德县",
            codeValue: "640423"
        },
        {
            codeName: "固原市泾源县",
            codeValue: "640424"
        },
        {
            codeName: "固原市彭阳县",
            codeValue: "640425"
        },
        {
            codeName: "宁夏回族自治区中卫市",
            codeValue: "640500"
        },
        {
            codeName: "中卫市市辖区",
            codeValue: "640501"
        },
        {
            codeName: "中卫市沙坡头区",
            codeValue: "640502"
        },
        {
            codeName: "中卫市中宁县",
            codeValue: "640521"
        },
        {
            codeName: "中卫市海原县",
            codeValue: "640522"
        },
        {
            codeName: "新疆维吾尔自治区",
            codeValue: "650000"
        },
        {
            codeName: "新疆维吾尔自治区乌鲁木齐市",
            codeValue: "650100"
        },
        {
            codeName: "乌鲁木齐市市辖区",
            codeValue: "650101"
        },
        {
            codeName: "乌鲁木齐市天山区",
            codeValue: "650102"
        },
        {
            codeName: "乌鲁木齐市沙依巴克区",
            codeValue: "650103"
        },
        {
            codeName: "乌鲁木齐市新市区",
            codeValue: "650104"
        },
        {
            codeName: "乌鲁木齐市水磨沟区",
            codeValue: "650105"
        },
        {
            codeName: "乌鲁木齐市头屯河区",
            codeValue: "650106"
        },
        {
            codeName: "乌鲁木齐市达坂城区",
            codeValue: "650107"
        },
        {
            codeName: "乌鲁木齐市米东区",
            codeValue: "650109"
        },
        {
            codeName: "乌鲁木齐市乌鲁木齐县",
            codeValue: "650121"
        },
        {
            codeName: "新疆维吾尔自治区克拉玛依市",
            codeValue: "650200"
        },
        {
            codeName: "克拉玛依市市辖区",
            codeValue: "650201"
        },
        {
            codeName: "克拉玛依市独山子区",
            codeValue: "650202"
        },
        {
            codeName: "克拉玛依市克拉玛依区",
            codeValue: "650203"
        },
        {
            codeName: "克拉玛依市白碱滩区",
            codeValue: "650204"
        },
        {
            codeName: "克拉玛依市乌尔禾区",
            codeValue: "650205"
        },
        {
            codeName: "新疆维吾尔自治区吐鲁番市",
            codeValue: "650400"
        },
        {
            codeName: "吐鲁番市市辖区",
            codeValue: "650401"
        },
        {
            codeName: "吐鲁番市高昌区",
            codeValue: "650402"
        },
        {
            codeName: "吐鲁番市鄯善县",
            codeValue: "650421"
        },
        {
            codeName: "吐鲁番市托克逊县",
            codeValue: "650422"
        },
        {
            codeName: "新疆维吾尔自治区哈密市",
            codeValue: "650500"
        },
        {
            codeName: "哈密市伊州区",
            codeValue: "650502"
        },
        {
            codeName: "哈密市巴里坤哈萨克自治县",
            codeValue: "650521"
        },
        {
            codeName: "哈密市伊吾县",
            codeValue: "650522"
        },
        {
            codeName: "新疆维吾尔自治区昌吉回族自治州",
            codeValue: "652300"
        },
        {
            codeName: "昌吉回族自治州昌吉市",
            codeValue: "652301"
        },
        {
            codeName: "昌吉回族自治州阜康市",
            codeValue: "652302"
        },
        {
            codeName: "昌吉回族自治州呼图壁县",
            codeValue: "652323"
        },
        {
            codeName: "昌吉回族自治州玛纳斯县",
            codeValue: "652324"
        },
        {
            codeName: "昌吉回族自治州奇台县",
            codeValue: "652325"
        },
        {
            codeName: "昌吉回族自治州吉木萨尔县",
            codeValue: "652327"
        },
        {
            codeName: "昌吉回族自治州木垒哈萨克自治县",
            codeValue: "652328"
        },
        {
            codeName: "新疆维吾尔自治区博尔塔拉蒙古自治州",
            codeValue: "652700"
        },
        {
            codeName: "博尔塔拉蒙古自治州博乐市",
            codeValue: "652701"
        },
        {
            codeName: "博尔塔拉蒙古自治州阿拉山口市",
            codeValue: "652702"
        },
        {
            codeName: "博尔塔拉蒙古自治州精河县",
            codeValue: "652722"
        },
        {
            codeName: "博尔塔拉蒙古自治州温泉县",
            codeValue: "652723"
        },
        {
            codeName: "新疆维吾尔自治区巴音郭楞蒙古自治州",
            codeValue: "652800"
        },
        {
            codeName: "巴音郭楞蒙古自治州库尔勒市",
            codeValue: "652801"
        },
        {
            codeName: "巴音郭楞蒙古自治州轮台县",
            codeValue: "652822"
        },
        {
            codeName: "巴音郭楞蒙古自治州尉犁县",
            codeValue: "652823"
        },
        {
            codeName: "巴音郭楞蒙古自治州若羌县",
            codeValue: "652824"
        },
        {
            codeName: "巴音郭楞蒙古自治州且末县",
            codeValue: "652825"
        },
        {
            codeName: "巴音郭楞蒙古自治州焉耆回族自治县",
            codeValue: "652826"
        },
        {
            codeName: "巴音郭楞蒙古自治州和静县",
            codeValue: "652827"
        },
        {
            codeName: "巴音郭楞蒙古自治州和硕县",
            codeValue: "652828"
        },
        {
            codeName: "巴音郭楞蒙古自治州博湖县",
            codeValue: "652829"
        },
        {
            codeName: "新疆维吾尔自治区阿克苏地区",
            codeValue: "652900"
        },
        {
            codeName: "阿克苏地区阿克苏市",
            codeValue: "652901"
        },
        {
            codeName: "阿克苏地区温宿县",
            codeValue: "652922"
        },
        {
            codeName: "阿克苏地区库车县",
            codeValue: "652923"
        },
        {
            codeName: "阿克苏地区沙雅县",
            codeValue: "652924"
        },
        {
            codeName: "阿克苏地区新和县",
            codeValue: "652925"
        },
        {
            codeName: "阿克苏地区拜城县",
            codeValue: "652926"
        },
        {
            codeName: "阿克苏地区乌什县",
            codeValue: "652927"
        },
        {
            codeName: "阿克苏地区阿瓦提县",
            codeValue: "652928"
        },
        {
            codeName: "阿克苏地区柯坪县",
            codeValue: "652929"
        },
        {
            codeName: "新疆维吾尔自治区克孜勒苏柯尔克孜自治州",
            codeValue: "653000"
        },
        {
            codeName: "克孜勒苏柯尔克孜自治州阿图什市",
            codeValue: "653001"
        },
        {
            codeName: "克孜勒苏柯尔克孜自治州阿克陶县",
            codeValue: "653022"
        },
        {
            codeName: "克孜勒苏柯尔克孜自治州阿合奇县",
            codeValue: "653023"
        },
        {
            codeName: "克孜勒苏柯尔克孜自治州乌恰县",
            codeValue: "653024"
        },
        {
            codeName: "新疆维吾尔自治区喀什地区",
            codeValue: "653100"
        },
        {
            codeName: "喀什地区喀什市",
            codeValue: "653101"
        },
        {
            codeName: "喀什地区疏附县",
            codeValue: "653121"
        },
        {
            codeName: "喀什地区疏勒县",
            codeValue: "653122"
        },
        {
            codeName: "喀什地区英吉沙县",
            codeValue: "653123"
        },
        {
            codeName: "喀什地区泽普县",
            codeValue: "653124"
        },
        {
            codeName: "喀什地区莎车县",
            codeValue: "653125"
        },
        {
            codeName: "喀什地区叶城县",
            codeValue: "653126"
        },
        {
            codeName: "喀什地区麦盖提县",
            codeValue: "653127"
        },
        {
            codeName: "喀什地区岳普湖县",
            codeValue: "653128"
        },
        {
            codeName: "喀什地区伽师县",
            codeValue: "653129"
        },
        {
            codeName: "喀什地区巴楚县",
            codeValue: "653130"
        },
        {
            codeName: "喀什地区塔什库尔干塔吉克自治县",
            codeValue: "653131"
        },
        {
            codeName: "新疆维吾尔自治区和田地区",
            codeValue: "653200"
        },
        {
            codeName: "和田地区和田市",
            codeValue: "653201"
        },
        {
            codeName: "和田地区和田县",
            codeValue: "653221"
        },
        {
            codeName: "和田地区墨玉县",
            codeValue: "653222"
        },
        {
            codeName: "和田地区皮山县",
            codeValue: "653223"
        },
        {
            codeName: "和田地区洛浦县",
            codeValue: "653224"
        },
        {
            codeName: "和田地区策勒县",
            codeValue: "653225"
        },
        {
            codeName: "和田地区于田县",
            codeValue: "653226"
        },
        {
            codeName: "和田地区民丰县",
            codeValue: "653227"
        },
        {
            codeName: "新疆维吾尔自治区伊犁哈萨克自治州",
            codeValue: "654000"
        },
        {
            codeName: "伊犁哈萨克自治州伊宁市",
            codeValue: "654002"
        },
        {
            codeName: "伊犁哈萨克自治州奎屯市",
            codeValue: "654003"
        },
        {
            codeName: "伊犁哈萨克自治州霍尔果斯市",
            codeValue: "654004"
        },
        {
            codeName: "伊犁哈萨克自治州伊宁县",
            codeValue: "654021"
        },
        {
            codeName: "伊犁哈萨克自治州察布查尔锡伯自治县",
            codeValue: "654022"
        },
        {
            codeName: "伊犁哈萨克自治州霍城县",
            codeValue: "654023"
        },
        {
            codeName: "伊犁哈萨克自治州巩留县",
            codeValue: "654024"
        },
        {
            codeName: "伊犁哈萨克自治州新源县",
            codeValue: "654025"
        },
        {
            codeName: "伊犁哈萨克自治州昭苏县",
            codeValue: "654026"
        },
        {
            codeName: "伊犁哈萨克自治州特克斯县",
            codeValue: "654027"
        },
        {
            codeName: "伊犁哈萨克自治州尼勒克县",
            codeValue: "654028"
        },
        {
            codeName: "新疆维吾尔自治区塔城地区",
            codeValue: "654200"
        },
        {
            codeName: "塔城地区塔城市",
            codeValue: "654201"
        },
        {
            codeName: "塔城地区乌苏市",
            codeValue: "654202"
        },
        {
            codeName: "塔城地区额敏县",
            codeValue: "654221"
        },
        {
            codeName: "塔城地区沙湾县",
            codeValue: "654223"
        },
        {
            codeName: "塔城地区托里县",
            codeValue: "654224"
        },
        {
            codeName: "塔城地区裕民县",
            codeValue: "654225"
        },
        {
            codeName: "塔城地区和布克赛尔蒙古自治县",
            codeValue: "654226"
        },
        {
            codeName: "新疆维吾尔自治区阿勒泰地区",
            codeValue: "654300"
        },
        {
            codeName: "阿勒泰地区阿勒泰市",
            codeValue: "654301"
        },
        {
            codeName: "阿勒泰地区布尔津县",
            codeValue: "654321"
        },
        {
            codeName: "阿勒泰地区富蕴县",
            codeValue: "654322"
        },
        {
            codeName: "阿勒泰地区福海县",
            codeValue: "654323"
        },
        {
            codeName: "阿勒泰地区哈巴河县",
            codeValue: "654324"
        },
        {
            codeName: "阿勒泰地区青河县",
            codeValue: "654325"
        },
        {
            codeName: "阿勒泰地区吉木乃县",
            codeValue: "654326"
        },
        {
            codeName: "新疆维吾尔自治区自治区直辖县级行政单位",
            codeValue: "659000"
        },
        {
            codeName: "新疆维吾尔自治区省直辖行政区划石河子市",
            codeValue: "659001"
        },
        {
            codeName: "新疆维吾尔自治区省直辖县级行政单位阿拉尔市",
            codeValue: "659002"
        },
        {
            codeName: "新疆维吾尔自治区省直辖县级行政单位图木舒克市",
            codeValue: "659003"
        },
        {
            codeName: "新疆维吾尔自治区省直辖县级行政单位五家渠市",
            codeValue: "659004"
        },
        {
            codeName: "新疆维吾尔自治区省直辖县级行政单位北屯市",
            codeValue: "659005"
        },
        {
            codeName: "新疆维吾尔自治区省直辖县级行政单位铁门关市",
            codeValue: "659006"
        },
        {
            codeName: "新疆维吾尔自治区省直辖县级行政单位双河市",
            codeValue: "659007"
        },
        {
            codeName: "新疆维吾尔自治区省直辖县级行政单位可克达拉市",
            codeValue: "659008"
        },
        {
            codeName: "新疆维吾尔自治区省直辖县级行政单位昆玉市",
            codeValue: "659009"
        },
        {
            codeName: "台湾省",
            codeValue: "710000"
        },
        {
            codeName: "香港特别行政区",
            codeValue: "810000"
        },
        {
            codeName: "澳门特别行政区",
            codeValue: "820000"
        },
        {
            codeName: "中国",
            codeValue: "910000"
        },
        {
            codeName: "境外",
            codeValue: "920000"
        }
    ],
    // QTY_UNIT:[
    //     { codeValue: '200', codeName: '托' },
    //     { codeValue: '011', codeName: '件' },
    //     { codeValue: '125', codeName: '包' },
    //     { codeValue: '035', codeName: '千克' },
    // ],
    // 计量单位
    CUS_UNIT: [
        { codeValue: 'TUO', codeName: '托' },
        {
            codeName: "台",
            codeValue: "001"
        },
        {
            codeName: "座",
            codeValue: "002"
        },
        {
            codeName: "辆",
            codeValue: "003"
        },
        {
            codeName: "艘",
            codeValue: "004"
        },
        {
            codeName: "架",
            codeValue: "005"
        },
        {
            codeName: "套",
            codeValue: "006"
        },
        {
            codeName: "个",
            codeValue: "007"
        },
        {
            codeName: "只",
            codeValue: "008"
        },
        {
            codeName: "头",
            codeValue: "009"
        },
        {
            codeName: "张",
            codeValue: "010"
        },
        {
            codeName: "件",
            codeValue: "011"
        },
        {
            codeName: "支",
            codeValue: "012"
        },
        {
            codeName: "枝",
            codeValue: "013"
        },
        {
            codeName: "根",
            codeValue: "014"
        },
        {
            codeName: "条",
            codeValue: "015"
        },
        {
            codeName: "把",
            codeValue: "016"
        },
        {
            codeName: "块",
            codeValue: "017"
        },
        {
            codeName: "卷",
            codeValue: "018"
        },
        {
            codeName: "副",
            codeValue: "019"
        },
        {
            codeName: "片",
            codeValue: "020"
        },
        {
            codeName: "组",
            codeValue: "021"
        },
        {
            codeName: "份",
            codeValue: "022"
        },
        {
            codeName: "幅",
            codeValue: "023"
        },
        {
            codeName: "双",
            codeValue: "025"
        },
        {
            codeName: "对",
            codeValue: "026"
        },
        {
            codeName: "棵",
            codeValue: "027"
        },
        {
            codeName: "株",
            codeValue: "028"
        },
        {
            codeName: "井",
            codeValue: "029"
        },
        {
            codeName: "米",
            codeValue: "030"
        },
        {
            codeName: "盘",
            codeValue: "031"
        },
        {
            codeName: "平方米",
            codeValue: "032"
        },
        {
            codeName: "立方米",
            codeValue: "033"
        },
        {
            codeName: "筒",
            codeValue: "034"
        },
        {
            codeName: "千克",
            codeValue: "035"
        },
        {
            codeName: "克",
            codeValue: "036"
        },
        {
            codeName: "盆",
            codeValue: "037"
        },
        {
            codeName: "万个",
            codeValue: "038"
        },
        {
            codeName: "具",
            codeValue: "039"
        },
        {
            codeName: "百副",
            codeValue: "040"
        },
        {
            codeName: "百支",
            codeValue: "041"
        },
        {
            codeName: "百把",
            codeValue: "042"
        },
        {
            codeName: "百个",
            codeValue: "043"
        },
        {
            codeName: "百片",
            codeValue: "044"
        },
        {
            codeName: "刀",
            codeValue: "045"
        },
        {
            codeName: "疋",
            codeValue: "046"
        },
        {
            codeName: "公担",
            codeValue: "047"
        },
        {
            codeName: "扇",
            codeValue: "048"
        },
        {
            codeName: "百枝",
            codeValue: "049"
        },
        {
            codeName: "千只",
            codeValue: "050"
        },
        {
            codeName: "千块",
            codeValue: "051"
        },
        {
            codeName: "千盒",
            codeValue: "052"
        },
        {
            codeName: "千枝",
            codeValue: "053"
        },
        {
            codeName: "千个",
            codeValue: "054"
        },
        {
            codeName: "亿支",
            codeValue: "055"
        },
        {
            codeName: "亿个",
            codeValue: "056"
        },
        {
            codeName: "万套",
            codeValue: "057"
        },
        {
            codeName: "千张",
            codeValue: "058"
        },
        {
            codeName: "万张",
            codeValue: "059"
        },
        {
            codeName: "千伏安",
            codeValue: "060"
        },
        {
            codeName: "千瓦",
            codeValue: "061"
        },
        {
            codeName: "千瓦时",
            codeValue: "062"
        },
        {
            codeName: "千升",
            codeValue: "063"
        },
        {
            codeName: "英尺",
            codeValue: "067"
        },
        {
            codeName: "吨",
            codeValue: "070"
        },
        {
            codeName: "长吨",
            codeValue: "071"
        },
        {
            codeName: "短吨",
            codeValue: "072"
        },
        {
            codeName: "司马担",
            codeValue: "073"
        },
        {
            codeName: "司马斤",
            codeValue: "074"
        },
        {
            codeName: "斤",
            codeValue: "075"
        },
        {
            codeName: "磅",
            codeValue: "076"
        },
        {
            codeName: "担",
            codeValue: "077"
        },
        {
            codeName: "英担",
            codeValue: "078"
        },
        {
            codeName: "短担",
            codeValue: "079"
        },
        {
            codeName: "两",
            codeValue: "080"
        },
        {
            codeName: "市担",
            codeValue: "081"
        },
        {
            codeName: "盎司",
            codeValue: "083"
        },
        {
            codeName: "克拉",
            codeValue: "084"
        },
        {
            codeName: "市尺",
            codeValue: "085"
        },
        {
            codeName: "码",
            codeValue: "086"
        },
        {
            codeName: "英寸",
            codeValue: "088"
        },
        {
            codeName: "寸",
            codeValue: "089"
        },
        {
            codeName: "升",
            codeValue: "095"
        },
        {
            codeName: "毫升",
            codeValue: "096"
        },
        {
            codeName: "英加仑",
            codeValue: "097"
        },
        {
            codeName: "美加仑",
            codeValue: "098"
        },
        {
            codeName: "立方英尺",
            codeValue: "099"
        },
        {
            codeName: "立方尺",
            codeValue: "101"
        },
        {
            codeName: "平方码",
            codeValue: "110"
        },
        {
            codeName: "平方英尺",
            codeValue: "111"
        },
        {
            codeName: "平方尺",
            codeValue: "112"
        },
        {
            codeName: "英制马力",
            codeValue: "115"
        },
        {
            codeName: "公制马力",
            codeValue: "116"
        },
        {
            codeName: "令",
            codeValue: "118"
        },
        {
            codeName: "箱",
            codeValue: "120"
        },
        {
            codeName: "批",
            codeValue: "121"
        },
        {
            codeName: "罐",
            codeValue: "122"
        },
        {
            codeName: "桶",
            codeValue: "123"
        },
        {
            codeName: "扎",
            codeValue: "124"
        },
        {
            codeName: "包",
            codeValue: "125"
        },
        {
            codeName: "箩",
            codeValue: "126"
        },
        {
            codeName: "打",
            codeValue: "127"
        },
        {
            codeName: "筐",
            codeValue: "128"
        },
        {
            codeName: "罗",
            codeValue: "129"
        },
        {
            codeName: "匹",
            codeValue: "130"
        },
        {
            codeName: "册",
            codeValue: "131"
        },
        {
            codeName: "本",
            codeValue: "132"
        },
        {
            codeName: "发",
            codeValue: "133"
        },
        {
            codeName: "枚",
            codeValue: "134"
        },
        {
            codeName: "捆",
            codeValue: "135"
        },
        {
            codeName: "袋",
            codeValue: "136"
        },
        {
            codeName: "粒",
            codeValue: "139"
        },
        {
            codeName: "盒",
            codeValue: "140"
        },
        {
            codeName: "合",
            codeValue: "141"
        },
        {
            codeName: "瓶",
            codeValue: "142"
        },
        {
            codeName: "千支",
            codeValue: "143"
        },
        {
            codeName: "万双",
            codeValue: "144"
        },
        {
            codeName: "万粒",
            codeValue: "145"
        },
        {
            codeName: "千粒",
            codeValue: "146"
        },
        {
            codeName: "千米",
            codeValue: "147"
        },
        {
            codeName: "千英尺",
            codeValue: "148"
        },
        {
            codeName: "百万贝可",
            codeValue: "149"
        },
        {
            codeName: "部",
            codeValue: "163"
        },
        {
            codeName: "亿株",
            codeValue: "164"
        },
        {
            codeName: "人份",
            codeValue: "170"
        }
    ],
    // 品牌类型
    BrandType:[
        {
            codeName: "无品牌",
            codeValue: "0"
        },{
            codeName: "境内自主品牌",
            codeValue: "1"
        },{
            codeName: "境内收购品牌",
            codeValue: "2"
        },{
            codeName: "境外品牌(贴牌生产)",
            codeValue: "3"
        },{
            codeName: "境外品牌(其它)",
            codeValue: "4"
        },
    ],
    // 出口享惠情况
    ExportBenefits:[
        {
            codeName: "出口货物在最终目的国(地区)不享受优惠关税",
            codeValue: "0"
        },{
            codeName: "出口货物在最终目的国(地区)享受优惠关税",
            codeValue: "1"
        },{
            codeName: "不能确定在最终目的国(地区)享受优惠关税",
            codeValue: "2"
        },{
            codeName: "不适用于进口报关单",
            codeValue: "3"
        },
    ],
    // 集装箱规格
    CUS_MAPPING_NORMS_CODE:[
        {
            codeName: "普通2*标准箱（L）",
            cusCode: "L",
            codeValue: "11",
            gbName: "普通2*标准箱（L）",
            ciqName: "普通2*标准箱（L）",
            cusName: "普通2*标准箱（L）",
            gbCode: "11",
            ciqCode: "111"
        },
        {
            codeName: "冷藏2*标准箱（L）",
            cusCode: "L",
            codeValue: "12",
            gbName: "冷藏2*标准箱（L）",
            ciqName: "冷藏2*标准箱（L）",
            cusName: "冷藏2*标准箱（L）",
            gbCode: "12",
            ciqCode: "121"
        },
        {
            codeName: "罐式2*标准箱（L）",
            cusCode: "L",
            codeValue: "13",
            gbName: "罐式2*标准箱（L）",
            ciqName: "罐式2*标准箱（L）",
            cusName: "罐式2*标准箱（L）",
            gbCode: "13",
            ciqCode: "131"
        },
        {
            codeName: "普通标准箱（S）",
            cusCode: "S",
            codeValue: "21",
            gbName: "普通标准箱（S）",
            ciqName: "普通标准箱（S）",
            cusName: "普通标准箱（S）",
            gbCode: "21",
            ciqCode: "211"
        },
        {
            codeName: "冷藏标准箱（S）",
            cusCode: "S",
            codeValue: "22",
            gbName: "冷藏标准箱（S）",
            ciqName: "冷藏标准箱（S）",
            cusName: "冷藏标准箱（S）",
            gbCode: "22",
            ciqCode: "221"
        },
        {
            codeName: "罐式标准箱（S）",
            cusCode: "S",
            codeValue: "23",
            gbName: "罐式标准箱（S）",
            ciqName: "罐式标准箱（S）",
            cusName: "罐式标准箱（S）",
            gbCode: "23",
            ciqCode: "231"
        },
        {
            codeName: "其他标准箱（S）",
            cusCode: "S",
            codeValue: "31",
            gbName: "其他标准箱（S）",
            ciqName: "其他标准箱（S）",
            cusName: "其他标准箱（S）",
            gbCode: "31",
            ciqCode: "998"
        },
        {
            codeName: "其他2*标准箱（L）",
            cusCode: "L",
            codeValue: "32",
            gbName: "其他2*标准箱（L）",
            ciqName: "其他2*标准箱（L）",
            cusName: "其他2*标准箱（L）",
            gbCode: "32",
            ciqCode: "999"
        },
        {
            codeName: "非集装箱",
            cusCode: "N",
            codeValue: "N",
            gbName: "非集装箱",
            ciqName: "非集装箱",
            cusName: "非集装箱",
            gbCode: "N",
            ciqCode: null
        }
    ],
    // 运费标志
    feeMarkList:[
        {
            codeName: "率",
            codeValue: "1"
        },{
            codeName: "单价",
            codeValue: "2"
        },{
            codeName: "总价",
            codeValue: "3"
        },
    ],
    // 保险费、杂费
    otherCostMarkList:[
        {
            codeName: "率",
            codeValue: "1"
        },{
            codeName: "总价",
            codeValue: "3"
        },
    ],
    // 进出口标志
    importsExportsCodeList:[
        {
            codeName: "进口",
            codeValue: "I"
        },{
            codeName: "出口",
            codeValue: "E"
        },
    ],
    // 查询页面报关单类型
    queryDeclarationTypeList:[
        {
            codeName: "一般报关单",
            codeValue: "0"
        },{
            codeName: "转关提前报关单",
            codeValue: "1"
        },{
            codeName: "备案清单",
            codeValue: "2"
        },{
            codeName: "转关提前备案清单",
            codeValue: "3"
        },{
            codeName: "出口二次转关",
            codeValue: "4"
        },{
            codeName: "内贸货物备案清单",
            codeValue: "5"
        },{
            codeName: "横琴简化备案清单",
            codeValue: "6"
        }
    ],
    // 特殊业务标识列表
    specialBusinessList:[
        {
            codeName: "国际赛事",
            codeValue: "0"
        },{
            codeName: "特殊进出军工物资",
            codeValue: "1"
        },{
            codeName: "国际援助物资",
            codeValue: "2"
        },{
            codeName: "国际会议",
            codeValue: "3"
        },{
            codeName: "直通放行",
            codeValue: "4"
        },{
            codeName: "外交礼遇",
            codeValue: "5"
        },{
            codeName: "转关",
            codeValue: "6"
        }
    ],
    // 
    businessMattersList:[
        {
            codeName: "税单无纸化",
            codeValue: "0"
        },{
            codeName: "水运中转",
            codeValue: "1"
        },{
            codeName: "担保验放",
            codeValue: "2"
        },{
            codeName: "跨境电商海外仓",
            codeValue: "3"
        },{
            codeName: "组合港",
            codeValue: "4"
        }
    ],
    // 检验检疫签证申报要素
    certificateList:[
        {
            cusCiqNo: null,
            requCertSeqNo: "1",
            tableFlag: null,
            appCertCode: "11",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "品质证书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "2",
            tableFlag: null,
            appCertCode: "12",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "重量证书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "3",
            tableFlag: null,
            appCertCode: "13",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "数量证书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "4",
            tableFlag: null,
            appCertCode: "14",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "兽医卫生证书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "5",
            tableFlag: null,
            appCertCode: "15",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "健康证书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "6",
            tableFlag: null,
            appCertCode: "16",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "卫生证书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "7",
            tableFlag: null,
            appCertCode: "17",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "动物卫生证书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "8",
            tableFlag: null,
            appCertCode: "18",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "植物检疫证书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "9",
            tableFlag: null,
            appCertCode: "19",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "熏蒸/消毒证书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "10",
            tableFlag: null,
            appCertCode: "20",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "出境货物换证凭单"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "11",
            tableFlag: null,
            appCertCode: "21",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "入境货物检验检疫证明（申请出具）"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "12",
            tableFlag: null,
            appCertCode: "22",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "出境货物不合格通知单"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "13",
            tableFlag: null,
            appCertCode: "23",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "集装箱检验检疫结果单"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "14",
            tableFlag: null,
            appCertCode: "24",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "入境货物检验检疫证明（申请不出具）"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "15",
            tableFlag: null,
            appCertCode: "25",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "随车检验单"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "16",
            tableFlag: null,
            appCertCode: "26",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "检验检疫处理通知书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "17",
            tableFlag: null,
            appCertCode: "94",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "电子底账"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "18",
            tableFlag: null,
            appCertCode: "95",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "入境货物调离通知单"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "19",
            tableFlag: null,
            appCertCode: "96",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "出境货物检验检疫工作联系单"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "20",
            tableFlag: null,
            appCertCode: "97",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "空白证书"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "21",
            tableFlag: null,
            appCertCode: "98",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "其他单"
        },
        {
            cusCiqNo: null,
            requCertSeqNo: "22",
            tableFlag: null,
            appCertCode: "99",
            applOri: "1",
            applCopyQuan: "2",
            createUser: null,
            indbTime: null,
            updateUser: null,
            updateTime: null,
            state: "",
            appCertName: "其他证书"
        }
    ],
    // 包装类别
    CIQ_DANGER_PACK_TYPE:[
        {
            codeName: "一类",
            codeValue: "1"
        },{
            codeName: "二类",
            codeValue: "2"
        },{
            codeName: "三类",
            codeValue: "3"
        },{
            codeName: "无",
            codeValue: "4"
        }
    ],
    // 货物属性
    cargoAttributesList:[
        {
            codeName: "3C目录内",
            codeValue: "11"
        },{
            codeName: "3C目录外",
            codeValue: "12"
        },{
            codeName: "无需办理3C认证",
            codeValue: "13"
        },{
            codeName: "预包装",
            codeValue: "14"
        },{
            codeName: "非预包装",
            codeValue: "15"
        },{
            codeName: "转基因产品",
            codeValue: "16"
        },{
            codeName: "非转基因产品",
            codeValue: "17"
        },{
            codeName: "首次进出口",
            codeValue: "18"
        },{
            codeName: "正常",
            codeValue: "19"
        },{
            codeName: "废品",
            codeValue: "20"
        },{
            codeName: "旧品",
            codeValue: "21"
        },{
            codeName: "成套设备",
            codeValue: "22"
        },{
            codeName: "带皮木材/板材",
            codeValue: "23"
        },{
            codeName: "不带皮木材/板材",
            codeValue: "24"
        },{
            codeName: "A级特殊物品",
            codeValue: "25"
        },{
            codeName: "B级特殊物品",
            codeValue: "26"
        },{
            codeName: "C级特殊物品",
            codeValue: "27"
        },{
            codeName: "D级特殊物品",
            codeValue: "28"
        },{
            codeName: "V/W非特殊物品",
            codeValue: "29"
        },{
            codeName: "市场采购",
            codeValue: "30"
        },{
            codeName: "散装危险化学品",
            codeValue: "31"
        },{
            codeName: "件装危险化学品",
            codeValue: "32"
        },{
            codeName: "非危险化学品",
            codeValue: "33"
        },{
            codeName: "I类医疗器械",
            codeValue: "34"
        },{
            codeName: "II类医疗器械",
            codeValue: "35"
        },{
            codeName: "III类医疗器械",
            codeValue: "36"
        },{
            codeName: "医疗器械零部件",
            codeValue: "37"
        },{
            codeName: "非医疗器械",
            codeValue: "38"
        },{
            codeName: "特种设备",
            codeValue: "39"
        },{
            codeName: "非特种设备",
            codeValue: "40"
        },{
            codeName: "真空包装等货物",
            codeValue: "41"
        },{
            codeName: "办理进口登记用饲料和饲料添加剂样品",
            codeValue: "42"
        },{
            codeName: "科研用饲料和饲料添加剂样品",
            codeValue: "43"
        },{
            codeName: "其他用途饲料和饲料添加剂样品",
            codeValue: "44"
        },{
            codeName: "检验结果采信",
            codeValue: "46"
        },{
            codeName: "再制造产品",
            codeValue: "47"
        },{
            codeName: "一般贸易出口的退运工业品",
            codeValue: "48"
        },
    ],
    // 随附单据文件类别
    autocompleterList:[
        {
            codeName: "发票",
            codeValue: "00000001"
        },{
            codeName: "装箱单",
            codeValue: "00000002"
        },{
            codeName: "提/运单",
            codeValue: "00000003"
        },{
            codeName: "合同",
            codeValue: "00000004"
        },{
            codeName: "代理报关委托协议（纸质）",
            codeValue: "00000008"
        },{
            codeName: "原产地证据文件",
            codeValue: "00000009"
        },{
            codeName: "载货清单（舱单）",
            codeValue: "00000010"
        },{
            codeName: "特许权使用费涉及的原进口货物报关单海关编号",
            codeValue: "00000011"
        },{
            codeName: "特许权使用费合同/协议",
            codeValue: "00000012"
        },{
            codeName: "特许权使用费发票",
            codeValue: "00000013"
        },{
            codeName: "特许权使用费支付凭证",
            codeValue: "00000014"
        },{
            codeName: "代扣代缴税款纳税凭证",
            codeValue: "00000015"
        },{
            codeName: "特许权使用费其他材料",
            codeValue: "00000016"
        },{
            codeName: "出口证明信",
            codeValue: "00000017"
        },{
            codeName: "代理报关委托协议（电子）",
            codeValue: "10000001"
        },{
            codeName: "减免税货物税款担保证明",
            codeValue: "10000002"
        },{
            codeName: "减免税货物税款担保延期证明",
            codeValue: "10000003"
        },{
            codeName: "跨境B2B出口单证",
            codeValue: "10000004"
        },{
            codeName: "兽医(卫生)证书",
            codeValue: "20000011"
        },{
            codeName: "动物检疫证书",
            codeValue: "20000012"
        },{
            codeName: "植物检疫证书",
            codeValue: "20000013"
        },{
            codeName: "装运前检验证书",
            codeValue: "20000014"
        },{
            codeName: "重量证书",
            codeValue: "20000015"
        },{
            codeName: "TCK检验证书（美国小麦）",
            codeValue: "20000016"
        },{
            codeName: "熏蒸证书",
            codeValue: "20000017"
        },{
            codeName: "放射性物质检测合格证明",
            codeValue: "20000018"
        },{
            codeName: "木材发货检验码单",
            codeValue: "20000019"
        },{
            codeName: "水果预检验证书",
            codeValue: "20000020"
        },{
            codeName: "中转进境确认证明文件（经港澳地区中转入境水果）",
            codeValue: "20000021"
        },{
            codeName: "检测报告",
            codeValue: "20000022"
        },{
            codeName: "危险特性分类鉴别报告",
            codeValue: "20000023"
        },{
            codeName: "型式试验报告",
            codeValue: "20000024"
        },{
            codeName: "动物检疫合格证明（国产原料）；进境货物检疫证明、原产国检验证书（进口原料）",
            codeValue: "20000025"
        },{
            codeName: "微生物检测报告（沙门氏菌、产志贺毒素大肠杆菌、金黄色葡萄球菌、单增李斯球菌）",
            codeValue: "20000026"
        },{
            codeName: "出口水产品成品检验报告",
            codeValue: "20000027"
        },{
            codeName: "检疫处理结果报关单",
            codeValue: "20000028"
        },{
            codeName: "检验报告",
            codeValue: "20000029"
        },{
            codeName: "质量安全符合性声明",
            codeValue: "20000030"
        },{
            codeName: "企业提供的证明材料",
            codeValue: "50000001"
        },{
            codeName: "企业提供的声明",
            codeValue: "50000002"
        },{
            codeName: "企业提供的标签标识",
            codeValue: "50000003"
        },{
            codeName: "企业提供的其他",
            codeValue: "50000004"
        },{
            codeName: "农业转基因生物安全证书",
            codeValue: "50000005"
        },{
            codeName: "引进种子、苗木检疫审批单",
            codeValue: "50000006"
        },{
            codeName: "远洋自捕水产品的确认通知（文件）和远洋渔业项目确认表、农业部远洋渔业企业资格证书",
            codeValue: "50000007"
        },{
            codeName: "特种设备制造许可证",
            codeValue: "50000008"
        },{
            codeName: "进口化妆品卫生许可批件",
            codeValue: "50000009"
        },{
            codeName: "特殊医学用途配方食品注册证书",
            codeValue: "50000010"
        },{
            codeName: "保健食品注册证书/备案凭证",
            codeValue: "50000011"
        },{
            codeName: "捕捞船舶登记证和捕捞许可证（野生捕捞水生动物）",
            codeValue: "50000012"
        },{
            codeName: "化妆品生产许可证（仅限首次出口提供）",
            codeValue: "50000013"
        },{
            codeName: "特殊用途销售包装化妆品成品应当提供相应的卫生许可批件或者具有相关资质的机构出具的是否存在安全性风险物质的有关安全性评估资料（仅限首次出口时提供）",
            codeValue: "50000014"
        },{
            codeName: "民用爆炸品进口审批单",
            codeValue: "60000001"
        },{
            codeName: "民用爆炸口出口审批单",
            codeValue: "60000002"
        },{
            codeName: "军品出口许可证",
            codeValue: "60000003"
        },{
            codeName: "人类遗传资源材料出口、出境证明",
            codeValue: "60000004"
        },{
            codeName: "古生物化石出口、出境批件",
            codeValue: "60000005"
        },{
            codeName: "密码出口许可证",
            codeValue: "60000006"
        },{
            codeName: "援外项目任务通知单",
            codeValue: "60000007"
        },{
            codeName: "医疗用毒性药品进出口批件",
            codeValue: "60000008"
        },{
            codeName: "放射性药品进出口批件",
            codeValue: "60000009"
        },{
            codeName: "血液出口批件",
            codeValue: "60000010"
        },{
            codeName: "化学品进出口环境管理登记证明",
            codeValue: "60000011"
        },{
            codeName: "企业符合性声明",
            codeValue: "80000001"
        },{
            codeName: "抑制剂或稳定剂情况说明",
            codeValue: "80000002"
        },{
            codeName: "危险公示标签",
            codeValue: "80000003"
        },{
            codeName: "安全数据单",
            codeValue: "80000004"
        },
    ],
    // 保税核注
    // 清单类型
    INVT_BILL_TYPE:[
        {
            codeName: "普通清单",
            codeValue: "0"
        },{
            codeName: "集报清单",
            codeValue: "1"
        },{
            codeName: "先入区后报关",
            codeValue: "3"
        },{
            codeName: "简单加工",
            codeValue: "4"
        },{
            codeName: "保税展示交易",
            codeValue: "5"
        },{
            codeName: "区内流转",
            codeValue: "6"
        },{
            codeName: "区港联动",
            codeValue: "7"
        },{
            codeName: "保税电商",
            codeValue: "8"
        },{
            codeName: "纳成品内销",
            codeValue: "9"
        },{
            codeName: "选择性征关税",
            codeValue: "A"
        },{
            codeName: "保区折料内销",
            codeValue: "B"
        },{
            codeName: "选择性征税分送集报",
            codeValue: "C"
        },{
            codeName: "区内直转",
            codeValue: "D"
        },{
            codeName: "一线一票多车",
            codeValue: "E"
        },
    ],
    // 申报类型 
    INVT_DECLARE_TYPE:[
        {
            codeName: "备案申请",
            codeValue: "1"
        },{
            codeName: "变更申请",
            codeValue: "2"
        },{
            codeName: "删除申请",
            codeValue: "3"
        }
    ],
    //料件、成品标志
    INVT_MtpckEndprd_TYPE:[
        {
            codeName: "料件",
            codeValue: "I"
        },{
            codeName: "成品",
            codeValue: "E"
        }
    ],
    // 流转类型
    INVT_list_TYPE:[
        {
            codeName: "加工贸易深加工结转",
            codeValue: "A"
        },{
            codeName: "加工贸易余料结转",
            codeValue: "B"
        },{
            codeName: "不作价设备结转",
            codeValue: "C"
        },{
            codeName: "区间深加工结转",
            codeValue: "D"
        },{
            codeName: "区间料件结转",
            codeValue: "E"
        }
    ],
    // 是否报关标志
    INVT_DCLCUS_FLAG: [
        {
            codeName: "报关",
            codeValue: "1"
        },{
            codeName: "非报关",
            codeValue: "0"
        }
    ],
    // 是否生成报关单
    INVT_GENDEC_FLAG:[
        {
            codeName: "生成",
            codeValue: "1"
        },{
            codeName: "不生成",
            codeValue: "2"
        }
    ],
    // 报关单类型
    INVT_decTYPE_TYPE:[
        {
            codeName: "进口报关单",
            codeValue: "1"
        },{
            codeName: "出口报关单",
            codeValue: "2"
        },{
            codeName: "进境备案清单",
            codeValue: "3"
        },{
            codeName: "出境备案清单",
            codeValue: "4"
        },{
            codeName: "进境两单一审备案清单",
            codeValue: "5"
        },{
            codeName: "出境两单一审备案清单",
            codeValue: "6"
        },{
            codeName: "转关提前进口报关单",
            codeValue: "9"
        },{
            codeName: "转关提前出口报关单",
            codeValue: "A"
        },{
            codeName: "转关提前进境备案清单",
            codeValue: "B"
        },{
            codeName: "转关提前出境备案清单",
            codeValue: "C"
        },{
            codeName: "出口二次转关单",
            codeValue: "F"
        },{
            codeName: "进口提前/工厂验放报关单",
            codeValue: "G"
        },{
            codeName: "出口提前/工厂验放报关单",
            codeValue: "H"
        },{
            codeName: "进口提前/暂时进口报关单",
            codeValue: "I"
        },{
            codeName: "出口提前/暂时出口报关单",
            codeValue: "J"
        },{
            codeName: "进口提前/中欧班列报关单",
            codeValue: "K"
        },{
            codeName: "出口提前/中欧班列报关单",
            codeValue: "L"
        },{
            codeName: "出口提前/市场采购报关单",
            codeValue: "M"
        },{
            codeName: "出口提前/空运联程报关单",
            codeValue: "N"
        },{
            codeName: "进口提前/工厂验放备案清单",
            codeValue: "O"
        },{
            codeName: "出口提前/工厂验放备案清单",
            codeValue: "P"
        },{
            codeName: "进口提前/暂时进口备案清单",
            codeValue: "Q"
        },{
            codeName: "出口提前/暂时出口备案清单",
            codeValue: "R"
        },{
            codeName: "进口提前/中欧班列备案清单",
            codeValue: "S"
        },{
            codeName: "出口提前/中欧班列备案清单",
            codeValue: "T"
        },{
            codeName: "出口提前/市场采购备案清单",
            codeValue: "U"
        },{
            codeName: "出口提前/空运联程备案清单",
            codeValue: "V"
        },{
            codeName: "进口公路舱单跨境快速通关报关单",
            codeValue: "a"
        },{
            codeName: "出口公路舱单跨境快速通关报关单",
            codeValue: "b"
        },{
            codeName: "进口公路舱单跨境快速通关备案清单",
            codeValue: "c"
        },{
            codeName: "出口公路舱单跨境快速通关备案清单",
            codeValue: "d"
        },{
            codeName: "进口极简备案清单",
            codeValue: "g"
        },{
            codeName: "出口极简备案清单",
            codeValue: "h"
        },{
            codeName: "进口次简备案清单",
            codeValue: "i"
        },{
            codeName: "出口次简备案清单",
            codeValue: "j"
        },{
            codeName: "进口完整申报报关单",
            codeValue: "m"
        },{
            codeName: "进口完整申报备案清单",
            codeValue: "n"
        },{
            codeName: "多式联运进口报关单",
            codeValue: "p"
        },{
            codeName: "多式联运出口报关单",
            codeValue: "q"
        }
    ],
    // 报关类型 当报关标志为“1-报关”时，必填；当报关标志填写为“2-非报关”时，无需填写。
    INVT_dclcus_TYPE:[
        {
            codeName: "关联报关",
            codeValue: "1"
        },{
            codeName: "对应报关",
            codeValue: "2"
        }
    ],
    // 保税核注--修改标志
    MODF_MARKCD_TYPE:[
        {
            codeName: "未修改",
            codeValue: "0"
        },{
            codeName: "修改",
            codeValue: "1"
        },{
            codeName: "删除",
            codeValue: "2"
        },{
            codeName: "增加",
            codeValue: "3"
        }
    ],
}
export default AEObasicData